/* eslint-disable */
export const rows=[
    {
     "description": "AGILENT TECHNOLOGIES INC",
     "symbol": "A"
    },
    {
     "description": "ALCOA CORP",
     "symbol": "AA"
    },
    {
     "description": "AAF FIRST PRIORITY CLO BOND",
     "symbol": "AAA"
    },
    {
     "description": "ALTERNATIVE INVESTMENT TRUST",
     "symbol": "AAAIF"
    },
    {
     "description": "AAREAL BANK AG",
     "symbol": "AAALF"
    },
    {
     "description": "AAREAL BANK AG-UNSPON ADR",
     "symbol": "AAALY"
    },
    {
     "description": "GOLDMAN SACHS PHYSICAL GOLD",
     "symbol": "GS"
    },
    {
     "description": "ASIA BROADBAND INC",
     "symbol": "AABB"
    },
    {
     "description": "ABERDEEN INTERNATIONAL INC",
     "symbol": "AABVF"
    },
    {
     "description": "ARES ACQUISITION CORP-A",
     "symbol": "AAC"
    },
    {
     "description": "ARES ACQUISITION CORP",
     "symbol": "AAC.U"
    },
    {
     "description": "ARES ACQUISITION CL A -CW27",
     "symbol": "AAC.WS"
    },
    {
     "description": "AAC TECHNOLOGIES HOLDINGS IN",
     "symbol": "AACAF"
    },
    {
     "description": "AAC TECHNOLOGIES H-UNSPON AD",
     "symbol": "AACAY"
    },
    {
     "description": "ATA CREATIVITY GLOBAL - ADR",
     "symbol": "AACG"
    },
    {
     "description": "ARMADA ACQUISITION CORP I",
     "symbol": "AACI"
    },
    {
     "description": "ARMADA ACQUISITION CORP I",
     "symbol": "AACIU"
    },
    {
     "description": "ARMADA ACQUISITION I -CW23",
     "symbol": "AACIW"
    },
    {
     "description": "AMERICAN COMMERCE SOLUTIONS",
     "symbol": "AACS"
    },
    {
     "description": "AURORA SOLAR TECHNOLOGIES IN",
     "symbol": "AACTF"
    },
    {
     "description": "AADI BIOSCIENCE INC",
     "symbol": "AADI"
    },
    {
     "description": "ADVISORSHARES DORSEY WRIGHT",
     "symbol": "AADR"
    },
    {
     "description": "ALTAIR RESOURCES INC",
     "symbol": "AAEEF"
    },
    {
     "description": "AIRTEL AFRICA PLC",
     "symbol": "AAFRF"
    },
    {
     "description": "ALL AMERICAN GOLD CORP",
     "symbol": "AAGC"
    },
    {
     "description": "AAG ENERGY HOLDINGS LTD",
     "symbol": "AAGEF"
    },
    {
     "description": "AFTERMATH SILVER LTD",
     "symbol": "AAGFF"
    },
    {
     "description": "AMERICA GREAT HEALTH",
     "symbol": "AAGH"
    },
    {
     "description": "AIA GROUP LTD-SP ADR",
     "symbol": "AAGIY"
    },
    {
     "description": "ASTRA AGRO LESTARI-UNSP ADR",
     "symbol": "AAGRY"
    },
    {
     "description": "ASAHI CO LTD",
     "symbol": "AAHIF"
    },
    {
     "description": "ARLINGTON ASSET INVESTMENT-A",
     "symbol": "AAIC"
    },
    {
     "description": "ARLINGTON ASSET INVEST",
     "symbol": "AAIC.PRB"
    },
    {
     "description": "ARLINGTON ASSET INVEST",
     "symbol": "AAIC.PRC"
    },
    {
     "description": "AIA GROUP LTD",
     "symbol": "AAIGF"
    },
    {
     "description": "ALABAMA AIRCRAFT INDUSTRIES",
     "symbol": "AAIIQ"
    },
    {
     "description": "ARLINGTON ASSET INVEST",
     "symbol": "AAIN"
    },
    {
     "description": "AMERICAN AIRES INC",
     "symbol": "AAIRF"
    },
    {
     "description": "AMERICAN AIRLINES GROUP INC",
     "symbol": "AAL"
    },
    {
     "description": "AALBERTS NV",
     "symbol": "AALBF"
    },
    {
     "description": "APOLLO ASSET MGMNT INC",
     "symbol": "AAM.PRA"
    },
    {
     "description": "APOLLO ASSET MGMNT INC",
     "symbol": "AAM.PRB"
    },
    {
     "description": "ATLAS MARA LTD",
     "symbol": "AAMAF"
    },
    {
     "description": "ALTISOURCE ASSET MANAGEMENT",
     "symbol": "AAMC"
    },
    {
     "description": "ATLANTIC AMERICAN CORP",
     "symbol": "AAME"
    },
    {
     "description": "ALMADEX MINERALS LTD\/NEW",
     "symbol": "AAMMF"
    },
    {
     "description": "ARMADA MERCANTILE LTD",
     "symbol": "AAMTF"
    },
    {
     "description": "AARON'S CO INC\/THE",
     "symbol": "AAN"
    },
    {
     "description": "AROUNDTOWN SA",
     "symbol": "AANNF"
    },
    {
     "description": "APPLIED OPTOELECTRONICS INC",
     "symbol": "AAOI"
    },
    {
     "description": "AAON INC",
     "symbol": "AAON"
    },
    {
     "description": "ADVANCE AUTO PARTS INC",
     "symbol": "AAP"
    },
    {
     "description": "AAP INC",
     "symbol": "AAPJ"
    },
    {
     "description": "APPLE INC",
     "symbol": "AAPL"
    },
    {
     "description": "ALL AMERICAN PET CO INC",
     "symbol": "AAPT"
    },
    {
     "description": "ACCELERATE ACQUISITION COR-A",
     "symbol": "AAQC"
    },
    {
     "description": "ACCELERATE ACQUISITION CORP",
     "symbol": "AAQC.U"
    },
    {
     "description": "ACCELERATE ACQUISITION -CW27",
     "symbol": "AAQC.WS"
    },
    {
     "description": "ALL ACTIVE ASSET CAPITAL LTD",
     "symbol": "AASCF"
    },
    {
     "description": "AMERICA'S SUPPLIERS INC",
     "symbol": "AASL"
    },
    {
     "description": "GLOBAL ACQUISITIONS CORPORAT",
     "symbol": "AASP"
    },
    {
     "description": "ATLANTIC SAPPHIRE ASA",
     "symbol": "AASZF"
    },
    {
     "description": "AMERICAN ASSETS TRUST INC",
     "symbol": "AAT"
    },
    {
     "description": "AUTOSCOPE TECHNOLOGIES CORP",
     "symbol": "AATC"
    },
    {
     "description": "AA PLC",
     "symbol": "AATDF"
    },
    {
     "description": "ATI AIRTEST TECHNOLOGIES INC",
     "symbol": "AATGF"
    },
    {
     "description": "AGAPE ATP CORP",
     "symbol": "AATP"
    },
    {
     "description": "AMG Capital Trust II",
     "symbol": "AATRL"
    },
    {
     "description": "ADAPTIVE AD SYSTEMS INC",
     "symbol": "AATV"
    },
    {
     "description": "ALMADEN MINERALS LTD - B",
     "symbol": "AAU"
    },
    {
     "description": "ANGOLD RESOURCES LTD",
     "symbol": "AAUGF"
    },
    {
     "description": "ANGLO AMERICAN PLC",
     "symbol": "AAUKF"
    },
    {
     "description": "ABN AMRO BANK NV-UNSP ADR",
     "symbol": "AAVMY"
    },
    {
     "description": "ADVANTAGE ENERGY LTD",
     "symbol": "AAVVF"
    },
    {
     "description": "ABIVAX SA",
     "symbol": "AAVXF"
    },
    {
     "description": "ASCEND WELLNESS HOLDINGS-A",
     "symbol": "AAWH"
    },
    {
     "description": "ATLAS AIR WORLDWIDE HOLDINGS",
     "symbol": "AAWW"
    },
    {
     "description": "ISHARES MSCI ALL COUNTRY ASI",
     "symbol": "AAXJ"
    },
    {
     "description": "AAMAXAN TRANSPORT GROUP INC",
     "symbol": "AAXT"
    },
    {
     "description": "AACL HOLDINGS LTD-ADR",
     "symbol": "AAYYY"
    },
    {
     "description": "ALLIANCEBERNSTEIN HOLDING LP",
     "symbol": "AB"
    },
    {
     "description": "ABRDN ASIA-PACIFIC INCOME FU",
     "symbol": "ABAKF"
    },
    {
     "description": "AUTOMATIC BANK SERVICES LTD",
     "symbol": "ABANF"
    },
    {
     "description": "ABB LTD-SPON ADR",
     "symbol": "ABB"
    },
    {
     "description": "ABRDN ASIAN INCOME FUND L",
     "symbol": "ABBAF"
    },
    {
     "description": "AUBURN BANCORP INC",
     "symbol": "ABBB"
    },
    {
     "description": "ABRASILVER RESOURCE CORP",
     "symbol": "ABBRF"
    },
    {
     "description": "ABBVIE INC",
     "symbol": "ABBV"
    },
    {
     "description": "ABBY INC",
     "symbol": "ABBY"
    },
    {
     "description": "AMERISOURCEBERGEN CORP",
     "symbol": "ABC"
    },
    {
     "description": "ATHABASCA MINERALS INC",
     "symbol": "ABCAF"
    },
    {
     "description": "AMERIS BANCORP",
     "symbol": "ABCB"
    },
    {
     "description": "ABCO ENERGY INC",
     "symbol": "ABCE"
    },
    {
     "description": "ABACUS MINING & EXPLORATION",
     "symbol": "ABCFF"
    },
    {
     "description": "ABCELLERA BIOLOGICS INC",
     "symbol": "ABCL"
    },
    {
     "description": "ABCAM PLC-SPON ADR",
     "symbol": "ABCM"
    },
    {
     "description": "AMBASE CORP",
     "symbol": "ABCP"
    },
    {
     "description": "ABCAM PLC",
     "symbol": "ABCZF"
    },
    {
     "description": "ALM BRAND A\/S - ADR",
     "symbol": "ABDBY"
    },
    {
     "description": "AB DYNAMICS PLC",
     "symbol": "ABDDF"
    },
    {
     "description": "AMBASSADOR FOOD SERVICES",
     "symbol": "ABDR"
    },
    {
     "description": "ABINGDON HEALTH PLC",
     "symbol": "ABDXF"
    },
    {
     "description": "ADVANCED BIO-MEMBERSHIP UNIT",
     "symbol": "ABENU"
    },
    {
     "description": "ABEONA THERAPEUTICS INC",
     "symbol": "ABEO"
    },
    {
     "description": "VISION LITHIUM INC",
     "symbol": "ABEPF"
    },
    {
     "description": "ABSOLUTE CORE STRATEGY ETF",
     "symbol": "ABEQ"
    },
    {
     "description": "AMBEV SA-ADR",
     "symbol": "ABEV"
    },
    {
     "description": "ABBEY PLC",
     "symbol": "ABEYF"
    },
    {
     "description": "ABERTIS INFRAESTRUCTURAS SA",
     "symbol": "ABFOF"
    },
    {
     "description": "ABF PAN ASIA BOND INDEX -USD",
     "symbol": "ABFXF"
    },
    {
     "description": "ASBURY AUTOMOTIVE GROUP",
     "symbol": "ABG"
    },
    {
     "description": "ABG ACQUISITION CORP I - A",
     "symbol": "ABGI"
    },
    {
     "description": "ABENGOA SA -CL A",
     "symbol": "ABGOF"
    },
    {
     "description": "ABENGOA SA-UNSPON ADR",
     "symbol": "ABGOY"
    },
    {
     "description": "ABG SUNDAL COLLIER HOLDING",
     "symbol": "ABGSF"
    },
    {
     "description": "Alfen Beheer BV ADR -UNSP",
     "symbol": "ABHBY"
    },
    {
     "description": "ABILITY INC",
     "symbol": "ABILF"
    },
    {
     "description": "ARCA BIOPHARMA INC",
     "symbol": "ABIO"
    },
    {
     "description": "ATHENA BITCOIN GLOBAL",
     "symbol": "ABIT"
    },
    {
     "description": "AMERICAN BASKETBALL ASSOCIAT",
     "symbol": "ABKB"
    },
    {
     "description": "ABLE ENERGY INC",
     "symbol": "ABLE"
    },
    {
     "description": "ALTEN SA",
     "symbol": "ABLGF"
    },
    {
     "description": "AMERICAN BILTRITE INC",
     "symbol": "ABLT"
    },
    {
     "description": "ABB LTD-REG",
     "symbol": "ABLZF"
    },
    {
     "description": "ABM INDUSTRIES INC",
     "symbol": "ABM"
    },
    {
     "description": "ALBIOMA SA",
     "symbol": "ABMAF"
    },
    {
     "description": "ABCOURT MINES INC -CL B",
     "symbol": "ABMBF"
    },
    {
     "description": "AMERICAN BIO MEDICA CORP",
     "symbol": "ABMC"
    },
    {
     "description": "ABIOMED INC",
     "symbol": "ABMD"
    },
    {
     "description": "AMERICAN BATTERY TECHNOLOGY",
     "symbol": "ABML"
    },
    {
     "description": "PRODIGY GOLD NL",
     "symbol": "ABMMF"
    },
    {
     "description": "ABN AMRO BANK NV-CVA",
     "symbol": "ABMRF"
    },
    {
     "description": "ADVANCED BIOMEDICAL TECHNOLO",
     "symbol": "ABMT"
    },
    {
     "description": "ABEN RESOURCES LTD",
     "symbol": "ABNAF"
    },
    {
     "description": "AIRBNB INC-CLASS A",
     "symbol": "ABNB"
    },
    {
     "description": "ABOITIZ EQUITY VENTURES INC",
     "symbol": "ABOIF"
    },
    {
     "description": "ACUMEN PHARMACEUTICALS INC",
     "symbol": "ABOS"
    },
    {
     "description": "ABACUS PROPERTY GROUP",
     "symbol": "ABPPF"
    },
    {
     "description": "AIRBORNE SECURITY & PROTECTI",
     "symbol": "ABPR"
    },
    {
     "description": "AB INTERNATIONAL GROUP CORP",
     "symbol": "ABQQ"
    },
    {
     "description": "ARBOR REALTY TRUST INC",
     "symbol": "ABR"
    },
    {
     "description": "ARBOR REALTY TRUST INC",
     "symbol": "ABR.PRD"
    },
    {
     "description": "ARBOR REALTY TRUST INC",
     "symbol": "ABR.PRE"
    },
    {
     "description": "ARBOR REALTY TRUST INC",
     "symbol": "ABR.PRF"
    },
    {
     "description": "ARBOR METALS CORP",
     "symbol": "ABRMF"
    },
    {
     "description": "AB SCIENCE SA",
     "symbol": "ABSCF"
    },
    {
     "description": "ABSCI CORP",
     "symbol": "ABSI"
    },
    {
     "description": "ABS-CBN HOLDINGS CORP-PDR",
     "symbol": "ABSOF"
    },
    {
     "description": "AIRBOSS OF AMERICA CORP",
     "symbol": "ABSSF"
    },
    {
     "description": "ABSOLUTE SOFTWARE CORPORATIO",
     "symbol": "ABST"
    },
    {
     "description": "ABBOTT LABORATORIES",
     "symbol": "ABT"
    },
    {
     "description": "ALTEROLA BIOTECH INC",
     "symbol": "ABTI"
    },
    {
     "description": "AB&T FINANCIAL CORP",
     "symbol": "ABTO"
    },
    {
     "description": "ALLEGIANCE BANCSHARES INC",
     "symbol": "ABTX"
    },
    {
     "description": "ABOITIZ EQUITY VENTURES-ADR",
     "symbol": "ABTZY"
    },
    {
     "description": "ARBUTUS BIOPHARMA CORP",
     "symbol": "ABUS"
    },
    {
     "description": "ABVC BIOPHARMA INC",
     "symbol": "ABVC"
    },
    {
     "description": "AFFINITY BEVERAGE GROUP INC",
     "symbol": "ABVG"
    },
    {
     "description": "ABV CONSULTING INC",
     "symbol": "ABVN"
    },
    {
     "description": "AIRBORNE WIRELESS NETWORK",
     "symbol": "ABWN"
    },
    {
     "description": "ABAXX TECHNOLOGIES INC -CW23",
     "symbol": "ABXWF"
    },
    {
     "description": "ABAXX TECHNOLOGIES IN",
     "symbol": "ABXXF"
    },
    {
     "description": "ABOITIZ POWER CORP",
     "symbol": "ABZPF"
    },
    {
     "description": "ABOITIZ POWER CORP-UNSP ADR",
     "symbol": "ABZPY"
    },
    {
     "description": "ABLAZE TECHNOLOGIES INC",
     "symbol": "ABZT"
    },
    {
     "description": "ABZU GOLD LTD",
     "symbol": "ABZUF"
    },
    {
     "description": "ASSOCIATED CAPITAL GROUP - A",
     "symbol": "AC"
    },
    {
     "description": "ARCOSA INC",
     "symbol": "ACA"
    },
    {
     "description": "ATLANTIC COAST ACQUISITION-A",
     "symbol": "ACAB"
    },
    {
     "description": "ATLANTIC COASTAL ACQUISITION",
     "symbol": "ACABU"
    },
    {
     "description": "ATLANTIC COAST ACQ -CW23",
     "symbol": "ACABW"
    },
    {
     "description": "ACADIA PHARMACEUTICALS INC",
     "symbol": "ACAD"
    },
    {
     "description": "ATLANTIC COASTAL ACQUISITI-A",
     "symbol": "ACAH"
    },
    {
     "description": "ATLANTIC COASTAL ACQUISITION",
     "symbol": "ACAHU"
    },
    {
     "description": "ATLANTIC COASTAL ACQ A -CW27",
     "symbol": "ACAHW"
    },
    {
     "description": "SAFEPLUS INTERNATIONAL HOLDI",
     "symbol": "ACAI"
    },
    {
     "description": "AMERICANN INC",
     "symbol": "ACAN"
    },
    {
     "description": "ATHENA CONSUMER ACQUISITIO-A",
     "symbol": "ACAQ"
    },
    {
     "description": "ATHENA CONSUMER ACQU CORP",
     "symbol": "ACAQ.U"
    },
    {
     "description": "ATHENA CONSUMER ACQ -CW23",
     "symbol": "ACAQ.WS"
    },
    {
     "description": "ACE AVIATION HOLDINGS INC",
     "symbol": "ACAVF"
    },
    {
     "description": "ALSET CAPITAL ACQUISITI-CL A",
     "symbol": "ACAX"
    },
    {
     "description": "ALSET CAPITAL ACQUISITIO-RTS",
     "symbol": "ACAXR"
    },
    {
     "description": "ALSET CAPITAL ACQUISITION CO",
     "symbol": "ACAXU"
    },
    {
     "description": "ALSET CAPITAL ACQ-CW27",
     "symbol": "ACAXW"
    },
    {
     "description": "ACADIAN TIMBER CORP",
     "symbol": "ACAZF"
    },
    {
     "description": "AURORA CANNABIS INC",
     "symbol": "ACB"
    },
    {
     "description": "ACE GLOBAL BUSINESS ACQUISIT",
     "symbol": "ACBA"
    },
    {
     "description": "ACE GLOBAL BUSINESS ACQUISIT",
     "symbol": "ACBAU"
    },
    {
     "description": "ACE GLOBAL BUSINESS -CW27",
     "symbol": "ACBAW"
    },
    {
     "description": "ALBINA COMMUNITY BANCORP",
     "symbol": "ACBCQ"
    },
    {
     "description": "ANNABIDIOL CORP",
     "symbol": "ACBD"
    },
    {
     "description": "ACRO BIOMEDICAL CO LTD",
     "symbol": "ACBM"
    },
    {
     "description": "AMERICAN CAMPUS COMMUNITIES",
     "symbol": "ACC"
    },
    {
     "description": "ACACIA DIVERSIFIED HOLDINGS",
     "symbol": "ACCA"
    },
    {
     "description": "ACCOLADE INC",
     "symbol": "ACCD"
    },
    {
     "description": "ACCORD FINANCIAL CORP",
     "symbol": "ACCFF"
    },
    {
     "description": "AAC CLYDE SPACE AB",
     "symbol": "ACCMF"
    },
    {
     "description": "ACCO BRANDS CORP",
     "symbol": "ACCO"
    },
    {
     "description": "ACCESS-POWER & CO INC",
     "symbol": "ACCR"
    },
    {
     "description": "ACCOR SA-SPONSORED ADR",
     "symbol": "ACCYY"
    },
    {
     "description": "ASCENDANT DIGITAL ACQU-CL A",
     "symbol": "ACDI"
    },
    {
     "description": "ASCENDANT DIGITAL ACQUISITIO",
     "symbol": "ACDI.U"
    },
    {
     "description": "ASCENDANT DIGITAL ACQ -CW23",
     "symbol": "ACDI.WS"
    },
    {
     "description": "ASCENDAS REAL ESTATE INV TRT",
     "symbol": "ACDSF"
    },
    {
     "description": "AIR CANADA",
     "symbol": "ACDVF"
    },
    {
     "description": "ACE ETHANOL LLC - UNIT",
     "symbol": "ACEEU"
    },
    {
     "description": "ACE HARDWARE INDONESIA",
     "symbol": "ACEHF"
    },
    {
     "description": "ACEA SPA",
     "symbol": "ACEJF"
    },
    {
     "description": "ACCEL ENTERTAINMENT INC",
     "symbol": "ACEL"
    },
    {
     "description": "ASCENTIAL PLC-ADR",
     "symbol": "ACENY"
    },
    {
     "description": "ACER THERAPEUTICS INC",
     "symbol": "ACER"
    },
    {
     "description": "ALPS CLEAN ENERGY ETF",
     "symbol": "ACES"
    },
    {
     "description": "ADICET BIO INC",
     "symbol": "ACET"
    },
    {
     "description": "ACE CONVERGENCE ACQU-CLASS A",
     "symbol": "ACEV"
    },
    {
     "description": "ACE CONVERGENCE ACQUISITION",
     "symbol": "ACEVU"
    },
    {
     "description": "ACE CONVERGENCE ACQU-C -CW27",
     "symbol": "ACEVW"
    },
    {
     "description": "ACER INC-SPONSORED GDR REG S",
     "symbol": "ACEYY"
    },
    {
     "description": "AMC FINANCIAL HOLDINGS INC",
     "symbol": "ACFL"
    },
    {
     "description": "ACORN ENERGY INC",
     "symbol": "ACFN"
    },
    {
     "description": "AGRICULTURAL BANK OF CHINA-H",
     "symbol": "ACGBF"
    },
    {
     "description": "AGRICULTURAL BANK-UNSPON ADR",
     "symbol": "ACGBY"
    },
    {
     "description": "AMACORE GROUP INC\/THE",
     "symbol": "ACGI"
    },
    {
     "description": "ACI GLOBAL CORP",
     "symbol": "ACGJ"
    },
    {
     "description": "ARCH CAPITAL GROUP LTD",
     "symbol": "ACGL"
    },
    {
     "description": "ARCH CAPITAL GROUP LTD",
     "symbol": "ACGLN"
    },
    {
     "description": "ARCH CAPITAL GROUP LTD",
     "symbol": "ACGLO"
    },
    {
     "description": "ACCELL GROUP",
     "symbol": "ACGPF"
    },
    {
     "description": "ALLIANCE CREATIVE GROUP INC",
     "symbol": "ACGX"
    },
    {
     "description": "SUBSEA 7 SA",
     "symbol": "ACGYF"
    },
    {
     "description": "ALUMINUM CORP OF CHINA-ADR",
     "symbol": "ACH"
    },
    {
     "description": "ACADIA HEALTHCARE CO INC",
     "symbol": "ACHC"
    },
    {
     "description": "ARCH BIOPARTNERS INC",
     "symbol": "ACHFF"
    },
    {
     "description": "ACHIKO LTD",
     "symbol": "ACHKF"
    },
    {
     "description": "ACHILLES THERAPEUTICS PL-ADR",
     "symbol": "ACHL"
    },
    {
     "description": "ACHISON INC-CLASS A",
     "symbol": "ACHN"
    },
    {
     "description": "ARCHER AVIATION INC-A",
     "symbol": "ACHR"
    },
    {
     "description": "ARCHER AVIATION INC    -CW26",
     "symbol": "ACHR.WS"
    },
    {
     "description": "ACHIEVE LIFE SCIENCES INC",
     "symbol": "ACHV"
    },
    {
     "description": "ALBERTSONS COS INC - CLASS A",
     "symbol": "ACI"
    },
    {
     "description": "BBVA-ACCION IBEX 35 ETF",
     "symbol": "ACIBF"
    },
    {
     "description": "ATLAS CREST INVESTMENT COR-A",
     "symbol": "ACII"
    },
    {
     "description": "ATLAS CREST INVESTMENT CORP",
     "symbol": "ACII.U"
    },
    {
     "description": "ATLAS CREST INV CL A -CW28",
     "symbol": "ACII.WS"
    },
    {
     "description": "APTUS COLLARED INC OPP ETF",
     "symbol": "ACIO"
    },
    {
     "description": "AIMS APAC REIT",
     "symbol": "ACIRF"
    },
    {
     "description": "ASIAN CITRUS HOLDINGS LTD",
     "symbol": "ACITF"
    },
    {
     "description": "AC IMMUNE SA",
     "symbol": "ACIU"
    },
    {
     "description": "ACI WORLDWIDE INC",
     "symbol": "ACIW"
    },
    {
     "description": "ACOM CO LTD",
     "symbol": "ACJJF"
    },
    {
     "description": "ARCELIK AS-UNSPONSORED ADR",
     "symbol": "ACKAY"
    },
    {
     "description": "AUCKLAND INTL AIRPORT LTD",
     "symbol": "ACKDF"
    },
    {
     "description": "ACKRELL SPAC PARTNERS-SUBUNI",
     "symbol": "ACKIT"
    },
    {
     "description": "ACKRELL SPAC PARTNERS I CO",
     "symbol": "ACKIU"
    },
    {
     "description": "ACKRELL SPAC PARTNERS -CW26",
     "symbol": "ACKIW"
    },
    {
     "description": "AMERICAN CREEK RESOURCES LTD",
     "symbol": "ACKRF"
    },
    {
     "description": "ACQUIRE LTD",
     "symbol": "ACLD"
    },
    {
     "description": "ACME LITHIUM INC",
     "symbol": "ACLHF"
    },
    {
     "description": "ATCO LTD -CLASS I",
     "symbol": "ACLLF"
    },
    {
     "description": "AXCELIS TECHNOLOGIES INC",
     "symbol": "ACLS"
    },
    {
     "description": "ATCO LTD -CL 'II'",
     "symbol": "ACLTF"
    },
    {
     "description": "ARCELLX INC",
     "symbol": "ACLX"
    },
    {
     "description": "AECOM",
     "symbol": "ACM"
    },
    {
     "description": "AGRO CAPITAL MANAGEMENT CORP",
     "symbol": "ACMB"
    },
    {
     "description": "AMERICAN CHURCH MORTGAGE CO",
     "symbol": "ACMC"
    },
    {
     "description": "ATLAS CONS MINING & DEV-ADR",
     "symbol": "ACMDY"
    },
    {
     "description": "ASCOM HOLDING AG-REG",
     "symbol": "ACMLF"
    },
    {
     "description": "ARC MINERALS LTD",
     "symbol": "ACMNF"
    },
    {
     "description": "ACM RESEARCH INC-CLASS A",
     "symbol": "ACMR"
    },
    {
     "description": "ACMAT CORP",
     "symbol": "ACMT"
    },
    {
     "description": "ACMAT CORP -CL A",
     "symbol": "ACMTA"
    },
    {
     "description": "ACCENTURE PLC-CL A",
     "symbol": "ACN"
    },
    {
     "description": "ACNB CORP",
     "symbol": "ACNB"
    },
    {
     "description": "ASCENDAS INDIA TRUST",
     "symbol": "ACNDF"
    },
    {
     "description": "ALICE CONS MINING INC",
     "symbol": "ACNE"
    },
    {
     "description": "AMSTERDAM COMMODITIES NV",
     "symbol": "ACNFF"
    },
    {
     "description": "AMERICAN COMMUNITY NEWSPAPER",
     "symbol": "ACNI"
    },
    {
     "description": "AUSCANN GROUP HOLDINGS LTD",
     "symbol": "ACNNF"
    },
    {
     "description": "ACCELERA INNOVATIONS INC",
     "symbol": "ACNV"
    },
    {
     "description": "ALPHA COGNITION INC",
     "symbol": "ACOGF"
    },
    {
     "description": "ACLARION INC",
     "symbol": "ACON"
    },
    {
     "description": "ACLARION INC -CW27",
     "symbol": "ACONW"
    },
    {
     "description": "A2 MILK CO LTD",
     "symbol": "ACOPF"
    },
    {
     "description": "THE A2 MILK CO LTD-UNSP ADR",
     "symbol": "ACOPY"
    },
    {
     "description": "ACORDA THERAPEUTICS INC",
     "symbol": "ACOR"
    },
    {
     "description": "ARCHOS",
     "symbol": "ACOSF"
    },
    {
     "description": "ABERDEEN INCOME CREDIT STRAT",
     "symbol": "ACP"
    },
    {
     "description": "ABERDEEN INCOME CREDIT",
     "symbol": "ACP.PRA"
    },
    {
     "description": "ACACIA PHARMA GROUP PLC",
     "symbol": "ACPGF"
    },
    {
     "description": "AC ENERGY CORP",
     "symbol": "ACPIF"
    },
    {
     "description": "ARCPACIFIC RESOURCES CORP",
     "symbol": "ACPRF"
    },
    {
     "description": "AC PARTNERS INC",
     "symbol": "ACPS"
    },
    {
     "description": "INDEPENDENCE HDS CORP-CL A",
     "symbol": "ACQR"
    },
    {
     "description": "INDEPENDENCE HOLDINGS CORP",
     "symbol": "ACQRU"
    },
    {
     "description": "INDEPENDENCE HDS -CL A -CW28",
     "symbol": "ACQRW"
    },
    {
     "description": "ACRES COMMERCIAL REALTY CORP",
     "symbol": "ACR"
    },
    {
     "description": "ACRES COMMERCIAL REALTY",
     "symbol": "ACR.PRC"
    },
    {
     "description": "ACRES COMMERCIAL REALTY",
     "symbol": "ACR.PRD"
    },
    {
     "description": "ASIA CARBON INDUSTRIES INC",
     "symbol": "ACRB"
    },
    {
     "description": "ACREAGE HOLDINGS-SUB VTG D",
     "symbol": "ACRDF"
    },
    {
     "description": "ARES COMMERCIAL REAL ESTATE",
     "symbol": "ACRE"
    },
    {
     "description": "ACCOR SA",
     "symbol": "ACRFF"
    },
    {
     "description": "ACREAGE HOLDINGS-SUB VTG E",
     "symbol": "ACRHF"
    },
    {
     "description": "ATACAMA RESOURCES INTNL INC",
     "symbol": "ACRL"
    },
    {
     "description": "ACROPOLIS INFRASTRUCTURE - A",
     "symbol": "ACRO"
    },
    {
     "description": "ACROPOLIS INFRASTRUCTURE ACQ",
     "symbol": "ACRO.U"
    },
    {
     "description": "ACROPOLIS INFRASTRUCTU -CW26",
     "symbol": "ACRO.WS"
    },
    {
     "description": "ACLARIS THERAPEUTICS INC",
     "symbol": "ACRS"
    },
    {
     "description": "AMERICREW INC",
     "symbol": "ACRU"
    },
    {
     "description": "ACELRX PHARMACEUTICALS INC",
     "symbol": "ACRX"
    },
    {
     "description": "ACS ACTIVIDADES CONS Y SERV",
     "symbol": "ACSAF"
    },
    {
     "description": "ACS ACTIVIDADES CONS-UNS ADR",
     "symbol": "ACSAY"
    },
    {
     "description": "ACS MOTION CONTROL LTD",
     "symbol": "ACSEF"
    },
    {
     "description": "AMERICAN CUSTOMER SATISFACTI",
     "symbol": "ACSI"
    },
    {
     "description": "ACASTI PHARMA INC",
     "symbol": "ACST"
    },
    {
     "description": "ACCSYS TECHNOLOGIES PLC",
     "symbol": "ACSYF"
    },
    {
     "description": "ENACT HOLDINGS INC",
     "symbol": "ACT"
    },
    {
     "description": "ARCLIGHT CLEAN TRANSITION -A",
     "symbol": "ACTD"
    },
    {
     "description": "ARCLIGHT CLEAN TRANSITION II",
     "symbol": "ACTDU"
    },
    {
     "description": "ARCLIGHT CLEAN TR CL A -CW27",
     "symbol": "ACTDW"
    },
    {
     "description": "ACACIA RESEARCH CORP",
     "symbol": "ACTG"
    },
    {
     "description": "ADURO CLEAN TECHNOLOGIES INC",
     "symbol": "ACTHF"
    },
    {
     "description": "ARTEC GLOBAL MEDIA INC",
     "symbol": "ACTL"
    },
    {
     "description": "LEADERSHARES ACTIVIST LEADER",
     "symbol": "ACTV"
    },
    {
     "description": "ADVANCED CONTAINER TECHNOLOG",
     "symbol": "ACTX"
    },
    {
     "description": "ACME UNITED CORP",
     "symbol": "ACU"
    },
    {
     "description": "ACURA PHARMACEUTICALS INC",
     "symbol": "ACUR"
    },
    {
     "description": "ACUSPHERE INC",
     "symbol": "ACUS"
    },
    {
     "description": "ACCUSTEM SCIENCES INC",
     "symbol": "ACUT"
    },
    {
     "description": "VIRTUS ALLIANZGI DIV & INC",
     "symbol": "ACV"
    },
    {
     "description": "ACV AUCTIONS INC-A",
     "symbol": "ACVA"
    },
    {
     "description": "AMERICAN CONSERVATIVE VALUES",
     "symbol": "ACVF"
    },
    {
     "description": "SPDR ACWI",
     "symbol": "ACWEF"
    },
    {
     "description": "ISHARES MSCI GLOBAL MULTIFAC",
     "symbol": "ACWF"
    },
    {
     "description": "ISHARES MSCI ACWI ETF",
     "symbol": "ACWI"
    },
    {
     "description": "ACCELEWARE LTD",
     "symbol": "ACWRF"
    },
    {
     "description": "ISHARES MSCI GLOBAL MIN VOL",
     "symbol": "ACWV"
    },
    {
     "description": "ISHARES MSCI ACWI EX US ETF",
     "symbol": "ACWX"
    },
    {
     "description": "ACCIONA SA",
     "symbol": "ACXIF"
    },
    {
     "description": "ACURX PHARMACEUTICALS INC",
     "symbol": "ACXP"
    },
    {
     "description": "HUAIZHONG HEALTH GROUP INC",
     "symbol": "ADAD"
    },
    {
     "description": "ADAGENE INC-ADR",
     "symbol": "ADAG"
    },
    {
     "description": "ANTHEMIS DIGITAL ACQUISITION",
     "symbol": "ADAL"
    },
    {
     "description": "ANTHEMIS DIGITAL ACQUISITION",
     "symbol": "ADALU"
    },
    {
     "description": "ANTHEMIS DIGITAL ACQ -CW23",
     "symbol": "ADALW"
    },
    {
     "description": "ADAPTIMMUNE THERAPEUTICS-ADR",
     "symbol": "ADAP"
    },
    {
     "description": "ADBRI LTD",
     "symbol": "ADBCF"
    },
    {
     "description": "ADOBE INC",
     "symbol": "ADBE"
    },
    {
     "description": "ADORE BEAUTY GROUP LTD",
     "symbol": "ADBGF"
    },
    {
     "description": "ADDIKO BANK AG",
     "symbol": "ADBKF"
    },
    {
     "description": "AUDIOBOOM GROUP PLC",
     "symbol": "ADBMF"
    },
    {
     "description": "AMERICANA DISTRIBUTION INC",
     "symbol": "ADBN"
    },
    {
     "description": "ALDEBARAN RESOURCES INC",
     "symbol": "ADBRF"
    },
    {
     "description": "AGREE REALTY CORP",
     "symbol": "ADC"
    },
    {
     "description": "AGREE REALTY CORP",
     "symbol": "ADC.PRA"
    },
    {
     "description": "ADCORE INC",
     "symbol": "ADCOF"
    },
    {
     "description": "ADC THERAPEUTICS SA",
     "symbol": "ADCT"
    },
    {
     "description": "ADS MARITIME HOLDING PLC",
     "symbol": "ADCUF"
    },
    {
     "description": "AD CAPITAL US INC",
     "symbol": "ADCV"
    },
    {
     "description": "ADDMASTER CORP",
     "symbol": "ADDC"
    },
    {
     "description": "ADIDAS AG",
     "symbol": "ADDDF"
    },
    {
     "description": "ADDTECH AB-UNSP ADR",
     "symbol": "ADDHY"
    },
    {
     "description": "ADDLIFE AB-B",
     "symbol": "ADDLF"
    },
    {
     "description": "ADDLIFE AB - UNSP ADR",
     "symbol": "ADDLY"
    },
    {
     "description": "ADDEX THERAPEUTICS LTD",
     "symbol": "ADDXF"
    },
    {
     "description": "ADIDAS AG-SPONSORED ADR",
     "symbol": "ADDYY"
    },
    {
     "description": "ALTERNATIVE ENERGY DEVELOPME",
     "symbol": "ADEC"
    },
    {
     "description": "26 CAPITAL ACQUISITION COR-A",
     "symbol": "ADER"
    },
    {
     "description": "26 CAPITAL ACQUISITION CORP",
     "symbol": "ADERU"
    },
    {
     "description": "26 CAPITAL ACQ CL A -CW27",
     "symbol": "ADERW"
    },
    {
     "description": "AIDA ENGINEE LTD-UNSPON ADR",
     "symbol": "ADERY"
    },
    {
     "description": "ADVANCED EMISSIONS SOLUTIONS",
     "symbol": "ADES"
    },
    {
     "description": "ADEVINTA ASA",
     "symbol": "ADEVF"
    },
    {
     "description": "ADEVINTA ASA - UNSP ADR",
     "symbol": "ADEVY"
    },
    {
     "description": "ADIT EDTECH ACQUISITION",
     "symbol": "ADEX"
    },
    {
     "description": "ADIT EDTECH ACQUISITION CORP",
     "symbol": "ADEX.U"
    },
    {
     "description": "ADIT EDTECH ACQ -CW27",
     "symbol": "ADEX.WS"
    },
    {
     "description": "ANFIELD DYNAMIC FIXED INCOME",
     "symbol": "ADFI"
    },
    {
     "description": "ADF GROUP INC",
     "symbol": "ADFJF"
    },
    {
     "description": "AMERICAN DEFENSE SYSTEMS INC",
     "symbol": "ADFS"
    },
    {
     "description": "ADVANCE LITHIUM CORP",
     "symbol": "ADGCF"
    },
    {
     "description": "ADAGIO THERAPEUTICS INC",
     "symbol": "ADGI"
    },
    {
     "description": "ALLDIGITAL HOLDINGS INC",
     "symbol": "ADGL"
    },
    {
     "description": "ADVANTEGO CORP",
     "symbol": "ADGO"
    },
    {
     "description": "AMERICAN DIVERSIFIED HOLDING",
     "symbol": "ADHC"
    },
    {
     "description": "ANDO HOLDINGS LTD",
     "symbol": "ADHG"
    },
    {
     "description": "APPLIED DEVELOPMENT HLDGS LT",
     "symbol": "ADHLF"
    },
    {
     "description": "ANALOG DEVICES INC",
     "symbol": "ADI"
    },
    {
     "description": "ADIA NUTRITION INC",
     "symbol": "ADIA"
    },
    {
     "description": "ADIAL PHARMACEUTICALS INC",
     "symbol": "ADIL"
    },
    {
     "description": "ADIAL PHARMACEUTICALS I-CW23",
     "symbol": "ADILW"
    },
    {
     "description": "SMARTETFS APAC DVD BUILDER",
     "symbol": "ADIV"
    },
    {
     "description": "ADIAL PHARMACEUTICALS -CW24",
     "symbol": "ADIWW"
    },
    {
     "description": "ADEKA CORP",
     "symbol": "ADKCF"
    },
    {
     "description": "ADKINS ENERGY LLC",
     "symbol": "ADKIL"
    },
    {
     "description": "ADIRONDACK TRUST CO SARATOGA",
     "symbol": "ADKT"
    },
    {
     "description": "ADBRI LTD-UNSPONSORED ADR",
     "symbol": "ADLDY"
    },
    {
     "description": "AMERICAN MEDICAL TECH INC",
     "symbol": "ADLI"
    },
    {
     "description": "ARCHER-DANIELS-MIDLAND CO",
     "symbol": "ADM"
    },
    {
     "description": "ADMA BIOLOGICS INC",
     "symbol": "ADMA"
    },
    {
     "description": "APTUS DRAWDOWN MANAGED EQUIT",
     "symbol": "ADME"
    },
    {
     "description": "ADAMANT DRI PROCESSING AND M",
     "symbol": "ADMG"
    },
    {
     "description": "ADRIATIC METALS PLC-CDI",
     "symbol": "ADMLF"
    },
    {
     "description": "ADAMIS PHARMACEUTICALS CORP",
     "symbol": "ADMP"
    },
    {
     "description": "ADM ENDEAVORS INC",
     "symbol": "ADMQ"
    },
    {
     "description": "ADM TRONICS UNLIMITED INC\/DE",
     "symbol": "ADMT"
    },
    {
     "description": "ADVENT TECHNOLOGIES HOLDINGS",
     "symbol": "ADN"
    },
    {
     "description": "ADIENT PLC",
     "symbol": "ADNT"
    },
    {
     "description": "AMCI ACQUISITION CORP-CW26",
     "symbol": "ADNWW"
    },
    {
     "description": "EDOC ACQUISITION CORP-CL A",
     "symbol": "ADOC"
    },
    {
     "description": "DOC ACQUISITION CORP-RIGHTS",
     "symbol": "ADOCR"
    },
    {
     "description": "EDOC ACQUISITION CL A -CW27",
     "symbol": "ADOCW"
    },
    {
     "description": "ADOCIA SAS-ADR",
     "symbol": "ADOCY"
    },
    {
     "description": "ADOCIA SAS",
     "symbol": "ADOIF"
    },
    {
     "description": "ANTEOTECH LTD",
     "symbol": "ADONF"
    },
    {
     "description": "ADARO ENERGY IND - UNSP ADR",
     "symbol": "ADOOY"
    },
    {
     "description": "AUTOMATIC DATA PROCESSING",
     "symbol": "ADP"
    },
    {
     "description": "ADLER GROUP SA",
     "symbol": "ADPPF"
    },
    {
     "description": "ADAPTIVE BIOTECHNOLOGIES",
     "symbol": "ADPT"
    },
    {
     "description": "AUDIO PIXELS HOLDINGS LTD",
     "symbol": "ADPXF"
    },
    {
     "description": "AUDIO PIXELS HOLDINGS LTD",
     "symbol": "ADPXY"
    },
    {
     "description": "ADARA ACQUISITION CORP-CL A",
     "symbol": "ADRA"
    },
    {
     "description": "ADARA ACQUISITION CORP",
     "symbol": "ADRA.U"
    },
    {
     "description": "ADARA ACQUISITION CL A -CW26",
     "symbol": "ADRA.WS"
    },
    {
     "description": "INVESCO BLDRS EMERGING MARKE",
     "symbol": "ADRE"
    },
    {
     "description": "ADAVALE RESOURCES LTD",
     "symbol": "ADRLF"
    },
    {
     "description": "KONINKLIJKE AHOLD-SP ADR",
     "symbol": "ADRNY"
    },
    {
     "description": "AULT DISRUPTIVE TECHNOLOGIES",
     "symbol": "ADRT"
    },
    {
     "description": "AULT DISRUPTIVE TECHNOLOGIES",
     "symbol": "ADRT.U"
    },
    {
     "description": "AULT DISRUPTIVE TECH -CW23",
     "symbol": "ADRT.WS"
    },
    {
     "description": "ANDRITZ AG",
     "symbol": "ADRZF"
    },
    {
     "description": "ANDRITZ AG-UNSPON ADR",
     "symbol": "ADRZY"
    },
    {
     "description": "ADS-TEC ENERGY PLC",
     "symbol": "ADSE"
    },
    {
     "description": "ADS-TEC ENERGY PLC-WRNT",
     "symbol": "ADSEW"
    },
    {
     "description": "ADESSO SE",
     "symbol": "ADSGF"
    },
    {
     "description": "AUTODESK INC",
     "symbol": "ADSK"
    },
    {
     "description": "ADSTAR INC",
     "symbol": "ADST"
    },
    {
     "description": "ALLIED SECURITY INNOVATIONS",
     "symbol": "ADSV"
    },
    {
     "description": "ADT INC",
     "symbol": "ADT"
    },
    {
     "description": "ADVANCED DEPOSITION TECH INC",
     "symbol": "ADTC"
    },
    {
     "description": "ADVANTECH CO LTD",
     "symbol": "ADTEF"
    },
    {
     "description": "IMETAL RESOURCES INC",
     "symbol": "ADTFF"
    },
    {
     "description": "ADTHEORENT HOLDINGS CO INC",
     "symbol": "ADTH"
    },
    {
     "description": "ADTHEORENT HOLDINGS CO-CW27",
     "symbol": "ADTHW"
    },
    {
     "description": "ADRIATIC METALS PLC",
     "symbol": "ADTLF"
    },
    {
     "description": "ADAPTIVE MEDIAS INC",
     "symbol": "ADTM"
    },
    {
     "description": "ADTRAN INC",
     "symbol": "ADTN"
    },
    {
     "description": "ALLIANCE MEDIA HOLDINGS INC",
     "symbol": "ADTR"
    },
    {
     "description": "ADVANTEST CORP",
     "symbol": "ADTTF"
    },
    {
     "description": "ADITXT INC",
     "symbol": "ADTX"
    },
    {
     "description": "ADTEGRITY.COM INTL INC",
     "symbol": "ADTY"
    },
    {
     "description": "ADDUS HOMECARE CORP",
     "symbol": "ADUS"
    },
    {
     "description": "ADVANTAGE SOLUTIONS INC",
     "symbol": "ADV"
    },
    {
     "description": "ADVANT-E CORPORATION",
     "symbol": "ADVCD"
    },
    {
     "description": "ADVERUM BIOTECHNOLOGIES INC",
     "symbol": "ADVM"
    },
    {
     "description": "ADVANCE ZINCTEK LTD",
     "symbol": "ADVNF"
    },
    {
     "description": "ADVA OPTICAL NETWORKING SE",
     "symbol": "ADVOF"
    },
    {
     "description": "ADVANTIS CORP",
     "symbol": "ADVT"
    },
    {
     "description": "ADVECO GROUP INC",
     "symbol": "ADVV"
    },
    {
     "description": "ADVANTAGE SOLUTIONS IN-CW25",
     "symbol": "ADVWW"
    },
    {
     "description": "ADVERTY AB",
     "symbol": "ADVYF"
    },
    {
     "description": "ADVENTUS MINING CORP",
     "symbol": "ADVZF"
    },
    {
     "description": "ANDREW PELLER LTD -A",
     "symbol": "ADWPF"
    },
    {
     "description": "ADWAYS INC",
     "symbol": "ADWYF"
    },
    {
     "description": "ADAMS DIVERSIFIED EQUITY",
     "symbol": "ADX"
    },
    {
     "description": "ADEX MINING INC",
     "symbol": "ADXDF"
    },
    {
     "description": "ADDEX THERAPEUTICS LTD",
     "symbol": "ADXN"
    },
    {
     "description": "ADX ENERGY LTD",
     "symbol": "ADXRF"
    },
    {
     "description": "ADVAXIS INC",
     "symbol": "ADXS"
    },
    {
     "description": "ADYEN NV-UNSPON ADR",
     "symbol": "ADYEY"
    },
    {
     "description": "ADYTON RESOURCES CORP",
     "symbol": "ADYRF"
    },
    {
     "description": "ADYNXX INC",
     "symbol": "ADYX"
    },
    {
     "description": "ADYEN NV",
     "symbol": "ADYYF"
    },
    {
     "description": "DB AGRICULTURE SHORT ETN",
     "symbol": "ADZCF"
    },
    {
     "description": "ADVANCE RESIDENCE INVESTMENT",
     "symbol": "ADZZF"
    },
    {
     "description": "ADAMS RESOURCES & ENERGY INC",
     "symbol": "AE"
    },
    {
     "description": "AUTHENTIC EQUITY ACQUISITI-A",
     "symbol": "AEAC"
    },
    {
     "description": "AUTHENTIC EQUITY ACQUISITION",
     "symbol": "AEACU"
    },
    {
     "description": "AUTHENTIC EQUITY ACQ -CW27",
     "symbol": "AEACW"
    },
    {
     "description": "ALTENERGY ACQUISITION CORP-A",
     "symbol": "AEAE"
    },
    {
     "description": "ALTENERGY ACQUISITION CORP",
     "symbol": "AEAEU"
    },
    {
     "description": "ALTENERGY ACQUISITION -CW23",
     "symbol": "AEAEW"
    },
    {
     "description": "ANADOLU EFES BIRACILIK-ADR",
     "symbol": "AEBZY"
    },
    {
     "description": "ACTION ENERGY INC",
     "symbol": "AECFF"
    },
    {
     "description": "AMERICAN ENERGY DEVELOPMENT",
     "symbol": "AEDC"
    },
    {
     "description": "AEDIFICA",
     "symbol": "AEDFF"
    },
    {
     "description": "AMEREN CORPORATION",
     "symbol": "AEE"
    },
    {
     "description": "AMERICAN ENVIRONMENTAL ENERG",
     "symbol": "AEEI"
    },
    {
     "description": "ASIA EQUITY EXCHANGE GROUP I",
     "symbol": "AEEX"
    },
    {
     "description": "ABERDEEN EM MRKT EQTY INC",
     "symbol": "AEF"
    },
    {
     "description": "AEGON FUNDING CO LLC",
     "symbol": "AEFC"
    },
    {
     "description": "AEFFE SPA",
     "symbol": "AEFSF"
    },
    {
     "description": "AEGON N.V.-NY REG SHR",
     "symbol": "AEG"
    },
    {
     "description": "AMERICAN ENERGY GROUP LTD",
     "symbol": "AEGG"
    },
    {
     "description": "AEGON NV",
     "symbol": "AEGOF"
    },
    {
     "description": "AECON GROUP INC",
     "symbol": "AEGXF"
    },
    {
     "description": "ALTERNATIVE ENERGY PARTNERS",
     "symbol": "AEGY"
    },
    {
     "description": "AESTHER HEALTHCARE ACQU-CL A",
     "symbol": "AEHA"
    },
    {
     "description": "AESTHER HEALTHCARE ACQUISITI",
     "symbol": "AEHAU"
    },
    {
     "description": "AESTHER HEALTHCARE ACQ -CW23",
     "symbol": "AEHAW"
    },
    {
     "description": "ANTELOPE ENTERPRISE HOLDINGS",
     "symbol": "AEHL"
    },
    {
     "description": "AEHR TEST SYSTEMS",
     "symbol": "AEHR"
    },
    {
     "description": "ALSET EHOME INTERNATIONAL IN",
     "symbol": "AEI"
    },
    {
     "description": "AERIA INC",
     "symbol": "AEICF"
    },
    {
     "description": "ADVANCED ENERGY INDUSTRIES",
     "symbol": "AEIS"
    },
    {
     "description": "AMERICAN EQUITY INVT LIFE HL",
     "symbol": "AEL"
    },
    {
     "description": "AMERICAN EQUITY INVESTME",
     "symbol": "AEL.PRA"
    },
    {
     "description": "AMERICAN EQUITY INVESTME",
     "symbol": "AEL.PRB"
    },
    {
     "description": "ANADOLU HAYAT EMEK-UNSP ADR",
     "symbol": "AELIY"
    },
    {
     "description": "ADACEL TECHNOLOGIES LTD",
     "symbol": "AELTF"
    },
    {
     "description": "AGNICO EAGLE MINES LTD",
     "symbol": "AEM"
    },
    {
     "description": "AMERICAN CENT EMERG MARK BND",
     "symbol": "AEMB"
    },
    {
     "description": "ARCHER ENTERTAINMENT MEDIA C",
     "symbol": "AEMC"
    },
    {
     "description": "AETHLON MEDICAL INC",
     "symbol": "AEMD"
    },
    {
     "description": "AEM HOLDINGS LTD",
     "symbol": "AEMFF"
    },
    {
     "description": "A2A SPA",
     "symbol": "AEMMF"
    },
    {
     "description": "A2A SPA-UNSPONSORED ADR",
     "symbol": "AEMMY"
    },
    {
     "description": "ADVANCED ENGINE TECHNOLOGIES",
     "symbol": "AENG"
    },
    {
     "description": "AENZA SAA-SPON ADR",
     "symbol": "AENZ"
    },
    {
     "description": "AMERICAN EAGLE OUTFITTERS",
     "symbol": "AEO"
    },
    {
     "description": "AEON FINANCIAL SERVICE CO LT",
     "symbol": "AEOJF"
    },
    {
     "description": "AEON METALS LTD",
     "symbol": "AEOMF"
    },
    {
     "description": "ADP",
     "symbol": "AEOXF"
    },
    {
     "description": "AMERICAN ELECTRIC POWER",
     "symbol": "AEP"
    },
    {
     "description": "ANGLO-EASTERN PLANTATIONS",
     "symbol": "AEPLF"
    },
    {
     "description": "AMERICAN ELECTRIC POWER",
     "symbol": "AEPPZ"
    },
    {
     "description": "AMERICAN ENERGY PARTNERS INC",
     "symbol": "AEPT"
    },
    {
     "description": "AERCAP HOLDINGS NV",
     "symbol": "AER"
    },
    {
     "description": "AEROFLOT-RUSSIAN-144A GDR",
     "symbol": "AERAY"
    },
    {
     "description": "AEROCLEAN TECHNOLOGIES INC",
     "symbol": "AERC"
    },
    {
     "description": "APPLIED ENERGETICS INC",
     "symbol": "AERG"
    },
    {
     "description": "AERIE PHARMACEUTICALS INC",
     "symbol": "AERI"
    },
    {
     "description": "AER ENERGY RESOURCES INC",
     "symbol": "AERN"
    },
    {
     "description": "AERIUS INC",
     "symbol": "AERS"
    },
    {
     "description": "AES CORP",
     "symbol": "AES"
    },
    {
     "description": "AES CORP\/THE",
     "symbol": "AESC"
    },
    {
     "description": "ALLIED ESPORTS ENTERTAINMENT",
     "symbol": "AESE"
    },
    {
     "description": "ALLIED ESPORTS ENTERTAIN-CW",
     "symbol": "AESEW"
    },
    {
     "description": "ATLANTIC ENERGY SOLUTIONS IN",
     "symbol": "AESO"
    },
    {
     "description": "ANFIELD US EQUITY SECTOR ROT",
     "symbol": "AESR"
    },
    {
     "description": "AERIS ENVIRONMENTAL LTD",
     "symbol": "AETLF"
    },
    {
     "description": "ARC RESOURCES LTD",
     "symbol": "AETUF"
    },
    {
     "description": "AEVA TECHNOLOGIES INC",
     "symbol": "AEVA"
    },
    {
     "description": "INTERPRIVATE ACQUISITI -CW24",
     "symbol": "AEVA.WS"
    },
    {
     "description": "AEVIS VICTORIA SA",
     "symbol": "AEVIF"
    },
    {
     "description": "AEW UK REIT PLC",
     "symbol": "AEWRF"
    },
    {
     "description": "ATOS SE",
     "symbol": "AEXAF"
    },
    {
     "description": "ATOS ORIGIN SA-UNSP ADR",
     "symbol": "AEXAY"
    },
    {
     "description": "AIM EXPLORATION INC",
     "symbol": "AEXE"
    },
    {
     "description": "AMINEX PLC",
     "symbol": "AEXFF"
    },
    {
     "description": "ADDVANTAGE TECHNOLOGIES GRP",
     "symbol": "AEY"
    },
    {
     "description": "AUDIOEYE INC",
     "symbol": "AEYE"
    },
    {
     "description": "AETERNA ZENTARIS INC",
     "symbol": "AEZS"
    },
    {
     "description": "ARENA FORTIFY ACQUISITION-A",
     "symbol": "AFAC"
    },
    {
     "description": "ARENA FORTIFY ACQUISITION CO",
     "symbol": "AFACU"
    },
    {
     "description": "ARENA FORTIFY ACQ CL A -CW28",
     "symbol": "AFACW"
    },
    {
     "description": "AF ACQUISITION CORP-CLASS A",
     "symbol": "AFAQ"
    },
    {
     "description": "AF ACQUISITION CORP",
     "symbol": "AFAQU"
    },
    {
     "description": "AF ACQUISITION CORP -CW28",
     "symbol": "AFAQW"
    },
    {
     "description": "AURA FAT PROJECTS ACQUISITON",
     "symbol": "AFARU"
    },
    {
     "description": "ALLIANCE NATIONAL MUNI INC",
     "symbol": "AFB"
    },
    {
     "description": "ALLIED FIRST BANCORP INC",
     "symbol": "AFBA"
    },
    {
     "description": "AMERICAN FIBER GREEN PRODUCT",
     "symbol": "AFBG"
    },
    {
     "description": "AFFINITY BANCSHARES INC",
     "symbol": "AFBI"
    },
    {
     "description": "AFRICAN RAINBOW MINERALS LTD",
     "symbol": "AFBOF"
    },
    {
     "description": "AFC GAMMA INC",
     "symbol": "AFCG"
    },
    {
     "description": "AFC AJAX",
     "symbol": "AFCJF"
    },
    {
     "description": "AMCOR FINANCIAL CORP",
     "symbol": "AFCL"
    },
    {
     "description": "AFRICAN DISCOVERY GROUP INC",
     "symbol": "AFDG"
    },
    {
     "description": "AFF HOLDING GROUP INC",
     "symbol": "AFFG"
    },
    {
     "description": "AFFILIATED RESOURCES CORP",
     "symbol": "AFFL"
    },
    {
     "description": "AFFINITY NETWORKS INC",
     "symbol": "AFFN"
    },
    {
     "description": "AmTrust Financial Services Inc",
     "symbol": "AFFS"
    },
    {
     "description": "AmTrust Financial Services Inc",
     "symbol": "AFFT"
    },
    {
     "description": "AFFLUENCE CORP",
     "symbol": "AFFU"
    },
    {
     "description": "AFFINION GROUP HOLDINGS-CW24",
     "symbol": "AFFWW"
    },
    {
     "description": "AFFYMAX INC",
     "symbol": "AFFY"
    },
    {
     "description": "AMERICAN FINANCIAL GROUP INC",
     "symbol": "AFG"
    },
    {
     "description": "AMERICAN FINANCIAL GROUP",
     "symbol": "AFGB"
    },
    {
     "description": "AMERICAN FINANCIAL GROUP",
     "symbol": "AFGC"
    },
    {
     "description": "AMERICAN FINANCIAL GROUP",
     "symbol": "AFGD"
    },
    {
     "description": "AMERICAN FINANCIAL GROUP",
     "symbol": "AFGE"
    },
    {
     "description": "AGFA-GEVAERT NV",
     "symbol": "AFGVF"
    },
    {
     "description": "AGFA GEVAERT NV-UNSPON ADR",
     "symbol": "AFGVY"
    },
    {
     "description": "AFC ENERGY PLC",
     "symbol": "AFGYF"
    },
    {
     "description": "ATLAS FINANCIAL HOLDINGS INC",
     "symbol": "AFHIQ"
    },
    {
     "description": "AFCON HOLDINGS LTD",
     "symbol": "AFHLF"
    },
    {
     "description": "ARMSTRONG FLOORING INC",
     "symbol": "AFI"
    },
    {
     "description": "ACUTUS MEDICAL INC",
     "symbol": "AFIB"
    },
    {
     "description": "ANFIELD UNIVERSAL FIXED INCO",
     "symbol": "AFIF"
    },
    {
     "description": "AMFI CORP-CL A",
     "symbol": "AFIPA"
    },
    {
     "description": "VANECK AFRICA INDEX ETF",
     "symbol": "AFK"
    },
    {
     "description": "AFLAC INC",
     "symbol": "AFL"
    },
    {
     "description": "FIRST TRUST ACTIVE FACTOR LA",
     "symbol": "AFLG"
    },
    {
     "description": "AIR FRANCE-KLM-ADR",
     "symbol": "AFLYY"
    },
    {
     "description": "FIRST TRUST ACTIVE FACTOR MI",
     "symbol": "AFMC"
    },
    {
     "description": "AFFIMED NV",
     "symbol": "AFMD"
    },
    {
     "description": "ALPHAMIN RESOURCES CORP",
     "symbol": "AFMJF"
    },
    {
     "description": "AEROFOAM METALS INC",
     "symbol": "AFML"
    },
    {
     "description": "AMFIN FINANCIAL CORP",
     "symbol": "AFNL"
    },
    {
     "description": "ALL FOR ONE MEDIA CORP",
     "symbol": "AFOM"
    },
    {
     "description": "AUSTRALIAN FOUNDATION INV CO",
     "symbol": "AFOVF"
    },
    {
     "description": "ALUMIFUEL POWER CORP",
     "symbol": "AFPW"
    },
    {
     "description": "AIR FRANCE-KLM",
     "symbol": "AFRAF"
    },
    {
     "description": "AFFIRM HOLDINGS INC",
     "symbol": "AFRM"
    },
    {
     "description": "ALPHAFORM AG",
     "symbol": "AFRMF"
    },
    {
     "description": "AmTrust Financial Services Inc",
     "symbol": "AFSIA"
    },
    {
     "description": "AmTrust Financial Services Inc",
     "symbol": "AFSIB"
    },
    {
     "description": "AmTrust Financial Services Inc",
     "symbol": "AFSIC"
    },
    {
     "description": "AmTrust Financial Services Inc",
     "symbol": "AFSIM"
    },
    {
     "description": "AmTrust Financial Services Inc",
     "symbol": "AFSIN"
    },
    {
     "description": "AmTrust Financial Services Inc",
     "symbol": "AFSIP"
    },
    {
     "description": "FIRST TRUST ACTIVE FACTOR SM",
     "symbol": "AFSM"
    },
    {
     "description": "APOLLO SENIOR FLOATING RATE",
     "symbol": "AFT"
    },
    {
     "description": "ALTERNATIVE FUEL TECHNOLOGIE",
     "symbol": "AFTC"
    },
    {
     "description": "AFRIMAT LTD",
     "symbol": "AFTLF"
    },
    {
     "description": "AFTERMASTER INC",
     "symbol": "AFTM"
    },
    {
     "description": "AFTERNEXT HEALTHTECH ACQUI-A",
     "symbol": "AFTR"
    },
    {
     "description": "AFTERNEXT HEALTHTECH ACQUISI",
     "symbol": "AFTR.U"
    },
    {
     "description": "AFTERNEXT HEALTHTECH -CW23",
     "symbol": "AFTR.WS"
    },
    {
     "description": "AFRITIN MINING LTD",
     "symbol": "AFTTF"
    },
    {
     "description": "PACER CSOP FTSE CHINA A50 ET",
     "symbol": "AFTY"
    },
    {
     "description": "AFRY AB",
     "symbol": "AFXXF"
    },
    {
     "description": "AFYA LTD-CLASS A",
     "symbol": "AFYA"
    },
    {
     "description": "AFFINITY GOLD CORP",
     "symbol": "AFYG"
    },
    {
     "description": "FIRST MAJESTIC SILVER CORP",
     "symbol": "AG"
    },
    {
     "description": "AFRICAN GOLD ACQUISITION C-A",
     "symbol": "AGAC"
    },
    {
     "description": "AFRICAN GOLD ACQUISITION COR",
     "symbol": "AGAC.U"
    },
    {
     "description": "AFRICAN GOLD ACQUISITION CW",
     "symbol": "AGAC.WS"
    },
    {
     "description": "DB AGRICULTURE DOUBLE SHORT",
     "symbol": "AGATF"
    },
    {
     "description": "AGBA ACQUISITION LTD",
     "symbol": "AGBA"
    },
    {
     "description": "AGBA ACQUISITION LTD-RIGHTS",
     "symbol": "AGBAR"
    },
    {
     "description": "AGBA ACQUISITION LTD",
     "symbol": "AGBAU"
    },
    {
     "description": "AGBA ACQUISITION LTD -CW24",
     "symbol": "AGBAW"
    },
    {
     "description": "ALTIMETER GROWTH CORP 2-A",
     "symbol": "AGCB"
    },
    {
     "description": "GENSOURCE POTASH CORP",
     "symbol": "AGCCF"
    },
    {
     "description": "AGCO CORP",
     "symbol": "AGCO"
    },
    {
     "description": "ANDES GOLD CORP",
     "symbol": "AGCZ"
    },
    {
     "description": "ABERDEEN GLBL DYN DIVID",
     "symbol": "AGD"
    },
    {
     "description": "ANTIOQUIA GOLD INC",
     "symbol": "AGDXF"
    },
    {
     "description": "AGRI DYNAMICS INC",
     "symbol": "AGDY"
    },
    {
     "description": "AGEX THERAPEUTICS INC",
     "symbol": "AGE"
    },
    {
     "description": "AGENUS INC",
     "symbol": "AGEN"
    },
    {
     "description": "AGEAS",
     "symbol": "AGESF"
    },
    {
     "description": "AGEAS -SPON ADR",
     "symbol": "AGESY"
    },
    {
     "description": "AGRA VENTURES LTD",
     "symbol": "AGFAF"
    },
    {
     "description": "AGF MANAGEMENT LTD-CLASS B",
     "symbol": "AGFMF"
    },
    {
     "description": "AGROFRESH SOLUTIONS INC",
     "symbol": "AGFS"
    },
    {
     "description": "DB AGRICULTURE LONG ETN",
     "symbol": "AGFXF"
    },
    {
     "description": "AGRIFY CORP",
     "symbol": "AGFY"
    },
    {
     "description": "ISHARES CORE U.S. AGGREGATE",
     "symbol": "AGG"
    },
    {
     "description": "AFRICAN GOLD GROUP INC",
     "symbol": "AGGFF"
    },
    {
     "description": "ANTILIA GROUP CORP",
     "symbol": "AGGG"
    },
    {
     "description": "SIMPLIFY AGGR BD PL CR HD ET",
     "symbol": "AGGH"
    },
    {
     "description": "AGRIOS GLOBAL HOLDINGS LTD",
     "symbol": "AGGHF"
    },
    {
     "description": "ALLIED ENERGY INC",
     "symbol": "AGGI"
    },
    {
     "description": "AGILE GROWTH CORP-A",
     "symbol": "AGGR"
    },
    {
     "description": "AGILE GROWTH CORP",
     "symbol": "AGGRU"
    },
    {
     "description": "AGILE GROWTH CORP -CW27",
     "symbol": "AGGRW"
    },
    {
     "description": "ANGIOGENEX INC",
     "symbol": "AGGX"
    },
    {
     "description": "WISDOMTREE YIELD ENHANCED US",
     "symbol": "AGGY"
    },
    {
     "description": "AG GROWTH INTERNATIONAL INC",
     "symbol": "AGGZF"
    },
    {
     "description": "AEON GLOBAL HEALTH CORP",
     "symbol": "AGHC"
    },
    {
     "description": "ALAMOS GOLD INC-CLASS A",
     "symbol": "AGI"
    },
    {
     "description": "AGILETHOUGHT INC",
     "symbol": "AGIL"
    },
    {
     "description": "AGILETHOUGHT IN       -CW26",
     "symbol": "AGILW"
    },
    {
     "description": "AMERICAN GRAPHITE TECHNOLOGI",
     "symbol": "AGIN"
    },
    {
     "description": "AGIOS PHARMACEUTICALS INC",
     "symbol": "AGIO"
    },
    {
     "description": "AGILON HEALTH INC",
     "symbol": "AGL"
    },
    {
     "description": "AGUILA COPPER CORP",
     "symbol": "AGLAF"
    },
    {
     "description": "AUSTRAL GOLD LTD",
     "symbol": "AGLDF"
    },
    {
     "description": "AEGLEA BIOTHERAPEUTICS INC",
     "symbol": "AGLE"
    },
    {
     "description": "ANGELALIGN TECHNOLOGY INC",
     "symbol": "AGLFF"
    },
    {
     "description": "AGL ENERGY LTD",
     "symbol": "AGLNF"
    },
    {
     "description": "ANGEL TELECOM CORP",
     "symbol": "AGLT"
    },
    {
     "description": "AGL ENERGY LTD-SPON ADR",
     "symbol": "AGLXY"
    },
    {
     "description": "FEDERAL AGRIC MTG CORP-CL C",
     "symbol": "AGM"
    },
    {
     "description": "FEDERAL AGRIC MTG CORP-CL A",
     "symbol": "AGM.A"
    },
    {
     "description": "FARMER MAC",
     "symbol": "AGM.PRC"
    },
    {
     "description": "FARMER MAC",
     "symbol": "AGM.PRD"
    },
    {
     "description": "FARMER MAC",
     "symbol": "AGM.PRE"
    },
    {
     "description": "FARMER MAC",
     "symbol": "AGM.PRF"
    },
    {
     "description": "FARMER MAC",
     "symbol": "AGM.PRG"
    },
    {
     "description": "AGM GROUP HOLDINGS INC",
     "symbol": "AGMH"
    },
    {
     "description": "ALGOMA CENTRAL CORP",
     "symbol": "AGMJF"
    },
    {
     "description": "AGNC INVESTMENT CORP",
     "symbol": "AGNC"
    },
    {
     "description": "AGNC INVESTMENT CORP",
     "symbol": "AGNCM"
    },
    {
     "description": "AGNC INVESTMENT CORP",
     "symbol": "AGNCN"
    },
    {
     "description": "AGNC INVESTMENT CORP",
     "symbol": "AGNCO"
    },
    {
     "description": "AGNC INVESTMENT CORP",
     "symbol": "AGNCP"
    },
    {
     "description": "GLB X AGING POPULATION ETF",
     "symbol": "AGNG"
    },
    {
     "description": "AGRONOMICS LTD",
     "symbol": "AGNMF"
    },
    {
     "description": "ALGERNON PHARMACEUTICALS INC",
     "symbol": "AGNPF"
    },
    {
     "description": "AGAVENNY CORP",
     "symbol": "AGNY"
    },
    {
     "description": "ASSURED GUARANTY LTD",
     "symbol": "AGO"
    },
    {
     "description": "ABENGOA SA- B SHARES",
     "symbol": "AGOAF"
    },
    {
     "description": "ETC GAVEKAL ASIA PACIFIC GOV",
     "symbol": "AGOV"
    },
    {
     "description": "ABENGOA SA- B SHARES-CW25",
     "symbol": "AGOWF"
    },
    {
     "description": "ADAPTIVE ALPHA OPPORTUNITIES",
     "symbol": "AGOX"
    },
    {
     "description": "AMER SPORTS OYJ",
     "symbol": "AGPDF"
    },
    {
     "description": "ANGLO PACIFIC GROUP PLC",
     "symbol": "AGPIF"
    },
    {
     "description": "APPLE GREEN HOLDING INC",
     "symbol": "AGPL"
    },
    {
     "description": "ANGLO AMERICAN PLATINUM LTD",
     "symbol": "AGPPF"
    },
    {
     "description": "AGILE GROUP HOLDINGS LTD",
     "symbol": "AGPYF"
    },
    {
     "description": "AGILE GROUP HO-UNSPON ADR",
     "symbol": "AGPYY"
    },
    {
     "description": "PROSHARES ULTRA SILVER",
     "symbol": "AGQ"
    },
    {
     "description": "Algonquin Power and Utilities Corporation",
     "symbol": "AGQPF"
    },
    {
     "description": "AVANGRID INC",
     "symbol": "AGR"
    },
    {
     "description": "MINNOVA CORP",
     "symbol": "AGRDF"
    },
    {
     "description": "ARGONAUT RESOURCES NL",
     "symbol": "AGREF"
    },
    {
     "description": "AGRIFORCE GROWING SYSTEMS LT",
     "symbol": "AGRI"
    },
    {
     "description": "Agribank",
     "symbol": "AGRIP"
    },
    {
     "description": "AGRIFORCE GROWING SYST -CW27",
     "symbol": "AGRIW"
    },
    {
     "description": "ADECOAGRO SA",
     "symbol": "AGRO"
    },
    {
     "description": "ABSA GROUP LTD",
     "symbol": "AGRPF"
    },
    {
     "description": "ABSA GROUP LTD  -SPON ADR",
     "symbol": "AGRPY"
    },
    {
     "description": "AGRA RESOURCES LLC-UNIT CL A",
     "symbol": "AGRRU"
    },
    {
     "description": "AGRISTAR INC",
     "symbol": "AGRS"
    },
    {
     "description": "AF GRUPPEN ASA",
     "symbol": "AGRUF"
    },
    {
     "description": "AGILE THERAPEUTICS INC",
     "symbol": "AGRX"
    },
    {
     "description": "PLAYAGS INC",
     "symbol": "AGS"
    },
    {
     "description": "SILVER STREAM MINING CORP",
     "symbol": "AGSM"
    },
    {
     "description": "AMERIGUARD SECURITY SERVICES",
     "symbol": "AGSS"
    },
    {
     "description": "ARGENTUM SILVER CORP",
     "symbol": "AGSVF"
    },
    {
     "description": "ISHARES ARGENTINA",
     "symbol": "AGT"
    },
    {
     "description": "AGRITERRA LTD",
     "symbol": "AGTAF"
    },
    {
     "description": "APPLIED GENETIC TECHNOLOGIES",
     "symbol": "AGTC"
    },
    {
     "description": "AGTECH HOLDINGS LTD",
     "symbol": "AGTEF"
    },
    {
     "description": "AGILITI INC",
     "symbol": "AGTI"
    },
    {
     "description": "AGRITEK HOLDINGS INC",
     "symbol": "AGTK"
    },
    {
     "description": "ANGSTROM TECHNOLOGIES INC",
     "symbol": "AGTT"
    },
    {
     "description": "AGENTIX CORP",
     "symbol": "AGTX"
    },
    {
     "description": "ARCTIC GLACIER INCOME FD-UT",
     "symbol": "AGUNF"
    },
    {
     "description": "ARGO INVESTMENTS LTD",
     "symbol": "AGVNF"
    },
    {
     "description": "ARGAN INC",
     "symbol": "AGX"
    },
    {
     "description": "ANGLO ASIAN MINING PLC",
     "symbol": "AGXKF"
    },
    {
     "description": "AGLITI INC-CW22",
     "symbol": "AGXLW"
    },
    {
     "description": "SILVER X MINING CORP",
     "symbol": "AGXPF"
    },
    {
     "description": "AGILE THERAPEUTICS -CW26",
     "symbol": "AGXRW"
    },
    {
     "description": "ARGENTEX GROUP PLC",
     "symbol": "AGXTF"
    },
    {
     "description": "AGILYX AS",
     "symbol": "AGXXF"
    },
    {
     "description": "ALLIED ENERGY CORP",
     "symbol": "AGYP"
    },
    {
     "description": "AGILYSYS INC",
     "symbol": "AGYS"
    },
    {
     "description": "ALLERGY THERAPEUTICS PLC",
     "symbol": "AGYTF"
    },
    {
     "description": "ISHARES AGENCY BOND ETF",
     "symbol": "AGZ"
    },
    {
     "description": "WISDOMTREE TRUST WISDOMTREE",
     "symbol": "AGZD"
    },
    {
     "description": "AEGEAN AIRLINES",
     "symbol": "AGZNF"
    },
    {
     "description": "ALPHA TECHNOLOGIES GROUP INC",
     "symbol": "AHAG"
    },
    {
     "description": "DESIGN MILK CO LTD",
     "symbol": "AHAHF"
    },
    {
     "description": "Anheuser Busch Inbev SA",
     "symbol": "AHBIF"
    },
    {
     "description": "ARCHIVALCD INC",
     "symbol": "AHCD"
    },
    {
     "description": "ANHUI CONCH CEMENT CO LTD-H",
     "symbol": "AHCHF"
    },
    {
     "description": "CONCH CEMENT-H-UNS ADR",
     "symbol": "AHCHY"
    },
    {
     "description": "AUSTRALIAN ETHICAL INVT LTD",
     "symbol": "AHCLF"
    },
    {
     "description": "ADAPTHEALTH CORP",
     "symbol": "AHCO"
    },
    {
     "description": "AMERICAN HELIUM INC",
     "symbol": "AHELF"
    },
    {
     "description": "ADECCO GROUP AG-REG",
     "symbol": "AHEXF"
    },
    {
     "description": "ADECCO GROUP AG-REG-UNSP ADR",
     "symbol": "AHEXY"
    },
    {
     "description": "FLOW CAPITAL CORP",
     "symbol": "AHFCF"
    },
    {
     "description": "ACTIVE HEALTH FOODS INC",
     "symbol": "AHFD"
    },
    {
     "description": "ABSOLUTE HEALTH AND FITNESS",
     "symbol": "AHFI"
    },
    {
     "description": "AKSO HEALTH GROUP",
     "symbol": "AHG"
    },
    {
     "description": "ALTHEA GROUP HOLDINGS LTD",
     "symbol": "AHGHF"
    },
    {
     "description": "ALTERNATE HEALTH CORP",
     "symbol": "AHGIF"
    },
    {
     "description": "ARMADA HOFFLER PROPERTIES IN",
     "symbol": "AHH"
    },
    {
     "description": "ARMADA HOFFLER PROPERTIE",
     "symbol": "AHH.PRA"
    },
    {
     "description": "ASAHI HOLDINGS INC",
     "symbol": "AHHLF"
    },
    {
     "description": "ADAPTIVE HIGH INCOME ETF",
     "symbol": "AHHX"
    },
    {
     "description": "ADVANCED HUMAN IMAGING LTD",
     "symbol": "AHI"
    },
    {
     "description": "ASAHI INTECC CO LTD",
     "symbol": "AHICF"
    },
    {
     "description": "AMERICAN HERITAGE INTERNATIO",
     "symbol": "AHII"
    },
    {
     "description": "ALUF HOLDINGS INC",
     "symbol": "AHIX"
    },
    {
     "description": "ASAHI KASEI CORP",
     "symbol": "AHKSF"
    },
    {
     "description": "ASAHI KASEI CORP-UNSPON ADR",
     "symbol": "AHKSY"
    },
    {
     "description": "ASPEN INSURANCE HLDG LTD",
     "symbol": "AHL.PRC"
    },
    {
     "description": "ASPEN INSURANCE HLDG LTD",
     "symbol": "AHL.PRD"
    },
    {
     "description": "ASPEN INSURANCE HLDG LTD",
     "symbol": "AHL.PRE"
    },
    {
     "description": "ATD NEW HOLDINGS INC",
     "symbol": "AHLD"
    },
    {
     "description": "AmeriHome Inc",
     "symbol": "AHM"
    },
    {
     "description": "ARCHON MINERALS LTD",
     "symbol": "AHNMF"
    },
    {
     "description": "ATHENA GOLD CORP",
     "symbol": "AHNR"
    },
    {
     "description": "KONINKLIJKE AHOLD DELHAIZE N",
     "symbol": "AHODF"
    },
    {
     "description": "AMERICAN HOTEL INCOME PROPER",
     "symbol": "AHOTF"
    },
    {
     "description": "AVISTA PUBLIC ACQUIS-CLASS A",
     "symbol": "AHPA"
    },
    {
     "description": "AVISTA PUBLIC ACQUISITION CO",
     "symbol": "AHPAU"
    },
    {
     "description": "AVISTA PUBLIC ACQUIS -CW26",
     "symbol": "AHPAW"
    },
    {
     "description": "ALLIED HEALTHCARE PRODUCTS",
     "symbol": "AHPI"
    },
    {
     "description": "AHREN ACQUISITION CO-CLASS A",
     "symbol": "AHRN"
    },
    {
     "description": "AHREN ACQUISITION CORP",
     "symbol": "AHRNU"
    },
    {
     "description": "AHREN ACQUISITION -CW23",
     "symbol": "AHRNW"
    },
    {
     "description": "ASHFORD HOSPITALITY TRUST",
     "symbol": "AHT"
    },
    {
     "description": "ASHFORD HOSPITALITY TRUS",
     "symbol": "AHT.PRD"
    },
    {
     "description": "ASHFORD HOSPITALITY TRUS",
     "symbol": "AHT.PRF"
    },
    {
     "description": "ASHFORD HOSPITALITY TRUS",
     "symbol": "AHT.PRG"
    },
    {
     "description": "ASHFORD HOSPITALITY TRUS",
     "symbol": "AHT.PRH"
    },
    {
     "description": "ASHFORD HOSPITALITY TRUS",
     "symbol": "AHT.PRI"
    },
    {
     "description": "ATHENS WATER SUPPLY & SEWAGE",
     "symbol": "AHWSF"
    },
    {
     "description": "AMERICAN CENTURY SELECT HY",
     "symbol": "AHYB"
    },
    {
     "description": "C3.AI INC-A",
     "symbol": "AI"
    },
    {
     "description": "ISHARES ASIA 50 ETF",
     "symbol": "AIA"
    },
    {
     "description": "CAPITAL A BHD",
     "symbol": "AIABF"
    },
    {
     "description": "AIADVERTISING INC",
     "symbol": "AIAD"
    },
    {
     "description": "AURUBIS AG",
     "symbol": "AIAGF"
    },
    {
     "description": "AURUBIS AG-UNSPON ADR",
     "symbol": "AIAGY"
    },
    {
     "description": "ASCENTIAL PLC",
     "symbol": "AIAPF"
    },
    {
     "description": "AIB ACQUISITION CORP-A",
     "symbol": "AIB"
    },
    {
     "description": "AIB ACQUISITION CORP- RTS",
     "symbol": "AIBBR"
    },
    {
     "description": "AIB ACQUISITION CORP",
     "symbol": "AIBBU"
    },
    {
     "description": "AIR BERLIN PLC",
     "symbol": "AIBEF"
    },
    {
     "description": "AIB GROUP PLC-UNSP ADR",
     "symbol": "AIBGY"
    },
    {
     "description": "AIB GROUP PLC",
     "symbol": "AIBRF"
    },
    {
     "description": "ARLINGTON ASSET INVEST",
     "symbol": "AIC"
    },
    {
     "description": "AIR CHINA LTD-H",
     "symbol": "AICAF"
    },
    {
     "description": "AIDA PHARMACEUTICALS INC",
     "symbol": "AIDA"
    },
    {
     "description": "AIS HOLDINGS GROUP INC",
     "symbol": "AIDG"
    },
    {
     "description": "AI POWERED EQUITY ETF",
     "symbol": "AIEQ"
    },
    {
     "description": "APOLLO TACTICAL INCOME FUND",
     "symbol": "AIF"
    },
    {
     "description": "ASIA FINANCIAL HLDGS LTD",
     "symbol": "AIFIF"
    },
    {
     "description": "AIFUL CORP-UNSPON ADR",
     "symbol": "AIFLY"
    },
    {
     "description": "AIFARM LTD",
     "symbol": "AIFM"
    },
    {
     "description": "AGENT INFORMATION SOFTWARE I",
     "symbol": "AIFS"
    },
    {
     "description": "AMERICAN INTERNATIONAL GROUP",
     "symbol": "AIG"
    },
    {
     "description": "AMERICAN INTL GROUP",
     "symbol": "AIG.PRA"
    },
    {
     "description": "ARTISTMSS INTERNATIONAL GROU",
     "symbol": "AIGI"
    },
    {
     "description": "AESTHETIC MEDICAL INTERN-ADR",
     "symbol": "AIH"
    },
    {
     "description": "ADCOCK INGRAM HOLDINGS LTD",
     "symbol": "AIHLF"
    },
    {
     "description": "SENMIAO TECHNOLOGY LTD",
     "symbol": "AIHS"
    },
    {
     "description": "AI HOLDINGS CORP",
     "symbol": "AIHZF"
    },
    {
     "description": "AI POWERED INTERNATIONAL EQU",
     "symbol": "AIIQ"
    },
    {
     "description": "AIXTRON SE-UNSPONSORED ADR",
     "symbol": "AIIXY"
    },
    {
     "description": "AICA KOGYO CO LTD",
     "symbol": "AIKCF"
    },
    {
     "description": "AIKIDO PHARMA INC",
     "symbol": "AIKI"
    },
    {
     "description": "ALTERNATIVE INVESTMENT CORP",
     "symbol": "AIKO"
    },
    {
     "description": "ALPHA INTELLIGENT-LRG CAP GR",
     "symbol": "AILG"
    },
    {
     "description": "Ameren Illinois Company",
     "symbol": "AILIH"
    },
    {
     "description": "Ameren Illinois Company",
     "symbol": "AILIM"
    },
    {
     "description": "Ameren Illinois Company",
     "symbol": "AILIN"
    },
    {
     "description": "Ameren Illinois Company",
     "symbol": "AILIO"
    },
    {
     "description": "Ameren Illinois Company",
     "symbol": "AILIP"
    },
    {
     "description": "Ameren Illinois Company",
     "symbol": "AILLI"
    },
    {
     "description": "Ameren Illinois Company",
     "symbol": "AILLM"
    },
    {
     "description": "Ameren Illinois Company",
     "symbol": "AILLN"
    },
    {
     "description": "Ameren Illinois Company",
     "symbol": "AILLO"
    },
    {
     "description": "Ameren Illinois Company",
     "symbol": "AILLP"
    },
    {
     "description": "AIRIQ INC",
     "symbol": "AILQF"
    },
    {
     "description": "ARGENT INDUSTRIAL LTD",
     "symbol": "AILTF"
    },
    {
     "description": "ALPHA INTELLIGENT-LRG CAP VL",
     "symbol": "AILV"
    },
    {
     "description": "AIM IMMUNOTECH INC",
     "symbol": "AIM"
    },
    {
     "description": "ALTRA INDUSTRIAL MOTION CORP",
     "symbol": "AIMC"
    },
    {
     "description": "AINOS INC",
     "symbol": "AIMD"
    },
    {
     "description": "AIMIA INC",
     "symbol": "AIMFF"
    },
    {
     "description": "AIMRITE HOLDINGS CORP",
     "symbol": "AIMH"
    },
    {
     "description": "AI\/ML INNOVATIONS INC",
     "symbol": "AIMLF"
    },
    {
     "description": "ALBANY INTL CORP-CL A",
     "symbol": "AIN"
    },
    {
     "description": "ASHFORD INC",
     "symbol": "AINC"
    },
    {
     "description": "AINSWORTH GAME TECHNOLOGY LT",
     "symbol": "AINSF"
    },
    {
     "description": "APOLLO INVESTMENT CORP",
     "symbol": "AINV"
    },
    {
     "description": "VIRTUS ALLIANZGI ART INTEL",
     "symbol": "AIO"
    },
    {
     "description": "AXIOM HOLDINGS INC",
     "symbol": "AIOM"
    },
    {
     "description": "ATRESMEDIA CORP DE MEDIOS DE",
     "symbol": "AIOSF"
    },
    {
     "description": "ARTERIS INC",
     "symbol": "AIP"
    },
    {
     "description": "AI TECHNOLOGY GROUP INC",
     "symbol": "AIPG"
    },
    {
     "description": "AIRPORTS OF THAILAND PC-NVDR",
     "symbol": "AIPUF"
    },
    {
     "description": "AIRPORTS OF THAILAND PCL-ADR",
     "symbol": "AIPUY"
    },
    {
     "description": "GLOBAL X ART INTEL & TECH",
     "symbol": "AIQ"
    },
    {
     "description": "AIR LIQUIDE SA",
     "symbol": "AIQUF"
    },
    {
     "description": "AIR LIQUIDE-UNSPONSORED ADR",
     "symbol": "AIQUY"
    },
    {
     "description": "AAR CORP",
     "symbol": "AIR"
    },
    {
     "description": "APARTMENT INCOME REIT CO",
     "symbol": "AIRC"
    },
    {
     "description": "AIRGAIN INC",
     "symbol": "AIRG"
    },
    {
     "description": "AIR INDUSTRIES GROUP",
     "symbol": "AIRI"
    },
    {
     "description": "AIRMATE CAYMAN INTERNATIONAL",
     "symbol": "AIRMF"
    },
    {
     "description": "FIRST TRUST RBA AMERICAN IND",
     "symbol": "AIRR"
    },
    {
     "description": "AURION RESOURCES LTD",
     "symbol": "AIRRF"
    },
    {
     "description": "AIRSCULPT TECHNOLOGIES INC",
     "symbol": "AIRS"
    },
    {
     "description": "AIR T INC",
     "symbol": "AIRT"
    },
    {
     "description": "AIR T FUNDING",
     "symbol": "AIRTP"
    },
    {
     "description": "AIR CHINA LTD-SPONSORED-ADR",
     "symbol": "AIRYY"
    },
    {
     "description": "AMUNDI FLOATING RATE USD COR",
     "symbol": "AISFF"
    },
    {
     "description": "A.I.S. RESOURCES LTD",
     "symbol": "AISSF"
    },
    {
     "description": "APPLIED INDUSTRIAL TECH INC",
     "symbol": "AIT"
    },
    {
     "description": "WUNONG ASIA PACIFIC CO LTD",
     "symbol": "AITA"
    },
    {
     "description": "AIRTIFICIAL INTELLIGENCE STR",
     "symbol": "AITLF"
    },
    {
     "description": "ANRITSU CORP",
     "symbol": "AITUF"
    },
    {
     "description": "ANRITSU CORP - UNSP ADR",
     "symbol": "AITUY"
    },
    {
     "description": "ASIAN TELEVISION NETWORK INT",
     "symbol": "AITVF"
    },
    {
     "description": "ARTIFICIAL INTELLIGENCE TECH",
     "symbol": "AITX"
    },
    {
     "description": "APARTMENT INVT & MGMT CO -A",
     "symbol": "AIV"
    },
    {
     "description": "AVIVA PLC",
     "symbol": "AIVAF"
    },
    {
     "description": "WISDOMTREE INTERNATIONAL AI",
     "symbol": "AIVI"
    },
    {
     "description": "WISDOMTREE US AI ENHANCED VA",
     "symbol": "AIVL"
    },
    {
     "description": "AMERICAN INTERNATIONAL VENT",
     "symbol": "AIVN"
    },
    {
     "description": "AURORA INVESTMENT TRUST PLC",
     "symbol": "AIVTF"
    },
    {
     "description": "MORDECHAI AVIV TAASIOT BENIY",
     "symbol": "AIVVF"
    },
    {
     "description": "AIXIN LIFE INTERNATIONAL INC",
     "symbol": "AIXN"
    },
    {
     "description": "AIXTRON SE",
     "symbol": "AIXXF"
    },
    {
     "description": "ASSURANT INC",
     "symbol": "AIZ"
    },
    {
     "description": "ASSURANT INC",
     "symbol": "AIZN"
    },
    {
     "description": "ARTHUR J GALLAGHER & CO",
     "symbol": "AJG"
    },
    {
     "description": "AJIA INNOGROUP HOLDINGS LTD",
     "symbol": "AJIA"
    },
    {
     "description": "AJINOMOTO CO INC",
     "symbol": "AJINF"
    },
    {
     "description": "AJINOMOTO INC -UNSPON ADR",
     "symbol": "AJINY"
    },
    {
     "description": "AJIS CO LTD",
     "symbol": "AJISF"
    },
    {
     "description": "AJ LUCAS GROUP LTD",
     "symbol": "AJLGF"
    },
    {
     "description": "ASHMORE GROUP PLC",
     "symbol": "AJMPF"
    },
    {
     "description": "AYUJOY HERBALS LTD",
     "symbol": "AJOY"
    },
    {
     "description": "A.J. PLAST PUBLIC CO-FOREIGN",
     "symbol": "AJPLF"
    },
    {
     "description": "AEROJET ROCKETDYNE HOLDINGS",
     "symbol": "AJRD"
    },
    {
     "description": "AJISEN CHINA HOLDINGS LTD",
     "symbol": "AJSCF"
    },
    {
     "description": "GREAT AJAX CORP",
     "symbol": "AJX"
    },
    {
     "description": "GREAT AJAX CORP",
     "symbol": "AJXA"
    },
    {
     "description": "AJ1G INC",
     "symbol": "AJYG"
    },
    {
     "description": "AKA BRANDS HOLDING CORP",
     "symbol": "AKA"
    },
    {
     "description": "AKER ASA-A SHARES",
     "symbol": "AKAAF"
    },
    {
     "description": "ALK-ABELLO A\/S-SPON ADR",
     "symbol": "AKABY"
    },
    {
     "description": "AKATSUKI INC",
     "symbol": "AKAFF"
    },
    {
     "description": "AKAMAI TECHNOLOGIES INC",
     "symbol": "AKAM"
    },
    {
     "description": "AKANDA CORP",
     "symbol": "AKAN"
    },
    {
     "description": "HOMERUN RESOURCES INC",
     "symbol": "AKAVF"
    },
    {
     "description": "AKEBIA THERAPEUTICS INC",
     "symbol": "AKBA"
    },
    {
     "description": "AKEBONO BRAKE INDUSTRY CO",
     "symbol": "AKBIF"
    },
    {
     "description": "AKITA BANK LTD\/THE",
     "symbol": "AKBKF"
    },
    {
     "description": "ALK-ABELLO A\/S",
     "symbol": "AKBLF"
    },
    {
     "description": "AKBANK T.A.S.-ADR",
     "symbol": "AKBTY"
    },
    {
     "description": "AKER CARBON CAPTURE ASA",
     "symbol": "AKCCF"
    },
    {
     "description": "ASUSTEK COMPUTER INC",
     "symbol": "AKCPF"
    },
    {
     "description": "ARIAKE JAPAN CO LTD",
     "symbol": "AKEJF"
    },
    {
     "description": "AKESO INC",
     "symbol": "AKESF"
    },
    {
     "description": "SPORTS VENTURES ACQUISITIO-A",
     "symbol": "AKIC"
    },
    {
     "description": "SPORTS VENTURES ACQUISITION",
     "symbol": "AKICU"
    },
    {
     "description": "SPORTS VENT ACQ CL A -CW27",
     "symbol": "AKICW"
    },
    {
     "description": "AKASTOR ASA",
     "symbol": "AKKVF"
    },
    {
     "description": "KB RECYCLING INDUSTRIES LTD",
     "symbol": "AKMYF"
    },
    {
     "description": "EMBOTELLADORA ANDINA-ADR A",
     "symbol": "AKO.A"
    },
    {
     "description": "EMBOTELLADORA ANDINA-ADR B",
     "symbol": "AKO.B"
    },
    {
     "description": "AERKOMM INC",
     "symbol": "AKOM"
    },
    {
     "description": "AKORA RESOURCES LTD",
     "symbol": "AKORF"
    },
    {
     "description": "AKER OFFSHORE WIND AS",
     "symbol": "AKOWF"
    },
    {
     "description": "ACADIA REALTY TRUST",
     "symbol": "AKR"
    },
    {
     "description": "ACKROO INC",
     "symbol": "AKRFF"
    },
    {
     "description": "AKERO THERAPEUTICS INC",
     "symbol": "AKRO"
    },
    {
     "description": "PHILLY SHIPYARD ASA",
     "symbol": "AKRRF"
    },
    {
     "description": "AKER SOLUTIONS ASA",
     "symbol": "AKRTF"
    },
    {
     "description": "AKER SOLUTIONS ASA-UNSP ADR",
     "symbol": "AKRYY"
    },
    {
     "description": "SBERBANK OF RUSSIA PJSC",
     "symbol": "AKSJF"
    },
    {
     "description": "AKSYS LTD",
     "symbol": "AKSY"
    },
    {
     "description": "AKITA DRILLING LTD-CL A",
     "symbol": "AKTAF"
    },
    {
     "description": "AKOUSTIS TECHNOLOGIES INC",
     "symbol": "AKTS"
    },
    {
     "description": "AKARI THERAPEUTICS PLC-ADR",
     "symbol": "AKTX"
    },
    {
     "description": "AKUMIN INC",
     "symbol": "AKU"
    },
    {
     "description": "AKOUOS INC",
     "symbol": "AKUS"
    },
    {
     "description": "ARKANOVA ENERGY CORP",
     "symbol": "AKVA"
    },
    {
     "description": "AKOYA BIOSCIENCES INC",
     "symbol": "AKYA"
    },
    {
     "description": "AKZO NOBEL N.V.",
     "symbol": "AKZOF"
    },
    {
     "description": "AKZO NOBEL NV-SPON ADR",
     "symbol": "AKZOY"
    },
    {
     "description": "AIR LEASE CORP",
     "symbol": "AL"
    },
    {
     "description": "AIR LEASE CORP",
     "symbol": "AL.PRA"
    },
    {
     "description": "AURORA LABS LTD",
     "symbol": "ALABF"
    },
    {
     "description": "ALBERTON ACQUISITION CORP",
     "symbol": "ALAC"
    },
    {
     "description": "ALBERTON ACQUISITION CO-RTS",
     "symbol": "ALACR"
    },
    {
     "description": "ALBERTON ACQUISITION CORP",
     "symbol": "ALACU"
    },
    {
     "description": "ALBERTON ACQUISTION CO-CW23",
     "symbol": "ALACW"
    },
    {
     "description": "ALANCO TECHNOLOGIES INC",
     "symbol": "ALAN"
    },
    {
     "description": "ALLIANCE AVIATION SERVICES L",
     "symbol": "ALAVF"
    },
    {
     "description": "ALBEMARLE CORP",
     "symbol": "ALB"
    },
    {
     "description": "ALBA MINERAL RESOURCES PLC",
     "symbol": "ALBAF"
    },
    {
     "description": "ALIBABA HEALTH INFO-UNSP ADR",
     "symbol": "ALBBY"
    },
    {
     "description": "ALIBABA HEALTH INFORMATION T",
     "symbol": "ALBHF"
    },
    {
     "description": "ALPHA SERVICES AND HOLDINGS",
     "symbol": "ALBKF"
    },
    {
     "description": "ALPHA SERVICES & HDS-SP ADR",
     "symbol": "ALBKY"
    },
    {
     "description": "ALBIOMA SA UNSP - ADR",
     "symbol": "ALBMY"
    },
    {
     "description": "ALBIREO PHARMA INC",
     "symbol": "ALBO"
    },
    {
     "description": "COMMUNITY CAP BANCSHARES INC",
     "symbol": "ALBY"
    },
    {
     "description": "ALCON INC",
     "symbol": "ALC"
    },
    {
     "description": "ALTC ACQUISITION CORP-CL A",
     "symbol": "ALCC"
    },
    {
     "description": "ALICANTO MINERALS LTD",
     "symbol": "ALCCF"
    },
    {
     "description": "ATLANTIC CENTRAL ENTERPRISES",
     "symbol": "ALCN"
    },
    {
     "description": "ALICO INC",
     "symbol": "ALCO"
    },
    {
     "description": "ALCHIP TECHNOLOGIES LTD",
     "symbol": "ALCPF"
    },
    {
     "description": "ALPHA COPPER CORP",
     "symbol": "ALCUF"
    },
    {
     "description": "ATLANTICA INC",
     "symbol": "ALDA"
    },
    {
     "description": "ALADDIN HEALTHCARE TECHNOLOG",
     "symbol": "ALDNF"
    },
    {
     "description": "ALDERAN RESOURCES LTD",
     "symbol": "ALDRF"
    },
    {
     "description": "APPLIFE DIGITAL SOLUTIONS IN",
     "symbol": "ALDS"
    },
    {
     "description": "KIPLIN METALS INC",
     "symbol": "ALDVF"
    },
    {
     "description": "ALDEYRA THERAPEUTICS INC",
     "symbol": "ALDX"
    },
    {
     "description": "ALLETE INC",
     "symbol": "ALE"
    },
    {
     "description": "ALEAFIA HEALTH INC",
     "symbol": "ALEAF"
    },
    {
     "description": "ALECTOR INC",
     "symbol": "ALEC"
    },
    {
     "description": "ALLIED GROUP LTD-UNSP ADR",
     "symbol": "ALEDY"
    },
    {
     "description": "ALLEGRO.EU SA",
     "symbol": "ALEGF"
    },
    {
     "description": "ALEXANDER & BALDWIN INC",
     "symbol": "ALEX"
    },
    {
     "description": "ALFI INC",
     "symbol": "ALF"
    },
    {
     "description": "ALPHACLONE ALTERNATIVE ALPHA",
     "symbol": "ALFA"
    },
    {
     "description": "ASTRAL FOODS LTD",
     "symbol": "ALFDF"
    },
    {
     "description": "ALFA S.A.B.-A",
     "symbol": "ALFFF"
    },
    {
     "description": "ALFI INC-CW25",
     "symbol": "ALFIW"
    },
    {
     "description": "ALFEN BEHEER B.V.",
     "symbol": "ALFNF"
    },
    {
     "description": "ALFRESA HOLDINGS CO-UNSP ADR",
     "symbol": "ALFRY"
    },
    {
     "description": "ALFA LAVAL AB",
     "symbol": "ALFVF"
    },
    {
     "description": "ALFA LAVAL AB-UNSPON ADR",
     "symbol": "ALFVY"
    },
    {
     "description": "ALAMO GROUP INC",
     "symbol": "ALG"
    },
    {
     "description": "ALLEGIANCE COAL LTD",
     "symbol": "ALGCF"
    },
    {
     "description": "ALLIGATOR ENERGY LTD",
     "symbol": "ALGEF"
    },
    {
     "description": "ALLIANCE GLOBAL GROUP INC",
     "symbol": "ALGGF"
    },
    {
     "description": "ALLIANCE GLOBAL GRO-UNSP ADR",
     "symbol": "ALGGY"
    },
    {
     "description": "ALMA GOLD INC",
     "symbol": "ALGLF"
    },
    {
     "description": "ALLEGRO MICROSYSTEMS INC",
     "symbol": "ALGM"
    },
    {
     "description": "ALIGN TECHNOLOGY INC",
     "symbol": "ALGN"
    },
    {
     "description": "ALIGOS THERAPEUTICS INC",
     "symbol": "ALGS"
    },
    {
     "description": "ALLEGIANT TRAVEL CO",
     "symbol": "ALGT"
    },
    {
     "description": "ALLIANCE GROWERS CORP",
     "symbol": "ALGWF"
    },
    {
     "description": "ALIGNMENT HEALTHCARE INC",
     "symbol": "ALHC"
    },
    {
     "description": "Alco Holdings Ltd",
     "symbol": "ALHHF"
    },
    {
     "description": "ALLIED CORP",
     "symbol": "ALID"
    },
    {
     "description": "ARTIFICIAL LIFE INC",
     "symbol": "ALIF"
    },
    {
     "description": "ALIMERA SCIENCES INC",
     "symbol": "ALIM"
    },
    {
     "description": "ALTERA INFRASTRUCTURE LP",
     "symbol": "ALIN.PRA"
    },
    {
     "description": "ALTERA INFRASTRUCTURE LP",
     "symbol": "ALIN.PRB"
    },
    {
     "description": "ALTERA INFRASTRUCTURE LP",
     "symbol": "ALIN.PRE"
    },
    {
     "description": "ACTELION LTD-REG",
     "symbol": "ALIOF"
    },
    {
     "description": "ALIGHT INC - CLASS A",
     "symbol": "ALIT"
    },
    {
     "description": "ALLIANCE TRUST PLC",
     "symbol": "ALITF"
    },
    {
     "description": "AUTOLIV INC-SWED DEP RECEIPT",
     "symbol": "ALIV"
    },
    {
     "description": "ALLIANZ SE-REG",
     "symbol": "ALIZF"
    },
    {
     "description": "ALLIANZ SE - UNSP ADR",
     "symbol": "ALIZY"
    },
    {
     "description": "ALJ REGIONAL HOLDINGS INC",
     "symbol": "ALJJ"
    },
    {
     "description": "ALASKA AIR GROUP INC",
     "symbol": "ALK"
    },
    {
     "description": "ALKANE RESOURCES LTD",
     "symbol": "ALKEF"
    },
    {
     "description": "ALKALINE FUEL CELL POWER COR",
     "symbol": "ALKFF"
    },
    {
     "description": "ALASKA HYDRO CORP",
     "symbol": "ALKHF"
    },
    {
     "description": "ALKAME HOLDINGS INC",
     "symbol": "ALKM"
    },
    {
     "description": "ALKANE INC",
     "symbol": "ALKN"
    },
    {
     "description": "ALKERMES PLC",
     "symbol": "ALKS"
    },
    {
     "description": "ALKAMI TECHNOLOGY INC",
     "symbol": "ALKT"
    },
    {
     "description": "ALLSTATE CORP",
     "symbol": "ALL"
    },
    {
     "description": "ALLSTATE CORP",
     "symbol": "ALL.PRB"
    },
    {
     "description": "ALLSTATE CORP",
     "symbol": "ALL.PRG"
    },
    {
     "description": "ALLSTATE CORP",
     "symbol": "ALL.PRH"
    },
    {
     "description": "ALLSTATE CORP",
     "symbol": "ALL.PRI"
    },
    {
     "description": "ALLDAY MARTS INC",
     "symbol": "ALLDF"
    },
    {
     "description": "ALLEGION PLC",
     "symbol": "ALLE"
    },
    {
     "description": "ALLEGO NV",
     "symbol": "ALLG"
    },
    {
     "description": "ATHENA PUBCO BV -25",
     "symbol": "ALLG.WS"
    },
    {
     "description": "ATLANTIC LITHIUM LTD",
     "symbol": "ALLIF"
    },
    {
     "description": "ALLAKOS INC",
     "symbol": "ALLK"
    },
    {
     "description": "ALLIN CORPORATION",
     "symbol": "ALLN"
    },
    {
     "description": "ALLOGENE THERAPEUTICS INC",
     "symbol": "ALLO"
    },
    {
     "description": "AROCELL AB",
     "symbol": "ALLPF"
    },
    {
     "description": "ALLARITY THERAPEUTICS INC",
     "symbol": "ALLR"
    },
    {
     "description": "ALLOT LTD",
     "symbol": "ALLT"
    },
    {
     "description": "ALTICE EUROPE NV",
     "symbol": "ALLVF"
    },
    {
     "description": "ALLIED MINDS PLC",
     "symbol": "ALLWF"
    },
    {
     "description": "ARIS GOLD CORP",
     "symbol": "ALLXF"
    },
    {
     "description": "ALLY FINANCIAL INC",
     "symbol": "ALLY"
    },
    {
     "description": "ALIMCO FINANCIAL CORP",
     "symbol": "ALMC"
    },
    {
     "description": "Altus Midstream LP",
     "symbol": "ALMDP"
    },
    {
     "description": "ALAMO ENERGY CORP",
     "symbol": "ALME"
    },
    {
     "description": "ALTIUM LTD",
     "symbol": "ALMFF"
    },
    {
     "description": "ALUMINUM CORP OF CHINA LTD-H",
     "symbol": "ALMMF"
    },
    {
     "description": "ALMONTY INDUSTRIES INC",
     "symbol": "ALMTF"
    },
    {
     "description": "ALCHEMY CREATIVE INC",
     "symbol": "ALMY"
    },
    {
     "description": "ALLENA PHARMACEUTICALS INC",
     "symbol": "ALNA"
    },
    {
     "description": "ANA HOLDINGS INC",
     "symbol": "ALNPF"
    },
    {
     "description": "ANA HOLDINGS INC-SPONS ADR",
     "symbol": "ALNPY"
    },
    {
     "description": "MEDICLINIC INTERNATIONAL PLC",
     "symbol": "ALNRF"
    },
    {
     "description": "ALNYLAM PHARMACEUTICALS INC",
     "symbol": "ALNY"
    },
    {
     "description": "ALLIED RESOURCES INC",
     "symbol": "ALOD"
    },
    {
     "description": "ALSP ORCHID ACQUISITION-CL A",
     "symbol": "ALOR"
    },
    {
     "description": "ALSP ORCHID ACQUISITION CORP",
     "symbol": "ALORU"
    },
    {
     "description": "ALSP ORCHID ACQ CL A -CW23",
     "symbol": "ALORW"
    },
    {
     "description": "ALIOR BANK SA - UNSP ADR",
     "symbol": "ALORY"
    },
    {
     "description": "ASTRONOVA INC",
     "symbol": "ALOT"
    },
    {
     "description": "AYALALAND LOGISTICS HOLDINGS",
     "symbol": "ALOXF"
    },
    {
     "description": "ALABAMA POWER CO",
     "symbol": "ALP.PRQ"
    },
    {
     "description": "ALPHA HEALTHCARE ACQUISITI-A",
     "symbol": "ALPA"
    },
    {
     "description": "ALPHA HEALTHCARE ACQUISITION",
     "symbol": "ALPAU"
    },
    {
     "description": "ALPHA HEALTHCARE ACQUIS-CW27",
     "symbol": "ALPAW"
    },
    {
     "description": "ALPHA INVESTMENT INC",
     "symbol": "ALPC"
    },
    {
     "description": "ALPHA-EN CORP",
     "symbol": "ALPE"
    },
    {
     "description": "ALPHA GROWTH PLC",
     "symbol": "ALPGF"
    },
    {
     "description": "ALPINE BANKS OF COLORADO-B",
     "symbol": "ALPIB"
    },
    {
     "description": "ALPEK SA DE CV",
     "symbol": "ALPKF"
    },
    {
     "description": "ASTELLAS PHARMA INC",
     "symbol": "ALPMF"
    },
    {
     "description": "ASTELLAS PHARMA INC-UNSP ADR",
     "symbol": "ALPMY"
    },
    {
     "description": "ALPINE IMMUNE SCIENCES INC",
     "symbol": "ALPN"
    },
    {
     "description": "ALPINE 4 HOLDINGS INC",
     "symbol": "ALPP"
    },
    {
     "description": "Alabama Power Company",
     "symbol": "ALPVN"
    },
    {
     "description": "ALERISLIFE INC",
     "symbol": "ALR"
    },
    {
     "description": "ALERION CLEANPOWER",
     "symbol": "ALRCF"
    },
    {
     "description": "ANTLER GOLD INC",
     "symbol": "ALRGF"
    },
    {
     "description": "ALLREAL HOLDING AG-REG",
     "symbol": "ALRHF"
    },
    {
     "description": "ALARM.COM HOLDINGS INC",
     "symbol": "ALRM"
    },
    {
     "description": "AILERON THERAPEUTICS INC",
     "symbol": "ALRN"
    },
    {
     "description": "ALERUS FINANCIAL CORP",
     "symbol": "ALRS"
    },
    {
     "description": "ALR TECHNOLOGIES INC",
     "symbol": "ALRT"
    },
    {
     "description": "ALLENERGY INC",
     "symbol": "ALRY"
    },
    {
     "description": "ALPHA STAR ACQUISITION CORP",
     "symbol": "ALSA"
    },
    {
     "description": "ALPHA STAR ACQ CORP - RIGHTS",
     "symbol": "ALSAR"
    },
    {
     "description": "ALPHA STAR ACQUISITION CORP",
     "symbol": "ALSAU"
    },
    {
     "description": "ALPHA STAR ACQUISITION -CW23",
     "symbol": "ALSAW"
    },
    {
     "description": "ALSERES PHARMACEUTICALS INC",
     "symbol": "ALSE"
    },
    {
     "description": "ATLAS RESOURCES INTERNATIONA",
     "symbol": "ALSI"
    },
    {
     "description": "ALSTOM SA-UNSPON ADR",
     "symbol": "ALSMY"
    },
    {
     "description": "ALLISON TRANSMISSION HOLDING",
     "symbol": "ALSN"
    },
    {
     "description": "ALSTRIA OFFICE REIT-AG",
     "symbol": "ALSRF"
    },
    {
     "description": "ALSEA SAB DE CV",
     "symbol": "ALSSF"
    },
    {
     "description": "ALLSTAR HEALTH BRANDS INC",
     "symbol": "ALST"
    },
    {
     "description": "ALTIMMUNE INC",
     "symbol": "ALT"
    },
    {
     "description": "MORELLA CORP LTD",
     "symbol": "ALTAF"
    },
    {
     "description": "ALPINE AUTO BROKERS INC",
     "symbol": "ALTB"
    },
    {
     "description": "ALTITUDE INTERNATIONAL INC",
     "symbol": "ALTD"
    },
    {
     "description": "ALTA EQUIPMENT GROUP INC",
     "symbol": "ALTG"
    },
    {
     "description": "ALTA EQUIPMENT GROUP",
     "symbol": "ALTG.PRA"
    },
    {
     "description": "Altagas Ltd",
     "symbol": "ALTGF"
    },
    {
     "description": "ALTECH CHEMICAL LTD",
     "symbol": "ALTHF"
    },
    {
     "description": "PACER LUNT LARGE CAP ALTERNA",
     "symbol": "ALTL"
    },
    {
     "description": "ALTUS MIDSTREAM CO - CW23",
     "symbol": "ALTMW"
    },
    {
     "description": "ALTO INGREDIENTS INC",
     "symbol": "ALTO"
    },
    {
     "description": "ALTIPLANO METALS INC",
     "symbol": "ALTPF"
    },
    {
     "description": "ALTAIR ENGINEERING INC - A",
     "symbol": "ALTR"
    },
    {
     "description": "PRSHR MRNGSTR ALT SOL ETF",
     "symbol": "ALTS"
    },
    {
     "description": "ALTURAS MINERALS CORP",
     "symbol": "ALTSF"
    },
    {
     "description": "ALTITUDE ACQUISITION CORP-A",
     "symbol": "ALTU"
    },
    {
     "description": "ALTUS STRATEGIES PLC",
     "symbol": "ALTUF"
    },
    {
     "description": "ALTITUDE ACQUISITION CORP",
     "symbol": "ALTUU"
    },
    {
     "description": "ALTITUDE ACQ CL A -CW27",
     "symbol": "ALTUW"
    },
    {
     "description": "ALTEX INDUSTRIES INC",
     "symbol": "ALTX"
    },
    {
     "description": "GLOBAL X ALTERNATIVE INCOME",
     "symbol": "ALTY"
    },
    {
     "description": "AUTOLIV INC",
     "symbol": "ALV"
    },
    {
     "description": "BIG RIDGE GOLD CORP",
     "symbol": "ALVLF"
    },
    {
     "description": "ALVIVA HOLDINGS LTD",
     "symbol": "ALVNF"
    },
    {
     "description": "ALVOPETRO ENERGY LTD",
     "symbol": "ALVOF"
    },
    {
     "description": "ALLOVIR INC",
     "symbol": "ALVR"
    },
    {
     "description": "ALVARION LTD",
     "symbol": "ALVRQ"
    },
    {
     "description": "A-LIVING SMART CITY SERVICES",
     "symbol": "ALVSF"
    },
    {
     "description": "ALLVUE SYSTEMS HDS INC-A",
     "symbol": "ALVU"
    },
    {
     "description": "ALTICE EUROPE NV - B",
     "symbol": "ALVVF"
    },
    {
     "description": "ALEXANDER'S INC",
     "symbol": "ALX"
    },
    {
     "description": "ALX RESOURCES CORP",
     "symbol": "ALXEF"
    },
    {
     "description": "ALX ONCOLOGY HOLDINGS INC",
     "symbol": "ALXO"
    },
    {
     "description": "AVANTE LOGIXX INC",
     "symbol": "ALXXF"
    },
    {
     "description": "ALITHYA GROUP INC-CLASS A",
     "symbol": "ALYA"
    },
    {
     "description": "ALY ENERGY SERVICES INC",
     "symbol": "ALYE"
    },
    {
     "description": "ALTERNET SYSTEMS INC",
     "symbol": "ALYI"
    },
    {
     "description": "ALZCHEM GROUP AG",
     "symbol": "ALZCF"
    },
    {
     "description": "ALZAMEND NEURO INC",
     "symbol": "ALZN"
    },
    {
     "description": "ALONY HETZ PROPERTIES & INV",
     "symbol": "ALZPF"
    },
    {
     "description": "ANTERO MIDSTREAM CORP",
     "symbol": "AM"
    },
    {
     "description": "AMADEUS IT GROUP SA",
     "symbol": "AMADF"
    },
    {
     "description": "AMADEUS IT GROUP-UNSP ADR",
     "symbol": "AMADY"
    },
    {
     "description": "AMALGAMATED FINANCIAL CORP",
     "symbol": "AMAL"
    },
    {
     "description": "AMBRX BIOPHARMA INC-ADR",
     "symbol": "AMAM"
    },
    {
     "description": "AMANO CORP",
     "symbol": "AMANF"
    },
    {
     "description": "AMERICAN ACQUISITION OP-CL A",
     "symbol": "AMAO"
    },
    {
     "description": "AMERICAN ACQUISITION OPPORTU",
     "symbol": "AMAOU"
    },
    {
     "description": "AMERICAN ACQ -CL A -CW26",
     "symbol": "AMAOW"
    },
    {
     "description": "APPLIED MATERIALS INC",
     "symbol": "AMAT"
    },
    {
     "description": "RH HEDGED MULTI-ASSET INC",
     "symbol": "AMAX"
    },
    {
     "description": "AMAZING ENERGY OIL AND GAS C",
     "symbol": "AMAZ"
    },
    {
     "description": "AMBARELLA INC",
     "symbol": "AMBA"
    },
    {
     "description": "AMBU A\/S - UNSP ADR",
     "symbol": "AMBBY"
    },
    {
     "description": "AMBAC FINANCIAL GROUP INC",
     "symbol": "AMBC"
    },
    {
     "description": "AMBAC FINANCIAL GROUP-CW23",
     "symbol": "AMBC.WS"
    },
    {
     "description": "AMERICAN MOBILE DENTAL CORP",
     "symbol": "AMBD"
    },
    {
     "description": "AMBEA AB",
     "symbol": "AMBEF"
    },
    {
     "description": "AMBU A\/S-B",
     "symbol": "AMBFF"
    },
    {
     "description": "AMBG INC",
     "symbol": "AMBG"
    },
    {
     "description": "AMERICAN BANK INC(PA)",
     "symbol": "AMBK"
    },
    {
     "description": "American Bank Inc",
     "symbol": "AMBKP"
    },
    {
     "description": "AMBOW EDUCATION HOLDING-ADR",
     "symbol": "AMBO"
    },
    {
     "description": "ARDAGH METAL PACKAGING SA",
     "symbol": "AMBP"
    },
    {
     "description": "ARDAGH METAL PACKAGING -CW26",
     "symbol": "AMBP.WS"
    },
    {
     "description": "AMARANTUS BIOSCIENCE HOLDING",
     "symbol": "AMBS"
    },
    {
     "description": "AMERICAN BUSINESS BANK",
     "symbol": "AMBZ"
    },
    {
     "description": "AMC ENTERTAINMENT HLDS-CL A",
     "symbol": "AMC"
    },
    {
     "description": "AMCOR PLC-CDI",
     "symbol": "AMCCF"
    },
    {
     "description": "ANDATEE CHINA MARINE FUEL SE",
     "symbol": "AMCF"
    },
    {
     "description": "AMCI ACQUISITION CORP II-A",
     "symbol": "AMCI"
    },
    {
     "description": "AMCI ACQUISITION CORP II",
     "symbol": "AMCIU"
    },
    {
     "description": "AMCI ACQUISITION II A -CW28",
     "symbol": "AMCIW"
    },
    {
     "description": "AMCOR PLC",
     "symbol": "AMCR"
    },
    {
     "description": "AMERICAN EDUCATION CENTER IN",
     "symbol": "AMCT"
    },
    {
     "description": "AMATA CORP PUBLIC COLTD-NVDR",
     "symbol": "AMCUF"
    },
    {
     "description": "AMC NETWORKS INC-A",
     "symbol": "AMCX"
    },
    {
     "description": "ACS GLOBAL INC",
     "symbol": "AMCY"
    },
    {
     "description": "ADVANCED MICRO DEVICES",
     "symbol": "AMD"
    },
    {
     "description": "SINTX TECHNOLOGIES INC-CW23",
     "symbol": "AMDDW"
    },
    {
     "description": "AMUNDI MSCI EMU ESG LEADERS",
     "symbol": "AMDFF"
    },
    {
     "description": "AMUNDI MSCI EM ASIA UCITS",
     "symbol": "AMDIF"
    },
    {
     "description": "AMADA CO LTD-UNSP ADR",
     "symbol": "AMDLY"
    },
    {
     "description": "AMUNDI SA",
     "symbol": "AMDUF"
    },
    {
     "description": "AMADA CO LTD",
     "symbol": "AMDWF"
    },
    {
     "description": "AMETEK INC",
     "symbol": "AME"
    },
    {
     "description": "AMEDISYS INC",
     "symbol": "AMED"
    },
    {
     "description": "APOLLO MEDICAL HOLDINGS INC",
     "symbol": "AMEH"
    },
    {
     "description": "AMEN PROPERTIES INC",
     "symbol": "AMEN"
    },
    {
     "description": "EMLES MADE IN AMERICA ETF",
     "symbol": "AMER"
    },
    {
     "description": "ANTERIS TECHNOLOGIES LTD",
     "symbol": "AMEUF"
    },
    {
     "description": "AMASTEN FASTIGHETS AB",
     "symbol": "AMFAF"
    },
    {
     "description": "AMB FINANCIAL CORP",
     "symbol": "AMFC"
    },
    {
     "description": "AMERICAN FILMS INC",
     "symbol": "AMFL"
    },
    {
     "description": "AMPLIFON SPA",
     "symbol": "AMFPF"
    },
    {
     "description": "AMPLIFON SPA-UNSP ADR",
     "symbol": "AMFPY"
    },
    {
     "description": "AFFILIATED MANAGERS GROUP",
     "symbol": "AMG"
    },
    {
     "description": "ASTON MARTIN LAGONDA GLOBAL",
     "symbol": "AMGDF"
    },
    {
     "description": "AMGEN INC",
     "symbol": "AMGN"
    },
    {
     "description": "AMA GROUP LTD",
     "symbol": "AMGRF"
    },
    {
     "description": "ANGES INC",
     "symbol": "AMGXF"
    },
    {
     "description": "AMERICAN METAL & TECHNOLOGY",
     "symbol": "AMGY"
    },
    {
     "description": "AMERICAN HOMES 4 RENT- A",
     "symbol": "AMH"
    },
    {
     "description": "AMERICAN HOMES 4 RENT",
     "symbol": "AMH.PRF"
    },
    {
     "description": "AMERICAN HOMES 4 RENT",
     "symbol": "AMH.PRG"
    },
    {
     "description": "AMERICAN HOMES 4 RENT",
     "symbol": "AMH.PRH"
    },
    {
     "description": "HLK BIOTECH HOLDING GROUP IN",
     "symbol": "AMHD"
    },
    {
     "description": "AMERGENT HOSPITALITY GROUP I",
     "symbol": "AMHG"
    },
    {
     "description": "AMIGO HOLDINGS PLC",
     "symbol": "AMHLF"
    },
    {
     "description": "VERDE AGRITECH PLC",
     "symbol": "AMHPF"
    },
    {
     "description": "AMERICAN HEMP VENTURES INC",
     "symbol": "AMHV"
    },
    {
     "description": "ADMIRAL GROUP PLC",
     "symbol": "AMIGF"
    },
    {
     "description": "ADMIRAL GROUP PLC-UNSPON ADR",
     "symbol": "AMIGY"
    },
    {
     "description": "AMERICAN INTERNATIONAL HOLDI",
     "symbol": "AMIH"
    },
    {
     "description": "AMERICAN INTL INDUSTRIES INC",
     "symbol": "AMIN"
    },
    {
     "description": "ASHANTI SANKOFA INC",
     "symbol": "AMIQF"
    },
    {
     "description": "ABRA MINING & INDUSTRIAL",
     "symbol": "AMIUF"
    },
    {
     "description": "ATRIUM MORTGAGE INVESTMENT C",
     "symbol": "AMIVF"
    },
    {
     "description": "JPMORGAN ALERIAN MLP INDEX",
     "symbol": "AMJ"
    },
    {
     "description": "ASSETMARK FINANCIAL HOLDINGS",
     "symbol": "AMK"
    },
    {
     "description": "AP MOLLER-MAERSK A\/S-A",
     "symbol": "AMKAF"
    },
    {
     "description": "AP MOLLER-MAERSK A\/S-B",
     "symbol": "AMKBF"
    },
    {
     "description": "A P MOLLER-MAERSK-B-UNSP ADR",
     "symbol": "AMKBY"
    },
    {
     "description": "AMKOR TECHNOLOGY INC",
     "symbol": "AMKR"
    },
    {
     "description": "ABC-MART INC",
     "symbol": "AMKYF"
    },
    {
     "description": "AMELCO CORP",
     "symbol": "AMLC"
    },
    {
     "description": "AMERICAN LEISURE HOLDINGS IN",
     "symbol": "AMLH"
    },
    {
     "description": "AEON MALL CO LTD",
     "symbol": "AMLLF"
    },
    {
     "description": "AMERICAN LITHIUM MINERALS IN",
     "symbol": "AMLM"
    },
    {
     "description": "ALERIAN MLP ETF",
     "symbol": "AMLP"
    },
    {
     "description": "AMP LTD",
     "symbol": "AMLTF"
    },
    {
     "description": "AMYLYX PHARMACEUTICALS INC",
     "symbol": "AMLX"
    },
    {
     "description": "AMP LTD - SP ADR",
     "symbol": "AMLYY"
    },
    {
     "description": "AFRICAN MINERALS LTD",
     "symbol": "AMLZF"
    },
    {
     "description": "AMUR MINERALS CORP",
     "symbol": "AMMCF"
    },
    {
     "description": "AMMB HOLDINGS BHD",
     "symbol": "AMMHF"
    },
    {
     "description": "AMERICAN CANNABIS CO INC",
     "symbol": "AMMJ"
    },
    {
     "description": "AMMPOWER CORP",
     "symbol": "AMMPF"
    },
    {
     "description": "AMERAMEX INTERNATIONAL",
     "symbol": "AMMX"
    },
    {
     "description": "AMN HEALTHCARE SERVICES INC",
     "symbol": "AMN"
    },
    {
     "description": "ETRACS ALERIAN MIDSTREAM ENE",
     "symbol": "AMNA"
    },
    {
     "description": "AMER NATL BNKSHS\/DANVILLE VA",
     "symbol": "AMNB"
    },
    {
     "description": "AMINCOR INC - CL A",
     "symbol": "AMNC"
    },
    {
     "description": "AMINCOR INC - CL B",
     "symbol": "AMNCB"
    },
    {
     "description": "ETRACS ALERIAN MIDST H\/DV EN",
     "symbol": "AMND"
    },
    {
     "description": "AMERICAN GREEN GROUP INC",
     "symbol": "AMNE"
    },
    {
     "description": "ARMANINO FOODS OF DISTINCT",
     "symbol": "AMNF"
    },
    {
     "description": "APPLIED MINERALS INC",
     "symbol": "AMNL"
    },
    {
     "description": "AMCOMRI ENTERTAINMENT INC",
     "symbol": "AMNNF"
    },
    {
     "description": "AMERICAN SIERRA GOLD CORP",
     "symbol": "AMNP"
    },
    {
     "description": "ASIA CEMENT CHINA HOLDINGS",
     "symbol": "AMNTF"
    },
    {
     "description": "AMBRIAN PLC",
     "symbol": "AMNZF"
    },
    {
     "description": "QRAFT AI-ENH US LRG CAP MTM",
     "symbol": "AMOM"
    },
    {
     "description": "ATOMOS LTD",
     "symbol": "AMOSF"
    },
    {
     "description": "ALLIED MOTION TECHNOLOGIES",
     "symbol": "AMOT"
    },
    {
     "description": "AMERICA MOVIL-ADR SERIES A",
     "symbol": "AMOV"
    },
    {
     "description": "AMERICA MOVIL SAB DE C-SER A",
     "symbol": "AMOVF"
    },
    {
     "description": "AMERIPRISE FINANCIAL INC",
     "symbol": "AMP"
    },
    {
     "description": "AMPD VENTURES INC",
     "symbol": "AMPDF"
    },
    {
     "description": "AMPIO PHARMACEUTICALS INC",
     "symbol": "AMPE"
    },
    {
     "description": "AMPLITECH GROUP INC",
     "symbol": "AMPG"
    },
    {
     "description": "AMPLITECH GROUP INC-CW26",
     "symbol": "AMPGW"
    },
    {
     "description": "AMPHASTAR PHARMACEUTICALS IN",
     "symbol": "AMPH"
    },
    {
     "description": "ADVANCED MERGER PARTNERS I-A",
     "symbol": "AMPI"
    },
    {
     "description": "ADVANCED MERGER PARTNERS INC",
     "symbol": "AMPI.U"
    },
    {
     "description": "ADVANCED MERGER PART -CW26",
     "symbol": "AMPI.WS"
    },
    {
     "description": "AMPLITUDE INC-CLASS A",
     "symbol": "AMPL"
    },
    {
     "description": "AMPERICO CORP",
     "symbol": "AMPO"
    },
    {
     "description": "ALTUS POWER INC",
     "symbol": "AMPS"
    },
    {
     "description": "ALTUS POWER INC - CW27",
     "symbol": "AMPS.WS"
    },
    {
     "description": "AMPLIFY ENERGY CORP",
     "symbol": "AMPY"
    },
    {
     "description": "AMPLIFY ENERGY CORP-CW22",
     "symbol": "AMPYW"
    },
    {
     "description": "ALPHA METALLURGICAL RESOURCE",
     "symbol": "AMR"
    },
    {
     "description": "AMERICAN RACING CAPITAL INC",
     "symbol": "AMRA"
    },
    {
     "description": "AMERESCO INC-CL A",
     "symbol": "AMRC"
    },
    {
     "description": "A-MARK PRECIOUS METALS INC",
     "symbol": "AMRK"
    },
    {
     "description": "AMERICAN LITHIUM CORP-CW24",
     "symbol": "AMRLF"
    },
    {
     "description": "AMARIN CORP PLC -ADR",
     "symbol": "AMRN"
    },
    {
     "description": "AMAERO INTERNATIONAL LTD",
     "symbol": "AMROF"
    },
    {
     "description": "AMOREPACIFIC CORP",
     "symbol": "AMRPF"
    },
    {
     "description": "AMERICAN METALS RECOVERY AND",
     "symbol": "AMRR"
    },
    {
     "description": "AMYRIS INC",
     "symbol": "AMRS"
    },
    {
     "description": "AMERICAN MART CORP",
     "symbol": "AMRT"
    },
    {
     "description": "AMARU INC",
     "symbol": "AMRU"
    },
    {
     "description": "AMNEAL PHARMACEUTICALS INC",
     "symbol": "AMRX"
    },
    {
     "description": "ARENA MINERALS INC",
     "symbol": "AMRZF"
    },
    {
     "description": "AMERICAN SHARED HOSPITAL SER",
     "symbol": "AMS"
    },
    {
     "description": "AMERICAN SENIORS ASSOCIATION",
     "symbol": "AMSA"
    },
    {
     "description": "AMERICAN SUPERCONDUCTOR CORP",
     "symbol": "AMSC"
    },
    {
     "description": "AMERISAFE INC",
     "symbol": "AMSF"
    },
    {
     "description": "ARCELORMITTAL SOUTH-SPN ADR",
     "symbol": "AMSIY"
    },
    {
     "description": "AUSTRALIAN MINES LTD",
     "symbol": "AMSLF"
    },
    {
     "description": "AMS-OSRAM AG - UNSP ADR",
     "symbol": "AMSSY"
    },
    {
     "description": "AMESITE INC",
     "symbol": "AMST"
    },
    {
     "description": "AMANASU ENVIRONMENT CORP",
     "symbol": "AMSU"
    },
    {
     "description": "AMERICAN SOFTWARE INC-CL A",
     "symbol": "AMSWA"
    },
    {
     "description": "ARCELORMITTAL",
     "symbol": "AMSYF"
    },
    {
     "description": "AMERICAN TOWER CORP",
     "symbol": "AMT"
    },
    {
     "description": "AMISTAR CORP",
     "symbol": "AMTA"
    },
    {
     "description": "AMERANT BANCORP INC",
     "symbol": "AMTB"
    },
    {
     "description": "AMERITRANS CAPTL CORPORATION",
     "symbol": "AMTCQ"
    },
    {
     "description": "AMTD IDEA GROUP",
     "symbol": "AMTD"
    },
    {
     "description": "APPLIED MOLECULAR TRANSPORT",
     "symbol": "AMTI"
    },
    {
     "description": "Ameritrans Capital Corporation",
     "symbol": "AMTPQ"
    },
    {
     "description": "ETRACS ALERIAN MDSTR ENER TR",
     "symbol": "AMTR"
    },
    {
     "description": "AEMETIS INC",
     "symbol": "AMTX"
    },
    {
     "description": "AMERITYRE CORP",
     "symbol": "AMTY"
    },
    {
     "description": "ETRACS ALERIAN MLP IND SER B",
     "symbol": "AMUB"
    },
    {
     "description": "AMUN IDX EQY GBL MS AL STF B",
     "symbol": "AMUDF"
    },
    {
     "description": "AMVIG HOLDINGS LTD",
     "symbol": "AMVGF"
    },
    {
     "description": "AMG ADVANCED METALLURGICAL",
     "symbol": "AMVMF"
    },
    {
     "description": "AMERICAN WOODMARK CORP",
     "symbol": "AMWD"
    },
    {
     "description": "AMERISTAR NETWORK INC",
     "symbol": "AMWK"
    },
    {
     "description": "AMERICAN WELL CORP-CLASS A",
     "symbol": "AMWL"
    },
    {
     "description": "AMERICA MOVIL-SPN ADR CL L",
     "symbol": "AMX"
    },
    {
     "description": "AMEX EXPLORATION INC",
     "symbol": "AMXEF"
    },
    {
     "description": "AMERICA MOVIL SAB DE C-SER L",
     "symbol": "AMXVF"
    },
    {
     "description": "MAXX SPORTS TV INC",
     "symbol": "AMXX"
    },
    {
     "description": "AMRYT PHARMA PLC - SPNR ADR",
     "symbol": "AMYT"
    },
    {
     "description": "AMERICAN MANGANESE INC",
     "symbol": "AMYZF"
    },
    {
     "description": "INFRACAP MLP ETF",
     "symbol": "AMZA"
    },
    {
     "description": "AMAZON.COM INC",
     "symbol": "AMZN"
    },
    {
     "description": "AUTONATION INC",
     "symbol": "AN"
    },
    {
     "description": "ANAPTYSBIO INC",
     "symbol": "ANAB"
    },
    {
     "description": "ARCTOS NORTHSTAR ACQUISIT-A",
     "symbol": "ANAC"
    },
    {
     "description": "ARCTOS NORTHSTAR ACQUISITION",
     "symbol": "ANAC.U"
    },
    {
     "description": "ARCTOS NORTHSTAR ACQ -CW28",
     "symbol": "ANAC.WS"
    },
    {
     "description": "ALTERNATURALS INC",
     "symbol": "ANAS"
    },
    {
     "description": "AMERICAN NATIONAL GROUP INC",
     "symbol": "ANAT"
    },
    {
     "description": "ALPHA NETWORK ALLIANCE VENTU",
     "symbol": "ANAV"
    },
    {
     "description": "RESTANCE INC",
     "symbol": "ANCE"
    },
    {
     "description": "AMERICAN CONSUMERS INC",
     "symbol": "ANCSQ"
    },
    {
     "description": "ALIMENTATION COUCHE-TARD INC",
     "symbol": "ANCTF"
    },
    {
     "description": "ANDOVER BANCORP INC\/OH",
     "symbol": "ANDC"
    },
    {
     "description": "ANR INC - CTGG REV - 2023 R",
     "symbol": "ANDD"
    },
    {
     "description": "ANDERSONS INC\/THE",
     "symbol": "ANDE"
    },
    {
     "description": "AEON DELIGHT CO LTD",
     "symbol": "ANDGF"
    },
    {
     "description": "ANDLAUER HEALTHCARE GROUP IN",
     "symbol": "ANDHF"
    },
    {
     "description": "ANDIAMO CORP",
     "symbol": "ANDI"
    },
    {
     "description": "ANDROMEDA METALS LTD",
     "symbol": "ANDMF"
    },
    {
     "description": "ALUMINDO LIGHT METAL INDU PT",
     "symbol": "ANDOF"
    },
    {
     "description": "ANDREA ELECTRONICS CORP",
     "symbol": "ANDR"
    },
    {
     "description": "ANEBULO PHARMACEUTICALS INC",
     "symbol": "ANEB"
    },
    {
     "description": "ARISTA NETWORKS INC",
     "symbol": "ANET"
    },
    {
     "description": "PROSHARES MSCI TRANSFORM CHG",
     "symbol": "ANEW"
    },
    {
     "description": "AUST AND NZ BANKING GROUP",
     "symbol": "ANEWF"
    },
    {
     "description": "ABERCROMBIE & FITCH CO-CL A",
     "symbol": "ANF"
    },
    {
     "description": "ANTOFAGASTA PLC",
     "symbol": "ANFGF"
    },
    {
     "description": "AMIRA NATURE FOODS LTD",
     "symbol": "ANFIF"
    },
    {
     "description": "ANGEL GOLD CORP",
     "symbol": "ANGCF"
    },
    {
     "description": "ANGANG STEEL CO LTD-H",
     "symbol": "ANGGF"
    },
    {
     "description": "ANGHAMI INC",
     "symbol": "ANGH"
    },
    {
     "description": "ANGHAMI INC -CW27",
     "symbol": "ANGHW"
    },
    {
     "description": "ANGI INC",
     "symbol": "ANGI"
    },
    {
     "description": "VANECK FALLEN ANGEL HIGH YLD",
     "symbol": "ANGL"
    },
    {
     "description": "ANGLER GAMING PLC",
     "symbol": "ANGMF"
    },
    {
     "description": "ANGION BIOMEDICA CORP",
     "symbol": "ANGN"
    },
    {
     "description": "ANGIODYNAMICS INC",
     "symbol": "ANGO"
    },
    {
     "description": "ANGLO AMERICAN PLAT-SPON ADR",
     "symbol": "ANGPY"
    },
    {
     "description": "CANADA ONE MINING CORP",
     "symbol": "ANGUF"
    },
    {
     "description": "ANGUS GOLD INC",
     "symbol": "ANGVF"
    },
    {
     "description": "MEDICLINIC INTERNATIO-UN ADR",
     "symbol": "ANHGY"
    },
    {
     "description": "ANCHOR HOCKING HOLDINGS",
     "symbol": "ANHH"
    },
    {
     "description": "ANIKA THERAPEUTICS INC",
     "symbol": "ANIK"
    },
    {
     "description": "ACERINOX SA-UNSPON ADR",
     "symbol": "ANIOY"
    },
    {
     "description": "ANI PHARMACEUTICALS INC",
     "symbol": "ANIP"
    },
    {
     "description": "ANIXA BIOSCIENCES INC",
     "symbol": "ANIX"
    },
    {
     "description": "ANGKOR RESOURCES CORP",
     "symbol": "ANKOF"
    },
    {
     "description": "ATON RESOURCES INC",
     "symbol": "ANLBF"
    },
    {
     "description": "ANFIELD ENERGY INC",
     "symbol": "ANLDF"
    },
    {
     "description": "ANACOMP INC",
     "symbol": "ANMP"
    },
    {
     "description": "ANIMA HOLDING SPA",
     "symbol": "ANNMF"
    },
    {
     "description": "AENA SME SA",
     "symbol": "ANNSF"
    },
    {
     "description": "ANNEXON INC",
     "symbol": "ANNX"
    },
    {
     "description": "ANPAC BIO-MEDICAL SCIENC-ADR",
     "symbol": "ANPC"
    },
    {
     "description": "ANGLE PLC",
     "symbol": "ANPCF"
    },
    {
     "description": "ANGLE PLC-SPON ADR",
     "symbol": "ANPCY"
    },
    {
     "description": "ANTA SPORTS PRODUCTS LTD",
     "symbol": "ANPDF"
    },
    {
     "description": "ANTA SPORTS PROD-UNSPON ADR",
     "symbol": "ANPDY"
    },
    {
     "description": "ANPULO FOOD INC",
     "symbol": "ANPFF"
    },
    {
     "description": "ANDEAN PRECIOUS METALS CORP",
     "symbol": "ANPMF"
    },
    {
     "description": "AMERICAN PATRIOT OIL & GAS L",
     "symbol": "ANPOF"
    },
    {
     "description": "ANAERGIA INC-SUB VOTING SHR",
     "symbol": "ANRGF"
    },
    {
     "description": "ANSELL LTD",
     "symbol": "ANSLF"
    },
    {
     "description": "ANSELL LTD-UNSPON ADR",
     "symbol": "ANSLY"
    },
    {
     "description": "ANSON RESOURCES LTD",
     "symbol": "ANSNF"
    },
    {
     "description": "ANSYS INC",
     "symbol": "ANSS"
    },
    {
     "description": "AMANASU TECHNOLOGIES CORP",
     "symbol": "ANSU"
    },
    {
     "description": "AION THERAPEUTIC INC",
     "symbol": "ANTCF"
    },
    {
     "description": "AIRNET TECHNOLOGY INC-ADR",
     "symbol": "ANTE"
    },
    {
     "description": "ADVANTAGEWON OIL CORP",
     "symbol": "ANTGF"
    },
    {
     "description": "ANTHERA PHARMACEUTICALS INC",
     "symbol": "ANTH"
    },
    {
     "description": "ANTIGENICS INC\/CO",
     "symbol": "ANTI"
    },
    {
     "description": "ANTHEM INC",
     "symbol": "ANTM"
    },
    {
     "description": "ANTILLES GOLD LTD",
     "symbol": "ANTMF"
    },
    {
     "description": "IIDA GROUP HOLDINGS CO LTD",
     "symbol": "ANTOF"
    },
    {
     "description": "ANTARES VISION SPA",
     "symbol": "ANTVF"
    },
    {
     "description": "AN2 THERAPEUTICS INC",
     "symbol": "ANTX"
    },
    {
     "description": "ANOVA METALS LTD",
     "symbol": "ANVMF"
    },
    {
     "description": "ANNOVIS BIO",
     "symbol": "ANVS"
    },
    {
     "description": "ANVIA HOLDINGS CORP",
     "symbol": "ANVV"
    },
    {
     "description": "ANACONDA MINING INC",
     "symbol": "ANXGF"
    },
    {
     "description": "ANNEXIN PHARMACEUTICALS AB",
     "symbol": "ANXNF"
    },
    {
     "description": "SPHERE 3D CORP",
     "symbol": "ANY"
    },
    {
     "description": "AENA SME SA-ADR",
     "symbol": "ANYYY"
    },
    {
     "description": "AUST & NZ BNKG GRP-SPON ADR",
     "symbol": "ANZBY"
    },
    {
     "description": "AIR NEW ZEALAND LTD",
     "symbol": "ANZFF"
    },
    {
     "description": "AIR NEW ZEALAND - ADR",
     "symbol": "ANZLY"
    },
    {
     "description": "AIR NEW ZEALAND LTD-RIGHTS",
     "symbol": "ANZRF"
    },
    {
     "description": "ANZU SPECIAL ACQUISITION -A",
     "symbol": "ANZU"
    },
    {
     "description": "ANZU SPECIAL ACQUISITION COR",
     "symbol": "ANZUU"
    },
    {
     "description": "ANZU SPECIAL ACQ -CW27",
     "symbol": "ANZUW"
    },
    {
     "description": "ISHARES CORE AGGRESSIVE ALLO",
     "symbol": "AOA"
    },
    {
     "description": "ALPHA ONE INC",
     "symbol": "AOAO"
    },
    {
     "description": "AMERICAN ORIENTAL BIOENGINEE",
     "symbol": "AOBI"
    },
    {
     "description": "AUTOCANADA INC",
     "symbol": "AOCIF"
    },
    {
     "description": "ABERDEEN TTL DYN DIVID",
     "symbol": "AOD"
    },
    {
     "description": "AFERIAN PLC",
     "symbol": "AOECF"
    },
    {
     "description": "AUSTRALIAN OIL & GAS CORP",
     "symbol": "AOGC"
    },
    {
     "description": "AROGO CAPITAL ACQUISITION -A",
     "symbol": "AOGO"
    },
    {
     "description": "AROGO CAPITAL ACQUISITION CO",
     "symbol": "AOGOU"
    },
    {
     "description": "AROGO CAPITAL ACQ -CW23",
     "symbol": "AOGOW"
    },
    {
     "description": "AUTOHELLAS SA",
     "symbol": "AOHLF"
    },
    {
     "description": "AFRICA OIL CORP",
     "symbol": "AOIFF"
    },
    {
     "description": "ARTS OPTICAL INTL HLDGS LTD",
     "symbol": "AOIHF"
    },
    {
     "description": "NFINITI INC",
     "symbol": "AOIXD"
    },
    {
     "description": "ISHARES CORE CONSERVATIVE AL",
     "symbol": "AOK"
    },
    {
     "description": "AEOLUS PHARMACEUTICALS INC",
     "symbol": "AOLS"
    },
    {
     "description": "ISHARES CORE MODERATE ALLOCA",
     "symbol": "AOM"
    },
    {
     "description": "ALSTOM",
     "symbol": "AOMFF"
    },
    {
     "description": "MOSENERGO PAO-SPONSORED ADR",
     "symbol": "AOMOY"
    },
    {
     "description": "ANGEL OAK MORTGAGE INC",
     "symbol": "AOMR"
    },
    {
     "description": "ACSL LTD",
     "symbol": "AOMUF"
    },
    {
     "description": "AON PLC-CLASS A",
     "symbol": "AON"
    },
    {
     "description": "AEON CO LTD",
     "symbol": "AONNF"
    },
    {
     "description": "AEON COMPANY LTD- UNSPON ADR",
     "symbol": "AONNY"
    },
    {
     "description": "AUTOCO.COM INC",
     "symbol": "AOOO"
    },
    {
     "description": "ISHARES CORE GROWTH ALLOCATI",
     "symbol": "AOR"
    },
    {
     "description": "AMERICAN OVERSEAS GROUP LTD",
     "symbol": "AOREF"
    },
    {
     "description": "ARGOS RESOURCES LTD-DI",
     "symbol": "AORGF"
    },
    {
     "description": "ARTIVION INC",
     "symbol": "AORT"
    },
    {
     "description": "SMITH (A.O.) CORP",
     "symbol": "AOS"
    },
    {
     "description": "ALPHA & OMEGA SEMICONDUCTOR",
     "symbol": "AOSL"
    },
    {
     "description": "ANOTO GROUP AB",
     "symbol": "AOTOF"
    },
    {
     "description": "PRECINCT PROPERTIES NEW ZEAL",
     "symbol": "AOTUF"
    },
    {
     "description": "ASCOT RESOURCES LTD",
     "symbol": "AOTVF"
    },
    {
     "description": "AMERICAN OUTDOOR BRANDS INC",
     "symbol": "AOUT"
    },
    {
     "description": "ANDOVER MINING CORP",
     "symbol": "AOVTF"
    },
    {
     "description": "AO WORLD PLC",
     "symbol": "AOWDF"
    },
    {
     "description": "AOXING PHARMACEUTICAL CO INC",
     "symbol": "AOXG"
    },
    {
     "description": "ADVANCED OXYGEN TECH INC",
     "symbol": "AOXY"
    },
    {
     "description": "AOZORA BANK LTD",
     "symbol": "AOZOF"
    },
    {
     "description": "AOZORA BANK LTD-UNSPON ADR",
     "symbol": "AOZOY"
    },
    {
     "description": "AMPCO-PITTSBURGH CORP",
     "symbol": "AP"
    },
    {
     "description": "AMPCO-PITTSBURGH CORP -CW25",
     "symbol": "AP.WS"
    },
    {
     "description": "APA CORP",
     "symbol": "APA"
    },
    {
     "description": "APPIA RARE EARTHS & URANIUM",
     "symbol": "APAAF"
    },
    {
     "description": "STONEBRIDGE ACQUISITION CORP",
     "symbol": "APAC"
    },
    {
     "description": "STONEBRIDGE ACQUISITION CORP",
     "symbol": "APACU"
    },
    {
     "description": "STONEBRIDGE ACQUISITION-CW23",
     "symbol": "APACW"
    },
    {
     "description": "APA GROUP",
     "symbol": "APAJF"
    },
    {
     "description": "ARTISAN PARTNERS ASSET MA -A",
     "symbol": "APAM"
    },
    {
     "description": "AP ACQUISITION CORP-A",
     "symbol": "APCA"
    },
    {
     "description": "AP ACQUISITION CORP",
     "symbol": "APCA.U"
    },
    {
     "description": "AP ACQUISITION CORP-A -23",
     "symbol": "APCA.WS"
    },
    {
     "description": "A-CAP ENERGY LTD",
     "symbol": "APCDF"
    },
    {
     "description": "NEW TECH MINERALS CORP",
     "symbol": "APCOF"
    },
    {
     "description": "APPTECH PAYMENTS CORP",
     "symbol": "APCX"
    },
    {
     "description": "APPTECH -CW26",
     "symbol": "APCXW"
    },
    {
     "description": "AIR PRODUCTS & CHEMICALS INC",
     "symbol": "APD"
    },
    {
     "description": "APPLIED DNA SCIENCES INC",
     "symbol": "APDN"
    },
    {
     "description": "AUTOPISTAS DEL SOL SA - D",
     "symbol": "APDSF"
    },
    {
     "description": "EAGERS AUTOMOTIVE LTD",
     "symbol": "APEAF"
    },
    {
     "description": "AMERICAN PUBLIC EDUCATION",
     "symbol": "APEI"
    },
    {
     "description": "ALPS ALPINE CO LTD",
     "symbol": "APELF"
    },
    {
     "description": "ALPS ALPINE CO-UNSPON ADR",
     "symbol": "APELY"
    },
    {
     "description": "APERAM-NY REGISTRY SHARES",
     "symbol": "APEMY"
    },
    {
     "description": "APOLLO ENDOSURGERY INC",
     "symbol": "APEN"
    },
    {
     "description": "COLOURED TIES CAPITAL INC",
     "symbol": "APEOF"
    },
    {
     "description": "ALPHA METAVERSE TECHNOLOGIES",
     "symbol": "APETF"
    },
    {
     "description": "ATLAS ENGINEERED PRODUCTS LT",
     "symbol": "APEUF"
    },
    {
     "description": "API GROUP CORP",
     "symbol": "APG"
    },
    {
     "description": "APOLLO STRATEGIC GROWTH-CL A",
     "symbol": "APGB"
    },
    {
     "description": "APOLLO STRATEGIC GROWTH CAPI",
     "symbol": "APGB.U"
    },
    {
     "description": "APOLLO STRATEGIC CL A -CW27",
     "symbol": "APGB.WS"
    },
    {
     "description": "AMERICAN POWER GROUP CORP",
     "symbol": "APGI"
    },
    {
     "description": "APPLIED GRAPHENE MATERIALS P",
     "symbol": "APGMF"
    },
    {
     "description": "APOLLO SILVER CORP",
     "symbol": "APGOF"
    },
    {
     "description": "APPGATE INC",
     "symbol": "APGT"
    },
    {
     "description": "AMPHENOL CORP-CL A",
     "symbol": "APH"
    },
    {
     "description": "ALPHA ENERGY INC",
     "symbol": "APHE"
    },
    {
     "description": "ALPHA LITHIUM CORP A",
     "symbol": "APHLF"
    },
    {
     "description": "AMERICAN PICTURE HOUSE CORP",
     "symbol": "APHP"
    },
    {
     "description": "ALPHINAT INC",
     "symbol": "APHTF"
    },
    {
     "description": "AGORA INC-ADR",
     "symbol": "API"
    },
    {
     "description": "APPLIED BLOCKCHAIN INC",
     "symbol": "APLD"
    },
    {
     "description": "APPLE HOSPITALITY REIT INC",
     "symbol": "APLE"
    },
    {
     "description": "APPILI THERAPEUTICS INC-CL A",
     "symbol": "APLIF"
    },
    {
     "description": "AE ENERGY HOLDING I INC",
     "symbol": "APLN"
    },
    {
     "description": "APOLLO BANCORP INC \/PA",
     "symbol": "APLO"
    },
    {
     "description": "APELLIS PHARMACEUTICALS INC",
     "symbol": "APLS"
    },
    {
     "description": "APPLIED THERAPEUTICS INC",
     "symbol": "APLT"
    },
    {
     "description": "APPLUS SERVICES SA",
     "symbol": "APLUF"
    },
    {
     "description": "AP ALTERNATIVE ASSETS LP",
     "symbol": "APLVF"
    },
    {
     "description": "APTORUM GROUP LTD-CLASS A",
     "symbol": "APM"
    },
    {
     "description": "MORIEN RESOURCES CORP",
     "symbol": "APMCF"
    },
    {
     "description": "EAGLE GRAPHITE INC",
     "symbol": "APMFF"
    },
    {
     "description": "AXONPRIME INFRASTRUCTURE-A",
     "symbol": "APMI"
    },
    {
     "description": "AXON INFRASTRUCTURE ACQUISI",
     "symbol": "APMIU"
    },
    {
     "description": "AXONPRIME INFRASTR A -CW23",
     "symbol": "APMIW"
    },
    {
     "description": "APARTMENTLOVE INC",
     "symbol": "APMLF"
    },
    {
     "description": "ASPERMONT LTD",
     "symbol": "APMOF"
    },
    {
     "description": "APERAM",
     "symbol": "APMSF"
    },
    {
     "description": "APEIRON CAPITAL INVESTMENT-A",
     "symbol": "APN"
    },
    {
     "description": "APEIRON CAPITAL INVESTMENT C",
     "symbol": "APN.U"
    },
    {
     "description": "APEIRON CAPITAL INV -CW23",
     "symbol": "APN.WS"
    },
    {
     "description": "ASPEN PHARMACARE HOLDINGS LT",
     "symbol": "APNHF"
    },
    {
     "description": "ASPEN PHARMACARE HL-UNSP ADR",
     "symbol": "APNHY"
    },
    {
     "description": "ALPEN CO LTD",
     "symbol": "APNYF"
    },
    {
     "description": "APOLLO GLOBAL MANAGEMENT INC",
     "symbol": "APO"
    },
    {
     "description": "APOGEE ENTERPRISES INC",
     "symbol": "APOG"
    },
    {
     "description": "APOLLO TOURISM & LEISURE LTD",
     "symbol": "APOOF"
    },
    {
     "description": "APPLOVIN CORP-CLASS A",
     "symbol": "APP"
    },
    {
     "description": "APPLIED BIOSCIENCES CORP",
     "symbol": "APPB"
    },
    {
     "description": "APAC RESOURCES LTD",
     "symbol": "APPCF"
    },
    {
     "description": "APPLIED DNA SCIENCES -CW24",
     "symbol": "APPDW"
    },
    {
     "description": "APPEN LTD",
     "symbol": "APPEF"
    },
    {
     "description": "APPFOLIO INC - A",
     "symbol": "APPF"
    },
    {
     "description": "APPHARVEST INC",
     "symbol": "APPH"
    },
    {
     "description": "APPHARVEST INC-CW27",
     "symbol": "APPHW"
    },
    {
     "description": "APPIER GROUP INC",
     "symbol": "APPIF"
    },
    {
     "description": "APPAREL MANUFACTURING ASSOCI",
     "symbol": "APPM"
    },
    {
     "description": "APPIAN CORP",
     "symbol": "APPN"
    },
    {
     "description": "DIGITAL TURBINE INC",
     "symbol": "APPS"
    },
    {
     "description": "MONSTER ARTS INC",
     "symbol": "APPZ"
    },
    {
     "description": "APPLIQATE INC",
     "symbol": "APQT"
    },
    {
     "description": "TRAILBREAKER RESOURCES LTD",
     "symbol": "APRAF"
    },
    {
     "description": "Alabama Power Company",
     "symbol": "APRCP"
    },
    {
     "description": "Alabama Power Company",
     "symbol": "APRDM"
    },
    {
     "description": "Alabama Power Company",
     "symbol": "APRDN"
    },
    {
     "description": "Alabama Power Company",
     "symbol": "APRDO"
    },
    {
     "description": "Alabama Power Company",
     "symbol": "APRDP"
    },
    {
     "description": "APREA THERAPEUTICS INC",
     "symbol": "APRE"
    },
    {
     "description": "AMERICAN PACIFIC RIM COMMERC",
     "symbol": "APRM"
    },
    {
     "description": "BLUE APRON HOLDINGS INC-A",
     "symbol": "APRN"
    },
    {
     "description": "ALLEGIANT PROFESSIONAL BUSIN",
     "symbol": "APRO"
    },
    {
     "description": "APPLE RUSH CO INC",
     "symbol": "APRU"
    },
    {
     "description": "TRUESHARES STR OUTCOME APRIL",
     "symbol": "APRZ"
    },
    {
     "description": "APOLLO STRATEGIC GROWTH-CL A",
     "symbol": "APSG"
    },
    {
     "description": "APOLLO STRATEGIC GROWTH CAPI",
     "symbol": "APSG.U"
    },
    {
     "description": "APOLLO STRATEGIC GROWT -CW27",
     "symbol": "APSG.WS"
    },
    {
     "description": "AQUA POWER SYSTEMS INC",
     "symbol": "APSI"
    },
    {
     "description": "ALPHA PRO TECH LTD",
     "symbol": "APT"
    },
    {
     "description": "ADVANCED PROTEOME THERAPEUTI",
     "symbol": "APTCF"
    },
    {
     "description": "ALASKA POWER & TELEPHONE CO",
     "symbol": "APTL"
    },
    {
     "description": "ALPHA PARTNERS TECHNOLOGY-A",
     "symbol": "APTM"
    },
    {
     "description": "ALPHA PARTNERS TECHNOLOGY ME",
     "symbol": "APTMU"
    },
    {
     "description": "ALPHA PARTNERS TECHNOLOGY-CW",
     "symbol": "APTMW"
    },
    {
     "description": "APTOSE BIOSCIENCES INC",
     "symbol": "APTO"
    },
    {
     "description": "AIRPORTS OF THAILAND PCL-FOR",
     "symbol": "APTPF"
    },
    {
     "description": "PREFERRED APARTMENT COMMUNIT",
     "symbol": "APTS"
    },
    {
     "description": "Preferred Apartment Communities Inc",
     "symbol": "APTSP"
    },
    {
     "description": "ASIAN PAY TELEVISION TRUST",
     "symbol": "APTTF"
    },
    {
     "description": "APTIV PLC",
     "symbol": "APTV"
    },
    {
     "description": "APTIV PLC",
     "symbol": "APTV.PRA"
    },
    {
     "description": "APTINYX INC",
     "symbol": "APTX"
    },
    {
     "description": "APT SYSTEMS INC",
     "symbol": "APTY"
    },
    {
     "description": "ARISE TECHNOLOGIES CORP",
     "symbol": "APVNF"
    },
    {
     "description": "APTEVO THERAPEUTICS INC",
     "symbol": "APVO"
    },
    {
     "description": "APPLIED VISUAL SCIENCES INC",
     "symbol": "APVS"
    },
    {
     "description": "APTEVO THERAPEUTICS IN-CW24",
     "symbol": "APVTW"
    },
    {
     "description": "ASIA PACIFIC WIRE & CABLE",
     "symbol": "APWC"
    },
    {
     "description": "ADVANCED POWERLINE TECHNOLOG",
     "symbol": "APWL"
    },
    {
     "description": "APEX HEALTHCARE ETF",
     "symbol": "APXH"
    },
    {
     "description": "APX ACQUISITION CORP I",
     "symbol": "APXI"
    },
    {
     "description": "APX ACQUISITION CORP I",
     "symbol": "APXIU"
    },
    {
     "description": "APX ACQUISITION CORP I -23",
     "symbol": "APXIW"
    },
    {
     "description": "APPEN LTD - UNSP ADR",
     "symbol": "APXYY"
    },
    {
     "description": "CARASENT ASA",
     "symbol": "APXZF"
    },
    {
     "description": "ASPYRA INC",
     "symbol": "APYI"
    },
    {
     "description": "ASIASEC PROPERTIES LTD",
     "symbol": "APYLF"
    },
    {
     "description": "APPYEA INC",
     "symbol": "APYPD"
    },
    {
     "description": "ALLIED PROPERTIES REAL ESTAT",
     "symbol": "APYRF"
    },
    {
     "description": "APYX MEDICAL CORP",
     "symbol": "APYX"
    },
    {
     "description": "AQUA CORPORATION PUBLIC CO L",
     "symbol": "AQAAF"
    },
    {
     "description": "AQUABOUNTY TECHNOLOGIES",
     "symbol": "AQB"
    },
    {
     "description": "AAB NATIONAL CO",
     "symbol": "AQBN"
    },
    {
     "description": "AQ CORP",
     "symbol": "AQCP"
    },
    {
     "description": "A CLASSIFIED AD INC",
     "symbol": "AQFD"
    },
    {
     "description": "AI QUALITY GROWTH ETF",
     "symbol": "AQGX"
    },
    {
     "description": "AQUIS COMMUNICATIONS GROUP",
     "symbol": "AQIS"
    },
    {
     "description": "AQUA METALS INC",
     "symbol": "AQMS"
    },
    {
     "description": "ALGONQUIN POWER & UTILITIES",
     "symbol": "AQN"
    },
    {
     "description": "ALGONQUIN PWR & UTILITY",
     "symbol": "AQNA"
    },
    {
     "description": "ALGONQUIN PWR & UTILITY",
     "symbol": "AQNB"
    },
    {
     "description": "ALGONQUIN PWR &",
     "symbol": "AQNU"
    },
    {
     "description": "AQUARIUS SURGICAL TECHNOLOGI",
     "symbol": "AQQRF"
    },
    {
     "description": "AMERICAN SPECTRUM REALTY INC",
     "symbol": "AQQSQ"
    },
    {
     "description": "AQUESTIVE THERAPEUTICS INC",
     "symbol": "AQST"
    },
    {
     "description": "AEQUUS PHARMACEUTICALS INC",
     "symbol": "AQSZF"
    },
    {
     "description": "EVOQUA WATER TECHNOLOGIES CO",
     "symbol": "AQUA"
    },
    {
     "description": "AQUARIUS ENGINES AM LTD",
     "symbol": "AQUEF"
    },
    {
     "description": "AQUAGOLD INTERNATIONAL INC",
     "symbol": "AQUI"
    },
    {
     "description": "GLOBAL X CLEAN WATER ETF",
     "symbol": "AQWA"
    },
    {
     "description": "ANTERO RESOURCES CORP",
     "symbol": "AR"
    },
    {
     "description": "ACLARA RESOURCES INC",
     "symbol": "ARAAF"
    },
    {
     "description": "ARAFURA RESOURCES LTD",
     "symbol": "ARAFF"
    },
    {
     "description": "AURASOURCE INC",
     "symbol": "ARAO"
    },
    {
     "description": "ARAX HOLDINGS CORP",
     "symbol": "ARAT"
    },
    {
     "description": "ARA US HOSPITALITY TRUST",
     "symbol": "ARAUF"
    },
    {
     "description": "ARAVIVE INC",
     "symbol": "ARAV"
    },
    {
     "description": "ACCURAY INC",
     "symbol": "ARAY"
    },
    {
     "description": "ALTSHARES MERGER ARBITRAGE",
     "symbol": "ARB"
    },
    {
     "description": "ARBE ROBOTICS LTD",
     "symbol": "ARBE"
    },
    {
     "description": "ARBE ROBOTICS LTD -CW26",
     "symbol": "ARBEW"
    },
    {
     "description": "ARB CORP LTD",
     "symbol": "ARBFF"
    },
    {
     "description": "AEQUI ACQUISITION CORP-CL A",
     "symbol": "ARBG"
    },
    {
     "description": "AEQUI ACQUISITION CORP",
     "symbol": "ARBGU"
    },
    {
     "description": "AEQUI ACQ CL A -CW27",
     "symbol": "ARBGW"
    },
    {
     "description": "ARBIOS SYSTEMS INC",
     "symbol": "ARBI"
    },
    {
     "description": "ARGO BLOCKCHAIN PLC",
     "symbol": "ARBK"
    },
    {
     "description": "ARGO BLOCKCHAIN PLC",
     "symbol": "ARBKF"
    },
    {
     "description": "ARGO BLOCKCHAIN PLC",
     "symbol": "ARBKL"
    },
    {
     "description": "ARGO GOLD INC",
     "symbol": "ARBTF"
    },
    {
     "description": "AMERICAN BUSINESS CORP",
     "symbol": "ARBU"
    },
    {
     "description": "AMERICAN RIVIERA BANCORP",
     "symbol": "ARBV"
    },
    {
     "description": "ARC DOCUMENT SOLUTIONS INC",
     "symbol": "ARC"
    },
    {
     "description": "ARCADIS NV - NY REG",
     "symbol": "ARCAY"
    },
    {
     "description": "ARCBEST CORP",
     "symbol": "ARCB"
    },
    {
     "description": "ARES CAPITAL CORP",
     "symbol": "ARCC"
    },
    {
     "description": "ARCO PLATFORM LTD - CLASS A",
     "symbol": "ARCE"
    },
    {
     "description": "ARCH RESOURCES INC",
     "symbol": "ARCH"
    },
    {
     "description": "ARBOR RAPHA CAPITAL BIOHOLDI",
     "symbol": "ARCK"
    },
    {
     "description": "ARBOR RAPHA CAPITAL BIOHOLDI",
     "symbol": "ARCKU"
    },
    {
     "description": "ARBOR RAPHA CAPITAL -CW28",
     "symbol": "ARCKW"
    },
    {
     "description": "ARROW RESERVE CAP MANAG ETF",
     "symbol": "ARCM"
    },
    {
     "description": "ARCANE CRYPTO AB",
     "symbol": "ARCNF"
    },
    {
     "description": "ARCOS DORADOS HOLDINGS INC-A",
     "symbol": "ARCO"
    },
    {
     "description": "ARCIS RESOURCES CORP",
     "symbol": "ARCS"
    },
    {
     "description": "ARCTURUS THERAPEUTICS HOLDIN",
     "symbol": "ARCT"
    },
    {
     "description": "ARCUS DEVELOPMENT GROUP INC",
     "symbol": "ARCUF"
    },
    {
     "description": "ARCADIS NV",
     "symbol": "ARCVF"
    },
    {
     "description": "ARC GROUP WORLDWIDE INC",
     "symbol": "ARCW"
    },
    {
     "description": "ARCELORMITTAL SOUTH AFRICA",
     "symbol": "ARCXF"
    },
    {
     "description": "Ardagh Group SA",
     "symbol": "ARD"
    },
    {
     "description": "ARES DYNAMIC CREDIT ALLOCATI",
     "symbol": "ARDC"
    },
    {
     "description": "ARDIDEN LTD",
     "symbol": "ARDDF"
    },
    {
     "description": "ARDENT LEISURE GROUP LTD",
     "symbol": "ARDLF"
    },
    {
     "description": "ARGENT MINERALS LTD",
     "symbol": "ARDNF"
    },
    {
     "description": "ARIDIS PHARMACEUTICALS INC",
     "symbol": "ARDS"
    },
    {
     "description": "ARDELYX INC",
     "symbol": "ARDX"
    },
    {
     "description": "ALEXANDRIA REAL ESTATE EQUIT",
     "symbol": "ARE"
    },
    {
     "description": "AMERICAN REBEL HOLDINGS INC",
     "symbol": "AREB"
    },
    {
     "description": "AMERICAN REBEL HOLDINGS -23",
     "symbol": "AREBW"
    },
    {
     "description": "AMERICAN RESOURCES CORP",
     "symbol": "AREC"
    },
    {
     "description": "AMERICAN RESOURCES CORP CW24",
     "symbol": "ARECW"
    },
    {
     "description": "ARENA GROUP HOLDINGS INC\/THE",
     "symbol": "AREN"
    },
    {
     "description": "ARES MANAGEMENT CORP - A",
     "symbol": "ARES"
    },
    {
     "description": "ARTIS REAL ESTATE INVESTMENT",
     "symbol": "ARESF"
    },
    {
     "description": "ARETE INDUSTRIES INC",
     "symbol": "ARET"
    },
    {
     "description": "AREV LIFE SCIENCES GLOBAL CO",
     "symbol": "AREVF"
    },
    {
     "description": "ARCHER EXPLORATION CORP",
     "symbol": "AREXF"
    },
    {
     "description": "PROMIS NEUROSCIENCES INC",
     "symbol": "ARFXF"
    },
    {
     "description": "ARION GROUP CORP",
     "symbol": "ARGC"
    },
    {
     "description": "ARGO GROUP US INC",
     "symbol": "ARGD"
    },
    {
     "description": "ASTON MARTIN LAGO - UNSP ADR",
     "symbol": "ARGGY"
    },
    {
     "description": "ARGYLE SECURITY INC",
     "symbol": "ARGL"
    },
    {
     "description": "ARGENX SE",
     "symbol": "ARGNF"
    },
    {
     "description": "ARGO GROUP INTERNATIONAL",
     "symbol": "ARGO"
    },
    {
     "description": "ARGO GROUP INTERNATIONAL",
     "symbol": "ARGO.PRA"
    },
    {
     "description": "ARGO GRAPHICS INC",
     "symbol": "ARGPF"
    },
    {
     "description": "ARGENTUM 47 INC",
     "symbol": "ARGQ"
    },
    {
     "description": "GLOBAL X MSCI ARGENTINA ETF",
     "symbol": "ARGT"
    },
    {
     "description": "ARTEMIS GOLD INC",
     "symbol": "ARGTF"
    },
    {
     "description": "ARGUS CAPITAL CORP-CL A",
     "symbol": "ARGU"
    },
    {
     "description": "ARGUS CAPITAL CORP",
     "symbol": "ARGUU"
    },
    {
     "description": "ARGUS CAPITAL CORP -CW23",
     "symbol": "ARGUW"
    },
    {
     "description": "ARGUS WORLDWIDE CORP",
     "symbol": "ARGW"
    },
    {
     "description": "ARGENX SE - ADR",
     "symbol": "ARGX"
    },
    {
     "description": "AVANTI ENERGY INC",
     "symbol": "ARGYF"
    },
    {
     "description": "ALFRESA HOLDINGS CORP",
     "symbol": "ARHCF"
    },
    {
     "description": "ARCHTIS LTD",
     "symbol": "ARHLF"
    },
    {
     "description": "ARCHON CORPORATION",
     "symbol": "ARHN"
    },
    {
     "description": "AMREST HOLDINGS SE",
     "symbol": "ARHOF"
    },
    {
     "description": "ARHAUS INC",
     "symbol": "ARHS"
    },
    {
     "description": "ARHT MEDIA INC",
     "symbol": "ARHTF"
    },
    {
     "description": "AAK AB",
     "symbol": "ARHUF"
    },
    {
     "description": "ARCHER",
     "symbol": "ARHVF"
    },
    {
     "description": "APOLLO COMMERCIAL REAL ESTAT",
     "symbol": "ARI"
    },
    {
     "description": "ARION BANKI HF-SDR",
     "symbol": "ARIFF"
    },
    {
     "description": "ARISTA INVESTORS CORP",
     "symbol": "ARINA"
    },
    {
     "description": "ARIS WATER SOLUTION INC-A",
     "symbol": "ARIS"
    },
    {
     "description": "ARISZ ACQUISITION CORP",
     "symbol": "ARIZ"
    },
    {
     "description": "AFFINITY METALS CORP",
     "symbol": "ARIZF"
    },
    {
     "description": "ARISZ ACQUISITION CORP-RTS",
     "symbol": "ARIZR"
    },
    {
     "description": "ARISZ ACQUISITION CORP",
     "symbol": "ARIZU"
    },
    {
     "description": "ARISZ ACQUISITION CORP -CW23",
     "symbol": "ARIZW"
    },
    {
     "description": "ARKEMA",
     "symbol": "ARKAF"
    },
    {
     "description": "ARKEMA-SPONSORED ADR",
     "symbol": "ARKAY"
    },
    {
     "description": "ARK FINTECH INNOVATION ETF",
     "symbol": "ARKF"
    },
    {
     "description": "ARK GENOMIC REVOLUTION ETF",
     "symbol": "ARKG"
    },
    {
     "description": "ARK INNOVATION ETF",
     "symbol": "ARKK"
    },
    {
     "description": "ARKO CORP",
     "symbol": "ARKO"
    },
    {
     "description": "ARKO CORP -CW25",
     "symbol": "ARKOW"
    },
    {
     "description": "ARK AUTONOMOUS TECH & ROBOT",
     "symbol": "ARKQ"
    },
    {
     "description": "ARK RESTAURANTS CORP",
     "symbol": "ARKR"
    },
    {
     "description": "PREMIER VETERINARY GROUP PLC",
     "symbol": "ARKTF"
    },
    {
     "description": "ARK NEXT GENERATION INTERNET",
     "symbol": "ARKW"
    },
    {
     "description": "ARK SPACE EXPLORATION & INNO",
     "symbol": "ARKX"
    },
    {
     "description": "AMERICAN REALTY INVESTORS IN",
     "symbol": "ARL"
    },
    {
     "description": "ARGAN",
     "symbol": "ARLLF"
    },
    {
     "description": "ARLO TECHNOLOGIES INC",
     "symbol": "ARLO"
    },
    {
     "description": "ALLIANCE RESOURCE PARTNERS",
     "symbol": "ARLP"
    },
    {
     "description": "ARGO LIVING SOILS CORP",
     "symbol": "ARLSF"
    },
    {
     "description": "ARISTOCRAT LEISURE LTD",
     "symbol": "ARLUF"
    },
    {
     "description": "ASIARIM CORP",
     "symbol": "ARMC"
    },
    {
     "description": "ARMOR ELECTRIC INC",
     "symbol": "ARME"
    },
    {
     "description": "ARAMARK",
     "symbol": "ARMK"
    },
    {
     "description": "ARMM INC",
     "symbol": "ARMM"
    },
    {
     "description": "ARMATA PHARMACEUTICALS INC",
     "symbol": "ARMP"
    },
    {
     "description": "ARMOR US EQUITY INDEX ETF",
     "symbol": "ARMR"
    },
    {
     "description": "ATRIUM REAL ESTATE INVESTMEN",
     "symbol": "ARMVF"
    },
    {
     "description": "AURA MINERALS INC",
     "symbol": "ARMZF"
    },
    {
     "description": "ARCONIC CORP",
     "symbol": "ARNC"
    },
    {
     "description": "ARGONAUT GOLD INC",
     "symbol": "ARNGF"
    },
    {
     "description": "ARNO THERAPEUTICS INC",
     "symbol": "ARNI"
    },
    {
     "description": "ARCHROCK INC",
     "symbol": "AROC"
    },
    {
     "description": "ARROW FINANCIAL CORP",
     "symbol": "AROW"
    },
    {
     "description": "ALDORO RESOURCES LTD",
     "symbol": "AROZF"
    },
    {
     "description": "AREM PACIFIC CORP",
     "symbol": "ARPC"
    },
    {
     "description": "AGRIPURE HOLDING PLC-NVDR",
     "symbol": "ARPPF"
    },
    {
     "description": "AIRPORTS OF THAILAND PCL",
     "symbol": "ARPRF"
    },
    {
     "description": "AIRPORT CITY LTD",
     "symbol": "ARPTF"
    },
    {
     "description": "ARQIT QUANTUM INC",
     "symbol": "ARQQ"
    },
    {
     "description": "ARQIT QUANTUM INC -CW26",
     "symbol": "ARQQW"
    },
    {
     "description": "ARCUTIS BIOTHERAPEUTICS INC",
     "symbol": "ARQT"
    },
    {
     "description": "ARMOUR RESIDENTIAL REIT INC",
     "symbol": "ARR"
    },
    {
     "description": "ARMOUR RESIDENTIAL REIT",
     "symbol": "ARR.PRC"
    },
    {
     "description": "ARRIA NLG PLC",
     "symbol": "ARRAF"
    },
    {
     "description": "AMERIGO RESOURCES LTD",
     "symbol": "ARREF"
    },
    {
     "description": "ARCH RESOURCES INC-CW23",
     "symbol": "ARRHW"
    },
    {
     "description": "ARJO AB - B SHARES",
     "symbol": "ARRJF"
    },
    {
     "description": "AMERICAN RARE EARTHS LTD",
     "symbol": "ARRNF"
    },
    {
     "description": "ADP - UNSP ADR",
     "symbol": "ARRPY"
    },
    {
     "description": "ARDEA RESOURCES LTD",
     "symbol": "ARRRF"
    },
    {
     "description": "ARTISAN CONSUMER GOODS INC",
     "symbol": "ARRT"
    },
    {
     "description": "ARROWROOT ACQUISITION CORP-A",
     "symbol": "ARRW"
    },
    {
     "description": "ARROWROOT ACQUISITION CORP",
     "symbol": "ARRWU"
    },
    {
     "description": "ARROWROOT ACQUISITION -CW26",
     "symbol": "ARRWW"
    },
    {
     "description": "ARCHER MATERIALS LTD",
     "symbol": "ARRXF"
    },
    {
     "description": "ARRAY TECHNOLOGIES INC",
     "symbol": "ARRY"
    },
    {
     "description": "AMERICAN SECURITY RESOURCES",
     "symbol": "ARSC"
    },
    {
     "description": "ALTAI RESOURCES INC",
     "symbol": "ARSEF"
    },
    {
     "description": "ALTIMA RESOURCES LTD",
     "symbol": "ARSLF"
    },
    {
     "description": "ARES STRATEGIC MINING INC",
     "symbol": "ARSMF"
    },
    {
     "description": "AUREUS INC",
     "symbol": "ARSN"
    },
    {
     "description": "AERIS RESOURCES LTD",
     "symbol": "ARSRF"
    },
    {
     "description": "ASSURA PLC",
     "symbol": "ARSSF"
    },
    {
     "description": "FAGRON",
     "symbol": "ARSUF"
    },
    {
     "description": "ARTISAN ACQUISITION CORP-A",
     "symbol": "ARTA"
    },
    {
     "description": "ARTISAN ACQUISITION CORP",
     "symbol": "ARTAU"
    },
    {
     "description": "ARTISAN ACQUISITION A -CW28",
     "symbol": "ARTAW"
    },
    {
     "description": "ARTISTDIRECT INC",
     "symbol": "ARTD"
    },
    {
     "description": "ARTEMIS STRATEGIC INVES-CL A",
     "symbol": "ARTE"
    },
    {
     "description": "ARTEMIS STRATEGIC INVESTMENT",
     "symbol": "ARTEU"
    },
    {
     "description": "ARTEMIS STRATEGIC INVES-CW23",
     "symbol": "ARTEW"
    },
    {
     "description": "AIRTHINGS ASA",
     "symbol": "ARTGF"
    },
    {
     "description": "ARCH THERAPEUTICS INC",
     "symbol": "ARTH"
    },
    {
     "description": "ARTELO BIOSCIENCES INC",
     "symbol": "ARTL"
    },
    {
     "description": "ARTELO BIOSCIENCES INC-CW24",
     "symbol": "ARTLW"
    },
    {
     "description": "AMERICAN NORTEL COMM INC",
     "symbol": "ARTM"
    },
    {
     "description": "ARTESIAN RESOURCES CORP-CL A",
     "symbol": "ARTNA"
    },
    {
     "description": "ARTESIAN RESOURCES CORP-CL B",
     "symbol": "ARTNB"
    },
    {
     "description": "AIRTRONA INTERNATIONAL INC",
     "symbol": "ARTR"
    },
    {
     "description": "ARTEMIS RESOURCES LTD",
     "symbol": "ARTTF"
    },
    {
     "description": "ART'S-WAY MANUFACTURING CO",
     "symbol": "ARTW"
    },
    {
     "description": "ARTNET AG - REG",
     "symbol": "ARTZF"
    },
    {
     "description": "ACRUX LTD",
     "symbol": "ARUXF"
    },
    {
     "description": "AREVA",
     "symbol": "ARVCF"
    },
    {
     "description": "ARRIVAL SA",
     "symbol": "ARVL"
    },
    {
     "description": "ARVINAS INC",
     "symbol": "ARVN"
    },
    {
     "description": "FIRST TRUST INDXX METAVERSE",
     "symbol": "ARVR"
    },
    {
     "description": "ALLIANCE RECOVERY CORP",
     "symbol": "ARVY"
    },
    {
     "description": "ARROW ELECTRONICS INC",
     "symbol": "ARW"
    },
    {
     "description": "ARROW RESOURCES DEVELOPMENT",
     "symbol": "ARWD"
    },
    {
     "description": "ARROW GLOBAL GROUP PLC",
     "symbol": "ARWGF"
    },
    {
     "description": "AROWAY ENERGY INC",
     "symbol": "ARWJF"
    },
    {
     "description": "ARROWHEAD PHARMACEUTICALS IN",
     "symbol": "ARWR"
    },
    {
     "description": "IMAGINE LITHIUM INC",
     "symbol": "ARXRF"
    },
    {
     "description": "ARRAYIT CORP",
     "symbol": "ARYC"
    },
    {
     "description": "ARYA SCIENCES ACQUISITION-A",
     "symbol": "ARYD"
    },
    {
     "description": "ARYA SCIENCES ACQUISITION -A",
     "symbol": "ARYE"
    },
    {
     "description": "ARGOSY MINERALS LTD",
     "symbol": "ARYMF"
    },
    {
     "description": "ARYX THERAPEUTICS INC",
     "symbol": "ARYX"
    },
    {
     "description": "ASSICURAZIONI GENERALI",
     "symbol": "ARZGF"
    },
    {
     "description": "ASSICURAZIONI GEN-UNSPON ADR",
     "symbol": "ARZGY"
    },
    {
     "description": "ARYZTA AG",
     "symbol": "ARZTF"
    },
    {
     "description": "ARYZTA AG-UNSPON ADR",
     "symbol": "ARZTY"
    },
    {
     "description": "ASA GOLD AND PRECIOUS METALS",
     "symbol": "ASA"
    },
    {
     "description": "AUSTRIA TECHNOLOGIE & SYSTEM",
     "symbol": "ASAAF"
    },
    {
     "description": "AUSTRALIAN AGRICULTURAL CO",
     "symbol": "ASAGF"
    },
    {
     "description": "SENDAS DISTRIBUIDORA SA",
     "symbol": "ASAI"
    },
    {
     "description": "ARTIFICIAL SOLUTIONS INTERNA",
     "symbol": "ASAIF"
    },
    {
     "description": "ASSURANCEAMERICA CORP",
     "symbol": "ASAM"
    },
    {
     "description": "ASANA INC - CL A",
     "symbol": "ASAN"
    },
    {
     "description": "AURORA SPINE CORP",
     "symbol": "ASAPF"
    },
    {
     "description": "ATLANTIC AVENUE ACQUISI-CL A",
     "symbol": "ASAQ"
    },
    {
     "description": "ATLANTIC AVENUE ACQUISITION",
     "symbol": "ASAQ.U"
    },
    {
     "description": "ATLANTIC AVENUE ACQUIS -CW27",
     "symbol": "ASAQ.WS"
    },
    {
     "description": "ASIA STANDARD INTL.GROUP",
     "symbol": "ASASF"
    },
    {
     "description": "ASI AVIATION INC",
     "symbol": "ASAV"
    },
    {
     "description": "ASTREA ACQUISITION CORP-CL A",
     "symbol": "ASAX"
    },
    {
     "description": "ASTREA ACQUISITION CORP",
     "symbol": "ASAXU"
    },
    {
     "description": "ASTREA ACQUISITION CORP-CW26",
     "symbol": "ASAXW"
    },
    {
     "description": "ASSA ABLOY AB-B",
     "symbol": "ASAZF"
    },
    {
     "description": "ASSA ABLOY AB - UNSP ADR",
     "symbol": "ASAZY"
    },
    {
     "description": "ASSOCIATED BANC-CORP",
     "symbol": "ASB"
    },
    {
     "description": "ASSOC BANC-CORP",
     "symbol": "ASB.PRE"
    },
    {
     "description": "ASSOC BANC-CORP",
     "symbol": "ASB.PRF"
    },
    {
     "description": "ASSOCIATED BRITISH FOODS PLC",
     "symbol": "ASBFF"
    },
    {
     "description": "ASSOC BRITISH FOODS-UNSP ADR",
     "symbol": "ASBFY"
    },
    {
     "description": "ASAHI GROUP HOLDINGS LTD",
     "symbol": "ASBRF"
    },
    {
     "description": "ARDMORE SHIPPING CORP",
     "symbol": "ASC"
    },
    {
     "description": "A SPAC I ACQUISITION CORP-A",
     "symbol": "ASCA"
    },
    {
     "description": "A SPAC I ACQUISITION CO-RTS",
     "symbol": "ASCAR"
    },
    {
     "description": "A SPAC I ACQUISITION CORP",
     "symbol": "ASCAU"
    },
    {
     "description": "A SPAC I ACQUISITION A -27",
     "symbol": "ASCAW"
    },
    {
     "description": "ASCENDIA BRANDS INC",
     "symbol": "ASCBQ"
    },
    {
     "description": "ARISTOCRAT GROUP CORP",
     "symbol": "ASCC"
    },
    {
     "description": "ASICS CORP",
     "symbol": "ASCCF"
    },
    {
     "description": "ASICS CORP -UNSP ADR",
     "symbol": "ASCCY"
    },
    {
     "description": "AMERICAN SHIPPING COMPANY AS",
     "symbol": "ASCJF"
    },
    {
     "description": "AUSCRETE CORP",
     "symbol": "ASCK"
    },
    {
     "description": "Ascletis Pharma Inc",
     "symbol": "ASCLF"
    },
    {
     "description": "ABSECON BANCORP",
     "symbol": "ASCN"
    },
    {
     "description": "ASCOPIAVE SPA",
     "symbol": "ASCOF"
    },
    {
     "description": "AMERICAN CRYSTAL SUGAR-PREF",
     "symbol": "ASCS"
    },
    {
     "description": "ARIZONA SONORAN COPPER CO IN",
     "symbol": "ASCUF"
    },
    {
     "description": "ASTRO AEROSPACE LTD",
     "symbol": "ASDN"
    },
    {
     "description": "ANSALDO STS SPA",
     "symbol": "ASDOF"
    },
    {
     "description": "ASCENDANT RESOURCES INC",
     "symbol": "ASDRF"
    },
    {
     "description": "ARCTIC STAR EXPLORATION CORP",
     "symbol": "ASDZF"
    },
    {
     "description": "GLOBAL X FTSE SOUTHEAST ASIA",
     "symbol": "ASEA"
    },
    {
     "description": "APT SATELLITE HOLDINGS LTD",
     "symbol": "ASEJF"
    },
    {
     "description": "AISIN CORP",
     "symbol": "ASEKF"
    },
    {
     "description": "AISIN CORP - UNSP ADR",
     "symbol": "ASEKY"
    },
    {
     "description": "ALPINE SUMMIT ENERGY PARTNER",
     "symbol": "ASEPF"
    },
    {
     "description": "FLEXSHARES REAL ASSETS FUND",
     "symbol": "ASET"
    },
    {
     "description": "ASEFA PCL-NVDR",
     "symbol": "ASFAF"
    },
    {
     "description": "ASFG INC",
     "symbol": "ASFJ"
    },
    {
     "description": "APPSOFT TECHNOLOGIES INC",
     "symbol": "ASFT"
    },
    {
     "description": "AMERICAN SCIENTIFIC RESOURCE",
     "symbol": "ASFX"
    },
    {
     "description": "ASSOCIATES FIRST CAPITAL-RVO",
     "symbol": "ASFZ"
    },
    {
     "description": "LIBERTY ALL-STAR GROWTH FD",
     "symbol": "ASG"
    },
    {
     "description": "ABERDEEN STNDRD GLBL INFRA",
     "symbol": "ASGI"
    },
    {
     "description": "AGC INC",
     "symbol": "ASGLF"
    },
    {
     "description": "AGC INC-UNSP ADR",
     "symbol": "ASGLY"
    },
    {
     "description": "ASGN INC",
     "symbol": "ASGN"
    },
    {
     "description": "ASANTE GOLD CORP",
     "symbol": "ASGOF"
    },
    {
     "description": "ASTRALIS AS",
     "symbol": "ASGRF"
    },
    {
     "description": "ALTUS GROUP LTD",
     "symbol": "ASGTF"
    },
    {
     "description": "ASIA GLOBAL CROSSING LTD-A",
     "symbol": "ASGXF"
    },
    {
     "description": "ASHLAND GLOBAL HOLDINGS INC",
     "symbol": "ASH"
    },
    {
     "description": "XTRACKERS HARVEST CSI 300 CH",
     "symbol": "ASHR"
    },
    {
     "description": "XTRACKERS HARVEST CSI 500 CH",
     "symbol": "ASHS"
    },
    {
     "description": "ASHTEAD GROUP PLC",
     "symbol": "ASHTF"
    },
    {
     "description": "ASHTEAD GROUP PLC-UNSPON ADR",
     "symbol": "ASHTY"
    },
    {
     "description": "XTRACKERS MSCI CHINA A INCLU",
     "symbol": "ASHX"
    },
    {
     "description": "PROGRESSIVE PLANET SOLUTIONS",
     "symbol": "ASHXF"
    },
    {
     "description": "ADVANSIX INC",
     "symbol": "ASIX"
    },
    {
     "description": "ALASKA PACIFIC ENERGY CORP",
     "symbol": "ASKE"
    },
    {
     "description": "ASTIKA HOLDINGS INC",
     "symbol": "ASKH"
    },
    {
     "description": "ASETEK A\/S",
     "symbol": "ASKTF"
    },
    {
     "description": "AERSALE CORP",
     "symbol": "ASLE"
    },
    {
     "description": "AMERICAN SILVER MINING CO",
     "symbol": "ASLM"
    },
    {
     "description": "ASLAN PHARMACEUTICALS LT-ADR",
     "symbol": "ASLN"
    },
    {
     "description": "ALIEN METALS LTD-DI",
     "symbol": "ASLRF"
    },
    {
     "description": "AVINO SILVER & GOLD MINES",
     "symbol": "ASM"
    },
    {
     "description": "ASSEMBLY BIOSCIENCES INC",
     "symbol": "ASMB"
    },
    {
     "description": "ASM INTERNATIONAL-NY REG SHS",
     "symbol": "ASMIY"
    },
    {
     "description": "ASML HOLDING NV-NY REG SHS",
     "symbol": "ASML"
    },
    {
     "description": "ASML HOLDING NV",
     "symbol": "ASMLF"
    },
    {
     "description": "AUSTRALIAN STRATEGIC MATERIA",
     "symbol": "ASMMF"
    },
    {
     "description": "ASM PACIFIC TECHNOLOGY",
     "symbol": "ASMVF"
    },
    {
     "description": "ASM PACIFIC TECHNOL-UNSP ADR",
     "symbol": "ASMVY"
    },
    {
     "description": "ASM INTERNATIONAL NV",
     "symbol": "ASMXF"
    },
    {
     "description": "EKIMAS CORP",
     "symbol": "ASNB"
    },
    {
     "description": "A-SONIC AEROSPACE LTD",
     "symbol": "ASNCF"
    },
    {
     "description": "ASCENDIS PHARMA A\/S - ADR",
     "symbol": "ASND"
    },
    {
     "description": "AVIDUS MANAGEMENT GROUP INC",
     "symbol": "ASNHF"
    },
    {
     "description": "ASANTE INC",
     "symbol": "ASNXF"
    },
    {
     "description": "ACADEMY SPORTS & OUTDOORS IN",
     "symbol": "ASO"
    },
    {
     "description": "ASOS PLC",
     "symbol": "ASOMF"
    },
    {
     "description": "ASOS PLC-UNSP ADR",
     "symbol": "ASOMY"
    },
    {
     "description": "ASSECO POLAND SA",
     "symbol": "ASOZF"
    },
    {
     "description": "ASSECO POLAND SA-UNSPON ADR",
     "symbol": "ASOZY"
    },
    {
     "description": "ABRI SPAC I INC",
     "symbol": "ASPA"
    },
    {
     "description": "ABRI SPAC I INC",
     "symbol": "ASPAU"
    },
    {
     "description": "ABRI SPAC I INC -CW23",
     "symbol": "ASPAW"
    },
    {
     "description": "ALPHA CAPITAL ACQUISITION-A",
     "symbol": "ASPC"
    },
    {
     "description": "ACERUS PHARMACEUTICALS CORP",
     "symbol": "ASPCF"
    },
    {
     "description": "ALPHA CAPITAL ACQUISITION CO",
     "symbol": "ASPCU"
    },
    {
     "description": "ALPHA CAPITAL ACQ CL A -CW27",
     "symbol": "ASPCW"
    },
    {
     "description": "ASPEN DIGITAL INC",
     "symbol": "ASPD"
    },
    {
     "description": "ASPIRE GLOBAL PLC",
     "symbol": "ASPGF"
    },
    {
     "description": "ASCENTAGE PHARMA GROUP INTER",
     "symbol": "ASPHF"
    },
    {
     "description": "Aspire Real Estate Investors Inc",
     "symbol": "ASPI"
    },
    {
     "description": "ASPEN AEROGELS INC",
     "symbol": "ASPN"
    },
    {
     "description": "ADSOUTH PARTNERS INC",
     "symbol": "ASPR"
    },
    {
     "description": "ALTISOURCE PORTFOLIO SOL",
     "symbol": "ASPS"
    },
    {
     "description": "ALADDIN SEPARATION TECH INC",
     "symbol": "ASPT"
    },
    {
     "description": "ASPEN GROUP INC",
     "symbol": "ASPU"
    },
    {
     "description": "ARISTA POWER INC",
     "symbol": "ASPW"
    },
    {
     "description": "ASYMMETRIC S&P 500 ETF",
     "symbol": "ASPY"
    },
    {
     "description": "ASIA PROPERTIES INC",
     "symbol": "ASPZ"
    },
    {
     "description": "GRUPO AEROPORTUARIO SUR-ADR",
     "symbol": "ASR"
    },
    {
     "description": "AS ROMA SPA",
     "symbol": "ASRAF"
    },
    {
     "description": "ASTRA ENERGY INC",
     "symbol": "ASRE"
    },
    {
     "description": "GRUPO AEROPORT DEL SURESTE-B",
     "symbol": "ASRMF"
    },
    {
     "description": "ASARINA PHARMA AB",
     "symbol": "ASRPF"
    },
    {
     "description": "ASSERTIO HOLDINGS INC",
     "symbol": "ASRT"
    },
    {
     "description": "AMERISERV FINANCIAL INC",
     "symbol": "ASRV"
    },
    {
     "description": "ASSISTED 4 LIVING INC",
     "symbol": "ASSF"
    },
    {
     "description": "AP THAILAND PCL - NVDR",
     "symbol": "ASSPF"
    },
    {
     "description": "ASTRA VEDA CORP",
     "symbol": "ASTA"
    },
    {
     "description": "ASTROTECH CORP",
     "symbol": "ASTC"
    },
    {
     "description": "ASTEC INDUSTRIES INC",
     "symbol": "ASTE"
    },
    {
     "description": "ASCENT SOLAR TECHNOLOGIES",
     "symbol": "ASTI"
    },
    {
     "description": "ALGOMA STEEL GROUP INC",
     "symbol": "ASTL"
    },
    {
     "description": "ALGOMA STEEL GROUP INC -CW26",
     "symbol": "ASTLW"
    },
    {
     "description": "ASTRO COMMUNICATIONS INC",
     "symbol": "ASTO"
    },
    {
     "description": "ASTM SPA",
     "symbol": "ASTPF"
    },
    {
     "description": "ASTRA SPACE INC",
     "symbol": "ASTR"
    },
    {
     "description": "AST SPACEMOBILE INC",
     "symbol": "ASTS"
    },
    {
     "description": "AST SPACEMOBILE INC-CW24",
     "symbol": "ASTSW"
    },
    {
     "description": "AUSTRALIS OIL & GAS LTD",
     "symbol": "ASTTF"
    },
    {
     "description": "AUSTEVOLL SEAFOOD ASA",
     "symbol": "ASTVF"
    },
    {
     "description": "ASURE SOFTWARE INC",
     "symbol": "ASUR"
    },
    {
     "description": "ASUSTEK COMPUTER-GDR REG S",
     "symbol": "ASUUY"
    },
    {
     "description": "GUNGNIR RESOURCES INC",
     "symbol": "ASWRF"
    },
    {
     "description": "ASE TECHNOLOGY HOLDING -ADR",
     "symbol": "ASX"
    },
    {
     "description": "ASENSUS SURGICAL INC",
     "symbol": "ASXC"
    },
    {
     "description": "ASX LTD",
     "symbol": "ASXFF"
    },
    {
     "description": "ASX LTD-UNSPONSORED ADR",
     "symbol": "ASXFY"
    },
    {
     "description": "ELYSEE DEVELOPMENT CORP",
     "symbol": "ASXSF"
    },
    {
     "description": "AMTECH SYSTEMS INC",
     "symbol": "ASYS"
    },
    {
     "description": "AUSTERLITZ ACQUISITION COR-A",
     "symbol": "ASZ"
    },
    {
     "description": "AUSTERLITZ ACQUISITION CORP",
     "symbol": "ASZ.U"
    },
    {
     "description": "AUSTERLITZ ACQ CL A -CW27",
     "symbol": "ASZ.WS"
    },
    {
     "description": "JV GROUP INC",
     "symbol": "ASZP"
    },
    {
     "description": "AMERICAS TECHNOLOGY ACQUISIT",
     "symbol": "ATA"
    },
    {
     "description": "AMERICAS TECHNOLOGY ACQUISIT",
     "symbol": "ATA.U"
    },
    {
     "description": "AMERICAS TECH ACQ -CW27",
     "symbol": "ATA.WS"
    },
    {
     "description": "ATACADAO SA - UNSPONS ADR",
     "symbol": "ATAAY"
    },
    {
     "description": "ATAC RESOURCES LTD",
     "symbol": "ATADF"
    },
    {
     "description": "ATAI LIFE SCIENCES NV",
     "symbol": "ATAI"
    },
    {
     "description": "AURORA TECHNOLOGY ACQUISI-A",
     "symbol": "ATAK"
    },
    {
     "description": "AURORA TECHNOLOGY ACQUISI-R",
     "symbol": "ATAKR"
    },
    {
     "description": "AURORA TECHNOLOGY ACQUISITIO",
     "symbol": "ATAKU"
    },
    {
     "description": "AURORA TECHNOLOGY ACQUIS -28",
     "symbol": "ATAKW"
    },
    {
     "description": "ALTAIR INTERNATIONAL CORP",
     "symbol": "ATAO"
    },
    {
     "description": "ALTIMAR ACQUISITION CORP-A",
     "symbol": "ATAQ"
    },
    {
     "description": "ALTIMAR ACQUISITION CORP III",
     "symbol": "ATAQ.U"
    },
    {
     "description": "ALTIMAR ACQUISITION A -CW28",
     "symbol": "ATAQ.WS"
    },
    {
     "description": "AVATAR VENTURES INC",
     "symbol": "ATAR"
    },
    {
     "description": "ATLANTIA SPA",
     "symbol": "ATASF"
    },
    {
     "description": "ATLANTIA SPA-UNSPONSORED ADR",
     "symbol": "ATASY"
    },
    {
     "description": "AMERICA FIRST MULTIFAMILY IN",
     "symbol": "ATAX"
    },
    {
     "description": "ATEA ASA",
     "symbol": "ATAZF"
    },
    {
     "description": "ABSOLUTE CLEAN ENERGY PCL",
     "symbol": "ATBBF"
    },
    {
     "description": "ASTON BAY HOLDINGS LTD",
     "symbol": "ATBHF"
    },
    {
     "description": "ANTIBE THERAPEUTICS INC",
     "symbol": "ATBPF"
    },
    {
     "description": "ATOTECH LTD",
     "symbol": "ATC"
    },
    {
     "description": "AMERITRUST CORP",
     "symbol": "ATCC"
    },
    {
     "description": "ALTAIR CORP\/DE",
     "symbol": "ATCD"
    },
    {
     "description": "ADVANCETC LTD",
     "symbol": "ATCLF"
    },
    {
     "description": "ATICO MINING CORP",
     "symbol": "ATCMF"
    },
    {
     "description": "ATEC INC",
     "symbol": "ATCN"
    },
    {
     "description": "ATLAS CORP",
     "symbol": "ATCO"
    },
    {
     "description": "ATLAS CORP",
     "symbol": "ATCO.PRD"
    },
    {
     "description": "ATLAS CORP",
     "symbol": "ATCO.PRH"
    },
    {
     "description": "ATLAS CORP",
     "symbol": "ATCO.PRI"
    },
    {
     "description": "ATLAS CORP",
     "symbol": "ATCOL"
    },
    {
     "description": "ATC VENTURE GROUP INC",
     "symbol": "ATCV"
    },
    {
     "description": "ATLAS TECHNICAL CONSULTANTS",
     "symbol": "ATCX"
    },
    {
     "description": "MONTANA EXPLORATION CORP",
     "symbol": "ATDEF"
    },
    {
     "description": "AUTO TRADER GROUP PLC",
     "symbol": "ATDRF"
    },
    {
     "description": "AUTO TRADER GROUP-UNSP ADR",
     "symbol": "ATDRY"
    },
    {
     "description": "DATA443 RISK MITIGATION INC",
     "symbol": "ATDS"
    },
    {
     "description": "Atea ASA",
     "symbol": "ATEAY"
    },
    {
     "description": "ALPHATEC HOLDINGS INC",
     "symbol": "ATEC"
    },
    {
     "description": "ATHENA TECHNOLOGY ACQUISIT-A",
     "symbol": "ATEK"
    },
    {
     "description": "ATHENA TECHNOLOGY ACQUISITIO",
     "symbol": "ATEK.U"
    },
    {
     "description": "ATHENA TECHNOLOGY ACQ -CW23",
     "symbol": "ATEK.WS"
    },
    {
     "description": "A10 NETWORKS INC",
     "symbol": "ATEN"
    },
    {
     "description": "ASTRA EXPLORATION INC",
     "symbol": "ATEPF"
    },
    {
     "description": "ATERIAN INC",
     "symbol": "ATER"
    },
    {
     "description": "ANTERIX INC",
     "symbol": "ATEX"
    },
    {
     "description": "ADVANTEST CORP- SPON ADR",
     "symbol": "ATEYY"
    },
    {
     "description": "ALGER 35 ETF",
     "symbol": "ATFV"
    },
    {
     "description": "AltaGas Ltd",
     "symbol": "ATGAF"
    },
    {
     "description": "ADTALEM GLOBAL EDUCATION INC",
     "symbol": "ATGE"
    },
    {
     "description": "ALTAGAS LTD",
     "symbol": "ATGFF"
    },
    {
     "description": "ACTINOGEN MEDICAL LTD",
     "symbol": "ATGGF"
    },
    {
     "description": "ALTIGEN COMMUNICATIONS INC",
     "symbol": "ATGN"
    },
    {
     "description": "AltaGas Ltd",
     "symbol": "ATGPF"
    },
    {
     "description": "AUTOGRILL SPA",
     "symbol": "ATGSF"
    },
    {
     "description": "AUTOGRILL SPA-UNSPONSOR ADR",
     "symbol": "ATGSY"
    },
    {
     "description": "ACTIVE ENERGY GROUP PLC",
     "symbol": "ATGVF"
    },
    {
     "description": "ATHENE HOLDING LTD",
     "symbol": "ATH.PRA"
    },
    {
     "description": "ATHENE HOLDING LTD",
     "symbol": "ATH.PRB"
    },
    {
     "description": "ATHENE HOLDING LTD",
     "symbol": "ATH.PRC"
    },
    {
     "description": "ATHENE HOLDING LTD",
     "symbol": "ATH.PRD"
    },
    {
     "description": "ATHIRA PHARMA INC",
     "symbol": "ATHA"
    },
    {
     "description": "ACCELERATED TECHNOLOGIES HOL",
     "symbol": "ATHC"
    },
    {
     "description": "ALTERITY THERAPEUTICS-ADR",
     "symbol": "ATHE"
    },
    {
     "description": "AETHER CATALYST SOLUTIONS IN",
     "symbol": "ATHHF"
    },
    {
     "description": "AMERICAN TRANSPORTATION HOLD",
     "symbol": "ATHI"
    },
    {
     "description": "ANTISENSE THERAPEUTICS LTD",
     "symbol": "ATHJF"
    },
    {
     "description": "AUTOHOME INC-ADR",
     "symbol": "ATHM"
    },
    {
     "description": "ATHABASCA OIL CORP",
     "symbol": "ATHOF"
    },
    {
     "description": "ATHERSYS INC",
     "symbol": "ATHX"
    },
    {
     "description": "ALLEGHENY TECHNOLOGIES INC",
     "symbol": "ATI"
    },
    {
     "description": "ATIF HOLDINGS LTD",
     "symbol": "ATIF"
    },
    {
     "description": "ATLANTIS GAMING CORP",
     "symbol": "ATIG"
    },
    {
     "description": "ATI PHYSICAL THERAPY INC",
     "symbol": "ATIP"
    },
    {
     "description": "ATI PHYSICAL THERAPY INC",
     "symbol": "ATIP.WS"
    },
    {
     "description": "ATI NETWORKS INC",
     "symbol": "ATIW"
    },
    {
     "description": "ANALYTIXINSIGHT INC",
     "symbol": "ATIXF"
    },
    {
     "description": "ATKORE INC",
     "symbol": "ATKR"
    },
    {
     "description": "AltaGas Ltd",
     "symbol": "ATLAF"
    },
    {
     "description": "ATLANTICUS HOLDINGS CORP",
     "symbol": "ATLC"
    },
    {
     "description": "ATLANTICUS HOLDINGS CORP",
     "symbol": "ATLCL"
    },
    {
     "description": "ATLANTICUS HOLDINGS CORP",
     "symbol": "ATLCP"
    },
    {
     "description": "ATLAS COPCO AB-SPON ADR B SH",
     "symbol": "ATLCY"
    },
    {
     "description": "ATLANTA GOLD INC",
     "symbol": "ATLDF"
    },
    {
     "description": "ARTELO BIOSCIENCES INC-CW25",
     "symbol": "ATLEW"
    },
    {
     "description": "ACTELION LTD-NEW LINE",
     "symbol": "ATLIF"
    },
    {
     "description": "ATLAS COPCO AB-A SHS",
     "symbol": "ATLKF"
    },
    {
     "description": "ATLAS COPCO AB-SPONS ADR A",
     "symbol": "ATLKY"
    },
    {
     "description": "ATALAYA MINING PLC",
     "symbol": "ATLMF"
    },
    {
     "description": "AMES NATIONAL CORP",
     "symbol": "ATLO"
    },
    {
     "description": "ALTALEY MINING CORP",
     "symbol": "ATLYF"
    },
    {
     "description": "ARTEMIS ALPHA TRUST PLC-ORD",
     "symbol": "ATMAF"
    },
    {
     "description": "ATMOFIZER TECHNOLOGIES INC",
     "symbol": "ATMFF"
    },
    {
     "description": "ALL THINGS MOBILE ANALYTIC I",
     "symbol": "ATMH"
    },
    {
     "description": "AMERICATOWNE HOLDINGS INC",
     "symbol": "ATMO"
    },
    {
     "description": "IPATH SELECT MLP ETN",
     "symbol": "ATMP"
    },
    {
     "description": "ATEAM INC",
     "symbol": "ATMQF"
    },
    {
     "description": "ARTEMIS THERAPEUTICS INC",
     "symbol": "ATMS"
    },
    {
     "description": "ALTERNATIVE ENERGY TECHNOLOG",
     "symbol": "ATNE"
    },
    {
     "description": "180 LIFE SCIENCES CORP",
     "symbol": "ATNF"
    },
    {
     "description": "KBL MERGER CORP IV - CW23",
     "symbol": "ATNFW"
    },
    {
     "description": "ATN INTERNATIONAL INC",
     "symbol": "ATNI"
    },
    {
     "description": "ACTINIUM PHARMACEUTICALS INC",
     "symbol": "ATNM"
    },
    {
     "description": "AUTONEUM HOLDING AG",
     "symbol": "ATNNF"
    },
    {
     "description": "ATLANTIS TECHNOLOGY GROUP",
     "symbol": "ATNP"
    },
    {
     "description": "ATHENEX INC",
     "symbol": "ATNX"
    },
    {
     "description": "ATMOS ENERGY CORP",
     "symbol": "ATO"
    },
    {
     "description": "AUTO1 GROUP SE",
     "symbol": "ATOGF"
    },
    {
     "description": "AUTO1 GROUP SE - UNSP ADR",
     "symbol": "ATOGY"
    },
    {
     "description": "ATOMERA INC",
     "symbol": "ATOM"
    },
    {
     "description": "ANTON OILFIELD SERVICES GP",
     "symbol": "ATONF"
    },
    {
     "description": "ANTON OILFIELD SERV-UNSP ADR",
     "symbol": "ATONY"
    },
    {
     "description": "ASTOR EXPLORATIONS CORP",
     "symbol": "ATOR"
    },
    {
     "description": "ATOSSA THERAPEUTICS INC",
     "symbol": "ATOS"
    },
    {
     "description": "ATOSSA GENETICS INC-CW22",
     "symbol": "ATOWW"
    },
    {
     "description": "DURANGO RESOURCES INC",
     "symbol": "ATOXF"
    },
    {
     "description": "ATP Oil and Gas Corporation",
     "symbol": "ATPGQ"
    },
    {
     "description": "SUSTAINABLE NUTRITION GROUP",
     "symbol": "ATPHF"
    },
    {
     "description": "ATLANTIS PLASTICS INC-CL A",
     "symbol": "ATPL"
    },
    {
     "description": "APTARGROUP INC",
     "symbol": "ATR"
    },
    {
     "description": "ATARA BIOTHERAPEUTICS INC",
     "symbol": "ATRA"
    },
    {
     "description": "ATRIUM EUROPEAN REAL ESTATE",
     "symbol": "ATRBF"
    },
    {
     "description": "ATRICURE INC",
     "symbol": "ATRC"
    },
    {
     "description": "SCHRODER ASIAN TOTAL RETURN",
     "symbol": "ATRHF"
    },
    {
     "description": "ATRION CORPORATION",
     "symbol": "ATRI"
    },
    {
     "description": "ASTRONICS CORP",
     "symbol": "ATRO"
    },
    {
     "description": "ASTRONICS CORP-CL B",
     "symbol": "ATROB"
    },
    {
     "description": "ALTAREA",
     "symbol": "ATRRF"
    },
    {
     "description": "ANTARES PHARMA INC",
     "symbol": "ATRS"
    },
    {
     "description": "ALTAREIT",
     "symbol": "ATRTF"
    },
    {
     "description": "ALTIUS RENEWABLE ROYALTIES",
     "symbol": "ATRWF"
    },
    {
     "description": "ADHERA THERAPEUTICS INC",
     "symbol": "ATRX"
    },
    {
     "description": "ATS AUTOMATION TOOLING SYS",
     "symbol": "ATSAF"
    },
    {
     "description": "AIR TRANSPORT SERVICES GROUP",
     "symbol": "ATSG"
    },
    {
     "description": "ALLIED TELESIS HOLDINGS KK",
     "symbol": "ATSKF"
    },
    {
     "description": "ARCHIMEDES TECH SPAC-SUBUNIT",
     "symbol": "ATSPT"
    },
    {
     "description": "ARCHIMEDES TECH SPAC PARTNER",
     "symbol": "ATSPU"
    },
    {
     "description": "ARCHIMEDES TECH SPAC P -CW27",
     "symbol": "ATSPW"
    },
    {
     "description": "ABATTIS BIOCEUTICALS CORP",
     "symbol": "ATTBF"
    },
    {
     "description": "AUTO ITALIA HOLDINGS LTD",
     "symbol": "ATTGF"
    },
    {
     "description": "ATLAS COPCO AB-B SHS",
     "symbol": "ATTLF"
    },
    {
     "description": "ATENTO SA",
     "symbol": "ATTO"
    },
    {
     "description": "ASCOTT RESIDENCE TRUST",
     "symbol": "ATTRF"
    },
    {
     "description": "ALTICE USA INC- A",
     "symbol": "ATUS"
    },
    {
     "description": "ALTIUS MINERALS CORPORATION",
     "symbol": "ATUSF"
    },
    {
     "description": "TENAZ ENERGY CORP",
     "symbol": "ATUUF"
    },
    {
     "description": "TRIBE CAPITAL GROWTH CORP-A",
     "symbol": "ATVC"
    },
    {
     "description": "TRIBE CAPITAL GROWTH CORP I",
     "symbol": "ATVCU"
    },
    {
     "description": "TRIBE CAPITAL GROWTH CORP-CW",
     "symbol": "ATVCW"
    },
    {
     "description": "ATRESMEDIA CORP DE -UNSP ADR",
     "symbol": "ATVDY"
    },
    {
     "description": "ACTIVISION BLIZZARD INC",
     "symbol": "ATVI"
    },
    {
     "description": "AMERITEK VENTURES",
     "symbol": "ATVK"
    },
    {
     "description": "AUSTRALIAN VANADIUM LTD",
     "symbol": "ATVVF"
    },
    {
     "description": "ATWEC TECHNOLOGIES INC",
     "symbol": "ATWT"
    },
    {
     "description": "ADDENTAX GROUP CORP",
     "symbol": "ATXG"
    },
    {
     "description": "AVENUE THERAPEUTICS INC",
     "symbol": "ATXI"
    },
    {
     "description": "ADVANTEX MARKETING INTL INC",
     "symbol": "ATXMF"
    },
    {
     "description": "ASTRIA THERAPEUTICS INC",
     "symbol": "ATXS"
    },
    {
     "description": "ACUITYADS HOLDING INC",
     "symbol": "ATY"
    },
    {
     "description": "ATLAS TECHNOLOGY GROUP INC",
     "symbol": "ATYG"
    },
    {
     "description": "ASIA TIME CORP",
     "symbol": "ATYM"
    },
    {
     "description": "ARITZIA INC-SUBORDINATE VOTI",
     "symbol": "ATZAF"
    },
    {
     "description": "ANGLOGOLD ASHANTI-SPON ADR",
     "symbol": "AU"
    },
    {
     "description": "ATLANTIC UNION BANKSHARES CO",
     "symbol": "AUB"
    },
    {
     "description": "ATLANTIC UNION BANKSHARE",
     "symbol": "AUBAP"
    },
    {
     "description": "AUBURN NATL BANCORPORATION",
     "symbol": "AUBN"
    },
    {
     "description": "AUSTBROKERS HOLDINGS LTD",
     "symbol": "AUBOF"
    },
    {
     "description": "GOLDPLAY MINING INC",
     "symbol": "AUCCF"
    },
    {
     "description": "AUCTIONCITIES.COM INC",
     "symbol": "AUCM"
    },
    {
     "description": "POLYMETAL INTERNATION-SP ADR",
     "symbol": "AUCOY"
    },
    {
     "description": "AUCNET INC",
     "symbol": "AUCTF"
    },
    {
     "description": "INFLECTION RESOURCES LTD",
     "symbol": "AUCUF"
    },
    {
     "description": "AUDACY INC",
     "symbol": "AUD"
    },
    {
     "description": "AUDIOCODES LTD",
     "symbol": "AUDC"
    },
    {
     "description": "AUDINATE GROUP LTD",
     "symbol": "AUDGF"
    },
    {
     "description": "AUDI AG",
     "symbol": "AUDVF"
    },
    {
     "description": "AUSNUTRIA DAIRY CORP LTD",
     "symbol": "AUDYF"
    },
    {
     "description": "AURA ENERGY LTD",
     "symbol": "AUEEF"
    },
    {
     "description": "AUGUSTA GOLD CORP",
     "symbol": "AUGG"
    },
    {
     "description": "AUGMEDIX INC",
     "symbol": "AUGX"
    },
    {
     "description": "TRUESHARES STRUC OUT AUG ETF",
     "symbol": "AUGZ"
    },
    {
     "description": "ANHUI EXPRESSWAY CO LTD-H",
     "symbol": "AUHEF"
    },
    {
     "description": "ADVANCE UNITED HOLDINGS INC",
     "symbol": "AUHIF"
    },
    {
     "description": "AURANIA RESOURCES LTD",
     "symbol": "AUIAF"
    },
    {
     "description": "IPSIDY INC",
     "symbol": "AUID"
    },
    {
     "description": "AUCKLAND INT AIR LTD-SP ADR",
     "symbol": "AUKNY"
    },
    {
     "description": "AMS-OSRAM AG",
     "symbol": "AUKUF"
    },
    {
     "description": "ANGLOGOLD ASHANTI LTD-CDI",
     "symbol": "AULDF"
    },
    {
     "description": "ANGLOGOLD ASHANTI LTD",
     "symbol": "AULGF"
    },
    {
     "description": "AURELIUS EQUITY OPPORTUNITIE",
     "symbol": "AULRF"
    },
    {
     "description": "AUSTAR LIFESCIENCES LTD",
     "symbol": "AULSF"
    },
    {
     "description": "1911 GOLD CORP",
     "symbol": "AUMBF"
    },
    {
     "description": "AURYN MINING CORP",
     "symbol": "AUMC"
    },
    {
     "description": "GOLDEN MINERALS CO",
     "symbol": "AUMN"
    },
    {
     "description": "AURELIA METALS LTD",
     "symbol": "AUMTF"
    },
    {
     "description": "AURCANA SILVER CORP",
     "symbol": "AUNFF"
    },
    {
     "description": "AUCTION MILLS INC",
     "symbol": "AUNM"
    },
    {
     "description": "AXP ENERGY LTD",
     "symbol": "AUNXF"
    },
    {
     "description": "AU OPTRONICS CORP-SPON ADR",
     "symbol": "AUOTY"
    },
    {
     "description": "AURINIA PHARMACEUTICALS INC",
     "symbol": "AUPH"
    },
    {
     "description": "AURORA INNOVATION INC",
     "symbol": "AUR"
    },
    {
     "description": "AURA BIOSCIENCES INC",
     "symbol": "AURA"
    },
    {
     "description": "AURORA ACQUISITION CORP-A",
     "symbol": "AURC"
    },
    {
     "description": "AURORA ACQUISITION CORP",
     "symbol": "AURCU"
    },
    {
     "description": "AURORA ACQUISITION A -CW28",
     "symbol": "AURCW"
    },
    {
     "description": "AURI INC",
     "symbol": "AURI"
    },
    {
     "description": "AURORA INNOVATION INC  -CW28",
     "symbol": "AUROW"
    },
    {
     "description": "AURELIUS MINERALS INC",
     "symbol": "AURQF"
    },
    {
     "description": "ATTUNE RTD",
     "symbol": "AURT"
    },
    {
     "description": "AURWEST RESOURCES CORP",
     "symbol": "AURWF"
    },
    {
     "description": "NUO THERAPEUTICS INC",
     "symbol": "AURX"
    },
    {
     "description": "AUSTERLITZ ACQUISITION COR-A",
     "symbol": "AUS"
    },
    {
     "description": "AUSTERLITZ ACQUISITION CORP",
     "symbol": "AUS.U"
    },
    {
     "description": "AUSTERLITZ ACQ CL A -CW26",
     "symbol": "AUS.WS"
    },
    {
     "description": "AUSTRALIS CAPITAL INC",
     "symbol": "AUSAF"
    },
    {
     "description": "ABX GROUP LTD",
     "symbol": "AUSBF"
    },
    {
     "description": "PERENTI GLOBAL LTD",
     "symbol": "AUSDF"
    },
    {
     "description": "GLOBAL X ADAPTIVE US FACTOR",
     "symbol": "AUSF"
    },
    {
     "description": "AURA SYSTEMS INC",
     "symbol": "AUSI"
    },
    {
     "description": "AUS TIN MINING LTD",
     "symbol": "AUSNF"
    },
    {
     "description": "AUSTIN ENGINEERING LTD",
     "symbol": "AUSTF"
    },
    {
     "description": "GOLD79 MINES LTD",
     "symbol": "AUSVF"
    },
    {
     "description": "AUTOLUS THERAPEUTICS PLC",
     "symbol": "AUTL"
    },
    {
     "description": "AUSTAL LTD",
     "symbol": "AUTLF"
    },
    {
     "description": "AUTOWEB INC",
     "symbol": "AUTO"
    },
    {
     "description": "AUTRIS",
     "symbol": "AUTR"
    },
    {
     "description": "AUSTRALIAN UNITY OFFICE FUND",
     "symbol": "AUTYF"
    },
    {
     "description": "AUDDIA INC",
     "symbol": "AUUD"
    },
    {
     "description": "AUDDIA INC-CW25",
     "symbol": "AUUDW"
    },
    {
     "description": "AUMANN AG",
     "symbol": "AUUMF"
    },
    {
     "description": "AUSTRALIAN VINTAGE LTD",
     "symbol": "AUVGF"
    },
    {
     "description": "APPLIED UV INC",
     "symbol": "AUVI"
    },
    {
     "description": "APPLIED UV INC",
     "symbol": "AUVIP"
    },
    {
     "description": "AUXICO RESOURCES CANADA INC",
     "symbol": "AUXIF"
    },
    {
     "description": "ALLEGIANT GOLD LTD",
     "symbol": "AUXXF"
    },
    {
     "description": "YAMANA GOLD INC",
     "symbol": "AUY"
    },
    {
     "description": "AVISTA CORP",
     "symbol": "AVA"
    },
    {
     "description": "AVA RISK GROUP LTD",
     "symbol": "AVAAF"
    },
    {
     "description": "AVALON ACQUISITION INC-A",
     "symbol": "AVAC"
    },
    {
     "description": "AVANCE GAS HOLDING LTD",
     "symbol": "AVACF"
    },
    {
     "description": "AVALON ACQUISITION INC",
     "symbol": "AVACU"
    },
    {
     "description": "AVALON ACQUISITION INC--CW23",
     "symbol": "AVACW"
    },
    {
     "description": "AVEANNA HEALTHCARE HOLDINGS",
     "symbol": "AVAH"
    },
    {
     "description": "GRUPO AVAL ACCIONES Y VALORE",
     "symbol": "AVAL"
    },
    {
     "description": "AVANTI ACQUISITION CORP-A",
     "symbol": "AVAN"
    },
    {
     "description": "AVANTI ACQUISITION CORP",
     "symbol": "AVAN.U"
    },
    {
     "description": "AVANTI ACQUISITION A -CW25",
     "symbol": "AVAN.WS"
    },
    {
     "description": "AVAST PLC",
     "symbol": "AVASF"
    },
    {
     "description": "AEROVIRONMENT INC",
     "symbol": "AVAV"
    },
    {
     "description": "AVALONBAY COMMUNITIES INC",
     "symbol": "AVB"
    },
    {
     "description": "AVIDBANK HOLDINGS INC",
     "symbol": "AVBH"
    },
    {
     "description": "AVICANNA INC",
     "symbol": "AVCNF"
    },
    {
     "description": "AVALON GLOBOCARE CORP",
     "symbol": "AVCO"
    },
    {
     "description": "AVRICORE HEALTH INC",
     "symbol": "AVCRF"
    },
    {
     "description": "AMERICAN VIRTUAL CLOUD TECHN",
     "symbol": "AVCT"
    },
    {
     "description": "AVACTA GROUP PLC",
     "symbol": "AVCTF"
    },
    {
     "description": "PENSARE ACQUISITION CORP-CW",
     "symbol": "AVCTW"
    },
    {
     "description": "MONITOR VENTURES INC",
     "symbol": "AVCVF"
    },
    {
     "description": "AMERICAN VANGUARD CORP",
     "symbol": "AVD"
    },
    {
     "description": "AVANTIS INTERNATIONAL EQUITY",
     "symbol": "AVDE"
    },
    {
     "description": "AVDR US LARGECAP ESG ETF",
     "symbol": "AVDG"
    },
    {
     "description": "AVADEL PHARMACEUTICALS-ADR",
     "symbol": "AVDL"
    },
    {
     "description": "AVDR US LARGECAP LEADING ETF",
     "symbol": "AVDR"
    },
    {
     "description": "AVANTIS INTL S\/C VALUE ETF",
     "symbol": "AVDV"
    },
    {
     "description": "ADVENT-AWI HOLDINGS INC",
     "symbol": "AVDWF"
    },
    {
     "description": "AVIDXCHANGE HOLDINGS INC",
     "symbol": "AVDX"
    },
    {
     "description": "AVECHO BIOTECHNOLOGY LTD",
     "symbol": "AVEFF"
    },
    {
     "description": "AVANTIS EMERGING MARKETS EQ",
     "symbol": "AVEM"
    },
    {
     "description": "AVEO PHARMACEUTICALS INC",
     "symbol": "AVEO"
    },
    {
     "description": "AVANTIS EMERGING MARKETS VAL",
     "symbol": "AVES"
    },
    {
     "description": "AVEVA GROUP PLC",
     "symbol": "AVEVF"
    },
    {
     "description": "AVEW HOLDINGS INC",
     "symbol": "AVEW"
    },
    {
     "description": "AVEX GROUP HOLDINGS INC",
     "symbol": "AVEXF"
    },
    {
     "description": "ADVFN PLC",
     "symbol": "AVFCF"
    },
    {
     "description": "AVAILENT FINANCIAL INC",
     "symbol": "AVFL"
    },
    {
     "description": "AVIS FINANCIAL CORP",
     "symbol": "AVFP"
    },
    {
     "description": "AVIDIAN GOLD CORP",
     "symbol": "AVGDF"
    },
    {
     "description": "ADVANCED TECHNOLOGIES GROUP",
     "symbol": "AVGG"
    },
    {
     "description": "BROADCOM INC",
     "symbol": "AVGO"
    },
    {
     "description": "BROADCOM INC",
     "symbol": "AVGOP"
    },
    {
     "description": "AVINGER INC",
     "symbol": "AVGR"
    },
    {
     "description": "AVI GLOBAL TRUST PLC",
     "symbol": "AVGTF"
    },
    {
     "description": "AVITA MEDICAL INC - CDI",
     "symbol": "AVHHL"
    },
    {
     "description": "ACHARI VENTURES HOLDINGS COR",
     "symbol": "AVHI"
    },
    {
     "description": "ACHARI VENTURES HOLDINGS COR",
     "symbol": "AVHIU"
    },
    {
     "description": "ACHARI VENTURES HOLDIN -CW23",
     "symbol": "AVHIW"
    },
    {
     "description": "ACKERMANS & VAN HAAREN",
     "symbol": "AVHNF"
    },
    {
     "description": "ACKERMANS & VAN-UNSPON ADR",
     "symbol": "AVHNY"
    },
    {
     "description": "AVID TECHNOLOGY INC",
     "symbol": "AVID"
    },
    {
     "description": "ADVANCED INFO SVCS-SPON ADR",
     "symbol": "AVIFY"
    },
    {
     "description": "AVANTIS CORE FIXED INCOME",
     "symbol": "AVIG"
    },
    {
     "description": "AVICHINA INDUSTRY & TECH-H",
     "symbol": "AVIJF"
    },
    {
     "description": "ADVANCED INFO SERVICE-FOR RG",
     "symbol": "AVIKF"
    },
    {
     "description": "Aviva PLC",
     "symbol": "AVIPF"
    },
    {
     "description": "ATEA PHARMACEUTICALS INC",
     "symbol": "AVIR"
    },
    {
     "description": "AVANTIS INT LRG CAP VAL ETF",
     "symbol": "AVIV"
    },
    {
     "description": "ADVANCED INFO SERVICE-NVDR",
     "symbol": "AVIVF"
    },
    {
     "description": "AVIX TECHNOLOGIES INC",
     "symbol": "AVIX"
    },
    {
     "description": "ADVANCED INFO SERVICE PCL",
     "symbol": "AVIZF"
    },
    {
     "description": "ADVENT CONVERT & INCOME",
     "symbol": "AVK"
    },
    {
     "description": "AVALON ADVANCED MATERIALS IN",
     "symbol": "AVLNF"
    },
    {
     "description": "AVALANCHE INTERNATIONAL CORP",
     "symbol": "AVLP"
    },
    {
     "description": "AVALARA INC",
     "symbol": "AVLR"
    },
    {
     "description": "ADVANCED LIGHTING SOLUTIONS",
     "symbol": "AVLS"
    },
    {
     "description": "AVANTIS US LARGE CAP VALUE",
     "symbol": "AVLV"
    },
    {
     "description": "AVRA MEDICAL ROBOTICS INC",
     "symbol": "AVMR"
    },
    {
     "description": "AVANTIS CORE MUNICIPAL FIXED",
     "symbol": "AVMU"
    },
    {
     "description": "AVON PROTECTION PLC",
     "symbol": "AVNBF"
    },
    {
     "description": "AVENTURA EQUITIES INC",
     "symbol": "AVNE"
    },
    {
     "description": "ARVANA INC",
     "symbol": "AVNI"
    },
    {
     "description": "AVANOS MEDICAL INC",
     "symbol": "AVNS"
    },
    {
     "description": "AVIENT CORP",
     "symbol": "AVNT"
    },
    {
     "description": "AVIAT NETWORKS INC",
     "symbol": "AVNW"
    },
    {
     "description": "MANARIS 2010 CORP",
     "symbol": "AVNY"
    },
    {
     "description": "MISSION PRODUCE INC",
     "symbol": "AVO"
    },
    {
     "description": "AVOCA LLC",
     "symbol": "AVOA"
    },
    {
     "description": "AVNER OIL EXPLORATION - LP",
     "symbol": "AVOGF"
    },
    {
     "description": "ADVANCED VOICE RECOGNITION",
     "symbol": "AVOI"
    },
    {
     "description": "AMERICAN VIDEO TELECONFERENC",
     "symbol": "AVOT"
    },
    {
     "description": "ALTAVOZ ENTERTAINMENT INC",
     "symbol": "AVOZ"
    },
    {
     "description": "AVCORP INDUSTRIES INC",
     "symbol": "AVPFF"
    },
    {
     "description": "AVP INC",
     "symbol": "AVPI"
    },
    {
     "description": "AVRUPA MINERALS LTD",
     "symbol": "AVPMF"
    },
    {
     "description": "AVEPOINT INC",
     "symbol": "AVPT"
    },
    {
     "description": "AVEPOINT INC-CW24",
     "symbol": "AVPTW"
    },
    {
     "description": "AVANTIS REAL ESTATE ETF",
     "symbol": "AVRE"
    },
    {
     "description": "AVEROX INC",
     "symbol": "AVRI"
    },
    {
     "description": "AVROBIO INC",
     "symbol": "AVRO"
    },
    {
     "description": "AVARONE METALS INC",
     "symbol": "AVRTF"
    },
    {
     "description": "AVISANA CORP",
     "symbol": "AVSA"
    },
    {
     "description": "AVANTIS US SMALL CAP EQUITY",
     "symbol": "AVSC"
    },
    {
     "description": "AVANTIS REPS INTERN EQUI ETF",
     "symbol": "AVSD"
    },
    {
     "description": "AVANTIS RESP EMERG MKTS EQ-E",
     "symbol": "AVSE"
    },
    {
     "description": "AVANTIS SHORT-TERM FIXED INC",
     "symbol": "AVSF"
    },
    {
     "description": "AVI LTD-UNSPONSORED ADR",
     "symbol": "AVSFY"
    },
    {
     "description": "AVISTAR COMMUNICATIONS CORP",
     "symbol": "AVSR"
    },
    {
     "description": "AVANTIS RESP US EQUITY ETF",
     "symbol": "AVSU"
    },
    {
     "description": "AVNET INC",
     "symbol": "AVT"
    },
    {
     "description": "AVANT BRANDS INC",
     "symbol": "AVTBF"
    },
    {
     "description": "AEROVATE THERAPEUTICS INC",
     "symbol": "AVTE"
    },
    {
     "description": "AVITAR INC",
     "symbol": "AVTI"
    },
    {
     "description": "ADDVALUE TECHNOLOGIES LTD",
     "symbol": "AVTLF"
    },
    {
     "description": "AVANTOR INC",
     "symbol": "AVTR"
    },
    {
     "description": "AVANTOR INC",
     "symbol": "AVTR.PRA"
    },
    {
     "description": "AVAST PLC - UNSPON ADR",
     "symbol": "AVTTY"
    },
    {
     "description": "AVALO THERAPEUTICS INC",
     "symbol": "AVTX"
    },
    {
     "description": "AVANTIUM",
     "symbol": "AVTXF"
    },
    {
     "description": "AVANTIS U.S. EQUITY ETF",
     "symbol": "AVUS"
    },
    {
     "description": "AVANTIS US SMALL CAP VALUE",
     "symbol": "AVUV"
    },
    {
     "description": "ART VIVANT CO LTD",
     "symbol": "AVVFF"
    },
    {
     "description": "AVVAA WORLD HEALTH CARE PROD",
     "symbol": "AVVH"
    },
    {
     "description": "AVIVA PLC - SPON ADR",
     "symbol": "AVVIY"
    },
    {
     "description": "AVIO SPA",
     "symbol": "AVVOF"
    },
    {
     "description": "AVEVA GROUP PLC - UNSP ADR",
     "symbol": "AVVYY"
    },
    {
     "description": "ANAVEX LIFE SCIENCES CORP",
     "symbol": "AVXL"
    },
    {
     "description": "AVAX TECHNOLOGIES INC",
     "symbol": "AVXT"
    },
    {
     "description": "AVERY DENNISON CORP",
     "symbol": "AVY"
    },
    {
     "description": "AVAYA HOLDINGS CORP",
     "symbol": "AVYA"
    },
    {
     "description": "AVAYA HOLDINGS CORP-CW22",
     "symbol": "AVYAW"
    },
    {
     "description": "SIIC ENVIRONMENT HOLDINGS LT",
     "symbol": "AWAEF"
    },
    {
     "description": "WHITE FOX VENTURES INC",
     "symbol": "AWAW"
    },
    {
     "description": "ETFMG TRAVEL TECH ETF",
     "symbol": "AWAY"
    },
    {
     "description": "ALUMINA LTD",
     "symbol": "AWCMF"
    },
    {
     "description": "ALUMINA LTD-SPONSORED ADR",
     "symbol": "AWCMY"
    },
    {
     "description": "ALPHAWAVE IP GROUP PLC",
     "symbol": "AWEVF"
    },
    {
     "description": "ALLIANCEBERNSTEIN GL HI INC",
     "symbol": "AWF"
    },
    {
     "description": "AWG LTD",
     "symbol": "AWGL"
    },
    {
     "description": "ASPIRA WOMEN'S HEALTH INC",
     "symbol": "AWH"
    },
    {
     "description": "ANGO WORLD HOLDINGS INC",
     "symbol": "AWHI"
    },
    {
     "description": "ARMSTRONG WORLD INDUSTRIES",
     "symbol": "AWI"
    },
    {
     "description": "AMERICAN WATER WORKS CO INC",
     "symbol": "AWK"
    },
    {
     "description": "AWAKN LIFE SCIENCES CORP",
     "symbol": "AWKNF"
    },
    {
     "description": "AMERIWORKS INC",
     "symbol": "AWKS"
    },
    {
     "description": "AWILCO DRILLING PLC",
     "symbol": "AWLCF"
    },
    {
     "description": "AMERIWEST LITHIUM INC",
     "symbol": "AWLIF"
    },
    {
     "description": "AWILCO LNG AS",
     "symbol": "AWLNF"
    },
    {
     "description": "A-1 GROUP INC",
     "symbol": "AWON"
    },
    {
     "description": "ABERDEEN GLBL PREM PROP",
     "symbol": "AWP"
    },
    {
     "description": "AMERICAN STATES WATER CO",
     "symbol": "AWR"
    },
    {
     "description": "AWARE INC\/MASS",
     "symbol": "AWRE"
    },
    {
     "description": "A&W REVENUE ROYALTIES IN-UTS",
     "symbol": "AWRRF"
    },
    {
     "description": "ALL WORLD RESOURCES CORP",
     "symbol": "AWRS"
    },
    {
     "description": "ALLEGHENY & WESTERN RAILWAY",
     "symbol": "AWRY"
    },
    {
     "description": "ARIA WIRELESS SYSTEMS INC",
     "symbol": "AWSI"
    },
    {
     "description": "ATLANTIC POWER & INFRASTRUCT",
     "symbol": "AWSL"
    },
    {
     "description": "NATIONAL INVESTMENT SERVICES",
     "symbol": "AWTM"
    },
    {
     "description": "AIR WATER INC",
     "symbol": "AWTRF"
    },
    {
     "description": "ACCESS WORLDWIDE COMM INC",
     "symbol": "AWWC"
    },
    {
     "description": "ALPHA WASTEWATER INC",
     "symbol": "AWWI"
    },
    {
     "description": "AVALON HOLDINGS CORP-A",
     "symbol": "AWX"
    },
    {
     "description": "ETFMG 2X DAILY TRAVEL TECH E",
     "symbol": "AWYX"
    },
    {
     "description": "AXOS FINANCIAL INC",
     "symbol": "AX"
    },
    {
     "description": "AXIOS SUSTAINABLE GROWTH A-A",
     "symbol": "AXAC"
    },
    {
     "description": "AXIOS Sustainable Growth Acquisition Corporation",
     "symbol": "AXAC.RT"
    },
    {
     "description": "AXIOS SUSTAINABLE GRTH-CW27",
     "symbol": "AXAC.WS"
    },
    {
     "description": "AXA SA",
     "symbol": "AXAHF"
    },
    {
     "description": "AXA -SPONS ADR",
     "symbol": "AXAHY"
    },
    {
     "description": "ABRAXAS PETROLEUM CORP",
     "symbol": "AXAS"
    },
    {
     "description": "AXIOS MOBILE ASSETS CORP",
     "symbol": "AXBSF"
    },
    {
     "description": "EYES ON THE GO INC",
     "symbol": "AXCG"
    },
    {
     "description": "ALLIXON INTERNATIONAL CORP",
     "symbol": "AXCP"
    },
    {
     "description": "AZUCAR MINERALS LTD",
     "symbol": "AXDDF"
    },
    {
     "description": "ACCELERATE DIAGNOSTICS INC",
     "symbol": "AXDX"
    },
    {
     "description": "AXFOOD AB",
     "symbol": "AXFOF"
    },
    {
     "description": "AXFOOD AB-UNSPON ADR",
     "symbol": "AXFOY"
    },
    {
     "description": "AXIS ENERGY CORP",
     "symbol": "AXGC"
    },
    {
     "description": "AXOGEN INC",
     "symbol": "AXGN"
    },
    {
     "description": "INDUSTRIAL HUMAN CAPITAL INC",
     "symbol": "AXH"
    },
    {
     "description": "INDUSTRIAL HUMAN CAPITAL INC",
     "symbol": "AXH.U"
    },
    {
     "description": "INDUSTRIAL HUMAN CAPIT -CW28",
     "symbol": "AXH.WS"
    },
    {
     "description": "ALEXIUM INTERNATIONAL GROUP",
     "symbol": "AXIIF"
    },
    {
     "description": "AXIM BIOTECHNOLOGIES INC",
     "symbol": "AXIM"
    },
    {
     "description": "AMERICAN AXLE & MFG HOLDINGS",
     "symbol": "AXL"
    },
    {
     "description": "AXCELLA HEALTH INC",
     "symbol": "AXLA"
    },
    {
     "description": "T.J.T. INC",
     "symbol": "AXLE"
    },
    {
     "description": "AXELUM RESOURCES CORP",
     "symbol": "AXLMF"
    },
    {
     "description": "AXIOLOGIX INC",
     "symbol": "AXLX"
    },
    {
     "description": "AXMIN INC",
     "symbol": "AXMIF"
    },
    {
     "description": "AXM PHARMA INC",
     "symbol": "AXMP"
    },
    {
     "description": "AXION VENTURES INC",
     "symbol": "AXNVF"
    },
    {
     "description": "AXONICS INC",
     "symbol": "AXNX"
    },
    {
     "description": "AXON ENTERPRISE INC",
     "symbol": "AXON"
    },
    {
     "description": "AMERICAN EXPRESS CO",
     "symbol": "AXP"
    },
    {
     "description": "AMSECO EXPLORATION LTD",
     "symbol": "AXPRF"
    },
    {
     "description": "AXIS PETROLEUM CO",
     "symbol": "AXPT"
    },
    {
     "description": "AXION POWER INTERNATIONAL",
     "symbol": "AXPWQ"
    },
    {
     "description": "AMREP CORP",
     "symbol": "AXR"
    },
    {
     "description": "AMARC RESOURCES LTD",
     "symbol": "AXREF"
    },
    {
     "description": "AMEXDRUG CORP",
     "symbol": "AXRX"
    },
    {
     "description": "AXIS CAPITAL HOLDINGS LTD",
     "symbol": "AXS"
    },
    {
     "description": "AXIS CAPITAL HLDGS LTD",
     "symbol": "AXS.PRE"
    },
    {
     "description": "AXSOME THERAPEUTICS INC",
     "symbol": "AXSM"
    },
    {
     "description": "AXALTA COATING SYSTEMS LTD",
     "symbol": "AXTA"
    },
    {
     "description": "AXTIVE CORP",
     "symbol": "AXTC"
    },
    {
     "description": "AXIS TECHNOLOGIES",
     "symbol": "AXTG"
    },
    {
     "description": "AXT INC",
     "symbol": "AXTI"
    },
    {
     "description": "AXTEL SAB DE CV - CPO",
     "symbol": "AXTLF"
    },
    {
     "description": "ALEXCO RESOURCE CORP",
     "symbol": "AXU"
    },
    {
     "description": "CDN MAVERICK CAPITAL CORP",
     "symbol": "AXVEF"
    },
    {
     "description": "EXXE GROUP INC",
     "symbol": "AXXA"
    },
    {
     "description": "ALDERON IRON ORE CORP",
     "symbol": "AXXDF"
    },
    {
     "description": "AXIATA GROUP BERHAD",
     "symbol": "AXXTF"
    },
    {
     "description": "ATLANTICA SUSTAINABLE INFRAS",
     "symbol": "AY"
    },
    {
     "description": "AYALA LAND INC",
     "symbol": "AYAAF"
    },
    {
     "description": "AYALA LAND INC - UNSP ADR",
     "symbol": "AYAAY"
    },
    {
     "description": "AMAYA GLOBAL HOLDINGS CORP",
     "symbol": "AYAG"
    },
    {
     "description": "AYALA CORPORATION-UNSPON ADR",
     "symbol": "AYALY"
    },
    {
     "description": "AYA GOLD & SILVER INC",
     "symbol": "AYASF"
    },
    {
     "description": "AYFIE GROUP AS",
     "symbol": "AYFGF"
    },
    {
     "description": "AYGAZ AS-UNSPONSORED ADR",
     "symbol": "AYGUY"
    },
    {
     "description": "ACUITY BRANDS INC",
     "symbol": "AYI"
    },
    {
     "description": "AYALA PHARMACEUTICALS INC",
     "symbol": "AYLA"
    },
    {
     "description": "AFTER YOU PCL-NVDR",
     "symbol": "AYPCF"
    },
    {
     "description": "AYRO INC",
     "symbol": "AYRO"
    },
    {
     "description": "AYR WELLNESS INC",
     "symbol": "AYRWF"
    },
    {
     "description": "IPATH GEMS ASIA 8 ETN",
     "symbol": "AYTEF"
    },
    {
     "description": "AYTU BIOPHARMA INC",
     "symbol": "AYTU"
    },
    {
     "description": "AYURCANN HOLDINGS CORP",
     "symbol": "AYURF"
    },
    {
     "description": "ALTERYX INC - CLASS A",
     "symbol": "AYX"
    },
    {
     "description": "AYALA CORPORATION",
     "symbol": "AYYLF"
    },
    {
     "description": "A2Z SMART TECHNOLOGIES CORP",
     "symbol": "AZ"
    },
    {
     "description": "ALLIANZIM US LG CAP BUFFER10",
     "symbol": "AZAA"
    },
    {
     "description": "ALLIANZ US LRG CAP BUFF10 JA",
     "symbol": "AZAJ"
    },
    {
     "description": "ALLIANZIM US LRG CAP BU10 JU",
     "symbol": "AZAL"
    },
    {
     "description": "ALLIANZIM US LARGE CAP BUFFE",
     "symbol": "AZAO"
    },
    {
     "description": "ARIZONA SILVER EXPLORATION I",
     "symbol": "AZASF"
    },
    {
     "description": "ALLIANZIM US LG CAP BUFFER20",
     "symbol": "AZBA"
    },
    {
     "description": "AZABACHE ENERGY INC",
     "symbol": "AZBCF"
    },
    {
     "description": "ALLIANZIM US LRG CAP BUFF20",
     "symbol": "AZBJ"
    },
    {
     "description": "ALLIANZIM US LRG CAP BU 20 J",
     "symbol": "AZBL"
    },
    {
     "description": "ALLIANZIM US LARGE CAP BUFFE",
     "symbol": "AZBO"
    },
    {
     "description": "AZURE DYNAMICS CORP",
     "symbol": "AZDDQ"
    },
    {
     "description": "AZEK CO INC\/THE",
     "symbol": "AZEK"
    },
    {
     "description": "AMAZONAS FLORESTAL LTD",
     "symbol": "AZFL"
    },
    {
     "description": "AZTECA GOLD CORP",
     "symbol": "AZGFF"
    },
    {
     "description": "AZTEC OIL & GAS INC",
     "symbol": "AZGSQ"
    },
    {
     "description": "AZAR INTERNATIONAL CORP",
     "symbol": "AZIC"
    },
    {
     "description": "AZIMUT HOLDING SPA",
     "symbol": "AZIHF"
    },
    {
     "description": "AZIMUT HOLDING SPA-UNSP ADR",
     "symbol": "AZIHY"
    },
    {
     "description": "AZIEL CORP",
     "symbol": "AZIL"
    },
    {
     "description": "ARIZONA LITHIUM LTD",
     "symbol": "AZLAF"
    },
    {
     "description": "AZTEC LAND & CATTLE LTD",
     "symbol": "AZLCZ"
    },
    {
     "description": "AZELIS GROUP NV",
     "symbol": "AZLGF"
    },
    {
     "description": "AZELIO AB",
     "symbol": "AZLOF"
    },
    {
     "description": "ARIZONA METALS CORP",
     "symbol": "AZMCF"
    },
    {
     "description": "AZIMUT EXPLORATION INC",
     "symbol": "AZMTF"
    },
    {
     "description": "ASTRAZENECA PLC-SPONS ADR",
     "symbol": "AZN"
    },
    {
     "description": "ASTRAZENECA PLC",
     "symbol": "AZNCF"
    },
    {
     "description": "AZN CAPITAL CORP",
     "symbol": "AZNVF"
    },
    {
     "description": "AUTOZONE INC",
     "symbol": "AZO"
    },
    {
     "description": "ASPEN TECHNOLOGY INC",
     "symbol": "AZPN"
    },
    {
     "description": "AZURE POWER GLOBAL LTD",
     "symbol": "AZRE"
    },
    {
     "description": "AZRIELI GROUP LTD",
     "symbol": "AZRGF"
    },
    {
     "description": "AZURE HOLDING GROUP CORP",
     "symbol": "AZRH"
    },
    {
     "description": "AZURE MINERALS LTD",
     "symbol": "AZRMF"
    },
    {
     "description": "AZENTA INC",
     "symbol": "AZTA"
    },
    {
     "description": "TV AZTECA SAB DE CV-CPO",
     "symbol": "AZTEF"
    },
    {
     "description": "AZUL SA-ADR",
     "symbol": "AZUL"
    },
    {
     "description": "AZINCOURT ENERGY CORP",
     "symbol": "AZURD"
    },
    {
     "description": "AZEUS SYSTEMS HOLDINGS LTD",
     "symbol": "AZUSF"
    },
    {
     "description": "AIZAWA SECURITIES GROUP CO L",
     "symbol": "AZWSF"
    },
    {
     "description": "ANTIPA MINERALS LTD",
     "symbol": "AZYMF"
    },
    {
     "description": "AZIYO BIOLOGICS INC-CLASS A",
     "symbol": "AZYO"
    },
    {
     "description": "AZZ INC",
     "symbol": "AZZ"
    },
    {
     "description": "AZTEC MINERALS CORP",
     "symbol": "AZZTF"
    },
    {
     "description": "AVZ MINERALS LTD",
     "symbol": "AZZVF"
    },
    {
     "description": "BARNES GROUP INC",
     "symbol": "B"
    },
    {
     "description": "BOEING CO\/THE",
     "symbol": "BA"
    },
    {
     "description": "INVESCO TAXABLE MUNICIPAL BO",
     "symbol": "BAB"
    },
    {
     "description": "ALIBABA GROUP HOLDING-SP ADR",
     "symbol": "BABA"
    },
    {
     "description": "ALIBABA GROUP HOLDING LTD",
     "symbol": "BABAF"
    },
    {
     "description": "BAB INC",
     "symbol": "BABB"
    },
    {
     "description": "BUILDABLOCK CORP",
     "symbol": "BABL"
    },
    {
     "description": "INTL CONSOLIDATED AIRLINE-DI",
     "symbol": "BABWF"
    },
    {
     "description": "ELSE NUTRITION HOLDINGS INC",
     "symbol": "BABYF"
    },
    {
     "description": "BANK OF AMERICA CORP",
     "symbol": "BAC"
    },
    {
     "description": "BANK OF AMERICA CORP",
     "symbol": "BAC.PRB"
    },
    {
     "description": "BANK OF AMERICA CORP",
     "symbol": "BAC.PRE"
    },
    {
     "description": "BANK OF AMERICA CORP",
     "symbol": "BAC.PRK"
    },
    {
     "description": "BANK OF AMERICA CORP",
     "symbol": "BAC.PRL"
    },
    {
     "description": "BANK OF AMERICA CORP",
     "symbol": "BAC.PRM"
    },
    {
     "description": "BANK OF AMERICA CORP",
     "symbol": "BAC.PRN"
    },
    {
     "description": "BANK OF AMERICA CORP",
     "symbol": "BAC.PRO"
    },
    {
     "description": "BANK OF AMERICA CORP",
     "symbol": "BAC.PRP"
    },
    {
     "description": "BANK OF AMERICA CORP",
     "symbol": "BAC.PRQ"
    },
    {
     "description": "BANK OF AMERICA CORP",
     "symbol": "BAC.PRS"
    },
    {
     "description": "BERENSON ACQUISITION CO-CL A",
     "symbol": "BACA"
    },
    {
     "description": "BERENSON ACQUISITION CORP I",
     "symbol": "BACA.U"
    },
    {
     "description": "BERENSON ACQUISITION -CW26",
     "symbol": "BACA.WS"
    },
    {
     "description": "BANK OF CHINA LTD-H",
     "symbol": "BACHF"
    },
    {
     "description": "BANK OF CHINA-UNSPN ADR",
     "symbol": "BACHY"
    },
    {
     "description": "Bank of America Corp",
     "symbol": "BACRP"
    },
    {
     "description": "BAD ETF",
     "symbol": "BAD"
    },
    {
     "description": "BALD EAGLE GOLD CORP",
     "symbol": "BADEF"
    },
    {
     "description": "BADGER INFRASTRUCTURE SOLUTI",
     "symbol": "BADFF"
    },
    {
     "description": "BADGER STATE ETHANOL - CAP U",
     "symbol": "BADG"
    },
    {
     "description": "BADGER STATE ETHANOLL-CL A",
     "symbol": "BADGA"
    },
    {
     "description": "BAE SYSTEMS PLC",
     "symbol": "BAESF"
    },
    {
     "description": "BAE SYSTEMS PLC -SPON ADR",
     "symbol": "BAESY"
    },
    {
     "description": "BALFOUR BEATTY PLC",
     "symbol": "BAFBF"
    },
    {
     "description": "SUSSER BANC HOLDINGS CORP",
     "symbol": "BAFI"
    },
    {
     "description": "BAYFIRST FINANCIAL CORP",
     "symbol": "BAFN"
    },
    {
     "description": "BALFOUR BEATTY PLC-SPON ADR",
     "symbol": "BAFYY"
    },
    {
     "description": "A.G. BARR PLC",
     "symbol": "BAGFF"
    },
    {
     "description": "BOOZ ALLEN HAMILTON HOLDINGS",
     "symbol": "BAH"
    },
    {
     "description": "BAIDU INC-CLASS A",
     "symbol": "BAIDF"
    },
    {
     "description": "BASE INC",
     "symbol": "BAINF"
    },
    {
     "description": "CAMROVA RESOURCES INC",
     "symbol": "BAJFF"
    },
    {
     "description": "BRASKEM SA-SPON ADR",
     "symbol": "BAK"
    },
    {
     "description": "BARKBY GROUP PLC\/THE",
     "symbol": "BAKBF"
    },
    {
     "description": "GLOBAL OIL &  GAS LTD",
     "symbol": "BAKPF"
    },
    {
     "description": "IPATHR SERIES B BLOOMBERG CO",
     "symbol": "BAL"
    },
    {
     "description": "FASTIGHETS AB BALDER-B SHRS",
     "symbol": "BALDF"
    },
    {
     "description": "INN DEFINED WEALTH SHIELD",
     "symbol": "BALT"
    },
    {
     "description": "IPATH BLOOMBERG COTTON SUBIN",
     "symbol": "BALTF"
    },
    {
     "description": "BALLY'S CORP",
     "symbol": "BALY"
    },
    {
     "description": "BROOKFIELD ASSET MANAGE-CL A",
     "symbol": "BAM"
    },
    {
     "description": "Brookfield Asset Management Inc",
     "symbol": "BAMGF"
    },
    {
     "description": "BROOKFIELD FINANCE INC",
     "symbol": "BAMH"
    },
    {
     "description": "BROOKFIELD FIN I UK PLC",
     "symbol": "BAMI"
    },
    {
     "description": "Brookfield Asset Management Inc Pref Shs Ser 26 Canada",
     "symbol": "BAMKF"
    },
    {
     "description": "BROOKFIELD ASSET MANAGEMEN-A",
     "symbol": "BAMR"
    },
    {
     "description": "BAYERISCHE MOTOREN WERKE AG",
     "symbol": "BAMXF"
    },
    {
     "description": "BANC OF CALIFORNIA INC",
     "symbol": "BANC"
    },
    {
     "description": "BANDWIDTH INC-CLASS A",
     "symbol": "BAND"
    },
    {
     "description": "BANCFIRST CORP",
     "symbol": "BANF"
    },
    {
     "description": "BFC CAPITAL TRUST II",
     "symbol": "BANFP"
    },
    {
     "description": "Versant Power",
     "symbol": "BANGN"
    },
    {
     "description": "BANNEKER INC",
     "symbol": "BANI"
    },
    {
     "description": "BANNER CORPORATION",
     "symbol": "BANR"
    },
    {
     "description": "BANTEK INC",
     "symbol": "BANT"
    },
    {
     "description": "ARROWMARK FINANCIAL CORP",
     "symbol": "BANX"
    },
    {
     "description": "BARABOO BANCORP INC",
     "symbol": "BAOB"
    },
    {
     "description": "BAOSHENG MEDIA GROUP HOLDING",
     "symbol": "BAOS"
    },
    {
     "description": "CREDICORP LTD",
     "symbol": "BAP"
    },
    {
     "description": "INNOVATOR U.S. EQUITY BUFFER",
     "symbol": "BAPR"
    },
    {
     "description": "GRANITESHARES GOLD TRUST",
     "symbol": "BAR"
    },
    {
     "description": "BARK INC",
     "symbol": "BARK"
    },
    {
     "description": "ORIGINAL BARK CO\/THE -CW25",
     "symbol": "BARK.WS"
    },
    {
     "description": "BARU GOLD CORP",
     "symbol": "BARUF"
    },
    {
     "description": "BASANITE INC",
     "symbol": "BASA"
    },
    {
     "description": "COUCHBASE INC",
     "symbol": "BASE"
    },
    {
     "description": "BASF SE-SPON ADR",
     "symbol": "BASFY"
    },
    {
     "description": "BASIC ENERGY SERVICE-CW23",
     "symbol": "BASWQ"
    },
    {
     "description": "BASIC ENERGY SERVICES INC",
     "symbol": "BASXQ"
    },
    {
     "description": "BATTALION OIL CORP",
     "symbol": "BATL"
    },
    {
     "description": "BRITISH AMERICAN TOBACCO BHD",
     "symbol": "BATMF"
    },
    {
     "description": "LIBERTY MEDIA CORP-BRAVES A",
     "symbol": "BATRA"
    },
    {
     "description": "LIBERTY MEDIA CORP-BRAVES B",
     "symbol": "BATRB"
    },
    {
     "description": "LIBERTY MEDIA CORP-BRAVES C",
     "symbol": "BATRK"
    },
    {
     "description": "AMPLIFY LITHIUM BATTERY TECH",
     "symbol": "BATT"
    },
    {
     "description": "BLUE STAR GOLD CORP",
     "symbol": "BAUFF"
    },
    {
     "description": "INNOVATOR U.S. EQUITY BUFFER",
     "symbol": "BAUG"
    },
    {
     "description": "BAXTER INTERNATIONAL INC",
     "symbol": "BAX"
    },
    {
     "description": "BAYPORT INTERNATIONAL HOLDIN",
     "symbol": "BAYP"
    },
    {
     "description": "BAYER AG-SPONSORED ADR",
     "symbol": "BAYRY"
    },
    {
     "description": "BAYER AG-REG",
     "symbol": "BAYZF"
    },
    {
     "description": "BLACKBERRY LTD",
     "symbol": "BB"
    },
    {
     "description": "BB BIOTECH AG-REG",
     "symbol": "BBAGF"
    },
    {
     "description": "BIGBEAR.AI HOLDINGS INC",
     "symbol": "BBAI"
    },
    {
     "description": "BIGBEAR.AI HOLDINGS -CW28",
     "symbol": "BBAI.WS"
    },
    {
     "description": "BANCO DEL BAJIO SA",
     "symbol": "BBAJF"
    },
    {
     "description": "NEW YORK HEALTH CARE INC",
     "symbol": "BBAL"
    },
    {
     "description": "BBVA ARGENTINA SA-ADR",
     "symbol": "BBAR"
    },
    {
     "description": "JPMORGAN BETABUILDERS DEVELO",
     "symbol": "BBAX"
    },
    {
     "description": "BAKER BOYER BANCORP\/WALLA",
     "symbol": "BBBK"
    },
    {
     "description": "HUNTSMAN EXPLORATION INC",
     "symbol": "BBBMF"
    },
    {
     "description": "BLACK BIRD BIOTECH INC",
     "symbol": "BBBT"
    },
    {
     "description": "BRIXTON METALS CORP",
     "symbol": "BBBXF"
    },
    {
     "description": "BED BATH & BEYOND INC",
     "symbol": "BBBY"
    },
    {
     "description": "VIRTUS LIFESCI BIOTECH CLINI",
     "symbol": "BBC"
    },
    {
     "description": "JPMORGAN BETABUILDERS CANADA",
     "symbol": "BBCA"
    },
    {
     "description": "Better Being Co",
     "symbol": "BBCO"
    },
    {
     "description": "CONCRETE PUMPING HOLDINGS IN",
     "symbol": "BBCP"
    },
    {
     "description": "CONCRETE PUMPING HOLDIN-CW24",
     "symbol": "BBCPW"
    },
    {
     "description": "BANCO BRADESCO-ADR",
     "symbol": "BBD"
    },
    {
     "description": "BEBIDA BEVERAGE CO",
     "symbol": "BBDA"
    },
    {
     "description": "BARINGS BDC INC",
     "symbol": "BBDC"
    },
    {
     "description": "BANCO BRADESCO-ADR",
     "symbol": "BBDO"
    },
    {
     "description": "BETER BED HOLDING NV",
     "symbol": "BBEDF"
    },
    {
     "description": "JPMORGAN BETABUILDERS EUROPE",
     "symbol": "BBEU"
    },
    {
     "description": "BEASLEY BROADCAST GRP INC -A",
     "symbol": "BBGI"
    },
    {
     "description": "VANECK BIOTECH ETF",
     "symbol": "BBH"
    },
    {
     "description": "BRICKELL BIOTECH INC",
     "symbol": "BBI"
    },
    {
     "description": "VINCO VENTURES INC",
     "symbol": "BBIG"
    },
    {
     "description": "JPM BETABUILDERS INTL EQTY",
     "symbol": "BBIN"
    },
    {
     "description": "BRIDGEBIO PHARMA INC",
     "symbol": "BBIO"
    },
    {
     "description": "BONUS BIOGROUP LTD",
     "symbol": "BBIXF"
    },
    {
     "description": "JPMORGAN BETABUILDERS JAPAN",
     "symbol": "BBJP"
    },
    {
     "description": "BIGG DIGITAL ASSETS INC",
     "symbol": "BBKCF"
    },
    {
     "description": "BLOCKCHAIN LOYALTY CORP",
     "symbol": "BBLC"
    },
    {
     "description": "BONE BIOLOGICS CORP",
     "symbol": "BBLG"
    },
    {
     "description": "BONE BIOLOGICS CORP -CW26",
     "symbol": "BBLGW"
    },
    {
     "description": "BRITANNIA BULK HOLDINGS INC",
     "symbol": "BBLKF"
    },
    {
     "description": "BABYLON HOLDINGS LTD- CL A",
     "symbol": "BBLN"
    },
    {
     "description": "BABYLON HOLDINGS A -CW26",
     "symbol": "BBLN.WS"
    },
    {
     "description": "BUBBLR INC",
     "symbol": "BBLR"
    },
    {
     "description": "PETROLIA ENERGY CORP",
     "symbol": "BBLS"
    },
    {
     "description": "JPM BETABUILDERS US MID CAP",
     "symbol": "BBMC"
    },
    {
     "description": "BORDER BANCSHARES INC\/ME",
     "symbol": "BBME"
    },
    {
     "description": "BBMG CORPORATION - UNSPN ADR",
     "symbol": "BBMPY"
    },
    {
     "description": "BLACKROCK TAXABLE MUNICIPAL",
     "symbol": "BBN"
    },
    {
     "description": "BLACK BOX ENTERTAINMENT LTD",
     "symbol": "BBOE"
    },
    {
     "description": "VIRTUS LIFESCI BIOTECH PRODU",
     "symbol": "BBP"
    },
    {
     "description": "BBQ HOLDINGS INC",
     "symbol": "BBQ"
    },
    {
     "description": "BLACKBIRD PLC",
     "symbol": "BBRDF"
    },
    {
     "description": "JPM BETABLDRS MSCI US REIT",
     "symbol": "BBRE"
    },
    {
     "description": "BLUEBERRIES MEDICAL CORP",
     "symbol": "BBRRF"
    },
    {
     "description": "BREWBILT MANUFACTURING INC",
     "symbol": "BBRW"
    },
    {
     "description": "BURBERRY GROUP PLC",
     "symbol": "BBRYF"
    },
    {
     "description": "JPMORGAN BETABUILDERS 1-5 YR",
     "symbol": "BBSA"
    },
    {
     "description": "JPMORGAN BETABUILDERS US SC",
     "symbol": "BBSC"
    },
    {
     "description": "BBI LIFE SCIENCES CORP",
     "symbol": "BBSCF"
    },
    {
     "description": "BB SEGURIDADE PARTI-SPON ADR",
     "symbol": "BBSEY"
    },
    {
     "description": "BARRETT BUSINESS SVCS INC",
     "symbol": "BBSI"
    },
    {
     "description": "BLUESTONE RESOURCES INC",
     "symbol": "BBSRF"
    },
    {
     "description": "BBTV HOLDINGS INC",
     "symbol": "BBTVF"
    },
    {
     "description": "BROOKFIELD BUSINESS PT-UNIT",
     "symbol": "BBU"
    },
    {
     "description": "BROOKFIELD BUSINESS-CL A",
     "symbol": "BBUC"
    },
    {
     "description": "BIG BUCK BREWERY & STEAKHOUS",
     "symbol": "BBUCQ"
    },
    {
     "description": "JPMORGAN BETABUILDERS US EQU",
     "symbol": "BBUS"
    },
    {
     "description": "BANCO BILBAO VIZCAYA-SP ADR",
     "symbol": "BBVA"
    },
    {
     "description": "BANCO BILBAO VIZCAYA ARGENTA",
     "symbol": "BBVXF"
    },
    {
     "description": "BUILD-A-BEAR WORKSHOP INC",
     "symbol": "BBW"
    },
    {
     "description": "BATH & BODY WORKS INC",
     "symbol": "BBWI"
    },
    {
     "description": "BBX CAPITAL INC",
     "symbol": "BBXIA"
    },
    {
     "description": "BBX CAPITAL FLORIDA LLC-CL B",
     "symbol": "BBXIB"
    },
    {
     "description": "BBX MINERALS LTD",
     "symbol": "BBXMF"
    },
    {
     "description": "BEST BUY CO INC",
     "symbol": "BBY"
    },
    {
     "description": "ABRA INFORMATION TECHNOLOGIE",
     "symbol": "BBYLF"
    },
    {
     "description": "BRUNSWICK CORP",
     "symbol": "BC"
    },
    {
     "description": "BRUNSWICK CORP",
     "symbol": "BC.PRA"
    },
    {
     "description": "BRUNSWICK CORP",
     "symbol": "BC.PRB"
    },
    {
     "description": "BRUNSWICK CORP",
     "symbol": "BC.PRC"
    },
    {
     "description": "BIOATLA INC",
     "symbol": "BCAB"
    },
    {
     "description": "BROOKLINE CAPITAL ACQUISITIO",
     "symbol": "BCAC"
    },
    {
     "description": "BROOKLINE CAPITAL ACQUISITIO",
     "symbol": "BCACU"
    },
    {
     "description": "BROOKLINE CAPITAL ACQU -CW27",
     "symbol": "BCACW"
    },
    {
     "description": "SOUTHERN CALIFORNIA BANCORP",
     "symbol": "BCAL"
    },
    {
     "description": "BARON CAPITAL ENTERPRISE INC",
     "symbol": "BCAP"
    },
    {
     "description": "BLACKROCK CAPITAL ALLOCATION",
     "symbol": "BCAT"
    },
    {
     "description": "BRILLIANCE CHINA AUTOMOTIVE",
     "symbol": "BCAUF"
    },
    {
     "description": "BEACH COMMUNITY BANCSHARES I",
     "symbol": "BCBF"
    },
    {
     "description": "CARIBBEAN INVESTMENT HOLDING",
     "symbol": "BCBHF"
    },
    {
     "description": "BASE CARBON INC",
     "symbol": "BCBNF"
    },
    {
     "description": "BCB BANCORP INC",
     "symbol": "BCBP"
    },
    {
     "description": "BOISE CASCADE CO",
     "symbol": "BCC"
    },
    {
     "description": "BCE Inc ",
     "symbol": "BCCCF"
    },
    {
     "description": "BACTECH ENVIRONMENTAL CORP",
     "symbol": "BCCEF"
    },
    {
     "description": "BEAM COMMUNICATIONS HOLDINGS",
     "symbol": "BCCHF"
    },
    {
     "description": "BARISTAS COFFEE CO INC",
     "symbol": "BCCI"
    },
    {
     "description": "BECLE SAB DE CV",
     "symbol": "BCCLF"
    },
    {
     "description": "BAIC MOTOR CORP LTD-UNS ADR",
     "symbol": "BCCMY"
    },
    {
     "description": "BICO GROUP AB-ADR UNSPONSORE",
     "symbol": "BCCOY"
    },
    {
     "description": "ABRDN BLOOMBERG ALL COMMODIT",
     "symbol": "BCD"
    },
    {
     "description": "BIOCARDIA INC",
     "symbol": "BCDA"
    },
    {
     "description": "BIOCARDIA INC -CW22",
     "symbol": "BCDAW"
    },
    {
     "description": "POLAR WIRELESS CORP",
     "symbol": "BCDI"
    },
    {
     "description": "KUUHUBB INC",
     "symbol": "BCDMF"
    },
    {
     "description": "BANCO SANTANDER SA",
     "symbol": "BCDRF"
    },
    {
     "description": "BLAQCLOUDS INC",
     "symbol": "BCDS"
    },
    {
     "description": "BCE INC",
     "symbol": "BCE"
    },
    {
     "description": "BCE Inc",
     "symbol": "BCEFF"
    },
    {
     "description": "BEAR CREEK MINING CORP",
     "symbol": "BCEKF"
    },
    {
     "description": "ATRECA INC - A",
     "symbol": "BCEL"
    },
    {
     "description": "BCE Inc",
     "symbol": "BCEPF"
    },
    {
     "description": "BCE Inc",
     "symbol": "BCEXF"
    },
    {
     "description": "BANCO DE CHILE-ADR",
     "symbol": "BCH"
    },
    {
     "description": "BEACH ENERGY LTD-UNSP ADR",
     "symbol": "BCHEY"
    },
    {
     "description": "Birchcliff Energy Ltd New",
     "symbol": "BCHFP"
    },
    {
     "description": "GRAYSCALE BITCOIN CASH TRUST",
     "symbol": "BCHG"
    },
    {
     "description": "BUCHER INDUSTRIES AG-REG",
     "symbol": "BCHHF"
    },
    {
     "description": "BRAINCHIP HOLDING - SPON ADR",
     "symbol": "BCHPY"
    },
    {
     "description": "ABRDN BLOOMBERG ALL COMMODIT",
     "symbol": "BCI"
    },
    {
     "description": "BCII ENTERPRISES INC",
     "symbol": "BCII"
    },
    {
     "description": "ABRDN BLOOMBERG INDUSTRIAL M",
     "symbol": "BCIM"
    },
    {
     "description": "BANDO CHEMICAL INDUSTRIES",
     "symbol": "BCINF"
    },
    {
     "description": "BABCOCK INTL GROUP PLC",
     "symbol": "BCKIF"
    },
    {
     "description": "BABCOCK INTL GROUP-UNSP ADR",
     "symbol": "BCKIY"
    },
    {
     "description": "BECKER MILK CO LTD  -CL 'B'",
     "symbol": "BCKMF"
    },
    {
     "description": "BIO-CLEAN INTERNATIONAL INC",
     "symbol": "BCLE"
    },
    {
     "description": "BRAINSTORM CELL THERAPEUTICS",
     "symbol": "BCLI"
    },
    {
     "description": "BARCLAYS PLC",
     "symbol": "BCLYF"
    },
    {
     "description": "IPATH PURE BETA BROAD CMDTY",
     "symbol": "BCM"
    },
    {
     "description": "BCA MARKETPLACE PLC",
     "symbol": "BCMKF"
    },
    {
     "description": "BAYCOM CORP",
     "symbol": "BCML"
    },
    {
     "description": "BCM RESOURCES CORP",
     "symbol": "BCMRF"
    },
    {
     "description": "BANK OF COMMUN-UNSPON ADR",
     "symbol": "BCMXY"
    },
    {
     "description": "BARCO N.V.",
     "symbol": "BCNAF"
    },
    {
     "description": "BARCO NV-UNSPONSORED ADR",
     "symbol": "BCNAY"
    },
    {
     "description": "BEACON REDEVELOPMENT INDUSTR",
     "symbol": "BCND"
    },
    {
     "description": "BALINCAN USA INC",
     "symbol": "BCNN"
    },
    {
     "description": "BRINK'S CO\/THE",
     "symbol": "BCO"
    },
    {
     "description": "B COMMUNICATIONS LTD",
     "symbol": "BCOMF"
    },
    {
     "description": "BLUCORA INC",
     "symbol": "BCOR"
    },
    {
     "description": "BRIGHTCOVE",
     "symbol": "BCOV"
    },
    {
     "description": "1895 BANCORP OF WISCONSIN IN",
     "symbol": "BCOW"
    },
    {
     "description": "BALCHEM CORP",
     "symbol": "BCPC"
    },
    {
     "description": "BLUEONE CARD INC",
     "symbol": "BCRD"
    },
    {
     "description": "BLUE CAPITAL REINSURANCE HOL",
     "symbol": "BCRHF"
    },
    {
     "description": "BIOCRYST PHARMACEUTICALS INC",
     "symbol": "BCRX"
    },
    {
     "description": "BARCLAYS PLC-SPONS ADR",
     "symbol": "BCS"
    },
    {
     "description": "BLOCKCHAIN COINVESTORS -CL A",
     "symbol": "BCSA"
    },
    {
     "description": "BLOCKCHAIN COINVESTORS ACQUI",
     "symbol": "BCSAU"
    },
    {
     "description": "BLOCKCHAIN COINVESTORS ACQUI",
     "symbol": "BCSAW"
    },
    {
     "description": "BAIN CAPITAL SPECIALTY FINAN",
     "symbol": "BCSF"
    },
    {
     "description": "BANCORP SOUTHERN INDIANA",
     "symbol": "BCSO"
    },
    {
     "description": "BC TECHNOLOGY GROUP LTD",
     "symbol": "BCTCF"
    },
    {
     "description": "BANCORP 34 INC",
     "symbol": "BCTF"
    },
    {
     "description": "BRIACELL THERAPEUTICS CORP",
     "symbol": "BCTX"
    },
    {
     "description": "BRIACELL THERAPEUTICS -CW27",
     "symbol": "BCTXW"
    },
    {
     "description": "BRUNELLO CUCINELLI SPA",
     "symbol": "BCUCF"
    },
    {
     "description": "BRUNELLO CUCINELLI-UNSP ADR",
     "symbol": "BCUCY"
    },
    {
     "description": "BELL COPPER CORP",
     "symbol": "BCUFF"
    },
    {
     "description": "BANCROFT FUND LTD",
     "symbol": "BCV"
    },
    {
     "description": "BANCROFT FUND LTD",
     "symbol": "BCV.PRA"
    },
    {
     "description": "BOC AVIATION LTD",
     "symbol": "BCVVF"
    },
    {
     "description": "BCW GROUP HOLDING INC",
     "symbol": "BCWG"
    },
    {
     "description": "BLACKROCK RESOURCES & COMMOD",
     "symbol": "BCX"
    },
    {
     "description": "BICYCLE THERAPEUTICS PLC-ADR",
     "symbol": "BCYC"
    },
    {
     "description": "ISHARES CORE FTSE 100",
     "symbol": "BCYIF"
    },
    {
     "description": "BOULE DIAGNOSTICS INTERNATIO",
     "symbol": "BDABF"
    },
    {
     "description": "BELDEN INC",
     "symbol": "BDC"
    },
    {
     "description": "BROADCAST MARKETING GROUP IN",
     "symbol": "BDCM"
    },
    {
     "description": "BLUE DOLPHIN ENERGY CO",
     "symbol": "BDCO"
    },
    {
     "description": "ETRACS QRT 1.5 LEV BDC",
     "symbol": "BDCX"
    },
    {
     "description": "ETRACS MVIS BUSINESS DEVELOP",
     "symbol": "BDCZ"
    },
    {
     "description": "BID CORP LTD-SPONSORED ADR",
     "symbol": "BDDDY"
    },
    {
     "description": "DB BASE METALS DOUBLE LONG",
     "symbol": "BDDXF"
    },
    {
     "description": "INNOVATOR U.S. EQUITY BUFFER",
     "symbol": "BDEC"
    },
    {
     "description": "BLENDER FINANCE TECHNOLOGIES",
     "symbol": "BDFTF"
    },
    {
     "description": "BLACK DRAGON GOLD CORP-CDI",
     "symbol": "BDGCF"
    },
    {
     "description": "BLACK DRAGON RESOURCE COS IN",
     "symbol": "BDGR"
    },
    {
     "description": "BANK OF GEORGIA GROUP PLC",
     "symbol": "BDGSF"
    },
    {
     "description": "BERTRANDT AG",
     "symbol": "BDGXF"
    },
    {
     "description": "BRIDGEWAY NATIONAL CORP",
     "symbol": "BDGY"
    },
    {
     "description": "BLACK DIAMOND GROUP LTD",
     "symbol": "BDIMF"
    },
    {
     "description": "BIOLIDICS LTD",
     "symbol": "BDIXF"
    },
    {
     "description": "BLACKROCK ENHANCED EQTY DVD",
     "symbol": "BDJ"
    },
    {
     "description": "FLANIGAN'S ENTERPRISES INC",
     "symbol": "BDL"
    },
    {
     "description": "BURGUNDY DIAMOND MINES LTD",
     "symbol": "BDMMF"
    },
    {
     "description": "BUDIMEX",
     "symbol": "BDMXF"
    },
    {
     "description": "BRANDYWINE REALTY TRUST",
     "symbol": "BDN"
    },
    {
     "description": "BOLIDEN AB-UNSPN ADR",
     "symbol": "BDNNY"
    },
    {
     "description": "BANCO DO BRASIL SA-SPON ADR",
     "symbol": "BDORY"
    },
    {
     "description": "BDO UNIBANK INC",
     "symbol": "BDOUF"
    },
    {
     "description": "BDO UNIBANK INC-SPON ADR",
     "symbol": "BDOUY"
    },
    {
     "description": "BIOADAPTIVES INC",
     "symbol": "BDPT"
    },
    {
     "description": "BLONDER TONGUE LABORATORIES",
     "symbol": "BDR"
    },
    {
     "description": "BOMBARDIER INC-A",
     "symbol": "BDRAF"
    },
    {
     "description": "BOMBARDIER INC-B",
     "symbol": "BDRBF"
    },
    {
     "description": "BEIERSDORF AG",
     "symbol": "BDRFF"
    },
    {
     "description": "BEIERSDORF AG-UNSPON ADR",
     "symbol": "BDRFY"
    },
    {
     "description": "JAEGER RESOURCES CORP",
     "symbol": "BDRGF"
    },
    {
     "description": "BRDR A & O JOHANSEN AS-B",
     "symbol": "BDRJF"
    },
    {
     "description": "Bombardier Adj Pfd",
     "symbol": "BDRPF"
    },
    {
     "description": "BORDERS & SOUTHERN PETROLEUM",
     "symbol": "BDRSF"
    },
    {
     "description": "Bombardier Inc",
     "symbol": "BDRXF"
    },
    {
     "description": "BREAKWAVE DRY BULK SHIPPING",
     "symbol": "BDRY"
    },
    {
     "description": "BIODESIX INC",
     "symbol": "BDSX"
    },
    {
     "description": "BLACK DIAMOND THERAPEUTICS I",
     "symbol": "BDTX"
    },
    {
     "description": "BANGKOK DUSIT MED SERVICE-F",
     "symbol": "BDULF"
    },
    {
     "description": "BANGKOK DUSIT MED SERVI-NVDR",
     "symbol": "BDUUF"
    },
    {
     "description": "BANGKOK DUSIT MED -UNSP ADR",
     "symbol": "BDUUY"
    },
    {
     "description": "BAGGER DAVE'S BURGER TAVERN",
     "symbol": "BDVB"
    },
    {
     "description": "BUSINESS DEVELOPMENT CORP OF",
     "symbol": "BDVC"
    },
    {
     "description": "BIDVEST GROUP LTD",
     "symbol": "BDVSF"
    },
    {
     "description": "BIDVEST GROUP LTD-SPONS ADR",
     "symbol": "BDVSY"
    },
    {
     "description": "BUDWEISER BREWING CO APAC LT",
     "symbol": "BDWBF"
    },
    {
     "description": "BUDWEISER BREWING-UNSP ADR",
     "symbol": "BDWBY"
    },
    {
     "description": "BECTON DICKINSON AND CO",
     "symbol": "BDX"
    },
    {
     "description": "BECTON DICKINSON AND CO",
     "symbol": "BDXB"
    },
    {
     "description": "BODYSCAN CORP",
     "symbol": "BDYS"
    },
    {
     "description": "BLOOM ENERGY CORP- A",
     "symbol": "BE"
    },
    {
     "description": "BEAM THERAPEUTICS INC",
     "symbol": "BEAM"
    },
    {
     "description": "HEARTBEAM INC",
     "symbol": "BEAT"
    },
    {
     "description": "HEARTBEAM INC-CW26",
     "symbol": "BEATW"
    },
    {
     "description": "BEBE STORES INC",
     "symbol": "BEBE"
    },
    {
     "description": "ISHARES CORE EURO CORP BOND",
     "symbol": "BECBF"
    },
    {
     "description": "BCE Inc ",
     "symbol": "BECEF"
    },
    {
     "description": "BEACON ROOFING SUPPLY INC",
     "symbol": "BECN"
    },
    {
     "description": "BLACKROCK FUTURE CLIMATE AND",
     "symbol": "BECO"
    },
    {
     "description": "BECHTLE AG-UNSP ADR",
     "symbol": "BECTY"
    },
    {
     "description": "BEC WORLD PUBLIC CO LTD-ADR",
     "symbol": "BECVY"
    },
    {
     "description": "BRIGHT SCHOLAR EDUCATION-ADR",
     "symbol": "BEDU"
    },
    {
     "description": "ADVISORSHARES HOTEL ETF",
     "symbol": "BEDZ"
    },
    {
     "description": "BALD EAGLE ENERGY INC",
     "symbol": "BEEI"
    },
    {
     "description": "BEAM GLOBAL",
     "symbol": "BEEM"
    },
    {
     "description": "ENVISION SOLAR INTERNAT-CW24",
     "symbol": "BEEMW"
    },
    {
     "description": "BETTER ENVIRONMENT CONCEPTS",
     "symbol": "BEEN"
    },
    {
     "description": "BLACKSTAR ENTERPRISE GROUP I",
     "symbol": "BEGI"
    },
    {
     "description": "BIOCENTRIC ENERGY HOLDINGS I",
     "symbol": "BEHL"
    },
    {
     "description": "BEIGENE LTD",
     "symbol": "BEIGF"
    },
    {
     "description": "BEIJING NORTH STAR CO LTD-H",
     "symbol": "BEIJF"
    },
    {
     "description": "BEKAERT NV-UNSP ADR",
     "symbol": "BEKAY"
    },
    {
     "description": "KE HOLDINGS INC-ADR",
     "symbol": "BEKE"
    },
    {
     "description": "BEKAERT NV",
     "symbol": "BEKSF"
    },
    {
     "description": "BATERO GOLD CORP",
     "symbol": "BELDF"
    },
    {
     "description": "BEL FUSE INC-CL A",
     "symbol": "BELFA"
    },
    {
     "description": "BEL FUSE INC-CL B",
     "symbol": "BELFB"
    },
    {
     "description": "BELLEVUE GOLD LTD",
     "symbol": "BELGF"
    },
    {
     "description": "BELLE INTERNATIONAL HOLDINGS",
     "symbol": "BELLF"
    },
    {
     "description": "BELMONT RESOURCES INC",
     "symbol": "BELMF"
    },
    {
     "description": "BELL ROSE CAPITAL",
     "symbol": "BELR"
    },
    {
     "description": "FRANKLIN RESOURCES INC",
     "symbol": "BEN"
    },
    {
     "description": "BENS CREEK GROUP PLC",
     "symbol": "BENCF"
    },
    {
     "description": "BENESSERE CAPITAL ACQUI-CL A",
     "symbol": "BENE"
    },
    {
     "description": "BENESSERE CAPITAL ACQUI-RGT",
     "symbol": "BENER"
    },
    {
     "description": "BENESSERE CAPITAL ACQUISITIO",
     "symbol": "BENEU"
    },
    {
     "description": "BENESSERE CAPITAL ACQ -CW27",
     "symbol": "BENEW"
    },
    {
     "description": "BIO-EN HOLDINGS CORP",
     "symbol": "BENH"
    },
    {
     "description": "BENZ MINING CORP",
     "symbol": "BENZF"
    },
    {
     "description": "BEO BANCORP",
     "symbol": "BEOB"
    },
    {
     "description": "BROOKFIELD RENEWABLE PARTNER",
     "symbol": "BEP"
    },
    {
     "description": "BROOKFIELD RENEWABLE PAR",
     "symbol": "BEP.PRA"
    },
    {
     "description": "BROOKFIELD RENEWABLE COR-A",
     "symbol": "BEPC"
    },
    {
     "description": "BROOKFIELD BRP HOLDINGS",
     "symbol": "BEPH"
    },
    {
     "description": "BROOKFIELD BRP HOLDINGS",
     "symbol": "BEPI"
    },
    {
     "description": "BEACH ENERGY LTD",
     "symbol": "BEPTF"
    },
    {
     "description": "BLUE EARTH RESOURCES INC",
     "symbol": "BERI"
    },
    {
     "description": "BERKSHIRE BANCORP INC",
     "symbol": "BERK"
    },
    {
     "description": "BERRY GLOBAL GROUP INC",
     "symbol": "BERY"
    },
    {
     "description": "MICROSECTORS FANG & INN -3X",
     "symbol": "BERZ"
    },
    {
     "description": "BESRA GOLD INC",
     "symbol": "BESAF"
    },
    {
     "description": "BE SEMICONDUCTOR INDS-NY SHS",
     "symbol": "BESIY"
    },
    {
     "description": "BEST INC - ADR",
     "symbol": "BEST"
    },
    {
     "description": "BE SEMICONDUCTOR INDUSTRIES",
     "symbol": "BESVF"
    },
    {
     "description": "BETTERLIFE PHARMA INC",
     "symbol": "BETRF"
    },
    {
     "description": "BETTWORK INDUSTRIES INC",
     "symbol": "BETW"
    },
    {
     "description": "ROUNDHILL SPORTS BET & IGAM",
     "symbol": "BETZ"
    },
    {
     "description": "SCIENCE TO CONSUMERS INC",
     "symbol": "BEUT"
    },
    {
     "description": "DIVERSIFIED ROYALTY CORP",
     "symbol": "BEVFF"
    },
    {
     "description": "BEE VECTORING TECHNOLOGIES I",
     "symbol": "BEVVF"
    },
    {
     "description": "BEWHERE HOLDINGS INC",
     "symbol": "BEWFF"
    },
    {
     "description": "BROWN-FORMAN CORP-CLASS A",
     "symbol": "BF.A"
    },
    {
     "description": "BROWN-FORMAN CORP-CLASS B",
     "symbol": "BF.B"
    },
    {
     "description": "BATTERY FUTURE ACQUISITION-A",
     "symbol": "BFAC"
    },
    {
     "description": "BATTERY FUTURE ACQUISITION C",
     "symbol": "BFAC.U"
    },
    {
     "description": "BATTERY FUTURE ACQUIS A -23",
     "symbol": "BFAC.WS"
    },
    {
     "description": "BIOFRONTERA AG",
     "symbol": "BFAGY"
    },
    {
     "description": "BRIGHT HORIZONS FAMILY SOLUT",
     "symbol": "BFAM"
    },
    {
     "description": "BANK FIRST CORP",
     "symbol": "BFC"
    },
    {
     "description": "BANKFIRST CAPITAL CORP",
     "symbol": "BFCC"
    },
    {
     "description": "BITFRONTIER CAPITAL HOLDINGS",
     "symbol": "BFCH"
    },
    {
     "description": "BEDFORD ENERGY INC",
     "symbol": "BFDE"
    },
    {
     "description": "INNOVATOR U.S. EQUITY BUFFER",
     "symbol": "BFEB"
    },
    {
     "description": "BACHEM HOLDING AG-REG B",
     "symbol": "BFEHF"
    },
    {
     "description": "BASF SE",
     "symbol": "BFFAF"
    },
    {
     "description": "BIFFA PLC",
     "symbol": "BFFBF"
    },
    {
     "description": "BANGFU TECHNOLOGY GROUP CO L",
     "symbol": "BFGX"
    },
    {
     "description": "BREAD FINANCIAL HOLDINGS INC",
     "symbol": "BFH"
    },
    {
     "description": "BENEFICIAL HOLDINGS INC",
     "symbol": "BFHJ"
    },
    {
     "description": "BURGERFI INTERNATIONAL INC",
     "symbol": "BFI"
    },
    {
     "description": "BURGERFI INTERNATIONAL-CW23",
     "symbol": "BFIIW"
    },
    {
     "description": "BANKFINANCIAL CORP",
     "symbol": "BFIN"
    },
    {
     "description": "GLB X HEALTH & WELLNESS ETF",
     "symbol": "BFIT"
    },
    {
     "description": "BUILD BOND INNOVATION ETF",
     "symbol": "BFIX"
    },
    {
     "description": "BLACKROCK MUNICIPAL INC TRST",
     "symbol": "BFK"
    },
    {
     "description": "BILFINGER SE",
     "symbol": "BFLBF"
    },
    {
     "description": "BILFINGER SE  -UNSPON ADR",
     "symbol": "BFLBY"
    },
    {
     "description": "BROADCAST LIVE DIGITAL CORP",
     "symbol": "BFLD"
    },
    {
     "description": "BUTTERFLY NETWORK INC",
     "symbol": "BFLY"
    },
    {
     "description": "BUTTERFLY NETWORK INC -CW25",
     "symbol": "BFLY.WS"
    },
    {
     "description": "BIOFORCE NANOSCIENCES HOLDIN",
     "symbol": "BFNH"
    },
    {
     "description": "BARRON'S 400 ETF",
     "symbol": "BFOR"
    },
    {
     "description": "BIOFRONTERA INC",
     "symbol": "BFRI"
    },
    {
     "description": "BIOFRONTERA INC -CW26",
     "symbol": "BFRIW"
    },
    {
     "description": "SAUL CENTERS INC",
     "symbol": "BFS"
    },
    {
     "description": "SAUL CENTERS INC",
     "symbol": "BFS.PRD"
    },
    {
     "description": "SAUL CENTERS INC",
     "symbol": "BFS.PRE"
    },
    {
     "description": "BEFESA SA",
     "symbol": "BFSAF"
    },
    {
     "description": "BUSINESS FIRST BANCSHARES",
     "symbol": "BFST"
    },
    {
     "description": "BEFUT GLOBAL INC",
     "symbol": "BFTI"
    },
    {
     "description": "BLACKROCK FUTURE INNOVATORS",
     "symbol": "BFTR"
    },
    {
     "description": "BETTER FOR YOU WELLNESS INC",
     "symbol": "BFYW"
    },
    {
     "description": "BLACKROCK CALIFOR MUNI IN TR",
     "symbol": "BFZ"
    },
    {
     "description": "BUNGE LTD",
     "symbol": "BG"
    },
    {
     "description": "BIONEUTRA GLOBAL CORP",
     "symbol": "BGACF"
    },
    {
     "description": "BRIGADIER GOLD LTD",
     "symbol": "BGADF"
    },
    {
     "description": "BIOGAIA AB-B SHS",
     "symbol": "BGAIF"
    },
    {
     "description": "PROXIMUS",
     "symbol": "BGAOF"
    },
    {
     "description": "PROXIMUS-UNSPON ADR",
     "symbol": "BGAOY"
    },
    {
     "description": "BRAVADA GOLD CORP",
     "symbol": "BGAVF"
    },
    {
     "description": "BLACKSTONE STRATEGIC CREDIT",
     "symbol": "BGB"
    },
    {
     "description": "BEGA CHEESE LTD - UNSP ADR",
     "symbol": "BGCHY"
    },
    {
     "description": "BGC PARTNERS INC-CL A",
     "symbol": "BGCP"
    },
    {
     "description": "BLUE GEM ENTERPRISE",
     "symbol": "BGEM"
    },
    {
     "description": "BIO-BRIDGE SCIENCE INC",
     "symbol": "BGES"
    },
    {
     "description": "BEAUCE GOLD FIELDS INC",
     "symbol": "BGFGF"
    },
    {
     "description": "BIG 5 SPORTING GOODS CORP",
     "symbol": "BGFV"
    },
    {
     "description": "BILL IDENTITY LTD",
     "symbol": "BGGYF"
    },
    {
     "description": "BARINGS GL SH DUR HI YLD",
     "symbol": "BGH"
    },
    {
     "description": "BIRKS GROUP INC",
     "symbol": "BGI"
    },
    {
     "description": "BGI INC",
     "symbol": "BGII"
    },
    {
     "description": "BAILLIE GIFFORD JAPAN TRUST",
     "symbol": "BGJTF"
    },
    {
     "description": "BANGKOK BANK PUBLIC CO-NVDR",
     "symbol": "BGKKF"
    },
    {
     "description": "BIONEXUS GENE LAB CORP",
     "symbol": "BGLC"
    },
    {
     "description": "FT CBOE VEST GOLD STR QRT B",
     "symbol": "BGLD"
    },
    {
     "description": "BG MEDICINE INC",
     "symbol": "BGMD"
    },
    {
     "description": "BERGAMO ACQUISITION CORP",
     "symbol": "BGMO"
    },
    {
     "description": "BEIGENE LTD-ADR",
     "symbol": "BGNE"
    },
    {
     "description": "BLACKGOLD NATURAL RESOURCES",
     "symbol": "BGNRF"
    },
    {
     "description": "BIO-GENEX LABORATORIES INC",
     "symbol": "BGNX"
    },
    {
     "description": "BANGO PLC",
     "symbol": "BGOPF"
    },
    {
     "description": "BANG & OLUFSEN A\/S",
     "symbol": "BGOUF"
    },
    {
     "description": "BGP ACQUISITION CORP -CW27",
     "symbol": "BGPAF"
    },
    {
     "description": "BTS GROUP AB-B SHARES",
     "symbol": "BGPBF"
    },
    {
     "description": "BGP ACQUISITION CORP-A",
     "symbol": "BGPPF"
    },
    {
     "description": "BLACKROCK ENRGY & RES",
     "symbol": "BGR"
    },
    {
     "description": "TONY G CO-INVESTMENT HOLDING",
     "symbol": "BGRDF"
    },
    {
     "description": "ISHARES USD GREEN BOND ETF",
     "symbol": "BGRN"
    },
    {
     "description": "BLUESTEM GROUP INC",
     "symbol": "BGRP"
    },
    {
     "description": "BERKSHIRE GREY INC",
     "symbol": "BGRY"
    },
    {
     "description": "BERKSHIRE GREY         -CW26",
     "symbol": "BGRYW"
    },
    {
     "description": "B&G FOODS INC",
     "symbol": "BGS"
    },
    {
     "description": "BGSF INC",
     "symbol": "BGSF"
    },
    {
     "description": "BAILLIE GIFFORD SHIN NIPPON",
     "symbol": "BGSHF"
    },
    {
     "description": "BUILD ACQUISITION CORP-A",
     "symbol": "BGSX"
    },
    {
     "description": "BUILD ACQUISITION CORP",
     "symbol": "BGSX.U"
    },
    {
     "description": "BUILD ACQUIS CORP -A -CW26",
     "symbol": "BGSX.WS"
    },
    {
     "description": "BLACKROCK FLT RT INC",
     "symbol": "BGT"
    },
    {
     "description": "BIG TOKEN INC",
     "symbol": "BGTK"
    },
    {
     "description": "BILLY GOAT BRANDS LTD",
     "symbol": "BGTTF"
    },
    {
     "description": "BENGUET CORPORATION 'B' COM",
     "symbol": "BGUUF"
    },
    {
     "description": "BOUSSARD & GAVAUDAN HOLD",
     "symbol": "BGVDF"
    },
    {
     "description": "BLACKSTONE LONG-SHORT CREDIT",
     "symbol": "BGX"
    },
    {
     "description": "BLACKROCK ENHANCED INTERNATI",
     "symbol": "BGY"
    },
    {
     "description": "BIGLARI HOLDINGS INC-B",
     "symbol": "BH"
    },
    {
     "description": "BIGLARI HOLDINGS INC-A",
     "symbol": "BH.A"
    },
    {
     "description": "CRIXUS BH3 ACQUISITION CO-A",
     "symbol": "BHAC"
    },
    {
     "description": "CRIXUS BH3 ACQUISITION CO",
     "symbol": "BHACU"
    },
    {
     "description": "CRIXUS BH3 ACQUISITION -CW26",
     "symbol": "BHACW"
    },
    {
     "description": "BLUE HAT INTERACTIVE ENTERTA",
     "symbol": "BHAT"
    },
    {
     "description": "BAR HARBOR BANKSHARES",
     "symbol": "BHB"
    },
    {
     "description": "BEVERLY HILLS BANCORP INC",
     "symbol": "BHBCQ"
    },
    {
     "description": "BAUSCH HEALTH COS INC",
     "symbol": "BHC"
    },
    {
     "description": "BENCHMARK HOLDINGS PLC",
     "symbol": "BHCCF"
    },
    {
     "description": "BANK OF LABOR BANCSHARES INC",
     "symbol": "BHDB"
    },
    {
     "description": "BENCHMARK ELECTRONICS INC",
     "symbol": "BHE"
    },
    {
     "description": "BRIGHTHOUSE FINANCIAL INC",
     "symbol": "BHF"
    },
    {
     "description": "BRIGHTHOUSE FINANCIAL IN",
     "symbol": "BHFAL"
    },
    {
     "description": "BRIGHTHOUSE FINANCIAL IN",
     "symbol": "BHFAM"
    },
    {
     "description": "BRIGHTHOUSE FINANCIAL IN",
     "symbol": "BHFAN"
    },
    {
     "description": "BRIGHTHOUSE FINANCIAL IN",
     "symbol": "BHFAO"
    },
    {
     "description": "BRIGHTHOUSE FINANCIAL IN",
     "symbol": "BHFAP"
    },
    {
     "description": "BRIGHT HEALTH GROUP INC",
     "symbol": "BHG"
    },
    {
     "description": "BH GLOBAL CORP LTD",
     "symbol": "BHGCF"
    },
    {
     "description": "BHG GROUP AB",
     "symbol": "BHGSF"
    },
    {
     "description": "CRAFTPORT CANNABIS CORP",
     "symbol": "BHHKF"
    },
    {
     "description": "BOOHOO GROUP PLC",
     "symbol": "BHHOF"
    },
    {
     "description": "BENSON HILL INC",
     "symbol": "BHIL"
    },
    {
     "description": "BENSON HILL INC        -CW25",
     "symbol": "BHIL.WS"
    },
    {
     "description": "BLACKROCK CORE BOND TRUST",
     "symbol": "BHK"
    },
    {
     "description": "BOC HONG KONG HLDS-SPONS ADR",
     "symbol": "BHKLY"
    },
    {
     "description": "BERKSHIRE HILLS BANCORP INC",
     "symbol": "BHLB"
    },
    {
     "description": "BRADDA HEAD LITHIUM LTD",
     "symbol": "BHLIF"
    },
    {
     "description": "BUNKER HILL MINING CORP",
     "symbol": "BHLL"
    },
    {
     "description": "BH MACRO LTD",
     "symbol": "BHMCF"
    },
    {
     "description": "BASHNEFT PAO -PREF",
     "symbol": "BHNFF"
    },
    {
     "description": "BHANG INC-SUBORDINATE VTG SH",
     "symbol": "BHNGF"
    },
    {
     "description": "BOOHOO GROUP PLC - UNSP ADR",
     "symbol": "BHOOY"
    },
    {
     "description": "BHP GROUP LTD-SPON ADR",
     "symbol": "BHP"
    },
    {
     "description": "BHPA INC",
     "symbol": "BHPA"
    },
    {
     "description": "BHP GROUP LTD",
     "symbol": "BHPLF"
    },
    {
     "description": "BRAEMAR HOTELS & RESORTS INC",
     "symbol": "BHR"
    },
    {
     "description": "BRAEMAR HOTELS & RESORTS",
     "symbol": "BHR.PRB"
    },
    {
     "description": "BRAEMAR HOTELS & RESORTS",
     "symbol": "BHR.PRD"
    },
    {
     "description": "BURKE & HERBERT BK & TR\/VA",
     "symbol": "BHRB"
    },
    {
     "description": "BULL HORN HOLDINGS CORP",
     "symbol": "BHSE"
    },
    {
     "description": "BULL HORN HOLDINGS CORP",
     "symbol": "BHSEU"
    },
    {
     "description": "BULL HORN HOLDINGS CORP-CW25",
     "symbol": "BHSEW"
    },
    {
     "description": "BAYHORSE SILVER INC",
     "symbol": "BHSIF"
    },
    {
     "description": "BECHTLE AG",
     "symbol": "BHTLF"
    },
    {
     "description": "BLACKROCK VIRGINIA MUNI BOND",
     "symbol": "BHV"
    },
    {
     "description": "BIOHAVEN PHARMACEUTICAL HOLD",
     "symbol": "BHVN"
    },
    {
     "description": "BLACKHAWK BANCORP INC",
     "symbol": "BHWB"
    },
    {
     "description": "PROSHARES ULTRA NASD BIOTECH",
     "symbol": "BIB"
    },
    {
     "description": "INSPIRE 100 ESG ETF",
     "symbol": "BIBL"
    },
    {
     "description": "WATERLOO BREWING LTD",
     "symbol": "BIBLF"
    },
    {
     "description": "BIOCUBE INC",
     "symbol": "BICB"
    },
    {
     "description": "SOCIETE BIC SA",
     "symbol": "BICEF"
    },
    {
     "description": "BIC SA-UNSPONSORED ADR",
     "symbol": "BICEY"
    },
    {
     "description": "FIRST TRUST BICK INDEX FUND",
     "symbol": "BICK"
    },
    {
     "description": "BIOCURE TECHNOLOGY INC",
     "symbol": "BICTF"
    },
    {
     "description": "BIOCORRX INC",
     "symbol": "BICX"
    },
    {
     "description": "BLOCKCHAINK2 CORP",
     "symbol": "BIDCF"
    },
    {
     "description": "AMPLIFY DIGITAL & ONLINE TRA",
     "symbol": "BIDS"
    },
    {
     "description": "BAIDU INC - SPON ADR",
     "symbol": "BIDU"
    },
    {
     "description": "PREMIER BIOMEDICAL INC",
     "symbol": "BIEI"
    },
    {
     "description": "BIOELECTRONICS CORP",
     "symbol": "BIEL"
    },
    {
     "description": "BIOTEST AG-VORZUGSAKTIEN",
     "symbol": "BIESF"
    },
    {
     "description": "BIG LOTS INC",
     "symbol": "BIG"
    },
    {
     "description": "BIGCOMMERCE HOLDINGS-SER 1",
     "symbol": "BIGC"
    },
    {
     "description": "BIG TREE GROUP INC",
     "symbol": "BIGG"
    },
    {
     "description": "BIGEON",
     "symbol": "BIGN"
    },
    {
     "description": "DEFIANCE NEXT GEN BIG DATA",
     "symbol": "BIGY"
    },
    {
     "description": "BLACKROCK INNOV & GROW TR",
     "symbol": "BIGZ"
    },
    {
     "description": "BUHLER INDUSTRIES INC",
     "symbol": "BIIAF"
    },
    {
     "description": "BIOGEN INC",
     "symbol": "BIIB"
    },
    {
     "description": "BIONOVATE TECHNOLOGIES CORP",
     "symbol": "BIIO"
    },
    {
     "description": "SPDR BLOOMBERG 1-3 MONTH T-B",
     "symbol": "BIL"
    },
    {
     "description": "KINOVO PLC",
     "symbol": "BILBF"
    },
    {
     "description": "BILIBILI INC-SPONSORED ADR",
     "symbol": "BILI"
    },
    {
     "description": "BILL.COM HOLDINGS INC",
     "symbol": "BILL"
    },
    {
     "description": "SPDR BLOOMBERG 3-12 MONTH T-",
     "symbol": "BILS"
    },
    {
     "description": "BELLE ISLE CRP-NET PROFIT UT",
     "symbol": "BILSU"
    },
    {
     "description": "IGNITE INTERNATIONAL BRANDS",
     "symbol": "BILZF"
    },
    {
     "description": "BIMI INTERNATIONAL MEDICAL I",
     "symbol": "BIMI"
    },
    {
     "description": "BIONEUTRA INTERNATIONAL LTD",
     "symbol": "BIMO"
    },
    {
     "description": "BITMIS CORP",
     "symbol": "BIMT"
    },
    {
     "description": "BIONOID PHARMA INC",
     "symbol": "BINP"
    },
    {
     "description": "BIO-RAD LABORATORIES-A",
     "symbol": "BIO"
    },
    {
     "description": "BIO-RAD LABORATORIES -CL B",
     "symbol": "BIO.B"
    },
    {
     "description": "BIOASIS TECHNOLOGIES INC",
     "symbol": "BIOAF"
    },
    {
     "description": "BIOCEPT INC",
     "symbol": "BIOC"
    },
    {
     "description": "BLUE BIOFUELS INC",
     "symbol": "BIOF"
    },
    {
     "description": "BIOCARTIS GROUP NV",
     "symbol": "BIOGF"
    },
    {
     "description": "BIOGAIA AB-B -UNSP ADR",
     "symbol": "BIOGY"
    },
    {
     "description": "BIOME GROW INC",
     "symbol": "BIOIF"
    },
    {
     "description": "BIOLASE INC",
     "symbol": "BIOL"
    },
    {
     "description": "BIONITROGEN HOLDINGS CORP",
     "symbol": "BIONQ"
    },
    {
     "description": "BIOQUAL INC",
     "symbol": "BIOQ"
    },
    {
     "description": "BIOPLUS ACQUISITION CORP-A",
     "symbol": "BIOS"
    },
    {
     "description": "BIOPLUS ACQUISITION CORP",
     "symbol": "BIOSU"
    },
    {
     "description": "BIOPLUS ACQUISITION -CW23",
     "symbol": "BIOSW"
    },
    {
     "description": "BIOTECH ACQUISITION CO-CL A",
     "symbol": "BIOT"
    },
    {
     "description": "BIOTECH ACQUISITION CO",
     "symbol": "BIOTU"
    },
    {
     "description": "BIOTECH ACQUISITION A -CW27",
     "symbol": "BIOTW"
    },
    {
     "description": "SWEDISH ORPHAN BIOVITRUM AB",
     "symbol": "BIOVF"
    },
    {
     "description": "BIOCERES CROP SOLUTIONS CORP",
     "symbol": "BIOX"
    },
    {
     "description": "BIOSYENT INC",
     "symbol": "BIOYF"
    },
    {
     "description": "BROOKFIELD INFRASTRUCTURE PA",
     "symbol": "BIP"
    },
    {
     "description": "BROOKFIELD INFRASTRUCTUR",
     "symbol": "BIP.PRA"
    },
    {
     "description": "BROOKFIELD INFRASTRUCTUR",
     "symbol": "BIP.PRB"
    },
    {
     "description": "BROOKFIELD INFRASTRUCTURE-A",
     "symbol": "BIPC"
    },
    {
     "description": "BROOKFIELD INFRA FIN ULC",
     "symbol": "BIPH"
    },
    {
     "description": "BIP BERMUDA HOLDINGS I",
     "symbol": "BIPI"
    },
    {
     "description": "BIQI INTERNATIONAL HOLDINGS",
     "symbol": "BIQIF"
    },
    {
     "description": "ALLBIRDS INC-CL A",
     "symbol": "BIRD"
    },
    {
     "description": "BIRD CONSTRUCTION INC",
     "symbol": "BIRDF"
    },
    {
     "description": "BIRCHCLIFF ENERGY LTD",
     "symbol": "BIREF"
    },
    {
     "description": "BIOREM INC",
     "symbol": "BIRMF"
    },
    {
     "description": "BCI MINERALS LTD",
     "symbol": "BIRNF"
    },
    {
     "description": "PROSHARES ULTRASHORT NAS BIO",
     "symbol": "BIS"
    },
    {
     "description": "BALTIC INTERNATIONAL USA INC",
     "symbol": "BISA"
    },
    {
     "description": "BLACKROCK MULTI-SECTOR INCOM",
     "symbol": "BIT"
    },
    {
     "description": "FIRST BITCOIN CAPITAL CORP",
     "symbol": "BITCF"
    },
    {
     "description": "BITE ACQUISITION CORP",
     "symbol": "BITE"
    },
    {
     "description": "BITE ACQUISITION CORP",
     "symbol": "BITE.U"
    },
    {
     "description": "BITE ACQUISITION CORP -CW27",
     "symbol": "BITE.WS"
    },
    {
     "description": "BITFARMS LTD\/CANADA",
     "symbol": "BITF"
    },
    {
     "description": "BIOTAGE AB",
     "symbol": "BITGF"
    },
    {
     "description": "Bittium Corporation",
     "symbol": "BITMF"
    },
    {
     "description": "PROSHARES BITCOIN STRATEGY E",
     "symbol": "BITO"
    },
    {
     "description": "BITWISE CRYPTO IND INNOV ETF",
     "symbol": "BITQ"
    },
    {
     "description": "BIOTRON LTD",
     "symbol": "BITRF"
    },
    {
     "description": "GLOBAL X BLOCK & BIT STRAT",
     "symbol": "BITS"
    },
    {
     "description": "BITTERROOT RESOURCES LTD",
     "symbol": "BITTF"
    },
    {
     "description": "BITWISE 10 CRYPTO INDEX FUND",
     "symbol": "BITW"
    },
    {
     "description": "VANGUARD INTERMEDIATE-TERM B",
     "symbol": "BIV"
    },
    {
     "description": "BIOVIE INC",
     "symbol": "BIVI"
    },
    {
     "description": "BIO VIEW LTD",
     "symbol": "BIVWF"
    },
    {
     "description": "BIOXYTRAN INC",
     "symbol": "BIXT"
    },
    {
     "description": "VANECK BDC INCOME ETF",
     "symbol": "BIZD"
    },
    {
     "description": "BIZLINK HOLDING INC",
     "symbol": "BIZLF"
    },
    {
     "description": "BJ'S WHOLESALE CLUB HOLDINGS",
     "symbol": "BJ"
    },
    {
     "description": "INNOVATOR U.S. EQUITY BUFFER",
     "symbol": "BJAN"
    },
    {
     "description": "BEIJING CAPITAL INTL AIRPO-H",
     "symbol": "BJCHF"
    },
    {
     "description": "BEIJING CAPITAL-UNSPON ADR",
     "symbol": "BJCHY"
    },
    {
     "description": "BEIJING CAPITAL LAND LTD-H",
     "symbol": "BJCLF"
    },
    {
     "description": "BLUEJAY DIAGNOSTICS INC",
     "symbol": "BJDX"
    },
    {
     "description": "BEIJING ENTERPRISES CLEAN EN",
     "symbol": "BJECF"
    },
    {
     "description": "BEIJING GAS BLUE SKY HOLDING",
     "symbol": "BJGBF"
    },
    {
     "description": "BEIJING ENTERPRISES ENVIRONM",
     "symbol": "BJGDF"
    },
    {
     "description": "BEIJING ENTERPRISES HLDGS",
     "symbol": "BJINF"
    },
    {
     "description": "VANECK GAMING ETF",
     "symbol": "BJK"
    },
    {
     "description": "BERLI JUCKER PUB CO-FORGN",
     "symbol": "BJPUF"
    },
    {
     "description": "BJ'S RESTAURANTS INC",
     "symbol": "BJRI"
    },
    {
     "description": "SPORTS TOTO BHD",
     "symbol": "BJSAF"
    },
    {
     "description": "BEIJING TONG REN TANG CHINES",
     "symbol": "BJTRF"
    },
    {
     "description": "INNOVATOR U.S. EQUITY BUFFER",
     "symbol": "BJUL"
    },
    {
     "description": "INNOVATOR U.S. EQUITY BUFFER",
     "symbol": "BJUN"
    },
    {
     "description": "BONJOUR HOLDINGS LTD",
     "symbol": "BJURF"
    },
    {
     "description": "BEIJING ENTERPRISES WATER GR",
     "symbol": "BJWTF"
    },
    {
     "description": "BEIJING ENTERPRISES-UNSP ADR",
     "symbol": "BJWTY"
    },
    {
     "description": "BANK OF NEW YORK MELLON CORP",
     "symbol": "BK"
    },
    {
     "description": "Brookfield Office Properties Inc",
     "symbol": "BKAAF"
    },
    {
     "description": "BNY MELLON CORE BOND ETF",
     "symbol": "BKAG"
    },
    {
     "description": "BANK OF AYUDHYA PUBLIC-NVDR",
     "symbol": "BKAHF"
    },
    {
     "description": "BANK ALADIN SYARIAH TBK PT",
     "symbol": "BKALF"
    },
    {
     "description": "Brookfield Asset Management Inc",
     "symbol": "BKAMF"
    },
    {
     "description": "BANK OF AYUDHYA PCL-UNS ADR",
     "symbol": "BKAYY"
    },
    {
     "description": "PIPESTONE ENERGY CORP",
     "symbol": "BKBEF"
    },
    {
     "description": "MAGNETIC NORTH ACQUISITION C",
     "symbol": "BKBLF"
    },
    {
     "description": "BERKAH BETON - UNSP ADR",
     "symbol": "BKBSY"
    },
    {
     "description": "BLACKROCK CAPITAL INVESTMENT",
     "symbol": "BKCC"
    },
    {
     "description": "GLOBAL X BLOCKCHAIN ETF",
     "symbol": "BKCH"
    },
    {
     "description": "BNY MELLON CONCENTRATED INTL",
     "symbol": "BKCI"
    },
    {
     "description": "BLOCKCHAIN CAPITAL TOKENHUB",
     "symbol": "BKCPF"
    },
    {
     "description": "BANK OF CYPRUS HOLDINGS PLC",
     "symbol": "BKCYF"
    },
    {
     "description": "BROOKDALE SENIOR LIVING INC",
     "symbol": "BKD"
    },
    {
     "description": "BUCKLE INC\/THE",
     "symbol": "BKE"
    },
    {
     "description": "BANK OF EAST ASIA LTD",
     "symbol": "BKEAF"
    },
    {
     "description": "BANK EAST ASIA LTD-SPONS ADR",
     "symbol": "BKEAY"
    },
    {
     "description": "BNY MELLON EMERGING MARKETS",
     "symbol": "BKEM"
    },
    {
     "description": "BAKKEN ENERGY CORP",
     "symbol": "BKEN"
    },
    {
     "description": "BLUEKNIGHT ENERGY PARTNERS L",
     "symbol": "BKEP"
    },
    {
     "description": "BLUEKNIGHT ENERGY PARTNE",
     "symbol": "BKEPP"
    },
    {
     "description": "BNY MELLON GLOBAL EMERG MARK",
     "symbol": "BKES"
    },
    {
     "description": "BANCO ESPIRITO SANTO-REG",
     "symbol": "BKESF"
    },
    {
     "description": "BANCO ESPIRITO SANT-UNSP ADR",
     "symbol": "BKESY"
    },
    {
     "description": "BIKE24 HOLDING AG",
     "symbol": "BKETF"
    },
    {
     "description": "ISHARES MSCI BIC ETF",
     "symbol": "BKF"
    },
    {
     "description": "Brookfield Asset Management Inc",
     "symbol": "BKFAF"
    },
    {
     "description": "BANK OF COMMUNICATIONS CO-H",
     "symbol": "BKFCF"
    },
    {
     "description": "BKF CAPITAL GROUP INC",
     "symbol": "BKFG"
    },
    {
     "description": "BAKKAFROST P\/F",
     "symbol": "BKFKF"
    },
    {
     "description": "BAKKAFROST P\/F-ADR UNSPONSOR",
     "symbol": "BKFKY"
    },
    {
     "description": "Brookfield Asset Management Inc",
     "symbol": "BKFPF"
    },
    {
     "description": "BERKELEY GROUP HOLDINGS\/THE",
     "symbol": "BKGFF"
    },
    {
     "description": "BERKELEY GROUP-UNSPON ADR",
     "symbol": "BKGFY"
    },
    {
     "description": "BOOKTOPIA GROUP LTD",
     "symbol": "BKGGF"
    },
    {
     "description": "BANKGUAM HOLDING CO",
     "symbol": "BKGM"
    },
    {
     "description": "BLACK HILLS CORP",
     "symbol": "BKH"
    },
    {
     "description": "BANK HAPOALIM BM",
     "symbol": "BKHPF"
    },
    {
     "description": "BNY MELLON HIGH YIELD BETA E",
     "symbol": "BKHY"
    },
    {
     "description": "BANK HAPOALIM LTD-ADR",
     "symbol": "BKHYY"
    },
    {
     "description": "BLACK KNIGHT INC",
     "symbol": "BKI"
    },
    {
     "description": "BNY MELLON INTERNATIONAL EQU",
     "symbol": "BKIE"
    },
    {
     "description": "BANKINTER SA",
     "symbol": "BKIMF"
    },
    {
     "description": "BLACK IRON INC",
     "symbol": "BKIRF"
    },
    {
     "description": "BNY MELLON SUST INT EQUITY",
     "symbol": "BKIS"
    },
    {
     "description": "ISHARES US MBS USD DIST",
     "symbol": "BKISF"
    },
    {
     "description": "BLOCKCHAIN TECHNOLOGIES ETF",
     "symbol": "BKKCF"
    },
    {
     "description": "BANGKOK BANK PCL-UNSPON ADR",
     "symbol": "BKKLY"
    },
    {
     "description": "BANGKOK BANK PCL-FOREIGN REG",
     "symbol": "BKKPF"
    },
    {
     "description": "BAKKT HOLDINGS INC",
     "symbol": "BKKT"
    },
    {
     "description": "BAKKT HOLDINGS INC -CW26",
     "symbol": "BKKT.WS"
    },
    {
     "description": "BAKKAVOR GROUP PLC",
     "symbol": "BKKVF"
    },
    {
     "description": "BANGKOK EXPRESSWAY AND M-FOR",
     "symbol": "BKKXF"
    },
    {
     "description": "BNY MELLON US LARGE CAP CORE",
     "symbol": "BKLC"
    },
    {
     "description": "BLOCKMINT TECHNOLOGIES INC",
     "symbol": "BKLIF"
    },
    {
     "description": "CYPHER METAVERSE INC",
     "symbol": "BKLLF"
    },
    {
     "description": "INVESCO SENIOR LOAN ETF",
     "symbol": "BKLN"
    },
    {
     "description": "BUKALAPAK.COM PT TBK",
     "symbol": "BKLPF"
    },
    {
     "description": "BERKELEY ENERGIA LTD",
     "symbol": "BKLRF"
    },
    {
     "description": "BNY MELLON US MID CAP CORE E",
     "symbol": "BKMC"
    },
    {
     "description": "BEKEM METALS INC",
     "symbol": "BKMM"
    },
    {
     "description": "BARKER MINERALS LTD",
     "symbol": "BKMNF"
    },
    {
     "description": "BLACKOUT MEDIA CORP",
     "symbol": "BKMP"
    },
    {
     "description": "BLACKROCK INVT QUALITY MUNI",
     "symbol": "BKN"
    },
    {
     "description": "BOOKING HOLDINGS INC",
     "symbol": "BKNG"
    },
    {
     "description": "BANKINTER SA-SPONS ADR",
     "symbol": "BKNIY"
    },
    {
     "description": "Brookfield Office Properties Inc",
     "symbol": "BKOFF"
    },
    {
     "description": "OAK RIDGE FINANCIAL SERVICES",
     "symbol": "BKOR"
    },
    {
     "description": "BANK PEKAO SA",
     "symbol": "BKPKF"
    },
    {
     "description": "BANK OF QUEENSLAND LTD",
     "symbol": "BKQNF"
    },
    {
     "description": "BANK OF QUEENSLAND-UNSP ADR",
     "symbol": "BKQNY"
    },
    {
     "description": "BAKER HUGHES CO",
     "symbol": "BKR"
    },
    {
     "description": "BANK OF IRELAND GROUP PLC",
     "symbol": "BKRIF"
    },
    {
     "description": "BANK OF IRELAND-UNSP ADR",
     "symbol": "BKRIY"
    },
    {
     "description": "BANK RAKYAT INDONESIA PERSER",
     "symbol": "BKRKF"
    },
    {
     "description": "BANK RAKYAT INDONESIA-UN ADR",
     "symbol": "BKRKY"
    },
    {
     "description": "BLACK ROCK PETROLEUM CO",
     "symbol": "BKRP"
    },
    {
     "description": "BLACKROCK SILVER CORP",
     "symbol": "BKRRF"
    },
    {
     "description": "BNY MELLON SHORT DURATION CO",
     "symbol": "BKSB"
    },
    {
     "description": "BANK OF SOUTH CAROLINA CORP",
     "symbol": "BKSC"
    },
    {
     "description": "BLUEPRINT TECHNOLOGIES INC",
     "symbol": "BKSD"
    },
    {
     "description": "BNY MELLON US SMALL CAP CORE",
     "symbol": "BKSE"
    },
    {
     "description": "BANK OF SAGA LTD\/THE",
     "symbol": "BKSGF"
    },
    {
     "description": "BERKSHIRE HOMES INC",
     "symbol": "BKSH"
    },
    {
     "description": "BANKS ISLAND GOLD LTD",
     "symbol": "BKSLF"
    },
    {
     "description": "BLACKSKY TECHNOLOGY INC",
     "symbol": "BKSY"
    },
    {
     "description": "BLACKSKY TECHNOLOGY -CW24",
     "symbol": "BKSY.WS"
    },
    {
     "description": "BLACKROCK INCOME TRUST",
     "symbol": "BKT"
    },
    {
     "description": "BK TECHNOLOGIES CORP",
     "symbol": "BKTI"
    },
    {
     "description": "CRUZ BATTERY METALS CORP",
     "symbol": "BKTPF"
    },
    {
     "description": "BLACK ROCK MINING LTD",
     "symbol": "BKTRF"
    },
    {
     "description": "BANKUNITED INC",
     "symbol": "BKU"
    },
    {
     "description": "BLUE SKY URANIUM CORP",
     "symbol": "BKUCF"
    },
    {
     "description": "BAKHU HOLDINGS CORP",
     "symbol": "BKUH"
    },
    {
     "description": "BNY MELLON ULTRA SHORT INCOM",
     "symbol": "BKUI"
    },
    {
     "description": "BNY MELLON SUSTAIN US EQUITY",
     "symbol": "BKUS"
    },
    {
     "description": "BANK UTICA\/NY",
     "symbol": "BKUT"
    },
    {
     "description": "BANK UTICA N Y",
     "symbol": "BKUTK"
    },
    {
     "description": "BIO-KEY INTERNATIONAL INC",
     "symbol": "BKYI"
    },
    {
     "description": "SANTANDER BANK POLSKA SA",
     "symbol": "BKZHF"
    },
    {
     "description": "SANTANDER BANK POL-UNSP ADR",
     "symbol": "BKZHY"
    },
    {
     "description": "BLACKLINE INC",
     "symbol": "BL"
    },
    {
     "description": "BIO LAB NATURALS INC",
     "symbol": "BLAB"
    },
    {
     "description": "BLUE LAGOON RESOURCES INC",
     "symbol": "BLAGF"
    },
    {
     "description": "BLUE BIRD CORP",
     "symbol": "BLBD"
    },
    {
     "description": "BILIBILI INC-CLASS Z",
     "symbol": "BLBLF"
    },
    {
     "description": "BLOOMBERRY RESORTS CORP",
     "symbol": "BLBRF"
    },
    {
     "description": "BLACKBOXSTOCKS INC",
     "symbol": "BLBX"
    },
    {
     "description": "BELLICUM PHARMACEUTICALS INC",
     "symbol": "BLCM"
    },
    {
     "description": "SIREN NEXGEN ECONOMY ETF",
     "symbol": "BLCN"
    },
    {
     "description": "BLUECHIIP LTD",
     "symbol": "BLCPF"
    },
    {
     "description": "BLUECITY HOLDINGS LTD-ADR",
     "symbol": "BLCT"
    },
    {
     "description": "TOPBUILD CORP",
     "symbol": "BLD"
    },
    {
     "description": "BLADE AIR MOBILITY INC",
     "symbol": "BLDE"
    },
    {
     "description": "BLADE AIR MOBILITY INC-CW26",
     "symbol": "BLDEW"
    },
    {
     "description": "CAMBRIA GLOBAL REAL ESTATE",
     "symbol": "BLDG"
    },
    {
     "description": "BALLARD POWER SYSTEMS INC",
     "symbol": "BLDP"
    },
    {
     "description": "BUILDERS FIRSTSOURCE INC",
     "symbol": "BLDR"
    },
    {
     "description": "BLUE DIAMOND VENTURES INC",
     "symbol": "BLDV"
    },
    {
     "description": "BLACKROCK MUN INC TRUST II",
     "symbol": "BLE"
    },
    {
     "description": "BRANDED LEGACY INC",
     "symbol": "BLEG"
    },
    {
     "description": "INSPIRE GLOBAL HOPE ESG ETF",
     "symbol": "BLES"
    },
    {
     "description": "BLUEACACIA LTD - CLASS A",
     "symbol": "BLEU"
    },
    {
     "description": "BLUEACACIA LTD - RIGHTS",
     "symbol": "BLEUR"
    },
    {
     "description": "BLEUACACIA LTD",
     "symbol": "BLEUU"
    },
    {
     "description": "BLUEACACIA LTD CL A -CW23",
     "symbol": "BLEUW"
    },
    {
     "description": "BELEAVE INC",
     "symbol": "BLEVF"
    },
    {
     "description": "BLOCKCHAIN FOUNDRY INC",
     "symbol": "BLFDF"
    },
    {
     "description": "BIOLIFE SCIENCES INC",
     "symbol": "BLFE"
    },
    {
     "description": "BLUEFIRE EQUIPMENT CORP",
     "symbol": "BLFR"
    },
    {
     "description": "BIOLIFE SOLUTIONS INC",
     "symbol": "BLFS"
    },
    {
     "description": "BLUE FOUNDRY BANCORP",
     "symbol": "BLFY"
    },
    {
     "description": "BULIGO CAPITAL LTD",
     "symbol": "BLGCF"
    },
    {
     "description": "BAILLIE GIFFORD US GROWTH TR",
     "symbol": "BLGFF"
    },
    {
     "description": "BLGI INC",
     "symbol": "BLGI"
    },
    {
     "description": "BIOLARGO INC",
     "symbol": "BLGO"
    },
    {
     "description": "BELGRAVIA HARTFORD CAPITAL I",
     "symbol": "BLGVF"
    },
    {
     "description": "BALOISE HOLDING AG - REG",
     "symbol": "BLHEF"
    },
    {
     "description": "BALOISE HOLDING AG-UNSPN ADR",
     "symbol": "BLHEY"
    },
    {
     "description": "BLUE HOLDINGS INC",
     "symbol": "BLHI"
    },
    {
     "description": "BLUEHARBOR BANK",
     "symbol": "BLHK"
    },
    {
     "description": "BELIMO HOLDING AG-REG",
     "symbol": "BLHWF"
    },
    {
     "description": "VIRTUS NEWFLEET HIGH YIELD B",
     "symbol": "BLHY"
    },
    {
     "description": "BERKELEY LIGHTS INC",
     "symbol": "BLI"
    },
    {
     "description": "BB LIQUIDATING INC",
     "symbol": "BLIAQ"
    },
    {
     "description": "BB LIQUIDATING INC-CL B",
     "symbol": "BLIBQ"
    },
    {
     "description": "BEARING LITHIUM CORP",
     "symbol": "BLILF"
    },
    {
     "description": "BRIDGELINE DIGITAL INC",
     "symbol": "BLIN"
    },
    {
     "description": "BELISS CORP",
     "symbol": "BLIS"
    },
    {
     "description": "I3 INTERACTIVE INC",
     "symbol": "BLITF"
    },
    {
     "description": "BERLI JUCKER PUBLIC CO-ADR",
     "symbol": "BLJZY"
    },
    {
     "description": "BLACKROCK INC",
     "symbol": "BLK"
    },
    {
     "description": "BLACKBAUD INC",
     "symbol": "BLKB"
    },
    {
     "description": "INVESCO ALERIAN GALAXY BLOCK",
     "symbol": "BLKC"
    },
    {
     "description": "GLOBAL GAMING TECHNOLOGIES C",
     "symbol": "BLKCF"
    },
    {
     "description": "BUILD KING HOLDINGS LTD",
     "symbol": "BLKHF"
    },
    {
     "description": "ISHR HEALTHCARE INNOVATION",
     "symbol": "BLKIF"
    },
    {
     "description": "BLACKLINE SAFETY CORP",
     "symbol": "BLKLF"
    },
    {
     "description": "ISHARES MSCI USA ESG SCREEND",
     "symbol": "BLKXF"
    },
    {
     "description": "BALL CORP",
     "symbol": "BLL"
    },
    {
     "description": "BELL BUCKLE HOLDINGS INC",
     "symbol": "BLLB"
    },
    {
     "description": "BELL INDUSTRIES INC",
     "symbol": "BLLI"
    },
    {
     "description": "BELL EQUIPMENT LTD",
     "symbol": "BLLQF"
    },
    {
     "description": "BIOLIGHT LIFE SCIENCES LTD",
     "symbol": "BLLSF"
    },
    {
     "description": "BLUEJAY MINING PLC",
     "symbol": "BLLYF"
    },
    {
     "description": "BILOXI MARSH LANDS CORP",
     "symbol": "BLMC"
    },
    {
     "description": "BLOOM HEALTH PARTNERS INC",
     "symbol": "BLMHF"
    },
    {
     "description": "BANK LEUMI LE-ISRAEL",
     "symbol": "BLMIF"
    },
    {
     "description": "BLACKMORES LTD",
     "symbol": "BLMMF"
    },
    {
     "description": "BLOOMIN' BRANDS INC",
     "symbol": "BLMN"
    },
    {
     "description": "BLOOMIOS INC",
     "symbol": "BLMS"
    },
    {
     "description": "BALMUDA INC",
     "symbol": "BLMUF"
    },
    {
     "description": "BALANCE LABS INC",
     "symbol": "BLNC"
    },
    {
     "description": "BLEND LABS INC-A",
     "symbol": "BLND"
    },
    {
     "description": "BELONG ACQUISITION CORP-A",
     "symbol": "BLNG"
    },
    {
     "description": "BELONG ACQUISITION CORP",
     "symbol": "BLNGU"
    },
    {
     "description": "BELONG ACQUISITION A -CW27",
     "symbol": "BLNGW"
    },
    {
     "description": "BLINK CHARGING CO",
     "symbol": "BLNK"
    },
    {
     "description": "BLINK CHARGING CO - CW23",
     "symbol": "BLNKW"
    },
    {
     "description": "BLUE NOTE MINING INC",
     "symbol": "BLNMF"
    },
    {
     "description": "AMPLIFY TRANSFOR DATA SHARIN",
     "symbol": "BLOK"
    },
    {
     "description": "CO2 GRO INC",
     "symbol": "BLONF"
    },
    {
     "description": "CANNABIX TECHNOLOGIES INC",
     "symbol": "BLOZF"
    },
    {
     "description": "BLOK TECHNOLOGIES INC",
     "symbol": "BLPFF"
    },
    {
     "description": "BLUE LINE PROTECTION GROUP I",
     "symbol": "BLPG"
    },
    {
     "description": "BELLEROPHON THERAPEUTICS INC",
     "symbol": "BLPH"
    },
    {
     "description": "BLOCKQUARRY CORP",
     "symbol": "BLQC"
    },
    {
     "description": "BILLERUDKORSNAS AB",
     "symbol": "BLRDF"
    },
    {
     "description": "BILLERUDKORSNAS A-UNSPON ADR",
     "symbol": "BLRDY"
    },
    {
     "description": "BLADERANGER LTD",
     "symbol": "BLRNF"
    },
    {
     "description": "BIOLINERX LTD-SPONS ADR",
     "symbol": "BLRX"
    },
    {
     "description": "BLACKHAWK GROWTH CORP",
     "symbol": "BLRZF"
    },
    {
     "description": "BCLS ACQUISITION CORP- CL A",
     "symbol": "BLSA"
    },
    {
     "description": "BLUESCOPE STEEL LTD",
     "symbol": "BLSFF"
    },
    {
     "description": "BLUESCOPE STEEL LTD-UNSP ADR",
     "symbol": "BLSFY"
    },
    {
     "description": "BLUE SPHERE CORP",
     "symbol": "BLSP"
    },
    {
     "description": "BLACKSTONE MINERALS LTD",
     "symbol": "BLSTF"
    },
    {
     "description": "BELLSYSTEM24 HOLDINGS INC",
     "symbol": "BLSYF"
    },
    {
     "description": "BLUE THUNDER MINING INC",
     "symbol": "BLTMF"
    },
    {
     "description": "BRIGHT LIGHTS ACQUISITI-CL A",
     "symbol": "BLTS"
    },
    {
     "description": "BRIGHT LIGHTS ACQUISITION C",
     "symbol": "BLTSU"
    },
    {
     "description": "BRIGHT LIGHTS ACQ CL A -CW27",
     "symbol": "BLTSW"
    },
    {
     "description": "BELLUS HEALTH INC",
     "symbol": "BLU"
    },
    {
     "description": "BLUERIVER ACQUISITION CORP-A",
     "symbol": "BLUA"
    },
    {
     "description": "BLUERIVER ACQUISITION CORP",
     "symbol": "BLUA.U"
    },
    {
     "description": "BLUERIVER ACQUISIT A -CW26",
     "symbol": "BLUA.WS"
    },
    {
     "description": "BLUE RIBBON INCOME FUND",
     "symbol": "BLUBF"
    },
    {
     "description": "BLUEBIRD BIO INC",
     "symbol": "BLUE"
    },
    {
     "description": "BLUE MOON GROUP HOL-UNSP ADR",
     "symbol": "BLUMY"
    },
    {
     "description": "BLUE WATER GLOBAL GROUP INC",
     "symbol": "BLUU"
    },
    {
     "description": "VANGUARD LONG-TERM BOND ETF",
     "symbol": "BLV"
    },
    {
     "description": "GLOBALBLOCK DIGITAL ASSET TR",
     "symbol": "BLVDF"
    },
    {
     "description": "BLACKROCK LTD DURATION INC",
     "symbol": "BLW"
    },
    {
     "description": "BELLWAY PLC",
     "symbol": "BLWYF"
    },
    {
     "description": "BELLWAY PLC-UNSPONSORED ADR",
     "symbol": "BLWYY"
    },
    {
     "description": "BANCO LATINOAMERICANO COME-E",
     "symbol": "BLX"
    },
    {
     "description": "BLOX INC",
     "symbol": "BLXX"
    },
    {
     "description": "BOART LONGYEAR GROUP LTD-CDI",
     "symbol": "BLYFF"
    },
    {
     "description": "BALLY CORP",
     "symbol": "BLYQ"
    },
    {
     "description": "BOART LONGYEAR LTD-CW24",
     "symbol": "BLYYF"
    },
    {
     "description": "BACKBLAZE INC-A",
     "symbol": "BLZE"
    },
    {
     "description": "BSD CROWN LTD",
     "symbol": "BLZSF"
    },
    {
     "description": "BANCO MACRO SA-ADR",
     "symbol": "BMA"
    },
    {
     "description": "BLACK MOUNTAIN ACQUISITION-A",
     "symbol": "BMAC"
    },
    {
     "description": "BLACK MOUNTAIN ACQ CORP",
     "symbol": "BMAC.U"
    },
    {
     "description": "BLACK MOUNTAIN ACQ -CW27",
     "symbol": "BMAC.WS"
    },
    {
     "description": "BLOCKCHAIN MOON ACQUISITION",
     "symbol": "BMAQ"
    },
    {
     "description": "BLOCKCHAIN MOON ACQ-RTS",
     "symbol": "BMAQR"
    },
    {
     "description": "BLOCKCHAIN MOON ACQUISITION",
     "symbol": "BMAQU"
    },
    {
     "description": "BLOCKCHAIN MOON ACQ -CW23",
     "symbol": "BMAQW"
    },
    {
     "description": "INNOVATOR U.S. EQUITY BUFFER",
     "symbol": "BMAR"
    },
    {
     "description": "INNOVATOR U.S. EQUITY BUFFER",
     "symbol": "BMAY"
    },
    {
     "description": "BUMBLE INC-A",
     "symbol": "BMBL"
    },
    {
     "description": "BRAMBLES LTD",
     "symbol": "BMBLF"
    },
    {
     "description": "BENCHMARK BANKSHARES INC",
     "symbol": "BMBN"
    },
    {
     "description": "GRUPO BIMBO SAB A - SPON ADR",
     "symbol": "BMBOY"
    },
    {
     "description": "BIM BIRLESIK MAGAZALAR AS",
     "symbol": "BMBRF"
    },
    {
     "description": "BLOM BANK SAL-REG S GDR",
     "symbol": "BMBZF"
    },
    {
     "description": "BMO SHORT CORPORATE BOND IND",
     "symbol": "BMCBF"
    },
    {
     "description": "BAIC MOTOR CORP LTD-H",
     "symbol": "BMCLF"
    },
    {
     "description": "BIOTECH MEDICS INC",
     "symbol": "BMCS"
    },
    {
     "description": "BMO COVERED CALL CANADIAN BA",
     "symbol": "BMDLF"
    },
    {
     "description": "BANCA MONTE DEI PASCHI SIENA",
     "symbol": "BMDPF"
    },
    {
     "description": "BLACKROCK HEALTH SCIENCES",
     "symbol": "BME"
    },
    {
     "description": "BIOMEA FUSION INC",
     "symbol": "BMEA"
    },
    {
     "description": "BLACKROCK FUTURE HEALTH ETF",
     "symbol": "BMED"
    },
    {
     "description": "BANCO SANTANDER MEXICO SA IN",
     "symbol": "BMEXF"
    },
    {
     "description": "BLACKROCK HEALTH SCI TR II",
     "symbol": "BMEZ"
    },
    {
     "description": "BLACK MOUNTAIN GOLD USA CORP",
     "symbol": "BMGCF"
    },
    {
     "description": "BIOMAGNETICS DIAGNOSTICS COR",
     "symbol": "BMGP"
    },
    {
     "description": "BADGER METER INC",
     "symbol": "BMI"
    },
    {
     "description": "BRAZIL MINERALS INC",
     "symbol": "BMIX"
    },
    {
     "description": "BEACON MINERALS LTD",
     "symbol": "BMIXF"
    },
    {
     "description": "BMO JUNIOR GOLD INDEX ETF",
     "symbol": "BMJJF"
    },
    {
     "description": "BIOMARK DIAGNOSTICS INC",
     "symbol": "BMKDF"
    },
    {
     "description": "BANK OF AMERICA CORP",
     "symbol": "BML.PRG"
    },
    {
     "description": "BANK OF AMERICA CORP",
     "symbol": "BML.PRH"
    },
    {
     "description": "BANK OF AMERICA CORP",
     "symbol": "BML.PRJ"
    },
    {
     "description": "BANK OF AMERICA CORP",
     "symbol": "BML.PRL"
    },
    {
     "description": "BML INC",
     "symbol": "BMLKF"
    },
    {
     "description": "BMO LOW VOLATILITY US EQUITY",
     "symbol": "BMLWF"
    },
    {
     "description": "KBRIDGE ENERGY CORP",
     "symbol": "BMMCF"
    },
    {
     "description": "BODY & MIND INC",
     "symbol": "BMMJ"
    },
    {
     "description": "BMO EQUAL WEIGHT BANKS INDEX",
     "symbol": "BMMPF"
    },
    {
     "description": "BMO COVERED CALL UTILITIES E",
     "symbol": "BMMVF"
    },
    {
     "description": "BMO LOW VOLATILITY CANADIAN",
     "symbol": "BMMWF"
    },
    {
     "description": "BIOMIMIX INC",
     "symbol": "BMMX"
    },
    {
     "description": "BIOMIND LABS INC",
     "symbol": "BMNDF"
    },
    {
     "description": "BIMINI CAPITAL MANAGEMENT-A",
     "symbol": "BMNM"
    },
    {
     "description": "BITMINE IMMERSION TECHNOLOGI",
     "symbol": "BMNR"
    },
    {
     "description": "BANK OF MONTREAL",
     "symbol": "BMO"
    },
    {
     "description": "BMO MSCI INDIA ESG LEADERS I",
     "symbol": "BMOIF"
    },
    {
     "description": "BLUE MOON METALS INC",
     "symbol": "BMOOF"
    },
    {
     "description": "BMO EQUAL WEIGHT REITS INDEX",
     "symbol": "BMQWF"
    },
    {
     "description": "Bank Montreal Quebec",
     "symbol": "BMQZF"
    },
    {
     "description": "BIOMERICA INC",
     "symbol": "BMRA"
    },
    {
     "description": "BANK OF MARIN BANCORP\/CA",
     "symbol": "BMRC"
    },
    {
     "description": "BENCHMARK ENERGY CORP",
     "symbol": "BMRK"
    },
    {
     "description": "SOCIETE DES BAINS DE MER",
     "symbol": "BMRMF"
    },
    {
     "description": "BIOMARIN PHARMACEUTICAL INC",
     "symbol": "BMRN"
    },
    {
     "description": "B&M EUROPEAN VALUE RETAIL SA",
     "symbol": "BMRPF"
    },
    {
     "description": "B&M EUROPEAN VALUE-UNSP ADR",
     "symbol": "BMRRY"
    },
    {
     "description": "BMO SHORT PROVINCIAL BOND IN",
     "symbol": "BMRTF"
    },
    {
     "description": "BIOMASS SECURE POWER INC",
     "symbol": "BMSPF"
    },
    {
     "description": "BEMETALS CORP",
     "symbol": "BMTLF"
    },
    {
     "description": "BRIGHT MOUNTAIN MEDIA INC",
     "symbol": "BMTM"
    },
    {
     "description": "BM TECHNOLOGIES INC",
     "symbol": "BMTX"
    },
    {
     "description": "MEGALITH FINANCIAL ACQ-CW23",
     "symbol": "BMTX.WS"
    },
    {
     "description": "BATHURST METALS CORP",
     "symbol": "BMVVF"
    },
    {
     "description": "BAYERISCHE MOTOREN-SPON ADR",
     "symbol": "BMWYY"
    },
    {
     "description": "BEMAX INC",
     "symbol": "BMXC"
    },
    {
     "description": "BROOKMOUNT EXPLORATIONS INC",
     "symbol": "BMXI"
    },
    {
     "description": "BIOMERIEUX",
     "symbol": "BMXMF"
    },
    {
     "description": "BRISTOL-MYERS SQUIBB CO",
     "symbol": "BMY"
    },
    {
     "description": "Bristol Myers Squibb Company",
     "symbol": "BMYMP"
    },
    {
     "description": "BNCCORP",
     "symbol": "BNCC"
    },
    {
     "description": "BANCA MEDIOLANUM SPA-ADR",
     "symbol": "BNCDY"
    },
    {
     "description": "BENCHMARK METALS INC",
     "symbol": "BNCHF"
    },
    {
     "description": "BOUNCE MOBILE SYSTEMS INC",
     "symbol": "BNCM"
    },
    {
     "description": "BANCO BPM SPA",
     "symbol": "BNCZF"
    },
    {
     "description": "VANGUARD TOTAL BOND MARKET",
     "symbol": "BND"
    },
    {
     "description": "FLEXSHARES CORE SELECT BOND",
     "symbol": "BNDC"
    },
    {
     "description": "QUADRATIC DEFLATION ETF",
     "symbol": "BNDD"
    },
    {
     "description": "BANCO DE SABADELL SA",
     "symbol": "BNDSF"
    },
    {
     "description": "BANCO DE SABADELL-UNSPON ADR",
     "symbol": "BNDSY"
    },
    {
     "description": "VANGUARD TOTAL WORLD BOND ET",
     "symbol": "BNDW"
    },
    {
     "description": "VANGUARD TOTAL INTL BOND ETF",
     "symbol": "BNDX"
    },
    {
     "description": "BLUE HORIZON BNE ETF",
     "symbol": "BNE"
    },
    {
     "description": "BARNES & NOBLE EDUCATION INC",
     "symbol": "BNED"
    },
    {
     "description": "BONTERRA ENERGY CORP",
     "symbol": "BNEFF"
    },
    {
     "description": "BION ENVIRONMENTAL TECH INC",
     "symbol": "BNET"
    },
    {
     "description": "BENEFITFOCUS INC",
     "symbol": "BNFT"
    },
    {
     "description": "FIRST TRUST S-NETWORK STREAM",
     "symbol": "BNGE"
    },
    {
     "description": "BANGI INC",
     "symbol": "BNGI"
    },
    {
     "description": "BENGAL ENERGY LTD",
     "symbol": "BNGLF"
    },
    {
     "description": "BIONANO GENOMICS INC",
     "symbol": "BNGO"
    },
    {
     "description": "BIONANO GENOMICS INC",
     "symbol": "BNGOW"
    },
    {
     "description": "SAVENCIA SA",
     "symbol": "BNGRF"
    },
    {
     "description": "BONHEUR ASA",
     "symbol": "BNHUF"
    },
    {
     "description": "BERONI GROUP LTD",
     "symbol": "BNIGF"
    },
    {
     "description": "BANNIX ACQUISITION CORP",
     "symbol": "BNIX"
    },
    {
     "description": "BANNIX ACQUISITION CORP-RTS",
     "symbol": "BNIXR"
    },
    {
     "description": "BANNIX ACQUISITION CORP-CW23",
     "symbol": "BNIXW"
    },
    {
     "description": "MICROSECTORS US BIG BANK -3X",
     "symbol": "BNKD"
    },
    {
     "description": "BANGKOK AIRWAYS PCL-NVDR",
     "symbol": "BNKGF"
    },
    {
     "description": "BOC HONG KONG HOLDINGS LTD",
     "symbol": "BNKHF"
    },
    {
     "description": "BIONIK LABORATORIES CORP",
     "symbol": "BNKL"
    },
    {
     "description": "ISHARES S&P US BANKS UCITS",
     "symbol": "BNKSF"
    },
    {
     "description": "MICROSECTORS US BIG BANKS 3X",
     "symbol": "BNKU"
    },
    {
     "description": "BROADSTONE NET LEASE INC",
     "symbol": "BNL"
    },
    {
     "description": "BANCA MEDIOLANUM SPA",
     "symbol": "BNMDF"
    },
    {
     "description": "BENJAMIN HILL MINING CORP",
     "symbol": "BNNHF"
    },
    {
     "description": "BANNERMAN ENERGY LTD",
     "symbol": "BNNLF"
    },
    {
     "description": "BEENOS INC",
     "symbol": "BNNNF"
    },
    {
     "description": "BANNER ACQUISITION CORP",
     "symbol": "BNNR"
    },
    {
     "description": "BANNER ACQUISITION CORP",
     "symbol": "BNNRU"
    },
    {
     "description": "BANNER ACQUISITION -CW23",
     "symbol": "BNNRW"
    },
    {
     "description": "UNITED STATES BRENT OIL FUND",
     "symbol": "BNO"
    },
    {
     "description": "BIONOMICS LTD",
     "symbol": "BNOEF"
    },
    {
     "description": "INNOVATOR U.S. EQUITY BUFFER",
     "symbol": "BNOV"
    },
    {
     "description": "BOON INDUSTRIES INC",
     "symbol": "BNOW"
    },
    {
     "description": "BIONOMICS LTD-ADR",
     "symbol": "BNOX"
    },
    {
     "description": "BANPU PUBLIC CO L-UNSPON ADR",
     "symbol": "BNPJY"
    },
    {
     "description": "BNP PARIBAS",
     "symbol": "BNPQF"
    },
    {
     "description": "BNP PARIBAS-ADR",
     "symbol": "BNPQY"
    },
    {
     "description": "BURNING ROCK BIOTECH LTD-ADR",
     "symbol": "BNR"
    },
    {
     "description": "SOLON EIENDOM ASA",
     "symbol": "BNRPF"
    },
    {
     "description": "BANK OF NOVA SCOTIA",
     "symbol": "BNS"
    },
    {
     "description": "BONSO ELECTRONICS INTL INC",
     "symbol": "BNSO"
    },
    {
     "description": "Bank Nova Scotia Halifax",
     "symbol": "BNSPF"
    },
    {
     "description": "BENITEC BIOPHARMA INC",
     "symbol": "BNTC"
    },
    {
     "description": "BRENNTAG SE",
     "symbol": "BNTGF"
    },
    {
     "description": "BRENNTAG SE-UNSP ADR",
     "symbol": "BNTGY"
    },
    {
     "description": "BENEFIT ONE INC",
     "symbol": "BNTOF"
    },
    {
     "description": "BENTON RESOURCES INC",
     "symbol": "BNTRF"
    },
    {
     "description": "BIONTECH SE-ADR",
     "symbol": "BNTX"
    },
    {
     "description": "BINOVI TECHNOLOGIES CORP",
     "symbol": "BNVIF"
    },
    {
     "description": "BANXA HOLDINGS INC",
     "symbol": "BNXAF"
    },
    {
     "description": "BRINX RESOURCES LTD",
     "symbol": "BNXR"
    },
    {
     "description": "BLACKROCK NEW YORK MUNI INC",
     "symbol": "BNY"
    },
    {
     "description": "BANYAN CORP\/OREGON",
     "symbol": "BNYN"
    },
    {
     "description": "CONCENTRADORA HIPOTECARIA SA",
     "symbol": "BNZIF"
    },
    {
     "description": "BONE THERAPEUTICS SA",
     "symbol": "BNZPF"
    },
    {
     "description": "BIO-AMERICA INC",
     "symbol": "BOAA"
    },
    {
     "description": "BLUESCAPE OPPORTUNITIES AC-A",
     "symbol": "BOAC"
    },
    {
     "description": "BLUESCAPE OPPORTUNITIES ACQ",
     "symbol": "BOAC.U"
    },
    {
     "description": "BLUESCAPE OPPORTUNIT A -CW26",
     "symbol": "BOAC.WS"
    },
    {
     "description": "BORAL LTD",
     "symbol": "BOALF"
    },
    {
     "description": "BORAL LIMITED -SPON ADR",
     "symbol": "BOALY"
    },
    {
     "description": "BOA ACQUISITION CORP-A",
     "symbol": "BOAS"
    },
    {
     "description": "BOA ACQUISITION CORP",
     "symbol": "BOAS.U"
    },
    {
     "description": "BOA ACQUISITION CL A -CW28",
     "symbol": "BOAS.WS"
    },
    {
     "description": "SONICSHARES GLOBAL SHIPPING",
     "symbol": "BOAT"
    },
    {
     "description": "MERLYN AI BEST OF BREED CORE",
     "symbol": "BOB"
    },
    {
     "description": "BOSTON OMAHA CORP-CL A",
     "symbol": "BOC"
    },
    {
     "description": "BLUE OCEAN ACQUISITION COR-A",
     "symbol": "BOCN"
    },
    {
     "description": "BLUE OCEAN ACQUISITION CORP",
     "symbol": "BOCNU"
    },
    {
     "description": "BLUE OCEAN ACQUISITION A -23",
     "symbol": "BOCNW"
    },
    {
     "description": "BOUGAINVILLE COPPER LTD",
     "symbol": "BOCOF"
    },
    {
     "description": "INNOVATOR U.S. EQUITY BUFFER",
     "symbol": "BOCT"
    },
    {
     "description": "BEACHBODY CO INC\/THE",
     "symbol": "BODY"
    },
    {
     "description": "BEACHBODY CO-CW27",
     "symbol": "BODY.WS"
    },
    {
     "description": "BLACKROCK ENHANCED GLOBAL DI",
     "symbol": "BOE"
    },
    {
     "description": "BONESUPPORT HOLDING AB",
     "symbol": "BOEUF"
    },
    {
     "description": "BANK OF KYOTO LTD\/THE",
     "symbol": "BOFKF"
    },
    {
     "description": "BOGO-MEDELLIN MILLING CO INC",
     "symbol": "BOGMF"
    },
    {
     "description": "BANK OF HAWAII CORP",
     "symbol": "BOH"
    },
    {
     "description": "BANK OF HAWAII CORP",
     "symbol": "BOH.PRA"
    },
    {
     "description": "BANK IDAHO HLDG CO",
     "symbol": "BOID"
    },
    {
     "description": "PROSHARES ULTRA BLOOMBERG NA",
     "symbol": "BOIL"
    },
    {
     "description": "BOIRON SA",
     "symbol": "BOIRF"
    },
    {
     "description": "BOLLORE SE",
     "symbol": "BOIVF"
    },
    {
     "description": "BOK FINANCIAL CORPORATION",
     "symbol": "BOKF"
    },
    {
     "description": "BOL BANCSHARES INC",
     "symbol": "BOLB"
    },
    {
     "description": "BOL BANCSHARES INC-PREFERENC",
     "symbol": "BOLBP"
    },
    {
     "description": "BOLIDEN AB",
     "symbol": "BOLIF"
    },
    {
     "description": "BOLLINGER INDUSTRIES INC",
     "symbol": "BOLL"
    },
    {
     "description": "B3 SA - UNSP ADR",
     "symbol": "BOLSY"
    },
    {
     "description": "BOLT BIOTHERAPEUTICS INC",
     "symbol": "BOLT"
    },
    {
     "description": "BOLIVAR MINING CORP",
     "symbol": "BOLV"
    },
    {
     "description": "Bombardier Inc",
     "symbol": "BOMBF"
    },
    {
     "description": "BOOMER HOLDINGS INC",
     "symbol": "BOMH"
    },
    {
     "description": "DB BASE METALS DOUBLE SHORT",
     "symbol": "BOMMF"
    },
    {
     "description": "BOLSA MEXICANA DE VALORES SA",
     "symbol": "BOMXF"
    },
    {
     "description": "BON NATURAL LIFE LTD",
     "symbol": "BON"
    },
    {
     "description": "PIMCO ACTIVE BOND EXCHANGE-T",
     "symbol": "BOND"
    },
    {
     "description": "BONAL INTL INC",
     "symbol": "BONL"
    },
    {
     "description": "BON-TON STORES INC\/THE",
     "symbol": "BONTQ"
    },
    {
     "description": "BONTERRA RESOURCES INC",
     "symbol": "BONXF"
    },
    {
     "description": "BONANZA GOLDFIELDS CORP",
     "symbol": "BONZ"
    },
    {
     "description": "DMC GLOBAL INC",
     "symbol": "BOOM"
    },
    {
     "description": "BOOT BARN HOLDINGS INC",
     "symbol": "BOOT"
    },
    {
     "description": "BIOPHARMA CREDIT PLC",
     "symbol": "BOPCF"
    },
    {
     "description": "BORDER PETROLEUM LTD",
     "symbol": "BOPFF"
    },
    {
     "description": "BIOPOWER OPERATIONS CORP",
     "symbol": "BOPO"
    },
    {
     "description": "BOREALIS EXPLORATION LTD",
     "symbol": "BOREF"
    },
    {
     "description": "BOURQUE INDUSTRIES INC",
     "symbol": "BORK"
    },
    {
     "description": "CHINA NEW BORUN CORP-ADR",
     "symbol": "BORNY"
    },
    {
     "description": "BORR DRILLING LTD",
     "symbol": "BORR"
    },
    {
     "description": "BANK OF BOTETOURT BUCHANAN V",
     "symbol": "BORT"
    },
    {
     "description": "BORUSSIA DORTMUND GMBH & CO",
     "symbol": "BORUF"
    },
    {
     "description": "BOS BETTER ON-LINE SOLUTIONS",
     "symbol": "BOSC"
    },
    {
     "description": "GLOBAL X FOUNDER-RUN COMPANI",
     "symbol": "BOSS"
    },
    {
     "description": "HUGO BOSS AG-SPN ADR",
     "symbol": "BOSSY"
    },
    {
     "description": "DB BASE METALS SHORT ETN",
     "symbol": "BOSXF"
    },
    {
     "description": "BIOETHICS LTD",
     "symbol": "BOTH"
    },
    {
     "description": "BANK OF THE JAMES FINANCIAL",
     "symbol": "BOTJ"
    },
    {
     "description": "CHINA EVERBRIGHT WATER LTD",
     "symbol": "BOTRF"
    },
    {
     "description": "BONTEX INC",
     "symbol": "BOTX"
    },
    {
     "description": "LINGERIE FIGHTING CHAMPIONSH",
     "symbol": "BOTY"
    },
    {
     "description": "GLOBAL X ROBOTICS & ARTIFICI",
     "symbol": "BOTZ"
    },
    {
     "description": "INNOVATOR IBD BREAKOUT OPPS",
     "symbol": "BOUT"
    },
    {
     "description": "BIO-UV GROUP SAS",
     "symbol": "BOUVF"
    },
    {
     "description": "BOUYGUES SA",
     "symbol": "BOUYF"
    },
    {
     "description": "BOUYGUES-UNSPONSORED ADR",
     "symbol": "BOUYY"
    },
    {
     "description": "BIOINVENT INTERNATIONAL AB",
     "symbol": "BOVNF"
    },
    {
     "description": "BOARDWALK REAL ESTATE INVEST",
     "symbol": "BOWFF"
    },
    {
     "description": "BOWLERO CORP",
     "symbol": "BOWL"
    },
    {
     "description": "BOWLERO CORP -CW26",
     "symbol": "BOWL.WS"
    },
    {
     "description": "BOX INC - CLASS A",
     "symbol": "BOX"
    },
    {
     "description": "BOXED INC",
     "symbol": "BOXD"
    },
    {
     "description": "SEVEN OAKS ACQ CL A -CW25",
     "symbol": "BOXD.WS"
    },
    {
     "description": "BOXLIGHT CORP - CLASS A",
     "symbol": "BOXL"
    },
    {
     "description": "BOXSCORE BRANDS INC",
     "symbol": "BOXS"
    },
    {
     "description": "BOYAA INTERACTIVE INTERNATIO",
     "symbol": "BOYAF"
    },
    {
     "description": "BOOZT AB-UNSPONSORED ADR",
     "symbol": "BOZTY"
    },
    {
     "description": "BP PLC-SPONS ADR",
     "symbol": "BP"
    },
    {
     "description": "BULLPEN PARLAY ACQUISITION-A",
     "symbol": "BPAC"
    },
    {
     "description": "BULLPEN PARLAY ACQUISITION C",
     "symbol": "BPACU"
    },
    {
     "description": "BULLPEN PARLAY ACQUISITI -26",
     "symbol": "BPACW"
    },
    {
     "description": "BP PLC",
     "symbol": "BPAQF"
    },
    {
     "description": "BANCO COMERCIAL PORTUGUES-R",
     "symbol": "BPCGF"
    },
    {
     "description": "BANCO COMERCIAL-UNSPON ADR",
     "symbol": "BPCGY"
    },
    {
     "description": "VAR RESOURCES CORP",
     "symbol": "BPCOF"
    },
    {
     "description": "BISHOP CAPITAL CORP\/WYOMING",
     "symbol": "BPCP"
    },
    {
     "description": "BNP MSCI EMERGING SRI PAB",
     "symbol": "BPEMF"
    },
    {
     "description": "BANK OF THE PHILIPPINE ISLAN",
     "symbol": "BPHLF"
    },
    {
     "description": "BANK OF PHILIPPINE-UNSP ADR",
     "symbol": "BPHLY"
    },
    {
     "description": "BPI ENERGY HOLDINGS INC",
     "symbol": "BPIGF"
    },
    {
     "description": "PIRAEUS FINANCIAL HOLDINGS S",
     "symbol": "BPIRF"
    },
    {
     "description": "PIRAEUS FINANCIAL-UNSP ADR",
     "symbol": "BPIRY"
    },
    {
     "description": "BLUEPRINT MEDICINES CORP",
     "symbol": "BPMC"
    },
    {
     "description": "BADGER PAPER MILLS INC",
     "symbol": "BPMI"
    },
    {
     "description": "BASILEA PHARMACEUTICA-REG",
     "symbol": "BPMUF"
    },
    {
     "description": "BLACKPOLL FLEET INTERNATIONA",
     "symbol": "BPOL"
    },
    {
     "description": "POPULAR INC",
     "symbol": "BPOP"
    },
    {
     "description": "POPULAR CAPITAL TRUST II",
     "symbol": "BPOPM"
    },
    {
     "description": "Popular Inc",
     "symbol": "BPOPO"
    },
    {
     "description": "BPOST SA",
     "symbol": "BPOSF"
    },
    {
     "description": "BPOST SA - UNSP ADR",
     "symbol": "BPOSY"
    },
    {
     "description": "BID CORP LTD",
     "symbol": "BPPPF"
    },
    {
     "description": "THE BANK OF PRINCETON",
     "symbol": "BPRN"
    },
    {
     "description": "BP PRUDHOE BAY ROYALTY TRUST",
     "symbol": "BPT"
    },
    {
     "description": "BIO-PATH HOLDINGS INC",
     "symbol": "BPTH"
    },
    {
     "description": "BARITO PACIFIC TBK PT",
     "symbol": "BPTNF"
    },
    {
     "description": "BIOPHYTIS SA-ADR",
     "symbol": "BPTS"
    },
    {
     "description": "BPER BANCA SPA-UNSP ADR",
     "symbol": "BPXXY"
    },
    {
     "description": "BROOKFIELD PROP PFD LP",
     "symbol": "BPYPM"
    },
    {
     "description": "BROOKFIELD PROPERTY PART",
     "symbol": "BPYPN"
    },
    {
     "description": "BROOKFIELD PROPERTY PART",
     "symbol": "BPYPO"
    },
    {
     "description": "BROOKFIELD PROPERTY PART",
     "symbol": "BPYPP"
    },
    {
     "description": "BOSTON PIZZA ROYALTIES-UNITS",
     "symbol": "BPZZF"
    },
    {
     "description": "BOQII HOLDING LTD",
     "symbol": "BQ"
    },
    {
     "description": "BANK AUDI SAL- REG S GDR",
     "symbol": "BQAZF"
    },
    {
     "description": "BANQUE CANTONALE VAUDOIS-REG",
     "symbol": "BQCNF"
    },
    {
     "description": "BOSS ENERGY LTD",
     "symbol": "BQSSF"
    },
    {
     "description": "BIOQUEST CORP",
     "symbol": "BQST"
    },
    {
     "description": "BROADRIDGE FINANCIAL SOLUTIO",
     "symbol": "BR"
    },
    {
     "description": "BROAD CAPITAL ACQUISITION CO",
     "symbol": "BRAC"
    },
    {
     "description": "BROAD CAPITAL ACQUIS-RIGHT",
     "symbol": "BRACR"
    },
    {
     "description": "BROAD CAPITAL ACQUISITION CO",
     "symbol": "BRACU"
    },
    {
     "description": "BRAGG GAMING GROUP INC",
     "symbol": "BRAG"
    },
    {
     "description": "BAUER AG",
     "symbol": "BRAGF"
    },
    {
     "description": "BARAN GROUP LTD",
     "symbol": "BRANF"
    },
    {
     "description": "BRAVADA INTERNATIONAL LTD",
     "symbol": "BRAV"
    },
    {
     "description": "BRAXIA SCIENTIFIC CORP",
     "symbol": "BRAXF"
    },
    {
     "description": "BREWBILT BREWING CO",
     "symbol": "BRBL"
    },
    {
     "description": "BIG ROCK BREWERY INC",
     "symbol": "BRBMF"
    },
    {
     "description": "BREMBO SPA",
     "symbol": "BRBOF"
    },
    {
     "description": "BREMBO SPA-UNSOP ADR",
     "symbol": "BRBOY"
    },
    {
     "description": "BELLRING BRANDS INC",
     "symbol": "BRBR"
    },
    {
     "description": "BLUE RIDGE BANKSHARES INC",
     "symbol": "BRBS"
    },
    {
     "description": "BRUNSWICK BANCORP",
     "symbol": "BRBW"
    },
    {
     "description": "BRONCO BILLY CO LTD",
     "symbol": "BRBYF"
    },
    {
     "description": "BRADY CORPORATION - CL A",
     "symbol": "BRC"
    },
    {
     "description": "BRC INC-A",
     "symbol": "BRCC"
    },
    {
     "description": "BRC INC-A -27",
     "symbol": "BRCC.WS"
    },
    {
     "description": "BRAINCHIP HOLDINGS LTD",
     "symbol": "BRCHF"
    },
    {
     "description": "BURCON NUTRASCIENCE CORP",
     "symbol": "BRCN"
    },
    {
     "description": "BEARD COMPANY",
     "symbol": "BRCOQ"
    },
    {
     "description": "BRASILAGRO-CIA BRASILEIRA DE",
     "symbol": "BRCPF"
    },
    {
     "description": "GREENSTONE RESOURCES LTD",
     "symbol": "BRCSF"
    },
    {
     "description": "BEARD ENERGY TRANSITION AC-A",
     "symbol": "BRD"
    },
    {
     "description": "BEARD ENERGY TRANSITION ACQU",
     "symbol": "BRD.U"
    },
    {
     "description": "BEARD ENERGY TRANSITIO -CW27",
     "symbol": "BRD.WS"
    },
    {
     "description": "BREDBAND2 I SKANDINAVIEN AB",
     "symbol": "BRDBF"
    },
    {
     "description": "BRIDGESTONE CORP",
     "symbol": "BRDCF"
    },
    {
     "description": "BRIDGESTONE CORP-UNSPONS ADR",
     "symbol": "BRDCY"
    },
    {
     "description": "BRIDGE INVESTMENT GRP HDS-A",
     "symbol": "BRDG"
    },
    {
     "description": "BROADLEAF CO LTD",
     "symbol": "BRDLF"
    },
    {
     "description": "BIRD GLOBAL INC-CLASS A",
     "symbol": "BRDS"
    },
    {
     "description": "BIRD GLOBAL INC -CW26",
     "symbol": "BRDS.WS"
    },
    {
     "description": "MBANK      -UNSPONSORED ADR",
     "symbol": "BREJY"
    },
    {
     "description": "Brookfield Renewable Partners Preferred LP",
     "symbol": "BRENF"
    },
    {
     "description": "BRESLER & REINER INC",
     "symbol": "BRER"
    },
    {
     "description": "BRIDGEMARQ REAL ESTATE SERVI",
     "symbol": "BREUF"
    },
    {
     "description": "BREEZE HOLDINGS ACQUISITION",
     "symbol": "BREZ"
    },
    {
     "description": "BREEZE HOLDINGS ACQ- RIGHTS",
     "symbol": "BREZR"
    },
    {
     "description": "BREEZE HOLDINGS ACQUIS -CW27",
     "symbol": "BREZW"
    },
    {
     "description": "VANECK BRAZIL SMALL-CAP ETF",
     "symbol": "BRF"
    },
    {
     "description": "BRF SA",
     "symbol": "BRFFF"
    },
    {
     "description": "BARFRESH FOOD GROUP INC",
     "symbol": "BRFH"
    },
    {
     "description": "BLACKROCK FRONTIERS INVEST",
     "symbol": "BRFIF"
    },
    {
     "description": "BRF SA-ADR",
     "symbol": "BRFS"
    },
    {
     "description": "BLUEROCK RESIDENTIAL GROWTH",
     "symbol": "BRG"
    },
    {
     "description": "BLUEROCK RSDTL GR REIT",
     "symbol": "BRG.PRC"
    },
    {
     "description": "BLUEROCK RSDTL GR REIT",
     "symbol": "BRG.PRD"
    },
    {
     "description": "BORREGAARD ASA-UNSP ADR",
     "symbol": "BRGAY"
    },
    {
     "description": "BRIGHTROCK GOLD CORP",
     "symbol": "BRGC"
    },
    {
     "description": "BERGIO INTERNATIONAL INC",
     "symbol": "BRGO"
    },
    {
     "description": "BERGS TIMBER AB-B SHARES",
     "symbol": "BRGSF"
    },
    {
     "description": "BRII BIOSCIENCES LTD",
     "symbol": "BRIBF"
    },
    {
     "description": "BRIDGFORD FOODS CORP",
     "symbol": "BRID"
    },
    {
     "description": "MAGNA TERRA MINERALS INC",
     "symbol": "BRIOF"
    },
    {
     "description": "B RILEY PRINCIPAL 250 MERG-A",
     "symbol": "BRIV"
    },
    {
     "description": "B RILEY PRINCIPAL 250 MERGER",
     "symbol": "BRIVU"
    },
    {
     "description": "B RILEY PRINCIPAL 250 -CW27",
     "symbol": "BRIVW"
    },
    {
     "description": "BERKSHIRE HATHAWAY INC-CL A",
     "symbol": "BRK.A"
    },
    {
     "description": "BERKSHIRE HATHAWAY INC-CL B",
     "symbol": "BRK.B"
    },
    {
     "description": "BARKSDALE RESOURCES CORP",
     "symbol": "BRKCF"
    },
    {
     "description": "Brookfield Office Properties Inc",
     "symbol": "BRKFF"
    },
    {
     "description": "BURTECH ACQUISITION CORP-A",
     "symbol": "BRKH"
    },
    {
     "description": "BURTECH ACQUISITION CORP",
     "symbol": "BRKHU"
    },
    {
     "description": "BURTECH ACQUISITION -CW23",
     "symbol": "BRKHW"
    },
    {
     "description": "BROOKLINE BANCORP INC",
     "symbol": "BRKL"
    },
    {
     "description": "BROKE OUT INC",
     "symbol": "BRKO"
    },
    {
     "description": "BRUKER CORP",
     "symbol": "BRKR"
    },
    {
     "description": "BRICKWORKS LTD",
     "symbol": "BRKWF"
    },
    {
     "description": "BRITISH LAND CO PLC",
     "symbol": "BRLAF"
    },
    {
     "description": "DOMINION LENDING CENTRES INC",
     "symbol": "BRLGF"
    },
    {
     "description": "BRILLIANT ACQUISITION CORP",
     "symbol": "BRLI"
    },
    {
     "description": "BRILLIANT ACQUISITION - RTS",
     "symbol": "BRLIR"
    },
    {
     "description": "BRILLIANT ACQUISITION CORP",
     "symbol": "BRLIU"
    },
    {
     "description": "BRILLIANT ACQUISITION -CW",
     "symbol": "BRLIW"
    },
    {
     "description": "BARREL ENERGY INC",
     "symbol": "BRLL"
    },
    {
     "description": "BRILLIANT EARTH GROUP INC-A",
     "symbol": "BRLT"
    },
    {
     "description": "BORALEX INC -A",
     "symbol": "BRLXF"
    },
    {
     "description": "BROADMARK REALTY CAPITAL INC",
     "symbol": "BRMK"
    },
    {
     "description": "BROADMARK REALTY CAPIT-CW24",
     "symbol": "BRMK.WS"
    },
    {
     "description": "BR MALLS PARTICIPA-SP ADR",
     "symbol": "BRMSY"
    },
    {
     "description": "BARE METAL STANDARD INC",
     "symbol": "BRMT"
    },
    {
     "description": "BARNWELL INDUSTRIES INC",
     "symbol": "BRN"
    },
    {
     "description": "BRAIN BIOTECH AG",
     "symbol": "BRNBF"
    },
    {
     "description": "BORNEO RESOURCE INVESTMENTS",
     "symbol": "BRNE"
    },
    {
     "description": "BURU ENERGY LTD",
     "symbol": "BRNGF"
    },
    {
     "description": "BRONCUS HOLDING CORP",
     "symbol": "BRNHF"
    },
    {
     "description": "BROWN & BROWN INC",
     "symbol": "BRO"
    },
    {
     "description": "BARON ENERGY INC",
     "symbol": "BROE"
    },
    {
     "description": "BROOGE ENERGY LTD",
     "symbol": "BROG"
    },
    {
     "description": "BROOGE HOLDINGS LTD",
     "symbol": "BROGW"
    },
    {
     "description": "Brookfield Renewable Partners LP",
     "symbol": "BROOF"
    },
    {
     "description": "Brookfield Office Properties Inc",
     "symbol": "BROPF"
    },
    {
     "description": "DUTCH BROS INC-CLASS A",
     "symbol": "BROS"
    },
    {
     "description": "Brookfield Asset Management Inc",
     "symbol": "BROXF"
    },
    {
     "description": "BRP GROUP INC-A",
     "symbol": "BRP"
    },
    {
     "description": "GALAXY DIGITAL HOLDINGS LTD",
     "symbol": "BRPHF"
    },
    {
     "description": "B RILEY PRINCIPAL 150 MERG-A",
     "symbol": "BRPM"
    },
    {
     "description": "B RILEY PRINCIPAL 150 MERGER",
     "symbol": "BRPMU"
    },
    {
     "description": "B RILEY PRINCIP 150 ME -CW28",
     "symbol": "BRPMW"
    },
    {
     "description": "BORQS TECHNOLOGIES INC",
     "symbol": "BRQS"
    },
    {
     "description": "BORQS TECHNOLOGIES INC -CW22",
     "symbol": "BRQSW"
    },
    {
     "description": "BARLOWORLD LTD",
     "symbol": "BRRAF"
    },
    {
     "description": "BARLOWORLD LTD-UNSPONS ADR",
     "symbol": "BRRAY"
    },
    {
     "description": "BORREGAARD ASA",
     "symbol": "BRRDF"
    },
    {
     "description": "BLUE RIDGE REAL ESTATE CO",
     "symbol": "BRRE"
    },
    {
     "description": "BERGENBIO ASA",
     "symbol": "BRRGF"
    },
    {
     "description": "BARRY CALLEBAUT AG-UNSP ADR",
     "symbol": "BRRLY"
    },
    {
     "description": "BORN INC",
     "symbol": "BRRN"
    },
    {
     "description": "BROADSIDE ENTERPRISES INC",
     "symbol": "BRSE"
    },
    {
     "description": "BRAIN SCIENTIFIC INC",
     "symbol": "BRSF"
    },
    {
     "description": "QUEENS ROAD CAPITAL INVESTME",
     "symbol": "BRSGF"
    },
    {
     "description": "BALLISTIC RECOVERY SYSTEMS",
     "symbol": "BRSI"
    },
    {
     "description": "BARSELE MINERALS CORP",
     "symbol": "BRSLF"
    },
    {
     "description": "BRIGHTSPIRE CAPITAL INC",
     "symbol": "BRSP"
    },
    {
     "description": "BROAD STREET REALTY INC",
     "symbol": "BRST"
    },
    {
     "description": "BRAINSWAY LTD",
     "symbol": "BRSYF"
    },
    {
     "description": "BRT APARTMENTS CORP",
     "symbol": "BRT"
    },
    {
     "description": "BRIGHTEC INC",
     "symbol": "BRTE"
    },
    {
     "description": "BROTHER INDUSTRIES LTD",
     "symbol": "BRTHF"
    },
    {
     "description": "BROTHER INDS LTD-UNSPON ADR",
     "symbol": "BRTHY"
    },
    {
     "description": "BARRISTER GLOBAL SVCS NTWK",
     "symbol": "BRTR"
    },
    {
     "description": "BIORESTORATIVE THERAPIES INC",
     "symbol": "BRTX"
    },
    {
     "description": "BERENTZEN-GRUPPE AG",
     "symbol": "BRTZF"
    },
    {
     "description": "CANADA CARBON INC",
     "symbol": "BRUZF"
    },
    {
     "description": "BRAVIDA HOLDING AB",
     "symbol": "BRVDF"
    },
    {
     "description": "BRAVO MULTINATIONAL INC",
     "symbol": "BRVO"
    },
    {
     "description": "BLUE RIVER RESOURCES LTD",
     "symbol": "BRVRF"
    },
    {
     "description": "QUANTUM BATTERY METALS CORP",
     "symbol": "BRVVF"
    },
    {
     "description": "SABA CAPITAL INCOME & OPPORT",
     "symbol": "BRW"
    },
    {
     "description": "BRIXMOR PROPERTY GROUP INC",
     "symbol": "BRX"
    },
    {
     "description": "BERRY CORP",
     "symbol": "BRY"
    },
    {
     "description": "BERJAYA CORP BHD",
     "symbol": "BRYAF"
    },
    {
     "description": "BRI-CHEM CORP",
     "symbol": "BRYFF"
    },
    {
     "description": "BAROYECA GOLD & SILVER INC",
     "symbol": "BRYGF"
    },
    {
     "description": "BRYN RESOURCES INC",
     "symbol": "BRYN"
    },
    {
     "description": "AMANI GOLD LTD",
     "symbol": "BRYYF"
    },
    {
     "description": "BRAZE INC-A",
     "symbol": "BRZE"
    },
    {
     "description": "SCEPTER HOLDINGS INC",
     "symbol": "BRZL"
    },
    {
     "description": "DIREXION DAILY MSCI BRAZIL B",
     "symbol": "BRZU"
    },
    {
     "description": "BREEZER VENTURES INC",
     "symbol": "BRZV"
    },
    {
     "description": "BANCO SANTANDER-CHILE-ADR",
     "symbol": "BSAC"
    },
    {
     "description": "BLACK SPADE ACQUISITION CO-A",
     "symbol": "BSAQ"
    },
    {
     "description": "BLACK SPADE ACQUISITION CO",
     "symbol": "BSAQ.U"
    },
    {
     "description": "BLACK SPADE ACQUISIT -CW23",
     "symbol": "BSAQ.WS"
    },
    {
     "description": "INVESCO 2022 USD EM MKT DEBT",
     "symbol": "BSBE"
    },
    {
     "description": "BOGOTA FINANCIAL CORP",
     "symbol": "BSBK"
    },
    {
     "description": "BANCO SANTANDER BRASIL-ADS",
     "symbol": "BSBR"
    },
    {
     "description": "INVESCO 2023 USD EM MKT DEBT",
     "symbol": "BSCE"
    },
    {
     "description": "Invesco BulletShares 2021 Corporate Bond ETF",
     "symbol": "BSCL"
    },
    {
     "description": "INVESCO BULLETSHARES 2022 CO",
     "symbol": "BSCM"
    },
    {
     "description": "INVESCO BULLETSHARES 2023 CO",
     "symbol": "BSCN"
    },
    {
     "description": "INVESCO BULLETSHARES 2024 CO",
     "symbol": "BSCO"
    },
    {
     "description": "INVESCO BULLETSHARES 2025 CO",
     "symbol": "BSCP"
    },
    {
     "description": "INVESCO BULLETSHARES 2026 CO",
     "symbol": "BSCQ"
    },
    {
     "description": "INVESCO BULLETSHARES 2027 CO",
     "symbol": "BSCR"
    },
    {
     "description": "INVESCO BULLETSHARES 2028",
     "symbol": "BSCS"
    },
    {
     "description": "INVESCO BULLETSHARES 2029 CO",
     "symbol": "BSCT"
    },
    {
     "description": "INVESCO BULLETSHARES 2030 CB",
     "symbol": "BSCU"
    },
    {
     "description": "INVESCO BULLETSHARES 2031 CR",
     "symbol": "BSCV"
    },
    {
     "description": "INVESCO 2024 USD EM MKT DEBT",
     "symbol": "BSDE"
    },
    {
     "description": "BOSIDENG INTL HLDGS LTD",
     "symbol": "BSDGF"
    },
    {
     "description": "BOSIDENG INTL HLDGS-UNS ADR",
     "symbol": "BSDGY"
    },
    {
     "description": "ETFMG BREAKWAVE SEA DECARB T",
     "symbol": "BSEA"
    },
    {
     "description": "BRAEMAR SHIPPING SERVICES PL",
     "symbol": "BSEAF"
    },
    {
     "description": "BENESSE HOLDINGS INC",
     "symbol": "BSEFF"
    },
    {
     "description": "BENESSE HOLDINGS INC-UNS ADR",
     "symbol": "BSEFY"
    },
    {
     "description": "BIG SCREEN ENTERTAINMENT GRO",
     "symbol": "BSEG"
    },
    {
     "description": "BIOSTEM TECHNOLOGIES INC",
     "symbol": "BSEM"
    },
    {
     "description": "BASELODE ENERGY CORP",
     "symbol": "BSENF"
    },
    {
     "description": "INNOVATOR U.S. EQUITY BUFFER",
     "symbol": "BSEP"
    },
    {
     "description": "BASSETT FURNITURE INDS",
     "symbol": "BSET"
    },
    {
     "description": "BLUE STAR FOODS CORP",
     "symbol": "BSFC"
    },
    {
     "description": "BASIC-FIT NV",
     "symbol": "BSFFF"
    },
    {
     "description": "BANK OF SAN FRANCISCO",
     "symbol": "BSFO"
    },
    {
     "description": "BLUE SAFARI GROUP ACQUISIT-A",
     "symbol": "BSGA"
    },
    {
     "description": "BLUE SAFARI GROUP ACQUIS-RTS",
     "symbol": "BSGAR"
    },
    {
     "description": "BLUE SAFARI GROUP ACQUISITIO",
     "symbol": "BSGAU"
    },
    {
     "description": "BIGSTRING CORP",
     "symbol": "BSGC"
    },
    {
     "description": "BIOSIG TECHNOLOGIES INC",
     "symbol": "BSGM"
    },
    {
     "description": "BOSS HOLDINGS INC",
     "symbol": "BSHI"
    },
    {
     "description": "CHALLENGER ENERGY GROUP PLC",
     "symbol": "BSHPF"
    },
    {
     "description": "BUSHVELD MINERALS LTD",
     "symbol": "BSHVF"
    },
    {
     "description": "BRIGHTSPHERE INVESTMENT GROU",
     "symbol": "BSIG"
    },
    {
     "description": "INVESCO BULLETSHARES 2022 HI",
     "symbol": "BSJM"
    },
    {
     "description": "INVESCO BULLETSHARES 2023 HI",
     "symbol": "BSJN"
    },
    {
     "description": "INVESCO BULLETSHARES 2024 HI",
     "symbol": "BSJO"
    },
    {
     "description": "INVESCO BULLETSHARES 2025 HI",
     "symbol": "BSJP"
    },
    {
     "description": "INVESCO BULLETSHARES 2026 HI",
     "symbol": "BSJQ"
    },
    {
     "description": "INVESCO BULLETSHARES 2027 HI",
     "symbol": "BSJR"
    },
    {
     "description": "INVESCO BULLETSHARE 2028 HYC",
     "symbol": "BSJS"
    },
    {
     "description": "INVESCO 2029 HIGH YIELD CORP",
     "symbol": "BSJT"
    },
    {
     "description": "BIG SKY GROWTH PARTNERS IN-A",
     "symbol": "BSKY"
    },
    {
     "description": "BIG SKY GROWTH PARTNERS INC",
     "symbol": "BSKYU"
    },
    {
     "description": "BIG SKY GROWTH PARTNERS-CW",
     "symbol": "BSKYW"
    },
    {
     "description": "BAMBUSER AB",
     "symbol": "BSKZF"
    },
    {
     "description": "BLACKSTONE SENIOR FLOATING R",
     "symbol": "BSL"
    },
    {
     "description": "BLACK STONE MINERALS LP",
     "symbol": "BSM"
    },
    {
     "description": "BURSA MALAYSIA BHD",
     "symbol": "BSMAF"
    },
    {
     "description": "INVESCO BULLETSHARES 2022 MU",
     "symbol": "BSMM"
    },
    {
     "description": "INVESCO BULLETSHARES 2023 MU",
     "symbol": "BSMN"
    },
    {
     "description": "INVESCO BULLETSHARES 2024 MU",
     "symbol": "BSMO"
    },
    {
     "description": "INVESCO BULLETSHARES 2025 MU",
     "symbol": "BSMP"
    },
    {
     "description": "INVESCO BULLETSHARES 2026 MU",
     "symbol": "BSMQ"
    },
    {
     "description": "INVESCO BULLETSHARES 2027 MU",
     "symbol": "BSMR"
    },
    {
     "description": "INVESCO BULLETSHARES 2028 MU",
     "symbol": "BSMS"
    },
    {
     "description": "INVESCO BULLETSHARES 2029 MU",
     "symbol": "BSMT"
    },
    {
     "description": "INVESCO BULLETSHARES 2030 MU",
     "symbol": "BSMU"
    },
    {
     "description": "INVESCO BLTSHRS 2031 MUNI",
     "symbol": "BSMV"
    },
    {
     "description": "BANCO SANTANDER MEXICO -ADR",
     "symbol": "BSMX"
    },
    {
     "description": "BOSTON SAND & GRAVEL CO",
     "symbol": "BSND"
    },
    {
     "description": "BLUE STAR HELIUM LTD",
     "symbol": "BSNLF"
    },
    {
     "description": "BALLSTON SPA BANCORP INC",
     "symbol": "BSPA"
    },
    {
     "description": "BUMI SERPONG DAMAI PT",
     "symbol": "BSPDF"
    },
    {
     "description": "BUMI SERPONG DAMAI-UNSP ADR",
     "symbol": "BSPDY"
    },
    {
     "description": "BESPOKE EXTRACTS INC",
     "symbol": "BSPK"
    },
    {
     "description": "BIOSTAR PHARMACEUTICALS INC",
     "symbol": "BSPM"
    },
    {
     "description": "BLOCK INC - CDI",
     "symbol": "BSQKZ"
    },
    {
     "description": "BSQUARE CORP",
     "symbol": "BSQR"
    },
    {
     "description": "SIERRA BANCORP",
     "symbol": "BSRR"
    },
    {
     "description": "BSR REAL ESTATE INVESTMENT T",
     "symbol": "BSRTF"
    },
    {
     "description": "BASE RESOURCES LTD",
     "symbol": "BSRUF"
    },
    {
     "description": "BANK SOUTHSIDE VA CORPORATIO",
     "symbol": "BSSC"
    },
    {
     "description": "GREENWING RESOURCES LTD",
     "symbol": "BSSMF"
    },
    {
     "description": "BASSLINE PRODUCTIONS INC",
     "symbol": "BSSP"
    },
    {
     "description": "BLACKROCK SCIENCE & TECH TR",
     "symbol": "BST"
    },
    {
     "description": "BIOSTAGE INC",
     "symbol": "BSTG"
    },
    {
     "description": "BOUSTEAD SINGAPORE LTD",
     "symbol": "BSTGF"
    },
    {
     "description": "BOUSTEAD PROJECTS LTD",
     "symbol": "BSTJF"
    },
    {
     "description": "BRITE-STRIKE TACTICAL ILLUMI",
     "symbol": "BSTK"
    },
    {
     "description": "BOSTON CARRIERS INC",
     "symbol": "BSTN"
    },
    {
     "description": "BLUE STAR OPPORTUNITIES CORP",
     "symbol": "BSTO"
    },
    {
     "description": "INNOVATOR BUFF SU STRAT ETF",
     "symbol": "BSTP"
    },
    {
     "description": "BLACKROCK SCIENCE & TECH II",
     "symbol": "BSTZ"
    },
    {
     "description": "VANGUARD SHORT-TERM BOND ETF",
     "symbol": "BSV"
    },
    {
     "description": "BANK7 CORP",
     "symbol": "BSVN"
    },
    {
     "description": "BOSTON SCIENTIFIC CORP",
     "symbol": "BSX"
    },
    {
     "description": "BOSTON SCIENTIFIC CORP",
     "symbol": "BSX.PRA"
    },
    {
     "description": "BELO SUN MINING CORP",
     "symbol": "BSXGF"
    },
    {
     "description": "BENTLEY SYSTEMS INC-CLASS B",
     "symbol": "BSY"
    },
    {
     "description": "BIOSYNTECH INC",
     "symbol": "BSYI"
    },
    {
     "description": "BLACKROCK LNG-TM MUN ADV TST",
     "symbol": "BTA"
    },
    {
     "description": "BANK BTPN SYARIAH TBK PT",
     "symbol": "BTABF"
    },
    {
     "description": "BlackRock Target Allocation ETF Equity",
     "symbol": "BTAEAX"
    },
    {
     "description": "BlackRock Target Allocation ETF 90 10",
     "symbol": "BTAEBX"
    },
    {
     "description": "BlackRock Target Allocation ETF 10 90",
     "symbol": "BTAECX"
    },
    {
     "description": "BlackRock Target Allocation ETF 20 80",
     "symbol": "BTAEDX"
    },
    {
     "description": "BlackRock Target Allocation ETF 30 70",
     "symbol": "BTAEEX"
    },
    {
     "description": "BlackRock Target Allocation ETF 40 60",
     "symbol": "BTAEFX"
    },
    {
     "description": "BlackRock Target Allocation ETF 50 50",
     "symbol": "BTAEGX"
    },
    {
     "description": "BlackRock Target Allocation ETF 60 40",
     "symbol": "BTAEHX"
    },
    {
     "description": "BlackRock Target Allocation ETF 70 30",
     "symbol": "BTAEIX"
    },
    {
     "description": "BlackRock Target Allocation ETF 80 20",
     "symbol": "BTAEJX"
    },
    {
     "description": "BlackRock Target Allocation ETF Fixed Income",
     "symbol": "BTAEKX"
    },
    {
     "description": "BRITISH AMERICAN TOBACCO PLC",
     "symbol": "BTAFF"
    },
    {
     "description": "BIOXCEL THERAPEUTICS INC",
     "symbol": "BTAI"
    },
    {
     "description": "AGFIQ US MARKET NEUTRAL ANTI",
     "symbol": "BTAL"
    },
    {
     "description": "BATM ADVANCED COMMUNICATIONS",
     "symbol": "BTAVF"
    },
    {
     "description": "BIT BROTHER LTD",
     "symbol": "BTB"
    },
    {
     "description": "BT BRANDS INC",
     "symbol": "BTBD"
    },
    {
     "description": "BT BRANDS INC -CW26",
     "symbol": "BTBDW"
    },
    {
     "description": "BTB REAL ESTATE INVESTMENT T",
     "symbol": "BTBIF"
    },
    {
     "description": "BIT DIGITAL INC",
     "symbol": "BTBT"
    },
    {
     "description": "BIT MINING LTD - SPON ADR",
     "symbol": "BTCM"
    },
    {
     "description": "VOLT CRYPTO INDUS REV TECH",
     "symbol": "BTCR"
    },
    {
     "description": "BTCS INC",
     "symbol": "BTCS"
    },
    {
     "description": "BLUESKY DIGITAL ASSETS CORP",
     "symbol": "BTCWF"
    },
    {
     "description": "BIOTRICITY INC",
     "symbol": "BTCY"
    },
    {
     "description": "B2DIGITAL INC",
     "symbol": "BTDG"
    },
    {
     "description": "BARRATT DEVELOPMENTS PLC",
     "symbol": "BTDPF"
    },
    {
     "description": "BARRATT DEVELOPMENTS-UNS ADR",
     "symbol": "BTDPY"
    },
    {
     "description": "BENETEAU",
     "symbol": "BTEAF"
    },
    {
     "description": "PRINCIPAL HEALTHCARE INNOVAT",
     "symbol": "BTEC"
    },
    {
     "description": "BAYTEX ENERGY CORP",
     "symbol": "BTEGF"
    },
    {
     "description": "BLACKROCK FUTURE TECH ETF",
     "symbol": "BTEK"
    },
    {
     "description": "VALKYRIE BITCOIN STRATEGY",
     "symbol": "BTF"
    },
    {
     "description": "B2GOLD CORP",
     "symbol": "BTG"
    },
    {
     "description": "BITCOIN GROUP SE",
     "symbol": "BTGGF"
    },
    {
     "description": "BIGTINCAN HOLDINGS LTD",
     "symbol": "BTGHF"
    },
    {
     "description": "BITCOIN GENERATION INC",
     "symbol": "BTGN"
    },
    {
     "description": "BT GROUP PLC",
     "symbol": "BTGOF"
    },
    {
     "description": "BTS GROUP HOLDINGS PCL-FORGN",
     "symbol": "BTGRF"
    },
    {
     "description": "BTS GROUP HOLDINGS PCL-NVDR",
     "symbol": "BTGWF"
    },
    {
     "description": "BLACKROCK FUTURE US THEMES",
     "symbol": "BTHM"
    },
    {
     "description": "BRITISH AMERICAN TOB-SP ADR",
     "symbol": "BTI"
    },
    {
     "description": "BOATIM INC",
     "symbol": "BTIM"
    },
    {
     "description": "BLACK TUSK RESOURCES INC",
     "symbol": "BTKRF"
    },
    {
     "description": "BRITISH LAND CO PLC-SPON ADR",
     "symbol": "BTLCY"
    },
    {
     "description": "NORTH PEAK RESOURCES LTD",
     "symbol": "BTLLF"
    },
    {
     "description": "BALLANTYNE STRONG INC",
     "symbol": "BTN"
    },
    {
     "description": "JOHN HANCOCK FINANCIAL OPPOR",
     "symbol": "BTO"
    },
    {
     "description": "BENTON FINANCIAL CORP",
     "symbol": "BTOF"
    },
    {
     "description": "CHINA XIANGTAI FOOD CO LTD",
     "symbol": "BTOG"
    },
    {
     "description": "AMERICANAS SA-SPON GDR",
     "symbol": "BTOOY"
    },
    {
     "description": "GTFN HOLDINGS INC",
     "symbol": "BTOW"
    },
    {
     "description": "BANK BTPN TBK PT",
     "symbol": "BTPNF"
    },
    {
     "description": "BQE WATER INC",
     "symbol": "BTQNF"
    },
    {
     "description": "BETTER COLLECTIVE A\/S",
     "symbol": "BTRCF"
    },
    {
     "description": "BATTERY MINERAL RESOURCES CO",
     "symbol": "BTRMF"
    },
    {
     "description": "BTRS HOLDINGS INC-CL 1",
     "symbol": "BTRS"
    },
    {
     "description": "CLARIOS INTERNATIONAL INC",
     "symbol": "BTRY"
    },
    {
     "description": "Clarios International Inc",
     "symbol": "BTRY.PRA"
    },
    {
     "description": "BATTERY MINERALS LTD",
     "symbol": "BTRYF"
    },
    {
     "description": "HEALTH AND HAPPINESS H&H INT",
     "symbol": "BTSDF"
    },
    {
     "description": "BET SHEMESH ENGINES HOLDINGS",
     "symbol": "BTSEF"
    },
    {
     "description": "BTS GROUP HOLDINGS PCL",
     "symbol": "BTSGY"
    },
    {
     "description": "BETSSON AB-B",
     "symbol": "BTSNF"
    },
    {
     "description": "BETSSON AB-CLASS B ADR",
     "symbol": "BTSNY"
    },
    {
     "description": "BRIGHTSTAR INFORMATION TECH",
     "symbol": "BTSR"
    },
    {
     "description": "BTS RAIL MASS TRANSIT FUND-F",
     "symbol": "BTSRF"
    },
    {
     "description": "BLACKROCK MUNICIPAL 2030 TAR",
     "symbol": "BTT"
    },
    {
     "description": "BIOTEST AG-UNSPONSORED ADR",
     "symbol": "BTTAY"
    },
    {
     "description": "BETTER CHOICE CO INC",
     "symbol": "BTTR"
    },
    {
     "description": "BETTER THERAPEUTICS INC",
     "symbol": "BTTX"
    },
    {
     "description": "PEABODY ENERGY CORP",
     "symbol": "BTU"
    },
    {
     "description": "BTU METALS CORP",
     "symbol": "BTUMF"
    },
    {
     "description": "BATHURST RESOURCES LTD",
     "symbol": "BTURF"
    },
    {
     "description": "BRITVIC PLC",
     "symbol": "BTVCF"
    },
    {
     "description": "BRITVIC PLC-SPON ADR",
     "symbol": "BTVCY"
    },
    {
     "description": "BLUERUSH INC",
     "symbol": "BTVRF"
    },
    {
     "description": "BRIDGETOWN HOLDINGS LTD-CL A",
     "symbol": "BTWN"
    },
    {
     "description": "BRIDGETOWN HOLDINGS LTD",
     "symbol": "BTWNU"
    },
    {
     "description": "BRIDGETOWN HOLDINGS -CW27",
     "symbol": "BTWNW"
    },
    {
     "description": "BROOKLYN IMMUNOTHERAPEUTICS",
     "symbol": "BTX"
    },
    {
     "description": "BLACKROCK CREDIT ALLOCATION",
     "symbol": "BTZ"
    },
    {
     "description": "BOTS INC",
     "symbol": "BTZI"
    },
    {
     "description": "ANHEUSER-BUSCH INBEV-SPN ADR",
     "symbol": "BUD"
    },
    {
     "description": "ANHEUSER-BUSCH INBEV SA\/NV",
     "symbol": "BUDFF"
    },
    {
     "description": "CANNABIS GROWTH ETF",
     "symbol": "BUDX"
    },
    {
     "description": "WEED INC",
     "symbol": "BUDZ"
    },
    {
     "description": "BLUE ENERGY LTD",
     "symbol": "BUENF"
    },
    {
     "description": "INNOVATOR LADD ALLO BUFF ETF",
     "symbol": "BUFB"
    },
    {
     "description": "FT CBOE VEST FUND DEEP BUFF",
     "symbol": "BUFD"
    },
    {
     "description": "INNOVATOR LADDERED ALLOCATIO",
     "symbol": "BUFF"
    },
    {
     "description": "FT CBOE VEST BUFF ALLOC GROW",
     "symbol": "BUFG"
    },
    {
     "description": "FT CBOE VEST FUND OF BUFFER",
     "symbol": "BUFR"
    },
    {
     "description": "FT CBOE VEST BUFF ALLOC DEF",
     "symbol": "BUFT"
    },
    {
     "description": "GLOBAL X CYBERSECURITY ETF",
     "symbol": "BUG"
    },
    {
     "description": "BUMRUNGRAD HOSPITAL PCL-NVDR",
     "symbol": "BUGDF"
    },
    {
     "description": "BLUGLASS LTD",
     "symbol": "BUGLF"
    },
    {
     "description": "PRIMO NUTRACEUTICALS INC",
     "symbol": "BUGVF"
    },
    {
     "description": "BUCK HILL FALLS COMPANY",
     "symbol": "BUHF"
    },
    {
     "description": "BUMRUNGRAD HOSPITAL-FOREIGN",
     "symbol": "BUHPF"
    },
    {
     "description": "BUMRUNGRAD HOSPITAL-UNSP ADR",
     "symbol": "BUHPY"
    },
    {
     "description": "BLCKRCK UTIL INFRA & PWR OPP",
     "symbol": "BUI"
    },
    {
     "description": "BUILDINGIQ INC-CDI",
     "symbol": "BUIQL"
    },
    {
     "description": "BUKAKA TEKNIK UTAMA TBK PT",
     "symbol": "BUKKF"
    },
    {
     "description": "BUTLER NATIONAL CORP",
     "symbol": "BUKS"
    },
    {
     "description": "PACER US CASH COWS GROWTH",
     "symbol": "BUL"
    },
    {
     "description": "BULLET BLOCKCHAIN INC",
     "symbol": "BULT"
    },
    {
     "description": "MICROSECTORS FANG&INN 3X LEV",
     "symbol": "BULZ"
    },
    {
     "description": "BUMITAMA AGRI LTD",
     "symbol": "BUMTF"
    },
    {
     "description": "BURNED MEDIA LTD",
     "symbol": "BUNM"
    },
    {
     "description": "BWP TRUST",
     "symbol": "BUNNF"
    },
    {
     "description": "BURFORD CAPITAL LTD",
     "symbol": "BUR"
    },
    {
     "description": "BURBERRY GROUP PLC-SPON ADR",
     "symbol": "BURBY"
    },
    {
     "description": "BURNHAM HOLDINGS INC-CL A",
     "symbol": "BURCA"
    },
    {
     "description": "BURNHAM HOLDINGS INC-CL B",
     "symbol": "BURCB"
    },
    {
     "description": "BASIN URANIUM CORP",
     "symbol": "BURCF"
    },
    {
     "description": "Burnham Holdings Inc",
     "symbol": "BURCP"
    },
    {
     "description": "BURLINGTON STORES INC",
     "symbol": "BURL"
    },
    {
     "description": "BLUE STAR GLOBAL INC",
     "symbol": "BUSC"
    },
    {
     "description": "FIRST BUSEY CORP",
     "symbol": "BUSE"
    },
    {
     "description": "CALETHOS INC",
     "symbol": "BUUZ"
    },
    {
     "description": "FRANKLIN DISRUPTIVE COMMERCE",
     "symbol": "BUYZ"
    },
    {
     "description": "VANECK SOCIAL SENTIMENT ETF",
     "symbol": "BUZZ"
    },
    {
     "description": "BRIGHTVIEW HOLDINGS INC",
     "symbol": "BV"
    },
    {
     "description": "BIOVAXYS TECHNOLOGY CORP",
     "symbol": "BVAXF"
    },
    {
     "description": "MARIE BRIZARD WINE & SPIRITS",
     "symbol": "BVDRF"
    },
    {
     "description": "BEAVER COAL LTD",
     "symbol": "BVERS"
    },
    {
     "description": "BV FINANCIAL INC",
     "symbol": "BVFL"
    },
    {
     "description": "BLUEGREEN VACATIONS HOLDING",
     "symbol": "BVH"
    },
    {
     "description": "BFC FINANCIAL CORP-CLASS B",
     "symbol": "BVHBB"
    },
    {
     "description": "VISTRY GROUP PLC",
     "symbol": "BVHMF"
    },
    {
     "description": "BREVILLE GROUP LTD",
     "symbol": "BVILF"
    },
    {
     "description": "BREVILLE GROUP LTD-ADR",
     "symbol": "BVILY"
    },
    {
     "description": "BOLD VENTURES INC",
     "symbol": "BVLDF"
    },
    {
     "description": "CIA DE MINAS BUENAVENTUR-ADR",
     "symbol": "BVN"
    },
    {
     "description": "BAVARIAN NORDIC A\/S",
     "symbol": "BVNKF"
    },
    {
     "description": "BEVCANNA ENTERPRISES INC",
     "symbol": "BVNNF"
    },
    {
     "description": "BAVARIAN NORDIC A\/S-ADR",
     "symbol": "BVNRY"
    },
    {
     "description": "BUREAU VERITAS SA",
     "symbol": "BVRDF"
    },
    {
     "description": "BIOVENTUS INC - A",
     "symbol": "BVS"
    },
    {
     "description": "BRAVURA SOLUTIONS LTD",
     "symbol": "BVSFF"
    },
    {
     "description": "ICONIC MINERALS LTD",
     "symbol": "BVTEF"
    },
    {
     "description": "BRAVATEK SOLUTIONS INC",
     "symbol": "BVTK"
    },
    {
     "description": "BIVICTRIX THERAPEUTICS PLC",
     "symbol": "BVTXF"
    },
    {
     "description": "Bureau Veritas SA - ADR",
     "symbol": "BVVBY"
    },
    {
     "description": "BIONDVAX PHARMACEUTICALS-ADR",
     "symbol": "BVXV"
    },
    {
     "description": "BVZ HOLDING AG-REG NEW",
     "symbol": "BVZHF"
    },
    {
     "description": "BABCOCK & WILCOX ENTERPR",
     "symbol": "BW"
    },
    {
     "description": "BABCOCK & WILCOX ENTERPR",
     "symbol": "BW.PRA"
    },
    {
     "description": "BORGWARNER INC",
     "symbol": "BWA"
    },
    {
     "description": "BETTER WORLD ACQUISITION COR",
     "symbol": "BWAC"
    },
    {
     "description": "BETTER WORLD ACQUISITION COR",
     "symbol": "BWACU"
    },
    {
     "description": "BETTER WORLD ACQ -CW27",
     "symbol": "BWACW"
    },
    {
     "description": "BAWAG GROUP AG",
     "symbol": "BWAGF"
    },
    {
     "description": "BLUE WORLD ACQUISITION CORP",
     "symbol": "BWAQ"
    },
    {
     "description": "BLUE WORLD ACQUISITION - RTS",
     "symbol": "BWAQR"
    },
    {
     "description": "BLUE WORLD ACQUISITION CORP",
     "symbol": "BWAQU"
    },
    {
     "description": "BLUE WORLD ACQUISITION -29",
     "symbol": "BWAQW"
    },
    {
     "description": "BETAWAVE CORP",
     "symbol": "BWAV"
    },
    {
     "description": "BRAINSWAY LTD-ADR",
     "symbol": "BWAY"
    },
    {
     "description": "BRIDGEWATER BANCSHARES INC",
     "symbol": "BWB"
    },
    {
     "description": "BROADWEBASIA INC",
     "symbol": "BWBA"
    },
    {
     "description": "BRIDGEWATER BANCSHARES",
     "symbol": "BWBBP"
    },
    {
     "description": "BLUE WHALE ACQUISITION COR-A",
     "symbol": "BWC"
    },
    {
     "description": "BLUE WHALE ACQUISITION CORP",
     "symbol": "BWCAU"
    },
    {
     "description": "BLUE WHALE ACQ CORP -CW23",
     "symbol": "BWCAW"
    },
    {
     "description": "BLACKWOLF COPPER AND GOLD LT",
     "symbol": "BWCGF"
    },
    {
     "description": "BW ENERGY LTD",
     "symbol": "BWEFF"
    },
    {
     "description": "BOSWELL (JG) CO",
     "symbol": "BWEL"
    },
    {
     "description": "BROADWIND INC",
     "symbol": "BWEN"
    },
    {
     "description": "BANKWELL FINANCIAL GROUP INC",
     "symbol": "BWFG"
    },
    {
     "description": "BRANDYWINEGLOBAL GLOBAL INCO",
     "symbol": "BWG"
    },
    {
     "description": "BOARDWALKTECH SOFTWARE CORP",
     "symbol": "BWLKF"
    },
    {
     "description": "BW LPG LTD",
     "symbol": "BWLLF"
    },
    {
     "description": "BW LPG LTD-UNSPONSORED ADR",
     "symbol": "BWLLY"
    },
    {
     "description": "BOWLEVEN PLC",
     "symbol": "BWLVF"
    },
    {
     "description": "BROWNIE'S MARINE GROUP INC",
     "symbol": "BWMG"
    },
    {
     "description": "BOWMAN CONSULTING GROUP LTD",
     "symbol": "BWMN"
    },
    {
     "description": "BLACKROCK WORLD MINING TRUST",
     "symbol": "BWMTF"
    },
    {
     "description": "BETTERWARE DE MEXICO SAB DE",
     "symbol": "BWMX"
    },
    {
     "description": "BORROWMONEY.COM INC",
     "symbol": "BWMY"
    },
    {
     "description": "SI6 METALS LTD",
     "symbol": "BWNAF"
    },
    {
     "description": "BABCOCK & WILCOX ENTERPR",
     "symbol": "BWNB"
    },
    {
     "description": "BAWANG INTERNATIONAL GROUP",
     "symbol": "BWNGF"
    },
    {
     "description": "WOWJOINT HOLDINGS LTD",
     "symbol": "BWOWF"
    },
    {
     "description": "BLUE WATER PETROLEUM CORP",
     "symbol": "BWPC"
    },
    {
     "description": "BALWIN PROPERTIES PTY LTD",
     "symbol": "BWPPF"
    },
    {
     "description": "BABCOCK & WILCOX ENTERPR",
     "symbol": "BWSN"
    },
    {
     "description": "Bristol and West PLC",
     "symbol": "BWSTF"
    },
    {
     "description": "BOWLIN TRAVEL CENTERS INC",
     "symbol": "BWTL"
    },
    {
     "description": "BAKKEN WATER TRANSFER SERVIC",
     "symbol": "BWTX"
    },
    {
     "description": "BLUE WATER VACCINES INC",
     "symbol": "BWV"
    },
    {
     "description": "BLUE WATER VENTURES INTERNAT",
     "symbol": "BWVI"
    },
    {
     "description": "IPATH CBOE S&P 500 BUYWRITE",
     "symbol": "BWVTF"
    },
    {
     "description": "SPDR BLOOMBERG INT TREASURY",
     "symbol": "BWX"
    },
    {
     "description": "BWX TECHNOLOGIES INC",
     "symbol": "BWXT"
    },
    {
     "description": "BWX LTD",
     "symbol": "BWXXF"
    },
    {
     "description": "SPDR BLOOMBERG SHORT TERM IN",
     "symbol": "BWZ"
    },
    {
     "description": "BLACKSTONE INC",
     "symbol": "BX"
    },
    {
     "description": "BRAMBLES LTD-SPONSORED ADR",
     "symbol": "BXBLY"
    },
    {
     "description": "BLUELINX HOLDINGS INC",
     "symbol": "BXC"
    },
    {
     "description": "Brookfield Asset Management Inc",
     "symbol": "BXDIF"
    },
    {
     "description": "BEXIL CORP",
     "symbol": "BXLC"
    },
    {
     "description": "BLACKSTONE MORTGAGE TRU-CL A",
     "symbol": "BXMT"
    },
    {
     "description": "NUVEEN S&P500 BUY-WRT INC FD",
     "symbol": "BXMX"
    },
    {
     "description": "BANG HOLDINGS CORP",
     "symbol": "BXNG"
    },
    {
     "description": "BOSTON PROPERTIES INC",
     "symbol": "BXP"
    },
    {
     "description": "BOTANIX PHARMACEUTICALS LTD",
     "symbol": "BXPHF"
    },
    {
     "description": "BENDIGO AND ADELAIDE BANK",
     "symbol": "BXRBF"
    },
    {
     "description": "AUSTRALIAN SILICA QUARTZ GRP",
     "symbol": "BXRDF"
    },
    {
     "description": "BAUDAX BIO INC",
     "symbol": "BXRX"
    },
    {
     "description": "BLACKSTONE SECURED LENDING F",
     "symbol": "BXSL"
    },
    {
     "description": "EXGEN RESOURCES INC",
     "symbol": "BXXRF"
    },
    {
     "description": "BOXXY INC",
     "symbol": "BXXY"
    },
    {
     "description": "BYLINE BANCORP INC",
     "symbol": "BY"
    },
    {
     "description": "BANYAN GOLD CORP",
     "symbol": "BYAGF"
    },
    {
     "description": "BARRY CALLEBAUT AG-REG",
     "symbol": "BYCBF"
    },
    {
     "description": "BAYCURRENT CONSULTING INC",
     "symbol": "BYCRF"
    },
    {
     "description": "BOYD GAMING CORP",
     "symbol": "BYD"
    },
    {
     "description": "BOYDS COLLECTION LTD",
     "symbol": "BYDC"
    },
    {
     "description": "BYD CO LTD-H",
     "symbol": "BYDDF"
    },
    {
     "description": "BYD CO LTD-UNSPONSORED ADR",
     "symbol": "BYDDY"
    },
    {
     "description": "BOYD GROUP SERVICES INC",
     "symbol": "BYDGF"
    },
    {
     "description": "BYD ELECTRONIC INTL CO LTD",
     "symbol": "BYDIF"
    },
    {
     "description": "BYD ELECTRONIC INTL-UNSP ADR",
     "symbol": "BYDIY"
    },
    {
     "description": "BROADWAY FINANCIAL CORP\/DE",
     "symbol": "BYFC"
    },
    {
     "description": "SPROUT AI INC",
     "symbol": "BYFMF"
    },
    {
     "description": "BRYAH RESOURCES LTD",
     "symbol": "BYHFF"
    },
    {
     "description": "BAYING ECOLOGICAL HOLDING GR",
     "symbol": "BYIN"
    },
    {
     "description": "BOYLE BANCORP INC",
     "symbol": "BYLB"
    },
    {
     "description": "ISHARES YIELD OPTIMIZED BOND",
     "symbol": "BYLD"
    },
    {
     "description": "BYLOG GROUP CORP",
     "symbol": "BYLG"
    },
    {
     "description": "BIG YELLOW GROUP PLC",
     "symbol": "BYLOF"
    },
    {
     "description": "BAYLIN TECHNOLOGIES INC",
     "symbol": "BYLTF"
    },
    {
     "description": "BLACKROCK MUNICIPAL INCOME Q",
     "symbol": "BYM"
    },
    {
     "description": "BAYERISCHE MOTOREN WERKE-PRF",
     "symbol": "BYMOF"
    },
    {
     "description": "BANYAN ACQUISITION CORP-A",
     "symbol": "BYN"
    },
    {
     "description": "BANYAN ACQUISITION CORP",
     "symbol": "BYN.U"
    },
    {
     "description": "BANYAN ACQUISITION CO -CW23",
     "symbol": "BYN.WS"
    },
    {
     "description": "BEYOND MEAT INC",
     "symbol": "BYND"
    },
    {
     "description": "BANYAN TREE HOLDINGS LTD",
     "symbol": "BYNEF"
    },
    {
     "description": "BYNORDIC ACQUISITION CORP",
     "symbol": "BYNO"
    },
    {
     "description": "BYNORDIC ACQUISITION CORP",
     "symbol": "BYNOU"
    },
    {
     "description": "BYNORDIC ACQUISITION -CW27",
     "symbol": "BYNOW"
    },
    {
     "description": "BEYOND COMMERCE INC",
     "symbol": "BYOC"
    },
    {
     "description": "BOUNTY OIL & GAS NL",
     "symbol": "BYOGF"
    },
    {
     "description": "BODYCOTE PLC",
     "symbol": "BYPLF"
    },
    {
     "description": "BUYER GROUP INTERNATIONAL",
     "symbol": "BYRG"
    },
    {
     "description": "BII RAILWAY TRANSPORTATION T",
     "symbol": "BYRLF"
    },
    {
     "description": "BYRNA TECHNOLOGIES INC",
     "symbol": "BYRN"
    },
    {
     "description": "BYRON ENERGY LTD",
     "symbol": "BYROF"
    },
    {
     "description": "BAYSIDE CORP",
     "symbol": "BYSD"
    },
    {
     "description": "BEYONDSPRING INC",
     "symbol": "BYSI"
    },
    {
     "description": "ROUNDHILL IO DIGITAL INFRA",
     "symbol": "BYTE"
    },
    {
     "description": "BYTE ACQUISITION CORP - A",
     "symbol": "BYTS"
    },
    {
     "description": "BYTE ACQUISITION CORP",
     "symbol": "BYTSU"
    },
    {
     "description": "BYTE ACQUISITION COR A -CW28",
     "symbol": "BYTSW"
    },
    {
     "description": "BALYO SA - PROMESSES",
     "symbol": "BYYLF"
    },
    {
     "description": "KANZHUN LTD - ADR",
     "symbol": "BZ"
    },
    {
     "description": "KINCORA COPPER LTD",
     "symbol": "BZDLF"
    },
    {
     "description": "BUZZFEED INC",
     "symbol": "BZFD"
    },
    {
     "description": "890 5TH AVENUE PA CL A -CW27",
     "symbol": "BZFDW"
    },
    {
     "description": "BEAZER HOMES USA INC",
     "symbol": "BZH"
    },
    {
     "description": "BEAMZ INTERACTIVE INC",
     "symbol": "BZIC"
    },
    {
     "description": "BUNZL PLC",
     "symbol": "BZLFF"
    },
    {
     "description": "BUNZL PLC -SPONS ADR",
     "symbol": "BZLFY"
    },
    {
     "description": "BEAZLEY PLC",
     "symbol": "BZLYF"
    },
    {
     "description": "PROSHARES ULTRASHORT MSCI BR",
     "symbol": "BZQ"
    },
    {
     "description": "BEZEQ THE ISRAELI TELECOM CO",
     "symbol": "BZQIF"
    },
    {
     "description": "BEZEQ THE ISRAELI-UNSPON ADR",
     "symbol": "BZQIY"
    },
    {
     "description": "BLUBUZZARD INC",
     "symbol": "BZRD"
    },
    {
     "description": "BIZROCKET.COM INC",
     "symbol": "BZRT"
    },
    {
     "description": "BOOZT AB",
     "symbol": "BZTAF"
    },
    {
     "description": "BUZZ TECHNOLOGIES INC",
     "symbol": "BZTG"
    },
    {
     "description": "BAOZUN INC-SPN ADR",
     "symbol": "BZUN"
    },
    {
     "description": "BUSINESS WARRIOR CORP",
     "symbol": "BZWR"
    },
    {
     "description": "BURZYNSKI RESEARCH INSTITUTE",
     "symbol": "BZYR"
    },
    {
     "description": "BUZZI UNICEM SPA",
     "symbol": "BZZUF"
    },
    {
     "description": "BUZZI UNICEM SPA-UNSPON ADR",
     "symbol": "BZZUY"
    },
    {
     "description": "CITIGROUP INC",
     "symbol": "C"
    },
    {
     "description": "CITIGROUP INC",
     "symbol": "C.PRJ"
    },
    {
     "description": "CITIGROUP INC",
     "symbol": "C.PRK"
    },
    {
     "description": "CITIGROUP CAPITAL XIII",
     "symbol": "C.PRN"
    },
    {
     "description": "INDVR BRANDS INC",
     "symbol": "CAAOF"
    },
    {
     "description": "CORP AMERICA AIRPORTS SA",
     "symbol": "CAAP"
    },
    {
     "description": "CHINA AUTOMOTIVE SYSTEMS INC",
     "symbol": "CAAS"
    },
    {
     "description": "CABALETTA BIO INC",
     "symbol": "CABA"
    },
    {
     "description": "CALIFORNIA BUSINESS BANK",
     "symbol": "CABB"
    },
    {
     "description": "CALIBRE ENERGY INC",
     "symbol": "CABE"
    },
    {
     "description": "CARLSBERG AS-B-SPON ADR",
     "symbol": "CABGY"
    },
    {
     "description": "CARLSBERG-A",
     "symbol": "CABHF"
    },
    {
     "description": "CARLSBERG AS-B",
     "symbol": "CABJF"
    },
    {
     "description": "CABLE ONE INC",
     "symbol": "CABO"
    },
    {
     "description": "COASTAL BK&TR JACKSONVILLE",
     "symbol": "CABT"
    },
    {
     "description": "CAMDEN NATIONAL CORP",
     "symbol": "CAC"
    },
    {
     "description": "CREDIT ACCEPTANCE CORP",
     "symbol": "CACC"
    },
    {
     "description": "CLEARBRIDGE ALL CAP GROWTH E",
     "symbol": "CACG"
    },
    {
     "description": "CACHE INC",
     "symbol": "CACH"
    },
    {
     "description": "CACI INTERNATIONAL INC -CL A",
     "symbol": "CACI"
    },
    {
     "description": "CADENCE BANK",
     "symbol": "CADE"
    },
    {
     "description": "CADENCE BANK",
     "symbol": "CADE.PRA"
    },
    {
     "description": "CADILLAC VENTURES INC",
     "symbol": "CADIF"
    },
    {
     "description": "CANDEL THERAPEUTICS INC",
     "symbol": "CADL"
    },
    {
     "description": "CADELER A\/S",
     "symbol": "CADLF"
    },
    {
     "description": "CHEMESIS INTERNATIONAL INC",
     "symbol": "CADMF"
    },
    {
     "description": "CASCADES INC",
     "symbol": "CADNF"
    },
    {
     "description": "CAE INC",
     "symbol": "CAE"
    },
    {
     "description": "CAREER DESIGN CENTER CO LTD",
     "symbol": "CAEEF"
    },
    {
     "description": "CALIFORNIA-ENGELS MINING CO",
     "symbol": "CAEN"
    },
    {
     "description": "CHINA EAST EDUCATION HOLDING",
     "symbol": "CAETF"
    },
    {
     "description": "MORGAN STANLEY CHINA A SHARE",
     "symbol": "CAF"
    },
    {
     "description": "CONSUMER AUTOMOTIVE FINANCE",
     "symbol": "CAFI"
    },
    {
     "description": "BIOQUEST CORP",
     "symbol": "CAFS"
    },
    {
     "description": "CANAF INVESTMENTS INC",
     "symbol": "CAFZF"
    },
    {
     "description": "CONAGRA BRANDS INC",
     "symbol": "CAG"
    },
    {
     "description": "CRYPTOLOGY ASSET GROUP PLC",
     "symbol": "CAGPF"
    },
    {
     "description": "CALIFORNIA GRAPES INTERNATIO",
     "symbol": "CAGR"
    },
    {
     "description": "CASTLE GROUP INC",
     "symbol": "CAGU"
    },
    {
     "description": "CARDINAL HEALTH INC",
     "symbol": "CAH"
    },
    {
     "description": "CARRIER ALLIANCE HOLDINGS IN",
     "symbol": "CAHI"
    },
    {
     "description": "CARO HOLDINGS INC",
     "symbol": "CAHO"
    },
    {
     "description": "EVOLUTION MINING LTD",
     "symbol": "CAHPF"
    },
    {
     "description": "CA IMMOBILIEN ANLAGEN AG",
     "symbol": "CAIAF"
    },
    {
     "description": "CALIFORNIA INTERNATIONAL BAN",
     "symbol": "CAIB"
    },
    {
     "description": "CHIA TAI ENTERPRISES INTERNA",
     "symbol": "CAIHF"
    },
    {
     "description": "CAIXABANK- UNSPON ADR",
     "symbol": "CAIXY"
    },
    {
     "description": "CANON INC-SPONS ADR",
     "symbol": "CAJ"
    },
    {
     "description": "CANON INC",
     "symbol": "CAJFF"
    },
    {
     "description": "C&J ENERGY SERVICES INC-CW24",
     "symbol": "CAJSW"
    },
    {
     "description": "CHEESECAKE FACTORY INC\/THE",
     "symbol": "CAKE"
    },
    {
     "description": "MCKESSON EUROPE AG",
     "symbol": "CAKFF"
    },
    {
     "description": "MCKESSON EUROPE AG -   ADR",
     "symbol": "CAKFY"
    },
    {
     "description": "CALERES INC",
     "symbol": "CAL"
    },
    {
     "description": "CALITHERA BIOSCIENCES INC",
     "symbol": "CALA"
    },
    {
     "description": "CALIFORNIA BANCORP INC",
     "symbol": "CALB"
    },
    {
     "description": "CALEDONIA INVESTMENTS PLC",
     "symbol": "CALEF"
    },
    {
     "description": "PACER US SMALL CAP CASH COWS",
     "symbol": "CALF"
    },
    {
     "description": "CHINA AUTO LOGISTICS INC",
     "symbol": "CALI"
    },
    {
     "description": "CAL-MAINE FOODS INC",
     "symbol": "CALM"
    },
    {
     "description": "CALIDUS RESOURCES LTD",
     "symbol": "CALRF"
    },
    {
     "description": "CALLIDITAS THERAPEUTICS-ADR",
     "symbol": "CALT"
    },
    {
     "description": "CALIX INC",
     "symbol": "CALX"
    },
    {
     "description": "POLYNOVO LTD",
     "symbol": "CALZF"
    },
    {
     "description": "CAM GROUP INC",
     "symbol": "CAMG"
    },
    {
     "description": "CENTRAL ASIA METALS PLC",
     "symbol": "CAMLF"
    },
    {
     "description": "CALAMP CORP",
     "symbol": "CAMP"
    },
    {
     "description": "CAMURUS AB",
     "symbol": "CAMRF"
    },
    {
     "description": "CAMTEK LTD",
     "symbol": "CAMT"
    },
    {
     "description": "CAMINO MINERALS CORP",
     "symbol": "CAMZF"
    },
    {
     "description": "CANAAN INC",
     "symbol": "CAN"
    },
    {
     "description": "CAN B CORP",
     "symbol": "CANB"
    },
    {
     "description": "TEUCRIUM SUGAR FUND",
     "symbol": "CANE"
    },
    {
     "description": "CAN FITE BIOPHARMA LTD-ADR",
     "symbol": "CANF"
    },
    {
     "description": "CANGO INC\/KY - ADR",
     "symbol": "CANG"
    },
    {
     "description": "CANNLABS INC",
     "symbol": "CANL"
    },
    {
     "description": "GENERAL CANNABIS CORP",
     "symbol": "CANN"
    },
    {
     "description": "CANO HEALTH INC",
     "symbol": "CANO"
    },
    {
     "description": "JAWS ACQUISTION-CW25",
     "symbol": "CANO.WS"
    },
    {
     "description": "CALIFORNIA NANOTECHNOLOGIES",
     "symbol": "CANOF"
    },
    {
     "description": "CANAQUEST MEDICAL CORP",
     "symbol": "CANQF"
    },
    {
     "description": "WILLOW BIOSCIENCES INC",
     "symbol": "CANSF"
    },
    {
     "description": "ORCA GOLD INC",
     "symbol": "CANWF"
    },
    {
     "description": "CANNAWAKE CORP",
     "symbol": "CANX"
    },
    {
     "description": "CANYON SILVER MINES INC",
     "symbol": "CANY"
    },
    {
     "description": "CANON ELECTRONICS INC",
     "symbol": "CAOEF"
    },
    {
     "description": "FDG ELECTRIC VEHICLES LTD",
     "symbol": "CAOHF"
    },
    {
     "description": "CHINA AVIATION OIL SINGAPORE",
     "symbol": "CAOLF"
    },
    {
     "description": "CHINA OVERSEAS LAND & INVEST",
     "symbol": "CAOVF"
    },
    {
     "description": "CHINA OVERSEAS LAN-UNSPN ADR",
     "symbol": "CAOVY"
    },
    {
     "description": "CALIFORNIA ORCHARDS CO",
     "symbol": "CAOX"
    },
    {
     "description": "CHINA AOYUAN GROUP LTD",
     "symbol": "CAOYF"
    },
    {
     "description": "CAPITALSOUTH BANCORP",
     "symbol": "CAPB"
    },
    {
     "description": "CAPSTONE COMPANIES INC",
     "symbol": "CAPC"
    },
    {
     "description": "IPATH SHILLER CAPE ETN",
     "symbol": "CAPD"
    },
    {
     "description": "CROSSAMERICA PARTNERS LP",
     "symbol": "CAPL"
    },
    {
     "description": "CAPGEMINI SE",
     "symbol": "CAPMF"
    },
    {
     "description": "CAPSTONE FINANCIAL GROUP INC",
     "symbol": "CAPP"
    },
    {
     "description": "CAPRICOR THERAPEUTICS INC",
     "symbol": "CAPR"
    },
    {
     "description": "CAPSTONE THERAPEUTICS CORP",
     "symbol": "CAPS"
    },
    {
     "description": "CAPITAN MINING INC",
     "symbol": "CAPTF"
    },
    {
     "description": "CABO VERDE CAPITAL INC",
     "symbol": "CAPV"
    },
    {
     "description": "AVIS BUDGET GROUP INC",
     "symbol": "CAR"
    },
    {
     "description": "CARA THERAPEUTICS INC",
     "symbol": "CARA"
    },
    {
     "description": "CHINA RESOURCES CEMENT-ADR",
     "symbol": "CARCY"
    },
    {
     "description": "CARTER BANKSHARES INC",
     "symbol": "CARE"
    },
    {
     "description": "CARGURUS INC",
     "symbol": "CARG"
    },
    {
     "description": "CARRIER GLOBAL CORP",
     "symbol": "CARR"
    },
    {
     "description": "CARS.COM INC",
     "symbol": "CARS"
    },
    {
     "description": "CARVER BANCORP INC",
     "symbol": "CARV"
    },
    {
     "description": "FIRST TRUST S-NETWORK FUTURE",
     "symbol": "CARZ"
    },
    {
     "description": "CASCADE ACQUISITION COR-CL A",
     "symbol": "CAS"
    },
    {
     "description": "CASCADE ACQUISITION CORP",
     "symbol": "CAS.U"
    },
    {
     "description": "CASCADE ACQUISITION COR-CW27",
     "symbol": "CAS.WS"
    },
    {
     "description": "CASA SYSTEMS INC",
     "symbol": "CASA"
    },
    {
     "description": "CANSINO BIOLOGICS INC-H",
     "symbol": "CASBF"
    },
    {
     "description": "CANADIAN AEROSPACE GROUP INT",
     "symbol": "CASG"
    },
    {
     "description": "META FINANCIAL GROUP INC",
     "symbol": "CASH"
    },
    {
     "description": "CASI PHARMACEUTICALS INC",
     "symbol": "CASI"
    },
    {
     "description": "CASS INFORMATION SYSTEMS INC",
     "symbol": "CASS"
    },
    {
     "description": "CASA MINERALS INC",
     "symbol": "CASXF"
    },
    {
     "description": "CASEY'S GENERAL STORES INC",
     "symbol": "CASY"
    },
    {
     "description": "CATERPILLAR INC",
     "symbol": "CAT"
    },
    {
     "description": "CAMBRIDGE BANCORP",
     "symbol": "CATC"
    },
    {
     "description": "CAPSTONE TECHNOLOGIES GROUP",
     "symbol": "CATG"
    },
    {
     "description": "GLOBAL X S&P 500 CA VAL ETF",
     "symbol": "CATH"
    },
    {
     "description": "CLONE ALGO TECHNOLOGIES INC",
     "symbol": "CATI"
    },
    {
     "description": "CATSKILL LITIGATION TRUST",
     "symbol": "CATKU"
    },
    {
     "description": "CAT9 GROUP INC",
     "symbol": "CATN"
    },
    {
     "description": "CATO CORP-CLASS A",
     "symbol": "CATO"
    },
    {
     "description": "GIYANI METALS CORP",
     "symbol": "CATPF"
    },
    {
     "description": "CAT STRATEGIC METALS CORP",
     "symbol": "CATTF"
    },
    {
     "description": "4CABLE TV INTERNATIONAL INC",
     "symbol": "CATV"
    },
    {
     "description": "CHINA TONTINE WINES GROUP",
     "symbol": "CATWF"
    },
    {
     "description": "CATHAY GENERAL BANCORP",
     "symbol": "CATY"
    },
    {
     "description": "CAPRAL LTD",
     "symbol": "CAUFF"
    },
    {
     "description": "CAULDRON ENERGY LTD",
     "symbol": "CAULF"
    },
    {
     "description": "CAMBRIA AUTOMOBILES PLC",
     "symbol": "CAUTF"
    },
    {
     "description": "CENTAUR MEDIA PLC",
     "symbol": "CAUUF"
    },
    {
     "description": "CAVOTEC SA",
     "symbol": "CAVEF"
    },
    {
     "description": "ACC AVIATION HOLDINGS LTD",
     "symbol": "CAVG"
    },
    {
     "description": "CAVU RESOURCES INC",
     "symbol": "CAVR"
    },
    {
     "description": "CAVU MINING CORP",
     "symbol": "CAVVF"
    },
    {
     "description": "CWC ENERGY SERVICES CORP",
     "symbol": "CAWLF"
    },
    {
     "description": "CCA INDUSTRIES INC",
     "symbol": "CAWW"
    },
    {
     "description": "DISTRICT COPPER CORP",
     "symbol": "CAXPF"
    },
    {
     "description": "CATAPULT GROUP INTERNATIONAL",
     "symbol": "CAZGF"
    },
    {
     "description": "CHUBB LTD",
     "symbol": "CB"
    },
    {
     "description": "CITBA FINANCIAL CORP",
     "symbol": "CBAF"
    },
    {
     "description": "COLONY BANKCORP",
     "symbol": "CBAN"
    },
    {
     "description": "PLA ADMINISTRADORA INDUSTRIA",
     "symbol": "CBAOF"
    },
    {
     "description": "CBAK ENERGY TECHNOLOGY INC",
     "symbol": "CBAT"
    },
    {
     "description": "COMMONWEALTH BANK OF AUSTRAL",
     "symbol": "CBAUF"
    },
    {
     "description": "CYMABAY THERAPEUTICS INC",
     "symbol": "CBAY"
    },
    {
     "description": "CONTINENTAL BEVERAGE BRANDS",
     "symbol": "CBBB"
    },
    {
     "description": "COBALT BLUE HOLDINGS LTD",
     "symbol": "CBBHF"
    },
    {
     "description": "CBB BANCORP INC",
     "symbol": "CBBI"
    },
    {
     "description": "CBLT INC",
     "symbol": "CBBLF"
    },
    {
     "description": "VIRGIN MONEY UK PLC",
     "symbol": "CBBYF"
    },
    {
     "description": "CROWN BAUS CAPITAL CORP",
     "symbol": "CBCA"
    },
    {
     "description": "CALBEE INC",
     "symbol": "CBCFF"
    },
    {
     "description": "Colonial Capital Trust",
     "symbol": "CBCPQ"
    },
    {
     "description": "CENTRAL BANCOMPANY",
     "symbol": "CBCY"
    },
    {
     "description": "CENTRAL BANCOMPANY-CL B NVTG",
     "symbol": "CBCYB"
    },
    {
     "description": "COMUNIBANC CORP",
     "symbol": "CBCZ"
    },
    {
     "description": "CIA BRASILEIRA DE DIS- ADR",
     "symbol": "CBD"
    },
    {
     "description": "Companhia Brasileira de Distribuicao",
     "symbol": "CBD.WI"
    },
    {
     "description": "CBD OF DENVER INC",
     "symbol": "CBDD"
    },
    {
     "description": "BLUENRGY GROUP LTD",
     "symbol": "CBDEF"
    },
    {
     "description": "THC FARMACEUTICALS INC",
     "symbol": "CBDG"
    },
    {
     "description": "HEMPFUSION WELLNESS INC",
     "symbol": "CBDHF"
    },
    {
     "description": "CBD LIFE SCIENCES INC",
     "symbol": "CBDL"
    },
    {
     "description": "CBD GLOBAL SCIENCES INC",
     "symbol": "CBDNF"
    },
    {
     "description": "CANNABIS SATIVA INC",
     "symbol": "CBDS"
    },
    {
     "description": "CURATIVE BIOSCIENCES INC",
     "symbol": "CBDX"
    },
    {
     "description": "TARGET GROUP INC",
     "symbol": "CBDY"
    },
    {
     "description": "CABO DRILLING CORP",
     "symbol": "CBEEF"
    },
    {
     "description": "CAMBEX CORP",
     "symbol": "CBEX"
    },
    {
     "description": "CNB FINANCIAL SERVICES INC",
     "symbol": "CBFC"
    },
    {
     "description": "CB FINANCIAL SERVICES INC",
     "symbol": "CBFV"
    },
    {
     "description": "CHINA YIBAI UNITED GUARANTEE",
     "symbol": "CBGH"
    },
    {
     "description": "CANNABUSINESS GROUP INC",
     "symbol": "CBGI"
    },
    {
     "description": "CB GELDMARKT DE I-A EUR",
     "symbol": "CBGKF"
    },
    {
     "description": "CANNABIS GLOBAL INC",
     "symbol": "CBGL"
    },
    {
     "description": "CLOSE BROTHERS GROUP PLC",
     "symbol": "CBGPF"
    },
    {
     "description": "CLOSE BROTHERS GRP-UNSP ADR",
     "symbol": "CBGPY"
    },
    {
     "description": "CABRAL GOLD INC",
     "symbol": "CBGZF"
    },
    {
     "description": "VIRTUS ALLIANZGI CVRT 2024",
     "symbol": "CBH"
    },
    {
     "description": "CBC HOLDING CO",
     "symbol": "CBHC"
    },
    {
     "description": "CALIFORNIA BEACH RESTAURANTS",
     "symbol": "CBHR"
    },
    {
     "description": "CANOPUS BIOPHARMA INC",
     "symbol": "CBIA"
    },
    {
     "description": "CATALYST BIOSCIENCES INC",
     "symbol": "CBIO"
    },
    {
     "description": "CARNA BIOSCIENCES INC",
     "symbol": "CBIXF"
    },
    {
     "description": "Cabco Trust For J C Penney",
     "symbol": "CBJCL"
    },
    {
     "description": "CHRISTOPHER & BANKS CORP",
     "symbol": "CBKCQ"
    },
    {
     "description": "CONSUMERS BANCORP INC",
     "symbol": "CBKM"
    },
    {
     "description": "Cobank ACB",
     "symbol": "CBKPP"
    },
    {
     "description": "CBL & ASSOCIATES PROPERTIES",
     "symbol": "CBL"
    },
    {
     "description": "MERSEN",
     "symbol": "CBLNF"
    },
    {
     "description": "CARBONE LORRAINE-UNSP ADR",
     "symbol": "CBLNY"
    },
    {
     "description": "CAMPBELL RESOURCES INC",
     "symbol": "CBLRF"
    },
    {
     "description": "CHANGEBRIDGE CAPITAL LONG\/SH",
     "symbol": "CBLS"
    },
    {
     "description": "CHINA BLUECHEMICAL LTD - H",
     "symbol": "CBLUF"
    },
    {
     "description": "CHINA BLUECHEMICAL-UNSP ADR",
     "symbol": "CBLUY"
    },
    {
     "description": "CBM BANCORP INC",
     "symbol": "CBMB"
    },
    {
     "description": "CBM ASIA DEVELOPMENT CORP",
     "symbol": "CBMDF"
    },
    {
     "description": "CSB BANCORP INC\/MI",
     "symbol": "CBMI"
    },
    {
     "description": "CONSERVATIVE MEDIA BROADCAST",
     "symbol": "CBMJ"
    },
    {
     "description": "CAPITAL BANCORP INC\/MD",
     "symbol": "CBNK"
    },
    {
     "description": "C-BOND SYSTEMS INC",
     "symbol": "CBNT"
    },
    {
     "description": "Test",
     "symbol": "CBO"
    },
    {
     "description": "BAY COMMUNITY BANCORP",
     "symbol": "CBOBA"
    },
    {
     "description": "CBOE GLOBAL MARKETS INC",
     "symbol": "CBOE"
    },
    {
     "description": "CBOA FINANCIAL INC",
     "symbol": "CBOF"
    },
    {
     "description": "VANECK CHINA BOND ETF",
     "symbol": "CBON"
    },
    {
     "description": "CHINA BOTANIC PHARMACEUTICAL",
     "symbol": "CBPI"
    },
    {
     "description": "CBRE GROUP INC - A",
     "symbol": "CBRE"
    },
    {
     "description": "CHAIN BRIDGE I-A",
     "symbol": "CBRG"
    },
    {
     "description": "CHAIN BRIDGE I",
     "symbol": "CBRGU"
    },
    {
     "description": "CHAIN BRIDGE I-A -CW28",
     "symbol": "CBRGW"
    },
    {
     "description": "CMTSU LIQUIDATION INC",
     "symbol": "CBRI"
    },
    {
     "description": "CARBON RACE CORP",
     "symbol": "CBRJ"
    },
    {
     "description": "CRACKER BARREL OLD COUNTRY",
     "symbol": "CBRL"
    },
    {
     "description": "CHAMPION BEAR RESOURCES LTD",
     "symbol": "CBRSF"
    },
    {
     "description": "CB SCIENTIFIC INC",
     "symbol": "CBSC"
    },
    {
     "description": "CHANGEBRIDGE CAPITAL SUST EQ",
     "symbol": "CBSE"
    },
    {
     "description": "COMMERCE BANCSHARES INC",
     "symbol": "CBSH"
    },
    {
     "description": "CENTRAL BANK CORPORATION\/MI",
     "symbol": "CBSU"
    },
    {
     "description": "CYBERNET SYSTEMS CO",
     "symbol": "CBSZF"
    },
    {
     "description": "CABOT CORP",
     "symbol": "CBT"
    },
    {
     "description": "XTRA BITCOIN INC",
     "symbol": "CBTC"
    },
    {
     "description": "CANNABOTECH LTD",
     "symbol": "CBTEF"
    },
    {
     "description": "CITIZENS BANCORP INVESTMEN-A",
     "symbol": "CBTN"
    },
    {
     "description": "Corporate Backed Call Trust CTFS JC Penney",
     "symbol": "CBTRP"
    },
    {
     "description": "CATHEDRA BITCOIN INC",
     "symbol": "CBTTF"
    },
    {
     "description": "CBTX INC",
     "symbol": "CBTX"
    },
    {
     "description": "COMMUNITY BANK SYSTEM INC",
     "symbol": "CBU"
    },
    {
     "description": "CASHBUILD LTD-UNSP ADR",
     "symbol": "CBUDY"
    },
    {
     "description": "COMMODORE INTL LTD",
     "symbol": "CBUIF"
    },
    {
     "description": "GRATOMIC INC",
     "symbol": "CBULF"
    },
    {
     "description": "CHINA NATIONAL BUILDING MA-H",
     "symbol": "CBUMF"
    },
    {
     "description": "CHINA NATL BDG-UNSPON ADR",
     "symbol": "CBUMY"
    },
    {
     "description": "CLEAR BLUE TECHNOLOGIES INTE",
     "symbol": "CBUTF"
    },
    {
     "description": "COBRA VENTURE CORP",
     "symbol": "CBVTF"
    },
    {
     "description": "COMMENCEMENT BANCORP INC",
     "symbol": "CBWA"
    },
    {
     "description": "CANADIAN WESTERN BANK",
     "symbol": "CBWBF"
    },
    {
     "description": "AUXLY CANNABIS GROUP INC",
     "symbol": "CBWTF"
    },
    {
     "description": "TEST",
     "symbol": "CBX"
    },
    {
     "description": "CORBY SPIRIT AND WINE LTD",
     "symbol": "CBYDF"
    },
    {
     "description": "CAL-BAY INTL INC",
     "symbol": "CBYI"
    },
    {
     "description": "CBIZ INC",
     "symbol": "CBZ"
    },
    {
     "description": "CHEMOURS CO\/THE",
     "symbol": "CC"
    },
    {
     "description": "CASCADIA ACQUISITION CO-CL A",
     "symbol": "CCAI"
    },
    {
     "description": "CASCADIA ACQUISITION CORP",
     "symbol": "CCAIU"
    },
    {
     "description": "CASCADIA ACQUISITION -CW23",
     "symbol": "CCAIW"
    },
    {
     "description": "COASTAL CAPITAL ACQUISITION",
     "symbol": "CCAJ"
    },
    {
     "description": "CRESCENT CAPITAL BDC INC",
     "symbol": "CCAP"
    },
    {
     "description": "COLONIAL COAL INTERNATIONAL",
     "symbol": "CCARF"
    },
    {
     "description": "COASTAL FINANCIAL CORP\/WA",
     "symbol": "CCB"
    },
    {
     "description": "CHINO COMMERCIAL BANCORP",
     "symbol": "CCBC"
    },
    {
     "description": "CAPITAL CITY BANK GROUP INC",
     "symbol": "CCBG"
    },
    {
     "description": "C4 THERAPEUTICS INC",
     "symbol": "CCCC"
    },
    {
     "description": "CITY CHIC COLLECTIVE LTD",
     "symbol": "CCCHF"
    },
    {
     "description": "CHINA CABLE & COMMUNICATION",
     "symbol": "CCCI"
    },
    {
     "description": "CANCOM SE",
     "symbol": "CCCMF"
    },
    {
     "description": "CCC INTELLIGENT SOLUTIONS HO",
     "symbol": "CCCS"
    },
    {
     "description": "CALAMOS DYNAMIC CONVERTIBLE",
     "symbol": "CCD"
    },
    {
     "description": "CCL INDUSTRIES INC - CL B",
     "symbol": "CCDBF"
    },
    {
     "description": "CAN DO CO LTD",
     "symbol": "CCDOF"
    },
    {
     "description": "CASCADERO COPPER CORP",
     "symbol": "CCEDF"
    },
    {
     "description": "CARCLO PLC",
     "symbol": "CCEGF"
    },
    {
     "description": "CRYO-CELL INTL INC",
     "symbol": "CCEL"
    },
    {
     "description": "COCA-COLA EUROPACIFIC PARTNE",
     "symbol": "CCEP"
    },
    {
     "description": "CHASE CORP",
     "symbol": "CCF"
    },
    {
     "description": "CCSB FINANCIAL CORP",
     "symbol": "CCFC"
    },
    {
     "description": "CCFNB BANCORP INC",
     "symbol": "CCFN"
    },
    {
     "description": "CROWN CONFECTIONERY\/NEW-PREF",
     "symbol": "CCFYF"
    },
    {
     "description": "CHINA CINDA ASSET MANAGEME-H",
     "symbol": "CCGDF"
    },
    {
     "description": "CHINA SHANSHUI CEMENT GROUP",
     "symbol": "CCGLF"
    },
    {
     "description": "CHINA CGAME INC",
     "symbol": "CCGM"
    },
    {
     "description": "C&C GROUP PLC -  UNSP ADR",
     "symbol": "CCGPY"
    },
    {
     "description": "CHINA CLEAN ENERGY INC",
     "symbol": "CCGY"
    },
    {
     "description": "COCA-COLA HBC AG-DI",
     "symbol": "CCHBF"
    },
    {
     "description": "COCA-COLA HBC AG-UNSP ADR",
     "symbol": "CCHGY"
    },
    {
     "description": "CAMBRIDGE CAPITAL HOLDINGS I",
     "symbol": "CCHI"
    },
    {
     "description": "CENTRAL CHINA MANAGEMENT CO",
     "symbol": "CCHMF"
    },
    {
     "description": "COLUMBIA CARE INC",
     "symbol": "CCHWF"
    },
    {
     "description": "CAREER COLLEGE HOLDING CO IN",
     "symbol": "CCHZ"
    },
    {
     "description": "CROWN CASTLE INTL CORP",
     "symbol": "CCI"
    },
    {
     "description": "Canadian Imperial Bank",
     "symbol": "CCIXF"
    },
    {
     "description": "CAMECO CORP",
     "symbol": "CCJ"
    },
    {
     "description": "CROWN HOLDINGS INC",
     "symbol": "CCK"
    },
    {
     "description": "CCK CONSOLIDATED-CW23",
     "symbol": "CCKWF"
    },
    {
     "description": "CARNIVAL CORP",
     "symbol": "CCL"
    },
    {
     "description": "CCL INDUSTRIES - CL A",
     "symbol": "CCLLF"
    },
    {
     "description": "CSI COMPRESSCO LP",
     "symbol": "CCLP"
    },
    {
     "description": "CABLECLIX (USA) INC",
     "symbol": "CCLX"
    },
    {
     "description": "CONCORD MEDICAL - SPON ADR",
     "symbol": "CCM"
    },
    {
     "description": "CALLAHAN CONS MINES INC",
     "symbol": "CCMN"
    },
    {
     "description": "CMC MATERIALS INC",
     "symbol": "CCMP"
    },
    {
     "description": "COMPLETE CARE MEDICAL INC",
     "symbol": "CCMZ"
    },
    {
     "description": "COASTAL CAROLINA BANCSHARES",
     "symbol": "CCNB"
    },
    {
     "description": "CODE CHAIN NEW CONTINENT LTD",
     "symbol": "CCNC"
    },
    {
     "description": "KAIZEN DISCOVERY INC",
     "symbol": "CCNCF"
    },
    {
     "description": "CODE CHAIN-CW23",
     "symbol": "CCNCW"
    },
    {
     "description": "CNB FINANCIAL CORP\/PA",
     "symbol": "CCNE"
    },
    {
     "description": "CNB FINANCIAL CORP\/PA",
     "symbol": "CCNEP"
    },
    {
     "description": "CONNECTED IO LTD",
     "symbol": "CCNNF"
    },
    {
     "description": "CONCENTRIC AB",
     "symbol": "CCNTF"
    },
    {
     "description": "CLEAR CHANNEL OUTDOOR HOLDIN",
     "symbol": "CCO"
    },
    {
     "description": "CENTURY COBALT CORP",
     "symbol": "CCOB"
    },
    {
     "description": "CAPCOM CO LTD",
     "symbol": "CCOEF"
    },
    {
     "description": "CAPCOM CO LTD - ADR UNSPON",
     "symbol": "CCOEY"
    },
    {
     "description": "CHINA STATE CONSTRUCTION INT",
     "symbol": "CCOHF"
    },
    {
     "description": "COGENT COMMUNICATIONS HOLDIN",
     "symbol": "CCOI"
    },
    {
     "description": "COCA-COLA BOTTLERS JAPAN HOL",
     "symbol": "CCOJF"
    },
    {
     "description": "COCA-COLA BOTTLERS-UNSP ADR",
     "symbol": "CCOJY"
    },
    {
     "description": "CCOM GROUP INC",
     "symbol": "CCOM"
    },
    {
     "description": "CCOM Group Inc",
     "symbol": "CCOMP"
    },
    {
     "description": "CORE ASSETS CORP",
     "symbol": "CCOOF"
    },
    {
     "description": "CORE ALTERNATIVE ETF",
     "symbol": "CCOR"
    },
    {
     "description": "CANACCORD GENUITY GROUP INC",
     "symbol": "CCORF"
    },
    {
     "description": "CANDENTE COPPER CORP",
     "symbol": "CCOXF"
    },
    {
     "description": "CHINA COAL ENERGY CO-H",
     "symbol": "CCOZF"
    },
    {
     "description": "CHINA COAL ENERGY-UNSPON ADR",
     "symbol": "CCOZY"
    },
    {
     "description": "CAPITAL & COUNTIES PROPERTIE",
     "symbol": "CCPPF"
    },
    {
     "description": "CASEYCORP ENTERPRISES INC",
     "symbol": "CCPR"
    },
    {
     "description": "CANADA COMPUTATIONAL UNLIMIT",
     "symbol": "CCPUF"
    },
    {
     "description": "CORECARD CORP",
     "symbol": "CCRD"
    },
    {
     "description": "CONCORDIA FINANCIAL GROUP LT",
     "symbol": "CCRDF"
    },
    {
     "description": "CROSS COUNTRY HEALTHCARE INC",
     "symbol": "CCRN"
    },
    {
     "description": "GREEN RIVER GOLD CORP",
     "symbol": "CCRRF"
    },
    {
     "description": "ISHARES COMM CURVE CARRY STR",
     "symbol": "CCRV"
    },
    {
     "description": "CENTURY COMMUNITIES INC",
     "symbol": "CCS"
    },
    {
     "description": "CONSENSUS CLOUD SOLUTION",
     "symbol": "CCSI"
    },
    {
     "description": "CLEAN COAL TECHNOLOGIES INC",
     "symbol": "CCTC"
    },
    {
     "description": "COIN CITADEL",
     "symbol": "CCTL"
    },
    {
     "description": "CARE2.COM INC",
     "symbol": "CCTM"
    },
    {
     "description": "CHINA CRESCENT ENTERPRISES",
     "symbol": "CCTR"
    },
    {
     "description": "CACTUS ACQUISITION CORP 1 LT",
     "symbol": "CCTS"
    },
    {
     "description": "CACTUS ACQUISITION CORP 1 LT",
     "symbol": "CCTSU"
    },
    {
     "description": "CACTUS ACQUISITION CORP-CW23",
     "symbol": "CCTSW"
    },
    {
     "description": "CITIC TELECOM INTERNATIONAL",
     "symbol": "CCTTF"
    },
    {
     "description": "CIA CERVECERIAS UNI-SPON ADR",
     "symbol": "CCU"
    },
    {
     "description": "CCUR HOLDINGS INC",
     "symbol": "CCUR"
    },
    {
     "description": "CHURCHILL CAPITAL CORP V-A",
     "symbol": "CCV"
    },
    {
     "description": "CHURCHILL CAPITAL CORP V",
     "symbol": "CCV.U"
    },
    {
     "description": "CHURCHILL CAP V CL A -CW27",
     "symbol": "CCV.WS"
    },
    {
     "description": "COUNTRY CLUB OF VIRGINIA INC",
     "symbol": "CCVAJ"
    },
    {
     "description": "CHURCHILL CAPITAL CORP VI-A",
     "symbol": "CCVI"
    },
    {
     "description": "CHURCHILL CAPITAL CORP VI",
     "symbol": "CCVI.U"
    },
    {
     "description": "CHURCHILL CAP VI CL A -CW27",
     "symbol": "CCVI.WS"
    },
    {
     "description": "CROWN CAP VENTURES LTD",
     "symbol": "CCVL"
    },
    {
     "description": "CITIZENS COMMERCE BANCSHARES",
     "symbol": "CCVS"
    },
    {
     "description": "CHINA CONCH VENTURE HOLDINGS",
     "symbol": "CCVTF"
    },
    {
     "description": "CHURCH & CRAWFORD INC",
     "symbol": "CCWF"
    },
    {
     "description": "CANADA SILVER COBALT WORKS I",
     "symbol": "CCWOF"
    },
    {
     "description": "CHEMOCENTRYX INC",
     "symbol": "CCXI"
    },
    {
     "description": "CLANCY CORP",
     "symbol": "CCYC"
    },
    {
     "description": "CYAN AG",
     "symbol": "CCYNF"
    },
    {
     "description": "Lehman ABS Corp",
     "symbol": "CCYPQ"
    },
    {
     "description": "CCCB BANCORP INC",
     "symbol": "CCYY"
    },
    {
     "description": "Comcast Holdings Corporation",
     "symbol": "CCZ"
    },
    {
     "description": "CHINDATA GROUP HOLDINGS-ADR",
     "symbol": "CD"
    },
    {
     "description": "COEUR D'ALENE BANCORP INC",
     "symbol": "CDAB"
    },
    {
     "description": "CODIAK BIOSCIENCES INC",
     "symbol": "CDAK"
    },
    {
     "description": "COMPASS DIGITAL ACQUISITION",
     "symbol": "CDAQ"
    },
    {
     "description": "COMPASS DIGITAL ACQUISITION",
     "symbol": "CDAQU"
    },
    {
     "description": "COMPASS DIGITAL ACQ -CW23",
     "symbol": "CDAQW"
    },
    {
     "description": "CERIDIAN HCM HOLDING INC",
     "symbol": "CDAY"
    },
    {
     "description": "CORDOBA MINERALS CORP",
     "symbol": "CDBMF"
    },
    {
     "description": "CHINA DASHENG BIOTECHNOLOGY",
     "symbol": "CDBT"
    },
    {
     "description": "VICTORYSHARES US EQ INCOME E",
     "symbol": "CDC"
    },
    {
     "description": "GOLDCREST CO LTD",
     "symbol": "CDCTF"
    },
    {
     "description": "HEADWATER EXPLORATION INC",
     "symbol": "CDDRF"
    },
    {
     "description": "COEUR MINING INC",
     "symbol": "CDE"
    },
    {
     "description": "CREDITO EMILIANO SPA",
     "symbol": "CDEFF"
    },
    {
     "description": "CANDELARIA MINING CORP",
     "symbol": "CDELF"
    },
    {
     "description": "CENTENNIAL RESOURCE DEVELO-A",
     "symbol": "CDEV"
    },
    {
     "description": "CITY DEVELOPMENTS LTD",
     "symbol": "CDEVF"
    },
    {
     "description": "CITY DEVELOPMENTS-SPONS ADR",
     "symbol": "CDEVY"
    },
    {
     "description": "CARDIEX LTD",
     "symbol": "CDEXF"
    },
    {
     "description": "CITADEL EFT INC",
     "symbol": "CDFT"
    },
    {
     "description": "COMFORTDELGRO CORP LTD",
     "symbol": "CDGLF"
    },
    {
     "description": "COMFORTDELGRO CORP-UNSP ADR",
     "symbol": "CDGLY"
    },
    {
     "description": "CHINA DONGXIANG GROUP CO",
     "symbol": "CDGXF"
    },
    {
     "description": "CHINA DONGXIANG GRP-UNSP ADR",
     "symbol": "CDGXY"
    },
    {
     "description": "CDL HOSPITALITY TRUSTS",
     "symbol": "CDHSF"
    },
    {
     "description": "QUAD ENERGY CORP",
     "symbol": "CDID"
    },
    {
     "description": "C&D INTERNATIONAL INVESTMENT",
     "symbol": "CDIGF"
    },
    {
     "description": "CD INTERNATIONAL ENTERPRISES",
     "symbol": "CDIIQ"
    },
    {
     "description": "CASCADIA INVESTMENTS INC",
     "symbol": "CDIV"
    },
    {
     "description": "CARDIFF LEXINGTON CORP",
     "symbol": "CDIX"
    },
    {
     "description": "CARNEGIE DEVELOPMENT INC",
     "symbol": "CDJM"
    },
    {
     "description": "CDK GLOBAL INC",
     "symbol": "CDK"
    },
    {
     "description": "VICTORYSHARES US LARGE CAP H",
     "symbol": "CDL"
    },
    {
     "description": "COMPANHIA DE LOCACAO-SPN ADR",
     "symbol": "CDLDY"
    },
    {
     "description": "CARDLYTICS INC",
     "symbol": "CDLX"
    },
    {
     "description": "ICADE",
     "symbol": "CDMGF"
    },
    {
     "description": "AVID BIOSERVICES INC",
     "symbol": "CDMO"
    },
    {
     "description": "CAREDX INC",
     "symbol": "CDNA"
    },
    {
     "description": "CANADIAN TIRE CORP-CLASS A",
     "symbol": "CDNAF"
    },
    {
     "description": "CIA DE DISTRIBUCION INTEGRAL",
     "symbol": "CDNIF"
    },
    {
     "description": "GAMBIER GOLD CORP",
     "symbol": "CDNMF"
    },
    {
     "description": "CHINA INDUSTRIAL STEEL INC",
     "symbol": "CDNN"
    },
    {
     "description": "CONS CAPITAL NORTH AMERICA",
     "symbol": "CDNO"
    },
    {
     "description": "CADENCE DESIGN SYS INC",
     "symbol": "CDNS"
    },
    {
     "description": "CANADIAN TIRE CORP",
     "symbol": "CDNTF"
    },
    {
     "description": "Canadian Utilities Limited",
     "symbol": "CDNUF"
    },
    {
     "description": "CDON AB",
     "symbol": "CDOAF"
    },
    {
     "description": "CAN APARTMENT PROP REAL ESTA",
     "symbol": "CDPYF"
    },
    {
     "description": "CEDAR REALTY TRUST INC",
     "symbol": "CDR"
    },
    {
     "description": "CEDAR REALTY TRUST INC",
     "symbol": "CDR.PRB"
    },
    {
     "description": "CEDAR REALTY TRUST INC",
     "symbol": "CDR.PRC"
    },
    {
     "description": "CODE REBEL CORP",
     "symbol": "CDRBQ"
    },
    {
     "description": "CADRE HOLDINGS INC",
     "symbol": "CDRE"
    },
    {
     "description": "CODERE ONLINE LUXEMBOURG SA",
     "symbol": "CDRO"
    },
    {
     "description": "CODERE ONLINE LUXEMBOU -CW",
     "symbol": "CDROW"
    },
    {
     "description": "CYDSA SAB DE CV",
     "symbol": "CDSAF"
    },
    {
     "description": "CHINA DONGSHENG INTERNATIONA",
     "symbol": "CDSG"
    },
    {
     "description": "CARL DATA SOLUTIONS INC",
     "symbol": "CDTAF"
    },
    {
     "description": "CDTI ADVANCED MATERIALS INC",
     "symbol": "CDTI"
    },
    {
     "description": "CASTLE MINERALS LTD",
     "symbol": "CDTLF"
    },
    {
     "description": "CIDARA THERAPEUTICS INC",
     "symbol": "CDTX"
    },
    {
     "description": "CANADIAN UTILITIES LTD-A",
     "symbol": "CDUAF"
    },
    {
     "description": "Canadian Utilities Ltd ",
     "symbol": "CDUTF"
    },
    {
     "description": "CANADIAN UTILITIES LTD B",
     "symbol": "CDUUF"
    },
    {
     "description": "CAL DIVE INTERNATIONAL INC",
     "symbol": "CDVIQ"
    },
    {
     "description": "CARSON DEVELOPMENT CORP",
     "symbol": "CDVM"
    },
    {
     "description": "CDW CORP\/DE",
     "symbol": "CDW"
    },
    {
     "description": "CLOUDWARD INC",
     "symbol": "CDWD"
    },
    {
     "description": "SIMPLIFY HIGH YIELD PL CR HD",
     "symbol": "CDX"
    },
    {
     "description": "CHROMADEX CORP",
     "symbol": "CDXC"
    },
    {
     "description": "CLOUD DX INC",
     "symbol": "CDXFF"
    },
    {
     "description": "CARDAX INC",
     "symbol": "CDXI"
    },
    {
     "description": "CODEXIS INC",
     "symbol": "CDXS"
    },
    {
     "description": "CANADA 3000 INC",
     "symbol": "CDXTF"
    },
    {
     "description": "CHOICE CONSOLIDATION CORP",
     "symbol": "CDXXF"
    },
    {
     "description": "CADIZ INC",
     "symbol": "CDZI"
    },
    {
     "description": "CADIZ INC",
     "symbol": "CDZIP"
    },
    {
     "description": "CELANESE CORP",
     "symbol": "CE"
    },
    {
     "description": "CHINA EASTERN AIRLINES-ADS",
     "symbol": "CEA"
    },
    {
     "description": "CEA INDUSTRIES INC",
     "symbol": "CEAD"
    },
    {
     "description": "CEA INDUSTRIES INC -CW27",
     "symbol": "CEADW"
    },
    {
     "description": "CHINA EVERBRIGHT BANK CO L-H",
     "symbol": "CEBCF"
    },
    {
     "description": "CITYCHAMP WATCH & JEWELLERY",
     "symbol": "CEBTF"
    },
    {
     "description": "CEBU AIR INC",
     "symbol": "CEBUF"
    },
    {
     "description": "CEBU AIR INC-UNSPONSORED ADR",
     "symbol": "CEBUY"
    },
    {
     "description": "SALTBAE CAPITAL CORP",
     "symbol": "CECBF"
    },
    {
     "description": "CEC BRANDS LLC -CW25",
     "symbol": "CECBW"
    },
    {
     "description": "CECO ENVIRONMENTAL CORP",
     "symbol": "CECE"
    },
    {
     "description": "CENTRAL AND EASTERN EUROPE F",
     "symbol": "CEE"
    },
    {
     "description": "CERES INC\/JAPAN",
     "symbol": "CEEIF"
    },
    {
     "description": "UPSNAP INC\/CANADA",
     "symbol": "CEENF"
    },
    {
     "description": "SPROTT PHYSICAL GOLD AND SIL",
     "symbol": "CEF"
    },
    {
     "description": "GLOBAL X S&P CATH VAL DEVEL",
     "symbol": "CEFA"
    },
    {
     "description": "CENTRAL FLORIDA STATE BANK",
     "symbol": "CEFB"
    },
    {
     "description": "COMMERCIAL NATL FINL CORP\/MI",
     "symbol": "CEFC"
    },
    {
     "description": "ETRACS 150% CL END FUND ETN",
     "symbol": "CEFD"
    },
    {
     "description": "SABA CLOSED END FUNDS ETF",
     "symbol": "CEFS"
    },
    {
     "description": "CONSTELLATION ENERGY",
     "symbol": "CEG"
    },
    {
     "description": "CHINA EDUCATION GROUP HOLDIN",
     "symbol": "CEGHF"
    },
    {
     "description": "CERRO GRANDE MINING CORP",
     "symbol": "CEGMF"
    },
    {
     "description": "COSMO ENERGY HOLDINGS CO LTD",
     "symbol": "CEHCF"
    },
    {
     "description": "CHINA ELECTRONICS HOLDINGS",
     "symbol": "CEHD"
    },
    {
     "description": "CAMBER ENERGY INC",
     "symbol": "CEI"
    },
    {
     "description": "CONSOL ENERGY INC",
     "symbol": "CEIX"
    },
    {
     "description": "CRESCO LTD",
     "symbol": "CEJOF"
    },
    {
     "description": "CELCUITY INC",
     "symbol": "CELC"
    },
    {
     "description": "Bristol Myers Squibb Company",
     "symbol": "CELG.RT"
    },
    {
     "description": "CELSIUS HOLDINGS INC",
     "symbol": "CELH"
    },
    {
     "description": "CELLCOM ISRAEL LTD",
     "symbol": "CELJF"
    },
    {
     "description": "ANAGENICS LTD",
     "symbol": "CELMF"
    },
    {
     "description": "CYPRESS ENVIRONMENTAL PARTNE",
     "symbol": "CELP"
    },
    {
     "description": "CENTAMIN PLC",
     "symbol": "CELTF"
    },
    {
     "description": "CELULARITY INC",
     "symbol": "CELU"
    },
    {
     "description": "GX ACQUISITION CORP -CW26",
     "symbol": "CELUW"
    },
    {
     "description": "PREFERRED COMMERCE INC",
     "symbol": "CELV"
    },
    {
     "description": "CELEXPRESS INC",
     "symbol": "CELX"
    },
    {
     "description": "CREATIVE MEDICAL TECHNOLOGY",
     "symbol": "CELZ"
    },
    {
     "description": "CLEARBRIDGE MLP & MIDSTREAM",
     "symbol": "CEM"
    },
    {
     "description": "ISHARES JP MORGAN EM CORPORA",
     "symbol": "CEMB"
    },
    {
     "description": "CHEMBIO DIAGNOSTICS INC",
     "symbol": "CEMI"
    },
    {
     "description": "CENTER COAST BROOKFIELD MLP",
     "symbol": "CEN"
    },
    {
     "description": "CEN BIOTECH INC",
     "symbol": "CENBF"
    },
    {
     "description": "CARENET INC",
     "symbol": "CENEF"
    },
    {
     "description": "CENNTRO ELECTRIC GROUP LTD",
     "symbol": "CENN"
    },
    {
     "description": "CENAQ ENERGY CORP-CLASS A",
     "symbol": "CENQ"
    },
    {
     "description": "CENAQ ENERGY CORP",
     "symbol": "CENQU"
    },
    {
     "description": "CENAQ ENERGY CORP CL A -CW27",
     "symbol": "CENQW"
    },
    {
     "description": "CENTRAL GARDEN & PET CO",
     "symbol": "CENT"
    },
    {
     "description": "CENTRAL GARDEN AND PET CO-A",
     "symbol": "CENTA"
    },
    {
     "description": "CENTURY ALUMINUM COMPANY",
     "symbol": "CENX"
    },
    {
     "description": "Cnooc Ltd",
     "symbol": "CEO"
    },
    {
     "description": "CEO AMERICA INC",
     "symbol": "CEOA"
    },
    {
     "description": "CNPR GROUP",
     "symbol": "CEOPF"
    },
    {
     "description": "CECORS INC",
     "symbol": "CEOS"
    },
    {
     "description": "CENTRAL PUERTO-SPONSORED ADR",
     "symbol": "CEPU"
    },
    {
     "description": "CRESTWOOD EQUITY PARTNERS LP",
     "symbol": "CEQP"
    },
    {
     "description": "CRESTWOOD EQUITY PARTNER",
     "symbol": "CEQP.PR"
    },
    {
     "description": "CERES ACQUISITION CORP - A",
     "symbol": "CERAF"
    },
    {
     "description": "CEREVEL THERAPEUTICS HOLDING",
     "symbol": "CERE"
    },
    {
     "description": "CERES GLOBAL AG CORP",
     "symbol": "CERGF"
    },
    {
     "description": "CERNER CORP",
     "symbol": "CERN"
    },
    {
     "description": "CERUS CORP",
     "symbol": "CERS"
    },
    {
     "description": "CERTARA INC",
     "symbol": "CERT"
    },
    {
     "description": "CERES ACQUISITION CORP -CW25",
     "symbol": "CERWF"
    },
    {
     "description": "COLOMBIA ENERGY RESOURCES IN",
     "symbol": "CERX"
    },
    {
     "description": "CES ENERGY SOLUTIONS CORP",
     "symbol": "CESDF"
    },
    {
     "description": "CE SOFTWARE INC",
     "symbol": "CESF"
    },
    {
     "description": "CHESSER RESOURCES LTD",
     "symbol": "CESSF"
    },
    {
     "description": "CHINESE ESTATES HOLDINGS LTD",
     "symbol": "CESTF"
    },
    {
     "description": "CHINESE ESTATES HL-UNSP ADR",
     "symbol": "CESTY"
    },
    {
     "description": "CES SYNERGIES INC",
     "symbol": "CESX"
    },
    {
     "description": "CENTRAL SECURITIES CORP",
     "symbol": "CET"
    },
    {
     "description": "CATHEDRAL ENERGY SERVICES LT",
     "symbol": "CETEF"
    },
    {
     "description": "ISHARES MSCI EM ASIA ACC",
     "symbol": "CETFF"
    },
    {
     "description": "CAPITAL CITY ENERGY GROUP IN",
     "symbol": "CETG"
    },
    {
     "description": "CYBER ENVIRO-TECH INC",
     "symbol": "CETI"
    },
    {
     "description": "CHINA LOTSYNERGY HLDG LTD",
     "symbol": "CETMF"
    },
    {
     "description": "CEMTREX INC",
     "symbol": "CETX"
    },
    {
     "description": "CEMTREX INC",
     "symbol": "CETXP"
    },
    {
     "description": "CLEAN ENERGY TECHNOLOGIES IN",
     "symbol": "CETY"
    },
    {
     "description": "CENTURY GLOBAL COMMODITIES C",
     "symbol": "CEUMF"
    },
    {
     "description": "EATON VANCE CA MUNI INC TRST",
     "symbol": "CEV"
    },
    {
     "description": "CEVA INC",
     "symbol": "CEVA"
    },
    {
     "description": "CERES VENTURES INC",
     "symbol": "CEVE"
    },
    {
     "description": "CHINA EVERBRIGHT LTD",
     "symbol": "CEVIF"
    },
    {
     "description": "CHINA EVERBRIGHT-UNSP ADR",
     "symbol": "CEVIY"
    },
    {
     "description": "CTS EVENTIM AG & CO KGAA",
     "symbol": "CEVMF"
    },
    {
     "description": "CTS EVENTIM AG-ADR",
     "symbol": "CEVMY"
    },
    {
     "description": "WISDOMTREE EMERGING CURRENCY",
     "symbol": "CEW"
    },
    {
     "description": "CEWE STIFTUNG & CO KGAA",
     "symbol": "CEWCF"
    },
    {
     "description": "CIRCLE ENTERTAINMENT INC",
     "symbol": "CEXE"
    },
    {
     "description": "CACHE EXPLORATION INC",
     "symbol": "CEXPF"
    },
    {
     "description": "VICTORYSHARES EMERGING MARKE",
     "symbol": "CEY"
    },
    {
     "description": "PARENT CAPITAL CORP",
     "symbol": "CEYFF"
    },
    {
     "description": "CEZ AS - ADR",
     "symbol": "CEZYY"
    },
    {
     "description": "CF INDUSTRIES HOLDINGS INC",
     "symbol": "CF"
    },
    {
     "description": "VICTORYSHARES US 500 VOLATIL",
     "symbol": "CFA"
    },
    {
     "description": "CROSSFIRST BANKSHARES INC",
     "symbol": "CFB"
    },
    {
     "description": "CF BANKSHARES INC",
     "symbol": "CFBK"
    },
    {
     "description": "CORFACTS INC",
     "symbol": "CFCC"
    },
    {
     "description": "CAFE DE CORAL HOLDINGS LTD",
     "symbol": "CFCGF"
    },
    {
     "description": "CLEARBRIDGE FOCUS VALUE ESG",
     "symbol": "CFCV"
    },
    {
     "description": "CENTRIC FINANCIAL CORP",
     "symbol": "CFCX"
    },
    {
     "description": "CHINA NONFERROUS GOLD LTD",
     "symbol": "CFEGF"
    },
    {
     "description": "CHINA FEIHE LTD UNSP-ADR",
     "symbol": "CFEIY"
    },
    {
     "description": "CF ACQUISITION CORP VIII-A",
     "symbol": "CFFE"
    },
    {
     "description": "CF ACQUISITION CORP VIII",
     "symbol": "CFFEU"
    },
    {
     "description": "CF ACQUISITION VIII A -CW27",
     "symbol": "CFFEW"
    },
    {
     "description": "CIFI HOLDINGS GROUP CO LTD",
     "symbol": "CFFHF"
    },
    {
     "description": "C & F FINANCIAL CORP",
     "symbol": "CFFI"
    },
    {
     "description": "CFOAM LTD",
     "symbol": "CFFMF"
    },
    {
     "description": "CAPITOL FEDERAL FINANCIAL IN",
     "symbol": "CFFN"
    },
    {
     "description": "CF ACQUISITION CORP VII-CL A",
     "symbol": "CFFS"
    },
    {
     "description": "CF ACQUISITION CORP VII",
     "symbol": "CFFSU"
    },
    {
     "description": "CF ACQUISITION VII A -CW27",
     "symbol": "CFFSW"
    },
    {
     "description": "CITIZENS FINANCIAL GROUP",
     "symbol": "CFG"
    },
    {
     "description": "CITIZENS FINANCIAL GROUP",
     "symbol": "CFG.PRD"
    },
    {
     "description": "CITIZENS FINANCIAL GROUP",
     "symbol": "CFG.PRE"
    },
    {
     "description": "COMMUNITY FINANCIAL GR -WASH",
     "symbol": "CFGW"
    },
    {
     "description": "CAPITAL FINANCIAL GLOBAL INC",
     "symbol": "CFGX"
    },
    {
     "description": "CORNERSTONE FINANCIAL CORP N",
     "symbol": "CFIC"
    },
    {
     "description": "CHALLENGER LTD",
     "symbol": "CFIGF"
    },
    {
     "description": "CHALLENGER LTD-UNS ADR",
     "symbol": "CFIGY"
    },
    {
     "description": "CITIZENS FINANCIAL CORP-A\/KY",
     "symbol": "CFIN"
    },
    {
     "description": "CF ACQUISITION CORP IV-CL A",
     "symbol": "CFIV"
    },
    {
     "description": "CF ACQUISITION CORP IV",
     "symbol": "CFIVU"
    },
    {
     "description": "CF ACQUISITION CORP IV CW21",
     "symbol": "CFIVW"
    },
    {
     "description": "CASH FINANCIAL SERVICES GROU",
     "symbol": "CFLSF"
    },
    {
     "description": "CONFLUENT INC-CLASS A",
     "symbol": "CFLT"
    },
    {
     "description": "CONFORMIS INC",
     "symbol": "CFMS"
    },
    {
     "description": "CALIFORNIA FIRST LEASING COR",
     "symbol": "CFNB"
    },
    {
     "description": "COMPAGNIE FINANCIERE TRAD-BR",
     "symbol": "CFNCF"
    },
    {
     "description": "VICTORYSHARES US 500 ENHANCE",
     "symbol": "CFO"
    },
    {
     "description": "COMMUNITY FIRST BANCORP\/SC",
     "symbol": "CFOK"
    },
    {
     "description": "CHINA FOODS HOLDINGS LTD-A",
     "symbol": "CFOO"
    },
    {
     "description": "CALIFORNIA STYLE PALMS INC",
     "symbol": "CFPI"
    },
    {
     "description": "CANFOR PULP PRODUCTS INC",
     "symbol": "CFPUF"
    },
    {
     "description": "CANFOR CORP",
     "symbol": "CFPZF"
    },
    {
     "description": "CULLEN\/FROST BANKERS INC",
     "symbol": "CFR"
    },
    {
     "description": "CULLEN\/FROST BANKERS INC",
     "symbol": "CFR.PRB"
    },
    {
     "description": "CIE FINANCIERE RICHEMO-A REG",
     "symbol": "CFRHF"
    },
    {
     "description": "CONFORCE INTERNATIONAL INC",
     "symbol": "CFRI"
    },
    {
     "description": "CHINA AIRCRAFT LEASING GROUP",
     "symbol": "CFRLF"
    },
    {
     "description": "CIE FINANCIERE RICHEMO-CW",
     "symbol": "CFRSF"
    },
    {
     "description": "CIE FINANCIERE RICH-UNSP ADR",
     "symbol": "CFRUY"
    },
    {
     "description": "CONTRAFECT CORP",
     "symbol": "CFRX"
    },
    {
     "description": "CFSB BANCORP INC",
     "symbol": "CFSB"
    },
    {
     "description": "CHOFU SEISAKUSHO CO LTD",
     "symbol": "CFSKF"
    },
    {
     "description": "COMMUNITIES FIRST FINANCIAL",
     "symbol": "CFST"
    },
    {
     "description": "COMPLETE FINANCIAL SOLUTIONS",
     "symbol": "CFSU"
    },
    {
     "description": "CHINASOFT INTERNATIONAL LTD",
     "symbol": "CFTLF"
    },
    {
     "description": "CLIFTON MINING COMPANY",
     "symbol": "CFTN"
    },
    {
     "description": "CF ACQUISITION CORP VI-CLS A",
     "symbol": "CFVI"
    },
    {
     "description": "CF ACQUISITION CORP VI",
     "symbol": "CFVIU"
    },
    {
     "description": "CF ACQUISITION VI CL A -CW28",
     "symbol": "CFVIW"
    },
    {
     "description": "CALFRAC WELL SERVICES LTD",
     "symbol": "CFWFF"
    },
    {
     "description": "CALFRAC WELL SERVICES -CW23",
     "symbol": "CFWWF"
    },
    {
     "description": "COLEFAX GROUP PLC",
     "symbol": "CFXFF"
    },
    {
     "description": "CONIFEX TIMBER INC",
     "symbol": "CFXTF"
    },
    {
     "description": "ISHARES CANADIAN FUNDAMENTAL",
     "symbol": "CFYFF"
    },
    {
     "description": "CARLYLE GROUP INC\/THE",
     "symbol": "CG"
    },
    {
     "description": "CHINA GREEN AGRICULTURE INC",
     "symbol": "CGA"
    },
    {
     "description": "A2B AUSTRALIA LTD-UNSPON ADR",
     "symbol": "CGAAY"
    },
    {
     "description": "CARLYLE FINANCE LLC",
     "symbol": "CGABL"
    },
    {
     "description": "CODE GREEN APPAREL CORP",
     "symbol": "CGAC"
    },
    {
     "description": "CONCORDE GAMING CORP",
     "symbol": "CGAM"
    },
    {
     "description": "CHINA RESOURCES GAS GRP-ADR",
     "symbol": "CGASY"
    },
    {
     "description": "CENTERRA GOLD INC",
     "symbol": "CGAU"
    },
    {
     "description": "TCG BDC INC",
     "symbol": "CGBD"
    },
    {
     "description": "ISHARES GOLD BULLION ETF",
     "symbol": "CGBLF"
    },
    {
     "description": "CANOPY GROWTH CORP",
     "symbol": "CGC"
    },
    {
     "description": "CENTRAL GLASS CO LTD",
     "symbol": "CGCLF"
    },
    {
     "description": "COMMERCE GROUP CORPORATION",
     "symbol": "CGCO"
    },
    {
     "description": "CAPITAL GROUP CORE PLUS INC",
     "symbol": "CGCP"
    },
    {
     "description": "CHINA GROWTH DEVELOPMENT INC",
     "symbol": "CGDI"
    },
    {
     "description": "CONROY GOLD AND NATURAL RESO",
     "symbol": "CGDNF"
    },
    {
     "description": "CAPITAL GROUP DIVIDEND VALUE",
     "symbol": "CGDV"
    },
    {
     "description": "XALI GOLD CORP",
     "symbol": "CGDXF"
    },
    {
     "description": "COGECO COMMUNICATIONS INC",
     "symbol": "CGEAF"
    },
    {
     "description": "COGECO INC",
     "symbol": "CGECF"
    },
    {
     "description": "CGN NEW ENERGY HOLDINGS CO L",
     "symbol": "CGEGF"
    },
    {
     "description": "CGE ENERGY INC",
     "symbol": "CGEI"
    },
    {
     "description": "CULLINAN ONCOLOGY INC",
     "symbol": "CGEM"
    },
    {
     "description": "CAPGEMINI SE - UNSPONSOR ADR",
     "symbol": "CGEMY"
    },
    {
     "description": "COMPUGEN LTD",
     "symbol": "CGEN"
    },
    {
     "description": "CF ENERGY CORP",
     "symbol": "CGFEF"
    },
    {
     "description": "COATS GROUP PLC",
     "symbol": "CGGGF"
    },
    {
     "description": "Capital Group Global Growth",
     "symbol": "CGGO"
    },
    {
     "description": "CAPITAL GROUP GROWTH",
     "symbol": "CGGR"
    },
    {
     "description": "CGG - SPON ADR",
     "symbol": "CGGYY"
    },
    {
     "description": "CAPITAL GROUP HOLDINGS INC",
     "symbol": "CGHC"
    },
    {
     "description": "CHAARAT GOLD HOLDINGS LTD",
     "symbol": "CGHLF"
    },
    {
     "description": "CHINA GAS HOLDINGS LTD-ADR",
     "symbol": "CGHLY"
    },
    {
     "description": "CHINA GAS HOLDINGS LTD",
     "symbol": "CGHOF"
    },
    {
     "description": "CHEMTRADE LOGISTICS INCOM FD",
     "symbol": "CGIFF"
    },
    {
     "description": "CELADON GROUP INC",
     "symbol": "CGIP"
    },
    {
     "description": "ESR-REIT",
     "symbol": "CGIUF"
    },
    {
     "description": "CARGOJET INC",
     "symbol": "CGJTF"
    },
    {
     "description": "CHUGOKU ELECTRIC POWER CO",
     "symbol": "CGKEF"
    },
    {
     "description": "CHUGOKU ELECTRIC-UNSPON ADR",
     "symbol": "CGKEY"
    },
    {
     "description": "CASSIAR GOLD CORP",
     "symbol": "CGLCF"
    },
    {
     "description": "BUSCAR CO",
     "symbol": "CGLD"
    },
    {
     "description": "CORO GLOBAL INC",
     "symbol": "CGLO"
    },
    {
     "description": "COMFORT GLOVE BHD",
     "symbol": "CGLOF"
    },
    {
     "description": "CHINA MINSHENG BANKING COR-H",
     "symbol": "CGMBF"
    },
    {
     "description": "CHIANGMAI FROZEN FOODS-NVDR",
     "symbol": "CGMFF"
    },
    {
     "description": "CHALICE MINING LTD",
     "symbol": "CGMLF"
    },
    {
     "description": "CLINIGEN GROUP PLC-UNSP ADR",
     "symbol": "CGNGY"
    },
    {
     "description": "CARDIOGENICS HOLDINGS INC",
     "symbol": "CGNH"
    },
    {
     "description": "CGN MINING CO LTD",
     "symbol": "CGNMF"
    },
    {
     "description": "COGNETIVITY NEUROSCIENCES LT",
     "symbol": "CGNSF"
    },
    {
     "description": "COGNYTE SOFTWARE LTD",
     "symbol": "CGNT"
    },
    {
     "description": "CGN POWER CO LTD-H",
     "symbol": "CGNWF"
    },
    {
     "description": "COGNEX CORP",
     "symbol": "CGNX"
    },
    {
     "description": "CALAMOS GLOBAL TOTAL RETURN",
     "symbol": "CGO"
    },
    {
     "description": "CONTACT GOLD CORP",
     "symbol": "CGOLF"
    },
    {
     "description": "GRAND PHARMACEUTICAL GROUP L",
     "symbol": "CGPHF"
    },
    {
     "description": "CHINA REDSTONE GROUP INC",
     "symbol": "CGPI"
    },
    {
     "description": "CGG SA",
     "symbol": "CGPVF"
    },
    {
     "description": "C&C GROUP PLC",
     "symbol": "CGPZF"
    },
    {
     "description": "CGROWTH CAPITAL INC",
     "symbol": "CGRA"
    },
    {
     "description": "CANADIAN GENERAL INVESTMENTS",
     "symbol": "CGRIF"
    },
    {
     "description": "CAPSTONE GREEN ENERGY CORP",
     "symbol": "CGRN"
    },
    {
     "description": "CHARACTER GROUP PLC",
     "symbol": "CGROF"
    },
    {
     "description": "CANNAGROW HOLDINGS INC",
     "symbol": "CGRW"
    },
    {
     "description": "COUNTRY GARDEN - UNSP ADR",
     "symbol": "CGSHY"
    },
    {
     "description": "CGS INTERNATIONAL INC",
     "symbol": "CGSI"
    },
    {
     "description": "CENTERGISTIC SOLUTIONS INC",
     "symbol": "CGSO"
    },
    {
     "description": "CHINA TOPREACH INC",
     "symbol": "CGSXF"
    },
    {
     "description": "COGNITION THERAPEUTICS INC",
     "symbol": "CGTX"
    },
    {
     "description": "COM-GUARD.COM INC",
     "symbol": "CGUD"
    },
    {
     "description": "CASINO GUICHARD PERRACHON",
     "symbol": "CGUIF"
    },
    {
     "description": "CAPITAL GROUP CORE EQUITY",
     "symbol": "CGUS"
    },
    {
     "description": "CASINO GUICHARD P - SPON ADR",
     "symbol": "CGUSY"
    },
    {
     "description": "INVESCO S&P GLOBAL WATER IND",
     "symbol": "CGW"
    },
    {
     "description": "CGX ENERGY INC",
     "symbol": "CGXEF"
    },
    {
     "description": "CAPITAL GROUP INTL FOCUS ETY",
     "symbol": "CGXU"
    },
    {
     "description": "CHINA GALAXY SECURITIES-ADR",
     "symbol": "CGXYY"
    },
    {
     "description": "CHINA ENERGY RECOVERY INC",
     "symbol": "CGYV"
    },
    {
     "description": "CATCHA INVESTMENT CORP-A",
     "symbol": "CHAA"
    },
    {
     "description": "CATCHA INVESTMENT CORP",
     "symbol": "CHAA.U"
    },
    {
     "description": "CATCHA INVESTMENT -CW27",
     "symbol": "CHAA.WS"
    },
    {
     "description": "DRX DLY CHINA A-SHR BEAR 1X",
     "symbol": "CHAD"
    },
    {
     "description": "CHINA AEROSPACE INTL HLDG",
     "symbol": "CHAEF"
    },
    {
     "description": "CHANCELLOR GROUP INC",
     "symbol": "CHAG"
    },
    {
     "description": "CHINA ASSETS HOLDING LTD.",
     "symbol": "CHAJF"
    },
    {
     "description": "CHALICE BRANDS LTD",
     "symbol": "CHALF"
    },
    {
     "description": "CHAMPION INVESTMENTS INC",
     "symbol": "CHAM"
    },
    {
     "description": "DRX DLY CHINA A-SHR BULL 2X",
     "symbol": "CHAU"
    },
    {
     "description": "GLOBAL X CHINA BIOTECH INNOV",
     "symbol": "CHB"
    },
    {
     "description": "CHIBA BANK LTD\/THE",
     "symbol": "CHBAF"
    },
    {
     "description": "CHIBA BANK LTD\/THE-UNSP ADR",
     "symbol": "CHBAY"
    },
    {
     "description": "CROGHAN BANCSHARES INC",
     "symbol": "CHBH"
    },
    {
     "description": "CHINA CITIC BANK CORP LTD-H",
     "symbol": "CHBJF"
    },
    {
     "description": "CHIBA KOGYO BANK LTD\/THE",
     "symbol": "CHBKF"
    },
    {
     "description": "CHILL BRANDS GROUP PLC",
     "symbol": "CHBRF"
    },
    {
     "description": "CHINA AGRI-BUSINESS INC",
     "symbol": "CHBU"
    },
    {
     "description": "CHINA CHEMICAL CORP",
     "symbol": "CHCC"
    },
    {
     "description": "COMSTOCK HOLDING COMPANIES",
     "symbol": "CHCI"
    },
    {
     "description": "CHINA CITIC BANK-UNSPON ADR",
     "symbol": "CHCJY"
    },
    {
     "description": "CITIZEN WATCH CO LTD- UN ADR",
     "symbol": "CHCLY"
    },
    {
     "description": "CITY HOLDING CO",
     "symbol": "CHCO"
    },
    {
     "description": "COMPREHENSIVE CARE CORP",
     "symbol": "CHCR"
    },
    {
     "description": "COMMUNITY HEALTHCARE TRUST I",
     "symbol": "CHCT"
    },
    {
     "description": "CTGX MINING INC",
     "symbol": "CHCX"
    },
    {
     "description": "CHURCH & DWIGHT CO INC",
     "symbol": "CHD"
    },
    {
     "description": "COSCO SHIPPING INTERNATIONAL",
     "symbol": "CHDGF"
    },
    {
     "description": "EV DYNAMICS HOLDINGS LIMITED",
     "symbol": "CHDHF"
    },
    {
     "description": "CHURCHILL DOWNS INC",
     "symbol": "CHDN"
    },
    {
     "description": "CHRISTIAN DIOR SE",
     "symbol": "CHDRF"
    },
    {
     "description": "CHRISTIAN DIOR SE-UNSPON ADR",
     "symbol": "CHDRY"
    },
    {
     "description": "CHEMED CORP",
     "symbol": "CHE"
    },
    {
     "description": "CHINA EASTERN AIRLINES CO-H",
     "symbol": "CHEAF"
    },
    {
     "description": "CHEFS' WAREHOUSE INC\/THE",
     "symbol": "CHEF"
    },
    {
     "description": "CHECK CAP LTD",
     "symbol": "CHEK"
    },
    {
     "description": "CHECK CAP LTD- WARRANT",
     "symbol": "CHEKZ"
    },
    {
     "description": "COCHLEAR LTD",
     "symbol": "CHEOF"
    },
    {
     "description": "COCHLEAR LTD-UNSPON ADR",
     "symbol": "CHEOY"
    },
    {
     "description": "Cresud SACIF y A",
     "symbol": "CHESW"
    },
    {
     "description": "CHINA EVERBRIGHT ENVIRONMENT",
     "symbol": "CHFFF"
    },
    {
     "description": "CHINA EVERBRIGHT ENVI-UN ADR",
     "symbol": "CHFFY"
    },
    {
     "description": "CHINA ART FINANCIAL HOLDINGS",
     "symbol": "CHFHF"
    },
    {
     "description": "CHINA FOODS LTD-UNSPON ADR",
     "symbol": "CHFHY"
    },
    {
     "description": "CHINA FINANCE INC",
     "symbol": "CHFI"
    },
    {
     "description": "CHINA FEIHE LTD",
     "symbol": "CHFLF"
    },
    {
     "description": "CHUGAI PHARMACEUTICAL CO LTD",
     "symbol": "CHGCF"
    },
    {
     "description": "CHUGAI PHARMACEUTIC-UNSP ADR",
     "symbol": "CHGCY"
    },
    {
     "description": "CHEGG INC",
     "symbol": "CHGG"
    },
    {
     "description": "CHINA CARBON GRAPHITE GROUP",
     "symbol": "CHGI"
    },
    {
     "description": "CHANGHONG JIAHUA HOLDINGS LT",
     "symbol": "CHGJF"
    },
    {
     "description": "CHINA GENGSHENG MINERALS INC",
     "symbol": "CHGS"
    },
    {
     "description": "AXS CHANGE FINANCE ESG ETF",
     "symbol": "CHGX"
    },
    {
     "description": "CHOICE HOTELS INTL INC",
     "symbol": "CHH"
    },
    {
     "description": "CHC GROUP LLC",
     "symbol": "CHHCF"
    },
    {
     "description": "CHINA HEALTH INDUSTRIES HOLD",
     "symbol": "CHHE"
    },
    {
     "description": "CHEN HSONG HOLDINGS",
     "symbol": "CHHGF"
    },
    {
     "description": "CARERX CORP",
     "symbol": "CHHHF"
    },
    {
     "description": "CHINA HOLDINGS INC",
     "symbol": "CHHL"
    },
    {
     "description": "CHINA HONGQIAO GROUP LTD",
     "symbol": "CHHQF"
    },
    {
     "description": "CHINA HONGQIAO GR-UNSPON ADR",
     "symbol": "CHHQY"
    },
    {
     "description": "CALAMOS CONVERTIBLE OPP&INC",
     "symbol": "CHI"
    },
    {
     "description": "GLOBAL X MSCI CHINA COMMUNIC",
     "symbol": "CHIC"
    },
    {
     "description": "GLOBAL X MSCI CHINA ENERGY E",
     "symbol": "CHIE"
    },
    {
     "description": "CHINA FOOD & BEVERAGE CO",
     "symbol": "CHIF"
    },
    {
     "description": "GLOBAL X MSCI CHINA HEALTH",
     "symbol": "CHIH"
    },
    {
     "description": "GLOBAL X MSCI CHINA INDUSTRI",
     "symbol": "CHII"
    },
    {
     "description": "GLOBAL X MSCI CHINA INFO ETF",
     "symbol": "CHIK"
    },
    {
     "description": "GLOBAL X MSCI CHINA MATERIAL",
     "symbol": "CHIM"
    },
    {
     "description": "GLOBAL X MSCI CHINA CONSUMER",
     "symbol": "CHIQ"
    },
    {
     "description": "GBL X MSCI CHINA REAL ESTATE",
     "symbol": "CHIR"
    },
    {
     "description": "GBL X MSCI CHINA CONSUMER ST",
     "symbol": "CHIS"
    },
    {
     "description": "CHERUBIM INTERESTS INC",
     "symbol": "CHIT"
    },
    {
     "description": "GLOBAL X MSCI CHINA UTIL ETF",
     "symbol": "CHIU"
    },
    {
     "description": "GLOBAL X MSCI CHINA FINANCIA",
     "symbol": "CHIX"
    },
    {
     "description": "CHINA TRADITIONAL CHINESE ME",
     "symbol": "CHIZF"
    },
    {
     "description": "CHINA CHANGJIANG MINING & NE",
     "symbol": "CHJI"
    },
    {
     "description": "CSPC PHARMACEUTICAL GROUP LT",
     "symbol": "CHJTF"
    },
    {
     "description": "CHESAPEAKE ENERGY CORP",
     "symbol": "CHK"
    },
    {
     "description": "CHESAPEAKE ENERGY CORP -CW26",
     "symbol": "CHKEL"
    },
    {
     "description": "CHESAPEAKE ENERGY CORP -CW26",
     "symbol": "CHKEW"
    },
    {
     "description": "CHESAPEAKE ENERGY -CW26",
     "symbol": "CHKEZ"
    },
    {
     "description": "CK ASSET HOLDINGS LTD",
     "symbol": "CHKGF"
    },
    {
     "description": "CHINA SOUTHERN AIRLINES CO-H",
     "symbol": "CHKIF"
    },
    {
     "description": "CHAKANA COPPER CORP",
     "symbol": "CHKKF"
    },
    {
     "description": "COHIBA MINERALS LTD",
     "symbol": "CHKMF"
    },
    {
     "description": "CHECK POINT SOFTWARE TECH",
     "symbol": "CHKP"
    },
    {
     "description": "CHESAPEAKE GRANITE WASH TRUS",
     "symbol": "CHKR"
    },
    {
     "description": "China Mobile Limited",
     "symbol": "CHL"
    },
    {
     "description": "CENTENNIAL SPECIALTY FOODS",
     "symbol": "CHLE"
    },
    {
     "description": "CHINA LITERATURE LTD",
     "symbol": "CHLLF"
    },
    {
     "description": "ARA LOGOS LOGISTICS TRUST",
     "symbol": "CHLTF"
    },
    {
     "description": "CHARTER HALL LONG WALE REIT",
     "symbol": "CHLWF"
    },
    {
     "description": "CHINAAMC ETF SERIES - CH-HKD",
     "symbol": "CHMCF"
    },
    {
     "description": "CHINA MEDICINE CORP",
     "symbol": "CHME"
    },
    {
     "description": "CHEMUNG FINANCIAL CORP",
     "symbol": "CHMG"
    },
    {
     "description": "CHERRY HILL MORTGAGE INVESTM",
     "symbol": "CHMI"
    },
    {
     "description": "CHERRY HILL MTG INV CORP",
     "symbol": "CHMI.PRA"
    },
    {
     "description": "CHERRY HILL MTG INV CORP",
     "symbol": "CHMI.PRB"
    },
    {
     "description": "CHEMISTREE TECHNOLOGY INC",
     "symbol": "CHMJF"
    },
    {
     "description": "CHIMERIC THERAPEUTICS LTD",
     "symbol": "CHMMF"
    },
    {
     "description": "CHESTER MINING CO",
     "symbol": "CHMN"
    },
    {
     "description": "CHIKARANOMOTO HOLDINGS CO LT",
     "symbol": "CHMOF"
    },
    {
     "description": "CHAMPION INDUSTRIES INC\/WV",
     "symbol": "CHMP"
    },
    {
     "description": "CHIMERA ENERGY CORP",
     "symbol": "CHMR"
    },
    {
     "description": "CHARMT INC",
     "symbol": "CHMT"
    },
    {
     "description": "NEXT-CHEMX CORP",
     "symbol": "CHMX"
    },
    {
     "description": "CHINA FUND INC",
     "symbol": "CHN"
    },
    {
     "description": "LONCAR CHINA BIOPHARMA ETF",
     "symbol": "CHNA"
    },
    {
     "description": "CHINA INFRASTRUCTURE CONSTRU",
     "symbol": "CHNC"
    },
    {
     "description": "CHINA MEDIA INC",
     "symbol": "CHND"
    },
    {
     "description": "CHINA FOODS LTD",
     "symbol": "CHNFF"
    },
    {
     "description": "CHANGE HEALTHCARE INC",
     "symbol": "CHNG"
    },
    {
     "description": "CHINA NATURAL GAS INC",
     "symbol": "CHNGQ"
    },
    {
     "description": "CHANGE HEALTHCARE INC",
     "symbol": "CHNGU"
    },
    {
     "description": "CLASSWORX INC",
     "symbol": "CHNO"
    },
    {
     "description": "CHINA NATURAL RESOURCES INC",
     "symbol": "CHNR"
    },
    {
     "description": "CHINA STARCH HOLDINGS LTD",
     "symbol": "CHNSF"
    },
    {
     "description": "CHINA LNG GROUP LTD",
     "symbol": "CHNTF"
    },
    {
     "description": "CHINA EDUCATION RESOURCES IN",
     "symbol": "CHNUF"
    },
    {
     "description": "CHINA YOUZAN LTD",
     "symbol": "CHNVF"
    },
    {
     "description": "ISHARES CHINA CNY BOND USD-D",
     "symbol": "CHNYF"
    },
    {
     "description": "CHARTER OAK BANK",
     "symbol": "CHOB"
    },
    {
     "description": "CHINA OILFIELD SERVICES-H",
     "symbol": "CHOLF"
    },
    {
     "description": "CHOOM HOLDINGS INC",
     "symbol": "CHOOF"
    },
    {
     "description": "CHOW SANG SANG HLDG",
     "symbol": "CHOWF"
    },
    {
     "description": "CHINA PENGFEI GROUP LTD",
     "symbol": "CHPEF"
    },
    {
     "description": "CHAROEN POKPHAND FOOD-FORGN",
     "symbol": "CHPFF"
    },
    {
     "description": "CHESAPEAKE GOLD CORP",
     "symbol": "CHPGF"
    },
    {
     "description": "CHP MERGER CORP-CLASS A",
     "symbol": "CHPM"
    },
    {
     "description": "CHP MERGER CORP",
     "symbol": "CHPMU"
    },
    {
     "description": "CHP MERGER CORP -CW24",
     "symbol": "CHPMW"
    },
    {
     "description": "CHARGEPOINT HOLDINGS INC",
     "symbol": "CHPT"
    },
    {
     "description": "CHINA PACIFIC INSURANCE GR-H",
     "symbol": "CHPXF"
    },
    {
     "description": "CHINA PACIFIC INS-UNSPON ADR",
     "symbol": "CHPXY"
    },
    {
     "description": "CHARAH SOLUTIONS INC",
     "symbol": "CHRA"
    },
    {
     "description": "CHARAH SOLUTIONS INC",
     "symbol": "CHRB"
    },
    {
     "description": "CHARLE CO LTD",
     "symbol": "CHRLF"
    },
    {
     "description": "CHORUS AVIATION INC",
     "symbol": "CHRRF"
    },
    {
     "description": "COHERUS BIOSCIENCES INC",
     "symbol": "CHRS"
    },
    {
     "description": "CHORUS LTD",
     "symbol": "CHRUF"
    },
    {
     "description": "C.H. ROBINSON WORLDWIDE INC",
     "symbol": "CHRW"
    },
    {
     "description": "CHORUS LTD-ADR",
     "symbol": "CHRYY"
    },
    {
     "description": "CHICO'S FAS INC",
     "symbol": "CHS"
    },
    {
     "description": "CHS INC",
     "symbol": "CHSCL"
    },
    {
     "description": "CHS INC",
     "symbol": "CHSCM"
    },
    {
     "description": "CHS INC",
     "symbol": "CHSCN"
    },
    {
     "description": "CHS INC",
     "symbol": "CHSCO"
    },
    {
     "description": "CHS INC",
     "symbol": "CHSCP"
    },
    {
     "description": "CHINA SHOE HOLDINGS INC",
     "symbol": "CHSH"
    },
    {
     "description": "CHINA HIGH SPEED TRANSMISSIO",
     "symbol": "CHSTF"
    },
    {
     "description": "CHINA HIGH SPEED-UNSPON ADR",
     "symbol": "CHSTY"
    },
    {
     "description": "CHINA MEDICAL SYSTEMS INC",
     "symbol": "CHSY"
    },
    {
     "description": "CHINA MEDICAL SYSTEM HOLDING",
     "symbol": "CHSYF"
    },
    {
     "description": "CHUNGHWA TELECOM LT-SPON ADR",
     "symbol": "CHT"
    },
    {
     "description": "CHIPMOS TECHNOLOGIES INC",
     "symbol": "CHTGF"
    },
    {
     "description": "CNL HEALTHCARE PROPERTIES IN",
     "symbol": "CHTH"
    },
    {
     "description": "CHATHAM CORP",
     "symbol": "CHTM"
    },
    {
     "description": "CHARTER COMMUNICATIONS INC-A",
     "symbol": "CHTR"
    },
    {
     "description": "China Unicom Ltd",
     "symbol": "CHU"
    },
    {
     "description": "CHINA HUARONG ASSET MANAGE-H",
     "symbol": "CHUAF"
    },
    {
     "description": "CHARLIE'S HOLDINGS INC",
     "symbol": "CHUC"
    },
    {
     "description": "CHUBU ELECTRIC POWER CO INC",
     "symbol": "CHUEF"
    },
    {
     "description": "CHUY'S HOLDINGS INC",
     "symbol": "CHUY"
    },
    {
     "description": "CHARISMA ENERGY SERVICES LTD",
     "symbol": "CHVEF"
    },
    {
     "description": "CHINA VANKE CO LTD-H",
     "symbol": "CHVKF"
    },
    {
     "description": "CHINA VANKE CO LTD-UNSPONADR",
     "symbol": "CHVKY"
    },
    {
     "description": "CALAMOS GLOBAL DYNAMIC INCOM",
     "symbol": "CHW"
    },
    {
     "description": "CHW ACQUISITION CORP",
     "symbol": "CHWA"
    },
    {
     "description": "CHW ACQUISITION CORP",
     "symbol": "CHWAU"
    },
    {
     "description": "CHW ACQUISITION CORP -CW28",
     "symbol": "CHWAW"
    },
    {
     "description": "CHINAWE.COM INC",
     "symbol": "CHWE"
    },
    {
     "description": "CHINA TOWER CORP LTD-H",
     "symbol": "CHWRF"
    },
    {
     "description": "COOLPAD GROUP LTD",
     "symbol": "CHWTF"
    },
    {
     "description": "CHESSWOOD GROUP LTD",
     "symbol": "CHWWF"
    },
    {
     "description": "CHINA WATER INDUSTRY GROUP L",
     "symbol": "CHWXF"
    },
    {
     "description": "CHEWY INC - CLASS A",
     "symbol": "CHWY"
    },
    {
     "description": "CHAMPIONX CORP",
     "symbol": "CHX"
    },
    {
     "description": "TROILUS GOLD CORP",
     "symbol": "CHXMF"
    },
    {
     "description": "CALAMOS CVT AND HIGH INCOME",
     "symbol": "CHY"
    },
    {
     "description": "CHIYODA CORP",
     "symbol": "CHYCF"
    },
    {
     "description": "CHIYODA CORP-UNSPONSORED ADR",
     "symbol": "CHYCY"
    },
    {
     "description": "CATHAY FINANCIAL - REG S GDR",
     "symbol": "CHYFF"
    },
    {
     "description": "CHR HANSEN HOLDING -SPON ADR",
     "symbol": "CHYHY"
    },
    {
     "description": "CHYKINGYOUNG INVT DEV HLDGS",
     "symbol": "CHYI"
    },
    {
     "description": "CHINA SENIOR LIVING INDUSTRY",
     "symbol": "CHYL"
    },
    {
     "description": "CAHYA MATA SARAWAK BHD",
     "symbol": "CHYMF"
    },
    {
     "description": "CHIYODA CO LTD",
     "symbol": "CHYOF"
    },
    {
     "description": "HEALTH LOGIC INTERACTIVE INC",
     "symbol": "CHYPD"
    },
    {
     "description": "CHINA YUHUA EDUCATION CORP L",
     "symbol": "CHYUF"
    },
    {
     "description": "CHINA ZHONGWANG HOLDINGS LTD",
     "symbol": "CHZHF"
    },
    {
     "description": "CHINA ZHONG QI HOLDINGS LTD",
     "symbol": "CHZQ"
    },
    {
     "description": "CIGNA CORP",
     "symbol": "CI"
    },
    {
     "description": "CITIZENS INC",
     "symbol": "CIA"
    },
    {
     "description": "CHINA MENGNIU DAIRY CO",
     "symbol": "CIADF"
    },
    {
     "description": "CHINA MENGNIU-UNSPON ADR",
     "symbol": "CIADY"
    },
    {
     "description": "CHAMPION IRON LTD",
     "symbol": "CIAFF"
    },
    {
     "description": "CIAN PLC-ADR",
     "symbol": "CIAN"
    },
    {
     "description": "CHINA SCORE INC",
     "symbol": "CIAS"
    },
    {
     "description": "CIAO GROUP INC",
     "symbol": "CIAU"
    },
    {
     "description": "BANCOLOMBIA S.A.-SPONS ADR",
     "symbol": "CIB"
    },
    {
     "description": "COMMERCIAL INTL BANK-ADR",
     "symbol": "CIBEY"
    },
    {
     "description": "CIB MARINE BANCSHARES INC",
     "symbol": "CIBH"
    },
    {
     "description": "COMMUNITY INVESTORS BANCORP",
     "symbol": "CIBN"
    },
    {
     "description": "FIRST TRUST NASDAQ CYBERSECU",
     "symbol": "CIBR"
    },
    {
     "description": "CIBL INC",
     "symbol": "CIBY"
    },
    {
     "description": "Capitol Investment Corp VII",
     "symbol": "CIC.U"
    },
    {
     "description": "CHINA CONSTRUCTION BANK-H",
     "symbol": "CICHF"
    },
    {
     "description": "CHINA CONSTRUCT-UNSPON ADR",
     "symbol": "CICHY"
    },
    {
     "description": "CICERO INC",
     "symbol": "CICN"
    },
    {
     "description": "COSCO SHIPPING HOLDINGS CO-H",
     "symbol": "CICOF"
    },
    {
     "description": "CHINA COSCO HOLD-UNSPON ADR",
     "symbol": "CICOY"
    },
    {
     "description": "Capitol Investment Corp VI",
     "symbol": "CICX.U"
    },
    {
     "description": "VICTORYSHARES INTERNATIONAL",
     "symbol": "CID"
    },
    {
     "description": "CINEDIGM CORP - A",
     "symbol": "CIDM"
    },
    {
     "description": "CIENA CORP",
     "symbol": "CIEN"
    },
    {
     "description": "CHIERU CO LTD",
     "symbol": "CIERF"
    },
    {
     "description": "CORP INTERAMERICANA ENTRET-B",
     "symbol": "CIEZF"
    },
    {
     "description": "MFS INTERMEDIATE HIGH INC FN",
     "symbol": "CIF"
    },
    {
     "description": "CIPHER MINING INC",
     "symbol": "CIFR"
    },
    {
     "description": "GOOD WORKS ACQUISITIO -CW25",
     "symbol": "CIFRW"
    },
    {
     "description": "CIA ENERGETICA DE-SPON ADR",
     "symbol": "CIG"
    },
    {
     "description": "CIA ENERGETICA DE-SPON ADR",
     "symbol": "CIG.C"
    },
    {
     "description": "MH DEVELOPMENT LTD",
     "symbol": "CIGHF"
    },
    {
     "description": "COLLIERS INTERNATIONAL GROUP",
     "symbol": "CIGI"
    },
    {
     "description": "CI GLOBAL INFR PRIVATE POOL",
     "symbol": "CIGLF"
    },
    {
     "description": "CIGAMES",
     "symbol": "CIGMF"
    },
    {
     "description": "CHINA INDEX HDS-ADR",
     "symbol": "CIH"
    },
    {
     "description": "CHIHO ENVIRONMENTAL GROUP LT",
     "symbol": "CIHEF"
    },
    {
     "description": "CHINA MERCHANTS BANK-H",
     "symbol": "CIHHF"
    },
    {
     "description": "CHINA MERCHANTS BANK-UNS ADR",
     "symbol": "CIHKY"
    },
    {
     "description": "CB INDUSTRIAL PRODUCT HLDG",
     "symbol": "CIHPF"
    },
    {
     "description": "BLACKROCK ENH CAP AND INC",
     "symbol": "CII"
    },
    {
     "description": "CIIG CAPITAL PARTNERS II-A",
     "symbol": "CIIG"
    },
    {
     "description": "CIIG CAPITAL PARTNERS II INC",
     "symbol": "CIIGU"
    },
    {
     "description": "CIIG CAPITAL PART IIA -CW28",
     "symbol": "CIIGW"
    },
    {
     "description": "CITIC SECURITIES CO LTD-H",
     "symbol": "CIIHF"
    },
    {
     "description": "CITIC SECURITIES CO-UNSP ADR",
     "symbol": "CIIHY"
    },
    {
     "description": "TIANCI INTERNATIONAL INC",
     "symbol": "CIIT"
    },
    {
     "description": "CHINESEINVESTORS.COM INC",
     "symbol": "CIIX"
    },
    {
     "description": "CREDIT SUISSE ASSET MGMT INC",
     "symbol": "CIK"
    },
    {
     "description": "VICTORYSHARES INTERNATIONAL",
     "symbol": "CIL"
    },
    {
     "description": "CHINA LIFE INSURANCE CO-H",
     "symbol": "CILJF"
    },
    {
     "description": "CAPITAL DRILLING LTD",
     "symbol": "CILLF"
    },
    {
     "description": "CAROLINA MILLS INC",
     "symbol": "CILZ"
    },
    {
     "description": "CHIMERA INVESTMENT CORP",
     "symbol": "CIM"
    },
    {
     "description": "CHIMERA INVESTMENT CORP",
     "symbol": "CIM.PRA"
    },
    {
     "description": "CHIMERA INVESTMENT CORP",
     "symbol": "CIM.PRB"
    },
    {
     "description": "CHIMERA INVESTMENT CORP",
     "symbol": "CIM.PRC"
    },
    {
     "description": "CHIMERA INVESTMENT CORP",
     "symbol": "CIM.PRD"
    },
    {
     "description": "CIMB GROUP HOLDINGS BHD",
     "symbol": "CIMDF"
    },
    {
     "description": "CIMC ENRIC HOLDINGS LTD",
     "symbol": "CIMEF"
    },
    {
     "description": "IKANIK FARMS INC",
     "symbol": "CIMVF"
    },
    {
     "description": "Cimarex Energy Company",
     "symbol": "CIMXP"
    },
    {
     "description": "CINCOR PHARMA INC",
     "symbol": "CINC"
    },
    {
     "description": "CHINA INDUSTRIAL GROUP INC",
     "symbol": "CIND"
    },
    {
     "description": "CINCINNATI FINANCIAL CORP",
     "symbol": "CINF"
    },
    {
     "description": "CINGULATE INC",
     "symbol": "CING"
    },
    {
     "description": "COINSILIUM GROUP LTD",
     "symbol": "CINGF"
    },
    {
     "description": "CINGULATE -CW23",
     "symbol": "CINGW"
    },
    {
     "description": "CHINA TAIPING INSURANCE HOLD",
     "symbol": "CINSF"
    },
    {
     "description": "CI&T INC\/UNITED STATES-A",
     "symbol": "CINT"
    },
    {
     "description": "CRUCIAL INNOVATIONS CORP",
     "symbol": "CINV"
    },
    {
     "description": "CITY OFFICE REIT INC",
     "symbol": "CIO"
    },
    {
     "description": "CITY OFFICE REIT",
     "symbol": "CIO.PRA"
    },
    {
     "description": "CION INVESTMENT CORP",
     "symbol": "CION"
    },
    {
     "description": "CIELO SA",
     "symbol": "CIOXF"
    },
    {
     "description": "CIELO SA-SPONSORED ADR",
     "symbol": "CIOXY"
    },
    {
     "description": "CORRELATE INFRASTRUCTURE PAR",
     "symbol": "CIPI"
    },
    {
     "description": "CIRCOR INTERNATIONAL INC",
     "symbol": "CIR"
    },
    {
     "description": "CIRTRAN CORP",
     "symbol": "CIRX"
    },
    {
     "description": "CERBERUS CYBER SENTINEL CORP",
     "symbol": "CISO"
    },
    {
     "description": "CHINA STEEL CORP-SPONS GDR",
     "symbol": "CISXF"
    },
    {
     "description": "COSCO SHIPPING DEVELOPMENT-H",
     "symbol": "CITAF"
    },
    {
     "description": "CHINA SHIPPING CONT-UNSP ADR",
     "symbol": "CITAY"
    },
    {
     "description": "CARTICA ACQUISITION CORP-A",
     "symbol": "CITE"
    },
    {
     "description": "CARTICA ACQUISITION CORP",
     "symbol": "CITEU"
    },
    {
     "description": "CARTICA ACQUISITION A -28",
     "symbol": "CITEW"
    },
    {
     "description": "CITIZENS BANCSHARES CORP\/SC",
     "symbol": "CITZ"
    },
    {
     "description": "CIVISTA BANCSHARES INC",
     "symbol": "CIVB"
    },
    {
     "description": "CIVITAS RESOURCES INC",
     "symbol": "CIVI"
    },
    {
     "description": "CTR INVESTMENTS & CONSULTING",
     "symbol": "CIVX"
    },
    {
     "description": "CHINA INDUSTRIAL WASTE MANAG",
     "symbol": "CIWT"
    },
    {
     "description": "CITIZENS FINANCIAL CORP\/W V",
     "symbol": "CIWV"
    },
    {
     "description": "COMPX INTERNATIONAL INC",
     "symbol": "CIX"
    },
    {
     "description": "CAIXABANK SA",
     "symbol": "CIXPF"
    },
    {
     "description": "CI FINANCIAL CORP",
     "symbol": "CIXX"
    },
    {
     "description": "VICTORYSHARES DEVELOPED ENHA",
     "symbol": "CIZ"
    },
    {
     "description": "CITIZENS HOLDING COMPANY",
     "symbol": "CIZN"
    },
    {
     "description": "CEMBRE SPA",
     "symbol": "CJBEF"
    },
    {
     "description": "QUEBEC PRECIOUS METALS CORP",
     "symbol": "CJCFF"
    },
    {
     "description": "CHANJET INFORMATION TECH-H",
     "symbol": "CJETF"
    },
    {
     "description": "CHOW TAI FOOK JEWELLERY GROU",
     "symbol": "CJEWF"
    },
    {
     "description": "CHOW TAI FOOK JEWEL-UNSP ADR",
     "symbol": "CJEWY"
    },
    {
     "description": "GUNPOINT EXPLORATION LTD",
     "symbol": "CJIMF"
    },
    {
     "description": "CHINA JO-JO DRUGSTORES HOLDI",
     "symbol": "CJJD"
    },
    {
     "description": "CHINA JINMAO HOLDINGS GROUP",
     "symbol": "CJNHF"
    },
    {
     "description": "CENTRAL JAPAN RAILWAY CO",
     "symbol": "CJPRF"
    },
    {
     "description": "CENTRAL JAPAN RAI-UNSPON ADR",
     "symbol": "CJPRY"
    },
    {
     "description": "CHINA RESOURCES CEMENT",
     "symbol": "CJRCF"
    },
    {
     "description": "CORUS ENTERTAINMENT INC-B SH",
     "symbol": "CJREF"
    },
    {
     "description": "COKAL LTD",
     "symbol": "CKALF"
    },
    {
     "description": "CLARK COUNTY BANCORPORATION",
     "symbol": "CKCB"
    },
    {
     "description": "OPTHEA LTD",
     "symbol": "CKDXF"
    },
    {
     "description": "RADIO FUELS ENERGY CORPRADIO",
     "symbol": "CKEFF"
    },
    {
     "description": "KALNORTH GOLD MINES LTD",
     "symbol": "CKGDF"
    },
    {
     "description": "CAPITEC BANK HOLDINGS LTD",
     "symbol": "CKHGF"
    },
    {
     "description": "CAPITEC BANK HOLDINGS LT-ADR",
     "symbol": "CKHGY"
    },
    {
     "description": "CK HUTCHISON HOLDINGS LTD",
     "symbol": "CKHUF"
    },
    {
     "description": "CK HUTCHISON HOLDIN-UNSP ADR",
     "symbol": "CKHUY"
    },
    {
     "description": "CK INFRASTRUCTURE HOLDINGS L",
     "symbol": "CKISF"
    },
    {
     "description": "CK INFRASTRUCTURE - UNSP ADR",
     "symbol": "CKISY"
    },
    {
     "description": "CARMAT",
     "symbol": "CKMTF"
    },
    {
     "description": "CLARKSON PLC",
     "symbol": "CKNHF"
    },
    {
     "description": "Cobank ACB",
     "symbol": "CKNQP"
    },
    {
     "description": "CELL KINETICS LTD",
     "symbol": "CKNTF"
    },
    {
     "description": "CHUDENKO CORP",
     "symbol": "CKOCF"
    },
    {
     "description": "COOKPAD INC - UNSP ADR",
     "symbol": "CKPDY"
    },
    {
     "description": "CHECKPOINT THERAPEUTICS INC",
     "symbol": "CKPT"
    },
    {
     "description": "CREEK & RIVER CO LTD",
     "symbol": "CKRVF"
    },
    {
     "description": "VESUVIUS PLC",
     "symbol": "CKSNF"
    },
    {
     "description": "VESUVIUS PLC - UNSPON ADR",
     "symbol": "CKSNY"
    },
    {
     "description": "CKX LANDS INC",
     "symbol": "CKX"
    },
    {
     "description": "CYBERKEY SOLUTIONS INC",
     "symbol": "CKYS"
    },
    {
     "description": "CHUOKEIZAI-SHA HOLDINGS INC",
     "symbol": "CKZAF"
    },
    {
     "description": "COLGATE-PALMOLIVE CO",
     "symbol": "CL"
    },
    {
     "description": "COLONNADE ACQUISITION CORP-A",
     "symbol": "CLAA"
    },
    {
     "description": "COLONNADE ACQUISITION CORP I",
     "symbol": "CLAA.U"
    },
    {
     "description": "COLONNADE ACQ CL A -CW27",
     "symbol": "CLAA.WS"
    },
    {
     "description": "CORE ONE LABS INC",
     "symbol": "CLABF"
    },
    {
     "description": "CHINA LIAONING DINGXU ECOLOG",
     "symbol": "CLAD"
    },
    {
     "description": "CLAL INSURANCE ENTERPR HLDGS",
     "symbol": "CLALF"
    },
    {
     "description": "CLEANTECH ACQUISITION CORP",
     "symbol": "CLAQ"
    },
    {
     "description": "CLEANTECH ACQUISITION CO-RTS",
     "symbol": "CLAQR"
    },
    {
     "description": "CLEANTECH ACQUISITION CORP",
     "symbol": "CLAQU"
    },
    {
     "description": "CLEANTECH ACQUISITION CORPCW",
     "symbol": "CLAQW"
    },
    {
     "description": "CLARUS CORP",
     "symbol": "CLAR"
    },
    {
     "description": "CLASS ACCELERATION CORP-A",
     "symbol": "CLAS"
    },
    {
     "description": "CLASS ACCELERATION CORP",
     "symbol": "CLAS.U"
    },
    {
     "description": "CLASS ACCELERATION A -CW28",
     "symbol": "CLAS.WS"
    },
    {
     "description": "CAMELLIA PLC",
     "symbol": "CLAVF"
    },
    {
     "description": "CHAVANT CAPITAL ACQ CORP",
     "symbol": "CLAY"
    },
    {
     "description": "ISHARES 1-5 YEAR LADDERED CO",
     "symbol": "CLAYF"
    },
    {
     "description": "CHAVANT CAPITAL ACQ CORP",
     "symbol": "CLAYU"
    },
    {
     "description": "CHAVRANT CAPITAL ACQ -CW23",
     "symbol": "CLAYW"
    },
    {
     "description": "CLARITAS PHARMACEUTICALS INC",
     "symbol": "CLAZF"
    },
    {
     "description": "CORE LABORATORIES N.V.",
     "symbol": "CLB"
    },
    {
     "description": "CALBEE INC- UNSPONSORED ADR",
     "symbol": "CLBEY"
    },
    {
     "description": "COLUMBIA FINANCIAL INC",
     "symbol": "CLBK"
    },
    {
     "description": "CALIBER ENERGY INC",
     "symbol": "CLBN"
    },
    {
     "description": "COLOMBIER ACQUISITION CORP-A",
     "symbol": "CLBR"
    },
    {
     "description": "COLOMBIER ACQUISITION CORP",
     "symbol": "CLBR.U"
    },
    {
     "description": "COLOMBIER ACQ CL A -CW28",
     "symbol": "CLBR.WS"
    },
    {
     "description": "CALADRIUS BIOSCIENCES INC",
     "symbol": "CLBS"
    },
    {
     "description": "CELLEBRITE DI LTD",
     "symbol": "CLBT"
    },
    {
     "description": "CELLEBRITE DI LTD -CW23",
     "symbol": "CLBTW"
    },
    {
     "description": "CHRISTINA LAKE CANNABIS CORP",
     "symbol": "CLCFF"
    },
    {
     "description": "CLICKS GROUP LTD-SP ADR",
     "symbol": "CLCGY"
    },
    {
     "description": "CALCOL INC",
     "symbol": "CLCL"
    },
    {
     "description": "SINCH AB",
     "symbol": "CLCMF"
    },
    {
     "description": "CREATIVE LEARNING CORP",
     "symbol": "CLCN"
    },
    {
     "description": "CELL SOURCE INC",
     "symbol": "CLCS"
    },
    {
     "description": "CAPITALAND CHINA TRUST",
     "symbol": "CLDHF"
    },
    {
     "description": "DIREXION DAILY CLOUD BULL 2X",
     "symbol": "CLDL"
    },
    {
     "description": "DIREXION DAILY CLOUD BEAR 2X",
     "symbol": "CLDS"
    },
    {
     "description": "CHATHAM LODGING TRUST",
     "symbol": "CLDT"
    },
    {
     "description": "CHATHAM LODGING",
     "symbol": "CLDT.PRA"
    },
    {
     "description": "CELLDEX THERAPEUTICS INC",
     "symbol": "CLDX"
    },
    {
     "description": "COLES GROUP LTD",
     "symbol": "CLEGF"
    },
    {
     "description": "CHINA LIBERAL EDUCATION HOLD",
     "symbol": "CLEU"
    },
    {
     "description": "CONCRETE LEVELING SYSTEMS IN",
     "symbol": "CLEV"
    },
    {
     "description": "CLEVELAND-CLIFFS INC",
     "symbol": "CLF"
    },
    {
     "description": "CLEARFIELD INC",
     "symbol": "CLFD"
    },
    {
     "description": "ISHARES 1-5 YEAR LADDERED GO",
     "symbol": "CLFMF"
    },
    {
     "description": "CLARITY GOLD CORP",
     "symbol": "CLGCF"
    },
    {
     "description": "CALDAS GOLD CORP -CW",
     "symbol": "CLGDF"
    },
    {
     "description": "CLEGHORN MINERALS LTD",
     "symbol": "CLGMF"
    },
    {
     "description": "COLLPLANT BIOTECHNOLOGIES LT",
     "symbol": "CLGN"
    },
    {
     "description": "CLEAN SEED CAPITAL GROUP LTD",
     "symbol": "CLGPF"
    },
    {
     "description": "CLOUD NINE WEB3 TECHNOLOGIES",
     "symbol": "CLGUF"
    },
    {
     "description": "HUTECH21 COMPANY LTD",
     "symbol": "CLGZF"
    },
    {
     "description": "CLEAN HARBORS INC",
     "symbol": "CLH"
    },
    {
     "description": "CLST HOLDINGS INC",
     "symbol": "CLHI"
    },
    {
     "description": "COLTENE HOLDING AG-REG",
     "symbol": "CLHLF"
    },
    {
     "description": "CORDLIFE GROUP LTD",
     "symbol": "CLIFF"
    },
    {
     "description": "CLINIGEN GROUP PLC",
     "symbol": "CLIGF"
    },
    {
     "description": "CAPITALAND INVESTMENT LTD\/SI",
     "symbol": "CLILF"
    },
    {
     "description": "CLIMATE REAL IMPACT SOLUTI-A",
     "symbol": "CLIM"
    },
    {
     "description": "CLIMATE REAL IMPACT SOLUTION",
     "symbol": "CLIM.U"
    },
    {
     "description": "CLIMATE REAL IMPACT SOL-CW27",
     "symbol": "CLIM.WS"
    },
    {
     "description": "CLEAN EARTH ACQUISITIONS -A",
     "symbol": "CLIN"
    },
    {
     "description": "CLEAN EARTH ACQUISITION-RGHT",
     "symbol": "CLINR"
    },
    {
     "description": "CLEAN EARTH ACQUISITIONS COR",
     "symbol": "CLINU"
    },
    {
     "description": "CLEAN EARTH ACQUISITIONS -28",
     "symbol": "CLINW"
    },
    {
     "description": "CLEARSIGN TECHNOLOGIES CORP",
     "symbol": "CLIR"
    },
    {
     "description": "CLEARFORD WATER SYSTEMS INC",
     "symbol": "CLIRF"
    },
    {
     "description": "CLICKSTREAM CORP",
     "symbol": "CLIS"
    },
    {
     "description": "CITY OF LONDON INVESTMENT GR",
     "symbol": "CLIUF"
    },
    {
     "description": "PROSHARES LONG ONLINE\/SHORT",
     "symbol": "CLIX"
    },
    {
     "description": "CLARKE INC",
     "symbol": "CLKFF"
    },
    {
     "description": "CALCITECH LTD",
     "symbol": "CLKTF"
    },
    {
     "description": "TWC ENTERPRISES LTD",
     "symbol": "CLKXF"
    },
    {
     "description": "CLAYTON & LAMBERT MFG CO",
     "symbol": "CLLA"
    },
    {
     "description": "CHALLENGER EXPLORATION LTD",
     "symbol": "CLLEF"
    },
    {
     "description": "COLLINS FOODS LTD",
     "symbol": "CLLFF"
    },
    {
     "description": "CELL IMPACT AB",
     "symbol": "CLLIF"
    },
    {
     "description": "BICO GROUP AB",
     "symbol": "CLLKF"
    },
    {
     "description": "CELLNEX TELECOM SAU-UNSP ADR",
     "symbol": "CLLNY"
    },
    {
     "description": "CELLECTIS - ADR",
     "symbol": "CLLS"
    },
    {
     "description": "CALLINEX MINES INC",
     "symbol": "CLLXF"
    },
    {
     "description": "CORNERSTONE STRATEGIC VALUE",
     "symbol": "CLM"
    },
    {
     "description": "ICLIMA CLIMATE CHANGE SOLUTI",
     "symbol": "CLMA"
    },
    {
     "description": "CALGRO M3 HOLDINGS LTD",
     "symbol": "CLMHF"
    },
    {
     "description": "CLIMEON AB",
     "symbol": "CLMOF"
    },
    {
     "description": "CANADIAN PREMIUM SAND INC",
     "symbol": "CLMPF"
    },
    {
     "description": "CALUMET SPECIALTY PRODUCTS",
     "symbol": "CLMT"
    },
    {
     "description": "CLEAN ENERGY FUELS CORP",
     "symbol": "CLNE"
    },
    {
     "description": "CALIAN GROUP LTD",
     "symbol": "CLNFF"
    },
    {
     "description": "CLENE INC",
     "symbol": "CLNN"
    },
    {
     "description": "CLENE INC -CW25",
     "symbol": "CLNNW"
    },
    {
     "description": "IQ CLEANER TRANSPORT ETF",
     "symbol": "CLNR"
    },
    {
     "description": "CLEAN VISION CORP",
     "symbol": "CLNV"
    },
    {
     "description": "CELLNEX TELECOM SA",
     "symbol": "CLNXF"
    },
    {
     "description": "CLOVER LEAF CAPITAL CORP -A",
     "symbol": "CLOE"
    },
    {
     "description": "CLOETTA AB-B SHS",
     "symbol": "CLOEF"
    },
    {
     "description": "CLOVER LEAF CAPITAL CORP-RTS",
     "symbol": "CLOER"
    },
    {
     "description": "CLOVER LEAF CAPITAL CORP",
     "symbol": "CLOEU"
    },
    {
     "description": "CIPHERLOC CORP",
     "symbol": "CLOK"
    },
    {
     "description": "CYBERLOQ TECHNOLOGIES INC",
     "symbol": "CLOQ"
    },
    {
     "description": "GLOBAL X CLOUD COMPUTING ETF",
     "symbol": "CLOU"
    },
    {
     "description": "CLOVER HEALTH INVESTMENTS CO",
     "symbol": "CLOV"
    },
    {
     "description": "CLOUDWEB INC",
     "symbol": "CLOW"
    },
    {
     "description": "COLOPLAST-B",
     "symbol": "CLPBF"
    },
    {
     "description": "COLOPLAST A\/S-SPONSORED ADR",
     "symbol": "CLPBY"
    },
    {
     "description": "CLEAR PEAK ENERGY INC",
     "symbol": "CLPE"
    },
    {
     "description": "CLP HOLDINGS LTD",
     "symbol": "CLPHF"
    },
    {
     "description": "CLP HOLDINGS LTD-SPONS ADR",
     "symbol": "CLPHY"
    },
    {
     "description": "COMPAGNIE DES ALPES",
     "symbol": "CLPIF"
    },
    {
     "description": "CLIPPER LOGISTICS PLC",
     "symbol": "CLPLF"
    },
    {
     "description": "CLIPPER REALTY INC",
     "symbol": "CLPR"
    },
    {
     "description": "CLPS INC",
     "symbol": "CLPS"
    },
    {
     "description": "CLEARPOINT NEURO INC",
     "symbol": "CLPT"
    },
    {
     "description": "CHINA LONGYUAN POWER GROUP-H",
     "symbol": "CLPXF"
    },
    {
     "description": "CHINA LONGYUAN POWER-ADR",
     "symbol": "CLPXY"
    },
    {
     "description": "CLIQ DIGITAL AG",
     "symbol": "CLQDF"
    },
    {
     "description": "CONTINENTAL RESOURCES INC\/OK",
     "symbol": "CLR"
    },
    {
     "description": "CELLECTAR BIOSCIENCES INC",
     "symbol": "CLRB"
    },
    {
     "description": "CLEARDAY INC",
     "symbol": "CLRD"
    },
    {
     "description": "IQ CHAIKIN US LARGE CAP ETF",
     "symbol": "CLRG"
    },
    {
     "description": "CLEARTRONIC INC",
     "symbol": "CLRI"
    },
    {
     "description": "CLARIM ACQUISITION CORP-CL A",
     "symbol": "CLRM"
    },
    {
     "description": "CLEAN AIR METALS INC",
     "symbol": "CLRMF"
    },
    {
     "description": "CLARIM ACQUISITION CORP",
     "symbol": "CLRMU"
    },
    {
     "description": "CLARIM ACQ CL A -CW27",
     "symbol": "CLRMW"
    },
    {
     "description": "CLARENT CORP",
     "symbol": "CLRN"
    },
    {
     "description": "CLEARONE INC",
     "symbol": "CLRO"
    },
    {
     "description": "CLARITY PHARMACEUTICALS LTD",
     "symbol": "CLRPF"
    },
    {
     "description": "CASTILE RESOURCES LTD",
     "symbol": "CLRSF"
    },
    {
     "description": "CLAROCITY CORP",
     "symbol": "CLRYF"
    },
    {
     "description": "CELESTICA INC",
     "symbol": "CLS"
    },
    {
     "description": "CABANA TARGET LEADING SECTOR",
     "symbol": "CLSA"
    },
    {
     "description": "CABANA TARGET LEADING SECTOR",
     "symbol": "CLSC"
    },
    {
     "description": "CLEARSIDE BIOMEDICAL INC",
     "symbol": "CLSD"
    },
    {
     "description": "CONVERGENCE LONG\/SHORT EQY",
     "symbol": "CLSE"
    },
    {
     "description": "CLS HOLDINGS USA INC",
     "symbol": "CLSH"
    },
    {
     "description": "CLEANSPARK INC",
     "symbol": "CLSK"
    },
    {
     "description": "CABANA TARGET LEADING SECTOR",
     "symbol": "CLSM"
    },
    {
     "description": "CELSION CORP",
     "symbol": "CLSN"
    },
    {
     "description": "CANADIAN LIFE CO SPLIT CRP-A",
     "symbol": "CLSPF"
    },
    {
     "description": "CATALYST BANCORP INC",
     "symbol": "CLST"
    },
    {
     "description": "CHINA OIL AND GAS GROUP LTD",
     "symbol": "CLSZF"
    },
    {
     "description": "CALLIDITAS THERAPEUTICS-B",
     "symbol": "CLTEF"
    },
    {
     "description": "CELTIC PLC",
     "symbol": "CLTFF"
    },
    {
     "description": "CLEAN TECH BIOFUELS INC",
     "symbol": "CLTH"
    },
    {
     "description": "INVESCO TREASURY COLLATERAL",
     "symbol": "CLTL"
    },
    {
     "description": "EARTH LIFE SCIENCES INC",
     "symbol": "CLTS"
    },
    {
     "description": "CELERITY SOLUTIONS INC",
     "symbol": "CLTY"
    },
    {
     "description": "TOWN SPORTS INTERNATIONAL",
     "symbol": "CLUBQ"
    },
    {
     "description": "CLOVER CORP LTD",
     "symbol": "CLVCF"
    },
    {
     "description": "CLOVERLEAF KENNEL CLUB -CL A",
     "symbol": "CLVFA"
    },
    {
     "description": "CLINUVEL PHARMACEUTICALS LTD",
     "symbol": "CLVLF"
    },
    {
     "description": "CLINUVEL PHARMACUTIC-SP ADR",
     "symbol": "CLVLY"
    },
    {
     "description": "CLEVER LEAVES HOLDINGS INC",
     "symbol": "CLVR"
    },
    {
     "description": "CLEVER LEAVES HOLDINGS -CW",
     "symbol": "CLVRW"
    },
    {
     "description": "CLOVIS ONCOLOGY INC",
     "symbol": "CLVS"
    },
    {
     "description": "CELLAVISION AB",
     "symbol": "CLVSF"
    },
    {
     "description": "CLARIVATE PLC",
     "symbol": "CLVT"
    },
    {
     "description": "CLARIVATE PLC",
     "symbol": "CLVT.PRA"
    },
    {
     "description": "CLEARWATER PAPER CORP",
     "symbol": "CLW"
    },
    {
     "description": "CALLWAVE INC",
     "symbol": "CLWA"
    },
    {
     "description": "EURO TECH HOLDINGS CO LTD",
     "symbol": "CLWT"
    },
    {
     "description": "CALLOWAY'S NURSERY INC",
     "symbol": "CLWY"
    },
    {
     "description": "CLOROX COMPANY",
     "symbol": "CLX"
    },
    {
     "description": "CALIX LTD",
     "symbol": "CLXLF"
    },
    {
     "description": "COLLEXIS HOLDINGS INC",
     "symbol": "CLXS"
    },
    {
     "description": "CALYXT INC",
     "symbol": "CLXT"
    },
    {
     "description": "ISHARES GLOBAL AGRICULTURE I",
     "symbol": "CLYAF"
    },
    {
     "description": "ISHARES S&P\/TSX CANADIAN DIV",
     "symbol": "CLYLF"
    },
    {
     "description": "CATALYST METALS LTD",
     "symbol": "CLYMF"
    },
    {
     "description": "CELYAD ONCOLOGY",
     "symbol": "CLYYF"
    },
    {
     "description": "CLARIANT AG-REG",
     "symbol": "CLZNF"
    },
    {
     "description": "CLARIANT AG-UNSPONSORED ADR",
     "symbol": "CLZNY"
    },
    {
     "description": "CAN IMPERIAL BK OF COMMERCE",
     "symbol": "CM"
    },
    {
     "description": "COMERICA INC",
     "symbol": "CMA"
    },
    {
     "description": "CHINA MINSHENG BANKING-ADR",
     "symbol": "CMAKY"
    },
    {
     "description": "CHIBOUGAMAU INDEPENDENT MINE",
     "symbol": "CMAUF"
    },
    {
     "description": "CAREMAX INC",
     "symbol": "CMAX"
    },
    {
     "description": "CAREMAX-CW",
     "symbol": "CMAXW"
    },
    {
     "description": "CAMBIUM NETWORKS CORP",
     "symbol": "CMBM"
    },
    {
     "description": "CEMBRA MONEY BANK AG",
     "symbol": "CMBNF"
    },
    {
     "description": "ISHARES CMBS ETF",
     "symbol": "CMBS"
    },
    {
     "description": "CAMBIUM GLOBAL TIMBERLAND LT",
     "symbol": "CMBXF"
    },
    {
     "description": "COMMERCIAL METALS CO",
     "symbol": "CMC"
    },
    {
     "description": "CAPITALWORKS EMERGING M-CL A",
     "symbol": "CMCA"
    },
    {
     "description": "CAPITALWORKS EMERGING MARKET",
     "symbol": "CMCAU"
    },
    {
     "description": "CAPITALWORKS EMERGING-CW23",
     "symbol": "CMCAW"
    },
    {
     "description": "CALEDONIA MINING CORP PLC",
     "symbol": "CMCL"
    },
    {
     "description": "CHINA MOLYBDENUM CO LTD-H",
     "symbol": "CMCLF"
    },
    {
     "description": "CHEETAH MOBILE INC - ADR",
     "symbol": "CMCM"
    },
    {
     "description": "COLUMBUS MCKINNON CORP\/NY",
     "symbol": "CMCO"
    },
    {
     "description": "COMCAST CORP-CLASS A",
     "symbol": "CMCSA"
    },
    {
     "description": "CREATIVE MEDIA & COMMUNITY T",
     "symbol": "CMCT"
    },
    {
     "description": "CREATIVE MEDIA & CMNTY",
     "symbol": "CMCTP"
    },
    {
     "description": "CMC METALS LTD",
     "symbol": "CMCXF"
    },
    {
     "description": "CURTIS MATHES CORP",
     "symbol": "CMCZ"
    },
    {
     "description": "CHINA MODERN DAIRY HOLDINGS",
     "symbol": "CMDKF"
    },
    {
     "description": "COMMANDER RESOURCES LTD",
     "symbol": "CMDRF"
    },
    {
     "description": "COMPUTER MODELLING GROUP LTD",
     "symbol": "CMDXF"
    },
    {
     "description": "ISHARES BLOOMBERG ROLL SELEC",
     "symbol": "CMDY"
    },
    {
     "description": "CME GROUP INC",
     "symbol": "CME"
    },
    {
     "description": "COMPUTER ENGINEER & CONSULT",
     "symbol": "CMECF"
    },
    {
     "description": "CHINA MEIDONG AUTO HOLDINGS",
     "symbol": "CMEIF"
    },
    {
     "description": "POWER NICKEL INC",
     "symbol": "CMETF"
    },
    {
     "description": "CMONEY INC",
     "symbol": "CMEY"
    },
    {
     "description": "ISHARES CALIFORNIA MUNI BOND",
     "symbol": "CMF"
    },
    {
     "description": "CHINA MARINE FOOD GROUP LTD",
     "symbol": "CMFO"
    },
    {
     "description": "COMF5 INTERNATIONAL INC",
     "symbol": "CMFV"
    },
    {
     "description": "CHIPOTLE MEXICAN GRILL INC",
     "symbol": "CMG"
    },
    {
     "description": "CMGE TECHNOLOGY GROUP LTD",
     "symbol": "CMGEF"
    },
    {
     "description": "COMMERCIAL INTL BANK-GDR REG",
     "symbol": "CMGGF"
    },
    {
     "description": "CHAODA MODERN AGRICULTURE",
     "symbol": "CMGHF"
    },
    {
     "description": "CHAODA MODERN-UNSPON ADR",
     "symbol": "CMGHY"
    },
    {
     "description": "CHEMRING GROUP PLC",
     "symbol": "CMGMF"
    },
    {
     "description": "CHEMRING GROUP PLC-UNSP ADR",
     "symbol": "CMGMY"
    },
    {
     "description": "CMG HOLDINGS GROUP INC",
     "symbol": "CMGO"
    },
    {
     "description": "CLUBHOUSE MEDIA GROUP INC",
     "symbol": "CMGR"
    },
    {
     "description": "COMMUNITY HERITAGE FINANCIAL",
     "symbol": "CMHF"
    },
    {
     "description": "CIA MINERA AUTLAN-SER B",
     "symbol": "CMHFF"
    },
    {
     "description": "CHINA MERCHANTS PORT HOLDING",
     "symbol": "CMHHF"
    },
    {
     "description": "CHINA MERCHANTS-UNSPON ADR",
     "symbol": "CMHHY"
    },
    {
     "description": "COMPREHENSIVE HEALTHCARE SYS",
     "symbol": "CMHSF"
    },
    {
     "description": "BANNY COSMIC INTERNATIONAL H",
     "symbol": "CMHZ"
    },
    {
     "description": "CUMMINS INC",
     "symbol": "CMI"
    },
    {
     "description": "CMIC HOLDINGS CO LTD",
     "symbol": "CMICF"
    },
    {
     "description": "CAPELLA MINERALS LTD",
     "symbol": "CMILF"
    },
    {
     "description": "CHANGMING INDUSTRIAL MANAGEM",
     "symbol": "CMIM"
    },
    {
     "description": "CMARK INTERNATIONAL INC",
     "symbol": "CMIT"
    },
    {
     "description": "ISHARES CORE JP IMI USD-DIST",
     "symbol": "CMJIF"
    },
    {
     "description": "CMK GAMING INTERNATIONAL INC",
     "symbol": "CMKI"
    },
    {
     "description": "CANICKEL MINING LTD",
     "symbol": "CMLGF"
    },
    {
     "description": "CUMULUS MEDIA INC-CL A",
     "symbol": "CMLS"
    },
    {
     "description": "CHEMOMAB THERAPEUTICS LTD",
     "symbol": "CMMB"
    },
    {
     "description": "OXE MARINE AB",
     "symbol": "CMMCF"
    },
    {
     "description": "COMSTOCK METALS LTD",
     "symbol": "CMMMF"
    },
    {
     "description": "CEMEX HOLDINGS PHILIPPINES I",
     "symbol": "CMMXF"
    },
    {
     "description": "CLEARMIND MEDICINE INC",
     "symbol": "CMNDF"
    },
    {
     "description": "COMMERCE ENERGY GROUP INC",
     "symbol": "CMNR"
    },
    {
     "description": "CHINA MULANS NANO TECHNOLOGY",
     "symbol": "CMNT"
    },
    {
     "description": "COSMOPOLITAN INTL HLDGS",
     "symbol": "CMOIF"
    },
    {
     "description": "COSMO PHARMACEUTICALS NV",
     "symbol": "CMOPF"
    },
    {
     "description": "CURTISS MOTORCYCLES CO INC",
     "symbol": "CMOT"
    },
    {
     "description": "ISHARES GLOBAL WATER INDEX E",
     "symbol": "CMOXF"
    },
    {
     "description": "COMPASS MINERALS INTERNATION",
     "symbol": "CMP"
    },
    {
     "description": "COMPANHIA BRASILEIRA DE ALUM",
     "symbol": "CMPBY"
    },
    {
     "description": "COMPUMED INC",
     "symbol": "CMPD"
    },
    {
     "description": "COMPAL ELECTRONICS-REG S GDR",
     "symbol": "CMPFF"
    },
    {
     "description": "COMPASS GROUP PLC",
     "symbol": "CMPGF"
    },
    {
     "description": "COMPASS GROUP PLC-SPON ADR",
     "symbol": "CMPGY"
    },
    {
     "description": "CHECKMATE PHARMACEUTICALS IN",
     "symbol": "CMPI"
    },
    {
     "description": "CHAMPION REIT",
     "symbol": "CMPNF"
    },
    {
     "description": "COMPOSECURE INC",
     "symbol": "CMPO"
    },
    {
     "description": "COMPOSECURE INC -CW25",
     "symbol": "CMPOW"
    },
    {
     "description": "CIMPRESS PLC",
     "symbol": "CMPR"
    },
    {
     "description": "GENTERA SAB DE CV",
     "symbol": "CMPRF"
    },
    {
     "description": "COMPASS PATHWAYS PLC",
     "symbol": "CMPS"
    },
    {
     "description": "COMPUGROUP MEDICAL SE-ADR",
     "symbol": "CMPUY"
    },
    {
     "description": "COMPUGROUP MEDICAL SE & CO K",
     "symbol": "CMPVF"
    },
    {
     "description": "COMPASS THERAPEUTICS INC",
     "symbol": "CMPX"
    },
    {
     "description": "COMEPAY INC",
     "symbol": "CMPY"
    },
    {
     "description": "FIRST COMMERCE BANK\/LAKEWOOD",
     "symbol": "CMRB"
    },
    {
     "description": "COSTAMARE INC",
     "symbol": "CMRE"
    },
    {
     "description": "COSTAMARE INC",
     "symbol": "CMRE.PRB"
    },
    {
     "description": "COSTAMARE INC",
     "symbol": "CMRE.PRC"
    },
    {
     "description": "COSTAMARE INC",
     "symbol": "CMRE.PRD"
    },
    {
     "description": "COSTAMARE INC",
     "symbol": "CMRE.PRE"
    },
    {
     "description": "CIM REAL ESTATE FINANCE TRUS",
     "symbol": "CMRF"
    },
    {
     "description": "CHIMERIX INC",
     "symbol": "CMRX"
    },
    {
     "description": "COMMERCE RESOURCES CORP",
     "symbol": "CMRZF"
    },
    {
     "description": "CMS ENERGY CORP",
     "symbol": "CMS"
    },
    {
     "description": "CONSUMERS ENERGY CO",
     "symbol": "CMS.PRB"
    },
    {
     "description": "CMS ENERGY CORP",
     "symbol": "CMS.PRC"
    },
    {
     "description": "CMS ENERGY CORP",
     "symbol": "CMSA"
    },
    {
     "description": "CMS ENERGY CORP",
     "symbol": "CMSC"
    },
    {
     "description": "CMS ENERGY CORP",
     "symbol": "CMSD"
    },
    {
     "description": "COMPUTERSHARE LTD",
     "symbol": "CMSQF"
    },
    {
     "description": "COMPUTERSHARE LTD -SPONS ADR",
     "symbol": "CMSQY"
    },
    {
     "description": "COMSYS HOLDINGS CORP",
     "symbol": "CMSYF"
    },
    {
     "description": "CORE MOLDING TECHNOLOGIES IN",
     "symbol": "CMT"
    },
    {
     "description": "SUMITOMO MITSUI TRUST HOLDIN",
     "symbol": "CMTDF"
    },
    {
     "description": "CLAROS MORTGAGE TRUST INC",
     "symbol": "CMTG"
    },
    {
     "description": "COMTECH TELECOMMUNICATIONS",
     "symbol": "CMTL"
    },
    {
     "description": "CEMENTOS ARGOS SA-SPON ADR",
     "symbol": "CMTOY"
    },
    {
     "description": "CEMENTOS ARGOS-SPN ADR REGS",
     "symbol": "CMTSY"
    },
    {
     "description": "COMTURE CORP",
     "symbol": "CMTUF"
    },
    {
     "description": "COMMUNITY BANCORP INC\/VT",
     "symbol": "CMTV"
    },
    {
     "description": "COMTEX NEWS NETWORK INC",
     "symbol": "CMTX"
    },
    {
     "description": "MFS HIGH YIELD MUNICIPAL TRU",
     "symbol": "CMU"
    },
    {
     "description": "CMUV BANCORP",
     "symbol": "CMUV"
    },
    {
     "description": "CELLECTIS",
     "symbol": "CMVLF"
    },
    {
     "description": "COMMONWEALTH BK AUS-SP ADR",
     "symbol": "CMWAY"
    },
    {
     "description": "CROMWELL PROPERTY GROUP",
     "symbol": "CMWCF"
    },
    {
     "description": "CELL MEDX CORP",
     "symbol": "CMXC"
    },
    {
     "description": "CSL LTD",
     "symbol": "CMXHF"
    },
    {
     "description": "CORP MOCTEZUMA-SER *",
     "symbol": "CMZOF"
    },
    {
     "description": "CAIRO MEZZ PLC",
     "symbol": "CMZZF"
    },
    {
     "description": "XTRACKERS MSCI ALL CHINA EQU",
     "symbol": "CN"
    },
    {
     "description": "CNA FINANCIAL CORP",
     "symbol": "CNA"
    },
    {
     "description": "CANNASOUTH LTD",
     "symbol": "CNAAF"
    },
    {
     "description": "COMMERCIAL NATL FINL CORP\/PA",
     "symbol": "CNAF"
    },
    {
     "description": "Canadian Utilities Ltd ",
     "symbol": "CNAUF"
    },
    {
     "description": "CHESTER BANCORP INC",
     "symbol": "CNBA"
    },
    {
     "description": "CNB COMMUNITY BANCORP INC",
     "symbol": "CNBB"
    },
    {
     "description": "CHINA BCT PHARMA GROUP INC",
     "symbol": "CNBI"
    },
    {
     "description": "CITIZENS NATIONAL BANCSHARES",
     "symbol": "CNBL"
    },
    {
     "description": "CNB BANK SHARES INC",
     "symbol": "CNBN"
    },
    {
     "description": "CORNERSTONE BANCORP INC\/IL",
     "symbol": "CNBP"
    },
    {
     "description": "AMPLIFY SEYMOUR CANNABIS ETF",
     "symbol": "CNBS"
    },
    {
     "description": "CNB CORP",
     "symbol": "CNBW"
    },
    {
     "description": "CNBX PHARMACEUTICALS INC",
     "symbol": "CNBX"
    },
    {
     "description": "CNB CORPORATION \/MI",
     "symbol": "CNBZ"
    },
    {
     "description": "CENTENE CORP",
     "symbol": "CNC"
    },
    {
     "description": "CANNA CORP",
     "symbol": "CNCC"
    },
    {
     "description": "CONCERT PHARMACEUTICALS INC",
     "symbol": "CNCE"
    },
    {
     "description": "CONNECTED MEDIA TECHNOLGIES",
     "symbol": "CNCM"
    },
    {
     "description": "CHUN CAN CAPITAL GROUP",
     "symbol": "CNCN"
    },
    {
     "description": "CONDUIT CAPITAL LTD",
     "symbol": "CNCPF"
    },
    {
     "description": "LONCAR CANCER IMMUNOTHERAPY",
     "symbol": "CNCR"
    },
    {
     "description": "CHINA TELETECH HOLDING INC",
     "symbol": "CNCT"
    },
    {
     "description": "CONICO LTD",
     "symbol": "CNCZF"
    },
    {
     "description": "CONCORD ACQUISITION CORP -A",
     "symbol": "CND"
    },
    {
     "description": "CONCORD ACQUISITION CORP",
     "symbol": "CND.U"
    },
    {
     "description": "CONCORD ACQ CORP -A -CW25",
     "symbol": "CND.WS"
    },
    {
     "description": "CONCORD ACQUISITION CORP -A",
     "symbol": "CNDA"
    },
    {
     "description": "CONCORD ACQUISITION CORP II",
     "symbol": "CNDA.U"
    },
    {
     "description": "CONCORD ACQUISITION A -CW28",
     "symbol": "CNDA.WS"
    },
    {
     "description": "CONCORD ACQUISITION CORP -A",
     "symbol": "CNDB"
    },
    {
     "description": "CONCORD ACQUISITION CORP III",
     "symbol": "CNDB.U"
    },
    {
     "description": "CONCORD ACQ CL A -CW28",
     "symbol": "CNDB.WS"
    },
    {
     "description": "CANADIAN BANC CORP",
     "symbol": "CNDCF"
    },
    {
     "description": "CONCORDE AMERICA INC",
     "symbol": "CNDD"
    },
    {
     "description": "CONDOR GOLD PLC",
     "symbol": "CNDGF"
    },
    {
     "description": "Canadian Imperial Bank",
     "symbol": "CNDIF"
    },
    {
     "description": "CANDLEWOOD HOTEL CO INC",
     "symbol": "CNDL"
    },
    {
     "description": "CANADA ENERGY PARTNERS INC",
     "symbol": "CNDPF"
    },
    {
     "description": "CONDUENT INC",
     "symbol": "CNDT"
    },
    {
     "description": "CHINA EVERBRIGHT GREENTECH L",
     "symbol": "CNEBF"
    },
    {
     "description": "CLAREN ENERGY CORP",
     "symbol": "CNENF"
    },
    {
     "description": "CHINA NEW ENERGY GROUP CO",
     "symbol": "CNER"
    },
    {
     "description": "ZW DATA ACTION TECHNOLOGIES",
     "symbol": "CNET"
    },
    {
     "description": "CHINA NEW HIGHER EDUCATION G",
     "symbol": "CNEWF"
    },
    {
     "description": "CN ENERGY GROUP INC",
     "symbol": "CNEY"
    },
    {
     "description": "CNFINANCE HOLDINGS LTD",
     "symbol": "CNF"
    },
    {
     "description": "CANAFARMA HEMP PRODUCTS CORP",
     "symbol": "CNFHF"
    },
    {
     "description": "CFN ENTERPRISES INC",
     "symbol": "CNFN"
    },
    {
     "description": "CONIFER HOLDINGS INC",
     "symbol": "CNFR"
    },
    {
     "description": "CONIFER HOLDINGS INC",
     "symbol": "CNFRL"
    },
    {
     "description": "CONAIR CORP\/NEW YORK",
     "symbol": "CNGA"
    },
    {
     "description": "CHANGE FINANCIAL LTD",
     "symbol": "CNGFF"
    },
    {
     "description": "CANN GROUP LTD",
     "symbol": "CNGGF"
    },
    {
     "description": "CONCORDIS GROUP INC",
     "symbol": "CNGI"
    },
    {
     "description": "CK ASSET HOLDINGS LTD-ADR",
     "symbol": "CNGKY"
    },
    {
     "description": "CANNA-GLOBAL ACQUISITIO-CL A",
     "symbol": "CNGL"
    },
    {
     "description": "CANNA-GLOBAL ACQUISITION COR",
     "symbol": "CNGLU"
    },
    {
     "description": "CANNA-GLOBAL ACQUISIT -CW23",
     "symbol": "CNGLW"
    },
    {
     "description": "CENGAGE LEARNING HOLDINGS II",
     "symbol": "CNGO"
    },
    {
     "description": "CANNAGISTICS INC",
     "symbol": "CNGT"
    },
    {
     "description": "CONIHASSET CAPITAL PARTNERS",
     "symbol": "CNHA"
    },
    {
     "description": "CHINA HEALTH MANAGEMENT CORP",
     "symbol": "CNHC"
    },
    {
     "description": "CAIRN HOMES PLC-ADR",
     "symbol": "CNHHY"
    },
    {
     "description": "CNH INDUSTRIAL NV",
     "symbol": "CNHI"
    },
    {
     "description": "CANADIAN NATL RAILWAY CO",
     "symbol": "CNI"
    },
    {
     "description": "CHINA INTERNATIONAL CAPITA-H",
     "symbol": "CNICF"
    },
    {
     "description": "CENTURIA INDUSTRIAL REIT",
     "symbol": "CNIEF"
    },
    {
     "description": "CORNING NATURAL GAS HOLDING",
     "symbol": "CNIG"
    },
    {
     "description": "Corning Natural Gas Holding Corporation ",
     "symbol": "CNIGO"
    },
    {
     "description": "Corning Natural Gas Holding Corporation ",
     "symbol": "CNIGP"
    },
    {
     "description": "CANADA NICKEL CO INC",
     "symbol": "CNIKF"
    },
    {
     "description": "CHINA INTERNATIONAL MARINE-H",
     "symbol": "CNINF"
    },
    {
     "description": "CHINA INVESTMENT FUND CO LTD",
     "symbol": "CNIVF"
    },
    {
     "description": "JUFEEL INTERNATIONAL GROUP",
     "symbol": "CNJG"
    },
    {
     "description": "CINEMARK HOLDINGS INC",
     "symbol": "CNK"
    },
    {
     "description": "CANLAN ICE SPORTS CORP",
     "symbol": "CNLFF"
    },
    {
     "description": "Connecticut Light and Power Company",
     "symbol": "CNLHN"
    },
    {
     "description": "Connecticut Light and Power Company",
     "symbol": "CNLHO"
    },
    {
     "description": "Connecticut Light and Power Company",
     "symbol": "CNLHP"
    },
    {
     "description": "CANNALINK INC",
     "symbol": "CNLK"
    },
    {
     "description": "COLLECTIVE MINING LTD",
     "symbol": "CNLMF"
    },
    {
     "description": "Connecticut Light and Power Company",
     "symbol": "CNLPL"
    },
    {
     "description": "Connecticut Light and Power Company",
     "symbol": "CNLPM"
    },
    {
     "description": "Connecticut Light and Power Company",
     "symbol": "CNLTL"
    },
    {
     "description": "Connecticut Light and Power Company",
     "symbol": "CNLTN"
    },
    {
     "description": "Connecticut Light and Power Company",
     "symbol": "CNLTP"
    },
    {
     "description": "CORE & MAIN INC-CLASS A",
     "symbol": "CNM"
    },
    {
     "description": "CONMED CORP",
     "symbol": "CNMD"
    },
    {
     "description": "CANADIAN METALS INC",
     "symbol": "CNMTF"
    },
    {
     "description": "CANOE MINING VENTURES CORP",
     "symbol": "CNMVF"
    },
    {
     "description": "CANAMEX GOLD CORP",
     "symbol": "CNMXF"
    },
    {
     "description": "CANN AMERICAN CORP",
     "symbol": "CNNA"
    },
    {
     "description": "CINCINNATI BANCORP INC",
     "symbol": "CNNB"
    },
    {
     "description": "CANNONAU CORP",
     "symbol": "CNNC"
    },
    {
     "description": "CANANDAIGUA NATIONAL CORP",
     "symbol": "CNND"
    },
    {
     "description": "CANNAE HOLDINGS INC",
     "symbol": "CNNE"
    },
    {
     "description": "CANACOL ENERGY LTD",
     "symbol": "CNNEF"
    },
    {
     "description": "CHINA NETWORK MEDIA INC",
     "symbol": "CNNM"
    },
    {
     "description": "CINEWORLD GROUP PLC",
     "symbol": "CNNWF"
    },
    {
     "description": "CANNAMERICA BRANDS CORP",
     "symbol": "CNNXF"
    },
    {
     "description": "CNO FINANCIAL GROUP INC",
     "symbol": "CNO"
    },
    {
     "description": "CNO FINANCIAL GROUP INC",
     "symbol": "CNO.PRA"
    },
    {
     "description": "CONNECTONE BANCORP INC",
     "symbol": "CNOB"
    },
    {
     "description": "HEMLO EXPLORERS INC",
     "symbol": "CNOBF"
    },
    {
     "description": "CONNECTONE BANCORP INC",
     "symbol": "CNOBP"
    },
    {
     "description": "LYNX GLOBAL DIGITAL FINANCE",
     "symbol": "CNONF"
    },
    {
     "description": "CENTERPOINT ENERGY INC",
     "symbol": "CNP"
    },
    {
     "description": "CNP ASSURANCES",
     "symbol": "CNPAF"
    },
    {
     "description": "CNP ASSURANCES-UNSPON ADR",
     "symbol": "CNPAY"
    },
    {
     "description": "RIV CAPITAL INC",
     "symbol": "CNPOF"
    },
    {
     "description": "CHINA OVERSEAS PROPERTY HOLD",
     "symbol": "CNPPF"
    },
    {
     "description": "CONDOR PETROLEUM INC",
     "symbol": "CNPRF"
    },
    {
     "description": "CENTRAL PETROLEUM LTD",
     "symbol": "CNPTF"
    },
    {
     "description": "Connecticut Light and Power Company",
     "symbol": "CNPWM"
    },
    {
     "description": "Connecticut Light and Power Company",
     "symbol": "CNPWP"
    },
    {
     "description": "CANADIAN NATURAL RESOURCES",
     "symbol": "CNQ"
    },
    {
     "description": "CENTRAL CHINA SECURITIES C-H",
     "symbol": "CNQNF"
    },
    {
     "description": "CLEAN TEQ WATER LTD",
     "symbol": "CNQQF"
    },
    {
     "description": "CORNERSTONE BUILDING BRANDS",
     "symbol": "CNR"
    },
    {
     "description": "VICINITY CENTRES",
     "symbol": "CNRAF"
    },
    {
     "description": "CONRAD INDUSTRIES INC",
     "symbol": "CNRD"
    },
    {
     "description": "CONSORCIO ARA S.A.B.-SER *",
     "symbol": "CNRFF"
    },
    {
     "description": "SPDR S&P KENSHO CLEAN POWER",
     "symbol": "CNRG"
    },
    {
     "description": "CONDOR RESOURCES INC",
     "symbol": "CNRIF"
    },
    {
     "description": "CN RESOURCES INC",
     "symbol": "CNRR"
    },
    {
     "description": "COHEN & STEERS INC",
     "symbol": "CNS"
    },
    {
     "description": "CHANGSHOUHUA FOOD CO LTD",
     "symbol": "CNSHF"
    },
    {
     "description": "CHINA SANJIANG FINE CHEMICAL",
     "symbol": "CNSJF"
    },
    {
     "description": "CONSOLIDATED COMMUNICATIONS",
     "symbol": "CNSL"
    },
    {
     "description": "CAENEUS MINERALS LTD",
     "symbol": "CNSMF"
    },
    {
     "description": "CONSTANTINE METAL RESOURCES",
     "symbol": "CNSNF"
    },
    {
     "description": "CNS PHARMACEUTICALS INC",
     "symbol": "CNSP"
    },
    {
     "description": "COINSHARES INTERNATIONAL LTD",
     "symbol": "CNSRF"
    },
    {
     "description": "CANASIL RESOURCES",
     "symbol": "CNSUF"
    },
    {
     "description": "CONSTELLATION SOFTWARE INC",
     "symbol": "CNSWF"
    },
    {
     "description": "CENTESSA PHARMACEUTICALS-ADR",
     "symbol": "CNTA"
    },
    {
     "description": "CONNECT BIOPHARMA HOLDINGS L",
     "symbol": "CNTB"
    },
    {
     "description": "CONTEL TECHNOLOGY CO LTD",
     "symbol": "CNTCF"
    },
    {
     "description": "CHINA TECHFAITH WIRELESS-ADR",
     "symbol": "CNTFY"
    },
    {
     "description": "CENTOGENE NV",
     "symbol": "CNTG"
    },
    {
     "description": "Connecticut Light and Power Company",
     "symbol": "CNTHN"
    },
    {
     "description": "Connecticut Light and Power Company",
     "symbol": "CNTHO"
    },
    {
     "description": "Connecticut Light and Power Company",
     "symbol": "CNTHP"
    },
    {
     "description": "CANSORTIUM INC",
     "symbol": "CNTMF"
    },
    {
     "description": "CENTOR ENERGY INC",
     "symbol": "CNTO"
    },
    {
     "description": "CHARDAN NEXTECH ACQUISITION",
     "symbol": "CNTQ"
    },
    {
     "description": "CHARDAN NEXTECH ACQUISITION",
     "symbol": "CNTQU"
    },
    {
     "description": "CHARDAN NEXTECH ACQUISI-CW27",
     "symbol": "CNTQW"
    },
    {
     "description": "CENTR BRANDS CORP",
     "symbol": "CNTRF"
    },
    {
     "description": "CANNTRUST HOLDINGS INC",
     "symbol": "CNTTQ"
    },
    {
     "description": "ALPHA METALLURGICAL -CW23",
     "symbol": "CNTWW"
    },
    {
     "description": "CONTEXT THERAPEUTICS INC",
     "symbol": "CNTX"
    },
    {
     "description": "CENTURY CASINOS INC",
     "symbol": "CNTY"
    },
    {
     "description": "CANUC RESOURCES CORP",
     "symbol": "CNUCF"
    },
    {
     "description": "COMMUNITY BANCSHARES INC\/OH",
     "symbol": "CNUN"
    },
    {
     "description": "Canadian Utilities Ltd",
     "symbol": "CNUTF"
    },
    {
     "description": "CNOVA NV",
     "symbol": "CNVAF"
    },
    {
     "description": "BIOHARVEST SCIENCES INC",
     "symbol": "CNVCF"
    },
    {
     "description": "CVF TECHNOLOGIES CORP",
     "symbol": "CNVT"
    },
    {
     "description": "CONVATEC GROUP PLC",
     "symbol": "CNVVF"
    },
    {
     "description": "CONVATEC GROUP PLC-UNSP ADR",
     "symbol": "CNVVY"
    },
    {
     "description": "CONVEY HEALTH SOLUTIONS HOLD",
     "symbol": "CNVY"
    },
    {
     "description": "CINEWORLD GROUP PLC-UNSP ADR",
     "symbol": "CNWGY"
    },
    {
     "description": "CHINA NETWORKS INTERNATIONAL",
     "symbol": "CNWHF"
    },
    {
     "description": "CARDIAC NETWORK INC",
     "symbol": "CNWI"
    },
    {
     "description": "CISTERA NETWORKS INC",
     "symbol": "CNWT"
    },
    {
     "description": "CNX RESOURCES CORP",
     "symbol": "CNX"
    },
    {
     "description": "CONCENTRIX CORP",
     "symbol": "CNXC"
    },
    {
     "description": "PC CONNECTION INC",
     "symbol": "CNXN"
    },
    {
     "description": "CONNEXUS CORP",
     "symbol": "CNXS"
    },
    {
     "description": "VANECK CHINEXT ETF",
     "symbol": "CNXT"
    },
    {
     "description": "ISHARES MSCI CHINA A ETF",
     "symbol": "CNYA"
    },
    {
     "description": "SEARCHLIGHT RESOURCES INC",
     "symbol": "CNYCF"
    },
    {
     "description": "GLOBAL CORD BLOOD CORP",
     "symbol": "CO"
    },
    {
     "description": "INTERNATIONAL COBALT CORP",
     "symbol": "COBAF"
    },
    {
     "description": "COMBA TELECOM SYSTEMS HOLDIN",
     "symbol": "COBJF"
    },
    {
     "description": "COASTAL CARIBBEAN OIL & MINL",
     "symbol": "COCBF"
    },
    {
     "description": "COSCO CAPITAL INC",
     "symbol": "COCCF"
    },
    {
     "description": "COMERTON CORP",
     "symbol": "COCM"
    },
    {
     "description": "VITA COCO CO INC\/THE",
     "symbol": "COCO"
    },
    {
     "description": "COCRYSTAL PHARMA INC",
     "symbol": "COCP"
    },
    {
     "description": "COCA-COLA FEMSA SAB DE CV",
     "symbol": "COCSF"
    },
    {
     "description": "CHOCOLADEFABRIKEN LINDT-REG",
     "symbol": "COCXF"
    },
    {
     "description": "CODA OCTOPUS GROUP INC",
     "symbol": "CODA"
    },
    {
     "description": "CODAN LTD",
     "symbol": "CODAF"
    },
    {
     "description": "CODERE SA",
     "symbol": "CODEF"
    },
    {
     "description": "COMPAGNIE DE SAINT GOBAIN",
     "symbol": "CODGF"
    },
    {
     "description": "COMPASS DIVERSIFIED HOLDINGS",
     "symbol": "CODI"
    },
    {
     "description": "COMPASS DIVERSIF HOLDING",
     "symbol": "CODI.PRA"
    },
    {
     "description": "COMPASS DIVERSIF HOLDING",
     "symbol": "CODI.PRB"
    },
    {
     "description": "COMPASS DIVERSIF HOLDING",
     "symbol": "CODI.PRC"
    },
    {
     "description": "CODAN LTD - UNSP ADR",
     "symbol": "CODLY"
    },
    {
     "description": "CODA MINERALS LTD",
     "symbol": "CODMF"
    },
    {
     "description": "CORONADO GLOBAL RESOURCE-CDI",
     "symbol": "CODQL"
    },
    {
     "description": "CO-DIAGNOSTICS INC",
     "symbol": "CODX"
    },
    {
     "description": "COMPAGNIE DE SAINT-UNSP ADR",
     "symbol": "CODYY"
    },
    {
     "description": "CHINA ONLINE EDUCATION-ADR",
     "symbol": "COE"
    },
    {
     "description": "CONTACT ENERGY LTD",
     "symbol": "COENF"
    },
    {
     "description": "COEPTIS THERAPEUTICS INC",
     "symbol": "COEP"
    },
    {
     "description": "CAPITAL ONE FINANCIAL CORP",
     "symbol": "COF"
    },
    {
     "description": "CAPITAL ONE FINANCIAL CO",
     "symbol": "COF.PRI"
    },
    {
     "description": "CAPITAL ONE FINANCIAL CO",
     "symbol": "COF.PRJ"
    },
    {
     "description": "CAPITAL ONE FINANCIAL CO",
     "symbol": "COF.PRK"
    },
    {
     "description": "CAPITAL ONE FINANCIAL CO",
     "symbol": "COF.PRL"
    },
    {
     "description": "CAPITAL ONE FINANCIAL CO",
     "symbol": "COF.PRN"
    },
    {
     "description": "CAFE HOLDINGS INC",
     "symbol": "COFE"
    },
    {
     "description": "CREDIT ONE FINANCIAL INC",
     "symbol": "COFI"
    },
    {
     "description": "COFCO JOYCOME FOODS LTD",
     "symbol": "COFJF"
    },
    {
     "description": "COMFORIA RESIDENTIAL REIT IN",
     "symbol": "COFRF"
    },
    {
     "description": "CHOICEONE FINANCIAL SVCS INC",
     "symbol": "COFS"
    },
    {
     "description": "COLOUR LIFE SERVICES GROUP",
     "symbol": "COFSF"
    },
    {
     "description": "CORONATION FUND MANAGERS LTD",
     "symbol": "COFUF"
    },
    {
     "description": "COMPASS GOLD CORP",
     "symbol": "COGDF"
    },
    {
     "description": "COGNA EDUCACAO SA",
     "symbol": "COGNY"
    },
    {
     "description": "CHONGQING RURAL COMMERCIAL-H",
     "symbol": "COGQF"
    },
    {
     "description": "COGENT BIOSCIENCES INC",
     "symbol": "COGT"
    },
    {
     "description": "COGNITIV INC",
     "symbol": "COGV"
    },
    {
     "description": "COINIX GMBH & CO KGAA",
     "symbol": "COGXF"
    },
    {
     "description": "COGSTATE LTD",
     "symbol": "COGZF"
    },
    {
     "description": "CHEETAH OIL & GAS LTD",
     "symbol": "COHG"
    },
    {
     "description": "COHEN & CO INC",
     "symbol": "COHN"
    },
    {
     "description": "COHERENT INC",
     "symbol": "COHR"
    },
    {
     "description": "COHU INC",
     "symbol": "COHU"
    },
    {
     "description": "CRODA INTERNATIONAL PLC",
     "symbol": "COIHF"
    },
    {
     "description": "CRODA INTERNATIONAL-UNS ADR",
     "symbol": "COIHY"
    },
    {
     "description": "CITADEL EXPLORATION INC",
     "symbol": "COIL"
    },
    {
     "description": "COINBASE GLOBAL INC -CLASS A",
     "symbol": "COIN"
    },
    {
     "description": "COCOALAND HOLDINGS BHD",
     "symbol": "COKAF"
    },
    {
     "description": "COCA-COLA CONSOLIDATED INC",
     "symbol": "COKE"
    },
    {
     "description": "COLUMBIA BANKING SYSTEM INC",
     "symbol": "COLB"
    },
    {
     "description": "COOL CHIPS PLC",
     "symbol": "COLCF"
    },
    {
     "description": "AMERICOLD REALTY TRUST",
     "symbol": "COLD"
    },
    {
     "description": "CARDNO LTD",
     "symbol": "COLDF"
    },
    {
     "description": "COLE OFFICE & INDUSTRIAL REI",
     "symbol": "COLE"
    },
    {
     "description": "COLABOR GROUP INC",
     "symbol": "COLFF"
    },
    {
     "description": "COLICITY INC-A",
     "symbol": "COLI"
    },
    {
     "description": "COLICITY INC",
     "symbol": "COLIU"
    },
    {
     "description": "COLICITY INC-A -CW27",
     "symbol": "COLIW"
    },
    {
     "description": "COLLEGIUM PHARMACEUTICAL INC",
     "symbol": "COLL"
    },
    {
     "description": "COLUMBIA SPORTSWEAR CO",
     "symbol": "COLM"
    },
    {
     "description": "CHINA MEDICAL & HEALTHCARE G",
     "symbol": "COLRF"
    },
    {
     "description": "COLT RESOURCES INC",
     "symbol": "COLTF"
    },
    {
     "description": "COLOSSUS MINERALS INC",
     "symbol": "COLUF"
    },
    {
     "description": "DIREXION AUSPICE BRD CMDTY",
     "symbol": "COM"
    },
    {
     "description": "GRANITESHARES BCOM BROAD STR",
     "symbol": "COMB"
    },
    {
     "description": "COMMSCOPE HOLDING CO INC",
     "symbol": "COMM"
    },
    {
     "description": "COMPASS INC - CLASS A",
     "symbol": "COMP"
    },
    {
     "description": "COMSOVEREIGN HOLDING CORP",
     "symbol": "COMS"
    },
    {
     "description": "COMSOVEREIGN HOLDING",
     "symbol": "COMSP"
    },
    {
     "description": "COMSOVEREIGN HOLDING -CW25",
     "symbol": "COMSW"
    },
    {
     "description": "ISHARES GSCI COMMODITY DYNAM",
     "symbol": "COMT"
    },
    {
     "description": "CONECTISYS CORP",
     "symbol": "CONC"
    },
    {
     "description": "CONN'S INC",
     "symbol": "CONN"
    },
    {
     "description": "CONX CORP-CLASS A SHARES",
     "symbol": "CONX"
    },
    {
     "description": "NICKEL 28 CAPITAL CORP",
     "symbol": "CONXF"
    },
    {
     "description": "CONX CORP",
     "symbol": "CONXU"
    },
    {
     "description": "CONX CORP-CLASS A -CW27",
     "symbol": "CONXW"
    },
    {
     "description": "COOPER COS INC\/THE",
     "symbol": "COO"
    },
    {
     "description": "TRAEGER INC",
     "symbol": "COOK"
    },
    {
     "description": "CORNER GROWTH ACQUISITION-A",
     "symbol": "COOL"
    },
    {
     "description": "CORNER GROWTH ACQUISITION CO",
     "symbol": "COOLU"
    },
    {
     "description": "CORNER GROWTH ACQ CL A -CW27",
     "symbol": "COOLW"
    },
    {
     "description": "MR COOPER GROUP INC",
     "symbol": "COOP"
    },
    {
     "description": "CARBIOS",
     "symbol": "COOSF"
    },
    {
     "description": "CONOCOPHILLIPS",
     "symbol": "COP"
    },
    {
     "description": "COPAUR MINERALS INC",
     "symbol": "COPAF"
    },
    {
     "description": "CROPLOGIC LTD",
     "symbol": "COPGF"
    },
    {
     "description": "CRESO PHARMA LTD",
     "symbol": "COPHF"
    },
    {
     "description": "COOPER ENERGY LTD",
     "symbol": "COPJF"
    },
    {
     "description": "MEDIVOLVE INC",
     "symbol": "COPRF"
    },
    {
     "description": "GLOBAL X COPPER MINERS ETF",
     "symbol": "COPX"
    },
    {
     "description": "COREO AG",
     "symbol": "CORAF"
    },
    {
     "description": "CORNWALL RESOURCES INC",
     "symbol": "CORC"
    },
    {
     "description": "CORDIA CORPORATION",
     "symbol": "CORG"
    },
    {
     "description": "TEUCRIUM CORN FUND",
     "symbol": "CORN"
    },
    {
     "description": "PIMCO INV GRADE CORP BD ETF",
     "symbol": "CORP"
    },
    {
     "description": "CORENERGY INFRASTRUCTURE TRU",
     "symbol": "CORR"
    },
    {
     "description": "CORENERGY INFRASTRUCTURE",
     "symbol": "CORR.PRA"
    },
    {
     "description": "CORSAIR PARTNERING CORP -A",
     "symbol": "CORS"
    },
    {
     "description": "CORSAIR PARTNERING CORP",
     "symbol": "CORS.U"
    },
    {
     "description": "CORSAIR PARTNERING A -CW27",
     "symbol": "CORS.WS"
    },
    {
     "description": "CORCEPT THERAPEUTICS INC",
     "symbol": "CORT"
    },
    {
     "description": "CORE SCIENTIFIC INC",
     "symbol": "CORZ"
    },
    {
     "description": "POWER & DIGITAL INFRAS -CW28",
     "symbol": "CORZW"
    },
    {
     "description": "COSMOS GROUP HOLDINGS INC",
     "symbol": "COSG"
    },
    {
     "description": "CO2 SOLUTIONS INC",
     "symbol": "COSLF"
    },
    {
     "description": "COSMOS HOLDINGS INC",
     "symbol": "COSM"
    },
    {
     "description": "COASTAL SOUTH BANCSHARES INC",
     "symbol": "COSO"
    },
    {
     "description": "COSIGO RESOURCES LTD",
     "symbol": "COSRF"
    },
    {
     "description": "COSTCO WHOLESALE CORP",
     "symbol": "COST"
    },
    {
     "description": "COSEL CO LTD",
     "symbol": "COSXF"
    },
    {
     "description": "COTINGA PHARMACEUTICALS INC",
     "symbol": "COTQF"
    },
    {
     "description": "COMPUTER RESOURCE TECHNOLOGI",
     "symbol": "COTR"
    },
    {
     "description": "Corts Trust JC Penney",
     "symbol": "COTRP"
    },
    {
     "description": "COTY INC-CL A",
     "symbol": "COTY"
    },
    {
     "description": "COUPA SOFTWARE INC",
     "symbol": "COUP"
    },
    {
     "description": "COURSERA INC",
     "symbol": "COUR"
    },
    {
     "description": "CHINA OUTFITTERS HOLDNGS LTD",
     "symbol": "COUTF"
    },
    {
     "description": "CORPORATE UNIVERSE INC",
     "symbol": "COUV"
    },
    {
     "description": "CRESCENT COVE ACQUISITION-A",
     "symbol": "COVA"
    },
    {
     "description": "COVA ACQUISITION CORP",
     "symbol": "COVAU"
    },
    {
     "description": "CRESCENT COVE ACQ A -CW27",
     "symbol": "COVAW"
    },
    {
     "description": "COVESTRO AG-SPONSORED ADR",
     "symbol": "COVTY"
    },
    {
     "description": "IPATH SERIES B BLOOMBERG LIV",
     "symbol": "COW"
    },
    {
     "description": "CARBONMETA TECHNOLOGIES INC",
     "symbol": "COWI"
    },
    {
     "description": "COWEN INC - A",
     "symbol": "COWN"
    },
    {
     "description": "COWEN INC",
     "symbol": "COWNL"
    },
    {
     "description": "CANAL CAPITAL CORP",
     "symbol": "COWP"
    },
    {
     "description": "Canal Capital Corp",
     "symbol": "COWPP"
    },
    {
     "description": "IPATH BLOOMBERG LIVESTOCK SU",
     "symbol": "COWTF"
    },
    {
     "description": "PACER US CASH COWS 100 ETF",
     "symbol": "COWZ"
    },
    {
     "description": "CITYCON OYJ",
     "symbol": "COYJF"
    },
    {
     "description": "CZR RESOURCES LTD",
     "symbol": "COZIF"
    },
    {
     "description": "CANADIAN PACIFIC RAILWAY LTD",
     "symbol": "CP"
    },
    {
     "description": "COPA HOLDINGS SA-CLASS A",
     "symbol": "CPA"
    },
    {
     "description": "CONYERS PARK III ACQUISITI-A",
     "symbol": "CPAA"
    },
    {
     "description": "CONYERS PARK III ACQUISITION",
     "symbol": "CPAAU"
    },
    {
     "description": "CONY P III -CW23",
     "symbol": "CPAAW"
    },
    {
     "description": "CEMENTOS PACASMAYO SAA - ADR",
     "symbol": "CPAC"
    },
    {
     "description": "COOKPAD INC",
     "symbol": "CPADF"
    },
    {
     "description": "CHAMPION PAIN CARE CORP",
     "symbol": "CPAI"
    },
    {
     "description": "CAPITALAND INTEGRATED COMMER",
     "symbol": "CPAMF"
    },
    {
     "description": "COUNTER PRESS ACQUISITION CO",
     "symbol": "CPAQ"
    },
    {
     "description": "COUNTER PRESS ACQUISITION CO",
     "symbol": "CPAQU"
    },
    {
     "description": "COUNTER PRESS ACQ -CW27",
     "symbol": "CPAQW"
    },
    {
     "description": "CATALYST PARTNERS ACQ-A",
     "symbol": "CPAR"
    },
    {
     "description": "CATALYST PARTNERS ACQUISITIO",
     "symbol": "CPARU"
    },
    {
     "description": "CATALYST PARTNERS AC A -CW27",
     "symbol": "CPARW"
    },
    {
     "description": "CAMPBELL SOUP CO",
     "symbol": "CPB"
    },
    {
     "description": "ALS LTD",
     "symbol": "CPBLF"
    },
    {
     "description": "CP ALL PCL",
     "symbol": "CPBQF"
    },
    {
     "description": "CATHAY PACIFIC AIRWAYS",
     "symbol": "CPCAF"
    },
    {
     "description": "CATHAY PAC AIRWAYS-SPONS ADR",
     "symbol": "CPCAY"
    },
    {
     "description": "STRIPER ENERGY INC",
     "symbol": "CPCC"
    },
    {
     "description": "COPPERCORP RESOURCES INC",
     "symbol": "CPCPF"
    },
    {
     "description": "CALLON PETROLEUM CO",
     "symbol": "CPE"
    },
    {
     "description": "VOYAGEUR MINERAL EXPLORERS C",
     "symbol": "CPEFF"
    },
    {
     "description": "UNITED STATES COPPER INDEX",
     "symbol": "CPER"
    },
    {
     "description": "CAPITAL ENVIRONMENT HOLDINGS",
     "symbol": "CPEVF"
    },
    {
     "description": "CENTRAL PACIFIC FINANCIAL CO",
     "symbol": "CPF"
    },
    {
     "description": "CAPITAL FINANCIAL HOLDINGS",
     "symbol": "CPFH"
    },
    {
     "description": "COPPER FOX METALS INC",
     "symbol": "CPFXF"
    },
    {
     "description": "CRESCENT POINT ENERGY CORP",
     "symbol": "CPG"
    },
    {
     "description": "CPP GROUP PLC-UNSP ADR",
     "symbol": "CPGPY"
    },
    {
     "description": "CANTERBURY PARK HOLDING CORP",
     "symbol": "CPHC"
    },
    {
     "description": "CONSUN PHARMACEUTICAL GROUP",
     "symbol": "CPHGF"
    },
    {
     "description": "CHINA PHARMA HOLDINGS INC",
     "symbol": "CPHI"
    },
    {
     "description": "CIPHER PHARMACEUTICALS INC",
     "symbol": "CPHRF"
    },
    {
     "description": "IQ REAL RETURN ETF",
     "symbol": "CPI"
    },
    {
     "description": "CIPIA VISION LTD",
     "symbol": "CPIAF"
    },
    {
     "description": "CHAMPION TECHNOLOGY HOLDINGS",
     "symbol": "CPIHF"
    },
    {
     "description": "CAPTIVA VERDE WELLNESS CORP",
     "symbol": "CPIVF"
    },
    {
     "description": "CUMBERLAND PHARMACEUTICALS",
     "symbol": "CPIX"
    },
    {
     "description": "CHESAPEAKE UTILITIES CORP",
     "symbol": "CPK"
    },
    {
     "description": "CHESAPEAKE FINL SHS INC",
     "symbol": "CPKF"
    },
    {
     "description": "AKWAABA MINING LTD",
     "symbol": "CPKOF"
    },
    {
     "description": "ISHARES MSCI US SML CAP ACC",
     "symbol": "CPLCF"
    },
    {
     "description": "COPPERLEAF TECHNOLOGIES",
     "symbol": "CPLFF"
    },
    {
     "description": "CAPITAL PRODUCT PARTNERS LP",
     "symbol": "CPLP"
    },
    {
     "description": "COMMERCEPLANET INC",
     "symbol": "CPLT"
    },
    {
     "description": "CANNAPHARMARX INC",
     "symbol": "CPMD"
    },
    {
     "description": "MOSAIC IMMUNOENGINEERING INC",
     "symbol": "CPMV"
    },
    {
     "description": "TELEFONICA DEL PERU-B",
     "symbol": "CPNBF"
    },
    {
     "description": "EURO SUN MINING INC",
     "symbol": "CPNFF"
    },
    {
     "description": "COUPANG INC",
     "symbol": "CPNG"
    },
    {
     "description": "Capstone Infrastructure Corporation",
     "symbol": "CPOIF"
    },
    {
     "description": "POP CULTURE GROUP CO LTD-A",
     "symbol": "CPOP"
    },
    {
     "description": "CHAROEN POKPHAND FOODS-NVDR",
     "symbol": "CPOUF"
    },
    {
     "description": "CENTRAL PATTANA PUB-UNSP ADR",
     "symbol": "CPPBY"
    },
    {
     "description": "CP ALL PCL-UNSP ADR",
     "symbol": "CPPCY"
    },
    {
     "description": "COPPERBANK RESOURCES CORP",
     "symbol": "CPPKF"
    },
    {
     "description": "COPPER MOUNTAIN MINING CORP",
     "symbol": "CPPMF"
    },
    {
     "description": "CASSIOPEA SPA",
     "symbol": "CPPSF"
    },
    {
     "description": "CIRCLE PROPERTY PLC",
     "symbol": "CPPTF"
    },
    {
     "description": "CONTINENTAL ENERGY CORP",
     "symbol": "CPPXF"
    },
    {
     "description": "CHINA POWER EQUIPMENT INC",
     "symbol": "CPQQ"
    },
    {
     "description": "Capital Power Corporation",
     "symbol": "CPRHF"
    },
    {
     "description": "CAPRI HOLDINGS LTD",
     "symbol": "CPRI"
    },
    {
     "description": "CORTELCO SYSTEMS PUERTO",
     "symbol": "CPROF"
    },
    {
     "description": "ALLIED COPPER CORP",
     "symbol": "CPRRF"
    },
    {
     "description": "COPART INC",
     "symbol": "CPRT"
    },
    {
     "description": "CATALYST PHARMACEUTICALS INC",
     "symbol": "CPRX"
    },
    {
     "description": "COOPER-STANDARD HOLDING",
     "symbol": "CPS"
    },
    {
     "description": "CSI Properties Ltd",
     "symbol": "CPSDF"
    },
    {
     "description": "CPS TECHNOLOGIES CORP",
     "symbol": "CPSH"
    },
    {
     "description": "COMPUTER PROGRAMS & SYSTEMS",
     "symbol": "CPSI"
    },
    {
     "description": "FRIDAY'S DOG HOLDINGS INC",
     "symbol": "CPSJF"
    },
    {
     "description": "CAPSTONE SYSTEMS INC",
     "symbol": "CPSN"
    },
    {
     "description": "CAPSOURCE FINANCIAL INC",
     "symbol": "CPSO"
    },
    {
     "description": "CONSUMER PORTFOLIO SERVICES",
     "symbol": "CPSS"
    },
    {
     "description": "CONSUMER PRODUCTS SERVCES GR",
     "symbol": "CPSV"
    },
    {
     "description": "CAMDEN PROPERTY TRUST",
     "symbol": "CPT"
    },
    {
     "description": "LOGAN RIDGE FINANCE CORP",
     "symbol": "CPTAG"
    },
    {
     "description": "LOGAN RIDGE FINANCE CORP",
     "symbol": "CPTAL"
    },
    {
     "description": "X S&P 500 EQUAL WEIGHT",
     "symbol": "CPTFF"
    },
    {
     "description": "CROWN PROPTECH ACQUISITION-A",
     "symbol": "CPTK"
    },
    {
     "description": "CROWN PROPTECH ACQUISITIONS",
     "symbol": "CPTK.U"
    },
    {
     "description": "CROWN PROPTECH ACQ A -CW27",
     "symbol": "CPTK.WS"
    },
    {
     "description": "CEPTON INC",
     "symbol": "CPTN"
    },
    {
     "description": "GROWTH CAPITAL ACQ -CW27",
     "symbol": "CPTNW"
    },
    {
     "description": "CAPITAL PROPERTIES INC-CL A",
     "symbol": "CPTP"
    },
    {
     "description": "COMPUTE HEALTH ACQUISITION-A",
     "symbol": "CPUH"
    },
    {
     "description": "COMPUTE HEALTH ACQUISITION C",
     "symbol": "CPUH.U"
    },
    {
     "description": "COMPUTE HEALTH ACQ A -CW27",
     "symbol": "CPUH.WS"
    },
    {
     "description": "CAPITAL VENTURE EUROPE PLC",
     "symbol": "CPVNF"
    },
    {
     "description": "CERES POWER HOLDINGS PLC",
     "symbol": "CPWHF"
    },
    {
     "description": "CHINA POWER INTERNATIONAL",
     "symbol": "CPWIF"
    },
    {
     "description": "Capital Power Corporation",
     "symbol": "CPWPF"
    },
    {
     "description": "OCEAN THERMAL ENERGY CORP",
     "symbol": "CPWR"
    },
    {
     "description": "CLEAN ENERGY PATHWAYS INC",
     "symbol": "CPWY"
    },
    {
     "description": "CINEPLEX INC",
     "symbol": "CPXGF"
    },
    {
     "description": "CAPITAL POWER CORP",
     "symbol": "CPXWF"
    },
    {
     "description": "CORPORATE PROPERTY-CLASS C",
     "symbol": "CPYA"
    },
    {
     "description": "COMPLIANCE ENERGY CORP",
     "symbol": "CPYCF"
    },
    {
     "description": "CUSTOM DESIGNED COMPRESSOR S",
     "symbol": "CPYJ"
    },
    {
     "description": "CAREPAYMENT TECHNOLOGIES INC",
     "symbol": "CPYT"
    },
    {
     "description": "CENTRICA PLC",
     "symbol": "CPYYF"
    },
    {
     "description": "CENTRICA PLC-SP ADR",
     "symbol": "CPYYY"
    },
    {
     "description": "CALAMOS LNG\/SHRT EQ & DYN",
     "symbol": "CPZ"
    },
    {
     "description": "MAKINGORG INC",
     "symbol": "CQCQ"
    },
    {
     "description": "CHENIERE ENERGY PARTNERS LP",
     "symbol": "CQP"
    },
    {
     "description": "INVESCO CHINA TECHNOLOGY ETF",
     "symbol": "CQQQ"
    },
    {
     "description": "CONQUEST RESOURCES LTD",
     "symbol": "CQRLF"
    },
    {
     "description": "CRANE CO",
     "symbol": "CR"
    },
    {
     "description": "CRA INTERNATIONAL INC",
     "symbol": "CRAI"
    },
    {
     "description": "VANECK OIL REFINERS ETF",
     "symbol": "CRAK"
    },
    {
     "description": "CREDIT AGRICOLE SA",
     "symbol": "CRARF"
    },
    {
     "description": "CREDIT AGRICOLE SA-UNSP ADR",
     "symbol": "CRARY"
    },
    {
     "description": "CRAWFORD UNITED CORP",
     "symbol": "CRAWA"
    },
    {
     "description": "CRAYON GROUP HOLDING AS",
     "symbol": "CRAYF"
    },
    {
     "description": "CORBY SPIRIT AND WINE-CL B",
     "symbol": "CRBBF"
    },
    {
     "description": "CHINA RESOURCES LAND LTD",
     "symbol": "CRBJF"
    },
    {
     "description": "CHINA RESOURCES LAND-UNS ADR",
     "symbol": "CRBJY"
    },
    {
     "description": "CAREBOOK TECHNOLOGIES INC",
     "symbol": "CRBKF"
    },
    {
     "description": "ISHARES MSCI ACWI LOW CARBON",
     "symbol": "CRBN"
    },
    {
     "description": "CARBON ENERGY CORP",
     "symbol": "CRBO"
    },
    {
     "description": "CORBUS PHARMACEUTICALS HOLDI",
     "symbol": "CRBP"
    },
    {
     "description": "CARIBOU BIOSCIENCES INC",
     "symbol": "CRBU"
    },
    {
     "description": "CALIFORNIA RESOURCES CORP",
     "symbol": "CRC"
    },
    {
     "description": "CHONGQUING RURAL - UNSPN ADR",
     "symbol": "CRCBY"
    },
    {
     "description": "CRRC CORP LTD ADR-UNSPONSOR",
     "symbol": "CRCCY"
    },
    {
     "description": "CALIFORNIA RESOURCES -CW27",
     "symbol": "CRCQW"
    },
    {
     "description": "CRICUT INC - CLASS A",
     "symbol": "CRCT"
    },
    {
     "description": "CANAGOLD RESOURCES LTD",
     "symbol": "CRCUF"
    },
    {
     "description": "CRYPTO CO\/THE",
     "symbol": "CRCW"
    },
    {
     "description": "CRAWFORD & COMPANY -CL A",
     "symbol": "CRD.A"
    },
    {
     "description": "CRAWFORD & CO  -CL B",
     "symbol": "CRD.B"
    },
    {
     "description": "CARDINAL ETHANOL LLC-MEMB UT",
     "symbol": "CRDE"
    },
    {
     "description": "CARDIFF ONCOLOGY INC",
     "symbol": "CRDF"
    },
    {
     "description": "CONCORDIA FINANCIAL GRP-ADR",
     "symbol": "CRDIY"
    },
    {
     "description": "CARDIOL THERAPEUTICS INC-A",
     "symbol": "CRDL"
    },
    {
     "description": "CREDO TECHNOLOGY GROUP HOLDI",
     "symbol": "CRDO"
    },
    {
     "description": "CERRADO GOLD INC",
     "symbol": "CRDOF"
    },
    {
     "description": "COMMUNITY REDEVELOPMENT INC",
     "symbol": "CRDV"
    },
    {
     "description": "CREATIVE TECHNOLOGY LTD",
     "symbol": "CREAF"
    },
    {
     "description": "CRESCERA CAPITAL ACQUIS-CL A",
     "symbol": "CREC"
    },
    {
     "description": "CRITICAL ELEMENTS LITHIUM CO",
     "symbol": "CRECF"
    },
    {
     "description": "CRESCERA CAPITAL ACQUISITION",
     "symbol": "CRECU"
    },
    {
     "description": "CRESCERA CAPITAL ACQ -CW23",
     "symbol": "CRECW"
    },
    {
     "description": "SMART POWERR CORP",
     "symbol": "CREG"
    },
    {
     "description": "CHINA RARE EARTH HLDGS LTD",
     "symbol": "CREQF"
    },
    {
     "description": "CARREFOUR SA",
     "symbol": "CRERF"
    },
    {
     "description": "CRESUD SACI-CW26",
     "symbol": "CRESW"
    },
    {
     "description": "CRESUD S.A.-SPONS ADR",
     "symbol": "CRESY"
    },
    {
     "description": "CARBON REVOLUTION LTD",
     "symbol": "CREVF"
    },
    {
     "description": "CREATIVE REALITIES INC",
     "symbol": "CREX"
    },
    {
     "description": "CREATIVE REALITIES INC-CW23",
     "symbol": "CREXW"
    },
    {
     "description": "CORNERSTONE TOTAL RETURN FND",
     "symbol": "CRF"
    },
    {
     "description": "CARD FACTORY PLC",
     "symbol": "CRFCF"
    },
    {
     "description": "ZEDCOR INC",
     "symbol": "CRFQF"
    },
    {
     "description": "BC CRAFT SUPPLY CO LTD",
     "symbol": "CRFTF"
    },
    {
     "description": "CAREFREE GROUP INC",
     "symbol": "CRFU"
    },
    {
     "description": "CHARGE ENTERPRISES INC",
     "symbol": "CRGE"
    },
    {
     "description": "CHINA RESOURCES GAS GROUP LT",
     "symbol": "CRGGF"
    },
    {
     "description": "CALISSIO RESOURCES GROUP INC",
     "symbol": "CRGP"
    },
    {
     "description": "CURAEGIS TECHNOLOGIES INC",
     "symbol": "CRGS"
    },
    {
     "description": "CRESCENT ENERGY INC-A",
     "symbol": "CRGY"
    },
    {
     "description": "CRH PLC-SPONSORED ADR",
     "symbol": "CRH"
    },
    {
     "description": "COHN ROBBINS HOLDINGS-CL A",
     "symbol": "CRHC"
    },
    {
     "description": "COHN ROBBINS HOLDINGS CORP",
     "symbol": "CRHC.U"
    },
    {
     "description": "COHN ROBBINS HOLDINGS -CW25",
     "symbol": "CRHC.WS"
    },
    {
     "description": "CRH PLC",
     "symbol": "CRHCF"
    },
    {
     "description": "CROSS-HARBOUR HOLDINGS LTD",
     "symbol": "CRHHF"
    },
    {
     "description": "CHINA RESOURCES BEER HOLDING",
     "symbol": "CRHKF"
    },
    {
     "description": "CHINA RESOURCES BEER-SP ADR",
     "symbol": "CRHKY"
    },
    {
     "description": "CARTER'S INC",
     "symbol": "CRI"
    },
    {
     "description": "CURIS INC",
     "symbol": "CRIS"
    },
    {
     "description": "OPTICA RARE EARTH & CMS",
     "symbol": "CRIT"
    },
    {
     "description": "CHINA RUNJI CEMENT INC",
     "symbol": "CRJI"
    },
    {
     "description": "CROSSJECT",
     "symbol": "CRJTF"
    },
    {
     "description": "COMSTOCK RESOURCES INC",
     "symbol": "CRK"
    },
    {
     "description": "CRANK MEDIA INC",
     "symbol": "CRKM"
    },
    {
     "description": "CROWN ELECTROKINETICS CORP",
     "symbol": "CRKN"
    },
    {
     "description": "CREEK ROAD MINERS INC",
     "symbol": "CRKR"
    },
    {
     "description": "CIRMAKER TECHNOLOGY CORP",
     "symbol": "CRKT"
    },
    {
     "description": "CHERKIZOVO GROUP-GDR REG S",
     "symbol": "CRKZY"
    },
    {
     "description": "CHARLES RIVER LABORATORIES",
     "symbol": "CRL"
    },
    {
     "description": "CRESCO LABS INC-SUBORDINATE",
     "symbol": "CRLBF"
    },
    {
     "description": "CARDINAL ENERGY LTD",
     "symbol": "CRLFF"
    },
    {
     "description": "CIRCUIT RESEARCH LABS INC",
     "symbol": "CRLI"
    },
    {
     "description": "Central Parking Financial Trust",
     "symbol": "CRLKP"
    },
    {
     "description": "COMET RESOURCES LTD",
     "symbol": "CRLLF"
    },
    {
     "description": "CRESCO LABS INC -CW22",
     "symbol": "CRLWF"
    },
    {
     "description": "SALESFORCE INC",
     "symbol": "CRM"
    },
    {
     "description": "CRUMBS BAKE SHOP INC",
     "symbol": "CRMBQ"
    },
    {
     "description": "CORMEDIX INC",
     "symbol": "CRMD"
    },
    {
     "description": "CERMETEK MICROELECTRNICS INC",
     "symbol": "CRMK"
    },
    {
     "description": "AMERICA'S CAR-MART INC",
     "symbol": "CRMT"
    },
    {
     "description": "CROMWELL EUROPEAN REIT",
     "symbol": "CRMWF"
    },
    {
     "description": "CREDITRISKMONITOR.COM INC",
     "symbol": "CRMZ"
    },
    {
     "description": "CERENCE INC",
     "symbol": "CRNC"
    },
    {
     "description": "CAPRICORN ENERGY-UNSPON ADR",
     "symbol": "CRNCY"
    },
    {
     "description": "CARRIANNA GROUP HOLDINGS CO",
     "symbol": "CRNGF"
    },
    {
     "description": "CAPRICORN METALS LTD",
     "symbol": "CRNLF"
    },
    {
     "description": "CERAGON NETWORKS LTD",
     "symbol": "CRNT"
    },
    {
     "description": "CRINETICS PHARMACEUTICALS IN",
     "symbol": "CRNX"
    },
    {
     "description": "CAPRICORN ENERGY PLC",
     "symbol": "CRNZF"
    },
    {
     "description": "PROSHARES ULTRASHORT AUD",
     "symbol": "CROC"
    },
    {
     "description": "MARIMACA COPPER CORP",
     "symbol": "CROJF"
    },
    {
     "description": "CROMBIE REAL ESTATE INVESTME",
     "symbol": "CROMF"
    },
    {
     "description": "CRONOS GROUP INC",
     "symbol": "CRON"
    },
    {
     "description": "CARIBOO ROSE RESOURCES LTD",
     "symbol": "CROOF"
    },
    {
     "description": "CROESUS RETAIL TRUST",
     "symbol": "CRORF"
    },
    {
     "description": "SPENDA LTD",
     "symbol": "CROTF"
    },
    {
     "description": "CROCS INC",
     "symbol": "CROX"
    },
    {
     "description": "COLUMBIAN ROPE CO",
     "symbol": "CRPE"
    },
    {
     "description": "CORP FINANCIERA COLOM-SP ADR",
     "symbol": "CRPFY"
    },
    {
     "description": "CERES POWER - UNSP ADR",
     "symbol": "CRPHY"
    },
    {
     "description": "CHINA RESOURCES POWER HOLDIN",
     "symbol": "CRPJF"
    },
    {
     "description": "CHINA RESOURCES-UNSPON ADR",
     "symbol": "CRPJY"
    },
    {
     "description": "CAPITAL & REGIONAL PLC",
     "symbol": "CRPLF"
    },
    {
     "description": "CEAPRO INC",
     "symbol": "CRPOF"
    },
    {
     "description": "FT SKYBR CRYPT & DIG ECON",
     "symbol": "CRPT"
    },
    {
     "description": "CREDITO REAL SAB DE CV SOFOM",
     "symbol": "CRQDF"
    },
    {
     "description": "CROOZ INC",
     "symbol": "CRQZF"
    },
    {
     "description": "CHEETAH CANYON RESOURCES COR",
     "symbol": "CRRDF"
    },
    {
     "description": "CARREFOUR SA-SP ADR",
     "symbol": "CRRFY"
    },
    {
     "description": "CORPORATE RESOURCE SERVICES",
     "symbol": "CRRSQ"
    },
    {
     "description": "CRESCITA THERAPEUTICS INC",
     "symbol": "CRRTF"
    },
    {
     "description": "CVR MEDICAL CORP",
     "symbol": "CRRVF"
    },
    {
     "description": "CARPENTER TECHNOLOGY",
     "symbol": "CRS"
    },
    {
     "description": "CORNERSTONE COMMUNITY BANCOR",
     "symbol": "CRSB"
    },
    {
     "description": "CARSALES.COM LTD",
     "symbol": "CRSLF"
    },
    {
     "description": "CARSMARTT INC",
     "symbol": "CRSM"
    },
    {
     "description": "CRISPR THERAPEUTICS AG",
     "symbol": "CRSP"
    },
    {
     "description": "CORPORATE RESTAURANT CONCEPT",
     "symbol": "CRSQ"
    },
    {
     "description": "CORSAIR GAMING INC",
     "symbol": "CRSR"
    },
    {
     "description": "CROSSROADS IMPACT CORP",
     "symbol": "CRSS"
    },
    {
     "description": "CREST RESOURCES INC\/CA",
     "symbol": "CRSTF"
    },
    {
     "description": "CORSA COAL CORP",
     "symbol": "CRSXF"
    },
    {
     "description": "CROSS TIMBERS ROYALTY TRUST",
     "symbol": "CRT"
    },
    {
     "description": "CREATD INC",
     "symbol": "CRTD"
    },
    {
     "description": "JERRICK MEDIA HOLDINGS -CW25",
     "symbol": "CRTDW"
    },
    {
     "description": "CORETEC GROUP INC\/THE",
     "symbol": "CRTG"
    },
    {
     "description": "CARSGEN THERAPEUTICS HOLDING",
     "symbol": "CRTHF"
    },
    {
     "description": "CARTIER IRON CORP",
     "symbol": "CRTIF"
    },
    {
     "description": "CARTEL BLUE INC",
     "symbol": "CRTL"
    },
    {
     "description": "CRITEO SA-SPON ADR",
     "symbol": "CRTO"
    },
    {
     "description": "CHR HANSEN HOLDING A\/S",
     "symbol": "CRTSF"
    },
    {
     "description": "CORTUS METALS INC",
     "symbol": "CRTTF"
    },
    {
     "description": "CORTEXYME INC",
     "symbol": "CRTX"
    },
    {
     "description": "CRUCIBLE ACQUISITION CORP-A",
     "symbol": "CRU"
    },
    {
     "description": "CRUCIBLE ACQUISITION CORP",
     "symbol": "CRU.U"
    },
    {
     "description": "CRUCIBLE ACQ CL A -CW25",
     "symbol": "CRU.WS"
    },
    {
     "description": "COLIBRI RESOURCES CORP",
     "symbol": "CRUCF"
    },
    {
     "description": "CIRRUS LOGIC INC",
     "symbol": "CRUS"
    },
    {
     "description": "DEFIANCE HOTEL, AIRLINE, CRU",
     "symbol": "CRUZ"
    },
    {
     "description": "CHILCO RIVER HOLDINGS INC",
     "symbol": "CRVH"
    },
    {
     "description": "CORVEL CORP",
     "symbol": "CRVL"
    },
    {
     "description": "CORVUS PHARMACEUTICALS INC",
     "symbol": "CRVS"
    },
    {
     "description": "CAREVIEW COMMUNICATIONS INC",
     "symbol": "CRVW"
    },
    {
     "description": "CANADIAN OIL RECOVERY & REME",
     "symbol": "CRVYF"
    },
    {
     "description": "CRANSWICK PLC-UNSP ADR",
     "symbol": "CRWCY"
    },
    {
     "description": "CROWDSTRIKE HOLDINGS INC - A",
     "symbol": "CRWD"
    },
    {
     "description": "CROWN EQUITY HOLDINGS INC",
     "symbol": "CRWE"
    },
    {
     "description": "CROWDGATHER INC",
     "symbol": "CRWG"
    },
    {
     "description": "CRANSWICK PLC",
     "symbol": "CRWKF"
    },
    {
     "description": "CHINA RAILWAY GROUP LTD-H",
     "symbol": "CRWOF"
    },
    {
     "description": "CRANEWARE PLC",
     "symbol": "CRWRF"
    },
    {
     "description": "CROWN CRAFTS INC",
     "symbol": "CRWS"
    },
    {
     "description": "CROW TECHNOLOGIES 1977 LTD",
     "symbol": "CRWTF"
    },
    {
     "description": "TAXUS CARDIUM PHARMACEUTICAL",
     "symbol": "CRXM"
    },
    {
     "description": "VERT INFRASTRUCTURE LTD",
     "symbol": "CRXPF"
    },
    {
     "description": "CLARUS THERAPEUTICS HOLDINGS",
     "symbol": "CRXT"
    },
    {
     "description": "CLARUS THERAPEUTICS -CW27",
     "symbol": "CRXTW"
    },
    {
     "description": "CRYPTOBLOX TECHNOLOGIES INC",
     "symbol": "CRYBF"
    },
    {
     "description": "CHINA RAILWAY SIGNAL-UNSPADR",
     "symbol": "CRYCY"
    },
    {
     "description": "CRYSTAL INTERNATIONAL GROUP",
     "symbol": "CRYIF"
    },
    {
     "description": "CRYOMASS TECHNOLOGIES INC",
     "symbol": "CRYM"
    },
    {
     "description": "AMERICAN CRYOSTEM CORP",
     "symbol": "CRYO"
    },
    {
     "description": "CHINA RAILWAY SIGNAL & COM-H",
     "symbol": "CRYYF"
    },
    {
     "description": "COMMERZBANK AG",
     "symbol": "CRZBF"
    },
    {
     "description": "COMMERZBANK AG-SPONS ADR",
     "symbol": "CRZBY"
    },
    {
     "description": "CORAZON CAPITAL V838 MONOC-A",
     "symbol": "CRZN"
    },
    {
     "description": "CORAZON MINING LTD",
     "symbol": "CRZNF"
    },
    {
     "description": "CORAZON CAPITAL V838 MONOCER",
     "symbol": "CRZNU"
    },
    {
     "description": "CORAZON CAPITAL V838 A -CW28",
     "symbol": "CRZNW"
    },
    {
     "description": "CRAZY WOMAN CREEK BANCORP",
     "symbol": "CRZY"
    },
    {
     "description": "CREDIT SUISSE GROUP-SPON ADR",
     "symbol": "CS"
    },
    {
     "description": "VICTORYSHARES US SMALL CAP V",
     "symbol": "CSA"
    },
    {
     "description": "COSAN SA -ADR",
     "symbol": "CSAN"
    },
    {
     "description": "CREDIT SAISON CO LTD",
     "symbol": "CSASF"
    },
    {
     "description": "CHINA SHESAYS MEDICAL COSMET",
     "symbol": "CSAY"
    },
    {
     "description": "VICTORYSHARES US SMALL CAP H",
     "symbol": "CSB"
    },
    {
     "description": "CSB BANCORP INC",
     "symbol": "CSBB"
    },
    {
     "description": "CONSOLIDATED BIOFUELS INC",
     "symbol": "CSBF"
    },
    {
     "description": "CARROLL SHELBY INTERNATIONAL",
     "symbol": "CSBI"
    },
    {
     "description": "CHAMPIONS ONCOLOGY INC",
     "symbol": "CSBR"
    },
    {
     "description": "KUROS BIOSCIENCES AG-REG",
     "symbol": "CSBTF"
    },
    {
     "description": "CAPSTONE COPPER CORP",
     "symbol": "CSCCF"
    },
    {
     "description": "CHINA RENAISSANCE HOLDINGS L",
     "symbol": "CSCHF"
    },
    {
     "description": "COSCO SHIPPING INTERNAT-ADR",
     "symbol": "CSCMY"
    },
    {
     "description": "CHINA SCE PROPERTY HOLDINGS",
     "symbol": "CSCNF"
    },
    {
     "description": "CISCO SYSTEMS INC",
     "symbol": "CSCO"
    },
    {
     "description": "CROWN SEAL PCL-NVDR",
     "symbol": "CSCPF"
    },
    {
     "description": "COLOR STAR TECHNOLOGY CO LTD",
     "symbol": "CSCW"
    },
    {
     "description": "INVESCO S&P SPIN-OFF ETF",
     "symbol": "CSD"
    },
    {
     "description": "COSCO SHIPPING ENERGY TRAN-H",
     "symbol": "CSDXF"
    },
    {
     "description": "VICTORYSHARES US DISCOVERY E",
     "symbol": "CSF"
    },
    {
     "description": "CASH STORE FINANCIAL\/THE",
     "symbol": "CSFSF"
    },
    {
     "description": "CHINA SUNTIEN GREEN ENERGY-H",
     "symbol": "CSGEF"
    },
    {
     "description": "CHINA SUN GROUP HIGH-TECH CO",
     "symbol": "CSGH"
    },
    {
     "description": "CREDIT SUISSE GROUP AG-REG",
     "symbol": "CSGKF"
    },
    {
     "description": "COSTAR GROUP INC",
     "symbol": "CSGP"
    },
    {
     "description": "COSTAIN GROUP PLC",
     "symbol": "CSGQF"
    },
    {
     "description": "CHINA SILVER GROUP LTD",
     "symbol": "CSGRF"
    },
    {
     "description": "CSG SYSTEMS INTL INC",
     "symbol": "CSGS"
    },
    {
     "description": "CONSOLIDATED SPORTS MEDIA",
     "symbol": "CSGU"
    },
    {
     "description": "COSMO ENERGY HOLD-UNSP ADR",
     "symbol": "CSGYY"
    },
    {
     "description": "EXOS ACTIVE SPAC ARBITRAGE E",
     "symbol": "CSH"
    },
    {
     "description": "CHINA ENTERPRISES LTD",
     "symbol": "CSHEF"
    },
    {
     "description": "CSSC HONG KONG SHIPPING CO L",
     "symbol": "CSHKF"
    },
    {
     "description": "CASHMERE VALLEY BANK",
     "symbol": "CSHX"
    },
    {
     "description": "CARDIOVASCULAR SYSTEMS INC",
     "symbol": "CSII"
    },
    {
     "description": "CASIO COMPUTER CO LTD",
     "symbol": "CSIOF"
    },
    {
     "description": "CASIO COMPUTER CO-UNSPON ADR",
     "symbol": "CSIOY"
    },
    {
     "description": "CANADIAN SOLAR INC",
     "symbol": "CSIQ"
    },
    {
     "description": "CHANGSHENG INTERNATIONAL GRO",
     "symbol": "CSJT"
    },
    {
     "description": "CHINA SKYRISE DIGITAL SERVIC",
     "symbol": "CSKD"
    },
    {
     "description": "CATSKILL HUDSON BANCORP INC",
     "symbol": "CSKL"
    },
    {
     "description": "ISHARES MSCI KOREA USD ACC",
     "symbol": "CSKRF"
    },
    {
     "description": "CARLISLE COS INC",
     "symbol": "CSL"
    },
    {
     "description": "CRITICAL SOLUTIONS INC",
     "symbol": "CSLI"
    },
    {
     "description": "CSL LTD-SPONSORED ADR",
     "symbol": "CSLLY"
    },
    {
     "description": "CONSILIUM ACQUISITION CORP I",
     "symbol": "CSLM"
    },
    {
     "description": "CONSILIUM ACQUISITION -RIGHT",
     "symbol": "CSLMR"
    },
    {
     "description": "CONSILIUM ACQUISITION CORP I",
     "symbol": "CSLMU"
    },
    {
     "description": "CONSILIUM ACQUISITION -27",
     "symbol": "CSLMW"
    },
    {
     "description": "PROSHARES LARGE CAP CORE PLU",
     "symbol": "CSM"
    },
    {
     "description": "IQ CHAIKIN SMALL CAP ETF",
     "symbol": "CSML"
    },
    {
     "description": "C'SMEN CO LTD",
     "symbol": "CSMOF"
    },
    {
     "description": "CLASSIC MINERALS LTD",
     "symbol": "CSMRF"
    },
    {
     "description": "COSMOSTEEL HOLDINGS LTD",
     "symbol": "CSMSF"
    },
    {
     "description": "COSMOS PHARMACEUTICAL CORP",
     "symbol": "CSMYF"
    },
    {
     "description": "CORBION NV",
     "symbol": "CSNVF"
    },
    {
     "description": "CORBION NV -UNSP ADR",
     "symbol": "CSNVY"
    },
    {
     "description": "CADUCEUS SOFTWARE SYSTEMS CO",
     "symbol": "CSOC"
    },
    {
     "description": "CLAS OHLSON AB-B SHS",
     "symbol": "CSOHF"
    },
    {
     "description": "CHINA SOLAR & CLEAN ENERGY S",
     "symbol": "CSOL"
    },
    {
     "description": "CSOP FTSE CHINA A50 ETF-HKD",
     "symbol": "CSOPF"
    },
    {
     "description": "CSPC PHARMACEUTICAL-UNSPOADR",
     "symbol": "CSPCY"
    },
    {
     "description": "CSTONE PHARMACEUTICALS",
     "symbol": "CSPHF"
    },
    {
     "description": "CSP INC",
     "symbol": "CSPI"
    },
    {
     "description": "COSCO SHIPPING PORTS LTD",
     "symbol": "CSPKF"
    },
    {
     "description": "COSCO PACIFIC LTD-UNSP ADR",
     "symbol": "CSPKY"
    },
    {
     "description": "COUNTRYSIDE PARTNERSHIPS PLC",
     "symbol": "CSPLF"
    },
    {
     "description": "CANADIAN SPIRIT RESOURCES",
     "symbol": "CSPUF"
    },
    {
     "description": "CALAMOS STRAT TOT RETURN FD",
     "symbol": "CSQ"
    },
    {
     "description": "CENTERSPACE",
     "symbol": "CSR"
    },
    {
     "description": "CENTERSPACE",
     "symbol": "CSR.PRC"
    },
    {
     "description": "CSR Acquisition Corp",
     "symbol": "CSRA.U"
    },
    {
     "description": "CA NORD DE FRANCE-CCI",
     "symbol": "CSRFF"
    },
    {
     "description": "CSR LTD",
     "symbol": "CSRLF"
    },
    {
     "description": "CANSTAR RESOURCES INC",
     "symbol": "CSRNF"
    },
    {
     "description": "CROSS RIVER VENTURES CORP",
     "symbol": "CSRVF"
    },
    {
     "description": "KAPE TECHNOLOGIES PLC",
     "symbol": "CSSDF"
    },
    {
     "description": "CHICKEN SOUP FOR THE SOUL EN",
     "symbol": "CSSE"
    },
    {
     "description": "CHICKEN SOUP FOR SOUL",
     "symbol": "CSSEN"
    },
    {
     "description": "CHICKEN SOUP FOR SOUL",
     "symbol": "CSSEP"
    },
    {
     "description": "COSTAS INC",
     "symbol": "CSSI"
    },
    {
     "description": "CIRCASSIA GROUP PLC",
     "symbol": "CSSPF"
    },
    {
     "description": "CASPIAN SERVICES INC",
     "symbol": "CSSV"
    },
    {
     "description": "CHINA SHUIFA SINGYES ENERGY",
     "symbol": "CSSXF"
    },
    {
     "description": "CONSTELLATION ACQUISITION-A",
     "symbol": "CSTA"
    },
    {
     "description": "CONSTELLATION ACQUISITION CO",
     "symbol": "CSTA.U"
    },
    {
     "description": "CONSTELLATION ACQ A -CW27",
     "symbol": "CSTA.WS"
    },
    {
     "description": "CAESARSTONE LTD",
     "symbol": "CSTE"
    },
    {
     "description": "COSTAR TECHNOLOGIES INC",
     "symbol": "CSTI"
    },
    {
     "description": "CRESTON RESOURCES LTD",
     "symbol": "CSTJ"
    },
    {
     "description": "CASTLE BIOSCIENCES INC",
     "symbol": "CSTL"
    },
    {
     "description": "CONSTELLIUM SE",
     "symbol": "CSTM"
    },
    {
     "description": "ISHARES CORE S&P 500",
     "symbol": "CSTNL"
    },
    {
     "description": "ARROW EXPLORATION CORP",
     "symbol": "CSTPF"
    },
    {
     "description": "CAPSTAR FINANCIAL HOLDINGS I",
     "symbol": "CSTR"
    },
    {
     "description": "CRYPTOSTAR CORP",
     "symbol": "CSTXF"
    },
    {
     "description": "CHINA SHENHUA-UNSPON ADR",
     "symbol": "CSUAY"
    },
    {
     "description": "CANNABIS SUISSE CORP",
     "symbol": "CSUI"
    },
    {
     "description": "CARRIAGE SERVICES INC",
     "symbol": "CSV"
    },
    {
     "description": "COMPUTER SERVICES INC",
     "symbol": "CSVI"
    },
    {
     "description": "CAPITAL SOUTHWEST CORP",
     "symbol": "CSWC"
    },
    {
     "description": "CSW INDUSTRIALS INC",
     "symbol": "CSWI"
    },
    {
     "description": "CHINA SHINEWAY PHARMACEUTICA",
     "symbol": "CSWYF"
    },
    {
     "description": "CHINA SHINEWAY PH-UNSPON ADR",
     "symbol": "CSWYY"
    },
    {
     "description": "CSX CORP",
     "symbol": "CSX"
    },
    {
     "description": "CARSALES.COM LTD-UNSP ADR",
     "symbol": "CSXXY"
    },
    {
     "description": "CSE GLOBAL LTD",
     "symbol": "CSYJF"
    },
    {
     "description": "CSE GLOBAL LTD-UNSPON ADR",
     "symbol": "CSYJY"
    },
    {
     "description": "CLEARSTORY SYSTEMS INC",
     "symbol": "CSYS"
    },
    {
     "description": "COMMUNICATION SYNERGY TECHNO",
     "symbol": "CSYT"
    },
    {
     "description": "CLEARSTAR INC",
     "symbol": "CSZZF"
    },
    {
     "description": "SIMPLIFY MANAGED FUTURES ST",
     "symbol": "CTA"
    },
    {
     "description": "EI DU PONT DE NEMOUR & C",
     "symbol": "CTA.PRA"
    },
    {
     "description": "EI DU PONT DE NEMOUR & C",
     "symbol": "CTA.PRB"
    },
    {
     "description": "CANNTAB THERAPEUTICS LTD",
     "symbol": "CTABF"
    },
    {
     "description": "CAPITA PLC",
     "symbol": "CTAGF"
    },
    {
     "description": "CAPITA PLC-UNSPON ADR",
     "symbol": "CTAGY"
    },
    {
     "description": "CP LOTUS CORP",
     "symbol": "CTAIF"
    },
    {
     "description": "CASTLE AM & CO",
     "symbol": "CTAM"
    },
    {
     "description": "CARNEY TECHNOLOGY ACQU- CL A",
     "symbol": "CTAQ"
    },
    {
     "description": "CARNEY TECHNOLOGY ACQUISITIO",
     "symbol": "CTAQU"
    },
    {
     "description": "CARNEY TECHNOLOGY ACQ -CW27",
     "symbol": "CTAQW"
    },
    {
     "description": "CENTAURUS ENERGY INC",
     "symbol": "CTARF"
    },
    {
     "description": "CINTAS CORP",
     "symbol": "CTAS"
    },
    {
     "description": "CHINA TIANRUI AUTOMOTIVE",
     "symbol": "CTAUF"
    },
    {
     "description": "CHINA STAR ENTERTAINMENT LTD",
     "symbol": "CTAZF"
    },
    {
     "description": "QWEST CORP",
     "symbol": "CTBB"
    },
    {
     "description": "COIL TUBING TECHNOLOGY INC",
     "symbol": "CTBG"
    },
    {
     "description": "COMMUNITY TRUST BANCORP INC",
     "symbol": "CTBI"
    },
    {
     "description": "CITY BANK LYNNWOOD WA",
     "symbol": "CTBK"
    },
    {
     "description": "CANTABIO PHARMACEUTICALS INC",
     "symbol": "CTBO"
    },
    {
     "description": "CITY CAPITAL CORPORATION",
     "symbol": "CTCC"
    },
    {
     "description": "C2C GOLD CORP",
     "symbol": "CTCGF"
    },
    {
     "description": "COATTEC INDUSTRIES INC",
     "symbol": "CTCK"
    },
    {
     "description": "QWEST CORP",
     "symbol": "CTDD"
    },
    {
     "description": "City Developments Ltd",
     "symbol": "CTDEF"
    },
    {
     "description": "CENTAURUS DIAMOND TECHNOLOGI",
     "symbol": "CTDT"
    },
    {
     "description": "GLOBAL X CLEANTECH ETF",
     "symbol": "CTEC"
    },
    {
     "description": "CYNERGISTEK INC\/DE",
     "symbol": "CTEK"
    },
    {
     "description": "PROSHARES S&P KENSHO CLEANTC",
     "symbol": "CTEX"
    },
    {
     "description": "COMPUTER TASK GROUP INC",
     "symbol": "CTG"
    },
    {
     "description": "CITRINE GLOBAL CORP",
     "symbol": "CTGL"
    },
    {
     "description": "CONTANGO ORE INC",
     "symbol": "CTGO"
    },
    {
     "description": "Connecticut Natural Gas Corporation",
     "symbol": "CTGSP"
    },
    {
     "description": "CATHAY CONSTRUCTON",
     "symbol": "CTHCF"
    },
    {
     "description": "CHARLES & COLVARD LTD",
     "symbol": "CTHR"
    },
    {
     "description": "CANCER TREATMENT HOLDINGS",
     "symbol": "CTHZ"
    },
    {
     "description": "YUNHONG CTI LTD",
     "symbol": "CTIB"
    },
    {
     "description": "CTI BIOPHARMA CORP",
     "symbol": "CTIC"
    },
    {
     "description": "CHINA TAIPING INS-UNSPON ADR",
     "symbol": "CTIHY"
    },
    {
     "description": "CTI LOGISTICS LTD",
     "symbol": "CTILF"
    },
    {
     "description": "P2 GOLD INC",
     "symbol": "CTIMF"
    },
    {
     "description": "CITIC RESOURCES HOLDINGS LTD",
     "symbol": "CTJHF"
    },
    {
     "description": "CITIC RESOURCES HOLDINGS-ADR",
     "symbol": "CTJHY"
    },
    {
     "description": "COOTEK CAYMAN INC-ADR",
     "symbol": "CTK"
    },
    {
     "description": "CYTEK BIOSCIENCES INC",
     "symbol": "CTKB"
    },
    {
     "description": "TIAN LUN GAS HOLDINGS LTD",
     "symbol": "CTLGF"
    },
    {
     "description": "CANTALOUPE INC",
     "symbol": "CTLP"
    },
    {
     "description": "Cantaloupe Inc",
     "symbol": "CTLPP"
    },
    {
     "description": "CATALENT INC",
     "symbol": "CTLT"
    },
    {
     "description": "CANTERRA MINERALS CORP",
     "symbol": "CTMCF"
    },
    {
     "description": "CORPORATE TRAVEL MANAGEMENT",
     "symbol": "CTMLF"
    },
    {
     "description": "CATENA MEDIA PLC-CW24",
     "symbol": "CTMWF"
    },
    {
     "description": "CYTOMX THERAPEUTICS INC",
     "symbol": "CTMX"
    },
    {
     "description": "CITRON INC",
     "symbol": "CTNI"
    },
    {
     "description": "CENTRAL NATURAL RESOURCES",
     "symbol": "CTNR"
    },
    {
     "description": "CORNERSTONE CAPITAL RESOURCE",
     "symbol": "CTNXF"
    },
    {
     "description": "CTO REALTY GROWTH INC",
     "symbol": "CTO"
    },
    {
     "description": "CTO REALTY GROWTH INC",
     "symbol": "CTO.PRA"
    },
    {
     "description": "CITIGOLD CORP LTD",
     "symbol": "CTOHF"
    },
    {
     "description": "SECOND STREET CAPITAL INC",
     "symbol": "CTON"
    },
    {
     "description": "CUSTOM TRUCK ONE SOURCE INC",
     "symbol": "CTOS"
    },
    {
     "description": "CUSTOM TRUCK ONE SOURCE-CW25",
     "symbol": "CTOS.WS"
    },
    {
     "description": "CHARTER HALL GROUP",
     "symbol": "CTOUF"
    },
    {
     "description": "CHINA TOWER CORP L- UNSP ADR",
     "symbol": "CTOWY"
    },
    {
     "description": "CITIC LTD",
     "symbol": "CTPCF"
    },
    {
     "description": "CITIC LTD - ADR",
     "symbol": "CTPCY"
    },
    {
     "description": "Central Maine Power Co",
     "symbol": "CTPPO"
    },
    {
     "description": "CTPARTNERS EXECUTIVE SEARCH",
     "symbol": "CTPR"
    },
    {
     "description": "CIA DE TRANSMISSAO DE EN-ADR",
     "symbol": "CTPTY"
    },
    {
     "description": "CTP NV",
     "symbol": "CTPVF"
    },
    {
     "description": "CIA DE TRANSMISSAO DE EN-ADR",
     "symbol": "CTPZY"
    },
    {
     "description": "CLEARBRIDGE MLP & MIDSTREAM",
     "symbol": "CTR"
    },
    {
     "description": "COTERRA ENERGY INC",
     "symbol": "CTRA"
    },
    {
     "description": "CARETRUST REIT INC",
     "symbol": "CTRE"
    },
    {
     "description": "COUNTRY GARDEN SERVICES HOLD",
     "symbol": "CTRGF"
    },
    {
     "description": "CASTOR MARITIME INC",
     "symbol": "CTRM"
    },
    {
     "description": "CITI TRENDS INC",
     "symbol": "CTRN"
    },
    {
     "description": "CHAR TECHNOLOGIES LTD",
     "symbol": "CTRNF"
    },
    {
     "description": "CT REAL ESTATE INVESTMENT TR",
     "symbol": "CTRRF"
    },
    {
     "description": "ARK TRANSPARENCY ETF",
     "symbol": "CTRU"
    },
    {
     "description": "Hepion Pharmaceuticals Inc",
     "symbol": "CTRVP"
    },
    {
     "description": "HEPION PHARMACEUTICALS-CW23",
     "symbol": "CTRVW"
    },
    {
     "description": "COUNTRY GARDEN HOLDINGS CO",
     "symbol": "CTRYF"
    },
    {
     "description": "COUNTRY GARDEN HOLD-UNSP ADR",
     "symbol": "CTRYY"
    },
    {
     "description": "CTS CORP",
     "symbol": "CTS"
    },
    {
     "description": "CONVERGE TECHNOLOGY SOLUTION",
     "symbol": "CTSDF"
    },
    {
     "description": "COGNIZANT TECH SOLUTIONS-A",
     "symbol": "CTSH"
    },
    {
     "description": "CYTOSORBENTS CORP",
     "symbol": "CTSO"
    },
    {
     "description": "CATCHMARK TIMBER TRUST INC-A",
     "symbol": "CTT"
    },
    {
     "description": "CONTINENTAL AG",
     "symbol": "CTTAF"
    },
    {
     "description": "CONTINENTAL AG-SPONS ADR",
     "symbol": "CTTAY"
    },
    {
     "description": "CALMARE THERAPEUTICS INC",
     "symbol": "CTTC"
    },
    {
     "description": "CTT PHARMACEUTICAL HOLDINGS",
     "symbol": "CTTH"
    },
    {
     "description": "CETTIRE LTD",
     "symbol": "CTTLF"
    },
    {
     "description": "CATENA MEDIA PLC",
     "symbol": "CTTMF"
    },
    {
     "description": "CTT-CORREIOS DE PORTUGAL",
     "symbol": "CTTOF"
    },
    {
     "description": "CTT-CORREIOS DE PORTUGAL-ADR",
     "symbol": "CTTPY"
    },
    {
     "description": "COSTA GROUP HOLDINGS LTD",
     "symbol": "CTTQF"
    },
    {
     "description": "CENTREX LTD",
     "symbol": "CTTTF"
    },
    {
     "description": "CENTAURUS METALS LTD",
     "symbol": "CTTZF"
    },
    {
     "description": "CLEAN SEAS SEAFOOD LTD",
     "symbol": "CTUNF"
    },
    {
     "description": "CENTURY NEXT FINANCIAL CORP",
     "symbol": "CTUY"
    },
    {
     "description": "INNOVID CORP",
     "symbol": "CTV"
    },
    {
     "description": "ION ACQ CL A -CW27",
     "symbol": "CTV.WS"
    },
    {
     "description": "CORTEVA INC",
     "symbol": "CTVA"
    },
    {
     "description": "CERTIVE SOLUTIONS INC",
     "symbol": "CTVEF"
    },
    {
     "description": "CHINA TRAVEL INTL INV HK",
     "symbol": "CTVIF"
    },
    {
     "description": "COTTONWOOD MULTIFAMILY OPPOR",
     "symbol": "CTWD"
    },
    {
     "description": "AMPOL LTD",
     "symbol": "CTXAF"
    },
    {
     "description": "AMPOL LTD-UNSPONSORED ADR",
     "symbol": "CTXAY"
    },
    {
     "description": "CANTEX MINE DEVELOPMENT CORP",
     "symbol": "CTXDF"
    },
    {
     "description": "CITIUS PHARMACEUTICALS INC",
     "symbol": "CTXR"
    },
    {
     "description": "CITIUS PHARMACEUTIC INC-CW22",
     "symbol": "CTXRW"
    },
    {
     "description": "CITRIX SYSTEMS INC",
     "symbol": "CTXS"
    },
    {
     "description": "CTX VIRTUAL TECHNOLOGIES INC",
     "symbol": "CTXV"
    },
    {
     "description": "CEMATRIX CORP",
     "symbol": "CTXXF"
    },
    {
     "description": "CITY LODGE HOTELS LTD",
     "symbol": "CTYLF"
    },
    {
     "description": "COMMUNITY BANKERS CP\/MARION",
     "symbol": "CTYP"
    },
    {
     "description": "CHINA SHENHUA ENERGY CO-H",
     "symbol": "CUAEF"
    },
    {
     "description": "C3 METALS CORP",
     "symbol": "CUAUF"
    },
    {
     "description": "HERZFELD CARIBBEAN BASIN",
     "symbol": "CUBA"
    },
    {
     "description": "CUSTOMERS BANCORP INC",
     "symbol": "CUBB"
    },
    {
     "description": "CUBESMART",
     "symbol": "CUBE"
    },
    {
     "description": "CUSTOMERS BANCORP INC",
     "symbol": "CUBI"
    },
    {
     "description": "CUSTOMERS BANCORP INC",
     "symbol": "CUBI.PRE"
    },
    {
     "description": "CUSTOMERS BANCORP INC",
     "symbol": "CUBI.PRF"
    },
    {
     "description": "ASIAN GROWTH CUBS ETF",
     "symbol": "CUBS"
    },
    {
     "description": "CURATIVE BIOTECHNOLOGY INC",
     "symbol": "CUBT"
    },
    {
     "description": "CUBA BEVERAGE CO",
     "symbol": "CUBV"
    },
    {
     "description": "CUBICFARM SYSTEMS CORP",
     "symbol": "CUBXF"
    },
    {
     "description": "CHINA COMMUNICATIONS SERVI-H",
     "symbol": "CUCSF"
    },
    {
     "description": "CHINA COMMUNIC-UNSPON ADR",
     "symbol": "CUCSY"
    },
    {
     "description": "CUE BIOPHARMA INC",
     "symbol": "CUE"
    },
    {
     "description": "CUENTAS INC",
     "symbol": "CUEN"
    },
    {
     "description": "CUENTAS INC -CW27",
     "symbol": "CUENW"
    },
    {
     "description": "CRUNCHFISH AB",
     "symbol": "CUFHF"
    },
    {
     "description": "CHINA ORIENTAL GROUP CO LTD",
     "symbol": "CUGCF"
    },
    {
     "description": "CHINA ORIENTAL-UNSPON ADR",
     "symbol": "CUGCY"
    },
    {
     "description": "CHINA UNITED INSURANCE SERVI",
     "symbol": "CUII"
    },
    {
     "description": "CU IN",
     "symbol": "CUIPF"
    },
    {
     "description": "CURRIE ROSE RESOURCES",
     "symbol": "CUIRF"
    },
    {
     "description": "CARNIVAL PLC-ADR",
     "symbol": "CUK"
    },
    {
     "description": "CARNIVAL PLC",
     "symbol": "CUKPF"
    },
    {
     "description": "CULLMAN BANCORP INC\/MD",
     "symbol": "CULL"
    },
    {
     "description": "CULP INC",
     "symbol": "CULP"
    },
    {
     "description": "CULT FOOD SCIENCE CORP",
     "symbol": "CULTF"
    },
    {
     "description": "CARIBBEAN UTILITIES CO LTD-A",
     "symbol": "CUPUF"
    },
    {
     "description": "DRX DLY HEALTHCARE BULL 3X",
     "symbol": "CURE"
    },
    {
     "description": "CURVES HOLDINGS CO LTD",
     "symbol": "CURHF"
    },
    {
     "description": "CURIOSITYSTREAM INC",
     "symbol": "CURI"
    },
    {
     "description": "SOFTWARE ACQUISITION G -CW25",
     "symbol": "CURIW"
    },
    {
     "description": "CURALEAF HOLDINGS INC",
     "symbol": "CURLF"
    },
    {
     "description": "CURRENCY EXCHANGE INTERNATIO",
     "symbol": "CURN"
    },
    {
     "description": "CURO GROUP HOLDINGS CORP",
     "symbol": "CURO"
    },
    {
     "description": "CURE PHARMACEUTICAL HOLDING",
     "symbol": "CURR"
    },
    {
     "description": "CONSOLIDATED URANIUM INC",
     "symbol": "CURUF"
    },
    {
     "description": "TORRID HOLDINGS INC",
     "symbol": "CURV"
    },
    {
     "description": "CURRYS PLC - UNSP ADR",
     "symbol": "CURYY"
    },
    {
     "description": "CURZIO RESEARCH INC",
     "symbol": "CURZ"
    },
    {
     "description": "CUISINE SOLUTIONS INC",
     "symbol": "CUSI"
    },
    {
     "description": "COUNTRYSIDE PART PLC-UNS ADR",
     "symbol": "CUSPY"
    },
    {
     "description": "INVESCO MSCI GLOBAL TIMBER E",
     "symbol": "CUT"
    },
    {
     "description": "Canadian Utilities Ltd",
     "symbol": "CUTLF"
    },
    {
     "description": "CUTERA INC",
     "symbol": "CUTR"
    },
    {
     "description": "C UYEMURA & CO LTD",
     "symbol": "CUYRF"
    },
    {
     "description": "COLRUYT SA",
     "symbol": "CUYTF"
    },
    {
     "description": "COLRUYT SA-UNSPONSORED ADR",
     "symbol": "CUYTY"
    },
    {
     "description": "COUSINS PROPERTIES INC",
     "symbol": "CUZ"
    },
    {
     "description": "CUREVAC NV",
     "symbol": "CVAC"
    },
    {
     "description": "COVALON TECHNOLOGIES LTD",
     "symbol": "CVALF"
    },
    {
     "description": "CULTIVAR ETF",
     "symbol": "CVAR"
    },
    {
     "description": "CREATIVE VISTAS INC",
     "symbol": "CVAS"
    },
    {
     "description": "CAVITATION TECHNOLOGIES INC",
     "symbol": "CVAT"
    },
    {
     "description": "CVB FINANCIAL CORP",
     "symbol": "CVBF"
    },
    {
     "description": "CAVCO INDUSTRIES INC",
     "symbol": "CVCO"
    },
    {
     "description": "CENTRAL VALLEY COMM BANCORP",
     "symbol": "CVCY"
    },
    {
     "description": "CENOVUS ENERGY INC",
     "symbol": "CVE"
    },
    {
     "description": "CENOVUS ENERGY INC -CW26",
     "symbol": "CVE.WS"
    },
    {
     "description": "CIVEO CORP",
     "symbol": "CVEO"
    },
    {
     "description": "COVETRUS INC",
     "symbol": "CVET"
    },
    {
     "description": "COMMERCIAL VEHICLE GROUP INC",
     "symbol": "CVGI"
    },
    {
     "description": "CITY VIEW GREEN HOLDINGS INC",
     "symbol": "CVGRF"
    },
    {
     "description": "CALAVO GROWERS INC",
     "symbol": "CVGW"
    },
    {
     "description": "VENTURA CANNABIS & WELLNESS",
     "symbol": "CVHIF"
    },
    {
     "description": "CV HOLDINGS INC",
     "symbol": "CVHL"
    },
    {
     "description": "CABLEVISION HOLDING-SPON GDR",
     "symbol": "CVHSY"
    },
    {
     "description": "CVR ENERGY INC",
     "symbol": "CVI"
    },
    {
     "description": "CHURCHILL CAPITAL CORP VII-A",
     "symbol": "CVII"
    },
    {
     "description": "CHURCHILL CAPITAL CORP VII",
     "symbol": "CVII.U"
    },
    {
     "description": "CHURCHILL CAPITAL VII -CW28",
     "symbol": "CVII.WS"
    },
    {
     "description": "CIVMEC LTD",
     "symbol": "CVLFF"
    },
    {
     "description": "COVENANT LOGISTICS GROUP INC",
     "symbol": "CVLG"
    },
    {
     "description": "CELLAVISION AB-UNSP ADR",
     "symbol": "CVLLY"
    },
    {
     "description": "COMMVAULT SYSTEMS INC",
     "symbol": "CVLT"
    },
    {
     "description": "CODORUS VALLEY BANCORP INC",
     "symbol": "CVLY"
    },
    {
     "description": "CEL-SCI CORP",
     "symbol": "CVM"
    },
    {
     "description": "CARTER VALIDUS MISSION-CLS A",
     "symbol": "CVMCA"
    },
    {
     "description": "CARVANA CO",
     "symbol": "CVNA"
    },
    {
     "description": "COMVITA LTD",
     "symbol": "CVNZF"
    },
    {
     "description": "CARNARVON ENERGY LTD",
     "symbol": "CVONF"
    },
    {
     "description": "CP ALL PCL-FOREIGN",
     "symbol": "CVPBF"
    },
    {
     "description": "CP ALL PCL-NVDR",
     "symbol": "CVPUF"
    },
    {
     "description": "CHICAGO RIVET & MACHINE CO",
     "symbol": "CVR"
    },
    {
     "description": "CVRX INC",
     "symbol": "CVRX"
    },
    {
     "description": "CVS HEALTH CORP",
     "symbol": "CVS"
    },
    {
     "description": "CARDIOVASCULAR SCIENCES INC",
     "symbol": "CVSC"
    },
    {
     "description": "CVS GROUP PLC",
     "symbol": "CVSGF"
    },
    {
     "description": "CV SCIENCES INC",
     "symbol": "CVSI"
    },
    {
     "description": "COVISTA COMMUNICATIONS",
     "symbol": "CVST"
    },
    {
     "description": "CONVERGENCE SYSTEMS INC-CL A",
     "symbol": "CVSY"
    },
    {
     "description": "CVENT HOLDING CORP",
     "symbol": "CVT"
    },
    {
     "description": "CLAIRVEST GROUP INC",
     "symbol": "CVTGF"
    },
    {
     "description": "CIVITANAVI SYSTEMS SPA",
     "symbol": "CVTNF"
    },
    {
     "description": "CHINA VTV LTD",
     "symbol": "CVTV"
    },
    {
     "description": "CPI AEROSTRUCTURES INC",
     "symbol": "CVU"
    },
    {
     "description": "CLEARVUE TECHNOLOGIES LTD",
     "symbol": "CVUEF"
    },
    {
     "description": "CVD EQUIPMENT CORP",
     "symbol": "CVV"
    },
    {
     "description": "SOCIEDAD COMERCIAL DEL PLATA",
     "symbol": "CVVIF"
    },
    {
     "description": "VERTICAL EXPLORATION INC",
     "symbol": "CVVRF"
    },
    {
     "description": "COVESTRO AG",
     "symbol": "CVVTF"
    },
    {
     "description": "CANALASKA URANIUM LTD",
     "symbol": "CVVUF"
    },
    {
     "description": "CLEARVIEW WEALTH LTD",
     "symbol": "CVWLF"
    },
    {
     "description": "CHEVRON CORP",
     "symbol": "CVX"
    },
    {
     "description": "INVESCO ZACKS MULTI-ASSET IN",
     "symbol": "CVY"
    },
    {
     "description": "CURTISS-WRIGHT CORP",
     "symbol": "CW"
    },
    {
     "description": "CHINA WATER AFFAIRS GROUP",
     "symbol": "CWAFF"
    },
    {
     "description": "CLEARWATER ANALYTICS HDS-A",
     "symbol": "CWAN"
    },
    {
     "description": "SPDR BLOOMBERG CONVERTIBLE S",
     "symbol": "CWB"
    },
    {
     "description": "COMMUNITY WEST BANCSHARES",
     "symbol": "CWBC"
    },
    {
     "description": "CHARLOTTES WEB HOLDINGS INC",
     "symbol": "CWBHF"
    },
    {
     "description": "CW BANCORP",
     "symbol": "CWBK"
    },
    {
     "description": "COHBAR INC",
     "symbol": "CWBR"
    },
    {
     "description": "CONSOLIDATED WATER CO-ORD SH",
     "symbol": "CWCO"
    },
    {
     "description": "DRX DLY CHINA INT BULL 2X",
     "symbol": "CWEB"
    },
    {
     "description": "CREW ENERGY INC",
     "symbol": "CWEGF"
    },
    {
     "description": "CLEARWAY ENERGY INC-C",
     "symbol": "CWEN"
    },
    {
     "description": "CLEARWAY ENERGY INC-A",
     "symbol": "CWEN.A"
    },
    {
     "description": "Canadian Western Bank",
     "symbol": "CWESF"
    },
    {
     "description": "CRIMSON WINE GROUP LTD",
     "symbol": "CWGL"
    },
    {
     "description": "Cowen Group Inc",
     "symbol": "CWGRP"
    },
    {
     "description": "CARNEGIE CLEAN ENERGY LTD",
     "symbol": "CWGYF"
    },
    {
     "description": "CAMPING WORLD HOLDINGS INC-A",
     "symbol": "CWH"
    },
    {
     "description": "SPDR MSCI ACWI EX-US",
     "symbol": "CWI"
    },
    {
     "description": "COUNTRY-WIDE INSURANCE CO",
     "symbol": "CWID"
    },
    {
     "description": "CENTRAL WIRELESS INC",
     "symbol": "CWIR"
    },
    {
     "description": "CUSHMAN & WAKEFIELD PLC",
     "symbol": "CWK"
    },
    {
     "description": "CROWN RESORTS LTD",
     "symbol": "CWLDF"
    },
    {
     "description": "CROWN RESORTS LTD-UNSP ADR",
     "symbol": "CWLDY"
    },
    {
     "description": "CALDWELL PARTNERS INTL",
     "symbol": "CWLPF"
    },
    {
     "description": "CONSOLIDATED WOODJAM COPPER",
     "symbol": "CWMCF"
    },
    {
     "description": "CHINESEWORLDNET.COM INC",
     "symbol": "CWNOF"
    },
    {
     "description": "CW PETROLEUM CORP",
     "symbol": "CWPE"
    },
    {
     "description": "CONWEST PARTNERSHIP LP-UNITS",
     "symbol": "CWPS"
    },
    {
     "description": "CONCORD NEW ENERGY GROUP LTD",
     "symbol": "CWPWF"
    },
    {
     "description": "CASTELLUM AB",
     "symbol": "CWQXF"
    },
    {
     "description": "CASTELLUM AB-UNSPON ADR",
     "symbol": "CWQXY"
    },
    {
     "description": "CURRENCYWORKS INC",
     "symbol": "CWRK"
    },
    {
     "description": "COTTON & WESTERN MINING INC",
     "symbol": "CWRN"
    },
    {
     "description": "ADVISORSHARES EQUITY FOCUSED",
     "symbol": "CWS"
    },
    {
     "description": "CIELO WASTE SOLUTIONS CORP",
     "symbol": "CWSFF"
    },
    {
     "description": "CHARTWELL RETIREMENT RESIDEN",
     "symbol": "CWSRF"
    },
    {
     "description": "CASELLA WASTE SYSTEMS INC-A",
     "symbol": "CWST"
    },
    {
     "description": "CALIFORNIA WATER SERVICE GRP",
     "symbol": "CWT"
    },
    {
     "description": "CLEARWAVE TELECOMMUNICATIONS",
     "symbol": "CWTC"
    },
    {
     "description": "CROWN POINT ENERGY INC",
     "symbol": "CWVLF"
    },
    {
     "description": "LITHOQUEST RESOURCES INC",
     "symbol": "CWVWF"
    },
    {
     "description": "PLANT-BASED INVESTMENT CORP",
     "symbol": "CWWBF"
    },
    {
     "description": "CHAOWEI POWER HOLDINGS LTD",
     "symbol": "CWWGF"
    },
    {
     "description": "DOMAN BUILDING MATERIALS GRO",
     "symbol": "CWXZF"
    },
    {
     "description": "SMARTCENTRES REAL ESTATE INV",
     "symbol": "CWYUF"
    },
    {
     "description": "CEMEX SAB-SPONS ADR PART CER",
     "symbol": "CX"
    },
    {
     "description": "C5 ACQUISITION CORP-A",
     "symbol": "CXAC"
    },
    {
     "description": "C5 ACQUISITION CORP",
     "symbol": "CXAC.U"
    },
    {
     "description": "C5 ACQUISITION CORP-A -28",
     "symbol": "CXAC.WS"
    },
    {
     "description": "CALIBRE MINING CORP",
     "symbol": "CXBMF"
    },
    {
     "description": "CORIX BIOSCIENCE INC",
     "symbol": "CXBS"
    },
    {
     "description": "BITCOIN TRACKER ONE - SEK",
     "symbol": "CXBTF"
    },
    {
     "description": "CARDXX INC",
     "symbol": "CXCQ"
    },
    {
     "description": "CHINA XD PLASTICS CO LTD",
     "symbol": "CXDC"
    },
    {
     "description": "CREXENDO INC",
     "symbol": "CXDO"
    },
    {
     "description": "MFS HIGH INCOME MUNICIPAL TR",
     "symbol": "CXE"
    },
    {
     "description": "COMPUTER & TECHNOLOGIES HLDG",
     "symbol": "CXGEF"
    },
    {
     "description": "MFS INVESTMENT GRADE MUNICIP",
     "symbol": "CXH"
    },
    {
     "description": "COMMODORE APPLIED TECH",
     "symbol": "CXIA"
    },
    {
     "description": "CX NETWORK GROUP INC",
     "symbol": "CXKJ"
    },
    {
     "description": "SPRINKLR INC-A",
     "symbol": "CXM"
    },
    {
     "description": "CEMEX SAB-CPO",
     "symbol": "CXMSF"
    },
    {
     "description": "CORE LITHIUM LTD",
     "symbol": "CXOXF"
    },
    {
     "description": "WISDOMTREE CHINA EX-ST OW",
     "symbol": "CXSE"
    },
    {
     "description": "CELEXUS INC",
     "symbol": "CXUS"
    },
    {
     "description": "CORECIVIC INC",
     "symbol": "CXW"
    },
    {
     "description": "C21 INVESTMENTS INC",
     "symbol": "CXXIF"
    },
    {
     "description": "SIMPLIFY TAIL RISK STRATEGY",
     "symbol": "CYA"
    },
    {
     "description": "CELYAD ONCOLOGY-SPON ADR",
     "symbol": "CYAD"
    },
    {
     "description": "CYBERAGENT INC",
     "symbol": "CYAGF"
    },
    {
     "description": "CYANOTECH CORP",
     "symbol": "CYAN"
    },
    {
     "description": "CYBER APPS WORLD INC",
     "symbol": "CYAP"
    },
    {
     "description": "WISDOMTREE CHINESE YUAN STRA",
     "symbol": "CYB"
    },
    {
     "description": "CANYON BANCORP",
     "symbol": "CYBA"
    },
    {
     "description": "VIRGIN MONEY UK PLC - CDI",
     "symbol": "CYBBF"
    },
    {
     "description": "CYBER DIGITAL INC",
     "symbol": "CYBD"
    },
    {
     "description": "CYBEROPTICS CORP",
     "symbol": "CYBE"
    },
    {
     "description": "CYBERFORT SOFTWARE INC",
     "symbol": "CYBF"
    },
    {
     "description": "CYBERLUX CORP",
     "symbol": "CYBL"
    },
    {
     "description": "CYBIN INC",
     "symbol": "CYBN"
    },
    {
     "description": "CYBER SECURITY 1 AB-SPON ADR",
     "symbol": "CYBNY"
    },
    {
     "description": "CYBERDYNE INC",
     "symbol": "CYBQF"
    },
    {
     "description": "CYBERDYNE INC - SPON ADR",
     "symbol": "CYBQY"
    },
    {
     "description": "CYBERARK SOFTWARE LTD\/ISRAEL",
     "symbol": "CYBR"
    },
    {
     "description": "CYTTA CORP",
     "symbol": "CYCA"
    },
    {
     "description": "CYCLACEL PHARMACEUTICALS INC",
     "symbol": "CYCC"
    },
    {
     "description": "CYCLACEL PHARMACEUTICALS",
     "symbol": "CYCCP"
    },
    {
     "description": "CYCLOPHARM LTD",
     "symbol": "CYCMF"
    },
    {
     "description": "CYCLERION THERAPEUTICS INC",
     "symbol": "CYCN"
    },
    {
     "description": "CHINA YUCHAI INTL LTD",
     "symbol": "CYD"
    },
    {
     "description": "CHIYODA INTEGRE CO LTD",
     "symbol": "CYDGF"
    },
    {
     "description": "CYPRESS DEVELOPMENT CORP",
     "symbol": "CYDVF"
    },
    {
     "description": "CYDUCT DIAGNOSTICS INC",
     "symbol": "CYDX"
    },
    {
     "description": "CYTODYN INC",
     "symbol": "CYDY"
    },
    {
     "description": "CENTURY FINANCIAL CORP",
     "symbol": "CYFL"
    },
    {
     "description": "CYPHERPUNK HOLDINGS INC",
     "symbol": "CYFRF"
    },
    {
     "description": "CYFROWY POLSAT SA",
     "symbol": "CYFWF"
    },
    {
     "description": "CYFROWY POLSAT SA-UNSP ADR",
     "symbol": "CYFWY"
    },
    {
     "description": "CYBERAGENT INC-UNSPON ADR",
     "symbol": "CYGIY"
    },
    {
     "description": "CYGNUS E-TRANSACTION GROUP I",
     "symbol": "CYGT"
    },
    {
     "description": "COMMUNITY HEALTH SYSTEMS INC",
     "symbol": "CYH"
    },
    {
     "description": "CYIOS CORP",
     "symbol": "CYIO"
    },
    {
     "description": "CARGOTEC OYJ-B SHARE",
     "symbol": "CYJBF"
    },
    {
     "description": "CARGOTEC CORP-UNSPON ADR",
     "symbol": "CYJBY"
    },
    {
     "description": "COUNTY LINE ENERGY CORP",
     "symbol": "CYLC"
    },
    {
     "description": "CITY OF LONDON INVESTMENT TR",
     "symbol": "CYLTF"
    },
    {
     "description": "CEYLON GRAPHITE CORP",
     "symbol": "CYLYF"
    },
    {
     "description": "CYMBRIA CORP-A",
     "symbol": "CYMBF"
    },
    {
     "description": "CYMAT TECHNOLOGIES LTD",
     "symbol": "CYMHF"
    },
    {
     "description": "CYNGN INC",
     "symbol": "CYN"
    },
    {
     "description": "CYNK TECHNOLOGY CORP",
     "symbol": "CYNK"
    },
    {
     "description": "CYGNUS OIL AND GAS CORP",
     "symbol": "CYNS"
    },
    {
     "description": "GOLD STATE RESOURCES INC",
     "symbol": "CYNXF"
    },
    {
     "description": "CENTURY PETROLEUM CORP",
     "symbol": "CYPE"
    },
    {
     "description": "CYBER OPERATIONS INC",
     "symbol": "CYPJ"
    },
    {
     "description": "CYPRIUM METALS LTD",
     "symbol": "CYPMF"
    },
    {
     "description": "CYCLOPSS CORPORATION",
     "symbol": "CYPS"
    },
    {
     "description": "EQ INC",
     "symbol": "CYPXF"
    },
    {
     "description": "CYRELA BRAZIL REALTY-SPO ADR",
     "symbol": "CYRBY"
    },
    {
     "description": "CYBERECORD INC",
     "symbol": "CYRD"
    },
    {
     "description": "CYREN LTD",
     "symbol": "CYRN"
    },
    {
     "description": "CYBRA CORP",
     "symbol": "CYRP"
    },
    {
     "description": "CANARY RESOURCES INC",
     "symbol": "CYRR"
    },
    {
     "description": "CHEYENNE RESOURCES CORP",
     "symbol": "CYRS"
    },
    {
     "description": "CANYON RESOURCES LTD",
     "symbol": "CYRWF"
    },
    {
     "description": "CRYOPORT INC",
     "symbol": "CYRX"
    },
    {
     "description": "COMMUNITY BANCORP OF SANTA",
     "symbol": "CYSM"
    },
    {
     "description": "C-COM SATELLITE SYSTEMS INC",
     "symbol": "CYSNF"
    },
    {
     "description": "ISHARES S&P\/TSX CANADIAN PRE",
     "symbol": "CYSXF"
    },
    {
     "description": "CYTEIR THERAPEUTICS INC",
     "symbol": "CYT"
    },
    {
     "description": "CYCLO THERAPEUTICS INC",
     "symbol": "CYTH"
    },
    {
     "description": "CYCLO THERAPEUTICS -CW25",
     "symbol": "CYTHW"
    },
    {
     "description": "CYTOKINETICS INC",
     "symbol": "CYTK"
    },
    {
     "description": "ALTAMIRA THERAPEUTICS LTD",
     "symbol": "CYTO"
    },
    {
     "description": "CYTRX CORP",
     "symbol": "CYTR"
    },
    {
     "description": "CHINA YURUN FOOD GROUP LTD",
     "symbol": "CYUFF"
    },
    {
     "description": "CHINA HUIYUAN JUICE GROUP",
     "symbol": "CYUNF"
    },
    {
     "description": "BC MOLY LTD",
     "symbol": "CYUXF"
    },
    {
     "description": "CRYSTAL VALLEY FINANCIAL CP",
     "symbol": "CYVF"
    },
    {
     "description": "CYXTERA TECHNOLOGIES INC",
     "symbol": "CYXT"
    },
    {
     "description": "CHINA YONGDA AUTOMOBILES SER",
     "symbol": "CYYHF"
    },
    {
     "description": "CYNATA THERAPEUTICS LTD",
     "symbol": "CYYNF"
    },
    {
     "description": "CYBERZONE INC",
     "symbol": "CYZN"
    },
    {
     "description": "INVESCO ZACKS MID-CAP ETF",
     "symbol": "CZA"
    },
    {
     "description": "CHINA ZHENGTONG AUTO SERVICE",
     "symbol": "CZASF"
    },
    {
     "description": "CEZ AS",
     "symbol": "CZAVF"
    },
    {
     "description": "CITIZENS BANCORP\/ORE",
     "symbol": "CZBC"
    },
    {
     "description": "CITIZENS BANCSHARES CORP",
     "symbol": "CZBS"
    },
    {
     "description": "CITIZENS BANCORP OF VIRGINIA",
     "symbol": "CZBT"
    },
    {
     "description": "CITIZENS FINANCIAL SERVICES",
     "symbol": "CZFS"
    },
    {
     "description": "COLT CZ GROUP SE",
     "symbol": "CZGZF"
    },
    {
     "description": "CARL ZEISS MEDITEC AG - BR",
     "symbol": "CZMWF"
    },
    {
     "description": "CARL ZEISS MEDIT-UNSPON ADR",
     "symbol": "CZMWY"
    },
    {
     "description": "CITIZENS BANCORP\/CA",
     "symbol": "CZNB"
    },
    {
     "description": "CITIZENS & NORTHERN CORP",
     "symbol": "CZNC"
    },
    {
     "description": "CRUZANI INC",
     "symbol": "CZNI"
    },
    {
     "description": "CITIZENS NATIONAL CORP-KY",
     "symbol": "CZNL"
    },
    {
     "description": "CAZOO GROUP LTD",
     "symbol": "CZOO"
    },
    {
     "description": "CAZOO GROUP LTD-CW26",
     "symbol": "CZOO.WS"
    },
    {
     "description": "CAESARS ENTERTAINMENT INC",
     "symbol": "CZR"
    },
    {
     "description": "CITIZENS COMMUNITY BANCORP I",
     "symbol": "CZWI"
    },
    {
     "description": "CAZALY RESOURCES LTD",
     "symbol": "CZYRF"
    },
    {
     "description": "DOMINION ENERGY INC",
     "symbol": "D"
    },
    {
     "description": "DAC TECH GROUP INTL INC",
     "symbol": "DAAT"
    },
    {
     "description": "DANAOS CORP",
     "symbol": "DAC"
    },
    {
     "description": "DAICEL CORP",
     "symbol": "DACHF"
    },
    {
     "description": "OSAKA SODA CO LTD",
     "symbol": "DACLF"
    },
    {
     "description": "DADA NEXUS LTD-ADR",
     "symbol": "DADA"
    },
    {
     "description": "DATADOT TECHNOLOGY LTD",
     "symbol": "DADTF"
    },
    {
     "description": "DL CO LTD - PREF",
     "symbol": "DAEIF"
    },
    {
     "description": "DU-ART FILM LABS INC",
     "symbol": "DAFL"
    },
    {
     "description": "DAIWA OFFICE INVESTMENT CORP",
     "symbol": "DAFVF"
    },
    {
     "description": "DB AGRICULTURE DOUBLE LONG",
     "symbol": "DAGXF"
    },
    {
     "description": "DAMSTRA HOLDINGS LTD",
     "symbol": "DAHLF"
    },
    {
     "description": "DAH SING FINANCIAL HOLDINGS",
     "symbol": "DAHSF"
    },
    {
     "description": "DAIKEN CORP",
     "symbol": "DAICF"
    },
    {
     "description": "I-PEX INC",
     "symbol": "DAIKF"
    },
    {
     "description": "DATA I\/O CORP",
     "symbol": "DAIO"
    },
    {
     "description": "DAIHEN CORP",
     "symbol": "DAIPF"
    },
    {
     "description": "DAITO PHARMACEUTICAL CO LTD",
     "symbol": "DAITF"
    },
    {
     "description": "DAIFUKU CO LTD",
     "symbol": "DAIUF"
    },
    {
     "description": "DAI NIPPON TORYO CO LTD",
     "symbol": "DAIYF"
    },
    {
     "description": "DAKTRONICS INC",
     "symbol": "DAKT"
    },
    {
     "description": "DELTA AIR LINES INC",
     "symbol": "DAL"
    },
    {
     "description": "FIRST TRUST DORSEYWRIGHT DAL",
     "symbol": "DALI"
    },
    {
     "description": "DALLASNEWS CORP",
     "symbol": "DALN"
    },
    {
     "description": "D&L INDUSTRIES INC",
     "symbol": "DALQF"
    },
    {
     "description": "DA32 LIFE SCIENCE TECH ACQ-A",
     "symbol": "DALS"
    },
    {
     "description": "ANFIELD CAP DIVERSIFIED ALT",
     "symbol": "DALT"
    },
    {
     "description": "SPARTAN DELTA CORP",
     "symbol": "DALXF"
    },
    {
     "description": "VANECK DIGITAL ASSETS MINING",
     "symbol": "DAM"
    },
    {
     "description": "DANA INC",
     "symbol": "DAN"
    },
    {
     "description": "DANONE-SPONS ADR",
     "symbol": "DANOY"
    },
    {
     "description": "DANA RESOURCES",
     "symbol": "DANR"
    },
    {
     "description": "YOUDAO INC - ADR",
     "symbol": "DAO"
    },
    {
     "description": "CRYPTO 1 ACQUISITION COR-CLA",
     "symbol": "DAOO"
    },
    {
     "description": "CRYPTO 1 ACQUISITION CORP",
     "symbol": "DAOOU"
    },
    {
     "description": "CRYPTO 1 ACQUISITION -CW27",
     "symbol": "DAOOW"
    },
    {
     "description": "VANECK DIGITAL TRANSFORMATIO",
     "symbol": "DAPP"
    },
    {
     "description": "FT CB US EQ DEEP BUFF APR",
     "symbol": "DAPR"
    },
    {
     "description": "DARLING INGREDIENTS INC",
     "symbol": "DAR"
    },
    {
     "description": "DARE BIOSCIENCE INC",
     "symbol": "DARE"
    },
    {
     "description": "DOORDASH INC - A",
     "symbol": "DASH"
    },
    {
     "description": "DASSAULT SYSTEMES SE",
     "symbol": "DASTF"
    },
    {
     "description": "DASSAULT SYSTEMES S-SPON ADR",
     "symbol": "DASTY"
    },
    {
     "description": "PROSHARES BIG DATA REFINERS",
     "symbol": "DAT"
    },
    {
     "description": "DIGITAL ASSET MONETARY NETWO",
     "symbol": "DATI"
    },
    {
     "description": "DATCHAT INC",
     "symbol": "DATS"
    },
    {
     "description": "DATCHAT INC -CW26",
     "symbol": "DATSW"
    },
    {
     "description": "DATWYLER HOLDING-UNSPON ADR",
     "symbol": "DATWY"
    },
    {
     "description": "FT CBOE US EQUITY DEEP BUFFE",
     "symbol": "DAUG"
    },
    {
     "description": "DESERT GOLD VENTURES INC",
     "symbol": "DAUGF"
    },
    {
     "description": "ENDAVA PLC- SPON ADR",
     "symbol": "DAVA"
    },
    {
     "description": "DAVE INC",
     "symbol": "DAVE"
    },
    {
     "description": "DAVE INC -CW27",
     "symbol": "DAVEW"
    },
    {
     "description": "DAIWA INDUSTRIES LTD",
     "symbol": "DAWIF"
    },
    {
     "description": "DAY ONE BIOPHARMACEUTICALS I",
     "symbol": "DAWN"
    },
    {
     "description": "DAIWA HOUSE REIT INVESTMENT",
     "symbol": "DAWUF"
    },
    {
     "description": "GLOBAL X DAX GERMANY ETF",
     "symbol": "DAX"
    },
    {
     "description": "ISHARES CORE DAX DE EUR ACC",
     "symbol": "DAXXF"
    },
    {
     "description": "DEUTSCHE BANK AG-REGISTERED",
     "symbol": "DB"
    },
    {
     "description": "INVESCO DB AGRICULTURE FUND",
     "symbol": "DBA"
    },
    {
     "description": "XTRACKERS MSCI ALL WORLD EX",
     "symbol": "DBAW"
    },
    {
     "description": "INVESCO DB BASE METALS FUND",
     "symbol": "DBB"
    },
    {
     "description": "INVESCO DB COMMODITY INDEX T",
     "symbol": "DBC"
    },
    {
     "description": "DECIBEL CANNABIS CO INC",
     "symbol": "DBCCF"
    },
    {
     "description": "DIEBOLD NIXDORF INC",
     "symbol": "DBD"
    },
    {
     "description": "INVESCO DB ENERGY FUND",
     "symbol": "DBE"
    },
    {
     "description": "XTRACKERS MSCI EAFE HEDGED E",
     "symbol": "DBEF"
    },
    {
     "description": "IMGP DBI HEDGE STRATEGY ETF",
     "symbol": "DBEH"
    },
    {
     "description": "XTRACKERS MSCI EMERGING MARK",
     "symbol": "DBEM"
    },
    {
     "description": "XTRACKERS MSCI EUROPE HEDGED",
     "symbol": "DBEU"
    },
    {
     "description": "XTRACKERS MSCI EUROZONE HEDG",
     "symbol": "DBEZ"
    },
    {
     "description": "PANEX RESOURCES INC",
     "symbol": "DBGF"
    },
    {
     "description": "DIGITAL BRANDS GROUP INC",
     "symbol": "DBGI"
    },
    {
     "description": "DIGITAL BRANDS GROUP -CW28",
     "symbol": "DBGIW"
    },
    {
     "description": "XTRACKERS MSCI GERMANY HEDGE",
     "symbol": "DBGR"
    },
    {
     "description": "DESIGNER BRANDS INC-CLASS A",
     "symbol": "DBI"
    },
    {
     "description": "DACOTAH BANKS INC",
     "symbol": "DBIN"
    },
    {
     "description": "INNOVATOR DBL STACK 9 BUFF-J",
     "symbol": "DBJA"
    },
    {
     "description": "XTRACKERS MSCI JAPAN HEDGED",
     "symbol": "DBJP"
    },
    {
     "description": "DIGIMAX GLOBAL INC",
     "symbol": "DBKSF"
    },
    {
     "description": "DOUBLELINE OPPORT CREDIT",
     "symbol": "DBL"
    },
    {
     "description": "ADVISORSHARES DOUBLELINE VAL",
     "symbol": "DBLV"
    },
    {
     "description": "DOUBLEVIEW GOLD CORP",
     "symbol": "DBLVF"
    },
    {
     "description": "MACQUARIE MEXICO REAL ESTATE",
     "symbol": "DBMBF"
    },
    {
     "description": "IMGP DBI MANAGED FUTURES STR",
     "symbol": "DBMF"
    },
    {
     "description": "DBM GLOBAL INC",
     "symbol": "DBMG"
    },
    {
     "description": "DIGITAL BRAND MEDIA & MARKET",
     "symbol": "DBMM"
    },
    {
     "description": "CONCENTRADORA FIBRA HOTELERA",
     "symbol": "DBMXF"
    },
    {
     "description": "DOUBLELINE OPPORTUNISTIC BND",
     "symbol": "DBND"
    },
    {
     "description": "INVESCO DB OIL FUND",
     "symbol": "DBO"
    },
    {
     "description": "INNOV DBL STACKER 9 BUFF OCT",
     "symbol": "DBOC"
    },
    {
     "description": "DEUTSCHE BOERSE AG",
     "symbol": "DBOEF"
    },
    {
     "description": "DEUTSCHE BOERSE AG-UNSPN ADR",
     "symbol": "DBOEY"
    },
    {
     "description": "DIABLO RESOURCES LTD",
     "symbol": "DBORF"
    },
    {
     "description": "D-BOX TECHNOLOGIES INC",
     "symbol": "DBOXF"
    },
    {
     "description": "INVESCO DB PRECIOUS METALS F",
     "symbol": "DBP"
    },
    {
     "description": "DIGITALBRIDGE GROUP INC",
     "symbol": "DBRG"
    },
    {
     "description": "DIGITALBRIDGE GROUP INC",
     "symbol": "DBRG.PRH"
    },
    {
     "description": "DIGITALBRIDGE GROUP INC",
     "symbol": "DBRG.PRI"
    },
    {
     "description": "DIGITALBRIDGE GROUP INC",
     "symbol": "DBRG.PRJ"
    },
    {
     "description": "DAYBREAK OIL & GAS INC",
     "symbol": "DBRM"
    },
    {
     "description": "ASESOR DE ACTIVOS PRISMA SAP",
     "symbol": "DBRTF"
    },
    {
     "description": "INVESCO DB SILVER FUND",
     "symbol": "DBS"
    },
    {
     "description": "DBS GROUP HOLDINGS LTD",
     "symbol": "DBSDF"
    },
    {
     "description": "DBS GROUP HOLDINGS-SPON ADR",
     "symbol": "DBSDY"
    },
    {
     "description": "XTRACKER RHODIUM ETC",
     "symbol": "DBSHF"
    },
    {
     "description": "DECIBEL THERAPEUTICS INC",
     "symbol": "DBTX"
    },
    {
     "description": "DBUB GROUP INC",
     "symbol": "DBUB"
    },
    {
     "description": "INVESCO DB G10 CURRENCY HARV",
     "symbol": "DBV"
    },
    {
     "description": "DBV TECHNOLOGIES SA-SPON ADR",
     "symbol": "DBVT"
    },
    {
     "description": "DBV TECHNOLOGIES SA",
     "symbol": "DBVTF"
    },
    {
     "description": "DROPBOX INC-CLASS A",
     "symbol": "DBX"
    },
    {
     "description": "X STOXX EUROPE 600",
     "symbol": "DBXKF"
    },
    {
     "description": "X MSCI JAPAN",
     "symbol": "DBXRF"
    },
    {
     "description": "X GLOBAL SELECT DIV 100 SWAP",
     "symbol": "DBXXF"
    },
    {
     "description": "DAKOTA GOLD CORP",
     "symbol": "DC"
    },
    {
     "description": "DANIELS CORPORATE ADVISORY C",
     "symbol": "DCAC"
    },
    {
     "description": "DOCEBO INC",
     "symbol": "DCBO"
    },
    {
     "description": "DACIAN GOLD LTD",
     "symbol": "DCCNF"
    },
    {
     "description": "DCC PLC",
     "symbol": "DCCPF"
    },
    {
     "description": "DCC PLC-UNSPONSORED ADR",
     "symbol": "DCCPY"
    },
    {
     "description": "BNY MELLON ALCENTRA GLOBAL C",
     "symbol": "DCF"
    },
    {
     "description": "TRITIUM DCFC LTD",
     "symbol": "DCFC"
    },
    {
     "description": "TRITIUM DCFC LTD -CW24",
     "symbol": "DCFCW"
    },
    {
     "description": "DOCGO INC",
     "symbol": "DCGO"
    },
    {
     "description": "DOCGO INC-CW27",
     "symbol": "DCGOW"
    },
    {
     "description": "DIGITAL CHINA HOLDINGS LTD",
     "symbol": "DCHIF"
    },
    {
     "description": "DIGITAL CHINA HD LTD-UNP ADR",
     "symbol": "DCHIY"
    },
    {
     "description": "DECHRA PHARMACEUTICALS PLC",
     "symbol": "DCHPF"
    },
    {
     "description": "DISCOVERY HARBOUR RESOURCES",
     "symbol": "DCHRF"
    },
    {
     "description": "DONALDSON CO INC",
     "symbol": "DCI"
    },
    {
     "description": "DATA CALL TECHNOLOGIES INC",
     "symbol": "DCLT"
    },
    {
     "description": "DATA COMMUNICATIONS MANAGEME",
     "symbol": "DCMDF"
    },
    {
     "description": "DCM HOLDINGS CO LTD",
     "symbol": "DCMJF"
    },
    {
     "description": "CANADIAN PALLADIUM RESOURCES",
     "symbol": "DCNNF"
    },
    {
     "description": "DAI-ICHI LIFE HOLDINGS INC",
     "symbol": "DCNSF"
    },
    {
     "description": "DUCOMMUN INC",
     "symbol": "DCO"
    },
    {
     "description": "DISCOUNT INVESTMENT CORP-REG",
     "symbol": "DCOEF"
    },
    {
     "description": "DICKSON CONCEPTS INTL LTD",
     "symbol": "DCOHF"
    },
    {
     "description": "DIME COMMUNITY BANCSHARES IN",
     "symbol": "DCOM"
    },
    {
     "description": "DIME COMMUNITY BANCSHARE",
     "symbol": "DCOMP"
    },
    {
     "description": "DCP MIDSTREAM LP",
     "symbol": "DCP"
    },
    {
     "description": "DCP MIDSTREAM LP",
     "symbol": "DCP.PRB"
    },
    {
     "description": "DCP MIDSTREAM LP",
     "symbol": "DCP.PRC"
    },
    {
     "description": "DOUBLELINE SHILLER CAPE ETF",
     "symbol": "DCPE"
    },
    {
     "description": "DECIPHERA PHARMACEUTICALS IN",
     "symbol": "DCPH"
    },
    {
     "description": "DECARBONIZATION PLUS ACQUI-A",
     "symbol": "DCRD"
    },
    {
     "description": "DECARBONIZATION PLUS ACQUISI",
     "symbol": "DCRDU"
    },
    {
     "description": "DECARBONIZATION PLUS A -CW28",
     "symbol": "DCRDW"
    },
    {
     "description": "DIRECT COMMUNICATION SOLUTIO",
     "symbol": "DCSX"
    },
    {
     "description": "DUCK CREEK TECHNOLOGIES INC",
     "symbol": "DCT"
    },
    {
     "description": "DELCATH SYSTEMS INC",
     "symbol": "DCTH"
    },
    {
     "description": "DELTA CLEANTECH INC",
     "symbol": "DCTIF"
    },
    {
     "description": "DOMINION ENERGY INC",
     "symbol": "DCUE"
    },
    {
     "description": "DISCOVERY LTD",
     "symbol": "DCYHF"
    },
    {
     "description": "DISCOVERY HOLDINGS LTD-ADR",
     "symbol": "DCYHY"
    },
    {
     "description": "DUPONT DE NEMOURS INC",
     "symbol": "DD"
    },
    {
     "description": "MERCEDES-BENZ GROUP AG",
     "symbol": "DDAIF"
    },
    {
     "description": "DIC ASSET AG",
     "symbol": "DDCCF"
    },
    {
     "description": "3D SYSTEMS CORP",
     "symbol": "DDD"
    },
    {
     "description": "DIGITAL DAY AGENCY INC",
     "symbol": "DDDA"
    },
    {
     "description": "3DX INDUSTRIES INC",
     "symbol": "DDDX"
    },
    {
     "description": "FT CBOE VEST US DEEP BUF DEC",
     "symbol": "DDEC"
    },
    {
     "description": "DUNDEE CORP -CL A",
     "symbol": "DDEJF"
    },
    {
     "description": "DELAWARE INV DIVIDEND & INC",
     "symbol": "DDF"
    },
    {
     "description": "PROSHARES SHORT OIL & GAS",
     "symbol": "DDG"
    },
    {
     "description": "DDH1 LTD",
     "symbol": "DDHLF"
    },
    {
     "description": "DREAM IMPACT TRUST",
     "symbol": "DDHRF"
    },
    {
     "description": "DOUBLEDOWN INTERACTIVE -ADR",
     "symbol": "DDI"
    },
    {
     "description": "MARGARET LAKE DIAMONDS INC",
     "symbol": "DDIAF"
    },
    {
     "description": "FIRST TRUST DORSEY WRIGHT MO",
     "symbol": "DDIV"
    },
    {
     "description": "DINGDONG CAYMAN LTD -SPN ADR",
     "symbol": "DDL"
    },
    {
     "description": "WISDOMTREE DY CUR HDG SCP EQ",
     "symbol": "DDLS"
    },
    {
     "description": "DD'S DELUXE ROD HOLDER INC",
     "symbol": "DDLX"
    },
    {
     "description": "PROSHARES ULTRA DOW30",
     "symbol": "DDM"
    },
    {
     "description": "DAIHATSU DIESEL MFG CO LTD",
     "symbol": "DDMGF"
    },
    {
     "description": "ADAMERA MINERALS CORP",
     "symbol": "DDNFF"
    },
    {
     "description": "DATADOG INC - CLASS A",
     "symbol": "DDOG"
    },
    {
     "description": "DB COMMODITY SHORT ETN",
     "symbol": "DDPXF"
    },
    {
     "description": "DIVERSIFIED RESOURCES INC",
     "symbol": "DDRIQ"
    },
    {
     "description": "DRILLING CO OF 1972\/THE",
     "symbol": "DDRLF"
    },
    {
     "description": "DILLARDS INC-CL A",
     "symbol": "DDS"
    },
    {
     "description": "DILLARDS CAP TRUST I",
     "symbol": "DDT"
    },
    {
     "description": "WISDOMTREE DY CUR HDG INTL",
     "symbol": "DDWM"
    },
    {
     "description": "DIVIDEND GROWTH SPLIT CORP-A",
     "symbol": "DDWWF"
    },
    {
     "description": "DEERE & CO",
     "symbol": "DE"
    },
    {
     "description": "EASTERLY GOVERNMENT PROPERTI",
     "symbol": "DEA"
    },
    {
     "description": "DENALI CAPITAL ACQUISITION C",
     "symbol": "DECAU"
    },
    {
     "description": "DECKERS OUTDOOR CORP",
     "symbol": "DECK"
    },
    {
     "description": "DECISION DIAGNOSTICS CORP",
     "symbol": "DECN"
    },
    {
     "description": "DIVERSIFIED ENERGY CO PLC",
     "symbol": "DECPF"
    },
    {
     "description": "DECADE RESOURCES LTD",
     "symbol": "DECXF"
    },
    {
     "description": "TRUESHARES STRUC OUT DEC ETF",
     "symbol": "DECZ"
    },
    {
     "description": "FIRST TRUST TCW SEC PLUS ETF",
     "symbol": "DEED"
    },
    {
     "description": "XTRACK FTSE DEV EX US MULTI",
     "symbol": "DEEF"
    },
    {
     "description": "DB COMMODITY DOUBLE SHORT",
     "symbol": "DEENF"
    },
    {
     "description": "ROUNDHILL ACQUIRERS DEEP VAL",
     "symbol": "DEEP"
    },
    {
     "description": "DEER CONSUMER PRODUCTS INC",
     "symbol": "DEER"
    },
    {
     "description": "INVESCO DEFENSIVE EQUITY ETF",
     "symbol": "DEF"
    },
    {
     "description": "DEFI TECHNOLOGIES INC",
     "symbol": "DEFTF"
    },
    {
     "description": "DOUGLAS EMMETT INC",
     "symbol": "DEI"
    },
    {
     "description": "STERLING CAP DIV MULT MAN AT",
     "symbol": "DEIF"
    },
    {
     "description": "RIO PARANAPANEMA - SPONS ADR",
     "symbol": "DEIPY"
    },
    {
     "description": "DEVRO PLC",
     "symbol": "DEITF"
    },
    {
     "description": "DELIC HOLDINGS CORP",
     "symbol": "DELCF"
    },
    {
     "description": "DE'LONGHI SPA",
     "symbol": "DELHF"
    },
    {
     "description": "DELIVERY HERO SE - UNSP ADR",
     "symbol": "DELHY"
    },
    {
     "description": "DELEK GROUP LTD-UNSPON ADR",
     "symbol": "DELKY"
    },
    {
     "description": "DELL TECHNOLOGIES -C",
     "symbol": "DELL"
    },
    {
     "description": "DE LA RUE PLC",
     "symbol": "DELRF"
    },
    {
     "description": "DELTA-GALIL INDUSTRIES",
     "symbol": "DELTF"
    },
    {
     "description": "WISDOMTREE EMERGING MARKETS",
     "symbol": "DEM"
    },
    {
     "description": "DE.MEM LTD",
     "symbol": "DEMEF"
    },
    {
     "description": "DEMOCRASOFT HOLDINGS INC",
     "symbol": "DEMO"
    },
    {
     "description": "WT EMERGING MARKETS EQ INC",
     "symbol": "DEMWF"
    },
    {
     "description": "DEMOCRATIC LARGE CAP CORE",
     "symbol": "DEMZ"
    },
    {
     "description": "DENBURY INC",
     "symbol": "DEN"
    },
    {
     "description": "DENALI BANCORPORATION INC",
     "symbol": "DENI"
    },
    {
     "description": "DENKA CO LTD",
     "symbol": "DENKF"
    },
    {
     "description": "DENNY'S CORP",
     "symbol": "DENN"
    },
    {
     "description": "DISCOVERY ENERGY CORP",
     "symbol": "DENR"
    },
    {
     "description": "DIAGEO PLC-SPONSORED ADR",
     "symbol": "DEO"
    },
    {
     "description": "DIRECT EQUITY INTERNATIONAL",
     "symbol": "DEQI"
    },
    {
     "description": "JOURNEY MEDICAL CORP",
     "symbol": "DERM"
    },
    {
     "description": "WISDOMTREE US SMALLCAP DIVID",
     "symbol": "DES"
    },
    {
     "description": "DESCENTE LTD",
     "symbol": "DESLF"
    },
    {
     "description": "DESPEGAR.COM CORP",
     "symbol": "DESP"
    },
    {
     "description": "DESTINATION MATERNITY CORP",
     "symbol": "DESTQ"
    },
    {
     "description": "AKER BP ASA",
     "symbol": "DETNF"
    },
    {
     "description": "DETERRA ROYALTIES LTD",
     "symbol": "DETRF"
    },
    {
     "description": "DEUTSCHE INDUSTRIE REIT AG",
     "symbol": "DEUIF"
    },
    {
     "description": "XTRACKERS RUSSELL US MULTI",
     "symbol": "DEUS"
    },
    {
     "description": "DEUTZ AG",
     "symbol": "DEUZF"
    },
    {
     "description": "DEVMAR EQUITIES INC",
     "symbol": "DEVM"
    },
    {
     "description": "DEVRO PLC - UNP ADR",
     "symbol": "DEVOY"
    },
    {
     "description": "BIOSCIENCE NEUTRACEUTICALS I",
     "symbol": "DEVV"
    },
    {
     "description": "WISDOMTREE GLOBAL HIGH DIVID",
     "symbol": "DEW"
    },
    {
     "description": "DEWMAR INTERNATIONAL BMC INC",
     "symbol": "DEWM"
    },
    {
     "description": "DEWEY ELECTRONICS CORP",
     "symbol": "DEWY"
    },
    {
     "description": "DELAWARE ENHANCED GLOBAL DIV",
     "symbol": "DEX"
    },
    {
     "description": "DEXUS\/AU",
     "symbol": "DEXSF"
    },
    {
     "description": "DIMENSIONAL US CORE EQUITY 2",
     "symbol": "DFAC"
    },
    {
     "description": "DIMENSIONAL EMERGING CORE EQ",
     "symbol": "DFAE"
    },
    {
     "description": "DIMENSIONAL INTERNATIONAL CO",
     "symbol": "DFAI"
    },
    {
     "description": "DIMENSIONAL US REAL EST ETF",
     "symbol": "DFAR"
    },
    {
     "description": "DIMENSIONAL US SMALL CAP ETF",
     "symbol": "DFAS"
    },
    {
     "description": "DOF ASA",
     "symbol": "DFASF"
    },
    {
     "description": "DIMENSIONAL US TARGET VALUE",
     "symbol": "DFAT"
    },
    {
     "description": "DIMENSIONAL US CORE EQUITY M",
     "symbol": "DFAU"
    },
    {
     "description": "DIMENSIONAL WORLD EX US CORE",
     "symbol": "DFAX"
    },
    {
     "description": "DIMENSIONAL CORE FIXED INC",
     "symbol": "DFCF"
    },
    {
     "description": "DALRADA FINANCIAL CORP",
     "symbol": "DFCO"
    },
    {
     "description": "DFDS A\/S",
     "symbol": "DFDDF"
    },
    {
     "description": "WISDOMTREE EUR S\/C DIVIDEND",
     "symbol": "DFE"
    },
    {
     "description": "FT CBOE VEST US EQY DEEP BUF",
     "symbol": "DFEB"
    },
    {
     "description": "CHINA TMK BATTERY SYSTEMS IN",
     "symbol": "DFEL"
    },
    {
     "description": "DRX DLY AERO & DEF BULL 3X",
     "symbol": "DFEN"
    },
    {
     "description": "DIFFER GROUP HOLDING CO LTD",
     "symbol": "DFFGF"
    },
    {
     "description": "DIFFUSION PHARMACEUTICALS IN",
     "symbol": "DFFN"
    },
    {
     "description": "DREAM FINDERS HOMES INC - A",
     "symbol": "DFH"
    },
    {
     "description": "DONG FANG HUI LE INC",
     "symbol": "DFHL"
    },
    {
     "description": "DONOGHUE FORLINES TACTICAL H",
     "symbol": "DFHY"
    },
    {
     "description": "DIMENSIONAL INTERNATIONAL CO",
     "symbol": "DFIC"
    },
    {
     "description": "DIAMOND FIELDS RESOUCES INC",
     "symbol": "DFIFF"
    },
    {
     "description": "DAIRY FARM INTL-UNSPON ADR",
     "symbol": "DFIHY"
    },
    {
     "description": "DAIRY FARM INTL HLDGS LTD",
     "symbol": "DFILF"
    },
    {
     "description": "DONNELLEY FINANCIAL SOLUTION",
     "symbol": "DFIN"
    },
    {
     "description": "Dimensional Inflation-Protec",
     "symbol": "DFIP"
    },
    {
     "description": "DIMENSIONAL INTERNATIONAL SM",
     "symbol": "DFIS"
    },
    {
     "description": "DIMENSIONAL INTERNATIONAL VA",
     "symbol": "DFIV"
    },
    {
     "description": "WISDOMTREE JPN S\/C DVD FUND",
     "symbol": "DFJ"
    },
    {
     "description": "Daifuku Co Ltd - UNSP ADR",
     "symbol": "DFKCY"
    },
    {
     "description": "DEFENSE METALS CORP",
     "symbol": "DFMTF"
    },
    {
     "description": "SIREN DIVCON DIVIDEND DEFEND",
     "symbol": "DFND"
    },
    {
     "description": "DAVIS SELECT FINANCIAL ETF",
     "symbol": "DFNL"
    },
    {
     "description": "DIMENSIONAL NATIONAL MUNI BD",
     "symbol": "DFNM"
    },
    {
     "description": "DFNN INC",
     "symbol": "DFNNF"
    },
    {
     "description": "DONOGHUE FORLINES RISK MANAG",
     "symbol": "DFNV"
    },
    {
     "description": "D4T4 SOLUTIONS PLC",
     "symbol": "DFORF"
    },
    {
     "description": "FLAHERTY & CRUMRINE DYNAMIC",
     "symbol": "DFP"
    },
    {
     "description": "DONOGHUE FORLINES YLD R\/A",
     "symbol": "DFRA"
    },
    {
     "description": "DUFRY AG-REG",
     "symbol": "DFRYF"
    },
    {
     "description": "DISCOVER FINANCIAL SERVICES",
     "symbol": "DFS"
    },
    {
     "description": "DIMENSIONAL SHORT DURATION",
     "symbol": "DFSD"
    },
    {
     "description": "DIMENSIONAL US SMALL CAP VAL",
     "symbol": "DFSV"
    },
    {
     "description": "DEFENTECT GROUP INC",
     "symbol": "DFTC"
    },
    {
     "description": "DEFENSE TECHNOLOGY SYSTEMS I",
     "symbol": "DFTS"
    },
    {
     "description": "DIMENSIONAL US EQUITY ETF",
     "symbol": "DFUS"
    },
    {
     "description": "DOLLAR GENERAL CORP",
     "symbol": "DG"
    },
    {
     "description": "DGB ASIA BHD",
     "symbol": "DGBBF"
    },
    {
     "description": "DIAGNOCURE INC",
     "symbol": "DGCRF"
    },
    {
     "description": "DYNASTY GOLD CORP",
     "symbol": "DGDCF"
    },
    {
     "description": "DIAGEO PLC",
     "symbol": "DGEAF"
    },
    {
     "description": "DELTAGEN INC",
     "symbol": "DGEN"
    },
    {
     "description": "DIGITALX LTD",
     "symbol": "DGGXF"
    },
    {
     "description": "DIGIHOST TECHNOLOGY INC",
     "symbol": "DGHI"
    },
    {
     "description": "DONEGAL GROUP INC-CL A",
     "symbol": "DGICA"
    },
    {
     "description": "DONEGAL GROUP INC-B",
     "symbol": "DGICB"
    },
    {
     "description": "D7 ENTERPRISES INC",
     "symbol": "DGIF"
    },
    {
     "description": "DIGI INTERNATIONAL INC",
     "symbol": "DGII"
    },
    {
     "description": "VANECK DIGITAL INDIA ETF",
     "symbol": "DGIN"
    },
    {
     "description": "DIGITCOM INTERACTIVE VIDEO",
     "symbol": "DGIV"
    },
    {
     "description": "DYNA GROUP INTERNATIONAL INC",
     "symbol": "DGIX"
    },
    {
     "description": "INVESCO DB GOLD FUND",
     "symbol": "DGL"
    },
    {
     "description": "VELOCITYSHARES 3X INVERSE GO",
     "symbol": "DGLDF"
    },
    {
     "description": "DIGILITI MONEY GROUP INC",
     "symbol": "DGLT"
    },
    {
     "description": "DIGITAL ALLY INC",
     "symbol": "DGLY"
    },
    {
     "description": "DEGAMA SOFTWARE SOLUTIONS IN",
     "symbol": "DGMA"
    },
    {
     "description": "DIGITAL DOMAIN HOLDINGS LTD",
     "symbol": "DGMDF"
    },
    {
     "description": "DE GREY MINING LTD",
     "symbol": "DGMLF"
    },
    {
     "description": "DIGIMEDICAL SOLUTIONS INC",
     "symbol": "DGMS"
    },
    {
     "description": "DIGUANG INTERNATIONAL DEVELO",
     "symbol": "DGNG"
    },
    {
     "description": "DIAGNOS INC",
     "symbol": "DGNOF"
    },
    {
     "description": "DRAGONEER GROWTH OPP III-A",
     "symbol": "DGNU"
    },
    {
     "description": "DIGNITY PLC",
     "symbol": "DGNYF"
    },
    {
     "description": "DB GOLD DOUBLE LONG ETN",
     "symbol": "DGP"
    },
    {
     "description": "WISDOMTREE EMERGING MARKETS",
     "symbol": "DGRE"
    },
    {
     "description": "ISHARES CORE DIVIDEND GROWTH",
     "symbol": "DGRO"
    },
    {
     "description": "WISDOMTREE U.S. SMALLCAP QUA",
     "symbol": "DGRS"
    },
    {
     "description": "WISDOMTREE U.S. QUALITY DIVI",
     "symbol": "DGRW"
    },
    {
     "description": "WISDOMTREE EM SMALL CAP",
     "symbol": "DGS"
    },
    {
     "description": "SPDR GLOBAL DOW ETF",
     "symbol": "DGT"
    },
    {
     "description": "DIGITAL CORE REIT MANAGEMENT",
     "symbol": "DGTCF"
    },
    {
     "description": "DGTL HOLDINGS INC",
     "symbol": "DGTHF"
    },
    {
     "description": "OCI INTERNATIONAL HOLDINGS L",
     "symbol": "DGTLF"
    },
    {
     "description": "DIGITALTOWN INC",
     "symbol": "DGTW"
    },
    {
     "description": "DIALOG GROUP BHD",
     "symbol": "DGUPF"
    },
    {
     "description": "DRAEGERWERK AG",
     "symbol": "DGWPF"
    },
    {
     "description": "DEEP GREEN WASTE & RECYCLING",
     "symbol": "DGWR"
    },
    {
     "description": "QUEST DIAGNOSTICS INC",
     "symbol": "DGX"
    },
    {
     "description": "DB GOLD SHORT ETN",
     "symbol": "DGZ"
    },
    {
     "description": "DEFINITIVE HEALTHCARE CORP",
     "symbol": "DH"
    },
    {
     "description": "DIGITAL HEALTH ACQUISTION CO",
     "symbol": "DHAC"
    },
    {
     "description": "DIGITAL HEALTH ACQUISITION C",
     "symbol": "DHACU"
    },
    {
     "description": "DIGITAL HEALTH ACQUIST-CW23",
     "symbol": "DHACW"
    },
    {
     "description": "DHB CAPITAL CORP-CL A",
     "symbol": "DHBC"
    },
    {
     "description": "DHB CAPITAL CORP",
     "symbol": "DHBCU"
    },
    {
     "description": "DHB CAPITAL CORP-CL A -CW28",
     "symbol": "DHBCW"
    },
    {
     "description": "DIVERSIFIED HEALTHCARE TRUST",
     "symbol": "DHC"
    },
    {
     "description": "DHC ACQUISITION CORP-A",
     "symbol": "DHCA"
    },
    {
     "description": "DHC ACQUISITION CORP",
     "symbol": "DHCAU"
    },
    {
     "description": "DHC ACQUISITION CORP A -CW27",
     "symbol": "DHCAW"
    },
    {
     "description": "DIAMONDHEAD CASINO CORP",
     "symbol": "DHCC"
    },
    {
     "description": "DIVERSIFIED HEALTHCARE T",
     "symbol": "DHCNI"
    },
    {
     "description": "DIVERSIFIED HEALTHCARE T",
     "symbol": "DHCNL"
    },
    {
     "description": "BNYM HIGH YIELD STRAT",
     "symbol": "DHF"
    },
    {
     "description": "DOMAIN HOLDINGS AUSTRALIA LT",
     "symbol": "DHGAF"
    },
    {
     "description": "DIAMONDHEAD HOLDINGS CORP-A",
     "symbol": "DHHC"
    },
    {
     "description": "DIAMONDHEAD HOLDINGS CORP",
     "symbol": "DHHCU"
    },
    {
     "description": "DIAMONDHEAD HOLDINGS A -CW28",
     "symbol": "DHHCW"
    },
    {
     "description": "DESARROLLADORA HOMEX SAB DE",
     "symbol": "DHHXF"
    },
    {
     "description": "DR HORTON INC",
     "symbol": "DHI"
    },
    {
     "description": "DIAMOND HILL INVESTMENT GRP",
     "symbol": "DHIL"
    },
    {
     "description": "GLOBAL STRATEGIC GROUP LTD",
     "symbol": "DHKCF"
    },
    {
     "description": "DANAHER CORP",
     "symbol": "DHR"
    },
    {
     "description": "DANAHER CORP",
     "symbol": "DHR.PRB"
    },
    {
     "description": "DEUTSCHE EUROSHOP AG-UNS ADR",
     "symbol": "DHRPY"
    },
    {
     "description": "WISDOMTREE US HIGH DIVIDEND",
     "symbol": "DHS"
    },
    {
     "description": "DAH SING BANKING GROUP LTD",
     "symbol": "DHSBF"
    },
    {
     "description": "DHT HOLDINGS INC",
     "symbol": "DHT"
    },
    {
     "description": "DHI GROUP INC",
     "symbol": "DHX"
    },
    {
     "description": "CREDIT SUISSE HIGH YIELD BD",
     "symbol": "DHY"
    },
    {
     "description": "ISHARES USD HY CORP ESG USDA",
     "symbol": "DHYAF"
    },
    {
     "description": "ISHARES USD HY CORP ESG USDD",
     "symbol": "DHYDF"
    },
    {
     "description": "SPDR DJIA TRUST",
     "symbol": "DIA"
    },
    {
     "description": "DIAMANT ART CORP",
     "symbol": "DIAAF"
    },
    {
     "description": "DIAMOND HOLDINGS INC",
     "symbol": "DIAH"
    },
    {
     "description": "COLUMBIA DIVERSIFIED ETF",
     "symbol": "DIAL"
    },
    {
     "description": "DIALIGHT PLC",
     "symbol": "DIALF"
    },
    {
     "description": "NUVEEN DOW30 DYN OVERWRT FD",
     "symbol": "DIAX"
    },
    {
     "description": "1STDIBS.COM INC",
     "symbol": "DIBS"
    },
    {
     "description": "DAIBIRU CORP-UNSP ADR",
     "symbol": "DIBUY"
    },
    {
     "description": "DIC CORP",
     "symbol": "DICCF"
    },
    {
     "description": "DICE THERAPEUTICS INC",
     "symbol": "DICE"
    },
    {
     "description": "DISTRIBUIDORA INTERNACIONAL",
     "symbol": "DIDAF"
    },
    {
     "description": "DISTRIBUIDORA INT-UNSP ADR",
     "symbol": "DIDAY"
    },
    {
     "description": "DIDI GLOBAL INC",
     "symbol": "DIDI"
    },
    {
     "description": "DAITO TRUST CONS-SPN ADR",
     "symbol": "DIFTY"
    },
    {
     "description": "PROSHARES ULTRA OIL & GAS",
     "symbol": "DIG"
    },
    {
     "description": "DIGATRADE FINANCIAL CORP",
     "symbol": "DIGAF"
    },
    {
     "description": "DIGI.COM BHD",
     "symbol": "DIGBF"
    },
    {
     "description": "DIGITILITI INC",
     "symbol": "DIGI"
    },
    {
     "description": "DIGIPATH INC",
     "symbol": "DIGP"
    },
    {
     "description": "THRUVISION GROUP PLC",
     "symbol": "DIGTF"
    },
    {
     "description": "DIMENSIONAL INTERNATIONAL HI",
     "symbol": "DIHP"
    },
    {
     "description": "DOREL INDUSTRIES-CL B",
     "symbol": "DIIBF"
    },
    {
     "description": "DIRECT LINE INSURANCE GROUP",
     "symbol": "DIISF"
    },
    {
     "description": "DIRECT LINE INSURAN-UNSP ADR",
     "symbol": "DIISY"
    },
    {
     "description": "DILA CAPITAL ACQUISITION - A",
     "symbol": "DILA"
    },
    {
     "description": "DILA CAPITAL ACQUISITION COR",
     "symbol": "DILAU"
    },
    {
     "description": "DILA CAPITAL ACQ CL A -CW28",
     "symbol": "DILAW"
    },
    {
     "description": "WISDOMTREE INTL M\/C DVD FUND",
     "symbol": "DIM"
    },
    {
     "description": "DIMECO INC",
     "symbol": "DIMC"
    },
    {
     "description": "DINE BRANDS GLOBAL INC",
     "symbol": "DIN"
    },
    {
     "description": "HF SINCLAIR CORP",
     "symbol": "DINO"
    },
    {
     "description": "SCREEN HOLDINGS CO LTD",
     "symbol": "DINRF"
    },
    {
     "description": "DAVIS SELECT INTERNATIONAL",
     "symbol": "DINT"
    },
    {
     "description": "DIODES INC",
     "symbol": "DIOD"
    },
    {
     "description": "DIONICS INC",
     "symbol": "DION"
    },
    {
     "description": "DIOS EXPLORATION INC",
     "symbol": "DIOSF"
    },
    {
     "description": "DATANG INTL POWER GEN CO-H",
     "symbol": "DIPGF"
    },
    {
     "description": "DIRECTVIEW HOLDINGS INC",
     "symbol": "DIRV"
    },
    {
     "description": "WALT DISNEY CO\/THE",
     "symbol": "DIS"
    },
    {
     "description": "DISRUPTIVE ACQUISITION COR-A",
     "symbol": "DISA"
    },
    {
     "description": "DISRUPTIVE ACQUISITION CORP",
     "symbol": "DISAU"
    },
    {
     "description": "DISRUPTIVE ACQ CL A -CW26",
     "symbol": "DISAW"
    },
    {
     "description": "DISH NETWORK CORP-A",
     "symbol": "DISH"
    },
    {
     "description": "DISCO CORP",
     "symbol": "DISPF"
    },
    {
     "description": "DIMENSIONAL INTERNATIONAL SM",
     "symbol": "DISV"
    },
    {
     "description": "AMCON DISTRIBUTING CO",
     "symbol": "DIT"
    },
    {
     "description": "DS SMITH PLC",
     "symbol": "DITHF"
    },
    {
     "description": "DAITO TRUST CONSTRUCT CO LTD",
     "symbol": "DITTF"
    },
    {
     "description": "DIACEUTICS PLC",
     "symbol": "DIUXF"
    },
    {
     "description": "GLOBAL X SUPERDIVIDEND USE",
     "symbol": "DIV"
    },
    {
     "description": "AGFIQ HEDGED DIVIDEND INCOME",
     "symbol": "DIVA"
    },
    {
     "description": "ISHARES US DVD AND BUYBACK",
     "symbol": "DIVB"
    },
    {
     "description": "AMPLIFY CWP ENHANCED DIVIDEN",
     "symbol": "DIVO"
    },
    {
     "description": "SMARTETFS DIVIDEND BUILDER",
     "symbol": "DIVS"
    },
    {
     "description": "DiVall Insured Income Properties 2 Limited Partnership",
     "symbol": "DIVVZ"
    },
    {
     "description": "TRUESHARES LOW VOLATILITY EQ",
     "symbol": "DIVZ"
    },
    {
     "description": "DIGNITANA AB",
     "symbol": "DIZTF"
    },
    {
     "description": "FT CBOE VEST US EQ DEEP JAN",
     "symbol": "DJAN"
    },
    {
     "description": "ETRACS BLOOMBERG CMD INX-S\/B",
     "symbol": "DJCB"
    },
    {
     "description": "DAILY JOURNAL CORP",
     "symbol": "DJCO"
    },
    {
     "description": "INVESCO DOW JONES INDUSTRIAL",
     "symbol": "DJD"
    },
    {
     "description": "GLOBAL X DOW 30 COV CALL ETF",
     "symbol": "DJIA"
    },
    {
     "description": "IPATH BLOOMBERG COMMODITY IN",
     "symbol": "DJP"
    },
    {
     "description": "ISHARES EURO STOXX SMALL CAP",
     "symbol": "DJSCF"
    },
    {
     "description": "DJSP ENTERPRISES INC",
     "symbol": "DJSP"
    },
    {
     "description": "DAIICHI JITSUGYO CO LTD",
     "symbol": "DJTGF"
    },
    {
     "description": "FT CBOE VEST US EQ DEEP BUF",
     "symbol": "DJUL"
    },
    {
     "description": "FT CBOE VEST U.S. EQUITY DEE",
     "symbol": "DJUN"
    },
    {
     "description": "ISHARES STOXX EUR MID200 DE",
     "symbol": "DJXMF"
    },
    {
     "description": "ISHR STOXX EUR 600 BANKS DE",
     "symbol": "DJXSF"
    },
    {
     "description": "ISHARES STOXX EUROPE 600 DE",
     "symbol": "DJXXF"
    },
    {
     "description": "DELEK US HOLDINGS INC",
     "symbol": "DK"
    },
    {
     "description": "DRINKS AMERICAS HOLDINGS LTD",
     "symbol": "DKAM"
    },
    {
     "description": "DATA KNIGHTS ACQUISITION C-A",
     "symbol": "DKDCA"
    },
    {
     "description": "DATA KNIGHTS ACQUISITION COR",
     "symbol": "DKDCU"
    },
    {
     "description": "DATA KNIGHTS ACQ CL A -CW28",
     "symbol": "DKDCW"
    },
    {
     "description": "NEWMED ENERGY LP",
     "symbol": "DKDRF"
    },
    {
     "description": "DKG CAPITAL INC",
     "symbol": "DKGH"
    },
    {
     "description": "UNIVERSAL APPAREL & TEXTILE",
     "symbol": "DKGR"
    },
    {
     "description": "DAIICHI KIGENSO KAGAKU-KOGYO",
     "symbol": "DKGYF"
    },
    {
     "description": "DAIKIN INDUSTRIES LTD",
     "symbol": "DKILF"
    },
    {
     "description": "DAIKIN INDUSTRIES-UNSPON ADR",
     "symbol": "DKILY"
    },
    {
     "description": "DELEK LOGISTICS PARTNERS LP",
     "symbol": "DKL"
    },
    {
     "description": "DECKLAR RESOURCES INC",
     "symbol": "DKLRF"
    },
    {
     "description": "DRAFTKINGS INC - CL A",
     "symbol": "DKNG"
    },
    {
     "description": "DICK'S SPORTING GOODS INC",
     "symbol": "DKS"
    },
    {
     "description": "DAKSHIDIN CORP",
     "symbol": "DKSC"
    },
    {
     "description": "DKSH HOLDING AG",
     "symbol": "DKSHF"
    },
    {
     "description": "DAIICHIKOSHO CO LTD",
     "symbol": "DKSSF"
    },
    {
     "description": "TOP SHELF BRANDS HOLDINGS CO",
     "symbol": "DKTS"
    },
    {
     "description": "DELTA APPAREL INC",
     "symbol": "DLA"
    },
    {
     "description": "DEALERADVANCE INC",
     "symbol": "DLAD"
    },
    {
     "description": "DEUTSCHE LUFTHANSA-REG",
     "symbol": "DLAKF"
    },
    {
     "description": "LUFTHANSA-SPONS ADR",
     "symbol": "DLAKY"
    },
    {
     "description": "DOLBY LABORATORIES INC-CL A",
     "symbol": "DLB"
    },
    {
     "description": "DEEP LAKE CAPITAL ACQUIS-CLA",
     "symbol": "DLCA"
    },
    {
     "description": "DEEP LAKE CAPITAL ACQUISITIO",
     "symbol": "DLCAU"
    },
    {
     "description": "DEEP LAKE CAPITAL CL B -CW27",
     "symbol": "DLCAW"
    },
    {
     "description": "KIBUSH CAPITAL CORP",
     "symbol": "DLCR"
    },
    {
     "description": "DELTA ELECTRONICS THAI-FORGN",
     "symbol": "DLEGF"
    },
    {
     "description": "DATALEX PLC-ADR",
     "symbol": "DLEXY"
    },
    {
     "description": "DATALOGIC SPA",
     "symbol": "DLGCF"
    },
    {
     "description": "DIGITAL GARAGE INC",
     "symbol": "DLGEF"
    },
    {
     "description": "DATALOGIC INTERNATIONAL INC",
     "symbol": "DLGI"
    },
    {
     "description": "DLH HOLDINGS CORP",
     "symbol": "DLHC"
    },
    {
     "description": "DL HOLDINGS GROUP LTD",
     "symbol": "DLHGF"
    },
    {
     "description": "DIALOGUE HEALTH TECHNOLOGIES",
     "symbol": "DLHTF"
    },
    {
     "description": "DAI-ICHI LIFE HOLD INC UNSP",
     "symbol": "DLICY"
    },
    {
     "description": "DIXIE LEE INTERNATIONAL INDU",
     "symbol": "DLII"
    },
    {
     "description": "DELEK GROUP LTD",
     "symbol": "DLKGF"
    },
    {
     "description": "DALI FOODS GROUP CO LTD",
     "symbol": "DLLFF"
    },
    {
     "description": "DELTA LLOYD NV",
     "symbol": "DLLLF"
    },
    {
     "description": "DOLLARAMA INC",
     "symbol": "DLMAF"
    },
    {
     "description": "DIAMOND LAKE MINERALS INC",
     "symbol": "DLMI"
    },
    {
     "description": "WISDOMTREE US LARGECAP DIVID",
     "symbol": "DLN"
    },
    {
     "description": "D&L INDUSTRIES INC-UNSP ADR",
     "symbol": "DLNDY"
    },
    {
     "description": "DYNAGAS LNG PARTNERS LP",
     "symbol": "DLNG"
    },
    {
     "description": "DYNAGAS LNG PARTNERS LP",
     "symbol": "DLNG.PRA"
    },
    {
     "description": "DYNAGAS LNG PARTNERS LP",
     "symbol": "DLNG.PRB"
    },
    {
     "description": "DLOCAL LTD",
     "symbol": "DLO"
    },
    {
     "description": "DIGITAL LOCATIONS INC",
     "symbol": "DLOC"
    },
    {
     "description": "DOLPHIN ENTERTAINMENT INC",
     "symbol": "DLPN"
    },
    {
     "description": "DLP RESOURCES INC",
     "symbol": "DLPRF"
    },
    {
     "description": "LIAONING PORT CO LTD-H",
     "symbol": "DLPTF"
    },
    {
     "description": "DELPHAX TECHNOLOGIES INC",
     "symbol": "DLPX"
    },
    {
     "description": "DIGITAL REALTY TRUST INC",
     "symbol": "DLR"
    },
    {
     "description": "DIGITAL REALTY TRUST INC",
     "symbol": "DLR.PRJ"
    },
    {
     "description": "DIGITAL REALTY TRUST INC",
     "symbol": "DLR.PRK"
    },
    {
     "description": "DIGITAL REALTY TRUST INC",
     "symbol": "DLR.PRL"
    },
    {
     "description": "DELTA DRONE",
     "symbol": "DLRWF"
    },
    {
     "description": "CARLYLE COMMODITIES CORP",
     "symbol": "DLRYF"
    },
    {
     "description": "WISDOMTREE INTL S\/C DVD FUND",
     "symbol": "DLS"
    },
    {
     "description": "DELTA OIL & GAS INC",
     "symbol": "DLTA"
    },
    {
     "description": "DULUTH HOLDINGS INC - CL B",
     "symbol": "DLTH"
    },
    {
     "description": "DLT RESOLUTION INC",
     "symbol": "DLTI"
    },
    {
     "description": "DELTA 9 CANNABIS INC",
     "symbol": "DLTNF"
    },
    {
     "description": "DOLLAR TREE INC",
     "symbol": "DLTR"
    },
    {
     "description": "DALATA HOTEL GROUP PLC",
     "symbol": "DLTTF"
    },
    {
     "description": "DLT ASA",
     "symbol": "DLTXF"
    },
    {
     "description": "DE LA RUE PLC -UNSPON ADR",
     "symbol": "DLUEY"
    },
    {
     "description": "DELIVERY HERO SE",
     "symbol": "DLVHF"
    },
    {
     "description": "DELUXE CORP",
     "symbol": "DLX"
    },
    {
     "description": "DOUBLELINE YIELD OPPORT",
     "symbol": "DLY"
    },
    {
     "description": "DAIS CORP",
     "symbol": "DLYT"
    },
    {
     "description": "DESKTOP METAL INC-A",
     "symbol": "DM"
    },
    {
     "description": "DESTRA MULTI-ALTERNATIVE",
     "symbol": "DMA"
    },
    {
     "description": "DIAMEDICA THERAPEUTICS INC",
     "symbol": "DMAC"
    },
    {
     "description": "DEMAND BRANDS INC",
     "symbol": "DMAN"
    },
    {
     "description": "DEEP MEDICINE ACQUISITI-CL A",
     "symbol": "DMAQ"
    },
    {
     "description": "DEEP MEDICINE ACQUITION-RTS",
     "symbol": "DMAQR"
    },
    {
     "description": "FT CBOE VST US EQY DP BUF-MR",
     "symbol": "DMAR"
    },
    {
     "description": "GLOBAL X DISRUPTIVE MATER ET",
     "symbol": "DMAT"
    },
    {
     "description": "FT CBOE VEST US EQY D BU-MAY",
     "symbol": "DMAY"
    },
    {
     "description": "BNYM MUNI BND INFRA",
     "symbol": "DMB"
    },
    {
     "description": "DETWILER FENTON GROUP INC",
     "symbol": "DMCD"
    },
    {
     "description": "DMCI HOLDINGS INC-UNSP ADR",
     "symbol": "DMCHY"
    },
    {
     "description": "D'AMICO INTERNATIONAL SHIPPI",
     "symbol": "DMCOF"
    },
    {
     "description": "DEMOCRACY INTERNATIONAL FUND",
     "symbol": "DMCY"
    },
    {
     "description": "DIAMOND DISCOVERIES INTL COR",
     "symbol": "DMDD"
    },
    {
     "description": "AAM S&P DEVELOPED MARKETS HI",
     "symbol": "DMDV"
    },
    {
     "description": "DOMESTIC ENERGY CORP",
     "symbol": "DMEC"
    },
    {
     "description": "DESERT MOUNTAIN ENERGY CORP",
     "symbol": "DMEHF"
    },
    {
     "description": "BNYM MUNICIPAL INCOME",
     "symbol": "DMF"
    },
    {
     "description": "DECKER MANUFACTURING CORP",
     "symbol": "DMFG"
    },
    {
     "description": "DMG BLOCKCHAIN SOLUTIONS INC",
     "symbol": "DMGGF"
    },
    {
     "description": "DIAMCOR MINING INC",
     "symbol": "DMIFF"
    },
    {
     "description": "DENMARK BANCSHARES INC - A",
     "symbol": "DMKBA"
    },
    {
     "description": "DENMARK BANCSHARES INC - B",
     "symbol": "DMKBB"
    },
    {
     "description": "DORCHESTER MINERALS LP",
     "symbol": "DMLP"
    },
    {
     "description": "MERCEDES-BENZ GROUP-UNSP ADR",
     "symbol": "DMLRY"
    },
    {
     "description": "DIAMOND BANCSHARES INC",
     "symbol": "DMNB"
    },
    {
     "description": "DNI METALS INC",
     "symbol": "DMNKF"
    },
    {
     "description": "WESTERN ASSET MORTGAGE OPPOR",
     "symbol": "DMO"
    },
    {
     "description": "DELIMOBIL HOLDING SA",
     "symbol": "DMOB"
    },
    {
     "description": "DIAMOND BUILDING PDTS-NVDR",
     "symbol": "DMPBF"
    },
    {
     "description": "DEL MONTE PACIFIC LTD",
     "symbol": "DMPLF"
    },
    {
     "description": "KINTARA THERAPEUTICS-CW24",
     "symbol": "DMPWW"
    },
    {
     "description": "DOMINO'S PIZZA GROUP PLC",
     "symbol": "DMPZF"
    },
    {
     "description": "DIGIMARC CORP",
     "symbol": "DMRC"
    },
    {
     "description": "DAYTON & MICHIGAN RR CO",
     "symbol": "DMRR"
    },
    {
     "description": "Dayton and Michigan Railway Company",
     "symbol": "DMRRP"
    },
    {
     "description": "DIGITAL MEDIA SOLUTIONS-A",
     "symbol": "DMS"
    },
    {
     "description": "DIGITAL MEDIA SOL - CW23",
     "symbol": "DMS.WS"
    },
    {
     "description": "DERMISONICS INC",
     "symbol": "DMSI"
    },
    {
     "description": "D MECATRONICS INC",
     "symbol": "DMTA"
    },
    {
     "description": "DERMTECH INC",
     "symbol": "DMTK"
    },
    {
     "description": "DERMTECH INC-CW24",
     "symbol": "DMTKW"
    },
    {
     "description": "3-D MATRIX LTD",
     "symbol": "DMTRF"
    },
    {
     "description": "SMALL PHARMA INC",
     "symbol": "DMTTF"
    },
    {
     "description": "ISHARES ESG ADVANC MSCI EAFE",
     "symbol": "DMXF"
    },
    {
     "description": "DMY TECHNOLOGY GROUP INC VI",
     "symbol": "DMYS"
    },
    {
     "description": "DMY TECHNOLOGY GROUP INC VI",
     "symbol": "DMYS.U"
    },
    {
     "description": "DMY TECHNOLOGY GROUP -CW23",
     "symbol": "DMYS.WS"
    },
    {
     "description": "DOMINO'S PIZZA E-UNSPON ADR",
     "symbol": "DMZPY"
    },
    {
     "description": "GINKGO BIOWORKS HOLDINGS INC",
     "symbol": "DNA"
    },
    {
     "description": "GINKGO BIOWORKS      -CW27",
     "symbol": "DNA.WS"
    },
    {
     "description": "SOCIAL CAPITAL SUVRETTA HO-A",
     "symbol": "DNAA"
    },
    {
     "description": "SOCIAL CAPITAL SUVRETTA HO-A",
     "symbol": "DNAB"
    },
    {
     "description": "SOCIAL CAPITAL SUVRETTA HO-A",
     "symbol": "DNAC"
    },
    {
     "description": "DENA CO LTD",
     "symbol": "DNACF"
    },
    {
     "description": "SOCIAL CAPITAL SUVRETTA HO-A",
     "symbol": "DNAD"
    },
    {
     "description": "DNAPRINT GENOMICS",
     "symbol": "DNAG"
    },
    {
     "description": "DNA MEDICAL TECHNOLOGIES INC",
     "symbol": "DNAT"
    },
    {
     "description": "DNA BRANDS INC",
     "symbol": "DNAX"
    },
    {
     "description": "CODEX DNA INC",
     "symbol": "DNAY"
    },
    {
     "description": "DUN & BRADSTREET HOLDINGS IN",
     "symbol": "DNB"
    },
    {
     "description": "DNB BANK ASA",
     "symbol": "DNBBF"
    },
    {
     "description": "DNB BANK ASA - SPN ADR",
     "symbol": "DNBBY"
    },
    {
     "description": "DEFIANCE SILVER CORP",
     "symbol": "DNCVF"
    },
    {
     "description": "DUNDEE SUSTAINABLE TECHNOLOG",
     "symbol": "DNDDF"
    },
    {
     "description": "Dundee Corporation",
     "symbol": "DNDEF"
    },
    {
     "description": "Dundee Corporation",
     "symbol": "DNDPF"
    },
    {
     "description": "DND TECHNOLOGIES INC",
     "symbol": "DNDT"
    },
    {
     "description": "DUNELM GROUP PLC",
     "symbol": "DNEMF"
    },
    {
     "description": "DONGFENG MOTOR GRP CO LTD-H",
     "symbol": "DNFGF"
    },
    {
     "description": "DONGFENG MOTOR GRP-H-UNS ADR",
     "symbol": "DNFGY"
    },
    {
     "description": "DYNACOR GOLD MINES INC",
     "symbol": "DNGDF"
    },
    {
     "description": "DONGFANG ELECTRIC CORP LTD-H",
     "symbol": "DNGFF"
    },
    {
     "description": "DONGYUE GROUP",
     "symbol": "DNGYF"
    },
    {
     "description": "DANIELI & CO-RSP",
     "symbol": "DNIEF"
    },
    {
     "description": "DIVIDEND AND INCOME FUND",
     "symbol": "DNIF"
    },
    {
     "description": "DANIELI & CO-UNSPONSORED ADR",
     "symbol": "DNIYY"
    },
    {
     "description": "DANSKE BANK A\/S - SPON ADR",
     "symbol": "DNKEY"
    },
    {
     "description": "DKK CO LTD",
     "symbol": "DNKGF"
    },
    {
     "description": "DANAKALI LTD - ADR",
     "symbol": "DNKLY"
    },
    {
     "description": "WISDOMTREE GLOBAL EX-US QUAL",
     "symbol": "DNL"
    },
    {
     "description": "DENALI THERAPEUTICS INC",
     "symbol": "DNLI"
    },
    {
     "description": "DUNELM GROUP PLC-UNSP ADR",
     "symbol": "DNLMY"
    },
    {
     "description": "DANIMER SCIENTIFIC INC",
     "symbol": "DNMR"
    },
    {
     "description": "DENISON MINES CORP",
     "symbol": "DNN"
    },
    {
     "description": "ORSTED A\/S-UNSP ADR",
     "symbol": "DNNGY"
    },
    {
     "description": "DINO POLSKA SA",
     "symbol": "DNOPF"
    },
    {
     "description": "DINO POLSKA SA UNSP- ADR",
     "symbol": "DNOPY"
    },
    {
     "description": "FT CBOE VEST US EQUITY DEEP",
     "symbol": "DNOV"
    },
    {
     "description": "NOW INC",
     "symbol": "DNOW"
    },
    {
     "description": "DNP SELECT INCOME FUND INC",
     "symbol": "DNP"
    },
    {
     "description": "DAI NIPPON PRINTING CO LTD",
     "symbol": "DNPCF"
    },
    {
     "description": "DAI NIPPON PRINT-SPON ADR",
     "symbol": "DNPLY"
    },
    {
     "description": "SUMITOMO PHARMA CO LTD",
     "symbol": "DNPUF"
    },
    {
     "description": "DENBURY-CW23",
     "symbol": "DNRRW"
    },
    {
     "description": "DENARIUS METALS CORP",
     "symbol": "DNRSF"
    },
    {
     "description": "DENBURY-CW25",
     "symbol": "DNRWW"
    },
    {
     "description": "DINE S.A.B. DE C.V.",
     "symbol": "DNSBF"
    },
    {
     "description": "DANSKE BANK A\/S",
     "symbol": "DNSKF"
    },
    {
     "description": "DENTSU GROUP INC",
     "symbol": "DNTUF"
    },
    {
     "description": "DENTSU GROUP INC - UNSPD ADR",
     "symbol": "DNTUY"
    },
    {
     "description": "KRISPY KREME INC",
     "symbol": "DNUT"
    },
    {
     "description": "DENVER BANKSHARES INC",
     "symbol": "DNVB"
    },
    {
     "description": "DEINOVE",
     "symbol": "DNVVF"
    },
    {
     "description": "D AND Z MEDIA ACQUISITION-A",
     "symbol": "DNZ"
    },
    {
     "description": "D AND Z MEDIA ACQUISITION CO",
     "symbol": "DNZ.U"
    },
    {
     "description": "D AND Z MEDIA ACQ CL A -CW27",
     "symbol": "DNZ.WS"
    },
    {
     "description": "DENSO CORP",
     "symbol": "DNZOF"
    },
    {
     "description": "DENSO CORPORATION-UNSPON ADR",
     "symbol": "DNZOY"
    },
    {
     "description": "DIAMOND OFFSHORE DRILLING IN",
     "symbol": "DO"
    },
    {
     "description": "PHYSICIANS REALTY TRUST",
     "symbol": "DOC"
    },
    {
     "description": "BEYOND MEDICAL TECHNOLOGIES",
     "symbol": "DOCKF"
    },
    {
     "description": "DR. MARTENS PLC",
     "symbol": "DOCMF"
    },
    {
     "description": "DIGITALOCEAN HOLDINGS INC",
     "symbol": "DOCN"
    },
    {
     "description": "CLOUDMD SOFTWARE & SERVICES",
     "symbol": "DOCRF"
    },
    {
     "description": "DOXIMITY INC-CLASS A",
     "symbol": "DOCS"
    },
    {
     "description": "FT CBOE VEST US DEEP BUF OCT",
     "symbol": "DOCT"
    },
    {
     "description": "DOCUSIGN INC",
     "symbol": "DOCU"
    },
    {
     "description": "DIAMOND OFFSHORE DRILL -CW26",
     "symbol": "DODRW"
    },
    {
     "description": "ELEMENTS-DOGS OF DOW",
     "symbol": "DODXF"
    },
    {
     "description": "DOR ALON ENERGY IN ISRAEL",
     "symbol": "DOEGF"
    },
    {
     "description": "PROSHARES SHORT DOW30",
     "symbol": "DOG"
    },
    {
     "description": "ORSTED A\/S",
     "symbol": "DOGEF"
    },
    {
     "description": "DOGNESS INTERNATIONAL CORP-A",
     "symbol": "DOGZ"
    },
    {
     "description": "WISDOMTREE INTL L\/C DVD FUND",
     "symbol": "DOL"
    },
    {
     "description": "DOLE PLC",
     "symbol": "DOLE"
    },
    {
     "description": "DOLPHIN CAPITAL INVESTORS",
     "symbol": "DOLHF"
    },
    {
     "description": "DOLLY VARDEN SILVER LTD",
     "symbol": "DOLLF"
    },
    {
     "description": "DOMA HOLDINGS INC",
     "symbol": "DOMA"
    },
    {
     "description": "DOMA HOLDINGS IN     -CW27",
     "symbol": "DOMA.WS"
    },
    {
     "description": "DOMO INC - CLASS B",
     "symbol": "DOMO"
    },
    {
     "description": "DOMINION RES BLACK WARRIOR",
     "symbol": "DOMR"
    },
    {
     "description": "DOMINION WATER RESERVES CORP",
     "symbol": "DOMWF"
    },
    {
     "description": "WISDOMTREE US MIDCAP DIVIDEN",
     "symbol": "DON"
    },
    {
     "description": "SPHINX RESOURCES LTD",
     "symbol": "DONFF"
    },
    {
     "description": "BRP INC\/CA- SUB VOTING",
     "symbol": "DOOO"
    },
    {
     "description": "MASONITE INTERNATIONAL CORP",
     "symbol": "DOOR"
    },
    {
     "description": "DOOSAN FUEL CELL CO LTD",
     "symbol": "DOOSF"
    },
    {
     "description": "DORMAN PRODUCTS INC",
     "symbol": "DORM"
    },
    {
     "description": "DORO AB",
     "symbol": "DOROF"
    },
    {
     "description": "DOTDIGITAL GROUP PLC",
     "symbol": "DOTDF"
    },
    {
     "description": "DOUGLAS ELLIMAN INC",
     "symbol": "DOUG"
    },
    {
     "description": "DOUUGH LTD",
     "symbol": "DOUUF"
    },
    {
     "description": "DOVER CORP",
     "symbol": "DOV"
    },
    {
     "description": "DOVALUE SPA",
     "symbol": "DOVXF"
    },
    {
     "description": "DOW INC",
     "symbol": "DOW"
    },
    {
     "description": "ALTITUDE GROUP PLC",
     "symbol": "DOWLF"
    },
    {
     "description": "AMDOCS LTD",
     "symbol": "DOX"
    },
    {
     "description": "DOUYU INTERNATIONAL HOLD-ADR",
     "symbol": "DOYU"
    },
    {
     "description": "DIREX DAILY US INFRA BULL 2X",
     "symbol": "DOZR"
    },
    {
     "description": "DENTAL PATIENT CARE AMERICA",
     "symbol": "DPAT"
    },
    {
     "description": "DEEP BLUE MARINE INC",
     "symbol": "DPBE"
    },
    {
     "description": "D\/S NORDEN",
     "symbol": "DPBSF"
    },
    {
     "description": "DP CAP ACQUISITION CORP-CL A",
     "symbol": "DPCS"
    },
    {
     "description": "DP CAP ACQUISITION CORP I",
     "symbol": "DPCSU"
    },
    {
     "description": "DP CAP ACQUISITION A -CW23",
     "symbol": "DPCSW"
    },
    {
     "description": "DEEP DOWN INC",
     "symbol": "DPDW"
    },
    {
     "description": "DEEP EARTH RESOURCES INC",
     "symbol": "DPER"
    },
    {
     "description": "DEEP FIELD TECHNOLOGIES-CL A",
     "symbol": "DPFD"
    },
    {
     "description": "DUFF & PHELPS UTILITY & INC",
     "symbol": "DPG"
    },
    {
     "description": "DECHRA PHARMACEUTICALS -ADR",
     "symbol": "DPHAY"
    },
    {
     "description": "Direxion Daily Developed Markets Bear 3X Shares",
     "symbol": "DPK"
    },
    {
     "description": "DARKPULSE INC",
     "symbol": "DPLS"
    },
    {
     "description": "Desert Peak Minerals Inc",
     "symbol": "DPM"
    },
    {
     "description": "DUNDEE PRECIOUS METALS INC",
     "symbol": "DPMLF"
    },
    {
     "description": "DAPHNE INTERNATIONAL HOLDING",
     "symbol": "DPNEF"
    },
    {
     "description": "DAPHNE INTER-UNSPON ADR",
     "symbol": "DPNEY"
    },
    {
     "description": "DRAGANFLY INC",
     "symbol": "DPRO"
    },
    {
     "description": "DEUTSCHE POST AG-SPON ADR",
     "symbol": "DPSGY"
    },
    {
     "description": "DECISIONPOINT SYSTEMS INC\/CA",
     "symbol": "DPSI"
    },
    {
     "description": "DecisionPoint Systems Inc",
     "symbol": "DPSIP"
    },
    {
     "description": "3D PIONEER SYSTEMS INC",
     "symbol": "DPSM"
    },
    {
     "description": "DRX DLY REG BANK BULL 3X",
     "symbol": "DPST"
    },
    {
     "description": "DEUTSCHE POST AG-REG",
     "symbol": "DPSTF"
    },
    {
     "description": "DISCOUNT PRINT USA",
     "symbol": "DPUI"
    },
    {
     "description": "DOMINOS PIZZA UK & IRL-ADR",
     "symbol": "DPUKY"
    },
    {
     "description": "DIEGO PELLICER WORLDWIDE INC",
     "symbol": "DPWW"
    },
    {
     "description": "DELPHX CAPITAL MARKETS INC",
     "symbol": "DPXCF"
    },
    {
     "description": "DOMINO'S PIZZA INC",
     "symbol": "DPZ"
    },
    {
     "description": "DOMINO'S PIZZA ENTERPRISES L",
     "symbol": "DPZUF"
    },
    {
     "description": "DAQO NEW ENERGY CORP-ADR",
     "symbol": "DQ"
    },
    {
     "description": "PAN PACIFIC INTERNATIONAL HO",
     "symbol": "DQJCF"
    },
    {
     "description": "PAN PACIFIC INTERN-UNSP ADR",
     "symbol": "DQJCY"
    },
    {
     "description": "DSWISS INC",
     "symbol": "DQWS"
    },
    {
     "description": "MACONDRAY CAPITAL AC-CLASS A",
     "symbol": "DRAY"
    },
    {
     "description": "MACONDRAY CAPITAL ACQUISITIO",
     "symbol": "DRAYU"
    },
    {
     "description": "MACONDRAY CAPITAL AC A -CW23",
     "symbol": "DRAYW"
    },
    {
     "description": "ROTSHTEIN REALESTATE LTD",
     "symbol": "DRCAF"
    },
    {
     "description": "DORE COPPER MINING CORP",
     "symbol": "DRCMF"
    },
    {
     "description": "DEAR CASHMERE HOLDING CO",
     "symbol": "DRCR"
    },
    {
     "description": "DIRECT DIGITAL HOLDINGS IN-A",
     "symbol": "DRCT"
    },
    {
     "description": "DIRECT DIGITAL HOLDINGS-CW26",
     "symbol": "DRCTW"
    },
    {
     "description": "DRDGOLD LTD-SPONSORED ADR",
     "symbol": "DRD"
    },
    {
     "description": "DRDGOLD LTD",
     "symbol": "DRDGF"
    },
    {
     "description": "DREADNOUGHT RESOURCES LTD",
     "symbol": "DRDNF"
    },
    {
     "description": "DUKE REALTY CORP",
     "symbol": "DRE"
    },
    {
     "description": "DREAM HOMES & DEVELOPMENT CO",
     "symbol": "DREM"
    },
    {
     "description": "DREAM OFFICE REAL ESTATE INV",
     "symbol": "DRETF"
    },
    {
     "description": "DREAM INDUSTRIAL REAL ESTATE",
     "symbol": "DREUF"
    },
    {
     "description": "DR. FOODS INC",
     "symbol": "DRFS"
    },
    {
     "description": "DRAGON CAPITAL GROUP CORP",
     "symbol": "DRGV"
    },
    {
     "description": "DIAMONDROCK HOSPITALITY CO",
     "symbol": "DRH"
    },
    {
     "description": "DIAMONDROCK HOSPITALITY",
     "symbol": "DRH.PRA"
    },
    {
     "description": "DR HOENLE AG",
     "symbol": "DRHNF"
    },
    {
     "description": "DARDEN RESTAURANTS INC",
     "symbol": "DRI"
    },
    {
     "description": "XIANA MINING INC",
     "symbol": "DRIFF"
    },
    {
     "description": "DARIOHEALTH CORP",
     "symbol": "DRIO"
    },
    {
     "description": "DIREXION DAILY S&P OIL & GAS",
     "symbol": "DRIP"
    },
    {
     "description": "GLOBAL X AUTONOMOUS&ELEC-ETF",
     "symbol": "DRIV"
    },
    {
     "description": "MARTELLO TECHNOLOGIES GROUP",
     "symbol": "DRKOF"
    },
    {
     "description": "DARKTRACE PLC",
     "symbol": "DRKTF"
    },
    {
     "description": "DARKTRACE PLC - UNSP ADR",
     "symbol": "DRKTY"
    },
    {
     "description": "DERMATA THERAPEUTICS INC",
     "symbol": "DRMA"
    },
    {
     "description": "DERMATA THERAPEUTICS -CW26",
     "symbol": "DRMAW"
    },
    {
     "description": "DORMAKABA HOLDING AG-ADR",
     "symbol": "DRMKY"
    },
    {
     "description": "DREAM INTERNATIONAL LTD",
     "symbol": "DRMMF"
    },
    {
     "description": "DR. MARTENS PLC-UNSP ADR",
     "symbol": "DRMTY"
    },
    {
     "description": "DIREXION DAILY REAL ESTATE B",
     "symbol": "DRN"
    },
    {
     "description": "DRONE GUARDER INC",
     "symbol": "DRNG"
    },
    {
     "description": "NOHO INC",
     "symbol": "DRNK"
    },
    {
     "description": "DELIVEROO PLC",
     "symbol": "DROOF"
    },
    {
     "description": "FUSE SCIENCE INC",
     "symbol": "DROP"
    },
    {
     "description": "DRIL-QUIP INC",
     "symbol": "DRQ"
    },
    {
     "description": "DORMAKABA HOLDING AG",
     "symbol": "DRRKF"
    },
    {
     "description": "ARIANNE PHOSPHATE INC",
     "symbol": "DRRSF"
    },
    {
     "description": "DURECT CORPORATION",
     "symbol": "DRRX"
    },
    {
     "description": "DRONESHIELD LTD",
     "symbol": "DRSHF"
    },
    {
     "description": "APTUS DEFINED RISK ETF",
     "symbol": "DRSK"
    },
    {
     "description": "DESERT CONTROL AS",
     "symbol": "DRTFF"
    },
    {
     "description": "JET2 PLC",
     "symbol": "DRTGF"
    },
    {
     "description": "DART MINING NL",
     "symbol": "DRTMF"
    },
    {
     "description": "ALPHA TAU MEDICAL LTD",
     "symbol": "DRTS"
    },
    {
     "description": "ALPHA TAU MEDICAL LTD -27",
     "symbol": "DRTSW"
    },
    {
     "description": "DIRTT ENVIRONMENTAL SOLUTION",
     "symbol": "DRTT"
    },
    {
     "description": "BRIGHT MINDS BIOSCIENCES INC",
     "symbol": "DRUG"
    },
    {
     "description": "DREAM UNLIMITED-CL A SUB VOT",
     "symbol": "DRUNF"
    },
    {
     "description": "DIREXION DAILY REAL ESTATE B",
     "symbol": "DRV"
    },
    {
     "description": "DRIVEN BRANDS HOLDINGS INC",
     "symbol": "DRVN"
    },
    {
     "description": "DISCOVERY ALASKA LTD",
     "symbol": "DRVYF"
    },
    {
     "description": "DRAEGERWERK AG - PREF",
     "symbol": "DRWKF"
    },
    {
     "description": "A CLEAN SLATE INC",
     "symbol": "DRWN"
    },
    {
     "description": "DRAX GROUP PLC",
     "symbol": "DRXGF"
    },
    {
     "description": "DRAX GROUP PLC-UNSPON ADR",
     "symbol": "DRXGY"
    },
    {
     "description": "DRAYTON RICHDALE CORP",
     "symbol": "DRYN"
    },
    {
     "description": "DRIVE SHACK INC",
     "symbol": "DS"
    },
    {
     "description": "DRIVE SHACK INC",
     "symbol": "DS.PRB"
    },
    {
     "description": "DRIVE SHACK INC",
     "symbol": "DS.PRC"
    },
    {
     "description": "DRIVE SHACK INC",
     "symbol": "DS.PRD"
    },
    {
     "description": "DUDDELL STREET ACQUISITION-A",
     "symbol": "DSAC"
    },
    {
     "description": "DUDDELL STREET ACQUISITION C",
     "symbol": "DSACU"
    },
    {
     "description": "DUDDELL STREET ACQUIS -CW25",
     "symbol": "DSACW"
    },
    {
     "description": "DIRECT SELLING ACQUISITION-A",
     "symbol": "DSAQ"
    },
    {
     "description": "DIRECT SELLING ACQUISITION C",
     "symbol": "DSAQ.U"
    },
    {
     "description": "DIRECT SEL -CW28",
     "symbol": "DSAQ.WS"
    },
    {
     "description": "DOGWOOD STATE BANK",
     "symbol": "DSBX"
    },
    {
     "description": "DISCIPLINE FUND ETF",
     "symbol": "DSCF"
    },
    {
     "description": "DISCOVERY MINERALS LTD",
     "symbol": "DSCR"
    },
    {
     "description": "DISCO CORP-UNSPONSORED ADR",
     "symbol": "DSCSY"
    },
    {
     "description": "DISCOVERY-CORP ENTERPRISES",
     "symbol": "DSCVF"
    },
    {
     "description": "DSV A\/S",
     "symbol": "DSDVF"
    },
    {
     "description": "DSV A\/S - UNSP ADR",
     "symbol": "DSDVY"
    },
    {
     "description": "DAIWA SECURITIES GROUP INC",
     "symbol": "DSECF"
    },
    {
     "description": "DAIWA SECURITIES GR-SPON ADR",
     "symbol": "DSEEY"
    },
    {
     "description": "FT CBOE VEST US DEEP BUF SEP",
     "symbol": "DSEP"
    },
    {
     "description": "DIVERSEY HOLDINGS LTD",
     "symbol": "DSEY"
    },
    {
     "description": "DAH SING FINANCIA-UNSPON ADR",
     "symbol": "DSFGY"
    },
    {
     "description": "DESIGN THERAPEUTICS INC",
     "symbol": "DSGN"
    },
    {
     "description": "DSG GLOBAL INC",
     "symbol": "DSGT"
    },
    {
     "description": "DOGAN SIRKETLER GRUBU-UN ADR",
     "symbol": "DSGUY"
    },
    {
     "description": "DESCARTES SYSTEMS GRP\/THE",
     "symbol": "DSGX"
    },
    {
     "description": "DAISHI HOKUETSU FINANCIAL GR",
     "symbol": "DSHHF"
    },
    {
     "description": "DOSHISHA CO LTD",
     "symbol": "DSHIF"
    },
    {
     "description": "ISHARES MSCI KLD 400 SOCIAL",
     "symbol": "DSI"
    },
    {
     "description": "CURRYS PLC",
     "symbol": "DSITF"
    },
    {
     "description": "INNOVATOR DOUBLE STACKER-JAN",
     "symbol": "DSJA"
    },
    {
     "description": "DASEKE INC",
     "symbol": "DSKE"
    },
    {
     "description": "DUSK GROUP LTD",
     "symbol": "DSKGF"
    },
    {
     "description": "DAISEKI CO LTD",
     "symbol": "DSKIF"
    },
    {
     "description": "DAIICHI SANKYO CO LTD",
     "symbol": "DSKYF"
    },
    {
     "description": "DOUBLELINE INCOME SOLUTIONS",
     "symbol": "DSL"
    },
    {
     "description": "VELOCITYSHARES 3X INVERSE SI",
     "symbol": "DSLVF"
    },
    {
     "description": "BNYM STRAT MUNI BND",
     "symbol": "DSM"
    },
    {
     "description": "DEEP-SOUTH RESOURCES INC",
     "symbol": "DSMTF"
    },
    {
     "description": "DESIGN CAPITAL LTD",
     "symbol": "DSNCF"
    },
    {
     "description": "DAIICHI SANKYO CO-SPON ADR",
     "symbol": "DSNKY"
    },
    {
     "description": "DESTINY MEDIA TECHNOLOGIES",
     "symbol": "DSNY"
    },
    {
     "description": "INNOVATOR DOUBLE STACKER OCT",
     "symbol": "DSOC"
    },
    {
     "description": "DRUG FREE SOLUTION INC",
     "symbol": "DSOL"
    },
    {
     "description": "VIANT TECHNOLOGY INC-A",
     "symbol": "DSP"
    },
    {
     "description": "THE DE-SPAC ETF",
     "symbol": "DSPC"
    },
    {
     "description": "AQRU PLC",
     "symbol": "DSPHF"
    },
    {
     "description": "DIASORIN SPA",
     "symbol": "DSRLF"
    },
    {
     "description": "DESCRYPTO HOLDINGS INC",
     "symbol": "DSRO"
    },
    {
     "description": "DSS INC",
     "symbol": "DSS"
    },
    {
     "description": "DEEP SEA SUPPLY PLC",
     "symbol": "DSSPF"
    },
    {
     "description": "DISTINCT INFRASTRUCTURE GROU",
     "symbol": "DSTFF"
    },
    {
     "description": "DISTILLATE US FUNDAMENTAL ST",
     "symbol": "DSTL"
    },
    {
     "description": "DISTIT AB",
     "symbol": "DSTTF"
    },
    {
     "description": "DISTILLATE INTERNATIONAL FUN",
     "symbol": "DSTX"
    },
    {
     "description": "DISTELL GROUP HOLDINGS LTD",
     "symbol": "DSTZF"
    },
    {
     "description": "BLACKROCK DEBT STRATEGIES FD",
     "symbol": "DSU"
    },
    {
     "description": "DRONE SERVICES USA INC",
     "symbol": "DSUS"
    },
    {
     "description": "DISCOVERY SILVER CORP",
     "symbol": "DSVSF"
    },
    {
     "description": "DIVESTCO INC - CL A",
     "symbol": "DSVTF"
    },
    {
     "description": "DESWELL INDUSTRIES INC",
     "symbol": "DSWL"
    },
    {
     "description": "DIANA SHIPPING INC",
     "symbol": "DSX"
    },
    {
     "description": "DIANA SHIPPING INC",
     "symbol": "DSX.PRB"
    },
    {
     "description": "DAISYO CORP",
     "symbol": "DSYOF"
    },
    {
     "description": "DYNATRACE INC",
     "symbol": "DT"
    },
    {
     "description": "DELTA RESOURCES LTD",
     "symbol": "DTARF"
    },
    {
     "description": "DATA#3 LTD",
     "symbol": "DTATF"
    },
    {
     "description": "DTE ENERGY CO",
     "symbol": "DTB"
    },
    {
     "description": "SOLO BRANDS INC - CLASS A",
     "symbol": "DTC"
    },
    {
     "description": "Defence Therapeutics Inc",
     "symbol": "DTCFF"
    },
    {
     "description": "DOMETIC GROUP AB",
     "symbol": "DTCGF"
    },
    {
     "description": "DIRECT COATING INC",
     "symbol": "DTCO"
    },
    {
     "description": "DEUTSCHE WOHNEN SE-UNSP ADR",
     "symbol": "DTCWY"
    },
    {
     "description": "WISDOMTREE US TOTAL DIVIDEND",
     "symbol": "DTD"
    },
    {
     "description": "DELTA DJAKARTA TBK PT",
     "symbol": "DTDJF"
    },
    {
     "description": "DTE ENERGY COMPANY",
     "symbol": "DTE"
    },
    {
     "description": "DAVIDSTEA INC",
     "symbol": "DTEA"
    },
    {
     "description": "ALPS DISRUPTIVE TECHNOLOGIES",
     "symbol": "DTEC"
    },
    {
     "description": "DEUTSCHE TELEKOM AG-REG",
     "symbol": "DTEGF"
    },
    {
     "description": "DEUTSCHE TELEKOM AG-SPON ADR",
     "symbol": "DTEGY"
    },
    {
     "description": "DITEM EXPLORATIONS INC",
     "symbol": "DTEMF"
    },
    {
     "description": "DATA EVOLUTION HOLDINGS INC",
     "symbol": "DTEV"
    },
    {
     "description": "DURATEX SA UNSP - ADR",
     "symbol": "DTEXY"
    },
    {
     "description": "DTF TAX-FREE INCOME 2028 TER",
     "symbol": "DTF"
    },
    {
     "description": "DTE ENERGY CO",
     "symbol": "DTG"
    },
    {
     "description": "DAIMLER TRUCK HOLDING AG",
     "symbol": "DTGHF"
    },
    {
     "description": "DIGERATI TECHNOLOGIES INC",
     "symbol": "DTGI"
    },
    {
     "description": "WISDOMTREE INTERNATIONAL HIG",
     "symbol": "DTH"
    },
    {
     "description": "DTHERA SCIENCES",
     "symbol": "DTHR"
    },
    {
     "description": "DEFENSE TECHNOLOGIES INTERNA",
     "symbol": "DTII"
    },
    {
     "description": "PRECISION BIOSCIENCES INC",
     "symbol": "DTIL"
    },
    {
     "description": "BROOKFIELD DTLA FUND OFF",
     "symbol": "DTLA.PR"
    },
    {
     "description": "D2L INC",
     "symbol": "DTLIF"
    },
    {
     "description": "DT MIDSTREAM INC",
     "symbol": "DTM"
    },
    {
     "description": "DATAMETREX AI LTD",
     "symbol": "DTMXF"
    },
    {
     "description": "DETAI NEW ENERGY GROUP LTD",
     "symbol": "DTNEF"
    },
    {
     "description": "DOUTOR NICHIRES HOLDINGS CO",
     "symbol": "DTNHF"
    },
    {
     "description": "DNO ASA",
     "symbol": "DTNOF"
    },
    {
     "description": "DNO ASA-UNSP ADR",
     "symbol": "DTNOY"
    },
    {
     "description": "DIGITAL TRANSFORMATION OPP-A",
     "symbol": "DTOC"
    },
    {
     "description": "DIGITAL TRANSFORMATION OPPOR",
     "symbol": "DTOCU"
    },
    {
     "description": "DIGITAL TRANSFORMATION -CW28",
     "symbol": "DTOCW"
    },
    {
     "description": "AMPLIFY CLEANER LIVING ETF",
     "symbol": "DTOX"
    },
    {
     "description": "DTE ENERGY CO",
     "symbol": "DTP"
    },
    {
     "description": "DIRECTA PLUS PLC",
     "symbol": "DTPKF"
    },
    {
     "description": "DATELINE RESOURCES LTD",
     "symbol": "DTREF"
    },
    {
     "description": "DATATRAK INTERNATIONAL INC",
     "symbol": "DTRK"
    },
    {
     "description": "DETROIT LEGAL NEWS CO",
     "symbol": "DTRL"
    },
    {
     "description": "DELTRON INC",
     "symbol": "DTRO"
    },
    {
     "description": "DTRT HEALTH ACQ CORP-A",
     "symbol": "DTRT"
    },
    {
     "description": "DTRT HEALTH ACQUISITION CORP",
     "symbol": "DTRTU"
    },
    {
     "description": "DTRT HEALTH ACQUISITIO -CW22",
     "symbol": "DTRTW"
    },
    {
     "description": "DAIMLER TRUCK - SPON ADR",
     "symbol": "DTRUY"
    },
    {
     "description": "DELIVERY TECHNOLOGY SOLUTION",
     "symbol": "DTSL"
    },
    {
     "description": "DTS CORP",
     "symbol": "DTSOF"
    },
    {
     "description": "ETHER CAPITAL CORP",
     "symbol": "DTSRF"
    },
    {
     "description": "DATASEA INC",
     "symbol": "DTSS"
    },
    {
     "description": "DATA STORAGE CORP",
     "symbol": "DTST"
    },
    {
     "description": "DATA STORAGE CORP -CW26",
     "symbol": "DTSTW"
    },
    {
     "description": "DATATEC LTD",
     "symbol": "DTTLF"
    },
    {
     "description": "DATATEC LTD-UNSP ADR",
     "symbol": "DTTLY"
    },
    {
     "description": "DITO CME HOLDINGS CORP",
     "symbol": "DTTOF"
    },
    {
     "description": "DISH TV INDIA LTD-GDR",
     "symbol": "DTTVY"
    },
    {
     "description": "DESTINY PHARMA PLC",
     "symbol": "DTTYF"
    },
    {
     "description": "DTE ENERGY CO",
     "symbol": "DTW"
    },
    {
     "description": "DELTEX MEDICAL GROUP PLC",
     "symbol": "DTXMF"
    },
    {
     "description": "DOTZ NANO LTD",
     "symbol": "DTZZF"
    },
    {
     "description": "DASSAULT AVIATION SA",
     "symbol": "DUAVF"
    },
    {
     "description": "DUBBER CORP LTD",
     "symbol": "DUBRF"
    },
    {
     "description": "MERLYN AI SECTORSURFER MOMEN",
     "symbol": "DUDE"
    },
    {
     "description": "DUERR AG",
     "symbol": "DUERF"
    },
    {
     "description": "DUET ACQUISITION CORP-CL A",
     "symbol": "DUET"
    },
    {
     "description": "DUET ACQUISITION CORP",
     "symbol": "DUETU"
    },
    {
     "description": "DUET ACQUISITION CORP -27",
     "symbol": "DUETW"
    },
    {
     "description": "DUFRY AG - ADR",
     "symbol": "DUFRY"
    },
    {
     "description": "PROSHARES ULTRASHORT OIL&GAS",
     "symbol": "DUG"
    },
    {
     "description": "DIMENSIONAL US HIGH PROFI ET",
     "symbol": "DUHP"
    },
    {
     "description": "DUKE ENERGY CORP",
     "symbol": "DUK"
    },
    {
     "description": "DUKE ENERGY CORP",
     "symbol": "DUK.PRA"
    },
    {
     "description": "DUKE ENERGY CORP",
     "symbol": "DUKB"
    },
    {
     "description": "DUKETON MINING LTD",
     "symbol": "DUKMF"
    },
    {
     "description": "DUNE ACQUISITION CORP-CL A",
     "symbol": "DUNE"
    },
    {
     "description": "DUNE ACQUISITION CORP",
     "symbol": "DUNEU"
    },
    {
     "description": "DUNE ACQ CL A -CW27",
     "symbol": "DUNEW"
    },
    {
     "description": "DUNI AB-UNSPONSORED ADR",
     "symbol": "DUNIY"
    },
    {
     "description": "FANGDD NETWORK GROUP LTD-ADR",
     "symbol": "DUO"
    },
    {
     "description": "DUOLINGO",
     "symbol": "DUOL"
    },
    {
     "description": "DUOS TECHNOLOGIES GROUP INC",
     "symbol": "DUOT"
    },
    {
     "description": "VANECK MSTAR DURABLE DVD ETF",
     "symbol": "DURA"
    },
    {
     "description": "DURO FELGUERA SA",
     "symbol": "DUROF"
    },
    {
     "description": "DUERR AG -UNSP ADR",
     "symbol": "DURYY"
    },
    {
     "description": "DAVIS SELECT US EQUITY ETF",
     "symbol": "DUSA"
    },
    {
     "description": "DEUTSCHE EUROSHOP AG",
     "symbol": "DUSCF"
    },
    {
     "description": "DRX DLY INDUSTRIALS BULL 3X",
     "symbol": "DUSL"
    },
    {
     "description": "DIREXION DAILY GOLD MINERS I",
     "symbol": "DUST"
    },
    {
     "description": "DUSTIN GROUP AB",
     "symbol": "DUSXF"
    },
    {
     "description": "DUESENBERG TECHNOLOGIES INC",
     "symbol": "DUSYF"
    },
    {
     "description": "DIGITAL UTILITIES VENTURES",
     "symbol": "DUTV"
    },
    {
     "description": "DUO WORLD INC",
     "symbol": "DUUO"
    },
    {
     "description": "PERUVIAN METALS CORP",
     "symbol": "DUVNF"
    },
    {
     "description": "DOUBLEVERIFY HOLDINGS INC",
     "symbol": "DV"
    },
    {
     "description": "DAVITA INC",
     "symbol": "DVA"
    },
    {
     "description": "DOVARRI INC",
     "symbol": "DVAR"
    },
    {
     "description": "DYNAVAX TECHNOLOGIES CORP",
     "symbol": "DVAX"
    },
    {
     "description": "DAVIDE CAMPARI - UNSP ADR",
     "symbol": "DVCMY"
    },
    {
     "description": "DAVIDE CAMPARI-MILANO NV",
     "symbol": "DVDCF"
    },
    {
     "description": "DIVIDEND 15 SPLIT CORP II-A",
     "symbol": "DVDDF"
    },
    {
     "description": "DIVIDE DRIVES INC",
     "symbol": "DVDR"
    },
    {
     "description": "ISHARES DIVDAX UCITS ETF DE",
     "symbol": "DVDXF"
    },
    {
     "description": "DIVERSIFIED OIL AND GAS HOLD",
     "symbol": "DVFI"
    },
    {
     "description": "DVL INC",
     "symbol": "DVLN"
    },
    {
     "description": "GOLDEN DEVELOPING SOLUTIONS",
     "symbol": "DVLP"
    },
    {
     "description": "DRONE VOLT SACA",
     "symbol": "DVLTF"
    },
    {
     "description": "FIRST TRUST DRSY WRIGHT MOME",
     "symbol": "DVLU"
    },
    {
     "description": "DEVON ENERGY CORP",
     "symbol": "DVN"
    },
    {
     "description": "DANAVATION TECHNOLOGIES CORP",
     "symbol": "DVNCF"
    },
    {
     "description": "DEVIN ENERGY CORP",
     "symbol": "DVNGF"
    },
    {
     "description": "FRONTIER SERVICES GROUP LTD",
     "symbol": "DVNHF"
    },
    {
     "description": "FIRST TRUST DW MOMTM & LOW",
     "symbol": "DVOL"
    },
    {
     "description": "DISTRIBUSI VOUCHER NUSANTARA",
     "symbol": "DVOUF"
    },
    {
     "description": "DEVERON CORP",
     "symbol": "DVRNF"
    },
    {
     "description": "DLV RESOURCES LTD",
     "symbol": "DVRRF"
    },
    {
     "description": "DIVIDEND 15 SPLIT CORP-A",
     "symbol": "DVSPF"
    },
    {
     "description": "DIVIDEND SELECT 15 CORP",
     "symbol": "DVVDF"
    },
    {
     "description": "ISHARES SELECT DIVIDEND ETF",
     "symbol": "DVY"
    },
    {
     "description": "ISHARES ASIA\/PACIFIC DIVIDEN",
     "symbol": "DVYA"
    },
    {
     "description": "ISHARES EMERGING MARKETS DIV",
     "symbol": "DVYE"
    },
    {
     "description": "DIGITAL WORLD ACQUISITION-A",
     "symbol": "DWAC"
    },
    {
     "description": "DIGITAL WORLD ACQUISITION CO",
     "symbol": "DWACU"
    },
    {
     "description": "DIGITAL WORLD ACQ A -CW28",
     "symbol": "DWACW"
    },
    {
     "description": "DAIWA HOUSE INDUSTRY CO LTD",
     "symbol": "DWAHF"
    },
    {
     "description": "DAIWA HOUSE INDUS-UNSP ADR",
     "symbol": "DWAHY"
    },
    {
     "description": "INVESCO DWA SMALLCAP MOMENT",
     "symbol": "DWAS"
    },
    {
     "description": "ARROW DWA TACTICAL ETF",
     "symbol": "DWAT"
    },
    {
     "description": "ADVISORSHARES D\/W FSM CAP",
     "symbol": "DWAW"
    },
    {
     "description": "ARROW DWA COUNTRY ROTATION E",
     "symbol": "DWCR"
    },
    {
     "description": "JEOTEX INC",
     "symbol": "DWDZF"
    },
    {
     "description": "ADVISORSHARES D\/W ALPH EQ WT",
     "symbol": "DWEQ"
    },
    {
     "description": "DEUTSCHE WOHNEN SE",
     "symbol": "DWHHF"
    },
    {
     "description": "DELWINDS INSURANCE - CLASS A",
     "symbol": "DWIN"
    },
    {
     "description": "DELWINDS INSURANCE ACQUISITI",
     "symbol": "DWIN.U"
    },
    {
     "description": "DELWINDS INSURANC CL A -CW27",
     "symbol": "DWIN.WS"
    },
    {
     "description": "DINEWISE INC",
     "symbol": "DWIS"
    },
    {
     "description": "DAVIS SELECT WORLDWIDE ETF",
     "symbol": "DWLD"
    },
    {
     "description": "WISDOMTREE INTERNATIONAL EQU",
     "symbol": "DWM"
    },
    {
     "description": "ADVISORSHARES DORSEY MC ETF",
     "symbol": "DWMC"
    },
    {
     "description": "WISDOMTREE INTERNATIONAL MUL",
     "symbol": "DWMF"
    },
    {
     "description": "DOWA HOLDINGS CO LTD",
     "symbol": "DWMNF"
    },
    {
     "description": "DELHI BANK CORP",
     "symbol": "DWNX"
    },
    {
     "description": "DEEP WELL OIL & GAS INC",
     "symbol": "DWOG"
    },
    {
     "description": "FIRST TRUST DORSEY WRIGHT PE",
     "symbol": "DWPP"
    },
    {
     "description": "Draegerwerk AG and Company KGAA",
     "symbol": "DWRKF"
    },
    {
     "description": "ADVISORSHARES DORSEY WS ETF",
     "symbol": "DWSH"
    },
    {
     "description": "DAWSON GEOPHYSICAL CO",
     "symbol": "DWSN"
    },
    {
     "description": "ADVISORSHARES D\/W FSM CORE",
     "symbol": "DWUS"
    },
    {
     "description": "DERWENT LONDON PLC",
     "symbol": "DWVYF"
    },
    {
     "description": "DIAMOND ESTATES WINES & SPIR",
     "symbol": "DWWEF"
    },
    {
     "description": "SPDR S&P INTER DVD ETF",
     "symbol": "DWX"
    },
    {
     "description": "DYNEX CAPITAL INC",
     "symbol": "DX"
    },
    {
     "description": "DYNEX CAPITAL INC",
     "symbol": "DX.PRC"
    },
    {
     "description": "DEXIA SA-UNSPON ADR",
     "symbol": "DXBGY"
    },
    {
     "description": "BELLROCK BRANDS INC",
     "symbol": "DXBRF"
    },
    {
     "description": "DXC TECHNOLOGY CO",
     "symbol": "DXC"
    },
    {
     "description": "DEXCOM INC",
     "symbol": "DXCM"
    },
    {
     "description": "PROSHARES ULTRASHORT DOW30",
     "symbol": "DXD"
    },
    {
     "description": "DUNXIN FINANCIAL HOLDING-ADR",
     "symbol": "DXF"
    },
    {
     "description": "WISDOMTREE GERMANY HEDGED EQ",
     "symbol": "DXGE"
    },
    {
     "description": "DXI CAPITAL CORP",
     "symbol": "DXIEF"
    },
    {
     "description": "WISDOMTREE JAPAN HEDGED EQ",
     "symbol": "DXJ"
    },
    {
     "description": "WISDOMTREE JAPAN USD HEDGED",
     "symbol": "DXJJF"
    },
    {
     "description": "WISDOMTREE JAPAN HEDGED SMAL",
     "symbol": "DXJS"
    },
    {
     "description": "DESTINATION XL GROUP INC",
     "symbol": "DXLG"
    },
    {
     "description": "X MSCI EUROPE 1C",
     "symbol": "DXMEF"
    },
    {
     "description": "DXP ENTERPRISES INC",
     "symbol": "DXPE"
    },
    {
     "description": "DAXOR CORP",
     "symbol": "DXR"
    },
    {
     "description": "DIXIE GROUP INC",
     "symbol": "DXYN"
    },
    {
     "description": "DYCOM INDUSTRIES INC",
     "symbol": "DY"
    },
    {
     "description": "DYADIC INTERNATIONAL INC",
     "symbol": "DYAI"
    },
    {
     "description": "ANGEL OAK DYN FIN STRAT INC",
     "symbol": "DYFN"
    },
    {
     "description": "DYNACERT INC",
     "symbol": "DYFSF"
    },
    {
     "description": "LEADERSHARES DYNAMIC YIELD E",
     "symbol": "DYLD"
    },
    {
     "description": "DEEP YELLOW LTD",
     "symbol": "DYLLF"
    },
    {
     "description": "DIAMYD MEDICAL AB",
     "symbol": "DYMDF"
    },
    {
     "description": "DYNE THERAPEUTICS INC",
     "symbol": "DYN"
    },
    {
     "description": "DYNASTAR HOLDINGS INC",
     "symbol": "DYNA"
    },
    {
     "description": "DYE & DURHAM LTD",
     "symbol": "DYNDF"
    },
    {
     "description": "DYNTEK INC",
     "symbol": "DYNE"
    },
    {
     "description": "BLACKROCK US EQY FCTR ROTATE",
     "symbol": "DYNF"
    },
    {
     "description": "DYNARESOURCE INC",
     "symbol": "DYNR"
    },
    {
     "description": "DYNAMICS SPECIAL PURPOSE C-A",
     "symbol": "DYNS"
    },
    {
     "description": "DYNATRONICS CORP",
     "symbol": "DYNT"
    },
    {
     "description": "DUNES EXPLORATION LTD",
     "symbol": "DYRFF"
    },
    {
     "description": "DYNASIL CORP OF AMERICA",
     "symbol": "DYSL"
    },
    {
     "description": "DIASYS CORP",
     "symbol": "DYXC"
    },
    {
     "description": "DB COMMODITY DOUBLE LONG",
     "symbol": "DYYXF"
    },
    {
     "description": "JJY HOLDING GROUP",
     "symbol": "DZGH"
    },
    {
     "description": "DZS INC",
     "symbol": "DZSI"
    },
    {
     "description": "DB GOLD DOUBLE SHORT ETN",
     "symbol": "DZZ"
    },
    {
     "description": "ENI SPA-SPONSORED ADR",
     "symbol": "E"
    },
    {
     "description": "ELECTRONIC ARTS INC",
     "symbol": "EA"
    },
    {
     "description": "EARTHWORKS INDUSTRIES INC",
     "symbol": "EAATF"
    },
    {
     "description": "EDIFY ACQUISITION CORP-CL A",
     "symbol": "EAC"
    },
    {
     "description": "EAUTOCLAIMS INC",
     "symbol": "EACC"
    },
    {
     "description": "EACO CORP",
     "symbol": "EACO"
    },
    {
     "description": "EDIFY ACQUISITION CORP",
     "symbol": "EACPU"
    },
    {
     "description": "EDIFY ACQ CL A -CW27",
     "symbol": "EACPW"
    },
    {
     "description": "EARTH ALIVE CLEAN TECHNOLOGI",
     "symbol": "EACTF"
    },
    {
     "description": "ALLSPRING INCOME OPPORTUNITI",
     "symbol": "EAD"
    },
    {
     "description": "AIRBUS SE",
     "symbol": "EADSF"
    },
    {
     "description": "AIRBUS SE - UNSP ADR",
     "symbol": "EADSY"
    },
    {
     "description": "GRAFTECH INTERNATIONAL LTD",
     "symbol": "EAF"
    },
    {
     "description": "SIMPLIFY DEV EX-US PL DN CTY",
     "symbol": "EAFD"
    },
    {
     "description": "ISHARES ESG AWARE US AGGREGA",
     "symbol": "EAGG"
    },
    {
     "description": "LEAF MOBILE INC",
     "symbol": "EAGRF"
    },
    {
     "description": "ECO ANIMAL HEALTH GROUP PLC",
     "symbol": "EAHGF"
    },
    {
     "description": "ENTERGY ARKANSAS LLC",
     "symbol": "EAI"
    },
    {
     "description": "ISHARES ESG AWARE AGGR ALLOC",
     "symbol": "EAOA"
    },
    {
     "description": "ISHARES ESG AWARE CONS ALLOC",
     "symbol": "EAOK"
    },
    {
     "description": "ISHARES ESG AWARE MOD ALLOC",
     "symbol": "EAOM"
    },
    {
     "description": "ISHARES ESG AWARE GROW ALLOC",
     "symbol": "EAOR"
    },
    {
     "description": "ENERGY ABSOLUTE PCL-NVDR",
     "symbol": "EAPBF"
    },
    {
     "description": "EASTON PHARMACEUTICALS INC",
     "symbol": "EAPH"
    },
    {
     "description": "INNOVATOR EMERGING MARKETS P",
     "symbol": "EAPR"
    },
    {
     "description": "EARGO INC",
     "symbol": "EAR"
    },
    {
     "description": "ENTERTAINMENT ARTS RESEARCH",
     "symbol": "EARI"
    },
    {
     "description": "ELLINGTON RESIDENTIAL MORTGA",
     "symbol": "EARN"
    },
    {
     "description": "XTRACKERS MSCI EAFE ESG LDRS",
     "symbol": "EASG"
    },
    {
     "description": "EASTSIDE DISTILLING INC",
     "symbol": "EAST"
    },
    {
     "description": "BRINKER INTERNATIONAL INC",
     "symbol": "EAT"
    },
    {
     "description": "EAT & BEYOND GLOBAL HOLDINGS",
     "symbol": "EATBF"
    },
    {
     "description": "EVOLVE AUTOMOBILE INNOVATION",
     "symbol": "EATOF"
    },
    {
     "description": "EASTERN ASTERIA INC",
     "symbol": "EATR"
    },
    {
     "description": "VEGTECH PLANT BASED INNOVATI",
     "symbol": "EATV"
    },
    {
     "description": "ADVISORSHARES RESTAURANT ETF",
     "symbol": "EATZ"
    },
    {
     "description": "EAU TECHNOLOGIES INC",
     "symbol": "EAUI"
    },
    {
     "description": "ETFS PHYSICAL GOLD",
     "symbol": "EAUSF"
    },
    {
     "description": "ENERGY AND WATER DEV  CORP",
     "symbol": "EAWD"
    },
    {
     "description": "EALIXIR INC",
     "symbol": "EAXR"
    },
    {
     "description": "EVENTBRITE INC-CLASS A",
     "symbol": "EB"
    },
    {
     "description": "EUROPEAN BIOTECH ACQUISITI-A",
     "symbol": "EBAC"
    },
    {
     "description": "EUROPEAN BIOTECH ACQUISITION",
     "symbol": "EBACU"
    },
    {
     "description": "EUROPEAN BIOTECH-CW26",
     "symbol": "EBACW"
    },
    {
     "description": "EBAY INC",
     "symbol": "EBAY"
    },
    {
     "description": "Enbridge Inc",
     "symbol": "EBBGF"
    },
    {
     "description": "Enbridge Inc",
     "symbol": "EBBNF"
    },
    {
     "description": "EASTERN BANKSHARES INC",
     "symbol": "EBC"
    },
    {
     "description": "WT SILVER",
     "symbol": "EBCDF"
    },
    {
     "description": "EBARA CORP",
     "symbol": "EBCOF"
    },
    {
     "description": "EBARA CORP-UNSPONSORED ADR",
     "symbol": "EBCOY"
    },
    {
     "description": "ESPORTS TECHNOLOGIES INC",
     "symbol": "EBET"
    },
    {
     "description": "ENNIS INC",
     "symbol": "EBF"
    },
    {
     "description": "Enbridge Inc Re Pref Shs Ser 5 Canada",
     "symbol": "EBGEF"
    },
    {
     "description": "EBIX INC",
     "symbol": "EBIX"
    },
    {
     "description": "GLOBAL X E-COMMERCE ETF",
     "symbol": "EBIZ"
    },
    {
     "description": "ERSTE GROUP BANK AG-SPON ADR",
     "symbol": "EBKDY"
    },
    {
     "description": "ERSTE GROUP BANK AG",
     "symbol": "EBKOF"
    },
    {
     "description": "ECOFIN GLOBAL WATER ESG FUND",
     "symbol": "EBLU"
    },
    {
     "description": "EBULLION INC",
     "symbol": "EBML"
    },
    {
     "description": "EAGLE BANCORP MONTANA INC",
     "symbol": "EBMT"
    },
    {
     "description": "SPDR BLOOMBERG EM BOND",
     "symbol": "EBND"
    },
    {
     "description": "NEW ENERGY EXCHANGE LTD",
     "symbol": "EBODF"
    },
    {
     "description": "EBANG INTERNATIONAL HLDGS-A",
     "symbol": "EBON"
    },
    {
     "description": "EBOS GROUP LTD",
     "symbol": "EBOSF"
    },
    {
     "description": "EBOS GROUP LTD-SPN ADR",
     "symbol": "EBOSY"
    },
    {
     "description": "Enbridge Inc",
     "symbol": "EBPPF"
    },
    {
     "description": "WT BROAD COMMODITIES",
     "symbol": "EBQZF"
    },
    {
     "description": "CENTRAIS ELETRICAS BR-SP ADR",
     "symbol": "EBR"
    },
    {
     "description": "CENTRAIS ELEC BRAS-ADR PREF",
     "symbol": "EBR.B"
    },
    {
     "description": "Enbridge Inc",
     "symbol": "EBRGF"
    },
    {
     "description": "EBRO FOODS SA",
     "symbol": "EBRPF"
    },
    {
     "description": "EBRO FOODS SA -UNSP ADR",
     "symbol": "EBRPY"
    },
    {
     "description": "Enbridge Inc",
     "symbol": "EBRZF"
    },
    {
     "description": "EMERGENT BIOSOLUTIONS INC",
     "symbol": "EBS"
    },
    {
     "description": "EMPIRE BANCSHARES INC",
     "symbol": "EBSH"
    },
    {
     "description": "ENTERPRISE BANCORP INC",
     "symbol": "EBTC"
    },
    {
     "description": "ENIGMA-BULWARK LTD",
     "symbol": "EBWK"
    },
    {
     "description": "E-BUY HOME INC",
     "symbol": "EBYH"
    },
    {
     "description": "ECOPETROL SA-SPONSORED ADR",
     "symbol": "EC"
    },
    {
     "description": "ECO ATLANTIC OIL & GAS LTD",
     "symbol": "ECAOF"
    },
    {
     "description": "BLACKROCK ESG CAPITAL ALLOC",
     "symbol": "ECAT"
    },
    {
     "description": "EAGLE POINT CREDIT CO INC",
     "symbol": "ECC"
    },
    {
     "description": "EAGLE POINT CREDIT CO",
     "symbol": "ECC.PRD"
    },
    {
     "description": "EAGLE POINT CREDIT CO",
     "symbol": "ECCC"
    },
    {
     "description": "EAGLE FORD OIL & GAS CORP",
     "symbol": "ECCE"
    },
    {
     "description": "ECOLOCLEAN INDUSTRIES INC",
     "symbol": "ECCI"
    },
    {
     "description": "EAGLE POINT CREDIT CO",
     "symbol": "ECCV"
    },
    {
     "description": "EAGLE POINT CREDIT CO",
     "symbol": "ECCW"
    },
    {
     "description": "EAGLE POINT CREDIT CO",
     "symbol": "ECCX"
    },
    {
     "description": "ECRID INC",
     "symbol": "ECDD"
    },
    {
     "description": "ECO DEPOT INC",
     "symbol": "ECDP"
    },
    {
     "description": "EUROCELL PLC",
     "symbol": "ECELF"
    },
    {
     "description": "ECOSCIENCES INC",
     "symbol": "ECEZ"
    },
    {
     "description": "ELLSWORTH GROWTH AND INCOME",
     "symbol": "ECF"
    },
    {
     "description": "ELLSWORTH GRWTH & INC",
     "symbol": "ECF.PRA"
    },
    {
     "description": "ECOGRAF LTD",
     "symbol": "ECGFF"
    },
    {
     "description": "ECGI HOLDINGS INC",
     "symbol": "ECGI"
    },
    {
     "description": "ENVIT CAPITAL GROUP INC",
     "symbol": "ECGP"
    },
    {
     "description": "BELLATORA INC",
     "symbol": "ECGR"
    },
    {
     "description": "ECO-GROWTH STRATEGIES INC",
     "symbol": "ECGS"
    },
    {
     "description": "ISHARES MSCI CHILE ETF",
     "symbol": "ECH"
    },
    {
     "description": "STAR ENT GROUP LTD-UNSP ADR",
     "symbol": "ECHEY"
    },
    {
     "description": "ENCISION INC",
     "symbol": "ECIA"
    },
    {
     "description": "EDF",
     "symbol": "ECIFF"
    },
    {
     "description": "EDF-UNSPON ADR",
     "symbol": "ECIFY"
    },
    {
     "description": "ESG CORE INVESTMENTS -CW27",
     "symbol": "ECIVF"
    },
    {
     "description": "CHECKIT PLC",
     "symbol": "ECKTF"
    },
    {
     "description": "ECOLAB INC",
     "symbol": "ECL"
    },
    {
     "description": "ECOLOMONDO CORP",
     "symbol": "ECLMF"
    },
    {
     "description": "FIRST TRUST EIP CARBON IMPAC",
     "symbol": "ECLN"
    },
    {
     "description": "ENCOMPASS HOLDINGS INC",
     "symbol": "ECMH"
    },
    {
     "description": "ECOMETALS LTD",
     "symbol": "ECMLF"
    },
    {
     "description": "UNIVERSAL COPPER LTD",
     "symbol": "ECMXF"
    },
    {
     "description": "ECN CAPITAL CORP",
     "symbol": "ECNCF"
    },
    {
     "description": "ISHARES MSCI CHINA SMALL-CAP",
     "symbol": "ECNS"
    },
    {
     "description": "ECOGREEN INTERNATIONAL GROUP",
     "symbol": "ECOCF"
    },
    {
     "description": "US ECOLOGY INC",
     "symbol": "ECOL"
    },
    {
     "description": "US ECOLOGY PARENT INC -CW23",
     "symbol": "ECOLW"
    },
    {
     "description": "CHANNELADVISOR CORP",
     "symbol": "ECOM"
    },
    {
     "description": "COLUMBIA EMERGING MARKETS CO",
     "symbol": "ECON"
    },
    {
     "description": "ELECTROCORE INC",
     "symbol": "ECOR"
    },
    {
     "description": "ELCORA ADVANCED MATERIALS CO",
     "symbol": "ECORF"
    },
    {
     "description": "PACER EMERGING MARKETS CASH",
     "symbol": "ECOW"
    },
    {
     "description": "ECO INNOVATION GROUP INC",
     "symbol": "ECOX"
    },
    {
     "description": "TRUESHARES ESG ACTIVE OPPORT",
     "symbol": "ECOZ"
    },
    {
     "description": "ENCORE CAPITAL GROUP INC",
     "symbol": "ECPG"
    },
    {
     "description": "ECOPLUS INC",
     "symbol": "ECPL"
    },
    {
     "description": "EL CAPITAN PRECIOUS METALS",
     "symbol": "ECPN"
    },
    {
     "description": "CARTIER RESOURCES INC",
     "symbol": "ECRFF"
    },
    {
     "description": "ECC CAPITAL CORP",
     "symbol": "ECRO"
    },
    {
     "description": "CHEE CORP",
     "symbol": "ECRP"
    },
    {
     "description": "ATEX RESOURCES INC",
     "symbol": "ECRTF"
    },
    {
     "description": "ECARE SOLUTIONS INC",
     "symbol": "ECSL"
    },
    {
     "description": "ECOSYNTHETIX INC",
     "symbol": "ECSNF"
    },
    {
     "description": "WT COPPER",
     "symbol": "ECSTF"
    },
    {
     "description": "ECA MARCELLUS TRUST I",
     "symbol": "ECTM"
    },
    {
     "description": "ELECTROLUX PROFESSIONAL AB-B",
     "symbol": "ECTXF"
    },
    {
     "description": "ECUITY INC",
     "symbol": "ECUI"
    },
    {
     "description": "ECOVYST INC",
     "symbol": "ECVT"
    },
    {
     "description": "ECONOMIC INVESTMNT TRUST LTD",
     "symbol": "ECVTF"
    },
    {
     "description": "EC WORLD REIT",
     "symbol": "ECWDF"
    },
    {
     "description": "CXJ GROUP CO LTD",
     "symbol": "ECXJ"
    },
    {
     "description": "ECLIPX GROUP LTD",
     "symbol": "ECXXF"
    },
    {
     "description": "WT AGRICULTURE",
     "symbol": "ECYAF"
    },
    {
     "description": "WT SOYBEANS",
     "symbol": "ECYCF"
    },
    {
     "description": "WT WHEAT",
     "symbol": "ECYWF"
    },
    {
     "description": "CONSOLIDATED EDISON INC",
     "symbol": "ED"
    },
    {
     "description": "EDAP TMS SA -ADR",
     "symbol": "EDAP"
    },
    {
     "description": "DIREXION DLY EMG MKT BULL 3X",
     "symbol": "EDC"
    },
    {
     "description": "MORGAN STANLEY EMERGING MARK",
     "symbol": "EDD"
    },
    {
     "description": "EDREAMS ODIGEO SL",
     "symbol": "EDDRF"
    },
    {
     "description": "EDISON LITHIUM CORP",
     "symbol": "EDDYF"
    },
    {
     "description": "EDREAMS ODIGEO SL-UNSP ADR",
     "symbol": "EDEMY"
    },
    {
     "description": "ISHARES MSCI DENMARK ETF",
     "symbol": "EDEN"
    },
    {
     "description": "ELDERS LTD-UNSPONSORED ADR",
     "symbol": "EDESY"
    },
    {
     "description": "EDEN INNOVATIONS LTD",
     "symbol": "EDEYF"
    },
    {
     "description": "VIRTUS STONE HARBOR EMERGING",
     "symbol": "EDF"
    },
    {
     "description": "EDD HELMS GROUP INC",
     "symbol": "EDHD"
    },
    {
     "description": "VIRTUS STONE HARBOR EMERGING",
     "symbol": "EDI"
    },
    {
     "description": "EDION CORP",
     "symbol": "EDINF"
    },
    {
     "description": "EDITAS MEDICINE INC",
     "symbol": "EDIT"
    },
    {
     "description": "SPDR S&P EMERGING MARKETS DI",
     "symbol": "EDIV"
    },
    {
     "description": "EDUCATION MANAGEMENT CORP",
     "symbol": "EDMCQ"
    },
    {
     "description": "EMP DISTRIB Y COMERC NOR-ADR",
     "symbol": "EDN"
    },
    {
     "description": "ENDURANCE ACQUISITIO-CLASS A",
     "symbol": "EDNC"
    },
    {
     "description": "ENDURANCE ACQUISITION CORP",
     "symbol": "EDNCU"
    },
    {
     "description": "ENDURANCE ACQUISITIO -CW23",
     "symbol": "EDNCW"
    },
    {
     "description": "EDEN EMPIRE INC",
     "symbol": "EDNEF"
    },
    {
     "description": "EDENRED",
     "symbol": "EDNMF"
    },
    {
     "description": "EDENRED SA-UNSP ADR",
     "symbol": "EDNMY"
    },
    {
     "description": "EDEN RESEARCH PLC",
     "symbol": "EDNSF"
    },
    {
     "description": "GL X TELEMEDICINE DIG HEALTH",
     "symbol": "EDOC"
    },
    {
     "description": "ALPS EMERGING SECTOR DIVIDEN",
     "symbol": "EDOG"
    },
    {
     "description": "FIRST TRUST DOW 30 EQL WGHT",
     "symbol": "EDOW"
    },
    {
     "description": "ENERGIAS DE PORTUGAL-SP ADR",
     "symbol": "EDPFY"
    },
    {
     "description": "ENDEAVOR GROUP HOLD-CLASS A",
     "symbol": "EDR"
    },
    {
     "description": "ELDERS LTD",
     "symbol": "EDRSF"
    },
    {
     "description": "EDP RENOVAVEIS SA",
     "symbol": "EDRVF"
    },
    {
     "description": "EDP RENOVAVEIS SA-UNSPON ADR",
     "symbol": "EDRVY"
    },
    {
     "description": "ELECTRIC POWER DE-UNSPON ADR",
     "symbol": "EDRWY"
    },
    {
     "description": "EURODRY LTD",
     "symbol": "EDRY"
    },
    {
     "description": "EDESA BIOTECH INC",
     "symbol": "EDSA"
    },
    {
     "description": "EXCEED CO LTD",
     "symbol": "EDSFF"
    },
    {
     "description": "E-DATA CORPORATION",
     "symbol": "EDTA"
    },
    {
     "description": "SKILLFUL CRAFTSMAN EDUCATION",
     "symbol": "EDTK"
    },
    {
     "description": "EDTECHX HOLDINGS II-CLASS A",
     "symbol": "EDTX"
    },
    {
     "description": "SPECTRAL MEDICAL INC",
     "symbol": "EDTXF"
    },
    {
     "description": "EDTECHX HOLDINGS ACQUISITION",
     "symbol": "EDTXU"
    },
    {
     "description": "EDTECHX HOLD II CL A -CW27",
     "symbol": "EDTXW"
    },
    {
     "description": "NEW ORIENTAL EDUCATIO-SP ADR",
     "symbol": "EDU"
    },
    {
     "description": "EDUCATIONAL DEVELOPMENT CORP",
     "symbol": "EDUC"
    },
    {
     "description": "EDULAB INC",
     "symbol": "EDULF"
    },
    {
     "description": "GLOBAL X EDUCATION ETF",
     "symbol": "EDUT"
    },
    {
     "description": "VANGUARD EXTENDED DUR TREAS",
     "symbol": "EDV"
    },
    {
     "description": "ENDEAVOUR GROUP LTD\/AUSTRALI",
     "symbol": "EDVGF"
    },
    {
     "description": "ENDEAVOUR MINING PLC",
     "symbol": "EDVMF"
    },
    {
     "description": "ENDEAVOR BANK",
     "symbol": "EDVR"
    },
    {
     "description": "EDGEWATER EXPLORATION LTD",
     "symbol": "EDWZF"
    },
    {
     "description": "ENDEXX CORP",
     "symbol": "EDXC"
    },
    {
     "description": "NET ZERO RENEWABLE ENERGY IN",
     "symbol": "EDYYF"
    },
    {
     "description": "DIREXION DLY EMG MKT BEAR 3X",
     "symbol": "EDZ"
    },
    {
     "description": "E-DIRECT",
     "symbol": "EDZR"
    },
    {
     "description": "EXCELERATE ENERGY INC-A",
     "symbol": "EE"
    },
    {
     "description": "EUROPEAN EQUITY FUND INC\/THE",
     "symbol": "EEA"
    },
    {
     "description": "ISH MSCI USA ESG EHNCD USD-D",
     "symbol": "EEDSF"
    },
    {
     "description": "88 ENERGY LTD",
     "symbol": "EEENF"
    },
    {
     "description": "EURONET WORLDWIDE INC",
     "symbol": "EEFT"
    },
    {
     "description": "ENBW ENERGIE BADEN-WUERTTEMB",
     "symbol": "EEGBF"
    },
    {
     "description": "ELINE ENTERTAINMENT GRP INC",
     "symbol": "EEGI"
    },
    {
     "description": "EMPIRE ENERGY GROUP LTD",
     "symbol": "EEGUF"
    },
    {
     "description": "ELEMENTS SPECTRUM ETN",
     "symbol": "EEH"
    },
    {
     "description": "ELITE EDUCATION GROUP INTERN",
     "symbol": "EEIQ"
    },
    {
     "description": "INVESCO S&P EMERGING MARKETS",
     "symbol": "EELV"
    },
    {
     "description": "ISHARES MSCI EMERGING MARKET",
     "symbol": "EEM"
    },
    {
     "description": "ISHARES MSCI EMERG MRKT ASIA",
     "symbol": "EEMA"
    },
    {
     "description": "AAM S&P EM HIGH DIV VAL ETF",
     "symbol": "EEMD"
    },
    {
     "description": "E3 METALS CORP",
     "symbol": "EEMMF"
    },
    {
     "description": "INVESCO S&P EMERGING MARKETS",
     "symbol": "EEMO"
    },
    {
     "description": "ISHARES MSCI EMERGING MKT SM",
     "symbol": "EEMS"
    },
    {
     "description": "ISHARES MSCI EMG MKT MIN VOL",
     "symbol": "EEMV"
    },
    {
     "description": "SPDR MSCI EM FSL FL RSV FREE",
     "symbol": "EEMX"
    },
    {
     "description": "ELECTROCOMPONENTS PLC",
     "symbol": "EENEF"
    },
    {
     "description": "ELECTROCOMPONENTS PLC-UN ADR",
     "symbol": "EENEY"
    },
    {
     "description": "ENAV SPA",
     "symbol": "EENNF"
    },
    {
     "description": "ELEGANCE OPTICAL INTERNATION",
     "symbol": "EEOIF"
    },
    {
     "description": "ENERGEAN PLC",
     "symbol": "EERGF"
    },
    {
     "description": "DriveWealth Power Saver ETF",
     "symbol": "EERN"
    },
    {
     "description": "WISDOMTREE US SMALLCAP FUND",
     "symbol": "EES"
    },
    {
     "description": "ENERGY & ENVIRONMENTAL SERVI",
     "symbol": "EESE"
    },
    {
     "description": "EESTECH INC",
     "symbol": "EESH"
    },
    {
     "description": "ENCOMPASS ENERGY SERVICES IN",
     "symbol": "EESI"
    },
    {
     "description": "ENZYME ENVIRONMENTAL SOLUTIO",
     "symbol": "EESO"
    },
    {
     "description": "PROSHARES ULT MSCI EMER MKTS",
     "symbol": "EET"
    },
    {
     "description": "PROSHARES ULTSHRT MSCI EM",
     "symbol": "EEV"
    },
    {
     "description": "EVE & CO INC",
     "symbol": "EEVVF"
    },
    {
     "description": "EMERALD HOLDING INC",
     "symbol": "EEX"
    },
    {
     "description": "FIREFINCH LTD",
     "symbol": "EEYMF"
    },
    {
     "description": "ESSENTIAL ENERGY SERVICES LT",
     "symbol": "EEYUF"
    },
    {
     "description": "ISHARES MSCI EAFE ETF",
     "symbol": "EFA"
    },
    {
     "description": "PROSHARES EAFE DVD GROWERS",
     "symbol": "EFAD"
    },
    {
     "description": "GLOBAL X MSCI SUPERDIVIDEND",
     "symbol": "EFAS"
    },
    {
     "description": "ISHARES MSCI EAFE MIN VOL FA",
     "symbol": "EFAV"
    },
    {
     "description": "SPDR MSCI EAFA FOSSIL FUEL",
     "symbol": "EFAX"
    },
    {
     "description": "EAGLE FINANCIAL BANCORP INC",
     "symbol": "EFBI"
    },
    {
     "description": "ELLINGTON FINANCIAL INC",
     "symbol": "EFC"
    },
    {
     "description": "ELLINGTON FINANCIAL",
     "symbol": "EFC.PRA"
    },
    {
     "description": "ELLINGTON FINANCIAL",
     "symbol": "EFC.PRB"
    },
    {
     "description": "L&G RUSSELL 2000 SM CAP QUAL",
     "symbol": "EFFDF"
    },
    {
     "description": "ISHARES MSCI EAFE GROWTH ETF",
     "symbol": "EFG"
    },
    {
     "description": "EFG INTERNATIONAL AG",
     "symbol": "EFGIF"
    },
    {
     "description": "EIFFAGE",
     "symbol": "EFGSF"
    },
    {
     "description": "EIFFAGE-UNSPON ADR",
     "symbol": "EFGSY"
    },
    {
     "description": "EFG INTERNATIONAL-UNSPON ADR",
     "symbol": "EFGXY"
    },
    {
     "description": "EFG-HERMES HOLDINGS-GDR",
     "symbol": "EFGZF"
    },
    {
     "description": "EASTERN MICHIGAN FINANCIAL",
     "symbol": "EFIN"
    },
    {
     "description": "EGPI FIRECREEK INC",
     "symbol": "EFIR"
    },
    {
     "description": "SPDR S&P 500 ESG ETF",
     "symbol": "EFIV"
    },
    {
     "description": "FT TCW EMERGING MARKETS DEBT",
     "symbol": "EFIX"
    },
    {
     "description": "EATON VANCE FLOATING-RATE 20",
     "symbol": "EFL"
    },
    {
     "description": "CELL TECH INTERNATIONAL INC",
     "symbol": "EFLI"
    },
    {
     "description": "EFUEL EFN CORP",
     "symbol": "EFLN"
    },
    {
     "description": "EXERCISE FOR LIFE SYSTEMS",
     "symbol": "EFLS"
    },
    {
     "description": "ELECTROVAYA INC",
     "symbol": "EFLVF"
    },
    {
     "description": "WISDOMTREE PHYSICAL GOLD",
     "symbol": "EFMSF"
    },
    {
     "description": "L&G LONG DATED ALL COMMOD",
     "symbol": "EFNCF"
    },
    {
     "description": "ISHARES MSCI FINLAND ETF",
     "symbol": "EFNL"
    },
    {
     "description": "PROSHARES ULTRA MSCI EAFE",
     "symbol": "EFO"
    },
    {
     "description": "ENERGY FOCUS INC",
     "symbol": "EFOI"
    },
    {
     "description": "EFOORA HEALTH MANAGEMENT INC",
     "symbol": "EFOR"
    },
    {
     "description": "EFOTOXPRESS INC",
     "symbol": "EFOT"
    },
    {
     "description": "EATON VANCE SR FLTG RATE TR",
     "symbol": "EFR"
    },
    {
     "description": "PASOFINO GOLD LTD",
     "symbol": "EFRGF"
    },
    {
     "description": "EAST AFRICA METALS INC",
     "symbol": "EFRMF"
    },
    {
     "description": "NEXUS INDUSTRIAL REIT",
     "symbol": "EFRTF"
    },
    {
     "description": "ENTERPRISE FINANCIAL SERVICE",
     "symbol": "EFSC"
    },
    {
     "description": "ENTERPRISE FINANCIAL SER",
     "symbol": "EFSCP"
    },
    {
     "description": "ENTERPRISE FINANCIAL SERVICE",
     "symbol": "EFSG"
    },
    {
     "description": "1847 HOLDINGS LLC",
     "symbol": "EFSH"
    },
    {
     "description": "EAGLE FINANCIAL SERVICES INC",
     "symbol": "EFSI"
    },
    {
     "description": "EATON VANCE FLOAT RT INC TR",
     "symbol": "EFT"
    },
    {
     "description": "EARTHFIRST TECHNOLOGIES INC",
     "symbol": "EFTI"
    },
    {
     "description": "EFFECTOR THERAPEUTICS INC",
     "symbol": "EFTR"
    },
    {
     "description": "LOCUST WALK ACQUI CL A -CW27",
     "symbol": "EFTRW"
    },
    {
     "description": "PROSHARES ULTSHRT MSCI EAFE",
     "symbol": "EFU"
    },
    {
     "description": "ISHARES MSCI EAFE VALUE ETF",
     "symbol": "EFV"
    },
    {
     "description": "EF ENERGYFUNDERS VENTURES IN",
     "symbol": "EFVIF"
    },
    {
     "description": "EQUIFAX INC",
     "symbol": "EFX"
    },
    {
     "description": "PROSHARES SHORT MSCI EAFE",
     "symbol": "EFZ"
    },
    {
     "description": "EzFill Holdings Inc",
     "symbol": "EFZL"
    },
    {
     "description": "EGAIN CORP",
     "symbol": "EGAN"
    },
    {
     "description": "EARTH GEN BIOFUEL INC",
     "symbol": "EGBB"
    },
    {
     "description": "EAGLE BANCORP INC",
     "symbol": "EGBN"
    },
    {
     "description": "EASTERN GOLDFIELDS INC",
     "symbol": "EGDD"
    },
    {
     "description": "ENERGOLD DRILLING CORP",
     "symbol": "EGDFF"
    },
    {
     "description": "BLACKROCK ENHANCED GOVT FUND",
     "symbol": "EGF"
    },
    {
     "description": "EUROBANK ERGASIAS SERVICES A",
     "symbol": "EGFEF"
    },
    {
     "description": "EUROBANK ERGASIAS SV-UNS ADR",
     "symbol": "EGFEY"
    },
    {
     "description": "ICPEI HOLDINGS INC",
     "symbol": "EGFHF"
    },
    {
     "description": "EG ACQUISITION CORP-A",
     "symbol": "EGGF"
    },
    {
     "description": "EG ACQUISITION CORP",
     "symbol": "EGGF.U"
    },
    {
     "description": "EG ACQUISITION CORP-A -CW28",
     "symbol": "EGGF.WS"
    },
    {
     "description": "ENGHOUSE SYSTEMS LTD",
     "symbol": "EGHSF"
    },
    {
     "description": "8X8 INC",
     "symbol": "EGHT"
    },
    {
     "description": "ENGIE BRASIL SA - SPON ADR",
     "symbol": "EGIEY"
    },
    {
     "description": "EDGETECH INTERNATIONAL INC",
     "symbol": "EGIL"
    },
    {
     "description": "EUROGAS INTERNATIONAL INC",
     "symbol": "EGINF"
    },
    {
     "description": "2NDVOTE SOCIETY DEFENDED ETF",
     "symbol": "EGIS"
    },
    {
     "description": "ELRINGKLINGER AG",
     "symbol": "EGKLF"
    },
    {
     "description": "EAGLE BULK SHIPPING INC",
     "symbol": "EGLE"
    },
    {
     "description": "EUGLENA CO LTD",
     "symbol": "EGLNF"
    },
    {
     "description": "ENTHUSIAST GAMING HOLDINGS I",
     "symbol": "EGLX"
    },
    {
     "description": "EMERGENT METALS CORP",
     "symbol": "EGMCF"
    },
    {
     "description": "ENGINEER GOLD MINES LTD",
     "symbol": "EGMLF"
    },
    {
     "description": "EAGLE MOUNTAIN MINING LTD",
     "symbol": "EGMMF"
    },
    {
     "description": "ELDORADO GOLD CORP",
     "symbol": "EGO"
    },
    {
     "description": "ENERGY 1 CORP",
     "symbol": "EGOC"
    },
    {
     "description": "EASTGROUP PROPERTIES INC",
     "symbol": "EGP"
    },
    {
     "description": "EAGLE PLAINS RESOURCES LTD",
     "symbol": "EGPLF"
    },
    {
     "description": "VANECK EGYPT INDEX ETF",
     "symbol": "EGPT"
    },
    {
     "description": "ENERGY RESOURCES OF AUST",
     "symbol": "EGRAF"
    },
    {
     "description": "ENERGY RESOURCES-UNSPON ADR",
     "symbol": "EGRAY"
    },
    {
     "description": "E-GUARDIAN INC",
     "symbol": "EGRDF"
    },
    {
     "description": "EAGLE ENERGY INC",
     "symbol": "EGRGF"
    },
    {
     "description": "CHINA EVERGRANDE GROUP",
     "symbol": "EGRNF"
    },
    {
     "description": "CHINA EVERGRANDE GRP-UNS ADR",
     "symbol": "EGRNY"
    },
    {
     "description": "EAGLE PHARMACEUTICALS INC",
     "symbol": "EGRX"
    },
    {
     "description": "EGUARANTEE INC",
     "symbol": "EGTIF"
    },
    {
     "description": "ENERGTEK INC",
     "symbol": "EGTK"
    },
    {
     "description": "EYEFI TECHNOLOGIES INC",
     "symbol": "EGTTF"
    },
    {
     "description": "EGUANA TECHNOLOGIES INC",
     "symbol": "EGTYF"
    },
    {
     "description": "VAALCO ENERGY INC",
     "symbol": "EGY"
    },
    {
     "description": "ENERGY FINDERS INC",
     "symbol": "EGYF"
    },
    {
     "description": "EHANG HOLDINGS LTD-SPS ADR",
     "symbol": "EH"
    },
    {
     "description": "EHIME BANK LTD\/THE",
     "symbol": "EHBLF"
    },
    {
     "description": "ENCOMPASS HEALTH CORP",
     "symbol": "EHC"
    },
    {
     "description": "STAR ENTERTAINMENT GRP LTD\/T",
     "symbol": "EHGRF"
    },
    {
     "description": "WESTERN ASSET GLOBAL HIGH IN",
     "symbol": "EHI"
    },
    {
     "description": "EDINBURGH INVESTMENT TRUST",
     "symbol": "EHITF"
    },
    {
     "description": "GOEASY LTD",
     "symbol": "EHMEF"
    },
    {
     "description": "EHOUSE GLOBAL INC",
     "symbol": "EHOS"
    },
    {
     "description": "Eagle Hospitality Properties Trust Inc",
     "symbol": "EHPTP"
    },
    {
     "description": "EHEALTH INC",
     "symbol": "EHTH"
    },
    {
     "description": "EHAVE INC",
     "symbol": "EHVVF"
    },
    {
     "description": "EHYDROGEN SOLUTIONS INC",
     "symbol": "EHYD"
    },
    {
     "description": "EAGLE POINT INCOME CO INC",
     "symbol": "EIC"
    },
    {
     "description": "EAGLE PT INCOME CO INC",
     "symbol": "EICA"
    },
    {
     "description": "ENERGICA MOTOR CO SPA",
     "symbol": "EICAF"
    },
    {
     "description": "ELECTRICITE DE STRASBOURG-RG",
     "symbol": "EICSF"
    },
    {
     "description": "ISHARES MSCI INDONESIA ETF",
     "symbol": "EIDO"
    },
    {
     "description": "EXCHANGE INCOME CORP",
     "symbol": "EIFZF"
    },
    {
     "description": "EMPLOYERS HOLDINGS INC",
     "symbol": "EIG"
    },
    {
     "description": "8000 INC",
     "symbol": "EIGH"
    },
    {
     "description": "EIGER BIOPHARMACEUTICALS INC",
     "symbol": "EIGR"
    },
    {
     "description": "ENVIRONMENTAL INFRASTRUCTURE",
     "symbol": "EIHC"
    },
    {
     "description": "888 HOLDINGS PLC",
     "symbol": "EIHDF"
    },
    {
     "description": "EATON VANCE MUNICIPAL BOND F",
     "symbol": "EIM"
    },
    {
     "description": "VANECK ENERGY INCOME ETF",
     "symbol": "EINC"
    },
    {
     "description": "ENTERPRISE INFORMATICS INC",
     "symbol": "EINF"
    },
    {
     "description": "ENI SPA",
     "symbol": "EIPAF"
    },
    {
     "description": "ENABLE IPC CORP",
     "symbol": "EIPC"
    },
    {
     "description": "ISHARES MSCI IRELAND ETF",
     "symbol": "EIRL"
    },
    {
     "description": "ISHARES MSCI ISRAEL ETF",
     "symbol": "EIS"
    },
    {
     "description": "EDISON INTERNATIONAL",
     "symbol": "EIX"
    },
    {
     "description": "EIZO NANAO CORP",
     "symbol": "EIZOF"
    },
    {
     "description": "INNOVATOR EMERGING MARKETS P",
     "symbol": "EJAN"
    },
    {
     "description": "EJF ACQUISITION CORP-A",
     "symbol": "EJFA"
    },
    {
     "description": "EJF ACQUISITION CORP",
     "symbol": "EJFAU"
    },
    {
     "description": "EJF ACQUISITION CORP-A -CW27",
     "symbol": "EJFAW"
    },
    {
     "description": "E-HOME HOUSEHOLD SERVICE",
     "symbol": "EJH"
    },
    {
     "description": "EAST JAPAN RAILWAY CO",
     "symbol": "EJPRF"
    },
    {
     "description": "EAST JAPAN RAILWAY-UNSP ADR",
     "symbol": "EJPRY"
    },
    {
     "description": "EASYJET PLC",
     "symbol": "EJTTF"
    },
    {
     "description": "INNOVATOR EMERGING MARKETS P",
     "symbol": "EJUL"
    },
    {
     "description": "EJF INVESTMENTS LTD",
     "symbol": "EJVDF"
    },
    {
     "description": "CAPITAL LINK GLOBAL GREEN EN",
     "symbol": "EKAR"
    },
    {
     "description": "ELECTRONIC CONTROL SECURITY",
     "symbol": "EKCS"
    },
    {
     "description": "EKF DIAGNOSTICS HOLDINGS PLC",
     "symbol": "EKDHF"
    },
    {
     "description": "FIRST TRUST NASDAQ LUX DIGIT",
     "symbol": "EKG"
    },
    {
     "description": "CARDIOCOMM SOLUTIONS INC",
     "symbol": "EKGGF"
    },
    {
     "description": "EAST KANSAS AGRI-ENERGY-CL A",
     "symbol": "EKGRU"
    },
    {
     "description": "ENKA INSAAT VE SANAYI AS",
     "symbol": "EKIVF"
    },
    {
     "description": "EKO INTERNATIONAL CORP",
     "symbol": "EKNL"
    },
    {
     "description": "EKINOPS",
     "symbol": "EKNPF"
    },
    {
     "description": "ELK PETROLEUM LTD",
     "symbol": "EKPTF"
    },
    {
     "description": "ERICKSON INC",
     "symbol": "EKSN"
    },
    {
     "description": "EKSO BIONICS HOLDINGS INC",
     "symbol": "EKSO"
    },
    {
     "description": "ELEKTA AB-B SHS",
     "symbol": "EKTAF"
    },
    {
     "description": "ELEKTA AB-B SHS-UNSPON ADR",
     "symbol": "EKTAY"
    },
    {
     "description": "ECKOH PLC",
     "symbol": "EKTPF"
    },
    {
     "description": "EKWAN-X INC",
     "symbol": "EKWX"
    },
    {
     "description": "ECKERT & ZIEGLER STRAHLEN UN",
     "symbol": "EKZRF"
    },
    {
     "description": "ESTEE LAUDER COMPANIES-CL A",
     "symbol": "EL"
    },
    {
     "description": "ENVELA CORP",
     "symbol": "ELA"
    },
    {
     "description": "EL AL ISRAEL AIRLINES",
     "symbol": "ELALF"
    },
    {
     "description": "ELAMEX S.A. DE C.V.",
     "symbol": "ELAMF"
    },
    {
     "description": "ELANCO ANIMAL HEALTH INC",
     "symbol": "ELAN"
    },
    {
     "description": "ELANCO ANIMAL HEALTH INC",
     "symbol": "ELAT"
    },
    {
     "description": "ELECTRA BATTERY MATERIALS CO",
     "symbol": "ELBMD"
    },
    {
     "description": "ENTERGY LOUISIANA LLC",
     "symbol": "ELC"
    },
    {
     "description": "ELECTRA STONE LTD",
     "symbol": "ELCGF"
    },
    {
     "description": "EASTERN LIGHT CAPITAL INC",
     "symbol": "ELCI"
    },
    {
     "description": "ELECOM CO LTD",
     "symbol": "ELCMF"
    },
    {
     "description": "ELCOM INTERNATIONAL INC",
     "symbol": "ELCO"
    },
    {
     "description": "EDP-ENERGIAS DE PORTUGAL SA",
     "symbol": "ELCPF"
    },
    {
     "description": "ELECTRIC CAR COMPANY INC",
     "symbol": "ELCR"
    },
    {
     "description": "WISDOMTREE EMRG MKTS DEBT",
     "symbol": "ELD"
    },
    {
     "description": "ELEDON PHARMACEUTICALS INC",
     "symbol": "ELDN"
    },
    {
     "description": "EL.EN. SPA",
     "symbol": "ELEAF"
    },
    {
     "description": "ELECTRIC ROYALTIES LTD",
     "symbol": "ELECF"
    },
    {
     "description": "ELEMENT FLEET MANAGEMENT COR",
     "symbol": "ELEEF"
    },
    {
     "description": "ELEKTROS INC",
     "symbol": "ELEK"
    },
    {
     "description": "ELEMENTAL ROYALTIES CORP",
     "symbol": "ELEMF"
    },
    {
     "description": "ELEVATION ONCOLOGY INC",
     "symbol": "ELEV"
    },
    {
     "description": "ENDESA SA",
     "symbol": "ELEZF"
    },
    {
     "description": "ENDESA SA-UNSP ADR",
     "symbol": "ELEZY"
    },
    {
     "description": "ELF BEAUTY INC",
     "symbol": "ELF"
    },
    {
     "description": "E-L FINANCIAL CORP LTD",
     "symbol": "ELFIF"
    },
    {
     "description": "ELEMENT GLOBAL INC",
     "symbol": "ELGL"
    },
    {
     "description": "ELECTRIC & GAS TECH INC",
     "symbol": "ELGT"
    },
    {
     "description": "ELIA GROUP SA\/NV",
     "symbol": "ELIAF"
    },
    {
     "description": "ELIO MOTORS INC",
     "symbol": "ELIO"
    },
    {
     "description": "ELIXXER LTD",
     "symbol": "ELIXF"
    },
    {
     "description": "ELKEM ASA",
     "symbol": "ELKEF"
    },
    {
     "description": "GOLD ROAD RESOURCES LTD",
     "symbol": "ELKMF"
    },
    {
     "description": "ELAH HOLDINGS",
     "symbol": "ELLH"
    },
    {
     "description": "ELLAKTOR SA",
     "symbol": "ELLKF"
    },
    {
     "description": "ELLAKTOR SA-UNSPONSORED ADR",
     "symbol": "ELLKY"
    },
    {
     "description": "ELLOMAY CAPITAL LTD",
     "symbol": "ELLO"
    },
    {
     "description": "ELRINGKLINGER AG-UNSP ADR",
     "symbol": "ELLRY"
    },
    {
     "description": "ELIXINOL WELLNESS LTD",
     "symbol": "ELLXF"
    },
    {
     "description": "ELMER BANCORP INC",
     "symbol": "ELMA"
    },
    {
     "description": "ELECTROMED INC",
     "symbol": "ELMD"
    },
    {
     "description": "ELMO SOFTWARE LTD",
     "symbol": "ELMFF"
    },
    {
     "description": "ELEMENT79 GOLD CORP",
     "symbol": "ELMGF"
    },
    {
     "description": "ELECTRIC LAST MILE SOLUTIONS",
     "symbol": "ELMS"
    },
    {
     "description": "FORUM MERGER III CORP -CW27",
     "symbol": "ELMSW"
    },
    {
     "description": "ELEMENT 25 LTD",
     "symbol": "ELMTF"
    },
    {
     "description": "ELEMENTIS PLC-UNSP ADR",
     "symbol": "ELMTY"
    },
    {
     "description": "ELISA OYJ",
     "symbol": "ELMUF"
    },
    {
     "description": "ELISA OYJ-UNSPONSORED ADR",
     "symbol": "ELMUY"
    },
    {
     "description": "EL NINO VENTURES INC",
     "symbol": "ELNOF"
    },
    {
     "description": "ELEMENT NUTRITIONAL SCIENCES",
     "symbol": "ELNSF"
    },
    {
     "description": "ELINX CORP",
     "symbol": "ELNX"
    },
    {
     "description": "EMERGENCE GLOBAL ENTERPRISES",
     "symbol": "ELOAF"
    },
    {
     "description": "ENEL RUSSIA OJSC-SPON GDR",
     "symbol": "ELOKY"
    },
    {
     "description": "ELIOR SCA-UNSPON ADR",
     "symbol": "ELORY"
    },
    {
     "description": "ELOXX PHARMACEUTICALS INC",
     "symbol": "ELOX"
    },
    {
     "description": "CIA PARANAENSE ENER-SP ADR",
     "symbol": "ELP"
    },
    {
     "description": "ELOPAK ASA",
     "symbol": "ELPKF"
    },
    {
     "description": "EL PUERTO DE LIVERPOOL-C1",
     "symbol": "ELPQF"
    },
    {
     "description": "ISHARES ESG ADV INV GR CB",
     "symbol": "ELQD"
    },
    {
     "description": "ELRAY RESOURCES INC",
     "symbol": "ELRA"
    },
    {
     "description": "YINFU GOLD CORP",
     "symbol": "ELRE"
    },
    {
     "description": "EASTERN PLATINUM LTD",
     "symbol": "ELRFF"
    },
    {
     "description": "ELRON VENTURES LTD",
     "symbol": "ELRNF"
    },
    {
     "description": "ELIOR GROUP",
     "symbol": "ELROF"
    },
    {
     "description": "ELORO RESOURCES LTD",
     "symbol": "ELRRF"
    },
    {
     "description": "ELECTROLUX AB-B",
     "symbol": "ELRXF"
    },
    {
     "description": "EQUITY LIFESTYLE PROPERTIES",
     "symbol": "ELS"
    },
    {
     "description": "ELOS MEDTECH AB",
     "symbol": "ELSBF"
    },
    {
     "description": "ELECTRO-SENSORS INC",
     "symbol": "ELSE"
    },
    {
     "description": "ELSIGHT LTD",
     "symbol": "ELSLF"
    },
    {
     "description": "ELIS SA",
     "symbol": "ELSSF"
    },
    {
     "description": "ELECTRONIC SYSTEMS TECHNOLOG",
     "symbol": "ELST"
    },
    {
     "description": "ELTEK LTD",
     "symbol": "ELTK"
    },
    {
     "description": "ELEMENTOS LTD",
     "symbol": "ELTLF"
    },
    {
     "description": "ELITE PHARMACEUTICALS INC",
     "symbol": "ELTP"
    },
    {
     "description": "ELECTROLUX AB -SPONS ADR B",
     "symbol": "ELUXY"
    },
    {
     "description": "EVOLVA HOLDING SA",
     "symbol": "ELVAF"
    },
    {
     "description": "EVOLVA HOLDING SA-SPON ADR",
     "symbol": "ELVAY"
    },
    {
     "description": "ELVICTOR GROUP INC",
     "symbol": "ELVG"
    },
    {
     "description": "ELEVATE CREDIT INC",
     "symbol": "ELVT"
    },
    {
     "description": "ELEVATE URANIUM LTD",
     "symbol": "ELVUF"
    },
    {
     "description": "ELECTREON WIRELESS LTD",
     "symbol": "ELWSF"
    },
    {
     "description": "NOVA EYE MEDICAL LTD",
     "symbol": "ELXMF"
    },
    {
     "description": "ELIXIR ENERGY LTD",
     "symbol": "ELXPF"
    },
    {
     "description": "CALLAWAY GOLF COMPANY",
     "symbol": "ELY"
    },
    {
     "description": "ELIEM THERAPEUTICS INC",
     "symbol": "ELYM"
    },
    {
     "description": "ELYS GAME TECHNOLOGY CORP",
     "symbol": "ELYS"
    },
    {
     "description": "SMART SHARE GLOBAL LTD - ADR",
     "symbol": "EM"
    },
    {
     "description": "WT PHYSICAL PRECIOUS METALS",
     "symbol": "EMALF"
    },
    {
     "description": "EMAGIN CORPORATION",
     "symbol": "EMAN"
    },
    {
     "description": "ECOMAX INC",
     "symbol": "EMAX"
    },
    {
     "description": "ISHARES JP MORGAN USD EMERGI",
     "symbol": "EMB"
    },
    {
     "description": "EMAMBA INTERNATIONAL CORP",
     "symbol": "EMBA"
    },
    {
     "description": "EMBECTA CORP",
     "symbol": "EMBC"
    },
    {
     "description": "GLOBAL X EMERGING MARKETS BD",
     "symbol": "EMBD"
    },
    {
     "description": "ISHARES INT RATE HDG EM BOND",
     "symbol": "EMBH"
    },
    {
     "description": "EMBARK TECHNOLOGY INC",
     "symbol": "EMBK"
    },
    {
     "description": "EMBARK TECHNOLOGY INC-CW27",
     "symbol": "EMBKW"
    },
    {
     "description": "EMBARR DOWNS INC",
     "symbol": "EMBR"
    },
    {
     "description": "EMBER THERAPEUTICS INC",
     "symbol": "EMBT"
    },
    {
     "description": "ARCA CONTINENTAL SAB DE CV",
     "symbol": "EMBVF"
    },
    {
     "description": "NEXERA ENERGY INC",
     "symbol": "EMBYF"
    },
    {
     "description": "WISDOMTREE EM CORP BOND",
     "symbol": "EMCB"
    },
    {
     "description": "EMCLAIRE FINANCIAL CORP",
     "symbol": "EMCF"
    },
    {
     "description": "EML PAYMENTS LTD",
     "symbol": "EMCHF"
    },
    {
     "description": "EMERGE COMMERCE LTD",
     "symbol": "EMCMF"
    },
    {
     "description": "XTRACKERS EMERG MARK CARB RE",
     "symbol": "EMCR"
    },
    {
     "description": "WESTERN ASSET EMRG MRKT DBT",
     "symbol": "EMD"
    },
    {
     "description": "E MED FUTURE INC",
     "symbol": "EMDF"
    },
    {
     "description": "PROSHARES MSCI EMERGING MARK",
     "symbol": "EMDV"
    },
    {
     "description": "EMCOR GROUP INC",
     "symbol": "EME"
    },
    {
     "description": "ELECTROMEDICAL TECHNOLOGIES",
     "symbol": "EMED"
    },
    {
     "description": "EMERALD PLANTATION HOLDINGS",
     "symbol": "EMEXF"
    },
    {
     "description": "TEMPLETON EMERGING MKTS FND",
     "symbol": "EMF"
    },
    {
     "description": "FLUENCE CORP LTD",
     "symbol": "EMFGF"
    },
    {
     "description": "GLOBAL X MSCI NEXT EMERGING",
     "symbol": "EMFM"
    },
    {
     "description": "AMPLIFY EMERGING MARKETS FIN",
     "symbol": "EMFQ"
    },
    {
     "description": "SIMPLIFY EM EQ PLUS DOWN CON",
     "symbol": "EMGD"
    },
    {
     "description": "EMINENT GOLD CORP",
     "symbol": "EMGDF"
    },
    {
     "description": "EMERGENT HEALTH CORP",
     "symbol": "EMGE"
    },
    {
     "description": "ISHARES MSCI EMERGING MARKET",
     "symbol": "EMGF"
    },
    {
     "description": "SPDR BLOOMBERG EM USD BOND",
     "symbol": "EMHC"
    },
    {
     "description": "EAST MORGAN HOLDINGS INC",
     "symbol": "EMHI"
    },
    {
     "description": "EUROPEAN METALS HOLDINGS-DI",
     "symbol": "EMHLF"
    },
    {
     "description": "EMERALD HEALTH THERAPEUTICS",
     "symbol": "EMHTF"
    },
    {
     "description": "EUROPEAN METALS - SPON ADR",
     "symbol": "EMHXY"
    },
    {
     "description": "ISHARES J.P. MORGAN EM HIGH",
     "symbol": "EMHY"
    },
    {
     "description": "ISHARES EMERGING MARKETS INF",
     "symbol": "EMIF"
    },
    {
     "description": "KORE POTASH LTD",
     "symbol": "EMINF"
    },
    {
     "description": "ELBIT IMAGING LTD",
     "symbol": "EMITF"
    },
    {
     "description": "EMCORE CORP",
     "symbol": "EMKR"
    },
    {
     "description": "EASTERN CO\/THE",
     "symbol": "EML"
    },
    {
     "description": "EMPIRE CO LTD 'A'",
     "symbol": "EMLAF"
    },
    {
     "description": "VANECK JPM EM LOCAL CURR BND",
     "symbol": "EMLC"
    },
    {
     "description": "FTAC EMERALD ACQUISITION -A",
     "symbol": "EMLD"
    },
    {
     "description": "FTAC EMERALD ACQUISITION COR",
     "symbol": "EMLDU"
    },
    {
     "description": "FTAC EMERALD ACQUISITI A -23",
     "symbol": "EMLDW"
    },
    {
     "description": "EL MANIEL INTERNATIONAL INC",
     "symbol": "EMLL"
    },
    {
     "description": "FIRST TRUST NORTH AMERICAN E",
     "symbol": "EMLP"
    },
    {
     "description": "EMMI AG-REG",
     "symbol": "EMLZF"
    },
    {
     "description": "EMMAUS LIFE SCIENCES INC",
     "symbol": "EMMA"
    },
    {
     "description": "EMEDIA GROUP INC",
     "symbol": "EMMD"
    },
    {
     "description": "WISDOMTREE EMERGING MARKETS",
     "symbol": "EMMF"
    },
    {
     "description": "OKYO PHARMA LTD",
     "symbol": "EMMLF"
    },
    {
     "description": "EMMERSON RESOURCES LTD",
     "symbol": "EMMRF"
    },
    {
     "description": "EMMIS COMMUNICATIONS-CLASS A",
     "symbol": "EMMS"
    },
    {
     "description": "EASTMAN CHEMICAL CO",
     "symbol": "EMN"
    },
    {
     "description": "EURO MANGANESE INC-CDI",
     "symbol": "EMNAF"
    },
    {
     "description": "E-MONEE.COM INC",
     "symbol": "EMNC"
    },
    {
     "description": "ELEMENTIS PLC",
     "symbol": "EMNSF"
    },
    {
     "description": "PIMCO ENHCD ST M-ACTIVE ESG",
     "symbol": "EMNT"
    },
    {
     "description": "CLEARBRIDGE ENERGY MIDSTREAM",
     "symbol": "EMO"
    },
    {
     "description": "EXTREME MOTORSPORTS OF CALIF",
     "symbol": "EMOC"
    },
    {
     "description": "HEALIXA INC",
     "symbol": "EMOR"
    },
    {
     "description": "EMERITA RESOURCES CORP",
     "symbol": "EMOTF"
    },
    {
     "description": "ENTERGY MISSISSIPPI LLC",
     "symbol": "EMP"
    },
    {
     "description": "EMPOWERED PRODUCTS INC",
     "symbol": "EMPO"
    },
    {
     "description": "EMP METALS CORP",
     "symbol": "EMPPF"
    },
    {
     "description": "EMP SOLUTIONS INC",
     "symbol": "EMPS"
    },
    {
     "description": "EMPRESS ROYALTY CORP",
     "symbol": "EMPYF"
    },
    {
     "description": "EMERGING MRKTS INTERNET & EC",
     "symbol": "EMQQ"
    },
    {
     "description": "EM QUANTUM TECHNOLOGIES INC",
     "symbol": "EMQU"
    },
    {
     "description": "EMERSON ELECTRIC CO",
     "symbol": "EMR"
    },
    {
     "description": "EMERA INC",
     "symbol": "EMRAF"
    },
    {
     "description": "EMERGING HOLDINGS INC",
     "symbol": "EMRH"
    },
    {
     "description": "EMARINE GLOBAL INC",
     "symbol": "EMRN"
    },
    {
     "description": "EMS-CHEMIE HOLDING-UNSP ADR",
     "symbol": "EMSCY"
    },
    {
     "description": "XTRACKERS MSCI EMERGING MARK",
     "symbol": "EMSG"
    },
    {
     "description": "PROSHARES SHORT TERM USD EME",
     "symbol": "EMSH"
    },
    {
     "description": "EMS-CHEMIE HOLDING AG-REG",
     "symbol": "EMSHF"
    },
    {
     "description": "MUSK METALS CORP",
     "symbol": "EMSKF"
    },
    {
     "description": "EMMERSON PLC",
     "symbol": "EMSNF"
    },
    {
     "description": "ISHARES EDGE MSCI US MLTFCTR",
     "symbol": "EMSQF"
    },
    {
     "description": "ISH EDG MSCI WLD MLTFC USD A",
     "symbol": "EMSWF"
    },
    {
     "description": "SPDR DL EM FX IN ETF",
     "symbol": "EMTL"
    },
    {
     "description": "ELEMENT 29 RESOURCES INC",
     "symbol": "EMTRF"
    },
    {
     "description": "PROSHARES DECLINE OF THE RET",
     "symbol": "EMTY"
    },
    {
     "description": "EMX ROYALTY CORP",
     "symbol": "EMX"
    },
    {
     "description": "ISHARES MSCI EMR MRK EX CHNA",
     "symbol": "EMXC"
    },
    {
     "description": "ISHARES ESG ADV MSCI EM ETF",
     "symbol": "EMXF"
    },
    {
     "description": "EMBASSY BANCORP INC",
     "symbol": "EMYB"
    },
    {
     "description": "EUROMONEY INSTL INVESTOR PLC",
     "symbol": "EMYIF"
    },
    {
     "description": "EASY TECHNOLOGIES INC",
     "symbol": "EMYSF"
    },
    {
     "description": "ENABLE HOLDINGS INC",
     "symbol": "ENAB"
    },
    {
     "description": "ENAD GLOBAL 7 AB",
     "symbol": "ENADF"
    },
    {
     "description": "ENABLENCE TECHNOLOGIES INC",
     "symbol": "ENAFF"
    },
    {
     "description": "E.ON SE",
     "symbol": "ENAKF"
    },
    {
     "description": "ENBRIDGE INC",
     "symbol": "ENB"
    },
    {
     "description": "ENBRIDGE INC",
     "symbol": "ENBA"
    },
    {
     "description": "Enbridge Inc",
     "symbol": "ENBBF"
    },
    {
     "description": "Enbridge Inc",
     "symbol": "ENBFF"
    },
    {
     "description": "Enbridge Inc 550",
     "symbol": "ENBGF"
    },
    {
     "description": "ENB FINANCIAL CORP",
     "symbol": "ENBP"
    },
    {
     "description": "ENCORE BRANDS INC",
     "symbol": "ENCB"
    },
    {
     "description": "ENCOMPASS COMPLIANCE CORP",
     "symbol": "ENCC"
    },
    {
     "description": "ENERGEM CORP - CLASS A",
     "symbol": "ENCP"
    },
    {
     "description": "ENERGEM CORP",
     "symbol": "ENCPU"
    },
    {
     "description": "ENERGEM CORP - CL A -CW23",
     "symbol": "ENCPW"
    },
    {
     "description": "ENER-CORE INC",
     "symbol": "ENCR"
    },
    {
     "description": "ENCORE ENERGY SYSTEMS INC",
     "symbol": "ENCS"
    },
    {
     "description": "ENCANTO POTASH CORP",
     "symbol": "ENCTF"
    },
    {
     "description": "ENCORE ENERGY CORP",
     "symbol": "ENCUF"
    },
    {
     "description": "ENCAVIS AG",
     "symbol": "ENCVF"
    },
    {
     "description": "ENCHANTED WORLD INC",
     "symbol": "ENCW"
    },
    {
     "description": "Endurance Acquisition Corporation",
     "symbol": "ENDCU"
    },
    {
     "description": "ENDURANCE GOLD CORP",
     "symbol": "ENDGF"
    },
    {
     "description": "ENDURO METALS CORP",
     "symbol": "ENDMF"
    },
    {
     "description": "ENDOCAN CORP",
     "symbol": "ENDO"
    },
    {
     "description": "ENDO INTERNATIONAL PLC",
     "symbol": "ENDP"
    },
    {
     "description": "ENDOR AG",
     "symbol": "ENDRF"
    },
    {
     "description": "CANOE EIT INCOME FUND",
     "symbol": "ENDTF"
    },
    {
     "description": "ENDONOVO THERAPEUTICS INC",
     "symbol": "ENDV"
    },
    {
     "description": "ENEA SA-UNSP ADR",
     "symbol": "ENEAY"
    },
    {
     "description": "ENEA AB",
     "symbol": "ENEKF"
    },
    {
     "description": "ACCRETION ACQUISITION CORP",
     "symbol": "ENER"
    },
    {
     "description": "ACCRETION ACQUISITION COR-RT",
     "symbol": "ENERR"
    },
    {
     "description": "ACCRETION ACQUISITION CORP",
     "symbol": "ENERU"
    },
    {
     "description": "ACCRETION ACQUISITION -CW23",
     "symbol": "ENERW"
    },
    {
     "description": "ENEREV5 METALS INC",
     "symbol": "ENEVF"
    },
    {
     "description": "ENFUSION INC - CLASS A",
     "symbol": "ENFN"
    },
    {
     "description": "ALERIAN ENERGY INFRASTRUCTUR",
     "symbol": "ENFR"
    },
    {
     "description": "ENGLOBAL CORP",
     "symbol": "ENG"
    },
    {
     "description": "ENGAGE MOBILITY INC",
     "symbol": "ENGA"
    },
    {
     "description": "ENERGIEDIENST HOLDING AG-REG",
     "symbol": "ENGDF"
    },
    {
     "description": "ENAGAS SA",
     "symbol": "ENGGF"
    },
    {
     "description": "ENAGAS-UNSPONSORED ADR",
     "symbol": "ENGGY"
    },
    {
     "description": "ENERGY HARBOR CORP",
     "symbol": "ENGH"
    },
    {
     "description": "ENGIE-SPON ADR",
     "symbol": "ENGIY"
    },
    {
     "description": "NHOA",
     "symbol": "ENGPF"
    },
    {
     "description": "ENGIE",
     "symbol": "ENGQF"
    },
    {
     "description": "ENERGY & TECHNOLOGY CORP",
     "symbol": "ENGT"
    },
    {
     "description": "CENTRAL ENERGY PARTNERS LP",
     "symbol": "ENGY"
    },
    {
     "description": "ENERGROUP HOLDINGS CORP",
     "symbol": "ENHD"
    },
    {
     "description": "ENHERENT CORP",
     "symbol": "ENHT"
    },
    {
     "description": "ENEL AMERICAS SA-ADR",
     "symbol": "ENIA"
    },
    {
     "description": "ENEL CHILE SA-ADR",
     "symbol": "ENIC"
    },
    {
     "description": "ENIGMO INC",
     "symbol": "ENIGF"
    },
    {
     "description": "ENTERGY NEW ORLEANS LLC",
     "symbol": "ENJ"
    },
    {
     "description": "ENJOY TECHNOLOGY INC",
     "symbol": "ENJY"
    },
    {
     "description": "ENJOY TECHNOLOGY INC -CW25",
     "symbol": "ENJYW"
    },
    {
     "description": "ENERKON SOLAR INTERNATIONAL",
     "symbol": "ENKS"
    },
    {
     "description": "ENEL SPA - UNSPON ADR",
     "symbol": "ENLAY"
    },
    {
     "description": "ENLABS AB",
     "symbol": "ENLBF"
    },
    {
     "description": "ENLINK MIDSTREAM LLC",
     "symbol": "ENLC"
    },
    {
     "description": "ENLIGHT RENEWABLE ENERGY LTD",
     "symbol": "ENLTF"
    },
    {
     "description": "ENLIVEX THERAPEUTICS LTD",
     "symbol": "ENLV"
    },
    {
     "description": "ENERGEM RESOURCES INC",
     "symbol": "ENMFF"
    },
    {
     "description": "ENM HOLDINGS LTD",
     "symbol": "ENMHF"
    },
    {
     "description": "DH ENCHANTMENT INC",
     "symbol": "ENMI"
    },
    {
     "description": "ENSURGE MICROPOWER ASA",
     "symbol": "ENMPF"
    },
    {
     "description": "ENSURGE MICROPOWER AS-SP ADR",
     "symbol": "ENMPY"
    },
    {
     "description": "Enbridge Inc",
     "symbol": "ENNPF"
    },
    {
     "description": "ENTERGY NEW ORLEANS LLC",
     "symbol": "ENO"
    },
    {
     "description": "ENOCHIAN BIOSCIENCES INC",
     "symbol": "ENOB"
    },
    {
     "description": "ISHARES MSCI NORWAY ETF",
     "symbol": "ENOR"
    },
    {
     "description": "ENOVIS CORP",
     "symbol": "ENOV"
    },
    {
     "description": "EXECUTIVE NETWORK PARTNER-A",
     "symbol": "ENPC"
    },
    {
     "description": "EXECUTIVE NETWORK PARTNERING",
     "symbol": "ENPC.U"
    },
    {
     "description": "EXECUTIVE NETWORK PART -CW28",
     "symbol": "ENPC.WS"
    },
    {
     "description": "ENPRISE GROUP LIMITED",
     "symbol": "ENPGF"
    },
    {
     "description": "ENPHASE ENERGY INC",
     "symbol": "ENPH"
    },
    {
     "description": "CURRENT WATER TECHNOLOGIES I",
     "symbol": "ENPRF"
    },
    {
     "description": "ENQUEST PLC",
     "symbol": "ENQUF"
    },
    {
     "description": "ENERGIZER HOLDINGS INC",
     "symbol": "ENR"
    },
    {
     "description": "ENERGIX-RENEWABLE ENERGIES",
     "symbol": "ENREF"
    },
    {
     "description": "ENERFLEX LTD",
     "symbol": "ENRFF"
    },
    {
     "description": "ENERTOPIA CORP",
     "symbol": "ENRT"
    },
    {
     "description": "ENERSYS",
     "symbol": "ENS"
    },
    {
     "description": "ENSYSCE BIOSCIENCES INC",
     "symbol": "ENSC"
    },
    {
     "description": "LEISURE ACQUISITION COR-CW22",
     "symbol": "ENSCW"
    },
    {
     "description": "ENSIGN GROUP INC\/THE",
     "symbol": "ENSG"
    },
    {
     "description": "ENSECO ENERGY SERVICES CORP",
     "symbol": "ENSRF"
    },
    {
     "description": "ENSERVCO CORP",
     "symbol": "ENSV"
    },
    {
     "description": "ENANTA PHARMACEUTICALS INC",
     "symbol": "ENTA"
    },
    {
     "description": "ENTHEON BIOMEDICAL CORP",
     "symbol": "ENTBF"
    },
    {
     "description": "ESE ENTERTAINMENT INC",
     "symbol": "ENTEF"
    },
    {
     "description": "ENTERPRISE 4.0 TECHNOLOGY AC",
     "symbol": "ENTF"
    },
    {
     "description": "ENTERPRISE 4.0 TECHNOLOGY AC",
     "symbol": "ENTFU"
    },
    {
     "description": "ENTERPRISE 4.0 TECHNOL -CW23",
     "symbol": "ENTFW"
    },
    {
     "description": "ENTEGRIS INC",
     "symbol": "ENTG"
    },
    {
     "description": "ENCOUNTER TECHNOLOGIES INC",
     "symbol": "ENTI"
    },
    {
     "description": "ENTRA ASA",
     "symbol": "ENTOF"
    },
    {
     "description": "ERSHARES ENTREPRENEURS ETF",
     "symbol": "ENTR"
    },
    {
     "description": "ENTERA BIO LTD",
     "symbol": "ENTX"
    },
    {
     "description": "ENTERA BIO LTD-CW23",
     "symbol": "ENTXW"
    },
    {
     "description": "ENVESTNET INC",
     "symbol": "ENV"
    },
    {
     "description": "ENOVA INTERNATIONAL INC",
     "symbol": "ENVA"
    },
    {
     "description": "ENVERIC BIOSCIENCES INC",
     "symbol": "ENVB"
    },
    {
     "description": "ENOVA SYSTEMS INC",
     "symbol": "ENVS"
    },
    {
     "description": "ENOVIX CORP",
     "symbol": "ENVX"
    },
    {
     "description": "EATON VANCE NEW YORK MUNICIP",
     "symbol": "ENX"
    },
    {
     "description": "ENERGY POWER SYSTEMS LTD",
     "symbol": "ENYNF"
    },
    {
     "description": "ENZO BIOCHEM INC",
     "symbol": "ENZ"
    },
    {
     "description": "ENZOLYTICS INC",
     "symbol": "ENZC"
    },
    {
     "description": "ENZYMES AMERICAN HOLDING",
     "symbol": "ENZH"
    },
    {
     "description": "ISHARES MSCI NEW ZEALAND ETF",
     "symbol": "ENZL"
    },
    {
     "description": "ENZON PHARMACEUTICALS INC",
     "symbol": "ENZN"
    },
    {
     "description": "INNOVATOR EMER MKT PWR BUFF",
     "symbol": "EOCT"
    },
    {
     "description": "ELLIOTT OPPORTUNITY II COR-A",
     "symbol": "EOCW"
    },
    {
     "description": "ELLIOTT OPPORTUNITY II CORP",
     "symbol": "EOCW.U"
    },
    {
     "description": "ELLIOTT OPPORTUNITY II-CW23",
     "symbol": "EOCW.WS"
    },
    {
     "description": "ALLSPRING GLOBAL DIVIDEND OP",
     "symbol": "EOD"
    },
    {
     "description": "ECOFIBRE LTD",
     "symbol": "EOFBF"
    },
    {
     "description": "ECOFIBRE LTD - SPON ADR",
     "symbol": "EOFBY"
    },
    {
     "description": "EOG RESOURCES INC",
     "symbol": "EOG"
    },
    {
     "description": "EMERALD RESOURCES NL",
     "symbol": "EOGSF"
    },
    {
     "description": "EMECO HOLDINGS LTD",
     "symbol": "EOHDF"
    },
    {
     "description": "EOH HOLDINGS LTD",
     "symbol": "EOHHF"
    },
    {
     "description": "EATON VANCE ENHANCED EQ INCM",
     "symbol": "EOI"
    },
    {
     "description": "EVOLUS INC",
     "symbol": "EOLS"
    },
    {
     "description": "E.ON SE -SPONSORED ADR",
     "symbol": "EONGY"
    },
    {
     "description": "EUROPA METALS LTD",
     "symbol": "EOPAF"
    },
    {
     "description": "EMLES ALPHA OPPORTUNITIES",
     "symbol": "EOPS"
    },
    {
     "description": "ELECTRO OPTIC SYSTEMS HOLDIN",
     "symbol": "EOPSF"
    },
    {
     "description": "ELECTRO OPTIC SYSTEM-SPN ADR",
     "symbol": "EOPSY"
    },
    {
     "description": "ORBITE TECHNOLOGIES INC",
     "symbol": "EORBF"
    },
    {
     "description": "EATON VANCE ENH EQT INC II",
     "symbol": "EOS"
    },
    {
     "description": "ELECTRO-OPTICAL SYSTEMS CORP",
     "symbol": "EOSC"
    },
    {
     "description": "EOS ENERGY ENTERPRISES INC",
     "symbol": "EOSE"
    },
    {
     "description": "B. RILEY PRINCIPAL MER -CW26",
     "symbol": "EOSEW"
    },
    {
     "description": "EOS INTERNATIONAL INC",
     "symbol": "EOSI"
    },
    {
     "description": "EOS INC",
     "symbol": "EOSS"
    },
    {
     "description": "EATON VANCE NATIONAL MUNICIP",
     "symbol": "EOT"
    },
    {
     "description": "AIRTRIP CORP",
     "symbol": "EOVBF"
    },
    {
     "description": "EUROMAX RESOURCES LTD",
     "symbol": "EOXFF"
    },
    {
     "description": "EMPIRE PETROLEUM CORP",
     "symbol": "EP"
    },
    {
     "description": "EL PASO ENERGY CAP TRST",
     "symbol": "EP.PRC"
    },
    {
     "description": "ENERPAC TOOL GROUP CORP",
     "symbol": "EPAC"
    },
    {
     "description": "EPAM SYSTEMS INC",
     "symbol": "EPAM"
    },
    {
     "description": "BOTTOMLINE TECHNOLOGIES (DE)",
     "symbol": "EPAY"
    },
    {
     "description": "EPAZZ INC",
     "symbol": "EPAZ"
    },
    {
     "description": "EDGEWELL PERSONAL CARE CO",
     "symbol": "EPC"
    },
    {
     "description": "EMPIRIC STUDENT PROPERTY PLC",
     "symbol": "EPCFF"
    },
    {
     "description": "ENTERPRISE PRODUCTS PARTNERS",
     "symbol": "EPD"
    },
    {
     "description": "E'PRIME AEROSPACE CORP",
     "symbol": "EPEO"
    },
    {
     "description": "ECOM PRODUCTS GROUP",
     "symbol": "EPGC"
    },
    {
     "description": "EMPIRE GLOBAL GAMING INC",
     "symbol": "EPGG"
    },
    {
     "description": "EPIGENOMICS AG",
     "symbol": "EPGNF"
    },
    {
     "description": "EPIGENOMICS AG-SPON ADR",
     "symbol": "EPGNY"
    },
    {
     "description": "ENVIRONMENTAL POWER CORP",
     "symbol": "EPGRQ"
    },
    {
     "description": "ISHARES MSCI PHILIPPINES ETF",
     "symbol": "EPHE"
    },
    {
     "description": "EPIPHANY TECHNOLOGY ACQ-CL A",
     "symbol": "EPHY"
    },
    {
     "description": "EPIPHANY TECHNOLOGY ACQUISIT",
     "symbol": "EPHYU"
    },
    {
     "description": "EPIPHANY TECHNOLOGY AC -CW27",
     "symbol": "EPHYW"
    },
    {
     "description": "WISDOMTREE INDIA EARNINGS",
     "symbol": "EPI"
    },
    {
     "description": "EPIROC AB-A",
     "symbol": "EPIAF"
    },
    {
     "description": "EPIROC AB-B",
     "symbol": "EPIPF"
    },
    {
     "description": "ESSA PHARMA INC",
     "symbol": "EPIX"
    },
    {
     "description": "EPS HOLDINGS INC",
     "symbol": "EPLYF"
    },
    {
     "description": "EVOLUTION PETROLEUM CORP",
     "symbol": "EPM"
    },
    {
     "description": "EPIROC AB-UNSP ADR",
     "symbol": "EPOKY"
    },
    {
     "description": "ISHARES MSCI POLAND ETF",
     "symbol": "EPOL"
    },
    {
     "description": "EPIC CORP",
     "symbol": "EPOR"
    },
    {
     "description": "Epic Corporation",
     "symbol": "EPORP"
    },
    {
     "description": "ISHARES MSCI PACIFIC EX JAPA",
     "symbol": "EPP"
    },
    {
     "description": "EPR PROPERTIES",
     "symbol": "EPR"
    },
    {
     "description": "EPR PROPERTIES",
     "symbol": "EPR.PRC"
    },
    {
     "description": "EPR PROPERTIES",
     "symbol": "EPR.PRE"
    },
    {
     "description": "EPR PROPERTIES",
     "symbol": "EPR.PRG"
    },
    {
     "description": "FIRST TRUST TCW ESG PREMIER",
     "symbol": "EPRE"
    },
    {
     "description": "INNOVAT S&P INVEST GRD PREF",
     "symbol": "EPRF"
    },
    {
     "description": "EMPEROR WATCH & JEWELLERY",
     "symbol": "EPRJF"
    },
    {
     "description": "EMPEROR INTL HLDG LTD",
     "symbol": "EPRRF"
    },
    {
     "description": "EPIRUS BIOPHARMACEUTICALS IN",
     "symbol": "EPRSQ"
    },
    {
     "description": "ESSENTIAL PROPERTIES REALTY",
     "symbol": "EPRT"
    },
    {
     "description": "EUPRAXIA PHARMACEUTICALS INC",
     "symbol": "EPRXF"
    },
    {
     "description": "WISDOMTREE US LARGE CAP FUND",
     "symbol": "EPS"
    },
    {
     "description": "EPISURF MEDICAL AB-B SHS",
     "symbol": "EPSFF"
    },
    {
     "description": "EPSILON ENERGY LTD",
     "symbol": "EPSN"
    },
    {
     "description": "ENVIRONMENTAL PACKAGING TECH",
     "symbol": "EPTI"
    },
    {
     "description": "ISHARES MSCI PERU ETF",
     "symbol": "EPU"
    },
    {
     "description": "PROSHARES ULTRASHORT FTSE EU",
     "symbol": "EPV"
    },
    {
     "description": "EMPOWER CLINICS INC",
     "symbol": "EPWCF"
    },
    {
     "description": "ELECTRIC POWER DEVELOPMENT C",
     "symbol": "EPWDF"
    },
    {
     "description": "EMPOWERMENT & INCLUSION-CL A",
     "symbol": "EPWR"
    },
    {
     "description": "EMPOWERMENT & INCLUSION CAPI",
     "symbol": "EPWR.U"
    },
    {
     "description": "EMPOWERMENT & INC CL A -CW27",
     "symbol": "EPWR.WS"
    },
    {
     "description": "EP&T GLOBAL LTD",
     "symbol": "EPXGF"
    },
    {
     "description": "EPLAY DIGITAL INC",
     "symbol": "EPYFF"
    },
    {
     "description": "EPIZYME INC",
     "symbol": "EPZM"
    },
    {
     "description": "EQUILLIUM INC",
     "symbol": "EQ"
    },
    {
     "description": "INVESCO RUSSELL 1000 EQUAL W",
     "symbol": "EQAL"
    },
    {
     "description": "EQT AB",
     "symbol": "EQBBF"
    },
    {
     "description": "EQUITY BANCSHARES INC - CL A",
     "symbol": "EQBK"
    },
    {
     "description": "MENSA MINING CORP",
     "symbol": "EQBM"
    },
    {
     "description": "EQUITY COMMONWEALTH",
     "symbol": "EQC"
    },
    {
     "description": "EQUITY COMMONWEALTH",
     "symbol": "EQC.PRD"
    },
    {
     "description": "EQUITY DISTRIBUTION ACQUIS-A",
     "symbol": "EQD"
    },
    {
     "description": "EQUITY DISTRIBUTION ACQUISIT",
     "symbol": "EQD.U"
    },
    {
     "description": "EQUITY DISTRIBUTION A -CW25",
     "symbol": "EQD.WS"
    },
    {
     "description": "EQUITABLE FINANCIAL CORP",
     "symbol": "EQFN"
    },
    {
     "description": "EQUITABLE GROUP INC",
     "symbol": "EQGPF"
    },
    {
     "description": "EQUITABLE HOLDINGS INC",
     "symbol": "EQH"
    },
    {
     "description": "EQUITABLE HOLDINGS INC",
     "symbol": "EQH.PRA"
    },
    {
     "description": "EQUITABLE HOLDINGS INC",
     "symbol": "EQH.PRC"
    },
    {
     "description": "EQ HEALTH ACQUISITION CORP-A",
     "symbol": "EQHA"
    },
    {
     "description": "EQ HEALTH ACQUISITION CORP",
     "symbol": "EQHA.U"
    },
    {
     "description": "EQ HEALTH ACQ A -CW28",
     "symbol": "EQHA.WS"
    },
    {
     "description": "EQUINIX INC",
     "symbol": "EQIX"
    },
    {
     "description": "EQK REALTY INVESTORS I",
     "symbol": "EQKR"
    },
    {
     "description": "ALPS EQUAL SECTOR WEIGHT ETF",
     "symbol": "EQL"
    },
    {
     "description": "EQ LABS INC",
     "symbol": "EQLB"
    },
    {
     "description": "EQUITY METALS CORP",
     "symbol": "EQMEF"
    },
    {
     "description": "EQUINOR ASA-SPON ADR",
     "symbol": "EQNR"
    },
    {
     "description": "NATIXIS US EQUITY OPPORT ETF",
     "symbol": "EQOP"
    },
    {
     "description": "EQONEX LTD",
     "symbol": "EQOS"
    },
    {
     "description": "EQUITY RESIDENTIAL",
     "symbol": "EQR"
    },
    {
     "description": "PROSHRS EQTY RISING RATE ETF",
     "symbol": "EQRR"
    },
    {
     "description": "EQRX INC",
     "symbol": "EQRX"
    },
    {
     "description": "EQRX INC -CW28",
     "symbol": "EQRXW"
    },
    {
     "description": "EQUUS TOTAL RETURN INC",
     "symbol": "EQS"
    },
    {
     "description": "EQT CORP",
     "symbol": "EQT"
    },
    {
     "description": "EQUAL TRADING INC",
     "symbol": "EQTD"
    },
    {
     "description": "EQM TECHNOLOGIES & ENERGY IN",
     "symbol": "EQTE"
    },
    {
     "description": "EQUITECH INTERNATIONAL CORP",
     "symbol": "EQTL"
    },
    {
     "description": "Equitrans Midstream Corporation",
     "symbol": "EQTNP"
    },
    {
     "description": "ALTAMIRA GOLD CORP",
     "symbol": "EQTRF"
    },
    {
     "description": "LAKE WINN RESOURCES CORP",
     "symbol": "EQTXF"
    },
    {
     "description": "EQUATORIAL ENERGIA SA-ADR",
     "symbol": "EQUEY"
    },
    {
     "description": "EQUIFIN INC",
     "symbol": "EQUI"
    },
    {
     "description": "IQ ENGENDER EQUALITY ETF",
     "symbol": "EQUL"
    },
    {
     "description": "E- QURE CORP",
     "symbol": "EQUR"
    },
    {
     "description": "INVESCO S&P 100 EQUAL WEIGHT",
     "symbol": "EQWL"
    },
    {
     "description": "EQUINOX GOLD CORP",
     "symbol": "EQX"
    },
    {
     "description": "ENERGY REVENUE AMERICA INC",
     "symbol": "ERAO"
    },
    {
     "description": "ERASCA INC",
     "symbol": "ERAS"
    },
    {
     "description": "AMERICAN GREEN INC",
     "symbol": "ERBB"
    },
    {
     "description": "ALLSPRING MULTI-SECTOR INCOM",
     "symbol": "ERC"
    },
    {
     "description": "SPDR MSCI EUROPE CON STAPLES",
     "symbol": "ERCTF"
    },
    {
     "description": "ERDENE RESOURCE DEVELOPMENT",
     "symbol": "ERDCF"
    },
    {
     "description": "EROAD LTD",
     "symbol": "ERDLF"
    },
    {
     "description": "EREGLI DEMIR VE CELIK-UN ADR",
     "symbol": "ERELY"
    },
    {
     "description": "ZONTE METALS INC",
     "symbol": "EREPF"
    },
    {
     "description": "EAST RESOURCES ACQUISITION-A",
     "symbol": "ERES"
    },
    {
     "description": "EAST RESOURCES ACQUISITION C",
     "symbol": "ERESU"
    },
    {
     "description": "EAST RESOURCES ACQUIS -CW27",
     "symbol": "ERESW"
    },
    {
     "description": "ENERPLUS CORP",
     "symbol": "ERF"
    },
    {
     "description": "ERF WIRELESS INC",
     "symbol": "ERFB"
    },
    {
     "description": "EUROFINS SCIENTIFIC",
     "symbol": "ERFSF"
    },
    {
     "description": "ERGO SCIENCE CORP",
     "symbol": "ERGN"
    },
    {
     "description": "ENTIA BIOSCIENCES INC",
     "symbol": "ERGO"
    },
    {
     "description": "ALLSPRING UTILITIES AND HIGH",
     "symbol": "ERH"
    },
    {
     "description": "ERHC ENERGY INC",
     "symbol": "ERHE"
    },
    {
     "description": "ERICSSON (LM) TEL-SP ADR",
     "symbol": "ERIC"
    },
    {
     "description": "ERIE INDEMNITY COMPANY-CL A",
     "symbol": "ERIE"
    },
    {
     "description": "ENERGY RECOVERY INC",
     "symbol": "ERII"
    },
    {
     "description": "DYNAMIC TECHNOLOGIES GROUP I",
     "symbol": "ERILF"
    },
    {
     "description": "ERIN ENERGY CORP",
     "symbol": "ERINQ"
    },
    {
     "description": "ERICSSON LM-B SHS",
     "symbol": "ERIXF"
    },
    {
     "description": "EMBRAER SA-SPON ADR",
     "symbol": "ERJ"
    },
    {
     "description": "EUREKA HOMESTEAD BANCORP INC",
     "symbol": "ERKH"
    },
    {
     "description": "ENTREE RESOURCES LTD",
     "symbol": "ERLFF"
    },
    {
     "description": "EQUITYCOMPASS RISK MNGR ETF",
     "symbol": "ERM"
    },
    {
     "description": "ERAMET",
     "symbol": "ERMAF"
    },
    {
     "description": "ERAMET-UNSPONSORED ADR",
     "symbol": "ERMAY"
    },
    {
     "description": "ERECORD MANAGEMENT INC",
     "symbol": "ERMG"
    },
    {
     "description": "EURONEXT NV-UNSP ADR",
     "symbol": "ERNXY"
    },
    {
     "description": "ERO COPPER CORP",
     "symbol": "ERO"
    },
    {
     "description": "EUROFINS SCIENTIFIC-NEW",
     "symbol": "EROFF"
    },
    {
     "description": "EROS RESOURCES CORP",
     "symbol": "EROSF"
    },
    {
     "description": "IPATH EUR\/USD EXCHANGE RATE",
     "symbol": "EROTF"
    },
    {
     "description": "HUMAN PHEROMONE SCIENCES INC",
     "symbol": "EROX"
    },
    {
     "description": "EUROPEAN METALS HLDS LT-CDI",
     "symbol": "ERPNF"
    },
    {
     "description": "EUROPEAN RELIANCE GEN INSURA",
     "symbol": "ERPRF"
    },
    {
     "description": "Emera Inc",
     "symbol": "ERRAF"
    },
    {
     "description": "EURO RESSOURCES SA",
     "symbol": "ERRSF"
    },
    {
     "description": "ERSHARES NEXTGEN ENTREPRENEU",
     "symbol": "ERSX"
    },
    {
     "description": "INVESCO MSCI SUSTAINABLE FUT",
     "symbol": "ERTH"
    },
    {
     "description": "EUROTECH SPA",
     "symbol": "ERTWF"
    },
    {
     "description": "ER URGENT CARE HOLDINGS INC",
     "symbol": "ERUC"
    },
    {
     "description": "ISHARES MSCI RUSSIA ETF",
     "symbol": "ERUS"
    },
    {
     "description": "ERIN VENTURES INC",
     "symbol": "ERVFF"
    },
    {
     "description": "ERRAWARRA RESOURCES LTD",
     "symbol": "ERWWF"
    },
    {
     "description": "DIREXION DAILY ENERGY BULL 2",
     "symbol": "ERX"
    },
    {
     "description": "EREX CO LTD",
     "symbol": "ERXCF"
    },
    {
     "description": "DIREXION DAILY ENERGY BEAR 2",
     "symbol": "ERY"
    },
    {
     "description": "ERYTECH PHARMA - SPON ADR",
     "symbol": "ERYP"
    },
    {
     "description": "EVERSOURCE ENERGY",
     "symbol": "ES"
    },
    {
     "description": "ESAB CORP",
     "symbol": "ESAB"
    },
    {
     "description": "ESGEN ACQUISITION CORP-A",
     "symbol": "ESAC"
    },
    {
     "description": "ESGEN ACQUISITION CORP",
     "symbol": "ESACU"
    },
    {
     "description": "ESGEN ACQUISITION A -CW23",
     "symbol": "ESACW"
    },
    {
     "description": "ESSITY AKTIEBOLAG-A",
     "symbol": "ESAKF"
    },
    {
     "description": "EISAI CO LTD",
     "symbol": "ESALF"
    },
    {
     "description": "EISAI CO LTD-SPONSORED ADR",
     "symbol": "ESALY"
    },
    {
     "description": "EMPIRE STATE REALTY OP LP-ES",
     "symbol": "ESBA"
    },
    {
     "description": "ELMIRA SAVINGS BANK",
     "symbol": "ESBK"
    },
    {
     "description": "ES BANCSHARES INC",
     "symbol": "ESBS"
    },
    {
     "description": "ESCALADE INC",
     "symbol": "ESCA"
    },
    {
     "description": "ESCON JAPAN REIT INVESTMENT",
     "symbol": "ESCNF"
    },
    {
     "description": "XTRACKERS BBG US IG CORP ESG",
     "symbol": "ESCR"
    },
    {
     "description": "Escalera Resources Company",
     "symbol": "ESCSQ"
    },
    {
     "description": "EAST SIDE FINANCIAL",
     "symbol": "ESDF"
    },
    {
     "description": "ESCO TECHNOLOGIES INC",
     "symbol": "ESE"
    },
    {
     "description": "EUROSEAS LTD",
     "symbol": "ESEA"
    },
    {
     "description": "X-TRACKERS J.P. MORGAN ESG E",
     "symbol": "ESEB"
    },
    {
     "description": "BNP P FTSE EPRA\/NAREIT EURO",
     "symbol": "ESEFF"
    },
    {
     "description": "ECO-SAFE SYSTEMS USA INC",
     "symbol": "ESFS"
    },
    {
     "description": "FLEXSHARES STOXX US ESG SELE",
     "symbol": "ESG"
    },
    {
     "description": "AMERICAN CENTURY SUSTAINABLE",
     "symbol": "ESGA"
    },
    {
     "description": "IQ MACKAY ESG CORE PLUS BOND",
     "symbol": "ESGB"
    },
    {
     "description": "EROS STX GLOBAL CORP",
     "symbol": "ESGC"
    },
    {
     "description": "ISHARES TRUST ISHARES ESG AW",
     "symbol": "ESGD"
    },
    {
     "description": "ISHARES INC ISHARES ESG AWAR",
     "symbol": "ESGE"
    },
    {
     "description": "ORA BANDA MINING LTD",
     "symbol": "ESGFF"
    },
    {
     "description": "FLEXSHARES STOXX GLOBAL ESG",
     "symbol": "ESGG"
    },
    {
     "description": "ENSURGE INC",
     "symbol": "ESGI"
    },
    {
     "description": "ENVIROGOLD GLOBAL LTD",
     "symbol": "ESGLF"
    },
    {
     "description": "COLUMBIA SUSTAIN INTL EQ ETF",
     "symbol": "ESGN"
    },
    {
     "description": "ENSTAR GROUP LTD",
     "symbol": "ESGR"
    },
    {
     "description": "ENSTAR GROUP LTD",
     "symbol": "ESGRO"
    },
    {
     "description": "ENSTAR GROUP LTD",
     "symbol": "ESGRP"
    },
    {
     "description": "COLUMBIA SUSTAIN US EQ I ETF",
     "symbol": "ESGS"
    },
    {
     "description": "ISHARES ESG AWARE MSCI USA",
     "symbol": "ESGU"
    },
    {
     "description": "VANGUARD ESG US STOCK ETF",
     "symbol": "ESGV"
    },
    {
     "description": "AMERICAN CENT SUST GROWTH",
     "symbol": "ESGY"
    },
    {
     "description": "ESPRIT HOLDINGS LTD",
     "symbol": "ESHDF"
    },
    {
     "description": "X-TRACKERS J.P. MORGAN ESG U",
     "symbol": "ESHY"
    },
    {
     "description": "ELEMENT SOLUTIONS INC",
     "symbol": "ESI"
    },
    {
     "description": "ESG GLOBAL IMPACT CAPITAL IN",
     "symbol": "ESIFF"
    },
    {
     "description": "ESI GROUP",
     "symbol": "ESIGF"
    },
    {
     "description": "ITT EDUCATIONAL SERVICES INC",
     "symbol": "ESINQ"
    },
    {
     "description": "ESSENTIAL INNOVATIONS TECH",
     "symbol": "ESIV"
    },
    {
     "description": "SPDR S&P SMALLCAP 600 ESG",
     "symbol": "ESIX"
    },
    {
     "description": "ESKER SA",
     "symbol": "ESKEF"
    },
    {
     "description": "ETHERSTACK PLC-CDI",
     "symbol": "ESKKF"
    },
    {
     "description": "ESKEN LTD",
     "symbol": "ESKNF"
    },
    {
     "description": "EUSKALTEL SA",
     "symbol": "ESKTF"
    },
    {
     "description": "ESKAY MINING CORP",
     "symbol": "ESKYF"
    },
    {
     "description": "LOGISTICS DEVELOPMENT GROUP",
     "symbol": "ESLGF"
    },
    {
     "description": "ESSILORLUXOTTICA",
     "symbol": "ESLOF"
    },
    {
     "description": "ESSILORLUXOT-UNSPON ADR",
     "symbol": "ESLOY"
    },
    {
     "description": "EURO SOLAR PARKS INC",
     "symbol": "ESLP"
    },
    {
     "description": "ELBIT SYSTEMS LTD",
     "symbol": "ESLT"
    },
    {
     "description": "ESM ACQUISITION CORP-A",
     "symbol": "ESM"
    },
    {
     "description": "ESM ACQUISITION CORP",
     "symbol": "ESM.U"
    },
    {
     "description": "ESM ACQUISITION CL A -CW26",
     "symbol": "ESM.WS"
    },
    {
     "description": "ESPORTS MOGUL LTD",
     "symbol": "ESMAF"
    },
    {
     "description": "ESCALON MEDICAL CORP",
     "symbol": "ESMC"
    },
    {
     "description": "ISHARES ESG AWARE MSCI USA S",
     "symbol": "ESML"
    },
    {
     "description": "ENGAGESMART INC",
     "symbol": "ESMT"
    },
    {
     "description": "ISHARES ESG MSCI USA MIN VOL",
     "symbol": "ESMV"
    },
    {
     "description": "ENSYNC INC",
     "symbol": "ESNC"
    },
    {
     "description": "ELECTRONIC SENSOR TECHNOLOGY",
     "symbol": "ESNR"
    },
    {
     "description": "ESSENT GROUP LTD",
     "symbol": "ESNT"
    },
    {
     "description": "ENERGY SERVICES OF AMERICA",
     "symbol": "ESOA"
    },
    {
     "description": "ENEL SPA",
     "symbol": "ESOCF"
    },
    {
     "description": "ESPEY MFG & ELECTRONICS CORP",
     "symbol": "ESP"
    },
    {
     "description": "ESPRIT HOLDINGS LTD-SPON ADR",
     "symbol": "ESPGY"
    },
    {
     "description": "ESP RESOURCES INC",
     "symbol": "ESPI"
    },
    {
     "description": "VANECK VIDEOGAMING ESPORTS",
     "symbol": "ESPO"
    },
    {
     "description": "ESPERION THERAPEUTICS INC",
     "symbol": "ESPR"
    },
    {
     "description": "ESQUIRE FINANCIAL HOLDINGS I",
     "symbol": "ESQ"
    },
    {
     "description": "ESECURESOFT CO",
     "symbol": "ESQF"
    },
    {
     "description": "ESR CAYMAN LTD",
     "symbol": "ESRCF"
    },
    {
     "description": "EMPIRE STATE REALTY TRUST-A",
     "symbol": "ESRT"
    },
    {
     "description": "ESSEX PROPERTY TRUST INC",
     "symbol": "ESS"
    },
    {
     "description": "ESSA BANCORP INC",
     "symbol": "ESSA"
    },
    {
     "description": "EAST STONE ACQUISITION CORP",
     "symbol": "ESSC"
    },
    {
     "description": "EAST STONE ACQUISITION-RIGHT",
     "symbol": "ESSCR"
    },
    {
     "description": "EAST STONE ACQUISITION -UNIT",
     "symbol": "ESSCU"
    },
    {
     "description": "EAST STONE ACQUISITION -CW26",
     "symbol": "ESSCW"
    },
    {
     "description": "EARTH SEARCH SCIENCES INC",
     "symbol": "ESSE"
    },
    {
     "description": "ECO SCIENCE SOLUTIONS INC",
     "symbol": "ESSI"
    },
    {
     "description": "ESTABLISHMENT LABS HOLDINGS",
     "symbol": "ESTA"
    },
    {
     "description": "ELASTIC NV",
     "symbol": "ESTC"
    },
    {
     "description": "EARTHSTONE ENERGY INC - A",
     "symbol": "ESTE"
    },
    {
     "description": "ESTRE AMBIENTAL INC",
     "symbol": "ESTRF"
    },
    {
     "description": "ESTORE CORP",
     "symbol": "ESTTF"
    },
    {
     "description": "ESTRE AMBIENTAL INC-CW20",
     "symbol": "ESTWF"
    },
    {
     "description": "ESTRACS 2X LEV MSCI US ESG",
     "symbol": "ESUS"
    },
    {
     "description": "ENSIGN ENERGY SERVICES INC",
     "symbol": "ESVIF"
    },
    {
     "description": "E79 RESOURCES CORP",
     "symbol": "ESVNF"
    },
    {
     "description": "ENVIRO SOLUTIONS WORLDWIDE",
     "symbol": "ESWW"
    },
    {
     "description": "ESSEX MINERALS INC",
     "symbol": "ESXMF"
    },
    {
     "description": "EASYJET PLC-SPON ADR",
     "symbol": "ESYJY"
    },
    {
     "description": "EASYLINK SOLUTIONS CORP",
     "symbol": "ESYL"
    },
    {
     "description": "ESSENSYS GROUP LTD",
     "symbol": "ESYSF"
    },
    {
     "description": "EASY SOFTWARE AG",
     "symbol": "ESYYF"
    },
    {
     "description": "ENERGY TRANSFER LP",
     "symbol": "ET"
    },
    {
     "description": "ENERGY TRANSFER LP",
     "symbol": "ET.PRC"
    },
    {
     "description": "ENERGY TRANSFER LP",
     "symbol": "ET.PRD"
    },
    {
     "description": "ENERGY TRANSFER LP",
     "symbol": "ET.PRE"
    },
    {
     "description": "E.MERGE TECHNOLOGY ACQUISI-A",
     "symbol": "ETAC"
    },
    {
     "description": "E.MERGE TECHNOLOGY ACQUISITI",
     "symbol": "ETACU"
    },
    {
     "description": "E.MERGE TECHNOLOGY ACQ -CW25",
     "symbol": "ETACW"
    },
    {
     "description": "ENTERTAINMENT ARTS INC",
     "symbol": "ETAR"
    },
    {
     "description": "EATON VANCE T\/M BUY-WR IN",
     "symbol": "ETB"
    },
    {
     "description": "EASTGATE BIOTECH CORP",
     "symbol": "ETBI"
    },
    {
     "description": "ENVIRONMENTAL TECTONICS CORP",
     "symbol": "ETCC"
    },
    {
     "description": "GRAYSCALE ETHEREUM CLASSIC T",
     "symbol": "ETCG"
    },
    {
     "description": "ELECTR TELE-COMMUNCTN",
     "symbol": "ETCIA"
    },
    {
     "description": "ENERTECK CORP",
     "symbol": "ETCK"
    },
    {
     "description": "EUTELSAT COMMUNICAT-SPON ADR",
     "symbol": "ETCMY"
    },
    {
     "description": "ETHAN ALLEN INTERIORS INC",
     "symbol": "ETD"
    },
    {
     "description": "EMTEC INC",
     "symbol": "ETEC"
    },
    {
     "description": "ECO-TEK GROUP INC",
     "symbol": "ETEK"
    },
    {
     "description": "ENTERRA CORP",
     "symbol": "ETER"
    },
    {
     "description": "WT GOLD",
     "symbol": "ETFBF"
    },
    {
     "description": "EASTFIELD RESOURCES LTD",
     "symbol": "ETFLF"
    },
    {
     "description": "EATON VANCE T\/A GL DVD INCM",
     "symbol": "ETG"
    },
    {
     "description": "GRAYSCALE ETHEREUM TRUST",
     "symbol": "ETHE"
    },
    {
     "description": "ETHO CLIMATE LEADERSHIP ETF",
     "symbol": "ETHO"
    },
    {
     "description": "PROSPECTOR METALS CORP",
     "symbol": "ETHOD"
    },
    {
     "description": "ENTERGY TEXAS INC",
     "symbol": "ETI.PR"
    },
    {
     "description": "ENVIROTECHNOLOGIES INTERNATI",
     "symbol": "ETII"
    },
    {
     "description": "UNBOUND GROUP PLC",
     "symbol": "ETIVF"
    },
    {
     "description": "EATON VANCE RISK-MANAGED DIV",
     "symbol": "ETJ"
    },
    {
     "description": "EAST KANSAS AGRI-ENERGY-CL C",
     "symbol": "ETKKU"
    },
    {
     "description": "EAST KANSAS AGRI-ENERGY-CL B",
     "symbol": "ETKNU"
    },
    {
     "description": "EVOLUTION TECHNOLOGY RESOURC",
     "symbol": "ETKR"
    },
    {
     "description": "WT PHYSICAL SILVER",
     "symbol": "ETMLF"
    },
    {
     "description": "EATON CORP PLC",
     "symbol": "ETN"
    },
    {
     "description": "89BIO INC",
     "symbol": "ETNB"
    },
    {
     "description": "ENTEST GROUP INC",
     "symbol": "ETNI"
    },
    {
     "description": "EATON VANCE TAX ADV GL DVD O",
     "symbol": "ETO"
    },
    {
     "description": "ENTERPRISE GROUP INC",
     "symbol": "ETOLF"
    },
    {
     "description": "ETON PHARMACEUTICALS INC",
     "symbol": "ETON"
    },
    {
     "description": "AGRIMINCO CORP",
     "symbol": "ETPHF"
    },
    {
     "description": "ENTERGY CORP",
     "symbol": "ETR"
    },
    {
     "description": "ENTOURAGE HEALTH CORP",
     "symbol": "ETRGF"
    },
    {
     "description": "EQUITRANS MIDSTREAM CORP",
     "symbol": "ETRN"
    },
    {
     "description": "ETRUSCUS RESOURCES CORP",
     "symbol": "ETRUF"
    },
    {
     "description": "ETRION CORP",
     "symbol": "ETRXF"
    },
    {
     "description": "WT PHYSICAL PLATINUM",
     "symbol": "ETSLF"
    },
    {
     "description": "EARTH SCIENCE TECH INC",
     "symbol": "ETST"
    },
    {
     "description": "ETSY INC",
     "symbol": "ETSY"
    },
    {
     "description": "WT CORN",
     "symbol": "ETSYF"
    },
    {
     "description": "ENTASIS THERAPEUTICS HOLDING",
     "symbol": "ETTX"
    },
    {
     "description": "ESSITY AKTIEBOLAG-B",
     "symbol": "ETTYF"
    },
    {
     "description": "E2GOLD INC",
     "symbol": "ETUGF"
    },
    {
     "description": "EATON VANCE T\/M BUY-WRITE OP",
     "symbol": "ETV"
    },
    {
     "description": "EATON VANCE TAX MAN GLBL BR",
     "symbol": "ETW"
    },
    {
     "description": "E2OPEN PARENT HOLDINGS INC",
     "symbol": "ETWO"
    },
    {
     "description": "CC NEUBERGER PRINCIPAL -CW25",
     "symbol": "ETWO.WS"
    },
    {
     "description": "EATON VANCE MUNI INC 2028 TM",
     "symbol": "ETX"
    },
    {
     "description": "E-THERAPEUTICS PLC",
     "symbol": "ETXPF"
    },
    {
     "description": "EATON VANCE TAX-MANAGED DIVE",
     "symbol": "ETY"
    },
    {
     "description": "ENTREPRENEUR UNIVERSE BRIGHT",
     "symbol": "EUBG"
    },
    {
     "description": "EUCLID CAPITAL GROWTH ETF",
     "symbol": "EUCG"
    },
    {
     "description": "EUROCOMMERCIAL PROPERTIE-CV",
     "symbol": "EUCMF"
    },
    {
     "description": "EUCRATES BIOMEDICAL ACQUISIT",
     "symbol": "EUCR"
    },
    {
     "description": "EUCRATES BIOMEDICAL ACQUISIT",
     "symbol": "EUCRU"
    },
    {
     "description": "EUCRATES BIOMEDICAL ACQ-CW25",
     "symbol": "EUCRW"
    },
    {
     "description": "WISDOMTREE EUROPE QUALITY DI",
     "symbol": "EUDG"
    },
    {
     "description": "PROSHARES MSCI EUROPE DIVIDE",
     "symbol": "EUDV"
    },
    {
     "description": "ISHARES MSCI EUROPE FINANCIA",
     "symbol": "EUFN"
    },
    {
     "description": "PROSHARES SHORT EURO ETF",
     "symbol": "EUFX"
    },
    {
     "description": "EUROCASTLE INVESTMENT LTD",
     "symbol": "EUIVF"
    },
    {
     "description": "EUROPEAN LITHIUM LTD",
     "symbol": "EULIF"
    },
    {
     "description": "PROSHARES SHORT MSCI EMR MKT",
     "symbol": "EUM"
    },
    {
     "description": "EURO MANGANESE INC",
     "symbol": "EUMNF"
    },
    {
     "description": "PROSHARES ULTRASHORT EURO",
     "symbol": "EUO"
    },
    {
     "description": "EUROTECH LTD",
     "symbol": "EUOT"
    },
    {
     "description": "AGRIEURO CORP",
     "symbol": "EURI"
    },
    {
     "description": "DRX DLY FTSE EUROPE BULL 3X",
     "symbol": "EURL"
    },
    {
     "description": "EUROPCAR MOBILITY GROUP",
     "symbol": "EURMF"
    },
    {
     "description": "EURONAV NV",
     "symbol": "EURN"
    },
    {
     "description": "ISHARES MSCI USA EQUAL WEIGH",
     "symbol": "EUSA"
    },
    {
     "description": "ISHARES ESG ADV TOT USD BOND",
     "symbol": "EUSB"
    },
    {
     "description": "WISDOMTREE EUROPE HEDG SM EQ",
     "symbol": "EUSC"
    },
    {
     "description": "EUROCASH SA",
     "symbol": "EUSHF"
    },
    {
     "description": "EUROCASH SA-UNSP ADR",
     "symbol": "EUSHY"
    },
    {
     "description": "EUROSITE POWER INC",
     "symbol": "EUSP"
    },
    {
     "description": "EUTELSAT COMMUNICATIONS",
     "symbol": "EUTLF"
    },
    {
     "description": "AZARGA METALS CORP",
     "symbol": "EUUNF"
    },
    {
     "description": "EURONEXT NV",
     "symbol": "EUXTF"
    },
    {
     "description": "EURAZEO SE",
     "symbol": "EUZOF"
    },
    {
     "description": "ENVIVA INC",
     "symbol": "EVA"
    },
    {
     "description": "EGF THERAMED HEALTH CORP",
     "symbol": "EVAHF"
    },
    {
     "description": "ELVA INTERNATIONAL INC",
     "symbol": "EVAI"
    },
    {
     "description": "LOMBARD MEDICAL INC",
     "symbol": "EVARF"
    },
    {
     "description": "EVAXION BIOTECH A\/S",
     "symbol": "EVAX"
    },
    {
     "description": "EVOLUTION BLOCKCHAIN GROUP I",
     "symbol": "EVBC"
    },
    {
     "description": "EVERBRIDGE INC",
     "symbol": "EVBG"
    },
    {
     "description": "EVANS BANCORP INC",
     "symbol": "EVBN"
    },
    {
     "description": "ENTRAVISION COMMUNICATIONS-A",
     "symbol": "EVC"
    },
    {
     "description": "EVCI CAREER COLLEGES HOLDING",
     "symbol": "EVCI"
    },
    {
     "description": "EVERCOMMERCE INC",
     "symbol": "EVCM"
    },
    {
     "description": "EVE MOBILITY ACQUISITION C-A",
     "symbol": "EVE"
    },
    {
     "description": "EVE MOBILITY ACQUISITION COR",
     "symbol": "EVE.U"
    },
    {
     "description": "EVE MOBILITY ACQUISIT A -23",
     "symbol": "EVE.WS"
    },
    {
     "description": "DIREXION DAILY S&P EQ W B2X",
     "symbol": "EVEN"
    },
    {
     "description": "EVOLVE EDUCATION GROUP LTD",
     "symbol": "EVEOF"
    },
    {
     "description": "EVERQUOTE INC - CLASS A",
     "symbol": "EVER"
    },
    {
     "description": "EATON VANCE SENIOR INCOME TR",
     "symbol": "EVF"
    },
    {
     "description": "EVOFEM BIOSCIENCES INC",
     "symbol": "EVFM"
    },
    {
     "description": "EATON VANCE SHORT DUR DIV IN",
     "symbol": "EVG"
    },
    {
     "description": "EATON VANCE GBL INC BLDR NS",
     "symbol": "EVGBC"
    },
    {
     "description": "ELEVATION GOLD MINING CORP",
     "symbol": "EVGDF"
    },
    {
     "description": "EVERGREEN GAMING CORP",
     "symbol": "EVGEF"
    },
    {
     "description": "EVOLUTION AB",
     "symbol": "EVGGF"
    },
    {
     "description": "EVERGEN INFRASTRUCTURE CORP",
     "symbol": "EVGIF"
    },
    {
     "description": "EVOGENE LTD",
     "symbol": "EVGN"
    },
    {
     "description": "EVGO INC",
     "symbol": "EVGO"
    },
    {
     "description": "CLIMATE CHANGE CRISIS -CW25",
     "symbol": "EVGOW"
    },
    {
     "description": "EVERGRANDE PROPERTY SERVICES",
     "symbol": "EVGPF"
    },
    {
     "description": "EVERGRANDE PROP - UNSP ADR",
     "symbol": "EVGPY"
    },
    {
     "description": "EVERGREEN CORPORATION - CL A",
     "symbol": "EVGR"
    },
    {
     "description": "CHINA EVERGRANDE NEW ENERGY",
     "symbol": "EVGRF"
    },
    {
     "description": "EVERGREEN CORP",
     "symbol": "EVGRU"
    },
    {
     "description": "EVERGREEN CORPORATION -CW27",
     "symbol": "EVGRW"
    },
    {
     "description": "EVERGOLD CORP",
     "symbol": "EVGUF"
    },
    {
     "description": "EVOLENT HEALTH INC - A",
     "symbol": "EVH"
    },
    {
     "description": "EVENT HOSPITALITY AND ENTERT",
     "symbol": "EVHEF"
    },
    {
     "description": "EVI INDUSTRIES INC",
     "symbol": "EVI"
    },
    {
     "description": "EVIO INC",
     "symbol": "EVIO"
    },
    {
     "description": "VelocityShares 1x Long VSTOXX Futures ETN",
     "symbol": "EVIX"
    },
    {
     "description": "EVER-GLORY INTERNATIONAL GRO",
     "symbol": "EVK"
    },
    {
     "description": "EVONIK INDUSTRIES AG",
     "symbol": "EVKIF"
    },
    {
     "description": "EVONIK INDUSTRIES-UNSP ADR",
     "symbol": "EVKIY"
    },
    {
     "description": "EVERLERT INC",
     "symbol": "EVLI"
    },
    {
     "description": "ENVIROMETAL TECHNOLOGIES INC",
     "symbol": "EVLLF"
    },
    {
     "description": "EATON VANCE TABS 5-15 LDR MU",
     "symbol": "EVLMC"
    },
    {
     "description": "EVELO BIOSCIENCES INC",
     "symbol": "EVLO"
    },
    {
     "description": "EVOLV TECHNOLOGIES HOLDINGS",
     "symbol": "EVLV"
    },
    {
     "description": "NEWHOLD INVESTMENT A -CW26",
     "symbol": "EVLVW"
    },
    {
     "description": "EATON VANCE CAL MUNI BOND",
     "symbol": "EVM"
    },
    {
     "description": "EATON VANCE MUNICIPAL INCOME",
     "symbol": "EVN"
    },
    {
     "description": "EVIANA HEALTH CORP",
     "symbol": "EVNNF"
    },
    {
     "description": "ALTSHARES EVENT-DRIVEN ETF",
     "symbol": "EVNT"
    },
    {
     "description": "EVN AG-SP ADR",
     "symbol": "EVNVY"
    },
    {
     "description": "EVOTEC SE - SPON ADR",
     "symbol": "EVO"
    },
    {
     "description": "EVO TRANSPORTATION & ENERGY",
     "symbol": "EVOA"
    },
    {
     "description": "EVOLVING GOLD CORP",
     "symbol": "EVOGF"
    },
    {
     "description": "EVO ACQUISITION CORP-A",
     "symbol": "EVOJ"
    },
    {
     "description": "EVO ACQUISITION CORP",
     "symbol": "EVOJU"
    },
    {
     "description": "EVO ACQUISITION A -CW27",
     "symbol": "EVOJW"
    },
    {
     "description": "EVOKE PHARMA INC",
     "symbol": "EVOK"
    },
    {
     "description": "EVOLVING SYSTEMS INC",
     "symbol": "EVOL"
    },
    {
     "description": "EVO PAYMENTS INC-CLASS A",
     "symbol": "EVOP"
    },
    {
     "description": "EVOTEC SE",
     "symbol": "EVOTF"
    },
    {
     "description": "EVERCORE INC - A",
     "symbol": "EVR"
    },
    {
     "description": "EVERCEL INC",
     "symbol": "EVRC"
    },
    {
     "description": "EVERARC HOLDINGS LTD",
     "symbol": "EVREF"
    },
    {
     "description": "EVERFUEL A\/S",
     "symbol": "EVRFF"
    },
    {
     "description": "EVERGY INC",
     "symbol": "EVRG"
    },
    {
     "description": "EVERI HOLDINGS INC",
     "symbol": "EVRI"
    },
    {
     "description": "EVEROCK INC",
     "symbol": "EVRN"
    },
    {
     "description": "MOLECULE HOLDINGS INC",
     "symbol": "EVRRF"
    },
    {
     "description": "EVRAZ PLC",
     "symbol": "EVRZF"
    },
    {
     "description": "EVS BROADCAST EQUIPMENT-ADR",
     "symbol": "EVSBY"
    },
    {
     "description": "EVE SLEEP PLC",
     "symbol": "EVSLF"
    },
    {
     "description": "EVOLUTION SOLAR CORP",
     "symbol": "EVSO"
    },
    {
     "description": "GLAS-AIRE INDUSTRIES GROUP",
     "symbol": "EVSP"
    },
    {
     "description": "ENVIROSUITE LTD",
     "symbol": "EVSSF"
    },
    {
     "description": "EATON VANCE STOCK NEXTSHARES",
     "symbol": "EVSTC"
    },
    {
     "description": "ENVIRO SERV INC",
     "symbol": "EVSV"
    },
    {
     "description": "EATON VANCE TAX-ADV DVD INC",
     "symbol": "EVT"
    },
    {
     "description": "EVERTEC INC",
     "symbol": "EVTC"
    },
    {
     "description": "EVENTURE INTERACTIVE INC",
     "symbol": "EVTI"
    },
    {
     "description": "EVENTIKO INC",
     "symbol": "EVTK"
    },
    {
     "description": "VERTICAL AEROSPACE LTD",
     "symbol": "EVTL"
    },
    {
     "description": "VERTICAL AEROSPACE LTD -CW26",
     "symbol": "EVTL.WS"
    },
    {
     "description": "ENVIRO TECHNOLOGIES US INC",
     "symbol": "EVTN"
    },
    {
     "description": "EVIATION AIRCRAFT LTD",
     "symbol": "EVTNF"
    },
    {
     "description": "EV TRANSPORTATION INC",
     "symbol": "EVTP"
    },
    {
     "description": "ENVIROTECH VEHICLES INC",
     "symbol": "EVTV"
    },
    {
     "description": "EVERTZ TECHNOLOGIES LTD",
     "symbol": "EVTZF"
    },
    {
     "description": "EATON VANCE LTD DURATION FND",
     "symbol": "EVV"
    },
    {
     "description": "EVOLUTION AB-ADR",
     "symbol": "EVVTY"
    },
    {
     "description": "VANECK ENVIRONMENTAL SERVICE",
     "symbol": "EVX"
    },
    {
     "description": "EUROPEAN ELECTRIC METALS INC",
     "symbol": "EVXXF"
    },
    {
     "description": "EDWARDS LIFESCIENCES CORP",
     "symbol": "EW"
    },
    {
     "description": "ISHARES MSCI AUSTRALIA ETF",
     "symbol": "EWA"
    },
    {
     "description": "EAST WEST BANCORP INC",
     "symbol": "EWBC"
    },
    {
     "description": "ISHARES MSCI CANADA ETF",
     "symbol": "EWC"
    },
    {
     "description": "ENERGY WORLD CORP LTD",
     "symbol": "EWCLF"
    },
    {
     "description": "INVESCO S&P 500 EQUAL WEIG C",
     "symbol": "EWCO"
    },
    {
     "description": "EUROPEAN WAX CENTER INC-A",
     "symbol": "EWCZ"
    },
    {
     "description": "ISHARES MSCI SWEDEN ETF",
     "symbol": "EWD"
    },
    {
     "description": "GLOBAL X EM INTERNET & ECOMM",
     "symbol": "EWEB"
    },
    {
     "description": "ISHARES MSCI GERMANY ETF",
     "symbol": "EWG"
    },
    {
     "description": "EAT WELL INVESTMENT GROUP IN",
     "symbol": "EWGFF"
    },
    {
     "description": "ISHARES MSCI GERMANY SMALL-C",
     "symbol": "EWGS"
    },
    {
     "description": "ISHARES MSCI HONG KONG ETF",
     "symbol": "EWH"
    },
    {
     "description": "ISHARES MSCI ITALY ETF",
     "symbol": "EWI"
    },
    {
     "description": "ISHARES MSCI JAPAN ETF",
     "symbol": "EWJ"
    },
    {
     "description": "ISHARES MSCI JAPAN EQL WGHT",
     "symbol": "EWJE"
    },
    {
     "description": "ISHARES MSCI JAPAN VALUE ETF",
     "symbol": "EWJV"
    },
    {
     "description": "ISHARES MSCI BELGIUM ETF",
     "symbol": "EWK"
    },
    {
     "description": "EARTHWORKS ENTERTAINMENT INC",
     "symbol": "EWKS"
    },
    {
     "description": "ISHARES MSCI SWITZERLAND ETF",
     "symbol": "EWL"
    },
    {
     "description": "EWELLNESS HEALTHCARE CORP",
     "symbol": "EWLL"
    },
    {
     "description": "MERION INC",
     "symbol": "EWLU"
    },
    {
     "description": "ISHARES MSCI MALAYSIA ETF",
     "symbol": "EWM"
    },
    {
     "description": "INVESCO S&P MIDCAP 400 EQUAL",
     "symbol": "EWMC"
    },
    {
     "description": "ISHARES MSCI NETHERLANDS ETF",
     "symbol": "EWN"
    },
    {
     "description": "ISHARES MSCI AUSTRIA ETF",
     "symbol": "EWO"
    },
    {
     "description": "EASTWOOD BIO-MEDICAL CANADA",
     "symbol": "EWOOF"
    },
    {
     "description": "ISHARES MSCI SPAIN ETF",
     "symbol": "EWP"
    },
    {
     "description": "EMERGING WORLD PHARMA INC",
     "symbol": "EWPI"
    },
    {
     "description": "EAST WEST PETROLEUM CORP",
     "symbol": "EWPMF"
    },
    {
     "description": "ISHARES MSCI FRANCE ETF",
     "symbol": "EWQ"
    },
    {
     "description": "INVESCO NASDAQ 100 ACC",
     "symbol": "EWQQF"
    },
    {
     "description": "EWORLD COS INC",
     "symbol": "EWRC"
    },
    {
     "description": "INVESCO S&P 500 EQUAL WEIGHT",
     "symbol": "EWRE"
    },
    {
     "description": "ISHARES MSCI SINGAPORE ETF",
     "symbol": "EWS"
    },
    {
     "description": "INVESCO S&P SMALLCAP 600 EQU",
     "symbol": "EWSC"
    },
    {
     "description": "ISHARES MSCI TAIWAN ETF",
     "symbol": "EWT"
    },
    {
     "description": "EDGEWISE THERAPEUTICS INC",
     "symbol": "EWTX"
    },
    {
     "description": "ISHARES MSCI UNITED KINGDOM",
     "symbol": "EWU"
    },
    {
     "description": "ISHARES MSCI UNITED KINGDOM",
     "symbol": "EWUS"
    },
    {
     "description": "PROSHARES ULTSHRT MSCI JAPAN",
     "symbol": "EWV"
    },
    {
     "description": "ISHARES MSCI MEXICO ETF",
     "symbol": "EWW"
    },
    {
     "description": "SPDR S&P EMERGING MKTS SMALL",
     "symbol": "EWX"
    },
    {
     "description": "ISHARES MSCI SOUTH KOREA ETF",
     "symbol": "EWY"
    },
    {
     "description": "ISHARES MSCI BRAZIL ETF",
     "symbol": "EWZ"
    },
    {
     "description": "ISHARES MSCI BRAZIL SMALL-CA",
     "symbol": "EWZS"
    },
    {
     "description": "EXSCIENTIA PLC",
     "symbol": "EXAI"
    },
    {
     "description": "EXACT SCIENCES CORP",
     "symbol": "EXAS"
    },
    {
     "description": "EXOBOX TECHNOLOGIES CORP",
     "symbol": "EXBX"
    },
    {
     "description": "EXELON CORP",
     "symbol": "EXC"
    },
    {
     "description": "EXCEL CORP",
     "symbol": "EXCC"
    },
    {
     "description": "EXCO RESOURCES INC",
     "symbol": "EXCE"
    },
    {
     "description": "EXCHANGE BANKSHARES INC",
     "symbol": "EXCH"
    },
    {
     "description": "EXCELLERANT INC",
     "symbol": "EXCL"
    },
    {
     "description": "EXCELLENCE OPTO INC",
     "symbol": "EXCLF"
    },
    {
     "description": "EXCO TECHNOLOGIES LTD",
     "symbol": "EXCOF"
    },
    {
     "description": "EATON VANCE TAX-MGD B\/W STR",
     "symbol": "EXD"
    },
    {
     "description": "EXCEED WORLD INC",
     "symbol": "EXDW"
    },
    {
     "description": "EXELIXIS INC",
     "symbol": "EXEL"
    },
    {
     "description": "EXEO ENTERTAINMENT INC",
     "symbol": "EXEO"
    },
    {
     "description": "EXACT ENERGY RESOURCES INC",
     "symbol": "EXER"
    },
    {
     "description": "EXTENDICARE INC",
     "symbol": "EXETF"
    },
    {
     "description": "EXPENSIFY INC - A",
     "symbol": "EXFY"
    },
    {
     "description": "EATON VANCE TAX-MANAGED GLOB",
     "symbol": "EXG"
    },
    {
     "description": "EXLITES HOLDINGS INTERNATION",
     "symbol": "EXHI"
    },
    {
     "description": "ISHARES GLOBAL INDUSTRIALS E",
     "symbol": "EXI"
    },
    {
     "description": "ENDEAVOUR SILVER CORP",
     "symbol": "EXK"
    },
    {
     "description": "EXLA RESOURCES INC",
     "symbol": "EXLA"
    },
    {
     "description": "EXASOL AG",
     "symbol": "EXLGF"
    },
    {
     "description": "EXCELLENCE COMMERCIAL PROPER",
     "symbol": "EXLMF"
    },
    {
     "description": "EXLSERVICE HOLDINGS INC",
     "symbol": "EXLS"
    },
    {
     "description": "EXCELSIOR MINING CORP",
     "symbol": "EXMGF"
    },
    {
     "description": "EXMAR NV",
     "symbol": "EXMRF"
    },
    {
     "description": "ANYTHING TECHNOLOGIES MEDIA",
     "symbol": "EXMT"
    },
    {
     "description": "MYND ANALYTICS INC-CW22",
     "symbol": "EXMWW"
    },
    {
     "description": "DROPSUITE LTD",
     "symbol": "EXMXF"
    },
    {
     "description": "EXCELLON RESOURCES INC",
     "symbol": "EXN"
    },
    {
     "description": "EXENT CORP",
     "symbol": "EXNN"
    },
    {
     "description": "EXODUS MOVEMENT INC - A",
     "symbol": "EXOD"
    },
    {
     "description": "EXOPHARM LTD",
     "symbol": "EXOPF"
    },
    {
     "description": "EAGLE MATERIALS INC",
     "symbol": "EXP"
    },
    {
     "description": "EXPEDITORS INTL WASH INC",
     "symbol": "EXPD"
    },
    {
     "description": "EXPEDIA GROUP INC",
     "symbol": "EXPE"
    },
    {
     "description": "EXPERIAN PLC",
     "symbol": "EXPGF"
    },
    {
     "description": "EXPERIAN PLC-SPONS ADR",
     "symbol": "EXPGY"
    },
    {
     "description": "EXPO HOLDING INC",
     "symbol": "EXPH"
    },
    {
     "description": "EXP WORLD HOLDINGS INC",
     "symbol": "EXPI"
    },
    {
     "description": "ENDURANCE EXPLORATION GROUP",
     "symbol": "EXPL"
    },
    {
     "description": "EXPONENT INC",
     "symbol": "EXPO"
    },
    {
     "description": "EXPRESS INC",
     "symbol": "EXPR"
    },
    {
     "description": "EXTRA SPACE STORAGE INC",
     "symbol": "EXR"
    },
    {
     "description": "ECOLOGIX RESOURCE GROUP INC",
     "symbol": "EXRG"
    },
    {
     "description": "EXRO TECHNOLOGIES INC",
     "symbol": "EXROF"
    },
    {
     "description": "CONSOLIDATED ECO-SYSTEMS INC",
     "symbol": "EXSO"
    },
    {
     "description": "EXPERT.AI SPA",
     "symbol": "EXSPF"
    },
    {
     "description": "EXCHANGE BANK SANTA ROSA CAL",
     "symbol": "EXSR"
    },
    {
     "description": "ISHARES STOXX EUROPE 50",
     "symbol": "EXTDF"
    },
    {
     "description": "EXTERRAN CORP",
     "symbol": "EXTN"
    },
    {
     "description": "EXTREME NETWORKS INC",
     "symbol": "EXTR"
    },
    {
     "description": "EXXARO RESOURCES LTD",
     "symbol": "EXXAF"
    },
    {
     "description": "EXOR NV",
     "symbol": "EXXRF"
    },
    {
     "description": "NATIONAL VISION HOLDINGS INC",
     "symbol": "EYE"
    },
    {
     "description": "EYENOVIA INC",
     "symbol": "EYEN"
    },
    {
     "description": "SECOND SIGHT MEDICAL PRODUCT",
     "symbol": "EYES"
    },
    {
     "description": "SECOND SIGHT MEDICAL-CW22",
     "symbol": "EYESW"
    },
    {
     "description": "ELECTRICITY GEN PUB CO-FOREI",
     "symbol": "EYGPF"
    },
    {
     "description": "CAMBRIA EMERG SHRHLDR YIELD",
     "symbol": "EYLD"
    },
    {
     "description": "EYEPOINT PHARMACEUTICALS INC",
     "symbol": "EYPT"
    },
    {
     "description": "ELECTRICITY GENERAT-UNSP ADR",
     "symbol": "EYUBY"
    },
    {
     "description": "ELECTRICITY GENERA PCL-NVDR",
     "symbol": "EYUUF"
    },
    {
     "description": "ISHARES MSCI SOUTH AFRICA ET",
     "symbol": "EZA"
    },
    {
     "description": "EZENIA! INC",
     "symbol": "EZEN"
    },
    {
     "description": "EZFILL HOLDINGS INC",
     "symbol": "EZFL"
    },
    {
     "description": "EZGO TECHNOLOGIES LTD",
     "symbol": "EZGO"
    },
    {
     "description": "EZION HOLDINGS LTD",
     "symbol": "EZIDF"
    },
    {
     "description": "PROSHARES ULTRA MSCI JAPAN",
     "symbol": "EZJ"
    },
    {
     "description": "EZAKI GLICO CO LTD",
     "symbol": "EZKGF"
    },
    {
     "description": "WISDOMTREE US MIDCAP FUND",
     "symbol": "EZM"
    },
    {
     "description": "EZAGOO LTD",
     "symbol": "EZOO"
    },
    {
     "description": "EZCORP INC-CL A",
     "symbol": "EZPW"
    },
    {
     "description": "EZRAIDER CO",
     "symbol": "EZRG"
    },
    {
     "description": "EZTD INC",
     "symbol": "EZTD"
    },
    {
     "description": "ISHARES MSCI EUROZONE ETF",
     "symbol": "EZU"
    },
    {
     "description": "ENZYMATICA AB",
     "symbol": "EZYMF"
    },
    {
     "description": "FORD MOTOR CO",
     "symbol": "F"
    },
    {
     "description": "FORD MOTOR COMPANY",
     "symbol": "F.PRB"
    },
    {
     "description": "FORD MOTOR COMPANY",
     "symbol": "F.PRC"
    },
    {
     "description": "FIRST ADVANTAGE CORP",
     "symbol": "FA"
    },
    {
     "description": "FIRST TRUST ALT ABS RET ETF",
     "symbol": "FAAR"
    },
    {
     "description": "FIRST TRUST MULTI CAP VALUE",
     "symbol": "FAB"
    },
    {
     "description": "FARMERS BANCORP (INDIANA)",
     "symbol": "FABP"
    },
    {
     "description": "FIGURE ACQUISITION CORP I -A",
     "symbol": "FACA"
    },
    {
     "description": "FIGURE ACQUISITION CORP I",
     "symbol": "FACA.U"
    },
    {
     "description": "FIGURE ACQ I CL A -CW27",
     "symbol": "FACA.WS"
    },
    {
     "description": "FIRST ACCEPTANCE CORP",
     "symbol": "FACO"
    },
    {
     "description": "FREEDOM ACQUISITION I CORP-A",
     "symbol": "FACT"
    },
    {
     "description": "FREEDOM ACQUISITION I CORP",
     "symbol": "FACT.U"
    },
    {
     "description": "FREEDOM ACQ I CL A -CW27",
     "symbol": "FACT.WS"
    },
    {
     "description": "FANCL CORP",
     "symbol": "FACYF"
    },
    {
     "description": "FIRST TRUST MULTI CAP GROWTH",
     "symbol": "FAD"
    },
    {
     "description": "FIRST AMERICAN FINANCIAL",
     "symbol": "FAF"
    },
    {
     "description": "FIRST AMERICANO FINANCIAL CO",
     "symbol": "FAFL"
    },
    {
     "description": "FULL ALLIANCE GROUP INC",
     "symbol": "FAGI"
    },
    {
     "description": "FAHEY BANKING CO\/OH",
     "symbol": "FAHE"
    },
    {
     "description": "ISHARES FALLEN ANGEL HY CORP",
     "symbol": "FAHYF"
    },
    {
     "description": "CAMBRIA GLOBAL TAIL RISK ETF",
     "symbol": "FAIL"
    },
    {
     "description": "FACEKEY CORP",
     "symbol": "FAKC"
    },
    {
     "description": "FALCONSTOR SOFTWARE INC",
     "symbol": "FALC"
    },
    {
     "description": "FALCON METALS LTD\/AUSTRALIA",
     "symbol": "FALFF"
    },
    {
     "description": "FALCO HOLDINGS CO LTD",
     "symbol": "FALHF"
    },
    {
     "description": "ISHARES FALLEN ANGELS ETF",
     "symbol": "FALN"
    },
    {
     "description": "FIRST TRUST ABERDEEN GLOBAL",
     "symbol": "FAM"
    },
    {
     "description": "FUTURA MEDICAL PLC",
     "symbol": "FAMDF"
    },
    {
     "description": "FLAMEMASTER CORP",
     "symbol": "FAME"
    },
    {
     "description": "FARMMI INC",
     "symbol": "FAMI"
    },
    {
     "description": "FIRST TRUST GLOBAL WIND ENER",
     "symbol": "FAN"
    },
    {
     "description": "FIRSTRAND LTD",
     "symbol": "FANDF"
    },
    {
     "description": "FIRSTRAND LTD-UNSPON ADR",
     "symbol": "FANDY"
    },
    {
     "description": "DIAMONDBACK ENERGY INC",
     "symbol": "FANG"
    },
    {
     "description": "FANHUA INC-SPONSORED ADR",
     "symbol": "FANH"
    },
    {
     "description": "FANUC CORP",
     "symbol": "FANUF"
    },
    {
     "description": "FANUC CORP-UNSP ADR",
     "symbol": "FANUY"
    },
    {
     "description": "FT CBOE VEST US EQ BUFF APR",
     "symbol": "FAPR"
    },
    {
     "description": "FARMER BROS CO",
     "symbol": "FARM"
    },
    {
     "description": "FARO TECHNOLOGIES INC",
     "symbol": "FARO"
    },
    {
     "description": "FAR LTD",
     "symbol": "FARYF"
    },
    {
     "description": "DIREXION DAILY FIN BULL 3X",
     "symbol": "FAS"
    },
    {
     "description": "FANTASY ACES DAILY FANTASY S",
     "symbol": "FASDF"
    },
    {
     "description": "FASTENAL CO",
     "symbol": "FAST"
    },
    {
     "description": "FAT BRANDS INC-CL A",
     "symbol": "FAT"
    },
    {
     "description": "FAT BRANDS INC-CL B",
     "symbol": "FATBB"
    },
    {
     "description": "FAT BRANDS INC",
     "symbol": "FATBP"
    },
    {
     "description": "FAT BRANDS INC -CW25",
     "symbol": "FATBW"
    },
    {
     "description": "FATE THERAPEUTICS INC",
     "symbol": "FATE"
    },
    {
     "description": "FATHOM DIGITAL MANUFACTURING",
     "symbol": "FATH"
    },
    {
     "description": "ALTIMAR ACQ A -CW27",
     "symbol": "FATH.WS"
    },
    {
     "description": "FATTAL HOLDINGS 1998 LTD",
     "symbol": "FATLF"
    },
    {
     "description": "FAT PROJECTS ACQUISITION COR",
     "symbol": "FATP"
    },
    {
     "description": "FAT PROJECTS ACQUISITION COR",
     "symbol": "FATPU"
    },
    {
     "description": "FAT PROJECTS ACQUISIT -CW22",
     "symbol": "FATPW"
    },
    {
     "description": "FT CBOE VEST US EQUITY BUFF",
     "symbol": "FAUG"
    },
    {
     "description": "FAURECIA SE ADR- UNSP",
     "symbol": "FAURY"
    },
    {
     "description": "FAVO CAPITAL INC",
     "symbol": "FAVO"
    },
    {
     "description": "ABERDEEN ASIA-PACIFIC INCOME",
     "symbol": "FAX"
    },
    {
     "description": "Fairfax Financial Holdings Ltd",
     "symbol": "FAXRF"
    },
    {
     "description": "Fairfax Financial Holdings Ltd",
     "symbol": "FAXXF"
    },
    {
     "description": "DIREXION DAILY FIN BEAR 3X",
     "symbol": "FAZ"
    },
    {
     "description": "META PLATFORMS INC-CLASS A",
     "symbol": "FB"
    },
    {
     "description": "FIRST NATIONAL BANK ALASKA",
     "symbol": "FBAK"
    },
    {
     "description": "TRUST FIBRA UNO",
     "symbol": "FBASF"
    },
    {
     "description": "KNEAT.COM INC",
     "symbol": "FBAYF"
    },
    {
     "description": "FIRST TRUST 9910 BALANCED",
     "symbol": "FBBHYX"
    },
    {
     "description": "PROLOGIS PROPERTY MEXICO SA",
     "symbol": "FBBPF"
    },
    {
     "description": "FLAGSTAR BANCORP INC",
     "symbol": "FBC"
    },
    {
     "description": "FBC HOLDING INC",
     "symbol": "FBCD"
    },
    {
     "description": "FIBERCORE INC",
     "symbol": "FBCE"
    },
    {
     "description": "FIDELITY BLUE CHIP GROWTH",
     "symbol": "FBCG"
    },
    {
     "description": "FABLED COPPER CORP",
     "symbol": "FBCPF"
    },
    {
     "description": "FIDELITY BLUE CHIP VALUE ETF",
     "symbol": "FBCV"
    },
    {
     "description": "FBEC WORLDWIDE INC",
     "symbol": "FBEC"
    },
    {
     "description": "FABEGE AB-UNSPON ADR",
     "symbol": "FBGBY"
    },
    {
     "description": "FABEGE AB",
     "symbol": "FBGGF"
    },
    {
     "description": "FOODBASE GROUP INC",
     "symbol": "FBGI"
    },
    {
     "description": "FI ENHANCED LARGE CAP GROWTH",
     "symbol": "FBGX"
    },
    {
     "description": "FORTUNE BRANDS HOME & SECURI",
     "symbol": "FBHS"
    },
    {
     "description": "TIMES UNIVERSAL GROUP HOLDIN",
     "symbol": "FBIHF"
    },
    {
     "description": "FORTRESS BIOTECH INC",
     "symbol": "FBIO"
    },
    {
     "description": "FORTRESS BIOTECH INC",
     "symbol": "FBIOP"
    },
    {
     "description": "FNB BANCORP INC\/NEWTON PA",
     "symbol": "FBIP"
    },
    {
     "description": "FIRST BUSINESS FINANCIAL SER",
     "symbol": "FBIZ"
    },
    {
     "description": "FB FINANCIAL CORP",
     "symbol": "FBK"
    },
    {
     "description": "FIRST INTL BANK ISRAEL",
     "symbol": "FBKIF"
    },
    {
     "description": "FOOTBALL EQUITIES INC",
     "symbol": "FBLQ"
    },
    {
     "description": "FIRST BANCORP INC",
     "symbol": "FBLV"
    },
    {
     "description": "BUFFALO COAL CORP",
     "symbol": "FBMCF"
    },
    {
     "description": "FIRST BANCSHARES INC\/MS",
     "symbol": "FBMS"
    },
    {
     "description": "FIRST BANCORP\/NC",
     "symbol": "FBNC"
    },
    {
     "description": "FIDELITY TOTAL BOND ETF",
     "symbol": "FBND"
    },
    {
     "description": "FORBO HOLDING AG-REG",
     "symbol": "FBOHF"
    },
    {
     "description": "FORBO HOLDING AG-UNSP ADR",
     "symbol": "FBOHY"
    },
    {
     "description": "FIRST BANK OF OHIO",
     "symbol": "FBOO"
    },
    {
     "description": "MEDIA CENTRAL INC",
     "symbol": "FBOP"
    },
    {
     "description": "FIRST BANCORP PUERTO RICO",
     "symbol": "FBP"
    },
    {
     "description": "FARMERS BANK APPOMATTOX\/VA",
     "symbol": "FBPA"
    },
    {
     "description": "FIRST BANCORP OF INDIANA INC",
     "symbol": "FBPI"
    },
    {
     "description": "FBR LTD",
     "symbol": "FBRKF"
    },
    {
     "description": "FRANKLIN BSP REALTY TRUST IN",
     "symbol": "FBRT"
    },
    {
     "description": "FRANKLIN BSP REALTY TRST",
     "symbol": "FBRT.PRE"
    },
    {
     "description": "FORTE BIOSCIENCES INC",
     "symbol": "FBRX"
    },
    {
     "description": "2INVEST AG",
     "symbol": "FBSBF"
    },
    {
     "description": "FASTBASE INC",
     "symbol": "FBSE"
    },
    {
     "description": "FABASOFT AG",
     "symbol": "FBSFF"
    },
    {
     "description": "FABLED SILVER GOLD CORP-A",
     "symbol": "FBSGF"
    },
    {
     "description": "FIRST BANCSHARES INC (MO)",
     "symbol": "FBSI"
    },
    {
     "description": "FIRST TRUST NYSE ARCA BIOTEC",
     "symbol": "FBT"
    },
    {
     "description": "FIRST BANKERS TRUSTSHARES",
     "symbol": "FBTT"
    },
    {
     "description": "FARMERS BANKSHARES INC",
     "symbol": "FBVA"
    },
    {
     "description": "FCN BANC CORP",
     "symbol": "FBVI"
    },
    {
     "description": "FIRST TRUST BRAZIL",
     "symbol": "FBZ"
    },
    {
     "description": "FRANKLIN COVEY CO",
     "symbol": "FC"
    },
    {
     "description": "FIRST TRUST CHINA",
     "symbol": "FCA"
    },
    {
     "description": "FIRM CAPITAL APARTMENT REAL",
     "symbol": "FCAFF"
    },
    {
     "description": "FIRST TRUST CALIFORNIA MUNIC",
     "symbol": "FCAL"
    },
    {
     "description": "FIRST CAPITAL INC",
     "symbol": "FCAP"
    },
    {
     "description": "FORTRESS CAPITAL ACQUISITI-A",
     "symbol": "FCAX"
    },
    {
     "description": "FORTRESS CAPITAL ACQUISITION",
     "symbol": "FCAX.U"
    },
    {
     "description": "FORTRESS CAP ACQ CL A -CW27",
     "symbol": "FCAX.WS"
    },
    {
     "description": "FINECOBANK SPA",
     "symbol": "FCBBF"
    },
    {
     "description": "FIRST COMMUNITY BANKSHARES",
     "symbol": "FCBC"
    },
    {
     "description": "FIRST TRUST CYBERSECURITY",
     "symbol": "FCBRF"
    },
    {
     "description": "FAST CASUAL CONCEPTS INC COM",
     "symbol": "FCCI"
    },
    {
     "description": "SPECTRAL CAPITAL CORP",
     "symbol": "FCCN"
    },
    {
     "description": "FIRST COMMUNITY CORP",
     "symbol": "FCCO"
    },
    {
     "description": "FIRST COMMUNITY CORP\/TN",
     "symbol": "FCCT"
    },
    {
     "description": "First Community Corporation",
     "symbol": "FCCTO"
    },
    {
     "description": "First Community Corporation",
     "symbol": "FCCTP"
    },
    {
     "description": "FIRST TRUST EXCHANGE-TRADED",
     "symbol": "FCEF"
    },
    {
     "description": "FUELCELL ENERGY INC",
     "symbol": "FCEL"
    },
    {
     "description": "FuelCell Energy Inc",
     "symbol": "FCELB"
    },
    {
     "description": "FIRST COMMONWEALTH FINL CORP",
     "symbol": "FCF"
    },
    {
     "description": "FIRSTCASH HOLDINGS INC",
     "symbol": "FCFS"
    },
    {
     "description": "FIRST TRUST NATURAL GAS ETF",
     "symbol": "FCG"
    },
    {
     "description": "FIRST COLOMBIA GOLD CORP",
     "symbol": "FCGD"
    },
    {
     "description": "FCG INC",
     "symbol": "FCGN"
    },
    {
     "description": "FORECASTAGILITY CORPORATION",
     "symbol": "FCGY"
    },
    {
     "description": "FISCHER (GEORG)-REG",
     "symbol": "FCHRF"
    },
    {
     "description": "FIRST CHOICE HEALTHCARE SOLU",
     "symbol": "FCHS"
    },
    {
     "description": "FCCC INC",
     "symbol": "FCIC"
    },
    {
     "description": "FIRST CITRUS BANCORPORATION",
     "symbol": "FCIT"
    },
    {
     "description": "FIDELITY CLOUD COMPUTING ETF",
     "symbol": "FCLD"
    },
    {
     "description": "FIRSTWAVE CLOUD TECHNOLOGY L",
     "symbol": "FCLOF"
    },
    {
     "description": "FIRM CAPITAL MORTGAGE INVEST",
     "symbol": "FCMGF"
    },
    {
     "description": "FTI CONSULTING INC",
     "symbol": "FCN"
    },
    {
     "description": "FIRST CITIZENS BCSHS  -CL A",
     "symbol": "FCNCA"
    },
    {
     "description": "FIRST CITIZENS BCSHS  -CL B",
     "symbol": "FCNCB"
    },
    {
     "description": "FIRST CITIZENS BANCSHARE",
     "symbol": "FCNCO"
    },
    {
     "description": "FIRST CITIZENS BANCSHARE",
     "symbol": "FCNCP"
    },
    {
     "description": "FOUR CORNERS INC",
     "symbol": "FCNE"
    },
    {
     "description": "FIRST TRUST 9822 FT TOP THEM",
     "symbol": "FCNJWX"
    },
    {
     "description": "ABERDEEN GLOBAL INCOME FUND",
     "symbol": "FCO"
    },
    {
     "description": "1ST COLONIAL BANCORP INC",
     "symbol": "FCOB"
    },
    {
     "description": "COMPAGNIE DE L'ODET SA",
     "symbol": "FCODF"
    },
    {
     "description": "FIDELITY MSCI COMMUNICATION",
     "symbol": "FCOM"
    },
    {
     "description": "FIDELITY CORPORATE BOND ETF",
     "symbol": "FCOR"
    },
    {
     "description": "FIRST CAPITAL BANCSHARES INC",
     "symbol": "FCPB"
    },
    {
     "description": "FIDELITY STOCKS FOR INFL ETF",
     "symbol": "FCPI"
    },
    {
     "description": "FOUR CORNERS PROPERTY TRUST",
     "symbol": "FCPT"
    },
    {
     "description": "FIRST EAGLE ALTERNATIVE CAPI",
     "symbol": "FCRD"
    },
    {
     "description": "FLETCHER BUILDING-SPN ADR",
     "symbol": "FCREY"
    },
    {
     "description": "FCR IMMOBILIEN AG",
     "symbol": "FCRIF"
    },
    {
     "description": "FRANKLIN CREDIT MANAGEMENT",
     "symbol": "FCRM"
    },
    {
     "description": "ICHIGO OFFICE REIT INVESTMEN",
     "symbol": "FCRQF"
    },
    {
     "description": "FIRST EAGLE ALTERNATIVE",
     "symbol": "FCRX"
    },
    {
     "description": "FEDERATED HERMES SHORT CORP",
     "symbol": "FCSH"
    },
    {
     "description": "FOCUS GRAPHITE INC",
     "symbol": "FCSMF"
    },
    {
     "description": "FOCUS MINERALS LTD",
     "symbol": "FCSUF"
    },
    {
     "description": "FIRST TRUST SENIOR FLOATING",
     "symbol": "FCT"
    },
    {
     "description": "FACT INC",
     "symbol": "FCTI"
    },
    {
     "description": "FIRST TRUST LUNT US FACTOR",
     "symbol": "FCTR"
    },
    {
     "description": "FISSION URANIUM CORP",
     "symbol": "FCUUF"
    },
    {
     "description": "FOCUS UNIVERSAL INC",
     "symbol": "FCUV"
    },
    {
     "description": "FCC CO LTD",
     "symbol": "FCVFF"
    },
    {
     "description": "FIRST TRUST SSI STRATEGI ETF",
     "symbol": "FCVT"
    },
    {
     "description": "FREEPORT-MCMORAN INC",
     "symbol": "FCX"
    },
    {
     "description": "FIRST CAPITAL REAL ESTATE IN",
     "symbol": "FCXXF"
    },
    {
     "description": "FIDELITY D&D BANCORP INC",
     "symbol": "FDBC"
    },
    {
     "description": "FOUNDERS BAY HOLDINGS",
     "symbol": "FDBH"
    },
    {
     "description": "FRIENDABLE INC",
     "symbol": "FDBL"
    },
    {
     "description": "FORUM ENERGY METALS CORP",
     "symbol": "FDCFF"
    },
    {
     "description": "FUNDING CIRCLE HOLDINGS",
     "symbol": "FDCHF"
    },
    {
     "description": "FDCTECH INC",
     "symbol": "FDCT"
    },
    {
     "description": "FIRST TRUST STOXX EUROPE",
     "symbol": "FDD"
    },
    {
     "description": "FDM GROUP HOLDINGS PLC",
     "symbol": "FDDMF"
    },
    {
     "description": "FT CBOE VEST US EQ BUFF DEC",
     "symbol": "FDEC"
    },
    {
     "description": "FIDELIS ENERGY INC",
     "symbol": "FDEI"
    },
    {
     "description": "FIDELITY EMERG MARKETS MULTI",
     "symbol": "FDEM"
    },
    {
     "description": "FIRST TR DYN EUR EQTY INC",
     "symbol": "FDEU"
    },
    {
     "description": "FIDELITY INTERNATIONAL MULTI",
     "symbol": "FDEV"
    },
    {
     "description": "FOODFEST INTERNATIONAL 2000",
     "symbol": "FDFT"
    },
    {
     "description": "AMERICAN CENTURY FOCUSED DYN",
     "symbol": "FDG"
    },
    {
     "description": "SOUTHSTONE MINERALS LTD",
     "symbol": "FDGMF"
    },
    {
     "description": "FIRST DIGITAL HEALTH ACQUISI",
     "symbol": "FDHA.U"
    },
    {
     "description": "FIDELITY HOLDING CORP",
     "symbol": "FDHC"
    },
    {
     "description": "FIDELITY DIGITAL HEALTH ETF",
     "symbol": "FDHT"
    },
    {
     "description": "FIDELITY HI YIELD FACTOR ETF",
     "symbol": "FDHY"
    },
    {
     "description": "FIDELITY CRYPTO INDUSTRY & D",
     "symbol": "FDIG"
    },
    {
     "description": "FIDELITY CON DISCRET ETF",
     "symbol": "FDIS"
    },
    {
     "description": "FINDIT INC",
     "symbol": "FDIT"
    },
    {
     "description": "FIRST TRUST MORN DVD LEAD IN",
     "symbol": "FDL"
    },
    {
     "description": "FIDELITY FEDERAL BANCORP",
     "symbol": "FDLB"
    },
    {
     "description": "FIDELITY LOW VOLATILITY FACT",
     "symbol": "FDLO"
    },
    {
     "description": "FONDUL PROPRIETATEA SA\/FUND",
     "symbol": "FDLPF"
    },
    {
     "description": "FIRST TRUST DOW J SELECT MIC",
     "symbol": "FDM"
    },
    {
     "description": "4DMEDICAL LTD",
     "symbol": "FDMDF"
    },
    {
     "description": "FIDELITY MOMENTUM FACTOR ETF",
     "symbol": "FDMO"
    },
    {
     "description": "FREEDOM OIL AND GAS LTD",
     "symbol": "FDMQQ"
    },
    {
     "description": "FANDIFI TECHNOLOGY CORP",
     "symbol": "FDMSF"
    },
    {
     "description": "4D MOLECULAR THERAPEUTICS IN",
     "symbol": "FDMT"
    },
    {
     "description": "FIRST TRUST DJ INTERNET IND",
     "symbol": "FDN"
    },
    {
     "description": "FIRST TRUST DOW JONES INTL",
     "symbol": "FDNI"
    },
    {
     "description": "FUEL DOCTOR HOLDINGS INC",
     "symbol": "FDOC"
    },
    {
     "description": "FRESH DEL MONTE PRODUCE INC",
     "symbol": "FDP"
    },
    {
     "description": "FIDELITY DIV ETF RISE RATES",
     "symbol": "FDRR"
    },
    {
     "description": "FIDELITY ELETRIC VEHICLES AN",
     "symbol": "FDRV"
    },
    {
     "description": "FD TECHNOLOGIES PLC",
     "symbol": "FDRVF"
    },
    {
     "description": "FACTSET RESEARCH SYSTEMS INC",
     "symbol": "FDS"
    },
    {
     "description": "FIRST TRUST DEVELP MKT EX-US",
     "symbol": "FDT"
    },
    {
     "description": "FNDS3000 CORP",
     "symbol": "FDTC"
    },
    {
     "description": "FIRST TRUST DEVELOPED MARKET",
     "symbol": "FDTS"
    },
    {
     "description": "FIDUS INVESTMENT CORP",
     "symbol": "FDUS"
    },
    {
     "description": "FREEDOM FINANCIAL HOLDINGS I",
     "symbol": "FDVA"
    },
    {
     "description": "FACEDRIVE INC",
     "symbol": "FDVRF"
    },
    {
     "description": "FIDELITY HIGH DIVIDEND ETF",
     "symbol": "FDVV"
    },
    {
     "description": "FRIEDRICH VORWERK GROUP SE",
     "symbol": "FDVWF"
    },
    {
     "description": "FENIXORO GOLD CORP",
     "symbol": "FDVXF"
    },
    {
     "description": "FIDELITY WOMENS LEADERSHIP",
     "symbol": "FDWM"
    },
    {
     "description": "FEDEX CORP",
     "symbol": "FDX"
    },
    {
     "description": "FARADAY TECHNOLOGY CORP",
     "symbol": "FDYTF"
    },
    {
     "description": "FIRSTENERGY CORP",
     "symbol": "FE"
    },
    {
     "description": "5E ADVANCED MATERIALS INC",
     "symbol": "FEAM"
    },
    {
     "description": "5E ADVANCED MATERIALS IN-CDI",
     "symbol": "FEAV"
    },
    {
     "description": "TrueShares Structured Outcom",
     "symbol": "FEBZ"
    },
    {
     "description": "FRONTERA ENERGY CORP",
     "symbol": "FECCF"
    },
    {
     "description": "FIDELITY CHINA SPECIAL SITUA",
     "symbol": "FECHF"
    },
    {
     "description": "FEC RESOURCES INC",
     "symbol": "FECOF"
    },
    {
     "description": "FEDERAL CASTERS CORP",
     "symbol": "FEDC"
    },
    {
     "description": "ETRACS 2X LEVERAGED IFED",
     "symbol": "FEDL"
    },
    {
     "description": "FLEXSHARES ESG & CLIMATE US",
     "symbol": "FEDM"
    },
    {
     "description": "FEED ONE CO LTD",
     "symbol": "FEDOF"
    },
    {
     "description": "FOUR SEASONS EDUCATION CAYMA",
     "symbol": "FEDU"
    },
    {
     "description": "EMLES FEDERAL CONTRACTORS",
     "symbol": "FEDX"
    },
    {
     "description": "FLEXSHARES ESG & CLIMATE EM",
     "symbol": "FEEM"
    },
    {
     "description": "FREEPORT RESOURCES",
     "symbol": "FEERF"
    },
    {
     "description": "FERREXPO PLC",
     "symbol": "FEEXF"
    },
    {
     "description": "FERREXPO PLC-UNSP ADR",
     "symbol": "FEEXY"
    },
    {
     "description": "FAR EAST HOSPITALITY TRUST",
     "symbol": "FEHTF"
    },
    {
     "description": "FLEXSHARES ESG H\/Y CORP CORE",
     "symbol": "FEHY"
    },
    {
     "description": "FIRST TRUST MLP AND ENERGY I",
     "symbol": "FEI"
    },
    {
     "description": "FLEXSHARES ESG IG CORP CORE",
     "symbol": "FEIG"
    },
    {
     "description": "FREQUENCY ELECTRONICS INC",
     "symbol": "FEIM"
    },
    {
     "description": "FEINTOOL INTL HOLDING-REG",
     "symbol": "FEIOF"
    },
    {
     "description": "FERTIL-A-CHRON INC",
     "symbol": "FEKR"
    },
    {
     "description": "FRANKLIN ELECTRIC CO INC",
     "symbol": "FELE"
    },
    {
     "description": "FUJI ELECTRIC CO LTD",
     "symbol": "FELTF"
    },
    {
     "description": "FUJI ELECTRIC HLDS-UNSP ADR",
     "symbol": "FELTY"
    },
    {
     "description": "FIRST TRUST EMERGING MARKETS",
     "symbol": "FEM"
    },
    {
     "description": "FIRST TRUST EMERGING MARKETS",
     "symbol": "FEMB"
    },
    {
     "description": "FIRST ENERGY METALS LTD",
     "symbol": "FEMFF"
    },
    {
     "description": "FIRST TRUST EMERGING MARKETS",
     "symbol": "FEMS"
    },
    {
     "description": "FEMASYS INC",
     "symbol": "FEMY"
    },
    {
     "description": "FIRST TR ENRGY INC & GRW",
     "symbol": "FEN"
    },
    {
     "description": "FENNEC PHARMACEUTICALS INC",
     "symbol": "FENC"
    },
    {
     "description": "PHOENIX NEW MEDIA LTD -ADR",
     "symbol": "FENG"
    },
    {
     "description": "FIDELITY MSCI ENERGY ETF",
     "symbol": "FENY"
    },
    {
     "description": "FIRST TRUST ABERDEEN EMG OPP",
     "symbol": "FEO"
    },
    {
     "description": "OCEANIC IRON ORE CORP",
     "symbol": "FEOVF"
    },
    {
     "description": "FIRST TRUST EUROPE",
     "symbol": "FEP"
    },
    {
     "description": "FERGUSON PLC",
     "symbol": "FERG"
    },
    {
     "description": "FEARLESS FILMS INC",
     "symbol": "FERL"
    },
    {
     "description": "FERNHILL CORP",
     "symbol": "FERN"
    },
    {
     "description": "FAR EASTERN SHIPPING CO PLC",
     "symbol": "FESKF"
    },
    {
     "description": "FIRST REAL ESTATE INVT TRUST",
     "symbol": "FESNF"
    },
    {
     "description": "HYBRID KINETIC GROUP LTD",
     "symbol": "FESTF"
    },
    {
     "description": "FORUM ENERGY TECHNOLOGIES IN",
     "symbol": "FET"
    },
    {
     "description": "FENTURA FINANCIAL INC",
     "symbol": "FETM"
    },
    {
     "description": "FLEXSHARES ESG & CLIMATE US",
     "symbol": "FEUS"
    },
    {
     "description": "FIRST TRUST EUROZONE ALPHADE",
     "symbol": "FEUZ"
    },
    {
     "description": "INSPIRE FAITHWARD LARCAP MOM",
     "symbol": "FEVR"
    },
    {
     "description": "FAR EAST WIND POWER CORP",
     "symbol": "FEWP"
    },
    {
     "description": "FIRST TRUST LARGE CAP CORE A",
     "symbol": "FEX"
    },
    {
     "description": "FINTECH ECOSYSTEM DEVELOPM-A",
     "symbol": "FEXD"
    },
    {
     "description": "FINTECH ECOSYSTEM DEVELO-RTS",
     "symbol": "FEXDR"
    },
    {
     "description": "FINTECH ECOSYSTEM DEVELOPMEN",
     "symbol": "FEXDU"
    },
    {
     "description": "FINTECH ECOSYSTEM DEV -CW28",
     "symbol": "FEXDW"
    },
    {
     "description": "FJORDLAND EXPLORATION INC",
     "symbol": "FEXXF"
    },
    {
     "description": "SPDR EURO STOXX 50 ETF",
     "symbol": "FEZ"
    },
    {
     "description": "FAR EAST HORIZON LTD",
     "symbol": "FEZHF"
    },
    {
     "description": "FUTUREFUEL CORP",
     "symbol": "FF"
    },
    {
     "description": "FIRST TRUST ENH EQUITY INC",
     "symbol": "FFA"
    },
    {
     "description": "FIRST FINANCIAL BANCORP",
     "symbol": "FFBC"
    },
    {
     "description": "FFBW INC",
     "symbol": "FFBW"
    },
    {
     "description": "FLAHERTY & CRUMRINE PREFERRE",
     "symbol": "FFC"
    },
    {
     "description": "FAST FINANCE24 HOLDING AG",
     "symbol": "FFCNF"
    },
    {
     "description": "FFD FINANCIAL CORP",
     "symbol": "FFDF"
    },
    {
     "description": "1414 DEGREES LTD",
     "symbol": "FFDGF"
    },
    {
     "description": "FT CBOE VEST US EQY BUFF-FEB",
     "symbol": "FFEB"
    },
    {
     "description": "FORMULA FOLIOS HEDGED GROWTH",
     "symbol": "FFHG"
    },
    {
     "description": "FFI HOLDINGS PLC",
     "symbol": "FFHHF"
    },
    {
     "description": "FUWEI FILMS HOLDINGS CO LTD",
     "symbol": "FFHL"
    },
    {
     "description": "FIRST FINANCIAL - GDR REG S",
     "symbol": "FFHMY"
    },
    {
     "description": "Fairfax Financial Holdings Ltd",
     "symbol": "FFHPF"
    },
    {
     "description": "FLUSHING FINANCIAL CORP",
     "symbol": "FFIC"
    },
    {
     "description": "FARADAY FUTURE INTELLIGENT E",
     "symbol": "FFIE"
    },
    {
     "description": "FARADAY FUTURE         -CW27",
     "symbol": "FFIEW"
    },
    {
     "description": "FIRST FINL BANKSHARES INC",
     "symbol": "FFIN"
    },
    {
     "description": "UVA UNCONSTRAINED MEDIUM-TER",
     "symbol": "FFIU"
    },
    {
     "description": "F5 INC",
     "symbol": "FFIV"
    },
    {
     "description": "FREEFLOW INC",
     "symbol": "FFLO"
    },
    {
     "description": "FIRE & FLOWER HOLDINGS CORP",
     "symbol": "FFLWF"
    },
    {
     "description": "FIRST MINING GOLD CORP",
     "symbol": "FFMGF"
    },
    {
     "description": "FIRST FARMERS & MERCHANTS",
     "symbol": "FFMH"
    },
    {
     "description": "FIRST FARMERS FINANCIAL CORP",
     "symbol": "FFMR"
    },
    {
     "description": "The Future Fund Active ETF",
     "symbol": "FFND"
    },
    {
     "description": "FT 9984 BALANCED INCOME EQ",
     "symbol": "FFNPSX"
    },
    {
     "description": "4FRONT VENTURES CORP",
     "symbol": "FFNTF"
    },
    {
     "description": "FIRST FINANCIAL NORTHWEST",
     "symbol": "FFNW"
    },
    {
     "description": "FIREFOX GOLD CORP",
     "symbol": "FFOXF"
    },
    {
     "description": "FFP MARKETING COMPANY INC",
     "symbol": "FFPM"
    },
    {
     "description": "FT FTSE EPRA\/NAREIT REAL EST",
     "symbol": "FFR"
    },
    {
     "description": "SEED INNOVATIONS LTD",
     "symbol": "FFRIF"
    },
    {
     "description": "FUTURE FARM TECHNOLOGIES INC",
     "symbol": "FFRMF"
    },
    {
     "description": "FORMULAFOLIOS SMART GROWTH",
     "symbol": "FFSG"
    },
    {
     "description": "FORMULAFOLIOS TACTICAL GROWT",
     "symbol": "FFTG"
    },
    {
     "description": "FORMULAFOLIOS TACTICAL INCOM",
     "symbol": "FFTI"
    },
    {
     "description": "FATFISH GROUP LTD",
     "symbol": "FFTTF"
    },
    {
     "description": "INNOVATOR IBD 50 ETF",
     "symbol": "FFTY"
    },
    {
     "description": "4FRONT VENTURES CORP -CW22",
     "symbol": "FFVWF"
    },
    {
     "description": "FFW CORPORATION",
     "symbol": "FFWC"
    },
    {
     "description": "FIRST FOUNDATION INC",
     "symbol": "FFWM"
    },
    {
     "description": "FAIRFAX INDIA HO-SUB VTG SHS",
     "symbol": "FFXDF"
    },
    {
     "description": "HELIOS FAIRFAX PARTNERS CORP",
     "symbol": "FFXXF"
    },
    {
     "description": "FANSFRENZY CORP",
     "symbol": "FFZY"
    },
    {
     "description": "FIRST TRUST SPECIALTY FINANC",
     "symbol": "FGB"
    },
    {
     "description": "FIRST GLOBAL DATA LTD",
     "symbol": "FGBDF"
    },
    {
     "description": "FIRST GUARANTY BANCSHARES IN",
     "symbol": "FGBI"
    },
    {
     "description": "FIRST GUARANTY BANCSHRS",
     "symbol": "FGBIP"
    },
    {
     "description": "FLAGSHIP GLOBAL CORP",
     "symbol": "FGCN"
    },
    {
     "description": "FINANCIAL GRAVITY COMPANIES",
     "symbol": "FGCO"
    },
    {
     "description": "FEDERAL GRID CO UNIFI-SP GDR",
     "symbol": "FGCUL"
    },
    {
     "description": "FIRST TRUST DJ GL SEL DVD",
     "symbol": "FGD"
    },
    {
     "description": "FUJITSU GENERAL LTD",
     "symbol": "FGELF"
    },
    {
     "description": "FIBROGEN INC",
     "symbol": "FGEN"
    },
    {
     "description": "FLIGHT CENTRE TRAVEL GROUP L",
     "symbol": "FGETF"
    },
    {
     "description": "FG FINANCIAL GROUP INC",
     "symbol": "FGF"
    },
    {
     "description": "FORESIGHT FINANCIAL GROUP",
     "symbol": "FGFH"
    },
    {
     "description": "FIRST GREENWICH FINANCIAL IN",
     "symbol": "FGFI"
    },
    {
     "description": "FG FINANCIAL GROUP INC",
     "symbol": "FGFPP"
    },
    {
     "description": "FG FITNESS & MEDIA GROUP INC",
     "symbol": "FGFT"
    },
    {
     "description": "FRONTAGE HOLDINGS CORP",
     "symbol": "FGHQF"
    },
    {
     "description": "FGI INDUSTRIES LTD",
     "symbol": "FGI"
    },
    {
     "description": "FGI INDUSTRIES LTD -23",
     "symbol": "FGIWW"
    },
    {
     "description": "FALCON GOLD CORP",
     "symbol": "FGLDF"
    },
    {
     "description": "FGL HOLDINGS-CW21",
     "symbol": "FGLHF"
    },
    {
     "description": "FIRST TRUST GERMANY",
     "symbol": "FGM"
    },
    {
     "description": "FG MERGER CORP",
     "symbol": "FGMC"
    },
    {
     "description": "FG MERGER CORP",
     "symbol": "FGMCU"
    },
    {
     "description": "FG MERGER CORP -27",
     "symbol": "FGMCW"
    },
    {
     "description": "FORGE INNOVATION DEVELOPMENT",
     "symbol": "FGNV"
    },
    {
     "description": "FREEGOLD VENTURES LTD",
     "symbol": "FGOVF"
    },
    {
     "description": "FIRST GRAPHENE LTD",
     "symbol": "FGPHF"
    },
    {
     "description": "FRONTIER IP GROUP PLC",
     "symbol": "FGPPF"
    },
    {
     "description": "FERRELLGAS PARTNERS-LP",
     "symbol": "FGPR"
    },
    {
     "description": "FERRELLGAS PARTNERS LP-B",
     "symbol": "FGPRB"
    },
    {
     "description": "FIDELITY GROWTH OPPORTUNITIE",
     "symbol": "FGRO"
    },
    {
     "description": "FIRSTGROUP PLC",
     "symbol": "FGROF"
    },
    {
     "description": "FIRSTGROUP PLC-UNSP ADR",
     "symbol": "FGROY"
    },
    {
     "description": "FINGERPRINT CARDS AB-B",
     "symbol": "FGRRF"
    },
    {
     "description": "FINGERTANGO INC",
     "symbol": "FGRTF"
    },
    {
     "description": "FLAT GLASS GROUP CO LTD-H",
     "symbol": "FGSGF"
    },
    {
     "description": "FLUGHAFEN WIEN AG",
     "symbol": "FGWLF"
    },
    {
     "description": "FIRST TRUST 9925 LTD DUR",
     "symbol": "FGZTSX"
    },
    {
     "description": "FIRST TRUST 9972 CONVERTIBLE",
     "symbol": "FHACAX"
    },
    {
     "description": "FOUNTAIN HEALTHY AGING INC",
     "symbol": "FHAI"
    },
    {
     "description": "FT 9960 FT TOP THEMES ETF",
     "symbol": "FHAKIX"
    },
    {
     "description": "FIRST HAWAIIAN INC",
     "symbol": "FHB"
    },
    {
     "description": "FERNHILL BEVERAGE INC",
     "symbol": "FHBC"
    },
    {
     "description": "FIRST HELIUM INC",
     "symbol": "FHELF"
    },
    {
     "description": "FOUNDER HOLDINGS LTD",
     "symbol": "FHGDF"
    },
    {
     "description": "THE FOSCHINI GROUP LTD",
     "symbol": "FHHGF"
    },
    {
     "description": "FEDERATED HERMES INC",
     "symbol": "FHI"
    },
    {
     "description": "FREEHILL MINING LTD",
     "symbol": "FHILF"
    },
    {
     "description": "FT Strategic Fixed Income ETF Portfolio Series 5 Ca",
     "symbol": "FHKBLX"
    },
    {
     "description": "FRIENDLY HILLS BANCORP",
     "symbol": "FHLB"
    },
    {
     "description": "FIDELITY HEALTH CARE ETF",
     "symbol": "FHLC"
    },
    {
     "description": "FREEDOM HOLDINGS INC",
     "symbol": "FHLD"
    },
    {
     "description": "FUTURE HEALTH ESG CORP",
     "symbol": "FHLT"
    },
    {
     "description": "FUTURE HEALTH ESG CORP",
     "symbol": "FHLTU"
    },
    {
     "description": "FUTURE HEALTH ESG -CW23",
     "symbol": "FHLTW"
    },
    {
     "description": "FIRST HORIZON CORP",
     "symbol": "FHN"
    },
    {
     "description": "FIRST HORIZON CORP",
     "symbol": "FHN.PRB"
    },
    {
     "description": "FIRST HORIZON CORP",
     "symbol": "FHN.PRC"
    },
    {
     "description": "FIRST HORIZON CORP",
     "symbol": "FHN.PRD"
    },
    {
     "description": "FIRST HORIZON CORP",
     "symbol": "FHN.PRE"
    },
    {
     "description": "FIRST HORIZON CORP",
     "symbol": "FHN.PRF"
    },
    {
     "description": "FOSCHINI GROUP - UNSP ADR",
     "symbol": "FHNGY"
    },
    {
     "description": "FIRST HARTFORD CORP",
     "symbol": "FHRT"
    },
    {
     "description": "FIRST HIGH-SCHOOL EDUCAT-ADR",
     "symbol": "FHS"
    },
    {
     "description": "FHT FUTURE TECHNOLOGY LTD",
     "symbol": "FHTF"
    },
    {
     "description": "FOGHORN THERAPEUTICS INC",
     "symbol": "FHTX"
    },
    {
     "description": "FIRST HYDROGEN CORP",
     "symbol": "FHYDF"
    },
    {
     "description": "FED HERMES SHRT DUR HI YIELD",
     "symbol": "FHYS"
    },
    {
     "description": "FOCUS IMPACT ACQUISITION-A",
     "symbol": "FIAC"
    },
    {
     "description": "FOCUS IMPACT ACQUISITION COR",
     "symbol": "FIACU"
    },
    {
     "description": "FOCUS IMPACT ACQUISIT -CW23",
     "symbol": "FIACW"
    },
    {
     "description": "FIRST BANCSHARES INC\/OH",
     "symbol": "FIBH"
    },
    {
     "description": "FIRST INTERSTATE BANCSYS-A",
     "symbol": "FIBK"
    },
    {
     "description": "ISHARES U.S. FIXED INCOME BA",
     "symbol": "FIBR"
    },
    {
     "description": "FAIR ISAAC CORP",
     "symbol": "FICO"
    },
    {
     "description": "FT INTERNATIONAL DEV CAP STR",
     "symbol": "FICS"
    },
    {
     "description": "FRONTIER INVESTMENT CORP -A",
     "symbol": "FICV"
    },
    {
     "description": "FRONTIER INVESTMENT CORP",
     "symbol": "FICVU"
    },
    {
     "description": "FRONTIER INVESTMENT A -CW23",
     "symbol": "FICVW"
    },
    {
     "description": "FIRST TRUST S&P INTERNATIONA",
     "symbol": "FID"
    },
    {
     "description": "FIDELITY INTL HIGH DIV ETF",
     "symbol": "FIDI"
    },
    {
     "description": "FNB INC DENNISON OHIO",
     "symbol": "FIDS"
    },
    {
     "description": "FIDELITY INDUSTRIALS ETF",
     "symbol": "FIDU"
    },
    {
     "description": "FIRST IC CORP",
     "symbol": "FIEB"
    },
    {
     "description": "FRONTIER NATIONAL CORP",
     "symbol": "FIEC"
    },
    {
     "description": "UBS FI ENHANCED EUR 50 ETN",
     "symbol": "FIEE"
    },
    {
     "description": "FI ENHANCED GLOBAL HI YLD",
     "symbol": "FIEGF"
    },
    {
     "description": "OTSO GOLD CORP",
     "symbol": "FIEIF"
    },
    {
     "description": "FIELDS CORP",
     "symbol": "FIELF"
    },
    {
     "description": "FIRST TRUST ENERGY INFRASTRU",
     "symbol": "FIF"
    },
    {
     "description": "FIRST FOODS GROUP INC",
     "symbol": "FIFG"
    },
    {
     "description": "FIDELITY INV GRADE BOND ETF",
     "symbol": "FIGB"
    },
    {
     "description": "FREEDOM INTERNET GROUP INC",
     "symbol": "FIGI"
    },
    {
     "description": "FUTURE INTERNATIONAL GROUP C",
     "symbol": "FIGM"
    },
    {
     "description": "FIRST NATL BANK\/GROTON N Y",
     "symbol": "FIGR"
    },
    {
     "description": "FIGS INC-CLASS A",
     "symbol": "FIGS"
    },
    {
     "description": "UBS FI ENH GL HI YLD ETN",
     "symbol": "FIHD"
    },
    {
     "description": "Financial Institutions Inc",
     "symbol": "FIISO"
    },
    {
     "description": "Financial Institutions Inc",
     "symbol": "FIISP"
    },
    {
     "description": "ISHARES MSCI GLOBAL ENERGY P",
     "symbol": "FILL"
    },
    {
     "description": "FINDEX.COM INC",
     "symbol": "FIND"
    },
    {
     "description": "FINNING INTERNATIONAL INC",
     "symbol": "FINGF"
    },
    {
     "description": "MARLIN TECHNOLOGY CORP-A",
     "symbol": "FINM"
    },
    {
     "description": "LEONARDO SPA",
     "symbol": "FINMF"
    },
    {
     "description": "MARLIN TECHNOLOGY CORP",
     "symbol": "FINMU"
    },
    {
     "description": "MARLIN TECHNOLOGY -CW26",
     "symbol": "FINMW"
    },
    {
     "description": "LEONARDO SPA-ADR",
     "symbol": "FINMY"
    },
    {
     "description": "FIRST NATL OF NEBRASKA INC",
     "symbol": "FINN"
    },
    {
     "description": "ANGEL OAK FINANC STRAT INC",
     "symbol": "FINS"
    },
    {
     "description": "FINVOLUTION GROUP-ADR",
     "symbol": "FINV"
    },
    {
     "description": "FINWISE BANCORP",
     "symbol": "FINW"
    },
    {
     "description": "GLOBAL X FINTECH ETF",
     "symbol": "FINX"
    },
    {
     "description": "FIORE CANNABIS LTD",
     "symbol": "FIORF"
    },
    {
     "description": "FIRST TRACTOR CO-H",
     "symbol": "FIRRF"
    },
    {
     "description": "FIRST TRACTOR CO-UNSP ADR",
     "symbol": "FIRRY"
    },
    {
     "description": "FIDELITY NATIONAL INFO SERV",
     "symbol": "FIS"
    },
    {
     "description": "1ST CAPITAL BANCORP",
     "symbol": "FISB"
    },
    {
     "description": "FINANCIAL INSTITUTIONS INC",
     "symbol": "FISI"
    },
    {
     "description": "EMPIRE STATE REALTY OP -S250",
     "symbol": "FISK"
    },
    {
     "description": "FISSION 3.0 CORP",
     "symbol": "FISOF"
    },
    {
     "description": "SPDR SSGA F\/I SECTOR ROTATE",
     "symbol": "FISR"
    },
    {
     "description": "FISERV INC",
     "symbol": "FISV"
    },
    {
     "description": "FIFTH THIRD BANCORP",
     "symbol": "FITB"
    },
    {
     "description": "FIFTH THIRD BANCORP",
     "symbol": "FITBI"
    },
    {
     "description": "FIFTH THIRD BANCORP",
     "symbol": "FITBO"
    },
    {
     "description": "FIFTH THIRD BANCORP",
     "symbol": "FITBP"
    },
    {
     "description": "SPDR S&P KENSHO FUTURE SECUR",
     "symbol": "FITE"
    },
    {
     "description": "FIT HON TENG LTD",
     "symbol": "FITGF"
    },
    {
     "description": "KOIOS BEVERAGE CORP",
     "symbol": "FITSF"
    },
    {
     "description": "CREATIVE EDGE NUTRITION INC",
     "symbol": "FITX"
    },
    {
     "description": "FIDELITY INTL VAL FACTOR ETF",
     "symbol": "FIVA"
    },
    {
     "description": "FIVE BELOW",
     "symbol": "FIVE"
    },
    {
     "description": "DEFIANCE NEXT GEN CONN ETF",
     "symbol": "FIVG"
    },
    {
     "description": "FIVE9 INC",
     "symbol": "FIVN"
    },
    {
     "description": "STRATEGY SH NASDAQ 5HANDL",
     "symbol": "FIVR"
    },
    {
     "description": "FIRST TRUST WATER ETF",
     "symbol": "FIW"
    },
    {
     "description": "COMFORT SYSTEMS USA INC",
     "symbol": "FIX"
    },
    {
     "description": "FT 10051 DOC EQD FIXF-UI",
     "symbol": "FIXAFX"
    },
    {
     "description": "FIRST TRUST TCW OPP FIXED IN",
     "symbol": "FIXD"
    },
    {
     "description": "HOMOLOGY MEDICINES INC",
     "symbol": "FIXX"
    },
    {
     "description": "FIRST CITIZENS BANCSHARES",
     "symbol": "FIZN"
    },
    {
     "description": "NATIONAL BEVERAGE CORP",
     "symbol": "FIZZ"
    },
    {
     "description": "FT CBOE VEST US EQ BUFF JAN",
     "symbol": "FJAN"
    },
    {
     "description": "FOVEA JEWELRY HOLDINGS LTD",
     "symbol": "FJHL"
    },
    {
     "description": "FUJICCO CO LTD",
     "symbol": "FJIOF"
    },
    {
     "description": "FUJI OIL HOLDINGS INC",
     "symbol": "FJLLF"
    },
    {
     "description": "FIRST TRUST JAPAN",
     "symbol": "FJP"
    },
    {
     "description": "FUJII SANGYO CORP",
     "symbol": "FJSGF"
    },
    {
     "description": "FUJITEC CO LTD-UNSP ADR",
     "symbol": "FJTCY"
    },
    {
     "description": "FUJI MEDIA HOLDINGS INC",
     "symbol": "FJTNF"
    },
    {
     "description": "FUJI MEDIA HOLDINGS INC-ADR",
     "symbol": "FJTNY"
    },
    {
     "description": "FUJITSU LTD",
     "symbol": "FJTSF"
    },
    {
     "description": "FUJITSU LTD - UNSPON ADR",
     "symbol": "FJTSY"
    },
    {
     "description": "FT CBOE VEST US EQ BUFF JUL",
     "symbol": "FJUL"
    },
    {
     "description": "FT CBOE VEST U.S. EQUITY BUF",
     "symbol": "FJUN"
    },
    {
     "description": "FT 9961 SENIOR LOAN",
     "symbol": "FJZLAX"
    },
    {
     "description": "FUKUI COMPUTER HOLDINGS INC",
     "symbol": "FKCIF"
    },
    {
     "description": "CHARTER HALL SOCIAL INFRASTR",
     "symbol": "FKKEF"
    },
    {
     "description": "FUKUOKA FINANCIAL GROUP INC",
     "symbol": "FKKFF"
    },
    {
     "description": "FUKUOKA FINANCIAL GROUP-ADR",
     "symbol": "FKKFY"
    },
    {
     "description": "FOKUS MINING CORP",
     "symbol": "FKMCF"
    },
    {
     "description": "FISKARS OYJ ABP",
     "symbol": "FKRAF"
    },
    {
     "description": "FUKUSHIMA GALILEI CO LTD",
     "symbol": "FKSHF"
    },
    {
     "description": "FLOWERKIST SKIN CARE COSMETI",
     "symbol": "FKST"
    },
    {
     "description": "FIRST TRUST UNITED KINGDOM",
     "symbol": "FKU"
    },
    {
     "description": "FRANKLIN WIRELESS CORP",
     "symbol": "FKWL"
    },
    {
     "description": "FIRST KEYSTONE CORP",
     "symbol": "FKYS"
    },
    {
     "description": "FOOT LOCKER INC",
     "symbol": "FL"
    },
    {
     "description": "FRAZIER LIFESCIENCES ACQUI-A",
     "symbol": "FLAC"
    },
    {
     "description": "FRAZIER LIFESCIENCES ACQUIS",
     "symbol": "FLACU"
    },
    {
     "description": "FRAZIER LIFESCIENCES AC-CW25",
     "symbol": "FLACW"
    },
    {
     "description": "FARM LANDS OF AFRICA",
     "symbol": "FLAF"
    },
    {
     "description": "FIRST LIGHT ACQUISITION GR-A",
     "symbol": "FLAG"
    },
    {
     "description": "FIRST LIGHT ACQUISITION GROU",
     "symbol": "FLAG.U"
    },
    {
     "description": "FIRST LIGHT ACQUISITIO -CW23",
     "symbol": "FLAG.WS"
    },
    {
     "description": "FRANKLIN FTSE AUSTRALIA ETF",
     "symbol": "FLAU"
    },
    {
     "description": "FRANKLIN FTSE ASIA EX JAPAN",
     "symbol": "FLAX"
    },
    {
     "description": "FRANKLIN LIBERTY SENIOR LOAN",
     "symbol": "FLBL"
    },
    {
     "description": "FRANKLIN FTSE BRAZIL ETF",
     "symbol": "FLBR"
    },
    {
     "description": "FLAH & CRUM TTL RTRN FND",
     "symbol": "FLC"
    },
    {
     "description": "FRANKLIN FTSE CANADA ETF",
     "symbol": "FLCA"
    },
    {
     "description": "FRANKLIN LIBERTY US CORE BND",
     "symbol": "FLCB"
    },
    {
     "description": "FRANKLIN FTSE CHINA ETF",
     "symbol": "FLCH"
    },
    {
     "description": "FRANKLIN LIBERTY IG CORP ETF",
     "symbol": "FLCO"
    },
    {
     "description": "FLOOIDCX CORP",
     "symbol": "FLCX"
    },
    {
     "description": "FLUIDRA SA-UNSPONSORED ADR",
     "symbol": "FLDAY"
    },
    {
     "description": "FOLKUP DEVELOPMENT INC",
     "symbol": "FLDI"
    },
    {
     "description": "FRONTLINE GOLD CORP",
     "symbol": "FLDPF"
    },
    {
     "description": "FIDELITY LOW DURATION ETF",
     "symbol": "FLDR"
    },
    {
     "description": "RIVERNORTH PATRIOT ETF",
     "symbol": "FLDZ"
    },
    {
     "description": "FRANKLIN FTSE EUROPE ETF",
     "symbol": "FLEE"
    },
    {
     "description": "FRANKLIN FTSE EUROPE HEDGED",
     "symbol": "FLEH"
    },
    {
     "description": "THE 4 LESS GROUP INC",
     "symbol": "FLES"
    },
    {
     "description": "FLEETWOOD BANK CORP",
     "symbol": "FLEW"
    },
    {
     "description": "FLEX LTD",
     "symbol": "FLEX"
    },
    {
     "description": "FLAGSTAFF HOLDINGS INC",
     "symbol": "FLFF"
    },
    {
     "description": "FEDERAL LIFE GROUP INC",
     "symbol": "FLFG"
    },
    {
     "description": "FRANKLIN FTSE FRANCE ETF",
     "symbol": "FLFR"
    },
    {
     "description": "FRANKLIN FTSE UNITED KINGDOM",
     "symbol": "FLGB"
    },
    {
     "description": "FLORA GROWTH CORP",
     "symbol": "FLGC"
    },
    {
     "description": "FLUOGUIDE A\/S",
     "symbol": "FLGDF"
    },
    {
     "description": "FLAGSHIP COMMUNITIES REIT UT",
     "symbol": "FLGMF"
    },
    {
     "description": "FRANKLIN FTSE GERMANY ETF",
     "symbol": "FLGR"
    },
    {
     "description": "FULGENT GENETICS INC",
     "symbol": "FLGT"
    },
    {
     "description": "FRANKLIN LIBERTY US TR B ETF",
     "symbol": "FLGV"
    },
    {
     "description": "FLUGHAFEN ZUERICH AG-REG",
     "symbol": "FLGZY"
    },
    {
     "description": "FRANKLIN FTSE HONG KONG ETF",
     "symbol": "FLHK"
    },
    {
     "description": "FILAMENT HEALTH CORP",
     "symbol": "FLHLF"
    },
    {
     "description": "FRANKLIN LIBERTY HIGH YIELD",
     "symbol": "FLHY"
    },
    {
     "description": "FRANKLIN LIBERTY INTL AGG BO",
     "symbol": "FLIA"
    },
    {
     "description": "FIRST OF LONG ISLAND CORP",
     "symbol": "FLIC"
    },
    {
     "description": "FLSMIDTH & CO A\/S",
     "symbol": "FLIDF"
    },
    {
     "description": "FLSMIDTH & CO A\/S-UNSPON ADR",
     "symbol": "FLIDY"
    },
    {
     "description": "FRANKLIN FTSE INDIA ETF",
     "symbol": "FLIN"
    },
    {
     "description": "F&C INVESTMENT TRUST PLC",
     "symbol": "FLIVF"
    },
    {
     "description": "FRANKLIN FTSE ITALY ETF",
     "symbol": "FLIY"
    },
    {
     "description": "FRANKLIN FTSE JPN HEDGED ETF",
     "symbol": "FLJH"
    },
    {
     "description": "FRANKLIN FTSE JAPAN ETF",
     "symbol": "FLJP"
    },
    {
     "description": "FIH GROUP PLC",
     "symbol": "FLKDF"
    },
    {
     "description": "FALKEN INDUSTRIES LTD",
     "symbol": "FLKI"
    },
    {
     "description": "FRANKLIN FTSE SOUTH KOREA",
     "symbol": "FLKR"
    },
    {
     "description": "FULL HOUSE RESORTS INC",
     "symbol": "FLL"
    },
    {
     "description": "FRANKLIN FTSE LATIN AMERICA",
     "symbol": "FLLA"
    },
    {
     "description": "FULLSHARE HOLDINGS LTD",
     "symbol": "FLLHF"
    },
    {
     "description": "FOLLI FOLLIE GROU-UNSPON ADR",
     "symbol": "FLLIY"
    },
    {
     "description": "FEEL FOODS LTD",
     "symbol": "FLLLF"
    },
    {
     "description": "FRANKLIN LIBERTY US LOW VOL",
     "symbol": "FLLV"
    },
    {
     "description": "FULLWEALTH INTERNATIONAL GRO",
     "symbol": "FLLWF"
    },
    {
     "description": "FELLAZO CORP",
     "symbol": "FLLZ"
    },
    {
     "description": "FIRST TRUST GLOBAL ENGINEERI",
     "symbol": "FLM"
    },
    {
     "description": "FRANKLIN LIBERTY FEDERAL TAX",
     "symbol": "FLMB"
    },
    {
     "description": "FLAME ACQUISITION CORP -CL A",
     "symbol": "FLME"
    },
    {
     "description": "FLAME ACQUISITION CORP",
     "symbol": "FLME.U"
    },
    {
     "description": "FLAME ACQUISITION CL A -CW28",
     "symbol": "FLME.WS"
    },
    {
     "description": "FT Equity Allocation ETF Model Portfolio 2Q 22 Cash",
     "symbol": "FLMHSX"
    },
    {
     "description": "FRANKLIN DYNAMIC MUNICIPAL B",
     "symbol": "FLMI"
    },
    {
     "description": "FILO MINING CORP",
     "symbol": "FLMMF"
    },
    {
     "description": "FALCON MINERALS CORP",
     "symbol": "FLMN"
    },
    {
     "description": "FIELMANN AG",
     "symbol": "FLMNF"
    },
    {
     "description": "FALCON MINERALS CORP-CW23",
     "symbol": "FLMNW"
    },
    {
     "description": "FIELMANN AG-ADR",
     "symbol": "FLMNY"
    },
    {
     "description": "FLAME SEAL PRODUCTS INCORPOR",
     "symbol": "FLMP"
    },
    {
     "description": "FULL METAL MINERALS LTD - A",
     "symbol": "FLMTF"
    },
    {
     "description": "FRANKLIN FTSE MEXICO ETF",
     "symbol": "FLMX"
    },
    {
     "description": "FIRST TRUST LATIN AMERICA",
     "symbol": "FLN"
    },
    {
     "description": "FLUENCE ENERGY INC",
     "symbol": "FLNC"
    },
    {
     "description": "FREELANCER LTD",
     "symbol": "FLNCF"
    },
    {
     "description": "FLINDERS MINES LTD",
     "symbol": "FLNDF"
    },
    {
     "description": "FLEX LNG LTD",
     "symbol": "FLNG"
    },
    {
     "description": "FLUENT INC",
     "symbol": "FLNT"
    },
    {
     "description": "FLOWERS FOODS INC",
     "symbol": "FLO"
    },
    {
     "description": "FRESHLOCAL SOLUTIONS INC",
     "symbol": "FLOCF"
    },
    {
     "description": "FLOWERY GOLD MINES CO\/NEV",
     "symbol": "FLOD"
    },
    {
     "description": "FLOWER ONE HOLDINGS INC",
     "symbol": "FLOOF"
    },
    {
     "description": "ISHARES FLOATING RATE BOND E",
     "symbol": "FLOT"
    },
    {
     "description": "FRANKLIN LIBERTYQ GLOBAL DIV",
     "symbol": "FLQD"
    },
    {
     "description": "FRANKLIN LIBERTYQ EMERGING",
     "symbol": "FLQE"
    },
    {
     "description": "FRANKLIN LIBERTYQ GLOBAL EQ",
     "symbol": "FLQG"
    },
    {
     "description": "FRANKLIN LIBERTYQ INT EQ HED",
     "symbol": "FLQH"
    },
    {
     "description": "FRANKLIN LIBERTYQ US EQUITY",
     "symbol": "FLQL"
    },
    {
     "description": "FRANKLIN LIBERTYQ MID CAP EQ",
     "symbol": "FLQM"
    },
    {
     "description": "FRANKLIN LIBERTYQ SMALL CAP",
     "symbol": "FLQS"
    },
    {
     "description": "FLUOR CORP",
     "symbol": "FLR"
    },
    {
     "description": "ESSENTRA PLC",
     "symbol": "FLRAF"
    },
    {
     "description": "FLAMERET INC",
     "symbol": "FLRE"
    },
    {
     "description": "FIDELITY US MULTIFACTOR ETF",
     "symbol": "FLRG"
    },
    {
     "description": "SPDR BLOOMBERG INVESTMENT GR",
     "symbol": "FLRN"
    },
    {
     "description": "PACER PACIFIC ASSET FLOATING",
     "symbol": "FLRT"
    },
    {
     "description": "FRANKLIN FTSE RUSSIA ETF",
     "symbol": "FLRU"
    },
    {
     "description": "FLOWSERVE CORP",
     "symbol": "FLS"
    },
    {
     "description": "FRANKLIN FTSE SAUDI ARABIA",
     "symbol": "FLSA"
    },
    {
     "description": "FRANKLIN LIBERTY SYSTEMATIC",
     "symbol": "FLSP"
    },
    {
     "description": "FORBES ENERGY SERVICES LTD",
     "symbol": "FLSS"
    },
    {
     "description": "FUELSTREAM INC",
     "symbol": "FLST"
    },
    {
     "description": "FRANKLIN FTSE SWITZERLAND",
     "symbol": "FLSW"
    },
    {
     "description": "FLEETCOR TECHNOLOGIES INC",
     "symbol": "FLT"
    },
    {
     "description": "FIDELITY LTD TERM BOND ETF",
     "symbol": "FLTB"
    },
    {
     "description": "FILTRONIC PLC",
     "symbol": "FLTCF"
    },
    {
     "description": "FLOW TRADERS",
     "symbol": "FLTDF"
    },
    {
     "description": "RAREVIEW INFLAT\/DEFLAT ETF",
     "symbol": "FLTN"
    },
    {
     "description": "V\/E INV GR FLOATING RATE ETF",
     "symbol": "FLTR"
    },
    {
     "description": "FRANKLIN FTSE TAIWAN ETF",
     "symbol": "FLTW"
    },
    {
     "description": "FRANKLIN LIBERTY UL SHT BOND",
     "symbol": "FLUD"
    },
    {
     "description": "FLUIDRA SA",
     "symbol": "FLUIF"
    },
    {
     "description": "FLUROTECH LTD",
     "symbol": "FLURF"
    },
    {
     "description": "FLUX POWER HOLDINGS INC",
     "symbol": "FLUX"
    },
    {
     "description": "AMERICAN CENTURY FOCUSED LAR",
     "symbol": "FLV"
    },
    {
     "description": "FLOW BEVERAGE CORP",
     "symbol": "FLWBF"
    },
    {
     "description": "FLOWR CORP\/THE",
     "symbol": "FLWPF"
    },
    {
     "description": "1-800-FLOWERS.COM INC-CL A",
     "symbol": "FLWS"
    },
    {
     "description": "FLUXYS BELGIUM",
     "symbol": "FLXBF"
    },
    {
     "description": "FLEXIINTERNATIONAL SOFTWARE",
     "symbol": "FLXI"
    },
    {
     "description": "FLEXPOWER INC",
     "symbol": "FLXP"
    },
    {
     "description": "FLEXQUBE AB",
     "symbol": "FLXQF"
    },
    {
     "description": "FLEXSTEEL INDS",
     "symbol": "FLXS"
    },
    {
     "description": "FLEXPOINT SENSOR SYSTEMS INC",
     "symbol": "FLXT"
    },
    {
     "description": "SOAR TECHNOLOGY ACQUISITIO-A",
     "symbol": "FLYA"
    },
    {
     "description": "SOAR TECHNOLOGY ACQUISITION",
     "symbol": "FLYA.U"
    },
    {
     "description": "SOAR TECH ACQ CL A -CW27",
     "symbol": "FLYA.WS"
    },
    {
     "description": "FLYHT AEROSPACE SOLUTIONS LT",
     "symbol": "FLYLF"
    },
    {
     "description": "FLYING NICKEL MINING CORP",
     "symbol": "FLYNF"
    },
    {
     "description": "FLYWIRE CORP-VOTING",
     "symbol": "FLYW"
    },
    {
     "description": "FRANKLIN FTSE SOUTH AFRICA",
     "symbol": "FLZA"
    },
    {
     "description": "ISHR MSCI FRONT & SEL EM ETF",
     "symbol": "FM"
    },
    {
     "description": "FIDELITY MAGELLAN ETF",
     "symbol": "FMAG"
    },
    {
     "description": "FREEMAN GOLD CORP",
     "symbol": "FMANF"
    },
    {
     "description": "FARMERS & MERCHANTS BANCO\/OH",
     "symbol": "FMAO"
    },
    {
     "description": "FT CBOE VEST US EQTY BUF-MAR",
     "symbol": "FMAR"
    },
    {
     "description": "FIDELITY MATERIALS ETF",
     "symbol": "FMAT"
    },
    {
     "description": "FT CBOE VEST US EQY BUFF-MAY",
     "symbol": "FMAY"
    },
    {
     "description": "FIRST TRUST MANAGED MUNICIPA",
     "symbol": "FMB"
    },
    {
     "description": "FIRST MID BANCSHARES INC",
     "symbol": "FMBH"
    },
    {
     "description": "FARMERS & MERCHANTS BANK\/CA",
     "symbol": "FMBL"
    },
    {
     "description": "F & M BANK CORP",
     "symbol": "FMBM"
    },
    {
     "description": "FARMERS & MERCHANTS BANCSHAR",
     "symbol": "FMBN"
    },
    {
     "description": "FAMOUS BRANDS LTD-UNSP ADR",
     "symbol": "FMBRY"
    },
    {
     "description": "FULL MOTION BEVERAGE INC",
     "symbol": "FMBV"
    },
    {
     "description": "FMC CORP",
     "symbol": "FMC"
    },
    {
     "description": "FARMERS & MERCHANTS BANCO\/CA",
     "symbol": "FMCB"
    },
    {
     "description": "FREDDIE MAC",
     "symbol": "FMCC"
    },
    {
     "description": "Federal Home Loan Mortgage Corporation",
     "symbol": "FMCCG"
    },
    {
     "description": "Federal Home Loan Mortgage Corporation",
     "symbol": "FMCCH"
    },
    {
     "description": "Federal Home Loan Mortgage Corporation",
     "symbol": "FMCCI"
    },
    {
     "description": "Federal Home Loan Mortgage Corporation",
     "symbol": "FMCCJ"
    },
    {
     "description": "Federal Home Loan Mortgage Corporation",
     "symbol": "FMCCK"
    },
    {
     "description": "Federal Home Loan Mortgage Corporation",
     "symbol": "FMCCL"
    },
    {
     "description": "Federal Home Loan Mortgage Corporation",
     "symbol": "FMCCM"
    },
    {
     "description": "Federal Home Loan Mortgage Corporation",
     "symbol": "FMCCN"
    },
    {
     "description": "Federal Home Loan Mortgage Corporation",
     "symbol": "FMCCO"
    },
    {
     "description": "Federal Home Loan Mortgage Corporation",
     "symbol": "FMCCP"
    },
    {
     "description": "Federal Home Loan Mortgage Corporation",
     "symbol": "FMCCS"
    },
    {
     "description": "Federal Home Loan Mortgage Corporation",
     "symbol": "FMCCT"
    },
    {
     "description": "Federal Home Loan Mortgage Corporation",
     "symbol": "FMCKI"
    },
    {
     "description": "Federal Home Loan Mortgage Corporation",
     "symbol": "FMCKJ"
    },
    {
     "description": "Federal Home Loan Mortgage Corporation",
     "symbol": "FMCKK"
    },
    {
     "description": "Federal Home Loan Mortgage Corporation",
     "symbol": "FMCKL"
    },
    {
     "description": "Federal Home Loan Mortgage Corporation",
     "symbol": "FMCKM"
    },
    {
     "description": "Federal Home Loan Mortgage Corporation",
     "symbol": "FMCKN"
    },
    {
     "description": "Federal Home Loan Mortgage Corporation",
     "symbol": "FMCKO"
    },
    {
     "description": "Federal Home Loan Mortgage Corporation",
     "symbol": "FMCKP"
    },
    {
     "description": "FRESENIUS MEDICAL CARE AG &",
     "symbol": "FMCQF"
    },
    {
     "description": "FORAN MINING CORPORATION",
     "symbol": "FMCXF"
    },
    {
     "description": "FARMERS EDGE INC",
     "symbol": "FMEGF"
    },
    {
     "description": "FUNDSMITH EMERGING EQ TRUST",
     "symbol": "FMEQF"
    },
    {
     "description": "FIDELITY METAVERSE ETF",
     "symbol": "FMET"
    },
    {
     "description": "FIRST TRUST MANAGED FUTURES",
     "symbol": "FMF"
    },
    {
     "description": "FARMERS AND MERCHANTS BANCSH",
     "symbol": "FMFG"
    },
    {
     "description": "FIRST MONTAUK FINL CORP",
     "symbol": "FMFN"
    },
    {
     "description": "FIRST COMMUNITY FINL CORP",
     "symbol": "FMFP"
    },
    {
     "description": "FAIRMILE GOLDTECH INC",
     "symbol": "FMGDF"
    },
    {
     "description": "FAH MAI HOLDINGS GROUP INC",
     "symbol": "FMHG"
    },
    {
     "description": "FIRST TRUST MUNICIPAL HIGH I",
     "symbol": "FMHI"
    },
    {
     "description": "FARMHOUSE INC",
     "symbol": "FMHS"
    },
    {
     "description": "FIRST MIAMI BANCORP INC",
     "symbol": "FMIA"
    },
    {
     "description": "FIDELITY NEW MILLENNIUM ETF",
     "symbol": "FMIL"
    },
    {
     "description": "FORUM MERGER IV CORP-A",
     "symbol": "FMIV"
    },
    {
     "description": "FORUM MERGER IV CORP",
     "symbol": "FMIVU"
    },
    {
     "description": "FORUM MERGER IV CL A -CW27",
     "symbol": "FMIVW"
    },
    {
     "description": "FUJI CORP\/AICHI",
     "symbol": "FMMFF"
    },
    {
     "description": "FEDERATED HERMES PREMIER MUN",
     "symbol": "FMN"
    },
    {
     "description": "FARMERS NATL BANC CORP",
     "symbol": "FMNB"
    },
    {
     "description": "FRANKLIN MINING INC",
     "symbol": "FMNJ"
    },
    {
     "description": "FIRST TRUST NY MUNI HIGH INC",
     "symbol": "FMNY"
    },
    {
     "description": "FOMENTO DE CONSTRUC Y CONTRA",
     "symbol": "FMOCF"
    },
    {
     "description": "FOMENTO DE CONST-UNSPON ADR",
     "symbol": "FMOCY"
    },
    {
     "description": "F & M BANCORP OHIO",
     "symbol": "FMOO"
    },
    {
     "description": "FAME PRODUCTIONS INC",
     "symbol": "FMPR"
    },
    {
     "description": "FMQQ NXT FRNT & ECOMM ETF",
     "symbol": "FMQQ"
    },
    {
     "description": "FRESENIUS MEDICAL CARE-ADR",
     "symbol": "FMS"
    },
    {
     "description": "FORMA THERAPEUTICS HOLDINGS",
     "symbol": "FMTX"
    },
    {
     "description": "FOMENTO ECONOMICO MEX-SP ADR",
     "symbol": "FMX"
    },
    {
     "description": "FOMENTO ECONOMICO MEXICA-UBD",
     "symbol": "FMXUF"
    },
    {
     "description": "AMILOT CAPITAL INC",
     "symbol": "FMXVF"
    },
    {
     "description": "FIRST TRUST MORTGAGE INCOME",
     "symbol": "FMY"
    },
    {
     "description": "FAMILY ROOM ENTERTAINMENT",
     "symbol": "FMYR"
    },
    {
     "description": "FAMILY ZONE CYBER SAFETY LTD",
     "symbol": "FMZNF"
    },
    {
     "description": "FABRINET",
     "symbol": "FN"
    },
    {
     "description": "PARAGON 28 INC",
     "symbol": "FNA"
    },
    {
     "description": "EVOLUTIONARY GENOMICS INC",
     "symbol": "FNAM"
    },
    {
     "description": "FOUR NINES GOLD INC\/CA",
     "symbol": "FNAUF"
    },
    {
     "description": "FNB CORP",
     "symbol": "FNB"
    },
    {
     "description": "FNB CORP",
     "symbol": "FNB.PRE"
    },
    {
     "description": "FINECOBANK SPA-UNSP ADR",
     "symbol": "FNBKY"
    },
    {
     "description": "FINABLR PLC",
     "symbol": "FNBLF"
    },
    {
     "description": "FINBAR GROUP LTD",
     "symbol": "FNBRF"
    },
    {
     "description": "FINEMARK HOLDINGS INC",
     "symbol": "FNBT"
    },
    {
     "description": "FNCB BANCORP INC",
     "symbol": "FNCB"
    },
    {
     "description": "COVIVIO-UNSP ADR",
     "symbol": "FNCDY"
    },
    {
     "description": "FINCH THERAPEUTICS GROUP INC",
     "symbol": "FNCH"
    },
    {
     "description": "FINEOS CORP HOLDINGS PLC-CDI",
     "symbol": "FNCHF"
    },
    {
     "description": "MONCEY FINANCIERE",
     "symbol": "FNCIF"
    },
    {
     "description": "FANCAMP EXPLORATION LTD",
     "symbol": "FNCJF"
    },
    {
     "description": "FIDELITY FINANCIALS ETF",
     "symbol": "FNCL"
    },
    {
     "description": "FINCANTIERI SPA",
     "symbol": "FNCNF"
    },
    {
     "description": "NORTH AMERICAN FINANCIAL",
     "symbol": "FNCSF"
    },
    {
     "description": "ORANGE",
     "symbol": "FNCTF"
    },
    {
     "description": "FLOOR & DECOR HOLDINGS INC-A",
     "symbol": "FND"
    },
    {
     "description": "SCHWAB FUNDAMENTAL SMALL CAP",
     "symbol": "FNDA"
    },
    {
     "description": "SCHWAB FUNDAMENTAL BROAD MKT",
     "symbol": "FNDB"
    },
    {
     "description": "SCHWAB FUNDAMENTAL INTL S\/C",
     "symbol": "FNDC"
    },
    {
     "description": "SCHWAB FUNDAMENTAL EM L\/C",
     "symbol": "FNDE"
    },
    {
     "description": "SCHWAB FUNDAMENTAL INTL L\/C",
     "symbol": "FNDF"
    },
    {
     "description": "FUND.COM INC-CLASS A",
     "symbol": "FNDM"
    },
    {
     "description": "FONDO DE VALORES INMOBIL-ADR",
     "symbol": "FNDOY"
    },
    {
     "description": "FRIENDTIMES INC",
     "symbol": "FNDTF"
    },
    {
     "description": "SCHWAB FUNDAMENTAL LARGE CAP",
     "symbol": "FNDX"
    },
    {
     "description": "FIRST NATIONAL ENERGY CORP",
     "symbol": "FNEC"
    },
    {
     "description": "FRASER AND NEAVE LTD",
     "symbol": "FNEVF"
    },
    {
     "description": "FRASER AND NEAVE LTD-UNS ADR",
     "symbol": "FNEVY"
    },
    {
     "description": "FIDELITY NATIONAL FINANCIAL",
     "symbol": "FNF"
    },
    {
     "description": "FIRST NILES FINANCIAL INC",
     "symbol": "FNFI"
    },
    {
     "description": "First Niles Financial Inc",
     "symbol": "FNFPA"
    },
    {
     "description": "MICROSECTORS FANG+ INDEX -3X",
     "symbol": "FNGD"
    },
    {
     "description": "DIR DAY SL LRG FANGS BULL 2X",
     "symbol": "FNGG"
    },
    {
     "description": "ODESSA MINERALS LTD",
     "symbol": "FNGGF"
    },
    {
     "description": "MICROSECTORS FANG INDEX 2X L",
     "symbol": "FNGO"
    },
    {
     "description": "FINGERMOTION INC",
     "symbol": "FNGR"
    },
    {
     "description": "MICROSECTORS FANG+ ETNS",
     "symbol": "FNGS"
    },
    {
     "description": "MICROSECTORS FANG+ INDEX 3X",
     "symbol": "FNGU"
    },
    {
     "description": "FEDNAT HOLDING CO",
     "symbol": "FNHC"
    },
    {
     "description": "FIRST TRUST CHINDIA ETF",
     "symbol": "FNI"
    },
    {
     "description": "FATHOM NICKEL INC",
     "symbol": "FNICF"
    },
    {
     "description": "49 NORTH RESOURCES INC",
     "symbol": "FNINF"
    },
    {
     "description": "FIRST TRUST MID CAP VALUE",
     "symbol": "FNK"
    },
    {
     "description": "FUNKO INC-CLASS A",
     "symbol": "FNKO"
    },
    {
     "description": "FIRST BANCORP INC\/ME",
     "symbol": "FNLC"
    },
    {
     "description": "FIRST NATIONAL FINANCIAL COR",
     "symbol": "FNLIF"
    },
    {
     "description": "FRESNILLO PLC",
     "symbol": "FNLPF"
    },
    {
     "description": "FANNIE MAE",
     "symbol": "FNMA"
    },
    {
     "description": "Fannie Mae",
     "symbol": "FNMAG"
    },
    {
     "description": "Fannie Mae",
     "symbol": "FNMAH"
    },
    {
     "description": "Fannie Mae",
     "symbol": "FNMAI"
    },
    {
     "description": "Fannie Mae",
     "symbol": "FNMAJ"
    },
    {
     "description": "Fannie Mae",
     "symbol": "FNMAK"
    },
    {
     "description": "Fannie Mae",
     "symbol": "FNMAL"
    },
    {
     "description": "Fannie Mae",
     "symbol": "FNMAM"
    },
    {
     "description": "Fannie Mae",
     "symbol": "FNMAN"
    },
    {
     "description": "Fannie Mae",
     "symbol": "FNMAO"
    },
    {
     "description": "Fannie Mae",
     "symbol": "FNMAP"
    },
    {
     "description": "Fannie Mae",
     "symbol": "FNMAS"
    },
    {
     "description": "Fannie Mae",
     "symbol": "FNMAT"
    },
    {
     "description": "Federal National Mortgage Association",
     "symbol": "FNMFM"
    },
    {
     "description": "Federal National Mortgage Association",
     "symbol": "FNMFN"
    },
    {
     "description": "Federal National Mortgage Association",
     "symbol": "FNMFO"
    },
    {
     "description": "FINANCIAL 15 SPLIT CORP-A",
     "symbol": "FNNCF"
    },
    {
     "description": "FINNAIR OYJ",
     "symbol": "FNNNF"
    },
    {
     "description": "FLATEXDEGIRO AG",
     "symbol": "FNNTF"
    },
    {
     "description": "FINCANNA CAPITAL CORP",
     "symbol": "FNNZF"
    },
    {
     "description": "FURUNO ELECTRIC CO LTD",
     "symbol": "FNOEF"
    },
    {
     "description": "FT CBOE VEST US EQUITY BUFF",
     "symbol": "FNOV"
    },
    {
     "description": "Fortnox AB",
     "symbol": "FNOXF"
    },
    {
     "description": "FINEQIA INTERNATIONAL INC",
     "symbol": "FNQQF"
    },
    {
     "description": "1ST NRG CORP",
     "symbol": "FNRC"
    },
    {
     "description": "FORCEFIELD ENERGY INC",
     "symbol": "FNRG"
    },
    {
     "description": "FIRST NORTHERN COMMUNITY BAN",
     "symbol": "FNRN"
    },
    {
     "description": "DIREXION DAILY FINT BULL 2X",
     "symbol": "FNTC"
    },
    {
     "description": "FRONTEO INC",
     "symbol": "FNTOF"
    },
    {
     "description": "XR IMMERSIVE TECH INC",
     "symbol": "FNTTF"
    },
    {
     "description": "FRANCO-NEVADA CORP",
     "symbol": "FNV"
    },
    {
     "description": "FARNOVA GROUP HOLDINGS LTD",
     "symbol": "FNVAF"
    },
    {
     "description": "FINNOVATE ACQUISITION CORP-A",
     "symbol": "FNVT"
    },
    {
     "description": "FINNOVATE ACQUISITION CORP",
     "symbol": "FNVTU"
    },
    {
     "description": "FINNOVATE ACQUISITION -CW23",
     "symbol": "FNVTW"
    },
    {
     "description": "FIRST NORTHWEST BANCORP",
     "symbol": "FNWB"
    },
    {
     "description": "FINWARD BANCORP",
     "symbol": "FNWD"
    },
    {
     "description": "FIRST TRUST MID CAP CORE ALP",
     "symbol": "FNX"
    },
    {
     "description": "FENIX FINANCIAL LTD-ACCR INV",
     "symbol": "FNXLF"
    },
    {
     "description": "FENIX OUTDOOR INTERNATINONAL",
     "symbol": "FNXTF"
    },
    {
     "description": "FIRST TRUST MID CAP GROWTH",
     "symbol": "FNY"
    },
    {
     "description": "FINANCE OF AMERICA COS INC-A",
     "symbol": "FOA"
    },
    {
     "description": "FINANCE OF AMERICA COS -CW26",
     "symbol": "FOA.WS"
    },
    {
     "description": "FOBI AI INC",
     "symbol": "FOBIF"
    },
    {
     "description": "FOCUSRITE PLC",
     "symbol": "FOCIF"
    },
    {
     "description": "FOCUS FINANCIAL PARTNERS-A",
     "symbol": "FOCS"
    },
    {
     "description": "FT CBOE VEST US EQ BUFF OCT",
     "symbol": "FOCT"
    },
    {
     "description": "DOLPHIN DRILLING ASA",
     "symbol": "FOEAF"
    },
    {
     "description": "COHEN & STEERS CLOSED-END OP",
     "symbol": "FOF"
    },
    {
     "description": "AVISA DIAGNOSTICS INC",
     "symbol": "FOGCF"
    },
    {
     "description": "FORTUM OYJ",
     "symbol": "FOJCF"
    },
    {
     "description": "FORTUM OYJ-UNSPONSORED ADR",
     "symbol": "FOJCY"
    },
    {
     "description": "AMICUS THERAPEUTICS INC",
     "symbol": "FOLD"
    },
    {
     "description": "FALCON OIL & GAS LTD",
     "symbol": "FOLGF"
    },
    {
     "description": "FOMO CORP",
     "symbol": "FOMC"
    },
    {
     "description": "FOMO ETF",
     "symbol": "FOMO"
    },
    {
     "description": "FONAR CORP",
     "symbol": "FONR"
    },
    {
     "description": "FONU2 INC",
     "symbol": "FONU"
    },
    {
     "description": "FLOWER ONE HOLDINGS IN -CW23",
     "symbol": "FONWF"
    },
    {
     "description": "FORESTAR GROUP INC",
     "symbol": "FOR"
    },
    {
     "description": "FORIAN INC",
     "symbol": "FORA"
    },
    {
     "description": "FORWARD INDUSTRIES INC",
     "symbol": "FORD"
    },
    {
     "description": "Fortis Inc",
     "symbol": "FORFF"
    },
    {
     "description": "FORGEROCK INC-A",
     "symbol": "FORG"
    },
    {
     "description": "FORMIDABLE ETF",
     "symbol": "FORH"
    },
    {
     "description": "FORMFACTOR INC",
     "symbol": "FORM"
    },
    {
     "description": "FORRESTER RESEARCH INC",
     "symbol": "FORR"
    },
    {
     "description": "FORMULA SYSTEMS 1985-SP ADR",
     "symbol": "FORTY"
    },
    {
     "description": "FORU HOLDINGS INC",
     "symbol": "FORU"
    },
    {
     "description": "FORWARDLY INC",
     "symbol": "FORW"
    },
    {
     "description": "FORZA INNOVATIONS INC",
     "symbol": "FORZ"
    },
    {
     "description": "FOSSIL GROUP INC",
     "symbol": "FOSL"
    },
    {
     "description": "FOSSIL GROUP INC",
     "symbol": "FOSLL"
    },
    {
     "description": "FOSUN INTERNATIONAL LTD",
     "symbol": "FOSUF"
    },
    {
     "description": "FOSUN INTERNATIONAL-UNSP ADR",
     "symbol": "FOSUY"
    },
    {
     "description": "FORSYS METALS CORP",
     "symbol": "FOSYF"
    },
    {
     "description": "FIRST OTTAWA BANCSHARES INC",
     "symbol": "FOTB"
    },
    {
     "description": "FOUNDER SPAC-CL A",
     "symbol": "FOUN"
    },
    {
     "description": "FOUNDER SPAC",
     "symbol": "FOUNU"
    },
    {
     "description": "FOUNDER SPAC -CW23",
     "symbol": "FOUNW"
    },
    {
     "description": "SHIFT4 PAYMENTS INC-CLASS A",
     "symbol": "FOUR"
    },
    {
     "description": "ISHARES FOCUSED VALUE FACTOR",
     "symbol": "FOVL"
    },
    {
     "description": "FORD OTOMOTIV SANAYI AS-ADR",
     "symbol": "FOVSY"
    },
    {
     "description": "FOX CORP - CLASS B",
     "symbol": "FOX"
    },
    {
     "description": "FOX CORP - CLASS A",
     "symbol": "FOXA"
    },
    {
     "description": "FOX FACTORY HOLDING CORP",
     "symbol": "FOXF"
    },
    {
     "description": "FOXWAYNE ENTERPRISES ACQ- A",
     "symbol": "FOXW"
    },
    {
     "description": "FOXWAYNE ENTERPRISES ACQUISI",
     "symbol": "FOXWU"
    },
    {
     "description": "FOXWAYNE ENTERPRISES A -CW26",
     "symbol": "FOXWW"
    },
    {
     "description": "FOY-JOHNSTON INC",
     "symbol": "FOYJ"
    },
    {
     "description": "FIRST TRUST ASIA PAC EX-JAPN",
     "symbol": "FPA"
    },
    {
     "description": "FAR PEAK ACQUISITION CORP-A",
     "symbol": "FPAC"
    },
    {
     "description": "FAR PEAK ACQUISITION CORP",
     "symbol": "FPAC.U"
    },
    {
     "description": "FAR PEAK ACQ CL A -CW25",
     "symbol": "FPAC.WS"
    },
    {
     "description": "FIRST PACIFIC CO",
     "symbol": "FPAFF"
    },
    {
     "description": "FIRST PACIFIC CO LTD-SP ADR",
     "symbol": "FPAFY"
    },
    {
     "description": "FPA GLOBAL EQUITY ETF",
     "symbol": "FPAG"
    },
    {
     "description": "FLEXSHOPPER INC",
     "symbol": "FPAY"
    },
    {
     "description": "FIRST PHYSICIANS CAPITAL GRO",
     "symbol": "FPCG"
    },
    {
     "description": "FP CORP",
     "symbol": "FPCPF"
    },
    {
     "description": "FT-PREFERRED SECUR & INC ETF",
     "symbol": "FPE"
    },
    {
     "description": "FIRST TRUST INSTITUTIONAL PR",
     "symbol": "FPEI"
    },
    {
     "description": "FIRST TRUST INTERMEDIATE DUR",
     "symbol": "FPF"
    },
    {
     "description": "FIDELITY PREFERRED SEC INC",
     "symbol": "FPFD"
    },
    {
     "description": "FIVE POINT HOLDINGS LLC-CL A",
     "symbol": "FPH"
    },
    {
     "description": "FARON PHARMACEUTICALS OY",
     "symbol": "FPHAF"
    },
    {
     "description": "FIRST PHILIPPINE HLDGS",
     "symbol": "FPHHF"
    },
    {
     "description": "FARMLAND PARTNERS INC",
     "symbol": "FPI"
    },
    {
     "description": "FIRST TRUST NEW OPPORTUNITIE",
     "symbol": "FPL"
    },
    {
     "description": "FIRST PET LIFE INC",
     "symbol": "FPLF"
    },
    {
     "description": "PROVIDENT FINANCIAL PLC",
     "symbol": "FPLPF"
    },
    {
     "description": "PROVIDENT FINANCIAL-SPON ADR",
     "symbol": "FPLPY"
    },
    {
     "description": "5N PLUS INC",
     "symbol": "FPLSF"
    },
    {
     "description": "FLUOROPHARMA MEDICAL INC",
     "symbol": "FPMI"
    },
    {
     "description": "FP NEWSPAPERS INC",
     "symbol": "FPNUF"
    },
    {
     "description": "FPX NICKEL CORP",
     "symbol": "FPOCF"
    },
    {
     "description": "FIELDPOINT PETROLEUM CORP",
     "symbol": "FPPP"
    },
    {
     "description": "FALCO RESOURCES LTD",
     "symbol": "FPRGF"
    },
    {
     "description": "FIDELITY REAL ESTATE INVEST",
     "symbol": "FPRO"
    },
    {
     "description": "FRAPORT AG FRANKFURT AIRPORT",
     "symbol": "FPRUF"
    },
    {
     "description": "FRAPORT AG-UNSP ADR",
     "symbol": "FPRUY"
    },
    {
     "description": "CAPHA PHARMACEUTICALS INC",
     "symbol": "FPSUF"
    },
    {
     "description": "GOLDEN PURSUIT RESOURCES LTD",
     "symbol": "FPVTF"
    },
    {
     "description": "CHARLESTOWNE PREMIUM BEVERAG",
     "symbol": "FPWM"
    },
    {
     "description": "FIRST TRUST US EQUITY OPPORT",
     "symbol": "FPX"
    },
    {
     "description": "FIRST TRUST IPOX EUROPE EQUI",
     "symbol": "FPXE"
    },
    {
     "description": "FIRST TRUST INTERNATIONAL EQ",
     "symbol": "FPXI"
    },
    {
     "description": "FIDELITY QUALITY FACTOR ETF",
     "symbol": "FQAL"
    },
    {
     "description": "FUQUAN CAPITAL MANAGEMENT IN",
     "symbol": "FQCC"
    },
    {
     "description": "FUQUAN FINANCIAL CO",
     "symbol": "FQFC"
    },
    {
     "description": "FT 10091 BIE ETF PF SE55-UI",
     "symbol": "FQIENX"
    },
    {
     "description": "FIRST QUANTUM MINERALS LTD",
     "symbol": "FQVLF"
    },
    {
     "description": "FEVERTREE DRINKS PLC",
     "symbol": "FQVTF"
    },
    {
     "description": "FEVERTREE DRINKS PLC-UNS ADR",
     "symbol": "FQVTY"
    },
    {
     "description": "FIRST INDUSTRIAL REALTY TR",
     "symbol": "FR"
    },
    {
     "description": "BLACKROCK FLOAT RT INCOME ST",
     "symbol": "FRA"
    },
    {
     "description": "FORACO INTERNATIONAL SA",
     "symbol": "FRACF"
    },
    {
     "description": "FRANKLIN FINANCIAL SERVICES",
     "symbol": "FRAF"
    },
    {
     "description": "FRANCISCO INDS INC",
     "symbol": "FRAZ"
    },
    {
     "description": "FIRST BANK\/HAMILTON NJ",
     "symbol": "FRBA"
    },
    {
     "description": "REPUBLIC FIRST BANCORP INC",
     "symbol": "FRBK"
    },
    {
     "description": "FIREBIRD METALS LTD",
     "symbol": "FRBMF"
    },
    {
     "description": "FORBION EUROPEAN ACQUISITI-A",
     "symbol": "FRBN"
    },
    {
     "description": "FORBION EUROPEAN ACQUISITION",
     "symbol": "FRBNU"
    },
    {
     "description": "FORBION EUROPEAN ACQUI A -23",
     "symbol": "FRBNW"
    },
    {
     "description": "FIRST REPUBLIC BANK\/CA",
     "symbol": "FRC"
    },
    {
     "description": "FIRST REPUBLIC BANK",
     "symbol": "FRC.PRH"
    },
    {
     "description": "FIRST REPUBLIC BANK",
     "symbol": "FRC.PRI"
    },
    {
     "description": "FIRST REPUBLIC BANK",
     "symbol": "FRC.PRJ"
    },
    {
     "description": "FIRST REPUBLIC BANK",
     "symbol": "FRC.PRK"
    },
    {
     "description": "FIRST REPUBLIC BANK",
     "symbol": "FRC.PRL"
    },
    {
     "description": "FIRST REPUBLIC BANK",
     "symbol": "FRC.PRM"
    },
    {
     "description": "FIRST REPUBLIC BANK",
     "symbol": "FRC.PRN"
    },
    {
     "description": "FLETCHER BUILDING LTD",
     "symbol": "FRCEF"
    },
    {
     "description": "FAIRCOURT GOLD INCOME CORP",
     "symbol": "FRCGF"
    },
    {
     "description": "FIREMANS CONTRACTORS INC",
     "symbol": "FRCN"
    },
    {
     "description": "FAST RETAILING CO LTD",
     "symbol": "FRCOF"
    },
    {
     "description": "FAST RETAILING CO-UNSPON ADR",
     "symbol": "FRCOY"
    },
    {
     "description": "FRIEDMAN INDUSTRIES",
     "symbol": "FRD"
    },
    {
     "description": "FREEDOM 100 EMEGING MRKT ETF",
     "symbol": "FRDM"
    },
    {
     "description": "4DS MEMORY LTD",
     "symbol": "FRDSF"
    },
    {
     "description": "NOUMI LTD",
     "symbol": "FRDZF"
    },
    {
     "description": "FREDONIA MINING INC",
     "symbol": "FREDF"
    },
    {
     "description": "WHOLE EARTH BRANDS INC",
     "symbol": "FREE"
    },
    {
     "description": "FREESEAS INC",
     "symbol": "FREEF"
    },
    {
     "description": "ACT II GLOBAL ACQUISITI-CW24",
     "symbol": "FREEW"
    },
    {
     "description": "Federal Home Loan Mortgage Corporation",
     "symbol": "FREGP"
    },
    {
     "description": "Federal Home Loan Mortgage Corporation",
     "symbol": "FREJN"
    },
    {
     "description": "Federal Home Loan Mortgage Corporation",
     "symbol": "FREJO"
    },
    {
     "description": "Federal Home Loan Mortgage Corporation",
     "symbol": "FREJP"
    },
    {
     "description": "FREEE KK",
     "symbol": "FREKF"
    },
    {
     "description": "FIDELITY REAL ESTATE ETF",
     "symbol": "FREL"
    },
    {
     "description": "SMARTFREN TELECOM TBK PT",
     "symbol": "FRENF"
    },
    {
     "description": "FREQUENCY THERAPEUTICS INC",
     "symbol": "FREQ"
    },
    {
     "description": "FREMONT GOLD LTD",
     "symbol": "FRERF"
    },
    {
     "description": "FIRST REAL ESTATE INV TR NJ",
     "symbol": "FREVS"
    },
    {
     "description": "FREYR BATTERY SA",
     "symbol": "FREY"
    },
    {
     "description": "FREYR BATTERY SA -CW27",
     "symbol": "FREY.WS"
    },
    {
     "description": "The Fortegra Group Inc",
     "symbol": "FRF"
    },
    {
     "description": "THE FRESH FACTORY BC LTD",
     "symbol": "FRFAF"
    },
    {
     "description": "FIRST ROBINSON FINL CORP",
     "symbol": "FRFC"
    },
    {
     "description": "Fairfax Financial Holdings Ltd",
     "symbol": "FRFFF"
    },
    {
     "description": "Fairfax Financial Holdings Ltd",
     "symbol": "FRFGF"
    },
    {
     "description": "FAIRFAX FINANCIAL HLDGS LTD",
     "symbol": "FRFHF"
    },
    {
     "description": "FRITZY TECH INC",
     "symbol": "FRFR"
    },
    {
     "description": "TFF GROUP",
     "symbol": "FRFTF"
    },
    {
     "description": "Fairfax Financial Holdings Ltd",
     "symbol": "FRFXF"
    },
    {
     "description": "Fairfax Financial Holdings Ltd",
     "symbol": "FRFZF"
    },
    {
     "description": "FRANCHISE GROUP INC",
     "symbol": "FRG"
    },
    {
     "description": "FRANCHISE GROUP INC",
     "symbol": "FRGAP"
    },
    {
     "description": "FORGE GLOBAL HOLDINGS INC",
     "symbol": "FRGE"
    },
    {
     "description": "FORGE GLOBAL HOLDING-CL-CW25",
     "symbol": "FRGE.WS"
    },
    {
     "description": "FORGAME HOLDINGS LTD-ADR",
     "symbol": "FRGHY"
    },
    {
     "description": "FIESTA RESTAURANT GROUP",
     "symbol": "FRGI"
    },
    {
     "description": "FIRE & GAS DETECTION TECHNOL",
     "symbol": "FRGSF"
    },
    {
     "description": "FRONTIER ENERGY CORP",
     "symbol": "FRGY"
    },
    {
     "description": "FREEDOM HOLDING CORP\/NV",
     "symbol": "FRHC"
    },
    {
     "description": "FRESHII",
     "symbol": "FRHHF"
    },
    {
     "description": "FREEHOLD ROYALTIES LTD",
     "symbol": "FRHLF"
    },
    {
     "description": "FIRST TRUST S&P REIT INDEX F",
     "symbol": "FRI"
    },
    {
     "description": "MGI DIGITAL GRAPHIC TECHNOLO",
     "symbol": "FRIIF"
    },
    {
     "description": "FORTUNE REIT",
     "symbol": "FRIVF"
    },
    {
     "description": "FORTUNE RISE ACQUISITION COR",
     "symbol": "FRLA"
    },
    {
     "description": "FORTUNE RISE ACQUISITION COR",
     "symbol": "FRLAU"
    },
    {
     "description": "FORTUNE RISE ACQUISIT -CW23",
     "symbol": "FRLAW"
    },
    {
     "description": "FRELII INC",
     "symbol": "FRLI"
    },
    {
     "description": "FREELINE THERAPEUTICS HOLDIN",
     "symbol": "FRLN"
    },
    {
     "description": "FRASERS LOGISTICS & COMMERCI",
     "symbol": "FRLOF"
    },
    {
     "description": "FIRMA HOLDINGS CORP",
     "symbol": "FRMA"
    },
    {
     "description": "FORUM MOBILE INC",
     "symbol": "FRMB"
    },
    {
     "description": "FORMCAP CORP",
     "symbol": "FRMC"
    },
    {
     "description": "FIRST MERCHANTS CORP",
     "symbol": "FRME"
    },
    {
     "description": "FIRST MERCHANTS CORP",
     "symbol": "FRMEP"
    },
    {
     "description": "FRMO CORP",
     "symbol": "FRMO"
    },
    {
     "description": "FIRM CAPITAL PROPERTY TRUST",
     "symbol": "FRMUF"
    },
    {
     "description": "FRONTIER RESOURCES LTD",
     "symbol": "FRNRF"
    },
    {
     "description": "FRONTERA INVESTMENT INC",
     "symbol": "FRNV"
    },
    {
     "description": "FIDELITY CLEAN ENERGY ETF",
     "symbol": "FRNW"
    },
    {
     "description": "FUTURE PLC",
     "symbol": "FRNWF"
    },
    {
     "description": "FRONTLINE LTD",
     "symbol": "FRO"
    },
    {
     "description": "JFROG LTD",
     "symbol": "FROG"
    },
    {
     "description": "FRONTIER ACQUISITION CORP-A",
     "symbol": "FRON"
    },
    {
     "description": "FRONTIER ACQUISITION CORP",
     "symbol": "FRONU"
    },
    {
     "description": "FRONTIER ACQUISITON - CW28",
     "symbol": "FRONW"
    },
    {
     "description": "FRANKLIN SP500 PA UCITS ETF",
     "symbol": "FRPAF"
    },
    {
     "description": "FIRST REPUBLIC CORP AMERICA",
     "symbol": "FRPC"
    },
    {
     "description": "FRP HOLDINGS INC",
     "symbol": "FRPH"
    },
    {
     "description": "FORTY PILLARS MINING CORP",
     "symbol": "FRPMF"
    },
    {
     "description": "4D PHARMA PLC",
     "symbol": "FRPRF"
    },
    {
     "description": "FRESHPET INC",
     "symbol": "FRPT"
    },
    {
     "description": "FRONTIER DEVELOPMENTS PLC",
     "symbol": "FRRDF"
    },
    {
     "description": "4IMPRINT GROUP PLC",
     "symbol": "FRRFF"
    },
    {
     "description": "FRONTIER DIGITAL VENTURES LT",
     "symbol": "FRRGF"
    },
    {
     "description": "FIERA CAPITAL CORP",
     "symbol": "FRRPF"
    },
    {
     "description": "FOREMOST LITHIUM RESOURCE &",
     "symbol": "FRRSF"
    },
    {
     "description": "FERROVIAL SA",
     "symbol": "FRRVF"
    },
    {
     "description": "FERROVIAL SA-UNSPONSORED ADR",
     "symbol": "FRRVY"
    },
    {
     "description": "FERROTEC HOLDINGS CORP",
     "symbol": "FRRZF"
    },
    {
     "description": "FIRST AU LTD",
     "symbol": "FRSAF"
    },
    {
     "description": "FIRST RESOURCE BANK",
     "symbol": "FRSB"
    },
    {
     "description": "FIRST RESERVE SUSTAINABLE-A",
     "symbol": "FRSG"
    },
    {
     "description": "FIRST RESERVE SUSTAINABLE",
     "symbol": "FRSGU"
    },
    {
     "description": "FIRST RESERVE SUST A -CW27",
     "symbol": "FRSGW"
    },
    {
     "description": "FRESHWORKS INC-CL A",
     "symbol": "FRSH"
    },
    {
     "description": "CHINA JINMAO HOLDIN-UNSP ADR",
     "symbol": "FRSHY"
    },
    {
     "description": "FIRST RATE STAFFING CORP",
     "symbol": "FRSI"
    },
    {
     "description": "FRASERS HOSPITALITY TRUST",
     "symbol": "FRSRF"
    },
    {
     "description": "PRIMIS FINANCIAL CORP",
     "symbol": "FRST"
    },
    {
     "description": "FORESIGHT AUTONOMOUS-SP ADR",
     "symbol": "FRSX"
    },
    {
     "description": "FEDERAL REALTY INVS TRUST",
     "symbol": "FRT"
    },
    {
     "description": "FEDERAL REALTY INVESTMEN",
     "symbol": "FRT.PRC"
    },
    {
     "description": "FREENET AG",
     "symbol": "FRTAF"
    },
    {
     "description": "FREENET AG-UNSP ADR",
     "symbol": "FRTAY"
    },
    {
     "description": "FAR EAST CONSORTIUM INTERNAT",
     "symbol": "FRTCF"
    },
    {
     "description": "FORTITUDE GROUP INC",
     "symbol": "FRTD"
    },
    {
     "description": "FRONTERA GROUP INC",
     "symbol": "FRTG"
    },
    {
     "description": "FRUITAS HOLDINGS INC",
     "symbol": "FRTHF"
    },
    {
     "description": "FORTIUM HOLDINGS CORP",
     "symbol": "FRTM"
    },
    {
     "description": "FORTRAN CORP",
     "symbol": "FRTN"
    },
    {
     "description": "ALGER MID CAP 40 ETF",
     "symbol": "FRTY"
    },
    {
     "description": "FRIEDRICH - UNSP ADR",
     "symbol": "FRVWY"
    },
    {
     "description": "PWP FORWARD ACQUISITION CO-A",
     "symbol": "FRW"
    },
    {
     "description": "PWP FORWARD ACQUISITION CORP",
     "symbol": "FRWAU"
    },
    {
     "description": "PWP FORWARD ACQ CL A -CW27",
     "symbol": "FRWAW"
    },
    {
     "description": "FAIRWOOD HOLDINGS LTD",
     "symbol": "FRWDF"
    },
    {
     "description": "FOREST ROAD ACQUISITION CO-A",
     "symbol": "FRXB"
    },
    {
     "description": "FOREST ROAD ACQUISITION CORP",
     "symbol": "FRXB.U"
    },
    {
     "description": "FOREST ROAD ACQ CL A -CW26",
     "symbol": "FRXB.WS"
    },
    {
     "description": "FORECROSS CORPORATION",
     "symbol": "FRXX"
    },
    {
     "description": "FRASERS CENTREPOINT TRUST",
     "symbol": "FRZCF"
    },
    {
     "description": "FREEZE TAG INC",
     "symbol": "FRZT"
    },
    {
     "description": "FIVE STAR BANCORP",
     "symbol": "FSBC"
    },
    {
     "description": "FIDELITY SUSTAINABLE CORE PL",
     "symbol": "FSBD"
    },
    {
     "description": "FIRST SOUTHERN BANK\/WAYCROSS",
     "symbol": "FSBH"
    },
    {
     "description": "FS BANCORP INC",
     "symbol": "FSBW"
    },
    {
     "description": "FEDERAL SCREW WORKS",
     "symbol": "FSCR"
    },
    {
     "description": "FIRST TRUST HIGH INCOME LONG",
     "symbol": "FSD"
    },
    {
     "description": "FIRST CITIZENS NATL BANK",
     "symbol": "FSDK"
    },
    {
     "description": "FIRST SEACOAST BANCORP",
     "symbol": "FSEA"
    },
    {
     "description": "FIDELITY INV GRADE SECURIT",
     "symbol": "FSEC"
    },
    {
     "description": "FIRST SEISMIC CORP",
     "symbol": "FSEI"
    },
    {
     "description": "FS ENERGY AND POWER FUND",
     "symbol": "FSEN"
    },
    {
     "description": "FT CBOE VEST US EQ BUFF SEP",
     "symbol": "FSEP"
    },
    {
     "description": "FIRST SAVINGS FINANCIAL GRP",
     "symbol": "FSFG"
    },
    {
     "description": "FIRST FED SOUTH CAROLINA-FSB",
     "symbol": "FSGB"
    },
    {
     "description": "FIRST GEN CORPORATI-UNSP ADR",
     "symbol": "FSGCY"
    },
    {
     "description": "FIELD SOLUTIONS HOLDINGS LTD",
     "symbol": "FSGHF"
    },
    {
     "description": "FEISHANG ANTHRACITE RESOURCE",
     "symbol": "FSHRF"
    },
    {
     "description": "SHOUGANG FUSHAN RESOURCES GR",
     "symbol": "FSHYF"
    },
    {
     "description": "FLEXIBLE SOLUTIONS INTL INC",
     "symbol": "FSI"
    },
    {
     "description": "FT LTD DURATION INV GRADE",
     "symbol": "FSIG"
    },
    {
     "description": "FS KKR CAPITAL CORP",
     "symbol": "FSK"
    },
    {
     "description": "FIDELITY SUSTAINABLE LOW DUR",
     "symbol": "FSLD"
    },
    {
     "description": "FIRST SOLAR INC",
     "symbol": "FSLR"
    },
    {
     "description": "FIRST SHIP LEASE TRUST",
     "symbol": "FSLUF"
    },
    {
     "description": "FASTLY INC - CLASS A",
     "symbol": "FSLY"
    },
    {
     "description": "FORTUNA SILVER MINES INC",
     "symbol": "FSM"
    },
    {
     "description": "FIRST TRUST SHORT DUR MANAG",
     "symbol": "FSMB"
    },
    {
     "description": "FIDELITY SMALL-MID MULTIFACT",
     "symbol": "FSMD"
    },
    {
     "description": "1ST SUMMIT BANCORP OF JOHNST",
     "symbol": "FSMK"
    },
    {
     "description": "FIDELITY SMALL-MID CAP OPP",
     "symbol": "FSMO"
    },
    {
     "description": "FUSION ACQUISITION CORP II-A",
     "symbol": "FSNB"
    },
    {
     "description": "FUSION ACQUISITION CORP II",
     "symbol": "FSNB.U"
    },
    {
     "description": "FUSION ACQ II CL A -CW27",
     "symbol": "FSNB.WS"
    },
    {
     "description": "FOSUN TOURISM GROUP",
     "symbol": "FSNGF"
    },
    {
     "description": "FIRST STATE BANK\/CRANFORD NJ",
     "symbol": "FSNJ"
    },
    {
     "description": "FASHIONETTE AG",
     "symbol": "FSNTF"
    },
    {
     "description": "FRESENIUS SE & CO KGAA",
     "symbol": "FSNUF"
    },
    {
     "description": "FRESENIUS SE & CO-SPN ADR",
     "symbol": "FSNUY"
    },
    {
     "description": "WITHSECURE OYJ",
     "symbol": "FSOYF"
    },
    {
     "description": "FRANKLIN STREET PROPERTIES C",
     "symbol": "FSP"
    },
    {
     "description": "FISHER & PAYKEL HEALTHCARE C",
     "symbol": "FSPKF"
    },
    {
     "description": "FUSION PHARM INC",
     "symbol": "FSPM"
    },
    {
     "description": "FISKER INC",
     "symbol": "FSR"
    },
    {
     "description": "FIRST RESOURCES LTD-UNSP ADR",
     "symbol": "FSRCY"
    },
    {
     "description": "FAST RADIUS INC",
     "symbol": "FSRD"
    },
    {
     "description": "FAST RADIUS -CW28",
     "symbol": "FSRDW"
    },
    {
     "description": "FIRST RELIANCE BANCSHARES IN",
     "symbol": "FSRL"
    },
    {
     "description": "FRASERS PROPERTY LTD",
     "symbol": "FSRPF"
    },
    {
     "description": "FINSERV ACQUISITION CORP-A",
     "symbol": "FSRX"
    },
    {
     "description": "FINSERV ACQUISITION CORP II",
     "symbol": "FSRXU"
    },
    {
     "description": "FINSERV ACQUISITION CO-CW26",
     "symbol": "FSRXW"
    },
    {
     "description": "FEDERAL SIGNAL CORP",
     "symbol": "FSS"
    },
    {
     "description": "FORTISTAR SUSTAINABLE SOLU-A",
     "symbol": "FSSI"
    },
    {
     "description": "FORTISTAR SUSTAINABLE SOLUTI",
     "symbol": "FSSIU"
    },
    {
     "description": "FORTISTAR SUSTAIN A -CW27",
     "symbol": "FSSIW"
    },
    {
     "description": "FOSSAL SAA -ADR",
     "symbol": "FSSLY"
    },
    {
     "description": "FISION CORP",
     "symbol": "FSSN"
    },
    {
     "description": "FIDELITY SUSTAINABLE U.S. EQ",
     "symbol": "FSST"
    },
    {
     "description": "CI MORNINGSTAR CAN MOMT INDX",
     "symbol": "FSSTF"
    },
    {
     "description": "FAST ACQUISITION CORP-CL A",
     "symbol": "FST"
    },
    {
     "description": "FAST ACQUISITION CORP",
     "symbol": "FST.U"
    },
    {
     "description": "FAST ACQUISITION CORP -CW27",
     "symbol": "FST.WS"
    },
    {
     "description": "FIDELITY CON STAPLES ETF",
     "symbol": "FSTA"
    },
    {
     "description": "FIRST STATE FINANCIAL CORP\/F",
     "symbol": "FSTF"
    },
    {
     "description": "FT INDXX INNOV TRNSACT&PROCS",
     "symbol": "FSTGF"
    },
    {
     "description": "FIRST AMERICA RESOURCES CORP",
     "symbol": "FSTJ"
    },
    {
     "description": "FOSTER (LB) CO-A",
     "symbol": "FSTR"
    },
    {
     "description": "F-STAR THERAPEUTICS INC",
     "symbol": "FSTX"
    },
    {
     "description": "FORTESCUE METALS-SPON ADR",
     "symbol": "FSUGY"
    },
    {
     "description": "FORTESCUE METALS GROUP LTD",
     "symbol": "FSUMF"
    },
    {
     "description": "FOR STARTUPS INC",
     "symbol": "FSUPF"
    },
    {
     "description": "FIRSTSERVICE CORP",
     "symbol": "FSV"
    },
    {
     "description": "FIRESTONE VENTURES INC",
     "symbol": "FSVEF"
    },
    {
     "description": "FIRST SOUND BANK\/WASHINGTON",
     "symbol": "FSWA"
    },
    {
     "description": "FOSTERVILLE SOUTH EXPLO-CL A",
     "symbol": "FSXLF"
    },
    {
     "description": "FIDELITY SUSTAINABLE HY ETF",
     "symbol": "FSYD"
    },
    {
     "description": "FIRST TRUST SWITZERLAND",
     "symbol": "FSZ"
    },
    {
     "description": "FRANKLIN UNIVERSAL TRUST",
     "symbol": "FT"
    },
    {
     "description": "FIRST TRUST L C VAL ALP",
     "symbol": "FTA"
    },
    {
     "description": "FTAC ATHENA ACQUISITION CO-A",
     "symbol": "FTAA"
    },
    {
     "description": "FTAC ATHENA ACQUISITION CORP",
     "symbol": "FTAAU"
    },
    {
     "description": "FTAC ATHENA ACQ CL A -CW26",
     "symbol": "FTAAW"
    },
    {
     "description": "FIRST TRUST INDXX GLOBAL AGR",
     "symbol": "FTAG"
    },
    {
     "description": "FORTRESS TRANSPORTATION & IN",
     "symbol": "FTAI"
    },
    {
     "description": "FORTRESS TRANS & INFRAST",
     "symbol": "FTAI.PRA"
    },
    {
     "description": "FORTRESS TRANS & INFRAST",
     "symbol": "FTAI.PRB"
    },
    {
     "description": "FORTRESS TRANS & INFRAST",
     "symbol": "FTAI.PRC"
    },
    {
     "description": "BIDSTACK GROUP PLC",
     "symbol": "FTBGF"
    },
    {
     "description": "FORTUNE BAY CORP",
     "symbol": "FTBYF"
    },
    {
     "description": "FIRST TRUST LARGE CAP GROWTH",
     "symbol": "FTC"
    },
    {
     "description": "FIRST TRUST CLOUD COMPUTING",
     "symbol": "FTCGF"
    },
    {
     "description": "FARFETCH LTD-CLASS A",
     "symbol": "FTCH"
    },
    {
     "description": "FTC SOLAR INC",
     "symbol": "FTCI"
    },
    {
     "description": "FORTITUDE GOLD CORP",
     "symbol": "FTCO"
    },
    {
     "description": "FIRST TRUST CAPITAL STRENGTH",
     "symbol": "FTCPF"
    },
    {
     "description": "FIRST TRUST CAPITAL STRENGTH",
     "symbol": "FTCS"
    },
    {
     "description": "FINTECH ACQUISITION CORP V-A",
     "symbol": "FTCV"
    },
    {
     "description": "FINTECH ACQUISITION CORP V",
     "symbol": "FTCVU"
    },
    {
     "description": "FINTECH ACQUISITION V -CW25",
     "symbol": "FTCVW"
    },
    {
     "description": "FIRSTIME DESIGN LTD",
     "symbol": "FTDL"
    },
    {
     "description": "FIRST TRUST EUROZONE ALPHADX",
     "symbol": "FTDPF"
    },
    {
     "description": "FRONTDOOR INC",
     "symbol": "FTDR"
    },
    {
     "description": "FIDELITY MSCI INFO TECH ETF",
     "symbol": "FTEC"
    },
    {
     "description": "FIRST TRUST DJ INTNL INTRNET",
     "symbol": "FTEFF"
    },
    {
     "description": "FOR THE EARTH CORP",
     "symbol": "FTEG"
    },
    {
     "description": "FUEL TECH INC",
     "symbol": "FTEK"
    },
    {
     "description": "FINTECH EVOLUTION ACQUISIT-A",
     "symbol": "FTEV"
    },
    {
     "description": "FINTECH EVOLUTION ACQUISITIO",
     "symbol": "FTEV.U"
    },
    {
     "description": "FINTECH EVOLUTION ACQ -CW28",
     "symbol": "FTEV.WS"
    },
    {
     "description": "FRANKLIN LTD DUR INC TR",
     "symbol": "FTF"
    },
    {
     "description": "FUTURE FINTECH GROUP INC",
     "symbol": "FTFT"
    },
    {
     "description": "FIT AFTER FIFTY INC",
     "symbol": "FTFY"
    },
    {
     "description": "FIRST TRUST GLOBAL TACTICAL",
     "symbol": "FTGC"
    },
    {
     "description": "FIRAN TECHNOLOGY GROUP CORP",
     "symbol": "FTGFF"
    },
    {
     "description": "FIRST TRUST BIOTECHNOLOGY",
     "symbol": "FTGGF"
    },
    {
     "description": "FIRST TRUST EMERGING MARKETS",
     "symbol": "FTGLF"
    },
    {
     "description": "FIRST TRUST DJ INTERNET ETF",
     "symbol": "FTGPF"
    },
    {
     "description": "FTHI\/FIRST TRUST EXCHANGE-TR",
     "symbol": "FTHI"
    },
    {
     "description": "FATHOM HOLDINGS INC",
     "symbol": "FTHM"
    },
    {
     "description": "FIRST TRUST HIGH YLD OPPORT",
     "symbol": "FTHY"
    },
    {
     "description": "TECHNIPFMC PLC",
     "symbol": "FTI"
    },
    {
     "description": "FUTURETECH II ACQUISITI-CL A",
     "symbol": "FTII"
    },
    {
     "description": "FUTURETECH II ACQUISITION CO",
     "symbol": "FTIIU"
    },
    {
     "description": "FUTURETECH II ACQ -CW27",
     "symbol": "FTIIW"
    },
    {
     "description": "FLOTEK INDUSTRIES INC",
     "symbol": "FTK"
    },
    {
     "description": "FIRST TRUST EXCHANGE-TRADED",
     "symbol": "FTLB"
    },
    {
     "description": "FITLIFE BRANDS INC",
     "symbol": "FTLF"
    },
    {
     "description": "FIRST TRUST LONG\/SHORT EQTY",
     "symbol": "FTLS"
    },
    {
     "description": "FORTUNE MINERALS LTD",
     "symbol": "FTMDF"
    },
    {
     "description": "LUNDIN GOLD INC",
     "symbol": "FTMNF"
    },
    {
     "description": "FORTINET INC",
     "symbol": "FTNT"
    },
    {
     "description": "FTAC PARNASSUS ACQUISITION-A",
     "symbol": "FTPA"
    },
    {
     "description": "FTAC PARNASSUS ACQUISITION C",
     "symbol": "FTPAU"
    },
    {
     "description": "FTAC PARNASSUS ACQ A -CW26",
     "symbol": "FTPAW"
    },
    {
     "description": "420 PROPERTY MANAGEMENT INC",
     "symbol": "FTPM"
    },
    {
     "description": "FIRST TRUST INDXX GLOBAL NAT",
     "symbol": "FTRI"
    },
    {
     "description": "FIRST RESOURCES LTD",
     "symbol": "FTROF"
    },
    {
     "description": "FIELD TRIP HEALTH LTD",
     "symbol": "FTRP"
    },
    {
     "description": "FONTERRA SHAREHOLDERS FUND",
     "symbol": "FTRRF"
    },
    {
     "description": "FUTURIS CO",
     "symbol": "FTRS"
    },
    {
     "description": "Fortis Inc",
     "symbol": "FTRSF"
    },
    {
     "description": "FORTIS INC",
     "symbol": "FTS"
    },
    {
     "description": "FRANKLIN LIBERTY SHORT DURAT",
     "symbol": "FTSD"
    },
    {
     "description": "FIRST TRUST SENIOR LOAN ETF",
     "symbol": "FTSL"
    },
    {
     "description": "FIRST TRUST ENH SHORT MAT FD",
     "symbol": "FTSM"
    },
    {
     "description": "FORTERRA PLC",
     "symbol": "FTTRF"
    },
    {
     "description": "FULLER SMITH & TURNER - A",
     "symbol": "FTUAF"
    },
    {
     "description": "FORTIVE CORP",
     "symbol": "FTV"
    },
    {
     "description": "FINTECH ACQUISITION CORP -A",
     "symbol": "FTVI"
    },
    {
     "description": "FINTECH ACQUISITION CORP VI",
     "symbol": "FTVIU"
    },
    {
     "description": "FINTECH ACQUISITION A -CW27",
     "symbol": "FTVIW"
    },
    {
     "description": "FLITWAYS TECHNOLOGY INC",
     "symbol": "FTWS"
    },
    {
     "description": "FREIGHTWAYS LTD",
     "symbol": "FTWYF"
    },
    {
     "description": "FIRST TRUST NASDAQ FOOD & BE",
     "symbol": "FTXG"
    },
    {
     "description": "FOXTONS GROUP PLC",
     "symbol": "FTXGF"
    },
    {
     "description": "FIRST TRUST NASDAQ PHARMACEU",
     "symbol": "FTXH"
    },
    {
     "description": "FIRST TRUST NASDAQ SEMICONDU",
     "symbol": "FTXL"
    },
    {
     "description": "FIRST TRUST NASDAQ OIL & GAS",
     "symbol": "FTXN"
    },
    {
     "description": "FIRST TRUST NASDAQ BANK ETF",
     "symbol": "FTXO"
    },
    {
     "description": "FOOTHILLS EXPLORATION INC",
     "symbol": "FTXP"
    },
    {
     "description": "FIRST TRUST NASDAQ TRANSPORT",
     "symbol": "FTXR"
    },
    {
     "description": "FERTOZ LTD",
     "symbol": "FTZZF"
    },
    {
     "description": "FUNAI ELECTRIC CO LTD",
     "symbol": "FUAIF"
    },
    {
     "description": "GLOBAL CANNABIS APPLICATIONS",
     "symbol": "FUAPF"
    },
    {
     "description": "FUTABA CORP",
     "symbol": "FUBAF"
    },
    {
     "description": "FUBOTV INC",
     "symbol": "FUBO"
    },
    {
     "description": "FIRST TRUST VALUE LINE DVD",
     "symbol": "FUCIF"
    },
    {
     "description": "ELEMENTS ICE EXTRA BIOFUELS",
     "symbol": "FUE"
    },
    {
     "description": "FACE UP ENTERTAINMENT GROUP",
     "symbol": "FUEG"
    },
    {
     "description": "FUEGO ENTERPRISES INC",
     "symbol": "FUGI"
    },
    {
     "description": "FUSION INTERACTIVE CORP",
     "symbol": "FUIG"
    },
    {
     "description": "FUBON FINANCIAL HOLDING CO",
     "symbol": "FUISF"
    },
    {
     "description": "FUBON FINANCIAL HOL-GDR REGS",
     "symbol": "FUIZF"
    },
    {
     "description": "FUJITA ENGINEERING CO LTD",
     "symbol": "FUJGF"
    },
    {
     "description": "SUBARU CORP",
     "symbol": "FUJHF"
    },
    {
     "description": "SUBARU CORP-UNSPONS ADR",
     "symbol": "FUJHY"
    },
    {
     "description": "FUJIFILM HOLDINGS CORP",
     "symbol": "FUJIF"
    },
    {
     "description": "FUJIFILM HOLDINGS-UNSP ADR",
     "symbol": "FUJIY"
    },
    {
     "description": "FUJI SEAL INTERNATIONAL INC",
     "symbol": "FUJSF"
    },
    {
     "description": "FUJIMI INC",
     "symbol": "FUJXF"
    },
    {
     "description": "H.B. FULLER CO.",
     "symbol": "FUL"
    },
    {
     "description": "FULCRUM THERAPEUTICS INC",
     "symbol": "FULC"
    },
    {
     "description": "FULLNET COMMUNICATIONS INC",
     "symbol": "FULO"
    },
    {
     "description": "FULTON FINANCIAL CORP",
     "symbol": "FULT"
    },
    {
     "description": "FULTON FINANCIAL CORP",
     "symbol": "FULTP"
    },
    {
     "description": "FIRST TRUST ULTRA SHORT DUR",
     "symbol": "FUMB"
    },
    {
     "description": "CEDAR FAIR LP",
     "symbol": "FUN"
    },
    {
     "description": "FIRST UNITED CORP",
     "symbol": "FUNC"
    },
    {
     "description": "SPROTT FOCUS TRUST INC",
     "symbol": "FUND"
    },
    {
     "description": "FANSUNITE ENTERTAINMENT INC.",
     "symbol": "FUNFF"
    },
    {
     "description": "CORNERCAP FUNDAMETRICS L-CAP",
     "symbol": "FUNL"
    },
    {
     "description": "AMFIL TECHNOLOGIES INC",
     "symbol": "FUNN"
    },
    {
     "description": "FOUNTAINHALL CAPITAL CORP",
     "symbol": "FUNTF"
    },
    {
     "description": "4FUN MEDIA SA",
     "symbol": "FUNWF"
    },
    {
     "description": "FUCHS PETROLUB SE-PREF ADR",
     "symbol": "FUPBY"
    },
    {
     "description": "FUCHS PETROLUB SE",
     "symbol": "FUPEF"
    },
    {
     "description": "FUCHS PETROLUB SE-PREF",
     "symbol": "FUPPF"
    },
    {
     "description": "FAURECIA",
     "symbol": "FURCF"
    },
    {
     "description": "FURY GOLD MINES LTD",
     "symbol": "FURY"
    },
    {
     "description": "FIRST US BANCSHARES INC",
     "symbol": "FUSB"
    },
    {
     "description": "FUSE COBALT INC",
     "symbol": "FUSEF"
    },
    {
     "description": "FUSION PHARMACEUTICALS INC",
     "symbol": "FUSN"
    },
    {
     "description": "FUSE GROUP HOLDING INC",
     "symbol": "FUST"
    },
    {
     "description": "FUTURE ARCHITECT INC",
     "symbol": "FUSYF"
    },
    {
     "description": "PROSHARES MANAGED FUTURES ST",
     "symbol": "FUT"
    },
    {
     "description": "FUTURELAND CORP",
     "symbol": "FUTL"
    },
    {
     "description": "FUTURE SCIENCE HOLDINGS INC",
     "symbol": "FUTS"
    },
    {
     "description": "FUTU HOLDINGS LTD-ADR",
     "symbol": "FUTU"
    },
    {
     "description": "FIDELITY US UTILITIES ETF",
     "symbol": "FUTY"
    },
    {
     "description": "FUTURENET INC",
     "symbol": "FUUN"
    },
    {
     "description": "ARCIMOTO INC",
     "symbol": "FUV"
    },
    {
     "description": "FURUKAWA ELECTRIC CO LTD",
     "symbol": "FUWAF"
    },
    {
     "description": "FURUKAWA ELECTRIC-UNSPON ADR",
     "symbol": "FUWAY"
    },
    {
     "description": "AOYAMA ZAISAN NETWORKS CO LT",
     "symbol": "FUZAF"
    },
    {
     "description": "FIRST TRUST DW FOCUS 5 FUND",
     "symbol": "FV"
    },
    {
     "description": "FIDELITY VALUE FACTOR ETF",
     "symbol": "FVAL"
    },
    {
     "description": "5:01 ACQUISITION CORP- CL A",
     "symbol": "FVAM"
    },
    {
     "description": "FIRST TRUST DORSEY WRIGHT DY",
     "symbol": "FVC"
    },
    {
     "description": "FVCBANKCORP INC",
     "symbol": "FVCB"
    },
    {
     "description": "FIRST TRUST VALUE LINE DVD",
     "symbol": "FVD"
    },
    {
     "description": "YUMY CANDY CO INC\/THE",
     "symbol": "FVGCF"
    },
    {
     "description": "FORTRESS VALUE ACQUIS IV-A",
     "symbol": "FVIV"
    },
    {
     "description": "FORTRESS VALUE ACQUISITIN IV",
     "symbol": "FVIV.U"
    },
    {
     "description": "FORTRESS VALUE ACQ IV -CW28",
     "symbol": "FVIV.WS"
    },
    {
     "description": "FV PHARMA INTERNATIONAL CORP",
     "symbol": "FVPI"
    },
    {
     "description": "FIVERR INTERNATIONAL LTD",
     "symbol": "FVRR"
    },
    {
     "description": "FAR VISTA PETROLEUM CORP",
     "symbol": "FVSTA"
    },
    {
     "description": "FORTRESS VALUE ACQUISITION-A",
     "symbol": "FVT"
    },
    {
     "description": "FORTRESS VALUE ACQUISITION",
     "symbol": "FVT.U"
    },
    {
     "description": "FORTRESS VALUE ACQ A -CW27",
     "symbol": "FVT.WS"
    },
    {
     "description": "FORTUNE VALLEY TREASURES INC",
     "symbol": "FVTI"
    },
    {
     "description": "ARANJIN RESOURCES LTD",
     "symbol": "FVVSF"
    },
    {
     "description": "FIFTH WALL ACQUISITION COR-A",
     "symbol": "FWAC"
    },
    {
     "description": "FOURTH WAVE ENERGY INC",
     "symbol": "FWAV"
    },
    {
     "description": "FIRST WAVE BIOPHARMA",
     "symbol": "FWBI"
    },
    {
     "description": "FUTUREWORLD CORP",
     "symbol": "FWDG"
    },
    {
     "description": "FIREWEED ZINC LTD",
     "symbol": "FWEDF"
    },
    {
     "description": "LIBERTY MEDIA CORP-LIBERTY-A",
     "symbol": "FWONA"
    },
    {
     "description": "LIBERTY MEDIA CORP-LIBERTY-B",
     "symbol": "FWONB"
    },
    {
     "description": "LIBERTY MEDIA CORP-LIBERTY-C",
     "symbol": "FWONK"
    },
    {
     "description": "FORWARD PHARMA A\/S-ADR",
     "symbol": "FWP"
    },
    {
     "description": "FIRST TRUST 9949 MUNICIPAL",
     "symbol": "FWPZCX"
    },
    {
     "description": "FORWARD AIR CORP",
     "symbol": "FWRD"
    },
    {
     "description": "FIRST WATCH RESTAURANT GROUP",
     "symbol": "FWRG"
    },
    {
     "description": "INVESCO CURRENCYSHARES AUSTR",
     "symbol": "FXA"
    },
    {
     "description": "INVESCO CURRENCYSHARES BRITI",
     "symbol": "FXB"
    },
    {
     "description": "FOXBY CORP",
     "symbol": "FXBY"
    },
    {
     "description": "INVESCO CURRENCYSHARES CANAD",
     "symbol": "FXC"
    },
    {
     "description": "FIH MOBILE LTD",
     "symbol": "FXCNF"
    },
    {
     "description": "FIH MOBILE LTD -UNSP ADR",
     "symbol": "FXCNY"
    },
    {
     "description": "FINANCIAL STRATEGIES ACQ-CLA",
     "symbol": "FXCO"
    },
    {
     "description": "FOXCONN TECHNOLOGY CO LTD",
     "symbol": "FXCOF"
    },
    {
     "description": "FINANCIAL STRATEGIES ACQ -RT",
     "symbol": "FXCOR"
    },
    {
     "description": "FINANCIAL STRATEGIES -CW23",
     "symbol": "FXCOW"
    },
    {
     "description": "FIRST TRUST CONSUMER DISCRET",
     "symbol": "FXD"
    },
    {
     "description": "INVESCO CURRENCYSHARES EURO",
     "symbol": "FXE"
    },
    {
     "description": "INVESCO CURRENCYSHARES SWISS",
     "symbol": "FXF"
    },
    {
     "description": "Fairfax Financial Holdings Ltd",
     "symbol": "FXFLF"
    },
    {
     "description": "FIRST TRUST CONSUMER STAPLES",
     "symbol": "FXG"
    },
    {
     "description": "FIRST TRUST HEALTH CARE ALPH",
     "symbol": "FXH"
    },
    {
     "description": "ISHARES CHINA LARGE-CAP ETF",
     "symbol": "FXI"
    },
    {
     "description": "FIRST TRUST TECHNOLOGY ALPHA",
     "symbol": "FXL"
    },
    {
     "description": "F.S. BANCORP\/IN",
     "symbol": "FXLG"
    },
    {
     "description": "F45 TRAINING HOLDINGS INC",
     "symbol": "FXLV"
    },
    {
     "description": "FIRST TRUST ENERGY ALPHADEX",
     "symbol": "FXN"
    },
    {
     "description": "FIRST NATIONAL CORP\/VA",
     "symbol": "FXNC"
    },
    {
     "description": "FIRST TRUST FINANCIAL ALPHAD",
     "symbol": "FXO"
    },
    {
     "description": "PROSHARES ULTRASHORT FTSE CH",
     "symbol": "FXP"
    },
    {
     "description": "FIRST TRUST INDST\/PRODUCERS",
     "symbol": "FXR"
    },
    {
     "description": "FOX RIVER RESOURCES CORP",
     "symbol": "FXRVF"
    },
    {
     "description": "FIXSTARS CORP",
     "symbol": "FXSRF"
    },
    {
     "description": "FOXTONS GROUP PLC UNSP ADR",
     "symbol": "FXTGY"
    },
    {
     "description": "FIRST TRUST UTILITIES ALPHAD",
     "symbol": "FXU"
    },
    {
     "description": "FOX WIZEL LTD",
     "symbol": "FXWZF"
    },
    {
     "description": "INVESCO CURRENCYSHARES JAPAN",
     "symbol": "FXY"
    },
    {
     "description": "FIRST TRUST MATERIALS ALPHAD",
     "symbol": "FXZ"
    },
    {
     "description": "FRONTIER COMMUNICATIONS PARE",
     "symbol": "FYBR"
    },
    {
     "description": "FIRST TRUST SMALL CAP GROWTH",
     "symbol": "FYC"
    },
    {
     "description": "FUYAO GLASS INDUSTRY - ADR",
     "symbol": "FYGGY"
    },
    {
     "description": "FYI RESOURCES LTD",
     "symbol": "FYIRF"
    },
    {
     "description": "CAMBRIA FOREIGN SHAREHOLDER",
     "symbol": "FYLD"
    },
    {
     "description": "FIRST TRUST 9788 FTP STRATEG",
     "symbol": "FYLDPX"
    },
    {
     "description": "FINLAY MINERALS LTD",
     "symbol": "FYMNF"
    },
    {
     "description": "FIRST TRUST SMALL CAP VAL",
     "symbol": "FYT"
    },
    {
     "description": "FIRST TRUST SMALL CAP CORE A",
     "symbol": "FYX"
    },
    {
     "description": "FIRST TRUST NSDQ CLN EDG NRG",
     "symbol": "FYXGF"
    },
    {
     "description": "FUSE MEDICAL INC",
     "symbol": "FZMD"
    },
    {
     "description": "FLASHZERO CORP",
     "symbol": "FZRO"
    },
    {
     "description": "FAST ACQUISITION CORP II-A",
     "symbol": "FZT"
    },
    {
     "description": "FAST ACQUISITION CORP II",
     "symbol": "FZT.U"
    },
    {
     "description": "FAST ACQUISITION II A -CW26",
     "symbol": "FZT.WS"
    },
    {
     "description": "GENPACT LTD",
     "symbol": "G"
    },
    {
     "description": "CAMBRIA GLOBAL ASSET ALLOCAT",
     "symbol": "GAA"
    },
    {
     "description": "GABELLI EQUITY TRUST",
     "symbol": "GAB"
    },
    {
     "description": "GABELLI EQUITY TRUST",
     "symbol": "GAB.PRG"
    },
    {
     "description": "GABELLI EQUITY TRUST",
     "symbol": "GAB.PRH"
    },
    {
     "description": "GABELLI EQUITY TRUST",
     "symbol": "GAB.PRK"
    },
    {
     "description": "GEORGIA BANCSHARES INC",
     "symbol": "GABA"
    },
    {
     "description": "GERMAN AMERICAN BANCORP",
     "symbol": "GABC"
    },
    {
     "description": "GRAND BANK CORPORATION",
     "symbol": "GABK"
    },
    {
     "description": "GABY INC",
     "symbol": "GABLF"
    },
    {
     "description": "GLOBAL CONSUMER ACQUISITION",
     "symbol": "GACQ"
    },
    {
     "description": "GLOBAL CONSUMER ACQUISITION",
     "symbol": "GACQU"
    },
    {
     "description": "GLOBAL CONSUMER ACQ -CW27",
     "symbol": "GACQW"
    },
    {
     "description": "GREEN AUTOMOTIVE CO CORP",
     "symbol": "GACR"
    },
    {
     "description": "GAC HOLDCO INC -CW26",
     "symbol": "GACWF"
    },
    {
     "description": "GADSDEN PROPERTIES INC",
     "symbol": "GADS"
    },
    {
     "description": "GULF ALTERNATIVE ENERGY CORP",
     "symbol": "GAEC"
    },
    {
     "description": "GRUPO AEROPORTUARIO DEL CENT",
     "symbol": "GAERF"
    },
    {
     "description": "GA EXPRESS INC",
     "symbol": "GAEX"
    },
    {
     "description": "GREAT AMERICAN FINANCIAL COR",
     "symbol": "GAFL"
    },
    {
     "description": "GLOBAL ARENA HOLDING INC",
     "symbol": "GAHC"
    },
    {
     "description": "GLOBAL AGRICULTURAL HOLDINGS",
     "symbol": "GAHD"
    },
    {
     "description": "GAIA INC",
     "symbol": "GAIA"
    },
    {
     "description": "Guardforce AI Company Ltd",
     "symbol": "GAIFW"
    },
    {
     "description": "GAIL INDIA LTD-REG S GDR",
     "symbol": "GAILF"
    },
    {
     "description": "GLADSTONE INVESTMENT CORP",
     "symbol": "GAIN"
    },
    {
     "description": "GLADSTONE INVESTMENT COR",
     "symbol": "GAINN"
    },
    {
     "description": "GLADSTONE INVESTMENT COR",
     "symbol": "GAINZ"
    },
    {
     "description": "SPDR SSGA GLOBAL ALLOCATION",
     "symbol": "GAL"
    },
    {
     "description": "GALANTAS GOLD CORP",
     "symbol": "GALKF"
    },
    {
     "description": "GALENICA AG",
     "symbol": "GALNF"
    },
    {
     "description": "GALORE RESOURCES INC",
     "symbol": "GALOF"
    },
    {
     "description": "GALECTIN THERAPEUTICS INC",
     "symbol": "GALT"
    },
    {
     "description": "GENERAL AMERICAN INVESTORS",
     "symbol": "GAM"
    },
    {
     "description": "GENERAL AMERICAN INVEST",
     "symbol": "GAM.PRB"
    },
    {
     "description": "GAMBLING.COM GROUP LTD",
     "symbol": "GAMB"
    },
    {
     "description": "GOLDEN ARROW MERGER CORP-A",
     "symbol": "GAMC"
    },
    {
     "description": "GAMMA COMMUNICATIONS PLC",
     "symbol": "GAMCF"
    },
    {
     "description": "GOLDEN ARROW MERGER CORP",
     "symbol": "GAMCU"
    },
    {
     "description": "GOLDEN ARROW MERGER A -CW26",
     "symbol": "GAMCW"
    },
    {
     "description": "ENGINE GAMING AND MEDIA INC",
     "symbol": "GAME"
    },
    {
     "description": "GREAT AMERICAN FOOD CHAIN IN",
     "symbol": "GAMN"
    },
    {
     "description": "WEDBUSH ETFMG VIDEO GAME TEC",
     "symbol": "GAMR"
    },
    {
     "description": "GAN LTD",
     "symbol": "GAN"
    },
    {
     "description": "GAIN THERAPEUTICS INC",
     "symbol": "GANX"
    },
    {
     "description": "G&P ACQUISITION CORP-CL A",
     "symbol": "GAPA"
    },
    {
     "description": "G&P ACQUISITION CORP",
     "symbol": "GAPA.U"
    },
    {
     "description": "G&P ACQUISITION CL A -CW27",
     "symbol": "GAPA.WS"
    },
    {
     "description": "GOLDEN APPLE OIL & GAS INC",
     "symbol": "GAPJ"
    },
    {
     "description": "GENERATION ASIA I ACQUISIT-A",
     "symbol": "GAQ"
    },
    {
     "description": "GENERATION ASIA I ACQUISITIO",
     "symbol": "GAQ.U"
    },
    {
     "description": "GENERATION ASIA I ACQ -CW23",
     "symbol": "GAQ.WS"
    },
    {
     "description": "GARB OIL & POWER CORPORATION",
     "symbol": "GARB"
    },
    {
     "description": "NETCOINS HLDGS INC",
     "symbol": "GARLF"
    },
    {
     "description": "GOLDEN AGRI-RESOURCES LTD",
     "symbol": "GARPF"
    },
    {
     "description": "GOLDEN AGRI-RESOURCES-UN ADR",
     "symbol": "GARPY"
    },
    {
     "description": "GALLERY RESOURCES LTD",
     "symbol": "GARQF"
    },
    {
     "description": "GOLDEN ARROW RESOURCES CORP",
     "symbol": "GARWF"
    },
    {
     "description": "GASE ENERGY INC",
     "symbol": "GASE"
    },
    {
     "description": "Direxion Daily Natural Gas Related Bull 3X Shares New",
     "symbol": "GASL"
    },
    {
     "description": "GENERAL ASSEMBLY HDS-CLASS A",
     "symbol": "GASMF"
    },
    {
     "description": "NATURGY ENERGY GROUP SA",
     "symbol": "GASNF"
    },
    {
     "description": "NATURGY ENERGY GROUP SA-ADR",
     "symbol": "GASNY"
    },
    {
     "description": "STEALTHGAS INC",
     "symbol": "GASS"
    },
    {
     "description": "GABELLI ASSET ETF",
     "symbol": "GAST"
    },
    {
     "description": "Direxion Daily Natural Gas Related Bear 3X Shares New",
     "symbol": "GASX"
    },
    {
     "description": "NG ENERGY INTERNATIONAL CORP",
     "symbol": "GASXF"
    },
    {
     "description": "MARBLEGATE ACQUISITION COR-A",
     "symbol": "GATE"
    },
    {
     "description": "MARBLEGATE ACQUISITION CORP",
     "symbol": "GATEU"
    },
    {
     "description": "MARBLEGATE ACQUISITION -CW22",
     "symbol": "GATEW"
    },
    {
     "description": "GATLING EXPLORATION INC",
     "symbol": "GATGF"
    },
    {
     "description": "GATOS SILVER INC",
     "symbol": "GATO"
    },
    {
     "description": "GATX CORP",
     "symbol": "GATX"
    },
    {
     "description": "GALIANO GOLD INC",
     "symbol": "GAU"
    },
    {
     "description": "GAWK INC",
     "symbol": "GAWK"
    },
    {
     "description": "GALAXY NEXT GENERATION INC",
     "symbol": "GAXY"
    },
    {
     "description": "GALWAY GOLD INC",
     "symbol": "GAYGF"
    },
    {
     "description": "GALWAY METALS INC",
     "symbol": "GAYMF"
    },
    {
     "description": "IPATH SER B BBG NAT GAS TR",
     "symbol": "GAZ"
    },
    {
     "description": "GLOBAL BLUE GROUP HOLDING AG",
     "symbol": "GB"
    },
    {
     "description": "GLOBAL BLUE GROUP HOLDING AG",
     "symbol": "GB.WS"
    },
    {
     "description": "GUGGENHEIM TAXABLE MUNICIPAL",
     "symbol": "GBAB"
    },
    {
     "description": "MONARCH MINING CORP",
     "symbol": "GBARF"
    },
    {
     "description": "IPATH GBP\/USD EXCHANGE RATE",
     "symbol": "GBBEF"
    },
    {
     "description": "GRANADA GOLD MINE INC",
     "symbol": "GBBFF"
    },
    {
     "description": "GLOBAL LI-ION GRAPHITE CORP",
     "symbol": "GBBGF"
    },
    {
     "description": "GLOBAL ENERGY VENTURES LTD",
     "symbol": "GBBLF"
    },
    {
     "description": "GLOBAL BOATWORKS HOLDINGS IN",
     "symbol": "GBBT"
    },
    {
     "description": "GOODBABY INTERNATIONAL HOLDI",
     "symbol": "GBBYF"
    },
    {
     "description": "GLOBE TRADE CENTRE-UNSP ADR",
     "symbol": "GBCEY"
    },
    {
     "description": "METAVERSE CAPITAL CORP",
     "symbol": "GBCHF"
    },
    {
     "description": "GLACIER BANCORP INC",
     "symbol": "GBCI"
    },
    {
     "description": "GLOBAL BIO-CHEM-UNSPON ADR",
     "symbol": "GBCMY"
    },
    {
     "description": "SELECTIS HEALTH INC",
     "symbol": "GBCS"
    },
    {
     "description": "GOLUB CAPITAL BDC INC",
     "symbol": "GBDC"
    },
    {
     "description": "GLOBAL DOMINION ACCESS SA",
     "symbol": "GBDMF"
    },
    {
     "description": "GLOBAL BETA SMART INCOME ETF",
     "symbol": "GBDV"
    },
    {
     "description": "GLOBAL DIAMOND EXCHANGE INC",
     "symbol": "GBDX"
    },
    {
     "description": "GREAT BASIN ENERGIES INC",
     "symbol": "GBEI"
    },
    {
     "description": "GLOBAL RESOURCE ENERGY INC",
     "symbol": "GBEN"
    },
    {
     "description": "GEBERIT AG-REG",
     "symbol": "GBERF"
    },
    {
     "description": "GEBERIT AG-UNSP ADR",
     "symbol": "GBERY"
    },
    {
     "description": "ISHARES GOVERNMENT\/CREDIT BO",
     "symbol": "GBF"
    },
    {
     "description": "GRUPO BAFAR S.A.-B",
     "symbol": "GBFBF"
    },
    {
     "description": "GBANK FINANCIAL HOLDINGS INC",
     "symbol": "GBFH"
    },
    {
     "description": "GLOBAL GOLD CORP",
     "symbol": "GBGD"
    },
    {
     "description": "GB GROUP PLC",
     "symbol": "GBGPF"
    },
    {
     "description": "GLOBAL BETA RISING STARS ETF",
     "symbol": "GBGR"
    },
    {
     "description": "GLOBAL ENTERTAINMENT HOLDING",
     "symbol": "GBHL"
    },
    {
     "description": "GLOBAL HEMP GROUP INC",
     "symbol": "GBHPF"
    },
    {
     "description": "GOLDMAN SACHS ACCESS TREASUR",
     "symbol": "GBIL"
    },
    {
     "description": "GLOBEIMMUNE INC",
     "symbol": "GBIM"
    },
    {
     "description": "GENERATION BIO CO",
     "symbol": "GBIO"
    },
    {
     "description": "GAMCO INVESTORS INC-A",
     "symbol": "GBL"
    },
    {
     "description": "GROUPE BRUXELLES LAMBERT SA",
     "symbol": "GBLBF"
    },
    {
     "description": "GROUPE BRUXELLES-UNSPON ADR",
     "symbol": "GBLBY"
    },
    {
     "description": "INVESCO MSCI BUILDING ETF",
     "symbol": "GBLD"
    },
    {
     "description": "GLOBAL ENERGY METALS CORP",
     "symbol": "GBLEF"
    },
    {
     "description": "GLOBAL HUNTER CORP",
     "symbol": "GBLHF"
    },
    {
     "description": "GLOBAL INDEMNITY GROUP LLC-A",
     "symbol": "GBLI"
    },
    {
     "description": "GLOBAL BETA LOW BETA ETF",
     "symbol": "GBLO"
    },
    {
     "description": "GLOBAL PHARMATECH INC",
     "symbol": "GBLP"
    },
    {
     "description": "GBLT CORP",
     "symbol": "GBLTF"
    },
    {
     "description": "GB SCIENCES INC",
     "symbol": "GBLX"
    },
    {
     "description": "GREEN BATTERY MINERALS INC",
     "symbol": "GBMIF"
    },
    {
     "description": "GBM RESOURCES LTD",
     "symbol": "GBMRF"
    },
    {
     "description": "GLOBAL MATERIALS & SERVICES",
     "symbol": "GBMS"
    },
    {
     "description": "GREENBROOK TMS INC",
     "symbol": "GBNH"
    },
    {
     "description": "GLOBE INTERNATIONAL LTD",
     "symbol": "GBNLF"
    },
    {
     "description": "GLOBAL ENERGY NETWORKS CORP",
     "symbol": "GBNW"
    },
    {
     "description": "GIBSON ENERGY INC",
     "symbol": "GBNXF"
    },
    {
     "description": "GENERATIONS BANCORP NY INC",
     "symbol": "GBNY"
    },
    {
     "description": "GRUPO FINANCIERO BANORTE-O",
     "symbol": "GBOOF"
    },
    {
     "description": "GRUPO FIN BANORTE-SPON ADR",
     "symbol": "GBOOY"
    },
    {
     "description": "GREENBOX POS",
     "symbol": "GBOX"
    },
    {
     "description": "GLOBE PHOTOS INC",
     "symbol": "GBPT"
    },
    {
     "description": "NEW CONCEPT ENERGY INC",
     "symbol": "GBR"
    },
    {
     "description": "GREAT BEAR ROYALTIES CORP",
     "symbol": "GBRBF"
    },
    {
     "description": "GOLD BULL RESOURCES CORP",
     "symbol": "GBRCF"
    },
    {
     "description": "GOLDENBRIDGE ACQUISITION LTD",
     "symbol": "GBRG"
    },
    {
     "description": "GOLDENBRIDGE ACQUISITION-RTS",
     "symbol": "GBRGR"
    },
    {
     "description": "GOLDENBRIDGE ACQUISITION LTD",
     "symbol": "GBRGU"
    },
    {
     "description": "GOLDENBRIDGE ACQ LTD -CW25",
     "symbol": "GBRGW"
    },
    {
     "description": "GOLDEN BAND RESOURCES",
     "symbol": "GBRIF"
    },
    {
     "description": "GABRIEL RESOURCES LTD",
     "symbol": "GBRRF"
    },
    {
     "description": "GBS INC",
     "symbol": "GBS"
    },
    {
     "description": "GINEBRA SAN MIGUEL INC",
     "symbol": "GBSMF"
    },
    {
     "description": "GLOBAL BLOOD THERAPEUTICS IN",
     "symbol": "GBT"
    },
    {
     "description": "GRAYSCALE BITCOIN TRUST BTC",
     "symbol": "GBTC"
    },
    {
     "description": "PACER IPATH GOLD ETNS",
     "symbol": "GBUG"
    },
    {
     "description": "GIVBUX INC",
     "symbol": "GBUX"
    },
    {
     "description": "GOLDMAN SACHS FUT CONSUMER",
     "symbol": "GBUY"
    },
    {
     "description": "GREENBRIER COMPANIES INC",
     "symbol": "GBX"
    },
    {
     "description": "GBX INTERNATIONAL GROUP INC",
     "symbol": "GBXI"
    },
    {
     "description": "VIA SA-SP ADR",
     "symbol": "GBXPY"
    },
    {
     "description": "GRAND BAOXIN AUTO - UNSP ADR",
     "symbol": "GBXXY"
    },
    {
     "description": "GUARDIAN CAP GRP LTD-CL A",
     "symbol": "GCAAF"
    },
    {
     "description": "GREATER CANNABIS CO INC\/THE",
     "symbol": "GCAN"
    },
    {
     "description": "GREENE COUNTY BANCORP INC",
     "symbol": "GCBC"
    },
    {
     "description": "WISDOMTREE ENHANCED COMMODIT",
     "symbol": "GCC"
    },
    {
     "description": "GOLDEN CARIBOO RESOURCES LTD",
     "symbol": "GCCFF"
    },
    {
     "description": "GARDEN CITY CO\/COLORADO",
     "symbol": "GCCO"
    },
    {
     "description": "GRFFN CAP ES AST REIT-E",
     "symbol": "GCEA"
    },
    {
     "description": "CLAYMORE CEF GS CONNECT ETN",
     "symbol": "GCEC"
    },
    {
     "description": "GLOBAL CLEAN ENERGY HOLDINGS",
     "symbol": "GCEH"
    },
    {
     "description": "GLOBAL CLEAN ENERGY INC",
     "symbol": "GCEI"
    },
    {
     "description": "GRANITE CITY FOOD & BREWERY",
     "symbol": "GCFB"
    },
    {
     "description": "GOLDCLIFF RESOURCES CORP",
     "symbol": "GCFFF"
    },
    {
     "description": "GRUPO COMERCIAL CHEDRAUI SA",
     "symbol": "GCHEF"
    },
    {
     "description": "GOOCH & HOUSEGO PLC",
     "symbol": "GCHHF"
    },
    {
     "description": "GREENCHEK TECHNOLOGY INC",
     "symbol": "GCHK"
    },
    {
     "description": "GRUPO NUTRESA SA-SPON ADR",
     "symbol": "GCHOY"
    },
    {
     "description": "GC CHINA TURBINE CORP",
     "symbol": "GCHT"
    },
    {
     "description": "GANNETT CO INC",
     "symbol": "GCI"
    },
    {
     "description": "GENUINE INVESTORS ETF",
     "symbol": "GCIG"
    },
    {
     "description": "GC INTERNATIONAL INC",
     "symbol": "GCIN"
    },
    {
     "description": "GREENCELL INC",
     "symbol": "GCLL"
    },
    {
     "description": "GCM RESOURCES PLC",
     "symbol": "GCLMF"
    },
    {
     "description": "GS BLOOMBERG CLEAN ENERGY",
     "symbol": "GCLN"
    },
    {
     "description": "GAINCLIENTS INC",
     "symbol": "GCLT"
    },
    {
     "description": "GCM GROSVENOR INC - CLASS A",
     "symbol": "GCMG"
    },
    {
     "description": "GCM GROSVENOR INC A -CW25",
     "symbol": "GCMGW"
    },
    {
     "description": "GRUPO CATALANA OCCIDENTE SA",
     "symbol": "GCNJF"
    },
    {
     "description": "GENESCO INC",
     "symbol": "GCO"
    },
    {
     "description": "GOLDMAN SACHS ACCESS US AGG",
     "symbol": "GCOR"
    },
    {
     "description": "PACER GLOBAL CASH COWS DIVID",
     "symbol": "GCOW"
    },
    {
     "description": "GCP APPLIED TECHNOLOGIES",
     "symbol": "GCP"
    },
    {
     "description": "GCL TECHNOLOGY HOLDINGS LTD",
     "symbol": "GCPEF"
    },
    {
     "description": "GCP STUDENT LIVING PLC",
     "symbol": "GCPSF"
    },
    {
     "description": "GOLCAP RESOURCES CORP",
     "symbol": "GCRCF"
    },
    {
     "description": "ROGUE RESOURCES INC",
     "symbol": "GCRIF"
    },
    {
     "description": "GLOBAL CONNECTIONS PCL-NVDR",
     "symbol": "GCRPF"
    },
    {
     "description": "GECOSS CORP",
     "symbol": "GCSSF"
    },
    {
     "description": "SIEMENS GAMESA RENEWABLE ENE",
     "symbol": "GCTAF"
    },
    {
     "description": "SIEMENS GAMESA RENE-UNSP ADR",
     "symbol": "GCTAY"
    },
    {
     "description": "GLUCOTRACK INC",
     "symbol": "GCTK"
    },
    {
     "description": "GABELLI CONV AND INCOME SEC",
     "symbol": "GCV"
    },
    {
     "description": "GCC SAB DE CV",
     "symbol": "GCWOF"
    },
    {
     "description": "GRANITE CREEK COPPER LTD",
     "symbol": "GCXXF"
    },
    {
     "description": "GOLD CANYON BANK",
     "symbol": "GCYO"
    },
    {
     "description": "GENERAL DYNAMICS CORP",
     "symbol": "GD"
    },
    {
     "description": "GOLDEN AGE RESOURCES INC",
     "symbol": "GDAR"
    },
    {
     "description": "GOODBODY HEALTH INC",
     "symbol": "GDBYF"
    },
    {
     "description": "GOLD C-CW29 GOLD SPOT AUD\/",
     "symbol": "GDCWF"
    },
    {
     "description": "GOODFOOD MARKET CORP",
     "symbol": "GDDFF"
    },
    {
     "description": "GOODPATCH INC",
     "symbol": "GDDPF"
    },
    {
     "description": "GODADDY INC - CLASS A",
     "symbol": "GDDY"
    },
    {
     "description": "WISDOMTREE EFFICIENT GOLD PL",
     "symbol": "GDE"
    },
    {
     "description": "GOLDEN ENTERTAINMENT INC",
     "symbol": "GDEN"
    },
    {
     "description": "GD ENTERTAINMENT & TECHNOLOG",
     "symbol": "GDET"
    },
    {
     "description": "NEXTERS INC",
     "symbol": "GDEV"
    },
    {
     "description": "NEXTERS INC -CW28",
     "symbol": "GDEVW"
    },
    {
     "description": "GDI INTEGRATED FACILITY SERV",
     "symbol": "GDIFF"
    },
    {
     "description": "GDL FUND\/THE",
     "symbol": "GDL"
    },
    {
     "description": "GDL FUND",
     "symbol": "GDL.PRC"
    },
    {
     "description": "GRAYSCALE DIGITAL LARGE CAP",
     "symbol": "GDLC"
    },
    {
     "description": "GEODRILL LTD",
     "symbol": "GDLLF"
    },
    {
     "description": "GREENLAND MINERALS LTD",
     "symbol": "GDLNF"
    },
    {
     "description": "GADSDEN DYNAMIC MULTI-ASSET",
     "symbol": "GDMA"
    },
    {
     "description": "GOLDSTAR MINERALS INC",
     "symbol": "GDMIF"
    },
    {
     "description": "GLOBAL DIVERSIFIED MARKETING",
     "symbol": "GDMK"
    },
    {
     "description": "WISDOMTREE EFF GOLD PL MINER",
     "symbol": "GDMN"
    },
    {
     "description": "GOLDEN DAWN MINERALS INC",
     "symbol": "GDMRF"
    },
    {
     "description": "GOLDEN EAGLE RETAIL GROUP",
     "symbol": "GDNEF"
    },
    {
     "description": "GOLDEN EAGLE RET-UNSPON ADR",
     "symbol": "GDNEY"
    },
    {
     "description": "GUDANG GARAM TBK PT-UNSP ADR",
     "symbol": "GDNGY"
    },
    {
     "description": "GUODIAN TECHNOLOGY & ENVIR-H",
     "symbol": "GDNNF"
    },
    {
     "description": "GOOD NATURED PRODUCTS INC",
     "symbol": "GDNPF"
    },
    {
     "description": "GARDINER HEALTHCARE ACQUIS",
     "symbol": "GDNR"
    },
    {
     "description": "GARDINER HEALTHCARE ACQUISIT",
     "symbol": "GDNRU"
    },
    {
     "description": "GARDINER HEALTHCARE -CW24",
     "symbol": "GDNRW"
    },
    {
     "description": "GOODNESS GROWTH HOLDINGS INC",
     "symbol": "GDNSF"
    },
    {
     "description": "WESTERN ASSET GL CORP DEF OP",
     "symbol": "GDO"
    },
    {
     "description": "GOLDMAN SACHS FUTURE HEALTH",
     "symbol": "GDOC"
    },
    {
     "description": "GREEN DOT CORP-CLASS A",
     "symbol": "GDOT"
    },
    {
     "description": "GOODRICH PETROLEUM -CW26",
     "symbol": "GDPCW"
    },
    {
     "description": "RESOURCE CAPITAL GOLD CORP",
     "symbol": "GDPEF"
    },
    {
     "description": "GODOLPHIN RESOURCES LTD",
     "symbol": "GDPHF"
    },
    {
     "description": "GOLDQUEST MINING CORP",
     "symbol": "GDQMF"
    },
    {
     "description": "GOODRX HOLDINGS INC-CLASS A",
     "symbol": "GDRX"
    },
    {
     "description": "GOLD RESERVE INC",
     "symbol": "GDRZF"
    },
    {
     "description": "GDS HOLDINGS LTD - ADR",
     "symbol": "GDS"
    },
    {
     "description": "GLOBAL DIGITAL SOLUTIONS INC",
     "symbol": "GDSI"
    },
    {
     "description": "NEVADA ZINC CORP",
     "symbol": "GDSKF"
    },
    {
     "description": "GOLDENSTONE ACQUISITION LTD",
     "symbol": "GDST"
    },
    {
     "description": "GOLDENSTONE ACQUISITIO-RIGHT",
     "symbol": "GDSTR"
    },
    {
     "description": "GOLDENSTONE ACQUISITION LTD",
     "symbol": "GDSTU"
    },
    {
     "description": "GOLDENSTONE ACQUISITIO -CW23",
     "symbol": "GDSTW"
    },
    {
     "description": "GLADIATOR METALS CORP",
     "symbol": "GDTRF"
    },
    {
     "description": "GABELLI DIVIDEND & INCOME TR",
     "symbol": "GDV"
    },
    {
     "description": "GABELLI DVD & INC TR",
     "symbol": "GDV.PRH"
    },
    {
     "description": "GABELLI DVD & INC TR",
     "symbol": "GDV.PRK"
    },
    {
     "description": "R3 GLOBAL DIVIDEND GROWTH",
     "symbol": "GDVD"
    },
    {
     "description": "GLOBAL DEVELOPMENT & ENVIRON",
     "symbol": "GDVE"
    },
    {
     "description": "GLOBAL DEVELOPMENTS INC",
     "symbol": "GDVM"
    },
    {
     "description": "GOULD INVESTORS LP",
     "symbol": "GDVTZ"
    },
    {
     "description": "VANECK GOLD MINERS ETF",
     "symbol": "GDX"
    },
    {
     "description": "MICROSECTORS GOLD MINERS -3X",
     "symbol": "GDXD"
    },
    {
     "description": "VANECK JUNIOR GOLD MINERS",
     "symbol": "GDXJ"
    },
    {
     "description": "GOLDEX RESOURCES CORP",
     "symbol": "GDXRF"
    },
    {
     "description": "MICROSECTORS GOLD MINERS 3X",
     "symbol": "GDXU"
    },
    {
     "description": "RENU ENERGY LTD",
     "symbol": "GDYMF"
    },
    {
     "description": "GRID DYNAMICS HOLDINGS INC",
     "symbol": "GDYN"
    },
    {
     "description": "GOODYEAR THAILAND PCL",
     "symbol": "GDYTF"
    },
    {
     "description": "GENERAL ELECTRIC CO",
     "symbol": "GE"
    },
    {
     "description": "GEA GROUP AG",
     "symbol": "GEAGF"
    },
    {
     "description": "GREAT EAGLE HOLDINGS LTD",
     "symbol": "GEAHF"
    },
    {
     "description": "RADIKO HOLDINGS CORP",
     "symbol": "GEATF"
    },
    {
     "description": "GENTING BERHAD-UNSPON ADR",
     "symbol": "GEBEY"
    },
    {
     "description": "GENTING BHD",
     "symbol": "GEBHF"
    },
    {
     "description": "GENTING BERHAD -SPONS ADR",
     "symbol": "GEBHY"
    },
    {
     "description": "GREENBRIAR CAPITAL CORP",
     "symbol": "GEBRF"
    },
    {
     "description": "GREAT ELM CAPITAL CORP",
     "symbol": "GECC"
    },
    {
     "description": "GREAT ELM CAPITAL CORP",
     "symbol": "GECCM"
    },
    {
     "description": "GREAT ELM CAPITAL CORP",
     "symbol": "GECCN"
    },
    {
     "description": "GREAT ELM CAPITA",
     "symbol": "GECCO"
    },
    {
     "description": "GECINA SA",
     "symbol": "GECFF"
    },
    {
     "description": "RICHTER GEDEON -SPONS GDR",
     "symbol": "GEDSF"
    },
    {
     "description": "G8 EDUCATION LTD",
     "symbol": "GEDUF"
    },
    {
     "description": "GLOBAL ENVIRONMENTAL ENERGY",
     "symbol": "GEECF"
    },
    {
     "description": "GAMES & ESPORTS EXPERIENCE-A",
     "symbol": "GEEX"
    },
    {
     "description": "GAMES & ESPORTS EXPERIENCE A",
     "symbol": "GEEXU"
    },
    {
     "description": "GAMES & ESPORTS EXPERIEN -23",
     "symbol": "GEEXW"
    },
    {
     "description": "GREIF INC-CL A",
     "symbol": "GEF"
    },
    {
     "description": "GREIF INC-CL B",
     "symbol": "GEF.B"
    },
    {
     "description": "GEO FINANCE CORP",
     "symbol": "GEFI"
    },
    {
     "description": "GREAT ELM GROUP INC",
     "symbol": "GEG"
    },
    {
     "description": "GENESIS ELECTRONICS GROUP IN",
     "symbol": "GEGI"
    },
    {
     "description": "GOLD ENTERTAINMENT GROUP INC",
     "symbol": "GEGP"
    },
    {
     "description": "GAENSEL ENERGY GROUP INC",
     "symbol": "GEGR"
    },
    {
     "description": "GENEL ENERGY PLC",
     "symbol": "GEGYF"
    },
    {
     "description": "GENEL ENERGY PLC-ADR",
     "symbol": "GEGYY"
    },
    {
     "description": "GREAT EASTERN HOLDINGS LTD",
     "symbol": "GEHDF"
    },
    {
     "description": "GREAT EASTERN HOLD-UNSP ADR",
     "symbol": "GEHDY"
    },
    {
     "description": "GENESIS ENERGY L.P.",
     "symbol": "GEL"
    },
    {
     "description": "GRAPHANO ENERGY LTD",
     "symbol": "GELEF"
    },
    {
     "description": "CHATHAM ROCK PHOSPHATE LTD",
     "symbol": "GELGF"
    },
    {
     "description": "GELION PLC",
     "symbol": "GELNF"
    },
    {
     "description": "GREEN ENERGY LIVE INC",
     "symbol": "GELV"
    },
    {
     "description": "GEELY AUTOMOBILE HOLDINGS LT",
     "symbol": "GELYF"
    },
    {
     "description": "GEELY AUTOMOBILE-UNSPON ADR",
     "symbol": "GELYY"
    },
    {
     "description": "GOLDMAN SACHS ACTIVEBETA EM",
     "symbol": "GEM"
    },
    {
     "description": "GOLDMAN ACCESS EM USD BOND",
     "symbol": "GEMD"
    },
    {
     "description": "GEMXX CORP",
     "symbol": "GEMZ"
    },
    {
     "description": "GENCOR INDUSTRIES INC",
     "symbol": "GENC"
    },
    {
     "description": "GENETIC TECH LTD-SP ADR",
     "symbol": "GENE"
    },
    {
     "description": "GEAR ENERGY LTD",
     "symbol": "GENGF"
    },
    {
     "description": "GENERATION HEMP INC",
     "symbol": "GENH"
    },
    {
     "description": "GENIUS SPORTS LTD",
     "symbol": "GENI"
    },
    {
     "description": "GENIUS SPORTS LTD -CW28",
     "symbol": "GENI.WS"
    },
    {
     "description": "GENERATION MINING LTD",
     "symbol": "GENMF"
    },
    {
     "description": "GENESIS HEALTHCARE INC",
     "symbol": "GENN"
    },
    {
     "description": "GENIX PHARMACEUTICALS CORP",
     "symbol": "GENPF"
    },
    {
     "description": "GENESIS UNICORN CAPITAL CO-A",
     "symbol": "GENQ"
    },
    {
     "description": "GENESIS UNICORN CAPITAL CORP",
     "symbol": "GENQU"
    },
    {
     "description": "GENESIS UNICORN CAPIT -CW23",
     "symbol": "GENQW"
    },
    {
     "description": "GENUS PLC",
     "symbol": "GENSF"
    },
    {
     "description": "G5 ENTERTAINMENT AB",
     "symbol": "GENTF"
    },
    {
     "description": "GENEX PHARMACEUTICAL INC",
     "symbol": "GENX"
    },
    {
     "description": "PRINCIPAL MILLENNIALS ETF",
     "symbol": "GENY"
    },
    {
     "description": "GEO GROUP INC\/THE",
     "symbol": "GEO"
    },
    {
     "description": "GEOSPACE TECHNOLOGIES CORP",
     "symbol": "GEOS"
    },
    {
     "description": "GOLDEN ENERGY OFFSHORE SERVI",
     "symbol": "GEOUF"
    },
    {
     "description": "GENOVIS AB",
     "symbol": "GEOVF"
    },
    {
     "description": "GEPCO LTD",
     "symbol": "GEPC"
    },
    {
     "description": "GOLDMAN SACHS MLP & ENERGY R",
     "symbol": "GER"
    },
    {
     "description": "GLEN EAGLE RESOURCES INC",
     "symbol": "GERFF"
    },
    {
     "description": "GLOBAL ENERGY RESOURCES INC",
     "symbol": "GERI"
    },
    {
     "description": "ETFMG TRTMNT TESTING ADV ETF",
     "symbol": "GERM"
    },
    {
     "description": "GERON CORP",
     "symbol": "GERN"
    },
    {
     "description": "GREENSHIFT CORP",
     "symbol": "GERS"
    },
    {
     "description": "GUESS? INC",
     "symbol": "GES"
    },
    {
     "description": "GENERAL EUROPEAN STRATEGIC I",
     "symbol": "GESI"
    },
    {
     "description": "GETNET ADQUIRENCIA E SERVISO",
     "symbol": "GET"
    },
    {
     "description": "GETBUSY PLC",
     "symbol": "GETBF"
    },
    {
     "description": "GREEN ENVIROTECH HOLDINGS CO",
     "symbol": "GETH"
    },
    {
     "description": "GETECH GROUP PLC",
     "symbol": "GETPF"
    },
    {
     "description": "MEDIASET ESPANA COMUNICACION",
     "symbol": "GETVF"
    },
    {
     "description": "MEDIASET ESPANA C-UNSPON ADR",
     "symbol": "GETVY"
    },
    {
     "description": "GENERAL ENVIRONMENTAL MANAGE",
     "symbol": "GEVI"
    },
    {
     "description": "GEVO INC",
     "symbol": "GEVO"
    },
    {
     "description": "NEW GERMANY FUND",
     "symbol": "GF"
    },
    {
     "description": "GUARDFORCE AI CO LTD",
     "symbol": "GFAI"
    },
    {
     "description": "GUARDFORCE AI CO LTD -CW26",
     "symbol": "GFAIW"
    },
    {
     "description": "GAFISA SA-ADR",
     "symbol": "GFASY"
    },
    {
     "description": "GRIFCO INTERNATIONAL INC",
     "symbol": "GFCI"
    },
    {
     "description": "GUARANTY FINANCIAL CORP",
     "symbol": "GFCJ"
    },
    {
     "description": "GOOD FLOUR CORP\/THE",
     "symbol": "GFCOF"
    },
    {
     "description": "GENERAL FINANCE & DEVELOPMEN",
     "symbol": "GFDV"
    },
    {
     "description": "GOODFELLOW INC",
     "symbol": "GFELF"
    },
    {
     "description": "GRIFFON CORP",
     "symbol": "GFF"
    },
    {
     "description": "GROWTH FOR GOOD ACQUISITION",
     "symbol": "GFGD"
    },
    {
     "description": "GROWTH FOR GOOD ACQUISIT-RTS",
     "symbol": "GFGDR"
    },
    {
     "description": "GROWTH FOR GOOD ACQUISITION",
     "symbol": "GFGDU"
    },
    {
     "description": "GROWTH FOR GOOD ACQ -CW23",
     "symbol": "GFGDW"
    },
    {
     "description": "GURU FAVORITE STOCKS ETF",
     "symbol": "GFGF"
    },
    {
     "description": "GFG RESOURCES INC",
     "symbol": "GFGSF"
    },
    {
     "description": "GETFUGU INC",
     "symbol": "GFGU"
    },
    {
     "description": "FAST LINE HOLDING INC",
     "symbol": "GFGVF"
    },
    {
     "description": "GRANITE FALLS ENERGY-MEMB UN",
     "symbol": "GFGY"
    },
    {
     "description": "GOLD FIELDS LTD-SPONS ADR",
     "symbol": "GFI"
    },
    {
     "description": "GOLD FIELDS LTD",
     "symbol": "GFIOF"
    },
    {
     "description": "GFINITY PLC",
     "symbol": "GFIZF"
    },
    {
     "description": "GFK SE",
     "symbol": "GFKAF"
    },
    {
     "description": "OPUS ONE GOLD CORP",
     "symbol": "GFKRF"
    },
    {
     "description": "GULF KEYSTONE PET-SPON ADR",
     "symbol": "GFKSY"
    },
    {
     "description": "GFL ENVIRONMENTAL INC-SUB VT",
     "symbol": "GFL"
    },
    {
     "description": "GEMFIELDS PLC",
     "symbol": "GFLDF"
    },
    {
     "description": "GFL ENVIRONMENTAL INC",
     "symbol": "GFLU"
    },
    {
     "description": "GOLIATH FILM & MEDIA HOLDING",
     "symbol": "GFMH"
    },
    {
     "description": "GFM RESOURCES LTD",
     "symbol": "GFMRF"
    },
    {
     "description": "GRAYSCALE FUTURE OF FINANCE",
     "symbol": "GFOF"
    },
    {
     "description": "GENUFOOD ENERGY ENZYMES CORP",
     "symbol": "GFOO"
    },
    {
     "description": "GRAF ACQUISITION CORP IV",
     "symbol": "GFOR"
    },
    {
     "description": "GRAF ACQUISITION CORP IV",
     "symbol": "GFOR.U"
    },
    {
     "description": "GRAF ACQUISITION CORP-CW28",
     "symbol": "GFOR.WS"
    },
    {
     "description": "GLOBALFOUNDRIES INC",
     "symbol": "GFS"
    },
    {
     "description": "GOLD'N FUTURES MINERAL CORP",
     "symbol": "GFTRF"
    },
    {
     "description": "GLOBAL FIBER TECHNOLOGIES IN",
     "symbol": "GFTX"
    },
    {
     "description": "PLM EQUIPMENT GROWTH FD III",
     "symbol": "GFWQZ"
    },
    {
     "description": "GOLDEN FALCON ACQUISITI-CL A",
     "symbol": "GFX"
    },
    {
     "description": "GOLDEN FALCON ACQUISITION CO",
     "symbol": "GFX.U"
    },
    {
     "description": "GOLDEN FALCON ACQ CL A -CW26",
     "symbol": "GFX.WS"
    },
    {
     "description": "GENESIS GROWTH TECH ACQUIS-A",
     "symbol": "GGAA"
    },
    {
     "description": "GENESIS GROWTH TECH ACQUISIT",
     "symbol": "GGAAU"
    },
    {
     "description": "GENESIS GROWTH TECH AC A -23",
     "symbol": "GGAAW"
    },
    {
     "description": "GRUPO FINANCIERO GALICIA-ADR",
     "symbol": "GGAL"
    },
    {
     "description": "GOOD GAMER ENTERTAINMENT INC",
     "symbol": "GGAMF"
    },
    {
     "description": "GOLDGROUP MINING INC",
     "symbol": "GGAZF"
    },
    {
     "description": "GERDAU SA -SPON ADR",
     "symbol": "GGB"
    },
    {
     "description": "LXRANDCO INC-CLASS B",
     "symbol": "GGBBF"
    },
    {
     "description": "GUAR GLOBAL LTD",
     "symbol": "GGBL"
    },
    {
     "description": "GREEN GROWTH BRANDS INC",
     "symbol": "GGBXF"
    },
    {
     "description": "GENERIC GOLD CORP",
     "symbol": "GGCPF"
    },
    {
     "description": "GUANGDONG INVESTMENT LTD",
     "symbol": "GGDVF"
    },
    {
     "description": "GUANGDONG INVESTM-UNSPON ADR",
     "symbol": "GGDVY"
    },
    {
     "description": "GREEN GIANT INC",
     "symbol": "GGE"
    },
    {
     "description": "GRACO INC",
     "symbol": "GGG"
    },
    {
     "description": "GALANE GOLD LTD",
     "symbol": "GGGOF"
    },
    {
     "description": "GLOBAL GARDENS GROUP INC",
     "symbol": "GGGRF"
    },
    {
     "description": "GREGGS PLC",
     "symbol": "GGGSF"
    },
    {
     "description": "GREGGS PLC-UNSPONSORED ADR",
     "symbol": "GGGSY"
    },
    {
     "description": "G3 VRM ACQUISITION CORP-CL A",
     "symbol": "GGGV"
    },
    {
     "description": "G3 VRM ACQUISITION CORP-RTS",
     "symbol": "GGGVR"
    },
    {
     "description": "G3 VRM ACQUISITION CORP",
     "symbol": "GGGVU"
    },
    {
     "description": "GUGGENHEIM SPECIAL PURPOSE A",
     "symbol": "GGI.U"
    },
    {
     "description": "GARIBALDI RESOURCES CORP",
     "symbol": "GGIFF"
    },
    {
     "description": "GREEN GLOBE INTERNATIONAL IN",
     "symbol": "GGII"
    },
    {
     "description": "GENESIS METALS CORP",
     "symbol": "GGISF"
    },
    {
     "description": "GETCHELL GOLD CORP",
     "symbol": "GGLDF"
    },
    {
     "description": "GIANT GROUP LTD",
     "symbol": "GGLT"
    },
    {
     "description": "GGL RESOURCES CORP",
     "symbol": "GGLXF"
    },
    {
     "description": "GLENFARNE MERGER CORP-A",
     "symbol": "GGMC"
    },
    {
     "description": "GLENFARNE MERGER CORP",
     "symbol": "GGMCU"
    },
    {
     "description": "GLENFARNE MERGER CL A -CW27",
     "symbol": "GGMCW"
    },
    {
     "description": "GAMCO GLOBAL GOLD NATURAL RE",
     "symbol": "GGN"
    },
    {
     "description": "GAMCO GLOBAL GOLD NATURA",
     "symbol": "GGN.PRB"
    },
    {
     "description": "GN STORE NORD A\/S",
     "symbol": "GGNDF"
    },
    {
     "description": "GENOCEA BIOSCIENCES INC -23",
     "symbol": "GGNNW"
    },
    {
     "description": "GUDANG GARAM TBK PT",
     "symbol": "GGNPF"
    },
    {
     "description": "GORES GUGGENHEIM INC -CL A",
     "symbol": "GGPI"
    },
    {
     "description": "GORES GUGGENHEIM INC",
     "symbol": "GGPIU"
    },
    {
     "description": "GORES GUGGENHEIM CL A -CW27",
     "symbol": "GGPIW"
    },
    {
     "description": "G-RESOURCES GROUP LTD",
     "symbol": "GGPXF"
    },
    {
     "description": "GOGORO INC",
     "symbol": "GGR"
    },
    {
     "description": "GROUPE GORGE",
     "symbol": "GGRGF"
    },
    {
     "description": "GLOBAL GREEN SOLUTIONS INC",
     "symbol": "GGRN"
    },
    {
     "description": "GOLDEN GROWERS COOP",
     "symbol": "GGROU"
    },
    {
     "description": "GOGORO INC -CW27",
     "symbol": "GGROW"
    },
    {
     "description": "GABELLI GLOBAL GROWTH ETF",
     "symbol": "GGRW"
    },
    {
     "description": "GOLD AND GEMSTONE MINING INC",
     "symbol": "GGSM"
    },
    {
     "description": "GABELLI MULTIMEDIA TRUST INC",
     "symbol": "GGT"
    },
    {
     "description": "GABELLI MULTIMEDIA TRUST",
     "symbol": "GGT.PRE"
    },
    {
     "description": "GABELLI MULTIMEDIA TRUST",
     "symbol": "GGT.PRG"
    },
    {
     "description": "GOLDEN GOLIATH RESOURCES LTD",
     "symbol": "GGTHF"
    },
    {
     "description": "GGX GOLD CORP",
     "symbol": "GGXXF"
    },
    {
     "description": "GABELLI GLOBAL SMALL & M",
     "symbol": "GGZ"
    },
    {
     "description": "GUARDANT HEALTH INC",
     "symbol": "GH"
    },
    {
     "description": "GAMING & HOSPITALITY ACQUI-A",
     "symbol": "GHAC"
    },
    {
     "description": "GAMING & HOSPITALITY ACQUISI",
     "symbol": "GHACU"
    },
    {
     "description": "GAMING & HOSPITALITY A -CW28",
     "symbol": "GHACW"
    },
    {
     "description": "GRAND HAVANA INC",
     "symbol": "GHAV"
    },
    {
     "description": "Glass House Brands Inc",
     "symbol": "GHBWF"
    },
    {
     "description": "GRAHAM HOLDINGS CO-CLASS B",
     "symbol": "GHC"
    },
    {
     "description": "GLOBAL HEALTHCARE & EDUCATIO",
     "symbol": "GHEU"
    },
    {
     "description": "GREENTREE HOSPITALITY GR-ADR",
     "symbol": "GHG"
    },
    {
     "description": "GUANHUA CORP",
     "symbol": "GHGH"
    },
    {
     "description": "GO-AHEAD GROUP PLC",
     "symbol": "GHGUF"
    },
    {
     "description": "GO-AHEAD GROUP-UNSPON ADR",
     "symbol": "GHGUY"
    },
    {
     "description": "GAMEHOST INC",
     "symbol": "GHIFF"
    },
    {
     "description": "GREEN AND HILL INDUSTRIES IN",
     "symbol": "GHIL"
    },
    {
     "description": "GORES HOLDING IX INC-CL A",
     "symbol": "GHIX"
    },
    {
     "description": "GORES HOLDING IX INC",
     "symbol": "GHIXU"
    },
    {
     "description": "GORES HOLDING IX -CW24",
     "symbol": "GHIXW"
    },
    {
     "description": "GREENHILL & CO INC",
     "symbol": "GHL"
    },
    {
     "description": "GUILD HOLDINGS CO - CLASS A",
     "symbol": "GHLD"
    },
    {
     "description": "GRAHAM CORP",
     "symbol": "GHM"
    },
    {
     "description": "GOOD HEMP INC",
     "symbol": "GHMP"
    },
    {
     "description": "GH RESEARCH PLC",
     "symbol": "GHRS"
    },
    {
     "description": "GUARDION HEALTH SCIENCES INC",
     "symbol": "GHSI"
    },
    {
     "description": "GHST WORLD INC",
     "symbol": "GHST"
    },
    {
     "description": "GOOSE HOLLOW TACTICAL ALLOC",
     "symbol": "GHTA"
    },
    {
     "description": "G-H-3 INTERNATIONAL INC",
     "symbol": "GHTI"
    },
    {
     "description": "GOLDHAVEN RESOURCES CORP",
     "symbol": "GHVNF"
    },
    {
     "description": "PGIM GLOBAL HIGH YIELD FUND",
     "symbol": "GHY"
    },
    {
     "description": "GOLDMAN SACHS ACCESS HY CORP",
     "symbol": "GHYB"
    },
    {
     "description": "ISHARES GLOBAL HY CORP-DISTR",
     "symbol": "GHYCF"
    },
    {
     "description": "ISHARES US&INTL HIGH YIELD C",
     "symbol": "GHYG"
    },
    {
     "description": "GIGCAPITAL5 INC",
     "symbol": "GIA"
    },
    {
     "description": "GIGCAPITAL5 INC",
     "symbol": "GIA.U"
    },
    {
     "description": "GIGCAPITAL5 INC -CW28",
     "symbol": "GIA.WS"
    },
    {
     "description": "GESHER I ACQUISITION CORP-A",
     "symbol": "GIAC"
    },
    {
     "description": "GESHER I ACQUISITION CORP",
     "symbol": "GIACU"
    },
    {
     "description": "GESHER I ACQUISITION -CW28",
     "symbol": "GIACW"
    },
    {
     "description": "CGI INC",
     "symbol": "GIB"
    },
    {
     "description": "GIBB RIVER DIAMONDS LTD",
     "symbol": "GIBBF"
    },
    {
     "description": "GIB CAPITAL GROUP INC",
     "symbol": "GIBX"
    },
    {
     "description": "GLOBAL INDUSTRIAL CO",
     "symbol": "GIC"
    },
    {
     "description": "GOLDEN INDEPENDENCE MINING C",
     "symbol": "GIDMF"
    },
    {
     "description": "GULF ISLAND FABRICATION INC",
     "symbol": "GIFI"
    },
    {
     "description": "GRIFOLS SA",
     "symbol": "GIFLF"
    },
    {
     "description": "GRIFOLS SA - B",
     "symbol": "GIFOF"
    },
    {
     "description": "GIFA INC",
     "symbol": "GIFX"
    },
    {
     "description": "GIGA-TRONICS INC",
     "symbol": "GIGA"
    },
    {
     "description": "GOLDMAN SACHS INV GRD CORP",
     "symbol": "GIGB"
    },
    {
     "description": "SOFI GIG ECONOMY ETF",
     "symbol": "GIGE"
    },
    {
     "description": "GAMING INNOVATION GROUP INC",
     "symbol": "GIGI"
    },
    {
     "description": "GIGAMEDIA LTD",
     "symbol": "GIGM"
    },
    {
     "description": "GENTING SINGAPORE LTD",
     "symbol": "GIGNF"
    },
    {
     "description": "GENTING SINGAPORE-UNSPON ADR",
     "symbol": "GIGNY"
    },
    {
     "description": "SPDR S&P GLOBAL INFRASTRUCTU",
     "symbol": "GII"
    },
    {
     "description": "G-III APPAREL GROUP LTD",
     "symbol": "GIII"
    },
    {
     "description": "GORES HOLDINGS VIII INC-CL A",
     "symbol": "GIIX"
    },
    {
     "description": "GORES HOLDINGS VIII INC",
     "symbol": "GIIXU"
    },
    {
     "description": "GORES HOLD VIII CL A -CW27",
     "symbol": "GIIXW"
    },
    {
     "description": "GLOBAL DIV INV GRADE INC II",
     "symbol": "GIIZF"
    },
    {
     "description": "GRIFOLS SA-SPON ADR",
     "symbol": "GIKLY"
    },
    {
     "description": "GILDAN ACTIVEWEAR INC",
     "symbol": "GIL"
    },
    {
     "description": "GILEAD SCIENCES INC",
     "symbol": "GILD"
    },
    {
     "description": "GILAT SATELLITE NETWORKS LTD",
     "symbol": "GILT"
    },
    {
     "description": "GITENNES EXPLORATION INC",
     "symbol": "GILXF"
    },
    {
     "description": "TEMPLETON GLOBAL INCOME FUND",
     "symbol": "GIM"
    },
    {
     "description": "GOLDMAN SACHS INNOVATE EQTY",
     "symbol": "GINN"
    },
    {
     "description": "GREEN IMPACT PARTNERS INC",
     "symbol": "GIPIF"
    },
    {
     "description": "GLOBAL INNOVATIVE PLATFORMS",
     "symbol": "GIPL"
    },
    {
     "description": "GENERATION INCOME PROPERTIES",
     "symbol": "GIPR"
    },
    {
     "description": "GENERATION INCOME PROPER -CW",
     "symbol": "GIPRW"
    },
    {
     "description": "GENERAL MILLS INC",
     "symbol": "GIS"
    },
    {
     "description": "GRUPO INDUSTRIAL SALTILLO",
     "symbol": "GISMF"
    },
    {
     "description": "GLOBAL IT HOLDINGS INC",
     "symbol": "GITH"
    },
    {
     "description": "GRUPO DE INV SURAME-SPON ADR",
     "symbol": "GIVPY"
    },
    {
     "description": "GRUPO DE INVERSIONES-SPN ADR",
     "symbol": "GIVSY"
    },
    {
     "description": "GIVEX INFORMATION TECHNOLOGY",
     "symbol": "GIVXF"
    },
    {
     "description": "GIGINTERNATIONAL1 INC",
     "symbol": "GIW"
    },
    {
     "description": "GIGINTERNATIONAL1 INC",
     "symbol": "GIWWU"
    },
    {
     "description": "GIGINTERNATIONAL1 INC -CW28",
     "symbol": "GIWWW"
    },
    {
     "description": "GJ CULTURE GROUP US INC",
     "symbol": "GJCU"
    },
    {
     "description": "STRATS-US-04-6",
     "symbol": "GJH"
    },
    {
     "description": "GJENSIDIGE FORSIKRING ASA",
     "symbol": "GJNSF"
    },
    {
     "description": "GJENSIDIGE FORSIKRING-UN ADR",
     "symbol": "GJNSY"
    },
    {
     "description": "STRATS-WALMART",
     "symbol": "GJO"
    },
    {
     "description": "STRATS",
     "symbol": "GJP"
    },
    {
     "description": "STRATS-PG 2006-1",
     "symbol": "GJR"
    },
    {
     "description": "STRATS-GS-2006-02",
     "symbol": "GJS"
    },
    {
     "description": "GEO JS TECH GROUP CORP",
     "symbol": "GJST"
    },
    {
     "description": "STRATS-ALL-06-3",
     "symbol": "GJT"
    },
    {
     "description": "ADVISORSHARES GERBER KAWASAK",
     "symbol": "GK"
    },
    {
     "description": "GUSKIN GOLD CORP",
     "symbol": "GKIN"
    },
    {
     "description": "GREENKRAFT INC",
     "symbol": "GKIT"
    },
    {
     "description": "GLAUKOS CORP",
     "symbol": "GKOS"
    },
    {
     "description": "GATEKEEPER SYSTEMS INC",
     "symbol": "GKPRF"
    },
    {
     "description": "GRUPO KUO SAB DE CV-SER B",
     "symbol": "GKSDF"
    },
    {
     "description": "GRENKE AG",
     "symbol": "GKSGF"
    },
    {
     "description": "GIKEN LTD",
     "symbol": "GKSKF"
    },
    {
     "description": "GEK TERNA HOLDING REAL ESTAT",
     "symbol": "GKTRF"
    },
    {
     "description": "GLOBE LIFE INC",
     "symbol": "GL"
    },
    {
     "description": "GLOBE LIFE INC",
     "symbol": "GL.PRD"
    },
    {
     "description": "GEMINA LABORATORIES LTD",
     "symbol": "GLABF"
    },
    {
     "description": "GLADSTONE CAPITAL CORP",
     "symbol": "GLAD"
    },
    {
     "description": "GLASSBRIDGE ENTERPRISES INC",
     "symbol": "GLAE"
    },
    {
     "description": "GLANBIA PLC",
     "symbol": "GLAPF"
    },
    {
     "description": "GLANBIA PLC-SPONS ADR",
     "symbol": "GLAPY"
    },
    {
     "description": "GLOBIS ACQUISITION CORP",
     "symbol": "GLAQ"
    },
    {
     "description": "GLOBIS ACQUISITION CORP",
     "symbol": "GLAQU"
    },
    {
     "description": "GLOBIS ACQ -CW25",
     "symbol": "GLAQW"
    },
    {
     "description": "GLADIATOR RESOURCES LTD",
     "symbol": "GLARF"
    },
    {
     "description": "GLASS HOUSE BRANDS INC",
     "symbol": "GLASF"
    },
    {
     "description": "GLOBAL ATOMIC CORP",
     "symbol": "GLATF"
    },
    {
     "description": "GLAXOSMITHKLINE PLC",
     "symbol": "GLAXF"
    },
    {
     "description": "GLOBAL QUEST LTD",
     "symbol": "GLBB"
    },
    {
     "description": "GLOBAL SEED CORP",
     "symbol": "GLBD"
    },
    {
     "description": "GLOBAL-E ONLINE LTD",
     "symbol": "GLBE"
    },
    {
     "description": "GLOBRANDS LTD",
     "symbol": "GLBGF"
    },
    {
     "description": "GLOBALTECH HOLDINGS INC",
     "symbol": "GLBH"
    },
    {
     "description": "GOLDBANK MINING CORP",
     "symbol": "GLBKF"
    },
    {
     "description": "CARTESIAN GROWTH CORP-A",
     "symbol": "GLBL"
    },
    {
     "description": "CARTESIAN GROWTH CORP",
     "symbol": "GLBLU"
    },
    {
     "description": "CARTESIAN GROWTH CL A -CW27",
     "symbol": "GLBLW"
    },
    {
     "description": "GLOBAL BROKERAGE INC",
     "symbol": "GLBR"
    },
    {
     "description": "GLOBAL BRANDS GROUP HOLDING",
     "symbol": "GLBRF"
    },
    {
     "description": "GLOBUS MARITIME LIMITED",
     "symbol": "GLBS"
    },
    {
     "description": "GLOBEX MINING ENTERPRISES",
     "symbol": "GLBXF"
    },
    {
     "description": "GLEN BURNIE BANCORP",
     "symbol": "GLBZ"
    },
    {
     "description": "GOOD LIFE CHINA CORP",
     "symbol": "GLCC"
    },
    {
     "description": "GL EVENTS",
     "symbol": "GLCDF"
    },
    {
     "description": "VANECK CHINA GROWTH LEADERS",
     "symbol": "GLCN"
    },
    {
     "description": "GLENCORE PLC",
     "symbol": "GLCNF"
    },
    {
     "description": "GLOBAL LINKS CORP",
     "symbol": "GLCO"
    },
    {
     "description": "SPDR GOLD SHARES",
     "symbol": "GLD"
    },
    {
     "description": "GLOBALDATA PLC",
     "symbol": "GLDAF"
    },
    {
     "description": "STRATEGY SHARES GLD HDG BOND",
     "symbol": "GLDB"
    },
    {
     "description": "GREAT LAKES DREDGE & DOCK CO",
     "symbol": "GLDD"
    },
    {
     "description": "GOLDMINING INC",
     "symbol": "GLDG"
    },
    {
     "description": "X-LINKS GOLD SHRS COVRD CALL",
     "symbol": "GLDI"
    },
    {
     "description": "SPDR GOLD MINISHARES TRUST",
     "symbol": "GLDM"
    },
    {
     "description": "IDAHO CHAMPION GOLD MINES CA",
     "symbol": "GLDRF"
    },
    {
     "description": "USCF GOLD STRATEGY PLUS INCO",
     "symbol": "GLDX"
    },
    {
     "description": "GLOBAL ECOLOGY CORP",
     "symbol": "GLEC"
    },
    {
     "description": "GLADSTONE ACQUISITION CORP-A",
     "symbol": "GLEE"
    },
    {
     "description": "GLADSTONE ACQUISITION CORP",
     "symbol": "GLEEU"
    },
    {
     "description": "GLADSTONE ACQ CL A -CW27",
     "symbol": "GLEEW"
    },
    {
     "description": "GLOBAL FASHION GROUP SA",
     "symbol": "GLFGF"
    },
    {
     "description": "GALENFEHA INC",
     "symbol": "GLFH"
    },
    {
     "description": "MCHENRY METALS GOLF CORP",
     "symbol": "GLFN"
    },
    {
     "description": "TD HOLDINGS INC",
     "symbol": "GLG"
    },
    {
     "description": "GOGOLD RESOURCES INC",
     "symbol": "GLGDF"
    },
    {
     "description": "GREYSTONE LOGISTICS INC",
     "symbol": "GLGI"
    },
    {
     "description": "GLG LIFE TECH CORP",
     "symbol": "GLGLF"
    },
    {
     "description": "GLASS HOUSES ACQUISITION COR",
     "symbol": "GLHA"
    },
    {
     "description": "GLASS HOUSES ACQUISITION COR",
     "symbol": "GLHAU"
    },
    {
     "description": "GLASS HOUSES ACQ -CW27",
     "symbol": "GLHAW"
    },
    {
     "description": "PSH GROUP HOLDINGS INC",
     "symbol": "GLHD"
    },
    {
     "description": "GOLDEN HARP RESOURCES INC",
     "symbol": "GLHRF"
    },
    {
     "description": "AGFIQ GLOBAL INFRASTRUCTURE",
     "symbol": "GLIF"
    },
    {
     "description": "GLACIER LAKE RESOURCES INC",
     "symbol": "GLIIF"
    },
    {
     "description": "VANECK INDIA GROWTH LEADERS",
     "symbol": "GLIN"
    },
    {
     "description": "GOLD LION RESOURCES INC",
     "symbol": "GLIOF"
    },
    {
     "description": "CLEANTEK INDUSTRIES INC",
     "symbol": "GLKFF"
    },
    {
     "description": "GREAT LAKES GRAPHITE INC",
     "symbol": "GLKIF"
    },
    {
     "description": "PROSHARES ULTRASHORT GOLD",
     "symbol": "GLL"
    },
    {
     "description": "GOLDEN LAND BHD",
     "symbol": "GLLBF"
    },
    {
     "description": "GLOBAL-DINING INC",
     "symbol": "GLLDF"
    },
    {
     "description": "HYBRID SOFTWARE GROUP PLC",
     "symbol": "GLLGF"
    },
    {
     "description": "GOLDLION HOLDINGS LTD",
     "symbol": "GLLHF"
    },
    {
     "description": "GLOBALINK INVESTMENT INC",
     "symbol": "GLLI"
    },
    {
     "description": "GLOBALINK INVESTMENT INC-RTS",
     "symbol": "GLLIR"
    },
    {
     "description": "GLOBALINK INVESTMENT INC",
     "symbol": "GLLIU"
    },
    {
     "description": "GLOBALINK INVESTMENT -CW23",
     "symbol": "GLLIW"
    },
    {
     "description": "GLACIAL LAKES CORN PROCESSOR",
     "symbol": "GLLL"
    },
    {
     "description": "GALILEO JAPAN TRUST",
     "symbol": "GLLOF"
    },
    {
     "description": "GALMED PHARMACEUTICALS LTD",
     "symbol": "GLMD"
    },
    {
     "description": "GLACIER MEDIA INC",
     "symbol": "GLMFF"
    },
    {
     "description": "GALILEO MINING LTD",
     "symbol": "GLMGF"
    },
    {
     "description": "GLENCORE PLC -UNSP ADR",
     "symbol": "GLNCY"
    },
    {
     "description": "GOLAR LNG LTD",
     "symbol": "GLNG"
    },
    {
     "description": "GALAN LITHIUM LTD",
     "symbol": "GLNLF"
    },
    {
     "description": "GOLDEN STAR RESOURCES CORP",
     "symbol": "GLNS"
    },
    {
     "description": "GLENVILLE BANK HOLDING CO",
     "symbol": "GLNV"
    },
    {
     "description": "CLOUGH GLBL OPPORTUNITIES FD",
     "symbol": "GLO"
    },
    {
     "description": "GLOBANT SA",
     "symbol": "GLOB"
    },
    {
     "description": "CONTOURGLOBAL PLC",
     "symbol": "GLOFF"
    },
    {
     "description": "GASLOG LTD",
     "symbol": "GLOG.PRA"
    },
    {
     "description": "GLOW HOLDINGS INC",
     "symbol": "GLOH"
    },
    {
     "description": "GASLOG PARTNERS LP",
     "symbol": "GLOP"
    },
    {
     "description": "GASLOG PARTNERS LP",
     "symbol": "GLOP.PRA"
    },
    {
     "description": "GASLOG PARTNERS LP",
     "symbol": "GLOP.PRB"
    },
    {
     "description": "GASLOG PARTNERS LP",
     "symbol": "GLOP.PRC"
    },
    {
     "description": "GS ACTIVE BETA WORLD LVOL PL",
     "symbol": "GLOV"
    },
    {
     "description": "GLOBAL PARTNERS LP",
     "symbol": "GLP"
    },
    {
     "description": "GLOBAL PARTNERS LP",
     "symbol": "GLP.PRA"
    },
    {
     "description": "GLOBAL PARTNERS LP",
     "symbol": "GLP.PRB"
    },
    {
     "description": "GALP ENERGIA SGPS SA",
     "symbol": "GLPEF"
    },
    {
     "description": "GALP ENERGIA SGPS-UNSPON ADR",
     "symbol": "GLPEY"
    },
    {
     "description": "GALAPAGOS NV-SPON ADR",
     "symbol": "GLPG"
    },
    {
     "description": "GALAPAGOS NV",
     "symbol": "GLPGF"
    },
    {
     "description": "GAMING AND LEISURE PROPERTIE",
     "symbol": "GLPI"
    },
    {
     "description": "GLP J-REIT",
     "symbol": "GLPJF"
    },
    {
     "description": "GLOBAL PROFIT TECHNOLOGIES I",
     "symbol": "GLPT"
    },
    {
     "description": "CLOUGH GLOBAL EQUITY FUND",
     "symbol": "GLQ"
    },
    {
     "description": "GREENLIGHT CAPITAL RE LTD-A",
     "symbol": "GLRE"
    },
    {
     "description": "GLORI ENERGY INC",
     "symbol": "GLRI"
    },
    {
     "description": "GLEN ROSE PETROLEUM CORP",
     "symbol": "GLRP"
    },
    {
     "description": "INSPIRE FAITHWARD MIDCAP MOM",
     "symbol": "GLRY"
    },
    {
     "description": "GELESIS HOLDINGS INC",
     "symbol": "GLS"
    },
    {
     "description": "CAPSTAR SPECIAL PURPOSE-CW27",
     "symbol": "GLS.WS"
    },
    {
     "description": "GLORIUS SUN ENTERPRISES",
     "symbol": "GLSEF"
    },
    {
     "description": "GREENWICH LIFESCIENCES INC",
     "symbol": "GLSI"
    },
    {
     "description": "GLOBAL SPAC PARTNERS CO-SUB",
     "symbol": "GLSPT"
    },
    {
     "description": "GLOBAL SPAC PARTNERS CO",
     "symbol": "GLSPU"
    },
    {
     "description": "GLOBAL SPAC PARTNERS -CW27",
     "symbol": "GLSPW"
    },
    {
     "description": "GLATFELTER CORP",
     "symbol": "GLT"
    },
    {
     "description": "GALATA ACQUISITION CORP - A",
     "symbol": "GLTA"
    },
    {
     "description": "GALATA ACQUISITION CORP",
     "symbol": "GLTA.U"
    },
    {
     "description": "GALATA ACQ CORP CL A -CW28",
     "symbol": "GLTA.WS"
    },
    {
     "description": "GLOBALTRANS-SPONS GDR 144A",
     "symbol": "GLTIL"
    },
    {
     "description": "GALECTO INC",
     "symbol": "GLTO"
    },
    {
     "description": "ABRDN PRECIOUS METALS BASKET",
     "symbol": "GLTR"
    },
    {
     "description": "GLOBALTRA-SPONS GDR REG S",
     "symbol": "GLTVF"
    },
    {
     "description": "GABELLI GLOBAL UTIL & INCOME",
     "symbol": "GLU"
    },
    {
     "description": "GABELLI GLOB UTL & INC T",
     "symbol": "GLU.PRA"
    },
    {
     "description": "GABELLI GLOB UTL & INC T",
     "symbol": "GLU.PRB"
    },
    {
     "description": "GLUCOSE HEALTH INC",
     "symbol": "GLUC"
    },
    {
     "description": "MONTE ROSA THERAPEUTICS INC",
     "symbol": "GLUE"
    },
    {
     "description": "GREAT LAKES AVIATION LTD",
     "symbol": "GLUX"
    },
    {
     "description": "CLOUGH GLOBAL DIVIDEND AND I",
     "symbol": "GLV"
    },
    {
     "description": "GLENVEAGH PROPERTIES PLC",
     "symbol": "GLVHF"
    },
    {
     "description": "GALLANT VENTURE LTD",
     "symbol": "GLVNF"
    },
    {
     "description": "CORNING INC",
     "symbol": "GLW"
    },
    {
     "description": "GLOBAL WATER ASSET CORP",
     "symbol": "GLWA"
    },
    {
     "description": "GLOBALWORTH REAL ESTATE INVE",
     "symbol": "GLWHF"
    },
    {
     "description": "GLOW LIFETECH CORP",
     "symbol": "GLWLF"
    },
    {
     "description": "GALAXY GAMING INC",
     "symbol": "GLXZ"
    },
    {
     "description": "GLYCOMIMETICS INC",
     "symbol": "GLYC"
    },
    {
     "description": "GLYECO INC",
     "symbol": "GLYE"
    },
    {
     "description": "GLORY LTD - UNSPON ADR",
     "symbol": "GLYYY"
    },
    {
     "description": "GENERAL MOTORS CO",
     "symbol": "GM"
    },
    {
     "description": "GENMAB A\/S -SP ADR",
     "symbol": "GMAB"
    },
    {
     "description": "GENTING MALAYSIA BHD",
     "symbol": "GMALF"
    },
    {
     "description": "GENTING MALAYSIA BHD-SP ADR",
     "symbol": "GMALY"
    },
    {
     "description": "GS ACTIVEBETA US LC EQ",
     "symbol": "GMAVF"
    },
    {
     "description": "GUNMA BANK LTD",
     "symbol": "GMBKF"
    },
    {
     "description": "ESPORTS ENTERTAINMENT GROUP",
     "symbol": "GMBL"
    },
    {
     "description": "ESPORTS ENTERTAIN GRP",
     "symbol": "GMBLP"
    },
    {
     "description": "ESPORTS ENTERTAINMENT -CW25",
     "symbol": "GMBLW"
    },
    {
     "description": "ESPORTS ENTERTAINMENT -CW27",
     "symbol": "GMBLZ"
    },
    {
     "description": "GRUPO MEXICO SAB DE CV-SER B",
     "symbol": "GMBXF"
    },
    {
     "description": "GAMIDA CELL LTD",
     "symbol": "GMDA"
    },
    {
     "description": "GEM DIAMONDS LTD",
     "symbol": "GMDMF"
    },
    {
     "description": "GLOBAL MEDICAL PRODUCTS HOLD",
     "symbol": "GMDP"
    },
    {
     "description": "GOLDEN MEDITECH HOLDINGS LTD",
     "symbol": "GMDTF"
    },
    {
     "description": "GAMESTOP CORP-CLASS A",
     "symbol": "GME"
    },
    {
     "description": "GLOBUS MEDICAL INC - A",
     "symbol": "GMED"
    },
    {
     "description": "GAMBIT ENERGY INC",
     "symbol": "GMEI"
    },
    {
     "description": "GOME RETAIL HOLDINGS LTD",
     "symbol": "GMELF"
    },
    {
     "description": "GOME RETAIL HOLD-UNSP ADRR",
     "symbol": "GMELY"
    },
    {
     "description": "GOOD GAMING INC",
     "symbol": "GMER"
    },
    {
     "description": "VANECK GREEN METALS",
     "symbol": "GMET"
    },
    {
     "description": "GAMEON ENTERTAINMENT TECHNOL",
     "symbol": "GMETF"
    },
    {
     "description": "GME INNOTAINMENT INC",
     "symbol": "GMEV"
    },
    {
     "description": "SPDR S&P EMERGING ASIA PACIF",
     "symbol": "GMF"
    },
    {
     "description": "AETHERIUM ACQUISITION CORP-A",
     "symbol": "GMFI"
    },
    {
     "description": "AETHERIUM ACQUISITION CORP",
     "symbol": "GMFIU"
    },
    {
     "description": "AETHERIUM ACQUISITION A -28",
     "symbol": "GMFIW"
    },
    {
     "description": "GOLDEN MATRIX GROUP INC",
     "symbol": "GMGI"
    },
    {
     "description": "GRAPHENE MANUFACTURING GROUP",
     "symbol": "GMGMF"
    },
    {
     "description": "GOODMAN GROUP",
     "symbol": "GMGSF"
    },
    {
     "description": "GAMING TECHNOLOGIES INC",
     "symbol": "GMGT"
    },
    {
     "description": "GAM HOLDING AG",
     "symbol": "GMHLF"
    },
    {
     "description": "GAM HOLDING LTD-UNSPON ADR",
     "symbol": "GMHLY"
    },
    {
     "description": "G MINING VENTURES CORP",
     "symbol": "GMINF"
    },
    {
     "description": "GAMECARD-JOYCO HOLDINGS INC",
     "symbol": "GMJOF"
    },
    {
     "description": "GRUMA S.A.B.-UNSPONSORED ADR",
     "symbol": "GMKKY"
    },
    {
     "description": "Golar LNG Partners LP",
     "symbol": "GMLPF"
    },
    {
     "description": "GREEN MOUNTAIN DEVELOPMENT C",
     "symbol": "GMND"
    },
    {
     "description": "GOBIMIN INC",
     "symbol": "GMNFF"
    },
    {
     "description": "GOLD MOUNTAIN LTD",
     "symbol": "GMNGF"
    },
    {
     "description": "GEMINI GROUP GLOBAL CORP",
     "symbol": "GMNI"
    },
    {
     "description": "GAMENET GROUP SPA",
     "symbol": "GMNNF"
    },
    {
     "description": "GAUMONT SA",
     "symbol": "GMNTF"
    },
    {
     "description": "GMO FINANCIAL GATE INC",
     "symbol": "GMOFF"
    },
    {
     "description": "CAMBRIA GLOBAL MOMENTUM ETF",
     "symbol": "GMOM"
    },
    {
     "description": "GMO RESEARCH INC",
     "symbol": "GMORF"
    },
    {
     "description": "GMO INTERNET INC",
     "symbol": "GMOYF"
    },
    {
     "description": "RF Capital Group Inc",
     "symbol": "GMPFF"
    },
    {
     "description": "GOURMET PROVISIONS INTERNATI",
     "symbol": "GMPR"
    },
    {
     "description": "GESTAMP AUTOMOCION SA",
     "symbol": "GMPUF"
    },
    {
     "description": "GIVEMEPOWER CORP",
     "symbol": "GMPW"
    },
    {
     "description": "RF CAPITAL GROUP INC",
     "symbol": "GMPXD"
    },
    {
     "description": "GELUM RESOURCES LTD",
     "symbol": "GMRCF"
    },
    {
     "description": "GLOBAL MEDICAL REIT INC",
     "symbol": "GMRE"
    },
    {
     "description": "GLOBAL MEDICAL REIT INC",
     "symbol": "GMRE.PRA"
    },
    {
     "description": "GOLDEN RIM RESOURCES LTD",
     "symbol": "GMRMF"
    },
    {
     "description": "GME RESOURCES LTD",
     "symbol": "GMRSF"
    },
    {
     "description": "GMS INC",
     "symbol": "GMS"
    },
    {
     "description": "GRAND ENTERTAINMENT & MUSIC",
     "symbol": "GMSC"
    },
    {
     "description": "GAMESQUARE ESPORTS INC",
     "symbol": "GMSQF"
    },
    {
     "description": "GOLD MOUNTAIN MINING CORP",
     "symbol": "GMTNF"
    },
    {
     "description": "GEMINI THERAPEUTICS INC",
     "symbol": "GMTX"
    },
    {
     "description": "G MEDICAL INNOVATION HOLDING",
     "symbol": "GMVD"
    },
    {
     "description": "G MEDICAL INNOVATION -CW25",
     "symbol": "GMVDW"
    },
    {
     "description": "ENTAIN PLC",
     "symbol": "GMVHF"
    },
    {
     "description": "ENTAIN PLC -UNSPONSORED ADR",
     "symbol": "GMVHY"
    },
    {
     "description": "GMV MINERALS INC",
     "symbol": "GMVMF"
    },
    {
     "description": "GAMES WORKSHOP GROUP PLC",
     "symbol": "GMWKF"
    },
    {
     "description": "GRUPO MEXICANO DE DESARROLLO",
     "symbol": "GMXDF"
    },
    {
     "description": "GMEXICO TRANSPORTES SAB DE C",
     "symbol": "GMXTF"
    },
    {
     "description": "GMO INTERNET INC-UNSP ADR",
     "symbol": "GMYOY"
    },
    {
     "description": "GMO PAYMENT GATEWAY INC",
     "symbol": "GMYTF"
    },
    {
     "description": "MONETA MONEY BANK AS",
     "symbol": "GMYYF"
    },
    {
     "description": "GEMZ CORP",
     "symbol": "GMZP"
    },
    {
     "description": "GROUP NINE ACQUISITION -CL A",
     "symbol": "GNAC"
    },
    {
     "description": "GROUP NINE ACQUISITION CORP",
     "symbol": "GNACU"
    },
    {
     "description": "GROUP NINE ACQ CL A -CW26",
     "symbol": "GNACW"
    },
    {
     "description": "GENERATION ALPHA INC",
     "symbol": "GNAL"
    },
    {
     "description": "GENEREX BIOTECHNOLOGY CORP",
     "symbol": "GNBT"
    },
    {
     "description": "GENOCEA BIOSCIENCES INC",
     "symbol": "GNCA"
    },
    {
     "description": "GENCO CORP",
     "symbol": "GNCC"
    },
    {
     "description": "GREENCORE GROUP PLC",
     "symbol": "GNCGF"
    },
    {
     "description": "GREENCORE GROUP -SPON ADR",
     "symbol": "GNCGY"
    },
    {
     "description": "GENCELL LTD",
     "symbol": "GNCLF"
    },
    {
     "description": "GENCAN CAPITAL INC",
     "symbol": "GNCNF"
    },
    {
     "description": "GNCC CAPITAL INC",
     "symbol": "GNCP"
    },
    {
     "description": "GENIE ENERGY LTD-B",
     "symbol": "GNE"
    },
    {
     "description": "GENIE ENERGY LTD",
     "symbol": "GNE.PRA"
    },
    {
     "description": "GENERATION CAPITAL LTD",
     "symbol": "GNECF"
    },
    {
     "description": "GANFENG LITHIUM CO LTD-H",
     "symbol": "GNENF"
    },
    {
     "description": "GANFENG LITHIUM CO UNSP ADR",
     "symbol": "GNENY"
    },
    {
     "description": "GENFIT-ADR",
     "symbol": "GNFT"
    },
    {
     "description": "GENFIT",
     "symbol": "GNFTF"
    },
    {
     "description": "GETINGE AB-B SHS",
     "symbol": "GNGBF"
    },
    {
     "description": "GETINGE AB-UNSPONSORED ADR",
     "symbol": "GNGBY"
    },
    {
     "description": "GUNTHER GRANT INC",
     "symbol": "GNGR"
    },
    {
     "description": "INVENTUS MINING CORP",
     "symbol": "GNGXF"
    },
    {
     "description": "GUANGSHEN RAILWAY CO LTD-H",
     "symbol": "GNGYF"
    },
    {
     "description": "VIFOR PHARMA AG",
     "symbol": "GNHAF"
    },
    {
     "description": "GALENICA AG-UNSP ADR",
     "symbol": "GNHAY"
    },
    {
     "description": "ARIAN RESOURCES CORP",
     "symbol": "GNHRF"
    },
    {
     "description": "GNI GROUP LTD",
     "symbol": "GNIIF"
    },
    {
     "description": "GENCO SHIPPING & TRADING LTD",
     "symbol": "GNK"
    },
    {
     "description": "GLOBAL NET LEASE INC",
     "symbol": "GNL"
    },
    {
     "description": "GLOBAL NET LEASE INC",
     "symbol": "GNL.PRA"
    },
    {
     "description": "GLOBAL NET LEASE INC",
     "symbol": "GNL.PRB"
    },
    {
     "description": "GENESIS LAND DEVELOPMENT CO",
     "symbol": "GNLAF"
    },
    {
     "description": "GENELINK INC",
     "symbol": "GNLKQ"
    },
    {
     "description": "GREENLANE HOLDINGS INC - A",
     "symbol": "GNLN"
    },
    {
     "description": "ISHARES GNMA BOND ETF",
     "symbol": "GNMA"
    },
    {
     "description": "GENOMMA LAB INTERNACIONAL-B",
     "symbol": "GNMLF"
    },
    {
     "description": "GENMAB A\/S",
     "symbol": "GNMSF"
    },
    {
     "description": "GN STORE NORD A\/S-UNSP ADR",
     "symbol": "GNNDY"
    },
    {
     "description": "GENSCRIPT BIOTECH CORP",
     "symbol": "GNNSF"
    },
    {
     "description": "GOLDEN NUGGET ONLINE GAMING",
     "symbol": "GNOG"
    },
    {
     "description": "GENOIL INC",
     "symbol": "GNOLF"
    },
    {
     "description": "GLOBAL X GENOMICS & BIOTECHN",
     "symbol": "GNOM"
    },
    {
     "description": "AMERICAN CARESOURCE HOLDINGS",
     "symbol": "GNOW"
    },
    {
     "description": "GREEN PLANET GROUP INC",
     "symbol": "GNPG"
    },
    {
     "description": "GENIUS PRODUCTS INC",
     "symbol": "GNPR"
    },
    {
     "description": "GENPREX INC",
     "symbol": "GNPX"
    },
    {
     "description": "SPDR S&P GL NAT RESOURCES",
     "symbol": "GNR"
    },
    {
     "description": "GENERAC HOLDINGS INC",
     "symbol": "GNRC"
    },
    {
     "description": "GENERAL DATACOMM INDUSTRIES",
     "symbol": "GNRD"
    },
    {
     "description": "GENEURO SA",
     "symbol": "GNRRF"
    },
    {
     "description": "GREENROSE HOLDING CO INC\/THE",
     "symbol": "GNRS"
    },
    {
     "description": "GREENROSE HOLDING CO INC\/THE",
     "symbol": "GNRSU"
    },
    {
     "description": "GREENROSE HOLDING CO -CW24",
     "symbol": "GNRSW"
    },
    {
     "description": "GRAND RIVER COMMERCE INC",
     "symbol": "GNRV"
    },
    {
     "description": "GENIUS GROUP LTD",
     "symbol": "GNS"
    },
    {
     "description": "GNS GROUP INC",
     "symbol": "GNSG"
    },
    {
     "description": "GENIUS METALS INC",
     "symbol": "GNSMF"
    },
    {
     "description": "GENUSPLUS GROUP LTD",
     "symbol": "GNSPF"
    },
    {
     "description": "GENASYS INC",
     "symbol": "GNSS"
    },
    {
     "description": "GAMCO NATURAL RESOURCES GOLD",
     "symbol": "GNT"
    },
    {
     "description": "GAMCO NATURAL RE GOLD",
     "symbol": "GNT.PRA"
    },
    {
     "description": "GENENTA SCIENCE SPA - ADR",
     "symbol": "GNTA"
    },
    {
     "description": "GENTING PLANTATIONS BHD",
     "symbol": "GNTGF"
    },
    {
     "description": "GENETIC TECHNOLOGIES LTD",
     "symbol": "GNTLF"
    },
    {
     "description": "GENTOR RESOURCES INC",
     "symbol": "GNTOF"
    },
    {
     "description": "GENTEX CORP",
     "symbol": "GNTX"
    },
    {
     "description": "GUARANTY BANCSHARES INC",
     "symbol": "GNTY"
    },
    {
     "description": "GENIUS BRANDS INTERNATIONAL",
     "symbol": "GNUS"
    },
    {
     "description": "GENWORTH FINANCIAL INC-CL A",
     "symbol": "GNW"
    },
    {
     "description": "MASIVO CAPITAL CORP",
     "symbol": "GNYPF"
    },
    {
     "description": "GENERATION ZERO GROUP INC",
     "symbol": "GNZR"
    },
    {
     "description": "GUANGZHOU AUTOMOBILE GROUP-H",
     "symbol": "GNZUF"
    },
    {
     "description": "GUANGZHOU AUTOMOBILE-UNS ADR",
     "symbol": "GNZUY"
    },
    {
     "description": "GROCERY OUTLET HOLDING CORP",
     "symbol": "GO"
    },
    {
     "description": "GO ACQUISITION CORP-CLASS A",
     "symbol": "GOAC"
    },
    {
     "description": "GO ACQUISITION CORP",
     "symbol": "GOAC.U"
    },
    {
     "description": "GO ACQUISITION CORP -CW27GO",
     "symbol": "GOAC.WS"
    },
    {
     "description": "EVA LIVE INC",
     "symbol": "GOAI"
    },
    {
     "description": "GOLDEN ACQUISITION CORP",
     "symbol": "GOAQ"
    },
    {
     "description": "US GLB GLD & METAL MNRS ETF",
     "symbol": "GOAU"
    },
    {
     "description": "GOBI ACQUISITION CORP-A",
     "symbol": "GOBI"
    },
    {
     "description": "GEEKS ON CALL HOLDINGS INC",
     "symbol": "GOCH"
    },
    {
     "description": "GOHEALTH INC-CLASS A",
     "symbol": "GOCO"
    },
    {
     "description": "GO METALS CORP",
     "symbol": "GOCOF"
    },
    {
     "description": "GREEN ORGANIC DUTCHMAN -CW24",
     "symbol": "GODWF"
    },
    {
     "description": "FIRST TELLURIUM CORP",
     "symbol": "GODYF"
    },
    {
     "description": "GOLDHILLS HOLDING LTD",
     "symbol": "GODZF"
    },
    {
     "description": "1847 GOEDEKER INC",
     "symbol": "GOED"
    },
    {
     "description": "1847 GOEDEKER INC -CW26",
     "symbol": "GOED.WS"
    },
    {
     "description": "CANOO INC",
     "symbol": "GOEV"
    },
    {
     "description": "HENNESSY CAPITAL ACQUIS-CW25",
     "symbol": "GOEVW"
    },
    {
     "description": "GLOBAL X GOLD EXPLORERS ETF",
     "symbol": "GOEX"
    },
    {
     "description": "GUGGENHEIM STRATEGIC OPPORTU",
     "symbol": "GOF"
    },
    {
     "description": "GOFF CORP",
     "symbol": "GOFF"
    },
    {
     "description": "OPAP SA-UNSPON ADR",
     "symbol": "GOFPY"
    },
    {
     "description": "GOLDEN OCEAN GROUP LTD",
     "symbol": "GOGL"
    },
    {
     "description": "GOGREEN INVESTMENTS CORP",
     "symbol": "GOGN"
    },
    {
     "description": "GOGREEN INVESTMENTS CORP",
     "symbol": "GOGN.U"
    },
    {
     "description": "GOGREEN INVESTMENTS -CW23",
     "symbol": "GOGN.WS"
    },
    {
     "description": "GOGO INC",
     "symbol": "GOGO"
    },
    {
     "description": "GO GREEN GLOBAL TECHNOLOGIES",
     "symbol": "GOGR"
    },
    {
     "description": "GOLDEN GRAIL TECHNOLOGY CORP",
     "symbol": "GOGY"
    },
    {
     "description": "GLOBAL OIL & GAS AG",
     "symbol": "GOKFF"
    },
    {
     "description": "GOL LINHAS AEREAS INTEL-ADR",
     "symbol": "GOL"
    },
    {
     "description": "BARRICK GOLD CORP",
     "symbol": "GOLD"
    },
    {
     "description": "ACUSHNET HOLDINGS CORP",
     "symbol": "GOLF"
    },
    {
     "description": "GOLDEN LAKE EXPLORATION INC",
     "symbol": "GOLXF"
    },
    {
     "description": "GEOMEGA RESOURCES INC",
     "symbol": "GOMRF"
    },
    {
     "description": "GLADSTONE COMMERCIAL CORP",
     "symbol": "GOOD"
    },
    {
     "description": "GLADSTONE COMMERCIAL COR",
     "symbol": "GOODN"
    },
    {
     "description": "GLADSTONE COMMER",
     "symbol": "GOODO"
    },
    {
     "description": "ALPHABET INC-CL C",
     "symbol": "GOOG"
    },
    {
     "description": "ALPHABET INC-CL A",
     "symbol": "GOOGL"
    },
    {
     "description": "GOOI GLOBAL INC",
     "symbol": "GOOI"
    },
    {
     "description": "AQUARIUS AI INC",
     "symbol": "GOOLF"
    },
    {
     "description": "CANADA GOOSE HOLDINGS INC",
     "symbol": "GOOS"
    },
    {
     "description": "GIVOT OLAM OIL EXPLORAT- LP",
     "symbol": "GOOXF"
    },
    {
     "description": "GOURMET OCEAN PRODUCTS INC",
     "symbol": "GOPPF"
    },
    {
     "description": "GOLDREA RESOURCES CORP",
     "symbol": "GORAF"
    },
    {
     "description": "GOLDEN RIDGE RESOURCES LTD",
     "symbol": "GORIF"
    },
    {
     "description": "GORDON (I) CORP",
     "symbol": "GORL"
    },
    {
     "description": "GOLD RESOURCE CORP",
     "symbol": "GORO"
    },
    {
     "description": "GOSSAMER BIO INC",
     "symbol": "GOSS"
    },
    {
     "description": "GECKOSYSTEMS INTERNATIONAL",
     "symbol": "GOSY"
    },
    {
     "description": "GOLIATH RESOURCES LTD",
     "symbol": "GOTRF"
    },
    {
     "description": "GAOTU TECHEDU INC",
     "symbol": "GOTU"
    },
    {
     "description": "GOUVERNEUR BANCORP INC",
     "symbol": "GOVB"
    },
    {
     "description": "ISHARES US TREASURY BOND ETF",
     "symbol": "GOVT"
    },
    {
     "description": "GEOVAX LABS INC",
     "symbol": "GOVX"
    },
    {
     "description": "GEOVAX LABS INC -CW25",
     "symbol": "GOVXW"
    },
    {
     "description": "ISHARES 25+ YR TREAS STRIPS",
     "symbol": "GOVZ"
    },
    {
     "description": "GREENPOWER MOTOR CO INC",
     "symbol": "GP"
    },
    {
     "description": "GLOBAL PARTNER ACQUISITION-A",
     "symbol": "GPAC"
    },
    {
     "description": "GEOPACIFIC RESOURCES LTD",
     "symbol": "GPACF"
    },
    {
     "description": "GLOBAL PARTNER ACQUISITION C",
     "symbol": "GPACU"
    },
    {
     "description": "GLOBAL PARTNER ACQ A -CW27",
     "symbol": "GPACW"
    },
    {
     "description": "GRUPO AEROPORT DEL PACIFIC-B",
     "symbol": "GPAEF"
    },
    {
     "description": "GRUMA S.A.B.-B",
     "symbol": "GPAGF"
    },
    {
     "description": "GS ACTIVEBETA PARIS AC US LC",
     "symbol": "GPAL"
    },
    {
     "description": "GENUINE PARTS CO",
     "symbol": "GPC"
    },
    {
     "description": "GOLDEN PATH ACQUISITION CORP",
     "symbol": "GPCO"
    },
    {
     "description": "GOLDEN PATH ACQUISITION-RTS",
     "symbol": "GPCOR"
    },
    {
     "description": "GOLDEN PATH ACQUISITION CORP",
     "symbol": "GPCOU"
    },
    {
     "description": "GOLDEN PATH ACQ -CW28",
     "symbol": "GPCOW"
    },
    {
     "description": "GREEN POLKADOT BOX INC",
     "symbol": "GPDB"
    },
    {
     "description": "DANONE",
     "symbol": "GPDNF"
    },
    {
     "description": "GREAT PORTLAND ESTATES PLC",
     "symbol": "GPEAF"
    },
    {
     "description": "GREAT PLAINS ETHANOL LLC-E",
     "symbol": "GPELL"
    },
    {
     "description": "GREAT PLAINS ETHANOL LLC-C",
     "symbol": "GPEOL"
    },
    {
     "description": "GREAT PLAINS ETHANOL LLC-A",
     "symbol": "GPEOU"
    },
    {
     "description": "GRUPO FINANCIERO INBURSA-O",
     "symbol": "GPFOF"
    },
    {
     "description": "GRUPO FIN INBURSA-SP ADR O",
     "symbol": "GPFOY"
    },
    {
     "description": "GRAPEFRUIT USA INC",
     "symbol": "GPFT"
    },
    {
     "description": "GLOBAL POLE TRUSION GROUP CO",
     "symbol": "GPGC"
    },
    {
     "description": "GRUPO GIGANTE SAB-SER *",
     "symbol": "GPGNF"
    },
    {
     "description": "G6 MATERIALS CORP",
     "symbol": "GPHBF"
    },
    {
     "description": "GLOBAL PHARM HOLDINGS GROUP",
     "symbol": "GPHG"
    },
    {
     "description": "GRAPHITE ONE INC",
     "symbol": "GPHOF"
    },
    {
     "description": "GROUP 1 AUTOMOTIVE INC",
     "symbol": "GPI"
    },
    {
     "description": "WESCAN ENERGY CORP",
     "symbol": "GPIPF"
    },
    {
     "description": "GEORGIA POWER CO",
     "symbol": "GPJA"
    },
    {
     "description": "GRAPHIC PACKAGING HOLDING CO",
     "symbol": "GPK"
    },
    {
     "description": "GRAYSTONE PARK ENTERPRISES I",
     "symbol": "GPKE"
    },
    {
     "description": "GRAND PEAK CAPITAL CORP",
     "symbol": "GPKUF"
    },
    {
     "description": "GREAT PANTHER MINING LTD",
     "symbol": "GPL"
    },
    {
     "description": "GREEN PLANET BIO ENGINEERING",
     "symbol": "GPLB"
    },
    {
     "description": "GEOPULSE EXPLORATIONS INC",
     "symbol": "GPLS"
    },
    {
     "description": "GOLDEN PROSPECT PRECIOUS MET",
     "symbol": "GPMMF"
    },
    {
     "description": "GRANITE POINT MORTGAGE TRUST",
     "symbol": "GPMT"
    },
    {
     "description": "GRANITE POINT MTGE TRST",
     "symbol": "GPMT.PRA"
    },
    {
     "description": "GPM METALS INC",
     "symbol": "GPMTF"
    },
    {
     "description": "GLOBAL PAYMENTS INC",
     "symbol": "GPN"
    },
    {
     "description": "GRUPA LOTOS SA",
     "symbol": "GPOLF"
    },
    {
     "description": "PROMOTORA DE INFORMACIONES-A",
     "symbol": "GPOPF"
    },
    {
     "description": "GULFPORT ENERGY CORP",
     "symbol": "GPOR"
    },
    {
     "description": "GOLD PORT CORP",
     "symbol": "GPOTF"
    },
    {
     "description": "GRUPO CARSO SAB DE CV-SER A1",
     "symbol": "GPOVF"
    },
    {
     "description": "GRUPO CARSO -SPONS ADR",
     "symbol": "GPOVY"
    },
    {
     "description": "GPO PLUS INC",
     "symbol": "GPOX"
    },
    {
     "description": "GREEN PLAINS PARTNERS LP",
     "symbol": "GPP"
    },
    {
     "description": "CERRO DE PASCO RESOURCES INC",
     "symbol": "GPPRF"
    },
    {
     "description": "GOODMAN PROPERTY TRUST",
     "symbol": "GPPYF"
    },
    {
     "description": "GUANWEI RECYCLING CORP",
     "symbol": "GPRC"
    },
    {
     "description": "GREEN PLAINS INC",
     "symbol": "GPRE"
    },
    {
     "description": "AIDIGONG MATERNAL & CHILD HE",
     "symbol": "GPRHF"
    },
    {
     "description": "GEOPARK LTD",
     "symbol": "GPRK"
    },
    {
     "description": "GOPRO INC-CLASS A",
     "symbol": "GPRO"
    },
    {
     "description": "GAP INC\/THE",
     "symbol": "GPS"
    },
    {
     "description": "GENERAL PAYMENT SYSTEMS INC",
     "symbol": "GPSI"
    },
    {
     "description": "GOLDEN PATRIOT CORP",
     "symbol": "GPTC"
    },
    {
     "description": "GPT GROUP",
     "symbol": "GPTGF"
    },
    {
     "description": "GRANDE PORTAGE",
     "symbol": "GPTRF"
    },
    {
     "description": "GLOBAL PAYMENT TECH INC",
     "symbol": "GPTX"
    },
    {
     "description": "GOLDEN PHOENIX MINERALS INC",
     "symbol": "GPXM"
    },
    {
     "description": "GREAT QUEST FERTILIZER LTD",
     "symbol": "GQMLF"
    },
    {
     "description": "FLEXSHARES GLOBAL QUALITY RE",
     "symbol": "GQRE"
    },
    {
     "description": "GRAB HOLDINGS LTD - CL A",
     "symbol": "GRAB"
    },
    {
     "description": "GRAB HOLDINGS LTD-CW 26",
     "symbol": "GRABW"
    },
    {
     "description": "GRIFFIN-AMERICAN HEALTHC III",
     "symbol": "GRAH"
    },
    {
     "description": "TPCO HOLDING CORP",
     "symbol": "GRAMF"
    },
    {
     "description": "GRAYBUG VISION INC",
     "symbol": "GRAY"
    },
    {
     "description": "Graze Inc",
     "symbol": "GRAZ"
    },
    {
     "description": "GREEN BRIDGE INDUSTRIES INC",
     "symbol": "GRBG"
    },
    {
     "description": "GREEN BRICK PARTNERS INC",
     "symbol": "GRBK"
    },
    {
     "description": "GREEN BRICK PARTNERS INC",
     "symbol": "GRBK.PRA"
    },
    {
     "description": "GRUPO BIMBO SAB- SERIES A",
     "symbol": "GRBMF"
    },
    {
     "description": "GORMAN-RUPP CO",
     "symbol": "GRC"
    },
    {
     "description": "GOLD SPRINGS RESOURCE CORP",
     "symbol": "GRCAF"
    },
    {
     "description": "GUARDIAN CAPITAL GRP LTD",
     "symbol": "GRCGF"
    },
    {
     "description": "GRACELL BIOTECHNOLOGIES-ADR",
     "symbol": "GRCL"
    },
    {
     "description": "GRAINCORP LTD-A",
     "symbol": "GRCLF"
    },
    {
     "description": "GREENBELT RESOURCES CORP",
     "symbol": "GRCO"
    },
    {
     "description": "GREEN CURES AND BOTANICAL DI",
     "symbol": "GRCU"
    },
    {
     "description": "GREENCITY ACQUISITION CORP",
     "symbol": "GRCY"
    },
    {
     "description": "GREENCITY ACQUISITION CORP",
     "symbol": "GRCYU"
    },
    {
     "description": "GREENCITY ACQUISITION -CW",
     "symbol": "GRCYW"
    },
    {
     "description": "GRAND CITY PROPERTIES-ADR",
     "symbol": "GRDDY"
    },
    {
     "description": "GRINDROD LTD-UNSPON ADR",
     "symbol": "GRDLY"
    },
    {
     "description": "GROUNDSTAR RES LTD",
     "symbol": "GRDSF"
    },
    {
     "description": "GIORDANO INTERNATIONAL LTD",
     "symbol": "GRDZF"
    },
    {
     "description": "GREENIDGE GENERATION HOLDING",
     "symbol": "GREE"
    },
    {
     "description": "GREEN REIT PLC",
     "symbol": "GREEF"
    },
    {
     "description": "GREENIDGE GEN HLD INC",
     "symbol": "GREEL"
    },
    {
     "description": "GOLDMAN SACHS FUT REAL ESTAT",
     "symbol": "GREI"
    },
    {
     "description": "GLOBAL X MSCI GREECE ETF",
     "symbol": "GREK"
    },
    {
     "description": "GREENSMART CORP",
     "symbol": "GREN"
    },
    {
     "description": "IQ GLOBAL RESOURCES ETF",
     "symbol": "GRES"
    },
    {
     "description": "GREE INC",
     "symbol": "GREZF"
    },
    {
     "description": "EAGLE CAPITAL GROWTH FUND",
     "symbol": "GRF"
    },
    {
     "description": "CONCENTRADORA FIBRA DANHOS S",
     "symbol": "GRFFF"
    },
    {
     "description": "GRIFOLS SA-ADR",
     "symbol": "GRFS"
    },
    {
     "description": "GRAPHEX GROUP LTD",
     "symbol": "GRFXF"
    },
    {
     "description": "GRAPHEX GROUP LTD-SPON ADR",
     "symbol": "GRFXY"
    },
    {
     "description": "GEORGIA CAPITAL PLC",
     "symbol": "GRGCF"
    },
    {
     "description": "GREEN FOR ENERGY INC",
     "symbol": "GRGG"
    },
    {
     "description": "GREEN ENERGY RESOURCES INC",
     "symbol": "GRGR"
    },
    {
     "description": "GRIEG SEAFOOD ASA",
     "symbol": "GRGSF"
    },
    {
     "description": "GRAINGER PLC",
     "symbol": "GRGTF"
    },
    {
     "description": "GRAND GULF ENERGY LTD",
     "symbol": "GRGUF"
    },
    {
     "description": "GOLD ROCK HOLDINGS INC",
     "symbol": "GRHI"
    },
    {
     "description": "GREEN HYGIENICS INC",
     "symbol": "GRHY"
    },
    {
     "description": "FIRST TRST NASD CL EDG SGIIF",
     "symbol": "GRID"
    },
    {
     "description": "MUSCLE MAKER INC",
     "symbol": "GRIL"
    },
    {
     "description": "GRINDROD SHIPPING HOLDINGS L",
     "symbol": "GRIN"
    },
    {
     "description": "OPAP SA",
     "symbol": "GRKZF"
    },
    {
     "description": "GREEN LEAF INNOVATIONS INC",
     "symbol": "GRLF"
    },
    {
     "description": "GREATLAND GOLD PLC",
     "symbol": "GRLGF"
    },
    {
     "description": "GREENLAND RESOURCES INC",
     "symbol": "GRLRF"
    },
    {
     "description": "GRILLIT INC",
     "symbol": "GRLT"
    },
    {
     "description": "GROUP ELEVEN RESOURCES CORP",
     "symbol": "GRLVF"
    },
    {
     "description": "GOLDRICH MINING CO",
     "symbol": "GRMC"
    },
    {
     "description": "GREENTOWN MANAGEMENT HOLDING",
     "symbol": "GRMHF"
    },
    {
     "description": "GARMIN LTD",
     "symbol": "GRMN"
    },
    {
     "description": "TPCO HOLDING CORP -CW26",
     "symbol": "GRMWF"
    },
    {
     "description": "GREMZ INC",
     "symbol": "GRMZF"
    },
    {
     "description": "IPATH SERIES B CARBON ETN",
     "symbol": "GRN"
    },
    {
     "description": "GREENLIGHT BIOSCIENCES HOLDI",
     "symbol": "GRNA"
    },
    {
     "description": "GREENLIGHT BIOSCIENCES -CW27",
     "symbol": "GRNAW"
    },
    {
     "description": "VANECK GREEN BOND ETF",
     "symbol": "GRNB"
    },
    {
     "description": "GREENBANK CAPITAL INC",
     "symbol": "GRNBF"
    },
    {
     "description": "GRN HOLDING CORPORATION",
     "symbol": "GRNF"
    },
    {
     "description": "GREENGRO TECHNOLOGIES INC",
     "symbol": "GRNH"
    },
    {
     "description": "GREENLITE VENTURES INC",
     "symbol": "GRNL"
    },
    {
     "description": "GRAND CITY PROPERTIES",
     "symbol": "GRNNF"
    },
    {
     "description": "GREEN OASIS ENVIRONMENTAL",
     "symbol": "GRNO"
    },
    {
     "description": "GREENPRO CAPITAL CORP",
     "symbol": "GRNQ"
    },
    {
     "description": "GLOBAL X GREEN BUILDING ETF",
     "symbol": "GRNR"
    },
    {
     "description": "IPATH GLOBAL CARBON ETN",
     "symbol": "GRNTF"
    },
    {
     "description": "GREENLANE RENEWABLES INC",
     "symbol": "GRNWF"
    },
    {
     "description": "GREENORGANCIDUTCHMANHOL-CW22",
     "symbol": "GRODF"
    },
    {
     "description": "PETROTARG AB",
     "symbol": "GROLF"
    },
    {
     "description": "GROM SOCIAL ENTERPRISES INC",
     "symbol": "GROM"
    },
    {
     "description": "GROM SOCIAL ENTERPRISE -CW28",
     "symbol": "GROMW"
    },
    {
     "description": "GRAFTON GROUP PLC-UTS -CDI",
     "symbol": "GROUF"
    },
    {
     "description": "U.S. GLOBAL INVESTORS INC-A",
     "symbol": "GROW"
    },
    {
     "description": "GOLD ROYALTY CORP",
     "symbol": "GROY"
    },
    {
     "description": "GOLD ROYALTY CORP -CW27",
     "symbol": "GROY.WS"
    },
    {
     "description": "GRANITE REAL ESTATE INVESTME",
     "symbol": "GRP.U"
    },
    {
     "description": "GRUPO AEROMEXICO SAB DE CV",
     "symbol": "GRPAF"
    },
    {
     "description": "GRUPO LALA SAB DE CV",
     "symbol": "GRPBF"
    },
    {
     "description": "GRAPHENE NANOCHEM PLC",
     "symbol": "GRPEF"
    },
    {
     "description": "GRUPO TELEVISA SAB-SER CPO",
     "symbol": "GRPFF"
    },
    {
     "description": "GRAPHITE BIO INC",
     "symbol": "GRPH"
    },
    {
     "description": "PERSONA RECORDS INC",
     "symbol": "GRPI"
    },
    {
     "description": "GROUPON INC",
     "symbol": "GRPN"
    },
    {
     "description": "GRUPO TRAXION SAB DE CV",
     "symbol": "GRPOF"
    },
    {
     "description": "GRUPO ROTOPLAS SAB DE CV",
     "symbol": "GRPRF"
    },
    {
     "description": "GOLD RIVER PRODUCTIONS INC",
     "symbol": "GRPS"
    },
    {
     "description": "GETLINK SE",
     "symbol": "GRPTF"
    },
    {
     "description": "GETLINK SE - UNS ADR",
     "symbol": "GRPTY"
    },
    {
     "description": "GREENPLEX SERVICES INC",
     "symbol": "GRPX"
    },
    {
     "description": "GRANDSOUTH BANCORPORATION",
     "symbol": "GRRB"
    },
    {
     "description": "GrandSouth Bancorporation SC",
     "symbol": "GRRBP"
    },
    {
     "description": "GRANDVISION NV",
     "symbol": "GRRDF"
    },
    {
     "description": "GRANGE RESOURCES LTD",
     "symbol": "GRRLF"
    },
    {
     "description": "GERRESHEIMER AG",
     "symbol": "GRRMF"
    },
    {
     "description": "GRANITE BROADCASTING CORP",
     "symbol": "GRRP"
    },
    {
     "description": "GREATER THAN AB",
     "symbol": "GRRTF"
    },
    {
     "description": "GREENCASTLE RESOURCES LTD",
     "symbol": "GRSFF"
    },
    {
     "description": "GR SILVER MINING LTD",
     "symbol": "GRSLF"
    },
    {
     "description": "GROW SOLUTIONS HOLDINGS INC",
     "symbol": "GRSO"
    },
    {
     "description": "ETHEMA HEALTH CORP",
     "symbol": "GRST"
    },
    {
     "description": "GRASIM INDUSTRIES-SPON GDR",
     "symbol": "GRSXY"
    },
    {
     "description": "GRIFFIN RLTY TRUST INC",
     "symbol": "GRTA"
    },
    {
     "description": "GRIFFIN RLTY TRUST IN-AA",
     "symbol": "GRTAA"
    },
    {
     "description": "GREENTOWN SERVICE GROUP CO L",
     "symbol": "GRTNF"
    },
    {
     "description": "GRITSTONE BIO INC",
     "symbol": "GRTS"
    },
    {
     "description": "GRIFFIN RLTY TRUST INC COM-T",
     "symbol": "GRTT"
    },
    {
     "description": "GALERA THERAPEUTICS INC",
     "symbol": "GRTX"
    },
    {
     "description": "GUARANTY CORP-CL A",
     "symbol": "GRTYA"
    },
    {
     "description": "ELEMENTS ICE EXTRA GRAINS TO",
     "symbol": "GRU"
    },
    {
     "description": "GRUPO RESILIENT INTERNATIONA",
     "symbol": "GRUI"
    },
    {
     "description": "FNAC DARTY SA",
     "symbol": "GRUPF"
    },
    {
     "description": "GROWN ROGUE INTERNATIONAL IN",
     "symbol": "GRUSF"
    },
    {
     "description": "GROOVE BOTANICALS INC",
     "symbol": "GRVE"
    },
    {
     "description": "GROVE INC",
     "symbol": "GRVI"
    },
    {
     "description": "GREATVIEW ASEPTIC PACKAGING",
     "symbol": "GRVWF"
    },
    {
     "description": "GRAVITY CO LTD-SPONSORED ADR",
     "symbol": "GRVY"
    },
    {
     "description": "GROW CAPITAL INC",
     "symbol": "GRWC"
    },
    {
     "description": "GROWGENERATION CORP",
     "symbol": "GRWG"
    },
    {
     "description": "Great West Lifeco Inc",
     "symbol": "GRWLF"
    },
    {
     "description": "Great West Lifeco Inc",
     "symbol": "GRWTF"
    },
    {
     "description": "GREAT WALL PAN ASIA HOLDINGS",
     "symbol": "GRWWF"
    },
    {
     "description": "MOLTEN VENTURES PLC",
     "symbol": "GRWXF"
    },
    {
     "description": "GABELLI HEALTHCARE&WELLNESS",
     "symbol": "GRX"
    },
    {
     "description": "MARVEL GOLD LTD",
     "symbol": "GRXMF"
    },
    {
     "description": "AUSTRALIAN GOLDFIELDS LTD",
     "symbol": "GRXXF"
    },
    {
     "description": "GRAYCLIFF EXPLORATION LTD",
     "symbol": "GRYCF"
    },
    {
     "description": "AU MIN AFRICA PTY LTD",
     "symbol": "GRYEF"
    },
    {
     "description": "GREEN ENERGY GROUP INC",
     "symbol": "GRYG"
    },
    {
     "description": "GREEN HYGIENICS HOLDINGS INC",
     "symbol": "GRYN"
    },
    {
     "description": "GEO ENERGY RESOURCES LTD",
     "symbol": "GRYRF"
    },
    {
     "description": "GRIZZLE GROWTH ETF",
     "symbol": "GRZZ"
    },
    {
     "description": "Grizzly Energy LLC",
     "symbol": "GRZZP"
    },
    {
     "description": "GRIZZLY ENERGY LLC-SER C UNT",
     "symbol": "GRZZU"
    },
    {
     "description": "GOLDMAN SACHS GROUP INC",
     "symbol": "GS"
    },
    {
     "description": "GOLDMAN SACHS GROUP INC",
     "symbol": "GS.PRA"
    },
    {
     "description": "GOLDMAN SACHS GROUP INC",
     "symbol": "GS.PRC"
    },
    {
     "description": "GOLDMAN SACHS GROUP INC",
     "symbol": "GS.PRD"
    },
    {
     "description": "GOLDMAN SACHS GROUP INC",
     "symbol": "GS.PRJ"
    },
    {
     "description": "GOLDMAN SACHS GROUP INC",
     "symbol": "GS.PRK"
    },
    {
     "description": "GRUPO SIMEC S.A.-SER B",
     "symbol": "GSABF"
    },
    {
     "description": "GELSTAT CORP",
     "symbol": "GSAC"
    },
    {
     "description": "GLOBAL SYNERGY ACQUISITION-A",
     "symbol": "GSAQ"
    },
    {
     "description": "GLOBAL SYNERGY ACQUISITION C",
     "symbol": "GSAQU"
    },
    {
     "description": "GLOBAL SYNERGY ACQUIS -CW27",
     "symbol": "GSAQW"
    },
    {
     "description": "GLOBALSTAR INC",
     "symbol": "GSAT"
    },
    {
     "description": "GREAT SOUTHERN BANCORP INC",
     "symbol": "GSBC"
    },
    {
     "description": "GOLDMAN SACHS BDC INC",
     "symbol": "GSBD"
    },
    {
     "description": "GOLDEN STATE BANCORP",
     "symbol": "GSBX"
    },
    {
     "description": "Gatsby Digital Inc Series Seed Preferred Ps3",
     "symbol": "GSBYP"
    },
    {
     "description": "IONEER LTD",
     "symbol": "GSCCF"
    },
    {
     "description": "GS CONNECT S&P GSCI ENH COMM",
     "symbol": "GSCE"
    },
    {
     "description": "GOLDSANDS DEVELOPMENT CO",
     "symbol": "GSDC"
    },
    {
     "description": "GSDT FINTECH GROUP INC",
     "symbol": "GSDT"
    },
    {
     "description": "GOLDMAN SACHS MARKETBETA EME",
     "symbol": "GSEE"
    },
    {
     "description": "COVIVIO",
     "symbol": "GSEFF"
    },
    {
     "description": "GOLDMAN ACTIVEBTA EUR EQ ETF",
     "symbol": "GSEU"
    },
    {
     "description": "GORES HOLDINGS VII INC-A",
     "symbol": "GSEV"
    },
    {
     "description": "GORES HOLDINGS VII INC",
     "symbol": "GSEVU"
    },
    {
     "description": "GORES HOLDINGS VII A -CW27",
     "symbol": "GSEVW"
    },
    {
     "description": "GOLDMAN SACHS EQL WGHT LARGE",
     "symbol": "GSEW"
    },
    {
     "description": "GLOBAL SEAFOOD TECHNOLOGIES",
     "symbol": "GSFD"
    },
    {
     "description": "GREEN STREAM HOLDINGS INC",
     "symbol": "GSFI"
    },
    {
     "description": "GS FUTURE PLANET EQUITY ETF",
     "symbol": "GSFP"
    },
    {
     "description": "ISHARES S&P GSCI COMMODITY I",
     "symbol": "GSG"
    },
    {
     "description": "GENSIGHT BIOLOGICS SA",
     "symbol": "GSGTF"
    },
    {
     "description": "GOOSEHEAD INSURANCE INC -A",
     "symbol": "GSHD"
    },
    {
     "description": "GUSHEN INC",
     "symbol": "GSHN"
    },
    {
     "description": "GOLDSHORE RESOURCES INC",
     "symbol": "GSHRF"
    },
    {
     "description": "GOLDMAN SACHS MARKETBETA INT",
     "symbol": "GSID"
    },
    {
     "description": "GOLDMAN SACHS ACTIVEBETA INT",
     "symbol": "GSIE"
    },
    {
     "description": "GOLDMAN SACHS ACCESS INVESTM",
     "symbol": "GSIG"
    },
    {
     "description": "GENERAL STEEL HOLDINGS INC",
     "symbol": "GSIH"
    },
    {
     "description": "GENERAL STORE INTL CORP\/THE",
     "symbol": "GSIL"
    },
    {
     "description": "GENESIS MINERALS LTD",
     "symbol": "GSISF"
    },
    {
     "description": "GSI TECHNOLOGY INC",
     "symbol": "GSIT"
    },
    {
     "description": "GOLDMAN ACTIVEBETA JP EQ ETF",
     "symbol": "GSJY"
    },
    {
     "description": "GLAXOSMITHKLINE PLC-SPON ADR",
     "symbol": "GSK"
    },
    {
     "description": "GOLDSEEK RESOURCES INC",
     "symbol": "GSKKF"
    },
    {
     "description": "GLOBAL SHIP LEASE INC-CL A",
     "symbol": "GSL"
    },
    {
     "description": "GLOBAL SHIP LEASE INC",
     "symbol": "GSL.PRB"
    },
    {
     "description": "GOLDMAN ACTIVEBETA US LC ETF",
     "symbol": "GSLC"
    },
    {
     "description": "GLOBAL SHIP LEASE INC",
     "symbol": "GSLD"
    },
    {
     "description": "GREEN SCIENTIFIC LABS HOLDIN",
     "symbol": "GSLLF"
    },
    {
     "description": "GO SOLAR USA INC",
     "symbol": "GSLO"
    },
    {
     "description": "FERROGLOBE PLC",
     "symbol": "GSM"
    },
    {
     "description": "GLORY STAR NEW MEDIA GROUP H",
     "symbol": "GSMG"
    },
    {
     "description": "INDIANA RESOURCES LTD",
     "symbol": "GSMGF"
    },
    {
     "description": "GLORY STAR NEW -CW25",
     "symbol": "GSMGW"
    },
    {
     "description": "G&S MINERALS INC",
     "symbol": "GSML"
    },
    {
     "description": "GLOBAL ESCIENCE CORP",
     "symbol": "GSNC"
    },
    {
     "description": "IPATH GSCI TOTAL RETURN INDX",
     "symbol": "GSP"
    },
    {
     "description": "GULFSLOPE ENERGY INC",
     "symbol": "GSPE"
    },
    {
     "description": "GEOSPATIAL CORP",
     "symbol": "GSPH"
    },
    {
     "description": "GREEN STAR PRODUCTS INC",
     "symbol": "GSPI"
    },
    {
     "description": "GOLDEN STAR ENTERPRISES LTD",
     "symbol": "GSPT"
    },
    {
     "description": "GOTHAM ENHANCED 500 ETF",
     "symbol": "GSPY"
    },
    {
     "description": "G SQUARED ASCEND II INC -A",
     "symbol": "GSQB"
    },
    {
     "description": "G SQUARED ASCEND II INC",
     "symbol": "GSQB.U"
    },
    {
     "description": "G SQUARED ASCEND II -CW26",
     "symbol": "GSQB.WS"
    },
    {
     "description": "G SQUARED ASCEND I INC-CL A",
     "symbol": "GSQD"
    },
    {
     "description": "G SQUARED ASCEND I INC",
     "symbol": "GSQD.U"
    },
    {
     "description": "G SQUARED ASCEND I -CW27",
     "symbol": "GSQD.WS"
    },
    {
     "description": "GSP RESOURCE CORP",
     "symbol": "GSRCF"
    },
    {
     "description": "GSR II METEORA ACQUISIT-CL A",
     "symbol": "GSRM"
    },
    {
     "description": "GSR II METEORA ACQUISIT -RTS",
     "symbol": "GSRMR"
    },
    {
     "description": "GSR II METEORA ACQUISITION C",
     "symbol": "GSRMU"
    },
    {
     "description": "GSR II METEORA ACQ -CW23",
     "symbol": "GSRMW"
    },
    {
     "description": "GSRX INDUSTRIES INC",
     "symbol": "GSRX"
    },
    {
     "description": "GOLDMAN SACHS ACTIVEBETA US",
     "symbol": "GSSC"
    },
    {
     "description": "FIDELITY EMERGING MARKETS LT",
     "symbol": "GSSPF"
    },
    {
     "description": "GOSSAN RESOURCES",
     "symbol": "GSSRF"
    },
    {
     "description": "GOLDMAN SACHS ACCESS U\/SHORT",
     "symbol": "GSST"
    },
    {
     "description": "GLOBESTAR THERAPEUTICS CORP",
     "symbol": "GSTC"
    },
    {
     "description": "GREYSTONE DIGITAL TECHNOLOGY",
     "symbol": "GSTN"
    },
    {
     "description": "GRAPHENE & SOLAR TECH LTD",
     "symbol": "GSTX"
    },
    {
     "description": "GOLDMAN SACHS MARKETBETA US",
     "symbol": "GSUS"
    },
    {
     "description": "GOLDEN SUN MINING CORP",
     "symbol": "GSUXF"
    },
    {
     "description": "GOLD STANDARD VENTURES CORP",
     "symbol": "GSV"
    },
    {
     "description": "GSV INC",
     "symbol": "GSVI"
    },
    {
     "description": "GUANAJUATO SILVER CO LTD",
     "symbol": "GSVRF"
    },
    {
     "description": "INVESCO ULTRA SHORT DURATION",
     "symbol": "GSY"
    },
    {
     "description": "GOODYEAR TIRE & RUBBER CO",
     "symbol": "GT"
    },
    {
     "description": "GLOBAL TECHNOLOGY ACQUISIT-A",
     "symbol": "GTAC"
    },
    {
     "description": "GLOBAL TECHNOLOGY ACQUISITIO",
     "symbol": "GTACU"
    },
    {
     "description": "GLOBAL TECHNOLOGY ACQ -CW23",
     "symbol": "GTACW"
    },
    {
     "description": "GOLDEN TAG RESOURCES",
     "symbol": "GTAGF"
    },
    {
     "description": "GREEN THUMB INDUSTRIES INC",
     "symbol": "GTBIF"
    },
    {
     "description": "GT BIOPHARMA INC",
     "symbol": "GTBP"
    },
    {
     "description": "GETTY COPPER INC",
     "symbol": "GTCDF"
    },
    {
     "description": "GBT TECHNOLOGIES INC",
     "symbol": "GTCH"
    },
    {
     "description": "GEORGETOWN CORP",
     "symbol": "GTCP"
    },
    {
     "description": "GRAN TIERRA ENERGY INC",
     "symbol": "GTE"
    },
    {
     "description": "GREENLAND TECHNOLOGIES HOLDI",
     "symbol": "GTEC"
    },
    {
     "description": "GREENLAND TECHNOLOGIES-CW23",
     "symbol": "GTECW"
    },
    {
     "description": "GENTECH HOLDINGS INC",
     "symbol": "GTEH"
    },
    {
     "description": "GS FUTURE TECH LEADERS EQ",
     "symbol": "GTEK"
    },
    {
     "description": "GATES INDUSTRIAL CORP PLC",
     "symbol": "GTES"
    },
    {
     "description": "G2 TECHNOLOGIES CORP",
     "symbol": "GTGEF"
    },
    {
     "description": "GLOBAL TECHNOLOGIES GROUP",
     "symbol": "GTGP"
    },
    {
     "description": "GTG VENTURES INC",
     "symbol": "GTGT"
    },
    {
     "description": "GENETRON HOLDINGS LTD-ADR",
     "symbol": "GTH"
    },
    {
     "description": "GENESIS TECHNOLOGY INC",
     "symbol": "GTHDF"
    },
    {
     "description": "GENTING HONG KONG LTD",
     "symbol": "GTHKF"
    },
    {
     "description": "GT CAPITAL HOLDINGS INC",
     "symbol": "GTHOF"
    },
    {
     "description": "GUIDED THERAPEUTICS INC",
     "symbol": "GTHP"
    },
    {
     "description": "GENETHERA INC",
     "symbol": "GTHR"
    },
    {
     "description": "G1 THERAPEUTICS INC",
     "symbol": "GTHX"
    },
    {
     "description": "GLOBAL TECH INDUSTRIES GROUP",
     "symbol": "GTII"
    },
    {
     "description": "GOOD TIMES RESTAURANTS INC",
     "symbol": "GTIM"
    },
    {
     "description": "GOLDMAN SACHS ACCESS INFLATI",
     "symbol": "GTIP"
    },
    {
     "description": "GATEKEEPER USA INC",
     "symbol": "GTKP"
    },
    {
     "description": "GT LEGEND AUTOMOTIVE HOLDING",
     "symbol": "GTLA"
    },
    {
     "description": "GITLAB INC-CL A",
     "symbol": "GTLB"
    },
    {
     "description": "GLOBAL TECHNOLOGIES LTD",
     "symbol": "GTLL"
    },
    {
     "description": "CHART INDUSTRIES INC",
     "symbol": "GTLS"
    },
    {
     "description": "GRUPO TMM SA-SER A",
     "symbol": "GTMAF"
    },
    {
     "description": "GRUPO TMM SA-SP ADR A",
     "symbol": "GTMAY"
    },
    {
     "description": "GLOBE TELECOM INC",
     "symbol": "GTMEF"
    },
    {
     "description": "GLOBE TELECOM INC-UNSP ADR",
     "symbol": "GTMEY"
    },
    {
     "description": "GASTEM INC",
     "symbol": "GTMIF"
    },
    {
     "description": "GIANT MANUFACTURING",
     "symbol": "GTMUF"
    },
    {
     "description": "GRAY TELEVISION INC",
     "symbol": "GTN"
    },
    {
     "description": "GRAY TELEVISION INC-A",
     "symbol": "GTN.A"
    },
    {
     "description": "GTN LTD",
     "symbol": "GTNLF"
    },
    {
     "description": "INVESCO TOTAL RETURN BOND ET",
     "symbol": "GTO"
    },
    {
     "description": "GOTO GOJEK TOKOPEDIA TBK PT",
     "symbol": "GTOFF"
    },
    {
     "description": "GGTOOR INC",
     "symbol": "GTOR"
    },
    {
     "description": "GORES TECHNOLOGY PARTNERS-A",
     "symbol": "GTPA"
    },
    {
     "description": "GORES TECHNOLOGY PARTNERS IN",
     "symbol": "GTPAU"
    },
    {
     "description": "GORES TECH PARTN CL A -CW27",
     "symbol": "GTPAW"
    },
    {
     "description": "GORES TECHNOLOGY PRTNR II-A",
     "symbol": "GTPB"
    },
    {
     "description": "GORES TECHNOLOGY PARTNERS II",
     "symbol": "GTPBU"
    },
    {
     "description": "GORES TECH PARTN II A -CW27",
     "symbol": "GTPBW"
    },
    {
     "description": "GREAT AMERICAN BANCORP INC",
     "symbol": "GTPS"
    },
    {
     "description": "WISDOMTREE TARGET RANGE FUND",
     "symbol": "GTR"
    },
    {
     "description": "GTI RESOURCES LTD",
     "symbol": "GTRIF"
    },
    {
     "description": "GET REAL USA INC",
     "symbol": "GTRL"
    },
    {
     "description": "GETSWIFT TECHNOLOGIES LTD",
     "symbol": "GTSWF"
    },
    {
     "description": "GATTACA PLC",
     "symbol": "GTTCF"
    },
    {
     "description": "GTJ REIT INC",
     "symbol": "GTTJ"
    },
    {
     "description": "GTT COMMUNICATIONS INC",
     "symbol": "GTTNQ"
    },
    {
     "description": "GOLDEN TRIANGLE VENTURES,INC",
     "symbol": "GTVH"
    },
    {
     "description": "JOWAY HEALTH INDUSTRIES GROU",
     "symbol": "GTVI"
    },
    {
     "description": "GREENTOWN CHINA HOLDINGS",
     "symbol": "GTWCF"
    },
    {
     "description": "GARRETT MOTION INC",
     "symbol": "GTX"
    },
    {
     "description": "GARRETT MOTION INC",
     "symbol": "GTXAP"
    },
    {
     "description": "GTX CORP",
     "symbol": "GTXO"
    },
    {
     "description": "GETTY REALTY CORP",
     "symbol": "GTY"
    },
    {
     "description": "GTY TECHNOLOGY HOLDINGS INC",
     "symbol": "GTYH"
    },
    {
     "description": "GTY GOVTECH INC",
     "symbol": "GTYHW"
    },
    {
     "description": "GUARANTY BANCORP INC",
     "symbol": "GUAA"
    },
    {
     "description": "G.U.D. HOLDINGS LTD-UNSP ADR",
     "symbol": "GUDDY"
    },
    {
     "description": "G.U.D. HOLDINGS LTD",
     "symbol": "GUDHF"
    },
    {
     "description": "GUERBET",
     "symbol": "GUERF"
    },
    {
     "description": "GUESTLOGIX INC",
     "symbol": "GUESF"
    },
    {
     "description": "GRUPO FAMSA SAB-A",
     "symbol": "GUFAF"
    },
    {
     "description": "GUGGENHEIM ACTIVE ALLOCATION",
     "symbol": "GUG"
    },
    {
     "description": "GULF KEYSTONE PETROLEUM LTD",
     "symbol": "GUKYF"
    },
    {
     "description": "GUILD ESPORTS PLC",
     "symbol": "GULDF"
    },
    {
     "description": "GUOCO GROUP LTD",
     "symbol": "GULRF"
    },
    {
     "description": "GUOCO GROUP LTD-UNSPON ADR",
     "symbol": "GULRY"
    },
    {
     "description": "GULF COAST ULTRA DEEP ROYALT",
     "symbol": "GULTU"
    },
    {
     "description": "GUMI INC",
     "symbol": "GUMIF"
    },
    {
     "description": "GUNGHO ONLINE ENTERTAINMENT",
     "symbol": "GUNGF"
    },
    {
     "description": "FLEXSHARES GLOBAL UPSTREAM N",
     "symbol": "GUNR"
    },
    {
     "description": "GUNOSY INC",
     "symbol": "GUNYF"
    },
    {
     "description": "GUOLIAN SECURITIES CO LTD-H",
     "symbol": "GUONF"
    },
    {
     "description": "GUOTAI JUNAN SECURITIES CO-H",
     "symbol": "GUOSF"
    },
    {
     "description": "GULF RESOURCES INC",
     "symbol": "GURE"
    },
    {
     "description": "GURUNAVI INC",
     "symbol": "GURNF"
    },
    {
     "description": "GURU ORGANIC ENERGY CORP",
     "symbol": "GUROF"
    },
    {
     "description": "GLOBAL X GURU INDEX ETF",
     "symbol": "GURU"
    },
    {
     "description": "GOLDMAN SACHS MARKETBETA US",
     "symbol": "GUSA"
    },
    {
     "description": "DIREXION DAILY S&P OIL & GAS",
     "symbol": "GUSH"
    },
    {
     "description": "GABELLI UTILITY TRUST",
     "symbol": "GUT"
    },
    {
     "description": "GABELLI UTILITY TRUST",
     "symbol": "GUT.PRC"
    },
    {
     "description": "G2 GOLDFIELDS INC",
     "symbol": "GUYGF"
    },
    {
     "description": "GRUPO HERDEZ SAB-SERIES *",
     "symbol": "GUZOF"
    },
    {
     "description": "GRANITE CONSTRUCTION INC",
     "symbol": "GVA"
    },
    {
     "description": "CAMBRIA GLOBAL VALUE ETF",
     "symbol": "GVAL"
    },
    {
     "description": "GREEN VISOR FINANCIAL TECH-A",
     "symbol": "GVCI"
    },
    {
     "description": "GREEN VISOR FINANCIAL TECHNO",
     "symbol": "GVCIU"
    },
    {
     "description": "GREEN VISOR FIN TECH -CW23",
     "symbol": "GVCIW"
    },
    {
     "description": "GIVAUDAN-REG",
     "symbol": "GVDBF"
    },
    {
     "description": "GOLDEN VALLEY DEVELOPMENT",
     "symbol": "GVDI"
    },
    {
     "description": "GIVAUDAN-UNSPON ADR",
     "symbol": "GVDNY"
    },
    {
     "description": "GREENVILLE FEDERAL FINANCIAL",
     "symbol": "GVFF"
    },
    {
     "description": "GEROVA FINANCIAL GROUP LTD",
     "symbol": "GVFG"
    },
    {
     "description": "GEROVA FINANCIAL GROUP-UNIT",
     "symbol": "GVFGU"
    },
    {
     "description": "GLOBAL VISION HOLDINGS INC",
     "symbol": "GVHIB"
    },
    {
     "description": "ISHARES INTERMEDIATE GOVERNM",
     "symbol": "GVI"
    },
    {
     "description": "GOLD SACHS HEDGE IND VIP ETF",
     "symbol": "GVIP"
    },
    {
     "description": "GREENVALE MINING LTD",
     "symbol": "GVLMF"
    },
    {
     "description": "GREENVALE MINING-UNSP ADR",
     "symbol": "GVLMY"
    },
    {
     "description": "GSE SYSTEMS INC",
     "symbol": "GVP"
    },
    {
     "description": "GOOD VIBRATIONS SHOES INC",
     "symbol": "GVSI"
    },
    {
     "description": "GOVIEX URANIUM INC",
     "symbol": "GVXXF"
    },
    {
     "description": "GOLDEN VALLEY BANCSHARES INC",
     "symbol": "GVYB"
    },
    {
     "description": "GREENWAVE TECHNOLOGY SOLUTIO",
     "symbol": "GWAV"
    },
    {
     "description": "GWA GROUP LTD",
     "symbol": "GWAXF"
    },
    {
     "description": "GWA GROUP LTD -UNSPON ADR",
     "symbol": "GWAXY"
    },
    {
     "description": "GATEWAY BANK FSB",
     "symbol": "GWBK"
    },
    {
     "description": "GLOW ENERGY PCL - FOREIGN",
     "symbol": "GWEFF"
    },
    {
     "description": "GWG HOLDINGS INC",
     "symbol": "GWGH"
    },
    {
     "description": "ESS TECH INC",
     "symbol": "GWH"
    },
    {
     "description": "ESS TECH INC        -CW27",
     "symbol": "GWH.WS"
    },
    {
     "description": "GLOBAL WHOLEHEALTH PARTNERS",
     "symbol": "GWHP"
    },
    {
     "description": "GOOD WORKS II ACQUISITION CO",
     "symbol": "GWII"
    },
    {
     "description": "GOOD WORKS II ACQUISITION CW",
     "symbol": "GWIIW"
    },
    {
     "description": "GLORYWIN ENTERTAINMENT GROUP",
     "symbol": "GWIN"
    },
    {
     "description": "GREAT WESTERN IRON ORE PROPE",
     "symbol": "GWIO"
    },
    {
     "description": "GREAT-WEST LIFECO INC",
     "symbol": "GWLIF"
    },
    {
     "description": "GREAT WALL MOTOR COMPANY-H",
     "symbol": "GWLLF"
    },
    {
     "description": "GREAT WALL MOTOR CO-UNS ADR",
     "symbol": "GWLLY"
    },
    {
     "description": "Great West Lifeco Inc",
     "symbol": "GWLPF"
    },
    {
     "description": "GREAT WESTERN MINERALS GROUP",
     "symbol": "GWMGF"
    },
    {
     "description": "GOLDWIN INC",
     "symbol": "GWNCF"
    },
    {
     "description": "GOODHEART-WILLCOX CO INC",
     "symbol": "GWOX"
    },
    {
     "description": "WHOLEHEALTH PRODUCTS INC",
     "symbol": "GWPC"
    },
    {
     "description": "GP SOLUTIONS INC",
     "symbol": "GWPD"
    },
    {
     "description": "GUIDEWIRE SOFTWARE INC",
     "symbol": "GWRE"
    },
    {
     "description": "ENGOLD MINES LTD",
     "symbol": "GWRRF"
    },
    {
     "description": "GLOBAL WATER RESOURCES INC",
     "symbol": "GWRS"
    },
    {
     "description": "GOWEST GOLD LTD",
     "symbol": "GWSAF"
    },
    {
     "description": "GLOBAL WELLNESS STRATEGIES I",
     "symbol": "GWSFF"
    },
    {
     "description": "GULF WEST SECURITY NETWORK I",
     "symbol": "GWSND"
    },
    {
     "description": "GLOBAL WARMING SOLUTIONS INC",
     "symbol": "GWSO"
    },
    {
     "description": "GREENWAY TECHNOLOGIES INC",
     "symbol": "GWTI"
    },
    {
     "description": "GLOBAL WATER TECHNOLOGIES IN",
     "symbol": "GWTR"
    },
    {
     "description": "WW GRAINGER INC",
     "symbol": "GWW"
    },
    {
     "description": "GROWTHPOINT PROPERTIES LTD",
     "symbol": "GWWTF"
    },
    {
     "description": "SPDR S&P INTL SMALL CAP",
     "symbol": "GWX"
    },
    {
     "description": "GATEWAY GARAGE PARTNERS LLC",
     "symbol": "GWYGU"
    },
    {
     "description": "GENOWAY SA",
     "symbol": "GWYNF"
    },
    {
     "description": "GREENWAY TECHNOLOGY",
     "symbol": "GWYT"
    },
    {
     "description": "SPDR S&P CHINA ETF",
     "symbol": "GXC"
    },
    {
     "description": "GLOBAL X CHINA CLEAN ENE-USD",
     "symbol": "GXCCF"
    },
    {
     "description": "GLOBAL X MSCI COLOMBIA ETF",
     "symbol": "GXG"
    },
    {
     "description": "GX ACQUISITION CORP II-A",
     "symbol": "GXII"
    },
    {
     "description": "GX ACQUISITION CORP II",
     "symbol": "GXIIU"
    },
    {
     "description": "GX ACQUISITION II A -CW28",
     "symbol": "GXIIW"
    },
    {
     "description": "GRAYSCALE STELLAR LUMENS TRU",
     "symbol": "GXLM"
    },
    {
     "description": "INTERCONTINENTAL GOLD AND ME",
     "symbol": "GXMLF"
    },
    {
     "description": "GXO LOGISTICS INC",
     "symbol": "GXO"
    },
    {
     "description": "PROSPERA ENERGY INC",
     "symbol": "GXRFF"
    },
    {
     "description": "GEOX SPA",
     "symbol": "GXSBF"
    },
    {
     "description": "GEOX SPA-UNSPONSORED ADR",
     "symbol": "GXSBY"
    },
    {
     "description": "GOLDSOURCE MINES INC",
     "symbol": "GXSFF"
    },
    {
     "description": "GLOBAL X THEMATIC GROWTH ETF",
     "symbol": "GXTG"
    },
    {
     "description": "GUARDIAN EXPLORATION INC",
     "symbol": "GXUSF"
    },
    {
     "description": "GOLD BASIN RESOURCES CORP",
     "symbol": "GXXFF"
    },
    {
     "description": "GEX MANAGEMENT INC",
     "symbol": "GXXM"
    },
    {
     "description": "GALEXXY HOLDINGS INC",
     "symbol": "GXXY"
    },
    {
     "description": "GALAXY ENTERTAINMENT GROUP L",
     "symbol": "GXYEF"
    },
    {
     "description": "GALAXY ENTERTAINMEN-UNSP ADR",
     "symbol": "GXYYY"
    },
    {
     "description": "GUYANA GOLD CORP",
     "symbol": "GYGC"
    },
    {
     "description": "ARROW DOW JONES GLOBAL YIELD",
     "symbol": "GYLD"
    },
    {
     "description": "GUYANA GOLDSTRIKE INC",
     "symbol": "GYNAF"
    },
    {
     "description": "GREEN ENERGY ENTERPRISES INC",
     "symbol": "GYOG"
    },
    {
     "description": "GRYPHON GOLD CORP",
     "symbol": "GYPHQ"
    },
    {
     "description": "GYP PROPERTIES LTD",
     "symbol": "GYPPF"
    },
    {
     "description": "GYRODYNE LLC",
     "symbol": "GYRO"
    },
    {
     "description": "ECO ORO MINERALS CORP",
     "symbol": "GYSLF"
    },
    {
     "description": "GREYSON INTERNATIONAL INC",
     "symbol": "GYSN"
    },
    {
     "description": "GEYSER BRANDS INC",
     "symbol": "GYSRF"
    },
    {
     "description": "GRAYSTONE CO INC\/THE-A",
     "symbol": "GYST"
    },
    {
     "description": "GS YUASA CORP",
     "symbol": "GYUAF"
    },
    {
     "description": "GYM GROUP PLC\/THE",
     "symbol": "GYYMF"
    },
    {
     "description": "GASCOYNE RESOURCES LTD",
     "symbol": "GYYSF"
    },
    {
     "description": "GUOZI ZHONGYU CAPITAL HOLDIN",
     "symbol": "GZCC"
    },
    {
     "description": "GRIZZLY DISCOVERIES INC",
     "symbol": "GZDIF"
    },
    {
     "description": "GZ6G TECHNOLOGIES CORP",
     "symbol": "GZIC"
    },
    {
     "description": "YUEXIU TRANSPORT INFRASTRUCT",
     "symbol": "GZITF"
    },
    {
     "description": "GAZPROM NEFT-SPONSORED ADR",
     "symbol": "GZPFY"
    },
    {
     "description": "GUANGZHOU BAIYUNSHAN PHARM-H",
     "symbol": "GZPHF"
    },
    {
     "description": "GAZTRANSPORT ET TECHNIGA SA",
     "symbol": "GZPZF"
    },
    {
     "description": "GAZTRANSPORT ET TECHNIGA-ADR",
     "symbol": "GZPZY"
    },
    {
     "description": "GAZIT GLOBE LTD",
     "symbol": "GZTGF"
    },
    {
     "description": "GUANGZHOU R&F PROPERTIES - H",
     "symbol": "GZUHF"
    },
    {
     "description": "GUANGZHOU R&F PROP-H-UNS ADR",
     "symbol": "GZUHY"
    },
    {
     "description": "HYATT HOTELS CORP - CL A",
     "symbol": "H"
    },
    {
     "description": "HAWAIIAN HOLDINGS INC",
     "symbol": "HA"
    },
    {
     "description": "HEALTH ASSURANCE ACQUISIT-A",
     "symbol": "HAAC"
    },
    {
     "description": "HEALTH ASSURANCE ACQUISITION",
     "symbol": "HAACU"
    },
    {
     "description": "HEALTH ASSURANCE ACQU-CW25",
     "symbol": "HAACW"
    },
    {
     "description": "HAAD THIP PCL-NVDR",
     "symbol": "HAATF"
    },
    {
     "description": "HABERSHAM BANCORP",
     "symbol": "HABC"
    },
    {
     "description": "HAMILTON BANCORP INC",
     "symbol": "HABK"
    },
    {
     "description": "HACHIJUNI BANK LTD\/THE",
     "symbol": "HACBF"
    },
    {
     "description": "HACHIJUNI BANK LTD-UNS ADR",
     "symbol": "HACBY"
    },
    {
     "description": "ETFMG PRIME CYBER SECURITY E",
     "symbol": "HACK"
    },
    {
     "description": "HANISON CONSTRUCTION HOLDING",
     "symbol": "HACOF"
    },
    {
     "description": "HEALTH ADVANCE INC",
     "symbol": "HADV"
    },
    {
     "description": "HAEMONETICS CORP\/MASS",
     "symbol": "HAE"
    },
    {
     "description": "HANMI FINANCIAL CORPORATION",
     "symbol": "HAFC"
    },
    {
     "description": "HOLISTIC ASSET FINANCE GROUP",
     "symbol": "HAFG"
    },
    {
     "description": "HENSOLDT AG - UNSP ADR",
     "symbol": "HAGHY"
    },
    {
     "description": "HELP AT HOME INC",
     "symbol": "HAHI"
    },
    {
     "description": "HAREL INSURANCE INVESTMENTS",
     "symbol": "HAHRF"
    },
    {
     "description": "HEALTHCARE AI ACQUISITION -A",
     "symbol": "HAIA"
    },
    {
     "description": "HEALTHCARE AI ACQUISITION CO",
     "symbol": "HAIAU"
    },
    {
     "description": "HEALTHCARE AI ACQ -CW23",
     "symbol": "HAIAW"
    },
    {
     "description": "HAITIAN INTERNATIONAL HLDGS",
     "symbol": "HAIIF"
    },
    {
     "description": "SPDR S&P KENSHO SMART MOBILI",
     "symbol": "HAIL"
    },
    {
     "description": "HAIN CELESTIAL GROUP INC",
     "symbol": "HAIN"
    },
    {
     "description": "INFINYA LTD",
     "symbol": "HAIPF"
    },
    {
     "description": "HAITONG SECURITIES CO-UN ADR",
     "symbol": "HAITY"
    },
    {
     "description": "HAIVISION SYSTEMS INC",
     "symbol": "HAIVF"
    },
    {
     "description": "HALLIBURTON CO",
     "symbol": "HAL"
    },
    {
     "description": "HALBERD CORP",
     "symbol": "HALB"
    },
    {
     "description": "HAL TRUST",
     "symbol": "HALFF"
    },
    {
     "description": "HALLMARK FINL SERVICES INC",
     "symbol": "HALL"
    },
    {
     "description": "HALMA PLC - UNSPON ADR",
     "symbol": "HALMY"
    },
    {
     "description": "HALO COS INC",
     "symbol": "HALN"
    },
    {
     "description": "HALOZYME THERAPEUTICS INC",
     "symbol": "HALO"
    },
    {
     "description": "SILVER HAMMER MINING CORP",
     "symbol": "HAMRF"
    },
    {
     "description": "HANSTONE GOLD CORP",
     "symbol": "HANCF"
    },
    {
     "description": "HANNAN METALS LTD",
     "symbol": "HANNF"
    },
    {
     "description": "HALITRON INC",
     "symbol": "HAON"
    },
    {
     "description": "VANECK NATURAL RESOURCES ETF",
     "symbol": "HAP"
    },
    {
     "description": "HAPBEE TECHNOLOGIES-SUB VTG",
     "symbol": "HAPBF"
    },
    {
     "description": "HAPPINESS DEVELOPMENT GROU-A",
     "symbol": "HAPP"
    },
    {
     "description": "HARBOR CORP CULT LEADERS ETF",
     "symbol": "HAPY"
    },
    {
     "description": "HAPPINET CORP",
     "symbol": "HAPYF"
    },
    {
     "description": "HARLEYSVILLE FINANCIAL CORP",
     "symbol": "HARL"
    },
    {
     "description": "HARPOON THERAPEUTICS INC",
     "symbol": "HARP"
    },
    {
     "description": "IQ HEALTHY HEARTS ETF",
     "symbol": "HART"
    },
    {
     "description": "HASBRO INC",
     "symbol": "HAS"
    },
    {
     "description": "T HASEGAWA CO LTD",
     "symbol": "HASGF"
    },
    {
     "description": "HANNON ARMSTRONG SUSTAINABLE",
     "symbol": "HASI"
    },
    {
     "description": "HAUPPAUGE DIGITAL INC",
     "symbol": "HAUP"
    },
    {
     "description": "HOME APPRECIATION US REIT",
     "symbol": "HAUS"
    },
    {
     "description": "XTRACKERS INTL REAL ESTATE",
     "symbol": "HAUZ"
    },
    {
     "description": "HAVN LIFE SCIENCES INC",
     "symbol": "HAVLF"
    },
    {
     "description": "HAVAS SA",
     "symbol": "HAVSF"
    },
    {
     "description": "Hawaiian Electric Inc",
     "symbol": "HAWEL"
    },
    {
     "description": "Hawaiian Electric Inc",
     "symbol": "HAWEM"
    },
    {
     "description": "Hawaiian Electric Inc",
     "symbol": "HAWEN"
    },
    {
     "description": "Hawaiian Electric Inc",
     "symbol": "HAWLI"
    },
    {
     "description": "Hawaiian Electric Inc",
     "symbol": "HAWLL"
    },
    {
     "description": "Hawaiian Electric Inc",
     "symbol": "HAWLM"
    },
    {
     "description": "Hawaiian Electric Inc",
     "symbol": "HAWLN"
    },
    {
     "description": "HAW PAR CORP LTD",
     "symbol": "HAWPF"
    },
    {
     "description": "HAW PAR CORP LTD-UNSP ADR",
     "symbol": "HAWPY"
    },
    {
     "description": "HAWTHORN RESOURCES LTD",
     "symbol": "HAWWF"
    },
    {
     "description": "ISHARES CUR HDG MSCI ACWI-X",
     "symbol": "HAWX"
    },
    {
     "description": "HAYNES INTERNATIONAL INC",
     "symbol": "HAYN"
    },
    {
     "description": "HAYS PLC-UNSP ADR",
     "symbol": "HAYPY"
    },
    {
     "description": "HAYWARD HOLDINGS INC",
     "symbol": "HAYW"
    },
    {
     "description": "HAZAMA ANDO CORP",
     "symbol": "HAZAF"
    },
    {
     "description": "HAZ HOLDINGS INC",
     "symbol": "HAZH"
    },
    {
     "description": "HUNTINGTON BANCSHARES INC",
     "symbol": "HBAN"
    },
    {
     "description": "HUNTINGTON BANCSHARES",
     "symbol": "HBANM"
    },
    {
     "description": "HUNTINGTON BANCSHARES",
     "symbol": "HBANP"
    },
    {
     "description": "HORNBACH BAUMARKT AG",
     "symbol": "HBAUF"
    },
    {
     "description": "HAMILTON BEACH BRAND-A",
     "symbol": "HBB"
    },
    {
     "description": "HORNBACH HOLDING AG & CO KGA",
     "symbol": "HBBHF"
    },
    {
     "description": "BETAPRO GOLD BULLION 2X DAIL",
     "symbol": "HBCGF"
    },
    {
     "description": "HOME BANCORP INC",
     "symbol": "HBCP"
    },
    {
     "description": "HSBC HOLDINGS PLC",
     "symbol": "HBCYF"
    },
    {
     "description": "HONEY BADGER SILVER INC",
     "symbol": "HBEIF"
    },
    {
     "description": "ROYAL FOX GOLD INC",
     "symbol": "HBEXF"
    },
    {
     "description": "HONBRIDGE HOLDINGS LTD",
     "symbol": "HBGHF"
    },
    {
     "description": "HEIDELBERGER DRUCKMASCHINEN",
     "symbol": "HBGRF"
    },
    {
     "description": "HEIDELBERGER DRUC-UNSPON ADR",
     "symbol": "HBGRY"
    },
    {
     "description": "HANESBRANDS INC",
     "symbol": "HBI"
    },
    {
     "description": "HILLS BANCORP",
     "symbol": "HBIA"
    },
    {
     "description": "HAI JIA INTERNATIONAL LTD",
     "symbol": "HBIE"
    },
    {
     "description": "HARVARD BIOSCIENCE INC",
     "symbol": "HBIO"
    },
    {
     "description": "HOME BISTRO INC",
     "symbol": "HBIS"
    },
    {
     "description": "HIGHBANK RESOURCES LTD",
     "symbol": "HBKRF"
    },
    {
     "description": "HUDBAY MINERALS INC",
     "symbol": "HBM"
    },
    {
     "description": "HBM HEALTHCARE IVST-A",
     "symbol": "HBMBF"
    },
    {
     "description": "HBM HOLDINGS LTD",
     "symbol": "HBMHF"
    },
    {
     "description": "HUBEI MINKANG PHARMACEUTICAL",
     "symbol": "HBMK"
    },
    {
     "description": "HORIZON BANCORP INC\/IN",
     "symbol": "HBNC"
    },
    {
     "description": "BETAPRO NATURAL GAS INVERSE",
     "symbol": "HBNNF"
    },
    {
     "description": "HARBORSIDE INC",
     "symbol": "HBORF"
    },
    {
     "description": "EASTWEST BIOSCIENCE INC",
     "symbol": "HBOSF"
    },
    {
     "description": "HUTTIG BUILDING PRODUCTS INC",
     "symbol": "HBP"
    },
    {
     "description": "HELIX BIOPHARMA CORP",
     "symbol": "HBPCF"
    },
    {
     "description": "HBP ENERGY CORP",
     "symbol": "HBPE"
    },
    {
     "description": "HARBOUR ENERGY PLC-SPON ADR",
     "symbol": "HBRIY"
    },
    {
     "description": "HERBORIUM GROUP INC",
     "symbol": "HBRM"
    },
    {
     "description": "HIGHLANDS BANKSHARES INC",
     "symbol": "HBSI"
    },
    {
     "description": "HBT FINANCIAL INC\/DE",
     "symbol": "HBT"
    },
    {
     "description": "HARBOURTON CAPITAL GROUP INC",
     "symbol": "HBTC"
    },
    {
     "description": "BETAPRO CR OIL INV LEV DLY",
     "symbol": "HBTPF"
    },
    {
     "description": "BOOT (HENRY) PLC",
     "symbol": "HBTSF"
    },
    {
     "description": "HUBILU VENTURE CORP",
     "symbol": "HBUV"
    },
    {
     "description": "HCA HEALTHCARE INC",
     "symbol": "HCA"
    },
    {
     "description": "HALO COLLECTIVE INC",
     "symbol": "HCANF"
    },
    {
     "description": "HEALTHCARE SERVICES ACQUI-A",
     "symbol": "HCAR"
    },
    {
     "description": "HEALTHCARE SERVICES ACQUISIT",
     "symbol": "HCARU"
    },
    {
     "description": "HEALTHCARE SERVICES -CW27",
     "symbol": "HCARW"
    },
    {
     "description": "HEALTH CATALYST INC",
     "symbol": "HCAT"
    },
    {
     "description": "HIGH COUNTRY BANCORP INC",
     "symbol": "HCBC"
    },
    {
     "description": "HCB FINANCIAL CORP",
     "symbol": "HCBN"
    },
    {
     "description": "HARVEST COMMUNITY BANK",
     "symbol": "HCBP"
    },
    {
     "description": "WARRIOR MET COAL INC",
     "symbol": "HCC"
    },
    {
     "description": "HEALTHCARE CORP OF AMERICA",
     "symbol": "HCCA"
    },
    {
     "description": "HERITAGE-CRYSTAL CLEAN INC",
     "symbol": "HCCI"
    },
    {
     "description": "HARBOR CUSTOM DEVELOPMENT",
     "symbol": "HCDI"
    },
    {
     "description": "HARBOR CUSTOM DEV INC",
     "symbol": "HCDIP"
    },
    {
     "description": "HARBOR CUSTOM DEVEL -CW26",
     "symbol": "HCDIW"
    },
    {
     "description": "HARBOR CUSTOM DEV -CW26",
     "symbol": "HCDIZ"
    },
    {
     "description": "HEALTHY COFFEE INTL INC",
     "symbol": "HCEI"
    },
    {
     "description": "HUNTWICKE CAPITAL GROUP INC",
     "symbol": "HCGI"
    },
    {
     "description": "HAICHANG OCEAN PARK HOLDINGS",
     "symbol": "HCGOF"
    },
    {
     "description": "HIGHCOM GLOBAL SECURITY INC",
     "symbol": "HCGS"
    },
    {
     "description": "HOCHSCHILD MINING PLC",
     "symbol": "HCHDF"
    },
    {
     "description": "HOCHSCHILD MNG-UNSP ADR",
     "symbol": "HCHDY"
    },
    {
     "description": "HOTEL CHOCOLAT GROUP PLC",
     "symbol": "HCHOF"
    },
    {
     "description": "HCI GROUP INC",
     "symbol": "HCI"
    },
    {
     "description": "HENNESSY CAPITAL INVESTMEN-A",
     "symbol": "HCIC"
    },
    {
     "description": "HENNESSY CAPITAL INVESTMENT",
     "symbol": "HCICU"
    },
    {
     "description": "HENNESSY CAPITAL INVES-CW26",
     "symbol": "HCICW"
    },
    {
     "description": "HUDSON EXECUTIVE INVESTMENT",
     "symbol": "HCII"
    },
    {
     "description": "HUDSON EXECUTIVE INVESTMENT",
     "symbol": "HCIIU"
    },
    {
     "description": "HUDSON EXECUTIVE INV -CW27",
     "symbol": "HCIIW"
    },
    {
     "description": "HC GROUP INC",
     "symbol": "HCINF"
    },
    {
     "description": "HOCKING VALLEY BANCSHARES IN",
     "symbol": "HCKG"
    },
    {
     "description": "HACKETT GROUP INC\/THE",
     "symbol": "HCKT"
    },
    {
     "description": "HEALTH-CHEM CORP",
     "symbol": "HCLC"
    },
    {
     "description": "HOLISTA COLLTECH LTD",
     "symbol": "HCLHF"
    },
    {
     "description": "HUTCHMED CHINA-ADR",
     "symbol": "HCM"
    },
    {
     "description": "HCM ACQUISITION CORP-A",
     "symbol": "HCMA"
    },
    {
     "description": "HCM ACQUISITION CORP",
     "symbol": "HCMAU"
    },
    {
     "description": "HCM ACQUISITION CORP-A -CW27",
     "symbol": "HCMAW"
    },
    {
     "description": "HEALTHIER CHOICES MANAGEMENT",
     "symbol": "HCMC"
    },
    {
     "description": "HOLCIM LTD",
     "symbol": "HCMLF"
    },
    {
     "description": "HOLCIM LTD-UNS ADR",
     "symbol": "HCMLY"
    },
    {
     "description": "JAWS HURRICANE ACQUISITION-A",
     "symbol": "HCNE"
    },
    {
     "description": "JAWS HURRICANE ACQUISITON CO",
     "symbol": "HCNEU"
    },
    {
     "description": "JAWS HURRICANE ACQUISITI-CW",
     "symbol": "HCNEW"
    },
    {
     "description": "HARTFORD SCHRODERS COMMODITY",
     "symbol": "HCOM"
    },
    {
     "description": "HASHICORP INC-CL A",
     "symbol": "HCP"
    },
    {
     "description": "HOLCIM PHILIPPINES INC",
     "symbol": "HCPHF"
    },
    {
     "description": "HOLCIM PHILIPPINES-UNSP ADR",
     "symbol": "HCPHY"
    },
    {
     "description": "HARTFORD CORE BOND ETF",
     "symbol": "HCRB"
    },
    {
     "description": "HEALTHCARE SERVICES GROUP",
     "symbol": "HCSG"
    },
    {
     "description": "HC SURGICAL SPECIALISTS LTD",
     "symbol": "HCSPF"
    },
    {
     "description": "HEALTHCARE TRIANGLE INC",
     "symbol": "HCTI"
    },
    {
     "description": "HUTCHISON PORT HOLDINGS TR-U",
     "symbol": "HCTPF"
    },
    {
     "description": "HENNESSY CAPITAL INVEST-CL A",
     "symbol": "HCVI"
    },
    {
     "description": "HENNESSY CAPITAL INVESTMENT",
     "symbol": "HCVIU"
    },
    {
     "description": "HENNESSY CAPITAL INV A -CW27",
     "symbol": "HCVIW"
    },
    {
     "description": "HCW BIOLOGICS INC",
     "symbol": "HCWB"
    },
    {
     "description": "HOLY COW FOODS INC",
     "symbol": "HCWFF"
    },
    {
     "description": "HISCOX LTD",
     "symbol": "HCXLF"
    },
    {
     "description": "HISCOX LTD-UNSPONSORED ADR",
     "symbol": "HCXLY"
    },
    {
     "description": "HERCULES CAPITAL INC",
     "symbol": "HCXY"
    },
    {
     "description": "H-CYTE INC",
     "symbol": "HCYT"
    },
    {
     "description": "HOME DEPOT INC",
     "symbol": "HD"
    },
    {
     "description": "HAIDILAO INTERNATIONAL HOLDI",
     "symbol": "HDALF"
    },
    {
     "description": "XTRACKERS MSCI ALL WORLD EX",
     "symbol": "HDAW"
    },
    {
     "description": "HDFC BANK LTD-ADR",
     "symbol": "HDB"
    },
    {
     "description": "XTRACKERS MSCI EAFE HIGH DIV",
     "symbol": "HDEF"
    },
    {
     "description": "HEIDELBERGCEMENT AG-UNSP ADR",
     "symbol": "HDELY"
    },
    {
     "description": "PROSHARES HEDGE REPLICAT ETF",
     "symbol": "HDG"
    },
    {
     "description": "ADVISORSHARES RANGER EQ BEAR",
     "symbol": "HDGE"
    },
    {
     "description": "HAYDALE GRAPHENE INDUSTRIES",
     "symbol": "HDGHF"
    },
    {
     "description": "H-D INTERNATIONAL HOLDING GR",
     "symbol": "HDIH"
    },
    {
     "description": "HYPERTENSION DIAGNOSTICS INC",
     "symbol": "HDII"
    },
    {
     "description": "ISH MSCI USA QLY DVD USD DIS",
     "symbol": "HDIQF"
    },
    {
     "description": "HARDWOODS DISTRIBUTION INC",
     "symbol": "HDIUF"
    },
    {
     "description": "QRAFT AI-ENHANCED US HIGH DI",
     "symbol": "HDIV"
    },
    {
     "description": "ETRACS 2X HI DIV L-VOL ETN-B",
     "symbol": "HDLB"
    },
    {
     "description": "HUB DEALS CORP",
     "symbol": "HDLS"
    },
    {
     "description": "FT HORIZON MGD VOL D INT ETF",
     "symbol": "HDMV"
    },
    {
     "description": "HOMECO DAILY NEEDS REIT",
     "symbol": "HDNRF"
    },
    {
     "description": "DEFIANCE NEXT GEN H2 ETF",
     "symbol": "HDRO"
    },
    {
     "description": "EPSILON HEALTHCARE LTD",
     "symbol": "HDRPF"
    },
    {
     "description": "HIGHLAND COPPER CO INC",
     "symbol": "HDRSF"
    },
    {
     "description": "HEALTHSPACE DATA SYSTEMS LTD",
     "symbol": "HDSLF"
    },
    {
     "description": "HUDSON TECHNOLOGIES INC",
     "symbol": "HDSN"
    },
    {
     "description": "HEADSTRONG GROUP INC",
     "symbol": "HDST"
    },
    {
     "description": "HUNTER DOUGLAS NV",
     "symbol": "HDUGF"
    },
    {
     "description": "HEADSUP ENTERTAINMENT INTERN",
     "symbol": "HDUP"
    },
    {
     "description": "ISHARES CORE HIGH DIVIDEND E",
     "symbol": "HDV"
    },
    {
     "description": "HENDERSON INV LTD-SPON ADR",
     "symbol": "HDVTY"
    },
    {
     "description": "HEALTH DISCOVERY CORP",
     "symbol": "HDVY"
    },
    {
     "description": "HYPERDYNAMICS CORP",
     "symbol": "HDYNQ"
    },
    {
     "description": "HAWAIIAN ELECTRIC INDS",
     "symbol": "HE"
    },
    {
     "description": "TURTLE BEACH CORP",
     "symbol": "HEAR"
    },
    {
     "description": "GLOBAL HELIUM CORP",
     "symbol": "HECOF"
    },
    {
     "description": "WISDOMTREE EUROPE HEDGED EQU",
     "symbol": "HEDJ"
    },
    {
     "description": "ISHARES CRNCY HEDGD MSCI EM",
     "symbol": "HEEM"
    },
    {
     "description": "H&E EQUIPMENT SERVICES INC",
     "symbol": "HEES"
    },
    {
     "description": "HARTFORD SCHRODERS ESG US EQ",
     "symbol": "HEET"
    },
    {
     "description": "ISHA CURR HEDGED MSCI EAFE",
     "symbol": "HEFA"
    },
    {
     "description": "SWAN HEDGED EQUITY US LG CAP",
     "symbol": "HEGD"
    },
    {
     "description": "HENGAN INTL GROUP CO LTD",
     "symbol": "HEGIF"
    },
    {
     "description": "HENGAN INTL GROUP-UNSPON ADR",
     "symbol": "HEGIY"
    },
    {
     "description": "PEAK MINERALS LTD",
     "symbol": "HEGLF"
    },
    {
     "description": "HELLENIC EXCHANGES - ATHENS",
     "symbol": "HEHSF"
    },
    {
     "description": "HEICO CORP",
     "symbol": "HEI"
    },
    {
     "description": "HEICO CORP-CLASS A",
     "symbol": "HEI.A"
    },
    {
     "description": "HEINEKEN NV-SPN ADR",
     "symbol": "HEINY"
    },
    {
     "description": "HEALTHIA LTD",
     "symbol": "HEITF"
    },
    {
     "description": "HEKTAR REAL ESTATE INVESTMEN",
     "symbol": "HEKRF"
    },
    {
     "description": "HELEN OF TROY LTD",
     "symbol": "HELE"
    },
    {
     "description": "HELLOFRESH SE - UNSP ADR",
     "symbol": "HELFY"
    },
    {
     "description": "HENKEL AG & CO KGAA",
     "symbol": "HELKF"
    },
    {
     "description": "HELVETIA HOLDING AG-REG",
     "symbol": "HELNF"
    },
    {
     "description": "WINSHEAR GOLD CORP",
     "symbol": "HELOF"
    },
    {
     "description": "FRANKLIN GENOMIC ADVANCEMENT",
     "symbol": "HELX"
    },
    {
     "description": "HEALTHMED SERVICES LTD",
     "symbol": "HEME"
    },
    {
     "description": "HEMP INC",
     "symbol": "HEMP"
    },
    {
     "description": "HERO TECHNOLOGIES INC",
     "symbol": "HENC"
    },
    {
     "description": "HENGDELI HOLDINGS LTD",
     "symbol": "HENGF"
    },
    {
     "description": "HENGDELI HOLDINGS-UNSPON ADR",
     "symbol": "HENGY"
    },
    {
     "description": "HINTO ENERGY INC",
     "symbol": "HENI"
    },
    {
     "description": "HENKEL AG & CO- SPONS ADR",
     "symbol": "HENKY"
    },
    {
     "description": "HENKEL AG & CO KGAA VOR-PREF",
     "symbol": "HENOF"
    },
    {
     "description": "HENKEL KGAA-SPONS ADR PFD",
     "symbol": "HENOY"
    },
    {
     "description": "H2O INNOVATION INC",
     "symbol": "HEOFF"
    },
    {
     "description": "HIGHWATER ETHANOL LLC-MMB UT",
     "symbol": "HEOL"
    },
    {
     "description": "HOLLY ENERGY PARTNERS LP",
     "symbol": "HEP"
    },
    {
     "description": "HEPION PHARMACEUTICALS INC",
     "symbol": "HEPA"
    },
    {
     "description": "D-MARKET ELECTRONIC SERV-ADR",
     "symbol": "HEPS"
    },
    {
     "description": "HORIZONS ENHANCE INCOME GOLD",
     "symbol": "HEPZF"
    },
    {
     "description": "JOHN HANCOCK HEDGED EQUITY &",
     "symbol": "HEQ"
    },
    {
     "description": "SIMPLIFY HEDGED EQUITY ETF",
     "symbol": "HEQT"
    },
    {
     "description": "FTAC HERA ACQUISITION CORP-A",
     "symbol": "HERA"
    },
    {
     "description": "FTAC HERA ACQUISITION CORP",
     "symbol": "HERAU"
    },
    {
     "description": "FTAC HERA ACQ CL A -CW27",
     "symbol": "HERAW"
    },
    {
     "description": "YASHENG GROUP",
     "symbol": "HERB"
    },
    {
     "description": "HERC PRODUCTS INC",
     "symbol": "HERC"
    },
    {
     "description": "PACER CASH COWS FUND OF FUND",
     "symbol": "HERD"
    },
    {
     "description": "RED OAK HEREFORD FARMS INC",
     "symbol": "HERF"
    },
    {
     "description": "GLOBAL X VIDEO GAMES& ESPORT",
     "symbol": "HERO"
    },
    {
     "description": "HERITAGE CANNABIS HOLDINGS C",
     "symbol": "HERTF"
    },
    {
     "description": "HEROUX-DEVTEK INC",
     "symbol": "HERXF"
    },
    {
     "description": "HESS CORP",
     "symbol": "HES"
    },
    {
     "description": "HERMES INTERNATIONAL",
     "symbol": "HESAF"
    },
    {
     "description": "HERMES INTL-UNSPONSORED ADR",
     "symbol": "HESAY"
    },
    {
     "description": "HEALTH SCIENCES GROUP INC",
     "symbol": "HESG"
    },
    {
     "description": "HESS MIDSTREAM LP - CLASS A",
     "symbol": "HESM"
    },
    {
     "description": "HOME ENERGY SAVINGS CORP",
     "symbol": "HESV"
    },
    {
     "description": "HEALTHWAREHOUSE.COM INC",
     "symbol": "HEWA"
    },
    {
     "description": "ISHARES CURR HDG MSCI CANADA",
     "symbol": "HEWC"
    },
    {
     "description": "ISHA HEDGED MSCI GERMANY",
     "symbol": "HEWG"
    },
    {
     "description": "ISHA CURR HEDGED MSCI JAPAN",
     "symbol": "HEWJ"
    },
    {
     "description": "ISHARES CURR HEDGED MSCI UK",
     "symbol": "HEWU"
    },
    {
     "description": "HELLENIC EXCHANGES-UNSP ADR",
     "symbol": "HEXEY"
    },
    {
     "description": "HEXIMA LTD",
     "symbol": "HEXMF"
    },
    {
     "description": "HEXO CORP",
     "symbol": "HEXO"
    },
    {
     "description": "HUNTINGTON EXPLORATION INC",
     "symbol": "HEXPF"
    },
    {
     "description": "ISHARES CURRENCY HEDGED MSCI",
     "symbol": "HEZU"
    },
    {
     "description": "NAVIGATOR GLOBAL INVESTMENTS",
     "symbol": "HFAHF"
    },
    {
     "description": "HFB FINANCIAL CORP",
     "symbol": "HFBA"
    },
    {
     "description": "HALL OF FAME BEVERAGES INC",
     "symbol": "HFBG"
    },
    {
     "description": "HARFORD BANK-ABERDEEN MD",
     "symbol": "HFBK"
    },
    {
     "description": "HOME FEDERAL BANCORP INC\/LA",
     "symbol": "HFBL"
    },
    {
     "description": "HF FOODS GROUP INC",
     "symbol": "HFFG"
    },
    {
     "description": "HARTFORD LARGE CAP GROWTH ET",
     "symbol": "HFGO"
    },
    {
     "description": "HANFENG EVERGREEN INC",
     "symbol": "HFGVF"
    },
    {
     "description": "HAFNIA LTD",
     "symbol": "HFIAF"
    },
    {
     "description": "HIGHLAND INCOME FUND",
     "symbol": "HFRO"
    },
    {
     "description": "HIGHLAND INCOME FUND",
     "symbol": "HFRO.PRA"
    },
    {
     "description": "HARTFORD GREAT HEALTH CORP",
     "symbol": "HFUS"
    },
    {
     "description": "HERITAGE FINANCIAL CORP",
     "symbol": "HFWA"
    },
    {
     "description": "IQ 50PCT HEDGED FTSE INT ETF",
     "symbol": "HFXI"
    },
    {
     "description": "HSBC MSCI WORLD UCITS ETF",
     "symbol": "HFZJF"
    },
    {
     "description": "HERITAGE GLOBAL INC",
     "symbol": "HGBL"
    },
    {
     "description": "HYDROGRAPH CLEAN POWER INC",
     "symbol": "HGCPF"
    },
    {
     "description": "HGCAPITAL TRUST PLC",
     "symbol": "HGCTF"
    },
    {
     "description": "SPAREBANK 1 HELGELAND",
     "symbol": "HGDPF"
    },
    {
     "description": "HUMANIGEN INC",
     "symbol": "HGEN"
    },
    {
     "description": "HARBOR ALL WEATHER-INFLA FOC",
     "symbol": "HGER"
    },
    {
     "description": "HIGHWAY 50 GOLD CORP",
     "symbol": "HGGCF"
    },
    {
     "description": "HHGREGG INC",
     "symbol": "HGGGQ"
    },
    {
     "description": "HIGHGOLD MINING INC",
     "symbol": "HGGOF"
    },
    {
     "description": "HIGH ARCTIC ENERGY SERVICES",
     "symbol": "HGHAF"
    },
    {
     "description": "POWER ASSETS HOLDINGS LTD",
     "symbol": "HGKGF"
    },
    {
     "description": "POWER ASSETS HLDGS-SPON ADR",
     "symbol": "HGKGY"
    },
    {
     "description": "HIGHLAND GLOBAL ALLOCATION",
     "symbol": "HGLB"
    },
    {
     "description": "HUNT GOLD CORP",
     "symbol": "HGLC"
    },
    {
     "description": "PATAGONIA GOLD CORP",
     "symbol": "HGLD"
    },
    {
     "description": "HARMONY GOLD MINING CO LTD",
     "symbol": "HGMCF"
    },
    {
     "description": "HORIZON GROUP PROPERTIES INC",
     "symbol": "HGPI"
    },
    {
     "description": "HARGREAVES SERVICES PLC",
     "symbol": "HGRVF"
    },
    {
     "description": "HUGOTON ROYALTY TRUST",
     "symbol": "HGTXU"
    },
    {
     "description": "HAGERTY INC-A",
     "symbol": "HGTY"
    },
    {
     "description": "ALDEL FINANCIAL CL A -CW27",
     "symbol": "HGTY.WS"
    },
    {
     "description": "HILTON GRAND VACATIONS INC",
     "symbol": "HGV"
    },
    {
     "description": "HAGIWARA ELECTRIC HOLDINGS",
     "symbol": "HGWEF"
    },
    {
     "description": "HOGY MEDICAL CO LTD",
     "symbol": "HGYMF"
    },
    {
     "description": "HONG YUAN HOLDING GROUP",
     "symbol": "HGYN"
    },
    {
     "description": "HARTALEGA HOLDINGS BHD",
     "symbol": "HHBHF"
    },
    {
     "description": "HH BIOTECHNOLOGY HOLDINGS CO",
     "symbol": "HHBT"
    },
    {
     "description": "HOWARD HUGHES CORP\/THE",
     "symbol": "HHC"
    },
    {
     "description": "HIGHLANDS REIT INC",
     "symbol": "HHDS"
    },
    {
     "description": "HER IMPORTS",
     "symbol": "HHER"
    },
    {
     "description": "HHG CAPITAL CORP",
     "symbol": "HHGC"
    },
    {
     "description": "HHG CAPITAL CORP-RTS",
     "symbol": "HHGCR"
    },
    {
     "description": "HHG CAPITAL CORP",
     "symbol": "HHGCU"
    },
    {
     "description": "HHG CAPITAL CORP -CW27",
     "symbol": "HHGCW"
    },
    {
     "description": "HAWAIIAN HOSPITALITY GROUP I",
     "symbol": "HHGI"
    },
    {
     "description": "ETFMG REAL ESTATE TECH ETF",
     "symbol": "HHH"
    },
    {
     "description": "37 CAPITAL INC",
     "symbol": "HHHEF"
    },
    {
     "description": "HUISEN HOUSEHOLD INTERNATION",
     "symbol": "HHIGF"
    },
    {
     "description": "DFCITY GROUP BHD- SPON ADR",
     "symbol": "HHKSY"
    },
    {
     "description": "HH&L ACQUISITION CO -CLASS A",
     "symbol": "HHLA"
    },
    {
     "description": "HH&L ACQUISITION CORP",
     "symbol": "HHLA.U"
    },
    {
     "description": "HH&L ACQUISITION -A -CW26",
     "symbol": "HHLA.WS"
    },
    {
     "description": "HOT CHILI LTD",
     "symbol": "HHLKF"
    },
    {
     "description": "Hardwood Holdings LLC",
     "symbol": "HHLLU"
    },
    {
     "description": "HANNANS LTD",
     "symbol": "HHNNF"
    },
    {
     "description": "HERALD HOLDINGS LTD",
     "symbol": "HHOLF"
    },
    {
     "description": "MOJAVE BRANDS INC",
     "symbol": "HHPHF"
    },
    {
     "description": "HEADHUNTER GROUP PLC-ADR",
     "symbol": "HHR"
    },
    {
     "description": "HARBOR STAR SHIPPING SERVICE",
     "symbol": "HHRRF"
    },
    {
     "description": "HARTE-HANKS INC",
     "symbol": "HHS"
    },
    {
     "description": "HANNOVER HOUSE INC",
     "symbol": "HHSE"
    },
    {
     "description": "HI HO SILVER RESOURCES INC",
     "symbol": "HHSRF"
    },
    {
     "description": "HUISHANG BANK CORP LTD-H",
     "symbol": "HHSSF"
    },
    {
     "description": "HAMBURGER HAFEN UND LOGISTIK",
     "symbol": "HHULF"
    },
    {
     "description": "HAMBURGER HAFEN UND-UNSP ADR",
     "symbol": "HHULY"
    },
    {
     "description": "HUA HONG SEMICONDUCTOR LTD",
     "symbol": "HHUSF"
    },
    {
     "description": "HILLENBRAND INC",
     "symbol": "HI"
    },
    {
     "description": "HIBBETT INC",
     "symbol": "HIBB"
    },
    {
     "description": "DIREXION DAILY S&P 500 HIGH",
     "symbol": "HIBL"
    },
    {
     "description": "HIBERNIA REIT PLC",
     "symbol": "HIBRF"
    },
    {
     "description": "DIREXION DAILY S&P 500 HIGH",
     "symbol": "HIBS"
    },
    {
     "description": "MILLER\/HOWARD HIGH INCOME EQ",
     "symbol": "HIE"
    },
    {
     "description": "HINGHAM INSTITUTION FOR SVGS",
     "symbol": "HIFS"
    },
    {
     "description": "HARTFORD FINANCIAL SVCS GRP",
     "symbol": "HIG"
    },
    {
     "description": "HARTFORD FINL SVCS GRP",
     "symbol": "HIG.PRG"
    },
    {
     "description": "HIG ACQUISITION CORP-CLASS A",
     "symbol": "HIGA"
    },
    {
     "description": "HIG ACQUISITION CORP",
     "symbol": "HIGA.U"
    },
    {
     "description": "HIG ACQUISITION CORP A -CW25",
     "symbol": "HIGA.WS"
    },
    {
     "description": "HI-GREAT GROUP HOLDING CO",
     "symbol": "HIGR"
    },
    {
     "description": "HOLIDAY ISLAND HOLDINGS INC",
     "symbol": "HIHI"
    },
    {
     "description": "HIGHWAY HOLDINGS LTD",
     "symbol": "HIHO"
    },
    {
     "description": "HUNTINGTON INGALLS INDUSTRIE",
     "symbol": "HII"
    },
    {
     "description": "HIDILI INDUSTRY-UNSPON ADR",
     "symbol": "HIIDY"
    },
    {
     "description": "HUDSON EXECUTIVE INVESTMEN-A",
     "symbol": "HIII"
    },
    {
     "description": "HUDSON EXECUTIV INV CORP III",
     "symbol": "HIIIU"
    },
    {
     "description": "HUDSON EXECUTIVE INV A -CW28",
     "symbol": "HIIIW"
    },
    {
     "description": "HILL INTERNATIONAL INC",
     "symbol": "HIL"
    },
    {
     "description": "HILLSTREAM BIOPHARMA INC",
     "symbol": "HILS"
    },
    {
     "description": "HOLLUND INDUSTRIAL MARINE",
     "symbol": "HIMR"
    },
    {
     "description": "HIMS & HERS HEALTH INC",
     "symbol": "HIMS"
    },
    {
     "description": "HIMAX TECHNOLOGIES INC-ADR",
     "symbol": "HIMX"
    },
    {
     "description": "HEINEKEN NV",
     "symbol": "HINKF"
    },
    {
     "description": "HINO MOTORS LTD",
     "symbol": "HINOF"
    },
    {
     "description": "HINO MOTORS LTD-UNSPON ADR",
     "symbol": "HINOY"
    },
    {
     "description": "HYPROP INVESTMENTS LTD",
     "symbol": "HINVF"
    },
    {
     "description": "WESTERN ASSET HI INC OPPORT",
     "symbol": "HIO"
    },
    {
     "description": "AMERICAN PREMIUM WATER CORP",
     "symbol": "HIPH"
    },
    {
     "description": "HIPPO HOLDINGS INC",
     "symbol": "HIPO"
    },
    {
     "description": "HIPPO HOLDINGS INC A-CW27",
     "symbol": "HIPO.WS"
    },
    {
     "description": "GRANITESHARES HIPS US HIGH I",
     "symbol": "HIPS"
    },
    {
     "description": "HIRE TECHNOLOGIES INC",
     "symbol": "HIRRF"
    },
    {
     "description": "HIRU CORP",
     "symbol": "HIRU"
    },
    {
     "description": "HISENSE HOME APPLIANCES GR-H",
     "symbol": "HISEF"
    },
    {
     "description": "FIRST TRUST EXCHANGE-TRADED",
     "symbol": "HISF"
    },
    {
     "description": "H I S CO LTD",
     "symbol": "HISJF"
    },
    {
     "description": "HI SUN TECHNOLOGY CHINA LTD",
     "symbol": "HISNF"
    },
    {
     "description": "HEALTHCARE INTEGRATED TECHNO",
     "symbol": "HITC"
    },
    {
     "description": "HOUSTON INTERWEB DESIGN INC",
     "symbol": "HITD"
    },
    {
     "description": "HIGH TIDE INC",
     "symbol": "HITI"
    },
    {
     "description": "HIGH TIDE INC -CW23",
     "symbol": "HITTF"
    },
    {
     "description": "HERO INTERNATIONAL USA HOLDI",
     "symbol": "HIUH"
    },
    {
     "description": "HIVE BLOCKCHAIN TECHNOLOGIES",
     "symbol": "HIVE"
    },
    {
     "description": "HIGHWOODS PROPERTIES INC",
     "symbol": "HIW"
    },
    {
     "description": "WESTERN ASSET HIGH INC II",
     "symbol": "HIX"
    },
    {
     "description": "Western Asset High Income Fund Ii Inc",
     "symbol": "HIX.RT"
    },
    {
     "description": "HITACHI ZOSEN CORP",
     "symbol": "HIZOF"
    },
    {
     "description": "DIREXION HYDROGEN ETF",
     "symbol": "HJEN"
    },
    {
     "description": "HANJIAO GROUP INC",
     "symbol": "HJGP"
    },
    {
     "description": "ISHARES CUR HEDG JPX-NIK 400",
     "symbol": "HJPX"
    },
    {
     "description": "FONDAK-A",
     "symbol": "HJVDF"
    },
    {
     "description": "HKBN LTD",
     "symbol": "HKBNF"
    },
    {
     "description": "HKBN LTD - UNSPON ADR",
     "symbol": "HKBNY"
    },
    {
     "description": "HK BATTERY TECHNOLOGY INC",
     "symbol": "HKBT"
    },
    {
     "description": "HAT TRICK BEVERAGES INC",
     "symbol": "HKBV"
    },
    {
     "description": "HK ELECTRIC INVESTMENTS -SS",
     "symbol": "HKCVF"
    },
    {
     "description": "AMTD DIGITAL INC",
     "symbol": "HKD"
    },
    {
     "description": "HONG KONG FOOD INVESTMENT HO",
     "symbol": "HKFIF"
    },
    {
     "description": "HONG KONG ECONOMIC TIMES HLD",
     "symbol": "HKGEF"
    },
    {
     "description": "HK GRAPHENE TECHNOLOGY CORP",
     "symbol": "HKGT"
    },
    {
     "description": "HONGKONG LAND HOLDINGS LTD",
     "symbol": "HKHGF"
    },
    {
     "description": "HEINEKEN HOLDING NV",
     "symbol": "HKHHF"
    },
    {
     "description": "HEINEKEN HOLDING NV-SPN ADR",
     "symbol": "HKHHY"
    },
    {
     "description": "HOKUHOKU FINANCIAL-UNSP ADR",
     "symbol": "HKHUY"
    },
    {
     "description": "HIKMA PHARMACEUTICALS PLC",
     "symbol": "HKMPF"
    },
    {
     "description": "HIKMA PHARMACEUTICAL-SPN ADR",
     "symbol": "HKMPY"
    },
    {
     "description": "HUMANKIND US STOCK ETF",
     "symbol": "HKND"
    },
    {
     "description": "HONGKONG & SHANGHAI HOTELS",
     "symbol": "HKSHF"
    },
    {
     "description": "HONGKONG & SHANGHAI-UNSP ADR",
     "symbol": "HKSHY"
    },
    {
     "description": "HIKARI TSUSHIN INC",
     "symbol": "HKTGF"
    },
    {
     "description": "HKT TRUST AND HKT LTD-SS",
     "symbol": "HKTTF"
    },
    {
     "description": "HKT TRUST AND HKT-UNSP ADR",
     "symbol": "HKTTY"
    },
    {
     "description": "HONG KONG TECHNOLOGY VEN-ADR",
     "symbol": "HKTVY"
    },
    {
     "description": "HAKUHODO DY HOLDINGS INC",
     "symbol": "HKUOF"
    },
    {
     "description": "HAKUHODO DY HOLDINGS-UNS ADR",
     "symbol": "HKUOY"
    },
    {
     "description": "HK ELECTRIC INVESTME-SP ADR",
     "symbol": "HKVTY"
    },
    {
     "description": "HONG KONG WINALITE GROUP INC",
     "symbol": "HKWO"
    },
    {
     "description": "HONG KONG EXCHANGES & CLEAR",
     "symbol": "HKXCF"
    },
    {
     "description": "HONG KONG EXCHANGES-UNSP ADR",
     "symbol": "HKXCY"
    },
    {
     "description": "HECLA MINING CO",
     "symbol": "HL"
    },
    {
     "description": "HECLA MINING CO",
     "symbol": "HL.PRB"
    },
    {
     "description": "HAPAG-LLOYD AG",
     "symbol": "HLAGF"
    },
    {
     "description": "HAMILTON LANE ALL-CLASS A",
     "symbol": "HLAH"
    },
    {
     "description": "HAMILTON LANE ALLIANCE HOLDI",
     "symbol": "HLAHU"
    },
    {
     "description": "HAMILTON LANE ALL-CLAS-CW26",
     "symbol": "HLAHW"
    },
    {
     "description": "WAHED FTSE USA SHARIAH ETF",
     "symbol": "HLAL"
    },
    {
     "description": "HEARTLAND BANCCORP",
     "symbol": "HLAN"
    },
    {
     "description": "HERON LAKE BIOENERGY LLC",
     "symbol": "HLBYL"
    },
    {
     "description": "HELBIZ INC",
     "symbol": "HLBZ"
    },
    {
     "description": "HEIDELBERGCEMENT AG",
     "symbol": "HLBZF"
    },
    {
     "description": "HELBIZ INC-CW24",
     "symbol": "HLBZW"
    },
    {
     "description": "HOLOCO INC",
     "symbol": "HLCN"
    },
    {
     "description": "HENDERSON LAND DEV-SPON ADR",
     "symbol": "HLDCY"
    },
    {
     "description": "HENDERSON LAND DEVELOPMENT",
     "symbol": "HLDVF"
    },
    {
     "description": "HELIOS ENERGY LTD",
     "symbol": "HLEGF"
    },
    {
     "description": "HERBALIFE NUTRITION LTD",
     "symbol": "HLF"
    },
    {
     "description": "HONG LEONG BANK BERHAD",
     "symbol": "HLFAF"
    },
    {
     "description": "HALFORDS GROUP PLC",
     "symbol": "HLFDF"
    },
    {
     "description": "HALFORDS GROUP PLC-UNS ADR",
     "symbol": "HLFDY"
    },
    {
     "description": "HELLOFRESH SE",
     "symbol": "HLFFF"
    },
    {
     "description": "HILTON FOOD GRP - UNSP ADR",
     "symbol": "HLFGY"
    },
    {
     "description": "HOME LOAN FINANCIAL CORP",
     "symbol": "HLFN"
    },
    {
     "description": "HAILIANG EDUCATION GROUP-ADR",
     "symbol": "HLG"
    },
    {
     "description": "HARTFORD LONGEVITY ECONOMY E",
     "symbol": "HLGE"
    },
    {
     "description": "HELIOGEN INC",
     "symbol": "HLGN"
    },
    {
     "description": "HELIOGEN INC -CW28",
     "symbol": "HLGN.WS"
    },
    {
     "description": "HILLGROVE RESOURCES LTD",
     "symbol": "HLGVF"
    },
    {
     "description": "HOLMEN AB-B SHARES UNSP ADR",
     "symbol": "HLHLY"
    },
    {
     "description": "HOULIHAN LOKEY INC",
     "symbol": "HLI"
    },
    {
     "description": "HELIOS TECHNOLOGIES INC",
     "symbol": "HLIO"
    },
    {
     "description": "HARMONIC INC",
     "symbol": "HLIT"
    },
    {
     "description": "HELLA GMBH & CO KGAA",
     "symbol": "HLKHF"
    },
    {
     "description": "PONTUS PROTEIN LTD",
     "symbol": "HLKKF"
    },
    {
     "description": "HALAL FINANCIAL SERVICES INC",
     "symbol": "HLLF"
    },
    {
     "description": "HELLA GMBH & CO-UNSP ADR R",
     "symbol": "HLLGY"
    },
    {
     "description": "HALLMARK VENTURE GROUP INC",
     "symbol": "HLLK"
    },
    {
     "description": "HELLO PAL INTERNATIONAL INC",
     "symbol": "HLLPF"
    },
    {
     "description": "HELLIX VENTURES INC",
     "symbol": "HLLXF"
    },
    {
     "description": "HOLLEY INC",
     "symbol": "HLLY"
    },
    {
     "description": "EMPOWER LTD-CLASS A -CW27",
     "symbol": "HLLY.WS"
    },
    {
     "description": "HALMA PLC",
     "symbol": "HLMAF"
    },
    {
     "description": "SWIFTSURE INTERNATIONAL INC",
     "symbol": "HLMB"
    },
    {
     "description": "HILLMAN SOLUTIONS CORP",
     "symbol": "HLMN"
    },
    {
     "description": "HOLMEN AB-A SHS-UNSPON ADR",
     "symbol": "HLMNY"
    },
    {
     "description": "HAMILTON LANE INC-CLASS A",
     "symbol": "HLNE"
    },
    {
     "description": "HIGH LINER FOODS INC",
     "symbol": "HLNFF"
    },
    {
     "description": "HELO CORP",
     "symbol": "HLOC"
    },
    {
     "description": "HELIUM ONE GLOBAL LTD-DI",
     "symbol": "HLOGF"
    },
    {
     "description": "PRIVESTO INTERNATIONAL HOLDI",
     "symbol": "HLOI"
    },
    {
     "description": "HEALIOS KK",
     "symbol": "HLOSF"
    },
    {
     "description": "HELLENIC PETROLEUM HOLDINGS",
     "symbol": "HLPMF"
    },
    {
     "description": "HANG LUNG PROPERTIES LTD",
     "symbol": "HLPPF"
    },
    {
     "description": "HANG LUNG PROPERTIES-SP ADR",
     "symbol": "HLPPY"
    },
    {
     "description": "HILLIARD CORP",
     "symbol": "HLRD"
    },
    {
     "description": "HILLCREST ENERGY TECHNOLOGIE",
     "symbol": "HLRTF"
    },
    {
     "description": "HELIOSPECTRA AB",
     "symbol": "HLSPF"
    },
    {
     "description": "HALLENSTEIN GLASSON HOLDINGS",
     "symbol": "HLSTF"
    },
    {
     "description": "HILTON WORLDWIDE HOLDINGS IN",
     "symbol": "HLT"
    },
    {
     "description": "HEALTHCARE TRUST INC",
     "symbol": "HLTC"
    },
    {
     "description": "HILAN LTD",
     "symbol": "HLTEF"
    },
    {
     "description": "HILTON FOOD GROUP  PLC",
     "symbol": "HLTFF"
    },
    {
     "description": "CUE HEALTH INC",
     "symbol": "HLTH"
    },
    {
     "description": "HELLENIC TELECOMMUN ORGANIZA",
     "symbol": "HLTOF"
    },
    {
     "description": "HELLENIC TELECOM ORG-SP ADR",
     "symbol": "HLTOY"
    },
    {
     "description": "HLS THERAPEUTICS INC",
     "symbol": "HLTRF"
    },
    {
     "description": "HEALTHTECH SOLUTIONS INC",
     "symbol": "HLTT"
    },
    {
     "description": "H LUNDBECK A\/S",
     "symbol": "HLUKF"
    },
    {
     "description": "HEALTHEUNIVERSE INC",
     "symbol": "HLUN"
    },
    {
     "description": "H LUNDBECK A\/S-SPN ADR",
     "symbol": "HLUYY"
    },
    {
     "description": "HELVETIA HOLDING AG-UNSP ADR",
     "symbol": "HLVTY"
    },
    {
     "description": "ALMOST NEVER FILMS INC",
     "symbol": "HLWD"
    },
    {
     "description": "HELIX ENERGY SOLUTIONS GROUP",
     "symbol": "HLX"
    },
    {
     "description": "HI-LEX CORP",
     "symbol": "HLXFF"
    },
    {
     "description": "HELIX WIND CORP",
     "symbol": "HLXW"
    },
    {
     "description": "HEALTHLYNKED CORP",
     "symbol": "HLYK"
    },
    {
     "description": "HEARTLAND MEDIA ACQUISITIO-A",
     "symbol": "HMA"
    },
    {
     "description": "HEARTLAND MEDIA ACQUISITION",
     "symbol": "HMA.U"
    },
    {
     "description": "HEARTLAND MEDIA ACQUISIT -27",
     "symbol": "HMA.WS"
    },
    {
     "description": "HOME24 SE",
     "symbol": "HMAGF"
    },
    {
     "description": "HAMBURG INDUSTRIES INC",
     "symbol": "HMBG"
    },
    {
     "description": "HUMBL INC",
     "symbol": "HMBL"
    },
    {
     "description": "HONDA MOTOR CO LTD-SPONS ADR",
     "symbol": "HMC"
    },
    {
     "description": "HOME CAPITAL GROUP INC",
     "symbol": "HMCBF"
    },
    {
     "description": "HUMANCO ACQUISITION COR-CL A",
     "symbol": "HMCO"
    },
    {
     "description": "HUMANCO ACQUISITION CORP",
     "symbol": "HMCOU"
    },
    {
     "description": "HUMANCO ACQ  CL A -CW27",
     "symbol": "HMCOW"
    },
    {
     "description": "HAINAN MEILAN INTERNATIONA-H",
     "symbol": "HMCTF"
    },
    {
     "description": "HAMMOND POWER SOLUTIONS INC",
     "symbol": "HMDPF"
    },
    {
     "description": "HEMISPHERE ENERGY CORP",
     "symbol": "HMENF"
    },
    {
     "description": "HEMAGEN DIAGNOSTICS INC",
     "symbol": "HMGN"
    },
    {
     "description": "HEMI ENERGY GROUP INC",
     "symbol": "HMGP"
    },
    {
     "description": "HARVEST MINERALS LTD",
     "symbol": "HMIFF"
    },
    {
     "description": "HOMELAND RESOURCES LTD",
     "symbol": "HMLA"
    },
    {
     "description": "HAMLIN BK & TR\/SMETHPORT PA",
     "symbol": "HMLN"
    },
    {
     "description": "HOEGH LNG PARTNERS LP",
     "symbol": "HMLP"
    },
    {
     "description": "HOEGH LNG PARTNERS LP",
     "symbol": "HMLP.PRA"
    },
    {
     "description": "HORIZONS MARIJUANA LIFE SCIE",
     "symbol": "HMLSF"
    },
    {
     "description": "HAMMER FIBER OPTICS HOLDINGS",
     "symbol": "HMMR"
    },
    {
     "description": "HORACE MANN EDUCATORS",
     "symbol": "HMN"
    },
    {
     "description": "HMN FINANCIAL INC",
     "symbol": "HMNF"
    },
    {
     "description": "HMS NETWORKS AB",
     "symbol": "HMNKF"
    },
    {
     "description": "HEMNET GROUP AB - ADR",
     "symbol": "HMNTY"
    },
    {
     "description": "HUMAN UNITEC INTERNATIONAL",
     "symbol": "HMNU"
    },
    {
     "description": "HELIOS AND MATHESON ANALYTIC",
     "symbol": "HMNY"
    },
    {
     "description": "HARTFORD MUNI OPPORTUNITY ET",
     "symbol": "HMOP"
    },
    {
     "description": "HEMPAMERICANA INC",
     "symbol": "HMPQ"
    },
    {
     "description": "HOME POINT CAPITAL INC",
     "symbol": "HMPT"
    },
    {
     "description": "HOME REIT PLC",
     "symbol": "HMRPF"
    },
    {
     "description": "HAMMER METALS LTD",
     "symbol": "HMRRF"
    },
    {
     "description": "HENNES & MAURITZ AB-B SHS",
     "symbol": "HMRZF"
    },
    {
     "description": "HMS INCOME FUND INC",
     "symbol": "HMSI"
    },
    {
     "description": "HAMMERSON PLC",
     "symbol": "HMSNF"
    },
    {
     "description": "HOMESTREET INC",
     "symbol": "HMST"
    },
    {
     "description": "HOMESERVE PLC",
     "symbol": "HMSVF"
    },
    {
     "description": "HOMESERVE PLC-UNSP ADR",
     "symbol": "HMSVY"
    },
    {
     "description": "HOMASOTE COMPANY",
     "symbol": "HMTC"
    },
    {
     "description": "HUMAN METABOLOME TECHNOLOGIE",
     "symbol": "HMTGF"
    },
    {
     "description": "HITACHI METALS LTD",
     "symbol": "HMTLF"
    },
    {
     "description": "HITACHI METALS LTD-UNSP ADR",
     "symbol": "HMTLY"
    },
    {
     "description": "HEMISPHERE MEDIA GROUP INC",
     "symbol": "HMTV"
    },
    {
     "description": "HEMOSTEMIX INC",
     "symbol": "HMTXF"
    },
    {
     "description": "HARMONY GOLD MNG-SPON ADR",
     "symbol": "HMY"
    },
    {
     "description": "HMZ METALS INC",
     "symbol": "HMZMF"
    },
    {
     "description": "GIGA METALS CORP",
     "symbol": "HNCKF"
    },
    {
     "description": "HONDA MOTOR CO LTD",
     "symbol": "HNDAF"
    },
    {
     "description": "HANDENI GOLD INC",
     "symbol": "HNDI"
    },
    {
     "description": "NASDAQ 7 HANDL INDEX ETF",
     "symbol": "HNDL"
    },
    {
     "description": "HANOVER FOODS CORP-CL A",
     "symbol": "HNFSA"
    },
    {
     "description": "HANOVER FOODS CORP-CL B",
     "symbol": "HNFSB"
    },
    {
     "description": "HG SEMICONDUCTOR LTD",
     "symbol": "HNGGF"
    },
    {
     "description": "HONGKONG LAND HLDGS-UNSP ADR",
     "symbol": "HNGKY"
    },
    {
     "description": "HANGER INC",
     "symbol": "HNGR"
    },
    {
     "description": "HON HAI PRECISION INDUSTRY",
     "symbol": "HNHAF"
    },
    {
     "description": "HON HAI PRECISION-GDR REG S",
     "symbol": "HNHPF"
    },
    {
     "description": "HNI CORP",
     "symbol": "HNI"
    },
    {
     "description": "HANG LUNG GROUP LTD",
     "symbol": "HNLGF"
    },
    {
     "description": "HANG LUNG GROUP LTD-SP ADR",
     "symbol": "HNLGY"
    },
    {
     "description": "HANA MICROELECTRONICS-NVDR",
     "symbol": "HNMUF"
    },
    {
     "description": "HENNESSY ADVISORS INC",
     "symbol": "HNNA"
    },
    {
     "description": "HENNESSY ADVISORS INC",
     "symbol": "HNNAZ"
    },
    {
     "description": "HENNES & MAURITZ AB-UNSP ADR",
     "symbol": "HNNMY"
    },
    {
     "description": "HNO INTERNATIONAL INC",
     "symbol": "HNOI"
    },
    {
     "description": "HARVEY NORMAN HOLDINGS LTD",
     "symbol": "HNORF"
    },
    {
     "description": "HARVEY NORMAN HLD-UNSPON ADR",
     "symbol": "HNORY"
    },
    {
     "description": "HUANENG POWER INTL-SPONS ADR",
     "symbol": "HNP"
    },
    {
     "description": "HNR ACQUISITION CORP",
     "symbol": "HNRA"
    },
    {
     "description": "HNR ACQUISITION CORP -CW23",
     "symbol": "HNRA.WS"
    },
    {
     "description": "HOUSTON NATIONAL RESOURCES C",
     "symbol": "HNRC"
    },
    {
     "description": "HANSARD GLOBAL PLC",
     "symbol": "HNRDF"
    },
    {
     "description": "HALLADOR ENERGY CO",
     "symbol": "HNRG"
    },
    {
     "description": "HANSA BIOPHARMA AB",
     "symbol": "HNSBF"
    },
    {
     "description": "HENSOLDT AG",
     "symbol": "HNSDF"
    },
    {
     "description": "HANSOH PHARMACEUTICAL GROUP",
     "symbol": "HNSPF"
    },
    {
     "description": "HONEST CO INC\/THE",
     "symbol": "HNST"
    },
    {
     "description": "CHINA RUYI HOLDINGS LTD",
     "symbol": "HNTGF"
    },
    {
     "description": "HIGH NORTH RESOURCES LTD",
     "symbol": "HNTHF"
    },
    {
     "description": "HUNTING PLC",
     "symbol": "HNTIF"
    },
    {
     "description": "HUNTING PLC-UNSP ADR",
     "symbol": "HNTIY"
    },
    {
     "description": "HUNTMOUNTAIN RESOURCES LTD",
     "symbol": "HNTM"
    },
    {
     "description": "BETAPRO NATURAL GAS LEVERAGE",
     "symbol": "HNUZF"
    },
    {
     "description": "PIONEER DIVERSIFIED HIGH INC",
     "symbol": "HNW"
    },
    {
     "description": "HANWA CO LTD",
     "symbol": "HNWAF"
    },
    {
     "description": "HANWEI ENERGY SERVICES CORP",
     "symbol": "HNWEF"
    },
    {
     "description": "HOCHTIEF AG",
     "symbol": "HOCFF"
    },
    {
     "description": "HONSHU CHEMICAL INDUSTRY CO",
     "symbol": "HOCMF"
    },
    {
     "description": "HOYA CORP",
     "symbol": "HOCPF"
    },
    {
     "description": "HOYA CORP-SPONSORED ADR",
     "symbol": "HOCPY"
    },
    {
     "description": "HOTELES CITY EXPRESS SAB DE",
     "symbol": "HOCXF"
    },
    {
     "description": "HOEGH AUTOLINERS ASA",
     "symbol": "HOEGF"
    },
    {
     "description": "HOFSETH BIOCARE ASA",
     "symbol": "HOFBF"
    },
    {
     "description": "HOUSE FOODS GROUP INC",
     "symbol": "HOFJF"
    },
    {
     "description": "HOOKER FURNISHINGS CORP",
     "symbol": "HOFT"
    },
    {
     "description": "HALL OF FAME RESORT & ENTERT",
     "symbol": "HOFV"
    },
    {
     "description": "HALL OF FAME RESORT -CW",
     "symbol": "HOFVW"
    },
    {
     "description": "HARLEY-DAVIDSON INC",
     "symbol": "HOG"
    },
    {
     "description": "HOSIDEN CORP",
     "symbol": "HOIEF"
    },
    {
     "description": "HUNTER TECHNOLOGY CORP",
     "symbol": "HOILF"
    },
    {
     "description": "HOUSE OF JANE INC",
     "symbol": "HOJI"
    },
    {
     "description": "HONG KONG & CHINA GAS",
     "symbol": "HOKCF"
    },
    {
     "description": "HONG KONG & CHINA GAS-SP ADR",
     "symbol": "HOKCY"
    },
    {
     "description": "HOKU CORP",
     "symbol": "HOKUQ"
    },
    {
     "description": "ADVISORSHARES NORTH SQUARE M",
     "symbol": "HOLD"
    },
    {
     "description": "HOLLYSYS AUTOMATION TECHNOLO",
     "symbol": "HOLI"
    },
    {
     "description": "HOLOGIC INC",
     "symbol": "HOLX"
    },
    {
     "description": "LIFEGOAL HOME DOWN PAYMENT I",
     "symbol": "HOM"
    },
    {
     "description": "HOME BANCSHARES INC",
     "symbol": "HOMB"
    },
    {
     "description": "Caliber Home Loans Inc",
     "symbol": "HOMS"
    },
    {
     "description": "Caliber Home Loans Inc",
     "symbol": "HOMS.PRA"
    },
    {
     "description": "HOUMU HOLDINGS LTD",
     "symbol": "HOMU"
    },
    {
     "description": "HOYA CAPITAL HOUSING ETF",
     "symbol": "HOMZ"
    },
    {
     "description": "HONEYWELL INTERNATIONAL INC",
     "symbol": "HON"
    },
    {
     "description": "HARBORONE BANCORP INC",
     "symbol": "HONE"
    },
    {
     "description": "HONAT BANCORP INC",
     "symbol": "HONT"
    },
    {
     "description": "HON KWOK LAND INVESTMENT",
     "symbol": "HONWF"
    },
    {
     "description": "HOLOBEAM INC",
     "symbol": "HOOB"
    },
    {
     "description": "ROBINHOOD MARKETS INC - A",
     "symbol": "HOOD"
    },
    {
     "description": "HOOKIPA PHARMA INC",
     "symbol": "HOOK"
    },
    {
     "description": "HOPE BANCORP INC",
     "symbol": "HOPE"
    },
    {
     "description": "HEMOGENYX PHARMACEUTICALS PL",
     "symbol": "HOPHF"
    },
    {
     "description": "EMERGING MARKETS HORIZON -A",
     "symbol": "HORI"
    },
    {
     "description": "EMERGING MARKETS HORIZON COR",
     "symbol": "HORIU"
    },
    {
     "description": "EMERGING MARKETS HORIZN-CW23",
     "symbol": "HORIW"
    },
    {
     "description": "HOSHINO RESORTS REIT INC",
     "symbol": "HOSHF"
    },
    {
     "description": "HACI OMER SABANCI HLDG-ADR",
     "symbol": "HOSXF"
    },
    {
     "description": "HOT MAMA'S FOODS INC",
     "symbol": "HOTF"
    },
    {
     "description": "HOTH THERAPEUTICS INC",
     "symbol": "HOTH"
    },
    {
     "description": "KELLY HOTEL & LODGING ETF",
     "symbol": "HOTL"
    },
    {
     "description": "HOUR LOOP INC",
     "symbol": "HOUR"
    },
    {
     "description": "HOVNANIAN ENTERPRISES-A",
     "symbol": "HOV"
    },
    {
     "description": "HOVNANIAN ENTERPRISES",
     "symbol": "HOVNP"
    },
    {
     "description": "HOVNANIAN ENTERPRISES-CL B",
     "symbol": "HOVVB"
    },
    {
     "description": "WEREWOLF THERAPEUTICS INC",
     "symbol": "HOWL"
    },
    {
     "description": "HOPEWELL HOLDINGS LTD",
     "symbol": "HOWWF"
    },
    {
     "description": "HUHTAMAKI OYJ",
     "symbol": "HOYFF"
    },
    {
     "description": "HELMERICH & PAYNE",
     "symbol": "HP"
    },
    {
     "description": "HOME PRODUCT CENTER PCL-FOR",
     "symbol": "HPCRF"
    },
    {
     "description": "HEWLETT PACKARD ENTERPRISE",
     "symbol": "HPE"
    },
    {
     "description": "JOHN HANCOCK PFD INCOME II",
     "symbol": "HPF"
    },
    {
     "description": "HAPAG-LLOYD AG-UNSPON ADR",
     "symbol": "HPGLY"
    },
    {
     "description": "HIPGNOSIS SONGS FUND LTD",
     "symbol": "HPGSF"
    },
    {
     "description": "HAMAMATSU PHOTONICS KK",
     "symbol": "HPHTF"
    },
    {
     "description": "HAMAMATSU PHOTONICS-UNSP ADR",
     "symbol": "HPHTY"
    },
    {
     "description": "JOHN HANCOCK PFD INCOME FD",
     "symbol": "HPI"
    },
    {
     "description": "HUADIAN POWER INTL CORP-H",
     "symbol": "HPIFF"
    },
    {
     "description": "HUADIAN POWER INTL-UNSP ADR",
     "symbol": "HPIFY"
    },
    {
     "description": "HPIL HOLDING",
     "symbol": "HPIL"
    },
    {
     "description": "HIGHPEAK ENERGY INC",
     "symbol": "HPK"
    },
    {
     "description": "HIGHPEAK ENERGY INC-CVR",
     "symbol": "HPKER"
    },
    {
     "description": "HIGHPEAK ENERGY INC",
     "symbol": "HPKEW"
    },
    {
     "description": "HOME PLATE ACQUISITION -CL A",
     "symbol": "HPLT"
    },
    {
     "description": "HOME PLATE ACQUISITION CORP",
     "symbol": "HPLTU"
    },
    {
     "description": "HOME PLATE ACQ -CW23",
     "symbol": "HPLTW"
    },
    {
     "description": "AFRICA ENERGY CORP",
     "symbol": "HPMCF"
    },
    {
     "description": "HEMP NATURALS INC",
     "symbol": "HPMM"
    },
    {
     "description": "HOP-ON INC",
     "symbol": "HPNN"
    },
    {
     "description": "HUDSON PACIFIC PROPERTIES IN",
     "symbol": "HPP"
    },
    {
     "description": "HUDSON PACIFIC PROPERTIE",
     "symbol": "HPP.PRC"
    },
    {
     "description": "HP INC",
     "symbol": "HPQ"
    },
    {
     "description": "HPQ-SILICON RESOURCES INC",
     "symbol": "HPQFF"
    },
    {
     "description": "JOHN HANCOCK PFD INCOME III",
     "symbol": "HPS"
    },
    {
     "description": "HEMPSTRACT INC",
     "symbol": "HPST"
    },
    {
     "description": "HORIZONS PSYCHEDELIC STOCK",
     "symbol": "HPSYF"
    },
    {
     "description": "HAPPY TOWN HOLDINGS INC",
     "symbol": "HPTN"
    },
    {
     "description": "HOPTO INC",
     "symbol": "HPTO"
    },
    {
     "description": "HEXAGON PURUS ASA",
     "symbol": "HPURF"
    },
    {
     "description": "HPX CORP-A",
     "symbol": "HPX"
    },
    {
     "description": "HPX CORP",
     "symbol": "HPX.U"
    },
    {
     "description": "HPX CORP-A -CW25",
     "symbol": "HPX.WS"
    },
    {
     "description": "HAPPY CREEK MINERALS LTD",
     "symbol": "HPYCF"
    },
    {
     "description": "HQDA ELDERLY LIFE NETWORK CO",
     "symbol": "HQDA"
    },
    {
     "description": "HQ GLOBAL EDUCATION INC",
     "symbol": "HQGE"
    },
    {
     "description": "TEKLA HEALTHCARE INVESTORS",
     "symbol": "HQH"
    },
    {
     "description": "HIREQUEST INC",
     "symbol": "HQI"
    },
    {
     "description": "TEKLA LIFE SCIENCES INVESTOR",
     "symbol": "HQL"
    },
    {
     "description": "HEALTHEQUITY INC",
     "symbol": "HQY"
    },
    {
     "description": "HEALTHCARE REALTY TRUST INC",
     "symbol": "HR"
    },
    {
     "description": "HEAR ATLAST HOLDINGS INC",
     "symbol": "HRAL"
    },
    {
     "description": "HERA SPA",
     "symbol": "HRASF"
    },
    {
     "description": "HABA LABORATORIES INC",
     "symbol": "HRATF"
    },
    {
     "description": "H&R BLOCK INC",
     "symbol": "HRB"
    },
    {
     "description": "HARBOR BANKSHARES CORP",
     "symbol": "HRBK"
    },
    {
     "description": "HARBOR DIVERSIFIED INC",
     "symbol": "HRBR"
    },
    {
     "description": "HERSHEY CREAMERY CO",
     "symbol": "HRCR"
    },
    {
     "description": "HURRICANE ENERGY PLC",
     "symbol": "HRCXF"
    },
    {
     "description": "PATERSON RESOURCES LTD",
     "symbol": "HRDDF"
    },
    {
     "description": "HERE MEDIA INC",
     "symbol": "HRDI"
    },
    {
     "description": "HERE MEDIA INC-SPL SHRS",
     "symbol": "HRDIL"
    },
    {
     "description": "STANS ENERGY CORP",
     "symbol": "HREEF"
    },
    {
     "description": "HARFANG EXPLORATION INC",
     "symbol": "HRFED"
    },
    {
     "description": "HERITAGE NOLA BANCSHARES INC",
     "symbol": "HRGG"
    },
    {
     "description": "HARGREAVES LANSDOWN PLC",
     "symbol": "HRGLF"
    },
    {
     "description": "HARGREAVES LANSDOW-UNSP ADR",
     "symbol": "HRGLY"
    },
    {
     "description": "HERC HOLDINGS INC",
     "symbol": "HRI"
    },
    {
     "description": "HORIBA LTD",
     "symbol": "HRIBF"
    },
    {
     "description": "REVOLUTION CO LTD",
     "symbol": "HRKKF"
    },
    {
     "description": "HORMEL FOODS CORP",
     "symbol": "HRL"
    },
    {
     "description": "HERON RESOURCES LTD",
     "symbol": "HRLDF"
    },
    {
     "description": "HARMONY BIOSCIENCES HOLDINGS",
     "symbol": "HRMY"
    },
    {
     "description": "HYDRO ONE LTD",
     "symbol": "HRNNF"
    },
    {
     "description": "HRNETGROUP LTD",
     "symbol": "HRNTF"
    },
    {
     "description": "HIROSE ELEC CO - UNSP ADR",
     "symbol": "HROEY"
    },
    {
     "description": "HIROGIN HOLDINGS INC",
     "symbol": "HROGF"
    },
    {
     "description": "HARROW HEALTH INC",
     "symbol": "HROW"
    },
    {
     "description": "HARROW HEALTH INC",
     "symbol": "HROWL"
    },
    {
     "description": "HERANTIS PHARMA OYJ",
     "symbol": "HRPMF"
    },
    {
     "description": "HORIZON BANCORP INC\/AZ",
     "symbol": "HRRB"
    },
    {
     "description": "Horsehead Holding LLC",
     "symbol": "HRRS"
    },
    {
     "description": "HIROSE ELECTRIC CO LTD",
     "symbol": "HRSEF"
    },
    {
     "description": "HAIER SMART HOME CO LTD-H",
     "symbol": "HRSHF"
    },
    {
     "description": "HORRISON RESOURCES INC",
     "symbol": "HRSR"
    },
    {
     "description": "HARVEST OIL & GAS CORP",
     "symbol": "HRST"
    },
    {
     "description": "HIRERIGHT HOLDINGS CORP",
     "symbol": "HRT"
    },
    {
     "description": "HARTE GOLD CORP",
     "symbol": "HRTFF"
    },
    {
     "description": "HERITAGE INSURANCE HOLDINGS",
     "symbol": "HRTG"
    },
    {
     "description": "HEART TRONICS INC",
     "symbol": "HRTT"
    },
    {
     "description": "HERON THERAPEUTICS INC",
     "symbol": "HRTX"
    },
    {
     "description": "H&R REAL ESTATE INV-REIT UTS",
     "symbol": "HRUFF"
    },
    {
     "description": "HARVIA OYJ",
     "symbol": "HRVFF"
    },
    {
     "description": "HARVEST ONE CANNABIS INC",
     "symbol": "HRVOF"
    },
    {
     "description": "HORIZON TECHNOLOGY FINANCE C",
     "symbol": "HRZN"
    },
    {
     "description": "HORIZONS S&P\/TSX 60 INDEX ET",
     "symbol": "HRZSF"
    },
    {
     "description": "HORIZONS ACTIVE GLOBAL DIVID",
     "symbol": "HRZZF"
    },
    {
     "description": "HEALTH SCIENCES ACQUISITIONS",
     "symbol": "HSAQ"
    },
    {
     "description": "HSBC HOLDINGS PLC-SPONS ADR",
     "symbol": "HSBC"
    },
    {
     "description": "HERITAGE SOUTHEAST BANCORPOR",
     "symbol": "HSBI"
    },
    {
     "description": "HARSCO CORP",
     "symbol": "HSC"
    },
    {
     "description": "HOMELAND SECURITY CORP",
     "symbol": "HSCC"
    },
    {
     "description": "SAWADA HOLDINGS CO LTD",
     "symbol": "HSCEF"
    },
    {
     "description": "H-SOURCE HOLDINGS LTD",
     "symbol": "HSCHF"
    },
    {
     "description": "HIGHLAND SURPRISE CONSOLIDAT",
     "symbol": "HSCM"
    },
    {
     "description": "HOUSE OF CONTROL GROUP AS",
     "symbol": "HSCNF"
    },
    {
     "description": "HI SCORE CORP",
     "symbol": "HSCO"
    },
    {
     "description": "ISHARES CUR HDG MSCI EAFE SM",
     "symbol": "HSCZ"
    },
    {
     "description": "HELIUS MEDICAL TECHNOLOGIES",
     "symbol": "HSDT"
    },
    {
     "description": "HELIUS MEDICAL TECH -CW26",
     "symbol": "HSDTW"
    },
    {
     "description": "HILL STREET BEVERAGE CO INC",
     "symbol": "HSEEF"
    },
    {
     "description": "HONSEN ENERGY & RESOURCES IN",
     "symbol": "HSEN"
    },
    {
     "description": "HOMELAND SAFETY INTERNATIONA",
     "symbol": "HSFI"
    },
    {
     "description": "HAIER SMART HOME CO LTD-ADR",
     "symbol": "HSHCY"
    },
    {
     "description": "HOSHIZAKI CORP",
     "symbol": "HSHIF"
    },
    {
     "description": "HOME SOLUTIONS HEALTH INC",
     "symbol": "HSHL"
    },
    {
     "description": "HILL & SMITH HOLDINGS PLC",
     "symbol": "HSHPF"
    },
    {
     "description": "HOSHIZAKI CORP-UNSPON ADR",
     "symbol": "HSHZY"
    },
    {
     "description": "HENRY SCHEIN INC",
     "symbol": "HSIC"
    },
    {
     "description": "HEIDRICK & STRUGGLES INTL",
     "symbol": "HSII"
    },
    {
     "description": "HADASIT BIO HOLDINGS LTD",
     "symbol": "HSITF"
    },
    {
     "description": "HESKA CORP",
     "symbol": "HSKA"
    },
    {
     "description": "HEALTHCARE SOLUTIONS MANAGEM",
     "symbol": "HSMD"
    },
    {
     "description": "FIRST TRUST HORIZON MANAGED",
     "symbol": "HSMV"
    },
    {
     "description": "HANG SENG BANK LTD",
     "symbol": "HSNGF"
    },
    {
     "description": "HANG SENG BANK-SPONSORED ADR",
     "symbol": "HSNGY"
    },
    {
     "description": "HUDSON GLOBAL INC",
     "symbol": "HSON"
    },
    {
     "description": "HUSQVARNA AB-ADR",
     "symbol": "HSQVY"
    },
    {
     "description": "HASTINGS TECHNOLOGY METALS L",
     "symbol": "HSRMF"
    },
    {
     "description": "HARTFORD SHORT DURATION ETF",
     "symbol": "HSRT"
    },
    {
     "description": "HUBER & SUHNER AG-REG",
     "symbol": "HSSKF"
    },
    {
     "description": "HOST HOTELS & RESORTS INC",
     "symbol": "HST"
    },
    {
     "description": "HESTIA INSIGHT INC",
     "symbol": "HSTA"
    },
    {
     "description": "HST GLOBAL INC",
     "symbol": "HSTC"
    },
    {
     "description": "HOLOGRAPHIC STORAGE LTD",
     "symbol": "HSTG"
    },
    {
     "description": "HIGH SIERRA TECHNOLOGIES INC",
     "symbol": "HSTI"
    },
    {
     "description": "HEALTHSTREAM INC",
     "symbol": "HSTM"
    },
    {
     "description": "HISTOGEN INC",
     "symbol": "HSTO"
    },
    {
     "description": "HELIOSTAR METALS LTD",
     "symbol": "HSTXF"
    },
    {
     "description": "HARTFORD SUSTAINABLE INC ETF",
     "symbol": "HSUN"
    },
    {
     "description": "HOSTELWORLD GROUP PLC",
     "symbol": "HSWLF"
    },
    {
     "description": "HANGSENG CHINA ENT INDEX-HKD",
     "symbol": "HSXUF"
    },
    {
     "description": "HERSHEY CO\/THE",
     "symbol": "HSY"
    },
    {
     "description": "HARMONIC DRIVE SYSTEMS INC",
     "symbol": "HSYDF"
    },
    {
     "description": "HERSHA HOSPITALITY TRUST",
     "symbol": "HT"
    },
    {
     "description": "HERSHA HOSPITALITY TRUST",
     "symbol": "HT.PRC"
    },
    {
     "description": "HERSHA HOSPITALITY TRUST",
     "symbol": "HT.PRD"
    },
    {
     "description": "HERSHA HOSPITALITY TRUST",
     "symbol": "HT.PRE"
    },
    {
     "description": "HEALTHCARE TRUST OF AME-CL A",
     "symbol": "HTA"
    },
    {
     "description": "HARTFORD SCHRODERS TAX AWARE",
     "symbol": "HTAB"
    },
    {
     "description": "HUNT COS ACQUISITION CORP-A",
     "symbol": "HTAQ"
    },
    {
     "description": "HUNT COS ACQUISITION CORP I",
     "symbol": "HTAQ.U"
    },
    {
     "description": "HUNT COS ACQUISIT CL A -CW28",
     "symbol": "HTAQ.WS"
    },
    {
     "description": "HOMETRUST BANCSHARES INC",
     "symbol": "HTBI"
    },
    {
     "description": "HERITAGE COMMERCE CORP",
     "symbol": "HTBK"
    },
    {
     "description": "HEAT BIOLOGICS INC",
     "symbol": "HTBX"
    },
    {
     "description": "HTC CORP - REG S GDR",
     "symbol": "HTCKF"
    },
    {
     "description": "HITACHI CONSTRUCTION MACHINE",
     "symbol": "HTCMF"
    },
    {
     "description": "HITACHI CONSTRUCT-UNSPON ADR",
     "symbol": "HTCMY"
    },
    {
     "description": "HEARTCORE ENTERPRISES INC",
     "symbol": "HTCR"
    },
    {
     "description": "HUTCHISON TELECOMM HONG KONG",
     "symbol": "HTCTF"
    },
    {
     "description": "HTC CORP",
     "symbol": "HTCXF"
    },
    {
     "description": "JOHN HANCOCK T\/A DVD INCOME",
     "symbol": "HTD"
    },
    {
     "description": "HARD TO TREAT DISEASES INC",
     "symbol": "HTDS"
    },
    {
     "description": "ROBO GLOBAL HEALTHCARE TECH",
     "symbol": "HTEC"
    },
    {
     "description": "HORIZON TECHNOLOGY FINAN",
     "symbol": "HTFB"
    },
    {
     "description": "HERCULES CAPITAL INC",
     "symbol": "HTGC"
    },
    {
     "description": "HTG MOLECULAR DIAGNOSTICS",
     "symbol": "HTGM"
    },
    {
     "description": "HILLTOP HOLDINGS INC",
     "symbol": "HTH"
    },
    {
     "description": "HITACHI LTD",
     "symbol": "HTHIF"
    },
    {
     "description": "HITACHI LTD -ADR",
     "symbol": "HTHIY"
    },
    {
     "description": "HUMITECH INTERNATIONAL GROUP",
     "symbol": "HTHL"
    },
    {
     "description": "HUAZHU GROUP LTD-ADR",
     "symbol": "HTHT"
    },
    {
     "description": "HEALTHCARE TRUST",
     "symbol": "HTIA"
    },
    {
     "description": "HEALTHCARE TRUST",
     "symbol": "HTIBP"
    },
    {
     "description": "HEARTLAND EXPRESS INC",
     "symbol": "HTLD"
    },
    {
     "description": "HEARTLAND FINANCIAL USA INC",
     "symbol": "HTLF"
    },
    {
     "description": "HEARTLAND FINANCIAL USA",
     "symbol": "HTLFP"
    },
    {
     "description": "HAMILTON THORNE LTD",
     "symbol": "HTLZF"
    },
    {
     "description": "HUTCHISON TELECOMM (AUST)",
     "symbol": "HTMMF"
    },
    {
     "description": "HAITONG SECURITIES CO LTD-H",
     "symbol": "HTNGF"
    },
    {
     "description": "FUSION FUEL GREEN PLC-A",
     "symbol": "HTOO"
    },
    {
     "description": "FUSION FUEL GREEN PLC -CW26",
     "symbol": "HTOOW"
    },
    {
     "description": "HIGHLAND TRANSCEND PART-CL A",
     "symbol": "HTPA"
    },
    {
     "description": "HIGHLAND TRANSCEND PARTNERS",
     "symbol": "HTPA.U"
    },
    {
     "description": "HIGHLAND TRANSCEN CL A -CW27",
     "symbol": "HTPA.WS"
    },
    {
     "description": "HOTEL PROPERTY INVESTMENTS",
     "symbol": "HTPIF"
    },
    {
     "description": "HTC PURENERGY INC",
     "symbol": "HTPRF"
    },
    {
     "description": "HARTFORD TOTAL RTRN BOND ETF",
     "symbol": "HTRB"
    },
    {
     "description": "HUNTER CREEK MINING CO",
     "symbol": "HTRC"
    },
    {
     "description": "H3 ENTERPRISES INC",
     "symbol": "HTRE"
    },
    {
     "description": "HERE TO SERVE HOLDING CORP",
     "symbol": "HTSC"
    },
    {
     "description": "HEARTSOFT INC",
     "symbol": "HTSF"
    },
    {
     "description": "HITACHI TRANSPORT SYSTEM LTD",
     "symbol": "HTSLF"
    },
    {
     "description": "HISAMITSU PHARMACEUTICAL CO",
     "symbol": "HTSUF"
    },
    {
     "description": "HISAMITSU PHARMAC-UNSPON ADR",
     "symbol": "HTSUY"
    },
    {
     "description": "HULL TACTICAL US ETF",
     "symbol": "HTUS"
    },
    {
     "description": "HELIOS TOWERS PLC",
     "symbol": "HTWSF"
    },
    {
     "description": "JOHN HANCOCK TAX-ADVANTAGED",
     "symbol": "HTY"
    },
    {
     "description": "HERTZ GLOBAL HLDGS INC",
     "symbol": "HTZ"
    },
    {
     "description": "HERTZ GLOBAL HLDGS INC -CW51",
     "symbol": "HTZWW"
    },
    {
     "description": "HUABAO INTERNATIONAL HOLDING",
     "symbol": "HUABF"
    },
    {
     "description": "HUAKANG BIOMEDICAL HOLDINGS",
     "symbol": "HUAKF"
    },
    {
     "description": "HUATAI SECURITIES CO LTD-H",
     "symbol": "HUATF"
    },
    {
     "description": "HUBBELL INC",
     "symbol": "HUBB"
    },
    {
     "description": "HUB GROUP INC-CL A",
     "symbol": "HUBG"
    },
    {
     "description": "HUOBI TECHNOLOGY HOLDINGS LT",
     "symbol": "HUBIF"
    },
    {
     "description": "HUBSPOT INC",
     "symbol": "HUBS"
    },
    {
     "description": "HUBB VENTURES INC",
     "symbol": "HUBV"
    },
    {
     "description": "HUADI INTERNATIONAL GROUP CO",
     "symbol": "HUDI"
    },
    {
     "description": "HUDDLY AS",
     "symbol": "HUDLF"
    },
    {
     "description": "HUDSON RESOURCES INC",
     "symbol": "HUDRF"
    },
    {
     "description": "HUFVUDSTADEN AB-A SHS",
     "symbol": "HUFAF"
    },
    {
     "description": "FSD PHARMA INC-CLASS B",
     "symbol": "HUGE"
    },
    {
     "description": "HUGO BOSS AG  -ORD",
     "symbol": "HUGPF"
    },
    {
     "description": "USHG ACQUISITION CORP-A",
     "symbol": "HUGS"
    },
    {
     "description": "USHG ACQUISITION CORP",
     "symbol": "HUGS.U"
    },
    {
     "description": "USHG ACQUISITION CL A -CW28",
     "symbol": "HUGS.WS"
    },
    {
     "description": "HULIC REIT INC",
     "symbol": "HUICF"
    },
    {
     "description": "HUABAO INTERNAT-UNSPON ADR",
     "symbol": "HUIHY"
    },
    {
     "description": "HOUSE OF INVESTMENTS",
     "symbol": "HUIVF"
    },
    {
     "description": "HUIZE HOLDING LTD-ADR",
     "symbol": "HUIZ"
    },
    {
     "description": "HOKURIKU ELECTRICAL CONST",
     "symbol": "HUKEF"
    },
    {
     "description": "HULIC CO LTD",
     "symbol": "HULCF"
    },
    {
     "description": "STAN LEE MEDIA INC\/NEW",
     "symbol": "HULK"
    },
    {
     "description": "HUMANA INC",
     "symbol": "HUM"
    },
    {
     "description": "HUMACYTE INC",
     "symbol": "HUMA"
    },
    {
     "description": "HUMACYTE INC-CW27",
     "symbol": "HUMAW"
    },
    {
     "description": "HUMBLE & FUME INC",
     "symbol": "HUMBF"
    },
    {
     "description": "HUA MEDICINE",
     "symbol": "HUMDF"
    },
    {
     "description": "HUMBLE ENERGY INC",
     "symbol": "HUML"
    },
    {
     "description": "HUMMINGBIRD RESOURCES PLC",
     "symbol": "HUMRF"
    },
    {
     "description": "HUMATECH INC",
     "symbol": "HUMT"
    },
    {
     "description": "HUNTSMAN CORP",
     "symbol": "HUN"
    },
    {
     "description": "HUANENG POWER INTL INC-H",
     "symbol": "HUNGF"
    },
    {
     "description": "HUNTER MARITIME ACQUISITION",
     "symbol": "HUNTF"
    },
    {
     "description": "HUON AQUACULTURE GROUP LTD",
     "symbol": "HUOAF"
    },
    {
     "description": "HUTCHISON PORT HOLDINGS-ADR",
     "symbol": "HUPHY"
    },
    {
     "description": "HUB POWER COMPANY-SPONS GDR",
     "symbol": "HUPOF"
    },
    {
     "description": "HUSQVARNA AB-A SHS",
     "symbol": "HUQVF"
    },
    {
     "description": "HURCO COMPANIES INC",
     "symbol": "HURC"
    },
    {
     "description": "HURON CONSULTING GROUP INC",
     "symbol": "HURN"
    },
    {
     "description": "HOUSTON AMERICAN ENERGY CORP",
     "symbol": "HUSA"
    },
    {
     "description": "NICOLA MINING INC",
     "symbol": "HUSIF"
    },
    {
     "description": "HUDSON CAPITAL INC",
     "symbol": "HUSN"
    },
    {
     "description": "HUSQVARNA AB-B SHS",
     "symbol": "HUSQF"
    },
    {
     "description": "FT HORIZON MNGD VOL DOM ETF",
     "symbol": "HUSV"
    },
    {
     "description": "HUT 8 MINING CORP",
     "symbol": "HUT"
    },
    {
     "description": "HUTCHISON TELECOMM-UNSP ADR",
     "symbol": "HUTCY"
    },
    {
     "description": "HUTN INC",
     "symbol": "HUTN"
    },
    {
     "description": "HUYA INC-ADR",
     "symbol": "HUYA"
    },
    {
     "description": "HUAZHANG TECHNOLOGY HOLDING",
     "symbol": "HUZNF"
    },
    {
     "description": "ALPS HILLMAN ACTIVE VALUE ET",
     "symbol": "HVAL"
    },
    {
     "description": "HV BANCORP INC",
     "symbol": "HVBC"
    },
    {
     "description": "HARRISON VICKERS & WATERMAN",
     "symbol": "HVCW"
    },
    {
     "description": "HARVEST GOLD CORP",
     "symbol": "HVGDF"
    },
    {
     "description": "HURON VALLEY BANCORP INC",
     "symbol": "HVLM"
    },
    {
     "description": "HARBOURVEST GLOBAL PRIVA",
     "symbol": "HVPQF"
    },
    {
     "description": "HANNOVER RUECK SE",
     "symbol": "HVRRF"
    },
    {
     "description": "HANNOVER RUECKVERSICHER-ADR",
     "symbol": "HVRRY"
    },
    {
     "description": "HAVERTY FURNITURE",
     "symbol": "HVT"
    },
    {
     "description": "HAVERTY FURNITURE COS-CL A",
     "symbol": "HVT.A"
    },
    {
     "description": "HOME VALLEY BANCORP",
     "symbol": "HVYB"
    },
    {
     "description": "HWA FONG RUBBER THAI-NVDR",
     "symbol": "HWAFF"
    },
    {
     "description": "HOLLYWALL ENTERTAINMENT INC",
     "symbol": "HWAL"
    },
    {
     "description": "HEIWA REAL ESTATE CO LTD",
     "symbol": "HWARF"
    },
    {
     "description": "HEADWATER GOLD INC",
     "symbol": "HWAUF"
    },
    {
     "description": "HAWTHORN BANCSHARES INC",
     "symbol": "HWBK"
    },
    {
     "description": "HANCOCK WHITNEY CORP",
     "symbol": "HWC"
    },
    {
     "description": "HANCOCK WHITNEY CORP",
     "symbol": "HWCPZ"
    },
    {
     "description": "HOWDEN JOINERY GROUP PLC",
     "symbol": "HWDJF"
    },
    {
     "description": "HOWDEN JOINERY GROUP-UNS ADR",
     "symbol": "HWDJY"
    },
    {
     "description": "HEALTHWELL ACQUISITION COR-A",
     "symbol": "HWEL"
    },
    {
     "description": "HEALTHWELL ACQUISITION CORP",
     "symbol": "HWELU"
    },
    {
     "description": "HEALTHWELL ACQ CL A -CW28",
     "symbol": "HWELW"
    },
    {
     "description": "HWGG ENTERTAINMENT LTD",
     "symbol": "HWGG"
    },
    {
     "description": "HOMETOWN INTERNATIONAL INC",
     "symbol": "HWIN"
    },
    {
     "description": "HOME BANCORP WISCONSIN INC",
     "symbol": "HWIS"
    },
    {
     "description": "HAWKEYE GOLD & DIAMOND INC",
     "symbol": "HWKDF"
    },
    {
     "description": "HAWKEYE SYSTEMS INC",
     "symbol": "HWKE"
    },
    {
     "description": "HAWKINS INC",
     "symbol": "HWKN"
    },
    {
     "description": "HAWKMOON RESOURCES CORP",
     "symbol": "HWKRF"
    },
    {
     "description": "HAWKS ACQUISITION CORP - A",
     "symbol": "HWKZ"
    },
    {
     "description": "HAWKS ACQUISITION CORP",
     "symbol": "HWKZ.U"
    },
    {
     "description": "HAWKS ACQUISITION A -CW23",
     "symbol": "HWKZ.WS"
    },
    {
     "description": "HOWMET AEROSPACE INC",
     "symbol": "HWM"
    },
    {
     "description": "HOWMET AEROSPACE INC",
     "symbol": "HWM.PR"
    },
    {
     "description": "HIGH WIRE NETWORKS INC",
     "symbol": "HWNI"
    },
    {
     "description": "HAWK PROTECTION SYSTEMS INC",
     "symbol": "HWPR"
    },
    {
     "description": "HAWSONS IRON LTD",
     "symbol": "HWSNF"
    },
    {
     "description": "HAWK SYSTEMS INC",
     "symbol": "HWSY"
    },
    {
     "description": "HUNTSWORTH PLC",
     "symbol": "HWTFF"
    },
    {
     "description": "WILDSKY RESOURCES INC",
     "symbol": "HWTHF"
    },
    {
     "description": "HFACTOR INC",
     "symbol": "HWTR"
    },
    {
     "description": "HAWAII VINTAGE CHOCOLATE CO",
     "symbol": "HWVI"
    },
    {
     "description": "HELIX BIOMEDIX INC",
     "symbol": "HXBM"
    },
    {
     "description": "HEXAGON AB-B SHS",
     "symbol": "HXGBF"
    },
    {
     "description": "HEXAGON AB- UNSP ADR",
     "symbol": "HXGBY"
    },
    {
     "description": "HEXAGON COMPOSITES ASA",
     "symbol": "HXGCF"
    },
    {
     "description": "HEXCEL CORP",
     "symbol": "HXL"
    },
    {
     "description": "HELIOSX LITHIUM & TECHNOLOGI",
     "symbol": "HXLTF"
    },
    {
     "description": "HEXPOL AB",
     "symbol": "HXPLF"
    },
    {
     "description": "HARRIS EXPLORATION INC",
     "symbol": "HXPN"
    },
    {
     "description": "HISPANIC EXPRESS INC",
     "symbol": "HXPR"
    },
    {
     "description": "HEXPOL AB - UNSP ADR",
     "symbol": "HXXPY"
    },
    {
     "description": "HYSTER-YALE MATERIALS",
     "symbol": "HY"
    },
    {
     "description": "HAYMAKER ACQUISITION CORP-A",
     "symbol": "HYAC"
    },
    {
     "description": "HAYMAKER ACQUISITION CORP",
     "symbol": "HYACU"
    },
    {
     "description": "HAYMAKER ACQUISITION CO-CW27",
     "symbol": "HYACW"
    },
    {
     "description": "NEW AMERICA HIGH INCOME FUND",
     "symbol": "HYB"
    },
    {
     "description": "ISHARES BB RATED CORP BOND",
     "symbol": "HYBB"
    },
    {
     "description": "HYBRID ENERGY HOLDINGS INC",
     "symbol": "HYBE"
    },
    {
     "description": "SPDR BLACKSTONE HIGH INCOME",
     "symbol": "HYBL"
    },
    {
     "description": "HYPERBLOCK INC",
     "symbol": "HYBOF"
    },
    {
     "description": "HEYU BIOLOGICAL TECHNOLOGY C",
     "symbol": "HYBT"
    },
    {
     "description": "VANECK HIGH YIELD MUNI ETF",
     "symbol": "HYD"
    },
    {
     "description": "ISHARES HIGH YIELD BOND FACT",
     "symbol": "HYDB"
    },
    {
     "description": "HYDROMER INC",
     "symbol": "HYDI"
    },
    {
     "description": "HAYDEN HALL INC",
     "symbol": "HYDN"
    },
    {
     "description": "GLOBAL X HYDROGEN ETF",
     "symbol": "HYDR"
    },
    {
     "description": "XTRS LOW BETA HI YIELD ETF",
     "symbol": "HYDW"
    },
    {
     "description": "HYDROGEN ENGINE CENTER INC",
     "symbol": "HYEG"
    },
    {
     "description": "VANECK EMRG MKTS HI YLD",
     "symbol": "HYEM"
    },
    {
     "description": "HYUNDAI ELEVATOR CO.",
     "symbol": "HYEVF"
    },
    {
     "description": "HEALTHY EXTRACT INC",
     "symbol": "HYEX"
    },
    {
     "description": "HYDROFARM HOLDINGS GROUP INC",
     "symbol": "HYFM"
    },
    {
     "description": "HYFLUX LTD",
     "symbol": "HYFXF"
    },
    {
     "description": "HYFLUX LTD-UNSP ADR",
     "symbol": "HYFXY"
    },
    {
     "description": "ISHARES IBOXX HIGH YLD CORP",
     "symbol": "HYG"
    },
    {
     "description": "ISHARES INT RATE HEDG HY ETF",
     "symbol": "HYGH"
    },
    {
     "description": "HYDROGENETICS INC",
     "symbol": "HYGN"
    },
    {
     "description": "FLEXSHARES HIGH YIELD VALUE",
     "symbol": "HYGV"
    },
    {
     "description": "SIXTY SIX CAPITAL INC",
     "symbol": "HYHDF"
    },
    {
     "description": "PROSHARES HIGH YIELD INTERES",
     "symbol": "HYHG"
    },
    {
     "description": "HYGEIA HEALTHCARE HOLDINGS C",
     "symbol": "HYHHF"
    },
    {
     "description": "HYDROGEN HYBRID TECHNOLOGIES",
     "symbol": "HYHY"
    },
    {
     "description": "WESTERN ASSET HIGH YIELD DEF",
     "symbol": "HYI"
    },
    {
     "description": "WisdomTree Alternative Incom",
     "symbol": "HYIN"
    },
    {
     "description": "HYAKUGO BANK LTD\/THE",
     "symbol": "HYKUF"
    },
    {
     "description": "XTRACKERS USD HIGH YIELD COR",
     "symbol": "HYLB"
    },
    {
     "description": "HIGH YIELD ETF",
     "symbol": "HYLD"
    },
    {
     "description": "HYLIION HOLDINGS CORP",
     "symbol": "HYLN"
    },
    {
     "description": "FT TACTICAL HIGH YIELD ETF",
     "symbol": "HYLS"
    },
    {
     "description": "IQ S&P HY LOW VOL BOND ETF",
     "symbol": "HYLV"
    },
    {
     "description": "SPDR NUVEEN BLOOMBERG HIGH Y",
     "symbol": "HYMB"
    },
    {
     "description": "HYCROFT MINING HOLDING CORP",
     "symbol": "HYMC"
    },
    {
     "description": "HYCROFT MINING HOLDING -CW25",
     "symbol": "HYMCL"
    },
    {
     "description": "HYCROFT MINING HOLDING",
     "symbol": "HYMCW"
    },
    {
     "description": "HYCROFT MINING HOLD-CW22",
     "symbol": "HYMCZ"
    },
    {
     "description": "HYUNDAI MOTOR CO",
     "symbol": "HYMLF"
    },
    {
     "description": "HYUNDAI MOTOR CO LTD-PRF",
     "symbol": "HYMPF"
    },
    {
     "description": "HYUNDAI MOTOR CO-REG S GDR",
     "symbol": "HYMTF"
    },
    {
     "description": "BLACKROCK HIGH YIELD MUNI IN",
     "symbol": "HYMU"
    },
    {
     "description": "HYPEBEAST LTD - SPON ADR",
     "symbol": "HYPBY"
    },
    {
     "description": "HYPOWER FUEL INC",
     "symbol": "HYPF"
    },
    {
     "description": "HYUNDAI MOBIS CO LTD",
     "symbol": "HYPLF"
    },
    {
     "description": "HYPERA SA -SPON ADR",
     "symbol": "HYPMY"
    },
    {
     "description": "HYPOPORT SE",
     "symbol": "HYPOF"
    },
    {
     "description": "HYPEBEAST LTD",
     "symbol": "HYPPF"
    },
    {
     "description": "HYPERFINE INC",
     "symbol": "HYPR"
    },
    {
     "description": "HYDROGENPRO AS",
     "symbol": "HYPRF"
    },
    {
     "description": "HYQC INVESTMENT HOLDING CO",
     "symbol": "HYQC"
    },
    {
     "description": "HYRECAR INC",
     "symbol": "HYRE"
    },
    {
     "description": "XTRACKERS R\/M USD HI YLD",
     "symbol": "HYRM"
    },
    {
     "description": "PIMCO 0-5 YEAR H\/Y CORP BOND",
     "symbol": "HYS"
    },
    {
     "description": "HYSAN DEVELOPMENT CO",
     "symbol": "HYSNF"
    },
    {
     "description": "HYSAN DEVELOPMENT LTD-SP ADR",
     "symbol": "HYSNY"
    },
    {
     "description": "SUNHYDROGEN INC",
     "symbol": "HYSR"
    },
    {
     "description": "BLACKROCK CORP HI YLD",
     "symbol": "HYT"
    },
    {
     "description": "CP HIGH YIELD TREND ETF",
     "symbol": "HYTR"
    },
    {
     "description": "HANKYU HANSHIN HOLDINGS INC",
     "symbol": "HYUHF"
    },
    {
     "description": "XTRS HI BETA HI YIELD ETF",
     "symbol": "HYUP"
    },
    {
     "description": "HYWIN HOLDINGS LTD",
     "symbol": "HYW"
    },
    {
     "description": "HOLLYWOOD INTERMEDIATE INC",
     "symbol": "HYWI"
    },
    {
     "description": "HOLLYWOOD STUDIOS INTERNATIO",
     "symbol": "HYWS"
    },
    {
     "description": "ISHARES ESG ADV HIGH YIELD",
     "symbol": "HYXF"
    },
    {
     "description": "ISHARES INTERNATIONAL HIGH Y",
     "symbol": "HYXU"
    },
    {
     "description": "WISDOMTREE INTEREST RATE HED",
     "symbol": "HYZD"
    },
    {
     "description": "HYZON MOTORS INC",
     "symbol": "HYZN"
    },
    {
     "description": "DECARBONIZATION PLUS -CW25",
     "symbol": "HYZNW"
    },
    {
     "description": "BETAPRO S&P\/TSX CAPPED FINAN",
     "symbol": "HZBBF"
    },
    {
     "description": "BETAPRO S&P\/TSX CAPPED ENERG",
     "symbol": "HZBRF"
    },
    {
     "description": "GRAYSCALE HORIZEN TRUST",
     "symbol": "HZEN"
    },
    {
     "description": "HORIZONS HOLDINGS INTERNATIO",
     "symbol": "HZHI"
    },
    {
     "description": "HORIZONTE MINERALS PLC",
     "symbol": "HZMMF"
    },
    {
     "description": "BETAPRO SILVER 2X DAILY BULL",
     "symbol": "HZMXF"
    },
    {
     "description": "HORIZON GLOBAL CORP",
     "symbol": "HZN"
    },
    {
     "description": "HYUNDAI MOTOR CO LTD-3P",
     "symbol": "HZNDF"
    },
    {
     "description": "HORIZON OIL LTD",
     "symbol": "HZNFF"
    },
    {
     "description": "HORIZON MINERALS CORP",
     "symbol": "HZNM"
    },
    {
     "description": "DEXTERRA GROUP INC",
     "symbol": "HZNOF"
    },
    {
     "description": "HORIZON THERAPEUTICS PLC",
     "symbol": "HZNP"
    },
    {
     "description": "BETAPRO CANADIAN GOLD MINERS",
     "symbol": "HZNSF"
    },
    {
     "description": "MARINEMAX INC",
     "symbol": "HZO"
    },
    {
     "description": "HORIZON ACQUIS CORP II -CL A",
     "symbol": "HZON"
    },
    {
     "description": "HORIZON ACQUISITION CORP II",
     "symbol": "HZON.U"
    },
    {
     "description": "HORIZON ACQUIS CORP II -CW27",
     "symbol": "HZON.WS"
    },
    {
     "description": "BETAPRO CR OIL LEV DAILY BUL",
     "symbol": "HZOZF"
    },
    {
     "description": "HAZER GROUP LTD",
     "symbol": "HZRGF"
    },
    {
     "description": "BETAPRO CAN GD -2X DAILY BEA",
     "symbol": "HZRZF"
    },
    {
     "description": "HORIZONS ACTIVE ULTRA-SHORT",
     "symbol": "HZTVF"
    },
    {
     "description": "IAA INC",
     "symbol": "IAA"
    },
    {
     "description": "ISHARES MSCI CHINA A",
     "symbol": "IAACF"
    },
    {
     "description": "IBC ADVANCED ALLOYS CORP",
     "symbol": "IAALF"
    },
    {
     "description": "IAC\/INTERACTIVECORP",
     "symbol": "IAC"
    },
    {
     "description": "ION ACQUISITION CORP 3 LTD-A",
     "symbol": "IACC"
    },
    {
     "description": "INTER ACTION CORP",
     "symbol": "IACYF"
    },
    {
     "description": "VOYA ASIA PAC HI DVD EQ INC",
     "symbol": "IAE"
    },
    {
     "description": "ABERDEEN AUSTRALIA EQUITY FD",
     "symbol": "IAF"
    },
    {
     "description": "IA FINANCIAL CORP INC",
     "symbol": "IAFNF"
    },
    {
     "description": "IAMGOLD CORP",
     "symbol": "IAG"
    },
    {
     "description": "ISHARES INTL AGGREGATE BOND",
     "symbol": "IAGG"
    },
    {
     "description": "IMAGENETIX INC",
     "symbol": "IAGX"
    },
    {
     "description": "IAHL CORP",
     "symbol": "IAHL"
    },
    {
     "description": "ISHARES U.S. BROKER-DEALERS",
     "symbol": "IAI"
    },
    {
     "description": "ISHARES U.S. INSURANCE ETF",
     "symbol": "IAK"
    },
    {
     "description": "INNOVATOR INTERNATIONAL DEVE",
     "symbol": "IAPR"
    },
    {
     "description": "IAR SYSTEMS GROUP AB",
     "symbol": "IARGF"
    },
    {
     "description": "INTEGRA LIFESCIENCES HOLDING",
     "symbol": "IART"
    },
    {
     "description": "INTEGRAL AD SCIENCE HOLDING",
     "symbol": "IAS"
    },
    {
     "description": "ISHARES US REGIONAL BANKS ET",
     "symbol": "IAT"
    },
    {
     "description": "ISHARES GOLD TRUST",
     "symbol": "IAU"
    },
    {
     "description": "I-80 GOLD CORP",
     "symbol": "IAUCF"
    },
    {
     "description": "ISHARES GOLD STRATEGY ETF",
     "symbol": "IAUF"
    },
    {
     "description": "AIC MINES LTD",
     "symbol": "IAUFF"
    },
    {
     "description": "INSURANCE AUSTRALIA GROUP",
     "symbol": "IAUGF"
    },
    {
     "description": "INSURANCE AUSTRALIA-UNSP ADR",
     "symbol": "IAUGY"
    },
    {
     "description": "ISHARES GOLD TRUST MICRO",
     "symbol": "IAUM"
    },
    {
     "description": "ISHARES CORE S&P\/ASX 200 ETF",
     "symbol": "IAUTF"
    },
    {
     "description": "INDUSTRIAS BACHOCO SAB SP AD",
     "symbol": "IBA"
    },
    {
     "description": "INABA DENKI SANGYO CO LTD",
     "symbol": "IBADF"
    },
    {
     "description": "INTERNATIONAL BALER CORP",
     "symbol": "IBAL"
    },
    {
     "description": "INTERNATIONAL BATTERY METALS",
     "symbol": "IBATF"
    },
    {
     "description": "ISHARES BIOTECHNOLOGY ETF",
     "symbol": "IBB"
    },
    {
     "description": "Defiance Nasdaq Junior Biotechnology ETF",
     "symbol": "IBBJ"
    },
    {
     "description": "INVESCO NASDAQ BIOTECH ETF",
     "symbol": "IBBQ"
    },
    {
     "description": "ISHARES IBONDS MAR 2023 TERM",
     "symbol": "IBCE"
    },
    {
     "description": "INDEPENDENT BANK CORP - MICH",
     "symbol": "IBCP"
    },
    {
     "description": "INSPIRE CORPORATE BOND ESG E",
     "symbol": "IBD"
    },
    {
     "description": "ISHARES IBONDS MAR 2023 TERM",
     "symbol": "IBDD"
    },
    {
     "description": "ISHARES IBONDS DEC 2022 TERM",
     "symbol": "IBDN"
    },
    {
     "description": "ISHARES IBONDS DEC 2023 TERM",
     "symbol": "IBDO"
    },
    {
     "description": "ISHARES IBONDS DEC 2024 TERM",
     "symbol": "IBDP"
    },
    {
     "description": "ISHARES IBONDS DEC 2025 TERM",
     "symbol": "IBDQ"
    },
    {
     "description": "ISHARES IBONDS DEC 2026 TERM",
     "symbol": "IBDR"
    },
    {
     "description": "IBERDROLA SA-SPONSORED ADR",
     "symbol": "IBDRY"
    },
    {
     "description": "ISHRS IBNDS DEC 27 CORP ETF",
     "symbol": "IBDS"
    },
    {
     "description": "IBERDROLA SA",
     "symbol": "IBDSF"
    },
    {
     "description": "ISHARES IBONDS DEC 2028 ETF",
     "symbol": "IBDT"
    },
    {
     "description": "ISHARES IBONDS DEC 2029 TERM",
     "symbol": "IBDU"
    },
    {
     "description": "ISHARES IBONDS DEC 2030 CORP",
     "symbol": "IBDV"
    },
    {
     "description": "ISHARES IBONDS DEC 2031 CORP",
     "symbol": "IBDW"
    },
    {
     "description": "IBERE PHARMACEUTICALS-A",
     "symbol": "IBER"
    },
    {
     "description": "IBERE PHARMACEUTICALS",
     "symbol": "IBER.U"
    },
    {
     "description": "IBERE PHARMACEUTI CL A -CW27",
     "symbol": "IBER.WS"
    },
    {
     "description": "IBET SPORTS BETTING & GAMING",
     "symbol": "IBET"
    },
    {
     "description": "IBEX LTD",
     "symbol": "IBEX"
    },
    {
     "description": "ISHARES CORE GLB AGG BOND",
     "symbol": "IBGAF"
    },
    {
     "description": "NEXUS ENERGY SERVICES INC",
     "symbol": "IBGR"
    },
    {
     "description": "ISHARES IBONDS 2022 H\/Y INC",
     "symbol": "IBHB"
    },
    {
     "description": "ISHARES IBONDS 2023 H\/Y INC",
     "symbol": "IBHC"
    },
    {
     "description": "ISHARES IBONDS 2024 H\/Y INC",
     "symbol": "IBHD"
    },
    {
     "description": "ISHARES IBONDS 2025 H\/Y INC",
     "symbol": "IBHE"
    },
    {
     "description": "ISHARES IBOND 2026 HY & INC",
     "symbol": "IBHF"
    },
    {
     "description": "ISHARES IBONDS 2027 HY INC",
     "symbol": "IBHG"
    },
    {
     "description": "ISHARES IBONDS 2028 TM HY IN",
     "symbol": "IBHH"
    },
    {
     "description": "ISHARES IBONDS 2029 TM HY IN",
     "symbol": "IBHI"
    },
    {
     "description": "IBI GROUP INC",
     "symbol": "IBIBF"
    },
    {
     "description": "IBIDEN CO LTD",
     "symbol": "IBIDF"
    },
    {
     "description": "IBSG INTERNATIONAL INC",
     "symbol": "IBIN"
    },
    {
     "description": "IBIO INC",
     "symbol": "IBIO"
    },
    {
     "description": "IBI INVESTMENT HOUSE LTD",
     "symbol": "IBIVF"
    },
    {
     "description": "IBSTOCK PLC",
     "symbol": "IBJHF"
    },
    {
     "description": "IMINING TECHNOLOGIES INC",
     "symbol": "IBKKF"
    },
    {
     "description": "INTERACTIVE BROKERS GRO-CL A",
     "symbol": "IBKR"
    },
    {
     "description": "INTL BUSINESS MACHINES CORP",
     "symbol": "IBM"
    },
    {
     "description": "ISHARES IBONDS DEC 2022 TERM",
     "symbol": "IBMK"
    },
    {
     "description": "ISHARES DEC 2023 MUNI BD ETF",
     "symbol": "IBML"
    },
    {
     "description": "ISHARES IBONDS DEC 2024 TERM",
     "symbol": "IBMM"
    },
    {
     "description": "ISHARES IBONDS DEC 2025 TERM",
     "symbol": "IBMN"
    },
    {
     "description": "ISHARES IBONDS DEC 2026 TERM",
     "symbol": "IBMO"
    },
    {
     "description": "ISHARES IBONDS DEC 2027 TERM",
     "symbol": "IBMP"
    },
    {
     "description": "ISHARES IBONDS DEC 2028 MUNI",
     "symbol": "IBMQ"
    },
    {
     "description": "ICICI BANK LTD-SPON ADR",
     "symbol": "IBN"
    },
    {
     "description": "SPDR BLOOMBERG INT CORP",
     "symbol": "IBND"
    },
    {
     "description": "IBO",
     "symbol": "IBO"
    },
    {
     "description": "INTERNATIONAL BANCSHARES CRP",
     "symbol": "IBOC"
    },
    {
     "description": "UNIVERSAL IBOGAINE INC",
     "symbol": "IBOGF"
    },
    {
     "description": "INSTALLED BUILDING PRODUCTS",
     "symbol": "IBP"
    },
    {
     "description": "IBRANDS CORP",
     "symbol": "IBRC"
    },
    {
     "description": "IMMUNITYBIO INC",
     "symbol": "IBRX"
    },
    {
     "description": "INTEGRATED BUSINESS SYSTEMS",
     "symbol": "IBSS"
    },
    {
     "description": "ISHARES IBONDS DEC 2022 TERM",
     "symbol": "IBTB"
    },
    {
     "description": "ISHARES IBONDS DEC 2023 TERM",
     "symbol": "IBTD"
    },
    {
     "description": "ISHARES IBONDS DEC 2024 TERM",
     "symbol": "IBTE"
    },
    {
     "description": "ISHARES IBONDS DEC 2025 TERM",
     "symbol": "IBTF"
    },
    {
     "description": "ISHARES IBONDS DEC 2026 TERM",
     "symbol": "IBTG"
    },
    {
     "description": "ISHARES IBONDS DEC 2027 TERM",
     "symbol": "IBTH"
    },
    {
     "description": "ISHARES IBONDS DEC 2028 TERM",
     "symbol": "IBTI"
    },
    {
     "description": "ISHARES IBONDS DEC 2029 TERM",
     "symbol": "IBTJ"
    },
    {
     "description": "ISHARES IBONDS DEC 2030 TREA",
     "symbol": "IBTK"
    },
    {
     "description": "ISHARES IBONDS DEC 2031 TERM",
     "symbol": "IBTL"
    },
    {
     "description": "INSCORP INC",
     "symbol": "IBTN"
    },
    {
     "description": "INDEPENDENT BANK GROUP INC",
     "symbol": "IBTX"
    },
    {
     "description": "AMPLIFY ONLINE RETAIL ETF",
     "symbol": "IBUY"
    },
    {
     "description": "IBW FINANCIAL CORPORATION",
     "symbol": "IBWC"
    },
    {
     "description": "IBX GROUP INC",
     "symbol": "IBXG"
    },
    {
     "description": "IBEX TECHNOLOGIES INC",
     "symbol": "IBXNF"
    },
    {
     "description": "IBITX SOFTWARE INC",
     "symbol": "IBXS"
    },
    {
     "description": "IMAGION BIOSYSTEMS LTD",
     "symbol": "IBXXF"
    },
    {
     "description": "I-CABLE COMMUNICATIONS LTD",
     "symbol": "ICABF"
    },
    {
     "description": "I-CABLE COMMUNICATIONS-ADR",
     "symbol": "ICABY"
    },
    {
     "description": "ICAD INC",
     "symbol": "ICAD"
    },
    {
     "description": "INTL CONSOLIDATED-SPONS ADR",
     "symbol": "ICAGY"
    },
    {
     "description": "INFRACAP EQTY INCOME FUND",
     "symbol": "ICAP"
    },
    {
     "description": "ISHARES INTRMD CREDIT BOND",
     "symbol": "ICBIF"
    },
    {
     "description": "ICBS LTD",
     "symbol": "ICBT"
    },
    {
     "description": "IMD COS INC",
     "symbol": "ICBU"
    },
    {
     "description": "IMMUCELL CORP",
     "symbol": "ICCC"
    },
    {
     "description": "ICA GRUPPEN AB",
     "symbol": "ICCGF"
    },
    {
     "description": "ICC HOLDINGS INC",
     "symbol": "ICCH"
    },
    {
     "description": "ICECURE MEDICAL LTD",
     "symbol": "ICCM"
    },
    {
     "description": "INTERCARE DX INC",
     "symbol": "ICCO"
    },
    {
     "description": "ICORECONNECT INC",
     "symbol": "ICCT"
    },
    {
     "description": "INDEPENDENCE CONTRACT DRILLI",
     "symbol": "ICD"
    },
    {
     "description": "ISHARES CANADIAN REAL RETURN",
     "symbol": "ICDXF"
    },
    {
     "description": "ISHARES CANADIAN HYBRID CORP",
     "symbol": "ICDZF"
    },
    {
     "description": "INTERCONTINENTAL EXCHANGE IN",
     "symbol": "ICE"
    },
    {
     "description": "ICETANA LTD",
     "symbol": "ICETF"
    },
    {
     "description": "ISHARES COHEN & STEERS REIT",
     "symbol": "ICF"
    },
    {
     "description": "ICF INTERNATIONAL INC",
     "symbol": "ICFI"
    },
    {
     "description": "INCOME FINANCIAL TR-UTS",
     "symbol": "ICFNF"
    },
    {
     "description": "INDIA CAPITAL GROWTH FND LTD",
     "symbol": "ICGFF"
    },
    {
     "description": "IMAGE CHAIN GROUP LIMITED IN",
     "symbol": "ICGL"
    },
    {
     "description": "INTERMEDIATE CAPITAL GROUP",
     "symbol": "ICGUF"
    },
    {
     "description": "INDUSTRIAS CH S.A.B.-SER B",
     "symbol": "ICHBF"
    },
    {
     "description": "INTERCONTINENTAL HOTELS GROU",
     "symbol": "ICHGF"
    },
    {
     "description": "ICHINEN HOLDINGS CO LTD",
     "symbol": "ICHHF"
    },
    {
     "description": "ICHIGO INC",
     "symbol": "ICHIF"
    },
    {
     "description": "ISE CHEMICALS CORP",
     "symbol": "ICHMF"
    },
    {
     "description": "ICHOR HOLDINGS LTD",
     "symbol": "ICHR"
    },
    {
     "description": "IPATH OPTIMIZED CURRENCY ETN",
     "symbol": "ICITF"
    },
    {
     "description": "INNOVATIVE COMPOSITES INTERN",
     "symbol": "ICIZF"
    },
    {
     "description": "ICL GROUP LTD",
     "symbol": "ICL"
    },
    {
     "description": "INTERCLOUD SYSTEMS INC",
     "symbol": "ICLD"
    },
    {
     "description": "ICLICK INTERACTIVE ASIA-ADR",
     "symbol": "ICLK"
    },
    {
     "description": "ISHARES GLOBAL CLEAN ENERGY",
     "symbol": "ICLN"
    },
    {
     "description": "ICON PLC",
     "symbol": "ICLR"
    },
    {
     "description": "GREENFIRST FOREST PRODUCTS I",
     "symbol": "ICLTF"
    },
    {
     "description": "INVESTCORP CREDIT MANAGEMENT",
     "symbol": "ICMB"
    },
    {
     "description": "INVESCO US COMMUNICATION S&P",
     "symbol": "ICMNF"
    },
    {
     "description": "ICANIC BRANDS CO INC",
     "symbol": "ICNAF"
    },
    {
     "description": "ICONIC BRANDS INC",
     "symbol": "ICNB"
    },
    {
     "description": "ICONIC SPORTS ACQ CORP-A",
     "symbol": "ICNC"
    },
    {
     "description": "ICONIC SPORTS ACQUISITION CO",
     "symbol": "ICNC.U"
    },
    {
     "description": "ICONIC SPORTS ACQ -CW23",
     "symbol": "ICNC.WS"
    },
    {
     "description": "ICON MEDIA HOLDINGS INC",
     "symbol": "ICNM"
    },
    {
     "description": "ICON ENERGY LIMITED",
     "symbol": "ICNOF"
    },
    {
     "description": "ICOA INC",
     "symbol": "ICOA"
    },
    {
     "description": "ICOM INC",
     "symbol": "ICOIF"
    },
    {
     "description": "ISHARES MSCI COLOMBIA ETF",
     "symbol": "ICOL"
    },
    {
     "description": "PACER DEVELOPED MARKETS INTE",
     "symbol": "ICOW"
    },
    {
     "description": "INSCAPE CORP-B",
     "symbol": "ICPBF"
    },
    {
     "description": "ICP LTD",
     "symbol": "ICPFF"
    },
    {
     "description": "INTERCEPT PHARMACEUTICALS IN",
     "symbol": "ICPT"
    },
    {
     "description": "INCITEC PIVOT LTD",
     "symbol": "ICPVF"
    },
    {
     "description": "INPOINT COMM REAL ESTATE",
     "symbol": "ICR.PRA"
    },
    {
     "description": "INTERNATIONAL CARD ESTABLISH",
     "symbol": "ICRD"
    },
    {
     "description": "BLACKROCK ULTRA SHORT-TERM B",
     "symbol": "ICSH"
    },
    {
     "description": "ROLLING OPTICS HOLDING AB",
     "symbol": "ICTAF"
    },
    {
     "description": "INTL CONTAINER TERM SVCS INC",
     "symbol": "ICTEF"
    },
    {
     "description": "ICTS INTERNATIONAL NV",
     "symbol": "ICTSF"
    },
    {
     "description": "EYECITY.COM INC",
     "symbol": "ICTY"
    },
    {
     "description": "ICU MEDICAL INC",
     "symbol": "ICUI"
    },
    {
     "description": "ISHARES CONVERTIBLE BOND ETF",
     "symbol": "ICVT"
    },
    {
     "description": "ICOSAVAX INC",
     "symbol": "ICVX"
    },
    {
     "description": "PARTS ID INC",
     "symbol": "ID"
    },
    {
     "description": "IDACORP INC",
     "symbol": "IDA"
    },
    {
     "description": "T STAMP INC-CLASS A",
     "symbol": "IDAI"
    },
    {
     "description": "IDARADO MINING CO",
     "symbol": "IDAM"
    },
    {
     "description": "ISHARES CLOUD & 5G TECH ETF",
     "symbol": "IDAT"
    },
    {
     "description": "IDEX BIOMETRICS ASA -ADR",
     "symbol": "IDBA"
    },
    {
     "description": "INDUSTRIAS BACHOCO-SER B",
     "symbol": "IDBHF"
    },
    {
     "description": "IND & COMM BK OF CHINA-H",
     "symbol": "IDCBF"
    },
    {
     "description": "IND & COMM BK OF-UNSPON ADR",
     "symbol": "IDCBY"
    },
    {
     "description": "INTERDIGITAL INC",
     "symbol": "IDCC"
    },
    {
     "description": "INDOCAN RESOURCES INC",
     "symbol": "IDCN"
    },
    {
     "description": "INDUCTION HEALTHCARE GROUP P",
     "symbol": "IDDHF"
    },
    {
     "description": "INDUSTRIVARDEN AB-C SHS",
     "symbol": "IDDTF"
    },
    {
     "description": "INDUTRADE AB",
     "symbol": "IDDWF"
    },
    {
     "description": "VOYA INFRASTRUCTURE INDUSTRI",
     "symbol": "IDE"
    },
    {
     "description": "INVENT VENTURES INC",
     "symbol": "IDEA"
    },
    {
     "description": "ISHARES CORE MSCI DEV MKTS",
     "symbol": "IDEV"
    },
    {
     "description": "IDEANOMICS INC",
     "symbol": "IDEX"
    },
    {
     "description": "INDUSTRIA DE DISENO TEXTIL",
     "symbol": "IDEXF"
    },
    {
     "description": "INDITEX-UNSPON ADR",
     "symbol": "IDEXY"
    },
    {
     "description": "PEAK BANCORP INC",
     "symbol": "IDFB"
    },
    {
     "description": "5TH PLANET GAMES A\/S",
     "symbol": "IDGAF"
    },
    {
     "description": "INDIGO BOOKS & MUSIC INC",
     "symbol": "IDGBF"
    },
    {
     "description": "IDGLOBAL CORP",
     "symbol": "IDGC"
    },
    {
     "description": "INTERPACE DIAGNOSTICS-CW22",
     "symbol": "IDGGW"
    },
    {
     "description": "INTEGRATED DIAGNOSTICS HOLDI",
     "symbol": "IDGXF"
    },
    {
     "description": "INVESCO S&P INTERNATIONAL DE",
     "symbol": "IDHD"
    },
    {
     "description": "INVESCO S&P INTERNATIONAL DE",
     "symbol": "IDHQ"
    },
    {
     "description": "INTL DIGITAL HOLDING INC",
     "symbol": "IDIG"
    },
    {
     "description": "IDI INSURANCE CO LTD",
     "symbol": "IDINF"
    },
    {
     "description": "METAURUS US EQUITY CUMULATIV",
     "symbol": "IDIV"
    },
    {
     "description": "ISHARES CORE EURO STOXX50 DE",
     "symbol": "IDJEF"
    },
    {
     "description": "THREED CAPITAL INC",
     "symbol": "IDKFF"
    },
    {
     "description": "IDEMITSU KOSAN CO LTD",
     "symbol": "IDKOF"
    },
    {
     "description": "IDEMITSU KOSAN CO-UNSPON ADR",
     "symbol": "IDKOY"
    },
    {
     "description": "INVESCO FTSE INTERNATIONAL L",
     "symbol": "IDLB"
    },
    {
     "description": "IDLE MEDIA INC",
     "symbol": "IDLM"
    },
    {
     "description": "INVESCO S&P INTERNATIONAL DE",
     "symbol": "IDLV"
    },
    {
     "description": "INTERNATIONAL DRAWDOWN MANAG",
     "symbol": "IDME"
    },
    {
     "description": "INVESCO S&P INTERNATIONAL DE",
     "symbol": "IDMO"
    },
    {
     "description": "INTELLICHECK INC",
     "symbol": "IDN"
    },
    {
     "description": "ISHARES GEN-IMMUNOLOGY HLTH",
     "symbol": "IDNA"
    },
    {
     "description": "INTERNATIONAL DISPENSING CRP",
     "symbol": "IDND"
    },
    {
     "description": "ALPS INTERNATIONAL SECTOR DI",
     "symbol": "IDOG"
    },
    {
     "description": "ISHARES DOW JONES INDUS AVRG",
     "symbol": "IDOWF"
    },
    {
     "description": "IDP EDUCATION LTD",
     "symbol": "IDPUF"
    },
    {
     "description": "IDAHO STRATEGIC RESOURCES IN",
     "symbol": "IDR"
    },
    {
     "description": "IDERA PHARMACEUTICALS INC",
     "symbol": "IDRA"
    },
    {
     "description": "IDORSIA LTD",
     "symbol": "IDRSF"
    },
    {
     "description": "ISHARES SELF-DRIVING EV&TECH",
     "symbol": "IDRV"
    },
    {
     "description": "ISHARES EUROPE SRI USD-ACC",
     "symbol": "IDSEF"
    },
    {
     "description": "ISHARES DIGITAL SCRTY USD-D",
     "symbol": "IDSUF"
    },
    {
     "description": "IDT CORP-CLASS B",
     "symbol": "IDT"
    },
    {
     "description": "IDENTA CORP",
     "symbol": "IDTA"
    },
    {
     "description": "IDREAMSKY TECHNOLOGY HOLDING",
     "symbol": "IDTHF"
    },
    {
     "description": "IDENTITII LTD",
     "symbol": "IDTIF"
    },
    {
     "description": "INDUSTRIVARDEN AB-A SHS",
     "symbol": "IDTVF"
    },
    {
     "description": "ISHARES US UTILITIES ETF",
     "symbol": "IDU"
    },
    {
     "description": "ISHARES INTERNATIONAL SELECT",
     "symbol": "IDV"
    },
    {
     "description": "INTERNATIONAL ENDEAVORS CORP",
     "symbol": "IDVV"
    },
    {
     "description": "IDW MEDIA HOLDINGS INC-B",
     "symbol": "IDW"
    },
    {
     "description": "VANECK INDONESIA INDEX ETF",
     "symbol": "IDX"
    },
    {
     "description": "IDEX BIOMETRICS ASA",
     "symbol": "IDXAF"
    },
    {
     "description": "INTERPACE BIOSCIENCES INC",
     "symbol": "IDXG"
    },
    {
     "description": "IDEXX LABORATORIES INC",
     "symbol": "IDXX"
    },
    {
     "description": "IDEAYA BIOSCIENCES INC",
     "symbol": "IDYA"
    },
    {
     "description": "IMAGING DYNAMICS CO LTD",
     "symbol": "IDYLF"
    },
    {
     "description": "XREALITY GROUP LTD",
     "symbol": "IDZAF"
    },
    {
     "description": "INFRASTRUCTURE AND ENERGY AL",
     "symbol": "IEA"
    },
    {
     "description": "INDUSTRIAL ENTERPRISES OF AM",
     "symbol": "IEAM"
    },
    {
     "description": "M III ACQUISITION CORP-CW21",
     "symbol": "IEAWW"
    },
    {
     "description": "ISHARES EVOLVED US CONSUMER",
     "symbol": "IECS"
    },
    {
     "description": "ISHARES EDGE MSCI EM VALUE",
     "symbol": "IEDGF"
    },
    {
     "description": "ISHARES EVOLVED US DISCRETIO",
     "symbol": "IEDI"
    },
    {
     "description": "ISHARES 7-10 YEAR TREASURY B",
     "symbol": "IEF"
    },
    {
     "description": "ISHARES CORE MSCI EAFE ETF",
     "symbol": "IEFA"
    },
    {
     "description": "ISHARES EVOLVED US FINANCIAL",
     "symbol": "IEFN"
    },
    {
     "description": "INDEPENDENCE GOLD CORP",
     "symbol": "IEGCF"
    },
    {
     "description": "IEH CORP",
     "symbol": "IEHC"
    },
    {
     "description": "ISHARES EVOLVED US HEALTHCAR",
     "symbol": "IEHS"
    },
    {
     "description": "ISHARES 3-7 YEAR TREASURY BO",
     "symbol": "IEI"
    },
    {
     "description": "ISHARES EVOLVED US INNOVATIV",
     "symbol": "IEIH"
    },
    {
     "description": "INTEGRATED MICRO-ELECTRONICS",
     "symbol": "IELLF"
    },
    {
     "description": "ISHARES JPM USD EM CORP BND",
     "symbol": "IEMBF"
    },
    {
     "description": "ISHARES EVOLVED US MEDIA AND",
     "symbol": "IEME"
    },
    {
     "description": "ISHARES CORE MSCI EMERGING",
     "symbol": "IEMG"
    },
    {
     "description": "ISHARES CORE EM IMI USD DIST",
     "symbol": "IEMIF"
    },
    {
     "description": "ISHR EDGE MSCI WRLD MOMENTUM",
     "symbol": "IEMMF"
    },
    {
     "description": "ISHARES EDGE MSCI WRLD SIZE",
     "symbol": "IEMWF"
    },
    {
     "description": "ISH EDG MSCI WLD MNVL USD A",
     "symbol": "IEMXF"
    },
    {
     "description": "IENTERTAINMENT NETWORK INC",
     "symbol": "IENT"
    },
    {
     "description": "INFRAESTRUCTURA ENERGETICA N",
     "symbol": "IENVF"
    },
    {
     "description": "ISHARES U.S. OIL & GAS EXPLO",
     "symbol": "IEO"
    },
    {
     "description": "ICAHN ENTERPRISES LP",
     "symbol": "IEP"
    },
    {
     "description": "ISHARES MSCI BRAZIL",
     "symbol": "IERNF"
    },
    {
     "description": "IES HOLDINGS INC",
     "symbol": "IESC"
    },
    {
     "description": "INTERCEPT ENERGY SERVICES IN",
     "symbol": "IESCF"
    },
    {
     "description": "INTERCONEXION ELECTRICA-ADR",
     "symbol": "IESFY"
    },
    {
     "description": "ISHARES EVOLVED US TECHNOLOG",
     "symbol": "IETC"
    },
    {
     "description": "ISHARES CORE MSCI EUROPE ETF",
     "symbol": "IEUR"
    },
    {
     "description": "ISHARES MSCI EUROPE SMALL-CA",
     "symbol": "IEUS"
    },
    {
     "description": "ISHARES EUROPE ETF",
     "symbol": "IEV"
    },
    {
     "description": "IDEX CORP",
     "symbol": "IEX"
    },
    {
     "description": "IEXALT INC",
     "symbol": "IEXA"
    },
    {
     "description": "ISHARES U.S. OIL EQUIPMENT &",
     "symbol": "IEZ"
    },
    {
     "description": "IFABRIC CORP",
     "symbol": "IFABF"
    },
    {
     "description": "INFRASTRUCTURE MATERIALS COR",
     "symbol": "IFAM"
    },
    {
     "description": "IFAN FINANCIAL INC",
     "symbol": "IFAN"
    },
    {
     "description": "ITALIAN FOOD & BEVERAGE CORP",
     "symbol": "IFBC"
    },
    {
     "description": "INFOBIRD CO LTD",
     "symbol": "IFBD"
    },
    {
     "description": "IFCI INTERNATIONAL CORP",
     "symbol": "IFCI"
    },
    {
     "description": "INTACT FINANCIAL CORP",
     "symbol": "IFCZF"
    },
    {
     "description": "ETRACS IFED INDEX ETN",
     "symbol": "IFED"
    },
    {
     "description": "INTL FLAVORS & FRAGRANCES",
     "symbol": "IFF"
    },
    {
     "description": "ISHARES MSCI FAREASTXJP USDA",
     "symbol": "IFFIF"
    },
    {
     "description": "INFOCOM CORP",
     "symbol": "IFFOF"
    },
    {
     "description": "INFOSERVE GLOBAL HOLDINGS",
     "symbol": "IFGH"
    },
    {
     "description": "ISHARES INTERNATIONAL DEVELO",
     "symbol": "IFGL"
    },
    {
     "description": "INTEGRATED FINANCIAL HOLDING",
     "symbol": "IFHI"
    },
    {
     "description": "INFINT ACQUISITION CORP-A",
     "symbol": "IFIN"
    },
    {
     "description": "INFINT ACQUISITION CORP",
     "symbol": "IFIN.U"
    },
    {
     "description": "1NFINT ACQUISITION CORP-CW27",
     "symbol": "IFIN.WS"
    },
    {
     "description": "IFIS JAPAN LTD",
     "symbol": "IFISF"
    },
    {
     "description": "INFORMA PLC-SP ADR",
     "symbol": "IFJPY"
    },
    {
     "description": "INDEPENDENT FILM DEVELOPMENT",
     "symbol": "IFLM"
    },
    {
     "description": "IMAFLEX INC",
     "symbol": "IFLXF"
    },
    {
     "description": "INFOMEDIA LTD",
     "symbol": "IFMDF"
    },
    {
     "description": "IFRESH INC",
     "symbol": "IFMK"
    },
    {
     "description": "INFO SERVICES INTL DENTSU",
     "symbol": "IFMNF"
    },
    {
     "description": "INDIA FUND INC",
     "symbol": "IFN"
    },
    {
     "description": "INFINEON TECHNOLOGIES AG",
     "symbol": "IFNNF"
    },
    {
     "description": "INFINEON TECHNOLOGIES-ADR",
     "symbol": "IFNNY"
    },
    {
     "description": "INFINITY ENERGY RESOURCES",
     "symbol": "IFNY"
    },
    {
     "description": "INFORMA PLC",
     "symbol": "IFPJF"
    },
    {
     "description": "ISHARES US INFRASTRUCTURE",
     "symbol": "IFRA"
    },
    {
     "description": "INTL FRONTIER RES CORP",
     "symbol": "IFRTF"
    },
    {
     "description": "INFLARX NV",
     "symbol": "IFRX"
    },
    {
     "description": "INTERCORP FINANCIAL SERVICES",
     "symbol": "IFS"
    },
    {
     "description": "IFS INTERNATIONAL HOLDINGS",
     "symbol": "IFSH"
    },
    {
     "description": "INTERFOR CORP",
     "symbol": "IFSPF"
    },
    {
     "description": "IFAST CORP LTD",
     "symbol": "IFSTF"
    },
    {
     "description": "INFRASTRUTTURE WIRELESS ITAL",
     "symbol": "IFSUF"
    },
    {
     "description": "Intact Financial Corporation",
     "symbol": "IFTPF"
    },
    {
     "description": "IMPACT FUSION INTERNATIONAL",
     "symbol": "IFUS"
    },
    {
     "description": "INFRATIL LTD",
     "symbol": "IFUUF"
    },
    {
     "description": "FIRST TRUST DW FOCUS 5 INTL",
     "symbol": "IFV"
    },
    {
     "description": "ISHARES FTSE CHINA A50 E-HKD",
     "symbol": "IFXAF"
    },
    {
     "description": "INFRAX SYSTEMS INC",
     "symbol": "IFXY"
    },
    {
     "description": "Intact Financial Corporation",
     "symbol": "IFZZF"
    },
    {
     "description": "PRINCIPAL INVESTMENT GRADE",
     "symbol": "IG"
    },
    {
     "description": "VOYA GLOBAL ADVANTAGE AND PR",
     "symbol": "IGA"
    },
    {
     "description": "IG ACQUISITION CORP-CLASS A",
     "symbol": "IGAC"
    },
    {
     "description": "IG ACQUISITION CORP",
     "symbol": "IGACU"
    },
    {
     "description": "IG ACQUISITION CORP A -CW27",
     "symbol": "IGACW"
    },
    {
     "description": "ISHARES INTEREST RATE HEDGED",
     "symbol": "IGBH"
    },
    {
     "description": "INDIA GLOBALIZATION CAPITAL",
     "symbol": "IGC"
    },
    {
     "description": "ISHARES GLB CORP USD-H ACC",
     "symbol": "IGCHF"
    },
    {
     "description": "VOYA GLBL EQTY DVD & PRM OPP",
     "symbol": "IGD"
    },
    {
     "description": "IG DESIGN GROUP PLC",
     "symbol": "IGDFF"
    },
    {
     "description": "ISHARES NORTH AMERICAN NATUR",
     "symbol": "IGE"
    },
    {
     "description": "ISHARES INVESTMENT GRADE BON",
     "symbol": "IGEB"
    },
    {
     "description": "IGEN NETWORKS CORP",
     "symbol": "IGEN"
    },
    {
     "description": "IGE + XAO",
     "symbol": "IGEPF"
    },
    {
     "description": "IGAS ENERGY PLC",
     "symbol": "IGESF"
    },
    {
     "description": "INDO GLOBAL EXCHANGES PTE. L",
     "symbol": "IGEX"
    },
    {
     "description": "ISHARES GLOBAL INFRASTRUCTUR",
     "symbol": "IGF"
    },
    {
     "description": "INFINITO GOLD LTD",
     "symbol": "IGFFF"
    },
    {
     "description": "INVESTA OFFICE FUND",
     "symbol": "IGFUF"
    },
    {
     "description": "IGG INC",
     "symbol": "IGGGF"
    },
    {
     "description": "IG GROUP HOLDINGS-SPON ADR",
     "symbol": "IGGHY"
    },
    {
     "description": "IG GROUP HOLDINGS PLC",
     "symbol": "IGGRF"
    },
    {
     "description": "PROSHARES IG HEDGED",
     "symbol": "IGHG"
    },
    {
     "description": "WESTERN ASSET INV GRA DEF OP",
     "symbol": "IGI"
    },
    {
     "description": "ISHARES 5-10Y INV GRADE CORP",
     "symbol": "IGIB"
    },
    {
     "description": "INTERNATIONAL GENERAL INSURA",
     "symbol": "IGIC"
    },
    {
     "description": "INTERNATIONAL GENERAL-CW25",
     "symbol": "IGICW"
    },
    {
     "description": "IGM FINANCIAL INC",
     "symbol": "IGIFF"
    },
    {
     "description": "ISHARES 10+ YEAR INV GR CORP",
     "symbol": "IGLB"
    },
    {
     "description": "FT CBOE VEST GOLD STRATEGY T",
     "symbol": "IGLD"
    },
    {
     "description": "INTERNET GOLD-GOLDEN LINES",
     "symbol": "IGLDF"
    },
    {
     "description": "ISHARES EXPANDED TECH SECTOR",
     "symbol": "IGM"
    },
    {
     "description": "IGM BIOSCIENCES INC",
     "symbol": "IGMS"
    },
    {
     "description": "ISHARES NORTH AMERICAN TECH-",
     "symbol": "IGN"
    },
    {
     "description": "IGENE BIOTECHNOLOGY INC",
     "symbol": "IGNE"
    },
    {
     "description": "INGEN TECHNOLOGIES INC",
     "symbol": "IGNT"
    },
    {
     "description": "IGNYTE ACQUISITION CORP",
     "symbol": "IGNY"
    },
    {
     "description": "IGNYTE ACQUISITION CORP",
     "symbol": "IGNYU"
    },
    {
     "description": "IGNYTE ACQUISITION -CW27",
     "symbol": "IGNYW"
    },
    {
     "description": "ISHARES INTERNATIONAL TREASU",
     "symbol": "IGOV"
    },
    {
     "description": "IMPERIAL GINSENG PRODUCTS",
     "symbol": "IGPFF"
    },
    {
     "description": "IGNIS PETROLEUM GROUP INC",
     "symbol": "IGPG"
    },
    {
     "description": "INTEGRATED CANNABIS SOLUTION",
     "symbol": "IGPK"
    },
    {
     "description": "IMPELLAM GROUP PLC",
     "symbol": "IGPPF"
    },
    {
     "description": "ARGOSY PROPERTY LTD",
     "symbol": "IGPYF"
    },
    {
     "description": "CBRE GLOBAL REAL ESTATE INCO",
     "symbol": "IGR"
    },
    {
     "description": "ISHARES GLOBAL REAL ESTATE I",
     "symbol": "IGREF"
    },
    {
     "description": "ISHARES INTL DIV GROWTH ETF",
     "symbol": "IGRO"
    },
    {
     "description": "INTERNATIONAL GOLD RESOURCES",
     "symbol": "IGRU"
    },
    {
     "description": "INTERACTIVE HEALTH NETWORK",
     "symbol": "IGRW"
    },
    {
     "description": "ISHARES 1-5Y INV GRADE CORP",
     "symbol": "IGSB"
    },
    {
     "description": "IGS CAPITAL GROUP LTD",
     "symbol": "IGSC"
    },
    {
     "description": "INTERNATIONAL GAME TECHNOLOG",
     "symbol": "IGT"
    },
    {
     "description": "INCEPTION GROWTH ACQUISITION",
     "symbol": "IGTA"
    },
    {
     "description": "INCEPTION GROWTH ACQ LTD -RT",
     "symbol": "IGTAR"
    },
    {
     "description": "INCEPTION GROWTH ACQUISITION",
     "symbol": "IGTAU"
    },
    {
     "description": "INCEPTION GROWTH ACQ -23",
     "symbol": "IGTAW"
    },
    {
     "description": "IGUATEMI EMP DE SHOPPING",
     "symbol": "IGUEF"
    },
    {
     "description": "ISHARES EXPANDED TECH-SOFTWA",
     "symbol": "IGV"
    },
    {
     "description": "INTELGENX TECHNOLOGIES CORP",
     "symbol": "IGXT"
    },
    {
     "description": "TEST",
     "symbol": "IGZ"
    },
    {
     "description": "IHUMAN INC",
     "symbol": "IH"
    },
    {
     "description": "INNOVATIVE HOLDINGS ALLIANCE",
     "symbol": "IHAI"
    },
    {
     "description": "ISHARES CYBERSECURITY & TECH",
     "symbol": "IHAK"
    },
    {
     "description": "ISHARES MSCI CANADA ACC",
     "symbol": "IHCNF"
    },
    {
     "description": "INCHCAPE PLC",
     "symbol": "IHCPF"
    },
    {
     "description": "VOYA EMRG MRKTS HI INC DVD",
     "symbol": "IHD"
    },
    {
     "description": "WISDOMTREE INTERNATIONAL HED",
     "symbol": "IHDG"
    },
    {
     "description": "ISHARES US PHARMACEUTICALS E",
     "symbol": "IHE"
    },
    {
     "description": "IHEARTMEDIA INC - CLASS-CW39",
     "symbol": "IHETW"
    },
    {
     "description": "ISHARES U.S. HEALTHCARE PROV",
     "symbol": "IHF"
    },
    {
     "description": "INTERCONTINENTAL HOTELS-ADR",
     "symbol": "IHG"
    },
    {
     "description": "INTERACT HOLDINGS GROUP INC",
     "symbol": "IHGP"
    },
    {
     "description": "ISHARES US AGG BND USD DIST",
     "symbol": "IHHFF"
    },
    {
     "description": "IHH HEALTHCARE BHD",
     "symbol": "IHHHF"
    },
    {
     "description": "ISHARES MSCI PACIFIC EX-JPN",
     "symbol": "IHHSF"
    },
    {
     "description": "ISHARES U.S. MEDICAL DEVICES",
     "symbol": "IHI"
    },
    {
     "description": "IHI CORP",
     "symbol": "IHICF"
    },
    {
     "description": "IHI CORP-UNSP ADR",
     "symbol": "IHICY"
    },
    {
     "description": "ISHARES MSCI EM SMALL CAP",
     "symbol": "IHIHF"
    },
    {
     "description": "ISHARES CORE EURO STOXX 50",
     "symbol": "IHIIF"
    },
    {
     "description": "INVESCO HI INC 2023 TRGT TRM",
     "symbol": "IHIT"
    },
    {
     "description": "INTERNATIONAL BETHLEHEM MINI",
     "symbol": "IHLHF"
    },
    {
     "description": "INCANNEX HEALTHCARE LTD",
     "symbol": "IHLXF"
    },
    {
     "description": "ISHARES CORE S&P 500",
     "symbol": "IHPCF"
    },
    {
     "description": "ISHARES EURO INFL-LKD GOVT",
     "symbol": "IHPSF"
    },
    {
     "description": "ISHARES MSCI EUROPE EX-UK",
     "symbol": "IHPXF"
    },
    {
     "description": "ISHARES CORE MSCI JAPAN",
     "symbol": "IHREF"
    },
    {
     "description": "ISHARES MSCI JAPAN",
     "symbol": "IHRMF"
    },
    {
     "description": "ISHARES CHINA LARGE CAP",
     "symbol": "IHRPF"
    },
    {
     "description": "IHEARTMEDIA INC - CLASS A",
     "symbol": "IHRT"
    },
    {
     "description": "IHEARTMEDIA INC - CLASS B",
     "symbol": "IHRTB"
    },
    {
     "description": "IHS HOLDING LTD",
     "symbol": "IHS"
    },
    {
     "description": "ISHARES ASIA PAC DIVIDEND",
     "symbol": "IHSEF"
    },
    {
     "description": "ISHARES USD TIPS",
     "symbol": "IHSFF"
    },
    {
     "description": "ISHARES EDGE S&P500 MIN VOL",
     "symbol": "IHSRF"
    },
    {
     "description": "INTERNATIONAL HOUSEWARES RET",
     "symbol": "IHSWF"
    },
    {
     "description": "ISHARES MSCI NORTH AMERICA",
     "symbol": "IHSXF"
    },
    {
     "description": "ISHARES MSCI EM LATAM",
     "symbol": "IHSZF"
    },
    {
     "description": "INNSUITES HOSPITALITY TRUST",
     "symbol": "IHT"
    },
    {
     "description": "INVESCO HI INC 2024 TRGT TRM",
     "symbol": "IHTA"
    },
    {
     "description": "INTEGRATIVE HEALTH TECHNOLOG",
     "symbol": "IHTI"
    },
    {
     "description": "ISHARES TRSY 1-3YR USD ACC B",
     "symbol": "IHVPF"
    },
    {
     "description": "VANECK INT HIGH YIELD BOND",
     "symbol": "IHY"
    },
    {
     "description": "INVESCO HIGH YIELD BOND FACT",
     "symbol": "IHYF"
    },
    {
     "description": "CHINA INTELLIGENCE INFORMATI",
     "symbol": "IICN"
    },
    {
     "description": "IGO LTD-SPONS ADR",
     "symbol": "IIDDY"
    },
    {
     "description": "MORGAN STANLEY INDIA INVEST",
     "symbol": "IIF"
    },
    {
     "description": "INDUSTRIAL & INFRASTRUCTURE",
     "symbol": "IIFIF"
    },
    {
     "description": "INVESCO INV GRADE DEFENSIVE",
     "symbol": "IIGD"
    },
    {
     "description": "INVESCO INVEST GRADE VALUE",
     "symbol": "IIGV"
    },
    {
     "description": "INFORMATION SERVICES GROUP",
     "symbol": "III"
    },
    {
     "description": "INSU ACQUISITION CORP III-A",
     "symbol": "IIII"
    },
    {
     "description": "INSU ACQUISITION CORP III",
     "symbol": "IIIIU"
    },
    {
     "description": "INSU ACQUISITION III -CW26",
     "symbol": "IIIIW"
    },
    {
     "description": "INSTEEL INDUSTRIES INC",
     "symbol": "IIIN"
    },
    {
     "description": "I3 VERTICALS INC-CLASS A",
     "symbol": "IIIV"
    },
    {
     "description": "INTERNET INITIATIVE JAPAN",
     "symbol": "IIJIF"
    },
    {
     "description": "INTERNET INITIATIVE-SPON ADR",
     "symbol": "IIJIY"
    },
    {
     "description": "IINO KAIUN KAISHA LTD",
     "symbol": "IIKKF"
    },
    {
     "description": "INVESCO VALUE MUNICIPAL INCO",
     "symbol": "IIM"
    },
    {
     "description": "INTRICON CORP",
     "symbol": "IIN"
    },
    {
     "description": "INTEGRA INDOCABINET TBK PT",
     "symbol": "IINDF"
    },
    {
     "description": "INSPIRA TECHNOLOGIES OXY BHN",
     "symbol": "IINN"
    },
    {
     "description": "INSPIRA TECH OXY BHN -CW26",
     "symbol": "IINNW"
    },
    {
     "description": "IONIX TECHNOLOGY INC",
     "symbol": "IINX"
    },
    {
     "description": "INNOVATIVE INDUSTRIAL PROPER",
     "symbol": "IIPR"
    },
    {
     "description": "INNOVATIVE INDUSTRIAL",
     "symbol": "IIPR.PRA"
    },
    {
     "description": "INTERRENT REAL ESTATE INVEST",
     "symbol": "IIPZF"
    },
    {
     "description": "ISHARES EDGE MSCI USA MMNTM",
     "symbol": "IIQPF"
    },
    {
     "description": "ISF EDGE S&P500 MINVOL USD-D",
     "symbol": "IIQSF"
    },
    {
     "description": "ISHARES MSCI WORLD",
     "symbol": "IIREF"
    },
    {
     "description": "ISHARES GLBL INFRASTRUCTURE",
     "symbol": "IISGF"
    },
    {
     "description": "ISHARES JPM EM LCL GOV BND",
     "symbol": "IISHF"
    },
    {
     "description": "ISHARES ASIA PROPERTY YIELD",
     "symbol": "IISRF"
    },
    {
     "description": "INTESA SANPAOLO",
     "symbol": "IITSF"
    },
    {
     "description": "II-VI INC",
     "symbol": "IIVI"
    },
    {
     "description": "II-VI INC",
     "symbol": "IIVIP"
    },
    {
     "description": "ISHARES AUTOMATION&ROBOTIC-A",
     "symbol": "IIVPF"
    },
    {
     "description": "ISHARES GLOBAL GOV BND-ACC",
     "symbol": "IIXFF"
    },
    {
     "description": "ISHARES USD CORP ESG-USD ACC",
     "symbol": "IIXXF"
    },
    {
     "description": "INNOVATOR INTERNATIONAL DEVE",
     "symbol": "IJAN"
    },
    {
     "description": "ISHARES CORE S&P MIDCAP ETF",
     "symbol": "IJH"
    },
    {
     "description": "ISHARES S&P MID-CAP 400 VALU",
     "symbol": "IJJ"
    },
    {
     "description": "IJJ CORP",
     "symbol": "IJJP"
    },
    {
     "description": "ISHARES S&P MID-CAP 400 GROW",
     "symbol": "IJK"
    },
    {
     "description": "ISHARES JPM USD EM BND MXNHA",
     "symbol": "IJPBF"
    },
    {
     "description": "ISHARES CORE S&P SMALL-CAP E",
     "symbol": "IJR"
    },
    {
     "description": "ISHARES S&P SMALL-CAP 600 VA",
     "symbol": "IJS"
    },
    {
     "description": "ISHARES EURO CORP LARGE CAP",
     "symbol": "IJSHF"
    },
    {
     "description": "ISHARES S&P SMALL-CAP 600 GR",
     "symbol": "IJT"
    },
    {
     "description": "INNOVATOR INTERNATIONAL DEVE",
     "symbol": "IJUL"
    },
    {
     "description": "IKEGPS GROUP LTD",
     "symbol": "IKGPF"
    },
    {
     "description": "INTELAKARE MARKETING INC",
     "symbol": "IKMA"
    },
    {
     "description": "IKENA ONCOLOGY INC",
     "symbol": "IKNA"
    },
    {
     "description": "INHIBIKASE THERAPEUTICS INC",
     "symbol": "IKT"
    },
    {
     "description": "ITOKK INC",
     "symbol": "IKTO"
    },
    {
     "description": "INTERTEK GROUP PLC",
     "symbol": "IKTSF"
    },
    {
     "description": "INTERTEK GROUP PLC-UNSP ADR",
     "symbol": "IKTSY"
    },
    {
     "description": "INTERNATIONAL LAND ALLIANCE",
     "symbol": "ILAL"
    },
    {
     "description": "ISHARES MORNINGSTAR U.S. EQU",
     "symbol": "ILCB"
    },
    {
     "description": "ISHARES MORNINGSTAR GROWTH E",
     "symbol": "ILCG"
    },
    {
     "description": "ISHARES MORNINGSTAR VALUE ET",
     "symbol": "ILCV"
    },
    {
     "description": "INSPIRATION LEAD CO INC-CL A",
     "symbol": "ILDIA"
    },
    {
     "description": "INTERNATIONAL DALECO CORP",
     "symbol": "ILDO"
    },
    {
     "description": "FIRST TRUST INNOVATION LEADE",
     "symbol": "ILDR"
    },
    {
     "description": "ISHARES LATIN AMERICA 40 ETF",
     "symbol": "ILF"
    },
    {
     "description": "INTERNATIONAL LITHIUM CORP",
     "symbol": "ILHMF"
    },
    {
     "description": "ILIAD SA",
     "symbol": "ILIAF"
    },
    {
     "description": "ILIKA PLC",
     "symbol": "ILIKF"
    },
    {
     "description": "IL2M INTERNATIONAL CORP",
     "symbol": "ILIM"
    },
    {
     "description": "ILUKA RESOURCES LTD",
     "symbol": "ILKAF"
    },
    {
     "description": "ILUKA RESOURCES LTD-UNSP ADR",
     "symbol": "ILKAY"
    },
    {
     "description": "ILLUMINA INC",
     "symbol": "ILMN"
    },
    {
     "description": "PERMANENT TSB GROUP HOLDINGS",
     "symbol": "ILPMF"
    },
    {
     "description": "PERMANENT TSB GROU-NSPON ADR",
     "symbol": "ILPMY"
    },
    {
     "description": "INDUSTRIAL LOGISTICS PROPERT",
     "symbol": "ILPT"
    },
    {
     "description": "INTERNATIONAL STAR INC",
     "symbol": "ILST"
    },
    {
     "description": "ISHARES CORE 10+ YEAR USD BO",
     "symbol": "ILTB"
    },
    {
     "description": "ILUSTRATO PICTURES INTERNATI",
     "symbol": "ILUS"
    },
    {
     "description": "ILLOVO SUGAR LTD",
     "symbol": "ILVOF"
    },
    {
     "description": "INTERNATIONAL LUXURY PRODUCT",
     "symbol": "ILXP"
    },
    {
     "description": "I-MAB-SPONSORED ADR",
     "symbol": "IMAB"
    },
    {
     "description": "IMAC HOLDINGS INC",
     "symbol": "IMAC"
    },
    {
     "description": "IMAC HOLDINGS INC - 24",
     "symbol": "IMACW"
    },
    {
     "description": "I-MINERALS INC",
     "symbol": "IMAHF"
    },
    {
     "description": "INTERNATIONAL MEDIA ACQ-A",
     "symbol": "IMAQ"
    },
    {
     "description": "INTERNATIONAL MEDIA ACQ-RTS",
     "symbol": "IMAQR"
    },
    {
     "description": "INTERNATIONAL MEDIA ACQUISIT",
     "symbol": "IMAQU"
    },
    {
     "description": "INTERNATIONAL MEDIA AC -CW28",
     "symbol": "IMAQW"
    },
    {
     "description": "ISH S&P500 MATERIALS",
     "symbol": "IMATF"
    },
    {
     "description": "IMAX CORP",
     "symbol": "IMAX"
    },
    {
     "description": "IMPERIAL BRANDS PLC",
     "symbol": "IMBBF"
    },
    {
     "description": "IMPERIAL BRANDS PLC-SPON ADR",
     "symbol": "IMBBY"
    },
    {
     "description": "IMEDIA BRANDS INC",
     "symbol": "IMBI"
    },
    {
     "description": "IMEDIA BRANDS INC",
     "symbol": "IMBIL"
    },
    {
     "description": "ISHARES US MBS USD ACC",
     "symbol": "IMBXF"
    },
    {
     "description": "ISHARES MORNINGSTAR MID-CAP",
     "symbol": "IMCB"
    },
    {
     "description": "IM CANNABIS CORP",
     "symbol": "IMCC"
    },
    {
     "description": "IMCD GROUP NV - UNSP ADR",
     "symbol": "IMCDY"
    },
    {
     "description": "ISHARES MORNINGSTAR MID-CAP",
     "symbol": "IMCG"
    },
    {
     "description": "INFINITE GROUP INC",
     "symbol": "IMCI"
    },
    {
     "description": "IMMUNOCORE HOLDINGS PLC-ADR",
     "symbol": "IMCR"
    },
    {
     "description": "INDUSTRIA MACCHINE AUTOMATIC",
     "symbol": "IMCUF"
    },
    {
     "description": "ISHARES MORNINGSTAR MID-CAP",
     "symbol": "IMCV"
    },
    {
     "description": "IMDEX LTD",
     "symbol": "IMDXF"
    },
    {
     "description": "IMCD NV",
     "symbol": "IMDZF"
    },
    {
     "description": "FIRST TRUST S-NETWORK HEALTH",
     "symbol": "IMED"
    },
    {
     "description": "IMAGIN MEDICAL INC",
     "symbol": "IMEXF"
    },
    {
     "description": "INVESCO INT DVLP DYN MULTI",
     "symbol": "IMFL"
    },
    {
     "description": "IMAGINON INC",
     "symbol": "IMGI"
    },
    {
     "description": "IMAGE INTERNATIONAL GROUP IN",
     "symbol": "IMGL"
    },
    {
     "description": "IMMUNOGEN INC",
     "symbol": "IMGN"
    },
    {
     "description": "IMAGO BIOSCIENCES INC",
     "symbol": "IMGO"
    },
    {
     "description": "IMAGE METRICS INC",
     "symbol": "IMGX"
    },
    {
     "description": "IMPAC MORTGAGE HOLDINGS INC",
     "symbol": "IMH"
    },
    {
     "description": "IMPERALIS HOLDING CORP",
     "symbol": "IMHC"
    },
    {
     "description": "ISETAN MITSUKOSHI HOLDINGS L",
     "symbol": "IMHDF"
    },
    {
     "description": "ISETAN MITSUKOSHI-UNSP ADR",
     "symbol": "IMHDY"
    },
    {
     "description": "IMI PLC",
     "symbol": "IMIAF"
    },
    {
     "description": "IMI PLC-SPONSORED ADR",
     "symbol": "IMIAY"
    },
    {
     "description": "INCEPTION MINING INC",
     "symbol": "IMII"
    },
    {
     "description": "INTERRA COPPER CORP",
     "symbol": "IMIMF"
    },
    {
     "description": "IMERJN INC",
     "symbol": "IMJN"
    },
    {
     "description": "IMAGEXPRES CORP",
     "symbol": "IMJX"
    },
    {
     "description": "IMMEDIATEK INC",
     "symbol": "IMKI"
    },
    {
     "description": "INGLES MARKETS INC-CLASS A",
     "symbol": "IMKTA"
    },
    {
     "description": "INVESCO PREF SHARES DIST",
     "symbol": "IMKXF"
    },
    {
     "description": "IPATH S&P MLP ETN",
     "symbol": "IMLP"
    },
    {
     "description": "IMMUNOTECH LABORATORIES INC",
     "symbol": "IMMB"
    },
    {
     "description": "OMNI BRIDGEWAY LTD",
     "symbol": "IMMFF"
    },
    {
     "description": "IMMAGE BIOTHERAPEUTICS CORP",
     "symbol": "IMMG"
    },
    {
     "description": "IMMUTEP LTD-SP ADR",
     "symbol": "IMMP"
    },
    {
     "description": "IMMUPHARMA PLC",
     "symbol": "IMMPF"
    },
    {
     "description": "IMMOBILIARE GRANDE DISTRIBUZ",
     "symbol": "IMMQF"
    },
    {
     "description": "IMMERSION CORPORATION",
     "symbol": "IMMR"
    },
    {
     "description": "IMMUNOVIA AB",
     "symbol": "IMMVF"
    },
    {
     "description": "IMMIX BIOPHARMA INC",
     "symbol": "IMMX"
    },
    {
     "description": "IMING CORP",
     "symbol": "IMNG"
    },
    {
     "description": "IMMUNOME INC",
     "symbol": "IMNM"
    },
    {
     "description": "IMMUNE PHARMACEUTICALS INC",
     "symbol": "IMNPQ"
    },
    {
     "description": "IMINT IMAGE INTELLIGENCE AB",
     "symbol": "IMNTF"
    },
    {
     "description": "IMPERIAL OIL LTD",
     "symbol": "IMO"
    },
    {
     "description": "ALPHA INTL QUANT MOM ETF",
     "symbol": "IMOM"
    },
    {
     "description": "CHIPMOS TECHNOLOGIES INC-ADR",
     "symbol": "IMOS"
    },
    {
     "description": "IMPERIAL HELIUM CORP",
     "symbol": "IMPHF"
    },
    {
     "description": "Impac Mortgage Holdings Inc",
     "symbol": "IMPHO"
    },
    {
     "description": "Impac Mortgage Holdings Inc",
     "symbol": "IMPHP"
    },
    {
     "description": "WEBUILD SPA-UN ADR",
     "symbol": "IMPJY"
    },
    {
     "description": "IMPEL NEUROPHARMA INC",
     "symbol": "IMPL"
    },
    {
     "description": "IMPERIAL MINING GROUP LTD",
     "symbol": "IMPNF"
    },
    {
     "description": "IMPERIAL PETROLEUM INC",
     "symbol": "IMPP"
    },
    {
     "description": "INVESCO PREFERRED SHRS ACC",
     "symbol": "IMPPF"
    },
    {
     "description": "IMPERIAL PETROLEUM INC",
     "symbol": "IMPPP"
    },
    {
     "description": "INVESCO US REAL ESTATE S&P",
     "symbol": "IMPRF"
    },
    {
     "description": "IMPALA PLATINUM HOLDINGS LTD",
     "symbol": "IMPUF"
    },
    {
     "description": "IMPALA PLATINUM-SPON ADR",
     "symbol": "IMPUY"
    },
    {
     "description": "AEA-BRIDGES IMPACT CORP-CL A",
     "symbol": "IMPX"
    },
    {
     "description": "AEA-BRIDGES IMPACT CORP",
     "symbol": "IMPX.U"
    },
    {
     "description": "AEA-BRIDGES IMPACT COR -CW25",
     "symbol": "IMPX.WS"
    },
    {
     "description": "IMPLANET SA - SPON ADR",
     "symbol": "IMPZY"
    },
    {
     "description": "INMOBILIARIA COLONIAL SOCIMI",
     "symbol": "IMQCF"
    },
    {
     "description": "IMARA INC",
     "symbol": "IMRA"
    },
    {
     "description": "IMMURON LTD-SPON ADR",
     "symbol": "IMRN"
    },
    {
     "description": "IMMURON LTD-CW22",
     "symbol": "IMRNW"
    },
    {
     "description": "IMRIS INC",
     "symbol": "IMRSQ"
    },
    {
     "description": "IOMART GROUP PLC",
     "symbol": "IMRTF"
    },
    {
     "description": "IMMUNEERING CORP - CLASS A",
     "symbol": "IMRX"
    },
    {
     "description": "ISH S&P500 CONSUMER STAPLES",
     "symbol": "IMSBF"
    },
    {
     "description": "IShares VII Plc",
     "symbol": "IMSCF"
    },
    {
     "description": "ISHARES CORE MSCI EUROPE",
     "symbol": "IMSEF"
    },
    {
     "description": "ISHARES GLOBAL CLEAN ENERGY",
     "symbol": "IMSIF"
    },
    {
     "description": "IMASEN ELECTRIC INDUSTRIAL",
     "symbol": "IMSNF"
    },
    {
     "description": "ISH S&P500 INDUSTRIALS",
     "symbol": "IMSXF"
    },
    {
     "description": "ISHARES CORE 5-10 YEAR USD",
     "symbol": "IMTB"
    },
    {
     "description": "INTEGRATED MEDIA TECHNOLOGY",
     "symbol": "IMTE"
    },
    {
     "description": "INNOVATIVE MEDTECH INC",
     "symbol": "IMTH"
    },
    {
     "description": "IMAGE PROTECT INC",
     "symbol": "IMTL"
    },
    {
     "description": "ISHARES MSCI INTL MOMENTUM F",
     "symbol": "IMTM"
    },
    {
     "description": "INTERMETRO COMMUNICATIONS",
     "symbol": "IMTO"
    },
    {
     "description": "INTERACTIVE MOTORSPORTS & EN",
     "symbol": "IMTS"
    },
    {
     "description": "IMAGINATION TV INC",
     "symbol": "IMTV"
    },
    {
     "description": "IMMATICS NV",
     "symbol": "IMTX"
    },
    {
     "description": "IMMATICS NV -CW",
     "symbol": "IMTXW"
    },
    {
     "description": "IMMUNOCELLULAR THERAPEUTICS",
     "symbol": "IMUC"
    },
    {
     "description": "IMMUNE THERAPEUTICS INC",
     "symbol": "IMUN"
    },
    {
     "description": "IMMUNIC INC",
     "symbol": "IMUX"
    },
    {
     "description": "IMV INC",
     "symbol": "IMV"
    },
    {
     "description": "IMMUNOVANT INC",
     "symbol": "IMVT"
    },
    {
     "description": "ISHARES MSCI WORLD ESG SCRND",
     "symbol": "IMWEF"
    },
    {
     "description": "ISHARES MSCI WLD SMALL CAP",
     "symbol": "IMWSF"
    },
    {
     "description": "IMAX CHINA HOLDING INC",
     "symbol": "IMXCF"
    },
    {
     "description": "INTERNATIONAL MONEY EXPRESS",
     "symbol": "IMXI"
    },
    {
     "description": "IMPAX ENVIRONMENTAL MARKETS",
     "symbol": "IMXXF"
    },
    {
     "description": "IMERYS SA",
     "symbol": "IMYSF"
    },
    {
     "description": "IMERYS SA-UNSPON ADR",
     "symbol": "IMYSY"
    },
    {
     "description": "IN8BIO INC",
     "symbol": "INAB"
    },
    {
     "description": "INSIGHT ACQUISITION CORP-A",
     "symbol": "INAQ"
    },
    {
     "description": "INSIGHT ACQUISITION CORP",
     "symbol": "INAQ.U"
    },
    {
     "description": "INSIGHT ACQUISITION CO -CW23",
     "symbol": "INAQ.WS"
    },
    {
     "description": "INTERNETARRAY INC",
     "symbol": "INAR"
    },
    {
     "description": "INBANKSHARES CORP",
     "symbol": "INBC"
    },
    {
     "description": "INFUSION BRANDS INTERNATIONA",
     "symbol": "INBI"
    },
    {
     "description": "FIRST INTERNET BANCORP",
     "symbol": "INBK"
    },
    {
     "description": "FIRST INTERNET BANCORP",
     "symbol": "INBKZ"
    },
    {
     "description": "INTEGRATED BIOPHARMA INC",
     "symbol": "INBP"
    },
    {
     "description": "INBIT CORP",
     "symbol": "INBT"
    },
    {
     "description": "INHIBRX INC",
     "symbol": "INBX"
    },
    {
     "description": "INCA ONE GOLD CORP",
     "symbol": "INCAF"
    },
    {
     "description": "INTERNATIONAL CONSOLIDATED",
     "symbol": "INCC"
    },
    {
     "description": "COLUMBIA INDIA CONSUMER ETF",
     "symbol": "INCO"
    },
    {
     "description": "INNOCARE PHARMA LTD",
     "symbol": "INCPF"
    },
    {
     "description": "INTERCURE LTD",
     "symbol": "INCR"
    },
    {
     "description": "INCAPTA INC",
     "symbol": "INCT"
    },
    {
     "description": "INCYTE CORP",
     "symbol": "INCY"
    },
    {
     "description": "INCITEC PIVOT LTD-SPONS ADR",
     "symbol": "INCZY"
    },
    {
     "description": "ISHARES MSCI INDIA ETF",
     "symbol": "INDA"
    },
    {
     "description": "INDEPENDENT BANK CORP\/MA",
     "symbol": "INDB"
    },
    {
     "description": "NIFTY INDIA FINANCIALS ETF",
     "symbol": "INDF"
    },
    {
     "description": "INDOFOOD AGRI RESOURCES LTD",
     "symbol": "INDFF"
    },
    {
     "description": "INDOFOOD AGRI RES-UNSP ADR",
     "symbol": "INDFY"
    },
    {
     "description": "INDUS HOLDING AG",
     "symbol": "INDHF"
    },
    {
     "description": "INDIE SEMICONDUCTOR INC-A",
     "symbol": "INDI"
    },
    {
     "description": "INDIE SEMICONDUCTOR INC",
     "symbol": "INDIW"
    },
    {
     "description": "DIREXION DAILY MSCI INDIA BU",
     "symbol": "INDL"
    },
    {
     "description": "INDORAMA VENTURES PCL",
     "symbol": "INDMF"
    },
    {
     "description": "INDUSTRIAL MINERALS LIMITED",
     "symbol": "INDNF"
    },
    {
     "description": "INDONESIA ENERGY CORP LTD",
     "symbol": "INDO"
    },
    {
     "description": "INDORAMA VENTURES-UNSPON ADR",
     "symbol": "INDOY"
    },
    {
     "description": "INDAPTUS THERAPEUTICS INC",
     "symbol": "INDP"
    },
    {
     "description": "INNOVADERMA PLC",
     "symbol": "INDPF"
    },
    {
     "description": "INDIE RANCH MEDIA INC",
     "symbol": "INDR"
    },
    {
     "description": "PACER BENCHMARK INDUSTRIAL",
     "symbol": "INDS"
    },
    {
     "description": "INDUS REALTY TRUST INC",
     "symbol": "INDT"
    },
    {
     "description": "ISHARES INDIA 50 ETF",
     "symbol": "INDY"
    },
    {
     "description": "INEO TECH CORP",
     "symbol": "INEOF"
    },
    {
     "description": "INFORMATICA INC - CLASS A",
     "symbol": "INFA"
    },
    {
     "description": "Intact Financial Corporation",
     "symbol": "INFFF"
    },
    {
     "description": "INFINITY PHARMACEUTICALS INC",
     "symbol": "INFI"
    },
    {
     "description": "HORIZON KINETICS INFL BENEF",
     "symbol": "INFL"
    },
    {
     "description": "INFINERA CORP",
     "symbol": "INFN"
    },
    {
     "description": "INFINITY BANK",
     "symbol": "INFT"
    },
    {
     "description": "INFUSYSTEM HOLDINGS INC",
     "symbol": "INFU"
    },
    {
     "description": "INFINEX VENTURES INC",
     "symbol": "INFX"
    },
    {
     "description": "INFOSYS LTD-SP ADR",
     "symbol": "INFY"
    },
    {
     "description": "ING GROEP N.V.-SPONSORED ADR",
     "symbol": "ING"
    },
    {
     "description": "INGENIA COMMUNITIES GROUP",
     "symbol": "INGEF"
    },
    {
     "description": "INGENTA PLC",
     "symbol": "INGLF"
    },
    {
     "description": "INOGEN INC",
     "symbol": "INGN"
    },
    {
     "description": "INTERNATIONAL PROFESSIONAL T",
     "symbol": "INGP"
    },
    {
     "description": "INGREDION INC",
     "symbol": "INGR"
    },
    {
     "description": "ING GROEP NV",
     "symbol": "INGVF"
    },
    {
     "description": "INNERGEX RENEWABLE ENERGY",
     "symbol": "INGXF"
    },
    {
     "description": "INNOLOG HOLDINGS CORP",
     "symbol": "INHC"
    },
    {
     "description": "INTERNATIONAL ISOTOPES INC",
     "symbol": "INIS"
    },
    {
     "description": "ISHARES CORE CANADIAN SHORT",
     "symbol": "INITF"
    },
    {
     "description": "IFINIX CORP",
     "symbol": "INIX"
    },
    {
     "description": "INTRUM AB",
     "symbol": "INJJF"
    },
    {
     "description": "KLUDEIN I ACQUISITION CORP-A",
     "symbol": "INKA"
    },
    {
     "description": "KLUDEIN I ACQUISITION CORP",
     "symbol": "INKAU"
    },
    {
     "description": "KLUDEIN I ACQUISITION-CW27",
     "symbol": "INKAW"
    },
    {
     "description": "INKY",
     "symbol": "INKI"
    },
    {
     "description": "SPDR SSGA INCOME ALLOCATION",
     "symbol": "INKM"
    },
    {
     "description": "MINK THERAPEUTICS INC",
     "symbol": "INKT"
    },
    {
     "description": "GREENE CONCEPTS INC",
     "symbol": "INKW"
    },
    {
     "description": "ITEM 9 LABS CORP",
     "symbol": "INLB"
    },
    {
     "description": "INTELLINETICS INC",
     "symbol": "INLX"
    },
    {
     "description": "INMED PHARMACEUTICALS INC",
     "symbol": "INM"
    },
    {
     "description": "INMUNE BIO INC",
     "symbol": "INMB"
    },
    {
     "description": "INMODE LTD",
     "symbol": "INMD"
    },
    {
     "description": "INCA MINERALS LTD",
     "symbol": "INMNF"
    },
    {
     "description": "BLACKROCK INTER MUNI INC BND",
     "symbol": "INMU"
    },
    {
     "description": "SUMMIT HOTEL PROPERTIES INC",
     "symbol": "INN"
    },
    {
     "description": "SUMMIT HOTEL PROPERTIES",
     "symbol": "INN.PRE"
    },
    {
     "description": "SUMMIT HOTEL PROPERTIES",
     "symbol": "INN.PRF"
    },
    {
     "description": "INNOVATIVE PHARMACEUTICAL BI",
     "symbol": "INNBF"
    },
    {
     "description": "INNOTECH CORP",
     "symbol": "INNCF"
    },
    {
     "description": "INNERSCOPE HEARING TECHNOLOG",
     "symbol": "INND"
    },
    {
     "description": "INNOVARO INC",
     "symbol": "INNI"
    },
    {
     "description": "AMPLIA THERAPEUTICS LTD",
     "symbol": "INNMF"
    },
    {
     "description": "HARBOR DISRUPTIVE INNOVATION",
     "symbol": "INNO"
    },
    {
     "description": "INNOCAN PHARMA CORP",
     "symbol": "INNPF"
    },
    {
     "description": "INNOVAGE HOLDING CORP",
     "symbol": "INNV"
    },
    {
     "description": "INFINITE NETWORKS CORP",
     "symbol": "INNX"
    },
    {
     "description": "INOVIO PHARMACEUTICALS INC",
     "symbol": "INO"
    },
    {
     "description": "INNODATA INC",
     "symbol": "INOD"
    },
    {
     "description": "IN OVATIONS HOLDINGS INC",
     "symbol": "INOH"
    },
    {
     "description": "TPT STRATEGIC INC",
     "symbol": "INOQ"
    },
    {
     "description": "PREDICTIV AI INC",
     "symbol": "INOTF"
    },
    {
     "description": "INFONOW CORPORATION",
     "symbol": "INOW"
    },
    {
     "description": "International Paper Company",
     "symbol": "INPAP"
    },
    {
     "description": "INPOST SA",
     "symbol": "INPOF"
    },
    {
     "description": "INPOST SA  - UNSP ADR",
     "symbol": "INPOY"
    },
    {
     "description": "INPIXON",
     "symbol": "INPX"
    },
    {
     "description": "INDOOR HARVEST CORP",
     "symbol": "INQD"
    },
    {
     "description": "INQQ INDIA INTERNET AND ECOM",
     "symbol": "INQQ"
    },
    {
     "description": "ISHARES NASDAQ 100 INDEX ETF",
     "symbol": "INQQF"
    },
    {
     "description": "INRAD OPTICS INC",
     "symbol": "INRD"
    },
    {
     "description": "INLAND REAL ESTATE INCOME TR",
     "symbol": "INRE"
    },
    {
     "description": "INRETAIL PERU CORP",
     "symbol": "INREF"
    },
    {
     "description": "INFRONEER HOLDINGS INC",
     "symbol": "INRHF"
    },
    {
     "description": "VALNEVA SE",
     "symbol": "INRLF"
    },
    {
     "description": "INSTADOSE PHARMA CORP",
     "symbol": "INSD"
    },
    {
     "description": "INSPIRED ENTERTAINMENT INC",
     "symbol": "INSE"
    },
    {
     "description": "INSEEGO CORP",
     "symbol": "INSG"
    },
    {
     "description": "INSIGHT SELECT INCOME FUND",
     "symbol": "INSI"
    },
    {
     "description": "INSMED INC",
     "symbol": "INSM"
    },
    {
     "description": "INDUSTRY SOURCE CONSULTING I",
     "symbol": "INSO"
    },
    {
     "description": "INSPIRE MEDICAL SYSTEMS INC",
     "symbol": "INSP"
    },
    {
     "description": "INSTRUCTURE HOLDINGS INC",
     "symbol": "INST"
    },
    {
     "description": "INTERNATIONAL SEAWAYS INC",
     "symbol": "INSW"
    },
    {
     "description": "INTERNATIONAL SEAWAYS IN",
     "symbol": "INSW.PRA"
    },
    {
     "description": "WORLD FUEL SERVICES CORP",
     "symbol": "INT"
    },
    {
     "description": "INTAPP INC",
     "symbol": "INTA"
    },
    {
     "description": "Intact Financial Corporation",
     "symbol": "INTAF"
    },
    {
     "description": "INTEL CORP",
     "symbol": "INTC"
    },
    {
     "description": "INTEGRAL ACQUISITION CORP-A",
     "symbol": "INTE"
    },
    {
     "description": "INTEGRAL ACQUISITION CORP 1",
     "symbol": "INTEU"
    },
    {
     "description": "INTEGRAL ACQUISITION -CW28",
     "symbol": "INTEW"
    },
    {
     "description": "ISHARES MSCI INTERNATIONAL M",
     "symbol": "INTF"
    },
    {
     "description": "INTERGROUP CORP",
     "symbol": "INTG"
    },
    {
     "description": "INNOTECH CORP",
     "symbol": "INTH"
    },
    {
     "description": "INHIBITOR THERAPEUTICS INC",
     "symbol": "INTI"
    },
    {
     "description": "INDUSTRIAL NANOTECH INC",
     "symbol": "INTK"
    },
    {
     "description": "INITIO INC",
     "symbol": "INTO"
    },
    {
     "description": "INTEGRATED PHARMACEUTICALS",
     "symbol": "INTP"
    },
    {
     "description": "INTEST CORP",
     "symbol": "INTT"
    },
    {
     "description": "INTUIT INC",
     "symbol": "INTU"
    },
    {
     "description": "INTEGRATED VENTURES INC",
     "symbol": "INTV"
    },
    {
     "description": "SHARC INTERNATIONAL SYSTEMS",
     "symbol": "INTWF"
    },
    {
     "description": "INTRUSION INC",
     "symbol": "INTZ"
    },
    {
     "description": "INFINITUM COPPER CORP",
     "symbol": "INUMF"
    },
    {
     "description": "INUVO INC",
     "symbol": "INUV"
    },
    {
     "description": "INNOVIVA INC",
     "symbol": "INVA"
    },
    {
     "description": "IDENTIV INC",
     "symbol": "INVE"
    },
    {
     "description": "INVITATION HOMES INC",
     "symbol": "INVH"
    },
    {
     "description": "INTEGRAL VISION INC",
     "symbol": "INVI"
    },
    {
     "description": "INVESCO S&P 500 ACC",
     "symbol": "INVMF"
    },
    {
     "description": "INVO BIOSCIENCE INC",
     "symbol": "INVO"
    },
    {
     "description": "INVESCO US UTILITIES S&P",
     "symbol": "INVPF"
    },
    {
     "description": "INVENTERGY GLOBAL INC",
     "symbol": "INVT"
    },
    {
     "description": "INVESTVIEW INC",
     "symbol": "INVU"
    },
    {
     "description": "Investview Inc",
     "symbol": "INVUP"
    },
    {
     "description": "INDIVIOR PLC-SPON ADR",
     "symbol": "INVVY"
    },
    {
     "description": "INVESCO US MATERIALS S&P",
     "symbol": "INVXF"
    },
    {
     "description": "INNOVIZ TECHNOLOGIES LTD",
     "symbol": "INVZ"
    },
    {
     "description": "INNOVIZ TECHNOLOGIES -CW26",
     "symbol": "INVZW"
    },
    {
     "description": "INX DIGITAL CO INC\/THE",
     "symbol": "INXDF"
    },
    {
     "description": "INTOUCH INSIGHT LTD",
     "symbol": "INXSF"
    },
    {
     "description": "INARI AMERTRON BHD",
     "symbol": "INZRF"
    },
    {
     "description": "INOZYME PHARMA INC",
     "symbol": "INZY"
    },
    {
     "description": "ION GEOPHYSICAL CORP",
     "symbol": "IO"
    },
    {
     "description": "INNOVATIVE INTERNATIONAL A-A",
     "symbol": "IOAC"
    },
    {
     "description": "INNOVATIVE INTERNATIONAL ACQ",
     "symbol": "IOACU"
    },
    {
     "description": "INNOVATIVE INTERNATIONAL ACQ",
     "symbol": "IOACW"
    },
    {
     "description": "ION BEAM APPLICATIONS",
     "symbol": "IOBCF"
    },
    {
     "description": "IO BIOTECH INC",
     "symbol": "IOBT"
    },
    {
     "description": "IOCHPE MAXION S.A.-SP ADR",
     "symbol": "IOCJY"
    },
    {
     "description": "INNOVATOR INT DEV POWER BUFF",
     "symbol": "IOCT"
    },
    {
     "description": "IOWA FIRST BANCSHARES CORP",
     "symbol": "IOFB"
    },
    {
     "description": "INVESCO OFFICE J-REIT INC",
     "symbol": "IOFFF"
    },
    {
     "description": "IOFINA PLC",
     "symbol": "IOFNF"
    },
    {
     "description": "ISHARES OIL & GAS EXPL&PROD",
     "symbol": "IOGEF"
    },
    {
     "description": "IOI CORP BHD",
     "symbol": "IOIOF"
    },
    {
     "description": "ITOKI CORP",
     "symbol": "IOKIF"
    },
    {
     "description": "ISOMET CORP",
     "symbol": "IOMT"
    },
    {
     "description": "IONA ENERGY INC",
     "symbol": "IONAF"
    },
    {
     "description": "ION ENERGY LTD",
     "symbol": "IONGF"
    },
    {
     "description": "I-ON DIGITAL CORP",
     "symbol": "IONI"
    },
    {
     "description": "IONIC BRANDS CORP",
     "symbol": "IONKF"
    },
    {
     "description": "ASSURE HOLDINGS CORP",
     "symbol": "IONM"
    },
    {
     "description": "IONQ INC",
     "symbol": "IONQ"
    },
    {
     "description": "DMY TECH GRP III CL-A -CW26",
     "symbol": "IONQ.WS"
    },
    {
     "description": "IONIS PHARMACEUTICALS INC",
     "symbol": "IONS"
    },
    {
     "description": "ISHARES GLOBAL 100 ETF",
     "symbol": "IOO"
    },
    {
     "description": "INSIGNIA FINANCIAL LTD",
     "symbol": "IOOFF"
    },
    {
     "description": "ISHARES CORE CANADIAN LONG T",
     "symbol": "IOOXF"
    },
    {
     "description": "INCOME OPP REALTY INVESTORS",
     "symbol": "IOR"
    },
    {
     "description": "INNOSPEC INC",
     "symbol": "IOSP"
    },
    {
     "description": "SAMSARA INC-CL A",
     "symbol": "IOT"
    },
    {
     "description": "IOTA COMMUNICATIONS INC",
     "symbol": "IOTC"
    },
    {
     "description": "IOU FINANCIAL INC",
     "symbol": "IOUFF"
    },
    {
     "description": "IOUPAY LTD",
     "symbol": "IOUUF"
    },
    {
     "description": "IOVANCE BIOTHERAPEUTICS INC",
     "symbol": "IOVA"
    },
    {
     "description": "INTERVEST OFFICES & WAREHOUS",
     "symbol": "IOWFF"
    },
    {
     "description": "INTERNATIONAL PAPER CO",
     "symbol": "IP"
    },
    {
     "description": "IMMUNOPRECISE ANTIBODIES LTD",
     "symbol": "IPA"
    },
    {
     "description": "ISHARES CORE MSCI PACIFIC ET",
     "symbol": "IPAC"
    },
    {
     "description": "INTERPHARM HOLDINGS INC",
     "symbol": "IPAH"
    },
    {
     "description": "INTER PARFUMS INC",
     "symbol": "IPAR"
    },
    {
     "description": "INFLECTION POINT ACQUISITI-A",
     "symbol": "IPAX"
    },
    {
     "description": "INFLECTION POINT ACQUISITION",
     "symbol": "IPAXU"
    },
    {
     "description": "INFLECTION POINT ACQUISI-CW",
     "symbol": "IPAXW"
    },
    {
     "description": "ETFMG PRIME MOBILE PAYMENTS",
     "symbol": "IPAY"
    },
    {
     "description": "INDEXPLUS TRUST 2003-1",
     "symbol": "IPB"
    },
    {
     "description": "INTERNATIONAL PETROLEUM CORP",
     "symbol": "IPCFF"
    },
    {
     "description": "INTELLIPHARMACEUTICS INTERNA",
     "symbol": "IPCIF"
    },
    {
     "description": "PROFESSIONAL DIVERSITY NETWO",
     "symbol": "IPDN"
    },
    {
     "description": "DIVIDEND PERFORMERS ETF",
     "symbol": "IPDP"
    },
    {
     "description": "IMPEDIMED LTD",
     "symbol": "IPDQF"
    },
    {
     "description": "IPE UNIVERSAL INC",
     "symbol": "IPEU"
    },
    {
     "description": "INTERNATIONAL PERSONAL FINAN",
     "symbol": "IPFPF"
    },
    {
     "description": "INTERPUBLIC GROUP OF COS INC",
     "symbol": "IPG"
    },
    {
     "description": "IGO LTD",
     "symbol": "IPGDF"
    },
    {
     "description": "IMPERIUM TECHNOLOGY GROUP LT",
     "symbol": "IPGGF"
    },
    {
     "description": "IPG PHOTONICS CORP",
     "symbol": "IPGP"
    },
    {
     "description": "INTERPUMP GROUP SPA-ADR",
     "symbol": "IPGYY"
    },
    {
     "description": "INNATE PHARMA SA-SPONS ADR",
     "symbol": "IPHA"
    },
    {
     "description": "IPH LTD",
     "symbol": "IPHLF"
    },
    {
     "description": "INNATE PHARMA SA",
     "symbol": "IPHYF"
    },
    {
     "description": "INTREPID POTASH INC",
     "symbol": "IPI"
    },
    {
     "description": "IPIC ENTERTAINMENT INC-CL A",
     "symbol": "IPIC"
    },
    {
     "description": "INNOVATION PHARMACEUTICALS I",
     "symbol": "IPIX"
    },
    {
     "description": "IPACKETS INTERNATIONAL INC",
     "symbol": "IPKL"
    },
    {
     "description": "INVESCO INTERNATIONAL BUYBAC",
     "symbol": "IPKW"
    },
    {
     "description": "IMPLENIA AG-REG",
     "symbol": "IPLNF"
    },
    {
     "description": "INTERPLAY ENTERTAINMENT CORP",
     "symbol": "IPLY"
    },
    {
     "description": "INTERNATIONAL PRECIOUS MINER",
     "symbol": "IPMG"
    },
    {
     "description": "IMPERIAL METALS CORP",
     "symbol": "IPMLF"
    },
    {
     "description": "INFORMATION PLANNING CO LTD",
     "symbol": "IPNAF"
    },
    {
     "description": "IMAGINEAR INC",
     "symbol": "IPNFF"
    },
    {
     "description": "RENAISSANCE IPO ETF",
     "symbol": "IPO"
    },
    {
     "description": "INDUSTRIAS PENOLES SAB DE CV",
     "symbol": "IPOAF"
    },
    {
     "description": "SOCIAL CAPITAL HEDOSOPH- A",
     "symbol": "IPOD"
    },
    {
     "description": "SOCIAL CAPITAL HEDOSOPHIA HO",
     "symbol": "IPOD.U"
    },
    {
     "description": "SOCIAL CAPITAL HEDOSOP -CW25",
     "symbol": "IPOD.WS"
    },
    {
     "description": "SOCIAL CAPITAL HEDOSOPH VI-A",
     "symbol": "IPOF"
    },
    {
     "description": "SOCIAL CAPITAL HEDOSOPHIA HO",
     "symbol": "IPOF.U"
    },
    {
     "description": "SOCIAL CAPITAL HED VI - CW25",
     "symbol": "IPOF.WS"
    },
    {
     "description": "INPLAY OIL CORP",
     "symbol": "IPOOF"
    },
    {
     "description": "RENAISSANCE INTL IPO ETF",
     "symbol": "IPOS"
    },
    {
     "description": "ISHARES LISTED PRIVATE EQY",
     "symbol": "IPPIF"
    },
    {
     "description": "PREFERRED-PLUS ETF",
     "symbol": "IPPP"
    },
    {
     "description": "IMPACT MINERALS LTD",
     "symbol": "IPPTF"
    },
    {
     "description": "IMPERIAL RESOURCES INC",
     "symbol": "IPRC"
    },
    {
     "description": "IMPULSORA DEL DESARROLLO Y E",
     "symbol": "IPSBF"
    },
    {
     "description": "CENTURY THERAPEUTICS INC",
     "symbol": "IPSC"
    },
    {
     "description": "IPSEN",
     "symbol": "IPSEF"
    },
    {
     "description": "IPSEN SA-SPONSORED ADR",
     "symbol": "IPSEY"
    },
    {
     "description": "INNOVATIVE PAYMENT SOLUTIONS",
     "symbol": "IPSI"
    },
    {
     "description": "IPSOS",
     "symbol": "IPSOF"
    },
    {
     "description": "AS-IP TECH INC",
     "symbol": "IPTK"
    },
    {
     "description": "INDIEPUB ENTERTAINMENT INC",
     "symbol": "IPUB"
    },
    {
     "description": "INTERPRIVATE II ACQU-CLASS A",
     "symbol": "IPVA"
    },
    {
     "description": "INTERPRIVATE II ACQUISITION",
     "symbol": "IPVA.U"
    },
    {
     "description": "INTERPRIVATE II ACQU -CW28",
     "symbol": "IPVA.WS"
    },
    {
     "description": "INTERPRIVATE III FINANCIAL-A",
     "symbol": "IPVF"
    },
    {
     "description": "INTERPRIVATE III FINANCIAL",
     "symbol": "IPVF.U"
    },
    {
     "description": "INTERPRIVATE III FIN A -CW27",
     "symbol": "IPVF.WS"
    },
    {
     "description": "INTERPRIVATE IV INFRATECH-A",
     "symbol": "IPVI"
    },
    {
     "description": "INTERPRIVATE IV INFRATECH",
     "symbol": "IPVIU"
    },
    {
     "description": "INTERPRIVATE IV INFRAT -CW27",
     "symbol": "IPVIW"
    },
    {
     "description": "IPOWER INC",
     "symbol": "IPW"
    },
    {
     "description": "INTERNATIONAL POWER GROUP LT",
     "symbol": "IPWG"
    },
    {
     "description": "Indianapolis Power and Light",
     "symbol": "IPWLG"
    },
    {
     "description": "Indianapolis Power and Light",
     "symbol": "IPWLK"
    },
    {
     "description": "Indianapolis Power and Light",
     "symbol": "IPWLN"
    },
    {
     "description": "Indianapolis Power and Light",
     "symbol": "IPWLO"
    },
    {
     "description": "Indianapolis Power and Light",
     "symbol": "IPWLP"
    },
    {
     "description": "IDEAL POWER INC",
     "symbol": "IPWR"
    },
    {
     "description": "IMPAX ASSET MANAGEMENT GROUP",
     "symbol": "IPXAF"
    },
    {
     "description": "INPEX CORP",
     "symbol": "IPXHF"
    },
    {
     "description": "INPEX CORP-UNSPON ADR",
     "symbol": "IPXHY"
    },
    {
     "description": "IP GROUP PLC",
     "symbol": "IPZYF"
    },
    {
     "description": "IQIYI INC-ADR",
     "symbol": "IQ"
    },
    {
     "description": "IQ-AI LTD",
     "symbol": "IQAIF"
    },
    {
     "description": "FLEXSHARES-INT QUAL DVD DEFE",
     "symbol": "IQDE"
    },
    {
     "description": "FLEXSHARES-INT QUAL DVD INDE",
     "symbol": "IQDF"
    },
    {
     "description": "WISDOMTREE INTL QLTY DVD GRW",
     "symbol": "IQDG"
    },
    {
     "description": "FLEXSHARES INT QUAL DVD DYN",
     "symbol": "IQDY"
    },
    {
     "description": "IQE PLC",
     "symbol": "IQEPF"
    },
    {
     "description": "IQE PLC-UNSP ADR",
     "symbol": "IQEPY"
    },
    {
     "description": "IQGEO GROUP PLC",
     "symbol": "IQGLF"
    },
    {
     "description": "INVESCO QUALITY MUNI INC TR",
     "symbol": "IQI"
    },
    {
     "description": "IQ 500 INTERNATIONAL ETF",
     "symbol": "IQIN"
    },
    {
     "description": "ISHARES MSCI INTERNATIONAL Q",
     "symbol": "IQLT"
    },
    {
     "description": "FRANKLIN INTELLIGENT MACHINE",
     "symbol": "IQM"
    },
    {
     "description": "INTELLIGENT MEDICINE ACQUI-A",
     "symbol": "IQMD"
    },
    {
     "description": "INTELLIGENT MEDICINE ACQUISI",
     "symbol": "IQMDU"
    },
    {
     "description": "INTELLIGENT MEDICINE -CW23",
     "symbol": "IQMDW"
    },
    {
     "description": "ISH USD CORP INT HDG - USD A",
     "symbol": "IQSHF"
    },
    {
     "description": "IQ CANDRIAM ESG INTERNATIONA",
     "symbol": "IQSI"
    },
    {
     "description": "IQSTEL INC",
     "symbol": "IQST"
    },
    {
     "description": "IQ CANDRIAM ESG US EQUITY ET",
     "symbol": "IQSU"
    },
    {
     "description": "IQVIA HOLDINGS INC",
     "symbol": "IQV"
    },
    {
     "description": "IQ INTERNATIONAL AG",
     "symbol": "IQWLF"
    },
    {
     "description": "INGERSOLL-RAND INC",
     "symbol": "IR"
    },
    {
     "description": "INDORAMA VENTURES-FOREIGN",
     "symbol": "IRAMF"
    },
    {
     "description": "RESPONSIBLE GLOBAL ALLOCATIO",
     "symbol": "IRBA"
    },
    {
     "description": "INROB TECH LTD",
     "symbol": "IRBL"
    },
    {
     "description": "ISHARES ROBOTICS & ARTIFICIA",
     "symbol": "IRBO"
    },
    {
     "description": "IR BIOSCIENCES HOLDINGS INC",
     "symbol": "IRBS"
    },
    {
     "description": "IROBOT CORP",
     "symbol": "IRBT"
    },
    {
     "description": "INDIGENOUS ROOTS CORP",
     "symbol": "IRCC"
    },
    {
     "description": "INTER-ROCK MINERALS INC",
     "symbol": "IRCKF"
    },
    {
     "description": "IRSA PROPIEDADES COMERCI-ADR",
     "symbol": "IRCP"
    },
    {
     "description": "IRISH CONTINENTAL GROUP PLC",
     "symbol": "IRCUF"
    },
    {
     "description": "IRC LTD",
     "symbol": "IRCWF"
    },
    {
     "description": "IREN SPA",
     "symbol": "IRDEF"
    },
    {
     "description": "IREN SPA-UNSPON ADR",
     "symbol": "IRDEY"
    },
    {
     "description": "IRIDIUM COMMUNICATIONS INC",
     "symbol": "IRDM"
    },
    {
     "description": "IRISO ELECTRONICS CO LTD",
     "symbol": "IREEF"
    },
    {
     "description": "INTEGRATED RESEARCH LTD",
     "symbol": "IREHF"
    },
    {
     "description": "ISHARES MSCI EM",
     "symbol": "IREMF"
    },
    {
     "description": "IRIS ENERGY LTD",
     "symbol": "IREN"
    },
    {
     "description": "INTEREP NATL RADIO SALES-A",
     "symbol": "IREP"
    },
    {
     "description": "ISHARES COR FTSE 100-USD H-A",
     "symbol": "IRESF"
    },
    {
     "description": "ISRAS INVESTMENT COMPANY LTD",
     "symbol": "IRICF"
    },
    {
     "description": "IRIDIUM WORLD COMM LTD-CL A",
     "symbol": "IRIDQ"
    },
    {
     "description": "INTEGRATED DRILLING EQUIPMEN",
     "symbol": "IRIG"
    },
    {
     "description": "IRIDEX CORP",
     "symbol": "IRIX"
    },
    {
     "description": "IR JAPAN HOLDINGS LTD",
     "symbol": "IRJHF"
    },
    {
     "description": "NEW IRELAND FUND INC",
     "symbol": "IRL"
    },
    {
     "description": "ISRAEL CORP LIMITED\/THE",
     "symbol": "IRLCF"
    },
    {
     "description": "INTRALOT S.A.-INTEGRATED LOT",
     "symbol": "IRLTF"
    },
    {
     "description": "INTRALOT SA-UNSPONSORED ADR",
     "symbol": "IRLTY"
    },
    {
     "description": "IRON MOUNTAIN INC",
     "symbol": "IRM"
    },
    {
     "description": "IRADIMED CORP",
     "symbol": "IRMD"
    },
    {
     "description": "IR-MED INC",
     "symbol": "IRME"
    },
    {
     "description": "INFORMATION SERVICES CORP",
     "symbol": "IRMTF"
    },
    {
     "description": "INTERNATIONAL RANGER CORP",
     "symbol": "IRNG"
    },
    {
     "description": "IRON ROAD LTD",
     "symbol": "IRNRF"
    },
    {
     "description": "IRONSTONE GROUP INC",
     "symbol": "IRNS"
    },
    {
     "description": "IRONNET INC",
     "symbol": "IRNT"
    },
    {
     "description": "IRONNET INC-CW26",
     "symbol": "IRNT.WS"
    },
    {
     "description": "IF BANCORP INC",
     "symbol": "IROQ"
    },
    {
     "description": "IRPC PCL-UNSP ADR",
     "symbol": "IRPSY"
    },
    {
     "description": "IRRAS AB",
     "symbol": "IRRAF"
    },
    {
     "description": "INTERROLL HOLDING AG-REG",
     "symbol": "IRRHF"
    },
    {
     "description": "ISHARES CORE MSCI WORLD",
     "symbol": "IRRRF"
    },
    {
     "description": "INTEGRATED RAIL AND -CLASS A",
     "symbol": "IRRX"
    },
    {
     "description": "INTEGRATED RAIL AND RESOURCE",
     "symbol": "IRRX.U"
    },
    {
     "description": "INTEGRATED RAIL AND RE -CW23",
     "symbol": "IRRX.WS"
    },
    {
     "description": "IRSA -SP ADR",
     "symbol": "IRS"
    },
    {
     "description": "IRSA INVERSIONES Y REP -CW26",
     "symbol": "IRS.WS"
    },
    {
     "description": "ISHARES CORE S&P\/TSX CAPPED",
     "symbol": "IRSHF"
    },
    {
     "description": "ISH FLN ANGL HY CORP USD ACC",
     "symbol": "IRSIF"
    },
    {
     "description": "ISHARES JPM ESG USD EM BD A",
     "symbol": "IRSJF"
    },
    {
     "description": "IRESS LTD",
     "symbol": "IRSMF"
    },
    {
     "description": "IRSA PROPIEDADES COMERCIALES",
     "symbol": "IRSPF"
    },
    {
     "description": "ISHARES MSCI HLTH CARE-USD D",
     "symbol": "IRSVF"
    },
    {
     "description": "INDEPENDENCE REALTY TRUST IN",
     "symbol": "IRT"
    },
    {
     "description": "IRHYTHM TECHNOLOGIES INC",
     "symbol": "IRTC"
    },
    {
     "description": "IRVING RESOURCES INC",
     "symbol": "IRVRF"
    },
    {
     "description": "IRONWOOD PHARMACEUTICALS INC",
     "symbol": "IRWD"
    },
    {
     "description": "Irwin Financial Corporation",
     "symbol": "IRWPQ"
    },
    {
     "description": "ISHARES EUROPE CONS STP EURA",
     "symbol": "IRXTF"
    },
    {
     "description": "IRONSOURCE LTD-A",
     "symbol": "IS"
    },
    {
     "description": "IRON SPARK I INC-A",
     "symbol": "ISAA"
    },
    {
     "description": "ISHARES CORE MSCI EUROPE ACC",
     "symbol": "ISACF"
    },
    {
     "description": "ISHARES EM ASIA LOCAL GOVT",
     "symbol": "ISAGF"
    },
    {
     "description": "ISHARES CORE EM IMI ACC",
     "symbol": "ISAPF"
    },
    {
     "description": "ISHARES CORE CAN UNIV BOND",
     "symbol": "ISARF"
    },
    {
     "description": "ISA INTERNATIONALE INC",
     "symbol": "ISAT"
    },
    {
     "description": "ISABELLA BANK CORP",
     "symbol": "ISBA"
    },
    {
     "description": "ISE BLU EQUITY CORP",
     "symbol": "ISBL"
    },
    {
     "description": "ISHARES MORNINGSTAR SMALL-CA",
     "symbol": "ISCB"
    },
    {
     "description": "ISHARES GLOBAL HY CORP-ACC",
     "symbol": "ISCBF"
    },
    {
     "description": "ISRACARD LTD",
     "symbol": "ISCDF"
    },
    {
     "description": "ISHARES MSCI INTERNATIONAL S",
     "symbol": "ISCF"
    },
    {
     "description": "ISHARES MORNINGSTAR SMALL-CA",
     "symbol": "ISCG"
    },
    {
     "description": "ISH DIVERS COMMOD SWAP ETF",
     "symbol": "ISCMF"
    },
    {
     "description": "ISRACANN BIOSCIENCES INC",
     "symbol": "ISCNF"
    },
    {
     "description": "INTERNATIONAL STEM CELL CORP",
     "symbol": "ISCO"
    },
    {
     "description": "ISHARES GLOBAL CORP USD ACC",
     "symbol": "ISCRF"
    },
    {
     "description": "ISHARES MORNINGSTAR SMALL-CA",
     "symbol": "ISCV"
    },
    {
     "description": "ISHARES USD CORP BOND USD A",
     "symbol": "ISCXF"
    },
    {
     "description": "PGIM HIGH YIELD BOND FUND",
     "symbol": "ISD"
    },
    {
     "description": "ISRAEL DISCOUNT BANK-A",
     "symbol": "ISDAF"
    },
    {
     "description": "ISRAEL DISCOUNT-UNSPON ADR",
     "symbol": "ISDAY"
    },
    {
     "description": "VERIMATRIX SA",
     "symbol": "ISDCF"
    },
    {
     "description": "ISH USD SHRT HY CRP USD ACC",
     "symbol": "ISDDF"
    },
    {
     "description": "ISHARES CANADIAN SELECT",
     "symbol": "ISDJF"
    },
    {
     "description": "ISH DVL MKT PRPTY YLD USD A",
     "symbol": "ISDMF"
    },
    {
     "description": "ISSUER DIRECT CORP",
     "symbol": "ISDR"
    },
    {
     "description": "ISIGN MEDIA SOLUTIONS INC",
     "symbol": "ISDSF"
    },
    {
     "description": "INVESCO RAFI STRATEGIC DEVE",
     "symbol": "ISDX"
    },
    {
     "description": "ISHARES CORE CANADIAN CORPOR",
     "symbol": "ISDXF"
    },
    {
     "description": "IVERIC BIO INC",
     "symbol": "ISEE"
    },
    {
     "description": "ISHARES JPM EM LCL GOV USD-A",
     "symbol": "ISEJF"
    },
    {
     "description": "ISHARES EV & E DRIV TECH",
     "symbol": "ISELF"
    },
    {
     "description": "INVESCO RAFI STRATEGIC EMERG",
     "symbol": "ISEM"
    },
    {
     "description": "ISOENERGY LTD",
     "symbol": "ISENF"
    },
    {
     "description": "ISHARES S&P\/TSX CAPPED MATER",
     "symbol": "ISESF"
    },
    {
     "description": "ISHR MSCI AC FAR EAST  X-JP",
     "symbol": "ISEXF"
    },
    {
     "description": "WI2WI CORP",
     "symbol": "ISEYF"
    },
    {
     "description": "ISS A\/S",
     "symbol": "ISFFF"
    },
    {
     "description": "ISHARES USD FLOATING USD DIS",
     "symbol": "ISFLF"
    },
    {
     "description": "ING Groep NV",
     "symbol": "ISG"
    },
    {
     "description": "ISHARES CORE GLB AGG USD-H A",
     "symbol": "ISGAF"
    },
    {
     "description": "INSURAGUEST TECHNOLOGIES INC",
     "symbol": "ISGIF"
    },
    {
     "description": "ISIGN SOLUTIONS INC",
     "symbol": "ISGN"
    },
    {
     "description": "ISHARES GOLD PRODUCERS",
     "symbol": "ISGPF"
    },
    {
     "description": "ISHARES DIVERSIFIED MONTHLY",
     "symbol": "ISHAF"
    },
    {
     "description": "ISH USD TRES 20PLUS YR USD A",
     "symbol": "ISHBF"
    },
    {
     "description": "ISHARES DIGITAL SCRTY USD-A",
     "symbol": "ISHDF"
    },
    {
     "description": "ISHARES USD SHORT DUR USD D",
     "symbol": "ISHFF"
    },
    {
     "description": "ISHARES -3 YEAR INTERNATIONA",
     "symbol": "ISHG"
    },
    {
     "description": "ISHARES EURO HY CORP",
     "symbol": "ISHHF"
    },
    {
     "description": "ISLET HOLDINGS INC",
     "symbol": "ISHI"
    },
    {
     "description": "INFOSEARCH MEDIA INC",
     "symbol": "ISHM"
    },
    {
     "description": "ISHARES S&P SMALL CAP 600",
     "symbol": "ISHOF"
    },
    {
     "description": "FIRST TRUST S-NETWORK E-COMM",
     "symbol": "ISHP"
    },
    {
     "description": "ISHARES EM DIVIDEND",
     "symbol": "ISHPF"
    },
    {
     "description": "ISHARES HIGH QUALITY CANADIA",
     "symbol": "ISHQF"
    },
    {
     "description": "ISHARES CORE GBP CORP",
     "symbol": "ISHRF"
    },
    {
     "description": "ISHARES US TREAS 0-1YR USD A",
     "symbol": "ISHUF"
    },
    {
     "description": "ISHARES US AGG BND USD ACC",
     "symbol": "ISHVF"
    },
    {
     "description": "ISH MSCI WLD QLY DIV-USD DIS",
     "symbol": "ISHWF"
    },
    {
     "description": "ISHARES CORE CANADIANGOVERNM",
     "symbol": "ISHXF"
    },
    {
     "description": "ISHARES USD HY CORP USD ACC",
     "symbol": "ISHYF"
    },
    {
     "description": "ISHARES UK GILTS 0-5YR UCITS",
     "symbol": "ISHZF"
    },
    {
     "description": "ISHARES REF INCL & DIVRSTY",
     "symbol": "ISIDF"
    },
    {
     "description": "INSIGNIA SYSTEMS INC",
     "symbol": "ISIG"
    },
    {
     "description": "ISHARES OMX STOCKHOLM CAPPED",
     "symbol": "ISIVF"
    },
    {
     "description": "ISHARES JPM USD EM CRP USD A",
     "symbol": "ISJMF"
    },
    {
     "description": "ISHARES JPM USD EM BND USD A",
     "symbol": "ISJPF"
    },
    {
     "description": "ISLEWORTH HEALTHCARE ACQUISI",
     "symbol": "ISLE"
    },
    {
     "description": "ISLEWORTH HEALTHCARE -CW27",
     "symbol": "ISLEW"
    },
    {
     "description": "INTERNATIONAL SILVER INC",
     "symbol": "ISLV"
    },
    {
     "description": "INDRA SISTEMAS SA",
     "symbol": "ISMAF"
    },
    {
     "description": "INDRA SISTEMAS SA-UNSP ADR",
     "symbol": "ISMAY"
    },
    {
     "description": "ISHARES MSCI USA USD ACC",
     "symbol": "ISMCF"
    },
    {
     "description": "INSPIRE SMALL\/MID CAP ESG ET",
     "symbol": "ISMD"
    },
    {
     "description": "ISHARES CORE MSCI PACIF X-JP",
     "symbol": "ISMJF"
    },
    {
     "description": "ISM INTERNATIONAL INC",
     "symbol": "ISML"
    },
    {
     "description": "iShares IV PLC iShares Edge",
     "symbol": "ISMMF"
    },
    {
     "description": "ISHARES EDGE MSCI WRLD VALUE",
     "symbol": "ISMVF"
    },
    {
     "description": "ISHARES USD FLOATING MXN-H A",
     "symbol": "ISMXF"
    },
    {
     "description": "INTESA SANPAOLO-SPON ADR",
     "symbol": "ISNPY"
    },
    {
     "description": "ISOPLEXIS CORP",
     "symbol": "ISO"
    },
    {
     "description": "1MAGE SOFTWARE INC",
     "symbol": "ISOL"
    },
    {
     "description": "ISODIOL INTERNATIONAL INC",
     "symbol": "ISOLF"
    },
    {
     "description": "ISONICS CORP",
     "symbol": "ISON"
    },
    {
     "description": "ISHARES USD ASIA HYLD BD-ETF",
     "symbol": "ISOUF"
    },
    {
     "description": "ISPECIMEN INC",
     "symbol": "ISPC"
    },
    {
     "description": "ISHARES UK DIVIDEND",
     "symbol": "ISPCF"
    },
    {
     "description": "INTERSPEED INC",
     "symbol": "ISPD"
    },
    {
     "description": "ISHARES DVL MKT PROPERTY YLD",
     "symbol": "ISPFF"
    },
    {
     "description": "iShares Physical Metals PLC",
     "symbol": "ISPHF"
    },
    {
     "description": "INSPIRATO INC",
     "symbol": "ISPO"
    },
    {
     "description": "INSPIRATO -CW30",
     "symbol": "ISPOW"
    },
    {
     "description": "ISHARES MSCI EAST EUROPE CPD",
     "symbol": "ISQMF"
    },
    {
     "description": "ISHR EDGE MSCI WRLD QLY FCTR",
     "symbol": "ISQWF"
    },
    {
     "description": "ISORAY INC",
     "symbol": "ISR"
    },
    {
     "description": "VANECK ISRAEL ETF",
     "symbol": "ISRA"
    },
    {
     "description": "ISHARES S&P 500 IT SECTOR",
     "symbol": "ISRCF"
    },
    {
     "description": "INTUITIVE SURGICAL INC",
     "symbol": "ISRG"
    },
    {
     "description": "ISHARES S&P 500 ENERGY",
     "symbol": "ISRHF"
    },
    {
     "description": "ISHARES USD TRES 20PLUS YR",
     "symbol": "ISRIF"
    },
    {
     "description": "REGEN III CORP",
     "symbol": "ISRJF"
    },
    {
     "description": "ISRAMCO NEGEV 2 LP",
     "symbol": "ISRMF"
    },
    {
     "description": "ISHARES S&P CONSUMER DSCRTN",
     "symbol": "ISRNF"
    },
    {
     "description": "ISHARES USD CORP BOND USD D",
     "symbol": "ISRPF"
    },
    {
     "description": "ISHARES GBP CORP BOND 0-5YR",
     "symbol": "ISRRF"
    },
    {
     "description": "ISHARES S&P 500 FINANCIALS",
     "symbol": "ISRUF"
    },
    {
     "description": "ISHARES MSCI JAPAN USD-H ACC",
     "symbol": "ISRVF"
    },
    {
     "description": "ISHARES JPM USD EM BND USD D",
     "symbol": "ISRWF"
    },
    {
     "description": "ISHARES USD HY CORP USD DIST",
     "symbol": "ISRZF"
    },
    {
     "description": "INNOVATIVE SOLUTIONS & SUPP",
     "symbol": "ISSC"
    },
    {
     "description": "ISHARES USD SHORT DUR MXN HA",
     "symbol": "ISSDF"
    },
    {
     "description": "ISS A\/S - SPON ADR",
     "symbol": "ISSDY"
    },
    {
     "description": "ISHARES GBP INDEX-LNK GILTS",
     "symbol": "ISSEF"
    },
    {
     "description": "ISHARES USD TREASURY 7-10Y",
     "symbol": "ISSHF"
    },
    {
     "description": "ISHARES GLBL INFL LNKD GOVT",
     "symbol": "ISSIF"
    },
    {
     "description": "ISHARES GLOBAL GOV BND-DISTR",
     "symbol": "ISSPF"
    },
    {
     "description": "ISHARES GLOBAL HY CORP-DISTR",
     "symbol": "ISSQF"
    },
    {
     "description": "ISHARES EDGE MSCI EM MIN VOL",
     "symbol": "ISSRF"
    },
    {
     "description": "ISHARES MSCI AUSTRALIA",
     "symbol": "ISSSF"
    },
    {
     "description": "ISHARES CORE S&P 500 INDEX E",
     "symbol": "ISSXF"
    },
    {
     "description": "ISH S&P500 UTILITIES",
     "symbol": "ISSZF"
    },
    {
     "description": "ISHARES CORE 1-5 YEAR USD BO",
     "symbol": "ISTB"
    },
    {
     "description": "ISHR EUR 600 TRAVEL&LEIS DE",
     "symbol": "ISTOF"
    },
    {
     "description": "INVESTAR HOLDING CORP",
     "symbol": "ISTR"
    },
    {
     "description": "ISHARES USD TRSRY 1-3Y USD A",
     "symbol": "ISTXF"
    },
    {
     "description": "ISHARES ULTRASHRT BOND USD-A",
     "symbol": "ISUDF"
    },
    {
     "description": "ISUN INC",
     "symbol": "ISUN"
    },
    {
     "description": "ISHARES US PROPERTY YIELD",
     "symbol": "ISUPF"
    },
    {
     "description": "ISHARES USD ULTRASHORT BOND",
     "symbol": "ISUUF"
    },
    {
     "description": "ISUZU MOTORS LTD",
     "symbol": "ISUZF"
    },
    {
     "description": "ISUZU MOTORS LTD-UNSPON ADR",
     "symbol": "ISUZY"
    },
    {
     "description": "ISHARES NASDAQ 100 USD ACC",
     "symbol": "ISVAF"
    },
    {
     "description": "ISHARES MSCI CHINA USD ACC",
     "symbol": "ISVBF"
    },
    {
     "description": "ISHARES S&P HEALTH CARE",
     "symbol": "ISVFF"
    },
    {
     "description": "INTEGRATED SERVICES GROUP IN",
     "symbol": "ISVG"
    },
    {
     "description": "ISHARES USD TRES BOND 7-10Y",
     "symbol": "ISVIF"
    },
    {
     "description": "INTERSERVE PLC",
     "symbol": "ISVJF"
    },
    {
     "description": "ISHARES INTERNATIONAL DEVELO",
     "symbol": "ISVL"
    },
    {
     "description": "IMPACT SILVER CORP",
     "symbol": "ISVLF"
    },
    {
     "description": "ISHARES MSCI EMU USD-H ACC",
     "symbol": "ISVPF"
    },
    {
     "description": "ISHARES USD SHORT DUR USD A",
     "symbol": "ISVQF"
    },
    {
     "description": "ISHARES S&P 500 GBP-H",
     "symbol": "ISVSF"
    },
    {
     "description": "ISH MSCI USA ESG EHNCD USD-A",
     "symbol": "ISVTF"
    },
    {
     "description": "ISHARES EDGE MSCI USA VALUE",
     "symbol": "ISVUF"
    },
    {
     "description": "ISHARES MSCI ACWI",
     "symbol": "ISVVF"
    },
    {
     "description": "ISHARES CHINA CNY BOND USD-A",
     "symbol": "ISVXF"
    },
    {
     "description": "ISHARES CORE MSCI EMU-USD HA",
     "symbol": "ISVYF"
    },
    {
     "description": "ISHARES WRLD MINVOL ESG USDA",
     "symbol": "ISWMF"
    },
    {
     "description": "AMPLIFY INTERNATIONAL BLACKS",
     "symbol": "ISWN"
    },
    {
     "description": "ISHARES SMI ETF CH",
     "symbol": "ISXAF"
    },
    {
     "description": "ISHARES CORE S&P BSE SEN-HKD",
     "symbol": "ISXIF"
    },
    {
     "description": "ISHR EUROPE600 OIL & GAS DE",
     "symbol": "ISXOF"
    },
    {
     "description": "ISHARES USD CORP INTRST HDG",
     "symbol": "ISXPF"
    },
    {
     "description": "ISHARES MSCI EUROPE SRI",
     "symbol": "ISXRF"
    },
    {
     "description": "ISHARES DIGITALISATION",
     "symbol": "ISXVF"
    },
    {
     "description": "ISHARES EURO DIVIDEND",
     "symbol": "ISXXF"
    },
    {
     "description": "IN-SYSTCOM INC",
     "symbol": "ISYX"
    },
    {
     "description": "ISHARES MSCI INTERNATIONAL S",
     "symbol": "ISZE"
    },
    {
     "description": "INTERSHOP HOLDING AG",
     "symbol": "ISZNF"
    },
    {
     "description": "ISHARES USD TREASURY 3-7YR",
     "symbol": "ISZXF"
    },
    {
     "description": "ISHARES SUST MSCI USA SRI",
     "symbol": "ISZZF"
    },
    {
     "description": "GARTNER INC",
     "symbol": "IT"
    },
    {
     "description": "ISHARES U.S. AEROSPACE & DEF",
     "symbol": "ITA"
    },
    {
     "description": "SPARKLINE INTANGIBLE VAL ETF",
     "symbol": "ITAN"
    },
    {
     "description": "INDUSTRIAL TECH ACQUISITIO-A",
     "symbol": "ITAQ"
    },
    {
     "description": "INDUSTRIAL TECH ACQUISITIONS",
     "symbol": "ITAQU"
    },
    {
     "description": "INDUSTRIAL TECH ACQ A -CW28",
     "symbol": "ITAQW"
    },
    {
     "description": "INDO TAMBANGRAYA MEGAH-ADR",
     "symbol": "ITAYY"
    },
    {
     "description": "ISHARES U.S. HOME CONSTRUCTI",
     "symbol": "ITB"
    },
    {
     "description": "ISHARES USD TRSRY 1-3Y USD D",
     "symbol": "ITBFF"
    },
    {
     "description": "ITAU CORPBANCA",
     "symbol": "ITCB"
    },
    {
     "description": "INVESTEC LTD-UNSPONSORED ADR",
     "symbol": "ITCFY"
    },
    {
     "description": "INTRA-CELLULAR THERAPIES INC",
     "symbol": "ITCI"
    },
    {
     "description": "INFINITE TECHNOLOGY CORP \/DE",
     "symbol": "ITCJ"
    },
    {
     "description": "INTERDYNE CO",
     "symbol": "ITDN"
    },
    {
     "description": "INTERTECH SOLUTIONS INC",
     "symbol": "ITEC"
    },
    {
     "description": "I3 ENERGY PLC",
     "symbol": "ITEEF"
    },
    {
     "description": "HYVE GROUP PLC UNSP ADR",
     "symbol": "ITEGY"
    },
    {
     "description": "ITOCHU ENEX CO LTD",
     "symbol": "ITENF"
    },
    {
     "description": "HYVE GROUP PLC",
     "symbol": "ITEPF"
    },
    {
     "description": "BLUESTAR ISRAEL TECHNOLOGY E",
     "symbol": "ITEQ"
    },
    {
     "description": "ITEX CORP",
     "symbol": "ITEX"
    },
    {
     "description": "ITFOR INC",
     "symbol": "ITFRF"
    },
    {
     "description": "INTERFOUNDRY INC",
     "symbol": "ITFY"
    },
    {
     "description": "INTEGRAL DIAGNOSTICS LTD",
     "symbol": "ITGDF"
    },
    {
     "description": "ITALGAS SPA",
     "symbol": "ITGGF"
    },
    {
     "description": "AUGWIND ENERGY TECH STORAGE",
     "symbol": "ITGMF"
    },
    {
     "description": "INTEGER HOLDINGS CORP",
     "symbol": "ITGR"
    },
    {
     "description": "IANTHUS CAPITAL HOLDINGS INC",
     "symbol": "ITHUF"
    },
    {
     "description": "ITALIAN-THAI DEVELOPMENT PCL",
     "symbol": "ITHVF"
    },
    {
     "description": "ITHAX ACQUISITION CORP-A",
     "symbol": "ITHX"
    },
    {
     "description": "ITHAX ACQUISITION CORP",
     "symbol": "ITHXU"
    },
    {
     "description": "ITHAX ACQU CL A -CW27",
     "symbol": "ITHXW"
    },
    {
     "description": "ITERIS INC",
     "symbol": "ITI"
    },
    {
     "description": "INVESTORS TITLE CO",
     "symbol": "ITIC"
    },
    {
     "description": "ISHARES USD TIPS 0-5",
     "symbol": "ITIPF"
    },
    {
     "description": "INTRUM AB-UNSP ADR",
     "symbol": "ITJTY"
    },
    {
     "description": "ITEKNIK HOLDING CORP",
     "symbol": "ITKH"
    },
    {
     "description": "INDEPENDENT TANKERS CORP LTD",
     "symbol": "ITKSF"
    },
    {
     "description": "INTELLIGENTIAS INC",
     "symbol": "ITLI"
    },
    {
     "description": "INTERLINK PRODUCTS INTL INC",
     "symbol": "ITLK"
    },
    {
     "description": "VANECK INTERMEDIATE MUNI ETF",
     "symbol": "ITM"
    },
    {
     "description": "ITOCO INC",
     "symbol": "ITMC"
    },
    {
     "description": "ITM POWER PLC",
     "symbol": "ITMPF"
    },
    {
     "description": "INTERMAP TECHNOLOGIES CORP",
     "symbol": "ITMSF"
    },
    {
     "description": "INTERTAINMENT MEDIA INC",
     "symbol": "ITMTF"
    },
    {
     "description": "REACT GAMING GROUP INC",
     "symbol": "ITMZF"
    },
    {
     "description": "INTERNET INFINITY INC",
     "symbol": "ITNF"
    },
    {
     "description": "INTERNATIONAL MONETARY SYS",
     "symbol": "ITNM"
    },
    {
     "description": "LB-SHELL PLC",
     "symbol": "ITNRF"
    },
    {
     "description": "ITONIS INC",
     "symbol": "ITNS"
    },
    {
     "description": "ITOCHU CORP",
     "symbol": "ITOCF"
    },
    {
     "description": "ITOCHU CORP-UNSPONSORED ADR",
     "symbol": "ITOCY"
    },
    {
     "description": "ITO EN LTD",
     "symbol": "ITOEF"
    },
    {
     "description": "ITO EN LTD-PREF",
     "symbol": "ITONF"
    },
    {
     "description": "ITEOS THERAPEUTICS INC",
     "symbol": "ITOS"
    },
    {
     "description": "ISHARES CORE S&P TOTAL U.S.",
     "symbol": "ITOT"
    },
    {
     "description": "IIOT-OXYS INC",
     "symbol": "ITOX"
    },
    {
     "description": "IT TECH PACKAGING INC",
     "symbol": "ITP"
    },
    {
     "description": "INTREPID CAPITAL CORP",
     "symbol": "ITPC"
    },
    {
     "description": "INTERTAPE POLYMER GROUP INC",
     "symbol": "ITPOF"
    },
    {
     "description": "ITIQUIRA ACQUISITION CORP-A",
     "symbol": "ITQ"
    },
    {
     "description": "ITIQUIRA ACQUISITION CORP",
     "symbol": "ITQRU"
    },
    {
     "description": "ITIQUIRA ACQ CL A -CW27",
     "symbol": "ITQRW"
    },
    {
     "description": "ISHARES US TREAS 0-1YR MXN",
     "symbol": "ITRBF"
    },
    {
     "description": "INTEGRA RESOURCES CORP",
     "symbol": "ITRG"
    },
    {
     "description": "ITRON INC",
     "symbol": "ITRI"
    },
    {
     "description": "ITERUM THERAPEUTICS PLC",
     "symbol": "ITRM"
    },
    {
     "description": "ITURAN LOCATION AND CONTROL",
     "symbol": "ITRN"
    },
    {
     "description": "ITRONICS INC",
     "symbol": "ITRO"
    },
    {
     "description": "INTERTRUST NV",
     "symbol": "ITRUF"
    },
    {
     "description": "INTERRA RESOURCES CORP",
     "symbol": "ITRX"
    },
    {
     "description": "ISHARES S&P\/TSX CAPPED FINAN",
     "symbol": "ITSXF"
    },
    {
     "description": "ITT INC",
     "symbol": "ITT"
    },
    {
     "description": "INTACT GOLD CORP",
     "symbol": "ITTGF"
    },
    {
     "description": "ITOCHU TECHNO-SOLUTIONS CORP",
     "symbol": "ITTOF"
    },
    {
     "description": "ITOCHU TECHNO-SOLOT-UNSP ADR",
     "symbol": "ITTOY"
    },
    {
     "description": "INVESCO US TECHNOLOGY S&P",
     "symbol": "ITTSF"
    },
    {
     "description": "ITAU UNIBANCO H-SPON PRF ADR",
     "symbol": "ITUB"
    },
    {
     "description": "INTERUPS INC",
     "symbol": "ITUP"
    },
    {
     "description": "INTERACT-TV INC",
     "symbol": "ITVI"
    },
    {
     "description": "ITAUSA SA",
     "symbol": "ITVMF"
    },
    {
     "description": "ITV PLC",
     "symbol": "ITVPF"
    },
    {
     "description": "ITV PLC-UNSPON ADR",
     "symbol": "ITVPY"
    },
    {
     "description": "ILLINOIS TOOL WORKS",
     "symbol": "ITW"
    },
    {
     "description": "ITACONIX PLC",
     "symbol": "ITXXF"
    },
    {
     "description": "ISHARES AGEING POPULATION",
     "symbol": "IUAGF"
    },
    {
     "description": "IMUGENE LTD",
     "symbol": "IUGNF"
    },
    {
     "description": "ISHARES UK PROPERTY",
     "symbol": "IUKSF"
    },
    {
     "description": "ISHARES S&P\/TSX CAPPED ENERG",
     "symbol": "IUNSF"
    },
    {
     "description": "ISHARES MSCI EAFE INDEX ETF",
     "symbol": "IUNTF"
    },
    {
     "description": "ISHARES EDGE MSCI USA QLY",
     "symbol": "IUQFF"
    },
    {
     "description": "INVESCO RAFI STRATEGIC US ET",
     "symbol": "IUS"
    },
    {
     "description": "AMBERWAVE INVEST USA JSG",
     "symbol": "IUSA"
    },
    {
     "description": "ISHARES CORE TOTAL BOND ETF",
     "symbol": "IUSB"
    },
    {
     "description": "AS ONE CORP",
     "symbol": "IUSDF"
    },
    {
     "description": "ISHARES CORE S&P U.S. GROWTH",
     "symbol": "IUSG"
    },
    {
     "description": "ISHARES S&P\/TSX CAPPED REIT",
     "symbol": "IUSPF"
    },
    {
     "description": "INVESCO RAFI STRATEGIC US SM",
     "symbol": "IUSS"
    },
    {
     "description": "ISHARES CORE S&P U.S. VALUE",
     "symbol": "IUSV"
    },
    {
     "description": "ISHARES EDGE MSCI USA SIZE",
     "symbol": "IUSZF"
    },
    {
     "description": "INVESCO US TRES 3-7 YR DIST",
     "symbol": "IUTBF"
    },
    {
     "description": "ISHARES S&P\/TSX GLOBAL GOLD",
     "symbol": "IUTCF"
    },
    {
     "description": "ISHARES S&P\/TSX 60 INDEX ETF",
     "symbol": "IUTSF"
    },
    {
     "description": "ISH EDGE USA VALUE USD DIST",
     "symbol": "IUVDF"
    },
    {
     "description": "ISHARES U.S. HIGH YIELD BOND",
     "symbol": "IUYBF"
    },
    {
     "description": "INVENTIVA SA - ADR",
     "symbol": "IVA"
    },
    {
     "description": "INTEVAC INC",
     "symbol": "IVAC"
    },
    {
     "description": "ALPHA ARCHI INTL QT VLU ETF",
     "symbol": "IVAL"
    },
    {
     "description": "INVESCO AT1 CAPITAL BOND",
     "symbol": "IVATF"
    },
    {
     "description": "INNOVENT BIOLOGICS INC-ADR",
     "symbol": "IVBIY"
    },
    {
     "description": "INNOVATION1 BIOTECH INC",
     "symbol": "IVBT"
    },
    {
     "description": "ISHARES NSDQ US BIOTECH UCIT",
     "symbol": "IVBUF"
    },
    {
     "description": "INNOVENT BIOLOGICS INC",
     "symbol": "IVBXF"
    },
    {
     "description": "INVACARE CORP",
     "symbol": "IVC"
    },
    {
     "description": "INVESTCORP EUROPE ACQUISI-A",
     "symbol": "IVCB"
    },
    {
     "description": "INVESTCORP EUROPE ACQUISITIO",
     "symbol": "IVCBU"
    },
    {
     "description": "INVESTCORP EUROPE ACQUIS -27",
     "symbol": "IVCBW"
    },
    {
     "description": "IVECO GROUP NV",
     "symbol": "IVCGF"
    },
    {
     "description": "INVICTA HOLDINGS LTD",
     "symbol": "IVCHF"
    },
    {
     "description": "INVESTCO CORP",
     "symbol": "IVCO"
    },
    {
     "description": "SWIFTMERGE ACQUISITION COR-A",
     "symbol": "IVCP"
    },
    {
     "description": "SWIFTMERGE ACQUISITION CORP",
     "symbol": "IVCPU"
    },
    {
     "description": "SWIFTMERGE ACQUISITION -CW23",
     "symbol": "IVCPW"
    },
    {
     "description": "INVICTUS ENERGY LTD",
     "symbol": "IVCTF"
    },
    {
     "description": "IVEDA SOLUTIONS INC",
     "symbol": "IVDA"
    },
    {
     "description": "IVEDA SOLUTIONS INC -CW27",
     "symbol": "IVDAW"
    },
    {
     "description": "INVESCO FOCUSED DISCOVERY GR",
     "symbol": "IVDG"
    },
    {
     "description": "INNOVATIVE DESIGNS INC",
     "symbol": "IVDN"
    },
    {
     "description": "ISHARES S&P 500 VALUE ETF",
     "symbol": "IVE"
    },
    {
     "description": "INVESCO US CONS STAP S&P SEC",
     "symbol": "IVECF"
    },
    {
     "description": "WEDBUSH ETFMG GLOBAL CLOUD T",
     "symbol": "IVES"
    },
    {
     "description": "INVENTIVA SA",
     "symbol": "IVEVF"
    },
    {
     "description": "INNOVATIVE FOOD HOLDINGS INC",
     "symbol": "IVFH"
    },
    {
     "description": "INVICTUS FINANCIAL INC",
     "symbol": "IVFZF"
    },
    {
     "description": "DELAWARE IVY HIGH INC OPP",
     "symbol": "IVH"
    },
    {
     "description": "INVECH HOLDINGS INC",
     "symbol": "IVHI"
    },
    {
     "description": "INVINCIBLE INVESTMENT CORP",
     "symbol": "IVINF"
    },
    {
     "description": "INVICTUS MD STRATEGIES CORP",
     "symbol": "IVITF"
    },
    {
     "description": "ISHARES GLOBAL CORP",
     "symbol": "IVIVF"
    },
    {
     "description": "INVION LTD",
     "symbol": "IVIXF"
    },
    {
     "description": "INVESCO US LARGE CAP CORE ES",
     "symbol": "IVLC"
    },
    {
     "description": "ISHARES MSCI INTERNATIONAL V",
     "symbol": "IVLU"
    },
    {
     "description": "IN VERITAS MEDICAL DIAGNOSTI",
     "symbol": "IVME"
    },
    {
     "description": "ISHARES MSCI EM CONSUM GRWTH",
     "symbol": "IVMGF"
    },
    {
     "description": "INVESCO VAR RATE PREF SHRS",
     "symbol": "IVMKF"
    },
    {
     "description": "INVESCO KBW NASDAQ FINTECH",
     "symbol": "IVNFF"
    },
    {
     "description": "VANGUARD S&P MID-CAP 400 GRO",
     "symbol": "IVOG"
    },
    {
     "description": "QUADRATIC INT RTE VOL INFL H",
     "symbol": "IVOL"
    },
    {
     "description": "VANGUARD S&P MID-CAP 400 ETF",
     "symbol": "IVOO"
    },
    {
     "description": "IVOR EXPLORATION INC",
     "symbol": "IVORF"
    },
    {
     "description": "VANGUARD S&P MID-CAP 400 VAL",
     "symbol": "IVOV"
    },
    {
     "description": "IVANHOE MINES LTD-CL A",
     "symbol": "IVPAF"
    },
    {
     "description": "INVESCO MORTGAGE CAPITAL",
     "symbol": "IVR"
    },
    {
     "description": "INVESCO MORTGAGE CAPITAL",
     "symbol": "IVR.PRB"
    },
    {
     "description": "INVESCO MORTGAGE CAPITAL",
     "symbol": "IVR.PRC"
    },
    {
     "description": "INVESCO REAL ASSETS ESG ETF",
     "symbol": "IVRA"
    },
    {
     "description": "INOVALIS REAL ESTATE INVESTM",
     "symbol": "IVREF"
    },
    {
     "description": "INVITRO INTERNATIONAL",
     "symbol": "IVRO"
    },
    {
     "description": "INVESTOR AB-B SHS",
     "symbol": "IVSBF"
    },
    {
     "description": "INVESCO SELECT GROWTH ETF",
     "symbol": "IVSG"
    },
    {
     "description": "ISHARES S&P500 COMMUNICATION",
     "symbol": "IVSPF"
    },
    {
     "description": "ISH USD FLOAT BOND USD ACC",
     "symbol": "IVSRF"
    },
    {
     "description": "INNOVEST GLOBAL INC",
     "symbol": "IVST"
    },
    {
     "description": "INVESTOR AB-A SHS",
     "symbol": "IVSXF"
    },
    {
     "description": "INVENTRUST PROPERTIES CORP",
     "symbol": "IVT"
    },
    {
     "description": "INVESTMENT AB LATOUR-B SHS",
     "symbol": "IVTBF"
    },
    {
     "description": "INVESTEC PLC",
     "symbol": "IVTJF"
    },
    {
     "description": "INVESTEC PLC-UNSP ADR",
     "symbol": "IVTJY"
    },
    {
     "description": "IVU TRAFFIC TECHNOLOGIES AG",
     "symbol": "IVUFF"
    },
    {
     "description": "INVESCO US FINANCIALS S&P",
     "symbol": "IVUSF"
    },
    {
     "description": "ISHARES CORE S&P 500 ETF",
     "symbol": "IVV"
    },
    {
     "description": "INVINITY ENERGY SYSTEMS PLC",
     "symbol": "IVVGF"
    },
    {
     "description": "IVIVI TECHNOLOGIES INC",
     "symbol": "IVVI"
    },
    {
     "description": "ISHARES CORE EURO STOXX 50",
     "symbol": "IVVPF"
    },
    {
     "description": "ISHARES USD SHORT DUR HY CRP",
     "symbol": "IVVVF"
    },
    {
     "description": "ISHARES S&P 500 GROWTH ETF",
     "symbol": "IVW"
    },
    {
     "description": "INVESCO LTD",
     "symbol": "IVZ"
    },
    {
     "description": "IWAICOSMO HOLDINGS INC",
     "symbol": "IWAIF"
    },
    {
     "description": "IWALLET CORP",
     "symbol": "IWAL"
    },
    {
     "description": "ISHARES GLOBAL WATER",
     "symbol": "IWATF"
    },
    {
     "description": "ISHARES RUSSELL 1000 ETF",
     "symbol": "IWB"
    },
    {
     "description": "ISHARES MICRO-CAP ETF",
     "symbol": "IWC"
    },
    {
     "description": "ISHARES RUSSELL 1000 VALUE E",
     "symbol": "IWD"
    },
    {
     "description": "ETRACS 2X VALUE FACTR TR",
     "symbol": "IWDL"
    },
    {
     "description": "ISHARES RUSSELL 1000 GROWTH",
     "symbol": "IWF"
    },
    {
     "description": "ISHARES VIRTUAL WORK & LIFE",
     "symbol": "IWFH"
    },
    {
     "description": "ETRACS 2X GROWTH FACTR TR",
     "symbol": "IWFL"
    },
    {
     "description": "IWG PLC",
     "symbol": "IWGFF"
    },
    {
     "description": "AMPLIFY INFLATION FIGHTER",
     "symbol": "IWIN"
    },
    {
     "description": "IRWIN NATURALS INC",
     "symbol": "IWINF"
    },
    {
     "description": "AFP IMAGING CORP",
     "symbol": "IWKS"
    },
    {
     "description": "ISHARES RUSSELL TOP 200 ETF",
     "symbol": "IWL"
    },
    {
     "description": "ISHARES RUSSELL 2000 ETF",
     "symbol": "IWM"
    },
    {
     "description": "ETRACS 2X SIZE FACTR TR",
     "symbol": "IWML"
    },
    {
     "description": "ISHARES RUSSELL 2000 VALUE E",
     "symbol": "IWN"
    },
    {
     "description": "ISHARES RUSSELL 2000 GROWTH",
     "symbol": "IWO"
    },
    {
     "description": "ISHARES RUSSELL MID-CAP GROW",
     "symbol": "IWP"
    },
    {
     "description": "ISHARES RUSSELL MID-CAP ETF",
     "symbol": "IWR"
    },
    {
     "description": "IRWIN RESOURCES INC",
     "symbol": "IWRS"
    },
    {
     "description": "ISHARES RUSSELL MID-CAP VALU",
     "symbol": "IWS"
    },
    {
     "description": "WRIGHT INVESTORS' SERVICE HO",
     "symbol": "IWSH"
    },
    {
     "description": "IMAGEWARE SYSTEMS INC",
     "symbol": "IWSY"
    },
    {
     "description": "IWATANI CORP",
     "symbol": "IWTNF"
    },
    {
     "description": "ISHARES MSCI WORLD IT-USD D",
     "symbol": "IWTSF"
    },
    {
     "description": "ISHARES RUSSELL 3000 ETF",
     "symbol": "IWV"
    },
    {
     "description": "ISH EDGE MSCI WLD VAL USD-D",
     "symbol": "IWVUF"
    },
    {
     "description": "ISHARES RUSSELL TOP 200 VALU",
     "symbol": "IWX"
    },
    {
     "description": "ISHARES RUSSELL TOP 200 GROW",
     "symbol": "IWY"
    },
    {
     "description": "ORIX  - SPONSORED ADR",
     "symbol": "IX"
    },
    {
     "description": "IX ACQUISITION CORP-A",
     "symbol": "IXAQ"
    },
    {
     "description": "IX ACQUISITION CORP",
     "symbol": "IXAQU"
    },
    {
     "description": "IX ACQUISITION CORP -CW26",
     "symbol": "IXAQW"
    },
    {
     "description": "ISHARES GLOBAL ENERGY ETF",
     "symbol": "IXC"
    },
    {
     "description": "IX ENERGY HOLDINGS INC",
     "symbol": "IXEH"
    },
    {
     "description": "ISHARES GLOBAL FINANCIALS ET",
     "symbol": "IXG"
    },
    {
     "description": "INCANNEX HEALTHCARE LTD-ADR",
     "symbol": "IXHL"
    },
    {
     "description": "ISHARES GLOBAL HEALTHCARE ET",
     "symbol": "IXJ"
    },
    {
     "description": "ISHARES S&P GLOBAL CONSUMER",
     "symbol": "IXLCF"
    },
    {
     "description": "ISHARES S&P GLOBAL INDUSTRI",
     "symbol": "IXLDF"
    },
    {
     "description": "ISHARES GLOBAL TECH ETF",
     "symbol": "IXN"
    },
    {
     "description": "INDEX OIL & GAS INC",
     "symbol": "IXOG"
    },
    {
     "description": "ISHARES GLOBAL COMM SERVICES",
     "symbol": "IXP"
    },
    {
     "description": "IONIC RARE EARTHS LTD",
     "symbol": "IXRRF"
    },
    {
     "description": "INNEXUS BIOTECHNOLOGY INC",
     "symbol": "IXSBF"
    },
    {
     "description": "ISHARES MSCI EUROPE ESG SCRN",
     "symbol": "IXSCF"
    },
    {
     "description": "WISDOMTREE INDIA EX-STATE FD",
     "symbol": "IXSE"
    },
    {
     "description": "ISHARES MSCI EM XCHINA",
     "symbol": "IXSRF"
    },
    {
     "description": "ISHARES CORE INTL STOCK ETF",
     "symbol": "IXUS"
    },
    {
     "description": "ISHARES MSCI UK GBP ACC",
     "symbol": "IXXXF"
    },
    {
     "description": "ISHARES US CONSUMER DISCRETI",
     "symbol": "IYC"
    },
    {
     "description": "ISHARES U.S. ENERGY ETF",
     "symbol": "IYE"
    },
    {
     "description": "ISHARES US FINANCIALS ETF",
     "symbol": "IYF"
    },
    {
     "description": "ISHARES U.S. FINANCIAL SERVI",
     "symbol": "IYG"
    },
    {
     "description": "ISHARES U.S. HEALTHCARE ETF",
     "symbol": "IYH"
    },
    {
     "description": "ISHARES U.S. INDUSTRIALS ETF",
     "symbol": "IYJ"
    },
    {
     "description": "ISHARES US CONSUMER STAPLES",
     "symbol": "IYK"
    },
    {
     "description": "ISHARES MORNINGSTAR MULTI-AS",
     "symbol": "IYLD"
    },
    {
     "description": "ISHARES U.S. BASIC MATERIALS",
     "symbol": "IYM"
    },
    {
     "description": "ISHARES US REAL ESTATE ETF",
     "symbol": "IYR"
    },
    {
     "description": "ISHARES US TRANSPORTATION ET",
     "symbol": "IYT"
    },
    {
     "description": "ISHARES USTECHNOLOGY ETF",
     "symbol": "IYW"
    },
    {
     "description": "INYX INC",
     "symbol": "IYXI"
    },
    {
     "description": "ISHARES DOW JONES U.S. ETF",
     "symbol": "IYY"
    },
    {
     "description": "ISHARES US TELECOMMUNICATION",
     "symbol": "IYZ"
    },
    {
     "description": "INTERNATIONAL ZEOLITE CORP",
     "symbol": "IZCFF"
    },
    {
     "description": "IZEA WORLDWIDE INC",
     "symbol": "IZEA"
    },
    {
     "description": "ISHARES MSCI EM ACC",
     "symbol": "IZIZF"
    },
    {
     "description": "IZUMI CO LTD",
     "symbol": "IZMIF"
    },
    {
     "description": "IZON NETWORK INC",
     "symbol": "IZNN"
    },
    {
     "description": "IZOTROPIC CORP",
     "symbol": "IZOZF"
    },
    {
     "description": "INDIVIOR PLC",
     "symbol": "IZQVF"
    },
    {
     "description": "ARK ISRAEL INNOVATIVE TECHNO",
     "symbol": "IZRL"
    },
    {
     "description": "JACOBS ENGINEERING GROUP INC",
     "symbol": "J"
    },
    {
     "description": "JANUS HENDERSON AAA CLO ETF",
     "symbol": "JAAA"
    },
    {
     "description": "JAC JAPAN CO LTD",
     "symbol": "JACJF"
    },
    {
     "description": "JACK IN THE BOX INC",
     "symbol": "JACK"
    },
    {
     "description": "JACO ELECTRONICS INC",
     "symbol": "JACO"
    },
    {
     "description": "JADE ART GROUP INC",
     "symbol": "JADA"
    },
    {
     "description": "JPM US AGG BOND ETF",
     "symbol": "JAGG"
    },
    {
     "description": "JAGUAR MINING INC",
     "symbol": "JAGGF"
    },
    {
     "description": "GREEN STREET CAPITAL CORP",
     "symbol": "JAGR"
    },
    {
     "description": "JAGUAR HEALTH INC",
     "symbol": "JAGX"
    },
    {
     "description": "JAPAN AIRPORT TERMINAL CO",
     "symbol": "JAIRF"
    },
    {
     "description": "JAKKS PACIFIC INC",
     "symbol": "JAKK"
    },
    {
     "description": "BE ACTIVE HOLDINGS INC",
     "symbol": "JALA"
    },
    {
     "description": "JOHN ADAMS LIFE CORP",
     "symbol": "JALC"
    },
    {
     "description": "JAMF HOLDING CORP",
     "symbol": "JAMF"
    },
    {
     "description": "JASPER MINING CORPORATION",
     "symbol": "JAMGF"
    },
    {
     "description": "JAMMIN JAVA CORP",
     "symbol": "JAMN"
    },
    {
     "description": "JANONE INC",
     "symbol": "JAN"
    },
    {
     "description": "JANEL CORP",
     "symbol": "JANL"
    },
    {
     "description": "JANUX THERAPEUTICS INC",
     "symbol": "JANX"
    },
    {
     "description": "TRUESHARES STRUCT OUTC JAN",
     "symbol": "JANZ"
    },
    {
     "description": "JAPAN TOBACCO INC",
     "symbol": "JAPAF"
    },
    {
     "description": "JAPAN TOBACCO INC-UNSPON ADR",
     "symbol": "JAPAY"
    },
    {
     "description": "JAPAN SYSTEM TECHNIQUES CO",
     "symbol": "JAPPF"
    },
    {
     "description": "JAPAN AIRLINES CO-UNP ADR",
     "symbol": "JAPSY"
    },
    {
     "description": "JUPITER ACQUISITION CORP-A",
     "symbol": "JAQC"
    },
    {
     "description": "JUPITER ACQUISITION CORP",
     "symbol": "JAQCU"
    },
    {
     "description": "JUPITER ACQUISITION A -CW23",
     "symbol": "JAQCW"
    },
    {
     "description": "JARDINE MATHESON HLDGS LTD",
     "symbol": "JARLF"
    },
    {
     "description": "JASTEC CO LTD",
     "symbol": "JASTF"
    },
    {
     "description": "JASMINE INTL PCL-NVDR",
     "symbol": "JASUF"
    },
    {
     "description": "JATT ACQUISITION CORP - A",
     "symbol": "JATT"
    },
    {
     "description": "JATT ACQUISITION CORP",
     "symbol": "JATT.U"
    },
    {
     "description": "JATT ACQUISITION CORP -CW23",
     "symbol": "JATT.WS"
    },
    {
     "description": "JPMORGAN ACTIVE VALUE ETF",
     "symbol": "JAVA"
    },
    {
     "description": "JAXSTA LTD",
     "symbol": "JAXAF"
    },
    {
     "description": "JAZZ PHARMACEUTICALS PLC",
     "symbol": "JAZZ"
    },
    {
     "description": "JULIUS BAER GROUP LTD",
     "symbol": "JBARF"
    },
    {
     "description": "JULIUS BAER GROUP LTD-UN ADR",
     "symbol": "JBAXY"
    },
    {
     "description": "JANUS HENDERSON B-BBB CLO ET",
     "symbol": "JBBB"
    },
    {
     "description": "JOLLIBEE FOODS CORP",
     "symbol": "JBFCF"
    },
    {
     "description": "JOLLIBEE FOODS CORP-UNSP ADR",
     "symbol": "JBFCY"
    },
    {
     "description": "JBG SMITH PROPERTIES",
     "symbol": "JBGS"
    },
    {
     "description": "JB HI-FI LTD",
     "symbol": "JBHIF"
    },
    {
     "description": "HUNT (JB) TRANSPRT SVCS INC",
     "symbol": "JBHT"
    },
    {
     "description": "JANUS INTERNATIONAL GROUP IN",
     "symbol": "JBI"
    },
    {
     "description": "CORP-BACKED TRUST CERTS",
     "symbol": "JBK"
    },
    {
     "description": "JABIL INC",
     "symbol": "JBL"
    },
    {
     "description": "JETBLUE AIRWAYS CORP",
     "symbol": "JBLU"
    },
    {
     "description": "JACOBIO PHARMACEUTICALS GROU",
     "symbol": "JBPHF"
    },
    {
     "description": "JBS SA-SPONSORED ADR",
     "symbol": "JBSAY"
    },
    {
     "description": "JOHN B. SANFILIPPO & SON INC",
     "symbol": "JBSS"
    },
    {
     "description": "JOHN BEAN TECHNOLOGIES CORP",
     "symbol": "JBT"
    },
    {
     "description": "JBT BANCORP INC",
     "symbol": "JBTC"
    },
    {
     "description": "JUBILEE GOLD EXPLORATION - A",
     "symbol": "JBULF"
    },
    {
     "description": "JB&ZJMY HOLDING CO INC",
     "symbol": "JBZY"
    },
    {
     "description": "JCDECAUX SA",
     "symbol": "JCDXF"
    },
    {
     "description": "JC DECAUX SA-UNSPON ADR",
     "symbol": "JCDXY"
    },
    {
     "description": "NUVEEN CORE EQU ALPHA FD",
     "symbol": "JCE"
    },
    {
     "description": "JOHNSON CONTROLS INTERNATION",
     "symbol": "JCI"
    },
    {
     "description": "JACK CREEK INVESTMENT C-CL A",
     "symbol": "JCIC"
    },
    {
     "description": "JACK CREEK INVESTMENT CORP",
     "symbol": "JCICU"
    },
    {
     "description": "JACK CREEK INVESTMENT -CW27",
     "symbol": "JCICW"
    },
    {
     "description": "NUVEEN CREDIT OPP 2022 TARGE",
     "symbol": "JCO"
    },
    {
     "description": "JPMORGAN CORE PLUS BOND ETF",
     "symbol": "JCPB"
    },
    {
     "description": "JP MORGAN INFLATION MGD BOND",
     "symbol": "JCPI"
    },
    {
     "description": "JCR PHARMACEUTICALS CO LTD",
     "symbol": "JCRRF"
    },
    {
     "description": "JE CLEANTECH HOLDINGS LTD",
     "symbol": "JCSE"
    },
    {
     "description": "JEWETT-CAMERON TRADING LTD",
     "symbol": "JCTCF"
    },
    {
     "description": "JIUCAITONG GROUP LTD",
     "symbol": "JCTG"
    },
    {
     "description": "JPMORGAN CARBON TRANSITION",
     "symbol": "JCTR"
    },
    {
     "description": "JARDINE CYCLE & CARRIAGE LTD",
     "symbol": "JCYCF"
    },
    {
     "description": "JARDINE CYCLE & C-UNSPON ADR",
     "symbol": "JCYGY"
    },
    {
     "description": "JD.COM INC-ADR",
     "symbol": "JD"
    },
    {
     "description": "JD.COM INC - CL A",
     "symbol": "JDCMF"
    },
    {
     "description": "JD SPORTS FASHION PLC",
     "symbol": "JDDSF"
    },
    {
     "description": "JDE PEET'S NV",
     "symbol": "JDEPF"
    },
    {
     "description": "JDE PEETS BV - UNSP ADR",
     "symbol": "JDEPY"
    },
    {
     "description": "JD HEALTH INTERNATIONAL INC",
     "symbol": "JDHIF"
    },
    {
     "description": "JD HEALTH INTERNA UNSP - ADR",
     "symbol": "JDHIY"
    },
    {
     "description": "JPMORGAN US DIVIDEND ETF",
     "symbol": "JDIV"
    },
    {
     "description": "JD LOGISTICS INC",
     "symbol": "JDLGF"
    },
    {
     "description": "JD SPORTS FASHION PLC-UN ADR",
     "symbol": "JDSPY"
    },
    {
     "description": "DIREXION DAILY JUNIOR GOLD M",
     "symbol": "JDST"
    },
    {
     "description": "JD BANCSHARES INC",
     "symbol": "JDVB"
    },
    {
     "description": "WETHERSPOON (J.D.) PLC",
     "symbol": "JDWPF"
    },
    {
     "description": "WETHERSPOON (J.D.)-SPONS ADR",
     "symbol": "JDWPY"
    },
    {
     "description": "JURA ENERGY CORP",
     "symbol": "JECFF"
    },
    {
     "description": "JEFFERIES FINANCIAL GROUP IN",
     "symbol": "JEF"
    },
    {
     "description": "JOHNSON ELEC HLDG -UNSP ADR",
     "symbol": "JEHLY"
    },
    {
     "description": "JOHNSON ELECTRIC HOLDINGS",
     "symbol": "JELCF"
    },
    {
     "description": "JELD-WEN HOLDING INC",
     "symbol": "JELD"
    },
    {
     "description": "JEOL LTD",
     "symbol": "JELLF"
    },
    {
     "description": "JPMORGAN ACTIVEBUILDERS EMER",
     "symbol": "JEMA"
    },
    {
     "description": "NUVEEN EMERGING MARKETS DEBT",
     "symbol": "JEMD"
    },
    {
     "description": "IPATH GEMS INDEX ETN",
     "symbol": "JEMTF"
    },
    {
     "description": "JUST ENERGY GROUP INC",
     "symbol": "JENGQ"
    },
    {
     "description": "JPMORGAN EQUITY PREMIUM INCO",
     "symbol": "JEPI"
    },
    {
     "description": "ABERDEEN JAPAN EQUITY FUND I",
     "symbol": "JEQ"
    },
    {
     "description": "JER INVESTORS TRUST INC",
     "symbol": "JERT"
    },
    {
     "description": "JPMORGAN EUROPEAN DISCOVERY",
     "symbol": "JESCF"
    },
    {
     "description": "GLOBAL CROSSING AIRLINES GRO",
     "symbol": "JETMF"
    },
    {
     "description": "STAR JETS INTERNATIONAL INC",
     "symbol": "JETR"
    },
    {
     "description": "US GLOBAL JETS ETF",
     "symbol": "JETS"
    },
    {
     "description": "JIANGSU EXPRESS CO LTD-H",
     "symbol": "JEXYF"
    },
    {
     "description": "JIANGSU EXPRESS CO-SPONS ADR",
     "symbol": "JEXYY"
    },
    {
     "description": "JPMORGAN AMERICAN INVEST-ORD",
     "symbol": "JFAIF"
    },
    {
     "description": "JEFFERSONVILLE BANCORP\/N Y",
     "symbol": "JFBC"
    },
    {
     "description": "JUNGFRAUBAHN HOLDING AG-REG",
     "symbol": "JFBHF"
    },
    {
     "description": "JFE CONTAINER CO LTD",
     "symbol": "JFECF"
    },
    {
     "description": "JFE HOLDINGS INC",
     "symbol": "JFEEF"
    },
    {
     "description": "JFE SYSTEMS INC",
     "symbol": "JFEYF"
    },
    {
     "description": "JUPITER FUND MANAGEMENT",
     "symbol": "JFHHF"
    },
    {
     "description": "JUBILANT FLAME INTERNATIONAL",
     "symbol": "JFIL"
    },
    {
     "description": "JIAYIN GROUP INC-ADR",
     "symbol": "JFIN"
    },
    {
     "description": "NUVEEN FLOAT RATE INC FD",
     "symbol": "JFR"
    },
    {
     "description": "J FRONT RETAILING CO LTD",
     "symbol": "JFROF"
    },
    {
     "description": "JFT STRATEGIES FUND",
     "symbol": "JFTSF"
    },
    {
     "description": "9F INC - ADR",
     "symbol": "JFU"
    },
    {
     "description": "JACOB FORWARD ETF",
     "symbol": "JFWD"
    },
    {
     "description": "JEFFERSON SECURITY BANK\/W VA",
     "symbol": "JFWV"
    },
    {
     "description": "AURORA MOBILE LTD-ADR",
     "symbol": "JG"
    },
    {
     "description": "JGC HOLDINGS CORP",
     "symbol": "JGCCF"
    },
    {
     "description": "JGC HOLDINGS CORP-UNSPON ADR",
     "symbol": "JGCCY"
    },
    {
     "description": "JAGUAR FINANCIAL CORP",
     "symbol": "JGFCF"
    },
    {
     "description": "JAGUAR GLOBAL GROWTH CORP -A",
     "symbol": "JGGC"
    },
    {
     "description": "JAGUAR GLOBAL GROWTH CO-RGTS",
     "symbol": "JGGCR"
    },
    {
     "description": "JAGUAR GLOBAL GROWTH CORP I",
     "symbol": "JGGCU"
    },
    {
     "description": "JAGUAR GLOBAL GROWTH -CW27",
     "symbol": "JGGCW"
    },
    {
     "description": "NUVEEN GLOBAL H-I FD",
     "symbol": "JGH"
    },
    {
     "description": "JUNGHEINRICH - PRFD",
     "symbol": "JGHAF"
    },
    {
     "description": "JINZISHENG HOLDING GROUP",
     "symbol": "JGHG"
    },
    {
     "description": "JUNGHEINRICH AG-UNSPONSO ADR",
     "symbol": "JGHHY"
    },
    {
     "description": "JS GLOBAL LIFESTYLE CO LTD",
     "symbol": "JGLCF"
    },
    {
     "description": "AMPLIFY PURE JR GOLD MINERS",
     "symbol": "JGLD"
    },
    {
     "description": "JAPAN GOLD CORP",
     "symbol": "JGLDF"
    },
    {
     "description": "JINCHUAN GROUP INTERNATIONAL",
     "symbol": "JGRRF"
    },
    {
     "description": "JG SUMMIT HOLDINGS INC",
     "symbol": "JGSHF"
    },
    {
     "description": "JG SUMMIT HOLDINGS-UNSP ADR",
     "symbol": "JGSMY"
    },
    {
     "description": "JG WENTWORTH CO - CL A NEW",
     "symbol": "JGWE"
    },
    {
     "description": "NUVEEN CORPORATE INCOME 2023",
     "symbol": "JHAA"
    },
    {
     "description": "JOHN HANCOCK CORPORATE BOND",
     "symbol": "JHCB"
    },
    {
     "description": "JOHN HANCOCK MULTI MEDIA COM",
     "symbol": "JHCS"
    },
    {
     "description": "JOHN HANCOCK MULTI EM MRK ET",
     "symbol": "JHEM"
    },
    {
     "description": "JANUS HENDERSON GROUP PLC",
     "symbol": "JHG"
    },
    {
     "description": "JOHN HANCOCK INVEST TRUST",
     "symbol": "JHI"
    },
    {
     "description": "JAMES HARDIE INDUSTRIES-CDI",
     "symbol": "JHIUF"
    },
    {
     "description": "JOHN HANCOCK MULT FACT MATER",
     "symbol": "JHMA"
    },
    {
     "description": "JOHN HANCOCK MORTGAGE-BACKED",
     "symbol": "JHMB"
    },
    {
     "description": "JOHN HANCOCK MULT FACT CONSU",
     "symbol": "JHMC"
    },
    {
     "description": "JOHN HANCOCK MF DEV INTL ETF",
     "symbol": "JHMD"
    },
    {
     "description": "JOHN HANCOCK MULT FACT ENRGY",
     "symbol": "JHME"
    },
    {
     "description": "JOHN HANCOCK MULTI FACT FIN",
     "symbol": "JHMF"
    },
    {
     "description": "JOHN HANCOCK MULT FACT HEALT",
     "symbol": "JHMH"
    },
    {
     "description": "JOHN HANCOCK MULT FACT INDUS",
     "symbol": "JHMI"
    },
    {
     "description": "JOHN HANCOCK MULTI FACT LRG",
     "symbol": "JHML"
    },
    {
     "description": "JOHN HANCOCK MULTI FACT MID",
     "symbol": "JHMM"
    },
    {
     "description": "JOHN HANCOCK MULT FACT CONS",
     "symbol": "JHMS"
    },
    {
     "description": "JOHN HANCOCK MULTI FACT TECH",
     "symbol": "JHMT"
    },
    {
     "description": "JOHN HANCOCK MULT FACT UTIL",
     "symbol": "JHMU"
    },
    {
     "description": "JOHN HANCOCK PREFERRED INCOM",
     "symbol": "JHPI"
    },
    {
     "description": "ABLE GLOBAL BHD",
     "symbol": "JHRTF"
    },
    {
     "description": "JOHN HANCOCK INCOME SECS TR",
     "symbol": "JHS"
    },
    {
     "description": "JOHN HANCOCK MULTI SMALL CAP",
     "symbol": "JHSC"
    },
    {
     "description": "JAMES HARDIE IND PLC-SP ADR",
     "symbol": "JHX"
    },
    {
     "description": "JIANGXI COPPER CO LTD-H",
     "symbol": "JIAXF"
    },
    {
     "description": "JANUS HENDERSON SUST IMP C\/B",
     "symbol": "JIB"
    },
    {
     "description": "JPMORGAN ACTBUILD INT EQUITY",
     "symbol": "JIDA"
    },
    {
     "description": "JPMORGAN INTERNATIONAL GROWT",
     "symbol": "JIG"
    },
    {
     "description": "JPM CORP BOND RES EHD ETF",
     "symbol": "JIGB"
    },
    {
     "description": "J. JILL INC",
     "symbol": "JILL"
    },
    {
     "description": "CHINA GOLD INTERNATIONAL RES",
     "symbol": "JINFF"
    },
    {
     "description": "JPM USD ULTSHT INC UCITS ETF",
     "symbol": "JIREF"
    },
    {
     "description": "JIUMAOJIU INTERNATIONAL HOLD",
     "symbol": "JIUMF"
    },
    {
     "description": "IPATH SERIES B BLOOMBERG AGR",
     "symbol": "JJA"
    },
    {
     "description": "IPATH BLOOMBERG AGRICULTURE",
     "symbol": "JJATF"
    },
    {
     "description": "IPATH SERIES B BLOOMBERG COP",
     "symbol": "JJC"
    },
    {
     "description": "IPATH BLOOMBERG COPPER SUBIN",
     "symbol": "JJCTF"
    },
    {
     "description": "IPATH SERIES B BLOOMBERG ENE",
     "symbol": "JJE"
    },
    {
     "description": "IPATH BLOOMBERG ENERGY SUBIN",
     "symbol": "JJETF"
    },
    {
     "description": "IPATH SERIES B BLOOMBERG GRA",
     "symbol": "JJG"
    },
    {
     "description": "IPATH BLOOMBERG GRAINS SUBIN",
     "symbol": "JJGTF"
    },
    {
     "description": "IPATH SER B BLOOMBERG INDUST",
     "symbol": "JJM"
    },
    {
     "description": "IPATH BLOOMBERG INDUSTRIAL M",
     "symbol": "JJMTF"
    },
    {
     "description": "IPATH SERIES B BLOOMBERG NIC",
     "symbol": "JJN"
    },
    {
     "description": "IPATH BLOOMBERG NICKEL SUBIN",
     "symbol": "JJNTF"
    },
    {
     "description": "IPATH BLOOMBERG COFFEE SUBIN",
     "symbol": "JJOFF"
    },
    {
     "description": "IPATH SERIES B BBG PRECIOUS",
     "symbol": "JJP"
    },
    {
     "description": "IPATH BLOOMBERG PRECIOUS MET",
     "symbol": "JJPFF"
    },
    {
     "description": "IPATH SERIES B BBG SOFTS SUB",
     "symbol": "JJS"
    },
    {
     "description": "J & J SNACK FOODS CORP",
     "symbol": "JJSF"
    },
    {
     "description": "IPATH BLOOMBERG SOFTS SUBIND",
     "symbol": "JJSSF"
    },
    {
     "description": "IPATH SERIES B BBG TIN SUBIN",
     "symbol": "JJT"
    },
    {
     "description": "IPATH BLOOMBERG TIN SUBINDEX",
     "symbol": "JJTFF"
    },
    {
     "description": "IPATH SERIES B BLOOMBERG ALU",
     "symbol": "JJU"
    },
    {
     "description": "IPATH BLOOMBERG ALUMINUM SUB",
     "symbol": "JJUFF"
    },
    {
     "description": "JOHN KEELLS HOLDINGS-SP GDR",
     "symbol": "JKELF"
    },
    {
     "description": "JUST KITCHEN HOLDINGS CORP",
     "symbol": "JKHCF"
    },
    {
     "description": "JACK HENRY & ASSOCIATES INC",
     "symbol": "JKHY"
    },
    {
     "description": "LAWFINANCE LTD",
     "symbol": "JKLPF"
    },
    {
     "description": "KINGS ENTERTAINMENT GROUP IN",
     "symbol": "JKPTF"
    },
    {
     "description": "JAKROO INC",
     "symbol": "JKRO"
    },
    {
     "description": "JINKOSOLAR HOLDING CO-ADR",
     "symbol": "JKS"
    },
    {
     "description": "JACKSAM CORP",
     "symbol": "JKSM"
    },
    {
     "description": "JINKE SMART-UNSP ADR",
     "symbol": "JKSSY"
    },
    {
     "description": "JAPAN LOGISTICS FUND INC",
     "symbol": "JLGFF"
    },
    {
     "description": "JONES LANG LASALLE INC",
     "symbol": "JLL"
    },
    {
     "description": "JLM COUTURE INC",
     "symbol": "JLMC"
    },
    {
     "description": "JOLIMARK HOLDINGS LTD",
     "symbol": "JLMKF"
    },
    {
     "description": "SOUTH ATLANTIC GOLD INC",
     "symbol": "JLRRF"
    },
    {
     "description": "NUVEEN MORTGAGE & INCOME",
     "symbol": "JLS"
    },
    {
     "description": "MAXPRO CAPITAL ACQUISITION-A",
     "symbol": "JMAC"
    },
    {
     "description": "MAXPRO CAPITAL ACQUISITION C",
     "symbol": "JMACU"
    },
    {
     "description": "JADE MOUNTAIN ACQUISI -CW23",
     "symbol": "JMACW"
    },
    {
     "description": "JAMES BAY RESOURCES LTD",
     "symbol": "JMBRF"
    },
    {
     "description": "JANUS HENDERSON MORTG BACKED",
     "symbol": "JMBS"
    },
    {
     "description": "JAMCO CORP",
     "symbol": "JMCCF"
    },
    {
     "description": "JMDC INC",
     "symbol": "JMDCF"
    },
    {
     "description": "JAPAN MEDICAL DYNAMIC MKT",
     "symbol": "JMDMF"
    },
    {
     "description": "JARDINE MATHESON HD-UNSP ADR",
     "symbol": "JMHLY"
    },
    {
     "description": "JUMIA TECHNOLOGIES AG-ADR",
     "symbol": "JMIA"
    },
    {
     "description": "JUPITER MARINE INTL HOLDINGS",
     "symbol": "JMIH"
    },
    {
     "description": "JPMORGAN US MIN VOLATILITY",
     "symbol": "JMIN"
    },
    {
     "description": "NINE ALLIANCE SCIENCE & TECH",
     "symbol": "JMKJ"
    },
    {
     "description": "NUVEEN MULTI-MKT INC FD",
     "symbol": "JMM"
    },
    {
     "description": "JPMORGAN US MOMENTUM FACTOR",
     "symbol": "JMOM"
    },
    {
     "description": "JAMES MONROE CAPITAL CORP",
     "symbol": "JMON"
    },
    {
     "description": "KACHIKAIHATSU CO LTD",
     "symbol": "JMOTF"
    },
    {
     "description": "LEVELJUMP HEALTHCARE CORP",
     "symbol": "JMPHF"
    },
    {
     "description": "JOHNSON MATTHEY PLC",
     "symbol": "JMPLF"
    },
    {
     "description": "JOHNSON MATTHEY PLC-SPON ADR",
     "symbol": "JMPLY"
    },
    {
     "description": "JOHN MARSHALL BANCORP INC",
     "symbol": "JMSB"
    },
    {
     "description": "FISHER (JAMES) & SONS PLC",
     "symbol": "JMSFF"
    },
    {
     "description": "JPM ULTRA-SHORT MUNI INCOME",
     "symbol": "JMST"
    },
    {
     "description": "JAMES MARITIME HOLDINGS INC",
     "symbol": "JMTM"
    },
    {
     "description": "JPMORGAN MUNICIPAL ETF",
     "symbol": "JMUB"
    },
    {
     "description": "JAMES VY ETHANOL LLC-CAP U-A",
     "symbol": "JMVYU"
    },
    {
     "description": "JUPITER MINES LTD",
     "symbol": "JMXXF"
    },
    {
     "description": "JNBY DESIGN LTD",
     "symbol": "JNBYF"
    },
    {
     "description": "ROOGOLD INC",
     "symbol": "JNCCF"
    },
    {
     "description": "JOUNCE THERAPEUTICS INC",
     "symbol": "JNCE"
    },
    {
     "description": "JINDALEE RESOURCES LTD",
     "symbol": "JNDAF"
    },
    {
     "description": "JINS HOLDINGS INC",
     "symbol": "JNDOF"
    },
    {
     "description": "CUDA OIL AND GAS INC",
     "symbol": "JNEXF"
    },
    {
     "description": "JACK NATHAN MEDICAL CORP",
     "symbol": "JNHMF"
    },
    {
     "description": "JOHNSON & JOHNSON",
     "symbol": "JNJ"
    },
    {
     "description": "SPDR BLOOMBERG HIGH YIELD BO",
     "symbol": "JNK"
    },
    {
     "description": "JAPAN DISPLAY INC",
     "symbol": "JNNDF"
    },
    {
     "description": "JUNO MINERALS LTD",
     "symbol": "JNOMF"
    },
    {
     "description": "JENOPTIK AG",
     "symbol": "JNPKF"
    },
    {
     "description": "JUNIPER NETWORKS INC",
     "symbol": "JNPR"
    },
    {
     "description": "JNS HOLDINGS CORP",
     "symbol": "JNSH"
    },
    {
     "description": "JINHUI SHIPPING & TRANSPORTA",
     "symbol": "JNSTF"
    },
    {
     "description": "DIREXION DAILY JUNIOR GOLD M",
     "symbol": "JNUG"
    },
    {
     "description": "IPATH SERIES B BLOOMBERG COF",
     "symbol": "JO"
    },
    {
     "description": "JOANN INC",
     "symbol": "JOAN"
    },
    {
     "description": "GEE GROUP INC",
     "symbol": "JOB"
    },
    {
     "description": "51JOB INC-ADR",
     "symbol": "JOBS"
    },
    {
     "description": "JOBY AVIATION INC",
     "symbol": "JOBY"
    },
    {
     "description": "JOBY AVIATION INC     -CW25",
     "symbol": "JOBY.WS"
    },
    {
     "description": "ST JOE CO\/THE",
     "symbol": "JOE"
    },
    {
     "description": "VIRTUS TERRANOVA US QUAL MOM",
     "symbol": "JOET"
    },
    {
     "description": "JOEY NEW YORK INC",
     "symbol": "JOEY"
    },
    {
     "description": "JAPAN SMALLER CAPITALIZATION",
     "symbol": "JOF"
    },
    {
     "description": "JOFF FINTECH ACQ CORP-A",
     "symbol": "JOFF"
    },
    {
     "description": "JOFF FINTECH ACQUISITION COR",
     "symbol": "JOFFU"
    },
    {
     "description": "JOFF FINTECH ACQ -CW27",
     "symbol": "JOFFW"
    },
    {
     "description": "ATAC CREDIT ROTATION ETF",
     "symbol": "JOJO"
    },
    {
     "description": "JOINN LABORATORIES CHINA C-H",
     "symbol": "JOLCF"
    },
    {
     "description": "JOURDAN RESOURCES INC",
     "symbol": "JORFF"
    },
    {
     "description": "JOSEMARIA RESOURCES INC",
     "symbol": "JOSMF"
    },
    {
     "description": "JOHNSON OUTDOORS INC-A",
     "symbol": "JOUT"
    },
    {
     "description": "INFUSIVE COMPOUNDING GLB EQY",
     "symbol": "JOYY"
    },
    {
     "description": "JUPAI HOLDINGS LTD-ADR",
     "symbol": "JP"
    },
    {
     "description": "JAPAN AVIATION ELECTRONICS",
     "symbol": "JPAVF"
    },
    {
     "description": "NUVEEN PREFERRED & INCOME OP",
     "symbol": "JPC"
    },
    {
     "description": "JAPAN DISPLAY INC - UNSP ADR",
     "symbol": "JPDYY"
    },
    {
     "description": "JPM BETA US TRE BD 0-3 USD A",
     "symbol": "JPEIF"
    },
    {
     "description": "JPM DIVERSIFIED RET EM EQUIT",
     "symbol": "JPEM"
    },
    {
     "description": "JPX GLOBAL INC",
     "symbol": "JPEX"
    },
    {
     "description": "JAPFA COMFEED INDONES-TBK PT",
     "symbol": "JPFAF"
    },
    {
     "description": "JPMORGAN EUROPEAN INVEST-INC",
     "symbol": "JPFEF"
    },
    {
     "description": "JPM GL EQ MULTIFAC UCITS ETF",
     "symbol": "JPGLF"
    },
    {
     "description": "JAPAN POST HOLDINGS CO LTD",
     "symbol": "JPHLF"
    },
    {
     "description": "JPM HY RESEARCH ENHANCED",
     "symbol": "JPHY"
    },
    {
     "description": "NUVEEN PFD AND INC TERM FD",
     "symbol": "JPI"
    },
    {
     "description": "JPMORGAN INTL BND ETF",
     "symbol": "JPIB"
    },
    {
     "description": "JPMORGAN INCOME ETF",
     "symbol": "JPIE"
    },
    {
     "description": "JPM DIVERSIFIED RET INTL EQ",
     "symbol": "JPIN"
    },
    {
     "description": "JPMORGAN INDIAN INV TRUST",
     "symbol": "JPIVF"
    },
    {
     "description": "JPMORGAN CHASE & CO",
     "symbol": "JPM"
    },
    {
     "description": "JPMORGAN CHASE & CO",
     "symbol": "JPM.PRC"
    },
    {
     "description": "JPMORGAN CHASE & CO",
     "symbol": "JPM.PRD"
    },
    {
     "description": "JPMORGAN CHASE & CO",
     "symbol": "JPM.PRJ"
    },
    {
     "description": "JPMORGAN CHASE & CO",
     "symbol": "JPM.PRK"
    },
    {
     "description": "JPMORGAN CHASE & CO",
     "symbol": "JPM.PRL"
    },
    {
     "description": "JPMORGAN CHASE & CO",
     "symbol": "JPM.PRM"
    },
    {
     "description": "JPMORGAN USD EMERGING MARKET",
     "symbol": "JPMB"
    },
    {
     "description": "JPM DIVER RET US MC EQUITY",
     "symbol": "JPME"
    },
    {
     "description": "JPM BETA US TRES 0-1 USD UCT",
     "symbol": "JPMIF"
    },
    {
     "description": "JPM USD EM SOV BD UCITS ETF",
     "symbol": "JPMTF"
    },
    {
     "description": "JAPAN CASH MACHINE CO LTD",
     "symbol": "JPNCF"
    },
    {
     "description": "Direxion Daily Japan Bull 3x Shares",
     "symbol": "JPNL"
    },
    {
     "description": "JAPAN AIRLINES CO LTD",
     "symbol": "JPNRF"
    },
    {
     "description": "JACKPOT DIGITAL INC",
     "symbol": "JPOTF"
    },
    {
     "description": "JAPAN POST HOLDING-UNSP ADR",
     "symbol": "JPPHY"
    },
    {
     "description": "JAPAN POST INSURANCE CO LTD",
     "symbol": "JPPIF"
    },
    {
     "description": "JAPAN MATERIAL CO LTD",
     "symbol": "JPPMF"
    },
    {
     "description": "JAPAN PULP & PAPER CO LTD",
     "symbol": "JPPPF"
    },
    {
     "description": "JAPAN POST BANK CO LTD-ADR",
     "symbol": "JPPTY"
    },
    {
     "description": "JAPAN PRIME REALTY INVESTMEN",
     "symbol": "JPRRF"
    },
    {
     "description": "NUVEEN PREFERRED & INCOME SE",
     "symbol": "JPS"
    },
    {
     "description": "JPM DIVERSIFIED RT SMALL CAP",
     "symbol": "JPSE"
    },
    {
     "description": "JPMORGAN ULTRA-SHORT INCOME",
     "symbol": "JPST"
    },
    {
     "description": "JAPAN POST BANK CO LTD",
     "symbol": "JPSTF"
    },
    {
     "description": "JAPAN STEEL WORKS LTD",
     "symbol": "JPSWF"
    },
    {
     "description": "JAPAN STEEL WORKS-UNSPON ADR",
     "symbol": "JPSWY"
    },
    {
     "description": "NUVEEN PREFERRED AND INCOME",
     "symbol": "JPT"
    },
    {
     "description": "JAPAN PETROLEUM EXPLORATION",
     "symbol": "JPTXF"
    },
    {
     "description": "JPM USD ULTSHT INC UCITS ETF",
     "symbol": "JPUHF"
    },
    {
     "description": "JPMORGAN DIV RET US EQ ETF",
     "symbol": "JPUS"
    },
    {
     "description": "JPM BETA US TRE BD 0-3 MXN A",
     "symbol": "JPUTF"
    },
    {
     "description": "JAPAN EXCELLENT INC",
     "symbol": "JPXCF"
    },
    {
     "description": "JAPAN EXCHANGE GROUP INC-ADR",
     "symbol": "JPXGY"
    },
    {
     "description": "ISHARES JPX-NIKKEI 400 ETF",
     "symbol": "JPXN"
    },
    {
     "description": "NUVEEN CREDIT STRAT INCM",
     "symbol": "JQC"
    },
    {
     "description": "JACQUET METALS SA",
     "symbol": "JQTMF"
    },
    {
     "description": "JPMORGAN US QUALITY FACTOR",
     "symbol": "JQUA"
    },
    {
     "description": "JANUS HENDERSON US REAL EST",
     "symbol": "JRE"
    },
    {
     "description": "JPM GLOBAL REI ESG UCITS ETF",
     "symbol": "JREGF"
    },
    {
     "description": "JAPAN REAL ESTATE INVESTMENT",
     "symbol": "JREIF"
    },
    {
     "description": "JAPAN METROPOLITAN FUND INVE",
     "symbol": "JRFIF"
    },
    {
     "description": "DAIWA SECURITIES LIVING INVE",
     "symbol": "JRHIF"
    },
    {
     "description": "NUVEEN RL ASST INC & GRW",
     "symbol": "JRI"
    },
    {
     "description": "JAMES RIVER HOLDINGS CORP",
     "symbol": "JRIV"
    },
    {
     "description": "CHINA FINANCE ONLINE CO-ADR",
     "symbol": "JRJCY"
    },
    {
     "description": "JRJR33 INC",
     "symbol": "JRJRQ"
    },
    {
     "description": "JOURNEY ENERGY INC",
     "symbol": "JRNGF"
    },
    {
     "description": "ALPS GLOBAL TRAVEL BENEF ETF",
     "symbol": "JRNY"
    },
    {
     "description": "NUVEEN FLT RATE INC OPP FD",
     "symbol": "JRO"
    },
    {
     "description": "JERONIMO MARTINS",
     "symbol": "JRONF"
    },
    {
     "description": "JERONIMO MARTINS-UNSPON ADR",
     "symbol": "JRONY"
    },
    {
     "description": "JERICHO ENERGY VENTURES INC",
     "symbol": "JROOF"
    },
    {
     "description": "NUVEEN REAL EST INC FD",
     "symbol": "JRS"
    },
    {
     "description": "JERASH HOLDINGS US INC",
     "symbol": "JRSH"
    },
    {
     "description": "JRSIS HEALTH CARE CORP",
     "symbol": "JRSS"
    },
    {
     "description": "JERVOIS GLOBAL LTD",
     "symbol": "JRVMF"
    },
    {
     "description": "JAMES RIVER GROUP HOLDINGS L",
     "symbol": "JRVR"
    },
    {
     "description": "IMINE CORP",
     "symbol": "JRVS"
    },
    {
     "description": "J. SAINSBURY PLC-SPONS ADR",
     "symbol": "JSAIY"
    },
    {
     "description": "JS BEAUTY LAND NETWORK TECHN",
     "symbol": "JSBL"
    },
    {
     "description": "JPMORGAN SHORT DURATION CORE",
     "symbol": "JSCP"
    },
    {
     "description": "JSR CORP",
     "symbol": "JSCPF"
    },
    {
     "description": "JSR CORP-UNSPONSORED ADR",
     "symbol": "JSCPY"
    },
    {
     "description": "VTB BANK-SPON GDR 144A",
     "symbol": "JSCVL"
    },
    {
     "description": "NUVEEN SHT DUR CRED OPP FD",
     "symbol": "JSD"
    },
    {
     "description": "JONES SODA CO",
     "symbol": "JSDA"
    },
    {
     "description": "JSE LTD",
     "symbol": "JSEJF"
    },
    {
     "description": "JERUSALEM ECONOMY LTD",
     "symbol": "JSEOF"
    },
    {
     "description": "SISTEMA PJSC-REG S SPONS GDR",
     "symbol": "JSFCF"
    },
    {
     "description": "SISTEMA JSFC-144A SPONS GDR",
     "symbol": "JSFCY"
    },
    {
     "description": "LIXIL CORP",
     "symbol": "JSGCF"
    },
    {
     "description": "LIXIL CORP-UNSPN ADR",
     "symbol": "JSGRY"
    },
    {
     "description": "JOSHUA GOLD RESOURCES INC",
     "symbol": "JSHG"
    },
    {
     "description": "NAVIENT CORP",
     "symbol": "JSM"
    },
    {
     "description": "JANUS SMALL MID CAP GR ALP",
     "symbol": "JSMD"
    },
    {
     "description": "JANUS DETROIT STREET TRUST J",
     "symbol": "JSML"
    },
    {
     "description": "SAINSBURY (J) PLC",
     "symbol": "JSNSF"
    },
    {
     "description": "JSP CORP",
     "symbol": "JSPCF"
    },
    {
     "description": "JASPER THERAPEUTICS INC",
     "symbol": "JSPR"
    },
    {
     "description": "JASPER THERAPEUTICS INC-CW26",
     "symbol": "JSPRW"
    },
    {
     "description": "ADASINA SOCIAL JUSTICE GLB",
     "symbol": "JSTC"
    },
    {
     "description": "JUSTISS OIL CO INC",
     "symbol": "JSTS"
    },
    {
     "description": "JOHNSON SERVICE GROUP PLC",
     "symbol": "JSVGF"
    },
    {
     "description": "JUSTSYSTEMS CORP",
     "symbol": "JSYSF"
    },
    {
     "description": "JASTRZEBSKA SPOLKA WEGLOWA S",
     "symbol": "JSZWF"
    },
    {
     "description": "JIANPU TECHNOLOGY INC-SP ADR",
     "symbol": "JT"
    },
    {
     "description": "JETBLACK CORP",
     "symbol": "JTBK"
    },
    {
     "description": "JETCOM INC",
     "symbol": "JTCMF"
    },
    {
     "description": "JTC PLC",
     "symbol": "JTCPF"
    },
    {
     "description": "JTEKT CORP",
     "symbol": "JTEKF"
    },
    {
     "description": "JTEKT CORP-UNSPONSORED ADR",
     "symbol": "JTEKY"
    },
    {
     "description": "JUST EAT TAKEAWAY-SPONS ADR",
     "symbol": "JTKWY"
    },
    {
     "description": "JTNB BANCORP INC",
     "symbol": "JTNB"
    },
    {
     "description": "JAPAN AIRPORT TERMI-UNSP ADR",
     "symbol": "JTTRY"
    },
    {
     "description": "JUBILEE METALS GROUP PLC",
     "symbol": "JUBPF"
    },
    {
     "description": "JAWS JUGGERNAUT ACQUISITIO-A",
     "symbol": "JUGG"
    },
    {
     "description": "JAWS JUGGERNAUT ACQUISITION",
     "symbol": "JUGGU"
    },
    {
     "description": "JAWS JUGGERNAUT ACQUI-CW23",
     "symbol": "JUGGW"
    },
    {
     "description": "JUGGERNAUT EXPLORATION LTD",
     "symbol": "JUGRF"
    },
    {
     "description": "JANUS HENDERSON GROUP-CDI",
     "symbol": "JUHDY"
    },
    {
     "description": "JUKI CORP",
     "symbol": "JUKCF"
    },
    {
     "description": "JUKI CORP-UNSPON ADR",
     "symbol": "JUKIY"
    },
    {
     "description": "TRUESHARES STRUCT OUTCOME JU",
     "symbol": "JULZ"
    },
    {
     "description": "JUMBO SA",
     "symbol": "JUMSF"
    },
    {
     "description": "JUMBO SA-ADR",
     "symbol": "JUMSY"
    },
    {
     "description": "JUMA TECHNOLOGY CORP",
     "symbol": "JUMT"
    },
    {
     "description": "JUNIPER II CORP -CLASS A",
     "symbol": "JUN"
    },
    {
     "description": "JUNIPER II CORP",
     "symbol": "JUN.U"
    },
    {
     "description": "JUNIPER II CORP CL A -CW28",
     "symbol": "JUN.WS"
    },
    {
     "description": "TRUESHARES STRUCTURED OUTCOM",
     "symbol": "JUNZ"
    },
    {
     "description": "JUPITER GOLD CORP",
     "symbol": "JUPGF"
    },
    {
     "description": "JUPITER WELLNESS INC",
     "symbol": "JUPW"
    },
    {
     "description": "JUPITER WELLNESS INC -CW25",
     "symbol": "JUPWW"
    },
    {
     "description": "JPM ACTBUILD US LRG CAP EQ",
     "symbol": "JUSA"
    },
    {
     "description": "JUSHI HOLDINGS INC-B SUB VOT",
     "symbol": "JUSHF"
    },
    {
     "description": "GOLDMAN SACHS JUST US LRG",
     "symbol": "JUST"
    },
    {
     "description": "JUTHA MARITIME PCL-NVDR",
     "symbol": "JUTHF"
    },
    {
     "description": "JUTAL OFFSHORE OIL SERVICES",
     "symbol": "JUTOF"
    },
    {
     "description": "JUTAL OFFSHORE OIL-UNSP ADR",
     "symbol": "JUTOY"
    },
    {
     "description": "JUVA LIFE INC",
     "symbol": "JUVAF"
    },
    {
     "description": "JUNIATA VALLEY FINL CORP-PA",
     "symbol": "JUVF"
    },
    {
     "description": "COFFEE HOLDING CO INC",
     "symbol": "JVA"
    },
    {
     "description": "JPMORGAN US VALUE FACTOR ETF",
     "symbol": "JVAL"
    },
    {
     "description": "JVCKENWOOD CORP-UNSP ADR",
     "symbol": "JVCZY"
    },
    {
     "description": "JUVENTUS FOOTBALL CLUB SPA",
     "symbol": "JVTSF"
    },
    {
     "description": "JUPITER WELLNESS ACQUIS-CL A",
     "symbol": "JWAC"
    },
    {
     "description": "JUPITER WELLNESS ACQUIS-RGTS",
     "symbol": "JWACR"
    },
    {
     "description": "JAMES E WAGNER CULTIVATION C",
     "symbol": "JWCAF"
    },
    {
     "description": "JW CAYMAN THERAPEUTICS CO LT",
     "symbol": "JWCTF"
    },
    {
     "description": "JOWELL GLOBAL LTD",
     "symbol": "JWEL"
    },
    {
     "description": "JAMIESON WELLNESS INC",
     "symbol": "JWLLF"
    },
    {
     "description": "NORDSTROM INC",
     "symbol": "JWN"
    },
    {
     "description": "JAWS MUSTANG ACQUISITION C-A",
     "symbol": "JWSM"
    },
    {
     "description": "JAWS MUSTANG ACQUISITION COR",
     "symbol": "JWSM.U"
    },
    {
     "description": "JAWS MUSTANG ACQ C -CW26",
     "symbol": "JWSM.WS"
    },
    {
     "description": "JAPAN WOOL TEXTILE CO LTD",
     "symbol": "JWTXF"
    },
    {
     "description": "JINXIN FERTILITY GROUP LTD",
     "symbol": "JXFGF"
    },
    {
     "description": "ENEOS HOLDINGS INC",
     "symbol": "JXHGF"
    },
    {
     "description": "ENEOS HOLDINGS INC-UNSP ADR",
     "symbol": "JXHLY"
    },
    {
     "description": "ISHARES GLOBAL UTILITIES ETF",
     "symbol": "JXI"
    },
    {
     "description": "JAXON MINING INC",
     "symbol": "JXMNF"
    },
    {
     "description": "JACKSON FINANCIAL INC-A",
     "symbol": "JXN"
    },
    {
     "description": "JIYA ACQUISITION CORP -CL A",
     "symbol": "JYAC"
    },
    {
     "description": "JAYA BERSAMA INDO TBK PT",
     "symbol": "JYBSF"
    },
    {
     "description": "IPATH JPY\/USD EXCHANGE RATE",
     "symbol": "JYNFF"
    },
    {
     "description": "JOINT CORP\/THE",
     "symbol": "JYNT"
    },
    {
     "description": "JERSEY OIL & GAS PLC",
     "symbol": "JYOGF"
    },
    {
     "description": "JYSKE BANK-REG",
     "symbol": "JYSKF"
    },
    {
     "description": "JYSKE BANK-UNSP ADR",
     "symbol": "JYSKY"
    },
    {
     "description": "JIAYUAN INTERNATIONAL GROUP",
     "symbol": "JYUAF"
    },
    {
     "description": "JZ CAPITAL PARTNERS LTD",
     "symbol": "JZCLF"
    },
    {
     "description": "JAZZ RESOURCES INC",
     "symbol": "JZRIF"
    },
    {
     "description": "JANUS HENDERSON NET ZERO",
     "symbol": "JZRO"
    },
    {
     "description": "JIUZI HOLDINGS INC",
     "symbol": "JZXN"
    },
    {
     "description": "JZZ TECHNOLOGIES INC",
     "symbol": "JZZI"
    },
    {
     "description": "KELLOGG CO",
     "symbol": "K"
    },
    {
     "description": "KAIROUS ACQUISITION CORP LTD",
     "symbol": "KACL"
    },
    {
     "description": "KAIROUS ACQUISITION CORP-RTS",
     "symbol": "KACLR"
    },
    {
     "description": "KAIROUS ACQUISITION CORP LTD",
     "symbol": "KACLU"
    },
    {
     "description": "KAIROUS ACQUISITION -23",
     "symbol": "KACLW"
    },
    {
     "description": "KOA CORP",
     "symbol": "KACPF"
    },
    {
     "description": "KANSAI ELECTRIC POWER CO INC",
     "symbol": "KAEPF"
    },
    {
     "description": "KANSAI ELECTRIC PWR-UNS ADR",
     "symbol": "KAEPY"
    },
    {
     "description": "KKR ACQUISITION HOLDINGS I-A",
     "symbol": "KAHC"
    },
    {
     "description": "KKR ACQUISITION HOLDINGS I C",
     "symbol": "KAHC.U"
    },
    {
     "description": "KKR ACQ HOLDING I CL A -CW27",
     "symbol": "KAHC.WS"
    },
    {
     "description": "KAHALA CORP",
     "symbol": "KAHL"
    },
    {
     "description": "KADANT INC",
     "symbol": "KAI"
    },
    {
     "description": "KISMET ACQUISITION TWO-CL A",
     "symbol": "KAII"
    },
    {
     "description": "KISMET ACQUISITION TWO CORP",
     "symbol": "KAIIU"
    },
    {
     "description": "KISMET ACQ TWO CL A -CW27",
     "symbol": "KAIIW"
    },
    {
     "description": "KAWASAKI KISEN KAISHA-UN ADR",
     "symbol": "KAIKY"
    },
    {
     "description": "KAIROS ACQUISITION CORP-A",
     "symbol": "KAIR"
    },
    {
     "description": "KAIROS ACQUISITION CORP",
     "symbol": "KAIRU"
    },
    {
     "description": "KAIROS ACQ CL A -CW27",
     "symbol": "KAIRW"
    },
    {
     "description": "KAJIMA CORP",
     "symbol": "KAJMF"
    },
    {
     "description": "KAJIMA CORP-UNSPONSORED ADR",
     "symbol": "KAJMY"
    },
    {
     "description": "KAWASAKI KISEN KAISHA LTD",
     "symbol": "KAKKF"
    },
    {
     "description": "JSC KASPI.KZ GDR-REG S",
     "symbol": "KAKZF"
    },
    {
     "description": "KALA PHARMACEUTICALS INC",
     "symbol": "KALA"
    },
    {
     "description": "KAL ENERGY INC",
     "symbol": "KALG"
    },
    {
     "description": "KRANESHARES MSCI ALL CHINA I",
     "symbol": "KALL"
    },
    {
     "description": "KALGOORLIE GOLD MINING LTD",
     "symbol": "KALMF"
    },
    {
     "description": "KALLO INC",
     "symbol": "KALO"
    },
    {
     "description": "KAISER ALUMINUM CORP",
     "symbol": "KALU"
    },
    {
     "description": "KALVISTA PHARMACEUTICALS INC",
     "symbol": "KALV"
    },
    {
     "description": "KALI INC",
     "symbol": "KALY"
    },
    {
     "description": "KAMAN CORP",
     "symbol": "KAMN"
    },
    {
     "description": "KALAMAZOO RESOURCES LIMITED",
     "symbol": "KAMRF"
    },
    {
     "description": "KANEKA CORP",
     "symbol": "KANKF"
    },
    {
     "description": "KAANAPALI LAND LLC",
     "symbol": "KANP"
    },
    {
     "description": "KAO CORP",
     "symbol": "KAOCF"
    },
    {
     "description": "KAO CORP",
     "symbol": "KAOOY"
    },
    {
     "description": "KAP AG",
     "symbol": "KAPBF"
    },
    {
     "description": "INNOVATOR U.S. SMALL CAP POW",
     "symbol": "KAPR"
    },
    {
     "description": "KAR AUCTION SERVICES INC",
     "symbol": "KAR"
    },
    {
     "description": "KARO PHARMA AB",
     "symbol": "KARBF"
    },
    {
     "description": "KOALA CORP",
     "symbol": "KARE"
    },
    {
     "description": "KERNEL HOLDING SA",
     "symbol": "KARNF"
    },
    {
     "description": "KAROOOOO LTD",
     "symbol": "KARO"
    },
    {
     "description": "KRANESHARES ELECTRIC VEHICLE",
     "symbol": "KARS"
    },
    {
     "description": "INTELLABRIDGE TECHNOLOGY COR",
     "symbol": "KASHF"
    },
    {
     "description": "KASTEN INC",
     "symbol": "KAST"
    },
    {
     "description": "KATSURAGAWA ELECTRIC CO LTD",
     "symbol": "KATSF"
    },
    {
     "description": "KAT EXPLORATION INC",
     "symbol": "KATX"
    },
    {
     "description": "KAISER REEF LTD",
     "symbol": "KAURF"
    },
    {
     "description": "KAIVAL BRANDS INNOVATIONS GR",
     "symbol": "KAVL"
    },
    {
     "description": "KAYA HOLDINGS INC",
     "symbol": "KAYS"
    },
    {
     "description": "KB FINANCIAL GROUP INC-ADR",
     "symbol": "KB"
    },
    {
     "description": "KRANESHARES BOSERA MSCI CHIN",
     "symbol": "KBA"
    },
    {
     "description": "KONINKLIJKE BAM GROEP NV",
     "symbol": "KBAGF"
    },
    {
     "description": "KIMBALL INTERNATIONAL-B",
     "symbol": "KBAL"
    },
    {
     "description": "KOPPARBERGS BRYGGERI AB-B",
     "symbol": "KBBPF"
    },
    {
     "description": "KUBOTA PHARMACEUTICAL HOLDIN",
     "symbol": "KBBTF"
    },
    {
     "description": "KBC GROUP NV",
     "symbol": "KBCSF"
    },
    {
     "description": "KBC GROEP NV-UNSP ADR",
     "symbol": "KBCSY"
    },
    {
     "description": "KINGBOARD HOLDINGS LTD",
     "symbol": "KBDCF"
    },
    {
     "description": "KINGBOARD HOLDINGS-UNSPN ADR",
     "symbol": "KBDCY"
    },
    {
     "description": "KABEL DEUTSCHLAND HOLDING AG",
     "symbol": "KBDHF"
    },
    {
     "description": "SPDR S&P BANK ETF",
     "symbol": "KBE"
    },
    {
     "description": "KING'S BAY RESOURCES CORP",
     "symbol": "KBGCF"
    },
    {
     "description": "KB HOME",
     "symbol": "KBH"
    },
    {
     "description": "KRAIG BIOCRAFT LABORATORIES",
     "symbol": "KBLB"
    },
    {
     "description": "KRANESHARES BLOOMBERG CHINA",
     "symbol": "KBND"
    },
    {
     "description": "KUBIENT INC",
     "symbol": "KBNT"
    },
    {
     "description": "KUBIENT INC-CW25",
     "symbol": "KBNTW"
    },
    {
     "description": "KYTO TECHNOLOGY & LIFE SCIEN",
     "symbol": "KBPH"
    },
    {
     "description": "KBR INC",
     "symbol": "KBR"
    },
    {
     "description": "K-BRO LINEN INC",
     "symbol": "KBRLF"
    },
    {
     "description": "KBS REAL ESTATE INVESTMENT T",
     "symbol": "KBRS"
    },
    {
     "description": "KBS GROWTH & INCOME REIT I-A",
     "symbol": "KBSG"
    },
    {
     "description": "KBS REAL ESTATE INVESTMENT T",
     "symbol": "KBSR"
    },
    {
     "description": "KOBE STEEL LTD",
     "symbol": "KBSTF"
    },
    {
     "description": "KRANESHARES CICC CHINA CONS",
     "symbol": "KBUY"
    },
    {
     "description": "INVESCO KBW BANK ETF",
     "symbol": "KBWB"
    },
    {
     "description": "INVESCO KBW HIGH DIVIDEND YI",
     "symbol": "KBWD"
    },
    {
     "description": "INVESCO KBW PROPERTY & CASUA",
     "symbol": "KBWP"
    },
    {
     "description": "INVESCO KBW REGIONAL BANKING",
     "symbol": "KBWR"
    },
    {
     "description": "INVESCO KBW PREMIUM YIELD EQ",
     "symbol": "KBWY"
    },
    {
     "description": "KOBAYASHI PHARMACEUTICAL CO",
     "symbol": "KBYPF"
    },
    {
     "description": "KINGSOFT CLOUD HOLDINGS-ADR",
     "symbol": "KC"
    },
    {
     "description": "KENSINGTON CAPITAL ACQUISIT",
     "symbol": "KCA.U"
    },
    {
     "description": "Kensington Capital Acquisition Corp IV",
     "symbol": "KCAC.A.WS"
    },
    {
     "description": "KENSINGTON CAPITAL ACQUISITI",
     "symbol": "KCAC.U"
    },
    {
     "description": "Kensington Capital Acquisition Corp IV",
     "symbol": "KCAC.WSA"
    },
    {
     "description": "KRANESHARES CALIFORNIA CARBO",
     "symbol": "KCCA"
    },
    {
     "description": "KUTCHO COPPER CORP",
     "symbol": "KCCFF"
    },
    {
     "description": "KIMBERLY-CLARK DE MEXICO-A",
     "symbol": "KCDMF"
    },
    {
     "description": "KIMBERLY-CLARK DE MEXICO-ADR",
     "symbol": "KCDMY"
    },
    {
     "description": "SPDR S&P CAPITAL MARKETS ETF",
     "symbol": "KCE"
    },
    {
     "description": "KENSINGTON CAPITAL ACQ-A",
     "symbol": "KCGI"
    },
    {
     "description": "KENSINGTON CAPITAL ACQUISITI",
     "symbol": "KCGI.U"
    },
    {
     "description": "KENSINGTON CAPITAL ACQ -CW23",
     "symbol": "KCGI.WS"
    },
    {
     "description": "KARELIA TOBACCO CO. S.A.",
     "symbol": "KCIGF"
    },
    {
     "description": "KECK SENG INVESTMENTS",
     "symbol": "KCKSF"
    },
    {
     "description": "KANSAS CITY LIFE INS CO",
     "symbol": "KCLI"
    },
    {
     "description": "KCM HOLDINGS CORP",
     "symbol": "KCMH"
    },
    {
     "description": "KEY CAPITAL CORP\/TX",
     "symbol": "KCPC"
    },
    {
     "description": "KYNDRYL HOLDINGS INC",
     "symbol": "KD"
    },
    {
     "description": "KDC\/ONE DEVELOPMENT CORP INC",
     "symbol": "KDC"
    },
    {
     "description": "KADESTONE CAPITAL CORP",
     "symbol": "KDCCF"
    },
    {
     "description": "KID CASTLE EDUCATIONAL CORP",
     "symbol": "KDCE"
    },
    {
     "description": "KUDELSKI SA-BR",
     "symbol": "KDCXF"
    },
    {
     "description": "KDDI CORP",
     "symbol": "KDDIF"
    },
    {
     "description": "KDDI CORP-UNSPONSORED ADR",
     "symbol": "KDDIY"
    },
    {
     "description": "KAROLINSKA DEVELOPMENT-B",
     "symbol": "KDEVF"
    },
    {
     "description": "KINDSTAR GLOBALGENE TECHNOLO",
     "symbol": "KDGTF"
    },
    {
     "description": "KENEDIX RESIDENTIAL NEXT INV",
     "symbol": "KDIXF"
    },
    {
     "description": "KODIAK COPPER CORP",
     "symbol": "KDKCF"
    },
    {
     "description": "KLONDIKE GOLD CORP",
     "symbol": "KDKGF"
    },
    {
     "description": "KODIAK ENERGY INC",
     "symbol": "KDKN"
    },
    {
     "description": "KADOKAWA DWANGO CORP",
     "symbol": "KDKWF"
    },
    {
     "description": "CHINOOK THERAPEUTICS INC",
     "symbol": "KDNY"
    },
    {
     "description": "KIDOZ INC",
     "symbol": "KDOZF"
    },
    {
     "description": "KEURIG DR PEPPER INC",
     "symbol": "KDP"
    },
    {
     "description": "KINGSBARN TACTICAL BOND ETF",
     "symbol": "KDRN"
    },
    {
     "description": "KONINKLIJKE DSM NV",
     "symbol": "KDSKF"
    },
    {
     "description": "KENEDIX OFFICE INVESTMENT CO",
     "symbol": "KDXRF"
    },
    {
     "description": "KIMBALL ELECTRONICS INC",
     "symbol": "KE"
    },
    {
     "description": "KEWEENAW FINL CORP",
     "symbol": "KEFI"
    },
    {
     "description": "1812 BREWING CO INC",
     "symbol": "KEGS"
    },
    {
     "description": "KEY ENERGY SERVICES INC",
     "symbol": "KEGX"
    },
    {
     "description": "KEIYO BANK LTD\/THE",
     "symbol": "KEIBF"
    },
    {
     "description": "KEIHANSHIN BUILDING CO LTD",
     "symbol": "KEIHF"
    },
    {
     "description": "GLB X CHINA INNOVATION ETF",
     "symbol": "KEJI"
    },
    {
     "description": "KELWYNN INC DEL",
     "symbol": "KELN"
    },
    {
     "description": "KEISEI ELECTRIC RAILWAY CO",
     "symbol": "KELRF"
    },
    {
     "description": "KELT EXPLORATION LTD",
     "symbol": "KELTF"
    },
    {
     "description": "KELLY SERVICES INC -A",
     "symbol": "KELYA"
    },
    {
     "description": "KELLY SERVICES INC -CL B",
     "symbol": "KELYB"
    },
    {
     "description": "KRANESHARES EMERGING MARKETS",
     "symbol": "KEMQ"
    },
    {
     "description": "KRANESHARES MSCI E-MKT EX-CH",
     "symbol": "KEMX"
    },
    {
     "description": "KENON HOLDINGS LTD",
     "symbol": "KEN"
    },
    {
     "description": "KENILWORTH SYSTEMS CORP",
     "symbol": "KENS"
    },
    {
     "description": "KOREA ELEC POWER CORP-SP ADR",
     "symbol": "KEP"
    },
    {
     "description": "KEPPEL PACIFIC OAK US REIT",
     "symbol": "KEPPF"
    },
    {
     "description": "KEWAUNEE SCIENTIFIC CP",
     "symbol": "KEQU"
    },
    {
     "description": "AKERNA CORP",
     "symbol": "KERN"
    },
    {
     "description": "AKERNA CORP",
     "symbol": "KERNW"
    },
    {
     "description": "KRANESHARES MSCI CHINA ESG",
     "symbol": "KESG"
    },
    {
     "description": "KLEOS SPACE SA-CDI",
     "symbol": "KESPF"
    },
    {
     "description": "KRANESHARES EUROPEAN CARBON",
     "symbol": "KEUA"
    },
    {
     "description": "KEWEENAW LAND ASSOCIATION LT",
     "symbol": "KEWL"
    },
    {
     "description": "KIRBY CORP",
     "symbol": "KEX"
    },
    {
     "description": "KEYCORP",
     "symbol": "KEY"
    },
    {
     "description": "KEYCORP",
     "symbol": "KEY.PRI"
    },
    {
     "description": "KEYCORP",
     "symbol": "KEY.PRJ"
    },
    {
     "description": "KEYCORP",
     "symbol": "KEY.PRK"
    },
    {
     "description": "KEY COFFEE INC",
     "symbol": "KEYCF"
    },
    {
     "description": "KEYSTAR CORP",
     "symbol": "KEYR"
    },
    {
     "description": "KEYSIGHT TECHNOLOGIES IN",
     "symbol": "KEYS"
    },
    {
     "description": "KEYERA CORP",
     "symbol": "KEYUF"
    },
    {
     "description": "KOREA FUND INC",
     "symbol": "KF"
    },
    {
     "description": "KENTUCKY FIRST FEDERAL BANCO",
     "symbol": "KFFB"
    },
    {
     "description": "KEFI GOLD AND COPPER PLC",
     "symbol": "KFFLF"
    },
    {
     "description": "KFORCE INC",
     "symbol": "KFRC"
    },
    {
     "description": "KINGSWAY FINANCIAL SERVICES",
     "symbol": "KFS"
    },
    {
     "description": "KINGSWAY FINANCIAL-CL B-CW23",
     "symbol": "KFSYF"
    },
    {
     "description": "KRANESHARES CICC CHINA 5G",
     "symbol": "KFVG"
    },
    {
     "description": "KORN FERRY",
     "symbol": "KFY"
    },
    {
     "description": "KRANESHARES CICC CHINA LEADE",
     "symbol": "KFYP"
    },
    {
     "description": "KONGSBERG AUTOMOTIVE ASA",
     "symbol": "KGAUF"
    },
    {
     "description": "KINGBOARD LAMINATES HLDG LTD",
     "symbol": "KGBLF"
    },
    {
     "description": "KINGBOARD LAMINATE-UNSP ADR",
     "symbol": "KGBLY"
    },
    {
     "description": "KINROSS GOLD CORP",
     "symbol": "KGC"
    },
    {
     "description": "KINGDEE INTERNATIONAL SFTWR",
     "symbol": "KGDEF"
    },
    {
     "description": "KINGDEE INTERNAT-UNSPON ADR",
     "symbol": "KGDEY"
    },
    {
     "description": "KOLIBRI GLOBAL ENERGY INC",
     "symbol": "KGEIF"
    },
    {
     "description": "KLEANGAS ENERGY TECHNOLOGIES",
     "symbol": "KGET"
    },
    {
     "description": "KINGFISHER PLC",
     "symbol": "KGFHF"
    },
    {
     "description": "KINGFISHER PLC-SPONS ADR",
     "symbol": "KGFHY"
    },
    {
     "description": "KINGFISHER METAL CORP",
     "symbol": "KGFMF"
    },
    {
     "description": "KINGSOFT CORP LTD - SPON",
     "symbol": "KGFTY"
    },
    {
     "description": "KOGAN.COM LTD",
     "symbol": "KGGNF"
    },
    {
     "description": "KRANESHARES GLOBAL CARBON TR",
     "symbol": "KGHG"
    },
    {
     "description": "KAISER GROUP HOLDINGS INC",
     "symbol": "KGHI"
    },
    {
     "description": "KGHM POLSKA MIEDZ SA",
     "symbol": "KGHPF"
    },
    {
     "description": "PANGOLIN DIAMONDS CORP",
     "symbol": "KGHZF"
    },
    {
     "description": "KINGOLD JEWELRY INC",
     "symbol": "KGJI"
    },
    {
     "description": "KONA GOLD BEVERAGE INC",
     "symbol": "KGKG"
    },
    {
     "description": "KING GLOBAL VENTURES INC",
     "symbol": "KGLDF"
    },
    {
     "description": "KGL RESOURCES LTD",
     "symbol": "KGLLF"
    },
    {
     "description": "KAGOME CO LTD",
     "symbol": "KGMEF"
    },
    {
     "description": "KANGE CORP",
     "symbol": "KGNR"
    },
    {
     "description": "KILEY GROUP INC\/THE",
     "symbol": "KGRI"
    },
    {
     "description": "KRANESHARES MSCI CHINA CLEAN",
     "symbol": "KGRN"
    },
    {
     "description": "KRANESHARES CHINA INNOVATION",
     "symbol": "KGRO"
    },
    {
     "description": "KUNGSLEDEN AB",
     "symbol": "KGSDF"
    },
    {
     "description": "KINGSPAN GROUP PLC",
     "symbol": "KGSPF"
    },
    {
     "description": "KINGSPAN GROUP PLC-UNSP ADR",
     "symbol": "KGSPY"
    },
    {
     "description": "KINGMAN MINERALS LTD",
     "symbol": "KGSSF"
    },
    {
     "description": "KRUNG THAI BANK PUB CO-FOREI",
     "symbol": "KGTFF"
    },
    {
     "description": "KRUNG THAI BANK PUB-UNSP ADR",
     "symbol": "KGTFY"
    },
    {
     "description": "KRUNGTHAI CARD PCL-UNSP ADR",
     "symbol": "KGTHY"
    },
    {
     "description": "KRUNG THAI BANK PUB CO LTD",
     "symbol": "KGTLF"
    },
    {
     "description": "KRAFT HEINZ CO\/THE",
     "symbol": "KHC"
    },
    {
     "description": "KHD HUMBOLDT WEDAG INTERNATI",
     "symbol": "KHDHF"
    },
    {
     "description": "KEIKYU CORP",
     "symbol": "KHEXF"
    },
    {
     "description": "KOHNAN SHOJI CO LTD",
     "symbol": "KHJCF"
    },
    {
     "description": "KUEHNE + NAGEL INTL AG-REG",
     "symbol": "KHNGF"
    },
    {
     "description": "KUEHNE & NAGEL INTL-UNSP ADR",
     "symbol": "KHNGY"
    },
    {
     "description": "KEIHAN HOLDINGS CO LTD",
     "symbol": "KHNRF"
    },
    {
     "description": "KOC HOLDING AS-UNSPON ADR",
     "symbol": "KHOLY"
    },
    {
     "description": "KAHOOT! ASA",
     "symbol": "KHOTF"
    },
    {
     "description": "KHIRON LIFE SCIENCES CORP",
     "symbol": "KHRNF"
    },
    {
     "description": "KHIRON LIFE SCIENCES C-CW25",
     "symbol": "KHRWF"
    },
    {
     "description": "KNIGHT THERAPEUTICS INC",
     "symbol": "KHTRF"
    },
    {
     "description": "KRANESHARES ASIA PACIFIC HIG",
     "symbol": "KHYB"
    },
    {
     "description": "MADISON AVE MEDIA INC",
     "symbol": "KHZM"
    },
    {
     "description": "KIARO HOLDINGS CORP",
     "symbol": "KIARF"
    },
    {
     "description": "HPN HOLDINGS INC",
     "symbol": "KICK"
    },
    {
     "description": "KID BRANDS INC",
     "symbol": "KIDBQ"
    },
    {
     "description": "ORTHOPEDIATRICS CORP",
     "symbol": "KIDS"
    },
    {
     "description": "SPDR S&P INSURANCE ETF",
     "symbol": "KIE"
    },
    {
     "description": "KIER GROUP PLC",
     "symbol": "KIERF"
    },
    {
     "description": "KION GROUP AG-UNSP ADR",
     "symbol": "KIGRY"
    },
    {
     "description": "KISMET ACQUISITION THREE - A",
     "symbol": "KIII"
    },
    {
     "description": "KISMET ACQUISITION THREE COR",
     "symbol": "KIIIU"
    },
    {
     "description": "KISMET ACQ THREE A -CW27",
     "symbol": "KIIIW"
    },
    {
     "description": "KIKKOMAN CORP",
     "symbol": "KIKOF"
    },
    {
     "description": "KIKKOMAN CORP-UNSP ADR",
     "symbol": "KIKOY"
    },
    {
     "description": "KIMCO REALTY CORP",
     "symbol": "KIM"
    },
    {
     "description": "KIMCO REALTY CORP",
     "symbol": "KIM.PRL"
    },
    {
     "description": "KIMCO REALTY CORP",
     "symbol": "KIM.PRM"
    },
    {
     "description": "KIA CORP",
     "symbol": "KIMTF"
    },
    {
     "description": "NEXTDOOR HOLDINGS INC",
     "symbol": "KIND"
    },
    {
     "description": "KINGSTONE COS INC",
     "symbol": "KINS"
    },
    {
     "description": "KINTETSU GROUP HOLDINGS CO L",
     "symbol": "KINUF"
    },
    {
     "description": "KINS TECHNOLOGY GROUP INC-A",
     "symbol": "KINZ"
    },
    {
     "description": "KINS TECHNOLOGY GROUP INC",
     "symbol": "KINZU"
    },
    {
     "description": "KINS TECH GROUP CL A -CW25",
     "symbol": "KINZW"
    },
    {
     "description": "KKR INCOME OPPORTUNITIES",
     "symbol": "KIO"
    },
    {
     "description": "KELSO TECHNOLOGIES INC",
     "symbol": "KIQ"
    },
    {
     "description": "KIRKLAND'S INC",
     "symbol": "KIRK"
    },
    {
     "description": "KUMBA IRON ORE LTD-ADR",
     "symbol": "KIROY"
    },
    {
     "description": "KISH BANCORP INC\/PA",
     "symbol": "KISB"
    },
    {
     "description": "GROUP 6 METALS LTD",
     "symbol": "KISLF"
    },
    {
     "description": "KITANOTATSUJIN CORP",
     "symbol": "KITAF"
    },
    {
     "description": "KISSES FROM ITALY INC",
     "symbol": "KITL"
    },
    {
     "description": "PURPLE BIOTECH LTD",
     "symbol": "KITVF"
    },
    {
     "description": "KITZ CORP",
     "symbol": "KITZF"
    },
    {
     "description": "KIWIBOX.COM INC",
     "symbol": "KIWB"
    },
    {
     "description": "KIYO BANK LTD\/THE",
     "symbol": "KIYOF"
    },
    {
     "description": "INNOVATOR U.S. SMALL CAP POW",
     "symbol": "KJAN"
    },
    {
     "description": "COMJOYFUL INTERNATIONAL CO",
     "symbol": "KJFI"
    },
    {
     "description": "INNOVATOR U.S. SMALL CAP POW",
     "symbol": "KJUL"
    },
    {
     "description": "HINOKIYA GROUP CO LTD",
     "symbol": "KKHNF"
    },
    {
     "description": "KAKAKU.COM INC",
     "symbol": "KKKUF"
    },
    {
     "description": "KAKAKU.COM INC-UNSP ADR",
     "symbol": "KKMMY"
    },
    {
     "description": "KESKO OYJ-B SHS",
     "symbol": "KKOYF"
    },
    {
     "description": "KESKO OYJ-B SHS-UNSPON ADR",
     "symbol": "KKOYY"
    },
    {
     "description": "KAKEN PHARMACEUTICAL CO LTD",
     "symbol": "KKPCF"
    },
    {
     "description": "KAISA PROSPERITY HOLDINGS LT",
     "symbol": "KKPFF"
    },
    {
     "description": "KONINKLIJKE KPN NV",
     "symbol": "KKPNF"
    },
    {
     "description": "KONINKLIJKE KPN NV - SP ADR",
     "symbol": "KKPNY"
    },
    {
     "description": "KOKO PETROLEUM INC",
     "symbol": "KKPT"
    },
    {
     "description": "KKR & CO INC",
     "symbol": "KKR"
    },
    {
     "description": "KKR & CO INC",
     "symbol": "KKR.PRC"
    },
    {
     "description": "KATAKURA INDUSTRIES CO LTD",
     "symbol": "KKRAF"
    },
    {
     "description": "KKR GROUP FIN CO IX LLC",
     "symbol": "KKRS"
    },
    {
     "description": "CHROMOCURE INC",
     "symbol": "KKUR"
    },
    {
     "description": "BOSKALIS WESTMINSTER",
     "symbol": "KKWFF"
    },
    {
     "description": "KLA CORP",
     "symbol": "KLAC"
    },
    {
     "description": "KL ACQUISITION CORP\/MO-CLS A",
     "symbol": "KLAQ"
    },
    {
     "description": "KL ACQUISITION CORP",
     "symbol": "KLAQU"
    },
    {
     "description": "KL ACQUISITION CORP -CW28",
     "symbol": "KLAQW"
    },
    {
     "description": "KLABIN SA-SPONS ADR",
     "symbol": "KLBAY"
    },
    {
     "description": "KLAB INC",
     "symbol": "KLBIF"
    },
    {
     "description": "KFA LRG CAP QUAL DIV NDX ETF",
     "symbol": "KLCD"
    },
    {
     "description": "KLDISCOVERY INC",
     "symbol": "KLDI"
    },
    {
     "description": "KLDISCOVERY INC-CW24",
     "symbol": "KLDIW"
    },
    {
     "description": "KALEIDO BIOSCIENCES INC",
     "symbol": "KLDO"
    },
    {
     "description": "KNOWLEDGE LEADERS DEVELOPED",
     "symbol": "KLDW"
    },
    {
     "description": "KALO GOLD CORP",
     "symbol": "KLGDF"
    },
    {
     "description": "KLEGG ELECTRONICS INC",
     "symbol": "KLGG"
    },
    {
     "description": "KILLBUCK BANCSHARES INC",
     "symbol": "KLIB"
    },
    {
     "description": "KULICKE & SOFFA INDUSTRIES",
     "symbol": "KLIC"
    },
    {
     "description": "KUALA LUMPUR KEPONG BHD",
     "symbol": "KLKBF"
    },
    {
     "description": "KUALA LUMPUR KEPONG-UNSP ADR",
     "symbol": "KLKBY"
    },
    {
     "description": "KLOECKNER & CO SE",
     "symbol": "KLKNF"
    },
    {
     "description": "KALIUM LAKES LTD",
     "symbol": "KLLKF"
    },
    {
     "description": "KLIMATOR AB",
     "symbol": "KLMAF"
    },
    {
     "description": "KLM ROYAL DUTCH AIR  -NY REG",
     "symbol": "KLMR"
    },
    {
     "description": "DIREXION DAILY GLOBAL CLEAN",
     "symbol": "KLNE"
    },
    {
     "description": "KUSHNER LOCKE CO",
     "symbol": "KLOC"
    },
    {
     "description": "KLEPIERRE",
     "symbol": "KLPEF"
    },
    {
     "description": "KALEYRA INC",
     "symbol": "KLR"
    },
    {
     "description": "KALEYRA INC    - CW23",
     "symbol": "KLR.WS"
    },
    {
     "description": "KELLER GROUP PLC",
     "symbol": "KLRGF"
    },
    {
     "description": "KLONDIKE SILVER CORP",
     "symbol": "KLSVF"
    },
    {
     "description": "KOOLEARN TECHNOLOGY HOLDING",
     "symbol": "KLTHF"
    },
    {
     "description": "KLAUSTECH INC",
     "symbol": "KLTI"
    },
    {
     "description": "KALTURA INC",
     "symbol": "KLTR"
    },
    {
     "description": "KLX ENERGY SERVICES HOLDING",
     "symbol": "KLXE"
    },
    {
     "description": "KUNLUN ENERGY CO  -UNSP ADR",
     "symbol": "KLYCY"
    },
    {
     "description": "KELYNIAM GLOBAL INC",
     "symbol": "KLYG"
    },
    {
     "description": "KOMAX HOLDING AG-REG",
     "symbol": "KMAAF"
    },
    {
     "description": "KMA GLOBAL SOLUTIONS INTERNA",
     "symbol": "KMAG"
    },
    {
     "description": "KIMBERLY-CLARK CORP",
     "symbol": "KMB"
    },
    {
     "description": "KAMBI GROUP PLC",
     "symbol": "KMBIF"
    },
    {
     "description": "KAMADA LTD",
     "symbol": "KMDA"
    },
    {
     "description": "KOMEDA HOLDINGS CO LTD",
     "symbol": "KMDHF"
    },
    {
     "description": "KERMODE RESOURCES LTD",
     "symbol": "KMDRF"
    },
    {
     "description": "KRANESHARES EMERGING MARKETS",
     "symbol": "KMED"
    },
    {
     "description": "KOMERCNI BANKA AS",
     "symbol": "KMERF"
    },
    {
     "description": "KAYNE ANDERSON NEXTGEN ENERG",
     "symbol": "KMF"
    },
    {
     "description": "KELLER MANUFACTURING CO INC",
     "symbol": "KMFI"
    },
    {
     "description": "KUMAGAI GUMI CO LTD",
     "symbol": "KMGGF"
    },
    {
     "description": "KEMIAO GARMENT HOLDING GROUP",
     "symbol": "KMGH"
    },
    {
     "description": "KAMIGUMI CO LTD",
     "symbol": "KMGIF"
    },
    {
     "description": "ASIAMET RESOURCES LTD",
     "symbol": "KMGLF"
    },
    {
     "description": "KINDER MORGAN INC",
     "symbol": "KMI"
    },
    {
     "description": "KFA MOUNT LUCAS INDEX ST ETF",
     "symbol": "KMLM"
    },
    {
     "description": "RESPIRI LTD",
     "symbol": "KMLXF"
    },
    {
     "description": "FIRST URANIUM RESOURCES LTD",
     "symbol": "KMMIF"
    },
    {
     "description": "KILLAM APARTMENT REAL ESTATE",
     "symbol": "KMMPF"
    },
    {
     "description": "KINGSMEN CREATIVES LTD",
     "symbol": "KMNCF"
    },
    {
     "description": "KMN CAPITAL LTD",
     "symbol": "KMNNF"
    },
    {
     "description": "KEMPER CORP",
     "symbol": "KMPB"
    },
    {
     "description": "KEMPHARM INC",
     "symbol": "KMPH"
    },
    {
     "description": "KEMPER CORP",
     "symbol": "KMPR"
    },
    {
     "description": "KOMORI CORP",
     "symbol": "KMRCF"
    },
    {
     "description": "KOMERI CO LTD",
     "symbol": "KMRIF"
    },
    {
     "description": "KENMARE RESOURCES PLC",
     "symbol": "KMRPF"
    },
    {
     "description": "KAMAKURA SHINSHO LTD",
     "symbol": "KMSHF"
    },
    {
     "description": "KADIMASTEM LTD",
     "symbol": "KMSTF"
    },
    {
     "description": "KINGMAKER FOOTWEAR HLDGS LTD",
     "symbol": "KMSWF"
    },
    {
     "description": "KENNAMETAL INC",
     "symbol": "KMT"
    },
    {
     "description": "KOMATSU LTD",
     "symbol": "KMTUF"
    },
    {
     "description": "KOMATSU LTD -SPONS ADR",
     "symbol": "KMTUY"
    },
    {
     "description": "KAMUX CORP",
     "symbol": "KMUXF"
    },
    {
     "description": "KM WEDDING EVENTS MANAGEMENT",
     "symbol": "KMWE"
    },
    {
     "description": "CARMAX INC",
     "symbol": "KMX"
    },
    {
     "description": "KNOWLES CORP",
     "symbol": "KN"
    },
    {
     "description": "KONAMI HOLDINGS CORP",
     "symbol": "KNAMF"
    },
    {
     "description": "KINBASHA GAMING INTERNATIONA",
     "symbol": "KNBA"
    },
    {
     "description": "KNOWBE4 INC-A",
     "symbol": "KNBE"
    },
    {
     "description": "KNORR-BREMSE AG",
     "symbol": "KNBHF"
    },
    {
     "description": "KANE BIOTECH INC",
     "symbol": "KNBIF"
    },
    {
     "description": "KIRIN HOLDINGS CO LTD",
     "symbol": "KNBWF"
    },
    {
     "description": "KIRIN HOLDINGS CO-SPON ADR",
     "symbol": "KNBWY"
    },
    {
     "description": "KONICA MINOLTA INC",
     "symbol": "KNCAF"
    },
    {
     "description": "KONICA MINOLTA INC -UNS ADR",
     "symbol": "KNCAY"
    },
    {
     "description": "KENCANA AGRI LTD",
     "symbol": "KNCNF"
    },
    {
     "description": "KONECRANES OYJ",
     "symbol": "KNCRF"
    },
    {
     "description": "KONECRANES OYJ-UNSPON ADR",
     "symbol": "KNCRY"
    },
    {
     "description": "KINDEN CORP",
     "symbol": "KNDEF"
    },
    {
     "description": "KINDRED GROUP PLC",
     "symbol": "KNDGF"
    },
    {
     "description": "KANDI TECHNOLOGIES GROUP INC",
     "symbol": "KNDI"
    },
    {
     "description": "KENADYR METALS CORP",
     "symbol": "KNDYF"
    },
    {
     "description": "KNEOMEDIA LTD",
     "symbol": "KNEOF"
    },
    {
     "description": "KINGFISH LTD",
     "symbol": "KNFHF"
    },
    {
     "description": "KIATNAKIN PHATRA BAN-FOREIGN",
     "symbol": "KNFSF"
    },
    {
     "description": "FT CBOE VEST S&P 500 DIVIDEN",
     "symbol": "KNG"
    },
    {
     "description": "KINGSMEN RESOURCES LTD",
     "symbol": "KNGRF"
    },
    {
     "description": "UPHOLDINGS COMPOUND KINGS ET",
     "symbol": "KNGS"
    },
    {
     "description": "KENONGWO GROUP US INC",
     "symbol": "KNGW"
    },
    {
     "description": "KIM HENG LTD",
     "symbol": "KNHGF"
    },
    {
     "description": "KINETIC GROUP INC",
     "symbol": "KNIT"
    },
    {
     "description": "KINNEVIK AB - B",
     "symbol": "KNKBF"
    },
    {
     "description": "KUNEKT CORP",
     "symbol": "KNKT"
    },
    {
     "description": "KWS SAAT SE & CO KGAA",
     "symbol": "KNKZF"
    },
    {
     "description": "Knoll Inc",
     "symbol": "KNL"
    },
    {
     "description": "KANAMOTO CO LTD",
     "symbol": "KNMOF"
    },
    {
     "description": "KH NEOCHEM CO LTD",
     "symbol": "KNNCF"
    },
    {
     "description": "KION GROUP AG",
     "symbol": "KNNGF"
    },
    {
     "description": "KANEMATSU SUSTECH CORP",
     "symbol": "KNNKF"
    },
    {
     "description": "KAINOS GROUP PLC",
     "symbol": "KNNNF"
    },
    {
     "description": "KNOT OFFSHORE PARTNERS LP",
     "symbol": "KNOP"
    },
    {
     "description": "KRONOS ADVANCED TECHNOLOGIES",
     "symbol": "KNOS"
    },
    {
     "description": "KONTROL TECHNOLOGIES CORP",
     "symbol": "KNRLF"
    },
    {
     "description": "KNORR-BREMSE - UNSP ADR",
     "symbol": "KNRRY"
    },
    {
     "description": "KINIKSA PHARMACEUTICALS-A",
     "symbol": "KNSA"
    },
    {
     "description": "KINSALE CAPITAL GROUP INC",
     "symbol": "KNSL"
    },
    {
     "description": "KNIGHTSWAN ACQUISITION COR-A",
     "symbol": "KNSW"
    },
    {
     "description": "KNIGHTSWAN ACQUISITION CORP",
     "symbol": "KNSW.U"
    },
    {
     "description": "KNIGHTSWAN ACQUISITION A -28",
     "symbol": "KNSW.WS"
    },
    {
     "description": "KINNATE BIOPHARMA INC",
     "symbol": "KNTE"
    },
    {
     "description": "KINETIK HOLDINGS INC",
     "symbol": "KNTK"
    },
    {
     "description": "K92 MINING",
     "symbol": "KNTNF"
    },
    {
     "description": "KINTOR PHARMACEUTICAL LTD",
     "symbol": "KNTPF"
    },
    {
     "description": "KINTETSU DEPT STORE CO LTD",
     "symbol": "KNTTF"
    },
    {
     "description": "KNOW LABS INC",
     "symbol": "KNWN"
    },
    {
     "description": "KNIGHT-SWIFT TRANSPORTATION",
     "symbol": "KNX"
    },
    {
     "description": "KONE OYJ-B",
     "symbol": "KNYJF"
    },
    {
     "description": "KONE OYJ-B-UNSPONSORED ADR",
     "symbol": "KNYJY"
    },
    {
     "description": "COCA-COLA CO\/THE",
     "symbol": "KO"
    },
    {
     "description": "RESONATE BLENDS INC",
     "symbol": "KOAN"
    },
    {
     "description": "KOBE BUSSAN CO LTD",
     "symbol": "KOBNF"
    },
    {
     "description": "FIS KNIGHTS OF COL GLO BELIE",
     "symbol": "KOCG"
    },
    {
     "description": "INNOVATOR U.S. SMALL CAP POW",
     "symbol": "KOCT"
    },
    {
     "description": "KODIAK SCIENCES INC",
     "symbol": "KOD"
    },
    {
     "description": "EASTMAN KODAK CO",
     "symbol": "KODK"
    },
    {
     "description": "COCA-COLA FEMSA SAB-SP ADR",
     "symbol": "KOF"
    },
    {
     "description": "KOPP GLASS INC",
     "symbol": "KOGL"
    },
    {
     "description": "KGL RESOURCES LTD",
     "symbol": "KOGMF"
    },
    {
     "description": "CAPITAL LINK GLOBAL FINTECH",
     "symbol": "KOIN"
    },
    {
     "description": "KOJAMO OYJ",
     "symbol": "KOJAF"
    },
    {
     "description": "XTRACKERS MSCI KOKUSAI EQTY",
     "symbol": "KOKU"
    },
    {
     "description": "PROSHARES ULTRASHORT BLOOMBE",
     "symbol": "KOLD"
    },
    {
     "description": "KOLORFUSION INTL INC",
     "symbol": "KOLR"
    },
    {
     "description": "KOMO PLANT BASED FOODS INC",
     "symbol": "KOMOF"
    },
    {
     "description": "SPDR S&P KENSHO NEW ECONOMIE",
     "symbol": "KOMP"
    },
    {
     "description": "WELLBEING DIGITAL SCIENCES I",
     "symbol": "KONEF"
    },
    {
     "description": "FORMIDABLE FORTRESS ETF",
     "symbol": "KONG"
    },
    {
     "description": "Konami Holdings UNSP\/ADR",
     "symbol": "KONMY"
    },
    {
     "description": "KOOTENAY SILVER INC",
     "symbol": "KOOYF"
    },
    {
     "description": "KOPPERS HOLDINGS INC",
     "symbol": "KOP"
    },
    {
     "description": "KOPIN CORP",
     "symbol": "KOPN"
    },
    {
     "description": "KORE GROUP HOLDINGS INC",
     "symbol": "KORE"
    },
    {
     "description": "KING PUBCO INC -CW28",
     "symbol": "KORE.WS"
    },
    {
     "description": "KORE MINING LTD",
     "symbol": "KOREF"
    },
    {
     "description": "AMERICAN CENTURY DIVERSIFIED",
     "symbol": "KORP"
    },
    {
     "description": "DIREXION DLY S KOREA BULL 3X",
     "symbol": "KORU"
    },
    {
     "description": "KOSMOS ENERGY LTD",
     "symbol": "KOS"
    },
    {
     "description": "KOSE CORP",
     "symbol": "KOSCF"
    },
    {
     "description": "ONE STEP VENDING CORP",
     "symbol": "KOSK"
    },
    {
     "description": "KOSS CORP",
     "symbol": "KOSS"
    },
    {
     "description": "KOITO MANUFACTURING CO LTD",
     "symbol": "KOTMF"
    },
    {
     "description": "KOITO MANUFACTURING CO-ADR",
     "symbol": "KOTMY"
    },
    {
     "description": "KORVER CORP",
     "symbol": "KOVR"
    },
    {
     "description": "KEMIRA OYJ",
     "symbol": "KOYJF"
    },
    {
     "description": "KOZA ALTIN ISLETMEL-UNSP ADR",
     "symbol": "KOZAY"
    },
    {
     "description": "KOZA ALTIN ISLETMELERI AS",
     "symbol": "KOZZF"
    },
    {
     "description": "KINERJAPAY CORP",
     "symbol": "KPAY"
    },
    {
     "description": "KING OF PINE CREEK MINING",
     "symbol": "KPCM"
    },
    {
     "description": "KASIKORNBANK PCL-FOREIGN",
     "symbol": "KPCPF"
    },
    {
     "description": "KASIKORNBANK PCL-UNSPON ADR",
     "symbol": "KPCPY"
    },
    {
     "description": "KAPUAS PRIMA COAL TBK PT",
     "symbol": "KPCTF"
    },
    {
     "description": "KASIKORNBANK PCL-NVDR",
     "symbol": "KPCUF"
    },
    {
     "description": "KEPPEL DC REIT",
     "symbol": "KPDCF"
    },
    {
     "description": "KEPPEL CORP LTD",
     "symbol": "KPELF"
    },
    {
     "description": "KEPPEL CORP LTD-SPONS ADR",
     "symbol": "KPELY"
    },
    {
     "description": "KELLY PARTNERS GROUP HOLDING",
     "symbol": "KPGHF"
    },
    {
     "description": "KEY PETROLEUM LTD",
     "symbol": "KPHWF"
    },
    {
     "description": "EDGEWATER WIRELESS SYSTEMS I",
     "symbol": "KPIFF"
    },
    {
     "description": "KEPPEL INFRASTRUCTURE TRUST",
     "symbol": "KPLIF"
    },
    {
     "description": "KATAPULT HOLDINGS INC",
     "symbol": "KPLT"
    },
    {
     "description": "KATAPULT HOLDINGS INC -CW26",
     "symbol": "KPLTW"
    },
    {
     "description": "K+S AG-REG",
     "symbol": "KPLUF"
    },
    {
     "description": "K+S AG-SPONSORED ADR",
     "symbol": "KPLUY"
    },
    {
     "description": "KIMBERLY PARRY ORGANICS CORP",
     "symbol": "KPOC"
    },
    {
     "description": "KEEPER TECHNICAL LABORATORY",
     "symbol": "KPRTF"
    },
    {
     "description": "KIORA PHARMACEUTICALS INC",
     "symbol": "KPRX"
    },
    {
     "description": "KPS AG",
     "symbol": "KPSGF"
    },
    {
     "description": "KAPSCH TRAFFICCOM AG",
     "symbol": "KPSHF"
    },
    {
     "description": "KANSAI PAINT CO - UNSP ADR",
     "symbol": "KPTCY"
    },
    {
     "description": "KARYOPHARM THERAPEUTICS INC",
     "symbol": "KPTI"
    },
    {
     "description": "KP TISSUE INC",
     "symbol": "KPTSF"
    },
    {
     "description": "OPHIR GOLD CORP",
     "symbol": "KPZIF"
    },
    {
     "description": "KROGER CO",
     "symbol": "KR"
    },
    {
     "description": "KRANESHARES CSI CHINA INTRNT",
     "symbol": "KRANF"
    },
    {
     "description": "KREIDO BIOFUELS INC",
     "symbol": "KRBF"
    },
    {
     "description": "KS GLOBAL CARBON STRATGY ETF",
     "symbol": "KRBN"
    },
    {
     "description": "KURABO INDUSTRIES LTD",
     "symbol": "KRBOF"
    },
    {
     "description": "KIROMIC BIOPHARMA INC",
     "symbol": "KRBP"
    },
    {
     "description": "KORAB RESOURCES LTD",
     "symbol": "KRBRF"
    },
    {
     "description": "KILROY REALTY CORP",
     "symbol": "KRC"
    },
    {
     "description": "KING RIVER RESOURCES LTD",
     "symbol": "KRCLF"
    },
    {
     "description": "KARDEX HOLDING AG-REG",
     "symbol": "KRDXF"
    },
    {
     "description": "SPDR S&P REGIONAL BANKING",
     "symbol": "KRE"
    },
    {
     "description": "KONARED CORP",
     "symbol": "KRED"
    },
    {
     "description": "KKR REAL ESTATE FINANCE TRUS",
     "symbol": "KREF"
    },
    {
     "description": "KKR REAL ESTATE FIN",
     "symbol": "KREF.PRA"
    },
    {
     "description": "KEPPEL REIT",
     "symbol": "KREVF"
    },
    {
     "description": "KING RESOURCES INC",
     "symbol": "KRFG"
    },
    {
     "description": "KITE REALTY GROUP TRUST",
     "symbol": "KRG"
    },
    {
     "description": "KEG ROYALTIES INCOME FUND-UT",
     "symbol": "KRIUF"
    },
    {
     "description": "KRUK SA",
     "symbol": "KRKKF"
    },
    {
     "description": "KRAKEN ROBOTICS INC",
     "symbol": "KRKNF"
    },
    {
     "description": "36KR HOLDINGS INC",
     "symbol": "KRKR"
    },
    {
     "description": "KARNALYTE RESOURCES INC",
     "symbol": "KRLTF"
    },
    {
     "description": "GLOBAL X CONSCIOUS COMPANIES",
     "symbol": "KRMA"
    },
    {
     "description": "KRM22 PLC",
     "symbol": "KRMCF"
    },
    {
     "description": "REPRO MEDSYSTEMS INC",
     "symbol": "KRMD"
    },
    {
     "description": "KINGSROSE MINING LTD",
     "symbol": "KRMMF"
    },
    {
     "description": "KAROON ENERGY LTD",
     "symbol": "KRNGF"
    },
    {
     "description": "KAROON ENERGY LTD - UNSP ADR",
     "symbol": "KRNGY"
    },
    {
     "description": "KRANESHARES MSCI CHINA A USD",
     "symbol": "KRNIF"
    },
    {
     "description": "KERNEL GROUP HOLDINGS INC-A",
     "symbol": "KRNL"
    },
    {
     "description": "KERNEL GROUP HOLDINGS INC",
     "symbol": "KRNLU"
    },
    {
     "description": "KERNEL GROUP HLDG -A -CW27",
     "symbol": "KRNLW"
    },
    {
     "description": "KRONES AG",
     "symbol": "KRNNF"
    },
    {
     "description": "KORNIT DIGITAL LTD",
     "symbol": "KRNT"
    },
    {
     "description": "KRONES AG-UNSPON ADR",
     "symbol": "KRNTY"
    },
    {
     "description": "KEARNY FINANCIAL CORP\/MD",
     "symbol": "KRNY"
    },
    {
     "description": "KRONOS WORLDWIDE INC",
     "symbol": "KRO"
    },
    {
     "description": "KR1 PLC",
     "symbol": "KROEF"
    },
    {
     "description": "KRONOS BIO INC",
     "symbol": "KRON"
    },
    {
     "description": "GLOBAL X AGTECH & FOOD INNOV",
     "symbol": "KROP"
    },
    {
     "description": "KEROS THERAPEUTICS INC",
     "symbol": "KROS"
    },
    {
     "description": "KIMBELL ROYALTY PARTNERS LP",
     "symbol": "KRP"
    },
    {
     "description": "KARORA RESOURCES INC",
     "symbol": "KRRGF"
    },
    {
     "description": "KORRES NATURAL PRODUCTS",
     "symbol": "KRRTF"
    },
    {
     "description": "KERRY LOGISTICS NETWORK LTD",
     "symbol": "KRRYF"
    },
    {
     "description": "KARSAN OTOMOTIV",
     "symbol": "KRSOF"
    },
    {
     "description": "KRS CORP",
     "symbol": "KRSRF"
    },
    {
     "description": "KARAT PACKAGING INC",
     "symbol": "KRT"
    },
    {
     "description": "KARUNA THERAPEUTICS INC",
     "symbol": "KRTX"
    },
    {
     "description": "KURA SUSHI USA INC-CLASS A",
     "symbol": "KRUS"
    },
    {
     "description": "KERRY GROUP PLC-A",
     "symbol": "KRYAF"
    },
    {
     "description": "KERRY GROUP PLC-SPONS ADR",
     "symbol": "KRYAY"
    },
    {
     "description": "KERRY PROPERTIES LTD",
     "symbol": "KRYPF"
    },
    {
     "description": "KERRY PROPERTIES-UNSPON ADR",
     "symbol": "KRYPY"
    },
    {
     "description": "KRYSTAL BIOTECH INC",
     "symbol": "KRYS"
    },
    {
     "description": "ISHARES MSCI SAUDI ARABIA ET",
     "symbol": "KSA"
    },
    {
     "description": "KANSAI PAINT CO LTD",
     "symbol": "KSANF"
    },
    {
     "description": "KS BANCORP INC",
     "symbol": "KSBI"
    },
    {
     "description": "KFA SML CAP QUAL DIV NDX ETF",
     "symbol": "KSCD"
    },
    {
     "description": "KNIGHTSCOPE INC-A",
     "symbol": "KSCP"
    },
    {
     "description": "KASEI HOLDINGS PLC",
     "symbol": "KSEHF"
    },
    {
     "description": "KINGSOFT CORP LTD",
     "symbol": "KSFTF"
    },
    {
     "description": "K'S HOLDINGS CORP",
     "symbol": "KSHOF"
    },
    {
     "description": "Kuaishou Technolo ADR - UNSP",
     "symbol": "KSHTY"
    },
    {
     "description": "KADEM SUSTAINABLE IMPAC-CL A",
     "symbol": "KSI"
    },
    {
     "description": "KADEM SUSTAINABLE IMPACT COR",
     "symbol": "KSICU"
    },
    {
     "description": "KADEM SUSTAINABLE CL A -CW26",
     "symbol": "KSICW"
    },
    {
     "description": "KS INTERNATIONAL HOLDINGS CO",
     "symbol": "KSIH"
    },
    {
     "description": "KINGSGATE CONSOLIDATED LTD",
     "symbol": "KSKGF"
    },
    {
     "description": "KALERA AS",
     "symbol": "KSLLF"
    },
    {
     "description": "DWS STRATEGIC MUNICIPAL INCO",
     "symbol": "KSM"
    },
    {
     "description": "CONTAGIOUS GAMING INC",
     "symbol": "KSMRF"
    },
    {
     "description": "KISOJI CO LTD",
     "symbol": "KSOJF"
    },
    {
     "description": "KISSEI PHARMACEUTICAL CO LTD",
     "symbol": "KSPHF"
    },
    {
     "description": "KASPIEN HOLDINGS INC",
     "symbol": "KSPN"
    },
    {
     "description": "KENDALL SQUARE RESEARCH CORP",
     "symbol": "KSQR"
    },
    {
     "description": "KOSSAN RUBBER INDUSTRIES",
     "symbol": "KSRBF"
    },
    {
     "description": "KOSE CORP-UNSPONSORED ADR",
     "symbol": "KSRYY"
    },
    {
     "description": "KOHLS CORP",
     "symbol": "KSS"
    },
    {
     "description": "KESSELRING HOLDING CORP",
     "symbol": "KSSH"
    },
    {
     "description": "KESSELRUN RESOURCES LTD",
     "symbol": "KSSRF"
    },
    {
     "description": "KESTREL GOLD INC",
     "symbol": "KSTBF"
    },
    {
     "description": "KRANESHARES SSE STAR MKT 50",
     "symbol": "KSTR"
    },
    {
     "description": "KANEMATSU CORP",
     "symbol": "KSTUF"
    },
    {
     "description": "KANEMATSU ELECTRONICS LTD",
     "symbol": "KSUEF"
    },
    {
     "description": "KT CORP-SP ADR",
     "symbol": "KT"
    },
    {
     "description": "KONTOOR BRANDS INC",
     "symbol": "KTB"
    },
    {
     "description": "Structured Products Corp",
     "symbol": "KTBA"
    },
    {
     "description": "KEY TRONIC CORP",
     "symbol": "KTCC"
    },
    {
     "description": "KT&G CORP",
     "symbol": "KTCIF"
    },
    {
     "description": "KRANESHARES HANG SENG TECH",
     "symbol": "KTEC"
    },
    {
     "description": "KONATEL INC",
     "symbol": "KTEL"
    },
    {
     "description": "KEIO CORP",
     "symbol": "KTERF"
    },
    {
     "description": "DWS MUNICIPAL INCOME TRUST",
     "symbol": "KTF"
    },
    {
     "description": "K2 GOLD CORP",
     "symbol": "KTGDF"
    },
    {
     "description": "K-TIG LTD",
     "symbol": "KTGGF"
    },
    {
     "description": "CORTS-PECO ENE CP TR III",
     "symbol": "KTH"
    },
    {
     "description": "KRUNG THAI BANK - NVDR",
     "symbol": "KTHAF"
    },
    {
     "description": "KANTONE HOLDINGS LTD",
     "symbol": "KTHGF"
    },
    {
     "description": "KATAHDIN BANKSHARES CORP",
     "symbol": "KTHN"
    },
    {
     "description": "KMD BRANDS LTD",
     "symbol": "KTHUF"
    },
    {
     "description": "KATITAS CO LTD",
     "symbol": "KTITF"
    },
    {
     "description": "CORTS TRUST FOR AON CAP",
     "symbol": "KTN"
    },
    {
     "description": "KIATNAKIN PHATRA BANK P-NVDR",
     "symbol": "KTNUF"
    },
    {
     "description": "KRATOS DEFENSE & SECURITY",
     "symbol": "KTOS"
    },
    {
     "description": "KATIPULT TECHNOLOGY CORP",
     "symbol": "KTPPF"
    },
    {
     "description": "KINTARA THERAPEUTICS INC",
     "symbol": "KTRA"
    },
    {
     "description": "KOATSU GAS KOGYO CO LTD",
     "symbol": "KTSUF"
    },
    {
     "description": "PASITHEA THERAPEUTICS CORP",
     "symbol": "KTTA"
    },
    {
     "description": "PASITHEA THERAPEUTICS -CW26",
     "symbol": "KTTAW"
    },
    {
     "description": "KURITA WATER INDUSTRIES LTD",
     "symbol": "KTWIF"
    },
    {
     "description": "KURITA WATER IND-UNSP ADR",
     "symbol": "KTWIY"
    },
    {
     "description": "KITS EYECARE LTD",
     "symbol": "KTYCF"
    },
    {
     "description": "KUAISHOU TECHNOLOGY",
     "symbol": "KUASF"
    },
    {
     "description": "KUBOTA CORP",
     "symbol": "KUBTF"
    },
    {
     "description": "KUBOTA CORP-SPONS ADR",
     "symbol": "KUBTY"
    },
    {
     "description": "KUKA AG",
     "symbol": "KUKAF"
    },
    {
     "description": "KUKA AG - UNSPON ADR",
     "symbol": "KUKAY"
    },
    {
     "description": "KUKE MUSIC HOLDING LTD-ADR",
     "symbol": "KUKE"
    },
    {
     "description": "KOKUYO CO LTD",
     "symbol": "KUKYF"
    },
    {
     "description": "KULR TECHNOLOGY GROUP INC",
     "symbol": "KULR"
    },
    {
     "description": "KUMBA IRON ORE LTD",
     "symbol": "KUMBF"
    },
    {
     "description": "KUNLUN ENERGY CO LTD",
     "symbol": "KUNUF"
    },
    {
     "description": "KURA ONCOLOGY INC",
     "symbol": "KURA"
    },
    {
     "description": "KUREHA CORP",
     "symbol": "KURCF"
    },
    {
     "description": "KRANESHARES MSCI ALL CHINA H",
     "symbol": "KURE"
    },
    {
     "description": "KURARAY CO LTD",
     "symbol": "KURRF"
    },
    {
     "description": "KURARAY CO LTD-UNSPON ADR",
     "symbol": "KURRY"
    },
    {
     "description": "KUYA SILVER CORP",
     "symbol": "KUYAF"
    },
    {
     "description": "KAVANGO RESOURCES PLC",
     "symbol": "KVGOF"
    },
    {
     "description": "KVH INDUSTRIES INC",
     "symbol": "KVHI"
    },
    {
     "description": "KIDVILLE INC",
     "symbol": "KVIL"
    },
    {
     "description": "KFA VALUE LINE DYNAMIC CORE",
     "symbol": "KVLE"
    },
    {
     "description": "VALORE METALS CORP",
     "symbol": "KVLQF"
    },
    {
     "description": "KELVIN MEDICAL INC",
     "symbol": "KVMD"
    },
    {
     "description": "KHOSLA VENTURES ACQUISITION",
     "symbol": "KVSA"
    },
    {
     "description": "KHOSLA VENTURES ACQUISITIO-A",
     "symbol": "KVSC"
    },
    {
     "description": "KENNEDY-WILSON HOLDINGS INC",
     "symbol": "KW"
    },
    {
     "description": "KINGSWOOD ACQUISITION CORP-A",
     "symbol": "KWAC"
    },
    {
     "description": "KINGSWOOD ACQUISITION CORP",
     "symbol": "KWAC.U"
    },
    {
     "description": "KINGSWOOD ACQ CL A -CW27",
     "symbol": "KWAC.WS"
    },
    {
     "description": "KIWA BIO-TECH PRODUCTS GROUP",
     "symbol": "KWBT"
    },
    {
     "description": "KRANESHARES CSI CHINA INTERN",
     "symbol": "KWEB"
    },
    {
     "description": "KWESST MICRO SYSTEMS INC",
     "symbol": "KWEMF"
    },
    {
     "description": "KWG RESOURCES INC",
     "symbol": "KWGBF"
    },
    {
     "description": "KINGSWOOD HOLDINGS LTD",
     "symbol": "KWGHF"
    },
    {
     "description": "KWG GROUP HOLDINGS LTD",
     "symbol": "KWGPF"
    },
    {
     "description": "K WAH INTL HOLDINGS",
     "symbol": "KWHAF"
    },
    {
     "description": "KAWASAKI HEAVY INDUSTRIES",
     "symbol": "KWHIF"
    },
    {
     "description": "KAWASAKI HEAVY INDS-SP ADR",
     "symbol": "KWHIY"
    },
    {
     "description": "KWIKCLICK INC",
     "symbol": "KWIK"
    },
    {
     "description": "KIWI PROPERTY GROUP LTD",
     "symbol": "KWIPF"
    },
    {
     "description": "KWG LIVING GROUP HOLDINGS LT",
     "symbol": "KWLGF"
    },
    {
     "description": "KEWPIE CORP-ADR",
     "symbol": "KWPCY"
    },
    {
     "description": "QUAKER CHEMICAL CORPORATION",
     "symbol": "KWR"
    },
    {
     "description": "ISHARES MSCI KUWAIT ETF",
     "symbol": "KWT"
    },
    {
     "description": "KEW MEDIA GROUP INC",
     "symbol": "KWWMF"
    },
    {
     "description": "ISHARES GLOBAL CONSUMER STAP",
     "symbol": "KXI"
    },
    {
     "description": "KAIXIN AUTO HOLDINGS",
     "symbol": "KXIN"
    },
    {
     "description": "KAIXIN AUTO HOLDINGS-CW24",
     "symbol": "KXINW"
    },
    {
     "description": "KENEDIX RETAIL REIT CORP",
     "symbol": "KXNXF"
    },
    {
     "description": "KINAXIS INC",
     "symbol": "KXSCF"
    },
    {
     "description": "KEYENCE CORP",
     "symbol": "KYCCF"
    },
    {
     "description": "KEYARCH ACQUISITION CORP",
     "symbol": "KYCH"
    },
    {
     "description": "KEYARCH ACQUISITION CORP-RT",
     "symbol": "KYCHR"
    },
    {
     "description": "KEYARCH ACQUISITION CORP",
     "symbol": "KYCHU"
    },
    {
     "description": "KEYARCH ACQUISITION CORP -28",
     "symbol": "KYCHW"
    },
    {
     "description": "KYUDENKO CORP",
     "symbol": "KYDKF"
    },
    {
     "description": "KYOWA KIRIN CO LTD",
     "symbol": "KYKOF"
    },
    {
     "description": "KYORITSU MAINTENANCE CO LTD",
     "symbol": "KYMCF"
    },
    {
     "description": "KYMERA THERAPEUTICS INC",
     "symbol": "KYMR"
    },
    {
     "description": "KAYNE ANDERSON ENERGY INFRAS",
     "symbol": "KYN"
    },
    {
     "description": "KYN CAPITAL GROUP INC",
     "symbol": "KYNC"
    },
    {
     "description": "KYOCERA CORP",
     "symbol": "KYOCF"
    },
    {
     "description": "KYOCERA CORP -SPONS ADR",
     "symbol": "KYOCY"
    },
    {
     "description": "KYOEI STEEL LTD",
     "symbol": "KYOIF"
    },
    {
     "description": "KYORITSU AIR TECH INC",
     "symbol": "KYORF"
    },
    {
     "description": "KYORIN HOLDINGS INC",
     "symbol": "KYRNF"
    },
    {
     "description": "KYUSHU ELECTRIC POWER CO INC",
     "symbol": "KYSEF"
    },
    {
     "description": "KYUSHU ELECTRIC PO-UNSP ADR",
     "symbol": "KYSEY"
    },
    {
     "description": "KYUSHU FINANCIAL GROUP INC",
     "symbol": "KYUNF"
    },
    {
     "description": "EXEO GROUP INC",
     "symbol": "KYWAF"
    },
    {
     "description": "KYUSHU RAILWAY COMPANY",
     "symbol": "KYYHF"
    },
    {
     "description": "KEYWORDS STUDIOS PLC",
     "symbol": "KYYWF"
    },
    {
     "description": "KEYWORDS STUDIOS PLC-UNS ADR",
     "symbol": "KYYWY"
    },
    {
     "description": "KAZIA THERAPEUTICS-SPON ADR",
     "symbol": "KZIA"
    },
    {
     "description": "KEZAR LIFE SCIENCES INC",
     "symbol": "KZR"
    },
    {
     "description": "LOEWS CORP",
     "symbol": "L"
    },
    {
     "description": "LAKESHORE ACQUISITION I CO-A",
     "symbol": "LAAA"
    },
    {
     "description": "LAKESHORE ACQUISITION I CORP",
     "symbol": "LAAAU"
    },
    {
     "description": "LAKESHORE ACQ I -CW28",
     "symbol": "LAAAW"
    },
    {
     "description": "STARTECH LABS INC",
     "symbol": "LAAB"
    },
    {
     "description": "LI AUTO INC-CLASS A",
     "symbol": "LAAOF"
    },
    {
     "description": "STANDARD BIOTOOLS INC",
     "symbol": "LAB"
    },
    {
     "description": "DRX DLY S&P BIOTECH BEAR 3X",
     "symbol": "LABD"
    },
    {
     "description": "LABORATORIOS FARMACEUTICOS R",
     "symbol": "LABFF"
    },
    {
     "description": "LANDOS BIOPHARMA INC",
     "symbol": "LABP"
    },
    {
     "description": "DRX DLY S&P BIOTECH BULL 3X",
     "symbol": "LABU"
    },
    {
     "description": "LITHIUM AMERICAS CORP",
     "symbol": "LAC"
    },
    {
     "description": "LITHIA MOTORS INC",
     "symbol": "LAD"
    },
    {
     "description": "LADDER CAPITAL CORP-REIT",
     "symbol": "LADR"
    },
    {
     "description": "L.A. GEAR INC",
     "symbol": "LAGR"
    },
    {
     "description": "LINK-ASIA INTERNATIONAL MEDT",
     "symbol": "LAIMF"
    },
    {
     "description": "LAIX INC - ADR",
     "symbol": "LAIXY"
    },
    {
     "description": "LAKELAND INDUSTRIES INC",
     "symbol": "LAKE"
    },
    {
     "description": "LAMAR ADVERTISING CO-A",
     "symbol": "LAMR"
    },
    {
     "description": "LANCASTER COLONY CORP",
     "symbol": "LANC"
    },
    {
     "description": "GLADSTONE LAND CORP",
     "symbol": "LAND"
    },
    {
     "description": "GLADSTONE LAND CORP",
     "symbol": "LANDM"
    },
    {
     "description": "GLADSTONE LAND CORP",
     "symbol": "LANDO"
    },
    {
     "description": "LANCER ORTHODONTICS INC",
     "symbol": "LANZ"
    },
    {
     "description": "LAR ESPANA REAL ESTATE SOCIM",
     "symbol": "LAREF"
    },
    {
     "description": "LANDMARK BANCORP INC",
     "symbol": "LARK"
    },
    {
     "description": "LAIRD PLC",
     "symbol": "LARRF"
    },
    {
     "description": "LENTUO INTERNATI-SPON ADS",
     "symbol": "LASLY"
    },
    {
     "description": "NLIGHT INC",
     "symbol": "LASR"
    },
    {
     "description": "LATTENO FOOD CORP",
     "symbol": "LATF"
    },
    {
     "description": "LATAMGROWTH SPAC",
     "symbol": "LATG"
    },
    {
     "description": "LATAMGROWTH SPAC",
     "symbol": "LATGU"
    },
    {
     "description": "LATAMGROWTH SPAC -28",
     "symbol": "LATGW"
    },
    {
     "description": "Laurentian Bank",
     "symbol": "LAUCF"
    },
    {
     "description": "LAUREATE EDUCATION INC",
     "symbol": "LAUR"
    },
    {
     "description": "CS DISCO INC",
     "symbol": "LAW"
    },
    {
     "description": "LAWSON PRODUCTS INC",
     "symbol": "LAWS"
    },
    {
     "description": "8I ACQUISITION 2 CORP",
     "symbol": "LAX"
    },
    {
     "description": "LAXAI PHARMA LTD",
     "symbol": "LAXAF"
    },
    {
     "description": "8I ACQUISITION 2 CORP-RIGHTS",
     "symbol": "LAXXR"
    },
    {
     "description": "8I ACQUISITION 2 CORP",
     "symbol": "LAXXU"
    },
    {
     "description": "8I ACQUISITION 2 CORP -CW22",
     "symbol": "LAXXW"
    },
    {
     "description": "LAZARD LTD-CL A",
     "symbol": "LAZ"
    },
    {
     "description": "LUMINAR TECHNOLOGIES INC",
     "symbol": "LAZR"
    },
    {
     "description": "LAZYDAYS HOLDINGS INC",
     "symbol": "LAZY"
    },
    {
     "description": "LAZYDAYS HOLDINGS INC-CW20",
     "symbol": "LAZYW"
    },
    {
     "description": "LAKELAND BANCORP INC",
     "symbol": "LBAI"
    },
    {
     "description": "LUBOA GROUP INC",
     "symbol": "LBAO"
    },
    {
     "description": "LOCATION BASED TECHNOLOGIES",
     "symbol": "LBAS"
    },
    {
     "description": "LEATHERBACK LONG\/SHORT ALT Y",
     "symbol": "LBAY"
    },
    {
     "description": "LAKESHORE ACQUISITION II COR",
     "symbol": "LBBB"
    },
    {
     "description": "LAKESHORE ACQUISITION -RIGHT",
     "symbol": "LBBBR"
    },
    {
     "description": "LAKESHORE ACQUISITION II COR",
     "symbol": "LBBBU"
    },
    {
     "description": "LAKESHORE ACQUISITION II -26",
     "symbol": "LBBBW"
    },
    {
     "description": "LUTHER BURBANK CORP",
     "symbol": "LBC"
    },
    {
     "description": "LIBERO COPPER & GOLD CORP",
     "symbol": "LBCMF"
    },
    {
     "description": "LOUD BEVERAGE GROUP INC",
     "symbol": "LBEV"
    },
    {
     "description": "LEVEL BEST GOLF INC",
     "symbol": "LBGF"
    },
    {
     "description": "LUNDBERGS AB-B SHS",
     "symbol": "LBGUF"
    },
    {
     "description": "Direxion Daily Latin America Bull 2X Shares",
     "symbol": "LBJ"
    },
    {
     "description": "LINKBAL INC",
     "symbol": "LBKLF"
    },
    {
     "description": "LOBLAW COMPANIES LTD",
     "symbol": "LBLCF"
    },
    {
     "description": "LASERBOND LTD",
     "symbol": "LBLPF"
    },
    {
     "description": "LATTICE BIOLOGICS LTD",
     "symbol": "LBLTF"
    },
    {
     "description": "LONGBOARD PHARMACEUTICALS IN",
     "symbol": "LBPH"
    },
    {
     "description": "4D PHARMA PLC-ADR",
     "symbol": "LBPS"
    },
    {
     "description": "4D PHARMA PLC-CW",
     "symbol": "LBPSW"
    },
    {
     "description": "LIBERTY BROADBAND-A",
     "symbol": "LBRDA"
    },
    {
     "description": "LIBERTY BROADBAND B-",
     "symbol": "LBRDB"
    },
    {
     "description": "LIBERTY BROADBAND-C",
     "symbol": "LBRDK"
    },
    {
     "description": "LIBERTY BROADBAND CORP",
     "symbol": "LBRDP"
    },
    {
     "description": "LADYBUG RESOURCE GROUP INC",
     "symbol": "LBRG"
    },
    {
     "description": "LABRADOR IRON MINES HOLDINGS",
     "symbol": "LBRMF"
    },
    {
     "description": "LIBERTY OILFIELD SERVICES -A",
     "symbol": "LBRT"
    },
    {
     "description": "LIBERTY BANCSHARES INC OHIO",
     "symbol": "LBSI"
    },
    {
     "description": "LIBERTY STAR URANIUM & METAL",
     "symbol": "LBSR"
    },
    {
     "description": "LOTUS BIO-TECHNOLOGY DEVELOP",
     "symbol": "LBTD"
    },
    {
     "description": "LITHIUM & BORON TECHNOLOGY I",
     "symbol": "LBTI"
    },
    {
     "description": "ALMIRALL SA",
     "symbol": "LBTSF"
    },
    {
     "description": "LIBERTY GLOBAL PLC-A",
     "symbol": "LBTYA"
    },
    {
     "description": "LIBERTY GLOBAL PLC-B",
     "symbol": "LBTYB"
    },
    {
     "description": "LIBERTY GLOBAL PLC- C",
     "symbol": "LBTYK"
    },
    {
     "description": "LEAFBUYER TECHNOLOGIES INC",
     "symbol": "LBUY"
    },
    {
     "description": "LABWIRE INC",
     "symbol": "LBWR"
    },
    {
     "description": "LIBERTY ENERGY CORP",
     "symbol": "LBYE"
    },
    {
     "description": "LENDINGCLUB CORP",
     "symbol": "LC"
    },
    {
     "description": "LANDCADIA HOLDINGS IV INC-A",
     "symbol": "LCA"
    },
    {
     "description": "L CATTERTON ASIA ACQ-CLASS A",
     "symbol": "LCAA"
    },
    {
     "description": "L CATTERTON ASIA ACQUISITION",
     "symbol": "LCAAU"
    },
    {
     "description": "L CATTERTON ASIA ACQ-CW",
     "symbol": "LCAAW"
    },
    {
     "description": "LANDCADIA HOLDINGS IV INC",
     "symbol": "LCAHU"
    },
    {
     "description": "LANDCADIA HOLDINGS IV -CW28",
     "symbol": "LCAHW"
    },
    {
     "description": "LIONHEART ACQUISITION CORP-A",
     "symbol": "LCAP"
    },
    {
     "description": "LIONHEART ACQUISITION CORP",
     "symbol": "LCAPU"
    },
    {
     "description": "LIONHEART ACQUISITION -CW26",
     "symbol": "LCAPW"
    },
    {
     "description": "LESCARDEN INC",
     "symbol": "LCAR"
    },
    {
     "description": "L'OCCITANE INTERNATIONAL SA",
     "symbol": "LCCTF"
    },
    {
     "description": "L'OCCITANE INTERNA-UNSP ADR",
     "symbol": "LCCTY"
    },
    {
     "description": "CALIBER IMAGING & DIAGNOSTIC",
     "symbol": "LCDX"
    },
    {
     "description": "LOCAFY LTD",
     "symbol": "LCFY"
    },
    {
     "description": "LOCAFY LTD-CW27",
     "symbol": "LCFYW"
    },
    {
     "description": "STERLING CAPITAL FOCUS EQUIT",
     "symbol": "LCG"
    },
    {
     "description": "LION COPPER AND GOLD CORP",
     "symbol": "LCGMF"
    },
    {
     "description": "LEADER CAPITAL HOLDINGS CORP",
     "symbol": "LCHD"
    },
    {
     "description": "LEOCH INTERNATIONAL TECH",
     "symbol": "LCHIF"
    },
    {
     "description": "LIVECHAT SOFTWARE SA",
     "symbol": "LCHTF"
    },
    {
     "description": "LANNETT CO INC",
     "symbol": "LCI"
    },
    {
     "description": "LUCID GROUP INC",
     "symbol": "LCID"
    },
    {
     "description": "LCI INDUSTRIES",
     "symbol": "LCII"
    },
    {
     "description": "GOLDEN SKY MINERALS CORP",
     "symbol": "LCKYF"
    },
    {
     "description": "LIFE CLIPS INC",
     "symbol": "LCLP"
    },
    {
     "description": "LA COMER SAB DE CV",
     "symbol": "LCMRF"
    },
    {
     "description": "LCNB CORPORATION",
     "symbol": "LCNB"
    },
    {
     "description": "LOUISIANA CENTRAL OIL&GAS-UT",
     "symbol": "LCNTU"
    },
    {
     "description": "LIFESTYLE COMMUNITIES LTD",
     "symbol": "LCOMF"
    },
    {
     "description": "LEUTHOLD CORE ETF",
     "symbol": "LCR"
    },
    {
     "description": "LECERE CORP",
     "symbol": "LCRE"
    },
    {
     "description": "LEUCROTTA EXPLORATION INC",
     "symbol": "LCRTF"
    },
    {
     "description": "LANCASHIRE HOLDINGS LTD",
     "symbol": "LCSHF"
    },
    {
     "description": "LANCASHIRE HOLDINGS-ADR",
     "symbol": "LCSHY"
    },
    {
     "description": "LIFELOC TECHNOLOGIES INC",
     "symbol": "LCTC"
    },
    {
     "description": "BLACKROCK WRLD X US CARBON",
     "symbol": "LCTD"
    },
    {
     "description": "LECTRA",
     "symbol": "LCTSF"
    },
    {
     "description": "BLACKROCK US CARBON TR READ",
     "symbol": "LCTU"
    },
    {
     "description": "LINEAGE CELL THERAPEUTICS IN",
     "symbol": "LCTX"
    },
    {
     "description": "LIFETIME BRANDS INC",
     "symbol": "LCUT"
    },
    {
     "description": "LEARN CW INVESTMENT CORP-A",
     "symbol": "LCW"
    },
    {
     "description": "LEARN CW INVESTMENT CORP",
     "symbol": "LCW.U"
    },
    {
     "description": "LEARN CW INVESTMENT A -CW28",
     "symbol": "LCW.WS"
    },
    {
     "description": "L&G CYBER SECURITY UCITS ETF",
     "symbol": "LCYFF"
    },
    {
     "description": "IPATH BLOOMBERG LEAD SUBINDE",
     "symbol": "LD"
    },
    {
     "description": "SOLIDERE-UNSPON ADR",
     "symbol": "LDBTY"
    },
    {
     "description": "LIDA RESOURCES INC",
     "symbol": "LDDAF"
    },
    {
     "description": "LIBERTY DEFENSE HOLDINGS LTD",
     "symbol": "LDDFF"
    },
    {
     "description": "ISHARES ESG MSCI EM LEADERS",
     "symbol": "LDEM"
    },
    {
     "description": "LANDIS+GYR GROUP AG-UNSP ADR",
     "symbol": "LDGYY"
    },
    {
     "description": "LDH GROWTH CORP I-CLASS A",
     "symbol": "LDHA"
    },
    {
     "description": "LDH GROWTH CORP I",
     "symbol": "LDHAU"
    },
    {
     "description": "LDH GROWTH CORP I CL A -CW28",
     "symbol": "LDHAW"
    },
    {
     "description": "LAND & HOUSES PUB CO-FOR REG",
     "symbol": "LDHOF"
    },
    {
     "description": "LAND & HOUSES PUB - NVDR",
     "symbol": "LDHUF"
    },
    {
     "description": "LOANDEPOT INC -CLASS A",
     "symbol": "LDI"
    },
    {
     "description": "LONDON STOCK EXCHANGE GROUP",
     "symbol": "LDNXF"
    },
    {
     "description": "HIGHLANDER SILVER CORP",
     "symbol": "LDOMF"
    },
    {
     "description": "LEIDOS HOLDINGS INC",
     "symbol": "LDOS"
    },
    {
     "description": "COHEN & STEERS LIMITED DURAT",
     "symbol": "LDP"
    },
    {
     "description": "LAND SECURITIES GR-UNSP ADR",
     "symbol": "LDSCY"
    },
    {
     "description": "FIRST TR LOW DURATION ST-ETF",
     "symbol": "LDSF"
    },
    {
     "description": "LUDUSON G INC",
     "symbol": "LDSN"
    },
    {
     "description": "CHOCOLADEFABRIKEN LINDT-PC",
     "symbol": "LDSVF"
    },
    {
     "description": "PIMCO ENHANCED LOW DURATION",
     "symbol": "LDUR"
    },
    {
     "description": "LUMOS DIAGNOSTICS HOLDINGS L",
     "symbol": "LDXHF"
    },
    {
     "description": "LANDS' END INC",
     "symbol": "LE"
    },
    {
     "description": "LEAR CORP",
     "symbol": "LEA"
    },
    {
     "description": "SIREN DIVCON LEADERS DIVIDEN",
     "symbol": "LEAD"
    },
    {
     "description": "LEGACY EDUCATION ALLIANCE IN",
     "symbol": "LEAI"
    },
    {
     "description": "RIBBIT LEAP LTD - CLASS A",
     "symbol": "LEAP"
    },
    {
     "description": "RIBBIT LEAP LTD",
     "symbol": "LEAP.U"
    },
    {
     "description": "RIBBIT LEAP LTD -A -CW25",
     "symbol": "LEAP.WS"
    },
    {
     "description": "STRATEGIC ASSET LEASING INC",
     "symbol": "LEAS"
    },
    {
     "description": "LEATT CORP",
     "symbol": "LEAT"
    },
    {
     "description": "LEGIBLE INC",
     "symbol": "LEBGF"
    },
    {
     "description": "LEPANTO CONS MINING-'B'COM",
     "symbol": "LECBF"
    },
    {
     "description": "LIGNOL ENERGY CORP",
     "symbol": "LECFF"
    },
    {
     "description": "LECLANCHE SA-REG",
     "symbol": "LECNF"
    },
    {
     "description": "LINCOLN ELECTRIC HOLDINGS",
     "symbol": "LECO"
    },
    {
     "description": "LEOCOR GOLD INC",
     "symbol": "LECRF"
    },
    {
     "description": "SEMILEDS CORP\/TW",
     "symbol": "LEDS"
    },
    {
     "description": "LEE ENTERPRISES",
     "symbol": "LEE"
    },
    {
     "description": "LEON'S FURNITURE LTD",
     "symbol": "LEFUF"
    },
    {
     "description": "LEGGETT & PLATT INC",
     "symbol": "LEG"
    },
    {
     "description": "LEAD EDGE GROWTH OPPORTUNI-A",
     "symbol": "LEGA"
    },
    {
     "description": "LEAD EDGE GROWTH OPPORTUNITI",
     "symbol": "LEGAU"
    },
    {
     "description": "LEAD EDGE GROWTH OPP A -CW28",
     "symbol": "LEGAW"
    },
    {
     "description": "LEGACY HOUSING CORP",
     "symbol": "LEGH"
    },
    {
     "description": "LEG IMMOBILIEN SE",
     "symbol": "LEGIF"
    },
    {
     "description": "LEGEND BIOTECH CORP-ADR",
     "symbol": "LEGN"
    },
    {
     "description": "FIRST TRUST INDXX INNOVATIVE",
     "symbol": "LEGR"
    },
    {
     "description": "LEGACYXCHANGE INC",
     "symbol": "LEGX"
    },
    {
     "description": "Lehman Brothers Holdings Inc",
     "symbol": "LEHKQ"
    },
    {
     "description": "Lehman Brothers Holdings Inc",
     "symbol": "LEHLQ"
    },
    {
     "description": "Lehman Brothers Financial SA",
     "symbol": "LEHNQ"
    },
    {
     "description": "LEAD INNOVATION CORP",
     "symbol": "LEIC"
    },
    {
     "description": "LEJU HOLDINGS LTD-ADR",
     "symbol": "LEJU"
    },
    {
     "description": "LEKOIL LTD  - DI",
     "symbol": "LEKOF"
    },
    {
     "description": "ISHARES JP MORGAN EM LOCAL C",
     "symbol": "LEMB"
    },
    {
     "description": "LEADING EDGE MATERIALS CORP",
     "symbol": "LEMIF"
    },
    {
     "description": "LENNAR CORP-A",
     "symbol": "LEN"
    },
    {
     "description": "LENNAR CORP - B SHS",
     "symbol": "LEN.B"
    },
    {
     "description": "PRESBIA PLC",
     "symbol": "LENSF"
    },
    {
     "description": "LENTA IPJSC",
     "symbol": "LENTY"
    },
    {
     "description": "BNYM STRAT MUNI",
     "symbol": "LEO"
    },
    {
     "description": "LEONE ASSET MANAGEMENT INC",
     "symbol": "LEON"
    },
    {
     "description": "LEOVEGAS AB",
     "symbol": "LEOVF"
    },
    {
     "description": "LE SAUNDA HOLDINGS LTD",
     "symbol": "LESAF"
    },
    {
     "description": "LESLIE'S INC",
     "symbol": "LESL"
    },
    {
     "description": "ADVISOR LET BOB AI POWERED",
     "symbol": "LETB"
    },
    {
     "description": "CENTRUS ENERGY CORP-CLASS A",
     "symbol": "LEU"
    },
    {
     "description": "LION ELECTRIC CO\/THE",
     "symbol": "LEV"
    },
    {
     "description": "LION ELECTRIC CO\/THE -CW26",
     "symbol": "LEV.WS"
    },
    {
     "description": "LEVI STRAUSS & CO- CLASS A",
     "symbol": "LEVI"
    },
    {
     "description": "ALEXIS PRACTICAL TACTICAL ET",
     "symbol": "LEXI"
    },
    {
     "description": "LEXSTON LIFE SCIENCES CORP",
     "symbol": "LEXTF"
    },
    {
     "description": "LEXARIA BIOSCIENCE CORP",
     "symbol": "LEXX"
    },
    {
     "description": "LEXARIA BIOSCIENCE -CW25",
     "symbol": "LEXXW"
    },
    {
     "description": "LF CAPITAL ACQUISITION -CLA",
     "symbol": "LFAC"
    },
    {
     "description": "LF CAPITAL ACQUISITION CORP",
     "symbol": "LFACU"
    },
    {
     "description": "LANDSEA HOMES CORP -CW26",
     "symbol": "LFACW"
    },
    {
     "description": "LGBTQ LOYALTY HOLDINGS INC",
     "symbol": "LFAP"
    },
    {
     "description": "LIFE BANC & SPLIT CORP-A",
     "symbol": "LFBCF"
    },
    {
     "description": "CHINA LIFE INSURANCE CO-ADR",
     "symbol": "LFC"
    },
    {
     "description": "LIFT & CO CORP",
     "symbol": "LFCOF"
    },
    {
     "description": "LA FRANCAISE DES JEUX SAEM",
     "symbol": "LFDJF"
    },
    {
     "description": "VANECK LONG\/FLAT TREND ETF",
     "symbol": "LFEQ"
    },
    {
     "description": "LIFE ON EARTH INC",
     "symbol": "LFER"
    },
    {
     "description": "LUCKY FRIDAY EXTENSION MINE",
     "symbol": "LFEX"
    },
    {
     "description": "ARCHAEA ENERGY INC",
     "symbol": "LFG"
    },
    {
     "description": "LEDYARD FINANCIAL GROUP INC",
     "symbol": "LFGP"
    },
    {
     "description": "LAI FUNG HOLDINGS LTD",
     "symbol": "LFHLF"
    },
    {
     "description": "LONGFIN CORP",
     "symbol": "LFIN"
    },
    {
     "description": "LOANS4LESS.COM INC",
     "symbol": "LFLS"
    },
    {
     "description": "LEAFLY HOLDINGS INC",
     "symbol": "LFLY"
    },
    {
     "description": "MERIDA MERGER CORP I -CW26",
     "symbol": "LFLYW"
    },
    {
     "description": "LIFEMD INC",
     "symbol": "LFMD"
    },
    {
     "description": "LIFEMD INC",
     "symbol": "LFMDP"
    },
    {
     "description": "LIFEPOINT INC",
     "symbol": "LFPI"
    },
    {
     "description": "LIFESTANCE HEALTH GROUP INC",
     "symbol": "LFST"
    },
    {
     "description": "LIFESTYLE INTL HLDGS LTD",
     "symbol": "LFSYF"
    },
    {
     "description": "LIFESTYLE INTL-UNSPON ADR",
     "symbol": "LFSYY"
    },
    {
     "description": "LUMENT FINANCE TRUST INC",
     "symbol": "LFT"
    },
    {
     "description": "LUMENT FINANCE TRUST INC",
     "symbol": "LFT.PRA"
    },
    {
     "description": "LEFTERIS ACQUISITION CORP -A",
     "symbol": "LFTR"
    },
    {
     "description": "LEFTERIS ACQUISITION CORP",
     "symbol": "LFTRU"
    },
    {
     "description": "LEFTERIS ACQUISITION A -CW25",
     "symbol": "LFTRW"
    },
    {
     "description": "LIFETECH SCIENTIFIC CORP",
     "symbol": "LFTSF"
    },
    {
     "description": "LI & FUNG LTD",
     "symbol": "LFUGF"
    },
    {
     "description": "LITTELFUSE INC",
     "symbol": "LFUS"
    },
    {
     "description": "LIFEVANTAGE CORP",
     "symbol": "LFVN"
    },
    {
     "description": "LAZARD GROWTH ACQUISITION CO",
     "symbol": "LGAC"
    },
    {
     "description": "LAZARD GROWTH ACQUISITION CO",
     "symbol": "LGACU"
    },
    {
     "description": "LAZARD GROWTH ACQ A -CW27",
     "symbol": "LGACW"
    },
    {
     "description": "LGA HOLDINGS INC",
     "symbol": "LGAH"
    },
    {
     "description": "CANNABIZ MOBILE INC",
     "symbol": "LGBI"
    },
    {
     "description": "LEGENDS BUSINESS GROUP INC",
     "symbol": "LGBS"
    },
    {
     "description": "LG CHEM LTD",
     "symbol": "LGCLF"
    },
    {
     "description": "LG CORP-PREF",
     "symbol": "LGCOF"
    },
    {
     "description": "LEGION CAPITAL CORP",
     "symbol": "LGCP"
    },
    {
     "description": "LAGARDERE SA",
     "symbol": "LGDDF"
    },
    {
     "description": "LIBERTY GOLD CORP",
     "symbol": "LGDTF"
    },
    {
     "description": "LIONS GATE ENTERTAINMENT-A",
     "symbol": "LGF.A"
    },
    {
     "description": "LIONS GATE ENTERTAINMENT-B",
     "symbol": "LGF.B"
    },
    {
     "description": "LONGFOR GROUP HOLDINGS-ADR",
     "symbol": "LGFRY"
    },
    {
     "description": "LONG4LIFE LTD",
     "symbol": "LGGFF"
    },
    {
     "description": "LEGAL & GENERAL GROUP PLC",
     "symbol": "LGGNF"
    },
    {
     "description": "LEGAL & GEN GROUP -SPON ADR",
     "symbol": "LGGNY"
    },
    {
     "description": "HCM DEFENDER 500 INDEX ETF",
     "symbol": "LGH"
    },
    {
     "description": "LG HOUSEHOLD & HEALTH CARE",
     "symbol": "LGHHF"
    },
    {
     "description": "LION GROUP HOLDING LTD-S ADR",
     "symbol": "LGHL"
    },
    {
     "description": "LION GROUP HOLDING LTD-CW26",
     "symbol": "LGHLW"
    },
    {
     "description": "LG HOUSEHOLD & HEALTH-PREF",
     "symbol": "LGHMF"
    },
    {
     "description": "LAZARD GLOBAL TOT RT & INC",
     "symbol": "LGI"
    },
    {
     "description": "LGI HOMES INC",
     "symbol": "LGIH"
    },
    {
     "description": "LOGIQ INC",
     "symbol": "LGIQ"
    },
    {
     "description": "LGL GROUP INC\/THE",
     "symbol": "LGL"
    },
    {
     "description": "LGL GROUP INC\/THE -CW25",
     "symbol": "LGL.WS"
    },
    {
     "description": "GOLD BULLION SECURITIES LTD",
     "symbol": "LGLBF"
    },
    {
     "description": "GREEN BLOCK MINING CORP",
     "symbol": "LGLOF"
    },
    {
     "description": "SPDR SSGA US LARGE CAP LOW V",
     "symbol": "LGLV"
    },
    {
     "description": "CANADIAN NEXUS TEAM VENTURES",
     "symbol": "LGMFF"
    },
    {
     "description": "LIGHT MEDIA HOLDINGS INC",
     "symbol": "LGMH"
    },
    {
     "description": "LOGICMARK INC",
     "symbol": "LGMK"
    },
    {
     "description": "LEG IMMOBILIEN AG-UNSP ADR",
     "symbol": "LGMMY"
    },
    {
     "description": "LOGAN CLAY PRODUCTS CO",
     "symbol": "LGNC"
    },
    {
     "description": "LIGAND PHARMACEUTICALS",
     "symbol": "LGND"
    },
    {
     "description": "LIGAND PHARMA-ROCHE CVR",
     "symbol": "LGNDZ"
    },
    {
     "description": "LEGEND HOLDINGS CORP-H",
     "symbol": "LGNRF"
    },
    {
     "description": "LIGAND PHARMA-GLUCAGON CVR",
     "symbol": "LGNXZ"
    },
    {
     "description": "LIGAND PHARMA-GENERAL CVR",
     "symbol": "LGNYZ"
    },
    {
     "description": "LIGAND PHARMA-TR BETA CVR",
     "symbol": "LGNZZ"
    },
    {
     "description": "LARGO INC",
     "symbol": "LGO"
    },
    {
     "description": "FIRST TR LONG DURATION O-ETF",
     "symbol": "LGOV"
    },
    {
     "description": "LITTLE GREEN PHARMA LTD",
     "symbol": "LGPPF"
    },
    {
     "description": "LEGRAND SA-UNSP ADR",
     "symbol": "LGRDY"
    },
    {
     "description": "LEGRAND SA",
     "symbol": "LGRVF"
    },
    {
     "description": "SEMPER PARATUS ACQUISITION-A",
     "symbol": "LGST"
    },
    {
     "description": "SEMPER PARATUS ACQUISITION C",
     "symbol": "LGSTU"
    },
    {
     "description": "SEMPER PARATUS ACQU -CW26",
     "symbol": "LGSTW"
    },
    {
     "description": "LIGHT SA-SPONSORED ADR",
     "symbol": "LGSXY"
    },
    {
     "description": "CIMIC GROUP LTD",
     "symbol": "LGTHF"
    },
    {
     "description": "LEGATO MERGER CORP II",
     "symbol": "LGTO"
    },
    {
     "description": "LEGATO MERGER CORP II",
     "symbol": "LGTOU"
    },
    {
     "description": "LEGATO MERGER CORP II -CW23",
     "symbol": "LGTOW"
    },
    {
     "description": "LIGHTSPACE CORP",
     "symbol": "LGTS"
    },
    {
     "description": "LIGATT SECURITY INTERNATIONA",
     "symbol": "LGTT"
    },
    {
     "description": "LONGVIEW ACQUISITION CORP -A",
     "symbol": "LGV"
    },
    {
     "description": "LONGVIEW ACQUISITION CORP II",
     "symbol": "LGV.U"
    },
    {
     "description": "LONGVIEW ACQUIS -A -CW26",
     "symbol": "LGV.WS"
    },
    {
     "description": "LAMF GLOBAL VENTURES CORP I",
     "symbol": "LGVC"
    },
    {
     "description": "LAMF GLOBAL VENTURES CORP I",
     "symbol": "LGVCU"
    },
    {
     "description": "LAMF GLOBAL VENTURES -CW23",
     "symbol": "LGVCW"
    },
    {
     "description": "LONGEVERON INC",
     "symbol": "LGVN"
    },
    {
     "description": "LANDIS+GYR GROUP AG",
     "symbol": "LGYRF"
    },
    {
     "description": "LEGACY VENTURES INTERNATIO-B",
     "symbol": "LGYV"
    },
    {
     "description": "LOGIZARD CO LTD",
     "symbol": "LGZDF"
    },
    {
     "description": "LABORATORY CRP OF AMER HLDGS",
     "symbol": "LH"
    },
    {
     "description": "LERER HIPPEAU ACQUISITION-A",
     "symbol": "LHAA"
    },
    {
     "description": "LEO HOLDINGS CORP II-CLASS A",
     "symbol": "LHC"
    },
    {
     "description": "LEO HOLDINGS CORP II",
     "symbol": "LHC.U"
    },
    {
     "description": "LEO HOLDINGS II CL A -CW28",
     "symbol": "LHC.WS"
    },
    {
     "description": "LHC GROUP INC",
     "symbol": "LHCG"
    },
    {
     "description": "LUCIRA HEALTH INC",
     "symbol": "LHDX"
    },
    {
     "description": "LIGHTHOUSE GLOBAL HOLDINGS I",
     "symbol": "LHGI"
    },
    {
     "description": "Lehman Brothers Holdings Inc",
     "symbol": "LHHMQ"
    },
    {
     "description": "LEADER HILL CORP",
     "symbol": "LHIL"
    },
    {
     "description": "LIFEHOUSE RETIREMENT PROPERT",
     "symbol": "LHRP"
    },
    {
     "description": "LIGHTSTONE VALUE PLUS REAL E",
     "symbol": "LHTV"
    },
    {
     "description": "LIANHUA SUPERMARKET HLDGS -H",
     "symbol": "LHUAF"
    },
    {
     "description": "L3HARRIS TECHNOLOGIES INC",
     "symbol": "LHX"
    },
    {
     "description": "LI AUTO INC - ADR",
     "symbol": "LI"
    },
    {
     "description": "AMERICAN LITHIUM CORP",
     "symbol": "LIACF"
    },
    {
     "description": "LIANBIO-ADR",
     "symbol": "LIAN"
    },
    {
     "description": "LIBERTY BANCORP",
     "symbol": "LIBC"
    },
    {
     "description": "LIBERTY RESOURCES ACQUI-CL A",
     "symbol": "LIBY"
    },
    {
     "description": "LIBERTY RESOURCES ACQUISITIO",
     "symbol": "LIBYU"
    },
    {
     "description": "LIBERTY RESOURCES ACQ -CW22",
     "symbol": "LIBYW"
    },
    {
     "description": "LIVECHAIN INC",
     "symbol": "LICH"
    },
    {
     "description": "LICT CORP",
     "symbol": "LICT"
    },
    {
     "description": "LI-CYCLE HOLDINGS CORP",
     "symbol": "LICY"
    },
    {
     "description": "LIMCO DEL MAR LTD",
     "symbol": "LIDM"
    },
    {
     "description": "AEYE INC",
     "symbol": "LIDR"
    },
    {
     "description": "CF FINANCE ACQ III -CW27",
     "symbol": "LIDRW"
    },
    {
     "description": "LIFE CORP",
     "symbol": "LIFCF"
    },
    {
     "description": "LFTD PARTNERS INC",
     "symbol": "LIFD"
    },
    {
     "description": "ATYR PHARMA INC",
     "symbol": "LIFE"
    },
    {
     "description": "LIFENET INSURANCE CO",
     "symbol": "LIFNF"
    },
    {
     "description": "LIFE STEM GENETICS INC",
     "symbol": "LIFS"
    },
    {
     "description": "LIFE360 INC-CDI",
     "symbol": "LIFX"
    },
    {
     "description": "LABRADOR IRON ORE ROYALTY CO",
     "symbol": "LIFZF"
    },
    {
     "description": "LIG ASSETS INC",
     "symbol": "LIGA"
    },
    {
     "description": "LARCHMONT INTER HOLDCO LLC",
     "symbol": "LIHLU"
    },
    {
     "description": "LENNOX INTERNATIONAL INC",
     "symbol": "LII"
    },
    {
     "description": "LIBERTY LATIN AMERIC-CL A",
     "symbol": "LILA"
    },
    {
     "description": "LIBERTY LATIN AMERIC -B",
     "symbol": "LILAB"
    },
    {
     "description": "LIBERTY LATIN AMERIC-CL C",
     "symbol": "LILAK"
    },
    {
     "description": "LILIUM NV",
     "symbol": "LILM"
    },
    {
     "description": "LILIUM NV -CW26",
     "symbol": "LILMW"
    },
    {
     "description": "LINAMAR CORP",
     "symbol": "LIMAF"
    },
    {
     "description": "LINDE PLC",
     "symbol": "LIN"
    },
    {
     "description": "LINCOLN EDUCATIONAL SERVICES",
     "symbol": "LINC"
    },
    {
     "description": "LINDBLAD EXPEDITIONS HOLDING",
     "symbol": "LIND"
    },
    {
     "description": "INTERLINK ELECTRONICS INC",
     "symbol": "LINK"
    },
    {
     "description": "LIONTOWN RESOURCES LTD",
     "symbol": "LINRF"
    },
    {
     "description": "LIFE INSURANCE CO (ALA)",
     "symbol": "LINS"
    },
    {
     "description": "LIFE INSURANCE CO (ALA)-CL A",
     "symbol": "LINSA"
    },
    {
     "description": "LINIU TECHNOLOGY GROUP",
     "symbol": "LINUF"
    },
    {
     "description": "LION ENERGY LTD",
     "symbol": "LIOEF"
    },
    {
     "description": "LIONHEART III CORP -CLASS A",
     "symbol": "LION"
    },
    {
     "description": "LIONHEART III CORP",
     "symbol": "LIONU"
    },
    {
     "description": "LIONHEART III CL A -CW23",
     "symbol": "LIONW"
    },
    {
     "description": "LION CORP",
     "symbol": "LIOPF"
    },
    {
     "description": "LION CORP-UNSPONSORED ADR",
     "symbol": "LIOPY"
    },
    {
     "description": "LIPIDOR AB",
     "symbol": "LIPDF"
    },
    {
     "description": "LIQUID HOLDINGS GROUP INC",
     "symbol": "LIQDQ"
    },
    {
     "description": "LIQUID META CAPITAL HOLDINGS",
     "symbol": "LIQQF"
    },
    {
     "description": "LIQTECH INTERNATIONAL INC",
     "symbol": "LIQT"
    },
    {
     "description": "LI-S ENERGY LTD",
     "symbol": "LISEF"
    },
    {
     "description": "LITHIUM SOUTH DEVELOPMENT CO",
     "symbol": "LISMF"
    },
    {
     "description": "GLOBAL X LITHIUM & BATTERY T",
     "symbol": "LIT"
    },
    {
     "description": "LIGHTINTHEBOX HOLDING-ADR",
     "symbol": "LITB"
    },
    {
     "description": "LUMENTUM HOLDINGS INC",
     "symbol": "LITE"
    },
    {
     "description": "U.S. LITHIUM CORP",
     "symbol": "LITH"
    },
    {
     "description": "SNOW LAKE RESOURCES LTD",
     "symbol": "LITM"
    },
    {
     "description": "FRONTIER LITHIUM INC",
     "symbol": "LITOF"
    },
    {
     "description": "LOGISTICS INNOVATION TECH-A",
     "symbol": "LITT"
    },
    {
     "description": "LOGISTICS INNOVATION TECHNO",
     "symbol": "LITTU"
    },
    {
     "description": "LOGISTICS INNOVATION T-CW28",
     "symbol": "LITTW"
    },
    {
     "description": "GX LITH BATRY TECH UCITSAUSD",
     "symbol": "LITUF"
    },
    {
     "description": "EMLES @HOME ETF",
     "symbol": "LIV"
    },
    {
     "description": "LIV CAPITAL ACQUISITION CO-A",
     "symbol": "LIVB"
    },
    {
     "description": "LIV CAPITAL ACQUISITION CORP",
     "symbol": "LIVBU"
    },
    {
     "description": "LIV CAPITAL ACQUISITION -27",
     "symbol": "LIVBW"
    },
    {
     "description": "LIVE CURRENT MEDIA INC",
     "symbol": "LIVC"
    },
    {
     "description": "LIVE VENTURES INC",
     "symbol": "LIVE"
    },
    {
     "description": "LIVANOVA PLC",
     "symbol": "LIVN"
    },
    {
     "description": "LIXTE BIOTECHNOLOGY HOLDINGS",
     "symbol": "LIXT"
    },
    {
     "description": "LIXTE BIOTECHNOLOGY H -CW25",
     "symbol": "LIXTW"
    },
    {
     "description": "LIZHI INC",
     "symbol": "LIZI"
    },
    {
     "description": "LIGHTJUMP ACQUISITION CORP",
     "symbol": "LJAQ"
    },
    {
     "description": "LIGHTJUMP ACQUISITION CORP",
     "symbol": "LJAQU"
    },
    {
     "description": "LIGHTJUMP ACQUISITION -CW27",
     "symbol": "LJAQW"
    },
    {
     "description": "LA JOLLA PHARMACEUTICAL CO",
     "symbol": "LJPC"
    },
    {
     "description": "SSY GROUP LTD",
     "symbol": "LJUIF"
    },
    {
     "description": "LINK ADMINISTRATION HOLDINGS",
     "symbol": "LKADF"
    },
    {
     "description": "LKA GOLD INC",
     "symbol": "LKAI"
    },
    {
     "description": "LUOKUNG TECHNOLOGY CORP",
     "symbol": "LKCO"
    },
    {
     "description": "LAKE AREA CORN PROCESSORS LL",
     "symbol": "LKCRU"
    },
    {
     "description": "LUK FOOK HOLDINGS INTL LTD",
     "symbol": "LKFLF"
    },
    {
     "description": "LAKELAND FINANCIAL CORP",
     "symbol": "LKFN"
    },
    {
     "description": "LONKING HOLDINGS LTD-UNS ADR",
     "symbol": "LKHLY"
    },
    {
     "description": "LOOKERS PLC",
     "symbol": "LKKRF"
    },
    {
     "description": "LUCKY MINERALS INC",
     "symbol": "LKMNF"
    },
    {
     "description": "LUCKIN COFFEE INC - ADR",
     "symbol": "LKNCY"
    },
    {
     "description": "LAKES BLUE ENERGY NL",
     "symbol": "LKOLF"
    },
    {
     "description": "FLEXSHARES CREDIT-SCORED LON",
     "symbol": "LKOR"
    },
    {
     "description": "LKQ CORP",
     "symbol": "LKQ"
    },
    {
     "description": "LINK REIT",
     "symbol": "LKREF"
    },
    {
     "description": "LAKESIDE BANCSHARES INC",
     "symbol": "LKSB"
    },
    {
     "description": "LUKS GROUP VIETNAM HOLDINGS",
     "symbol": "LKSGF"
    },
    {
     "description": "LOOKSMART GROUP INC",
     "symbol": "LKST"
    },
    {
     "description": "LL FLOORING HOLDINGS INC",
     "symbol": "LL"
    },
    {
     "description": "TERRAN ORBITAL CORP",
     "symbol": "LLAP"
    },
    {
     "description": "TERRAN ORBITAL CORP -CW28",
     "symbol": "LLAP.WS"
    },
    {
     "description": "LIECHTENSTEIN LANDESBANK",
     "symbol": "LLAZF"
    },
    {
     "description": "LIFELINE BIOTECHNOLOGIES INC",
     "symbol": "LLBO"
    },
    {
     "description": "LLOYDS BANKING GROUP PLC",
     "symbol": "LLDTF"
    },
    {
     "description": "LLEIDANETWORKS SERVEIS TELEM",
     "symbol": "LLEIF"
    },
    {
     "description": "LENDLEASE GROUP",
     "symbol": "LLESF"
    },
    {
     "description": "LENDLEASE GROUP - SPON ADR",
     "symbol": "LLESY"
    },
    {
     "description": "LAKE RESOURCES NL",
     "symbol": "LLKKF"
    },
    {
     "description": "JX LUXVENTURE LTD",
     "symbol": "LLL"
    },
    {
     "description": "LAMPERD LESS LETHAL INC",
     "symbol": "LLLI"
    },
    {
     "description": "LANDMARK LAND CO INC",
     "symbol": "LLND"
    },
    {
     "description": "LIMELIGHT NETWORKS INC",
     "symbol": "LLNW"
    },
    {
     "description": "LINK LINUX INC",
     "symbol": "LLNXF"
    },
    {
     "description": "Lloyds Banking Group PLC",
     "symbol": "LLOBF"
    },
    {
     "description": "LYXOR UK GOVERNMENT BOND 0-5",
     "symbol": "LLXXF"
    },
    {
     "description": "ELI LILLY & CO",
     "symbol": "LLY"
    },
    {
     "description": "LIBERTY MEDIA ACQUISITION -A",
     "symbol": "LMACA"
    },
    {
     "description": "LIBERTY MEDIA ACQUISITION CO",
     "symbol": "LMACU"
    },
    {
     "description": "LIBERTY MEDIA ACQ CL A -CW27",
     "symbol": "LMACW"
    },
    {
     "description": "LMF ACQUISITION OPPORTUNIT-A",
     "symbol": "LMAO"
    },
    {
     "description": "LMF ACQUISITION OPPORTUNITIE",
     "symbol": "LMAOU"
    },
    {
     "description": "LMF ACQUISITION OPP -A -CW27",
     "symbol": "LMAOW"
    },
    {
     "description": "LEMAITRE VASCULAR INC",
     "symbol": "LMAT"
    },
    {
     "description": "LIMBACH HOLDINGS INC",
     "symbol": "LMB"
    },
    {
     "description": "FIRST TRUST LOW DURATION OPP",
     "symbol": "LMBS"
    },
    {
     "description": "LINGO MEDIA CORP",
     "symbol": "LMDCF"
    },
    {
     "description": "LUMIRADX LTD",
     "symbol": "LMDX"
    },
    {
     "description": "LUMIRADX LTD -CW26",
     "symbol": "LMDXW"
    },
    {
     "description": "LAURION MINERAL EXPLORATION",
     "symbol": "LMEFF"
    },
    {
     "description": "LM FUNDING AMERICA INC",
     "symbol": "LMFA"
    },
    {
     "description": "LUMINA GOLD CORP",
     "symbol": "LMGDF"
    },
    {
     "description": "LINK MOBILITY GROUP HOLDING",
     "symbol": "LMGHF"
    },
    {
     "description": "LIGHT MANAGEMENT GROUP INC",
     "symbol": "LMGR"
    },
    {
     "description": "LEM HOLDING SA-REG",
     "symbol": "LMHDF"
    },
    {
     "description": "LION E-MOBILITY AG",
     "symbol": "LMIAF"
    },
    {
     "description": "PHARMADRUG INC",
     "symbol": "LMLLF"
    },
    {
     "description": "LITHIUM AUSTRALIA NL",
     "symbol": "LMMFF"
    },
    {
     "description": "LANGHAM HOSPITALITY INV -SS",
     "symbol": "LMMHF"
    },
    {
     "description": "LEMONADE INC",
     "symbol": "LMND"
    },
    {
     "description": "LIMINAL BIOSCIENCES INC",
     "symbol": "LMNL"
    },
    {
     "description": "LIMONEIRA CO",
     "symbol": "LMNR"
    },
    {
     "description": "LEE & MAN PAPER MANUFACTURIN",
     "symbol": "LMPMF"
    },
    {
     "description": "LEE & MAN PAPER MANU-SP ADR",
     "symbol": "LMPMY"
    },
    {
     "description": "LAMPRELL PLC",
     "symbol": "LMPRF"
    },
    {
     "description": "LMP AUTOMOTIVE HOLDINGS INC",
     "symbol": "LMPX"
    },
    {
     "description": "LOMIKO METALS INC",
     "symbol": "LMRMF"
    },
    {
     "description": "LARAMIDE RESOURCES",
     "symbol": "LMRXF"
    },
    {
     "description": "LIMESTONE BOAT CO LTD\/THE",
     "symbol": "LMSBF"
    },
    {
     "description": "LIVE MICROSYSTEMS INC",
     "symbol": "LMSC"
    },
    {
     "description": "MACLOS CAPITAL INC",
     "symbol": "LMSMF"
    },
    {
     "description": "LATIN METALS INC",
     "symbol": "LMSQF"
    },
    {
     "description": "LIMESTONE BANCORP INC",
     "symbol": "LMST"
    },
    {
     "description": "LOCKHEED MARTIN CORP",
     "symbol": "LMT"
    },
    {
     "description": "LASER MASTER INTL INC",
     "symbol": "LMTI"
    },
    {
     "description": "LMWW HOLDINGS INC",
     "symbol": "LMWW"
    },
    {
     "description": "LINE Corporation",
     "symbol": "LN"
    },
    {
     "description": "LANDBAY INC - CL A",
     "symbol": "LNBY"
    },
    {
     "description": "LINCOLN NATIONAL CORP",
     "symbol": "LNC"
    },
    {
     "description": "LINCOLN MINING CORP\/CANADA",
     "symbol": "LNCLF"
    },
    {
     "description": "BRASILAGRO-CIA BRA - SPN ADR",
     "symbol": "LND"
    },
    {
     "description": "LINEA DIRECTA ASEGURADORA SA",
     "symbol": "LNDAF"
    },
    {
     "description": "LANDA APP LLC 10167 PORT ROY",
     "symbol": "LNDAS"
    },
    {
     "description": "LANDA APP LLC 1910 GROVE WAY",
     "symbol": "LNDBS"
    },
    {
     "description": "LANDEC CORP",
     "symbol": "LNDC"
    },
    {
     "description": "LANDA APP LLC 593 COUNTRY LA",
     "symbol": "LNDDS"
    },
    {
     "description": "LANDA APP LLC 6436 STONE TER",
     "symbol": "LNDES"
    },
    {
     "description": "LANDA APP LLC 6440 WOODSTONE",
     "symbol": "LNDFS"
    },
    {
     "description": "LANDA APP LLC 729 WINTER LN",
     "symbol": "LNDHS"
    },
    {
     "description": "LANDA APP LLC 8796 PARLIAMEN",
     "symbol": "LNDIS"
    },
    {
     "description": "LANDA APP LLC 8780 CHURCHILL",
     "symbol": "LNDJS"
    },
    {
     "description": "LANDA APP LLC 6848 SANDY CRK",
     "symbol": "LNDKS"
    },
    {
     "description": "LANDORE RESOURCES LTD",
     "symbol": "LNDLF"
    },
    {
     "description": "LUNDIN ENERGY AB",
     "symbol": "LNDNF"
    },
    {
     "description": "LANDA APP LLC",
     "symbol": "LNDOS"
    },
    {
     "description": "LIANDI CLEAN TECHNOLOGY INC",
     "symbol": "LNDT"
    },
    {
     "description": "SALONA GLOBAL MEDICAL DEVICE",
     "symbol": "LNDZF"
    },
    {
     "description": "LUNDIN ENERGY AB- SP ADR",
     "symbol": "LNEGY"
    },
    {
     "description": "LINK NET TBK PT",
     "symbol": "LNETF"
    },
    {
     "description": "L&F ACQUISITION CORP\/IL -A",
     "symbol": "LNFA"
    },
    {
     "description": "L&F ACQUISITION CORP\/IL",
     "symbol": "LNFA.U"
    },
    {
     "description": "L&F ACQUISITION CL A -CW27",
     "symbol": "LNFA.WS"
    },
    {
     "description": "CHENIERE ENERGY INC",
     "symbol": "LNG"
    },
    {
     "description": "LONGBAU GROUP INC",
     "symbol": "LNGB"
    },
    {
     "description": "LONGFOR GROUP HOLDINGS LTD",
     "symbol": "LNGPF"
    },
    {
     "description": "LASER ENERGETICS INC",
     "symbol": "LNGT"
    },
    {
     "description": "ESREY RESOURCES LTD",
     "symbol": "LNGYF"
    },
    {
     "description": "LINKBANCORP INC",
     "symbol": "LNKB"
    },
    {
     "description": "LINK ENERGY LLC",
     "symbol": "LNKE"
    },
    {
     "description": "LINK GROUP INC\/THE",
     "symbol": "LNKG"
    },
    {
     "description": "LINKLOGIS INC-CLASS B",
     "symbol": "LNKLF"
    },
    {
     "description": "LEANLIFE HEALTH INC",
     "symbol": "LNLHF"
    },
    {
     "description": "LINIKE MEDICAL GROUP LTD",
     "symbol": "LNMG"
    },
    {
     "description": "LINDSAY CORP",
     "symbol": "LNN"
    },
    {
     "description": "LI NING CO LTD",
     "symbol": "LNNGF"
    },
    {
     "description": "LI NING CO LTD-UNSPON ADR",
     "symbol": "LNNGY"
    },
    {
     "description": "LEONI AG",
     "symbol": "LNNNF"
    },
    {
     "description": "LEONI AG-UNSP ADR",
     "symbol": "LNNNY"
    },
    {
     "description": "LINIUS TECHNOLOGIES LTD",
     "symbol": "LNNTF"
    },
    {
     "description": "LION-PHILLIP S-REIT ETF",
     "symbol": "LNPLF"
    },
    {
     "description": "LONDONMETRIC PROPERTY PLC",
     "symbol": "LNSPF"
    },
    {
     "description": "LENSAR INC",
     "symbol": "LNSR"
    },
    {
     "description": "LONDON STOCK EXCHG-UNSP ADR",
     "symbol": "LNSTY"
    },
    {
     "description": "ALLIANT ENERGY CORP",
     "symbol": "LNT"
    },
    {
     "description": "LINTEC CORP",
     "symbol": "LNTEF"
    },
    {
     "description": "LANTHEUS HOLDINGS INC",
     "symbol": "LNTH"
    },
    {
     "description": "LEONTEQ AG",
     "symbol": "LNTQF"
    },
    {
     "description": "LENOVO GROUP LTD",
     "symbol": "LNVGF"
    },
    {
     "description": "LENOVO GROUP LTD-ADR",
     "symbol": "LNVGY"
    },
    {
     "description": "LINUX GOLD CORP",
     "symbol": "LNXGF"
    },
    {
     "description": "LANXESS AG",
     "symbol": "LNXSF"
    },
    {
     "description": "LANXESS AG-UNSPON ADR",
     "symbol": "LNXSY"
    },
    {
     "description": "LENZING AG",
     "symbol": "LNZNF"
    },
    {
     "description": "MANHATTAN BRIDGE CAPITAL INC",
     "symbol": "LOAN"
    },
    {
     "description": "LIVE OAK BANCSHARES INC",
     "symbol": "LOB"
    },
    {
     "description": "LOBE SCIENCES LTD",
     "symbol": "LOBEF"
    },
    {
     "description": "LIVE OAK CRESTVIEW CLIMATE-A",
     "symbol": "LOCC"
    },
    {
     "description": "LIVE OAK CRESTVIEW CLIMATE A",
     "symbol": "LOCC.U"
    },
    {
     "description": "LIVE OAK CRESTVIEW -CW26",
     "symbol": "LOCC.WS"
    },
    {
     "description": "LOCAL BOUNTI CORP",
     "symbol": "LOCL"
    },
    {
     "description": "LOCAL BOUNTI CORP -CW28",
     "symbol": "LOCL.WS"
    },
    {
     "description": "LOCAL CORP",
     "symbol": "LOCMQ"
    },
    {
     "description": "EL POLLO LOCO HOLDINGS INC",
     "symbol": "LOCO"
    },
    {
     "description": "COMSTOCK MINING INC",
     "symbol": "LODE"
    },
    {
     "description": "LOGICBIO THERAPEUTICS INC",
     "symbol": "LOGC"
    },
    {
     "description": "LOGITECH INTERNATIONAL-REG",
     "symbol": "LOGI"
    },
    {
     "description": "LEGEND OIL AND GAS LTD",
     "symbol": "LOGL"
    },
    {
     "description": "LOGANSPORT FINANCIAL CORP",
     "symbol": "LOGN"
    },
    {
     "description": "LOGICQUEST TECHNOLOGY INC",
     "symbol": "LOGQ"
    },
    {
     "description": "PEERLOGIX INC",
     "symbol": "LOGX"
    },
    {
     "description": "LOOMIS AB",
     "symbol": "LOIMF"
    },
    {
     "description": "LOOMIS AB-UNSP ADR",
     "symbol": "LOIMY"
    },
    {
     "description": "LIVE OAK MOBILITY ACQUISIT-A",
     "symbol": "LOKM"
    },
    {
     "description": "LIVE OAK MOBILITY ACQUISITIO",
     "symbol": "LOKM.U"
    },
    {
     "description": "LIVE OAK MOBILITY ACQ -CW28",
     "symbol": "LOKM.WS"
    },
    {
     "description": "LOMA NEGRA CIA IND-SPON ADR",
     "symbol": "LOMA"
    },
    {
     "description": "LION ONE METALS LTD",
     "symbol": "LOMLF"
    },
    {
     "description": "LONCOR GOLD INC",
     "symbol": "LONCF"
    },
    {
     "description": "LONKING HOLDINGS LTD",
     "symbol": "LONKF"
    },
    {
     "description": "LOON ENERGY CORP",
     "symbol": "LOONF"
    },
    {
     "description": "LOOP INDUSTRIES INC",
     "symbol": "LOOP"
    },
    {
     "description": "GRAND CANYON EDUCATION INC",
     "symbol": "LOPE"
    },
    {
     "description": "Gabelli Love Our Planet & Pe",
     "symbol": "LOPP"
    },
    {
     "description": "DIREXION LOW PRICED STOCK ET",
     "symbol": "LOPX"
    },
    {
     "description": "ACCESSO TECHNOLOGY GROUP PLC",
     "symbol": "LOQPF"
    },
    {
     "description": "LOTUS BAKERIES-UNSP ADR",
     "symbol": "LOTBY"
    },
    {
     "description": "LOT78 INC",
     "symbol": "LOTE"
    },
    {
     "description": "CARLOTZ INC",
     "symbol": "LOTZ"
    },
    {
     "description": "ACAMAR PARTNERS ACQUISI-CW26",
     "symbol": "LOTZW"
    },
    {
     "description": "SOUTH SHORE HOLDINGS LTD",
     "symbol": "LOUIF"
    },
    {
     "description": "INNOVATOR LOUP FRONTIER TECH",
     "symbol": "LOUP"
    },
    {
     "description": "SPARK NETWORKS SE-ADR",
     "symbol": "LOV"
    },
    {
     "description": "LOVARRA",
     "symbol": "LOVA"
    },
    {
     "description": "LOVESAC CO\/THE",
     "symbol": "LOVE"
    },
    {
     "description": "CANNARA BIOTECH INC",
     "symbol": "LOVFF"
    },
    {
     "description": "LOVE INTERNATIONAL GROUP INC",
     "symbol": "LOVV"
    },
    {
     "description": "LOWE'S COS INC",
     "symbol": "LOW"
    },
    {
     "description": "LOWELL FARMS INC",
     "symbol": "LOWLF"
    },
    {
     "description": "LINCOLN PARK BANCORP",
     "symbol": "LPBC"
    },
    {
     "description": "LIPOCINE INC",
     "symbol": "LPCN"
    },
    {
     "description": "LEE'S PHARMACEUTICAL HLDGS",
     "symbol": "LPCUF"
    },
    {
     "description": "LEPIDICO LTD",
     "symbol": "LPDNF"
    },
    {
     "description": "DORIAN LPG LTD",
     "symbol": "LPG"
    },
    {
     "description": "LOGAN GROUP CO LTD",
     "symbol": "LPHHF"
    },
    {
     "description": "LEE PHARMACEUTICALS",
     "symbol": "LPHM"
    },
    {
     "description": "LAREDO PETROLEUM INC",
     "symbol": "LPI"
    },
    {
     "description": "LPKF LASER & ELECTRONICS",
     "symbol": "LPKFF"
    },
    {
     "description": "LUPAKA GOLD CORP",
     "symbol": "LPKGF"
    },
    {
     "description": "LG DISPLAY CO LTD-ADR",
     "symbol": "LPL"
    },
    {
     "description": "LPL FINANCIAL HOLDINGS INC",
     "symbol": "LPLA"
    },
    {
     "description": "LIPPO MALLS INDONESIA RETAIL",
     "symbol": "LPMDF"
    },
    {
     "description": "LEEP INC",
     "symbol": "LPPI"
    },
    {
     "description": "LPP SA - UNSP ADR",
     "symbol": "LPPSY"
    },
    {
     "description": "OPEN LENDING CORP -  CL A",
     "symbol": "LPRO"
    },
    {
     "description": "LAURENT-PERRIER",
     "symbol": "LPRRF"
    },
    {
     "description": "LEGEND POWER SYSTEMS INC",
     "symbol": "LPSIF"
    },
    {
     "description": "LIVEPERSON INC",
     "symbol": "LPSN"
    },
    {
     "description": "LE@P TECHNOLOGY INC-CL A",
     "symbol": "LPTC"
    },
    {
     "description": "LIGHTPATH TECHNOLOGIES INC-A",
     "symbol": "LPTH"
    },
    {
     "description": "LONGPORT INC",
     "symbol": "LPTI"
    },
    {
     "description": "LOOP MEDIA INC",
     "symbol": "LPTV"
    },
    {
     "description": "LEAP THERAPEUTICS INC",
     "symbol": "LPTX"
    },
    {
     "description": "LOUISIANA-PACIFIC CORP",
     "symbol": "LPX"
    },
    {
     "description": "LIQUID AVATAR TECHNOLOGIES I",
     "symbol": "LQAVF"
    },
    {
     "description": "ISHARES IBOXX INVESTMENT GRA",
     "symbol": "LQD"
    },
    {
     "description": "LIQUIDIA CORP",
     "symbol": "LQDA"
    },
    {
     "description": "ISHARES BBB RATE CORP BOND",
     "symbol": "LQDB"
    },
    {
     "description": "ISHARES INT HEDG CORP BD ETF",
     "symbol": "LQDH"
    },
    {
     "description": "ISHARES INFLATION HEDGED COR",
     "symbol": "LQDI"
    },
    {
     "description": "LIQUIDITY SERVICES INC",
     "symbol": "LQDT"
    },
    {
     "description": "LIQUIDMETAL TECHNOLOGIES INC",
     "symbol": "LQMT"
    },
    {
     "description": "BLACK MAMMOTH METALS CORP",
     "symbol": "LQRCF"
    },
    {
     "description": "LIFEQUEST WORLD CORP",
     "symbol": "LQWC"
    },
    {
     "description": "LQWD FINTECH CORP",
     "symbol": "LQWDF"
    },
    {
     "description": "LARA EXPLORATION LTD",
     "symbol": "LRAXF"
    },
    {
     "description": "LAURENTIAN BANK OF CANADA",
     "symbol": "LRCDF"
    },
    {
     "description": "LOVITT RESOURCES INC",
     "symbol": "LRCFF"
    },
    {
     "description": "LAM RESEARCH CORP",
     "symbol": "LRCX"
    },
    {
     "description": "LAREDO OIL INC",
     "symbol": "LRDC"
    },
    {
     "description": "LORD GLOBAL CORPORATION",
     "symbol": "LRDG"
    },
    {
     "description": "ST JAMES GOLD CORP",
     "symbol": "LRDJF"
    },
    {
     "description": "LAREDO RESOURCES CORP",
     "symbol": "LRDR"
    },
    {
     "description": "LORDS & CO WORLDWIDE HOLDING",
     "symbol": "LRDSF"
    },
    {
     "description": "LOJAS RENNER SA SPONSORE-ADR",
     "symbol": "LRENY"
    },
    {
     "description": "LOGAN RIDGE FINANCE CORP",
     "symbol": "LRFC"
    },
    {
     "description": "CLRBRDG LRG CAP GWTH ESG ETF",
     "symbol": "LRGE"
    },
    {
     "description": "ISHARES MSCI USA MULTIFACTOR",
     "symbol": "LRGF"
    },
    {
     "description": "LUMINAR MEDIA GROUP INC",
     "symbol": "LRGR"
    },
    {
     "description": "LARK DISTILLING CO. LTD",
     "symbol": "LRKKF"
    },
    {
     "description": "L'OREAL",
     "symbol": "LRLCF"
    },
    {
     "description": "L'OREAL-UNSPONSORED ADR",
     "symbol": "LRLCY"
    },
    {
     "description": "LARIMAR THERAPEUTICS INC",
     "symbol": "LRMR"
    },
    {
     "description": "STRIDE INC",
     "symbol": "LRN"
    },
    {
     "description": "IQ US LRG CAP R&D LEAD ETF",
     "symbol": "LRND"
    },
    {
     "description": "LORAIN TELECOM CORP",
     "symbol": "LRNT"
    },
    {
     "description": "TRUESHARES TECHNOLOGY AI & D",
     "symbol": "LRNZ"
    },
    {
     "description": "GLOBAL HEALTH CLINICS LTD",
     "symbol": "LRSNF"
    },
    {
     "description": "LATIN RESOURCES LTD",
     "symbol": "LRSRF"
    },
    {
     "description": "LINK RESERVATIONS INC",
     "symbol": "LRSV"
    },
    {
     "description": "PURE GOLD MINING INC",
     "symbol": "LRTNF"
    },
    {
     "description": "LIBERTY ONE LITHIUM CORP",
     "symbol": "LRTTF"
    },
    {
     "description": "LEADERSHARES ALPHAFACTOR US",
     "symbol": "LSAF"
    },
    {
     "description": "LOS ANDES COPPER LTD",
     "symbol": "LSANF"
    },
    {
     "description": "LEADERSHARES ALPHAFACT TACT",
     "symbol": "LSAT"
    },
    {
     "description": "LAKE SHORE BANCORP INC",
     "symbol": "LSBK"
    },
    {
     "description": "LATTICE SEMICONDUCTOR CORP",
     "symbol": "LSCC"
    },
    {
     "description": "LIGHTING SCIENCE GROUP CORP",
     "symbol": "LSCG"
    },
    {
     "description": "LASSONDE INDS INC-CLASS A",
     "symbol": "LSDAF"
    },
    {
     "description": "LANDSEA HOMES CORP",
     "symbol": "LSEA"
    },
    {
     "description": "LANDSEA HOMES CORP-CW23",
     "symbol": "LSEAW"
    },
    {
     "description": "LAIRD SUPERFOOD INC",
     "symbol": "LSF"
    },
    {
     "description": "LIFESTORE FINANCIAL GROUP IN",
     "symbol": "LSFG"
    },
    {
     "description": "LAND SECURITIES GROUP PLC",
     "symbol": "LSGOF"
    },
    {
     "description": "LIFE STORAGE INC",
     "symbol": "LSI"
    },
    {
     "description": "LAI SUN GARMENT (INTL)",
     "symbol": "LSIHF"
    },
    {
     "description": "LISI",
     "symbol": "LSIIF"
    },
    {
     "description": "LISKA BIOMETRY INC",
     "symbol": "LSKA"
    },
    {
     "description": "LACHLAN STAR LTD",
     "symbol": "LSLCF"
    },
    {
     "description": "LASALLE LOGIPORT REIT",
     "symbol": "LSLGF"
    },
    {
     "description": "LSL PROPERTY SERVICES PLC",
     "symbol": "LSLPF"
    },
    {
     "description": "LODE-STAR MINING INC",
     "symbol": "LSMG"
    },
    {
     "description": "LODESTAR MINERALS LTD",
     "symbol": "LSMLF"
    },
    {
     "description": "LASTMINUTE.COM NV",
     "symbol": "LSMNF"
    },
    {
     "description": "LIGHTSPEED COMMERCE INC",
     "symbol": "LSPD"
    },
    {
     "description": "LARKSPUR HEALTH ACQUISITIO-A",
     "symbol": "LSPR"
    },
    {
     "description": "LARKSPUR HEALTH ACQUISITION",
     "symbol": "LSPRU"
    },
    {
     "description": "LARKSPUR HEALTH ACQUIS -CW23",
     "symbol": "LSPRW"
    },
    {
     "description": "LASERTEC CORP",
     "symbol": "LSRCF"
    },
    {
     "description": "LASERTEC CORP - ADR UNSP",
     "symbol": "LSRCY"
    },
    {
     "description": "NATIXIS LOOMIS SAYLES SHRT D",
     "symbol": "LSST"
    },
    {
     "description": "NIKKO LISTED 225 MINI ETF",
     "symbol": "LSTDF"
    },
    {
     "description": "LANDSTAR SYSTEM INC",
     "symbol": "LSTR"
    },
    {
     "description": "LIFESTYLE CHINA GROUP LTD",
     "symbol": "LSTYF"
    },
    {
     "description": "LIBERTY MEDIA COR-SIRIUSXM A",
     "symbol": "LSXMA"
    },
    {
     "description": "LIBERTY MEDIA COR-SIRIUSXM B",
     "symbol": "LSXMB"
    },
    {
     "description": "LIBERTY MEDIA COR-SIRIUSXM C",
     "symbol": "LSXMK"
    },
    {
     "description": "LIGHTBRIDGE CORP",
     "symbol": "LTBR"
    },
    {
     "description": "LTC PROPERTIES INC",
     "symbol": "LTC"
    },
    {
     "description": "LITE ACCESS TECHNOLOGIES INC",
     "symbol": "LTCCF"
    },
    {
     "description": "LATCH INC",
     "symbol": "LTCH"
    },
    {
     "description": "LATCH INC -CW26",
     "symbol": "LTCHW"
    },
    {
     "description": "GRAYSCALE LITECOIN TRUST",
     "symbol": "LTCN"
    },
    {
     "description": "LONG TERM CARE OPERATIONS 36",
     "symbol": "LTCO"
    },
    {
     "description": "LIFE'S TIME CAPSULE SERVICES",
     "symbol": "LTCP"
    },
    {
     "description": "LIVING 3D HOLDINGS LTD",
     "symbol": "LTDH"
    },
    {
     "description": "LOUD TECHNOLOGIES INC",
     "symbol": "LTEC"
    },
    {
     "description": "LS TELCOM AG",
     "symbol": "LTELF"
    },
    {
     "description": "LEET TECHNOLOGY INC",
     "symbol": "LTES"
    },
    {
     "description": "LITTLEFIELD CORP",
     "symbol": "LTFD"
    },
    {
     "description": "LIFE HEALTHCARE GROUP HOLDIN",
     "symbol": "LTGHF"
    },
    {
     "description": "LIFE HEALTHCARE - UNSPON ADR",
     "symbol": "LTGHY"
    },
    {
     "description": "XIAMEN LUTONG INTERNATIONAL",
     "symbol": "LTGJ"
    },
    {
     "description": "LIFE TIME GROUP HOLDINGS INC",
     "symbol": "LTH"
    },
    {
     "description": "LITHIUM POWER INTERNATIONAL",
     "symbol": "LTHHF"
    },
    {
     "description": "INZINC MINING LTD",
     "symbol": "LTHIF"
    },
    {
     "description": "LIVENT CORP",
     "symbol": "LTHM"
    },
    {
     "description": "LEGACY TECHNOLOGY HOLDINGS I",
     "symbol": "LTHO"
    },
    {
     "description": "LITHIUM TECHNOLOGY CORP",
     "symbol": "LTHUQ"
    },
    {
     "description": "LOGISTEC CORP - CLASS B",
     "symbol": "LTKBF"
    },
    {
     "description": "PROSHARES ULTRA TELECOMMUNIC",
     "symbol": "LTL"
    },
    {
     "description": "LATAM AIRLINES GROUP-SP ADR",
     "symbol": "LTMAQ"
    },
    {
     "description": "LITHIUM CHILE INC",
     "symbol": "LTMCF"
    },
    {
     "description": "ALLTEMP INC",
     "symbol": "LTMP"
    },
    {
     "description": "LABOR SMART INC",
     "symbol": "LTNC"
    },
    {
     "description": "LARSEN & TOUBRO-GDR REG S",
     "symbol": "LTOUF"
    },
    {
     "description": "PIMCO 15+ YR US TIPS INDX",
     "symbol": "LTPZ"
    },
    {
     "description": "LATROBE MAGNESIUM LTD",
     "symbol": "LTRBF"
    },
    {
     "description": "LEARNING TREE INTERNATIONAL",
     "symbol": "LTRE"
    },
    {
     "description": "LANTERN PHARMA INC",
     "symbol": "LTRN"
    },
    {
     "description": "LIBERTY TRIPADVISOR HDG-A",
     "symbol": "LTRPA"
    },
    {
     "description": "LIBERTY TRIPADVISOR HDG-B",
     "symbol": "LTRPB"
    },
    {
     "description": "LANTRONIX INC",
     "symbol": "LTRX"
    },
    {
     "description": "LOTTERY.COM INC",
     "symbol": "LTRY"
    },
    {
     "description": "LOTTERY.COM -CW21",
     "symbol": "LTRYW"
    },
    {
     "description": "Ladenburg Thalmann Financial Services Inc",
     "symbol": "LTSA"
    },
    {
     "description": "LIGHTSCAPE TECHNOLOGIES INC",
     "symbol": "LTSC"
    },
    {
     "description": "Ladenburg Thalmann Financial Services Inc",
     "symbol": "LTSF"
    },
    {
     "description": "Ladenburg Thalmann Financial Services Inc",
     "symbol": "LTSH"
    },
    {
     "description": "Ladenburg Thalmann Financial Services Inc",
     "symbol": "LTSK"
    },
    {
     "description": "Ladenburg Thalmann Financial Services Inc",
     "symbol": "LTSL"
    },
    {
     "description": "LOTUS RESOURCES LTD",
     "symbol": "LTSRF"
    },
    {
     "description": "LOTUS BAKERIES",
     "symbol": "LTSSF"
    },
    {
     "description": "LATTICE INC",
     "symbol": "LTTC"
    },
    {
     "description": "LOTTOGOPHER HOLDINGS INC",
     "symbol": "LTTGF"
    },
    {
     "description": "LEARNING TECHNOLOGIES GROUP",
     "symbol": "LTTHF"
    },
    {
     "description": "LOTUS VENTURES INC",
     "symbol": "LTTSF"
    },
    {
     "description": "LOTTE CORP-PREF",
     "symbol": "LTTZF"
    },
    {
     "description": "LITTLE SIOUX CORN PROCESSORS",
     "symbol": "LTUC"
    },
    {
     "description": "LITHIUM CORP",
     "symbol": "LTUM"
    },
    {
     "description": "LOTUS PHARMACEUTICALS INC",
     "symbol": "LTUS"
    },
    {
     "description": "LITTLE SIOUX CORN-MEM UNIT-A",
     "symbol": "LTUU"
    },
    {
     "description": "LUFAX HOLDING LTD-ADR",
     "symbol": "LU"
    },
    {
     "description": "LUBY'S INC",
     "symbol": "LUB"
    },
    {
     "description": "LUCA INC",
     "symbol": "LUCC"
    },
    {
     "description": "LUCID DIAGNOSTICS INC",
     "symbol": "LUCD"
    },
    {
     "description": "LUCARA DIAMOND CORP",
     "symbol": "LUCRF"
    },
    {
     "description": "LUDWIG ENTERPRISES INC",
     "symbol": "LUDG"
    },
    {
     "description": "LUFF ENTERPRISES LTD",
     "symbol": "LUFFF"
    },
    {
     "description": "REAL LUCK GROUP LTD",
     "symbol": "LUKEF"
    },
    {
     "description": "LUKOIL PJSC-ADR 144A",
     "symbol": "LUKFY"
    },
    {
     "description": "LUKOIL PJSC-SPON ADR",
     "symbol": "LUKOY"
    },
    {
     "description": "LULULEMON ATHLETICA INC",
     "symbol": "LULU"
    },
    {
     "description": "LUMBEE GUARANTY BANK",
     "symbol": "LUMB"
    },
    {
     "description": "LUMINEX RES CORP",
     "symbol": "LUMIF"
    },
    {
     "description": "LUMEN TECHNOLOGIES INC",
     "symbol": "LUMN"
    },
    {
     "description": "LUMOS PHARMA INC",
     "symbol": "LUMO"
    },
    {
     "description": "LUNA INNOVATIONS INC",
     "symbol": "LUNA"
    },
    {
     "description": "PULMONX CORP",
     "symbol": "LUNG"
    },
    {
     "description": "LUNDIN MINING CORP",
     "symbol": "LUNMF"
    },
    {
     "description": "LUOYANG GLASS COMPANY LTD-H",
     "symbol": "LUOYF"
    },
    {
     "description": "LOOPUP GROUP PLC",
     "symbol": "LUPGF"
    },
    {
     "description": "LABRADOR URANIUM INC",
     "symbol": "LURAF"
    },
    {
     "description": "MMA GLOBAL INC",
     "symbol": "LUSI"
    },
    {
     "description": "SOUTHWEST AIRLINES CO",
     "symbol": "LUV"
    },
    {
     "description": "LUVU BRANDS INC",
     "symbol": "LUVU"
    },
    {
     "description": "LUX HEALTH TECH ACQUIS-CL A",
     "symbol": "LUXA"
    },
    {
     "description": "LUX HEALTH TECH ACQUISITION",
     "symbol": "LUXAU"
    },
    {
     "description": "LUX HEALTH TECH ACQUIS -CW27",
     "symbol": "LUXAW"
    },
    {
     "description": "EMLES LUXURY GOODS ETF",
     "symbol": "LUXE"
    },
    {
     "description": "LUXXFOLIO HOLDINGS INC",
     "symbol": "LUXFF"
    },
    {
     "description": "LAVA MEDTECH ACQUISITION C-A",
     "symbol": "LVAC"
    },
    {
     "description": "LAVA MEDTECH ACQUISITION COR",
     "symbol": "LVACU"
    },
    {
     "description": "LAVA MEDTECH ACQUISIT -CW23",
     "symbol": "LVACW"
    },
    {
     "description": "VICTORIA LAKE INC",
     "symbol": "LVCA"
    },
    {
     "description": "LAS VEGAS CENTRAL RESERVATIO",
     "symbol": "LVCC"
    },
    {
     "description": "LIVECARE INC",
     "symbol": "LVCE"
    },
    {
     "description": "LIVING CELL TECHNOLOGIES LTD",
     "symbol": "LVCLF"
    },
    {
     "description": "LIVING CELL TECHNOLOGIES-ADR",
     "symbol": "LVCLY"
    },
    {
     "description": "LEVIATHAN NATURAL PRODUCTS I",
     "symbol": "LVCNF"
    },
    {
     "description": "LIMITLESS VENTURE GROUP INC",
     "symbol": "LVGI"
    },
    {
     "description": "LEGG MASON LO VOL HI DIV ETF",
     "symbol": "LVHD"
    },
    {
     "description": "LEGG MASON INTL LOW VOL DIV",
     "symbol": "LVHI"
    },
    {
     "description": "LVJI TECHNOLOGY HOLDINGS INC",
     "symbol": "LVJIF"
    },
    {
     "description": "LULU'S FASHION LOUNGE HOLDIN",
     "symbol": "LVLU"
    },
    {
     "description": "LEVEL VISION ELECTRONICS LTD",
     "symbol": "LVLV"
    },
    {
     "description": "LVMH MOET HENNESSY LOUIS VUI",
     "symbol": "LVMHF"
    },
    {
     "description": "LVMH MOET HENNESSY-UNSP ADR",
     "symbol": "LVMUY"
    },
    {
     "description": "LEONOVUS INC",
     "symbol": "LVNSF"
    },
    {
     "description": "LIVEONE INC",
     "symbol": "LVO"
    },
    {
     "description": "AMERICAN CENTURY LOW VOL ETF",
     "symbol": "LVOL"
    },
    {
     "description": "LIVEVOX HOLDINGS INC",
     "symbol": "LVOX"
    },
    {
     "description": "CRESCENT ACQUISITION CORP",
     "symbol": "LVOXU"
    },
    {
     "description": "CRESCENT ACQUISITION CO-CW24",
     "symbol": "LVOXW"
    },
    {
     "description": "LVPAI GROUP LTD",
     "symbol": "LVPA"
    },
    {
     "description": "LEVERE HOLDINGS CORP-A",
     "symbol": "LVRA"
    },
    {
     "description": "LEVERE HOLDINGS CORP",
     "symbol": "LVRAU"
    },
    {
     "description": "LEVERE HOLDINGS CORP A -CW28",
     "symbol": "LVRAW"
    },
    {
     "description": "CORDOVACANN CORP",
     "symbol": "LVRLF"
    },
    {
     "description": "LIVERPOOL GROUP INC",
     "symbol": "LVRP"
    },
    {
     "description": "LAS VEGAS SANDS CORP",
     "symbol": "LVS"
    },
    {
     "description": "LAI SUN DEVELOPMENT",
     "symbol": "LVSDF"
    },
    {
     "description": "LEVER STYLE CORP",
     "symbol": "LVSYF"
    },
    {
     "description": "LIVETILES LTD",
     "symbol": "LVTSF"
    },
    {
     "description": "LEVITEE LABS INC",
     "symbol": "LVTTF"
    },
    {
     "description": "LAVA THERAPEUTICS NV",
     "symbol": "LVTX"
    },
    {
     "description": "YOOMA WELLNESS INC",
     "symbol": "LVVEF"
    },
    {
     "description": "LIGHTSTONE VALUE PLUS REIT V",
     "symbol": "LVVP"
    },
    {
     "description": "LIGHTSTONE VALUE PLUS REAL E",
     "symbol": "LVVR"
    },
    {
     "description": "LIVEWIRE ERGOGENICS INC",
     "symbol": "LVVV"
    },
    {
     "description": "LIVEWORLD INC",
     "symbol": "LVWD"
    },
    {
     "description": "LEVIATHAN GOLD LTD-CLASS A",
     "symbol": "LVXFF"
    },
    {
     "description": "LVYUAN GREEN BUILDING MATERI",
     "symbol": "LVYN"
    },
    {
     "description": "LIVZON PHARMACEUTICAL GROU-H",
     "symbol": "LVZPF"
    },
    {
     "description": "LAMB WESTON HOLDINGS INC",
     "symbol": "LW"
    },
    {
     "description": "LIFEWAY FOODS INC",
     "symbol": "LWAY"
    },
    {
     "description": "LEWIS & CLARK BANCORP",
     "symbol": "LWCL"
    },
    {
     "description": "LCTI LOW CARBON TECHNOLOGIES",
     "symbol": "LWCTF"
    },
    {
     "description": "LUCKWEL PHARMACEUTICALS INC",
     "symbol": "LWEL"
    },
    {
     "description": "LIGHTWAVE LOGIC INC",
     "symbol": "LWLG"
    },
    {
     "description": "LONGWEN GROUP CORP",
     "symbol": "LWLW"
    },
    {
     "description": "SIENNA SENIOR LIVING INC",
     "symbol": "LWSCF"
    },
    {
     "description": "LOCOWEB SERVI - UNSP ADR",
     "symbol": "LWSIY"
    },
    {
     "description": "LAWSON INC",
     "symbol": "LWSOF"
    },
    {
     "description": "LEXINFINTECH HOLDINGS L-ADR",
     "symbol": "LX"
    },
    {
     "description": "LUX AMBER CORP",
     "symbol": "LXAM"
    },
    {
     "description": "LIXIANG EDUCATION HOLDIN-ADR",
     "symbol": "LXEH"
    },
    {
     "description": "LITHIUM ENERGI EXPLORATION I",
     "symbol": "LXENF"
    },
    {
     "description": "LUXFER HOLDINGS PLC",
     "symbol": "LXFR"
    },
    {
     "description": "LEXINGTON BIOSCIENCES INC",
     "symbol": "LXGTF"
    },
    {
     "description": "LX HOLDINGS CO LTD - PREF",
     "symbol": "LXHDF"
    },
    {
     "description": "LXI REIT PLC",
     "symbol": "LXILF"
    },
    {
     "description": "EUREKA 93 INC",
     "symbol": "LXLLF"
    },
    {
     "description": "LXP INDUSTRIAL TRUST",
     "symbol": "LXP"
    },
    {
     "description": "LXP INDUSTRIAL TRUST",
     "symbol": "LXP.PRC"
    },
    {
     "description": "GIBRALTAR GROWTH CORP -CW20",
     "symbol": "LXRAW"
    },
    {
     "description": "LUXOR-B SHS",
     "symbol": "LXRBF"
    },
    {
     "description": "LUXOR INDUSTRIAL CORP",
     "symbol": "LXRRF"
    },
    {
     "description": "LEXICON PHARMACEUTICALS INC",
     "symbol": "LXRX"
    },
    {
     "description": "LSB INDUSTRIES INC",
     "symbol": "LXU"
    },
    {
     "description": "LEXAGENE HOLDINGS INC",
     "symbol": "LXXGF"
    },
    {
     "description": "LYONDELLBASELL INDU-CL A",
     "symbol": "LYB"
    },
    {
     "description": "LYONS BANCORP INC",
     "symbol": "LYBC"
    },
    {
     "description": "LYELL IMMUNOPHARMA INC",
     "symbol": "LYEL"
    },
    {
     "description": "2NDVOTE LIFE NEUTRAL PLUS",
     "symbol": "LYFE"
    },
    {
     "description": "LYFT INC-A",
     "symbol": "LYFT"
    },
    {
     "description": "LLOYDS BANKING GROUP PLC-ADR",
     "symbol": "LYG"
    },
    {
     "description": "LYRIC JEANS INC",
     "symbol": "LYJN"
    },
    {
     "description": "DRAGON VICTORY INTERNATIONAL",
     "symbol": "LYL"
    },
    {
     "description": "LOYALTYPOINT INC",
     "symbol": "LYLP"
    },
    {
     "description": "LOYALTY VENTURES INC",
     "symbol": "LYLT"
    },
    {
     "description": "LIGHTYEAR NETWORK SOLUTIONS",
     "symbol": "LYNS"
    },
    {
     "description": "LYCOPODIUM LTD",
     "symbol": "LYOPF"
    },
    {
     "description": "LUYE PHARMA GROUP LTD",
     "symbol": "LYPHF"
    },
    {
     "description": "LYRA THERAPEUTICS INC",
     "symbol": "LYRA"
    },
    {
     "description": "CIRRUS NETWORKS HOLDINGS LTD",
     "symbol": "LYRTF"
    },
    {
     "description": "LYNAS RARE EARTHS LTD",
     "symbol": "LYSCF"
    },
    {
     "description": "LYNAS RARE EARTHS LTD-SP ADR",
     "symbol": "LYSDY"
    },
    {
     "description": "LEROY SEAFOOD GROUP ASA",
     "symbol": "LYSFF"
    },
    {
     "description": "LEROY SEAFOOD GROUP-ADR",
     "symbol": "LYSFY"
    },
    {
     "description": "LYSOGENE SA",
     "symbol": "LYSGF"
    },
    {
     "description": "LSI INDUSTRIES INC",
     "symbol": "LYTS"
    },
    {
     "description": "LIVE NATION ENTERTAINMENT IN",
     "symbol": "LYV"
    },
    {
     "description": "LYXOR EUROSTOXX 50 DR",
     "symbol": "LYXEF"
    },
    {
     "description": "LYXOR USD FLOATING RATE NOTE",
     "symbol": "LYXOF"
    },
    {
     "description": "LYXOR CAC 40",
     "symbol": "LYXRF"
    },
    {
     "description": "LYXOR ESG USD HIGH YIELD DR",
     "symbol": "LYXUF"
    },
    {
     "description": "LYXOR MSCI ASIA PACIFIC",
     "symbol": "LYXXF"
    },
    {
     "description": "LYXOR EMERGING MARKETS",
     "symbol": "LYYXF"
    },
    {
     "description": "LEGALZOOMCOM INC",
     "symbol": "LZ"
    },
    {
     "description": "LONZA GROUP AG-REG",
     "symbol": "LZAGF"
    },
    {
     "description": "LONZA GROUP AG-UNSPON ADR",
     "symbol": "LZAGY"
    },
    {
     "description": "LA-Z-BOY INC",
     "symbol": "LZB"
    },
    {
     "description": "LUZ DEL SUR SAA-COMUN",
     "symbol": "LZDLF"
    },
    {
     "description": "LIZHAN ENVIRONMENTAL CORP",
     "symbol": "LZENF"
    },
    {
     "description": "LZG INTERNATIONAL INC",
     "symbol": "LZGI"
    },
    {
     "description": "LOCALIZA RENT A CAR-SPN ADR",
     "symbol": "LZRFY"
    },
    {
     "description": "MACY'S INC",
     "symbol": "M"
    },
    {
     "description": "MASTERCARD INC - A",
     "symbol": "MA"
    },
    {
     "description": "MID-AMERICA APARTMENT COMM",
     "symbol": "MAA"
    },
    {
     "description": "MID-AMER APT COMMUNITIES",
     "symbol": "MAA.PRI"
    },
    {
     "description": "MAGINDUSTRIES CORP",
     "symbol": "MAAFF"
    },
    {
     "description": "MARKETING ALLIANCE INC\/THE",
     "symbol": "MAAL"
    },
    {
     "description": "MAANSHAN IRON & STEEL-H",
     "symbol": "MAANF"
    },
    {
     "description": "MANA CAPITAL ACQUISITION COR",
     "symbol": "MAAQ"
    },
    {
     "description": "MANA CAPITAL ACQUISITION-RTS",
     "symbol": "MAAQR"
    },
    {
     "description": "MANA CAPITAL ACQUISITION COR",
     "symbol": "MAAQU"
    },
    {
     "description": "MANA CAPITAL ACQ -CW26",
     "symbol": "MAAQW"
    },
    {
     "description": "VANECK MUNI ALLOCATION ETF",
     "symbol": "MAAX"
    },
    {
     "description": "MORTGAGE ADVICE BUREAU HOLDI",
     "symbol": "MABHF"
    },
    {
     "description": "MACERICH CO\/THE",
     "symbol": "MAC"
    },
    {
     "description": "MORINGA ACQUISITION CORP -A",
     "symbol": "MACA"
    },
    {
     "description": "MORINGA ACQUISITION CORP",
     "symbol": "MACAU"
    },
    {
     "description": "MORINGA ACQUISITION COR-CW26",
     "symbol": "MACAW"
    },
    {
     "description": "MISSION ADVANCEMENT CORP-A",
     "symbol": "MACC"
    },
    {
     "description": "MISSION ADVANCEMENT CORP",
     "symbol": "MACC.U"
    },
    {
     "description": "MISSION ADVANCEMENT A -CW28",
     "symbol": "MACC.WS"
    },
    {
     "description": "MACE SECURITY INTL INC",
     "symbol": "MACE"
    },
    {
     "description": "MERRIMACK PHARMACEUTICALS IN",
     "symbol": "MACK"
    },
    {
     "description": "MACA LTD",
     "symbol": "MACLF"
    },
    {
     "description": "THEMAC RESOURCES GROUP LTD",
     "symbol": "MACQF"
    },
    {
     "description": "MALLARD ACQUISITION CORP",
     "symbol": "MACU"
    },
    {
     "description": "MALLARD ACQUISITION CORP",
     "symbol": "MACUU"
    },
    {
     "description": "MALLARD ACQUISITION -CW27",
     "symbol": "MACUW"
    },
    {
     "description": "MADER GROUP LTD",
     "symbol": "MADGF"
    },
    {
     "description": "MADISON SYSTEMS INC",
     "symbol": "MADI"
    },
    {
     "description": "MANILA ELEC (MERALC)-UNS ADR",
     "symbol": "MAEOY"
    },
    {
     "description": "MAG SILVER CORP",
     "symbol": "MAG"
    },
    {
     "description": "POINT BRIDGE GOP STOCK T ETF",
     "symbol": "MAGA"
    },
    {
     "description": "MAGELLAN GOLD CORP",
     "symbol": "MAGE"
    },
    {
     "description": "MAGPLANE TECHNOLOGY INC",
     "symbol": "MAGP"
    },
    {
     "description": "MAGNET FORENSICS INC",
     "symbol": "MAGTF"
    },
    {
     "description": "MONARCH SERVICES INC",
     "symbol": "MAHI"
    },
    {
     "description": "MEDIPAL HOLDINGS CO-UNSP ADR",
     "symbol": "MAHLY"
    },
    {
     "description": "MAHINDRA & MAHINDRA-SPON GDR",
     "symbol": "MAHMF"
    },
    {
     "description": "MID-ATLANTIC HOME HEALTH NET",
     "symbol": "MAHN"
    },
    {
     "description": "MINERA ALAMOS INC",
     "symbol": "MAIFF"
    },
    {
     "description": "MAIN STREET CAPITAL CORP",
     "symbol": "MAIN"
    },
    {
     "description": "MAJESTIC CAPITAL LTD",
     "symbol": "MAJCQ"
    },
    {
     "description": "MICHAEL ANTHONY HOLDINGS INC",
     "symbol": "MAJJ"
    },
    {
     "description": "MAKARA MINING CORP",
     "symbol": "MAKAF"
    },
    {
     "description": "AD MAKEPEACE COMPANY",
     "symbol": "MAKE"
    },
    {
     "description": "MAKO MINING CORP",
     "symbol": "MAKOF"
    },
    {
     "description": "MARKS & SPENCER GROUP PLC",
     "symbol": "MAKSF"
    },
    {
     "description": "MARKS & SPENCER PLC-ADR",
     "symbol": "MAKSY"
    },
    {
     "description": "PROSHARES S&P KENSHO SMRT FA",
     "symbol": "MAKX"
    },
    {
     "description": "MACAU LEGEND DEVELOPMENT LTD",
     "symbol": "MALDF"
    },
    {
     "description": "MAGELLAN AEROSPACE CORP",
     "symbol": "MALJF"
    },
    {
     "description": "MINERAL RESOURCES LTD",
     "symbol": "MALRF"
    },
    {
     "description": "MINERAL RESOURCES LTD-ADR",
     "symbol": "MALRY"
    },
    {
     "description": "MONARCH AMBASSADOR INCOME ET",
     "symbol": "MAMB"
    },
    {
     "description": "MCAN MORTGAGE CORP",
     "symbol": "MAMTF"
    },
    {
     "description": "MANPOWERGROUP INC",
     "symbol": "MAN"
    },
    {
     "description": "MANHATTAN ASSOCIATES INC",
     "symbol": "MANH"
    },
    {
     "description": "MANOLETE PARTNERS PLC",
     "symbol": "MANOF"
    },
    {
     "description": "MANOR NATIONAL BANK\/THE",
     "symbol": "MANR"
    },
    {
     "description": "MANTECH INTERNATIONAL CORP-A",
     "symbol": "MANT"
    },
    {
     "description": "MANCHESTER UNITED PLC-CL A",
     "symbol": "MANU"
    },
    {
     "description": "MANNING VENTURES INC",
     "symbol": "MANVF"
    },
    {
     "description": "MANZ AG",
     "symbol": "MANZF"
    },
    {
     "description": "MAOYAN ENTERTAINMENT",
     "symbol": "MAOFF"
    },
    {
     "description": "MANITOU BF",
     "symbol": "MAOIF"
    },
    {
     "description": "MAUDORE MINERALS LTD",
     "symbol": "MAOMF"
    },
    {
     "description": "MANDARIN ORIENTAL INTL LTD",
     "symbol": "MAORF"
    },
    {
     "description": "ITISSALAT AL-MAGHRIB",
     "symbol": "MAOTF"
    },
    {
     "description": "MAPLETREE LOGISTICS TRUST",
     "symbol": "MAPGF"
    },
    {
     "description": "MAPLETREE INDUSTRIAL TRUST",
     "symbol": "MAPIF"
    },
    {
     "description": "MAPLE PRESS CO",
     "symbol": "MAPL"
    },
    {
     "description": "PROSTAR HOLDINGS INC",
     "symbol": "MAPPF"
    },
    {
     "description": "WM TECHNOLOGY INC",
     "symbol": "MAPS"
    },
    {
     "description": "WM TECHNOLOGY INC-CW24",
     "symbol": "MAPSW"
    },
    {
     "description": "MAPTELLIGENT INC",
     "symbol": "MAPT"
    },
    {
     "description": "ATLAS ARTERIA",
     "symbol": "MAQAF"
    },
    {
     "description": "MAQUIA CAPITAL ACQUISITION-A",
     "symbol": "MAQC"
    },
    {
     "description": "MAQUIA CAPITAL ACQUISITION",
     "symbol": "MAQCU"
    },
    {
     "description": "MAQUIA CAPITAL ACQ A -CW27",
     "symbol": "MAQCW"
    },
    {
     "description": "MARRIOTT INTERNATIONAL -CL A",
     "symbol": "MAR"
    },
    {
     "description": "MARATHON DIGITAL HOLDINGS IN",
     "symbol": "MARA"
    },
    {
     "description": "FIRST TRUST MERGER ARBITRAGE",
     "symbol": "MARB"
    },
    {
     "description": "REMARK HOLDINGS INC",
     "symbol": "MARK"
    },
    {
     "description": "Remark Holdings Inc",
     "symbol": "MARKP"
    },
    {
     "description": "MARINE PETROLEUM TRUST",
     "symbol": "MARPS"
    },
    {
     "description": "MARUBENI CORP",
     "symbol": "MARUF"
    },
    {
     "description": "MARUBENI CORP-UNSPONS ADR",
     "symbol": "MARUY"
    },
    {
     "description": "MARVEL DISCOVERY CORP",
     "symbol": "MARVF"
    },
    {
     "description": "TRUESHARES STRUC OUTCOME MAR",
     "symbol": "MARZ"
    },
    {
     "description": "MARSTON'S PLC",
     "symbol": "MARZF"
    },
    {
     "description": "MASCO CORP",
     "symbol": "MAS"
    },
    {
     "description": "MASIMO CORP",
     "symbol": "MASI"
    },
    {
     "description": "MAISON LUXE INC",
     "symbol": "MASN"
    },
    {
     "description": "908 DEVICES INC",
     "symbol": "MASS"
    },
    {
     "description": "MATTEL INC",
     "symbol": "MAT"
    },
    {
     "description": "MATTHEWS INTL CORP-CLASS A",
     "symbol": "MATW"
    },
    {
     "description": "MATSON INC",
     "symbol": "MATX"
    },
    {
     "description": "MATSUYAFOODS HOLDINGS CO LTD",
     "symbol": "MATYF"
    },
    {
     "description": "MAGNETIC RESOURCES NL",
     "symbol": "MAUGF"
    },
    {
     "description": "MARUI GROUP CO LTD",
     "symbol": "MAURF"
    },
    {
     "description": "MARUI LTD-UNSPON ADR",
     "symbol": "MAURY"
    },
    {
     "description": "MATSUI SECURITIES-UNSPON ADR",
     "symbol": "MAUSY"
    },
    {
     "description": "MONTAGE GOLD CORP",
     "symbol": "MAUTF"
    },
    {
     "description": "PIONEER MUNICIPAL HIGH INC",
     "symbol": "MAV"
    },
    {
     "description": "MAV BEAUTY BRANDS INC",
     "symbol": "MAVBF"
    },
    {
     "description": "MARUWA CO LTD",
     "symbol": "MAWAF"
    },
    {
     "description": "MAN WAH HOLDINGS LTD",
     "symbol": "MAWHF"
    },
    {
     "description": "MAN WAH HOLDINGS LTD-UNS ADR",
     "symbol": "MAWHY"
    },
    {
     "description": "MEDIAALPHA INC-CLASS A",
     "symbol": "MAX"
    },
    {
     "description": "MAX SOUND CORP",
     "symbol": "MAXD"
    },
    {
     "description": "MAX STOCK LTD",
     "symbol": "MAXFF"
    },
    {
     "description": "SOUTHERN ENERGY CORP",
     "symbol": "MAXMF"
    },
    {
     "description": "MAXEON SOLAR TECHNOLOGIE",
     "symbol": "MAXN"
    },
    {
     "description": "MAXAR TECHNOLOGIES INC",
     "symbol": "MAXR"
    },
    {
     "description": "MAXIS BHD",
     "symbol": "MAXSF"
    },
    {
     "description": "MAYNE PHARMA GROUP LTD",
     "symbol": "MAYNF"
    },
    {
     "description": "MAYS (J.W.) INC",
     "symbol": "MAYS"
    },
    {
     "description": "MAYEX USA INC",
     "symbol": "MAYX"
    },
    {
     "description": "TS STR OUTCOME MAY ETF",
     "symbol": "MAYZ"
    },
    {
     "description": "M3-BRIGADE ACQUISITION II-A",
     "symbol": "MBAC"
    },
    {
     "description": "M3-BRIGADE ACQUISITION II CO",
     "symbol": "MBAC.U"
    },
    {
     "description": "M3-BRIGADE ACQ II -CW27",
     "symbol": "MBAC.WS"
    },
    {
     "description": "CIBT EDUCATION GROUP INC",
     "symbol": "MBAIF"
    },
    {
     "description": "MBANK SA",
     "symbol": "MBAKF"
    },
    {
     "description": "MEDIABAY INC",
     "symbol": "MBAY"
    },
    {
     "description": "ISHARES MBS ETF",
     "symbol": "MBB"
    },
    {
     "description": "VANECK MOODY'S ANALYTICS BBB",
     "symbol": "MBBB"
    },
    {
     "description": "MARATHON BANCORP INC",
     "symbol": "MBBC"
    },
    {
     "description": "MONARCH BLUE CHIPS CORE ETF",
     "symbol": "MBCC"
    },
    {
     "description": "ITAFOS INC",
     "symbol": "MBCF"
    },
    {
     "description": "MABCURE INC",
     "symbol": "MBCI"
    },
    {
     "description": "MIDDLEFIELD BANC CORP",
     "symbol": "MBCN"
    },
    {
     "description": "MASS BUSINESS DEVELOPMENT CP",
     "symbol": "MBDC"
    },
    {
     "description": "MITSUBISHI UFJ FINANCIAL GRO",
     "symbol": "MBFJF"
    },
    {
     "description": "MITSUBISHI GAS CHEMICAL CO",
     "symbol": "MBGCF"
    },
    {
     "description": "MITSUBOSHI BELTING CO LTD",
     "symbol": "MBGFF"
    },
    {
     "description": "MED BIOGENE INC",
     "symbol": "MBGNF"
    },
    {
     "description": "MBH CORP PLC",
     "symbol": "MBHCF"
    },
    {
     "description": "MASCH BERTHOLD HERMLE AG-VOR",
     "symbol": "MBHPF"
    },
    {
     "description": "MBIA INC",
     "symbol": "MBI"
    },
    {
     "description": "MOBILE INFRASTRUCTURE CORP",
     "symbol": "MBIC"
    },
    {
     "description": "MARRONE BIO INNOVATIONS INC",
     "symbol": "MBII"
    },
    {
     "description": "MERCHANTS BANCORP\/IN",
     "symbol": "MBIN"
    },
    {
     "description": "MERCHANTS BANCORP",
     "symbol": "MBINN"
    },
    {
     "description": "MERCHANTS BANCORP",
     "symbol": "MBINO"
    },
    {
     "description": "MERCHANTS BANCORP",
     "symbol": "MBINP"
    },
    {
     "description": "MUSTANG BIO INC",
     "symbol": "MBIO"
    },
    {
     "description": "ORANGE BELGIUM",
     "symbol": "MBISF"
    },
    {
     "description": "METAL BANK LTD",
     "symbol": "MBKBF"
    },
    {
     "description": "MBT BANCSHARES INC",
     "symbol": "MBKL"
    },
    {
     "description": "MOBILUM TECHNOLOGIES INC",
     "symbol": "MBLMF"
    },
    {
     "description": "MORRIS STATE BANCSHARES INC",
     "symbol": "MBLU"
    },
    {
     "description": "MOBIVENTURES INC",
     "symbol": "MBLV"
    },
    {
     "description": "SPDR NUVEEN MUNICIPAL BOND",
     "symbol": "MBND"
    },
    {
     "description": "SPDR NUVEEN MUNI BOND ESG",
     "symbol": "MBNE"
    },
    {
     "description": "METRO BANK PLC",
     "symbol": "MBNKF"
    },
    {
     "description": "MEDALLION BANK UTAH",
     "symbol": "MBNKP"
    },
    {
     "description": "MARINE BANCORP FLA INC",
     "symbol": "MBOF"
    },
    {
     "description": "MICROBOT MEDICAL INC",
     "symbol": "MBOT"
    },
    {
     "description": "FREEDOM DAY DIVIDEND ETF",
     "symbol": "MBOX"
    },
    {
     "description": "MITCHELLS & BUTLERS PLC",
     "symbol": "MBPFF"
    },
    {
     "description": "MO-BRUK J MOKRZYCKI LTD",
     "symbol": "MBRFF"
    },
    {
     "description": "MBMI RESOURCES INC",
     "symbol": "MBRTF"
    },
    {
     "description": "MOLECULIN BIOTECH INC",
     "symbol": "MBRX"
    },
    {
     "description": "M3-BRIGADE ACQUISITION -CL A",
     "symbol": "MBSC"
    },
    {
     "description": "M3-BRIGADE ACQUISITION III C",
     "symbol": "MBSC.U"
    },
    {
     "description": "M3-BRIGADE ACQ III -CW23",
     "symbol": "MBSC.WS"
    },
    {
     "description": "FLEXSHARES DISCIPLINED DURAT",
     "symbol": "MBSD"
    },
    {
     "description": "ORANGE BELGIUM-SPON ADR",
     "symbol": "MBSRY"
    },
    {
     "description": "MOBILE STAR CORP\/THE",
     "symbol": "MBST"
    },
    {
     "description": "MOBILE TELESYSTEMS PUBLIC JO",
     "symbol": "MBT"
    },
    {
     "description": "NOCTURNE ACQUISITION CORP",
     "symbol": "MBTC"
    },
    {
     "description": "NOCTURNE ACQUISITION-RIGHTS",
     "symbol": "MBTCR"
    },
    {
     "description": "NOCTURNE ACQUISITION CORP",
     "symbol": "MBTCU"
    },
    {
     "description": "Melanion BTC Equity Universe UCITS ETF",
     "symbol": "MBTCX"
    },
    {
     "description": "MABUCHI MOTOR CO LTD",
     "symbol": "MBUMF"
    },
    {
     "description": "MABUCHI MOTOR CO LT-UNSP ADR",
     "symbol": "MBUMY"
    },
    {
     "description": "MALIBU BOATS INC - A",
     "symbol": "MBUU"
    },
    {
     "description": "MILLENNIUM BANKSHARES CORP",
     "symbol": "MBVA"
    },
    {
     "description": "MERCANTILE BANK CORP",
     "symbol": "MBWM"
    },
    {
     "description": "MICROBIX BIOSYSTEMS INC",
     "symbol": "MBXBF"
    },
    {
     "description": "MOUNTAIN BOY MINERALS LTD",
     "symbol": "MBYMF"
    },
    {
     "description": "MOELIS & CO - CLASS A",
     "symbol": "MC"
    },
    {
     "description": "MOUNTAIN & CO I ACQUISITION",
     "symbol": "MCAA"
    },
    {
     "description": "MOUNTAIN & CO I ACQUISITION",
     "symbol": "MCAAU"
    },
    {
     "description": "MOUNTAIN & CO I ACQ -CW23",
     "symbol": "MCAAW"
    },
    {
     "description": "MOUNTAIN CREST ACQUISITION C",
     "symbol": "MCAE"
    },
    {
     "description": "MOUNTAIN CREST ACQUISITI-RTS",
     "symbol": "MCAER"
    },
    {
     "description": "MOUNTAIN CREST ACQUISITION C",
     "symbol": "MCAEU"
    },
    {
     "description": "MOUNTAIN CREST ACQ CORP IV",
     "symbol": "MCAF"
    },
    {
     "description": "MOUNTAIN CREST ACQ CORP -RTS",
     "symbol": "MCAFR"
    },
    {
     "description": "MOUNTAIN CREST ACQ CORP IV",
     "symbol": "MCAFU"
    },
    {
     "description": "MOUNTAIN CREST ACQUISITION",
     "symbol": "MCAG"
    },
    {
     "description": "MOUNTAIN CREST ACQUISITI-RTS",
     "symbol": "MCAGR"
    },
    {
     "description": "MOUNTAIN CREST ACQUISITION C",
     "symbol": "MCAGU"
    },
    {
     "description": "MCAP INC",
     "symbol": "MCAP"
    },
    {
     "description": "MERCARI INC-UNSP ADR",
     "symbol": "MCARY"
    },
    {
     "description": "METROPOLITAN BANK HOLDING CO",
     "symbol": "MCB"
    },
    {
     "description": "MACATAWA BANK CORP",
     "symbol": "MCBC"
    },
    {
     "description": "MOUNTAIN COMMERCE BANCORP IN",
     "symbol": "MCBI"
    },
    {
     "description": "MADISON COUNTY FINANCIAL INC",
     "symbol": "MCBK"
    },
    {
     "description": "MICHIGAN COMMUNITY BANCORP",
     "symbol": "MCBP"
    },
    {
     "description": "MCBRIDE PLC",
     "symbol": "MCBRF"
    },
    {
     "description": "METROCITY BANKSHARES INC",
     "symbol": "MCBS"
    },
    {
     "description": "MCCHIP RESOURCES INC",
     "symbol": "MCCHF"
    },
    {
     "description": "MESTEK INC",
     "symbol": "MCCK"
    },
    {
     "description": "MACROMILL INC",
     "symbol": "MCCLF"
    },
    {
     "description": "MEDCOLCANNA ORGANICS INC",
     "symbol": "MCCNF"
    },
    {
     "description": "MCCOY GLOBAL INC",
     "symbol": "MCCRF"
    },
    {
     "description": "MCX TECHNOLOGIES CORP",
     "symbol": "MCCX"
    },
    {
     "description": "MCDONALD'S CORP",
     "symbol": "MCD"
    },
    {
     "description": "KMA HOLDING INC",
     "symbol": "MCDA"
    },
    {
     "description": "MCDERMOTT INTER TR B  -CW27",
     "symbol": "MCDBF"
    },
    {
     "description": "MCDERMOTT INTERNATIONAL LTD",
     "symbol": "MCDIF"
    },
    {
     "description": "MACDONALD MINES EXPLORATION",
     "symbol": "MCDMF"
    },
    {
     "description": "MCDERMOTT INTER TR A  -CW27",
     "symbol": "MCDTF"
    },
    {
     "description": "MILLENNIUM CELL INC",
     "symbol": "MCELQ"
    },
    {
     "description": "MONARCH CEMENT CO",
     "symbol": "MCEM"
    },
    {
     "description": "MACRO ENTERPRISES INC",
     "symbol": "MCESF"
    },
    {
     "description": "MULTICELL TECHNOLOGIES INC",
     "symbol": "MCET"
    },
    {
     "description": "MASTERCRAFT BOAT HOLDINGS IN",
     "symbol": "MCFT"
    },
    {
     "description": "MICRO FOCUS INTERNATIONAL",
     "symbol": "MCFUF"
    },
    {
     "description": "MEMBERSHIP COLLECTIVE GRP -A",
     "symbol": "MCG"
    },
    {
     "description": "MATCHAAH HOLDINGS INC",
     "symbol": "MCHA"
    },
    {
     "description": "MECHANICS BANK \/WALNUT CREEK",
     "symbol": "MCHB"
    },
    {
     "description": "MACMAHON HOLDINGS LTD",
     "symbol": "MCHHF"
    },
    {
     "description": "ISHARES MSCI CHINA ETF",
     "symbol": "MCHI"
    },
    {
     "description": "MARUICHI STEEL TUBE LTD",
     "symbol": "MCHIF"
    },
    {
     "description": "MCHENRY BANCORP INC",
     "symbol": "MCHN"
    },
    {
     "description": "MULTICHOICE GROUP LTD - ADR",
     "symbol": "MCHOY"
    },
    {
     "description": "MICROCHIP TECHNOLOGY INC",
     "symbol": "MCHP"
    },
    {
     "description": "M CASH INTEGRASI PT",
     "symbol": "MCHSF"
    },
    {
     "description": "MAUCH CHUNK TRUST FINANCIAL",
     "symbol": "MCHT"
    },
    {
     "description": "MGM CHINA HOLDINGS LTD",
     "symbol": "MCHVF"
    },
    {
     "description": "MGM CHINA HOLDINGS-UNSP ADR",
     "symbol": "MCHVY"
    },
    {
     "description": "MARCHEX INC-CLASS B",
     "symbol": "MCHX"
    },
    {
     "description": "BARINGS CORPORATE INVESTORS",
     "symbol": "MCI"
    },
    {
     "description": "MERCIA ASSET MANAGEMENT PLC",
     "symbol": "MCIAF"
    },
    {
     "description": "MULTICORP INTERNATIONAL INC",
     "symbol": "MCIC"
    },
    {
     "description": "MACAU CAPITAL INVESTMENTS",
     "symbol": "MCIM"
    },
    {
     "description": "MCI ONEHEALTH TECHNOLOGIES-A",
     "symbol": "MCIOF"
    },
    {
     "description": "MCJ CO LTD",
     "symbol": "MCJKF"
    },
    {
     "description": "MCKESSON CORP",
     "symbol": "MCK"
    },
    {
     "description": "MCKAY SECURITIES PLC-ORD",
     "symbol": "MCKAF"
    },
    {
     "description": "JADE LEADER CORP",
     "symbol": "MCKRF"
    },
    {
     "description": "MORSES CLUB PLC",
     "symbol": "MCLBF"
    },
    {
     "description": "MCLOUD TECHNOLOGIES CORP",
     "symbol": "MCLD"
    },
    {
     "description": "MCLOUD TECHNOLOGIES -27",
     "symbol": "MCLDW"
    },
    {
     "description": "MADISON COVERED CALL & EQUIT",
     "symbol": "MCN"
    },
    {
     "description": "MUCINNO HOLDING INC",
     "symbol": "MCNO"
    },
    {
     "description": "MOODY'S CORP",
     "symbol": "MCO"
    },
    {
     "description": "MARIJUANA COMPANY OF AMERICA",
     "symbol": "MCOA"
    },
    {
     "description": "MULTICHOICE GROUP LTD",
     "symbol": "MCOIF"
    },
    {
     "description": "MOUNT CARMEL PUBLIC UTIL CO",
     "symbol": "MCPB"
    },
    {
     "description": "MIDLAND CAPITAL HOLDINGS CRP",
     "symbol": "MCPH"
    },
    {
     "description": "MMC CORP BHD",
     "symbol": "MCPNF"
    },
    {
     "description": "MACQUARIE GROUP LTD",
     "symbol": "MCQEF"
    },
    {
     "description": "MFS CHARTER INCOME TRUST",
     "symbol": "MCR"
    },
    {
     "description": "MCRAE INDUSTRIES  -CL A",
     "symbol": "MCRAA"
    },
    {
     "description": "MCRAE INDUSTRIES INC-CL B",
     "symbol": "MCRAB"
    },
    {
     "description": "SERES THERAPEUTICS INC",
     "symbol": "MCRB"
    },
    {
     "description": "METALS CREEK RESOURCES CORP",
     "symbol": "MCREF"
    },
    {
     "description": "MONARCH CASINO & RESORT INC",
     "symbol": "MCRI"
    },
    {
     "description": "MICRO-MECHANICS HOLDINGS LTD",
     "symbol": "MCRNF"
    },
    {
     "description": "IQ HEDGE MACRO TRACKER ETF",
     "symbol": "MCRO"
    },
    {
     "description": "MICROPORT SCIENTIFIC CORP",
     "symbol": "MCRPF"
    },
    {
     "description": "MICROART INC",
     "symbol": "MCRT"
    },
    {
     "description": "MORGAN ADVANCED MATERIALS PL",
     "symbol": "MCRUF"
    },
    {
     "description": "MICRO-X LTD",
     "symbol": "MCRXF"
    },
    {
     "description": "MINCOR RESOURCES NL",
     "symbol": "MCRZF"
    },
    {
     "description": "MARCUS CORPORATION",
     "symbol": "MCS"
    },
    {
     "description": "METCASH LTD",
     "symbol": "MCSHF"
    },
    {
     "description": "MEDICAL CONNECTIONS HOLDINGS",
     "symbol": "MCTH"
    },
    {
     "description": "MICROPLANET TECHNOLOGY CORP",
     "symbol": "MCTYF"
    },
    {
     "description": "MCOT PCL-NVDR",
     "symbol": "MCTZF"
    },
    {
     "description": "MEDICURE INC",
     "symbol": "MCUJF"
    },
    {
     "description": "MIND CURE HEALTH INC",
     "symbol": "MCURF"
    },
    {
     "description": "MEDICOVER AB - B SHARE",
     "symbol": "MCVEF"
    },
    {
     "description": "MEDICOVER AB-UNSP ADR",
     "symbol": "MCVEY"
    },
    {
     "description": "MILL CITY VENTURES III LTD",
     "symbol": "MCVT"
    },
    {
     "description": "MISTER CAR WASH INC",
     "symbol": "MCW"
    },
    {
     "description": "MERCURY GENERAL CORP",
     "symbol": "MCY"
    },
    {
     "description": "MAD CATZ INTERACTIVE INC",
     "symbol": "MCZAF"
    },
    {
     "description": "MEDNAX INC",
     "symbol": "MD"
    },
    {
     "description": "MDA LTD",
     "symbol": "MDALF"
    },
    {
     "description": "DAVI LUXURY BRAND GROUP INC",
     "symbol": "MDAV"
    },
    {
     "description": "MEDIA WAY CORP",
     "symbol": "MDAW"
    },
    {
     "description": "MONGODB INC",
     "symbol": "MDB"
    },
    {
     "description": "MEDLAB CLINICAL LTD",
     "symbol": "MDBBF"
    },
    {
     "description": "MEDIBIO LTD",
     "symbol": "MDBIF"
    },
    {
     "description": "MEDIBANK PRIVATE LTD-UNS ADR",
     "symbol": "MDBKY"
    },
    {
     "description": "MEDIBANK PRIVATE LTD",
     "symbol": "MDBPF"
    },
    {
     "description": "MASTER DISTRIBUTION SYSTEMS",
     "symbol": "MDBS"
    },
    {
     "description": "MDC HOLDINGS INC",
     "symbol": "MDC"
    },
    {
     "description": "MEDICAL CARE TECHNOLOGIES",
     "symbol": "MDCE"
    },
    {
     "description": "MEDIQON GROUP AG",
     "symbol": "MDCKF"
    },
    {
     "description": "MEDINCELL SA",
     "symbol": "MDCLF"
    },
    {
     "description": "MEDICAN ENTERPRISES INC",
     "symbol": "MDCN"
    },
    {
     "description": "VICTORYSHARES THB MID ESG",
     "symbol": "MDCP"
    },
    {
     "description": "MEDIA DO CO LTD",
     "symbol": "MDDCF"
    },
    {
     "description": "MDM GROUP INC",
     "symbol": "MDDM"
    },
    {
     "description": "MERIDIAN ENERGY LTD",
     "symbol": "MDDNF"
    },
    {
     "description": "MEDICAL DEVELOPMENTS INTERNA",
     "symbol": "MDDVF"
    },
    {
     "description": "MEDIA 100 INC",
     "symbol": "MDEA"
    },
    {
     "description": "FIRST TRUST INDXX MEDDEV",
     "symbol": "MDEV"
    },
    {
     "description": "MELCO INTERNATIONAL DEVELOP.",
     "symbol": "MDEVF"
    },
    {
     "description": "MELCO INTERNATIONAL-UNS ADR",
     "symbol": "MDEVY"
    },
    {
     "description": "MADISON TECHNOLOGIES INC",
     "symbol": "MDEX"
    },
    {
     "description": "MEDIFORCE INC",
     "symbol": "MDFC"
    },
    {
     "description": "MEDIFOCUS INC",
     "symbol": "MDFZF"
    },
    {
     "description": "MEDIAG3 INC",
     "symbol": "MDGC"
    },
    {
     "description": "MEDIGENE AG",
     "symbol": "MDGEF"
    },
    {
     "description": "MEDIA AND GAMES INVEST SE",
     "symbol": "MDGIF"
    },
    {
     "description": "MADRIGAL PHARMACEUTICALS INC",
     "symbol": "MDGL"
    },
    {
     "description": "MEDGROUP INC\/CALIF",
     "symbol": "MDGP"
    },
    {
     "description": "MEDIGUS LTD - SPON ADR",
     "symbol": "MDGS"
    },
    {
     "description": "MEDIGUS LTD - SPON ADR-CW23",
     "symbol": "MDGSW"
    },
    {
     "description": "MDH ACQUISITION CORP -CL A",
     "symbol": "MDH"
    },
    {
     "description": "MDH ACQUISITION CORP",
     "symbol": "MDH.U"
    },
    {
     "description": "MDH ACQ CL A -CW28",
     "symbol": "MDH.WS"
    },
    {
     "description": "MEDIACO HOLDING INC-CL A",
     "symbol": "MDIA"
    },
    {
     "description": "MEDIOBANCA SPA",
     "symbol": "MDIBF"
    },
    {
     "description": "MEDIOBANCA SPA-UNSPONSOR ADR",
     "symbol": "MDIBY"
    },
    {
     "description": "MIDLAND IC&I LTD",
     "symbol": "MDICF"
    },
    {
     "description": "MODEC INC",
     "symbol": "MDIKF"
    },
    {
     "description": "MODEC INC-ADR",
     "symbol": "MDIKY"
    },
    {
     "description": "MEDGEN INC",
     "symbol": "MDIN"
    },
    {
     "description": "MEDITE CANCER DIAGNOSTICS IN",
     "symbol": "MDIT"
    },
    {
     "description": "FT MULTI-ASSET DIVERS INC",
     "symbol": "MDIV"
    },
    {
     "description": "MDJM LTD",
     "symbol": "MDJH"
    },
    {
     "description": "MEDIKALOKA HERMINA TBK PT",
     "symbol": "MDKLF"
    },
    {
     "description": "MDECHEM INC",
     "symbol": "MDKM"
    },
    {
     "description": "MEDICAL INTERNATIONAL TECHNO",
     "symbol": "MDLH"
    },
    {
     "description": "MEDLEY MANAGEMENT INC - A",
     "symbol": "MDLM"
    },
    {
     "description": "MONDELEZ INTERNATIONAL INC-A",
     "symbol": "MDLZ"
    },
    {
     "description": "MEDINAH MINERALS INC",
     "symbol": "MDMN"
    },
    {
     "description": "MDM PERMIAN INC",
     "symbol": "MDMP"
    },
    {
     "description": "MEDICENNA THERAPEUTICS CORP",
     "symbol": "MDNA"
    },
    {
     "description": "MCDONALD'S HOLDINGS CO JAPAN",
     "symbol": "MDNDF"
    },
    {
     "description": "MIDNIGHT SUN MINING CORP",
     "symbol": "MDNGF"
    },
    {
     "description": "MAIDEN LANE JEWELRY LTD",
     "symbol": "MDNL"
    },
    {
     "description": "MEDNOW INC-A",
     "symbol": "MDNWF"
    },
    {
     "description": "MANDOM CORP",
     "symbol": "MDOMF"
    },
    {
     "description": "MAISONS DU MONDE SA",
     "symbol": "MDOUF"
    },
    {
     "description": "MADISON PACIFIC PROP INC-B",
     "symbol": "MDPCF"
    },
    {
     "description": "MEDPEER INC",
     "symbol": "MDPEF"
    },
    {
     "description": "MD PICTURES TBK PT",
     "symbol": "MDPTF"
    },
    {
     "description": "MEDRA CORP",
     "symbol": "MDRA"
    },
    {
     "description": "MANDARAKE INC",
     "symbol": "MDRKF"
    },
    {
     "description": "MODERN MOBILITY AIDS INC",
     "symbol": "MDRM"
    },
    {
     "description": "MODERN PLANT BASED FOODS INC",
     "symbol": "MDRNF"
    },
    {
     "description": "MEDALIST DIVERSIFIED REIT IN",
     "symbol": "MDRR"
    },
    {
     "description": "MEDALIST DIVERSIFIED",
     "symbol": "MDRRP"
    },
    {
     "description": "MEDARTIS HOLDING AG",
     "symbol": "MDRSF"
    },
    {
     "description": "ALLSCRIPTS HEALTHCARE SOLUTI",
     "symbol": "MDRX"
    },
    {
     "description": "MATRIX DENTURE SYSTEMS INTL",
     "symbol": "MDSI"
    },
    {
     "description": "MEDUSA MINING LTD",
     "symbol": "MDSMF"
    },
    {
     "description": "MINSUD RESOURCES CORP",
     "symbol": "MDSQF"
    },
    {
     "description": "MEDTRONIC PLC",
     "symbol": "MDT"
    },
    {
     "description": "MEDIA TECHNOLOGIES INC",
     "symbol": "MDTC"
    },
    {
     "description": "MEDIATEK INC",
     "symbol": "MDTKF"
    },
    {
     "description": "MEDITERRANEAN TOWERS LTD",
     "symbol": "MDTWF"
    },
    {
     "description": "MDU RESOURCES GROUP INC",
     "symbol": "MDU"
    },
    {
     "description": "MODIV INC - CLASS C",
     "symbol": "MDV"
    },
    {
     "description": "MODIV INC",
     "symbol": "MDV.PRA"
    },
    {
     "description": "MEDAVAIL HOLDINGS INC",
     "symbol": "MDVL"
    },
    {
     "description": "MIDDLEBURY NATIONAL CORP",
     "symbol": "MDVT"
    },
    {
     "description": "MEDIWOUND LTD",
     "symbol": "MDWD"
    },
    {
     "description": "MDWERKS INC",
     "symbol": "MDWK"
    },
    {
     "description": "MIDWEST HOLDING INC",
     "symbol": "MDWT"
    },
    {
     "description": "MIMEDX GROUP INC",
     "symbol": "MDXG"
    },
    {
     "description": "MDXHEALTH SA-ADR",
     "symbol": "MDXH"
    },
    {
     "description": "MEDX HEALTH CORP",
     "symbol": "MDXHF"
    },
    {
     "description": "MEDIXALL GROUP INC",
     "symbol": "MDXL"
    },
    {
     "description": "MEDEX INC",
     "symbol": "MDXX"
    },
    {
     "description": "SPDR S&P MIDCAP 400 ETF TRST",
     "symbol": "MDY"
    },
    {
     "description": "SPDR S&P 400 MID CAPGROWTH E",
     "symbol": "MDYG"
    },
    {
     "description": "SPDR S&P 400 MID CAP VALUE E",
     "symbol": "MDYV"
    },
    {
     "description": "23ANDME HOLDING CO -CLASS A",
     "symbol": "ME"
    },
    {
     "description": "MERCURY ECOMMERCE ACQUISIT-A",
     "symbol": "MEAC"
    },
    {
     "description": "MERCURY ECOMMERCE ACQUISITIO",
     "symbol": "MEACU"
    },
    {
     "description": "MERCURY ECOMMERCE ACQ -CW23",
     "symbol": "MEACW"
    },
    {
     "description": "NABATI FOODS GLOBAL INC",
     "symbol": "MEALF"
    },
    {
     "description": "BLACKROCK SHORT MATURITY MUN",
     "symbol": "MEAR"
    },
    {
     "description": "MONETA GOLD INC",
     "symbol": "MEAUF"
    },
    {
     "description": "MEBUKI FINANCIAL GROUP INC",
     "symbol": "MEBUF"
    },
    {
     "description": "MAYVILLE ENGINEERING CO INC",
     "symbol": "MEC"
    },
    {
     "description": "MEC CO LTD",
     "symbol": "MECGF"
    },
    {
     "description": "MENICON CO LTD - UNSP ADR",
     "symbol": "MECNY"
    },
    {
     "description": "MDF COMMERCE INC",
     "symbol": "MECVF"
    },
    {
     "description": "MEDIFAST INC",
     "symbol": "MED"
    },
    {
     "description": "MEDARO MINING CORP",
     "symbol": "MEDAF"
    },
    {
     "description": "MEDICAL IMAGING CORP",
     "symbol": "MEDD"
    },
    {
     "description": "MEDACTA GROUP SA",
     "symbol": "MEDGF"
    },
    {
     "description": "MEDX HOLDINGS INC",
     "symbol": "MEDH"
    },
    {
     "description": "MEDIPHARM LABS CORP",
     "symbol": "MEDIF"
    },
    {
     "description": "MEDIOS AG",
     "symbol": "MEDOF"
    },
    {
     "description": "MEDPACE HOLDINGS INC",
     "symbol": "MEDP"
    },
    {
     "description": "TRXADE HEALTH INC",
     "symbol": "MEDS"
    },
    {
     "description": "MEDIATECHNICS CORP",
     "symbol": "MEDT"
    },
    {
     "description": "MEDEXUS PHARMACEUTICALS INC",
     "symbol": "MEDXF"
    },
    {
     "description": "MIDWEST ENERGY EMISSIONS COR",
     "symbol": "MEEC"
    },
    {
     "description": "MONTROSE ENVIRONMENTAL GROUP",
     "symbol": "MEG"
    },
    {
     "description": "MEGADO GOLD LTD",
     "symbol": "MEGDF"
    },
    {
     "description": "MEG ENERGY CORP",
     "symbol": "MEGEF"
    },
    {
     "description": "MEGGITT PLC",
     "symbol": "MEGGF"
    },
    {
     "description": "MEGGITT PLC-UNSPON ADR",
     "symbol": "MEGGY"
    },
    {
     "description": "MW INVESTMENT HOLDING GROUP",
     "symbol": "MEGH"
    },
    {
     "description": "MAINSTAY CBRE GLBL INFR MEGA",
     "symbol": "MEGI"
    },
    {
     "description": "MEGACHIPS CORP",
     "symbol": "MEGPF"
    },
    {
     "description": "METHODE ELECTRONICS INC",
     "symbol": "MEI"
    },
    {
     "description": "ISHARES MSCI EM IMI ESG SCRN",
     "symbol": "MEIEF"
    },
    {
     "description": "MEIJI ELECTRIC INDUSTRIES CO",
     "symbol": "MEIJF"
    },
    {
     "description": "METHES ENERGIES INTERNATIONA",
     "symbol": "MEIL"
    },
    {
     "description": "MEI PHARMA INC",
     "symbol": "MEIP"
    },
    {
     "description": "MEITEC CORP",
     "symbol": "MEITF"
    },
    {
     "description": "MEITU INC",
     "symbol": "MEIUF"
    },
    {
     "description": "MEITU INC- UNSP ADR",
     "symbol": "MEIUY"
    },
    {
     "description": "MERCIALYS",
     "symbol": "MEIYF"
    },
    {
     "description": "MEIJI HOLDINGS CO LTD",
     "symbol": "MEJHF"
    },
    {
     "description": "MEIJI HOLDINGS CO-UNSP ADR",
     "symbol": "MEJHY"
    },
    {
     "description": "MELI KASZEK PIONEER CORP-A",
     "symbol": "MEKA"
    },
    {
     "description": "MIE KOTSU GROUP HOLDINGS INC",
     "symbol": "MEKTF"
    },
    {
     "description": "MERCADOLIBRE INC",
     "symbol": "MELI"
    },
    {
     "description": "ROUNDHILL MEME",
     "symbol": "MEME"
    },
    {
     "description": "MIRACLE ENTERTAINMENT INC",
     "symbol": "MEMI"
    },
    {
     "description": "MENDOCINO BREWING CO INC",
     "symbol": "MENB"
    },
    {
     "description": "MILLENNIUM ENERGY CORP",
     "symbol": "MENC"
    },
    {
     "description": "MENE INC",
     "symbol": "MENEF"
    },
    {
     "description": "MOBILIZED ENTERTAINMENT INC",
     "symbol": "MENI"
    },
    {
     "description": "ADVISORSHARES NORTH SQUARE M",
     "symbol": "MENV"
    },
    {
     "description": "MEMEX INC",
     "symbol": "MENXF"
    },
    {
     "description": "MINORITY EQUALITY OPPORTUN-A",
     "symbol": "MEOA"
    },
    {
     "description": "MELBANA ENERGY LTD",
     "symbol": "MEOAF"
    },
    {
     "description": "MINORITY EQUALITY OPPORTUNIT",
     "symbol": "MEOAU"
    },
    {
     "description": "MINORITY EQUALITY OPPO -CW23",
     "symbol": "MEOAW"
    },
    {
     "description": "MESOBLAST LTD",
     "symbol": "MEOBF"
    },
    {
     "description": "METHANEX CORP",
     "symbol": "MEOH"
    },
    {
     "description": "MEDIPAL HOLDINGS CORP",
     "symbol": "MEPDF"
    },
    {
     "description": "ME RENEWABLE POWER CORP",
     "symbol": "MEPW"
    },
    {
     "description": "MAINSTREET EQUITY CORP",
     "symbol": "MEQYF"
    },
    {
     "description": "BANK OF AMERICA CORP",
     "symbol": "MER.PRK"
    },
    {
     "description": "MERCER INTERNATIONAL INC",
     "symbol": "MERC"
    },
    {
     "description": "MERGER MINES CORP",
     "symbol": "MERG"
    },
    {
     "description": "MERRIMAN HOLDINGS INC",
     "symbol": "MERR"
    },
    {
     "description": "METROPOLITAN ROYALTY CORP",
     "symbol": "MERT"
    },
    {
     "description": "MESA AIR GROUP INC",
     "symbol": "MESA"
    },
    {
     "description": "MESOBLAST LTD- SPON ADR",
     "symbol": "MESO"
    },
    {
     "description": "METLIFE INC",
     "symbol": "MET"
    },
    {
     "description": "METLIFE INC",
     "symbol": "MET.PRA"
    },
    {
     "description": "METLIFE INC",
     "symbol": "MET.PRE"
    },
    {
     "description": "METLIFE INC",
     "symbol": "MET.PRF"
    },
    {
     "description": "RAMACO RESOURCES INC",
     "symbol": "METC"
    },
    {
     "description": "RAMACO RESOURCES INC",
     "symbol": "METCL"
    },
    {
     "description": "METEORIC RESOURCES NL",
     "symbol": "METOF"
    },
    {
     "description": "ROUNDHILL BALL METAVERSE ETF",
     "symbol": "METV"
    },
    {
     "description": "METEN HOLDING GROUP LTD",
     "symbol": "METX"
    },
    {
     "description": "METEN HOLDING GROUP LTD",
     "symbol": "METXW"
    },
    {
     "description": "INVESCO MSCI EUROPE",
     "symbol": "MEUEF"
    },
    {
     "description": "MEXICAN GOLD MINING CORP",
     "symbol": "MEXGF"
    },
    {
     "description": "DIREXION DLY MEXICO BULL 3X",
     "symbol": "MEXX"
    },
    {
     "description": "MEDCO ENERGI INTERNA-UNS ADR",
     "symbol": "MEYYY"
    },
    {
     "description": "MISSFRESH LTD-ADR",
     "symbol": "MF"
    },
    {
     "description": "MFA FINANCIAL INC",
     "symbol": "MFA"
    },
    {
     "description": "MFA FINANCIAL INC",
     "symbol": "MFA.PRB"
    },
    {
     "description": "MFA FINANCIAL INC",
     "symbol": "MFA.PRC"
    },
    {
     "description": "M & F BANCORP INC",
     "symbol": "MFBP"
    },
    {
     "description": "MANULIFE FINANCIAL CORP",
     "symbol": "MFC"
    },
    {
     "description": "MICROWAVE FILTER CO INC",
     "symbol": "MFCO"
    },
    {
     "description": "MEDICAL FACILITIES CORP",
     "symbol": "MFCSF"
    },
    {
     "description": "MACQUARIE\/FT GL INT\/UT DV IN",
     "symbol": "MFD"
    },
    {
     "description": "MUTUAL FEDERAL BANCORP INC",
     "symbol": "MFDB"
    },
    {
     "description": "PIMCO RAFI DYNAMIC MULTI-FAC",
     "symbol": "MFDX"
    },
    {
     "description": "PIMCO RAFI DYNAMIC MULTI-FAC",
     "symbol": "MFEM"
    },
    {
     "description": "MIZUHO FINANCIAL GROUP-ADR",
     "symbol": "MFG"
    },
    {
     "description": "MAYFAIR GOLD CORP",
     "symbol": "MFGCF"
    },
    {
     "description": "MAINFREIGHT LTD",
     "symbol": "MFGHF"
    },
    {
     "description": "MERCHANTS FINANCIAL GROUP IN",
     "symbol": "MFGI"
    },
    {
     "description": "MICRO FOCUS INTL-SPN ADR",
     "symbol": "MFGP"
    },
    {
     "description": "MERCURITY FINTECH HOLDING IN",
     "symbol": "MFH"
    },
    {
     "description": "MEDALLION FINANCIAL CORP",
     "symbol": "MFIN"
    },
    {
     "description": "MITSUI FUDOSAN LOGISTICS PAR",
     "symbol": "MFLPF"
    },
    {
     "description": "FIRST TRUST EXCHANGE-TRADED",
     "symbol": "MFLX"
    },
    {
     "description": "LYXOR MSCI NEW ENERGY ESG FI",
     "symbol": "MFLYF"
    },
    {
     "description": "MFS MUNICIPAL INCOME TRUST",
     "symbol": "MFM"
    },
    {
     "description": "INTERNATIONAL ICONIC GOLD EX",
     "symbol": "MFMLF"
    },
    {
     "description": "MOBIVITY HOLDINGS CORP",
     "symbol": "MFON"
    },
    {
     "description": "MEGAFON-REG S GDR",
     "symbol": "MFOYY"
    },
    {
     "description": "MFEC PUBLIC CO LTD-NVDR",
     "symbol": "MFPBF"
    },
    {
     "description": "MINERA FRISCO SAB DE CV-A1",
     "symbol": "MFRVF"
    },
    {
     "description": "MEDIFIRST SOLUTIONS INC",
     "symbol": "MFST"
    },
    {
     "description": "MINDFUL CONSERVATIVE ETF",
     "symbol": "MFUL"
    },
    {
     "description": "PIMCO RAFI DYNAMIC MULTI-FAC",
     "symbol": "MFUS"
    },
    {
     "description": "MFS SPECIAL VALUE TRUST",
     "symbol": "MFV"
    },
    {
     "description": "MISTRAS GROUP INC",
     "symbol": "MG"
    },
    {
     "description": "MAGNA INTERNATIONAL INC",
     "symbol": "MGA"
    },
    {
     "description": "MORINAGA & CO LTD",
     "symbol": "MGAAF"
    },
    {
     "description": "MEGA URANIUM LTD",
     "symbol": "MGAFF"
    },
    {
     "description": "MORTGAGE OIL CORP",
     "symbol": "MGAG"
    },
    {
     "description": "MEGAWORLD CORP",
     "symbol": "MGAWF"
    },
    {
     "description": "MEGAWORLD CORP-USP ADR",
     "symbol": "MGAWY"
    },
    {
     "description": "VANGUARD MEGA CAP ETF",
     "symbol": "MGC"
    },
    {
     "description": "MGC PHARMACEUTICALS LTD",
     "symbol": "MGCLF"
    },
    {
     "description": "MGC VENTURES INC",
     "symbol": "MGCV"
    },
    {
     "description": "MICHELIN (CGDE)",
     "symbol": "MGDDF"
    },
    {
     "description": "MICHELIN (CGDE)-UNSPON ADR",
     "symbol": "MGDDY"
    },
    {
     "description": "MARATHON GOLD CORP",
     "symbol": "MGDPF"
    },
    {
     "description": "MGE ENERGY INC",
     "symbol": "MGEE"
    },
    {
     "description": "MFS GOVT MARKETS INC TRUST",
     "symbol": "MGF"
    },
    {
     "description": "MAGFORCE AG-BEAR",
     "symbol": "MGFRF"
    },
    {
     "description": "MONARCH GULF EXPLORATION INC",
     "symbol": "MGFX"
    },
    {
     "description": "MAGICSTEM GROUP CORP",
     "symbol": "MGGI"
    },
    {
     "description": "MORINAGA MILK INDUSTRY CO",
     "symbol": "MGGNF"
    },
    {
     "description": "MINCO CAPITAL CORP",
     "symbol": "MGHCF"
    },
    {
     "description": "MORGAN GROUP HOLDING CO",
     "symbol": "MGHL"
    },
    {
     "description": "MERCURY NZ LTD",
     "symbol": "MGHTF"
    },
    {
     "description": "MONEYGRAM INTERNATIONAL INC",
     "symbol": "MGI"
    },
    {
     "description": "MAGIC SOFTWARE ENTERPRISES",
     "symbol": "MGIC"
    },
    {
     "description": "MAGNUM GOLDCORP INC",
     "symbol": "MGIDF"
    },
    {
     "description": "MAGNIT PJSC-SPON GDR 144A",
     "symbol": "MGJCL"
    },
    {
     "description": "MAGNIT PJSC",
     "symbol": "MGJNF"
    },
    {
     "description": "VANGUARD MEGA CAP GROWTH ETF",
     "symbol": "MGK"
    },
    {
     "description": "MARYGOLD COMPANIES INC\/THE",
     "symbol": "MGLD"
    },
    {
     "description": "MEDGOLD RESOURCES CORP",
     "symbol": "MGLDF"
    },
    {
     "description": "MAGELLAN ENERGY LTD",
     "symbol": "MGLG"
    },
    {
     "description": "MAGELLAN INDUSTRIES INC",
     "symbol": "MGLI"
    },
    {
     "description": "MAGELLAN FINANCIAL GROUP LTD",
     "symbol": "MGLLF"
    },
    {
     "description": "MEDIA GLOBO CORP\/THE",
     "symbol": "MGLO"
    },
    {
     "description": "MAGNA GOLD CORP",
     "symbol": "MGLQF"
    },
    {
     "description": "MAGAZINE LUIZA SA - UNSP ADR",
     "symbol": "MGLUY"
    },
    {
     "description": "MGM RESORTS INTERNATIONAL",
     "symbol": "MGM"
    },
    {
     "description": "METRO GLOBAL MEDIA INC",
     "symbol": "MGMA"
    },
    {
     "description": "MGM HOLDINGS INC-VTG A",
     "symbol": "MGMB"
    },
    {
     "description": "MAPLE GOLD MINES LTD",
     "symbol": "MGMLF"
    },
    {
     "description": "MAGNITOGORSK-SPON GDR 144A",
     "symbol": "MGMOL"
    },
    {
     "description": "BALLAST SMALL\/MID CAP ETF",
     "symbol": "MGMT"
    },
    {
     "description": "MAGNITE INC",
     "symbol": "MGNI"
    },
    {
     "description": "MEGANET CORP",
     "symbol": "MGNT"
    },
    {
     "description": "MACROGENICS INC",
     "symbol": "MGNX"
    },
    {
     "description": "MIGOM GLOBAL CORP",
     "symbol": "MGOM"
    },
    {
     "description": "MEGOLA INC",
     "symbol": "MGON"
    },
    {
     "description": "MGM GROWTH PROPERTIES LLC-A",
     "symbol": "MGP"
    },
    {
     "description": "MASON GRAPHITE INC",
     "symbol": "MGPHF"
    },
    {
     "description": "MGP INGREDIENTS INC",
     "symbol": "MGPI"
    },
    {
     "description": "MEGAPORT LTD",
     "symbol": "MGPPF"
    },
    {
     "description": "COVER TECHNOLOGIES INC",
     "symbol": "MGPRF"
    },
    {
     "description": "M&G PLC",
     "symbol": "MGPUF"
    },
    {
     "description": "AFFILIATED MANAGERS GROU",
     "symbol": "MGR"
    },
    {
     "description": "AFFILIATED MANAGERS GROU",
     "symbol": "MGRB"
    },
    {
     "description": "MCGRATH RENTCORP",
     "symbol": "MGRC"
    },
    {
     "description": "AFFILIATED MANAGERS GROU",
     "symbol": "MGRD"
    },
    {
     "description": "MAGMATIC RESOURCES LTD",
     "symbol": "MGRLF"
    },
    {
     "description": "MUSTGROW BIOLOGICS CORP",
     "symbol": "MGROF"
    },
    {
     "description": "MCGRATH LTD",
     "symbol": "MGRTF"
    },
    {
     "description": "MORGUARD REAL ESTATE-TR UTS",
     "symbol": "MGRUF"
    },
    {
     "description": "MAGENTA THERAPEUTICS INC",
     "symbol": "MGTA"
    },
    {
     "description": "MEGATECH CORP",
     "symbol": "MGTC"
    },
    {
     "description": "MGT CAPITAL INVESTMENTS INC",
     "symbol": "MGTI"
    },
    {
     "description": "MEIRAGTX HOLDINGS PLC",
     "symbol": "MGTX"
    },
    {
     "description": "MACQUARIE GLOBAL INFR TOT RT",
     "symbol": "MGU"
    },
    {
     "description": "MAGNUM MINING AND EXPLORATIO",
     "symbol": "MGUFF"
    },
    {
     "description": "MOGUL ENERGY INTERNATIONAL I",
     "symbol": "MGUY"
    },
    {
     "description": "VANGUARD MEGA CAP VALUE ETF",
     "symbol": "MGV"
    },
    {
     "description": "MUSGRAVE MINERALS LTD",
     "symbol": "MGVMF"
    },
    {
     "description": "MAPLE LEAF GREEN WORLD INC",
     "symbol": "MGWFF"
    },
    {
     "description": "MGX MINERALS INC",
     "symbol": "MGXMF"
    },
    {
     "description": "MAGNOLIA OIL & GAS CORP - A",
     "symbol": "MGY"
    },
    {
     "description": "MOL HUNGARIAN OIL-SP ADR",
     "symbol": "MGYOY"
    },
    {
     "description": "MAGYAR BANCORP INC",
     "symbol": "MGYR"
    },
    {
     "description": "MAIDEN HOLDING LTD",
     "symbol": "MH.PRA"
    },
    {
     "description": "MAIDEN HOLDING LTD",
     "symbol": "MH.PRC"
    },
    {
     "description": "MAIDEN HOLDING LTD",
     "symbol": "MH.PRD"
    },
    {
     "description": "MOTHERCARE PLC",
     "symbol": "MHCRF"
    },
    {
     "description": "BLACKROCK MUNIHOLDINGS FUND",
     "symbol": "MHD"
    },
    {
     "description": "WESTERN ASSET MUNICIPAL HIGH",
     "symbol": "MHF"
    },
    {
     "description": "MIDNIGHT HOLDINGS GROUP INC",
     "symbol": "MHGI"
    },
    {
     "description": "MERITAGE HOSPITALITY GROUP",
     "symbol": "MHGU"
    },
    {
     "description": "Meritage Hospitality Group Inc",
     "symbol": "MHGUP"
    },
    {
     "description": "MOWI ASA - SPON ADR",
     "symbol": "MHGVY"
    },
    {
     "description": "MASTECH DIGITAL INC",
     "symbol": "MHH"
    },
    {
     "description": "MHHC ENTERPRISES INC",
     "symbol": "MHHC"
    },
    {
     "description": "PIONEER MUNI HIGH INC TR",
     "symbol": "MHI"
    },
    {
     "description": "MINERAL HILL INDUSTRIES LTD",
     "symbol": "MHIFF"
    },
    {
     "description": "INVESQUE INC",
     "symbol": "MHIVF"
    },
    {
     "description": "MOHAWK INDUSTRIES INC",
     "symbol": "MHK"
    },
    {
     "description": "MAIDEN HOLDING LTD",
     "symbol": "MHLA"
    },
    {
     "description": "MAIDEN HOLDINGS LTD",
     "symbol": "MHLD"
    },
    {
     "description": "BLACKROCK MUNIHOLDINGS NY QU",
     "symbol": "MHN"
    },
    {
     "description": "MAIDEN HOLDINGS NA LTD",
     "symbol": "MHNC"
    },
    {
     "description": "MENHADEN RESOURCE EFFICIENCY",
     "symbol": "MHNLF"
    },
    {
     "description": "M\/I HOMES INC",
     "symbol": "MHO"
    },
    {
     "description": "MANUFACTURED HOUSING PROPERT",
     "symbol": "MHPC"
    },
    {
     "description": "MHP SE",
     "symbol": "MHPSY"
    },
    {
     "description": "MEGACABLE HOLDINGS-CPO",
     "symbol": "MHSDF"
    },
    {
     "description": "MANHATTAN SCIENTIFICS INC",
     "symbol": "MHTX"
    },
    {
     "description": "MANHATTAN CORP LTD",
     "symbol": "MHTZF"
    },
    {
     "description": "MEIHUA INTERNATIONAL MEDICAL",
     "symbol": "MHUA"
    },
    {
     "description": "MINEHUB TECHNOLOGIES INC",
     "symbol": "MHUBF"
    },
    {
     "description": "MITSUBISHI HEAVY INDUSTRIES",
     "symbol": "MHVYF"
    },
    {
     "description": "MANTHEY REDMOND CORP",
     "symbol": "MHYR"
    },
    {
     "description": "MACQUARIE INFRASTRUCTURE HOL",
     "symbol": "MIC"
    },
    {
     "description": "MILLICOM INTL CELLULAR-SDR",
     "symbol": "MICCF"
    },
    {
     "description": "MINT INCOME FUND-TR UTS",
     "symbol": "MICFF"
    },
    {
     "description": "MYCRONIC AB",
     "symbol": "MICLF"
    },
    {
     "description": "MICRON SOLUTIONS INC",
     "symbol": "MICR"
    },
    {
     "description": "MICT INC",
     "symbol": "MICT"
    },
    {
     "description": "AMERICAN CENTURY MID CAP GRO",
     "symbol": "MID"
    },
    {
     "description": "MIDDLEBY CORP",
     "symbol": "MIDD"
    },
    {
     "description": "XTRACKERS S&P MIDCAP 400 ESG",
     "symbol": "MIDE"
    },
    {
     "description": "ISHARES MSCI USA MID-CAP MUL",
     "symbol": "MIDF"
    },
    {
     "description": "MIDLAND EXPLORATION INC",
     "symbol": "MIDLF"
    },
    {
     "description": "DIREXION DLY MID CAP BULL 3X",
     "symbol": "MIDU"
    },
    {
     "description": "Direxion Daily Mid Cap Bear 3X Shares New",
     "symbol": "MIDZ"
    },
    {
     "description": "MITSUBISHI ELECTRIC CORP",
     "symbol": "MIELF"
    },
    {
     "description": "MITSUBISHI ELECTRIC-UNSP ADR",
     "symbol": "MIELY"
    },
    {
     "description": "MITSUI E&S HOLDINGS CO LTD",
     "symbol": "MIESF"
    },
    {
     "description": "MITSUI ENGINEER & SHIPBU-ADR",
     "symbol": "MIESY"
    },
    {
     "description": "MIFFLINBURG BANCORP INC",
     "symbol": "MIFF"
    },
    {
     "description": "MILLENNIUM FOOD-TECH-LIMITED",
     "symbol": "MIFTF"
    },
    {
     "description": "VANECK MOODY'S ANALYTICS IG",
     "symbol": "MIG"
    },
    {
     "description": "MAWSON INFRASTRUCTURE GROUP",
     "symbol": "MIGI"
    },
    {
     "description": "MISC BHD",
     "symbol": "MIHDF"
    },
    {
     "description": "MONTAGUE INTERNATIONAL HOLDI",
     "symbol": "MIHL"
    },
    {
     "description": "MIKE THE PIKE PRODUCTIONS",
     "symbol": "MIKP"
    },
    {
     "description": "MILLENNIUM SUSTAINABLE VENTU",
     "symbol": "MILC"
    },
    {
     "description": "METROMILE INC",
     "symbol": "MILE"
    },
    {
     "description": "METROMILE INC-CW25",
     "symbol": "MILEW"
    },
    {
     "description": "GLOBAL X MILLENNIAL CONSUMER",
     "symbol": "MILN"
    },
    {
     "description": "MOBILICOM LTD\/AUSTRALIA",
     "symbol": "MILOF"
    },
    {
     "description": "MIMECAST LTD",
     "symbol": "MIME"
    },
    {
     "description": "MIMI'S ROCK CORP",
     "symbol": "MIMNF"
    },
    {
     "description": "AIRSPAN NETWORKS HOLDINGS IN",
     "symbol": "MIMO"
    },
    {
     "description": "AIRSPAN NETWORKS HOLDINGS-CW",
     "symbol": "MIMO.WS"
    },
    {
     "description": "Airspan Networks Holdings Inc",
     "symbol": "MIMO.WSA"
    },
    {
     "description": "Airspan Networks Holdings Inc",
     "symbol": "MIMO.WSB"
    },
    {
     "description": "Airspan Networks Holdings Inc",
     "symbol": "MIMO.WSC"
    },
    {
     "description": "MITSUBISHI MATERIALS CORP",
     "symbol": "MIMTF"
    },
    {
     "description": "NIGHTHAWK GOLD CORP",
     "symbol": "MIMZF"
    },
    {
     "description": "MFS INTERMEDIATE INC TRUST",
     "symbol": "MIN"
    },
    {
     "description": "ADVSHRS NEWFLEET MULTSEC INC",
     "symbol": "MINC"
    },
    {
     "description": "MIND TECHNOLOGY INC",
     "symbol": "MIND"
    },
    {
     "description": "MIND TECHNOLOGY INC",
     "symbol": "MINDP"
    },
    {
     "description": "MINERCO INC",
     "symbol": "MINE"
    },
    {
     "description": "MINIM INC",
     "symbol": "MINM"
    },
    {
     "description": "MAIRS & POWER MN MUNI BOND",
     "symbol": "MINN"
    },
    {
     "description": "PIMCO MUNICIPAL INCOME OPPOR",
     "symbol": "MINO"
    },
    {
     "description": "MINOR INTERNATIONAL PCL",
     "symbol": "MINOF"
    },
    {
     "description": "MINOR INTL PCL-CW23",
     "symbol": "MINRF"
    },
    {
     "description": "PIMCO ENHANCED SHORT MATURIT",
     "symbol": "MINT"
    },
    {
     "description": "EXCELSIOR MINING CORP -CW22",
     "symbol": "MINWF"
    },
    {
     "description": "MERCANTILE INVESTMENT TRUST",
     "symbol": "MINXF"
    },
    {
     "description": "PIONEER MUNI HIGH INC OPP",
     "symbol": "MIO"
    },
    {
     "description": "MILBON CO LTD",
     "symbol": "MIOFF"
    },
    {
     "description": "MINOR INTERNATIONAL PCL-NVDR",
     "symbol": "MIPCF"
    },
    {
     "description": "MIRION TECHNOLOGIES INC",
     "symbol": "MIR"
    },
    {
     "description": "MIRION TECHNOLOGIES INC-CW25",
     "symbol": "MIR.WS"
    },
    {
     "description": "MIRAI CORP",
     "symbol": "MIRAF"
    },
    {
     "description": "MEILLEURE HEALTH INTERNATION",
     "symbol": "MIRHF"
    },
    {
     "description": "MIRUM PHARMACEUTICALS INC",
     "symbol": "MIRM"
    },
    {
     "description": "MIROMATRIX MEDICAL INC",
     "symbol": "MIRO"
    },
    {
     "description": "SERRANO RESOURCES LTD",
     "symbol": "MIRXF"
    },
    {
     "description": "MILESTONE PHARMACEUTICALS IN",
     "symbol": "MIST"
    },
    {
     "description": "MINCO SILVER CORP",
     "symbol": "MISVF"
    },
    {
     "description": "MASON INDUSTRIAL TECHN-CL A",
     "symbol": "MIT"
    },
    {
     "description": "MASON INDUSTRIAL TECHNOLOGY",
     "symbol": "MIT.U"
    },
    {
     "description": "MASON INDUSTRIAL CL A -CW27",
     "symbol": "MIT.WS"
    },
    {
     "description": "COLISEUM ACQUISITION CORP-A",
     "symbol": "MITA"
    },
    {
     "description": "COLISEUM ACQUISITION CORP",
     "symbol": "MITAU"
    },
    {
     "description": "COLISEUM ACQUISITION A -CW28",
     "symbol": "MITAW"
    },
    {
     "description": "MEAT-TECH 3D LTD - ADR",
     "symbol": "MITC"
    },
    {
     "description": "MITSUBISHI ESTATE CO LTD",
     "symbol": "MITEF"
    },
    {
     "description": "MITSUBISHI ESTATE-UNSPON ADR",
     "symbol": "MITEY"
    },
    {
     "description": "MITIE GROUP PLC",
     "symbol": "MITFF"
    },
    {
     "description": "MITIE GROUP PLC-UNSP ADR",
     "symbol": "MITFY"
    },
    {
     "description": "MITESCO INC",
     "symbol": "MITI"
    },
    {
     "description": "MINT CORP\/THE",
     "symbol": "MITJF"
    },
    {
     "description": "MITEK SYSTEMS INC",
     "symbol": "MITK"
    },
    {
     "description": "MI TECHNOVATION BHD",
     "symbol": "MITNF"
    },
    {
     "description": "STEALTH BIOTHERAPEUTICS CORP",
     "symbol": "MITO"
    },
    {
     "description": "MITHRA PHARMACEUTICALS",
     "symbol": "MITPF"
    },
    {
     "description": "MOVING IMAGE TECHNOLOGIES IN",
     "symbol": "MITQ"
    },
    {
     "description": "MITSUI & CO LTD",
     "symbol": "MITSF"
    },
    {
     "description": "MITSUI & CO LTD-SPONS ADR",
     "symbol": "MITSY"
    },
    {
     "description": "AG MORTGAGE INVESTMENT TRUST",
     "symbol": "MITT"
    },
    {
     "description": "AG MORTGAGE INVEST TR",
     "symbol": "MITT.PRA"
    },
    {
     "description": "AG MORTGAGE INVEST TR",
     "symbol": "MITT.PRB"
    },
    {
     "description": "AG MORTGAGE INVEST TR",
     "symbol": "MITT.PRC"
    },
    {
     "description": "MITSUI CHEMICALS INC",
     "symbol": "MITUF"
    },
    {
     "description": "MITSUI CHEMICALS INC-UNS ADR",
     "symbol": "MITUY"
    },
    {
     "description": "MITSUBISHI HC CAPITAL INC",
     "symbol": "MIUFF"
    },
    {
     "description": "MITSUBISHI HC CAPITA-UNS ADR",
     "symbol": "MIUFY"
    },
    {
     "description": "MIURA CO LTD",
     "symbol": "MIURF"
    },
    {
     "description": "MIXI INC",
     "symbol": "MIXIF"
    },
    {
     "description": "MIX TELEMATICS LTD-SP ADR",
     "symbol": "MIXT"
    },
    {
     "description": "MIX 1 LIFE INC",
     "symbol": "MIXX"
    },
    {
     "description": "BLACKROCK MUNIYIELD MI QUALI",
     "symbol": "MIY"
    },
    {
     "description": "MIZUNO CORP",
     "symbol": "MIZUF"
    },
    {
     "description": "ETFMG ALTERNATIVE HARVEST",
     "symbol": "MJ"
    },
    {
     "description": "MJARDIN GROUP INC",
     "symbol": "MJARF"
    },
    {
     "description": "MAJOR DRILLING GROUP INTL",
     "symbol": "MJDLF"
    },
    {
     "description": "MOJO DATA SOLUTIONS INC",
     "symbol": "MJDS"
    },
    {
     "description": "MAJESTIC GOLD CORP",
     "symbol": "MJGCF"
    },
    {
     "description": "MJ HARVEST INC",
     "symbol": "MJHI"
    },
    {
     "description": "MIYAJI ENGINEERING GROUP INC",
     "symbol": "MJIEF"
    },
    {
     "description": "ETFMG 2X DLY INV ALT HARVEST",
     "symbol": "MJIN"
    },
    {
     "description": "ULTRACK SYSTEMS INC",
     "symbol": "MJLB"
    },
    {
     "description": "MEDICAL MARIJUANA INC",
     "symbol": "MJNA"
    },
    {
     "description": "MJ HOLDINGS INC",
     "symbol": "MJNE"
    },
    {
     "description": "MICRONICS JAPAN CO LTD",
     "symbol": "MJPNF"
    },
    {
     "description": "MAJESTIC HOLDCO LLC",
     "symbol": "MJSCZ"
    },
    {
     "description": "ETFMG U.S. ALTERNATIVE HARVE",
     "symbol": "MJUS"
    },
    {
     "description": "MAJIC WHEELS CORP",
     "symbol": "MJWL"
    },
    {
     "description": "NAKED WINES PLC-UNSP ADR",
     "symbol": "MJWNY"
    },
    {
     "description": "ETFMG 2X DAILY ALT HARVEST",
     "symbol": "MJXL"
    },
    {
     "description": "MCCORMICK & CO-NON VTG SHRS",
     "symbol": "MKC"
    },
    {
     "description": "MCCORMICK & CO INC VTG COM",
     "symbol": "MKC.V"
    },
    {
     "description": "MAKOTO CONSTRUCTION CO LTD",
     "symbol": "MKCOF"
    },
    {
     "description": "MOLECULAR DATA INC - ADR",
     "symbol": "MKD"
    },
    {
     "description": "MAUNA KEA TECHNOLOGIES",
     "symbol": "MKEAF"
    },
    {
     "description": "AS MERKO EHITUS",
     "symbol": "MKENF"
    },
    {
     "description": "MAKITA CORP",
     "symbol": "MKEWF"
    },
    {
     "description": "MARKFORGED HOLDING CORP",
     "symbol": "MKFG"
    },
    {
     "description": "ONE - CLASS A -CW25",
     "symbol": "MKFG.WS"
    },
    {
     "description": "MERCK KGAA",
     "symbol": "MKGAF"
    },
    {
     "description": "MAVERICK ENERGY GROUP LTD",
     "symbol": "MKGP"
    },
    {
     "description": "MCNB BANKS INC",
     "symbol": "MKIN"
    },
    {
     "description": "MERCK KGAA-SPONSORED ADR",
     "symbol": "MKKGY"
    },
    {
     "description": "MARIMEKKO OYJ",
     "symbol": "MKKOF"
    },
    {
     "description": "MARKEL CORP",
     "symbol": "MKL"
    },
    {
     "description": "M1 KLINIKEN AG",
     "symbol": "MKLNF"
    },
    {
     "description": "MURAKAMI CORP",
     "symbol": "MKMIF"
    },
    {
     "description": "MAKINO MILLING MACHINE CO",
     "symbol": "MKMLF"
    },
    {
     "description": "MKANGO RESOURCES LTD",
     "symbol": "MKNGF"
    },
    {
     "description": "MEIKO ELECTRONICS CO LTD",
     "symbol": "MKOEF"
    },
    {
     "description": "MEIKO TRANS CO LTD",
     "symbol": "MKOTF"
    },
    {
     "description": "MELKIOR RESOURCES INC",
     "symbol": "MKRIF"
    },
    {
     "description": "VALORA HOLDING AG-REG",
     "symbol": "MKRMF"
    },
    {
     "description": "MONKEY ROCK GROUP INC",
     "symbol": "MKRO"
    },
    {
     "description": "MANITOK ENERGY INC",
     "symbol": "MKRYF"
    },
    {
     "description": "MARKSMEN ENERGY INC",
     "symbol": "MKSEF"
    },
    {
     "description": "MKS INSTRUMENTS INC",
     "symbol": "MKSI"
    },
    {
     "description": "MARKET ACCESS CHINA MIN VAR",
     "symbol": "MKTAF"
    },
    {
     "description": "MAKITA CORP-SPONS ADR",
     "symbol": "MKTAY"
    },
    {
     "description": "DEEPMARKIT CORP",
     "symbol": "MKTDF"
    },
    {
     "description": "MARKETWISE INC",
     "symbol": "MKTW"
    },
    {
     "description": "MARKETWISE INC         -CW25",
     "symbol": "MKTWW"
    },
    {
     "description": "MARKETAXESS HOLDINGS INC",
     "symbol": "MKTX"
    },
    {
     "description": "DISTRICT METALS CORP",
     "symbol": "MKVNF"
    },
    {
     "description": "MARK DYNAMICS INDONESIA PT",
     "symbol": "MKYSF"
    },
    {
     "description": "MONEYLION INC",
     "symbol": "ML"
    },
    {
     "description": "MONEYLION INC      -CW27",
     "symbol": "ML.WS"
    },
    {
     "description": "MESA LABORATORIES INC",
     "symbol": "MLAB"
    },
    {
     "description": "MALACCA STRAITS ACQUISI-CL A",
     "symbol": "MLAC"
    },
    {
     "description": "MALACCA STRAITS ACQUISITION",
     "symbol": "MLACU"
    },
    {
     "description": "MALACCA STRAITS ACQUI -CW27",
     "symbol": "MLACW"
    },
    {
     "description": "MCLAREN TECHNOLOGY ACQ-A",
     "symbol": "MLAI"
    },
    {
     "description": "MCLAREN TECHNOLOGY ACQUISITI",
     "symbol": "MLAIU"
    },
    {
     "description": "MCLAREN TECHNOLOGY ACQ -CW23",
     "symbol": "MLAIW"
    },
    {
     "description": "WEBCENTRAL LTD",
     "symbol": "MLBEF"
    },
    {
     "description": "ML CAPITAL GROUP INC",
     "symbol": "MLCG"
    },
    {
     "description": "MELCO RESORTS & ENTERT-ADR",
     "symbol": "MLCO"
    },
    {
     "description": "MOUNTAIN CHINA RESORTS HLDG",
     "symbol": "MLCOF"
    },
    {
     "description": "MALACHITE INNOVATIONS INC",
     "symbol": "MLCT"
    },
    {
     "description": "MAJOR LEAGUE FOOTBALL INC",
     "symbol": "MLFB"
    },
    {
     "description": "MAPLE LEAF FOODS INC",
     "symbol": "MLFNF"
    },
    {
     "description": "MALAGA INC",
     "symbol": "MLGAF"
    },
    {
     "description": "M3 METALS CORP",
     "symbol": "MLGCF"
    },
    {
     "description": "MALAGA FINANCIAL CORP",
     "symbol": "MLGF"
    },
    {
     "description": "MITSUBISHI ESTATE LOGISTICS",
     "symbol": "MLGRF"
    },
    {
     "description": "M LINE HOLDINGS INC",
     "symbol": "MLHC"
    },
    {
     "description": "MUELLER INDUSTRIES INC",
     "symbol": "MLI"
    },
    {
     "description": "MERCATOR MINERALS LTD",
     "symbol": "MLKKF"
    },
    {
     "description": "MILLERKNOLL INC",
     "symbol": "MLKN"
    },
    {
     "description": "MEDLINK INTERNATIONAL-CL A",
     "symbol": "MLKNA"
    },
    {
     "description": "MOLECULAR PARTNERS AG",
     "symbol": "MLLCF"
    },
    {
     "description": "MULLEN GROUP LTD",
     "symbol": "MLLGF"
    },
    {
     "description": "MALIN CORP PLC",
     "symbol": "MLLNF"
    },
    {
     "description": "MEDALLION RESOURCES LTD",
     "symbol": "MLLOF"
    },
    {
     "description": "METALLURGICAL CORP OF CH-ADR",
     "symbol": "MLLUY"
    },
    {
     "description": "MARTIN MARIETTA MATERIALS",
     "symbol": "MLM"
    },
    {
     "description": "MILLENNIUM PRIME INC",
     "symbol": "MLMN"
    },
    {
     "description": "METALLICA MINERALS LTD",
     "symbol": "MLMZF"
    },
    {
     "description": "VANECK LONG MUNI ETF",
     "symbol": "MLN"
    },
    {
     "description": "MIDLAND HOLDINGS LTD",
     "symbol": "MLNHF"
    },
    {
     "description": "MERIDIANLINK INC",
     "symbol": "MLNK"
    },
    {
     "description": "MONTELLO RESOURCES LTD",
     "symbol": "MLORF"
    },
    {
     "description": "MAUI LAND & PINEAPPLE CO",
     "symbol": "MLP"
    },
    {
     "description": "GLOBAL X MLP ETF",
     "symbol": "MLPA"
    },
    {
     "description": "ETRACS ALERIAN INFRAST SER B",
     "symbol": "MLPB"
    },
    {
     "description": "MOLECULAR PHARMACOLOGY USA L",
     "symbol": "MLPH"
    },
    {
     "description": "MLP AG",
     "symbol": "MLPKF"
    },
    {
     "description": "MULTIPOLAR TECHNOLOGY TBK PT",
     "symbol": "MLPLF"
    },
    {
     "description": "MILLENNIAL PRECIOUS METALS C",
     "symbol": "MLPMF"
    },
    {
     "description": "CS S&P MLP INDEX ETN",
     "symbol": "MLPO"
    },
    {
     "description": "ETRACS 150% ALERIAN MLP ETN",
     "symbol": "MLPR"
    },
    {
     "description": "GLOBAL X MLP & ENERGY INFRAS",
     "symbol": "MLPX"
    },
    {
     "description": "MILLER INDUSTRIES INC\/TENN",
     "symbol": "MLR"
    },
    {
     "description": "MILLROCK RESOURCES INC",
     "symbol": "MLRKF"
    },
    {
     "description": "VK CO LTD-GDR 144A",
     "symbol": "MLRUY"
    },
    {
     "description": "VK CO LTD",
     "symbol": "MLRYY"
    },
    {
     "description": "MELROSE INDUSTRIES PLC",
     "symbol": "MLSPF"
    },
    {
     "description": "MILESTONE SCIENTIFIC INC",
     "symbol": "MLSS"
    },
    {
     "description": "MELROSE INDUSTRIES- UNSP ADR",
     "symbol": "MLSYY"
    },
    {
     "description": "MEDIRECT LATINO INC",
     "symbol": "MLTO"
    },
    {
     "description": "MOONLAKE IMMUNOTHERAPEUTICS",
     "symbol": "MLTX"
    },
    {
     "description": "MALAYAN UNITED INDUSTRIES BH",
     "symbol": "MLUIF"
    },
    {
     "description": "LYXOR EUR GOVERNMENT BD 3-5Y",
     "symbol": "MLUXF"
    },
    {
     "description": "LYXOR REFINITIV CORE COMM",
     "symbol": "MLUZF"
    },
    {
     "description": "MALVERN BANCORP INC",
     "symbol": "MLVF"
    },
    {
     "description": "METALS X LTD",
     "symbol": "MLXEF"
    },
    {
     "description": "MELEXIS NV",
     "symbol": "MLXSF"
    },
    {
     "description": "MELEXIS NV - UNSP ADR",
     "symbol": "MLXSY"
    },
    {
     "description": "MALAYAN BANKING-SPONS ADR",
     "symbol": "MLYBY"
    },
    {
     "description": "AMERICAN CUMO MINING CORP",
     "symbol": "MLYCF"
    },
    {
     "description": "WESTERN MAGNESIUM CORP",
     "symbol": "MLYF"
    },
    {
     "description": "MALAYAN BANKING BHD",
     "symbol": "MLYNF"
    },
    {
     "description": "MARLEY SPOON AG-CDI",
     "symbol": "MLYSF"
    },
    {
     "description": "MEMSCAP SA",
     "symbol": "MMAPF"
    },
    {
     "description": "META MATERIALS INC",
     "symbol": "MMAT"
    },
    {
     "description": "MSM MALAYSIA HOLDINGS BHD",
     "symbol": "MMAYF"
    },
    {
     "description": "MASMOVIL IBERCOM SA",
     "symbol": "MMBMF"
    },
    {
     "description": "MARSH & MCLENNAN COS",
     "symbol": "MMC"
    },
    {
     "description": "IQ MACKAY CA MUNI INTERMEDIA",
     "symbol": "MMCA"
    },
    {
     "description": "MERCELL HOLDING AS",
     "symbol": "MMCLF"
    },
    {
     "description": "MEMBERS CO LTD",
     "symbol": "MMCOF"
    },
    {
     "description": "MIND MEDICINE MINDMED -CW23",
     "symbol": "MMCWF"
    },
    {
     "description": "MAINSTAY MACKAY DEFINEDTERM",
     "symbol": "MMD"
    },
    {
     "description": "MIND MEDICINE MINDMED -CW24",
     "symbol": "MMDCF"
    },
    {
     "description": "MIRRIAD ADVERTISING PLC",
     "symbol": "MMDDF"
    },
    {
     "description": "MIND MEDICINE MINDMED -CW22",
     "symbol": "MMDWF"
    },
    {
     "description": "MOMENT GROUP AB",
     "symbol": "MMETF"
    },
    {
     "description": "MMEX RESOURCES CORP",
     "symbol": "MMEX"
    },
    {
     "description": "MALAYSIA MARINE AND HEAVY EN",
     "symbol": "MMHEF"
    },
    {
     "description": "MIRAMAR HOTEL & INVESTMENT",
     "symbol": "MMHTF"
    },
    {
     "description": "MARCUS & MILLICHAP INC",
     "symbol": "MMI"
    },
    {
     "description": "METRO MINING LTD",
     "symbol": "MMILF"
    },
    {
     "description": "IQ MACKAY MUNICIPAL INSURED",
     "symbol": "MMIN"
    },
    {
     "description": "MARMION INDUSTRIES CORP",
     "symbol": "MMIO"
    },
    {
     "description": "MEDMIRA INC",
     "symbol": "MMIRF"
    },
    {
     "description": "IQ MACKAY MUNICIPAL INTERMED",
     "symbol": "MMIT"
    },
    {
     "description": "HYGROVEST LTD",
     "symbol": "MMJJF"
    },
    {
     "description": "FIRST TRUST MULTI-MAN LG ETF",
     "symbol": "MMLG"
    },
    {
     "description": "MARTIN MIDSTREAM PARTNERS LP",
     "symbol": "MMLP"
    },
    {
     "description": "MMG LTD",
     "symbol": "MMLTF"
    },
    {
     "description": "3M CO",
     "symbol": "MMM"
    },
    {
     "description": "MAMAMANCINI'S HOLDINGS INC",
     "symbol": "MMMB"
    },
    {
     "description": "AVENIRA LTD",
     "symbol": "MMMKF"
    },
    {
     "description": "QUAD M SOLUTIONS INC",
     "symbol": "MMMM"
    },
    {
     "description": "MAMMOTH RESOURCES CORP",
     "symbol": "MMMRF"
    },
    {
     "description": "MASS MEGAWATTS WIND POWER IN",
     "symbol": "MMMW"
    },
    {
     "description": "MASTERMIND INC",
     "symbol": "MMND"
    },
    {
     "description": "MEDMEN ENTERPRISES INC-CL B",
     "symbol": "MMNFF"
    },
    {
     "description": "METALLIC MINERALS CORP",
     "symbol": "MMNGF"
    },
    {
     "description": "MUNTERS GROUP AB",
     "symbol": "MMNNF"
    },
    {
     "description": "MOMENTOUS HOLDINGS CORP",
     "symbol": "MMNT"
    },
    {
     "description": "MAGELLAN MIDSTREAM PARTNERS",
     "symbol": "MMP"
    },
    {
     "description": "MINAURUM GOLD INC",
     "symbol": "MMRGF"
    },
    {
     "description": "MASSMART HOLDINGS LTD",
     "symbol": "MMRTF"
    },
    {
     "description": "MASSMART HLDGS LTD-UNSP ADR",
     "symbol": "MMRTY"
    },
    {
     "description": "MAXIMUS INC",
     "symbol": "MMS"
    },
    {
     "description": "MEGMILK SNOW BRAND CO LTD",
     "symbol": "MMSBF"
    },
    {
     "description": "FIRST TRUST MULTI-MANAGER SM",
     "symbol": "MMSC"
    },
    {
     "description": "MACARTHUR MINERALS LTD",
     "symbol": "MMSDF"
    },
    {
     "description": "MARRET MULTI-STRATEGY INC-A",
     "symbol": "MMSGF"
    },
    {
     "description": "MCMILLAN SHAKESP - UNSP ADR",
     "symbol": "MMSHY"
    },
    {
     "description": "MERIT MEDICAL SYSTEMS INC",
     "symbol": "MMSI"
    },
    {
     "description": "MITSUI MINING & SMELTING-ADR",
     "symbol": "MMSMY"
    },
    {
     "description": "MFS MULTIMARKET INC TRUST",
     "symbol": "MMT"
    },
    {
     "description": "MICRO IMAGING TECHNOLOGY INC",
     "symbol": "MMTC"
    },
    {
     "description": "MICROMEM TECHNOLOGIES INC",
     "symbol": "MMTIF"
    },
    {
     "description": "Meta Matls Inc",
     "symbol": "MMTLP"
    },
    {
     "description": "SPDR S&P1500 MOMENTUM TILT",
     "symbol": "MMTM"
    },
    {
     "description": "MONUMENT MINING LTD",
     "symbol": "MMTMF"
    },
    {
     "description": "MITSUBISHI MOTORS CORP",
     "symbol": "MMTOF"
    },
    {
     "description": "MILLS MUSIC TRUST",
     "symbol": "MMTRS"
    },
    {
     "description": "MULTI-MEDIA TUTORIAL SVCS",
     "symbol": "MMTS"
    },
    {
     "description": "MEDICAL MEDIA TELEVISION INC",
     "symbol": "MMTV"
    },
    {
     "description": "WESTERN ASSET MANAGED MUNICI",
     "symbol": "MMU"
    },
    {
     "description": "MAVERIX METALS INC",
     "symbol": "MMX"
    },
    {
     "description": "MMX MINERACAO E METALICOS SA",
     "symbol": "MMXXF"
    },
    {
     "description": "MAKEMYTRIP LTD",
     "symbol": "MMYT"
    },
    {
     "description": "MANNING & NAPIER INC",
     "symbol": "MN"
    },
    {
     "description": "IQ MERGER ARBITRAGE ETF",
     "symbol": "MNA"
    },
    {
     "description": "MNP PETROLEUM CORP",
     "symbol": "MNAP"
    },
    {
     "description": "MORGUARD NORTH AMERICAN RESI",
     "symbol": "MNARF"
    },
    {
     "description": "MARQUETTE NATIONAL CORPORAT",
     "symbol": "MNAT"
    },
    {
     "description": "MINEBEA MITSUMI INC",
     "symbol": "MNBEF"
    },
    {
     "description": "MINEBEA MITSUMI INC",
     "symbol": "MNBEY"
    },
    {
     "description": "MNB HOLDINGS CORP",
     "symbol": "MNBO"
    },
    {
     "description": "MARS BANCORP INC",
     "symbol": "MNBP"
    },
    {
     "description": "MINBOS RESOURCES LTD",
     "symbol": "MNBRF"
    },
    {
     "description": "Chewy 2020 Mandatory Exchangable Trust",
     "symbol": "MNDEZ"
    },
    {
     "description": "MANDALAY RESOURCES CORP",
     "symbol": "MNDJF"
    },
    {
     "description": "MIND CTI LTD",
     "symbol": "MNDO"
    },
    {
     "description": "MUNDUS GROUP INC",
     "symbol": "MNDP"
    },
    {
     "description": "MANDIANT INC",
     "symbol": "MNDT"
    },
    {
     "description": "MONDAY.COM LTD",
     "symbol": "MNDY"
    },
    {
     "description": "MSA Safety Inc",
     "symbol": "MNESP"
    },
    {
     "description": "MANIFESTSEVEN HOLDINGS CORP",
     "symbol": "MNFSF"
    },
    {
     "description": "MINING GLOBAL INC",
     "symbol": "MNGG"
    },
    {
     "description": "MONGOLIA GROWTH GROUP LTD",
     "symbol": "MNGGF"
    },
    {
     "description": "MAN GROUP PLC\/JERSEY",
     "symbol": "MNGPF"
    },
    {
     "description": "MAYR-MELNHOF KARTON AG",
     "symbol": "MNHFF"
    },
    {
     "description": "MOWI ASA",
     "symbol": "MNHVF"
    },
    {
     "description": "MANI INC",
     "symbol": "MNICF"
    },
    {
     "description": "MANATI INDUSTRIES INC",
     "symbol": "MNII"
    },
    {
     "description": "MINOR INTERNATIONAL-UNSP ADR",
     "symbol": "MNILY"
    },
    {
     "description": "MINOR INTL PCL-CW24",
     "symbol": "MNINF"
    },
    {
     "description": "MINOR INTL PCL-CW23",
     "symbol": "MNIPF"
    },
    {
     "description": "MONASH IVF GROUP LTD",
     "symbol": "MNIVF"
    },
    {
     "description": "GEN2 TECHNOLOGIES INC",
     "symbol": "MNIZ"
    },
    {
     "description": "MANNKIND CORP",
     "symbol": "MNKD"
    },
    {
     "description": "MONKS INVESTMENT TRUST PLC",
     "symbol": "MNKIF"
    },
    {
     "description": "MALLINCKRODT PLC",
     "symbol": "MNKKQ"
    },
    {
     "description": "Manulife Financial Corporation",
     "symbol": "MNLCF"
    },
    {
     "description": "Manulife Financial Corporation",
     "symbol": "MNLFF"
    },
    {
     "description": "MINILUXE HOLDING CORP",
     "symbol": "MNLXF"
    },
    {
     "description": "DIREXION DAILY MM BULL 2X",
     "symbol": "MNM"
    },
    {
     "description": "MERCHANTS & MARINE BANCORP",
     "symbol": "MNMB"
    },
    {
     "description": "MIND MEDICINE MINDMED INC",
     "symbol": "MNMD"
    },
    {
     "description": "MONUMENTAL MINERALS CORP",
     "symbol": "MNMRF"
    },
    {
     "description": "MOTIVATING THE MASSES INC",
     "symbol": "MNMT"
    },
    {
     "description": "NUROSENE HEALTH INC",
     "symbol": "MNNDF"
    },
    {
     "description": "QUEENSLAND GOLD HILLS CORP",
     "symbol": "MNNFF"
    },
    {
     "description": "AFFLUENT PARTNERS HOLDINGS",
     "symbol": "MNNGF"
    },
    {
     "description": "MENICON CO LTD",
     "symbol": "MNNLF"
    },
    {
     "description": "MANDARIN ORIENT-UNSPON ADR",
     "symbol": "MNOIY"
    },
    {
     "description": "MEDICINOVA INC",
     "symbol": "MNOV"
    },
    {
     "description": "WESTERN ASSET MUNICIPAL PART",
     "symbol": "MNP"
    },
    {
     "description": "MERCHANTS NATL PROPERTIES",
     "symbol": "MNPP"
    },
    {
     "description": "MONOPAR THERAPEUTICS INC",
     "symbol": "MNPR"
    },
    {
     "description": "Manulife Financiall Corporation",
     "symbol": "MNQFF"
    },
    {
     "description": "MENORAH MIVTACHIM HOLDINGS L",
     "symbol": "MNRHF"
    },
    {
     "description": "MINOR INTERNATIONAL PCL-FOR",
     "symbol": "MNRIF"
    },
    {
     "description": "BRIGHAM MINERALS INC-CL A",
     "symbol": "MNRL"
    },
    {
     "description": "MINERAL MOUNTAIN RESOURCES L",
     "symbol": "MNRLF"
    },
    {
     "description": "MONRO INC",
     "symbol": "MNRO"
    },
    {
     "description": "MINEROS SA",
     "symbol": "MNSAF"
    },
    {
     "description": "MAINSTREET BANCSHARES INC",
     "symbol": "MNSB"
    },
    {
     "description": "MAINSTREET BANCSHARES IN",
     "symbol": "MNSBP"
    },
    {
     "description": "MAGNIS ENERGY TECHNOLOGIES L",
     "symbol": "MNSEF"
    },
    {
     "description": "MANSFELDER METALS LTD",
     "symbol": "MNSF"
    },
    {
     "description": "MONEYSUPERMARKET.CO-UNSP ADR",
     "symbol": "MNSKY"
    },
    {
     "description": "MINISO GROUP HOLDING LTD-ADR",
     "symbol": "MNSO"
    },
    {
     "description": "MONSTER BEVERAGE CORP",
     "symbol": "MNST"
    },
    {
     "description": "MINTH GROUP LTD",
     "symbol": "MNTHF"
    },
    {
     "description": "MINTH GROUP LTD - UNSPON ADR",
     "symbol": "MNTHY"
    },
    {
     "description": "MONTAUK RENEWABLES INC",
     "symbol": "MNTK"
    },
    {
     "description": "EVEREST CONSOLIDATOR ACQUISI",
     "symbol": "MNTN"
    },
    {
     "description": "EVEREST CONSOLIDATOR ACQUISI",
     "symbol": "MNTN.U"
    },
    {
     "description": "EVEREST CONSOLIDATOR -CW23",
     "symbol": "MNTN.WS"
    },
    {
     "description": "MENTOR CAPITAL INC",
     "symbol": "MNTR"
    },
    {
     "description": "MOMENTUS INC",
     "symbol": "MNTS"
    },
    {
     "description": "MOMENTUS INC-CW26",
     "symbol": "MNTSW"
    },
    {
     "description": "MANITOU GOLD INC",
     "symbol": "MNTUF"
    },
    {
     "description": "MOMENTIVE GLOBAL INC",
     "symbol": "MNTV"
    },
    {
     "description": "MANITEX INTERNATIONAL INC",
     "symbol": "MNTX"
    },
    {
     "description": "Manulife Financial Corporation",
     "symbol": "MNUFF"
    },
    {
     "description": "MANULIFE US REAL ESTATE INV",
     "symbol": "MNULF"
    },
    {
     "description": "MONDIAL VENTURES INC",
     "symbol": "MNVN"
    },
    {
     "description": "MOUNTAINVIEW ENERGY LTD",
     "symbol": "MNVWF"
    },
    {
     "description": "MONEX GROUP INC",
     "symbol": "MNXBF"
    },
    {
     "description": "AUTECO MINERALS LTD",
     "symbol": "MNXMF"
    },
    {
     "description": "MANGANESE X ENERGY CORP",
     "symbol": "MNXXF"
    },
    {
     "description": "MANZO PHARMACEUTICALS INC",
     "symbol": "MNZO"
    },
    {
     "description": "ALTRIA GROUP INC",
     "symbol": "MO"
    },
    {
     "description": "MONGOLIA ENERGY CORP LTD",
     "symbol": "MOAEF"
    },
    {
     "description": "MONGOLIA ENERGY CO-UNSP ADR",
     "symbol": "MOAEY"
    },
    {
     "description": "VANECK MORNINGSTAR WIDE MOAT",
     "symbol": "MOAT"
    },
    {
     "description": "MOBEUS INCOME & GROWTH 2 VCT",
     "symbol": "MOBEF"
    },
    {
     "description": "MOBI724 GLOBAL SOLUTIONS INC",
     "symbol": "MOBIF"
    },
    {
     "description": "MOBILE LADS CORP",
     "symbol": "MOBO"
    },
    {
     "description": "MOBIQUITY TECHNOLOGIES INC",
     "symbol": "MOBQ"
    },
    {
     "description": "MOBIQUITY TECHNOLOGIES -CW26",
     "symbol": "MOBQW"
    },
    {
     "description": "MOBEUS INCOME & GROWTH VCT P",
     "symbol": "MOBVF"
    },
    {
     "description": "MOBOTIX AG",
     "symbol": "MOBXF"
    },
    {
     "description": "MODERN CINEMA GROUP INC",
     "symbol": "MOCI"
    },
    {
     "description": "MODINE MANUFACTURING CO",
     "symbol": "MOD"
    },
    {
     "description": "MODERN TECHNOLOGY CORP",
     "symbol": "MODC"
    },
    {
     "description": "MODULAR MEDICAL INC",
     "symbol": "MODD"
    },
    {
     "description": "MODE GLOBAL HOLDINGS PLC",
     "symbol": "MODGF"
    },
    {
     "description": "MODEL N INC",
     "symbol": "MODN"
    },
    {
     "description": "MODIVCARE INC",
     "symbol": "MODV"
    },
    {
     "description": "MELCOR DEVELOPMENTS LTD",
     "symbol": "MODVF"
    },
    {
     "description": "MIDWESTONE FINANCIAL GROUP I",
     "symbol": "MOFG"
    },
    {
     "description": "MOOG INC-CLASS A",
     "symbol": "MOG.A"
    },
    {
     "description": "MOOG INC-CLASS B",
     "symbol": "MOG.B"
    },
    {
     "description": "MONGOLIAN MINING CORP",
     "symbol": "MOGLF"
    },
    {
     "description": "MOGO INC",
     "symbol": "MOGO"
    },
    {
     "description": "MOGU INC-ADR",
     "symbol": "MOGU"
    },
    {
     "description": "MOLINA HEALTHCARE INC",
     "symbol": "MOH"
    },
    {
     "description": "MOTOR OIL (HELLAS) SA",
     "symbol": "MOHCF"
    },
    {
     "description": "MOTOR OIL(HELLAS) SA-UNS ADR",
     "symbol": "MOHCY"
    },
    {
     "description": "ECMOHO LTD",
     "symbol": "MOHO"
    },
    {
     "description": "MOHR GROWTH ETF",
     "symbol": "MOHR"
    },
    {
     "description": "MOBEUS INCOME & GROWTH 4 VCT",
     "symbol": "MOIFF"
    },
    {
     "description": "MOJO ORGANICS INC",
     "symbol": "MOJO"
    },
    {
     "description": "MOL HUNGARIAN OIL AND GAS PL",
     "symbol": "MOLFF"
    },
    {
     "description": "MOLECULAR PARTNERS AG -ADR",
     "symbol": "MOLN"
    },
    {
     "description": "HELLO GROUP INC -SPN ADR",
     "symbol": "MOMO"
    },
    {
     "description": "MONEYONMOBILE INC",
     "symbol": "MOMT"
    },
    {
     "description": "MONUMENT CIRCLE ACQUI-CL A",
     "symbol": "MON"
    },
    {
     "description": "MONUMENT CIRCLE ACQUISITION",
     "symbol": "MONCU"
    },
    {
     "description": "MONUMENT CIRC ACQ CL A -CW27",
     "symbol": "MONCW"
    },
    {
     "description": "MONDI PLC",
     "symbol": "MONDF"
    },
    {
     "description": "MONDI PLC-UNSPON ADR",
     "symbol": "MONDY"
    },
    {
     "description": "MONTEGO RESOURCES INC",
     "symbol": "MONGF"
    },
    {
     "description": "MOON EQUITY HOLDINGS CORP",
     "symbol": "MONI"
    },
    {
     "description": "MONOTARO CO LTD",
     "symbol": "MONOF"
    },
    {
     "description": "MONOTARO CO LTD - UNSP ADR",
     "symbol": "MONOY"
    },
    {
     "description": "MONCLER SPA",
     "symbol": "MONRF"
    },
    {
     "description": "MONCLER SPA-UNSPONSORED ADR",
     "symbol": "MONRY"
    },
    {
     "description": "MONTEA NV",
     "symbol": "MONSF"
    },
    {
     "description": "VANECK AGRIBUSINESS ETF",
     "symbol": "MOO"
    },
    {
     "description": "SENSOR TECHNOLOGIES CORP",
     "symbol": "MOOIF"
    },
    {
     "description": "DIREXION MOONSHOT INNOVATORS",
     "symbol": "MOON"
    },
    {
     "description": "MONADELPHOUS GROUP-UNSP ADR",
     "symbol": "MOPHY"
    },
    {
     "description": "MOLINOS RIO DE LA PLATA SA",
     "symbol": "MOPLF"
    },
    {
     "description": "MOP ENVIRONMENTAL SOLUTIONS",
     "symbol": "MOPN"
    },
    {
     "description": "MORPHOSYS AG ADR",
     "symbol": "MOR"
    },
    {
     "description": "MORPHIC HOLDING INC",
     "symbol": "MORF"
    },
    {
     "description": "MORNINGSTAR INC",
     "symbol": "MORN"
    },
    {
     "description": "HOSTMORE PLC",
     "symbol": "MORRF"
    },
    {
     "description": "VANECK MORTGAGE REIT INCOME",
     "symbol": "MORT"
    },
    {
     "description": "MOSAIC CO\/THE",
     "symbol": "MOS"
    },
    {
     "description": "RELIA INC",
     "symbol": "MOSIF"
    },
    {
     "description": "MOBILESMITH INC",
     "symbol": "MOST"
    },
    {
     "description": "VANECK MORNINGSTAR ESG MOAT",
     "symbol": "MOTE"
    },
    {
     "description": "VANECK MSTAR GL WIDE MOAT",
     "symbol": "MOTG"
    },
    {
     "description": "VANECK MSTAR INT MOAT ETF",
     "symbol": "MOTI"
    },
    {
     "description": "POWERTAP HYDROGEN CAPITAL CO",
     "symbol": "MOTNF"
    },
    {
     "description": "SMARTETFS SMART TRANSP\/TECH",
     "symbol": "MOTO"
    },
    {
     "description": "MOTUS GI HOLDINGS INC",
     "symbol": "MOTS"
    },
    {
     "description": "MOTUS HOLDINGS LTD - ADR",
     "symbol": "MOTUY"
    },
    {
     "description": "MOVADO GROUP INC",
     "symbol": "MOV"
    },
    {
     "description": "MOVADO GROUP INC-CL A",
     "symbol": "MOVAA"
    },
    {
     "description": "MOVANO INC",
     "symbol": "MOVE"
    },
    {
     "description": "MOXIAN BVI INC",
     "symbol": "MOXC"
    },
    {
     "description": "MYNARIC AG",
     "symbol": "MOYFF"
    },
    {
     "description": "MOSAIC BRANDS LTD",
     "symbol": "MOZBF"
    },
    {
     "description": "MP MATERIALS CORP",
     "symbol": "MP"
    },
    {
     "description": "BLACKROCK MUNIYIELD PENNSYLV",
     "symbol": "MPA"
    },
    {
     "description": "MOTORCAR PARTS OF AMERICA IN",
     "symbol": "MPAA"
    },
    {
     "description": "MODEL PERFORMANCE ACQUISIT-A",
     "symbol": "MPAC"
    },
    {
     "description": "MODEL PERFORMANCE ACQ-RIGHTS",
     "symbol": "MPACR"
    },
    {
     "description": "MODEL PERFORMANCE ACQUISITIO",
     "symbol": "MPACU"
    },
    {
     "description": "MODEL PERFORMANCE ACQ -CW26",
     "symbol": "MPACW"
    },
    {
     "description": "MICROPAC INDUSTRIES INC",
     "symbol": "MPAD"
    },
    {
     "description": "MID PENN BANCORP INC",
     "symbol": "MPB"
    },
    {
     "description": "MARATHON PETROLEUM CORP",
     "symbol": "MPC"
    },
    {
     "description": "MOUNTAIN PACIFIC BANCORP INC",
     "symbol": "MPCB"
    },
    {
     "description": "METRO PACIFIC INVESTMENTS CO",
     "symbol": "MPCFF"
    },
    {
     "description": "MAPLETREE COMMERCIAL TRUST",
     "symbol": "MPCMF"
    },
    {
     "description": "INNOVACOM INC",
     "symbol": "MPEG"
    },
    {
     "description": "MAPFRE SA",
     "symbol": "MPFRF"
    },
    {
     "description": "MAPFRE SA-UNSP ADR",
     "symbol": "MPFRY"
    },
    {
     "description": "AURVISTA GOLD CORP - WARRANT",
     "symbol": "MPGMF"
    },
    {
     "description": "PAGEGROUP PLC",
     "symbol": "MPGPF"
    },
    {
     "description": "PAGEGROUP PLC-SP ADR",
     "symbol": "MPGPY"
    },
    {
     "description": "MPHB CAPITAL BHD",
     "symbol": "MPHBF"
    },
    {
     "description": "MEDIA PAL HOLDINGS CORP",
     "symbol": "MPHD"
    },
    {
     "description": "CALLITAS HEALTH INC",
     "symbol": "MPHMF"
    },
    {
     "description": "MPB BHC INC",
     "symbol": "MPHX"
    },
    {
     "description": "MCPHY ENERGY SA",
     "symbol": "MPHYF"
    },
    {
     "description": "MESSAGE PROCESSING INTL INC",
     "symbol": "MPIN"
    },
    {
     "description": "EMPIRE DIVERSIFIED ENERGY IN",
     "symbol": "MPIR"
    },
    {
     "description": "KAIROS MINERALS LTD",
     "symbol": "MPJFF"
    },
    {
     "description": "MULTIPLAN CORP",
     "symbol": "MPLN"
    },
    {
     "description": "MULTIPLAN CORP-CW25",
     "symbol": "MPLN.WS"
    },
    {
     "description": "MPLX LP",
     "symbol": "MPLX"
    },
    {
     "description": "MPLX LP",
     "symbol": "MPLXP"
    },
    {
     "description": "MPM TECHNOLOGIES INC",
     "symbol": "MPML"
    },
    {
     "description": "MEITUAN-CLASS B",
     "symbol": "MPNGF"
    },
    {
     "description": "MEITUAN - UNSP ADR",
     "symbol": "MPNGY"
    },
    {
     "description": "MERCATO PARTNERS ACQUISITI-A",
     "symbol": "MPRA"
    },
    {
     "description": "MERCATO PARTNERS ACQUISITION",
     "symbol": "MPRAU"
    },
    {
     "description": "MERCATO PARTNERS ACQ -CW26",
     "symbol": "MPRAW"
    },
    {
     "description": "MOTION PICTURE GROUP INC",
     "symbol": "MPRG"
    },
    {
     "description": "MONARCH PROCAP ETF",
     "symbol": "MPRO"
    },
    {
     "description": "REVOLUGROUP CANADA INC",
     "symbol": "MPSFF"
    },
    {
     "description": "MORPHOSYS AG",
     "symbol": "MPSYF"
    },
    {
     "description": "BARINGS PARTICIPATION INVEST",
     "symbol": "MPV"
    },
    {
     "description": "MOUNTAIN PROVINCE DIAMONDS",
     "symbol": "MPVDF"
    },
    {
     "description": "MEDICAL PROPERTIES TRUST INC",
     "symbol": "MPW"
    },
    {
     "description": "MONOLITHIC POWER SYSTEMS INC",
     "symbol": "MPWR"
    },
    {
     "description": "MARINE PRODUCTS CORP",
     "symbol": "MPX"
    },
    {
     "description": "MPX INTERNATIONAL CORP",
     "symbol": "MPXOF"
    },
    {
     "description": "MIPS AB",
     "symbol": "MPZAF"
    },
    {
     "description": "MIPS AB ADS - ADR",
     "symbol": "MPZAY"
    },
    {
     "description": "MPC CONTAINER SHIPS AS",
     "symbol": "MPZZF"
    },
    {
     "description": "MARQETA INC-A",
     "symbol": "MQ"
    },
    {
     "description": "MACQUARIE GROUP LTD-ADR",
     "symbol": "MQBKY"
    },
    {
     "description": "MACQUARIE TELECOM GROUP LTD",
     "symbol": "MQCTF"
    },
    {
     "description": "MCEWEN MINING INC-CW24",
     "symbol": "MQMNW"
    },
    {
     "description": "BLACKROCK MUNIYIELD QUAL II",
     "symbol": "MQT"
    },
    {
     "description": "BLACKROCK MUNIYIELD QUALITY",
     "symbol": "MQY"
    },
    {
     "description": "MURATA MANUFACTURING CO LTD",
     "symbol": "MRAAF"
    },
    {
     "description": "MURATA MANUFACTUR-UNSPON ADR",
     "symbol": "MRAAY"
    },
    {
     "description": "SMARTETFS ADVERT & MRKT TECH",
     "symbol": "MRAD"
    },
    {
     "description": "MARPAI INC-CLASS A",
     "symbol": "MRAI"
    },
    {
     "description": "MRC ALLIED INC",
     "symbol": "MRAIF"
    },
    {
     "description": "EVERSPIN TECHNOLOGIES INC",
     "symbol": "MRAM"
    },
    {
     "description": "MERIDIAN CORP",
     "symbol": "MRBK"
    },
    {
     "description": "MARBLE FINANCIAL INC",
     "symbol": "MRBLF"
    },
    {
     "description": "MRC GLOBAL INC",
     "symbol": "MRC"
    },
    {
     "description": "MORGUARD CORP",
     "symbol": "MRCBF"
    },
    {
     "description": "MONROE CAPITAL CORP",
     "symbol": "MRCC"
    },
    {
     "description": "H.U. GROUP HOLDINGS INC",
     "symbol": "MRCHF"
    },
    {
     "description": "MERCARI INC",
     "symbol": "MRCIF"
    },
    {
     "description": "MORO CORPORATION",
     "symbol": "MRCR"
    },
    {
     "description": "MERCURY SYSTEMS INC",
     "symbol": "MRCY"
    },
    {
     "description": "MERIDIAN HOLDINGS INC",
     "symbol": "MRDH"
    },
    {
     "description": "MOBILE READY ENTERTAINMENT C",
     "symbol": "MRDY"
    },
    {
     "description": "MEREO BIOPHARMA GROUP PL-ADR",
     "symbol": "MREO"
    },
    {
     "description": "DEMIRE DT MTS REAL ESTATE AG",
     "symbol": "MREOF"
    },
    {
     "description": "INSTITUTE OF BIOMEDICAL RESE",
     "symbol": "MRES"
    },
    {
     "description": "MARTINREA INTERNATIONAL INC",
     "symbol": "MRETF"
    },
    {
     "description": "PURANIUM ENERGY LTD",
     "symbol": "MREYF"
    },
    {
     "description": "MARFIN INVESTMENT GROUP HOLD",
     "symbol": "MRFGF"
    },
    {
     "description": "MARFIN INVESTMNT GRP-UNS ADR",
     "symbol": "MRFGY"
    },
    {
     "description": "MIRAGE ENERGY CORP",
     "symbol": "MRGE"
    },
    {
     "description": "MRG METALS LTD",
     "symbol": "MRGMF"
    },
    {
     "description": "MERGENCE CORP",
     "symbol": "MRGN"
    },
    {
     "description": "MARGO CARIBE INC",
     "symbol": "MRGO"
    },
    {
     "description": "PROSHARES MERGER ETF",
     "symbol": "MRGR"
    },
    {
     "description": "MIRAIT HOLDINGS CORP",
     "symbol": "MRHLF"
    },
    {
     "description": "MARANI BRANDS INC",
     "symbol": "MRIB"
    },
    {
     "description": "MEHADRIN LTD",
     "symbol": "MRIIF"
    },
    {
     "description": "MARIN SOFTWARE INC",
     "symbol": "MRIN"
    },
    {
     "description": "BMEX GOLD INC",
     "symbol": "MRIRF"
    },
    {
     "description": "PURPOSE MARIJUANA OPPORTUNIT",
     "symbol": "MRJOF"
    },
    {
     "description": "MERCK & CO. INC.",
     "symbol": "MRK"
    },
    {
     "description": "MARKER THERAPEUTICS INC",
     "symbol": "MRKR"
    },
    {
     "description": "MINERA IRL LTD",
     "symbol": "MRLLF"
    },
    {
     "description": "MINERA IRL LTD-UNSP ADR",
     "symbol": "MRLLY"
    },
    {
     "description": "MARLOWE PLC",
     "symbol": "MRLWF"
    },
    {
     "description": "MEDIROM HEALTHCARE TECHNOLOG",
     "symbol": "MRM"
    },
    {
     "description": "MARIMED INC",
     "symbol": "MRMD"
    },
    {
     "description": "MARMOTA LTD",
     "symbol": "MRMEF"
    },
    {
     "description": "MODERNA INC",
     "symbol": "MRNA"
    },
    {
     "description": "IQ US MID CAP R&D LEADERS ET",
     "symbol": "MRND"
    },
    {
     "description": "METATRON INC",
     "symbol": "MRNJ"
    },
    {
     "description": "MARINUS PHARMACEUTICALS INC",
     "symbol": "MRNS"
    },
    {
     "description": "MIRAINOVATE CO LTD",
     "symbol": "MRNVF"
    },
    {
     "description": "MARATHON OIL CORP",
     "symbol": "MRO"
    },
    {
     "description": "MADAGASCAR OIL LTD",
     "symbol": "MROIF"
    },
    {
     "description": "NEXTAGE THERAPEUTICS LTD",
     "symbol": "MROMF"
    },
    {
     "description": "MERA PHARMACEUTICALS INC",
     "symbol": "MRPI"
    },
    {
     "description": "MR PRICE GROUP LTD-SPON ADR",
     "symbol": "MRPLY"
    },
    {
     "description": "MERLIN PROPERTIES SOCIMI SA",
     "symbol": "MRPRF"
    },
    {
     "description": "MICROPHONICS INC",
     "symbol": "MRPS"
    },
    {
     "description": "MACREPORT.NET INC\/THE",
     "symbol": "MRPT"
    },
    {
     "description": "MR PRICE GROUP LTD",
     "symbol": "MRPZF"
    },
    {
     "description": "WAYLAND GROUP CORP",
     "symbol": "MRRCF"
    },
    {
     "description": "MERIDIAN MINING UK SOCIETAS",
     "symbol": "MRRDF"
    },
    {
     "description": "MARRET HIGH YIELD STRATEGIES",
     "symbol": "MRRHF"
    },
    {
     "description": "MORIROKU HOLDINGS CO LTD",
     "symbol": "MRRKF"
    },
    {
     "description": "MAREL HF",
     "symbol": "MRRLF"
    },
    {
     "description": "MARFRIG GLOBAL FOOD-SPON ADR",
     "symbol": "MRRTY"
    },
    {
     "description": "MARY ARGOTECHNOLOGIES INC",
     "symbol": "MRRYF"
    },
    {
     "description": "TOEWS AGILITY SHARES MANAGED",
     "symbol": "MRSK"
    },
    {
     "description": "MORI SEIKI CO LTD",
     "symbol": "MRSKF"
    },
    {
     "description": "MERSANA THERAPEUTICS INC",
     "symbol": "MRSN"
    },
    {
     "description": "MAXUS REALTY TRUST INC",
     "symbol": "MRTI"
    },
    {
     "description": "MARITIME RESOURCES CORP",
     "symbol": "MRTMF"
    },
    {
     "description": "MARTEN TRANSPORT LTD",
     "symbol": "MRTN"
    },
    {
     "description": "MARSTON'S PLC-UNSP ADR",
     "symbol": "MRTPY"
    },
    {
     "description": "METAL TIGER PLC",
     "symbol": "MRTTF"
    },
    {
     "description": "MIRATI THERAPEUTICS INC",
     "symbol": "MRTX"
    },
    {
     "description": "MARUHA NICHIRO CORP",
     "symbol": "MRUHF"
    },
    {
     "description": "MERUS NV",
     "symbol": "MRUS"
    },
    {
     "description": "METROVACESA SA",
     "symbol": "MRVCF"
    },
    {
     "description": "NUVO PHARMACEUTICALS INC",
     "symbol": "MRVFF"
    },
    {
     "description": "MIRVAC GROUP",
     "symbol": "MRVGF"
    },
    {
     "description": "MARAVAI LIFESCIENCES HLDGS-A",
     "symbol": "MRVI"
    },
    {
     "description": "MARVELL TECHNOLOGY INC",
     "symbol": "MRVL"
    },
    {
     "description": "MURRAY RIVER ORGANICS GROUP",
     "symbol": "MRVOF"
    },
    {
     "description": "MINERVA SA-SPON ADR",
     "symbol": "MRVSY"
    },
    {
     "description": "MIRAVANT MEDICAL TECHNOLOGIE",
     "symbol": "MRVT"
    },
    {
     "description": "MIRASOL RESOURCES LTD",
     "symbol": "MRZLF"
    },
    {
     "description": "MARIZYME INC",
     "symbol": "MRZM"
    },
    {
     "description": "MORGAN STANLEY",
     "symbol": "MS"
    },
    {
     "description": "MORGAN STANLEY",
     "symbol": "MS.PRA"
    },
    {
     "description": "MORGAN STANLEY",
     "symbol": "MS.PRE"
    },
    {
     "description": "MORGAN STANLEY",
     "symbol": "MS.PRF"
    },
    {
     "description": "MORGAN STANLEY",
     "symbol": "MS.PRI"
    },
    {
     "description": "MORGAN STANLEY",
     "symbol": "MS.PRK"
    },
    {
     "description": "MORGAN STANLEY",
     "symbol": "MS.PRL"
    },
    {
     "description": "MORGAN STANLEY",
     "symbol": "MS.PRO"
    },
    {
     "description": "MSA SAFETY INC",
     "symbol": "MSA"
    },
    {
     "description": "MEDICUS SCIENCES ACQUISITI-A",
     "symbol": "MSAC"
    },
    {
     "description": "MEDICUS SCIENCES ACQ -CW27",
     "symbol": "MSACW"
    },
    {
     "description": "MS&AD INSURANCE GROUP HOLDIN",
     "symbol": "MSADF"
    },
    {
     "description": "MS&AD INSURANCE-UNSPONS ADR",
     "symbol": "MSADY"
    },
    {
     "description": "MAN SHING AGRICULTURAL HOLD",
     "symbol": "MSAH"
    },
    {
     "description": "MESABI TRUST",
     "symbol": "MSB"
    },
    {
     "description": "MISSION BANCORP\/BAKERSFIELD",
     "symbol": "MSBC"
    },
    {
     "description": "MITSUBISHI CORP",
     "symbol": "MSBHF"
    },
    {
     "description": "MIDLAND STATES BANCORP INC",
     "symbol": "MSBI"
    },
    {
     "description": "MSB GLOBAL CAPITAL CORP",
     "symbol": "MSBM"
    },
    {
     "description": "STUDIO CITY INTERNATIONA-ADR",
     "symbol": "MSC"
    },
    {
     "description": "MSCI INC",
     "symbol": "MSCI"
    },
    {
     "description": "SATELLOS BIOSCIENCE INC",
     "symbol": "MSCLF"
    },
    {
     "description": "MORGAN STANLEY EMRG MKT DEBT",
     "symbol": "MSD"
    },
    {
     "description": "MSD ACQUISITION CORP-A",
     "symbol": "MSDA"
    },
    {
     "description": "MSD ACQUISITION CORP",
     "symbol": "MSDAU"
    },
    {
     "description": "MSD ACQUISITION CORP A -CW28",
     "symbol": "MSDAW"
    },
    {
     "description": "MAGSEIS FAIRFIELD ASA",
     "symbol": "MSEIF"
    },
    {
     "description": "MADISON SPORTS & ENTERTAINMT",
     "symbol": "MSET"
    },
    {
     "description": "MIDDLESEX WATER CO",
     "symbol": "MSEX"
    },
    {
     "description": "Middlesex Water Company",
     "symbol": "MSEXP"
    },
    {
     "description": "MEDIA SENTIMENT INC",
     "symbol": "MSEZ"
    },
    {
     "description": "MAINSTREET FINANCIAL CORP",
     "symbol": "MSFN"
    },
    {
     "description": "MICROSOFT CORP",
     "symbol": "MSFT"
    },
    {
     "description": "MAS GOLD CORP",
     "symbol": "MSGCF"
    },
    {
     "description": "MADISON SQUARE GARDEN ENTERT",
     "symbol": "MSGE"
    },
    {
     "description": "MOTORSPORT GAMES INC-A",
     "symbol": "MSGM"
    },
    {
     "description": "MAN SANG INTERNATIONAL LTD",
     "symbol": "MSGNF"
    },
    {
     "description": "MEDSMART GROUP INC",
     "symbol": "MSGP"
    },
    {
     "description": "DIREXION MRNA",
     "symbol": "MSGR"
    },
    {
     "description": "MADISON SQUARE GARDEN SPORTS",
     "symbol": "MSGS"
    },
    {
     "description": "MSH ENTERTAINMENT CORP",
     "symbol": "MSHE"
    },
    {
     "description": "MITSUBISHI SHOKUHIN CO LTD",
     "symbol": "MSHXF"
    },
    {
     "description": "MOTOROLA SOLUTIONS INC",
     "symbol": "MSI"
    },
    {
     "description": "MEDICAL SERVICES INTL INC",
     "symbol": "MSITF"
    },
    {
     "description": "MEDICAL SUPPLY INTERNATIONAL",
     "symbol": "MSIU"
    },
    {
     "description": "LIFEWORKS INC",
     "symbol": "MSIXF"
    },
    {
     "description": "MASCOT SILVER LEAD MINES",
     "symbol": "MSLM"
    },
    {
     "description": "MITSUI OSK LINES LTD",
     "symbol": "MSLOF"
    },
    {
     "description": "MITSUI OSK LINES LTD-UNS ADR",
     "symbol": "MSLOY"
    },
    {
     "description": "MUSCLE PHARM CORP",
     "symbol": "MSLP"
    },
    {
     "description": "MANTARO PRECIOUS METALS CORP",
     "symbol": "MSLVF"
    },
    {
     "description": "MSC INDUSTRIAL DIRECT CO-A",
     "symbol": "MSM"
    },
    {
     "description": "MIMASU SEMICONDUCTOR INDUST",
     "symbol": "MSMCF"
    },
    {
     "description": "GRID METALS CORP",
     "symbol": "MSMGF"
    },
    {
     "description": "MATSUKIYOCOCOKARA & CO",
     "symbol": "MSMKF"
    },
    {
     "description": "M\/S MANAGED RISK ETF",
     "symbol": "MSMR"
    },
    {
     "description": "MC ENDEAVORS INC",
     "symbol": "MSMY"
    },
    {
     "description": "EMERSON RADIO CORP",
     "symbol": "MSN"
    },
    {
     "description": "MISSION READY SOLUTIONS INC",
     "symbol": "MSNVF"
    },
    {
     "description": "ADVISORSHARES PURE US CANN",
     "symbol": "MSOS"
    },
    {
     "description": "DATTO HOLDING CORP",
     "symbol": "MSP"
    },
    {
     "description": "GROWENS SPA",
     "symbol": "MSPAF"
    },
    {
     "description": "METROSPACES INC",
     "symbol": "MSPC"
    },
    {
     "description": "METAL SKY STAR ACQUISITION C",
     "symbol": "MSSAU"
    },
    {
     "description": "Massachusetts Electric Co",
     "symbol": "MSSEL"
    },
    {
     "description": "MISUMI GROUP INC-UNSP ADR",
     "symbol": "MSSMY"
    },
    {
     "description": "MINDSET PHARMA INC",
     "symbol": "MSSTF"
    },
    {
     "description": "MESO NUMISMATICS INC",
     "symbol": "MSSV"
    },
    {
     "description": "LHA MARKET STATE TACTICAL",
     "symbol": "MSTB"
    },
    {
     "description": "MONARCH STAFFING INC",
     "symbol": "MSTF"
    },
    {
     "description": "MYSTIC HOLDINGS INC",
     "symbol": "MSTH"
    },
    {
     "description": "Morgan Stanley ",
     "symbol": "MSTLW"
    },
    {
     "description": "MASTERBEAT CORP",
     "symbol": "MSTO"
    },
    {
     "description": "LHA MARKET STATE TACTICAL Q",
     "symbol": "MSTQ"
    },
    {
     "description": "MICROSTRATEGY INC-CL A",
     "symbol": "MSTR"
    },
    {
     "description": "M.C.S. STEEL PCL-NVDR",
     "symbol": "MSTUF"
    },
    {
     "description": "MADORO METALS CORP",
     "symbol": "MSTXF"
    },
    {
     "description": "MISUMI GROUP INC",
     "symbol": "MSUXF"
    },
    {
     "description": "MID-SOUTHERN BANCORP INC",
     "symbol": "MSVB"
    },
    {
     "description": "MARIJUANA STRATEGIC VENTURES",
     "symbol": "MSVI"
    },
    {
     "description": "MASSIVIT 3D PRINTING TECHNOL",
     "symbol": "MSVTF"
    },
    {
     "description": "LHA MARKET STATE ALPHA SEEKE",
     "symbol": "MSVX"
    },
    {
     "description": "MAIN STREET FINANCIAL SERVIC",
     "symbol": "MSWV"
    },
    {
     "description": "MEDICAL SYSTEM NETWORK CO LT",
     "symbol": "MSYMF"
    },
    {
     "description": "MS YOUNG ADVENTURE ENT",
     "symbol": "MSYN"
    },
    {
     "description": "ARCELORMITTAL-NY REGISTERED",
     "symbol": "MT"
    },
    {
     "description": "METALLA ROYALTY & STREAMING",
     "symbol": "MTA"
    },
    {
     "description": "MEDTECH ACQUISITION CORP-A",
     "symbol": "MTAC"
    },
    {
     "description": "MEDTECH ACQUISITION CORP\/NY",
     "symbol": "MTACU"
    },
    {
     "description": "MEDTECH ACQUISITION CORP-CW",
     "symbol": "MTACW"
    },
    {
     "description": "CECONOMY AG",
     "symbol": "MTAGF"
    },
    {
     "description": "METALS ACQUISITION CORP-CL A",
     "symbol": "MTAL"
    },
    {
     "description": "METALS ACQUISITION CORP",
     "symbol": "MTAL.U"
    },
    {
     "description": "METALS ACQUISITION A -CW23",
     "symbol": "MTAL.WS"
    },
    {
     "description": "METALLICA METALS CORP",
     "symbol": "MTALF"
    },
    {
     "description": "M & T BANK CORP",
     "symbol": "MTB"
    },
    {
     "description": "M&T BANK CORPORATION",
     "symbol": "MTB.PRH"
    },
    {
     "description": "CARECLOUD INC",
     "symbol": "MTBC"
    },
    {
     "description": "CARECLOUD INC",
     "symbol": "MTBCO"
    },
    {
     "description": "CARECLOUD INC",
     "symbol": "MTBCP"
    },
    {
     "description": "MOUNT BURGESS MINING NL",
     "symbol": "MTBMF"
    },
    {
     "description": "MMTEC INC",
     "symbol": "MTC"
    },
    {
     "description": "MATCH GROUP INC",
     "symbol": "MTCH"
    },
    {
     "description": "ARCELORMITTAL",
     "symbol": "MTCN"
    },
    {
     "description": "MTR CORP LTD-UNSPONSORED ADR",
     "symbol": "MTCPY"
    },
    {
     "description": "METACRINE INC",
     "symbol": "MTCR"
    },
    {
     "description": "METTLER-TOLEDO INTERNATIONAL",
     "symbol": "MTD"
    },
    {
     "description": "MATADOR RESOURCES CO",
     "symbol": "MTDR"
    },
    {
     "description": "ST ANTHONY GOLD CORP",
     "symbol": "MTEHF"
    },
    {
     "description": "MOUNTAIN ENERGY INC",
     "symbol": "MTEI"
    },
    {
     "description": "MARIS - TECH LTD",
     "symbol": "MTEK"
    },
    {
     "description": "MARIS - TECH LTD -23",
     "symbol": "MTEKW"
    },
    {
     "description": "MOLECULAR TEMPLATES INC",
     "symbol": "MTEM"
    },
    {
     "description": "MAHANAGAR TELEPHONE-ADR",
     "symbol": "MTENY"
    },
    {
     "description": "MANNATECH INC",
     "symbol": "MTEX"
    },
    {
     "description": "MINSTER FINANCIAL CORP",
     "symbol": "MTFC"
    },
    {
     "description": "U.K. SPAC PLC",
     "symbol": "MTFGF"
    },
    {
     "description": "MGIC INVESTMENT CORP",
     "symbol": "MTG"
    },
    {
     "description": "MAPLETREE NORTH ASIA COMMERC",
     "symbol": "MTGCF"
    },
    {
     "description": "MUSTI GROUP OY",
     "symbol": "MTGOF"
    },
    {
     "description": "WISDOMTREE MTGE PLUS BOND",
     "symbol": "MTGP"
    },
    {
     "description": "MOUNT GIBSON IRON LTD",
     "symbol": "MTGRF"
    },
    {
     "description": "MOUNT GIBSON IRON LTD-ADR",
     "symbol": "MTGRY"
    },
    {
     "description": "MERITAGE HOMES CORP",
     "symbol": "MTH"
    },
    {
     "description": "YUNHONG GUIXIN GROUP HOLDING",
     "symbol": "MTHGF"
    },
    {
     "description": "M3 INC",
     "symbol": "MTHRF"
    },
    {
     "description": "M3 INC - UNSP ADR",
     "symbol": "MTHRY"
    },
    {
     "description": "MITHRIL RESOURCES LTD",
     "symbol": "MTIRF"
    },
    {
     "description": "MECHEL PJSC-SPONSORED ADR",
     "symbol": "MTL"
    },
    {
     "description": "Mechel PAO",
     "symbol": "MTL.PR"
    },
    {
     "description": "METALCORP LTD",
     "symbol": "MTLCF"
    },
    {
     "description": "METALLIS RESOUCES INC",
     "symbol": "MTLFF"
    },
    {
     "description": "MITSUBISHI CHEMICAL HOLDINGS",
     "symbol": "MTLHF"
    },
    {
     "description": "MITSUBISHI CHEMICAL-UNSP ADR",
     "symbol": "MTLHY"
    },
    {
     "description": "METALINE CONTACT MINES",
     "symbol": "MTLI"
    },
    {
     "description": "METALINK LTD",
     "symbol": "MTLK"
    },
    {
     "description": "METALLUM RESOURCES INC",
     "symbol": "MTLLF"
    },
    {
     "description": "METALORE RESOURCES LTD",
     "symbol": "MTLRF"
    },
    {
     "description": "MATERIALISE NV-ADR",
     "symbol": "MTLS"
    },
    {
     "description": "METALL ZUG AG-SHS B-REG",
     "symbol": "MTLZF"
    },
    {
     "description": "MEGA MATRIX CORP",
     "symbol": "MTMT"
    },
    {
     "description": "MATMOWN INC",
     "symbol": "MTMW"
    },
    {
     "description": "VAIL RESORTS INC",
     "symbol": "MTN"
    },
    {
     "description": "MATINAS BIOPHARMA HOLDINGS I",
     "symbol": "MTNB"
    },
    {
     "description": "MTN GROUP LTD",
     "symbol": "MTNOF"
    },
    {
     "description": "MTN GROUP LTD-SPONS ADR",
     "symbol": "MTNOY"
    },
    {
     "description": "MELTRONIX INC",
     "symbol": "MTNX"
    },
    {
     "description": "FIRST GROWTH FUNDS LTD",
     "symbol": "MTOMF"
    },
    {
     "description": "MERITOR INC",
     "symbol": "MTOR"
    },
    {
     "description": "MIDATECH PHARMA PLC-ADR",
     "symbol": "MTP"
    },
    {
     "description": "METROPOLITAN BANK & TRUST",
     "symbol": "MTPOF"
    },
    {
     "description": "METROPOLITAN BANK &-UNSP ADR",
     "symbol": "MTPOY"
    },
    {
     "description": "MOUNTAIN TOP PROPERTIES INC",
     "symbol": "MTPP"
    },
    {
     "description": "METAPOWER INTERNATIONAL INC",
     "symbol": "MTPR"
    },
    {
     "description": "MOTORPOINT GROUP PLC",
     "symbol": "MTPTF"
    },
    {
     "description": "METROPOLE TELEVISION-UNS ADR",
     "symbol": "MTPVY"
    },
    {
     "description": "MESA ROYALTY TRUST",
     "symbol": "MTR"
    },
    {
     "description": "METRO INC\/CN",
     "symbol": "MTRAF"
    },
    {
     "description": "METRO INC",
     "symbol": "MTRI"
    },
    {
     "description": "MTR CORP",
     "symbol": "MTRJF"
    },
    {
     "description": "MATRICELF LTD",
     "symbol": "MTRLF"
    },
    {
     "description": "MATERION CORP",
     "symbol": "MTRN"
    },
    {
     "description": "METRO ONE DEVELOPMENT INC",
     "symbol": "MTRO"
    },
    {
     "description": "METRO SYSTEMS CORP PCL-NVDR",
     "symbol": "MTRPF"
    },
    {
     "description": "METAL ARTS COMPANY INC",
     "symbol": "MTRT"
    },
    {
     "description": "MATRIX SERVICE CO",
     "symbol": "MTRX"
    },
    {
     "description": "MONTEREY BIO ACQUISITION COR",
     "symbol": "MTRY"
    },
    {
     "description": "MONTEREY BIO ACQUISITION COR",
     "symbol": "MTRYU"
    },
    {
     "description": "MONTEREY BIO ACQ -CW23",
     "symbol": "MTRYW"
    },
    {
     "description": "METSA BOARD OYJ-B",
     "symbol": "MTSAF"
    },
    {
     "description": "MATSUI SECURITIES CO LTD",
     "symbol": "MTSEF"
    },
    {
     "description": "MITSUI FUDOSAN CO LTD",
     "symbol": "MTSFF"
    },
    {
     "description": "MITSUI FUDOSAN-UNSPON ADR",
     "symbol": "MTSFY"
    },
    {
     "description": "MACOM TECHNOLOGY SOLUTIONS H",
     "symbol": "MTSI"
    },
    {
     "description": "MATSUOKA CORP",
     "symbol": "MTSKF"
    },
    {
     "description": "METASTAT INC",
     "symbol": "MTST"
    },
    {
     "description": "MITSUBISHI CORP - ADR",
     "symbol": "MTSUY"
    },
    {
     "description": "MINERALS 260 LTD",
     "symbol": "MTSZF"
    },
    {
     "description": "MEATECH 3D LTD",
     "symbol": "MTTCF"
    },
    {
     "description": "GOLDOZ LTD",
     "symbol": "MTTGF"
    },
    {
     "description": "MATTERPORT INC",
     "symbol": "MTTR"
    },
    {
     "description": "CECONOMY AG - SPON ADR",
     "symbol": "MTTRY"
    },
    {
     "description": "METRO AG",
     "symbol": "MTTWF"
    },
    {
     "description": "MTU AERO ENGINES AG",
     "symbol": "MTUAF"
    },
    {
     "description": "MTU AERO ENGINES-UNSPON ADR",
     "symbol": "MTUAY"
    },
    {
     "description": "ETRACS 2X MOMNTM FACTR TR",
     "symbol": "MTUL"
    },
    {
     "description": "ISHARES MSCI USA MOMENTUM FA",
     "symbol": "MTUM"
    },
    {
     "description": "MOUNTAIN-VALLEY BANCSHARES",
     "symbol": "MTVB"
    },
    {
     "description": "MOTIVE CAPITAL CORP II-CL A",
     "symbol": "MTVC"
    },
    {
     "description": "MOTIVE CAPITAL CORP II",
     "symbol": "MTVC.U"
    },
    {
     "description": "MOTIVE CAPITAL II CL A -23",
     "symbol": "MTVC.WS"
    },
    {
     "description": "FOUNT METAVERSE ETF",
     "symbol": "MTVR"
    },
    {
     "description": "APT MOTO VOX GROUP INC",
     "symbol": "MTVX"
    },
    {
     "description": "MANITOWOC COMPANY INC",
     "symbol": "MTW"
    },
    {
     "description": "METWOOD INC",
     "symbol": "MTWD"
    },
    {
     "description": "METAWATER CO LTD",
     "symbol": "MTWTF"
    },
    {
     "description": "MINERALS TECHNOLOGIES INC",
     "symbol": "MTX"
    },
    {
     "description": "MTY FOOD GROUP INC",
     "symbol": "MTYFF"
    },
    {
     "description": "MASTEC INC",
     "symbol": "MTZ"
    },
    {
     "description": "MICRON TECHNOLOGY INC",
     "symbol": "MU"
    },
    {
     "description": "BLACKROCK MUNIASSETS FUND",
     "symbol": "MUA"
    },
    {
     "description": "ISHARES NATIONAL MUNI BOND E",
     "symbol": "MUB"
    },
    {
     "description": "BLACKROCK MUNIHOLDINGS CA QU",
     "symbol": "MUC"
    },
    {
     "description": "MUDRICK CAPITAL ACQUISITIO-A",
     "symbol": "MUDS"
    },
    {
     "description": "MUDRICK CAPITAL ACQUIS II",
     "symbol": "MUDSU"
    },
    {
     "description": "MUDRICK CAPITAL ACQUI -CW27",
     "symbol": "MUDSW"
    },
    {
     "description": "BLACKROCK MUNIHOLDINGS QU II",
     "symbol": "MUE"
    },
    {
     "description": "MUELLER (PAUL) CO",
     "symbol": "MUEL"
    },
    {
     "description": "MITSUBISHI UFJ FINL-SPON ADR",
     "symbol": "MUFG"
    },
    {
     "description": "MU GLOBAL HOLDING LTD",
     "symbol": "MUGH"
    },
    {
     "description": "MARUHACHI HOLDINGS CO LTD",
     "symbol": "MUHGF"
    },
    {
     "description": "BLACKROCK MUNICIPAL INCOME F",
     "symbol": "MUI"
    },
    {
     "description": "BLACKROCK MUNIHOLDINGS NJ QU",
     "symbol": "MUJ"
    },
    {
     "description": "MARUWA UNYU KIKAN CO LTD",
     "symbol": "MUKCF"
    },
    {
     "description": "MULIANG VIAGOO TECHNOLOGY IN",
     "symbol": "MULG"
    },
    {
     "description": "MULLEN AUTOMOTIVE INC",
     "symbol": "MULN"
    },
    {
     "description": "PIMCO INTERMEDIATE MUNICIPAL",
     "symbol": "MUNI"
    },
    {
     "description": "MUNDORO CAPITAL INC",
     "symbol": "MUNMF"
    },
    {
     "description": "M-UP HOLDINGS INC",
     "symbol": "MUPQF"
    },
    {
     "description": "MURPHY OIL CORP",
     "symbol": "MUR"
    },
    {
     "description": "LIGHTSPEED DISCOVERIES INC",
     "symbol": "MURCF"
    },
    {
     "description": "MURPHY CANYON ACQUISITION -A",
     "symbol": "MURF"
    },
    {
     "description": "MURPHY CANYON ACQUISITION CO",
     "symbol": "MURFU"
    },
    {
     "description": "MURPHY CANYON ACQ-CW27",
     "symbol": "MURFW"
    },
    {
     "description": "MUENCHENER RUECKVER AG-REG",
     "symbol": "MURGF"
    },
    {
     "description": "MUENCHENER RUECK-UNSPON ADR",
     "symbol": "MURGY"
    },
    {
     "description": "MURCHISON MINERALS LTD",
     "symbol": "MURMF"
    },
    {
     "description": "MURRAY & ROBERTS HOLDINGS",
     "symbol": "MURSF"
    },
    {
     "description": "MURRAY INTERNATIONAL TR-O",
     "symbol": "MURYF"
    },
    {
     "description": "MURPHY USA INC",
     "symbol": "MUSA"
    },
    {
     "description": "AMERICAN CENT MUTLISEC INCOM",
     "symbol": "MUSI"
    },
    {
     "description": "MULTI SOLUTIONS II INC",
     "symbol": "MUSS"
    },
    {
     "description": "COLUMBIA MULTI-SECTOR MUNICI",
     "symbol": "MUST"
    },
    {
     "description": "MUTUAL MERCHANT SERVICES INC",
     "symbol": "MUTM"
    },
    {
     "description": "MCEWEN MINING INC",
     "symbol": "MUX"
    },
    {
     "description": "MOTORVAC TECHNOLOGIES INC",
     "symbol": "MVAC"
    },
    {
     "description": "MINERVA INTELLIGENCE INC",
     "symbol": "MVAIF"
    },
    {
     "description": "MVB FINANCIAL CORP",
     "symbol": "MVBF"
    },
    {
     "description": "MOVIE STUDIO INC\/THE",
     "symbol": "MVES"
    },
    {
     "description": "BLACKROCK MUNIVEST FUND",
     "symbol": "MVF"
    },
    {
     "description": "MICROVISION INC",
     "symbol": "MVIS"
    },
    {
     "description": "MISSION VALLEY BANCORP",
     "symbol": "MVLY"
    },
    {
     "description": "MOUNTAIN VALLEY MD HOLDINGS",
     "symbol": "MVMDF"
    },
    {
     "description": "MOVEMENT IND CORP",
     "symbol": "MVNT"
    },
    {
     "description": "MV OIL TRUST",
     "symbol": "MVO"
    },
    {
     "description": "Roundhill Pro Sports Media and Apparel ETF",
     "symbol": "MVP"
    },
    {
     "description": "AMPLIFY THEMATIC ALL STARS",
     "symbol": "MVPS"
    },
    {
     "description": "MVP HOLDINGS INC",
     "symbol": "MVPT"
    },
    {
     "description": "MEDIVIR AB-B SHS",
     "symbol": "MVRBF"
    },
    {
     "description": "ETRACS 150% MORTGAG REIT ETN",
     "symbol": "MVRL"
    },
    {
     "description": "MICROVAST HOLDINGS INC",
     "symbol": "MVST"
    },
    {
     "description": "MICROVAST HOLD INC-CW26",
     "symbol": "MVSTW"
    },
    {
     "description": "BLACKROCK MUNIVEST FUND II",
     "symbol": "MVT"
    },
    {
     "description": "PROSHARES ULTRA MIDCAP400",
     "symbol": "MVV"
    },
    {
     "description": "MVV ENERGIE AG",
     "symbol": "MVVEF"
    },
    {
     "description": "MOOVLY MEDIA INC",
     "symbol": "MVVYF"
    },
    {
     "description": "MOVEIX INC",
     "symbol": "MVXM"
    },
    {
     "description": "MUELLER WATER PRODUCTS INC-A",
     "symbol": "MWA"
    },
    {
     "description": "MIDWAY LTD",
     "symbol": "MWAYF"
    },
    {
     "description": "MATACHEWAN CONS MINES LTD-A",
     "symbol": "MWCAF"
    },
    {
     "description": "MAWSON GOLD LTD",
     "symbol": "MWSNF"
    },
    {
     "description": "MANILA WATER COMPANY",
     "symbol": "MWTCF"
    },
    {
     "description": "MANILA WATER COMP-UNSP ADR",
     "symbol": "MWTCY"
    },
    {
     "description": "MELTWATER HOLDING NV",
     "symbol": "MWTRF"
    },
    {
     "description": "MARKETING WORLDWIDE CORP",
     "symbol": "MWWC"
    },
    {
     "description": "MINEWORX TECHNOLOGIES LTD",
     "symbol": "MWXRF"
    },
    {
     "description": "MAGNACHIP SEMICONDUCTOR CORP",
     "symbol": "MX"
    },
    {
     "description": "M.A.X. AUTOMATION SE",
     "symbol": "MXAAF"
    },
    {
     "description": "LYXOR EURO GOV BOND 1-3Y",
     "symbol": "MXBGF"
    },
    {
     "description": "MEXCO ENERGY CORP",
     "symbol": "MXC"
    },
    {
     "description": "ORBIA ADVANCE CORP SAB DE CV",
     "symbol": "MXCHF"
    },
    {
     "description": "MEXICHEM SAB DE CV-UNSP ADR",
     "symbol": "MXCHY"
    },
    {
     "description": "MAX CO LTD",
     "symbol": "MXCLF"
    },
    {
     "description": "MAXCYTE INC",
     "symbol": "MXCT"
    },
    {
     "description": "MDXHEALTH",
     "symbol": "MXDHF"
    },
    {
     "description": "NATIONWIDE MAXIMUM DIVERSIFI",
     "symbol": "MXDU"
    },
    {
     "description": "MEXICO EQUITY AND INCOME FD",
     "symbol": "MXE"
    },
    {
     "description": "MEXICO FUND INC",
     "symbol": "MXF"
    },
    {
     "description": "MOLSON COORS CANADA INC -B",
     "symbol": "MXGBF"
    },
    {
     "description": "MAXIM POWER CORP",
     "symbol": "MXGFF"
    },
    {
     "description": "ISHARES GLOBAL MATERIALS ETF",
     "symbol": "MXI"
    },
    {
     "description": "MAXLINEAR INC",
     "symbol": "MXL"
    },
    {
     "description": "MX GOLD CORP",
     "symbol": "MXLGF"
    },
    {
     "description": "MAXELL LTD",
     "symbol": "MXLLF"
    },
    {
     "description": "MAXIM RESOURCES INC",
     "symbol": "MXMSF"
    },
    {
     "description": "MAX RESOURCE CORP",
     "symbol": "MXROF"
    },
    {
     "description": "MEXUS GOLD US",
     "symbol": "MXSG"
    },
    {
     "description": "METALEX VENTURES LTD",
     "symbol": "MXTLF"
    },
    {
     "description": "MONTERO MINING AND EXPLORATI",
     "symbol": "MXTRF"
    },
    {
     "description": "MAXCOM TELECOMUNICACIONES SA",
     "symbol": "MXTSF"
    },
    {
     "description": "MAXVALU TOKAI CO LTD",
     "symbol": "MXVAF"
    },
    {
     "description": "ISHARES MDAX UCITS DE EUR A",
     "symbol": "MXXEF"
    },
    {
     "description": "MUNCY BANK FINANCIAL INC",
     "symbol": "MYBF"
    },
    {
     "description": "MEYER BURGER TECHNOLOGY AG",
     "symbol": "MYBUF"
    },
    {
     "description": "GALLAGHER SECURITY CORP",
     "symbol": "MYCLF"
    },
    {
     "description": "MYDECINE INNOVATIONS GROUP I",
     "symbol": "MYCOD"
    },
    {
     "description": "BLACKROCK MUNIYIELD FUND",
     "symbol": "MYD"
    },
    {
     "description": "MYERS INDUSTRIES INC",
     "symbol": "MYE"
    },
    {
     "description": "MYFREIGHTWORLD TECHNOLOGIES",
     "symbol": "MYFT"
    },
    {
     "description": "FIRST WESTERN FINANCIAL INC",
     "symbol": "MYFW"
    },
    {
     "description": "MYRIAD GENETICS INC",
     "symbol": "MYGN"
    },
    {
     "description": "MOUNTAIN HIGH ACQUISITIONS C",
     "symbol": "MYHI"
    },
    {
     "description": "BLACKROCK MUNIYIELD QUALITY",
     "symbol": "MYI"
    },
    {
     "description": "REKLAIM LTD",
     "symbol": "MYIDF"
    },
    {
     "description": "PLANTING HOPE CO\/THE",
     "symbol": "MYLKF"
    },
    {
     "description": "MYMD PHARMACEUTICALS INC",
     "symbol": "MYMD"
    },
    {
     "description": "MALLEE RESOURCES LTD",
     "symbol": "MYMRF"
    },
    {
     "description": "MYMETICS CORP",
     "symbol": "MYMX"
    },
    {
     "description": "BLACKROCK MUNIYIELD NY QUALI",
     "symbol": "MYN"
    },
    {
     "description": "MYNARIC AG",
     "symbol": "MYNA"
    },
    {
     "description": "MYND LIFE SCIENCES INC",
     "symbol": "MYNDF"
    },
    {
     "description": "MAINZ BIOMED BV",
     "symbol": "MYNZ"
    },
    {
     "description": "MYOMO INC",
     "symbol": "MYO"
    },
    {
     "description": "MYOVANT SCIENCES LTD",
     "symbol": "MYOV"
    },
    {
     "description": "MALAYSIA AIRPORTS HLDGS BHD",
     "symbol": "MYPRF"
    },
    {
     "description": "PLAYSTUDIOS INC",
     "symbol": "MYPS"
    },
    {
     "description": "ACIES ACQUISITION CL A -CW27",
     "symbol": "MYPSW"
    },
    {
     "description": "MYR GROUP INC\/DELAWARE",
     "symbol": "MYRG"
    },
    {
     "description": "MERYLLION RESOURCES CORP",
     "symbol": "MYRLF"
    },
    {
     "description": "MYREXIS INC",
     "symbol": "MYRX"
    },
    {
     "description": "MYRIAD INTERACTIVE MEDIA",
     "symbol": "MYRY"
    },
    {
     "description": "MY SCREEN MOBILE INC",
     "symbol": "MYSL"
    },
    {
     "description": "MYSON INC",
     "symbol": "MYSN"
    },
    {
     "description": "MONEYSUPERMARKET.COM",
     "symbol": "MYSRF"
    },
    {
     "description": "MY SIZE INC",
     "symbol": "MYSZ"
    },
    {
     "description": "MAGYAR TELEKOM TELE-SPON ADR",
     "symbol": "MYTAY"
    },
    {
     "description": "MYT NETHERLANDS PARENT BV",
     "symbol": "MYTE"
    },
    {
     "description": "TELEKOM MALAYSIA BHD",
     "symbol": "MYTEF"
    },
    {
     "description": "MU YAN TECHNOLOGY GROUP CO L",
     "symbol": "MYTG"
    },
    {
     "description": "MYTILINEOS S.A.",
     "symbol": "MYTHF"
    },
    {
     "description": "MYTILINEOS SA-UNSP ADR",
     "symbol": "MYTHY"
    },
    {
     "description": "PROSHARES SHORT MIDCAP 400",
     "symbol": "MYY"
    },
    {
     "description": "ADVANCED HUMAN IMAGING LTD",
     "symbol": "MYZQF"
    },
    {
     "description": "MAZDA MOTOR CORP",
     "symbol": "MZDAF"
    },
    {
     "description": "MAZDA MOTOR CORP-UNSPON ADR",
     "symbol": "MZDAY"
    },
    {
     "description": "MIZUHO FINANCIAL GROUP INC",
     "symbol": "MZHOF"
    },
    {
     "description": "MYZIPSOFT INC",
     "symbol": "MZPS"
    },
    {
     "description": "MIZRAHI TEFAHOT BANK LTD",
     "symbol": "MZTFF"
    },
    {
     "description": "MENZIES (JOHN) PLC",
     "symbol": "MZTLF"
    },
    {
     "description": "MAEZAWA KASEI INDUSTRIES CO",
     "symbol": "MZWAF"
    },
    {
     "description": "PROSHARES ULTSHRT MIDCAP400",
     "symbol": "MZZ"
    },
    {
     "description": "MATADOR MINING LIMITED",
     "symbol": "MZZMF"
    },
    {
     "description": "NORTH ATLANTIC ACQUISITION-A",
     "symbol": "NAAC"
    },
    {
     "description": "NORTH ATLANTIC ACQUISITION C",
     "symbol": "NAACU"
    },
    {
     "description": "NORTH ATLANTIC ACQ -CW25",
     "symbol": "NAACW"
    },
    {
     "description": "N-ABLE INC",
     "symbol": "NABL"
    },
    {
     "description": "NATIONAL AUSTRALIA BK-SP ADR",
     "symbol": "NABZY"
    },
    {
     "description": "NUVEEN CA QUAL MUNI INC FD",
     "symbol": "NAC"
    },
    {
     "description": "NATIONAL CAP BANCORP INC",
     "symbol": "NACB"
    },
    {
     "description": "IMPACT SHARES NAACP MINORITY",
     "symbol": "NACP"
    },
    {
     "description": "NEXTPOINT ACQUISITION CORP-A",
     "symbol": "NACQF"
    },
    {
     "description": "NUVEEN QUAL MUNI INCOME FD",
     "symbol": "NAD"
    },
    {
     "description": "NORTH AMERICAN DATACOM INC",
     "symbol": "NADA"
    },
    {
     "description": "NATIONAL ART EXCHANGE INC",
     "symbol": "NAEX"
    },
    {
     "description": "NORTH AMERICA FRAC SAND INC",
     "symbol": "NAFS"
    },
    {
     "description": "NAGA GROUP AG\/THE",
     "symbol": "NAGGF"
    },
    {
     "description": "NEW ASIA HOLDINGS INC",
     "symbol": "NAHD"
    },
    {
     "description": "NATURAL ALTERNATIVES INTL",
     "symbol": "NAII"
    },
    {
     "description": "DRX DLY HOMEBUILDERS BULL 3X",
     "symbol": "NAIL"
    },
    {
     "description": "NORTH ATLANTIC SMALLER COMP",
     "symbol": "NAJSF"
    },
    {
     "description": "NORTHERN DYNASTY MINERALS",
     "symbol": "NAK"
    },
    {
     "description": "NORTH AMERICAN EXPLORATION",
     "symbol": "NAMX"
    },
    {
     "description": "NUVEEN NY QUAL MUNI INC FD",
     "symbol": "NAN"
    },
    {
     "description": "NAN HAI CORP LTD",
     "symbol": "NANHF"
    },
    {
     "description": "NANOVATION MICROTECH INC",
     "symbol": "NANN"
    },
    {
     "description": "SPDR S&P NORTH AMERICAN NATU",
     "symbol": "NANR"
    },
    {
     "description": "NANOPHASE TECHNOLOGIES CORP",
     "symbol": "NANX"
    },
    {
     "description": "NANOVIBRONIX INC",
     "symbol": "NAOV"
    },
    {
     "description": "DUCKHORN PORTFOLIO INC\/THE",
     "symbol": "NAPA"
    },
    {
     "description": "INNOVATOR GROWTH 100 POWER B",
     "symbol": "NAPR"
    },
    {
     "description": "NASPERS LTD-N SHS",
     "symbol": "NAPRF"
    },
    {
     "description": "INARI MEDICAL INC",
     "symbol": "NARI"
    },
    {
     "description": "NAGOYA RAILROAD CO LTD",
     "symbol": "NARRF"
    },
    {
     "description": "NASB FINANCIAL INC",
     "symbol": "NASB"
    },
    {
     "description": "NORDIC AMERICAN TANKERS LTD",
     "symbol": "NAT"
    },
    {
     "description": "NATHAN'S FAMOUS INC",
     "symbol": "NATH"
    },
    {
     "description": "NATIONAL INSTRUMENTS CORP",
     "symbol": "NATI"
    },
    {
     "description": "NATURES SUNSHINE PRODS INC",
     "symbol": "NATR"
    },
    {
     "description": "NORTH AMER TUNGSTEN CORP LTD",
     "symbol": "NATUF"
    },
    {
     "description": "NATIONAL AUSTRALIA BANK LTD",
     "symbol": "NAUBF"
    },
    {
     "description": "NEVGOLD CORP",
     "symbol": "NAUFF"
    },
    {
     "description": "NATIONAL AMERICAN UNIVERSITY",
     "symbol": "NAUH"
    },
    {
     "description": "NAUTILUS BIOTECHNOLOGY INC",
     "symbol": "NAUT"
    },
    {
     "description": "NAVIDEA BIOPHARMACEUTICALS I",
     "symbol": "NAVB"
    },
    {
     "description": "NAVIENT CORP",
     "symbol": "NAVI"
    },
    {
     "description": "NIPPON ACTIVE VALUE FUND PLC",
     "symbol": "NAVVF"
    },
    {
     "description": "NUVEEN AZ QUAL MUNI INC FD",
     "symbol": "NAZ"
    },
    {
     "description": "NUVEEN TAX MUNI INC",
     "symbol": "NBB"
    },
    {
     "description": "NATURAL BEAUTY BIO-TECH",
     "symbol": "NBBTF"
    },
    {
     "description": "NB NEXT GEN CONNECT CONS ETF",
     "symbol": "NBCC"
    },
    {
     "description": "NEON BLOOM INC",
     "symbol": "NBCO"
    },
    {
     "description": "NB CARBON TRANS & INFRA ETF",
     "symbol": "NBCT"
    },
    {
     "description": "NO BORDERS INC",
     "symbol": "NBDR"
    },
    {
     "description": "NB DISRUPTERS ETF",
     "symbol": "NBDS"
    },
    {
     "description": "NEWAGE INC",
     "symbol": "NBEV"
    },
    {
     "description": "NIPPON BUILDING FUND INC",
     "symbol": "NBFJF"
    },
    {
     "description": "NATIONAL BANK OF GREECE",
     "symbol": "NBGIF"
    },
    {
     "description": "NBI GLB REAL ASSETS INC ETF",
     "symbol": "NBGLF"
    },
    {
     "description": "NATIONAL BANK OF GREECE SA",
     "symbol": "NBGRY"
    },
    {
     "description": "NEWBRIDGE GLOBAL VENTURES IN",
     "symbol": "NBGV"
    },
    {
     "description": "NEUBERGER BERMAN MUNICIPAL",
     "symbol": "NBH"
    },
    {
     "description": "NATIONAL BANK HOLD-CL A",
     "symbol": "NBHC"
    },
    {
     "description": "NOBIA AB-UNSPON ADR",
     "symbol": "NBIAY"
    },
    {
     "description": "NBI INC-PREFERENCE",
     "symbol": "NBIIP"
    },
    {
     "description": "NASCENT BIOTECH INC",
     "symbol": "NBIO"
    },
    {
     "description": "NEUROCRINE BIOSCIENCES INC",
     "symbol": "NBIX"
    },
    {
     "description": "National Bank",
     "symbol": "NBKCF"
    },
    {
     "description": "NESTBUILDER.COM CORP",
     "symbol": "NBLD"
    },
    {
     "description": "NOBEL CORP-CW2",
     "symbol": "NBLRF"
    },
    {
     "description": "NOBLE CORP-WT1",
     "symbol": "NBLTF"
    },
    {
     "description": "NOBLE CORP-CW1",
     "symbol": "NBLWF"
    },
    {
     "description": "NEO BATTERY MATERIALS LTD",
     "symbol": "NBMFF"
    },
    {
     "description": "NOBLE METAL GROUP",
     "symbol": "NBMLF"
    },
    {
     "description": "NORTHEAST BANK",
     "symbol": "NBN"
    },
    {
     "description": "NORDEA BANK ABP",
     "symbol": "NBNKF"
    },
    {
     "description": "NEUBERGER BERMAN NY MUNI",
     "symbol": "NBO"
    },
    {
     "description": "NB PRIVATE EQUITY PARTNERS L",
     "symbol": "NBPVF"
    },
    {
     "description": "NABORS INDUSTRIES LTD",
     "symbol": "NBR"
    },
    {
     "description": "NUBIAN RESOURCES LTD",
     "symbol": "NBRFF"
    },
    {
     "description": "NORTH BAY RESOURCES INC",
     "symbol": "NBRI"
    },
    {
     "description": "BROWN (N) GROUP PLC",
     "symbol": "NBRNF"
    },
    {
     "description": "NABRIVA THERAPEUTICS PLC",
     "symbol": "NBRV"
    },
    {
     "description": "NABORS INDUSTRIES LTD -CW26",
     "symbol": "NBRWF"
    },
    {
     "description": "NEWBERRY SPECIALTY BAKERS IN",
     "symbol": "NBRY"
    },
    {
     "description": "NEUBASE THERAPEUTICS INC",
     "symbol": "NBSE"
    },
    {
     "description": "NEWBURY STREET ACQUISITION C",
     "symbol": "NBST"
    },
    {
     "description": "NEWBURY STREET ACQUISITION C",
     "symbol": "NBSTU"
    },
    {
     "description": "NEWBURY STREET ACQ -CW27",
     "symbol": "NBSTW"
    },
    {
     "description": "N B T BANCORP INC",
     "symbol": "NBTB"
    },
    {
     "description": "NOBEL RESOURCES CORP",
     "symbol": "NBTRF"
    },
    {
     "description": "NANOBIOTIX SA - ADR",
     "symbol": "NBTX"
    },
    {
     "description": "NUBEVA TECHNOLOGIES LTD",
     "symbol": "NBVAF"
    },
    {
     "description": "NATIONWIDE BEVERAGE BOTTLING",
     "symbol": "NBVB"
    },
    {
     "description": "NUTRIPURE BEVERAGES INC",
     "symbol": "NBVG"
    },
    {
     "description": "NEUBERGER BERMAN CA MUNI",
     "symbol": "NBW"
    },
    {
     "description": "NBRGR BRMN NEX GEN CONNECT",
     "symbol": "NBXG"
    },
    {
     "description": "NOVABAY PHARMACEUTICALS INC",
     "symbol": "NBY"
    },
    {
     "description": "NIOBAY METALS INC",
     "symbol": "NBYCF"
    },
    {
     "description": "NACCO INDUSTRIES-CL A",
     "symbol": "NC"
    },
    {
     "description": "NUVEEN CALIFORNIA MUNICIPAL",
     "symbol": "NCA"
    },
    {
     "description": "NCAB GROUP AB",
     "symbol": "NCABF"
    },
    {
     "description": "NEWCOURT ACQUISITION CORP-A",
     "symbol": "NCAC"
    },
    {
     "description": "NEWCOURT ACQUISITION CORP",
     "symbol": "NCACU"
    },
    {
     "description": "NEWCOURT ACQUISITION -CW28",
     "symbol": "NCACW"
    },
    {
     "description": "NEWCORE GOLD LTD",
     "symbol": "NCAUF"
    },
    {
     "description": "BANDAI NAMCO HOLDINGS INC",
     "symbol": "NCBDF"
    },
    {
     "description": "BANDAI NAMCO HOLDINGS IN-ADR",
     "symbol": "NCBDY"
    },
    {
     "description": "NICOLET BANKSHARES INC",
     "symbol": "NCBS"
    },
    {
     "description": "NCC AB-B SHS",
     "symbol": "NCCBF"
    },
    {
     "description": "NCC GROUP PLC",
     "symbol": "NCCGF"
    },
    {
     "description": "NICODROPS INC",
     "symbol": "NCDP"
    },
    {
     "description": "NCONDEZI ENERGY LTD",
     "symbol": "NCDZF"
    },
    {
     "description": "NACEL ENERGY CORP",
     "symbol": "NCEN"
    },
    {
     "description": "NORTHCLIFF RESOURCES LTD",
     "symbol": "NCFFF"
    },
    {
     "description": "NICHIREI CORP-ADR",
     "symbol": "NCHEY"
    },
    {
     "description": "NICHICON CORP",
     "symbol": "NCHNF"
    },
    {
     "description": "NUCHEV LTD",
     "symbol": "NCHVF"
    },
    {
     "description": "NICKEL ASIA CORP",
     "symbol": "NCKAF"
    },
    {
     "description": "NORWEGIAN CRUISE LINE HOLDIN",
     "symbol": "NCLH"
    },
    {
     "description": "NITORI HOLDINGS CO LTD",
     "symbol": "NCLTF"
    },
    {
     "description": "NITORI HLDGS CO LTD-UNSP ADR",
     "symbol": "NCLTY"
    },
    {
     "description": "GOLDON RESOURCES LTD",
     "symbol": "NCMBF"
    },
    {
     "description": "NEWCREST MINING LTD",
     "symbol": "NCMGF"
    },
    {
     "description": "NEWCREST MINING LTD-SPON ADR",
     "symbol": "NCMGY"
    },
    {
     "description": "NATIONAL CINEMEDIA INC",
     "symbol": "NCMI"
    },
    {
     "description": "NUCANA PLC-ADR",
     "symbol": "NCNA"
    },
    {
     "description": "NCINO INC",
     "symbol": "NCNO"
    },
    {
     "description": "NICKEL CREEK PLATINUM CORP",
     "symbol": "NCPCF"
    },
    {
     "description": "NETCAPITAL INC",
     "symbol": "NCPL"
    },
    {
     "description": "NCP LITIGATION TRUST",
     "symbol": "NCPLL"
    },
    {
     "description": "NCR CORPORATION",
     "symbol": "NCR"
    },
    {
     "description": "NOCERA INC",
     "symbol": "NCRA"
    },
    {
     "description": "NIPPON CARBON CO LTD",
     "symbol": "NCRBF"
    },
    {
     "description": "NEW CENTURY RESOURCES CORP",
     "symbol": "NCRE"
    },
    {
     "description": "NCR Corporation",
     "symbol": "NCRRP"
    },
    {
     "description": "NCS MULTISTAGE HOLDINGS INC",
     "symbol": "NCSM"
    },
    {
     "description": "NICE LTD",
     "symbol": "NCSYF"
    },
    {
     "description": "NABTESCO CORP",
     "symbol": "NCTKF"
    },
    {
     "description": "NABTESCO CORP-UNSP ADR",
     "symbol": "NCTKY"
    },
    {
     "description": "NASCENT WINE COMPANY INC",
     "symbol": "NCTW"
    },
    {
     "description": "THE9 LTD-ADR",
     "symbol": "NCTY"
    },
    {
     "description": "VIRTUS ALLIANZGI CN & INC",
     "symbol": "NCV"
    },
    {
     "description": "VIRTUS ALLIANZGI CVTF",
     "symbol": "NCV.PRA"
    },
    {
     "description": "NICHIWA SANGYO CO LTD",
     "symbol": "NCWAF"
    },
    {
     "description": "NBC BANCORP INC",
     "symbol": "NCXS"
    },
    {
     "description": "VIRTUS ALLIANZGI CN & INC II",
     "symbol": "NCZ"
    },
    {
     "description": "VIRTUS ALLIANZGI CVTF II",
     "symbol": "NCZ.PRA"
    },
    {
     "description": "NIGHTDRAGON ACQUISITION CO-A",
     "symbol": "NDAC"
    },
    {
     "description": "NIGHTDRAGON ACQUISITION CORP",
     "symbol": "NDACU"
    },
    {
     "description": "NIGHTDRAGON ACQ -CW27",
     "symbol": "NDACW"
    },
    {
     "description": "NASDAQ INC",
     "symbol": "NDAQ"
    },
    {
     "description": "NDATALYZE CORP",
     "symbol": "NDATF"
    },
    {
     "description": "NEDBANK GROUP LTD",
     "symbol": "NDBKF"
    },
    {
     "description": "NEDBANK GROUP LTD-SPONS ADR",
     "symbol": "NDBKY"
    },
    {
     "description": "NORDIC SEMICONDUCTOR ASA",
     "symbol": "NDCVF"
    },
    {
     "description": "NEDAP N.V.",
     "symbol": "NDDLF"
    },
    {
     "description": "NITTO DENKO CORP",
     "symbol": "NDEKF"
    },
    {
     "description": "NITTO DENKO CORP-UNSPONS ADR",
     "symbol": "NDEKY"
    },
    {
     "description": "AFRICAN ENERGY METALS INC",
     "symbol": "NDENF"
    },
    {
     "description": "NOVUS ACQUISITION & DEVELOPM",
     "symbol": "NDEV"
    },
    {
     "description": "NINE DRAGONS PAPER HOLDINGS",
     "symbol": "NDGPF"
    },
    {
     "description": "NINE DRAGONS PAPER-UNSP ADR",
     "symbol": "NDGPY"
    },
    {
     "description": "NATIONWIDE DOW JONES RISK MA",
     "symbol": "NDJI"
    },
    {
     "description": "NOODLES & CO",
     "symbol": "NDLS"
    },
    {
     "description": "NEW DESTINY MINING CORP",
     "symbol": "NDMCF"
    },
    {
     "description": "NUVEEN DYNAMIC MUNI OPPORT",
     "symbol": "NDMO"
    },
    {
     "description": "NOWNEWS DIGITAL MEDIA TECHNO",
     "symbol": "NDMT"
    },
    {
     "description": "TORTOISE ENERGY INDEPENDENCE",
     "symbol": "NDP"
    },
    {
     "description": "ENDRA LIFE SCIENCES INC",
     "symbol": "NDRA"
    },
    {
     "description": "ENDRA LIFE SCIENCES INC-CW22",
     "symbol": "NDRAW"
    },
    {
     "description": "NIBE INDUSTRIER AB-B SHS",
     "symbol": "NDRBF"
    },
    {
     "description": "NORDSON CORP",
     "symbol": "NDSN"
    },
    {
     "description": "NORTHERN DATA AG",
     "symbol": "NDTAF"
    },
    {
     "description": "NDT PHARMACEUTICALS INC",
     "symbol": "NDTP"
    },
    {
     "description": "INDIVA LTD",
     "symbol": "NDVAF"
    },
    {
     "description": "NUVEEN DIVIDEND GROWTH ETF",
     "symbol": "NDVG"
    },
    {
     "description": "NEW WORLD DEVELOP -SPONS ADR",
     "symbol": "NDVLY"
    },
    {
     "description": "NDIVISION INC",
     "symbol": "NDVN"
    },
    {
     "description": "NEW DOVER CAPITAL CORP",
     "symbol": "NDVR"
    },
    {
     "description": "NETDRAGON WEBSOFT-UNSPON ADR",
     "symbol": "NDWTY"
    },
    {
     "description": "NOBLE CORP",
     "symbol": "NE"
    },
    {
     "description": "NUVEEN AMT-FR QLTY MUNI INC",
     "symbol": "NEA"
    },
    {
     "description": "NEARMAP LTD",
     "symbol": "NEAPF"
    },
    {
     "description": "BLACKROCK SHORT MATURITY BON",
     "symbol": "NEAR"
    },
    {
     "description": "NEW AMERICA ENERGY CORP",
     "symbol": "NECA"
    },
    {
     "description": "NORTHEAST COMMUNITY BANCORP",
     "symbol": "NECB"
    },
    {
     "description": "NEXTERA ENERGY INC",
     "symbol": "NEE"
    },
    {
     "description": "NEXTERA ENERGY CAPITAL",
     "symbol": "NEE.PRN"
    },
    {
     "description": "NEXTERA ENERGY INC",
     "symbol": "NEE.PRO"
    },
    {
     "description": "NEXTERA ENERGY INC",
     "symbol": "NEE.PRP"
    },
    {
     "description": "NEXTERA ENERGY INC",
     "symbol": "NEE.PRQ"
    },
    {
     "description": "NEFFS BANCORP INC\/PA",
     "symbol": "NEFB"
    },
    {
     "description": "Neffs Bancorp Inc",
     "symbol": "NEFBP"
    },
    {
     "description": "NEWEGG COMMERCE INC",
     "symbol": "NEGG"
    },
    {
     "description": "NEXGENRX INC",
     "symbol": "NEGXF"
    },
    {
     "description": "NORTHSTAR ELECTRONICS INC",
     "symbol": "NEIK"
    },
    {
     "description": "NEWMONT CORP",
     "symbol": "NEM"
    },
    {
     "description": "NEW ENERGY METALS CORP",
     "symbol": "NEMCF"
    },
    {
     "description": "INEEDMD HOLDINGS INC",
     "symbol": "NEMD"
    },
    {
     "description": "NEMETSCHEK SE-ADR",
     "symbol": "NEMKY"
    },
    {
     "description": "NEMETSCHEK SE",
     "symbol": "NEMTF"
    },
    {
     "description": "NEW ENGLAND REALTY ASSOC-LP",
     "symbol": "NEN"
    },
    {
     "description": "NORDIC ENTERTAINMENT GROUP-B",
     "symbol": "NENTF"
    },
    {
     "description": "NORDIC ENTERTAINME-UNSP ADR",
     "symbol": "NENTY"
    },
    {
     "description": "NEOGENOMICS INC",
     "symbol": "NEO"
    },
    {
     "description": "NEOGEN CORP",
     "symbol": "NEOG"
    },
    {
     "description": "NEOJAPAN INC",
     "symbol": "NEOJF"
    },
    {
     "description": "NEOMEDIA TECHNOLOGIES INC",
     "symbol": "NEOM"
    },
    {
     "description": "NEONODE INC",
     "symbol": "NEON"
    },
    {
     "description": "NEOVOLTA INC",
     "symbol": "NEOV"
    },
    {
     "description": "NEXTERA ENERGY PARTNERS LP",
     "symbol": "NEP"
    },
    {
     "description": "NEPHROS INC",
     "symbol": "NEPH"
    },
    {
     "description": "NEPTUNE WELLNESS SOLUTIONS I",
     "symbol": "NEPT"
    },
    {
     "description": "ROUNDHILL BITKRAFT ESPORTS",
     "symbol": "NERD"
    },
    {
     "description": "NUTECH ENERGY RESOURCES INC",
     "symbol": "NERG"
    },
    {
     "description": "MINERVA NEUROSCIENCES INC",
     "symbol": "NERV"
    },
    {
     "description": "NATIONAL ENERGY SERVICES REU",
     "symbol": "NESR"
    },
    {
     "description": "NORTHERN STAR RESOURCES LTD",
     "symbol": "NESRF"
    },
    {
     "description": "NATIONAL ENERGY SERVICE-CW23",
     "symbol": "NESRW"
    },
    {
     "description": "CLOUDFLARE INC - CLASS A",
     "symbol": "NET"
    },
    {
     "description": "NABORS ENERGY TRANSITION - A",
     "symbol": "NETC"
    },
    {
     "description": "NABORS ENERGY TRANSITION COR",
     "symbol": "NETC.U"
    },
    {
     "description": "NABORS ENERGY TRANSITI -CW23",
     "symbol": "NETC.WS"
    },
    {
     "description": "NETCOMPANY GROUP - UNSP ADR",
     "symbol": "NETGY"
    },
    {
     "description": "ENETI INC",
     "symbol": "NETI"
    },
    {
     "description": "NETLEASE CORPORATE REAL ESTA",
     "symbol": "NETL"
    },
    {
     "description": "NETLINK NBN TRUST",
     "symbol": "NETLF"
    },
    {
     "description": "NETOBJECTS INC",
     "symbol": "NETO"
    },
    {
     "description": "NETEASE INC",
     "symbol": "NETTF"
    },
    {
     "description": "NETWORK MEDIA GROUP INC",
     "symbol": "NETWF"
    },
    {
     "description": "ENGINE 1 TRANSFORM CLIMATE",
     "symbol": "NETZ"
    },
    {
     "description": "NEWMARKET CORP",
     "symbol": "NEU"
    },
    {
     "description": "NEUROGENESIS INC",
     "symbol": "NEUN"
    },
    {
     "description": "NUVEEN ENH MUNI VALUE FD",
     "symbol": "NEV"
    },
    {
     "description": "NEVADA COPPER CORP",
     "symbol": "NEVDF"
    },
    {
     "description": "NEVO ENERGY INC",
     "symbol": "NEVE"
    },
    {
     "description": "ABLIVA AB",
     "symbol": "NEVPF"
    },
    {
     "description": "PUXIN LTD-ADR",
     "symbol": "NEW"
    },
    {
     "description": "NEWFOUNDLAND DISCOVERY CORP",
     "symbol": "NEWDF"
    },
    {
     "description": "New England Power Co",
     "symbol": "NEWEN"
    },
    {
     "description": "NEWGEN BIOPHARMA CORP",
     "symbol": "NEWG"
    },
    {
     "description": "NEWHYDROGEN INC",
     "symbol": "NEWH"
    },
    {
     "description": "NEW PACIFIC METALS CORP",
     "symbol": "NEWP"
    },
    {
     "description": "NEW RELIC INC",
     "symbol": "NEWR"
    },
    {
     "description": "NEWTEK BUSINESS SERVICES COR",
     "symbol": "NEWT"
    },
    {
     "description": "NEWTEK BUSINESS SERVICES",
     "symbol": "NEWTL"
    },
    {
     "description": "NEWTEK BUSINESS SERVICES",
     "symbol": "NEWTZ"
    },
    {
     "description": "NEWTOPIA INC",
     "symbol": "NEWUF"
    },
    {
     "description": "NEXTIER OILFIELD SOLUTIONS I",
     "symbol": "NEX"
    },
    {
     "description": "NEXA RESOURCES SA",
     "symbol": "NEXA"
    },
    {
     "description": "NEXTECH AR SOLUTIONS CORP",
     "symbol": "NEXCF"
    },
    {
     "description": "NEXT DYNAMICS INC",
     "symbol": "NEXD"
    },
    {
     "description": "NEXIMMUNE INC",
     "symbol": "NEXI"
    },
    {
     "description": "NEXJ SYSTEMS INC",
     "symbol": "NEXJF"
    },
    {
     "description": "NEXE INNOVATIONS INC",
     "symbol": "NEXNF"
    },
    {
     "description": "NEXANS SA-UNSPONSORED ADR",
     "symbol": "NEXNY"
    },
    {
     "description": "NEXON CO LTD",
     "symbol": "NEXOF"
    },
    {
     "description": "NEXON CO LTD-UNSP ADR",
     "symbol": "NEXOY"
    },
    {
     "description": "NEXI SPA",
     "symbol": "NEXPF"
    },
    {
     "description": "NEXTDECADE CORP",
     "symbol": "NEXT"
    },
    {
     "description": "HARMONY MERGER CORP-WARRANT",
     "symbol": "NEXTW"
    },
    {
     "description": "NEXI SPA - UNSP ADR",
     "symbol": "NEXXY"
    },
    {
     "description": "NORTHFIELD BANCORP INC",
     "symbol": "NFBK"
    },
    {
     "description": "NEW FORTRESS ENERGY INC",
     "symbol": "NFE"
    },
    {
     "description": "NEW FRONTIER ENERGY INC",
     "symbol": "NFEI"
    },
    {
     "description": "NATIONAL FUEL GAS CO",
     "symbol": "NFG"
    },
    {
     "description": "NEW FOUND GOLD CORP",
     "symbol": "NFGC"
    },
    {
     "description": "BEIJINGWEST INDUSTRIES INTER",
     "symbol": "NFGRF"
    },
    {
     "description": "VIRTUS DVD INTRST & PRM STR",
     "symbol": "NFJ"
    },
    {
     "description": "EXPLOITS DISCOVERY CORP",
     "symbol": "NFLDF"
    },
    {
     "description": "VIRTUS NEWFLEET MULTI-SECTOR",
     "symbol": "NFLT"
    },
    {
     "description": "NETFLIX INC",
     "symbol": "NFLX"
    },
    {
     "description": "INFINITE ACQUISITION CO-CL A",
     "symbol": "NFNT"
    },
    {
     "description": "INFINITE ACQUISITION CORP",
     "symbol": "NFNT.U"
    },
    {
     "description": "INFINITE ACQUISITION -CW23",
     "symbol": "NFNT.WS"
    },
    {
     "description": "NFON AG",
     "symbol": "NFONF"
    },
    {
     "description": "NORTHFIELD PRECISION INSTR",
     "symbol": "NFPC"
    },
    {
     "description": "NISSIN FOODS HOLDINGS CO LTD",
     "symbol": "NFPDF"
    },
    {
     "description": "FLEXSHARES STOXX GLOBAL BROA",
     "symbol": "NFRA"
    },
    {
     "description": "NFINANSE INC",
     "symbol": "NFSE"
    },
    {
     "description": "NOFIRE TECHNOLOGIES INC",
     "symbol": "NFTI"
    },
    {
     "description": "FIRST TRUST INDIA NIFTY 50 E",
     "symbol": "NFTY"
    },
    {
     "description": "Defiance Digital Revolution",
     "symbol": "NFTZ"
    },
    {
     "description": "NFI GROUP INC",
     "symbol": "NFYEF"
    },
    {
     "description": "ENPHYS ACQUISITION CORP",
     "symbol": "NFYS"
    },
    {
     "description": "ENPHYS ACQUISITION CORP",
     "symbol": "NFYS.U"
    },
    {
     "description": "ENPHYS ACQUISITION -CW24",
     "symbol": "NFYS.WS"
    },
    {
     "description": "NOVAGOLD RESOURCES INC",
     "symbol": "NG"
    },
    {
     "description": "NORTHERN GENESIS ACQUISITI-A",
     "symbol": "NGC"
    },
    {
     "description": "NORTHERN GENESIS ACQUISITION",
     "symbol": "NGC.U"
    },
    {
     "description": "NORTHERN GENESIS ACQ -CW27",
     "symbol": "NGC.WS"
    },
    {
     "description": "NEW GENERATION CONSUMER GROU",
     "symbol": "NGCG"
    },
    {
     "description": "NAGACORP LTD",
     "symbol": "NGCRF"
    },
    {
     "description": "NAGACORP LTD-UNSP ADR",
     "symbol": "NGCRY"
    },
    {
     "description": "NEW GOLD INC",
     "symbol": "NGD"
    },
    {
     "description": "GLOBAL X MSCI NIGERIA ETF",
     "symbol": "NGE"
    },
    {
     "description": "NGE CAPITAL LTD",
     "symbol": "NGELF"
    },
    {
     "description": "NERVGEN PHARMA CORP",
     "symbol": "NGENF"
    },
    {
     "description": "NEW GLOBAL ENERGY INC",
     "symbol": "NGEY"
    },
    {
     "description": "NATIONAL GRID PLC-SP ADR",
     "symbol": "NGG"
    },
    {
     "description": "NATIONAL GRID PLC",
     "symbol": "NGGTF"
    },
    {
     "description": "NOVA GROUP HOLDINGS LTD",
     "symbol": "NGHDF"
    },
    {
     "description": "NGK INSULATORS LTD",
     "symbol": "NGKIF"
    },
    {
     "description": "NAGANO KEIKI CO LTD",
     "symbol": "NGKKF"
    },
    {
     "description": "NGK SPARK PLUG CO LTD",
     "symbol": "NGKSF"
    },
    {
     "description": "NGK SPARK PLUG-UNSPON ADR",
     "symbol": "NGKSY"
    },
    {
     "description": "NGL ENERGY PARTNERS LP",
     "symbol": "NGL"
    },
    {
     "description": "NGL ENERGY PARTNERS LP",
     "symbol": "NGL.PRB"
    },
    {
     "description": "NGL ENERGY PARTNERS LP",
     "symbol": "NGL.PRC"
    },
    {
     "description": "NAGAILEBEN CO LTD",
     "symbol": "NGLBF"
    },
    {
     "description": "NEVADA CANYON GOLD CORP",
     "symbol": "NGLD"
    },
    {
     "description": "ANGLO AMERICAN PLC-SPONS ADR",
     "symbol": "NGLOY"
    },
    {
     "description": "NGM BIOPHARMACEUTICALS INC",
     "symbol": "NGM"
    },
    {
     "description": "NEXT GENERATION MANAGEMENT C",
     "symbol": "NGMC"
    },
    {
     "description": "NUGEN MEDICAL DEVICES INC",
     "symbol": "NGMDF"
    },
    {
     "description": "NEOGAMES SA",
     "symbol": "NGMS"
    },
    {
     "description": "NORTHERN GROWERS LLC-CL B",
     "symbol": "NGOOB"
    },
    {
     "description": "NORTHERN GROWERS LLC - CL C",
     "symbol": "NGOOL"
    },
    {
     "description": "NORTHERN GROWERS LLC - A",
     "symbol": "NGOWL"
    },
    {
     "description": "NORTHERN GRAPHITE CORP",
     "symbol": "NGPHF"
    },
    {
     "description": "NATIONAL GRAPHITE CORP",
     "symbol": "NGRC"
    },
    {
     "description": "NAGARRO SE",
     "symbol": "NGRRF"
    },
    {
     "description": "NATURAL GAS SERVICES GROUP",
     "symbol": "NGS"
    },
    {
     "description": "NIGHTFOOD HOLDINGS INC",
     "symbol": "NGTF"
    },
    {
     "description": "NEW GUINEA GOLD CORP",
     "symbol": "NGUGF"
    },
    {
     "description": "NATURAL GROCERS BY VITAMIN C",
     "symbol": "NGVC"
    },
    {
     "description": "INGEVITY CORP",
     "symbol": "NGVT"
    },
    {
     "description": "NGEX MINERALS LTD",
     "symbol": "NGXXF"
    },
    {
     "description": "NANTHEALTH INC",
     "symbol": "NH"
    },
    {
     "description": "NORTH ARROW MINERALS INC",
     "symbol": "NHAWF"
    },
    {
     "description": "NICHIBAN CO LTD",
     "symbol": "NHBAF"
    },
    {
     "description": "NATIONAL HEALTHCARE CORP",
     "symbol": "NHC"
    },
    {
     "description": "NHC COMMUNICATIONS INC",
     "symbol": "NHCMF"
    },
    {
     "description": "NIHON CHOUZAI CO LTD",
     "symbol": "NHCZF"
    },
    {
     "description": "NATURAL HEALTH FARM HOLDINGS",
     "symbol": "NHEL"
    },
    {
     "description": "NH FOODS LTD",
     "symbol": "NHFOF"
    },
    {
     "description": "NEW HORIZON GROUP INC",
     "symbol": "NHGP"
    },
    {
     "description": "NH HOTEL GROUP SA",
     "symbol": "NHHEF"
    },
    {
     "description": "FUELPOSITIVE CORP",
     "symbol": "NHHHF"
    },
    {
     "description": "NORTHSTAR HEALTHCARE INCOME",
     "symbol": "NHHS"
    },
    {
     "description": "NATL HEALTH INVESTORS INC",
     "symbol": "NHI"
    },
    {
     "description": "NEWHOLD INVESTMENT CORP II-A",
     "symbol": "NHIC"
    },
    {
     "description": "NEWHOLD INVESTMENT CORP II",
     "symbol": "NHICU"
    },
    {
     "description": "NEWHOLD INVESTM II-A -CW23",
     "symbol": "NHICW"
    },
    {
     "description": "NICHI-IKO PHARMACEUTICAL CO",
     "symbol": "NHKFF"
    },
    {
     "description": "NHK SPRING CO LTD",
     "symbol": "NHKGF"
    },
    {
     "description": "NHALE INC",
     "symbol": "NHLE"
    },
    {
     "description": "NATIONAL HEALTHCARE LOGISTIC",
     "symbol": "NHLG"
    },
    {
     "description": "NOUVEAU HOLDINGS INC",
     "symbol": "NHLI"
    },
    {
     "description": "NAHL GROUP PLC",
     "symbol": "NHLPF"
    },
    {
     "description": "NIHON M&A CENTER HOLDINGS IN",
     "symbol": "NHMAF"
    },
    {
     "description": "NATE'S FOOD CO",
     "symbol": "NHMD"
    },
    {
     "description": "NAVER CORP",
     "symbol": "NHNCF"
    },
    {
     "description": "NIHON KOHDEN CORP",
     "symbol": "NHNKF"
    },
    {
     "description": "NIHON KOHDEN CORP-ADR",
     "symbol": "NHNKY"
    },
    {
     "description": "SOMPO HOLDINGS INC",
     "symbol": "NHOLF"
    },
    {
     "description": "NEDERMAN HOLDING AB",
     "symbol": "NHOXF"
    },
    {
     "description": "NEW HOPE CORP LTD",
     "symbol": "NHPEF"
    },
    {
     "description": "LUMIERA HEALTH INC",
     "symbol": "NHPHF"
    },
    {
     "description": "NEUBERGER BERMAN HIGH YIELD",
     "symbol": "NHS"
    },
    {
     "description": "Neuberger Berman High Yield Strategies Fund",
     "symbol": "NHS.RT"
    },
    {
     "description": "NATURAL HEALTH TRENDS CORP",
     "symbol": "NHTC"
    },
    {
     "description": "NORTHEAST DEVELOPMENT CORP I",
     "symbol": "NHVP"
    },
    {
     "description": "NORSK HYDRO AS-SPONS ADR",
     "symbol": "NHYDY"
    },
    {
     "description": "NATURAL HARMONY FOODS INC",
     "symbol": "NHYF"
    },
    {
     "description": "NORSK HYDRO ASA",
     "symbol": "NHYKF"
    },
    {
     "description": "NEW HORIZON HEALTH LTD",
     "symbol": "NHZHF"
    },
    {
     "description": "NISOURCE INC",
     "symbol": "NI"
    },
    {
     "description": "NISOURCE INC",
     "symbol": "NI.PRB"
    },
    {
     "description": "NIBE INDUSTRIER - UNSP ADR",
     "symbol": "NIABY"
    },
    {
     "description": "NIITAKA CO LTD",
     "symbol": "NIAKF"
    },
    {
     "description": "IPATH BLOOMBERG COCOA SUBIND",
     "symbol": "NIB"
    },
    {
     "description": "NICE LTD - SPON ADR",
     "symbol": "NICE"
    },
    {
     "description": "NICHIAS CORP",
     "symbol": "NICFF"
    },
    {
     "description": "NITCHES INC",
     "symbol": "NICH"
    },
    {
     "description": "NICHOLAS FINANCIAL INC",
     "symbol": "NICK"
    },
    {
     "description": "CLASS 1 NICKEL AND TECHNOLOG",
     "symbol": "NICLF"
    },
    {
     "description": "NICKEL MINES LTD",
     "symbol": "NICMF"
    },
    {
     "description": "NICO RESOURCES LTD",
     "symbol": "NICOF"
    },
    {
     "description": "NICOX SA",
     "symbol": "NICXF"
    },
    {
     "description": "NUVEEN INT DUR MUNI TERM FD",
     "symbol": "NID"
    },
    {
     "description": "NORTHEAST INDIANA BANCORP",
     "symbol": "NIDB"
    },
    {
     "description": "VIRTUS ALLIANZGI EQ & CONV",
     "symbol": "NIE"
    },
    {
     "description": "NIFCO INC",
     "symbol": "NIFCF"
    },
    {
     "description": "NIFCO INC-UNSPONSORED ADR",
     "symbol": "NIFCY"
    },
    {
     "description": "DIREXION FALLEN KNIVES ETF",
     "symbol": "NIFE"
    },
    {
     "description": "VIDEO RIVER NETWORKS INC",
     "symbol": "NIHK"
    },
    {
     "description": "NEW INFINITY HOLDINGS LTD",
     "symbol": "NIHL"
    },
    {
     "description": "NIPPON PAPER INDUSTRIES CO L",
     "symbol": "NIJPF"
    },
    {
     "description": "NICKEL ROCK RESOURCES INC",
     "symbol": "NIKLF"
    },
    {
     "description": "NILAM RESOURCES INC",
     "symbol": "NILA"
    },
    {
     "description": "BITNILE HOLDINGS INC",
     "symbol": "NILE"
    },
    {
     "description": "SURGE BATTERY METALS INC",
     "symbol": "NILIF"
    },
    {
     "description": "NILAR INTERNATIONAL AB",
     "symbol": "NILRF"
    },
    {
     "description": "MMC NORILSK NICKEL PJSC-ADR",
     "symbol": "NILSY"
    },
    {
     "description": "NUVEEN SEL MAT MUNI FD",
     "symbol": "NIM"
    },
    {
     "description": "NISOURCE INC",
     "symbol": "NIMC"
    },
    {
     "description": "NON-INVASIVE MONITORING SYS",
     "symbol": "NIMU"
    },
    {
     "description": "NINE ENERGY SERVICE INC",
     "symbol": "NINE"
    },
    {
     "description": "NAMI CORP",
     "symbol": "NINK"
    },
    {
     "description": "NIKON CORP",
     "symbol": "NINOF"
    },
    {
     "description": "NIKON CORP PLC-UNSPON ADR",
     "symbol": "NINOY"
    },
    {
     "description": "NINETY ONE PLC",
     "symbol": "NINTF"
    },
    {
     "description": "NIO INC - ADR",
     "symbol": "NIO"
    },
    {
     "description": "NIOCORP DEVELOPMENTS LTD",
     "symbol": "NIOBF"
    },
    {
     "description": "NIOCAN INC",
     "symbol": "NIOCF"
    },
    {
     "description": "PLATO GOLD CORP",
     "symbol": "NIOVF"
    },
    {
     "description": "NIPPON KONPO UNYU SOKO CO",
     "symbol": "NIPKF"
    },
    {
     "description": "NH FOODS LTD - UNSPONS ADR",
     "symbol": "NIPMY"
    },
    {
     "description": "NEC CORP",
     "symbol": "NIPNF"
    },
    {
     "description": "JAPAN HOTEL REIT INVESTMENT",
     "symbol": "NIPOF"
    },
    {
     "description": "NIPPON ACCOMMODATIONS FUND",
     "symbol": "NIPPF"
    },
    {
     "description": "NUVEEN INT DUR QU MUN TRM FD",
     "symbol": "NIQ"
    },
    {
     "description": "SPORTSHERO LTD",
     "symbol": "NIROF"
    },
    {
     "description": "NISUN INTERNATIONAL ENTERPRI",
     "symbol": "NISN"
    },
    {
     "description": "NOVOLIPETSK STEEL-GDR 144A",
     "symbol": "NISQY"
    },
    {
     "description": "NISSIN ELECTRIC CO LTD",
     "symbol": "NISSF"
    },
    {
     "description": "NIPPON STEEL CORP",
     "symbol": "NISTF"
    },
    {
     "description": "NIPPON SUISAN KAISH-UNSP ADR",
     "symbol": "NISUY"
    },
    {
     "description": "HANNA CAPITAL CORP",
     "symbol": "NITMF"
    },
    {
     "description": "NIU TECHNOLOGIES-SPONS ADR",
     "symbol": "NIU"
    },
    {
     "description": "NSI NV",
     "symbol": "NIUWF"
    },
    {
     "description": "INNOVATOR GROWTH 100 POWER B",
     "symbol": "NJAN"
    },
    {
     "description": "NIDEC CORPORATION-SPON ADR",
     "symbol": "NJDCY"
    },
    {
     "description": "NOJIMA CO LTD",
     "symbol": "NJMLF"
    },
    {
     "description": "NICHOLS PLC",
     "symbol": "NJMVF"
    },
    {
     "description": "NEW JERSEY RESOURCES CORP",
     "symbol": "NJR"
    },
    {
     "description": "INNOVATOR GROWTH 100 POWER B",
     "symbol": "NJUL"
    },
    {
     "description": "NIKE INC -CL B",
     "symbol": "NKE"
    },
    {
     "description": "NUVEEN GA QUAL MUNI INC FD",
     "symbol": "NKG"
    },
    {
     "description": "NEVADA KING GOLD CORP",
     "symbol": "NKGFF"
    },
    {
     "description": "NIKOLA CORP",
     "symbol": "NKLA"
    },
    {
     "description": "NORITSU KOKI CO LTD",
     "symbol": "NKOKF"
    },
    {
     "description": "PALLADIUM ONE MINING INC",
     "symbol": "NKORF"
    },
    {
     "description": "LABRADOR GOLD CORP",
     "symbol": "NKOSF"
    },
    {
     "description": "NIKKO ETF - TOPIX",
     "symbol": "NKOUF"
    },
    {
     "description": "NOKIAN RENKAAT OYJ",
     "symbol": "NKRKF"
    },
    {
     "description": "NOKIAN TYRES OYJ-UNSPON ADR",
     "symbol": "NKRKY"
    },
    {
     "description": "NIKRON TECHNOLOGIES INC",
     "symbol": "NKRN"
    },
    {
     "description": "NIKO RESOURCES LTD",
     "symbol": "NKRSF"
    },
    {
     "description": "NATIONAL BANKSHARES INC\/VA",
     "symbol": "NKSH"
    },
    {
     "description": "NORSKE SKOGINDUSTRIER ASA",
     "symbol": "NKSJF"
    },
    {
     "description": "NEKTAR THERAPEUTICS",
     "symbol": "NKTR"
    },
    {
     "description": "NKARTA INC",
     "symbol": "NKTX"
    },
    {
     "description": "NKWE PLATINUM LTD",
     "symbol": "NKWEF"
    },
    {
     "description": "OCEANIC WIND ENERGY INC",
     "symbol": "NKWFF"
    },
    {
     "description": "NUVEEN CA AMT-FR MUNI INC FD",
     "symbol": "NKX"
    },
    {
     "description": "NAIKAI ZOSEN CORP",
     "symbol": "NKZFF"
    },
    {
     "description": "NL INDUSTRIES",
     "symbol": "NL"
    },
    {
     "description": "NUONCOLOGY LABS INC",
     "symbol": "NLAB"
    },
    {
     "description": "NUTRALIFE BIOSCIENCES INC",
     "symbol": "NLBS"
    },
    {
     "description": "NEWLAKE CAPITAL PARTNERS INC",
     "symbol": "NLCP"
    },
    {
     "description": "NILFISK HOLDING A\/S",
     "symbol": "NLFKF"
    },
    {
     "description": "NORTHERN LION GOLD CORP",
     "symbol": "NLGCF"
    },
    {
     "description": "NORTHERN LIGHTS ACQUISITI-A",
     "symbol": "NLIT"
    },
    {
     "description": "NORTHERN LIGHTS ACQUISITION",
     "symbol": "NLITU"
    },
    {
     "description": "NORTHERN LIGHTS ACQUIS -CW22",
     "symbol": "NLITW"
    },
    {
     "description": "NILORNGRUPPEN AB-B SHS",
     "symbol": "NLLGF"
    },
    {
     "description": "NEL ASA",
     "symbol": "NLLSF"
    },
    {
     "description": "NEL ASA-UNSP ADR",
     "symbol": "NLLSY"
    },
    {
     "description": "NATIONAL LAMPOON INC",
     "symbol": "NLMP"
    },
    {
     "description": "NORTONLIFELOCK INC",
     "symbol": "NLOK"
    },
    {
     "description": "NOBLE MINERAL EXPLORATION IN",
     "symbol": "NLPXF"
    },
    {
     "description": "VANECK URANIUM + NUCLEAR ENE",
     "symbol": "NLR"
    },
    {
     "description": "NORTHERN LIGHTS RESOURCES CO",
     "symbol": "NLRCF"
    },
    {
     "description": "NAUTILUS INC",
     "symbol": "NLS"
    },
    {
     "description": "NIELSEN HOLDINGS PLC",
     "symbol": "NLSN"
    },
    {
     "description": "NLS PHARMACEUTICS LTD",
     "symbol": "NLSP"
    },
    {
     "description": "NLS PHARMACEUTICS LTD -CW25",
     "symbol": "NLSPW"
    },
    {
     "description": "NETLIST INC",
     "symbol": "NLST"
    },
    {
     "description": "NOLATO AB-B SHS",
     "symbol": "NLTBF"
    },
    {
     "description": "NEOLEUKIN THERAPEUTICS INC",
     "symbol": "NLTX"
    },
    {
     "description": "NEW LEAF VENTURES INC",
     "symbol": "NLVVF"
    },
    {
     "description": "ANNALY CAPITAL MANAGEMENT IN",
     "symbol": "NLY"
    },
    {
     "description": "ANNALY CAPITAL MGMT",
     "symbol": "NLY.PRF"
    },
    {
     "description": "ANNALY CAPITAL MGMT",
     "symbol": "NLY.PRG"
    },
    {
     "description": "ANNALY CAPITAL MGMT",
     "symbol": "NLY.PRI"
    },
    {
     "description": "NAVIOS MARITIME HOLDINGS INC",
     "symbol": "NM"
    },
    {
     "description": "NAVIOS MARITIME HOLDINGS",
     "symbol": "NM.PRG"
    },
    {
     "description": "NAVIOS MARITIME HOLDINGS",
     "symbol": "NM.PRH"
    },
    {
     "description": "NUVEEN MULTI-ASSET INCOME",
     "symbol": "NMAI"
    },
    {
     "description": "NEMAK SAB DE CV",
     "symbol": "NMAKF"
    },
    {
     "description": "NMB FINANCIAL CORP",
     "symbol": "NMBF"
    },
    {
     "description": "NUVEEN MUNICIPAL CREDIT OPP",
     "symbol": "NMCO"
    },
    {
     "description": "NMC INC",
     "symbol": "NMCX"
    },
    {
     "description": "NEONMIND BIOSCIENCES INC",
     "symbol": "NMDBD"
    },
    {
     "description": "NOMURA REAL ESTATE HOLDINGS",
     "symbol": "NMEHF"
    },
    {
     "description": "NORTHERN MINERALS & EXPLORAT",
     "symbol": "NMEX"
    },
    {
     "description": "NEW MOUNTAIN FINANCE CORP",
     "symbol": "NMFC"
    },
    {
     "description": "NOUVEAU MONDE GRAPHITE INC",
     "symbol": "NMG"
    },
    {
     "description": "NEOMAGIC CORP",
     "symbol": "NMGC"
    },
    {
     "description": "NANO MAGIC INC",
     "symbol": "NMGX"
    },
    {
     "description": "NMC HEALTH PLC - UNSP ADR",
     "symbol": "NMHLY"
    },
    {
     "description": "NUVEEN MUNI INC FD",
     "symbol": "NMI"
    },
    {
     "description": "NMI HOLDINGS INC-CLASS A",
     "symbol": "NMIH"
    },
    {
     "description": "NIAGARA MOHAWK POWER",
     "symbol": "NMK.PRB"
    },
    {
     "description": "NIAGARA MOHAWK POWER",
     "symbol": "NMK.PRC"
    },
    {
     "description": "CONTROLADORA NEMAK SAB DE CV",
     "symbol": "NMKCF"
    },
    {
     "description": "NB MLP & ENERGY INCOME",
     "symbol": "NML"
    },
    {
     "description": "NOVA MENTIS LIFE SCIENCE COR",
     "symbol": "NMLSF"
    },
    {
     "description": "NAVIOS MARITIME PARTNERS LP",
     "symbol": "NMM"
    },
    {
     "description": "NORTH MOUNTAIN MERGER CORP-A",
     "symbol": "NMMC"
    },
    {
     "description": "NMC HEALTH PLC",
     "symbol": "NMMCF"
    },
    {
     "description": "NORTH MOUNTAIN MERGER CORP",
     "symbol": "NMMCU"
    },
    {
     "description": "NORTH MOUNTAIN MERGER -CW25",
     "symbol": "NMMCW"
    },
    {
     "description": "NOMURA REAL ESTATE MASTER FU",
     "symbol": "NMMRF"
    },
    {
     "description": "NUMINUS WELLNESS INC -CW22",
     "symbol": "NMNSF"
    },
    {
     "description": "NUMINUS WELLNESS INC -CW23",
     "symbol": "NMNWF"
    },
    {
     "description": "NATIONSMARK NEXGEN",
     "symbol": "NMNX"
    },
    {
     "description": "NORTEC MINERALS CORP",
     "symbol": "NMNZF"
    },
    {
     "description": "NEMO MOTORS CORP",
     "symbol": "NMOC"
    },
    {
     "description": "Niagara Mohawk Holdings Inc",
     "symbol": "NMPWP"
    },
    {
     "description": "NOMURA HOLDINGS INC-SPON ADR",
     "symbol": "NMR"
    },
    {
     "description": "NEMAURA MEDICAL INC",
     "symbol": "NMRD"
    },
    {
     "description": "NAMIBIA CRITICAL METALS INC",
     "symbol": "NMREF"
    },
    {
     "description": "NEWMARK GROUP INC-CLASS A",
     "symbol": "NMRK"
    },
    {
     "description": "NATIONAL MILK RECORDS PLC",
     "symbol": "NMRPF"
    },
    {
     "description": "NUVEEN MN QUAL MUNI INC FD",
     "symbol": "NMS"
    },
    {
     "description": "NUTRITION MGMT SVCS CO-CL A",
     "symbol": "NMSCA"
    },
    {
     "description": "LIFEIST WELLNESS INC -CW23",
     "symbol": "NMSEF"
    },
    {
     "description": "NISHIMATSUYA CHAIN CO LTD",
     "symbol": "NMSYF"
    },
    {
     "description": "NUVEEN MA QUAL MUNI INC FD",
     "symbol": "NMT"
    },
    {
     "description": "NEUROONE MEDICAL TECHNOLOGIE",
     "symbol": "NMTC"
    },
    {
     "description": "NEW AGE METALS INC",
     "symbol": "NMTLF"
    },
    {
     "description": "9 METERS BIOPHARMA INC",
     "symbol": "NMTR"
    },
    {
     "description": "NIMTECH CORP",
     "symbol": "NMTT"
    },
    {
     "description": "NET MEDICAL XPRESS SOLUTIONS",
     "symbol": "NMXS"
    },
    {
     "description": "NAMSYS INC",
     "symbol": "NMYSF"
    },
    {
     "description": "NUVEEN MUNI HIGH INC OPP FD",
     "symbol": "NMZ"
    },
    {
     "description": "NEXTNAV INC",
     "symbol": "NN"
    },
    {
     "description": "NEXTNAV INC -CW27",
     "symbol": "NNAVW"
    },
    {
     "description": "NEW MOMENTUM CORP",
     "symbol": "NNAX"
    },
    {
     "description": "NANOBAC PHARMACEUTICALS INC",
     "symbol": "NNBP"
    },
    {
     "description": "NN INC",
     "symbol": "NNBR"
    },
    {
     "description": "NANOBIOTIX",
     "symbol": "NNBXF"
    },
    {
     "description": "NISSAN CHEMICAL INDUSTRIES",
     "symbol": "NNCHF"
    },
    {
     "description": "NISSAN CHEMICAL-UNSPON ADR",
     "symbol": "NNCHY"
    },
    {
     "description": "NANOSONICS LTD",
     "symbol": "NNCSF"
    },
    {
     "description": "NORANDA INCOME FUND",
     "symbol": "NNDIF"
    },
    {
     "description": "NANO DIMENSION LTD - ADR",
     "symbol": "NNDM"
    },
    {
     "description": "NIDEC CORP",
     "symbol": "NNDNF"
    },
    {
     "description": "NANOFORCE INC",
     "symbol": "NNFC"
    },
    {
     "description": "NONGFU SPRING CO LTD-H",
     "symbol": "NNFSF"
    },
    {
     "description": "NANOFILM TECHNOLOGIES INTERN",
     "symbol": "NNFTF"
    },
    {
     "description": "NN GROUP NV",
     "symbol": "NNGPF"
    },
    {
     "description": "NANOREPRO AG",
     "symbol": "NNGRF"
    },
    {
     "description": "NN GROUP NV - UNSPON ADR",
     "symbol": "NNGRY"
    },
    {
     "description": "TESORO MINERALS CORP",
     "symbol": "NNGVF"
    },
    {
     "description": "NELNET INC-CL A",
     "symbol": "NNI"
    },
    {
     "description": "NANKAI ELECTRIC RAILWAY CO",
     "symbol": "NNKEF"
    },
    {
     "description": "NOVA NET LEASE REIT",
     "symbol": "NNLRF"
    },
    {
     "description": "NANOLOGIX INC",
     "symbol": "NNLX"
    },
    {
     "description": "NEARCTIC NICKEL MINES INC",
     "symbol": "NNMIF"
    },
    {
     "description": "NINE ENTERTAINMENT CO HOLDIN",
     "symbol": "NNMTF"
    },
    {
     "description": "NANOMIX CORP",
     "symbol": "NNMX"
    },
    {
     "description": "NATIONAL RETAIL PROPERTIES",
     "symbol": "NNN"
    },
    {
     "description": "NANOCO GROUP PLC",
     "symbol": "NNOCF"
    },
    {
     "description": "NANO ONE MATERIALS CORP",
     "symbol": "NNOMF"
    },
    {
     "description": "NANO-X IMAGING LTD",
     "symbol": "NNOX"
    },
    {
     "description": "NINEPOINT ENERGY FUND",
     "symbol": "NNPEF"
    },
    {
     "description": "NEINOR HOMES SA",
     "symbol": "NNRHF"
    },
    {
     "description": "NNRF INC",
     "symbol": "NNRI"
    },
    {
     "description": "NRC GROUP ASA",
     "symbol": "NNRRF"
    },
    {
     "description": "NUTRANOMICS INC",
     "symbol": "NNRX"
    },
    {
     "description": "NEC NETWORKS & SYSTEM INTEGR",
     "symbol": "NNSCF"
    },
    {
     "description": "NANOSAVE TECHNOLOGIES INC",
     "symbol": "NNSV"
    },
    {
     "description": "NOCOPI TECHNOLOGIES INC",
     "symbol": "NNUP"
    },
    {
     "description": "HAWAIIAN MACADAMIA NUT ORCHA",
     "symbol": "NNUTU"
    },
    {
     "description": "NANOVIRICIDES INC",
     "symbol": "NNVC"
    },
    {
     "description": "NANOVEU LTD",
     "symbol": "NNVUF"
    },
    {
     "description": "NORTH WEST CO INC\/THE",
     "symbol": "NNWWF"
    },
    {
     "description": "NANOXPLORE INC",
     "symbol": "NNXPF"
    },
    {
     "description": "NEXITY SA - ADR UNSP",
     "symbol": "NNXXY"
    },
    {
     "description": "NUVEEN NEW YORK MUNICIPAL VA",
     "symbol": "NNY"
    },
    {
     "description": "NANYA TECHNOLOGY CORPORATION",
     "symbol": "NNYAF"
    },
    {
     "description": "NORTHAMERICAN ENERGY GROUP C",
     "symbol": "NNYR"
    },
    {
     "description": "NORTH AMERICAN CONSTRUCTION",
     "symbol": "NOA"
    },
    {
     "description": "NATURAL ORDER ACQUISITION CO",
     "symbol": "NOAC"
    },
    {
     "description": "NATURAL ORDER ACQUISITION CO",
     "symbol": "NOACU"
    },
    {
     "description": "NATURAL ORDER ACQ -CW25",
     "symbol": "NOACW"
    },
    {
     "description": "NOAH HOLDINGS LTD-SPON ADS",
     "symbol": "NOAH"
    },
    {
     "description": "NORTH BUD FARMS INC",
     "symbol": "NOBDF"
    },
    {
     "description": "NOBLE GROUP LTD",
     "symbol": "NOBGF"
    },
    {
     "description": "NOBLE GROUP LTD-UNSPON ADR",
     "symbol": "NOBGY"
    },
    {
     "description": "NOBILITY HOMES INC",
     "symbol": "NOBH"
    },
    {
     "description": "PROSHARES S&P 500 DIVIDEND A",
     "symbol": "NOBL"
    },
    {
     "description": "NORTHROP GRUMMAN CORP",
     "symbol": "NOC"
    },
    {
     "description": "NORDEN CROWN METALS CORP",
     "symbol": "NOCRF"
    },
    {
     "description": "NORSEMAN SILVER INC",
     "symbol": "NOCSF"
    },
    {
     "description": "INNOVATOR GROWTH-100 POWER B",
     "symbol": "NOCT"
    },
    {
     "description": "NORTH DALLAS BANK & TRUST CO",
     "symbol": "NODB"
    },
    {
     "description": "NODECHAIN INC",
     "symbol": "NODC"
    },
    {
     "description": "NI HOLDINGS INC",
     "symbol": "NODK"
    },
    {
     "description": "NEW ORIENTAL ENERGY & CHEMIC",
     "symbol": "NOEC"
    },
    {
     "description": "NORMA GROUP SE",
     "symbol": "NOEJF"
    },
    {
     "description": "NOEVIR HOLDING CO",
     "symbol": "NOEVF"
    },
    {
     "description": "NOF CORP",
     "symbol": "NOFCF"
    },
    {
     "description": "NORTHERN OIL AND GAS INC",
     "symbol": "NOG"
    },
    {
     "description": "NONGFU SPRING CO - UNSP ADR",
     "symbol": "NOGFY"
    },
    {
     "description": "NOHO PARTNERS OYJ",
     "symbol": "NOHHF"
    },
    {
     "description": "NOVATION HOLDINGS INC",
     "symbol": "NOHO"
    },
    {
     "description": "NOKIA CORP-SPON ADR",
     "symbol": "NOK"
    },
    {
     "description": "NOKIA OYJ",
     "symbol": "NOKBF"
    },
    {
     "description": "NOK AIRLINES CO LTD-NVDR",
     "symbol": "NOKFF"
    },
    {
     "description": "NOK AIRLINES CO LTD-FOREIGN",
     "symbol": "NOKPF"
    },
    {
     "description": "NUVEEN MO QUAL MUNI INC FD",
     "symbol": "NOM"
    },
    {
     "description": "NOMAD FOODS LTD",
     "symbol": "NOMD"
    },
    {
     "description": "CANEX METALS INC",
     "symbol": "NOMNF"
    },
    {
     "description": "NET ONE SYSTEMS CO LTD",
     "symbol": "NONEF"
    },
    {
     "description": "NET ONE SYSTEMS CO-UNSP ADR",
     "symbol": "NONEY"
    },
    {
     "description": "NOVO NORDISK A\/S-B",
     "symbol": "NONOF"
    },
    {
     "description": "NEO PERFORMANCE MATERIALS IN",
     "symbol": "NOPMF"
    },
    {
     "description": "NORANDA ALUMINUM HOLDING COR",
     "symbol": "NORNQ"
    },
    {
     "description": "GLOBAL X MSCI NORWAY ETF",
     "symbol": "NORW"
    },
    {
     "description": "NORSTRA ENERGY INC",
     "symbol": "NORX"
    },
    {
     "description": "NORZINC LTD",
     "symbol": "NORZF"
    },
    {
     "description": "NEOEN SA",
     "symbol": "NOSPF"
    },
    {
     "description": "NERDS ON SITE INC",
     "symbol": "NOSUF"
    },
    {
     "description": "NOWTRANSIT INC",
     "symbol": "NOTR"
    },
    {
     "description": "INOTIV INC",
     "symbol": "NOTV"
    },
    {
     "description": "NORTHERN MINERALS LTD",
     "symbol": "NOURF"
    },
    {
     "description": "NOUVEAU LIFE PHARMACEUTICALS",
     "symbol": "NOUV"
    },
    {
     "description": "NOV INC",
     "symbol": "NOV"
    },
    {
     "description": "SUNNOVA ENERGY INTERNATIONAL",
     "symbol": "NOVA"
    },
    {
     "description": "NOVATION COMPANIES INC",
     "symbol": "NOVC"
    },
    {
     "description": "NOVATEK PJSC-SPONS GDR REG S",
     "symbol": "NOVKY"
    },
    {
     "description": "NOVAN INC",
     "symbol": "NOVN"
    },
    {
     "description": "NOVA ROYALTY CORP",
     "symbol": "NOVRF"
    },
    {
     "description": "NOVANTA INC",
     "symbol": "NOVT"
    },
    {
     "description": "NOVA VISION ACQUISITION",
     "symbol": "NOVV"
    },
    {
     "description": "NOVA VISION ACQUISITION-RTS",
     "symbol": "NOVVR"
    },
    {
     "description": "NOVA VISION ACQUISITION CORP",
     "symbol": "NOVVU"
    },
    {
     "description": "NOVA VISION ACQUISIT -CW28",
     "symbol": "NOVVW"
    },
    {
     "description": "TRUESHARES STRUC OUTCOME NOV",
     "symbol": "NOVZ"
    },
    {
     "description": "SERVICENOW INC",
     "symbol": "NOW"
    },
    {
     "description": "NOWVERTICAL GROUP INC",
     "symbol": "NOWVF"
    },
    {
     "description": "NOXEL CORP",
     "symbol": "NOXL"
    },
    {
     "description": "NOXOPHARM LTD",
     "symbol": "NOXOF"
    },
    {
     "description": "NEENAH INC",
     "symbol": "NP"
    },
    {
     "description": "NEW PROVIDENCE ACQUISITION-A",
     "symbol": "NPAB"
    },
    {
     "description": "NEW PROVIDENCE ACQUISITION C",
     "symbol": "NPABU"
    },
    {
     "description": "NEW PROVIDENCE ACQ A -CW27",
     "symbol": "NPABW"
    },
    {
     "description": "QUADIENT SA",
     "symbol": "NPACF"
    },
    {
     "description": "QUADIENT SA - UNSPONS ADR",
     "symbol": "NPACY"
    },
    {
     "description": "JINUSHI CO LTD",
     "symbol": "NPCDF"
    },
    {
     "description": "NEUROPACE INC",
     "symbol": "NPCE"
    },
    {
     "description": "NIPPON PAINT HOLDINGS CO LTD",
     "symbol": "NPCPF"
    },
    {
     "description": "NUVEEN CORE PLUS IMPACT FUND",
     "symbol": "NPCT"
    },
    {
     "description": "ALLON THERAPEUTICS INC",
     "symbol": "NPCUF"
    },
    {
     "description": "NEW PLACER DOME GOLD CORP",
     "symbol": "NPDCF"
    },
    {
     "description": "NIPPON ELECTRIC GLASS CO LTD",
     "symbol": "NPEGF"
    },
    {
     "description": "NIPPON EXPRESS HOLDINGS INC",
     "symbol": "NPEHF"
    },
    {
     "description": "BAM BAM RESOURCES CORP",
     "symbol": "NPEZF"
    },
    {
     "description": "NUVEEN VAR RT PREF & INC",
     "symbol": "NPFD"
    },
    {
     "description": "NIPPN CORP",
     "symbol": "NPFUF"
    },
    {
     "description": "NUTRA PHARMA CORP",
     "symbol": "NPHC"
    },
    {
     "description": "NORTHLAND POWER INC",
     "symbol": "NPIFF"
    },
    {
     "description": "Northland Power Inc",
     "symbol": "NPIWF"
    },
    {
     "description": "NATIONAL PRESTO INDS INC",
     "symbol": "NPK"
    },
    {
     "description": "NAMPAK LTD-SPONSORED ADR",
     "symbol": "NPKLY"
    },
    {
     "description": "NIPPON KAYAKU CO LTD",
     "symbol": "NPKYF"
    },
    {
     "description": "NIPPON KAYAKU CO-UNSP ADR",
     "symbol": "NPKYY"
    },
    {
     "description": "NEWPEAK METALS LTD",
     "symbol": "NPMFF"
    },
    {
     "description": "NIPPON SHINYAKU CO LTD",
     "symbol": "NPNKF"
    },
    {
     "description": "NORTHPOINT COMMUNICATIONS",
     "symbol": "NPNTQ"
    },
    {
     "description": "VALQUA LTD",
     "symbol": "NPNVF"
    },
    {
     "description": "NIPPON YUSEN KK - SPON ADR",
     "symbol": "NPNYY"
    },
    {
     "description": "NIPPON ANTENNA CO LTD",
     "symbol": "NPNZF"
    },
    {
     "description": "ENPRO INDUSTRIES INC",
     "symbol": "NPO"
    },
    {
     "description": "NIPPON PROLOGIS REIT INC",
     "symbol": "NPONF"
    },
    {
     "description": "NIPPON GAS CO LTD",
     "symbol": "NPPGF"
    },
    {
     "description": "NIPPON LIGHT METAL HOLDINGS",
     "symbol": "NPPMF"
    },
    {
     "description": "NIPPON SHINYAKU CO-UNSP ADR",
     "symbol": "NPPNY"
    },
    {
     "description": "NIPPON SHARYO LTD",
     "symbol": "NPPSF"
    },
    {
     "description": "NEPTUNE DIGITAL ASSETS CORP",
     "symbol": "NPPTF"
    },
    {
     "description": "NIPPON TELEGRAPH & TELEPHONE",
     "symbol": "NPPXF"
    },
    {
     "description": "NEPRA FOODS INC",
     "symbol": "NPRFF"
    },
    {
     "description": "NET PROTECTIONS HOLDINGS INC",
     "symbol": "NPRHF"
    },
    {
     "description": "NIPRO CORP",
     "symbol": "NPRRF"
    },
    {
     "description": "NIPPON REIT INVESTMENT CORP",
     "symbol": "NPRTF"
    },
    {
     "description": "NAPIER VENTURES INC",
     "symbol": "NPRVF"
    },
    {
     "description": "NIPPON STEEL CORP-SPON ADR",
     "symbol": "NPSCY"
    },
    {
     "description": "NIPPON SHEET GLASS CO LTD",
     "symbol": "NPSGF"
    },
    {
     "description": "NIPPON SHEET GLAS-UNSPON ADR",
     "symbol": "NPSGY"
    },
    {
     "description": "NSK LTD",
     "symbol": "NPSKF"
    },
    {
     "description": "NSK LTD-UNSPONSORED ADR",
     "symbol": "NPSKY"
    },
    {
     "description": "NASPERS LTD-N SHS SPON ADR",
     "symbol": "NPSNY"
    },
    {
     "description": "NIPPON STEEL TRADING CORP",
     "symbol": "NPSTF"
    },
    {
     "description": "NORTHERN POTASH CO",
     "symbol": "NPTH"
    },
    {
     "description": "NEOPHOTONICS CORP",
     "symbol": "NPTN"
    },
    {
     "description": "NIPPON TELEVISION HOLDINGS",
     "symbol": "NPTVF"
    },
    {
     "description": "NEUROPATHIX INC",
     "symbol": "NPTX"
    },
    {
     "description": "NUVEEN VA QUAL MUNI INC FD",
     "symbol": "NPV"
    },
    {
     "description": "NIPPON CONCRETE INDUSTRIES",
     "symbol": "NPVRF"
    },
    {
     "description": "NQ MINERALS PLC - SPON ADR",
     "symbol": "NQMIY"
    },
    {
     "description": "NQ MINERALS PLC",
     "symbol": "NQMLF"
    },
    {
     "description": "NUVEEN PA QUAL MUNI INC FD",
     "symbol": "NQP"
    },
    {
     "description": "NEWPARK RESOURCES INC",
     "symbol": "NR"
    },
    {
     "description": "NOBLE ROCK ACQUISITION COR-A",
     "symbol": "NRAC"
    },
    {
     "description": "NOBLE ROCK ACQUISITION CORP",
     "symbol": "NRACU"
    },
    {
     "description": "NOBLE ROCK ACQ CL A -CW27",
     "symbol": "NRACW"
    },
    {
     "description": "NEUROBO PHARMACEUTICALS INC",
     "symbol": "NRBO"
    },
    {
     "description": "NOVUS ROBOTICS INC",
     "symbol": "NRBT"
    },
    {
     "description": "NATIONAL RESEARCH CORP",
     "symbol": "NRC"
    },
    {
     "description": "NASHVILLE RECORDS INC",
     "symbol": "NRCD"
    },
    {
     "description": "NORCOM INFORMATION TECHNOLOG",
     "symbol": "NRCIF"
    },
    {
     "description": "NORDEA BANK ABP - SPON ADR",
     "symbol": "NRDBY"
    },
    {
     "description": "NERDWALLET INC-CL A",
     "symbol": "NRDS"
    },
    {
     "description": "NORDEX SE",
     "symbol": "NRDXF"
    },
    {
     "description": "NERDY INC",
     "symbol": "NRDY"
    },
    {
     "description": "NERDY INC              -CW26",
     "symbol": "NRDY.WS"
    },
    {
     "description": "NEXPOINT REAL ESTATE FINANCE",
     "symbol": "NREF"
    },
    {
     "description": "NEXPOINT REAL ESTATE FIN",
     "symbol": "NREF.PRA"
    },
    {
     "description": "NR INSTANT PRODUCE PCL-NVDR",
     "symbol": "NRFTF"
    },
    {
     "description": "NRG ENERGY INC",
     "symbol": "NRG"
    },
    {
     "description": "MICROSECTORS US BIG OIL -3X",
     "symbol": "NRGD"
    },
    {
     "description": "NEWRANGE GOLD CORP",
     "symbol": "NRGOF"
    },
    {
     "description": "Narragansett Electric Company",
     "symbol": "NRGSP"
    },
    {
     "description": "ENERGY TODAY INC",
     "symbol": "NRGT"
    },
    {
     "description": "MICROSECTORS US BIG OIL 3X",
     "symbol": "NRGU"
    },
    {
     "description": "ENERGY VAULT HOLDINGS INC",
     "symbol": "NRGV"
    },
    {
     "description": "ENERGY VAULT HLDS CL A-CW27",
     "symbol": "NRGV.WS"
    },
    {
     "description": "PIMCO ENRGY & TACT CRDT",
     "symbol": "NRGX"
    },
    {
     "description": "NOMURA RESEARCH INS-UNSP ADR",
     "symbol": "NRILY"
    },
    {
     "description": "NORTHRIM BANCORP INC",
     "symbol": "NRIM"
    },
    {
     "description": "NORRIS INDUSTRIES INC",
     "symbol": "NRIS"
    },
    {
     "description": "NURIX THERAPEUTICS INC",
     "symbol": "NRIX"
    },
    {
     "description": "NRJ GROUP",
     "symbol": "NRJGF"
    },
    {
     "description": "NUVEEN NY AMT-FR MUNI INC FD",
     "symbol": "NRK"
    },
    {
     "description": "NKT HOLDING A\/S",
     "symbol": "NRKBF"
    },
    {
     "description": "NORTHERN CALIFORNIA BANCORP",
     "symbol": "NRLB"
    },
    {
     "description": "NEUBERGER BERMAN REAL ESTATE",
     "symbol": "NRO"
    },
    {
     "description": "NOBLE ROMANS INC",
     "symbol": "NROM"
    },
    {
     "description": "NATURAL RESOURCE PARTNERS LP",
     "symbol": "NRP"
    },
    {
     "description": "NRP STONE INC",
     "symbol": "NRPI"
    },
    {
     "description": "NUTRI PHARMACEUTICALS RESEAR",
     "symbol": "NRPR"
    },
    {
     "description": "NORRA METALS CORP",
     "symbol": "NRRMF"
    },
    {
     "description": "NORSEMONT MINING INC",
     "symbol": "NRRSF"
    },
    {
     "description": "NURAN WIRELESS INC",
     "symbol": "NRRWF"
    },
    {
     "description": "NORSE ATLANTIC ASA",
     "symbol": "NRSAF"
    },
    {
     "description": "NOMURA HOLDINGS INC",
     "symbol": "NRSCF"
    },
    {
     "description": "NORDIC SEMICONDUCTOR ASA-ADR",
     "symbol": "NRSDY"
    },
    {
     "description": "NEUROSENSE THERAPEUTICS LTD",
     "symbol": "NRSN"
    },
    {
     "description": "NEUROSENSE THERAPEUTI -CW23",
     "symbol": "NRSNW"
    },
    {
     "description": "SPUNTECH INDUSTRIES LTD",
     "symbol": "NRSPF"
    },
    {
     "description": "NORSTAR HOLDINGS INC",
     "symbol": "NRSTF"
    },
    {
     "description": "NORTH EUROPEAN OIL RTY TRUST",
     "symbol": "NRT"
    },
    {
     "description": "NORTHERN POWER SYSTEMS CORP",
     "symbol": "NRTHF"
    },
    {
     "description": "NOBILIS HEALTH CORP",
     "symbol": "NRTSF"
    },
    {
     "description": "NORITZ CORP",
     "symbol": "NRTZF"
    },
    {
     "description": "NATIONAL RURAL UTIL COOP",
     "symbol": "NRUC"
    },
    {
     "description": "NORTHERN URANIUM CORP",
     "symbol": "NRUNF"
    },
    {
     "description": "NORAM LITHIUM CORP",
     "symbol": "NRVTF"
    },
    {
     "description": "NEWRIVER REIT PLC",
     "symbol": "NRWRF"
    },
    {
     "description": "NARROWSTEP INC",
     "symbol": "NRWS"
    },
    {
     "description": "NEUTRISCI INTERNATIONAL INC",
     "symbol": "NRXCF"
    },
    {
     "description": "NRX PHARMACEUTICALS INC",
     "symbol": "NRXP"
    },
    {
     "description": "NRX PHARMACEUTICALS INC-CW22",
     "symbol": "NRXPW"
    },
    {
     "description": "NORDEX SE-UNSPONSORED ADR",
     "symbol": "NRXXY"
    },
    {
     "description": "NORWAY ROYAL SALMON ASA",
     "symbol": "NRYYF"
    },
    {
     "description": "NORWAY ROYAL SALMO-UNSPR ADR",
     "symbol": "NRYYY"
    },
    {
     "description": "NEW RESIDENTIAL INVESTMENT",
     "symbol": "NRZ"
    },
    {
     "description": "NEW RESIDENTIAL INV CORP",
     "symbol": "NRZ.PRA"
    },
    {
     "description": "NEW RESIDENTIAL INV CORP",
     "symbol": "NRZ.PRB"
    },
    {
     "description": "NEW RESIDENTIAL INV CORP",
     "symbol": "NRZ.PRC"
    },
    {
     "description": "NEW RESIDENTIAL INV CORP",
     "symbol": "NRZ.PRD"
    },
    {
     "description": "NUSTAR ENERGY LP",
     "symbol": "NS"
    },
    {
     "description": "NUSTAR ENERGY LP",
     "symbol": "NS.PRA"
    },
    {
     "description": "NUSTAR ENERGY LP",
     "symbol": "NS.PRB"
    },
    {
     "description": "NUSTAR ENERGY LP",
     "symbol": "NS.PRC"
    },
    {
     "description": "NATIONAL STORAGE AFFILIATES",
     "symbol": "NSA"
    },
    {
     "description": "NATIONAL STORAGE AFFILIA",
     "symbol": "NSA.PRA"
    },
    {
     "description": "NISSAN MOTOR CO LTD",
     "symbol": "NSANF"
    },
    {
     "description": "NISSAN MOTOR CO LTD-SPON ADR",
     "symbol": "NSANY"
    },
    {
     "description": "NSTAR Electric Company",
     "symbol": "NSARO"
    },
    {
     "description": "NSTAR Electric Company",
     "symbol": "NSARP"
    },
    {
     "description": "MEGUMAGOLD CORP",
     "symbol": "NSAUF"
    },
    {
     "description": "NET SAVINGS LINK INC",
     "symbol": "NSAV"
    },
    {
     "description": "NORTHERN STAR FINANCIAL INC",
     "symbol": "NSBK"
    },
    {
     "description": "NORFOLK SOUTHERN CORP",
     "symbol": "NSC"
    },
    {
     "description": "NANALYSIS SCIENTIFIC CORP",
     "symbol": "NSCIF"
    },
    {
     "description": "NUVEEN SMALL CAP SELECT ETF",
     "symbol": "NSCS"
    },
    {
     "description": "NATIONAL SECURITY GROUP INC",
     "symbol": "NSEC"
    },
    {
     "description": "NIPPON SEIKI CO LTD",
     "symbol": "NSEIF"
    },
    {
     "description": "NS8 CORP",
     "symbol": "NSEO"
    },
    {
     "description": "NXT ENERGY SOLUTIONS INC",
     "symbol": "NSFDF"
    },
    {
     "description": "NISSHIN SEIFUN GROUP INC",
     "symbol": "NSFMF"
    },
    {
     "description": "NORTHSTAR GOLD CORP",
     "symbol": "NSGCF"
    },
    {
     "description": "NISSHINBO HOLDINGS-UNSP ADR",
     "symbol": "NSHBY"
    },
    {
     "description": "NIPPON SHOKUBAI CO LTD",
     "symbol": "NSHKF"
    },
    {
     "description": "NORTHERN SHIELD RESOURCES IN",
     "symbol": "NSHRF"
    },
    {
     "description": "NANOSPHERE HEALTH SCIENCES I",
     "symbol": "NSHSF"
    },
    {
     "description": "INSIGHT ENTERPRISES INC",
     "symbol": "NSIT"
    },
    {
     "description": "KONGSBERG GRUPPEN ASA",
     "symbol": "NSKFF"
    },
    {
     "description": "NUVEEN SENIOR INCOME FUND",
     "symbol": "NSL"
    },
    {
     "description": "NEW SOURCE ENERGY PARTNERS L",
     "symbol": "NSLPQ"
    },
    {
     "description": "ENSSOLUTIONS GROUP INC",
     "symbol": "NSLSF"
    },
    {
     "description": "NESTLE (MALAYSIA) BERHAD",
     "symbol": "NSLYF"
    },
    {
     "description": "NORTHERN SPHERE MINING CORP",
     "symbol": "NSMCF"
    },
    {
     "description": "NATIONAL STORM MANAGEMENT",
     "symbol": "NSMG"
    },
    {
     "description": "NORTHERN STAR MINING CORP",
     "symbol": "NSMSF"
    },
    {
     "description": "NISSAN SHATAI CO LTD",
     "symbol": "NSNHF"
    },
    {
     "description": "INSPERITY INC",
     "symbol": "NSP"
    },
    {
     "description": "NATURALLY SPLENDID ENT LTD",
     "symbol": "NSPDF"
    },
    {
     "description": "NATIONWIDE S&P 500 RISK-MAN",
     "symbol": "NSPI"
    },
    {
     "description": "9 SPOKES INTERNATIONAL LTD",
     "symbol": "NSPKF"
    },
    {
     "description": "INSPIREMD INC",
     "symbol": "NSPR"
    },
    {
     "description": "NEWRON SPORT",
     "symbol": "NSPT"
    },
    {
     "description": "NOMAD ROYALTY CO LTD",
     "symbol": "NSR"
    },
    {
     "description": "NEXTSOURCE MATERIALS INC",
     "symbol": "NSRCF"
    },
    {
     "description": "NESTLE SA-REG",
     "symbol": "NSRGF"
    },
    {
     "description": "NESTLE SA-SPONS ADR",
     "symbol": "NSRGY"
    },
    {
     "description": "NOVO RESOURCES CORP",
     "symbol": "NSRPF"
    },
    {
     "description": "NORTH SPRINGS RESOURCES CORP",
     "symbol": "NSRS"
    },
    {
     "description": "NOMAD ROYALTY CO LTD -CW22",
     "symbol": "NSRWF"
    },
    {
     "description": "NUSTAR LOGISTICS LP",
     "symbol": "NSS"
    },
    {
     "description": "NAPCO SECURITY TECHNOLOGIES",
     "symbol": "NSSC"
    },
    {
     "description": "NS SOLUTIONS CORP",
     "symbol": "NSSXF"
    },
    {
     "description": "NORTHERN STAR INVESTMENT C-A",
     "symbol": "NSTB"
    },
    {
     "description": "NORTHERN STAR INVESTMENT COR",
     "symbol": "NSTB.U"
    },
    {
     "description": "NORTHERN STAR INV CL A -CW28",
     "symbol": "NSTB.WS"
    },
    {
     "description": "NORTHERN STAR INVESTMENT -A",
     "symbol": "NSTC"
    },
    {
     "description": "NORTHERN STAR INVESTMENT III",
     "symbol": "NSTC.U"
    },
    {
     "description": "NORTHERN STAR INV CL A -CW27",
     "symbol": "NSTC.WS"
    },
    {
     "description": "NORTHERN STAR INVESTMENT -A",
     "symbol": "NSTD"
    },
    {
     "description": "NORTHERN STAR INVESTMENT COR",
     "symbol": "NSTD.U"
    },
    {
     "description": "NORTHERN STAR INV CL A -CW27",
     "symbol": "NSTD.WS"
    },
    {
     "description": "NANOSTRING TECHNOLOGIES INC",
     "symbol": "NSTG"
    },
    {
     "description": "NOVATEK PJSC",
     "symbol": "NSTKF"
    },
    {
     "description": "NOVELSTEM INTERNATIONAL CORP",
     "symbol": "NSTM"
    },
    {
     "description": "NOSTRUM OIL & GAS P-UNSP ADR",
     "symbol": "NSTRY"
    },
    {
     "description": "NSTS BANCORP INC",
     "symbol": "NSTS"
    },
    {
     "description": "NORTHERN STAR RES-SPON ADR",
     "symbol": "NSTYY"
    },
    {
     "description": "NISSUI PHARMACEUTICAL CO LTD",
     "symbol": "NSUIF"
    },
    {
     "description": "NORTHERN SUPERIOR RESOURCES",
     "symbol": "NSUPF"
    },
    {
     "description": "NASS VALLEY GATEWAY LTD",
     "symbol": "NSVGF"
    },
    {
     "description": "AUQ GOLD MINING INC",
     "symbol": "NSVLF"
    },
    {
     "description": "NITRO SOFTWARE LTD",
     "symbol": "NSWEF"
    },
    {
     "description": "NATIONAL STOCK YARDS CO",
     "symbol": "NSYC"
    },
    {
     "description": "NORTECH SYSTEMS INC",
     "symbol": "NSYS"
    },
    {
     "description": "NETENT AB",
     "symbol": "NTABF"
    },
    {
     "description": "NANTAI INTERNATIONAL INC",
     "symbol": "NTAI"
    },
    {
     "description": "NETAPP INC",
     "symbol": "NTAP"
    },
    {
     "description": "BANK OF N.T. BUTTERFIELD&SON",
     "symbol": "NTB"
    },
    {
     "description": "NEW TRIPOLI BANCORP INC",
     "symbol": "NTBP"
    },
    {
     "description": "N1 TECHNOLOGIES INC",
     "symbol": "NTCHF"
    },
    {
     "description": "NUTECH INC",
     "symbol": "NTCI"
    },
    {
     "description": "NATURA &CO HOLDING-ADR",
     "symbol": "NTCO"
    },
    {
     "description": "NORTHISLE COPPER & GOLD INC",
     "symbol": "NTCPF"
    },
    {
     "description": "NETSCOUT SYSTEMS INC",
     "symbol": "NTCT"
    },
    {
     "description": "NATCORE TECHNOLOGY INC",
     "symbol": "NTCXF"
    },
    {
     "description": "NETCOMPANY GROUP AS",
     "symbol": "NTCYF"
    },
    {
     "description": "NINTENDO CO LTD",
     "symbol": "NTDOF"
    },
    {
     "description": "NINTENDO CO LTD-UNSPONS ADR",
     "symbol": "NTDOY"
    },
    {
     "description": "NTT DATA CORP-UNSPON ADR",
     "symbol": "NTDTY"
    },
    {
     "description": "NOVA TECH ENTERPRISES INC",
     "symbol": "NTEI"
    },
    {
     "description": "NANOTECH ENTERTAINMENT INC",
     "symbol": "NTEK"
    },
    {
     "description": "92 ENERGY LTD",
     "symbol": "NTELF"
    },
    {
     "description": "NETEASE INC-ADR",
     "symbol": "NTES"
    },
    {
     "description": "NYSE Tick Pilot TEST",
     "symbol": "NTEST"
    },
    {
     "description": "NF NIKKEI 225 ETF",
     "symbol": "NTETF"
    },
    {
     "description": "NETWORK 1 FINANCIAL GROUP",
     "symbol": "NTFL"
    },
    {
     "description": "NOTIFY TECHNOLOGY CORP",
     "symbol": "NTFY"
    },
    {
     "description": "TORTOISE MIDSTREAM ENERGY",
     "symbol": "NTG"
    },
    {
     "description": "NANOTECH GAMING INC",
     "symbol": "NTGL"
    },
    {
     "description": "NETGEAR INC",
     "symbol": "NTGR"
    },
    {
     "description": "NETIMPACT HOLDINGS INC",
     "symbol": "NTHD"
    },
    {
     "description": "NORTHERN TECHNOLOGIES INTL",
     "symbol": "NTIC"
    },
    {
     "description": "NEUROBIOLOGICAL TECHNOLOGIES",
     "symbol": "NTII"
    },
    {
     "description": "NEUROTECH INTERNATIONAL LTD",
     "symbol": "NTILF"
    },
    {
     "description": "NATIONAL BANK OF CANADA",
     "symbol": "NTIOF"
    },
    {
     "description": "NETWORK-1 TECHNOLOGIES INC",
     "symbol": "NTIP"
    },
    {
     "description": "NATIONWIDE RUSSELL 2000 RISK",
     "symbol": "NTKI"
    },
    {
     "description": "INTELLIA THERAPEUTICS INC",
     "symbol": "NTLA"
    },
    {
     "description": "NET TALK.COM INC",
     "symbol": "NTLK"
    },
    {
     "description": "NETMED INC",
     "symbol": "NTME"
    },
    {
     "description": "NORTHERN OCEAN LTD",
     "symbol": "NTNOF"
    },
    {
     "description": "NUTANIX INC - A",
     "symbol": "NTNX"
    },
    {
     "description": "NESTE OYJ",
     "symbol": "NTOIF"
    },
    {
     "description": "NESTE OYJ - UNSP ADR",
     "symbol": "NTOIY"
    },
    {
     "description": "NOTOX TECHNOLOGIES CORP",
     "symbol": "NTOX"
    },
    {
     "description": "NAM TAI PROPERTY INC",
     "symbol": "NTP"
    },
    {
     "description": "NETPLEX GROUP INC",
     "symbol": "NTPL"
    },
    {
     "description": "NETPAY INTL INC",
     "symbol": "NTPY"
    },
    {
     "description": "NUTRIEN LTD",
     "symbol": "NTR"
    },
    {
     "description": "NATERA INC",
     "symbol": "NTRA"
    },
    {
     "description": "NUTRIBAND INC",
     "symbol": "NTRB"
    },
    {
     "description": "NUTRIBAND INC -CW26",
     "symbol": "NTRBW"
    },
    {
     "description": "NEUTRA CORP",
     "symbol": "NTRR"
    },
    {
     "description": "NORTHERN TRUST CORP",
     "symbol": "NTRS"
    },
    {
     "description": "NORTHERN TRUST CORP",
     "symbol": "NTRSO"
    },
    {
     "description": "NATUR INTERNATIONAL CORP",
     "symbol": "NTRU"
    },
    {
     "description": "WISDOMTREE EMERGING MARKETS",
     "symbol": "NTSE"
    },
    {
     "description": "NATIONAL STORAGE REIT",
     "symbol": "NTSGF"
    },
    {
     "description": "WISDOMTREE INTERNATIONAL EFF",
     "symbol": "NTSI"
    },
    {
     "description": "NORTHSTAR ETHA-CAP UNIT CL A",
     "symbol": "NTSLU"
    },
    {
     "description": "NETSTREIT CORP",
     "symbol": "NTST"
    },
    {
     "description": "WISDOMTREE US EFFICIENT CORE",
     "symbol": "NTSX"
    },
    {
     "description": "NETCENTS TECHNOLOGY INC",
     "symbol": "NTTCF"
    },
    {
     "description": "NTT DATA CORP",
     "symbol": "NTTDF"
    },
    {
     "description": "NOVATTI GROUP LTD",
     "symbol": "NTTIF"
    },
    {
     "description": "NIPPON TELEGRAPH & TELE-ADR",
     "symbol": "NTTYY"
    },
    {
     "description": "BIPROGY INC",
     "symbol": "NTULF"
    },
    {
     "description": "NATURAL BLUE RESOURCES INC",
     "symbol": "NTUR"
    },
    {
     "description": "NATUS MEDICAL INC",
     "symbol": "NTUS"
    },
    {
     "description": "NORTHERN VERTEX MINING -CW23",
     "symbol": "NTVMF"
    },
    {
     "description": "NETSOL TECHNOLOGIES INC",
     "symbol": "NTWK"
    },
    {
     "description": "NATIXIS",
     "symbol": "NTXFF"
    },
    {
     "description": "NEXTEER AUTOMOTIVE GROUP LTD",
     "symbol": "NTXVF"
    },
    {
     "description": "NATUZZI SPA-SP ADR",
     "symbol": "NTZ"
    },
    {
     "description": "IMPACT SHARES MSCI GL CLIM",
     "symbol": "NTZO"
    },
    {
     "description": "NU HOLDINGS LTD\/CAYMAN ISL-A",
     "symbol": "NU"
    },
    {
     "description": "NUVEEN ENHANCED YIELD U.S. A",
     "symbol": "NUAG"
    },
    {
     "description": "NORTHUMBERLAND BANCORP",
     "symbol": "NUBC"
    },
    {
     "description": "NUVEEN ESG US AGGREGATE BOND",
     "symbol": "NUBD"
    },
    {
     "description": "NUBIA BRAND INTERNATIONAL CO",
     "symbol": "NUBIU"
    },
    {
     "description": "NUVEEN ESG INTERNATIONAL DEV",
     "symbol": "NUDM"
    },
    {
     "description": "NUVEEN ESG DIVIDEND ETF",
     "symbol": "NUDV"
    },
    {
     "description": "NUCOR CORP",
     "symbol": "NUE"
    },
    {
     "description": "NUEARTH CORP",
     "symbol": "NUEC"
    },
    {
     "description": "NUVEEN ESG EMERGING MARKETS",
     "symbol": "NUEM"
    },
    {
     "description": "NUFARM LTD",
     "symbol": "NUFMF"
    },
    {
     "description": "NUGL INC",
     "symbol": "NUGL"
    },
    {
     "description": "NUGENE INTERNATIONAL INC",
     "symbol": "NUGN"
    },
    {
     "description": "NUVEEN GROWTH OPPORTUNITIES",
     "symbol": "NUGO"
    },
    {
     "description": "CANNABIS STRATEGIC VENTURES",
     "symbol": "NUGS"
    },
    {
     "description": "DIREXION DAILY GOLD MINERS I",
     "symbol": "NUGT"
    },
    {
     "description": "NUGENEREX IMMUNO-ONCOLOGY IN",
     "symbol": "NUGX"
    },
    {
     "description": "NUHEARA LTD",
     "symbol": "NUHRF"
    },
    {
     "description": "NUVEEN ESG HIGH YIELD CORP B",
     "symbol": "NUHY"
    },
    {
     "description": "NUKKLEUS INC",
     "symbol": "NUKK"
    },
    {
     "description": "NUVEEN ESG LARGE-CAP ETF",
     "symbol": "NULC"
    },
    {
     "description": "NUVEEN ESG LARGE-CAP GROWTH",
     "symbol": "NULG"
    },
    {
     "description": "NULEGACY GOLD CORP",
     "symbol": "NULGF"
    },
    {
     "description": "NUVEEN ESG LARGE-CAP VALUE E",
     "symbol": "NULV"
    },
    {
     "description": "NU-MED PLUS INC",
     "symbol": "NUMD"
    },
    {
     "description": "NUVEEN ESG MIDCAP GROWTH ETF",
     "symbol": "NUMG"
    },
    {
     "description": "NUMINUS WELLNESS INC",
     "symbol": "NUMIF"
    },
    {
     "description": "NUVEEN ESG MID-CAP VALUE ETF",
     "symbol": "NUMV"
    },
    {
     "description": "NUNZIA PHARMACEUTICAL CORP",
     "symbol": "NUNZ"
    },
    {
     "description": "NUVEEN OH QUAL MUNI INC FD",
     "symbol": "NUO"
    },
    {
     "description": "NOMURA RESEARCH INSTITUTE LT",
     "symbol": "NURAF"
    },
    {
     "description": "NUVEEN SHORTTERM REIT ETF",
     "symbol": "NURE"
    },
    {
     "description": "NEUROMETRIX INC",
     "symbol": "NURO"
    },
    {
     "description": "NEUREN PHARMACEUTICALS LTD",
     "symbol": "NURPF"
    },
    {
     "description": "NU SKIN ENTERPRISES INC - A",
     "symbol": "NUS"
    },
    {
     "description": "NUVEEN ENHANCED YIELD 1-5 YE",
     "symbol": "NUSA"
    },
    {
     "description": "NUVEEN ESG SMALL-CAP ETF",
     "symbol": "NUSC"
    },
    {
     "description": "NATIONWIDE NASDAQ-100 RISK-M",
     "symbol": "NUSI"
    },
    {
     "description": "NAUTILUS MINERALS INC",
     "symbol": "NUSMF"
    },
    {
     "description": "New Source Energy Partners LP",
     "symbol": "NUSPQ"
    },
    {
     "description": "NUTROGANICS INC",
     "symbol": "NUTTQ"
    },
    {
     "description": "NUTEX HEALTH INC",
     "symbol": "NUTX"
    },
    {
     "description": "REJUVEL BIO-SCIENCES INC",
     "symbol": "NUUU"
    },
    {
     "description": "NUVEEN MUNI VALUE FD",
     "symbol": "NUV"
    },
    {
     "description": "NUVASIVE INC",
     "symbol": "NUVA"
    },
    {
     "description": "NUVATION BIO INC",
     "symbol": "NUVB"
    },
    {
     "description": "NUVATION BIO INC -CW27",
     "symbol": "NUVB.WS"
    },
    {
     "description": "NUVUS GRO CORP",
     "symbol": "NUVG"
    },
    {
     "description": "EMO CAPITAL CORP",
     "symbol": "NUVI"
    },
    {
     "description": "NUVALENT INC-A",
     "symbol": "NUVL"
    },
    {
     "description": "NUVIM INC",
     "symbol": "NUVM"
    },
    {
     "description": "Nuvo Group Ltd",
     "symbol": "NUVO"
    },
    {
     "description": "NUVERA COMMUNICATIONS INC",
     "symbol": "NUVR"
    },
    {
     "description": "NUVISTA ENERGY LTD",
     "symbol": "NUVSF"
    },
    {
     "description": "NUVEEN AMT-FREE MUNI VAL FD",
     "symbol": "NUW"
    },
    {
     "description": "NUWELLIS INC",
     "symbol": "NUWE"
    },
    {
     "description": "CHF SOLUTIONS-CW25",
     "symbol": "NUWEW"
    },
    {
     "description": "NUZEE INC",
     "symbol": "NUZE"
    },
    {
     "description": "NOVA MINERALS LTD",
     "symbol": "NVAAF"
    },
    {
     "description": "NORTHVIEW ACQUISITION CORP",
     "symbol": "NVAC"
    },
    {
     "description": "NOVA CANNABIS INC",
     "symbol": "NVACF"
    },
    {
     "description": "NORTHVIEW ACQUISITION CO-RTS",
     "symbol": "NVACR"
    },
    {
     "description": "NORTHVIEW ACQUISITION -23",
     "symbol": "NVACW"
    },
    {
     "description": "NOVAVAX INC",
     "symbol": "NVAX"
    },
    {
     "description": "NEOVASC INC",
     "symbol": "NVCN"
    },
    {
     "description": "NVCN CORP",
     "symbol": "NVCP"
    },
    {
     "description": "NOVOCURE LTD",
     "symbol": "NVCR"
    },
    {
     "description": "NUVECTIS PHARMA INC",
     "symbol": "NVCT"
    },
    {
     "description": "NVIDIA CORP",
     "symbol": "NVDA"
    },
    {
     "description": "NEVADA EXPLORATION INC",
     "symbol": "NVDEF"
    },
    {
     "description": "NEVADA SILVER CORP",
     "symbol": "NVDSF"
    },
    {
     "description": "NVE CORP",
     "symbol": "NVEC"
    },
    {
     "description": "NV5 GLOBAL INC",
     "symbol": "NVEE"
    },
    {
     "description": "NUVEI CORP-SUBORDINATE VTG",
     "symbol": "NVEI"
    },
    {
     "description": "NOVA LIFESTYLE INC",
     "symbol": "NVFY"
    },
    {
     "description": "NUVEEN AMT-FR MUNI CREDIT FD",
     "symbol": "NVG"
    },
    {
     "description": "NOBLE VICI GROUP INC",
     "symbol": "NVGI"
    },
    {
     "description": "NV GOLD CORP",
     "symbol": "NVGLF"
    },
    {
     "description": "NAVIGATOR HOLDINGS LTD",
     "symbol": "NVGS"
    },
    {
     "description": "NOVAGANT CORP",
     "symbol": "NVGT"
    },
    {
     "description": "INVIVO THERAPEUTICS HOLDINGS",
     "symbol": "NVIV"
    },
    {
     "description": "NEVADA LITHIUM RESOURCES INC",
     "symbol": "NVLHF"
    },
    {
     "description": "NOVA LEAP HEALTH CORP",
     "symbol": "NVLPF"
    },
    {
     "description": "NOVAMIND INC",
     "symbol": "NVMDF"
    },
    {
     "description": "NOVA LTD",
     "symbol": "NVMI"
    },
    {
     "description": "NAVARRE MINERALS LTD",
     "symbol": "NVMLF"
    },
    {
     "description": "HANCOCK JAFFE LABORAT -CW26",
     "symbol": "NVNBW"
    },
    {
     "description": "ENVVENO MEDICAL CORP",
     "symbol": "NVNO"
    },
    {
     "description": "HANCOCK JAFFE LABORATOR-CW23",
     "symbol": "NVNOW"
    },
    {
     "description": "NOVINT TECHNOLOGIES INC",
     "symbol": "NVNT"
    },
    {
     "description": "NOVONIX LTD",
     "symbol": "NVNXF"
    },
    {
     "description": "NOVO-NORDISK A\/S-SPONS ADR",
     "symbol": "NVO"
    },
    {
     "description": "NOVO RESOURCES CORP -CW23",
     "symbol": "NVOOF"
    },
    {
     "description": "NOVO INTEGRATED SCIENCES INC",
     "symbol": "NVOS"
    },
    {
     "description": "NEVARO CAPITAL CORP",
     "symbol": "NVPLF"
    },
    {
     "description": "QRAFT AI-ENH US NEXT VALUE",
     "symbol": "NVQ"
    },
    {
     "description": "NVR INC",
     "symbol": "NVR"
    },
    {
     "description": "NEVRO CORP",
     "symbol": "NVRO"
    },
    {
     "description": "NOVRA TECHNOLOGIES INC",
     "symbol": "NVRVF"
    },
    {
     "description": "NOVARTIS AG-SPONSORED ADR",
     "symbol": "NVS"
    },
    {
     "description": "NEW VISTA ACQUISITION CORP-A",
     "symbol": "NVSA"
    },
    {
     "description": "NEW VISTA ACQUISITION CORP",
     "symbol": "NVSAU"
    },
    {
     "description": "NEW VISTA ACQ CL A -CW27",
     "symbol": "NVSAW"
    },
    {
     "description": "NOVARTIS AG-REG",
     "symbol": "NVSEF"
    },
    {
     "description": "NEVADA SUNRISE GOLD CORP",
     "symbol": "NVSGF"
    },
    {
     "description": "NOVUS HOLDINGS LTD",
     "symbol": "NVSHF"
    },
    {
     "description": "NOVOROSSIYSK TRADE-SP GDR",
     "symbol": "NVSKL"
    },
    {
     "description": "ENVISTA HOLDINGS CORP",
     "symbol": "NVST"
    },
    {
     "description": "NVENT ELECTRIC PLC",
     "symbol": "NVT"
    },
    {
     "description": "INVITAE CORP",
     "symbol": "NVTA"
    },
    {
     "description": "TRENCH METALS CORP",
     "symbol": "NVTQF"
    },
    {
     "description": "NAVITAS SEMICONDUCTOR CORP",
     "symbol": "NVTS"
    },
    {
     "description": "NUVVE HOLDING CORP",
     "symbol": "NVVE"
    },
    {
     "description": "NUVVE HOLDING CORP-CW26",
     "symbol": "NVVEW"
    },
    {
     "description": "NOVONIX LTD-ADR",
     "symbol": "NVX"
    },
    {
     "description": "NAVYA SAS",
     "symbol": "NVYAF"
    },
    {
     "description": "NOVACYT",
     "symbol": "NVYTF"
    },
    {
     "description": "NOVOZYMES A\/S-B SHARES",
     "symbol": "NVZMF"
    },
    {
     "description": "NOVOZYMES A\/S-UNSPONS ADR",
     "symbol": "NVZMY"
    },
    {
     "description": "NORWEGIAN AIR SHUTTLE AS",
     "symbol": "NWARF"
    },
    {
     "description": "NOWAUTO INC",
     "symbol": "NWAU"
    },
    {
     "description": "NEW WORLD BRANDS INC",
     "symbol": "NWBD"
    },
    {
     "description": "NORTHWEST BANCSHARES INC",
     "symbol": "NWBI"
    },
    {
     "description": "NORTHWEST BIOTHERAPEUTICS",
     "symbol": "NWBO"
    },
    {
     "description": "NEWBORN TOWN INC",
     "symbol": "NWBTF"
    },
    {
     "description": "NORTHWEST COPPER CORP",
     "symbol": "NWCCF"
    },
    {
     "description": "NEWCARDIO INC",
     "symbol": "NWCI"
    },
    {
     "description": "NETWORK CN INC",
     "symbol": "NWCN"
    },
    {
     "description": "NEW MEDIA INVESTMENT-CW23",
     "symbol": "NWDVW"
    },
    {
     "description": "NORTHWESTERN CORP",
     "symbol": "NWE"
    },
    {
     "description": "NEW FOCUS AUTO TECH HOLDINGS",
     "symbol": "NWFAF"
    },
    {
     "description": "NORWOOD FINANCIAL CORP",
     "symbol": "NWFL"
    },
    {
     "description": "NATWEST GROUP PLC -SPON ADR",
     "symbol": "NWG"
    },
    {
     "description": "NEW WORLD GOLD CORP",
     "symbol": "NWGC"
    },
    {
     "description": "ELYS GAME TECH CORP-CW25",
     "symbol": "NWGIW"
    },
    {
     "description": "NEWGEN TECHNOLOGIES INC",
     "symbol": "NWGN"
    },
    {
     "description": "HANDA MINING CORP",
     "symbol": "NWHAF"
    },
    {
     "description": "NORTHWEST HEALTHCARE PROPERT",
     "symbol": "NWHUF"
    },
    {
     "description": "NUINSCO RESOURCES LTD",
     "symbol": "NWIFF"
    },
    {
     "description": "NAKED WINES PLC",
     "symbol": "NWINF"
    },
    {
     "description": "NETWORK INT HOLD-UNSP ADR",
     "symbol": "NWITY"
    },
    {
     "description": "NETCARE LTD-UNSPON ADR",
     "symbol": "NWKHY"
    },
    {
     "description": "NETWORK INTERNATIONAL HOLDIN",
     "symbol": "NWKLF"
    },
    {
     "description": "NEWELL BRANDS INC",
     "symbol": "NWL"
    },
    {
     "description": "NUVEEN WINSLOW LG CAP GR ESG",
     "symbol": "NWLG"
    },
    {
     "description": "NATIONAL WESTERN LIFE GROU-A",
     "symbol": "NWLI"
    },
    {
     "description": "NEWLOX GOLD VENTURES CORP",
     "symbol": "NWLXF"
    },
    {
     "description": "NATIONAL WASTE MANAGEMENT HO",
     "symbol": "NWMH"
    },
    {
     "description": "NORTHWEST NATURAL HOLDING CO",
     "symbol": "NWN"
    },
    {
     "description": "NEW CENTURY RESOURCES LTD",
     "symbol": "NWNNF"
    },
    {
     "description": "NORTH WEST OIL GROUP INC",
     "symbol": "NWOL"
    },
    {
     "description": "NEWPORT GOLD INC",
     "symbol": "NWPG"
    },
    {
     "description": "NEWRON PHARMACEUTICALS SPA",
     "symbol": "NWPHF"
    },
    {
     "description": "CLEARSTREAM ENERGY SERVICES",
     "symbol": "NWPIF"
    },
    {
     "description": "NOW CORP\/THE",
     "symbol": "NWPN"
    },
    {
     "description": "NEW PEOPLES BANKSHARES INC",
     "symbol": "NWPP"
    },
    {
     "description": "NORTHWEST PIPE CO",
     "symbol": "NWPX"
    },
    {
     "description": "KENORLAND MINERALS LTD",
     "symbol": "NWRCF"
    },
    {
     "description": "NEW WORLD DEPT ST-UNSPON ADR",
     "symbol": "NWRLY"
    },
    {
     "description": "NEWS CORP - CLASS B",
     "symbol": "NWS"
    },
    {
     "description": "NEWS CORP - CLASS A",
     "symbol": "NWSA"
    },
    {
     "description": "NEWS CORP - CLASS B- CDI",
     "symbol": "NWSAL"
    },
    {
     "description": "NWS HOLDINGS LTD-SPON ADR",
     "symbol": "NWSGY"
    },
    {
     "description": "NEWS CORP - CLASS A- CDI",
     "symbol": "NWSLL"
    },
    {
     "description": "NEW STANDARD ENERGY LTD",
     "symbol": "NWSTF"
    },
    {
     "description": "NWS HOLDINGS LTD",
     "symbol": "NWSZF"
    },
    {
     "description": "NEWTECH CO LTD",
     "symbol": "NWTCF"
    },
    {
     "description": "NEW TMW TOPCO INC",
     "symbol": "NWTM"
    },
    {
     "description": "NW TECH CAPITAL INC",
     "symbol": "NWTT"
    },
    {
     "description": "NATIONWIDE UTILITIES CORP",
     "symbol": "NWUC"
    },
    {
     "description": "ENWAVE CORP",
     "symbol": "NWVCF"
    },
    {
     "description": "NEW CHINA LIFE INSURANCE C-H",
     "symbol": "NWWCF"
    },
    {
     "description": "NEW WORLD DEVELOPMENT",
     "symbol": "NWWDF"
    },
    {
     "description": "NEWNOTE FINANCIAL CORP",
     "symbol": "NWWTF"
    },
    {
     "description": "NEWAX INC",
     "symbol": "NWXJ"
    },
    {
     "description": "NEWPORT EXPLORATION LTD",
     "symbol": "NWXPF"
    },
    {
     "description": "NORTHWAY FINANCIAL INC",
     "symbol": "NWYF"
    },
    {
     "description": "NEW YOU INC",
     "symbol": "NWYU"
    },
    {
     "description": "QUANEX BUILDING PRODUCTS",
     "symbol": "NX"
    },
    {
     "description": "NUVEEN CA SEL TX-FR INC PORT",
     "symbol": "NXC"
    },
    {
     "description": "LIFULL CO LTD",
     "symbol": "NXCLF"
    },
    {
     "description": "NEXCORE HEALTHCARE CAPITAL C",
     "symbol": "NXCR"
    },
    {
     "description": "NEXTDC LTD",
     "symbol": "NXDCF"
    },
    {
     "description": "NEXPOINT DIVERSIFIED REAL ES",
     "symbol": "NXDT"
    },
    {
     "description": "NEXPOINT DIV REAL ESTA",
     "symbol": "NXDT.PRA"
    },
    {
     "description": "NEXGEN ENERGY LTD",
     "symbol": "NXE"
    },
    {
     "description": "NEXIEN BIOPHARMA INC",
     "symbol": "NXEN"
    },
    {
     "description": "NEXT FIFTEEN COMMUNICATIONS",
     "symbol": "NXFNF"
    },
    {
     "description": "NXGEN BRANDS INC",
     "symbol": "NXGB"
    },
    {
     "description": "NEXGEL INC",
     "symbol": "NXGL"
    },
    {
     "description": "NEXGEL INC -CW26",
     "symbol": "NXGLW"
    },
    {
     "description": "NEXGEN MINING INC",
     "symbol": "NXGM"
    },
    {
     "description": "NEXTGEN HEALTHCARE INC",
     "symbol": "NXGN"
    },
    {
     "description": "NEXT PLC",
     "symbol": "NXGPF"
    },
    {
     "description": "NEXT PLC-UNSPON ADR",
     "symbol": "NXGPY"
    },
    {
     "description": "NEXTELIGENT HOLDINGS INC",
     "symbol": "NXGT"
    },
    {
     "description": "NEXT HYDROGEN SOLUTIONS INC",
     "symbol": "NXHSF"
    },
    {
     "description": "NUVEEN NJ QUAL MUNI INC FD",
     "symbol": "NXJ"
    },
    {
     "description": "NUIX LTD",
     "symbol": "NXLLF"
    },
    {
     "description": "NEXT MEATS HOLDINGS INC",
     "symbol": "NXMH"
    },
    {
     "description": "NEXTMART INC",
     "symbol": "NXMR"
    },
    {
     "description": "NUVEEN NY SEL TX-FR INC PORT",
     "symbol": "NXN"
    },
    {
     "description": "NEXEON MEDSYSTEMS INC",
     "symbol": "NXNN"
    },
    {
     "description": "NEXOPTIC TECHNOLOGY CORP",
     "symbol": "NXOPF"
    },
    {
     "description": "NUVEEN SEL TX-FR INC PORT",
     "symbol": "NXP"
    },
    {
     "description": "NATIONAL EXPRESS GROUP PLC",
     "symbol": "NXPGF"
    },
    {
     "description": "NATIONAL EXP GRP-UNSP ADR",
     "symbol": "NXPGY"
    },
    {
     "description": "NXP SEMICONDUCTORS NV",
     "symbol": "NXPI"
    },
    {
     "description": "NEXTPLAT CORP",
     "symbol": "NXPL"
    },
    {
     "description": "ORBSAT CORP -CW23",
     "symbol": "NXPLW"
    },
    {
     "description": "NEXANS SA",
     "symbol": "NXPRF"
    },
    {
     "description": "NEXPRISE INC",
     "symbol": "NXPS"
    },
    {
     "description": "NEXTERA ENTERPRISES INC-A",
     "symbol": "NXRA"
    },
    {
     "description": "NEXPOINT RESIDENTIAL",
     "symbol": "NXRT"
    },
    {
     "description": "NEXT SCIENCE LTD",
     "symbol": "NXSCF"
    },
    {
     "description": "NEXIS INTERNATIONAL INDUSTRI",
     "symbol": "NXSI"
    },
    {
     "description": "NEXTECH SOLUTIONS INC",
     "symbol": "NXSL"
    },
    {
     "description": "NEXSTAR MEDIA GROUP INC-CL A",
     "symbol": "NXST"
    },
    {
     "description": "NEXT BIOMETRICS GROUP AS",
     "symbol": "NXTBF"
    },
    {
     "description": "NEXTCURE INC",
     "symbol": "NXTC"
    },
    {
     "description": "NEXTRACTION ENERGY CORP",
     "symbol": "NXTFF"
    },
    {
     "description": "FIRST TRUST INDXX NEXTG ETF",
     "symbol": "NXTG"
    },
    {
     "description": "NXT NUTRITIONALS HOLDINGS IN",
     "symbol": "NXTH"
    },
    {
     "description": "NEXT10 INC",
     "symbol": "NXTN"
    },
    {
     "description": "NEXTPLAY TECHNOLOGIES INC",
     "symbol": "NXTP"
    },
    {
     "description": "LIFEIST WELLNESS INC",
     "symbol": "NXTTF"
    },
    {
     "description": "FIRST TRUST INDXX NETG ETF",
     "symbol": "NXTUF"
    },
    {
     "description": "NEXITY FINANCIAL CORP",
     "symbol": "NXTYQ"
    },
    {
     "description": "NEXUS GOLD CORP",
     "symbol": "NXXGF"
    },
    {
     "description": "NEXT GAMES OY",
     "symbol": "NXXTF"
    },
    {
     "description": "NEXITY",
     "symbol": "NXYAF"
    },
    {
     "description": "NAYAX LTD",
     "symbol": "NYAXF"
    },
    {
     "description": "NEW YORK CITY REIT INC-A",
     "symbol": "NYC"
    },
    {
     "description": "NEW YORK COMMUNITY BANCORP",
     "symbol": "NYCB"
    },
    {
     "description": "NY COMMUNITY BANCORP INC",
     "symbol": "NYCB.PRA"
    },
    {
     "description": "NY COMMUNITY CAP TRUST V",
     "symbol": "NYCBpU"
    },
    {
     "description": "ISHARES NEW YORK MUNI BOND E",
     "symbol": "NYF"
    },
    {
     "description": "NAYUKI HOLDINGS LTD",
     "symbol": "NYKHF"
    },
    {
     "description": "NYLE INTERNATIONAL CORP",
     "symbol": "NYLE"
    },
    {
     "description": "NEW YORK MORTGAGE TRUST INC",
     "symbol": "NYMT"
    },
    {
     "description": "NEW YORK MORTGAGE TRUST",
     "symbol": "NYMTL"
    },
    {
     "description": "NEW YORK MORTGAGE TRUST",
     "symbol": "NYMTM"
    },
    {
     "description": "NEW YORK MORTGAGE TRUST",
     "symbol": "NYMTN"
    },
    {
     "description": "NEW YORK MORTGAGE TRUST",
     "symbol": "NYMTZ"
    },
    {
     "description": "NYMOX PHARMACEUTICAL CORP",
     "symbol": "NYMX"
    },
    {
     "description": "NYC ON THE MOVE INC",
     "symbol": "NYOM"
    },
    {
     "description": "NYRSTAR NV-UNSPONSORED ADR",
     "symbol": "NYRSY"
    },
    {
     "description": "NEW YORK TIMES CO-A",
     "symbol": "NYT"
    },
    {
     "description": "NIPPON YUSEN KK",
     "symbol": "NYUKF"
    },
    {
     "description": "NYVATEX OIL CORP",
     "symbol": "NYVA"
    },
    {
     "description": "NTG CLARITY NETWORKS INC",
     "symbol": "NYWKF"
    },
    {
     "description": "NYXOAH SA",
     "symbol": "NYXH"
    },
    {
     "description": "NYXIO TECHNOLOGIES CORP",
     "symbol": "NYXO"
    },
    {
     "description": "SPDR MSCI ACWI CLIMATE PARIS",
     "symbol": "NZAC"
    },
    {
     "description": "NEW ZEALAND OIL & GAS LTD",
     "symbol": "NZEOF"
    },
    {
     "description": "NEW ZEALAND OIL-UNSP ADR",
     "symbol": "NZEOY"
    },
    {
     "description": "NEW ZEALAND ENERGY CORP",
     "symbol": "NZERF"
    },
    {
     "description": "NUVEEN MUNI CREDIT INC FD",
     "symbol": "NZF"
    },
    {
     "description": "NZJ HOLDINGS INC",
     "symbol": "NZIH"
    },
    {
     "description": "NEW ZEALAND KING SALMON INVE",
     "symbol": "NZKSF"
    },
    {
     "description": "NEW ZEALAND RURAL LAND CO LT",
     "symbol": "NZLRF"
    },
    {
     "description": "NZME LTD",
     "symbol": "NZMEF"
    },
    {
     "description": "CHANNEL INFRASTRUCTURE NZ LT",
     "symbol": "NZRFF"
    },
    {
     "description": "CHANNEL INFR NZ LTD-UNSP ADR",
     "symbol": "NZRFY"
    },
    {
     "description": "STRATEGY SHARES HALT CLIMATE",
     "symbol": "NZRO"
    },
    {
     "description": "NEW ZEALAND COASTAL SEAFOODS",
     "symbol": "NZSCF"
    },
    {
     "description": "NZX LTD",
     "symbol": "NZSTF"
    },
    {
     "description": "SPARK NEW ZEALAND LTD",
     "symbol": "NZTCF"
    },
    {
     "description": "SMARTSHARES NZ TOP 10 ETF",
     "symbol": "NZTSF"
    },
    {
     "description": "SPDR MSCI USA CLIMATE PARIS",
     "symbol": "NZUS"
    },
    {
     "description": "NZ WINDFARMS LTD",
     "symbol": "NZWFF"
    },
    {
     "description": "REALTY INCOME CORP",
     "symbol": "O"
    },
    {
     "description": "OAKTREE ACQ CORP II - CL A",
     "symbol": "OACB"
    },
    {
     "description": "OAKTREE ACQUISITION CORP II",
     "symbol": "OACB.U"
    },
    {
     "description": "OAKTREE ACQ CORP II A -CW27",
     "symbol": "OACB.WS"
    },
    {
     "description": "ONEASCENT CORE PLUS BOND ETF",
     "symbol": "OACP"
    },
    {
     "description": "OAKTREE CAPITAL GRP LLC",
     "symbol": "OAK.PRA"
    },
    {
     "description": "OAKTREE CAPITAL GRP LLC",
     "symbol": "OAK.PRB"
    },
    {
     "description": "OAK VIEW BANKSHARES INC",
     "symbol": "OAKV"
    },
    {
     "description": "ONEASCENT LARGE CAP CORE",
     "symbol": "OALC"
    },
    {
     "description": "OVERACTIVE MEDIA CORP",
     "symbol": "OAMCF"
    },
    {
     "description": "TATNEFT PAO-SPONSORED ADR",
     "symbol": "OAOFY"
    },
    {
     "description": "FORT ST. JAMES NICKEL CORP",
     "symbol": "OARFF"
    },
    {
     "description": "OAR RESOURCES LTD",
     "symbol": "OARRF"
    },
    {
     "description": "OHIO ART CO",
     "symbol": "OART"
    },
    {
     "description": "OASIS PETROLEUM INC",
     "symbol": "OAS"
    },
    {
     "description": "VIVESTO AB-ADR",
     "symbol": "OASMY"
    },
    {
     "description": "OASIS PETROLEUM INC-CW24",
     "symbol": "OASPW"
    },
    {
     "description": "OAT INC",
     "symbol": "OATN"
    },
    {
     "description": "OUTBRAIN INC",
     "symbol": "OB"
    },
    {
     "description": "OCEAN BIO-CHEM INC",
     "symbol": "OBCI"
    },
    {
     "description": "OBOCON INC",
     "symbol": "OBCN"
    },
    {
     "description": "OBDUCAT AB-B SHS",
     "symbol": "OBDCF"
    },
    {
     "description": "ORBIT DROP INC",
     "symbol": "OBDP"
    },
    {
     "description": "OBSIDIAN ENERGY LTD",
     "symbol": "OBE"
    },
    {
     "description": "ORBIT GARANT DRILLING INC",
     "symbol": "OBGRF"
    },
    {
     "description": "OBIC BUSINESS CONSULTANTS",
     "symbol": "OBIBF"
    },
    {
     "description": "OBIC CO LTD",
     "symbol": "OBIIF"
    },
    {
     "description": "OBLONG INC",
     "symbol": "OBLG"
    },
    {
     "description": "ORBITAL ENTERPRISES",
     "symbol": "OBLR"
    },
    {
     "description": "SPDR LOOMIS SAYLES OPP BOND",
     "symbol": "OBND"
    },
    {
     "description": "ORIGIN BANCORP INC",
     "symbol": "OBNK"
    },
    {
     "description": "OSISKO MINING INC",
     "symbol": "OBNNF"
    },
    {
     "description": "KRANESHARES MSCI ONE BELT ON",
     "symbol": "OBOR"
    },
    {
     "description": "OBRASCON HUARTE LAIN S.A.",
     "symbol": "OBSJF"
    },
    {
     "description": "OBSEVA SA",
     "symbol": "OBSV"
    },
    {
     "description": "ORANGE COUNTY BANCORP INC",
     "symbol": "OBT"
    },
    {
     "description": "OSPREY BITCOIN TRUST",
     "symbol": "OBTC"
    },
    {
     "description": "ORBITAL CORP LTD",
     "symbol": "OBTEF"
    },
    {
     "description": "OBITX INC",
     "symbol": "OBTX"
    },
    {
     "description": "OBAYASHI CORP",
     "symbol": "OBYCF"
    },
    {
     "description": "OWENS CORNING",
     "symbol": "OC"
    },
    {
     "description": "OMNICHANNEL ACQUISITION-CL A",
     "symbol": "OCA"
    },
    {
     "description": "OMNICHANNEL ACQUISITION CORP",
     "symbol": "OCA.U"
    },
    {
     "description": "OMNICHANNEL ACQ CL A -CW27",
     "symbol": "OCA.WS"
    },
    {
     "description": "OCEANAGOLD CORP",
     "symbol": "OCANF"
    },
    {
     "description": "OCA ACQUISITION CORP-CL A",
     "symbol": "OCAX"
    },
    {
     "description": "OCA ACQUISITION CORP",
     "symbol": "OCAXU"
    },
    {
     "description": "OCA ACQ CORP -CL A -CW27",
     "symbol": "OCAXW"
    },
    {
     "description": "OPTICAL CABLE CORP",
     "symbol": "OCC"
    },
    {
     "description": "OFS CREDIT CO INC",
     "symbol": "OCCI"
    },
    {
     "description": "OFS CREDIT COMPANY",
     "symbol": "OCCIN"
    },
    {
     "description": "OFS CREDIT COMPANY",
     "symbol": "OCCIO"
    },
    {
     "description": "OCADO GROUP PLC - SP ADR",
     "symbol": "OCDDY"
    },
    {
     "description": "OCADO GROUP PLC",
     "symbol": "OCDGF"
    },
    {
     "description": "ORTHO CLINICAL DIAGNOSTICS H",
     "symbol": "OCDX"
    },
    {
     "description": "OCEANIA HEALTHCARE LTD",
     "symbol": "OCEHF"
    },
    {
     "description": "ORGANICELL REGENERATIVE MEDI",
     "symbol": "OCEL"
    },
    {
     "description": "IQ CLEAN OCEANS ETF",
     "symbol": "OCEN"
    },
    {
     "description": "OCEAN SPRAY CRANBERRIES INC",
     "symbol": "OCESO"
    },
    {
     "description": "Ocean Spray Cran",
     "symbol": "OCESP"
    },
    {
     "description": "OCEANFIRST FINANCIAL CORP",
     "symbol": "OCFC"
    },
    {
     "description": "OCEANFIRST FINANCIAL CP",
     "symbol": "OCFCP"
    },
    {
     "description": "ONECONNECT FINANCIAL TECHNO",
     "symbol": "OCFT"
    },
    {
     "description": "ORIENTAL CULTURE HOLDING LTD",
     "symbol": "OCG"
    },
    {
     "description": "OCUGEN INC",
     "symbol": "OCGN"
    },
    {
     "description": "OCEANA GROUP LTD",
     "symbol": "OCGPF"
    },
    {
     "description": "OUTCROP SILVER & GOLD CORP",
     "symbol": "OCGSF"
    },
    {
     "description": "OCI NV",
     "symbol": "OCINF"
    },
    {
     "description": "CLEARSHARES OCIO ETF",
     "symbol": "OCIO"
    },
    {
     "description": "OAKLEY CAPITAL INVESTMENTS",
     "symbol": "OCIVF"
    },
    {
     "description": "ORACLE CORP JAPAN",
     "symbol": "OCLCF"
    },
    {
     "description": "ORICA LTD",
     "symbol": "OCLDF"
    },
    {
     "description": "ORICA LTD-UNSP ADR",
     "symbol": "OCLDY"
    },
    {
     "description": "ONCOLOGIX TECH INC",
     "symbol": "OCLG"
    },
    {
     "description": "ORIGINCLEAR INC",
     "symbol": "OCLN"
    },
    {
     "description": "OCWEN FINANCIAL CORP",
     "symbol": "OCN"
    },
    {
     "description": "OCONOMOWOC BANCSHARES INC",
     "symbol": "OCNB"
    },
    {
     "description": "OLYMPUS CORP",
     "symbol": "OCPNF"
    },
    {
     "description": "OLYMPUS CORP-SPON ADR",
     "symbol": "OCPNY"
    },
    {
     "description": "ROSNEFT OIL CO OAO-GDR 144A",
     "symbol": "OCRNL"
    },
    {
     "description": "OAKTREE SPECIALTY LENDING CO",
     "symbol": "OCSL"
    },
    {
     "description": "OXFORD CANNABINOID TECHNOLOG",
     "symbol": "OCTHF"
    },
    {
     "description": "OCEAN OUTDOOR LTD",
     "symbol": "OCTPF"
    },
    {
     "description": "OCTAGON 88 RESOURCES INC",
     "symbol": "OCTX"
    },
    {
     "description": "TRUESHARES STRUC OUTCOME OCT",
     "symbol": "OCTZ"
    },
    {
     "description": "OCULAR THERAPEUTIX INC",
     "symbol": "OCUL"
    },
    {
     "description": "OCUPHIRE PHARMA INC",
     "symbol": "OCUP"
    },
    {
     "description": "OCUMENSION THERAPEUTICS",
     "symbol": "OCUTF"
    },
    {
     "description": "ONCOCYTE CORP",
     "symbol": "OCX"
    },
    {
     "description": "OIL-DRI CORP OF AMERICA",
     "symbol": "ODC"
    },
    {
     "description": "ODD BURGER CORP",
     "symbol": "ODDAF"
    },
    {
     "description": "PACER BLUESTAR DIG ENTERTAIN",
     "symbol": "ODDS"
    },
    {
     "description": "PETRICHOR ENERGY INC",
     "symbol": "ODEFF"
    },
    {
     "description": "ODAKYU ELECTRIC RAILWAY CO",
     "symbol": "ODERF"
    },
    {
     "description": "OLD DOMINION FREIGHT LINE",
     "symbol": "ODFL"
    },
    {
     "description": "ODYSSEY SEMICONDUCTOR TECHNO",
     "symbol": "ODII"
    },
    {
     "description": "ODIMO INC",
     "symbol": "ODMO"
    },
    {
     "description": "OLD MUTUAL LTD",
     "symbol": "ODMUF"
    },
    {
     "description": "ODP CORP\/THE",
     "symbol": "ODP"
    },
    {
     "description": "OUTDOOR SPECIALTY PRODUCTS I",
     "symbol": "ODRS"
    },
    {
     "description": "ODONATE THERAPEUTICS INC",
     "symbol": "ODTC"
    },
    {
     "description": "ODYNE CORP",
     "symbol": "ODYC"
    },
    {
     "description": "ODYSSEY GROUP INTERNATIONAL",
     "symbol": "ODYY"
    },
    {
     "description": "ORION ENGINEERED CARBONS SA",
     "symbol": "OEC"
    },
    {
     "description": "ORACLE ENERGY CORP",
     "symbol": "OECPF"
    },
    {
     "description": "OSAGE EXPLORATION & DEVELOPM",
     "symbol": "OEDVQ"
    },
    {
     "description": "ISHARES S&P 100 ETF",
     "symbol": "OEF"
    },
    {
     "description": "ORBITAL ENERGY GROUP INC",
     "symbol": "OEG"
    },
    {
     "description": "ONENERGY INC",
     "symbol": "OEGFF"
    },
    {
     "description": "ONE EQUITY PARTNERS OPEN-A",
     "symbol": "OEPW"
    },
    {
     "description": "ONE EQUITY PARTNERS OPEN WAT",
     "symbol": "OEPWU"
    },
    {
     "description": "ONE EQUITY PARTNERS A -CW27",
     "symbol": "OEPWW"
    },
    {
     "description": "OESTERREICHISCHE POST AG",
     "symbol": "OERCF"
    },
    {
     "description": "OC OERLIKON CORP AG-REG",
     "symbol": "OERLF"
    },
    {
     "description": "OC OERLIKON CORP-UNSP ADR",
     "symbol": "OERLY"
    },
    {
     "description": "ORION ENERGY SYSTEMS INC",
     "symbol": "OESX"
    },
    {
     "description": "OSHARES EUROPE QUALITY DIVID",
     "symbol": "OEUR"
    },
    {
     "description": "VERBUND AG",
     "symbol": "OEZVF"
    },
    {
     "description": "VERBUND AG-SPONS ADR",
     "symbol": "OEZVY"
    },
    {
     "description": "CORPORATE OFFICE PROPERTIES",
     "symbol": "OFC"
    },
    {
     "description": "OCONEE FEDERAL FINANCIAL COR",
     "symbol": "OFED"
    },
    {
     "description": "OFG BANCORP",
     "symbol": "OFG"
    },
    {
     "description": "ORTHOFIX MEDICAL INC",
     "symbol": "OFIX"
    },
    {
     "description": "OMEGA FLEX INC",
     "symbol": "OFLX"
    },
    {
     "description": "OFS CAPITAL CORP",
     "symbol": "OFS"
    },
    {
     "description": "OMNI FINANCIAL SERVICES INC",
     "symbol": "OFSI"
    },
    {
     "description": "OFS CAPITAL CORP",
     "symbol": "OFSSH"
    },
    {
     "description": "CARBON STREAMING CORP",
     "symbol": "OFSTF"
    },
    {
     "description": "CARBON STREAMING CORP -CW26",
     "symbol": "OFSWF"
    },
    {
     "description": "ONION GLOBAL LTD",
     "symbol": "OG"
    },
    {
     "description": "ORGANIC AGRICULTURAL CO LTD",
     "symbol": "OGAA"
    },
    {
     "description": "EMPIRE STATE REALTY OP-S60",
     "symbol": "OGCP"
    },
    {
     "description": "OTIS GALLERY LLC-MEMB INTERE",
     "symbol": "OGDAS"
    },
    {
     "description": "OTIS GALLERY LLC-MEMB INTERE",
     "symbol": "OGDBS"
    },
    {
     "description": "OCEANAGOLD CORP-CDI",
     "symbol": "OGDCF"
    },
    {
     "description": "OTIS GALLERY LLC",
     "symbol": "OGDCS"
    },
    {
     "description": "OTIS GALLERY LLC",
     "symbol": "OGDDS"
    },
    {
     "description": "OTIS GALLERY LLC-MEMB INTERE",
     "symbol": "OGDES"
    },
    {
     "description": "OTIS GALLERY LLC-MEMB INTERE",
     "symbol": "OGDFS"
    },
    {
     "description": "OMEGA DIAGNOSTICS GROUP PLC",
     "symbol": "OGDGF"
    },
    {
     "description": "OTIS GALLERY LLC-MEMBE INTER",
     "symbol": "OGDHS"
    },
    {
     "description": "OTIS GALLERY LLC-MEMBE INTER",
     "symbol": "OGDIS"
    },
    {
     "description": "OTIS GALLERY LLC",
     "symbol": "OGDJS"
    },
    {
     "description": "OTIS GALLERY LLC",
     "symbol": "OGDKS"
    },
    {
     "description": "OTIS GALLERY LLC-MEMBE INTER",
     "symbol": "OGDLS"
    },
    {
     "description": "OTIS GALLERY LLC",
     "symbol": "OGDMS"
    },
    {
     "description": "OGE ENERGY CORP",
     "symbol": "OGE"
    },
    {
     "description": "ORAGENICS INC",
     "symbol": "OGEN"
    },
    {
     "description": "ORIGIN ENERGY LTD",
     "symbol": "OGFGF"
    },
    {
     "description": "0RIGIN ENERGY LTD-UNSPON ADR",
     "symbol": "OGFGY"
    },
    {
     "description": "OTIS GALLERY LLC-MEMBE INTER",
     "symbol": "OGFKS"
    },
    {
     "description": "OTIS GALLERY LLC-MEMBE INTER",
     "symbol": "OGFPS"
    },
    {
     "description": "OTIS COLLECTION LLC-MEMBERSH",
     "symbol": "OGGCS"
    },
    {
     "description": "ORAGIN FOODS INC",
     "symbol": "OGGFF"
    },
    {
     "description": "OTIS GALLERY LLC-MEMBE INTER",
     "symbol": "OGGFS"
    },
    {
     "description": "OTIS GALLERY LLC-MEMB INTERE",
     "symbol": "OGGLS"
    },
    {
     "description": "OTIS GALLERY LLC-MEMB INTERE",
     "symbol": "OGGMS"
    },
    {
     "description": "ORIGEN RESOURCES INC",
     "symbol": "OGGNF"
    },
    {
     "description": "OTIS GALLERY LLC-MEMB INTERE",
     "symbol": "OGGTS"
    },
    {
     "description": "OTIS GALLERY LLC-MEMB INTERE",
     "symbol": "OGGXS"
    },
    {
     "description": "ORGANIGRAM HOLDINGS INC",
     "symbol": "OGI"
    },
    {
     "description": "O'SHARES GLOBAL INTERNET GIA",
     "symbol": "OGIG"
    },
    {
     "description": "OTIS GALLERY LLC-MEMB INTERE",
     "symbol": "OGLAS"
    },
    {
     "description": "OTIS GALLERY LLC-MEMB INTERE",
     "symbol": "OGLCS"
    },
    {
     "description": "OTIS GALLERY LLC-MEMB INTERE",
     "symbol": "OGLFS"
    },
    {
     "description": "OTIS GALLERY LLC-MEMB INTERE",
     "symbol": "OGLGS"
    },
    {
     "description": "OTIS GALLERY LLC-MEMB INTERE",
     "symbol": "OGLHS"
    },
    {
     "description": "OTIS GALLERY LLC",
     "symbol": "OGLYS"
    },
    {
     "description": "OTIS GALLERY LLC-MEMB INTERE",
     "symbol": "OGMAS"
    },
    {
     "description": "OTIS GALLERY LLC-MEMBE INTER",
     "symbol": "OGMBS"
    },
    {
     "description": "ORGANON & CO",
     "symbol": "OGN"
    },
    {
     "description": "BRAVO ENTERPRISES LTD",
     "symbol": "OGNG"
    },
    {
     "description": "OROGEN ROYALTIES INC",
     "symbol": "OGNRF"
    },
    {
     "description": "ORGANA TECHNOLOGIES GROUP IN",
     "symbol": "OGNT"
    },
    {
     "description": "ORGANTO FOODS INC",
     "symbol": "OGOFF"
    },
    {
     "description": "OTIS GALLERY LLC",
     "symbol": "OGPKS"
    },
    {
     "description": "ONE GAS INC",
     "symbol": "OGS"
    },
    {
     "description": "OTIS GALLERY LLC-MEMB INTERE",
     "symbol": "OGSAS"
    },
    {
     "description": "OTIS GALLERY LLC",
     "symbol": "OGSBS"
    },
    {
     "description": "OTIS GALLERY LLC-MEMB INTERE",
     "symbol": "OGSCS"
    },
    {
     "description": "OTIS GALLERY LLC",
     "symbol": "OGSDS"
    },
    {
     "description": "OTIS GALLERY LLC",
     "symbol": "OGSES"
    },
    {
     "description": "OTIS GALLERY LLC-MEMB INTERE",
     "symbol": "OGSFS"
    },
    {
     "description": "OTIS GALLERY LLC-MEMB INTERE",
     "symbol": "OGSGS"
    },
    {
     "description": "OTIS GALLERY LLC",
     "symbol": "OGSHS"
    },
    {
     "description": "OTIS GALLERY LLC-MEMB INTERE",
     "symbol": "OGSJS"
    },
    {
     "description": "OTIS GALLERY LLC-MEMB UNITS",
     "symbol": "OGSKS"
    },
    {
     "description": "OTIS GALLERY LLC-MEMB INTERE",
     "symbol": "OGSLS"
    },
    {
     "description": "ORGANIC SALES AND MARKETING",
     "symbol": "OGSM"
    },
    {
     "description": "OTIS GALLERY LLC",
     "symbol": "OGSNS"
    },
    {
     "description": "OTIS GALLERY LLC-MEMB INTERE",
     "symbol": "OGSOS"
    },
    {
     "description": "OVERSEAS SHIPHOLD-CL A CW39",
     "symbol": "OGSRW"
    },
    {
     "description": "OTIS GALLERY LLC-MEMBE INTER",
     "symbol": "OGSSS"
    },
    {
     "description": "OTIS GALLERY LLC-MEMB INTERE",
     "symbol": "OGSTS"
    },
    {
     "description": "OTIS GALLERY LLC-MEMB INTERE",
     "symbol": "OGSUS"
    },
    {
     "description": "OTIS GALLERY LLC-MEMB INTERE",
     "symbol": "OGSVS"
    },
    {
     "description": "OTIS GALLERY LLC-MEMB INTERE",
     "symbol": "OGSWS"
    },
    {
     "description": "OTIS GALLERY LLC",
     "symbol": "OGSXS"
    },
    {
     "description": "OTIS GALLERY LLC-MEMB INTERE",
     "symbol": "OGSYS"
    },
    {
     "description": "OTIS GALLERY LLC",
     "symbol": "OGSZS"
    },
    {
     "description": "OTIS GALLERY LLC-MEMBE INTER",
     "symbol": "OGTDS"
    },
    {
     "description": "GAZPROM PJSC-SPON ADR",
     "symbol": "OGZPY"
    },
    {
     "description": "GAZPROM PAO-ADR 144A",
     "symbol": "OGZRY"
    },
    {
     "description": "OPY ACQUISITION CORP I - A",
     "symbol": "OHAA"
    },
    {
     "description": "OPY ACQUISITION CORP I",
     "symbol": "OHAAU"
    },
    {
     "description": "OPY ACQUISITION IA -CW23",
     "symbol": "OHAAW"
    },
    {
     "description": "ORACLE HEALTHCARE ACQUISIT",
     "symbol": "OHAQ"
    },
    {
     "description": "OLD HARBOR BANK",
     "symbol": "OHBK"
    },
    {
     "description": "OHB SE",
     "symbol": "OHBTF"
    },
    {
     "description": "OPTIMUS HEALTHCARE SERVICES",
     "symbol": "OHCS"
    },
    {
     "description": "OMEGA HEALTHCARE INVESTORS",
     "symbol": "OHI"
    },
    {
     "description": "OHMOTO GUMI CO LTD",
     "symbol": "OHMGF"
    },
    {
     "description": "ORION ACQUISITION CORP-CL A",
     "symbol": "OHPA"
    },
    {
     "description": "ORION ACQUISITION CORP",
     "symbol": "OHPAU"
    },
    {
     "description": "ORION ACQUISITION CL A -CW26",
     "symbol": "OHPAW"
    },
    {
     "description": "OASIS HOTEL & RESORT CASINO",
     "symbol": "OHTR"
    },
    {
     "description": "O-I GLASS INC",
     "symbol": "OI"
    },
    {
     "description": "INVESCO MUNICIPAL INCOME OPP",
     "symbol": "OIA"
    },
    {
     "description": "OI SA-ADR",
     "symbol": "OIBRQ"
    },
    {
     "description": "OI SA-ADR",
     "symbol": "OIBZQ"
    },
    {
     "description": "OICINTRA INC",
     "symbol": "OICT"
    },
    {
     "description": "OIDON CO LTD",
     "symbol": "OIDN"
    },
    {
     "description": "OILEX LTD",
     "symbol": "OIEXF"
    },
    {
     "description": "CHARIOT LTD",
     "symbol": "OIGLF"
    },
    {
     "description": "VANECK OIL SERVICES ETF",
     "symbol": "OIH"
    },
    {
     "description": "OCEANEERING INTL INC",
     "symbol": "OII"
    },
    {
     "description": "O3 MINING INC",
     "symbol": "OIIIF"
    },
    {
     "description": "O2MICRO INTERNATIONAL-ADR",
     "symbol": "OIIM"
    },
    {
     "description": "IPATH PURE BETA CRUDE OIL",
     "symbol": "OIL"
    },
    {
     "description": "PERMEX PETROLEUM CORP",
     "symbol": "OILCF"
    },
    {
     "description": "MICRO OG EXP PROD 3X INV LEV",
     "symbol": "OILD"
    },
    {
     "description": "NEXTLEAF SOLUTIONS LTD",
     "symbol": "OILFF"
    },
    {
     "description": "PROSHARES K-1 FREE CRUDE ETF",
     "symbol": "OILK"
    },
    {
     "description": "IPATH S&P GSCI CRUDE OIL TR",
     "symbol": "OILNF"
    },
    {
     "description": "OIL REFINERIES LTD",
     "symbol": "OILRF"
    },
    {
     "description": "MICRO OG EXP PROD 3X LEVG",
     "symbol": "OILU"
    },
    {
     "description": "SINO AMERICAN OIL CO",
     "symbol": "OILY"
    },
    {
     "description": "OIL STATES INTERNATIONAL INC",
     "symbol": "OIS"
    },
    {
     "description": "OISIX RA DAICHI INC",
     "symbol": "OISXF"
    },
    {
     "description": "OITA BANK LTD\/THE",
     "symbol": "OITAF"
    },
    {
     "description": "OJI HOLDINGS CORP",
     "symbol": "OJIPF"
    },
    {
     "description": "OJI HOLDINGS CORP-UNSPD ADR",
     "symbol": "OJIPY"
    },
    {
     "description": "OJAI OIL CO",
     "symbol": "OJOC"
    },
    {
     "description": "ROSNEFT OIL CO PJSC-REGS GDR",
     "symbol": "OJSCY"
    },
    {
     "description": "OJSYS INC",
     "symbol": "OJSY"
    },
    {
     "description": "OKAMURA CORP",
     "symbol": "OKAMF"
    },
    {
     "description": "ONWARD HOLDINGS-UNSPON ADR",
     "symbol": "OKASY"
    },
    {
     "description": "OKINAWA CELLULAR TELEPHONE",
     "symbol": "OKCTF"
    },
    {
     "description": "ONEOK INC",
     "symbol": "OKE"
    },
    {
     "description": "OKEANIS ECO TANKERS CORP",
     "symbol": "OKENF"
    },
    {
     "description": "OKINAWA ELECTRIC POWER CO",
     "symbol": "OKEPF"
    },
    {
     "description": "OKI ELECTRIC INDUSTRY CO LTD",
     "symbol": "OKIEF"
    },
    {
     "description": "OKI ELECTRIC IND CO-UNS ADR",
     "symbol": "OKIEY"
    },
    {
     "description": "OKLO RESOURCES LTD",
     "symbol": "OKLOF"
    },
    {
     "description": "OKAPI RESOURCES LTD",
     "symbol": "OKPRF"
    },
    {
     "description": "OKASAN SECURITIES GROUP INC",
     "symbol": "OKSCF"
    },
    {
     "description": "OKTA INC",
     "symbol": "OKTA"
    },
    {
     "description": "OLB GROUP INC",
     "symbol": "OLB"
    },
    {
     "description": "ORIENTAL LAND CO LTD",
     "symbol": "OLCLF"
    },
    {
     "description": "ORIENTAL LAND CO LTD-ADR",
     "symbol": "OLCLY"
    },
    {
     "description": "UNIVERSAL DISPLAY CORP",
     "symbol": "OLED"
    },
    {
     "description": "OLFACTORY BIOSCIENCES CORP",
     "symbol": "OLFC"
    },
    {
     "description": "OLAM GROUP LTD",
     "symbol": "OLGPF"
    },
    {
     "description": "OMNILIT ACQUISITION CORP-A",
     "symbol": "OLIT"
    },
    {
     "description": "OMNILIT ACQUISITION CORP",
     "symbol": "OLITU"
    },
    {
     "description": "OMNILIT ACQUISITION CL A -23",
     "symbol": "OLITW"
    },
    {
     "description": "OLINK HOLDING AB - ADR",
     "symbol": "OLK"
    },
    {
     "description": "OLLIE'S BARGAIN OUTLET HOLDI",
     "symbol": "OLLI"
    },
    {
     "description": "OLEMA PHARMACEUTICALS INC",
     "symbol": "OLMA"
    },
    {
     "description": "ONELIFE TECHNOLOGIES CORP",
     "symbol": "OLMM"
    },
    {
     "description": "OLIN CORP",
     "symbol": "OLN"
    },
    {
     "description": "OMNI-LITE INDUSTRIES CANADA",
     "symbol": "OLNCF"
    },
    {
     "description": "ONELINK CORP",
     "symbol": "OLNK"
    },
    {
     "description": "OLO INC - CLASS A",
     "symbol": "OLO"
    },
    {
     "description": "DB CRUDE OIL LONG EXCHANGE",
     "symbol": "OLOXF"
    },
    {
     "description": "ONE LIBERTY PROPERTIES INC",
     "symbol": "OLP"
    },
    {
     "description": "OLAPLEX HOLDINGS INC",
     "symbol": "OLPX"
    },
    {
     "description": "OLIVEDA INTERNATIONAL INC",
     "symbol": "OLVI"
    },
    {
     "description": "OLIVUT RESOURCES LTD",
     "symbol": "OLVRF"
    },
    {
     "description": "OUTSET MEDICAL INC",
     "symbol": "OM"
    },
    {
     "description": "GRUPO AEROPORTUARIO CEN-ADR",
     "symbol": "OMAB"
    },
    {
     "description": "OMAGINE INC",
     "symbol": "OMAGQ"
    },
    {
     "description": "OMNICOM GROUP",
     "symbol": "OMC"
    },
    {
     "description": "OMNICELL INC",
     "symbol": "OMCL"
    },
    {
     "description": "OHMORIYA CO LTD",
     "symbol": "OMCOF"
    },
    {
     "description": "ORMAND INDUSTRIES INC",
     "symbol": "OMDD"
    },
    {
     "description": "OMEGA ALPHA SPAC -CLASS A",
     "symbol": "OMEG"
    },
    {
     "description": "OMEROS CORP",
     "symbol": "OMER"
    },
    {
     "description": "ODYSSEY MARINE EXPLORATION",
     "symbol": "OMEX"
    },
    {
     "description": "ONEMAIN HOLDINGS INC",
     "symbol": "OMF"
    },
    {
     "description": "INVESCO RUSSELL 1000 DYN M\/F",
     "symbol": "OMFL"
    },
    {
     "description": "INVESCO RSL 2000 DYN MLTFCTR",
     "symbol": "OMFS"
    },
    {
     "description": "OMEGA THERAPEUTICS INC",
     "symbol": "OMGA"
    },
    {
     "description": "OMAI GOLD MINES CORP",
     "symbol": "OMGGF"
    },
    {
     "description": "OMNI HEALTH INC",
     "symbol": "OMHE"
    },
    {
     "description": "OM HOLDINGS INTERNATIONAL I",
     "symbol": "OMHI"
    },
    {
     "description": "OM HOLDINGS LTD",
     "symbol": "OMHLF"
    },
    {
     "description": "OWENS & MINOR INC",
     "symbol": "OMI"
    },
    {
     "description": "SINGULAR GENOMICS SYSTEMS IN",
     "symbol": "OMIC"
    },
    {
     "description": "OMID HOLDINGS INC",
     "symbol": "OMID"
    },
    {
     "description": "OOH!MEDIA LTD",
     "symbol": "OMLAF"
    },
    {
     "description": "OMNIMMUNE HOLDINGS INC",
     "symbol": "OMMH"
    },
    {
     "description": "OMINECA MINING & METALS LTD",
     "symbol": "OMMSF"
    },
    {
     "description": "OMPHALOS CORP",
     "symbol": "OMPS"
    },
    {
     "description": "OMNIQ CORP",
     "symbol": "OMQS"
    },
    {
     "description": "OMRON CORP",
     "symbol": "OMRNF"
    },
    {
     "description": "OMRON CORP- SPONSORED ADR",
     "symbol": "OMRNY"
    },
    {
     "description": "ORTHOMETRIX INC",
     "symbol": "OMRX"
    },
    {
     "description": "OMNITEK ENGINEERING CORP",
     "symbol": "OMTK"
    },
    {
     "description": "OMNI VENTURES INC",
     "symbol": "OMVE"
    },
    {
     "description": "OMV AG",
     "symbol": "OMVJF"
    },
    {
     "description": "OMV AG-BEARER SHRS ADR",
     "symbol": "OMVKY"
    },
    {
     "description": "INSURCOM FINANCIAL CORP",
     "symbol": "OMWDF"
    },
    {
     "description": "OMNIA WELLNESS INC",
     "symbol": "OMWS"
    },
    {
     "description": "OSISKO METALS INC",
     "symbol": "OMZNF"
    },
    {
     "description": "ON SEMICONDUCTOR",
     "symbol": "ON"
    },
    {
     "description": "OLD NATIONAL BANCORP",
     "symbol": "ONB"
    },
    {
     "description": "ONE BIO CORP",
     "symbol": "ONBI"
    },
    {
     "description": "ONCOLYS BIOPHARMA INC",
     "symbol": "ONBPF"
    },
    {
     "description": "OLD NATL BANCORP",
     "symbol": "ONBPO"
    },
    {
     "description": "OLD NATL BANCORP",
     "symbol": "ONBPP"
    },
    {
     "description": "ON4 COMMUNICATIONS INC",
     "symbol": "ONCI"
    },
    {
     "description": "141 CAPITAL INC",
     "symbol": "ONCP"
    },
    {
     "description": "ONCORUS INC",
     "symbol": "ONCR"
    },
    {
     "description": "ONCOSEC MEDICAL INC",
     "symbol": "ONCS"
    },
    {
     "description": "ONCTERNAL THERAPEUTICS INC",
     "symbol": "ONCT"
    },
    {
     "description": "ONCOLYTICS BIOTECH INC-CW22",
     "symbol": "ONCWF"
    },
    {
     "description": "ONCOLYTICS BIOTECH INC",
     "symbol": "ONCY"
    },
    {
     "description": "PROSHARES ON-DEMAND ETF",
     "symbol": "OND"
    },
    {
     "description": "ONDAS HOLDINGS INC",
     "symbol": "ONDS"
    },
    {
     "description": "ONESMART INTERNATIONAL -ADR",
     "symbol": "ONE"
    },
    {
     "description": "1LIFE HEALTHCARE INC",
     "symbol": "ONEM"
    },
    {
     "description": "SPDR RUSSELL 1000 MOMEN FOCU",
     "symbol": "ONEO"
    },
    {
     "description": "FIDELITY NASDAQ COMPOSITE IN",
     "symbol": "ONEQ"
    },
    {
     "description": "SPDR RUSSELL LOW VOL FOCUS",
     "symbol": "ONEV"
    },
    {
     "description": "ONEWATER MARINE INC-CL A",
     "symbol": "ONEW"
    },
    {
     "description": "ONEX CORPORATION",
     "symbol": "ONEXF"
    },
    {
     "description": "SPDR RUSSELL 1000 YIELD FOCU",
     "symbol": "ONEY"
    },
    {
     "description": "DIREXION DAILY OIL BULL 2X",
     "symbol": "ONG"
    },
    {
     "description": "ORION OFFICE REIT INC",
     "symbol": "ONL"
    },
    {
     "description": "PROSHARES ONLINE RETAIL ETF",
     "symbol": "ONLN"
    },
    {
     "description": "ONAMBA CO LTD",
     "symbol": "ONMBF"
    },
    {
     "description": "ONEMARKET LTD",
     "symbol": "ONMKF"
    },
    {
     "description": "GLOBAL X ADAPTIVE U.S. RISK",
     "symbol": "ONOF"
    },
    {
     "description": "ON HOLDING AG-CLASS A",
     "symbol": "ONON"
    },
    {
     "description": "CASTELLUM INC",
     "symbol": "ONOV"
    },
    {
     "description": "ONCOLOGY PHARMA INC",
     "symbol": "ONPH"
    },
    {
     "description": "ONCOPEPTIDES AB",
     "symbol": "ONPPF"
    },
    {
     "description": "ONS ACQUISITION CORP",
     "symbol": "ONS.U"
    },
    {
     "description": "ONASSIS HOLDINGS CORP",
     "symbol": "ONSS"
    },
    {
     "description": "ONE SOFTWARE TECHNOLOGIES LT",
     "symbol": "ONSTF"
    },
    {
     "description": "ON24 INC",
     "symbol": "ONTF"
    },
    {
     "description": "ONTO INNOVATION INC",
     "symbol": "ONTO"
    },
    {
     "description": "BLACKROCK OIL CORP",
     "symbol": "ONTRF"
    },
    {
     "description": "OXFORD NANOPORE TECHNOLOGIES",
     "symbol": "ONTTF"
    },
    {
     "description": "ONCONOVA THERAPEUTICS INC",
     "symbol": "ONTX"
    },
    {
     "description": "ONLINE VACATION CENTER HOLDI",
     "symbol": "ONVC"
    },
    {
     "description": "ORGANOVO HOLDINGS INC",
     "symbol": "ONVO"
    },
    {
     "description": "ORONOVA ENERGY INC",
     "symbol": "ONVRF"
    },
    {
     "description": "ONEVIEW HEALTHCARE PLC-CDI",
     "symbol": "ONVVF"
    },
    {
     "description": "ONWARD MEDICAL",
     "symbol": "ONWRF"
    },
    {
     "description": "ONYX CORP\/UTAH",
     "symbol": "ONXC"
    },
    {
     "description": "ONTEX GROUP NV",
     "symbol": "ONXXF"
    },
    {
     "description": "ONTEX GROUP NV-UNS ADR",
     "symbol": "ONXYY"
    },
    {
     "description": "ONYX ACQUISITION CO I-CL A",
     "symbol": "ONYX"
    },
    {
     "description": "ONYX ACQUISITION CO I",
     "symbol": "ONYXU"
    },
    {
     "description": "ONYX ACQ CO I CL A -CW23",
     "symbol": "ONYXW"
    },
    {
     "description": "ORGANIZACION SORIANA S.A.B-B",
     "symbol": "ONZBF"
    },
    {
     "description": "OMDA OIL & GAS INC",
     "symbol": "OOAG"
    },
    {
     "description": "ON THE BEACH GROUP PLC",
     "symbol": "OOBHF"
    },
    {
     "description": "ORION DIVERSIFIED HOLDING CO",
     "symbol": "OODH"
    },
    {
     "description": "OOEDO ONSEN REIT INVESTMENT",
     "symbol": "OODVF"
    },
    {
     "description": "C2E ENERGY INC",
     "symbol": "OOGI"
    },
    {
     "description": "OOMA INC",
     "symbol": "OOMA"
    },
    {
     "description": "01 COMMUNIQUE LABORATORY INC",
     "symbol": "OONEF"
    },
    {
     "description": "OPTION NV",
     "symbol": "OONVF"
    },
    {
     "description": "OOOOO ENTERTAINMENT COMMERCE",
     "symbol": "OOOOF"
    },
    {
     "description": "DIREXION DAILY TRVL VACA 2X",
     "symbol": "OOTO"
    },
    {
     "description": "OCEANPAL INC",
     "symbol": "OP"
    },
    {
     "description": "MAGNUM OPUS ACQUISITION LT-A",
     "symbol": "OPA"
    },
    {
     "description": "MAGNUM OPUS ACQUISITION LTD",
     "symbol": "OPA.U"
    },
    {
     "description": "MAGNUM OPUS ACQ CL A -CW27",
     "symbol": "OPA.WS"
    },
    {
     "description": "OFFERPAD SOLUTIONS INC",
     "symbol": "OPAD"
    },
    {
     "description": "OFFERPAD SOLUTIONS INC -CW25",
     "symbol": "OPAD.WS"
    },
    {
     "description": "OP BANCORP",
     "symbol": "OPBK"
    },
    {
     "description": "OPTIBIOTIX HEALTH PLC",
     "symbol": "OPBXF"
    },
    {
     "description": "ORGANIC POTASH CORP",
     "symbol": "OPCGF"
    },
    {
     "description": "OPTION CARE HEALTH INC",
     "symbol": "OPCH"
    },
    {
     "description": "OPENDOOR TECHNOLOGIES INC",
     "symbol": "OPEN"
    },
    {
     "description": "CLEARSHARES ULTRA-SHORT MATU",
     "symbol": "OPER"
    },
    {
     "description": "OTELLO CORP ASA",
     "symbol": "OPESF"
    },
    {
     "description": "OPPFI INC",
     "symbol": "OPFI"
    },
    {
     "description": "FG NEW AMERICA ACQUISI -CW27",
     "symbol": "OPFI.WS"
    },
    {
     "description": "OPGEN INC",
     "symbol": "OPGN"
    },
    {
     "description": "OPTIGENEX INC",
     "symbol": "OPGX"
    },
    {
     "description": "OPTIMUMBANK HOLDINGS INC",
     "symbol": "OPHC"
    },
    {
     "description": "ORGANIC PLANT HEALTH INC",
     "symbol": "OPHI"
    },
    {
     "description": "ONO PHARMACEUTICAL CO LTD",
     "symbol": "OPHLF"
    },
    {
     "description": "ONO PHARMACEUTICAL CO-UN ADR",
     "symbol": "OPHLY"
    },
    {
     "description": "OFFICE PROPERTIES INCOME TRU",
     "symbol": "OPI"
    },
    {
     "description": "OFFICE PPTY INCOME TRST",
     "symbol": "OPINL"
    },
    {
     "description": "OPKO HEALTH INC",
     "symbol": "OPK"
    },
    {
     "description": "DIGITAL HOLDINGS INC",
     "symbol": "OPKYF"
    },
    {
     "description": "OPTIMUMCARE CORP",
     "symbol": "OPMC"
    },
    {
     "description": "OPTIONS MEDIA GROUP HOLDINGS",
     "symbol": "OPMG"
    },
    {
     "description": "OPERADORA DE SITES MEX- A-1",
     "symbol": "OPMXF"
    },
    {
     "description": "1PM INDUSTRIES INC",
     "symbol": "OPMZ"
    },
    {
     "description": "OPEN DOOR INC",
     "symbol": "OPNDF"
    },
    {
     "description": "OPIANT PHARMACEUTICALS INC",
     "symbol": "OPNT"
    },
    {
     "description": "OLD POINT FINANCIAL CORP",
     "symbol": "OPOF"
    },
    {
     "description": "OPEN ORPHAN PLC",
     "symbol": "OPORF"
    },
    {
     "description": "RIVERNRTH\/DOUBLELNE STR OPP",
     "symbol": "OPP"
    },
    {
     "description": "RIVERNORTH\/DOUBLELINE",
     "symbol": "OPP.PRA"
    },
    {
     "description": "RIVERNORTH\/DOUBLELINE",
     "symbol": "OPP.PRB"
    },
    {
     "description": "OPEN HOUSE GROUP CO LTD",
     "symbol": "OPPPF"
    },
    {
     "description": "CORBETT ROAD TACTICAL OPP",
     "symbol": "OPPX"
    },
    {
     "description": "OPERA LTD-ADR",
     "symbol": "OPRA"
    },
    {
     "description": "OPORTUN FINANCIAL CORP",
     "symbol": "OPRT"
    },
    {
     "description": "OPTIMIZERX CORP",
     "symbol": "OPRX"
    },
    {
     "description": "OPSENS INC",
     "symbol": "OPSSF"
    },
    {
     "description": "OPT-SCIENCES CORP",
     "symbol": "OPST"
    },
    {
     "description": "OPTHEA LTD-SPON ADR",
     "symbol": "OPT"
    },
    {
     "description": "ORIENTAL PETRO & MIN 'B' COM",
     "symbol": "OPTBF"
    },
    {
     "description": "OPTIMI HEALTH CORP",
     "symbol": "OPTHF"
    },
    {
     "description": "OPTEC INTERNATIONAL INC",
     "symbol": "OPTI"
    },
    {
     "description": "OPTIMUM INTERACTIVE (USA)",
     "symbol": "OPTL"
    },
    {
     "description": "OPTINOSE INC",
     "symbol": "OPTN"
    },
    {
     "description": "OCEAN POWER TECHNOLOGIES INC",
     "symbol": "OPTT"
    },
    {
     "description": "OPTICEPT TECHNOLOGIES AB",
     "symbol": "OPTZF"
    },
    {
     "description": "OPUS MAGNUM AMERIS INC",
     "symbol": "OPUS"
    },
    {
     "description": "OPTIMUM VENTURES LTD",
     "symbol": "OPVLF"
    },
    {
     "description": "NANOFLEX POWER CORP",
     "symbol": "OPVS"
    },
    {
     "description": "OPAWICA EXPLORATIONS INC",
     "symbol": "OPWEF"
    },
    {
     "description": "OPTEX SYSTEMS HOLDINGS INC",
     "symbol": "OPXS"
    },
    {
     "description": "OPPENHEIMER HOLDINGS-CL A",
     "symbol": "OPY"
    },
    {
     "description": "POLYUS PJSC-SPONSORED ADR",
     "symbol": "OPYGY"
    },
    {
     "description": "OL GROUPE",
     "symbol": "OQLGF"
    },
    {
     "description": "OSISKO GOLD ROYALTIES LTD",
     "symbol": "OR"
    },
    {
     "description": "ORMAT TECHNOLOGIES INC",
     "symbol": "ORA"
    },
    {
     "description": "MONARCA MINERALS INC",
     "symbol": "ORAGF"
    },
    {
     "description": "ORANGE-SPON ADR",
     "symbol": "ORAN"
    },
    {
     "description": "OREGON BANCORP INC",
     "symbol": "ORBN"
    },
    {
     "description": "ORBIT INTERNATIONAL CORP",
     "symbol": "ORBT"
    },
    {
     "description": "ORCHID ISLAND CAPITAL INC",
     "symbol": "ORC"
    },
    {
     "description": "OWL ROCK CAPITAL CORP",
     "symbol": "ORCC"
    },
    {
     "description": "ORACLE CORP",
     "symbol": "ORCL"
    },
    {
     "description": "OREA MINING CORP",
     "symbol": "OREAF"
    },
    {
     "description": "ORIGIN ENTERPRISES PLC",
     "symbol": "ORENF"
    },
    {
     "description": "ORESTONE MINING CORP",
     "symbol": "ORESF"
    },
    {
     "description": "OREFINDERS RESOURCES INC",
     "symbol": "ORFDF"
    },
    {
     "description": "ORANGE BELT SUPPLY CO",
     "symbol": "ORGB"
    },
    {
     "description": "ORGHARVEST INC",
     "symbol": "ORGH"
    },
    {
     "description": "ORGANO CORP",
     "symbol": "ORGJF"
    },
    {
     "description": "ORIGIN MATERIALS INC",
     "symbol": "ORGN"
    },
    {
     "description": "ORIGIN MATERIALS       -CW26",
     "symbol": "ORGNW"
    },
    {
     "description": "ORGANOGENESIS HOLDINGS INC",
     "symbol": "ORGO"
    },
    {
     "description": "ORGENESIS INC",
     "symbol": "ORGS"
    },
    {
     "description": "ORHUB INC",
     "symbol": "ORHB"
    },
    {
     "description": "OLD REPUBLIC INTL CORP",
     "symbol": "ORI"
    },
    {
     "description": "ORION BIOTECH OPPORTUNITI-A",
     "symbol": "ORIA"
    },
    {
     "description": "ORION BIOTECH OPPORTUNITIES",
     "symbol": "ORIAU"
    },
    {
     "description": "ORION BIOTECH OPPORTU -CW27",
     "symbol": "ORIAW"
    },
    {
     "description": "ORIC PHARMACEUTICALS INC",
     "symbol": "ORIC"
    },
    {
     "description": "ORION HEALTH GROUP LTD",
     "symbol": "ORIIF"
    },
    {
     "description": "ORION OYJ-CLASS B",
     "symbol": "ORINF"
    },
    {
     "description": "ORION OYJ-UNSPON ADR",
     "symbol": "ORINY"
    },
    {
     "description": "ORIOR AG",
     "symbol": "ORIOF"
    },
    {
     "description": "ORKLA ASA",
     "symbol": "ORKLF"
    },
    {
     "description": "ORKLA ASA-SPON ADR",
     "symbol": "ORKLY"
    },
    {
     "description": "ORLA MINING LTD",
     "symbol": "ORLA"
    },
    {
     "description": "O'REILLY AUTOMOTIVE INC",
     "symbol": "ORLY"
    },
    {
     "description": "ORFORD MINING CORP",
     "symbol": "ORMFF"
    },
    {
     "description": "LABYRINTH RESOURCES LTD",
     "symbol": "ORMIF"
    },
    {
     "description": "OREX MINERALS INC",
     "symbol": "ORMNF"
    },
    {
     "description": "ORAMED PHARMACEUTICALS INC",
     "symbol": "ORMP"
    },
    {
     "description": "ORMET CORP",
     "symbol": "ORMTQ"
    },
    {
     "description": "ORION GROUP HOLDINGS INC",
     "symbol": "ORN"
    },
    {
     "description": "ALLKEM LTD",
     "symbol": "OROCF"
    },
    {
     "description": "ORIGO PARTNERS PLC",
     "symbol": "OROPF"
    },
    {
     "description": "ORIENT OVERSEAS INTL LTD",
     "symbol": "OROVF"
    },
    {
     "description": "ORIENT OVERSEAS-UNSPON ADR",
     "symbol": "OROVY"
    },
    {
     "description": "OROSUR MINING INC",
     "symbol": "OROXF"
    },
    {
     "description": "OREGON PACIFIC BANCORP",
     "symbol": "ORPB"
    },
    {
     "description": "ORPEA",
     "symbol": "ORPEF"
    },
    {
     "description": "ORPHAZYME A\/S - ADR",
     "symbol": "ORPHY"
    },
    {
     "description": "OSE IMMUNO",
     "symbol": "ORPOF"
    },
    {
     "description": "ORORA LTD",
     "symbol": "ORRAF"
    },
    {
     "description": "OROCO RESOURCE CORP",
     "symbol": "ORRCF"
    },
    {
     "description": "ORRSTOWN FINL SERVICES INC",
     "symbol": "ORRF"
    },
    {
     "description": "ORPEA-UNSPONSORED ADR",
     "symbol": "ORRRY"
    },
    {
     "description": "ORTOMA AB",
     "symbol": "ORRTF"
    },
    {
     "description": "ORORA LTD-UNSPONSORED ADR",
     "symbol": "ORRYY"
    },
    {
     "description": "ORIAN SHM LTD",
     "symbol": "ORSHF"
    },
    {
     "description": "ORSU METALS CORP",
     "symbol": "ORSUF"
    },
    {
     "description": "ORSUS XELENT TECHNOLOGIES IN",
     "symbol": "ORSX"
    },
    {
     "description": "ORTHO REGENERATIVE TECHNOLOG",
     "symbol": "ORTIF"
    },
    {
     "description": "ORCHARD THERAPEUTICS PLC-ADR",
     "symbol": "ORTX"
    },
    {
     "description": "ORVANA MINERALS CORP",
     "symbol": "ORVMF"
    },
    {
     "description": "ORCHID VENTURES INC",
     "symbol": "ORVRF"
    },
    {
     "description": "ORIENTAL WATCH HOLDINGS",
     "symbol": "ORWHF"
    },
    {
     "description": "ORIX CORP",
     "symbol": "ORXCF"
    },
    {
     "description": "ORCA ENERGY GROUP INC",
     "symbol": "ORXGF"
    },
    {
     "description": "ORIX JREIT INC",
     "symbol": "ORXJF"
    },
    {
     "description": "OREXO AB",
     "symbol": "ORXOF"
    },
    {
     "description": "OREXO AB-SPN ADR",
     "symbol": "ORXOY"
    },
    {
     "description": "FORZA PETROLEUM LTD",
     "symbol": "ORXPF"
    },
    {
     "description": "ORYX TECHNOLOGY CORP",
     "symbol": "ORYX"
    },
    {
     "description": "ORYX INTERNATIONAL GROWTH",
     "symbol": "ORYYF"
    },
    {
     "description": "ORYZON GENOMICS",
     "symbol": "ORYZF"
    },
    {
     "description": "OREZONE GOLD CORP",
     "symbol": "ORZCF"
    },
    {
     "description": "OREZONE GOLD CORP -CW23",
     "symbol": "ORZWF"
    },
    {
     "description": "OSRAM LICHT AG",
     "symbol": "OSAGF"
    },
    {
     "description": "OSRAM LICHT AG-UNSP ADR",
     "symbol": "OSAGY"
    },
    {
     "description": "OLD SECOND BANCORP INC",
     "symbol": "OSBC"
    },
    {
     "description": "OCONEE FINANCIAL CORP",
     "symbol": "OSBK"
    },
    {
     "description": "OSCEOLA GOLD INC",
     "symbol": "OSCI"
    },
    {
     "description": "ORASCOM INVESTMENT HOLD-GDR",
     "symbol": "OSCMY"
    },
    {
     "description": "ONESCREEN INC",
     "symbol": "OSCN"
    },
    {
     "description": "OSCAR HEALTH INC - CLASS A",
     "symbol": "OSCR"
    },
    {
     "description": "JAPAN EXCHANGE GROUP INC",
     "symbol": "OSCUF"
    },
    {
     "description": "OPUS SMALL CAP VALUE ETF",
     "symbol": "OSCV"
    },
    {
     "description": "OVERSEAS SHIPHOLDING GROUP-A",
     "symbol": "OSG"
    },
    {
     "description": "OTIS GALLERY LLC",
     "symbol": "OSGAS"
    },
    {
     "description": "OTIS GALLERY LLC",
     "symbol": "OSGBS"
    },
    {
     "description": "OSG CORP",
     "symbol": "OSGCF"
    },
    {
     "description": "OTIS GALLERY LLC",
     "symbol": "OSGLS"
    },
    {
     "description": "OTIS GALLERY LLC",
     "symbol": "OSGPS"
    },
    {
     "description": "OSAKA GAS CO LTD",
     "symbol": "OSGSF"
    },
    {
     "description": "OSAKA GAS CO LTD-UNSP ADR",
     "symbol": "OSGSY"
    },
    {
     "description": "OTIS GALLERY LLC",
     "symbol": "OSGVS"
    },
    {
     "description": "OTIS GALLERY LLC",
     "symbol": "OSGWS"
    },
    {
     "description": "OAK STREET HEALTH INC",
     "symbol": "OSH"
    },
    {
     "description": "OSHIDORI INTERNATIONAL HOLDI",
     "symbol": "OSHDF"
    },
    {
     "description": "OISHI GROUP PCL-FOREIGN",
     "symbol": "OSHIF"
    },
    {
     "description": "OSIRIS ACQUISITION CORP-A",
     "symbol": "OSI"
    },
    {
     "description": "OSIRIS ACQUISITION CORP",
     "symbol": "OSI.U"
    },
    {
     "description": "OSIRIS ACQUISITION CORP-CW28",
     "symbol": "OSI.WS"
    },
    {
     "description": "OSINO RESOURCES CORP",
     "symbol": "OSIIF"
    },
    {
     "description": "OPTIMUM SOURCE INTL LTD",
     "symbol": "OSIN"
    },
    {
     "description": "OSI SYSTEMS INC",
     "symbol": "OSIS"
    },
    {
     "description": "OSHKOSH CORP",
     "symbol": "OSK"
    },
    {
     "description": "OSYKA CORP",
     "symbol": "OSKA"
    },
    {
     "description": "OSAKA STEEL CO LTD",
     "symbol": "OSKXF"
    },
    {
     "description": "OSOTSPA PCL-FOREIGN",
     "symbol": "OSOPF"
    },
    {
     "description": "OSPREY MEDICAL INC-CDI",
     "symbol": "OSPMZ"
    },
    {
     "description": "ONESPAN INC",
     "symbol": "OSPN"
    },
    {
     "description": "OSIRIS CORP",
     "symbol": "OSRS"
    },
    {
     "description": "ONE STOP SYSTEMS INC",
     "symbol": "OSS"
    },
    {
     "description": "OSSDSIGN AB",
     "symbol": "OSSDF"
    },
    {
     "description": "OSSUR HF",
     "symbol": "OSSFF"
    },
    {
     "description": "ONESOFT SOLUTIONS INC",
     "symbol": "OSSIF"
    },
    {
     "description": "OSSUR HF- SPON ADR",
     "symbol": "OSSUY"
    },
    {
     "description": "Overstock Com Inc",
     "symbol": "OSTBP"
    },
    {
     "description": "OSTERREICHISCHE POST-SP ADR",
     "symbol": "OSTIY"
    },
    {
     "description": "OVERSTOCK.COM INC",
     "symbol": "OSTK"
    },
    {
     "description": "Overstockcom Inc",
     "symbol": "OSTKO"
    },
    {
     "description": "ORIGINAL SIXTEEN TO ONE MINE",
     "symbol": "OSTO"
    },
    {
     "description": "OYSTER ENTERPRISES-CL A",
     "symbol": "OSTR"
    },
    {
     "description": "OYSTER ENTERPRISES ACQUISITI",
     "symbol": "OSTRU"
    },
    {
     "description": "OYSTER ENTERPRISE ACQUIS-W27",
     "symbol": "OSTRW"
    },
    {
     "description": "OSAKA TITANIUM TECHNOLOGIES",
     "symbol": "OSTTF"
    },
    {
     "description": "OTSUKA CORP",
     "symbol": "OSUKF"
    },
    {
     "description": "ORASURE TECHNOLOGIES INC",
     "symbol": "OSUR"
    },
    {
     "description": "ONESPAWORLD HOLDINGS LTD",
     "symbol": "OSW"
    },
    {
     "description": "ONESPAWORLD HOLDINGS LTD",
     "symbol": "OSWWF"
    },
    {
     "description": "OTIS GALLERY LLC-MEMB INTERE",
     "symbol": "OTAGS"
    },
    {
     "description": "OTIS GALLERY LLC-MEMB INTERE",
     "symbol": "OTBGS"
    },
    {
     "description": "OTIS COLLECTION LLC",
     "symbol": "OTCAS"
    },
    {
     "description": "OTIS COLLECTION LLC",
     "symbol": "OTCBS"
    },
    {
     "description": "OCUMETICS TECHNOLOGY CORP",
     "symbol": "OTCFF"
    },
    {
     "description": "OTIS COLLECTION LLC-MEMBERSH",
     "symbol": "OTCGS"
    },
    {
     "description": "OTC MARKETS GROUP INC-A",
     "symbol": "OTCM"
    },
    {
     "description": "OTIS COLLECTION LLC-MEMBERSH",
     "symbol": "OTCNS"
    },
    {
     "description": "OTIS COLLECTION LLC-MEMBERSH",
     "symbol": "OTCSS"
    },
    {
     "description": "OCEANTECH ACQUISITIONS- CL A",
     "symbol": "OTEC"
    },
    {
     "description": "OCEANTECH ACQUISITIONS I COR",
     "symbol": "OTECU"
    },
    {
     "description": "OCEANTECH ACQUISITIONS- CW A",
     "symbol": "OTECW"
    },
    {
     "description": "OAK TREE EDUCATIONAL PARTNER",
     "symbol": "OTED"
    },
    {
     "description": "OTIS GALLERY LLC-MEMB INTERE",
     "symbol": "OTEGS"
    },
    {
     "description": "OPEN TEXT CORP",
     "symbol": "OTEX"
    },
    {
     "description": "Otis Gallery LLC",
     "symbol": "OTFGS"
    },
    {
     "description": "OUTFRONT CO",
     "symbol": "OTFT"
    },
    {
     "description": "OTIS GALLERY LLC-MEMB UNITS",
     "symbol": "OTGAS"
    },
    {
     "description": "OTIS GALLERY LLC-MEMB INTERE",
     "symbol": "OTGBS"
    },
    {
     "description": "O2GOLD INC",
     "symbol": "OTGDF"
    },
    {
     "description": "OTIS GALLERY LLC",
     "symbol": "OTGFS"
    },
    {
     "description": "OTIS GALLERY LLC-MEMB INTERE",
     "symbol": "OTGGS"
    },
    {
     "description": "OTIS GALLERY LLC",
     "symbol": "OTGKS"
    },
    {
     "description": "CD PROJEKT SA",
     "symbol": "OTGLF"
    },
    {
     "description": "OTIS GALLERY LLC-MEMB INTERE",
     "symbol": "OTGLS"
    },
    {
     "description": "CD PROJEKT SA - UNSP ADR",
     "symbol": "OTGLY"
    },
    {
     "description": "OTIS GALLERY LLC-MEMBER INTE",
     "symbol": "OTGOS"
    },
    {
     "description": "OTIS GALLERY LLC-MEMB INTERE",
     "symbol": "OTGPS"
    },
    {
     "description": "OTIS GALLERY LLC-MEMB INTERE",
     "symbol": "OTGRS"
    },
    {
     "description": "OTIS GALLERY LLC-MEMB INTERE",
     "symbol": "OTGSS"
    },
    {
     "description": "OTIS GALLERY LLC-MEMB INTERE",
     "symbol": "OTGTS"
    },
    {
     "description": "OTIS GALLERY LLC-MEMB INTERE",
     "symbol": "OTGUS"
    },
    {
     "description": "OTIS GALLERY LLC-MEMB INTERE",
     "symbol": "OTGVS"
    },
    {
     "description": "OTIS GALLERY LLC-MEMB INTERE",
     "symbol": "OTGWS"
    },
    {
     "description": "OTIS GALLERY LLC-MEMBE INTER",
     "symbol": "OTGXS"
    },
    {
     "description": "OTIS GALLERY LLC-MEMB INTERE",
     "symbol": "OTGYS"
    },
    {
     "description": "OTIS GALLERY LLC-MEMBE INTER",
     "symbol": "OTGZS"
    },
    {
     "description": "OTONOMY INC",
     "symbol": "OTIC"
    },
    {
     "description": "OTIS WORLDWIDE CORP",
     "symbol": "OTIS"
    },
    {
     "description": "ON TRACK INNOVATIONS LTD",
     "symbol": "OTIVF"
    },
    {
     "description": "OTIS GALLERY LLC-MEMB INTERE",
     "symbol": "OTKMS"
    },
    {
     "description": "OTIS GALLERY LLC-MEMB INTERE",
     "symbol": "OTKWS"
    },
    {
     "description": "OTIS GALLERY LLC-MEMB INTERE",
     "symbol": "OTLBS"
    },
    {
     "description": "ONCOTELIC THERAPEUTICS INC",
     "symbol": "OTLC"
    },
    {
     "description": "OUTLOOK THERAPEUTICS INC",
     "symbol": "OTLK"
    },
    {
     "description": "OATLY GROUP AB",
     "symbol": "OTLY"
    },
    {
     "description": "OTIS COLLECTION LLC",
     "symbol": "OTMES"
    },
    {
     "description": "OTIS GALLERY LLC-MEMB INTERE",
     "symbol": "OTMGS"
    },
    {
     "description": "OTIS GALLERY LLC-MEMB INTERE",
     "symbol": "OTMJS"
    },
    {
     "description": "O T MINING CORP",
     "symbol": "OTMN"
    },
    {
     "description": "OTONOMO TECHNOLOGIES LTD",
     "symbol": "OTMO"
    },
    {
     "description": "OTONOMO TECHNOLOGIES -CW26",
     "symbol": "OTMOW"
    },
    {
     "description": "OTIS GALLERY LLC-MEMB INTERE",
     "symbol": "OTNAS"
    },
    {
     "description": "OTIS GALLERY LLC-MEMB INTERE",
     "symbol": "OTNKS"
    },
    {
     "description": "O2 SECURE WIRELESS INC",
     "symbol": "OTOW"
    },
    {
     "description": "OTP BANK PLC",
     "symbol": "OTPBF"
    },
    {
     "description": "OTIS GALLERY LLC-MEMB INTERE",
     "symbol": "OTPFS"
    },
    {
     "description": "OTP BANK NYRT-REG S GDR",
     "symbol": "OTPGF"
    },
    {
     "description": "OPTIM CORP",
     "symbol": "OTPMF"
    },
    {
     "description": "OTR ACQUISITION CORP-CLASS A",
     "symbol": "OTRA"
    },
    {
     "description": "OTR ACQUISITION CORP",
     "symbol": "OTRAU"
    },
    {
     "description": "OTR ACQUISITION -CL A -CW25",
     "symbol": "OTRAW"
    },
    {
     "description": "ONTRAK INC",
     "symbol": "OTRK"
    },
    {
     "description": "ONTRAK INC",
     "symbol": "OTRKP"
    },
    {
     "description": "OTIS GALLERY LLC-MEMBER INTE",
     "symbol": "OTRNS"
    },
    {
     "description": "OTIS GALLERY LLC-MEMB INTERE",
     "symbol": "OTSBS"
    },
    {
     "description": "OTIS COLLECTION LLC",
     "symbol": "OTSCS"
    },
    {
     "description": "OTIS GALLERY LLC-MEMB INTERE",
     "symbol": "OTSDS"
    },
    {
     "description": "OTIS GALLERY LLC-MEMB INTERE",
     "symbol": "OTSES"
    },
    {
     "description": "OTIS GALLERY LLC",
     "symbol": "OTSFS"
    },
    {
     "description": "OTIS GALLERY LLC-MEMB INTERE",
     "symbol": "OTSGS"
    },
    {
     "description": "OTIS GALLERY LLC-MEMB INTERE",
     "symbol": "OTSJS"
    },
    {
     "description": "OTSUKA HOLDINGS CO LTD",
     "symbol": "OTSKF"
    },
    {
     "description": "OTSUKA HOLDINGS CO LTD- UNSP",
     "symbol": "OTSKY"
    },
    {
     "description": "Otis Collection LLC Membership",
     "symbol": "OTSLS"
    },
    {
     "description": "OTIS GALLERY LLC-MEMB INTERE",
     "symbol": "OTSMS"
    },
    {
     "description": "OTIS GALLERY LLC",
     "symbol": "OTSNS"
    },
    {
     "description": "OTIS GALLERY LLC",
     "symbol": "OTSOS"
    },
    {
     "description": "OTIS GALLERY LLC",
     "symbol": "OTSPS"
    },
    {
     "description": "OTIS GALLERY LLC",
     "symbol": "OTSQS"
    },
    {
     "description": "OTIS GALLERY LLC",
     "symbol": "OTSRS"
    },
    {
     "description": "OTIS GALLERY LLC",
     "symbol": "OTSTS"
    },
    {
     "description": "OTIS GALLERY LLC",
     "symbol": "OTSUS"
    },
    {
     "description": "OTIS GALLERY LLC",
     "symbol": "OTSWS"
    },
    {
     "description": "OTTO ENERGY LTD",
     "symbol": "OTTEF"
    },
    {
     "description": "OTIS GALLERY LLC-MEMBE INTER",
     "symbol": "OTTPS"
    },
    {
     "description": "OTTER TAIL CORP",
     "symbol": "OTTR"
    },
    {
     "description": "OTIS GALLERY LLC-MEMBER INTE",
     "symbol": "OTTSS"
    },
    {
     "description": "VIVA ENTERTAINMENT GROUP INC",
     "symbol": "OTTV"
    },
    {
     "description": "OTTAWA BANCORP INC",
     "symbol": "OTTW"
    },
    {
     "description": "OUE COMMERCIAL REAL ESTATE I",
     "symbol": "OUECF"
    },
    {
     "description": "METSO OUTOTEC OYJ",
     "symbol": "OUKPF"
    },
    {
     "description": "METSO OUTOTEC COR UNSPON ADR",
     "symbol": "OUKPY"
    },
    {
     "description": "VANECK MERK GOLD TRUST",
     "symbol": "OUNZ"
    },
    {
     "description": "OSHARES U.S QUALITY DIVIDEND",
     "symbol": "OUSA"
    },
    {
     "description": "OSHARES U.S. SMALL-CAP QUALI",
     "symbol": "OUSM"
    },
    {
     "description": "OUSTER INC",
     "symbol": "OUST"
    },
    {
     "description": "COLONNADE ACQUISITION -CW25",
     "symbol": "OUST.WS"
    },
    {
     "description": "OUTSOURCING INC",
     "symbol": "OUSZF"
    },
    {
     "description": "OUTFRONT MEDIA INC",
     "symbol": "OUT"
    },
    {
     "description": "OUTBACK OIL & MINERAL EXPL",
     "symbol": "OUTB"
    },
    {
     "description": "OUTOKUMPU OYJ",
     "symbol": "OUTFF"
    },
    {
     "description": "OUTOKUMPU OYJ-UNSPN ADR",
     "symbol": "OUTKY"
    },
    {
     "description": "OVAL CORP",
     "symbol": "OVACF"
    },
    {
     "description": "OVATION SCIENCE INC",
     "symbol": "OVATF"
    },
    {
     "description": "OVERLAY SHARES CORE BOND ETF",
     "symbol": "OVB"
    },
    {
     "description": "OHIO VALLEY BANC CORP",
     "symbol": "OVBC"
    },
    {
     "description": "OVERSEA-CHINESE BANKING CORP",
     "symbol": "OVCHF"
    },
    {
     "description": "OVERSEA-CHINESE BANK-UNS ADR",
     "symbol": "OVCHY"
    },
    {
     "description": "OVERLAY SHARES FOREIGN EQUIT",
     "symbol": "OVF"
    },
    {
     "description": "OVH GROUPE SAS",
     "symbol": "OVHFF"
    },
    {
     "description": "OVH GROUPE SAS - UNS ADR",
     "symbol": "OVHGY"
    },
    {
     "description": "OVID THERAPEUTICS INC",
     "symbol": "OVID"
    },
    {
     "description": "ONCOVISTA INNOVATIVE THERAPI",
     "symbol": "OVIT"
    },
    {
     "description": "OVERLAY SHARES LARGE CAP EQ",
     "symbol": "OVL"
    },
    {
     "description": "OVERLAY SHRS HDG LRG CAP EQY",
     "symbol": "OVLH"
    },
    {
     "description": "OAK VALLEY BANCORP",
     "symbol": "OVLY"
    },
    {
     "description": "OVERLAY SHARES MUNICIPAL BON",
     "symbol": "OVM"
    },
    {
     "description": "OVERLAY SHARES SMALL CAP EQ",
     "symbol": "OVS"
    },
    {
     "description": "OVERLAY SHARES SHRT TERM BON",
     "symbol": "OVT"
    },
    {
     "description": "OCULUS VISIONTECH INC",
     "symbol": "OVTZ"
    },
    {
     "description": "OVINTIV INC",
     "symbol": "OVV"
    },
    {
     "description": "OVERLAND MANAGEMENT INC",
     "symbol": "OVZM"
    },
    {
     "description": "OWC PHARMACEUTICAL RESEARCH",
     "symbol": "OWCP"
    },
    {
     "description": "ODAWARA ENGINEERING CO LTD",
     "symbol": "OWECF"
    },
    {
     "description": "BLUE OWL CAPITAL INC",
     "symbol": "OWL"
    },
    {
     "description": "BLUE OWL CAPITAL INC-CW26",
     "symbol": "OWL.WS"
    },
    {
     "description": "OWLET INC",
     "symbol": "OWLT"
    },
    {
     "description": "SANDBRIDGE ACQUISITION -CW27",
     "symbol": "OWLT.WS"
    },
    {
     "description": "IMPACT SHARES AFFORDABLE HOU",
     "symbol": "OWNS"
    },
    {
     "description": "ONE WORLD PRODUCTS INC",
     "symbol": "OWPC"
    },
    {
     "description": "ONE WORLD LITHIUM INC",
     "symbol": "OWRDF"
    },
    {
     "description": "ONE WORLD UNIVERSE INC",
     "symbol": "OWUV"
    },
    {
     "description": "ONE WORLD VENTURES INC",
     "symbol": "OWVI"
    },
    {
     "description": "OKUWA CO LTD",
     "symbol": "OWWAF"
    },
    {
     "description": "OXBRIDGE ACQUISITION CORP",
     "symbol": "OXAC"
    },
    {
     "description": "OXBRIDGE ACQUISITION CORP",
     "symbol": "OXACU"
    },
    {
     "description": "OXBRIDGE ACQUISITION -CW23",
     "symbol": "OXACW"
    },
    {
     "description": "OXFORD BANK CORP",
     "symbol": "OXBC"
    },
    {
     "description": "OXFORD BIOMEDICA PLC",
     "symbol": "OXBDF"
    },
    {
     "description": "OXFORD BIODYNAMICS PLC",
     "symbol": "OXBOF"
    },
    {
     "description": "OXBRIDGE RE HOLDINGS LTD",
     "symbol": "OXBR"
    },
    {
     "description": "OXBRIDGE RE HOLDINGS-CW24",
     "symbol": "OXBRW"
    },
    {
     "description": "VELOCYS PLC",
     "symbol": "OXFCF"
    },
    {
     "description": "OXFORD INVESTMENTS HOLDINGS",
     "symbol": "OXIHF"
    },
    {
     "description": "OXFORD INSTRUMENTS PLC",
     "symbol": "OXINF"
    },
    {
     "description": "OXFORD LANE CAPITAL CORP",
     "symbol": "OXLC"
    },
    {
     "description": "OXFORD LANE CAPITAL CORP",
     "symbol": "OXLCL"
    },
    {
     "description": "OXFORD LANE CAPITAL CORP",
     "symbol": "OXLCM"
    },
    {
     "description": "OXFORD LANE CAPITAL CORP",
     "symbol": "OXLCO"
    },
    {
     "description": "OXFORD LANE CAPITAL CORP",
     "symbol": "OXLCP"
    },
    {
     "description": "OXFORD LANE CAPITAL CORP",
     "symbol": "OXLCZ"
    },
    {
     "description": "OXFORD INDUSTRIES INC",
     "symbol": "OXM"
    },
    {
     "description": "ONXEO",
     "symbol": "OXNXF"
    },
    {
     "description": "OXFORD SQUARE CAPITAL CORP",
     "symbol": "OXSQ"
    },
    {
     "description": "Oxford Square Capital Corporation",
     "symbol": "OXSQA"
    },
    {
     "description": "OXFORD SQUARE CAPITAL CO",
     "symbol": "OXSQG"
    },
    {
     "description": "OXFORD SQUARE CAPITAL CO",
     "symbol": "OXSQL"
    },
    {
     "description": "OXFORD SQUARE CAPITAL CO",
     "symbol": "OXSQZ"
    },
    {
     "description": "OXUS ACQUISITION CORP-A",
     "symbol": "OXUS"
    },
    {
     "description": "OXUS ACQUISITION CORP",
     "symbol": "OXUSU"
    },
    {
     "description": "OXUS ACQUISITION CORP -CW23",
     "symbol": "OXUSW"
    },
    {
     "description": "OCCIDENTAL PETROLEUM CORP",
     "symbol": "OXY"
    },
    {
     "description": "OCCIDENTAL PETROLEUM-CW27",
     "symbol": "OXY.WS"
    },
    {
     "description": "OYO CORP",
     "symbol": "OYOCF"
    },
    {
     "description": "ROBIT OYJ",
     "symbol": "OYRRF"
    },
    {
     "description": "OYSTER POINT PHARMA INC",
     "symbol": "OYST"
    },
    {
     "description": "BELPOINTE PREP LLC",
     "symbol": "OZ"
    },
    {
     "description": "OUTBACK GOLDFIELDS CORP",
     "symbol": "OZBKF"
    },
    {
     "description": "OZFOREX GROUP LTD - UNSP ADR",
     "symbol": "OZFRY"
    },
    {
     "description": "BANK OZK",
     "symbol": "OZK"
    },
    {
     "description": "BANK OZK",
     "symbol": "OZKAP"
    },
    {
     "description": "OZ MINERALS LTD",
     "symbol": "OZMLF"
    },
    {
     "description": "OZON HOLDINGS PLC - ADR",
     "symbol": "OZON"
    },
    {
     "description": "OZOP ENERGY SOLUTIONS INC",
     "symbol": "OZSC"
    },
    {
     "description": "ORPHAZYME A\/S",
     "symbol": "OZYMF"
    },
    {
     "description": "PLAINS ALL AMER PIPELINE LP",
     "symbol": "PAA"
    },
    {
     "description": "PAN AMERICAN SILVER CORP",
     "symbol": "PAAS"
    },
    {
     "description": "PAN AMERICAN SILVER CORP-CVR",
     "symbol": "PAASF"
    },
    {
     "description": "PGIM ACT AGGRG BOND ETF",
     "symbol": "PAB"
    },
    {
     "description": "PANAMERICAN BANCORP",
     "symbol": "PABN"
    },
    {
     "description": "ISHARES PARIS - ALIG CLI MUE",
     "symbol": "PABU"
    },
    {
     "description": "GRUPO AEROPORTUARIO PAC-ADR",
     "symbol": "PAC"
    },
    {
     "description": "PACIFIC BIOSCIENCES OF CALIF",
     "symbol": "PACB"
    },
    {
     "description": "PACIFIC CMA INC",
     "symbol": "PACC"
    },
    {
     "description": "PROOF ACQUISITION CORP I-A",
     "symbol": "PACI"
    },
    {
     "description": "PROOF ACQUISITION CORP I",
     "symbol": "PACI.U"
    },
    {
     "description": "PROOF ACQUISITION CORP -CW23",
     "symbol": "PACI.WS"
    },
    {
     "description": "RANPAK HOLDINGS CORP",
     "symbol": "PACK"
    },
    {
     "description": "PACO INTEGRATED ENERGY INC",
     "symbol": "PACO"
    },
    {
     "description": "PRIME ACQUISITION CORP",
     "symbol": "PACQF"
    },
    {
     "description": "PACIFIC VENTURES GROUP INC",
     "symbol": "PACV"
    },
    {
     "description": "PACWEST BANCORP",
     "symbol": "PACW"
    },
    {
     "description": "PIONEER MERGER CORP -CLASS A",
     "symbol": "PACX"
    },
    {
     "description": "PACTON GOLD INC",
     "symbol": "PACXF"
    },
    {
     "description": "PIONEER MERGER CORP",
     "symbol": "PACXU"
    },
    {
     "description": "PIONEER MERGER CL A -CW27",
     "symbol": "PACXW"
    },
    {
     "description": "ADARO ENERGY INDONESIA TBK P",
     "symbol": "PADEF"
    },
    {
     "description": "PEACE ARCH ENTERTAINMENT GRP",
     "symbol": "PAEGF"
    },
    {
     "description": "ANEKA TAMBANG TBK PT-UNS ADR",
     "symbol": "PAEKY"
    },
    {
     "description": "PACIFICO ACQUISTION CORP",
     "symbol": "PAFO"
    },
    {
     "description": "PACIFICO ACQUISITION COR-RTS",
     "symbol": "PAFOR"
    },
    {
     "description": "PACIFICO ACQUISITION CORP",
     "symbol": "PAFOU"
    },
    {
     "description": "PAN AFRICAN RESOURCES PLC",
     "symbol": "PAFRF"
    },
    {
     "description": "PAN AFRICAN RESOU - ADR SPO",
     "symbol": "PAFRY"
    },
    {
     "description": "PENSKE AUTOMOTIVE GROUP INC",
     "symbol": "PAG"
    },
    {
     "description": "PARAGON ID",
     "symbol": "PAGDF"
    },
    {
     "description": "PLAINS GP HOLDINGS LP-CL A",
     "symbol": "PAGP"
    },
    {
     "description": "PAGSEGURO DIGITAL LTD-CL A",
     "symbol": "PAGS"
    },
    {
     "description": "PHIBRO ANIMAL HEALTH CORP-A",
     "symbol": "PAHC"
    },
    {
     "description": "PETS AT HOME GROUP PLC",
     "symbol": "PAHGF"
    },
    {
     "description": "WESTERN ASSET INVESTMENT GRA",
     "symbol": "PAI"
    },
    {
     "description": "PAION AG",
     "symbol": "PAIOF"
    },
    {
     "description": "GLOBAL X MSCI PAKISTAN ETF",
     "symbol": "PAK"
    },
    {
     "description": "MAP AKTIF ADIPERKASA PT-ADR",
     "symbol": "PAKTY"
    },
    {
     "description": "PALADIN ENERGY LTD",
     "symbol": "PALAF"
    },
    {
     "description": "PACER LUNT LRG CAP MULTI-FAC",
     "symbol": "PALC"
    },
    {
     "description": "PALISADE BIO INC",
     "symbol": "PALI"
    },
    {
     "description": "ABRDN PALLADIUM ETF TRUST",
     "symbol": "PALL"
    },
    {
     "description": "MOPALS.COM INC",
     "symbol": "PALS"
    },
    {
     "description": "PALTALK INC",
     "symbol": "PALT"
    },
    {
     "description": "PAMPA ENERGIA SA-SPON ADR",
     "symbol": "PAM"
    },
    {
     "description": "PACER LUNT MIDCAP MULT-FACT",
     "symbol": "PAMC"
    },
    {
     "description": "PANACEA ACQUISITION CORPII-A",
     "symbol": "PANA"
    },
    {
     "description": "PANACOS PHARMACEUTICALS INC",
     "symbol": "PANC"
    },
    {
     "description": "PANDORA A\/S-SPONSORED ADR",
     "symbol": "PANDY"
    },
    {
     "description": "PING AN HEALTHCARE AND TECHN",
     "symbol": "PANHF"
    },
    {
     "description": "PANGAEA LOGISTICS SOLUTIONS",
     "symbol": "PANL"
    },
    {
     "description": "PANORAMIC RESOURCES LTD",
     "symbol": "PANRF"
    },
    {
     "description": "PALO ALTO NETWORKS INC",
     "symbol": "PANW"
    },
    {
     "description": "PLATINEX INC",
     "symbol": "PANXF"
    },
    {
     "description": "PAO GROUP INC",
     "symbol": "PAOG"
    },
    {
     "description": "PARROT SA",
     "symbol": "PAOTF"
    },
    {
     "description": "INNOVATOR U.S. EQUITY POWER",
     "symbol": "PAPR"
    },
    {
     "description": "PROVIDENT ACQUISITION CORP-A",
     "symbol": "PAQC"
    },
    {
     "description": "PROVIDENT ACQUISITION CORP",
     "symbol": "PAQCU"
    },
    {
     "description": "PROVIDENT ACQUISITION-CW26",
     "symbol": "PAQCW"
    },
    {
     "description": "PAR TECHNOLOGY CORP\/DEL",
     "symbol": "PAR"
    },
    {
     "description": "PARAMOUNT GLOBAL-CLASS B",
     "symbol": "PARA"
    },
    {
     "description": "PARAMOUNT GLOBAL-CLASS A",
     "symbol": "PARAA"
    },
    {
     "description": "PARAMOUNT GLOBAL",
     "symbol": "PARAP"
    },
    {
     "description": "PONIARD PHARMACEUTICALS INC",
     "symbol": "PARD"
    },
    {
     "description": "Poniard Pharmaceuticals Inc",
     "symbol": "PARDP"
    },
    {
     "description": "PARNELL PHARMACEUTICALS HOLD",
     "symbol": "PARNF"
    },
    {
     "description": "PARX MATERIALS NV",
     "symbol": "PARPF"
    },
    {
     "description": "PARQUES REUNIDOS SERVICIOS C",
     "symbol": "PARQF"
    },
    {
     "description": "PAR PACIFIC HOLDINGS INC",
     "symbol": "PARR"
    },
    {
     "description": "PAREX RESOURCES INC",
     "symbol": "PARXF"
    },
    {
     "description": "PASSAGE BIO INC",
     "symbol": "PASG"
    },
    {
     "description": "PATIENT ACCESS SOLUTIONS INC",
     "symbol": "PASO"
    },
    {
     "description": "PLASTIC OMNIUM",
     "symbol": "PASTF"
    },
    {
     "description": "UIPATH INC - CLASS A",
     "symbol": "PATH"
    },
    {
     "description": "PATRIOT TRANSPORTATION HOLDI",
     "symbol": "PATI"
    },
    {
     "description": "PATRICK INDUSTRIES INC",
     "symbol": "PATK"
    },
    {
     "description": "PATRYS LTD",
     "symbol": "PATLF"
    },
    {
     "description": "SHINE MINERALS CORP",
     "symbol": "PAUFF"
    },
    {
     "description": "INNOVATOR U.S. EQUITY POWER",
     "symbol": "PAUG"
    },
    {
     "description": "GLOBAL X US INFRASTRUCTURE",
     "symbol": "PAVE"
    },
    {
     "description": "PAVMED INC",
     "symbol": "PAVM"
    },
    {
     "description": "PAVMED INC-CW24",
     "symbol": "PAVMZ"
    },
    {
     "description": "PENN WAREHOUSING & SAFE DEP",
     "symbol": "PAWH"
    },
    {
     "description": "PROSHARES PET CARE ETF",
     "symbol": "PAWZ"
    },
    {
     "description": "PATRIA INVESTMENTS LTD-A",
     "symbol": "PAX"
    },
    {
     "description": "PREAXIA HEALTH CARE PAYMENT",
     "symbol": "PAXH"
    },
    {
     "description": "PIMCO ACCESS INCOME FUND",
     "symbol": "PAXS"
    },
    {
     "description": "PAYMENTUS HOLDINGS INC-A",
     "symbol": "PAY"
    },
    {
     "description": "PAYA HOLDINGS INC",
     "symbol": "PAYA"
    },
    {
     "description": "PAYCOM SOFTWARE INC",
     "symbol": "PAYC"
    },
    {
     "description": "PAID INC",
     "symbol": "PAYD"
    },
    {
     "description": "PAYONEER GLOBAL INC",
     "symbol": "PAYO"
    },
    {
     "description": "PAYONEER GLOBAL INC-CW27",
     "symbol": "PAYOW"
    },
    {
     "description": "PAYSIGN INC",
     "symbol": "PAYS"
    },
    {
     "description": "PAYCHEX INC",
     "symbol": "PAYX"
    },
    {
     "description": "PLAZA RETAIL REIT",
     "symbol": "PAZRF"
    },
    {
     "description": "PROSPERITY BANCSHARES INC",
     "symbol": "PB"
    },
    {
     "description": "PEMBINA PIPELINE CORP",
     "symbol": "PBA"
    },
    {
     "description": "PETRO USA INC",
     "symbol": "PBAJ"
    },
    {
     "description": "PRIVATE BANCORP OF AMERICA I",
     "symbol": "PBAM"
    },
    {
     "description": "BUKIT ASAM TBK PT",
     "symbol": "PBATF"
    },
    {
     "description": "PHOENIX BIOTECH ACQUISI-CL A",
     "symbol": "PBAX"
    },
    {
     "description": "PHOENIX BIOTECH ACQUISITION",
     "symbol": "PBAXU"
    },
    {
     "description": "PHOENIX BIOTECH ACQ -CW26",
     "symbol": "PBAXW"
    },
    {
     "description": "DEUTSCHE PFANDBRIEFBANK AG",
     "symbol": "PBBGF"
    },
    {
     "description": "PROBI AB",
     "symbol": "PBBIF"
    },
    {
     "description": "PB BANKSHARES INC",
     "symbol": "PBBK"
    },
    {
     "description": "PEEKABOO BEANS INC",
     "symbol": "PBBSF"
    },
    {
     "description": "PUBLICIS GROUPE-CW22",
     "symbol": "PBCBF"
    },
    {
     "description": "PBCO FINANCIAL CORP",
     "symbol": "PBCO"
    },
    {
     "description": "BANK CENTRAL ASIA TBK PT",
     "symbol": "PBCRF"
    },
    {
     "description": "BANK CENTRAL ASIA-UNSPON ADR",
     "symbol": "PBCRY"
    },
    {
     "description": "INVESCO GLOBAL CLEAN ENERGY",
     "symbol": "PBD"
    },
    {
     "description": "BANK DANAMON INDON-UNSP ADR",
     "symbol": "PBDBY"
    },
    {
     "description": "PT Bank Danamon Indonesia TBK",
     "symbol": "PBDIF"
    },
    {
     "description": "INVESCO PUREBETA FTSE DEVELO",
     "symbol": "PBDM"
    },
    {
     "description": "INVESCO DYNAMIC BIOTECHNOLOG",
     "symbol": "PBE"
    },
    {
     "description": "INVESCO PUREBETA FTSE EMERGI",
     "symbol": "PBEE"
    },
    {
     "description": "TOUCHSTONE EXPLORATION INC",
     "symbol": "PBEGF"
    },
    {
     "description": "PREMIUM BEVERAGE GROUP INC",
     "symbol": "PBEV"
    },
    {
     "description": "PBF ENERGY INC-CLASS A",
     "symbol": "PBF"
    },
    {
     "description": "PLANET BASED FOODS GLOBAL IN",
     "symbol": "PBFFF"
    },
    {
     "description": "PIONEER BANCORP INC\/NY",
     "symbol": "PBFS"
    },
    {
     "description": "PBF LOGISTICS LP",
     "symbol": "PBFX"
    },
    {
     "description": "MULTI BINTANG INDONESIA PT",
     "symbol": "PBGDF"
    },
    {
     "description": "PRESTIGE CONSUMER HEALTHCARE",
     "symbol": "PBH"
    },
    {
     "description": "PATHFINDER BANCORP INC",
     "symbol": "PBHC"
    },
    {
     "description": "PARAMOUNT BED HOLDINGS CO LT",
     "symbol": "PBHDF"
    },
    {
     "description": "PBS HOLDING INC",
     "symbol": "PBHG"
    },
    {
     "description": "PITNEY BOWES INC",
     "symbol": "PBI"
    },
    {
     "description": "PITNEY BOWES INC",
     "symbol": "PBI.PRB"
    },
    {
     "description": "PARADIGM BIOPHARMACEUTICALS",
     "symbol": "PBIGF"
    },
    {
     "description": "BFI FINANCE INDONESIA TBK PT",
     "symbol": "PBIIF"
    },
    {
     "description": "PRESSURE BIOSCIENCES INC",
     "symbol": "PBIO"
    },
    {
     "description": "PRUDENTIAL BANCORP INC",
     "symbol": "PBIP"
    },
    {
     "description": "INVESCO DYNAMIC FOOD & BEVER",
     "symbol": "PBJ"
    },
    {
     "description": "PIONEER BANKCORP INC",
     "symbol": "PBKC"
    },
    {
     "description": "POLLARD BANKNOTE LTD",
     "symbol": "PBKOF"
    },
    {
     "description": "PARTNERS BANK OF CALIFORNIA",
     "symbol": "PBKX"
    },
    {
     "description": "PANBELA THERAPEUTICS INC",
     "symbol": "PBLA"
    },
    {
     "description": "PUBLIC BANK BERHAD",
     "symbol": "PBLOF"
    },
    {
     "description": "PACIFIC BAY MINERALS LTD",
     "symbol": "PBMFF"
    },
    {
     "description": "PACIFIC BOOKER MINERALS INC",
     "symbol": "PBMLF"
    },
    {
     "description": "BUMI RESOURCES TBK PT",
     "symbol": "PBMRF"
    },
    {
     "description": "BUMI RESOURCES TB-UNSPON ADR",
     "symbol": "PBMRY"
    },
    {
     "description": "Pembina Pipeline Corporation",
     "symbol": "PBNAF"
    },
    {
     "description": "PB FINL CORP",
     "symbol": "PBNC"
    },
    {
     "description": "INVESCO PUREBETA US AGGREGAT",
     "symbol": "PBND"
    },
    {
     "description": "PINNACLE BANK\/GILROY CA",
     "symbol": "PBNK"
    },
    {
     "description": "BANK NEGARA INDONESIA PERSER",
     "symbol": "PBNNF"
    },
    {
     "description": "INVESCO S&P 500 BUYWRITE ETF",
     "symbol": "PBP"
    },
    {
     "description": "POTBELLY CORP",
     "symbol": "PBPB"
    },
    {
     "description": "PETROLEO BRASILEIRO-SPON ADR",
     "symbol": "PBR"
    },
    {
     "description": "PETROLEO BRASIL-SP PREF  ADR",
     "symbol": "PBR.A"
    },
    {
     "description": "INVESCO DYNAMIC MEDIA ETF",
     "symbol": "PBS"
    },
    {
     "description": "PROSIEBENSAT.1 MEDIA SE",
     "symbol": "PBSFF"
    },
    {
     "description": "PROSIEBEN SAT.1-UNSP ADR",
     "symbol": "PBSFY"
    },
    {
     "description": "INVESCO PUREBETA MSCI USA SM",
     "symbol": "PBSM"
    },
    {
     "description": "PHARMA-BIO SERV INC",
     "symbol": "PBSV"
    },
    {
     "description": "PERMIAN BASIN ROYALTY TRUST",
     "symbol": "PBT"
    },
    {
     "description": "PLOVER BAY TECHNOLOGIES LTD",
     "symbol": "PBTDF"
    },
    {
     "description": "POINTSBET HOLDINGS LTD",
     "symbol": "PBTHF"
    },
    {
     "description": "INVESCO PUREBETA 0-5 YR US T",
     "symbol": "PBTP"
    },
    {
     "description": "POWERBRIDGE TECHNOLOGIES CO",
     "symbol": "PBTS"
    },
    {
     "description": "PACER IPATH GOLD TRENDPILOT",
     "symbol": "PBUG"
    },
    {
     "description": "INVESCO PUREBETA MSCI USA ET",
     "symbol": "PBUS"
    },
    {
     "description": "INVESCO WILDERHILL CLEAN ENE",
     "symbol": "PBW"
    },
    {
     "description": "PROBILITY MEDIA CORP",
     "symbol": "PBYA"
    },
    {
     "description": "PUMA BIOTECHNOLOGY INC",
     "symbol": "PBYI"
    },
    {
     "description": "PUBLITY AG",
     "symbol": "PBYYF"
    },
    {
     "description": "PACIFIC AMERICAN HOLDINGS LT",
     "symbol": "PCACF"
    },
    {
     "description": "PACCAR INC",
     "symbol": "PCAR"
    },
    {
     "description": "PACIFIC ASSETS TRUST PLC",
     "symbol": "PCASF"
    },
    {
     "description": "PCB BANCORP",
     "symbol": "PCB"
    },
    {
     "description": "PACIFIC COAST BANKERS BANCSH",
     "symbol": "PCBB"
    },
    {
     "description": "PIEDMONT COMMUNITY BANK GROU",
     "symbol": "PCBN"
    },
    {
     "description": "PALTAC CORPORATION",
     "symbol": "PCCOF"
    },
    {
     "description": "PERCEPTION CAPITAL CORP II-A",
     "symbol": "PCCT"
    },
    {
     "description": "PERCEPTION CAPITAL CORP II",
     "symbol": "PCCTU"
    },
    {
     "description": "PERCEPTION CAPITAL II -CW28",
     "symbol": "PCCTW"
    },
    {
     "description": "PCCW LTD-ADR",
     "symbol": "PCCWY"
    },
    {
     "description": "PETROCHINA CO LTD-H",
     "symbol": "PCCYF"
    },
    {
     "description": "POSTMEDIA NETWORK CANADA COR",
     "symbol": "PCDAF"
    },
    {
     "description": "PACIFIC CENTURY REGION DEVEL",
     "symbol": "PCDVF"
    },
    {
     "description": "INVESCO CEF INCOME COMPOSITE",
     "symbol": "PCEF"
    },
    {
     "description": "POWERCELL SWEDEN AB",
     "symbol": "PCELF"
    },
    {
     "description": "HIGH INCOME SECURITIES FUND",
     "symbol": "PCF"
    },
    {
     "description": "PACIFIC BASIN SHIPPING LTD",
     "symbol": "PCFBF"
    },
    {
     "description": "PACIFIC BASIN SHIP-UNSP ADR",
     "symbol": "PCFBY"
    },
    {
     "description": "PACIFIC NICKEL MINES LTD",
     "symbol": "PCFNF"
    },
    {
     "description": "POLAR CAPITAL GLOBAL FINANCI",
     "symbol": "PCFTF"
    },
    {
     "description": "P G & E CORP",
     "symbol": "PCG"
    },
    {
     "description": "PACIFIC GAS&ELEC",
     "symbol": "PCG.PRA"
    },
    {
     "description": "PACIFIC GAS&ELEC",
     "symbol": "PCG.PRB"
    },
    {
     "description": "PACIFIC GAS&ELEC",
     "symbol": "PCG.PRC"
    },
    {
     "description": "PACIFIC GAS&ELEC",
     "symbol": "PCG.PRD"
    },
    {
     "description": "PACIFIC GAS&ELEC",
     "symbol": "PCG.PRE"
    },
    {
     "description": "PACIFIC GAS&ELEC",
     "symbol": "PCG.PRG"
    },
    {
     "description": "PACIFIC GAS&ELEC",
     "symbol": "PCG.PRH"
    },
    {
     "description": "PACIFIC GAS&ELEC",
     "symbol": "PCG.PRI"
    },
    {
     "description": "PC GROUP INC",
     "symbol": "PCGR"
    },
    {
     "description": "PG&E CORP",
     "symbol": "PCGU"
    },
    {
     "description": "POTLATCHDELTIC CORP",
     "symbol": "PCH"
    },
    {
     "description": "PACIFIC CONQUEST HOLDINGS IN",
     "symbol": "PCHK"
    },
    {
     "description": "PHARMCHEM INC",
     "symbol": "PCHM"
    },
    {
     "description": "PTT GLOBAL CHEMICAL PCL-ADR",
     "symbol": "PCHUY"
    },
    {
     "description": "URBAN LOGISTICS REIT PLC",
     "symbol": "PCILF"
    },
    {
     "description": "PACIFIC IMPERIAL MINES INC",
     "symbol": "PCIMF"
    },
    {
     "description": "PIMCO CALIFORNIA MUNICIPA II",
     "symbol": "PCK"
    },
    {
     "description": "PINNACLE BANCSHARES INC",
     "symbol": "PCLB"
    },
    {
     "description": "PACIFIC LEGEND GROUP LTD",
     "symbol": "PCLGF"
    },
    {
     "description": "PROTOCALL TECHNOLOGIES INC",
     "symbol": "PCLI"
    },
    {
     "description": "PHARMACIELO LTD",
     "symbol": "PCLOF"
    },
    {
     "description": "PCM FUND INC",
     "symbol": "PCM"
    },
    {
     "description": "PUBLIC CO MANAGEMENT CORP",
     "symbol": "PCMC"
    },
    {
     "description": "PIMCO CORPORATE & INCOME STR",
     "symbol": "PCN"
    },
    {
     "description": "PRECISION SYSTEM SCIENCE CO",
     "symbol": "PCNEF"
    },
    {
     "description": "POINT OF CARE NANO-TECHNOLOG",
     "symbol": "PCNT"
    },
    {
     "description": "PENDRELL CORP",
     "symbol": "PCOA"
    },
    {
     "description": "PICO FAR EAST HOLDINGS LTD.",
     "symbol": "PCOFF"
    },
    {
     "description": "PANCONTINENTAL ENERGY NL",
     "symbol": "PCOGF"
    },
    {
     "description": "PACIFIC OAK STRATEGIC OPPORT",
     "symbol": "PCOK"
    },
    {
     "description": "PACIFIC ONLINE",
     "symbol": "PCOLF"
    },
    {
     "description": "POINTS.COM INC",
     "symbol": "PCOM"
    },
    {
     "description": "PROCORE TECHNOLOGIES INC",
     "symbol": "PCOR"
    },
    {
     "description": "PERIPHAS CAPITAL PARTNR-CL A",
     "symbol": "PCPC"
    },
    {
     "description": "PERIPHAS CAPITAL PARTNERING",
     "symbol": "PCPC.U"
    },
    {
     "description": "PERIPHAS CAPITAL CL A -CW28",
     "symbol": "PCPC.WS"
    },
    {
     "description": "PACIFIC CENTURY PREMIUM DEVE",
     "symbol": "PCPDF"
    },
    {
     "description": "PAPERCLIP INC",
     "symbol": "PCPJ"
    },
    {
     "description": "PC PARTNER GROUP LTD",
     "symbol": "PCPPF"
    },
    {
     "description": "LEEWARD GROUP HOLDINGS INC",
     "symbol": "PCPZ"
    },
    {
     "description": "PIMCO CALIFORNIA MUNI INC FD",
     "symbol": "PCQ"
    },
    {
     "description": "PETROLYMPIC LTD",
     "symbol": "PCQRF"
    },
    {
     "description": "PUCARA GOLD LTD",
     "symbol": "PCRAF"
    },
    {
     "description": "PRICER AB-B SHS",
     "symbol": "PCRBF"
    },
    {
     "description": "BOLT METALS CORP",
     "symbol": "PCRCF"
    },
    {
     "description": "PCA CORP",
     "symbol": "PCRDF"
    },
    {
     "description": "PANASONIC HOLDINGS CORP",
     "symbol": "PCRFF"
    },
    {
     "description": "PANASONIC HOLDINGS CORP -ADR",
     "symbol": "PCRFY"
    },
    {
     "description": "PASCO CORP",
     "symbol": "PCRRF"
    },
    {
     "description": "PACIRA BIOSCIENCES INC",
     "symbol": "PCRX"
    },
    {
     "description": "PROCESSA PHARMACEUTICALS INC",
     "symbol": "PCSA"
    },
    {
     "description": "PCSB FINANCIAL CORP",
     "symbol": "PCSB"
    },
    {
     "description": "PACIFIC SMILES GROUP LTD",
     "symbol": "PCSGF"
    },
    {
     "description": "PURE CAPITAL SOLUTIONS INC",
     "symbol": "PCST"
    },
    {
     "description": "PCS EDVENTURES!.COM INC",
     "symbol": "PCSV"
    },
    {
     "description": "PURECYCLE TECHNOLOGIES INC",
     "symbol": "PCT"
    },
    {
     "description": "PACT GROUP HOLDINGS-UNSP ADR",
     "symbol": "PCTGY"
    },
    {
     "description": "PCTEL INC",
     "symbol": "PCTI"
    },
    {
     "description": "PCT LTD",
     "symbol": "PCTL"
    },
    {
     "description": "PICTON PROPERTY INCOME LTD",
     "symbol": "PCTNF"
    },
    {
     "description": "PURECYCLE TECHNOLOGIES INC",
     "symbol": "PCTTU"
    },
    {
     "description": "PURECYCLE TECHNO-CW26",
     "symbol": "PCTTW"
    },
    {
     "description": "PAYLOCITY HOLDING CORP",
     "symbol": "PCTY"
    },
    {
     "description": "BRAVERN VENTURES LTD",
     "symbol": "PCTZF"
    },
    {
     "description": "PACE DEVELOPMENT CORP P-NVDR",
     "symbol": "PCVFF"
    },
    {
     "description": "VAXCYTE INC",
     "symbol": "PCVX"
    },
    {
     "description": "PCCW LTD",
     "symbol": "PCWLF"
    },
    {
     "description": "PARSEC CAPITAL ACQUISITION-A",
     "symbol": "PCX"
    },
    {
     "description": "PARSEC CAPITAL ACQUISITIONS",
     "symbol": "PCXCU"
    },
    {
     "description": "PARSEC CAPITAL ACQ -CW23",
     "symbol": "PCXCW"
    },
    {
     "description": "INVESCO EMERGING MARKETS SOV",
     "symbol": "PCY"
    },
    {
     "description": "PARK CITY GROUP INC",
     "symbol": "PCYG"
    },
    {
     "description": "PROCYON CORP",
     "symbol": "PCYN"
    },
    {
     "description": "PURE CYCLE CORP",
     "symbol": "PCYO"
    },
    {
     "description": "PRIMECARE SYSTEMS INC",
     "symbol": "PCYS"
    },
    {
     "description": "PAGERDUTY INC",
     "symbol": "PD"
    },
    {
     "description": "INVESCO OPTIMUM YIELD DIVERS",
     "symbol": "PDBC"
    },
    {
     "description": "PDC ENERGY INC",
     "symbol": "PDCE"
    },
    {
     "description": "PATTERSON COS INC",
     "symbol": "PDCO"
    },
    {
     "description": "PINDUODUO INC-ADR",
     "symbol": "PDD"
    },
    {
     "description": "INNOVATOR U.S. EQUITY POWER",
     "symbol": "PDEC"
    },
    {
     "description": "PARDEE RESOURCES CO INC",
     "symbol": "PDER"
    },
    {
     "description": "PRO-DEX INC",
     "symbol": "PDEX"
    },
    {
     "description": "PDF SOLUTIONS INC",
     "symbol": "PDFS"
    },
    {
     "description": "PENDRAGON PLC",
     "symbol": "PDGNF"
    },
    {
     "description": "PARADIGM OIL AND GAS INC",
     "symbol": "PDGO"
    },
    {
     "description": "PDG REALTY SA-SPON ADR",
     "symbol": "PDGRY"
    },
    {
     "description": "BOUND AND BEYOND PCL-NVDR",
     "symbol": "PDGUF"
    },
    {
     "description": "PIMCO DYNAMIC INCOME FUND",
     "symbol": "PDI"
    },
    {
     "description": "PREMIER DEVELOPMENT & INVEST",
     "symbol": "PDIV"
    },
    {
     "description": "PREDICTIVE DISCOVERY LTD",
     "symbol": "PDIYF"
    },
    {
     "description": "PONCE FINANCIAL GROUP INC",
     "symbol": "PDLB"
    },
    {
     "description": "PETRA DIAMONDS LTD-DI",
     "symbol": "PDLMF"
    },
    {
     "description": "PIEDMONT OFFICE REALTY TRU-A",
     "symbol": "PDM"
    },
    {
     "description": "PARADIGM MEDICAL INDUSTRIES",
     "symbol": "PDMI"
    },
    {
     "description": "INVESCO FTSE RAFI DEVELOPED",
     "symbol": "PDN"
    },
    {
     "description": "PADINI HOLDINGS BERHAD",
     "symbol": "PDNIF"
    },
    {
     "description": "PRESIDENTIAL RLTY CORP -CL A",
     "symbol": "PDNLA"
    },
    {
     "description": "PRESIDENTIAL RLTY NEW -CL B",
     "symbol": "PDNLB"
    },
    {
     "description": "PIMCO DYNAMIC INCOME OPPORT",
     "symbol": "PDO"
    },
    {
     "description": "PLATINUM STUDIOS INC",
     "symbol": "PDOS"
    },
    {
     "description": "PERIDOT ACQUISITION CORP-A",
     "symbol": "PDOT"
    },
    {
     "description": "PERIDOT ACQUISITION CORP II",
     "symbol": "PDOT.U"
    },
    {
     "description": "PERIDOT ACQUISITION A -CW28",
     "symbol": "PDOT.WS"
    },
    {
     "description": "INVESCO DWA MOMENTUM ETF",
     "symbol": "PDP"
    },
    {
     "description": "PERFORMANCE DRINK GROUP INC",
     "symbol": "PDPG"
    },
    {
     "description": "MARATHON GROUP CORP",
     "symbol": "PDPR"
    },
    {
     "description": "PUDO INC",
     "symbol": "PDPTF"
    },
    {
     "description": "PERNOD RICARD SA",
     "symbol": "PDRDF"
    },
    {
     "description": "PD-RX PHARMACEUTICALS INC",
     "symbol": "PDRX"
    },
    {
     "description": "PRECISION DRILLING CORP",
     "symbol": "PDS"
    },
    {
     "description": "PDS BIOTECHNOLOGY CORP",
     "symbol": "PDSB"
    },
    {
     "description": "DHARMA SATYA NUSANTARA PT",
     "symbol": "PDSNF"
    },
    {
     "description": "PARADISE ENTERTAINMENT LTD",
     "symbol": "PDSSF"
    },
    {
     "description": "JOHN HAN PREMIUM DIVIDEND FD",
     "symbol": "PDT"
    },
    {
     "description": "PREFERRED DENTAL TECHNOLOGIE",
     "symbol": "PDTTF"
    },
    {
     "description": "PDX PARTNERS INC",
     "symbol": "PDXP"
    },
    {
     "description": "FLUTTER ENTERTAINMENT PLC-DI",
     "symbol": "PDYPF"
    },
    {
     "description": "FLUTTER ENTERTAINM-UNSP ADR",
     "symbol": "PDYPY"
    },
    {
     "description": "HEALTHPEAK PROPERTIES INC",
     "symbol": "PEAK"
    },
    {
     "description": "PEAR THERAPEUTICS INC",
     "symbol": "PEAR"
    },
    {
     "description": "PEAR THERAPEUTICS INC-CW26",
     "symbol": "PEARW"
    },
    {
     "description": "PEBBLEBROOK HOTEL TRUST",
     "symbol": "PEB"
    },
    {
     "description": "PEBBLEBROOK HOTEL TRUST",
     "symbol": "PEB.PRE"
    },
    {
     "description": "PEBBLEBROOK HOTEL TRUST",
     "symbol": "PEB.PRF"
    },
    {
     "description": "PEBBLEBROOK HOTEL TRUST",
     "symbol": "PEB.PRG"
    },
    {
     "description": "PEBBLEBROOK HOTEL TRUST",
     "symbol": "PEB.PRH"
    },
    {
     "description": "PENN BANCSHARES INC",
     "symbol": "PEBA"
    },
    {
     "description": "PEOPLES BANCORP INC\/MD",
     "symbol": "PEBC"
    },
    {
     "description": "PEOPLES BANCORP OF NC",
     "symbol": "PEBK"
    },
    {
     "description": "PEOPLES BANCORP INC",
     "symbol": "PEBO"
    },
    {
     "description": "PET ECOLOGY BRANDS INC",
     "symbol": "PECD"
    },
    {
     "description": "PETRONAS CHEMICALS GROUP BHD",
     "symbol": "PECGF"
    },
    {
     "description": "PHOTOELECTRON CORP",
     "symbol": "PECN"
    },
    {
     "description": "PHILLIPS EDISON & COMPANY IN",
     "symbol": "PECO"
    },
    {
     "description": "PEDEVCO CORP",
     "symbol": "PED"
    },
    {
     "description": "PEOPLES EDUCATIONAL HOLDINGS",
     "symbol": "PEDH"
    },
    {
     "description": "DELFI LTD",
     "symbol": "PEFDF"
    },
    {
     "description": "PUBLIC SERVICE ENTERPRISE GP",
     "symbol": "PEG"
    },
    {
     "description": "PEGASYSTEMS INC",
     "symbol": "PEGA"
    },
    {
     "description": "ENERGI MEGA PERSADA TBK PT",
     "symbol": "PEGIF"
    },
    {
     "description": "ENERGI MEGA PERSADA-UNSP ADR",
     "symbol": "PEGIY"
    },
    {
     "description": "PROJECT ENERGY REIMAGINED AC",
     "symbol": "PEGR"
    },
    {
     "description": "PENNON GROUP PLC",
     "symbol": "PEGRF"
    },
    {
     "description": "PROJECT ENERGY REIMAGINED AC",
     "symbol": "PEGRU"
    },
    {
     "description": "PROJECT ENERGY REIMAG -CW28",
     "symbol": "PEGRW"
    },
    {
     "description": "PENNON GROUP PLC-UNSP ADR",
     "symbol": "PEGRY"
    },
    {
     "description": "PEGASUS COMPANIES INC\/THE",
     "symbol": "PEGX"
    },
    {
     "description": "PINEAPPLE ENERGY INC",
     "symbol": "PEGY"
    },
    {
     "description": "PENN REAL ESTATE INVEST TST",
     "symbol": "PEI"
    },
    {
     "description": "PENN REAL ESTATE INVEST",
     "symbol": "PEI.PRB"
    },
    {
     "description": "PENN REAL ESTATE INVEST",
     "symbol": "PEI.PRC"
    },
    {
     "description": "PENN REAL ESTATE INVEST",
     "symbol": "PEI.PRD"
    },
    {
     "description": "PEPINNINI MINERALS LTD",
     "symbol": "PEIMF"
    },
    {
     "description": "INVESCO DYNAMIC LEISURE AND",
     "symbol": "PEJ"
    },
    {
     "description": "PACIFIC ENERGY & MINING-NEW",
     "symbol": "PEMC"
    },
    {
     "description": "PURE ENERGY MINERALS LTD",
     "symbol": "PEMIF"
    },
    {
     "description": "PACIFIC EMPIRE MINERALS CORP",
     "symbol": "PEMSF"
    },
    {
     "description": "THOUGHTFUL BRANDS INC",
     "symbol": "PEMTF"
    },
    {
     "description": "PENUMBRA INC",
     "symbol": "PEN"
    },
    {
     "description": "PENINSULA ENERGY LTD",
     "symbol": "PENMF"
    },
    {
     "description": "PENN NATIONAL GAMING INC",
     "symbol": "PENN"
    },
    {
     "description": "PENTAMASTER CORP BHD",
     "symbol": "PENTF"
    },
    {
     "description": "ADAMS NATURAL RESOURCES FUND",
     "symbol": "PEO"
    },
    {
     "description": "PEPSICO INC",
     "symbol": "PEP"
    },
    {
     "description": "PEPPERLIME HEALTH ACQ - A",
     "symbol": "PEPL"
    },
    {
     "description": "PEPPERLIME HEALTH ACQUISITIO",
     "symbol": "PEPLU"
    },
    {
     "description": "PEPPERLIME HEALTH ACQ -CW23",
     "symbol": "PEPLW"
    },
    {
     "description": "PERION NETWORK LTD",
     "symbol": "PERI"
    },
    {
     "description": "PERLA GROUP INTERNATIONAL IN",
     "symbol": "PERL"
    },
    {
     "description": "PERMANENT TECHNOLOGIES INC",
     "symbol": "PERT"
    },
    {
     "description": "PANORO ENERGY ASA",
     "symbol": "PESAF"
    },
    {
     "description": "PERMA-FIX ENVIRONMENTAL SVCS",
     "symbol": "PESI"
    },
    {
     "description": "PTT PCL\/FOREIGN",
     "symbol": "PETFF"
    },
    {
     "description": "PETIQ INC",
     "symbol": "PETQ"
    },
    {
     "description": "VIBRA ENERGIA - ADR UNSP",
     "symbol": "PETRY"
    },
    {
     "description": "PETMED EXPRESS INC",
     "symbol": "PETS"
    },
    {
     "description": "PETVIVO HOLDINGS INC",
     "symbol": "PETV"
    },
    {
     "description": "PETVIVO HOLDINGS INC -CW26",
     "symbol": "PETVW"
    },
    {
     "description": "TDH HOLDINGS INC",
     "symbol": "PETZ"
    },
    {
     "description": "PROSHARES GLOBAL LISTED PRIV",
     "symbol": "PEX"
    },
    {
     "description": "PACER US EXPORT LEADERS ETF",
     "symbol": "PEXL"
    },
    {
     "description": "PTT EXPLORATION & PR-SP ADR",
     "symbol": "PEXNY"
    },
    {
     "description": "TEMPO SCAN PACIFIC TBK PT",
     "symbol": "PEXXF"
    },
    {
     "description": "PACIFIC RIDGE EXPLORATION LT",
     "symbol": "PEXZF"
    },
    {
     "description": "INVESCO HIGH YIELD EQUITY DI",
     "symbol": "PEY"
    },
    {
     "description": "PRECISION OPTICS CORP INC",
     "symbol": "PEYE"
    },
    {
     "description": "PARALLEL ENERGY TRUST-UNIT",
     "symbol": "PEYTF"
    },
    {
     "description": "PEYTO EXPLORATION & DEV CORP",
     "symbol": "PEYUF"
    },
    {
     "description": "INVESCO DWA CONSUMER CYCLICA",
     "symbol": "PEZ"
    },
    {
     "description": "PREFERRED BANK\/LOS ANGELES",
     "symbol": "PFBC"
    },
    {
     "description": "PACIFIC ALLIANCE BANK",
     "symbol": "PFBN"
    },
    {
     "description": "PEOPLES FINANCIAL CORP\/MISS",
     "symbol": "PFBX"
    },
    {
     "description": "PREMIER FINANCIAL CORP",
     "symbol": "PFC"
    },
    {
     "description": "FLAHERTY & CRUMRINE PREFERRE",
     "symbol": "PFD"
    },
    {
     "description": "PATHFINDER ACQUISITION -CL A",
     "symbol": "PFDR"
    },
    {
     "description": "PATHFINDER ACQUISITION CORP",
     "symbol": "PFDRU"
    },
    {
     "description": "PATHFINDER ACQ CL A -CW27",
     "symbol": "PFDRW"
    },
    {
     "description": "PFIZER INC",
     "symbol": "PFE"
    },
    {
     "description": "INNOVATOR U.S. EQUITY POWER",
     "symbol": "PFEB"
    },
    {
     "description": "ISHARES PREFERRED & INCOME S",
     "symbol": "PFF"
    },
    {
     "description": "VIRTUS INFRACAP US PFD ETF",
     "symbol": "PFFA"
    },
    {
     "description": "GLOBAL X US PREFERRED ETF",
     "symbol": "PFFD"
    },
    {
     "description": "POOL SAFE INC",
     "symbol": "PFFEF"
    },
    {
     "description": "ETRACS MON PAY 2XLEV PREFER",
     "symbol": "PFFL"
    },
    {
     "description": "PORTOFINO RESOURCES INC",
     "symbol": "PFFOF"
    },
    {
     "description": "INFRACAP REIT PREFERRED ETF",
     "symbol": "PFFR"
    },
    {
     "description": "GLOBAL X VARIABLE RATE PREF",
     "symbol": "PFFV"
    },
    {
     "description": "PFEIFFER VACUUM TECHNOLOGY",
     "symbol": "PFFVF"
    },
    {
     "description": "PRINCIPAL FINANCIAL GROUP",
     "symbol": "PFG"
    },
    {
     "description": "PFO GLOBAL INC",
     "symbol": "PFGBQ"
    },
    {
     "description": "PERFORMANCE FOOD GROUP CO",
     "symbol": "PFGC"
    },
    {
     "description": "PACIFIC EDGE LTD",
     "symbol": "PFGTF"
    },
    {
     "description": "PRUDENTIAL FINANCIAL INC",
     "symbol": "PFH"
    },
    {
     "description": "PROFESSIONAL HOLDING CORP-A",
     "symbol": "PFHD"
    },
    {
     "description": "PACIFIC HEALTH CARE ORG INC",
     "symbol": "PFHO"
    },
    {
     "description": "INVESCO DWA FINANCIAL MOMENT",
     "symbol": "PFI"
    },
    {
     "description": "PROFIRE ENERGY INC",
     "symbol": "PFIE"
    },
    {
     "description": "INVESCO FUNDAMENTAL INVESTME",
     "symbol": "PFIG"
    },
    {
     "description": "P & F INDUSTRIES -CL A",
     "symbol": "PFIN"
    },
    {
     "description": "PEOPLES FINANCIAL SERVICES",
     "symbol": "PFIS"
    },
    {
     "description": "SIMPLIFY INTEREST RATE HEDGE",
     "symbol": "PFIX"
    },
    {
     "description": "PIMCO INCOME STRATEGY FUND",
     "symbol": "PFL"
    },
    {
     "description": "PACIFIC FINANCIAL CORP",
     "symbol": "PFLC"
    },
    {
     "description": "AAM LOW DUR PREF & INC SEC",
     "symbol": "PFLD"
    },
    {
     "description": "PENNANTPARK FLOATING RATE CA",
     "symbol": "PFLT"
    },
    {
     "description": "INVESCO DIVIDEND ACHIEVERS E",
     "symbol": "PFM"
    },
    {
     "description": "PERFORMANT FINANCIAL CORP",
     "symbol": "PFMT"
    },
    {
     "description": "PIMCO INCOME STRATEGY FD II",
     "symbol": "PFN"
    },
    {
     "description": "PATHFINDER CELL THERAPY INC",
     "symbol": "PFND"
    },
    {
     "description": "PLYMOUTH FINANCIAL CORP",
     "symbol": "PFNL"
    },
    {
     "description": "PARAFIN CORP",
     "symbol": "PFNO"
    },
    {
     "description": "FLAHERTY & CRUMRINE PREFERRE",
     "symbol": "PFO"
    },
    {
     "description": "PREMIER FOODS PLC",
     "symbol": "PFODF"
    },
    {
     "description": "PETROFRONTIER CORP",
     "symbol": "PFRRF"
    },
    {
     "description": "PROVIDENT FINANCIAL SERVICES",
     "symbol": "PFS"
    },
    {
     "description": "PACIFIC SOFTWARE INC",
     "symbol": "PFSF"
    },
    {
     "description": "PENNYMAC FINANCIAL SERVICES",
     "symbol": "PFSI"
    },
    {
     "description": "PERFECT MEDICAL HEALTH MANAG",
     "symbol": "PFSMF"
    },
    {
     "description": "PFSWEB INC",
     "symbol": "PFSW"
    },
    {
     "description": "PORTAGE FINTECH ACQUISITIO-A",
     "symbol": "PFTA"
    },
    {
     "description": "PORTAGE FINTECH ACQUISITION",
     "symbol": "PFTAU"
    },
    {
     "description": "PORTAGE FINTECH ACQ -CW23",
     "symbol": "PFTAW"
    },
    {
     "description": "PURADYN FILTER TECHNOLOGIES",
     "symbol": "PFTI"
    },
    {
     "description": "PARALLEL FLIGHT TECHNOL CL B",
     "symbol": "PFTY"
    },
    {
     "description": "PUTNAM SUSTAINABLE FUTURE",
     "symbol": "PFUT"
    },
    {
     "description": "PETRONE WORLDWIDE INC",
     "symbol": "PFWIQ"
    },
    {
     "description": "PHENIXFIN CORP",
     "symbol": "PFX"
    },
    {
     "description": "VANECK PREF SEC X-FINANCIALS",
     "symbol": "PFXF"
    },
    {
     "description": "PHENIXFIN CORP",
     "symbol": "PFXNL"
    },
    {
     "description": "PHENIXFIN CORP",
     "symbol": "PFXNZ"
    },
    {
     "description": "PROCTER & GAMBLE CO\/THE",
     "symbol": "PG"
    },
    {
     "description": "PGI INC",
     "symbol": "PGAI"
    },
    {
     "description": "GLOBAL X MSCI PORTUGAL ETF",
     "symbol": "PGAL"
    },
    {
     "description": "PETROGRESS INC",
     "symbol": "PGAS"
    },
    {
     "description": "PPB GROUP BERHAD",
     "symbol": "PGBHF"
    },
    {
     "description": "PEAPACK GLADSTONE FINL CORP",
     "symbol": "PGC"
    },
    {
     "description": "PRIME GLOBAL CAPITAL GROUP I",
     "symbol": "PGCG"
    },
    {
     "description": "PUREGOLD PRICE CLUB INC",
     "symbol": "PGCMF"
    },
    {
     "description": "PTT GLOBAL CHEMICAL PCL-NVDR",
     "symbol": "PGCPF"
    },
    {
     "description": "IPATH ASIAN & GULF CURRENCY",
     "symbol": "PGDDF"
    },
    {
     "description": "PGS ASA",
     "symbol": "PGEJF"
    },
    {
     "description": "PRECIGEN INC",
     "symbol": "PGEN"
    },
    {
     "description": "PIGEON CORP-UNSPON ADR",
     "symbol": "PGENY"
    },
    {
     "description": "GROUP TEN METALS INC",
     "symbol": "PGEZF"
    },
    {
     "description": "INVESCO FINANCIAL PREFERRED",
     "symbol": "PGF"
    },
    {
     "description": "PINGIFY INTERNATIONAL INC",
     "symbol": "PGFY"
    },
    {
     "description": "PIAGGIO & C SPA-UNSP ADR",
     "symbol": "PGGCY"
    },
    {
     "description": "PEGASUS GAMING CORP",
     "symbol": "PGGG"
    },
    {
     "description": "INVESCO GLOBAL SHORT TERM HI",
     "symbol": "PGHY"
    },
    {
     "description": "PEREGRINE INDUSTRIES INC",
     "symbol": "PGID"
    },
    {
     "description": "PGI ENERGY INC",
     "symbol": "PGIE"
    },
    {
     "description": "PIMCO GLOBAL INCOME OPPORT-A",
     "symbol": "PGIFF"
    },
    {
     "description": "PRESTIGE INTERNATIONAL INC",
     "symbol": "PGINF"
    },
    {
     "description": "INVESCO GOLDEN DRAGON CHINA",
     "symbol": "PGJ"
    },
    {
     "description": "PAN GLOBAL CORP",
     "symbol": "PGLO"
    },
    {
     "description": "IPATH SERIES B BBG PLATINUM",
     "symbol": "PGM"
    },
    {
     "description": "IPATH BLOOMBERG PLATINUM SUB",
     "symbol": "PGMFF"
    },
    {
     "description": "PRIMEGEN ENERGY CORP",
     "symbol": "PGNE"
    },
    {
     "description": "PARAGON FINANCIAL SOLUTIONS",
     "symbol": "PGNN"
    },
    {
     "description": "PAN GLOBAL RESOURCES INC",
     "symbol": "PGNRF"
    },
    {
     "description": "PARAGON TECHNOLOGIES INC",
     "symbol": "PGNT"
    },
    {
     "description": "PROGYNY INC",
     "symbol": "PGNY"
    },
    {
     "description": "HARTSHEAD RESOURCES NL",
     "symbol": "PGNYF"
    },
    {
     "description": "PERF GO-GREEN HOLDINGS INC",
     "symbol": "PGOG"
    },
    {
     "description": "PATRIOT GOLD CORP",
     "symbol": "PGOL"
    },
    {
     "description": "PIMCO GLOBAL STOCKSPLUS & IN",
     "symbol": "PGP"
    },
    {
     "description": "PUBLICIS GROUPE",
     "symbol": "PGPEF"
    },
    {
     "description": "POWER GROUP PROJECTS CORP",
     "symbol": "PGPGF"
    },
    {
     "description": "PARTNERS GROUP HOLDING AG",
     "symbol": "PGPHF"
    },
    {
     "description": "PGE POLSKA GRUPA ENE-UNS ADR",
     "symbol": "PGPKY"
    },
    {
     "description": "PILGRIM PETROLEUM CORP",
     "symbol": "PGPM"
    },
    {
     "description": "PETROCORP GROUP INC",
     "symbol": "PGPXF"
    },
    {
     "description": "1-PAGE LTD",
     "symbol": "PGQWF"
    },
    {
     "description": "PROGRESSIVE CORP",
     "symbol": "PGR"
    },
    {
     "description": "PARAMOUNT GROUP INC",
     "symbol": "PGRE"
    },
    {
     "description": "PUTNAM FOCUSED LRG CAP GROW",
     "symbol": "PGRO"
    },
    {
     "description": "PROPERTYGURU GROUP LTD",
     "symbol": "PGRU"
    },
    {
     "description": "PROGRESS ACQUISITION CORP-A",
     "symbol": "PGRW"
    },
    {
     "description": "PROGRESS ACQUISITION CORP",
     "symbol": "PGRWU"
    },
    {
     "description": "PROGRESS ACQ CL A -CW27",
     "symbol": "PGRWW"
    },
    {
     "description": "PROGRESSIVE GREEN SOLUTION I",
     "symbol": "PGSC"
    },
    {
     "description": "PEGASUS DIGITAL MOBILITY A-A",
     "symbol": "PGSS"
    },
    {
     "description": "PEGASUS DIGITAL MOBILITY ACQ",
     "symbol": "PGSS.U"
    },
    {
     "description": "PEGASUS DIGITAL MOBILI -CW22",
     "symbol": "PGSS.WS"
    },
    {
     "description": "PGS SOFTWARE SA",
     "symbol": "PGSWF"
    },
    {
     "description": "PGT INNOVATIONS INC",
     "symbol": "PGTI"
    },
    {
     "description": "PACIFIC GREEN TECHNOLOGIES I",
     "symbol": "PGTK"
    },
    {
     "description": "PEGATRON CORP",
     "symbol": "PGTRF"
    },
    {
     "description": "PROSEGUR CASH SA - UNSP ADR",
     "symbol": "PGUCY"
    },
    {
     "description": "PROSEGUR CASH SA",
     "symbol": "PGUUF"
    },
    {
     "description": "PEGASUS PHARMACEUTICALS INC",
     "symbol": "PGUZ"
    },
    {
     "description": "PROMITHIAN GLOBAL VENTURES I",
     "symbol": "PGVI"
    },
    {
     "description": "PGG WRIGHTSON LTD",
     "symbol": "PGWFF"
    },
    {
     "description": "INVESCO PREFERRED ETF",
     "symbol": "PGX"
    },
    {
     "description": "PROSPER GOLD CORP",
     "symbol": "PGXFF"
    },
    {
     "description": "PELANGIO EXPLORATION INC",
     "symbol": "PGXPF"
    },
    {
     "description": "PATRIOT ENERGY CORP",
     "symbol": "PGYC"
    },
    {
     "description": "PANORA GAYRIMENKUL YATIRIM O",
     "symbol": "PGYOF"
    },
    {
     "description": "PRINCIPAL REAL ESTATE INCOME",
     "symbol": "PGZ"
    },
    {
     "description": "PARKER HANNIFIN CORP",
     "symbol": "PH"
    },
    {
     "description": "PHARMING GROUP NV - ADR",
     "symbol": "PHAR"
    },
    {
     "description": "PHASEBIO PHARMACEUTICALS INC",
     "symbol": "PHAS"
    },
    {
     "description": "PHATHOM PHARMACEUTICALS INC",
     "symbol": "PHAT"
    },
    {
     "description": "INVESCO FUNDAMENTAL HIGH YIE",
     "symbol": "PHB"
    },
    {
     "description": "PHARMARON BEIJING CO LTD-H",
     "symbol": "PHBBF"
    },
    {
     "description": "PHARMAGREEN BIOTECH INC",
     "symbol": "PHBI"
    },
    {
     "description": "PRESTON HOLLOW COMMUNITY A",
     "symbol": "PHCC"
    },
    {
     "description": "PHC HOLDINGS CORP",
     "symbol": "PHCCF"
    },
    {
     "description": "PUHUI WEALTH INVESTMENT MANA",
     "symbol": "PHCF"
    },
    {
     "description": "PURE HARVEST CORPORATE GROUP",
     "symbol": "PHCG"
    },
    {
     "description": "PANAMERA HOLDINGS CORP",
     "symbol": "PHCI"
    },
    {
     "description": "PHOTOCURE ASA",
     "symbol": "PHCUF"
    },
    {
     "description": "PIONEER FLOATING RATE FUND",
     "symbol": "PHD"
    },
    {
     "description": "INVESCO S&P 500 DOWNSIDE HED",
     "symbol": "PHDG"
    },
    {
     "description": "PRINCE HOUSING DEVELOPMENT",
     "symbol": "PHDVF"
    },
    {
     "description": "KONINKLIJKE PHILIPS NVR- NY",
     "symbol": "PHG"
    },
    {
     "description": "PHIL-GOOD PRODUCTS INC",
     "symbol": "PHGD"
    },
    {
     "description": "BIOMX INC",
     "symbol": "PHGE"
    },
    {
     "description": "BIOMX INC",
     "symbol": "PHGE.U"
    },
    {
     "description": "BIOMX INC",
     "symbol": "PHGE.WS"
    },
    {
     "description": "PETS AT HOME PLC-UNSP ADR",
     "symbol": "PHGPY"
    },
    {
     "description": "PHARMING GROUP NV",
     "symbol": "PHGUF"
    },
    {
     "description": "PLDT INC-SPON ADR",
     "symbol": "PHI"
    },
    {
     "description": "POPULATION HEALTH INVEST-A",
     "symbol": "PHIC"
    },
    {
     "description": "POPULATION HEALTH INVESTMENT",
     "symbol": "PHICU"
    },
    {
     "description": "POPULATION HEALTH CL A -CW25",
     "symbol": "PHICW"
    },
    {
     "description": "PHI GROUP INC\/DE",
     "symbol": "PHIG"
    },
    {
     "description": "PHI GROUP INC-CW44",
     "symbol": "PHIGW"
    },
    {
     "description": "PHI GROUP INC",
     "symbol": "PHIL"
    },
    {
     "description": "PHIO PHARMACEUTICALS CORP",
     "symbol": "PHIO"
    },
    {
     "description": "REVOLVE RENEWABLE POWER CORP",
     "symbol": "PHIXF"
    },
    {
     "description": "HM SAMPOERNA TBK PT",
     "symbol": "PHJMF"
    },
    {
     "description": "PIMCO HIGH INCOME FUND",
     "symbol": "PHK"
    },
    {
     "description": "POLY PROPERTY GROUP CO LTD",
     "symbol": "PHKIF"
    },
    {
     "description": "PACIFICHEALTH LABORATORIES",
     "symbol": "PHLI"
    },
    {
     "description": "PETERSHILL PARTNERS PLC",
     "symbol": "PHLLF"
    },
    {
     "description": "PULTEGROUP INC",
     "symbol": "PHM"
    },
    {
     "description": "PHARMACOM BIOVET INC",
     "symbol": "PHMB"
    },
    {
     "description": "PHARMA MAR SA",
     "symbol": "PHMMF"
    },
    {
     "description": "PHINERGY LTD",
     "symbol": "PHNGF"
    },
    {
     "description": "PHENOM RESOURCES CORP",
     "symbol": "PHNMF"
    },
    {
     "description": "INVESCO WATER RESOURCES ETF",
     "symbol": "PHO"
    },
    {
     "description": "PHOSAGRO PJSC-GDR REG S",
     "symbol": "PHOJY"
    },
    {
     "description": "PHOSPHATE HOLDINGS INC",
     "symbol": "PHOS"
    },
    {
     "description": "GROWLIFE INC",
     "symbol": "PHOT"
    },
    {
     "description": "PHILIP MORRIS CR AS",
     "symbol": "PHPMF"
    },
    {
     "description": "SIGNIFY NV - UNSP ADR",
     "symbol": "PHPPY"
    },
    {
     "description": "PRIMARY HEALTH PROPERTIES",
     "symbol": "PHPRF"
    },
    {
     "description": "PUSHPAY HOLDINGS LTD",
     "symbol": "PHPYF"
    },
    {
     "description": "PHREESIA INC",
     "symbol": "PHR"
    },
    {
     "description": "PHARMATHER HOLDINGS LTD",
     "symbol": "PHRRF"
    },
    {
     "description": "PHARMAGEN INC",
     "symbol": "PHRX"
    },
    {
     "description": "PHAROL SGPS SA",
     "symbol": "PHRZF"
    },
    {
     "description": "PENTHOUSE INTERNATIONAL INC",
     "symbol": "PHSL"
    },
    {
     "description": "PIONEER HIGH INCOME FUND",
     "symbol": "PHT"
    },
    {
     "description": "PLDT INC",
     "symbol": "PHTCF"
    },
    {
     "description": "PHUNWARE INC",
     "symbol": "PHUN"
    },
    {
     "description": "STELLAR ACQUISITION III-CW22",
     "symbol": "PHUNW"
    },
    {
     "description": "POH HUAT RESOURCES HLDGS BHD",
     "symbol": "PHURF"
    },
    {
     "description": "PHARVARIS NV",
     "symbol": "PHVS"
    },
    {
     "description": "PHILWEB CORP",
     "symbol": "PHWBF"
    },
    {
     "description": "PHX MINERALS INC",
     "symbol": "PHX"
    },
    {
     "description": "PHOENIX CANADA OIL CO LTD",
     "symbol": "PHXCF"
    },
    {
     "description": "PHX ENERGY SERVICES CORP",
     "symbol": "PHXHF"
    },
    {
     "description": "PGIM ACTIVE HIGH YIELD BOND",
     "symbol": "PHYL"
    },
    {
     "description": "ISHARES PHYSICAL GOLD ETC",
     "symbol": "PHYMF"
    },
    {
     "description": "IXICO PLC",
     "symbol": "PHYOF"
    },
    {
     "description": "PURE HYDROGEN CORPORATION LT",
     "symbol": "PHYRF"
    },
    {
     "description": "SPROTT PHYSICAL GOLD TRUST",
     "symbol": "PHYS"
    },
    {
     "description": "PYROPHYTE ACQUISITION CORP-A",
     "symbol": "PHYT"
    },
    {
     "description": "PYROPHYTE ACQUISITION CORP",
     "symbol": "PHYT.U"
    },
    {
     "description": "PHYT WS -CW",
     "symbol": "PHYT.WS"
    },
    {
     "description": "IMPINJ INC",
     "symbol": "PI"
    },
    {
     "description": "PRINCETON CAPITAL CORP",
     "symbol": "PIAC"
    },
    {
     "description": "PIAGGIO & C. S.P.A.",
     "symbol": "PIAGF"
    },
    {
     "description": "PING AN HEALTHCARE & TE-ADR",
     "symbol": "PIAHY"
    },
    {
     "description": "PRIME IMPACT ACQU I -CL A",
     "symbol": "PIAI"
    },
    {
     "description": "PRIME IMPACT ACQUISITION I",
     "symbol": "PIAI.U"
    },
    {
     "description": "PRIME IMPACT ACQU I -CW30",
     "symbol": "PIAI.WS"
    },
    {
     "description": "PING AN INSURANCE GROUP CO-H",
     "symbol": "PIAIF"
    },
    {
     "description": "INVESCO INTERNATIONAL CORPOR",
     "symbol": "PICB"
    },
    {
     "description": "PIVOTAL INVESTMENT CORPIII-A",
     "symbol": "PICC"
    },
    {
     "description": "PIVOTAL INVESTMENT CORP III",
     "symbol": "PICC.U"
    },
    {
     "description": "PIVOTAL INV 3 CL A -CW27",
     "symbol": "PICC.WS"
    },
    {
     "description": "ISHARES MSCI GLOBAL METALS &",
     "symbol": "PICK"
    },
    {
     "description": "INVESCO INTERNATIONAL DIVIDE",
     "symbol": "PID"
    },
    {
     "description": "INVESCO DWA EMERGING MARKETS",
     "symbol": "PIE"
    },
    {
     "description": "ROTHSCHILD & CO",
     "symbol": "PIEJF"
    },
    {
     "description": "INDOFOOD CBP SUKSES MAK-ADR",
     "symbol": "PIFFY"
    },
    {
     "description": "CLEARSHARES PITON INT FI ETF",
     "symbol": "PIFI"
    },
    {
     "description": "PREMIER FARNELL PLC",
     "symbol": "PIFLF"
    },
    {
     "description": "INDOFOOD SUKSES MAKMUR TBK P",
     "symbol": "PIFMF"
    },
    {
     "description": "INDOFOOD SUKSES MAK-UNSP ADR",
     "symbol": "PIFMY"
    },
    {
     "description": "PREMIER INFORMATION MANAGEME",
     "symbol": "PIFR"
    },
    {
     "description": "PINE CLIFF ENERGY LTD",
     "symbol": "PIFYF"
    },
    {
     "description": "PIGEON CORP",
     "symbol": "PIGEF"
    },
    {
     "description": "PLURAL INDUSTRY HOLDING GROU",
     "symbol": "PIHG"
    },
    {
     "description": "PIHLAJALINNA OYJ",
     "symbol": "PIHLF"
    },
    {
     "description": "POLARIS INTERNATIONAL HOLDIN",
     "symbol": "PIHN"
    },
    {
     "description": "POLARIS INC",
     "symbol": "PII"
    },
    {
     "description": "P3 HEALTH PARTNERS INC",
     "symbol": "PIII"
    },
    {
     "description": "FORESIGHT ACQ CORP -A -CW27",
     "symbol": "PIIIW"
    },
    {
     "description": "KIDPIK CORP",
     "symbol": "PIK"
    },
    {
     "description": "PIKSEL INC CLASS A-2",
     "symbol": "PIKL"
    },
    {
     "description": "INDAH KIAT PULP & PAPER TBK",
     "symbol": "PIKQF"
    },
    {
     "description": "PILBARA MINERALS LTD",
     "symbol": "PILBF"
    },
    {
     "description": "DIREXION DLY PHARMA BULL 3X",
     "symbol": "PILL"
    },
    {
     "description": "PUTNAM MASTER INTER INC TST",
     "symbol": "PIM"
    },
    {
     "description": "INVESCO INDIA EXCHANGE-TRADE",
     "symbol": "PIN"
    },
    {
     "description": "PREMIER INC-CLASS A",
     "symbol": "PINC"
    },
    {
     "description": "MALINDO FEEDMILL TBK PT",
     "symbol": "PINDF"
    },
    {
     "description": "ALPINE INCOME PROPERTY TRUST",
     "symbol": "PINE"
    },
    {
     "description": "PING IDENTITY HOLDING CORP",
     "symbol": "PING"
    },
    {
     "description": "SIMPLIFY HEALTH CARE ETF",
     "symbol": "PINK"
    },
    {
     "description": "PINTEREST INC- CLASS A",
     "symbol": "PINS"
    },
    {
     "description": "PINNACLE INVESTMENT MANAGEME",
     "symbol": "PINVF"
    },
    {
     "description": "PEOPLE'S INSURANCE CO GROU-H",
     "symbol": "PINXF"
    },
    {
     "description": "PEOPLE'S INSURANCE -UNSP ADR",
     "symbol": "PINXY"
    },
    {
     "description": "INVESCO GLOBAL WATER ETF",
     "symbol": "PIO"
    },
    {
     "description": "ESSENTIAL METALS LTD",
     "symbol": "PIONF"
    },
    {
     "description": "PREMIER INVESTMENT PROPERTIE",
     "symbol": "PIPI"
    },
    {
     "description": "PINE ISLAND ACQUISITION-CL A",
     "symbol": "PIPP"
    },
    {
     "description": "PINE ISLAND ACQUISITION CORP",
     "symbol": "PIPP.U"
    },
    {
     "description": "PINE ISLAND ACQ-CL A -CW27",
     "symbol": "PIPP.WS"
    },
    {
     "description": "PIPER SANDLER COS",
     "symbol": "PIPR"
    },
    {
     "description": "PROTEOMICS INTERNATIONAL LAB",
     "symbol": "PIQLF"
    },
    {
     "description": "PIERIS PHARMACEUTICALS INC",
     "symbol": "PIRS"
    },
    {
     "description": "POSTE ITALIANE SPA",
     "symbol": "PITAF"
    },
    {
     "description": "INDOCEMENT TUNGGAL PRAKARSA",
     "symbol": "PITPF"
    },
    {
     "description": "INDOCEMENT TUNGGAL-UNSPN ADR",
     "symbol": "PITPY"
    },
    {
     "description": "PAIUTE OIL & MINING CORP",
     "symbol": "PIUTQ"
    },
    {
     "description": "SHIFTPIXY INC",
     "symbol": "PIXY"
    },
    {
     "description": "INVESCO DWA DEVELOPED MARKET",
     "symbol": "PIZ"
    },
    {
     "description": "INNOVATOR U.S. EQUITY POWER",
     "symbol": "PJAN"
    },
    {
     "description": "PRIORITY AVIATION INC",
     "symbol": "PJET"
    },
    {
     "description": "INVESCO DYNAMIC PHARMACEUTIC",
     "symbol": "PJP"
    },
    {
     "description": "PJT PARTNERS INC - A",
     "symbol": "PJT"
    },
    {
     "description": "INNOVATOR U.S. EQUITY POWER",
     "symbol": "PJUL"
    },
    {
     "description": "INNOVATOR U.S. EQUITY POWER",
     "symbol": "PJUN"
    },
    {
     "description": "PJX RESOURCES INC",
     "symbol": "PJXRF"
    },
    {
     "description": "PARK HOTELS & RESORTS INC",
     "symbol": "PK"
    },
    {
     "description": "SIMPLY BETTER BRANDS CORP",
     "symbol": "PKANF"
    },
    {
     "description": "INVESCO DYNAMIC BUILDING & C",
     "symbol": "PKB"
    },
    {
     "description": "BAKRIE & BROTHERS PT",
     "symbol": "PKBAF"
    },
    {
     "description": "PEAKBIRCH COMMERCE INC",
     "symbol": "PKBFF"
    },
    {
     "description": "PARKE BANCORP INC",
     "symbol": "PKBK"
    },
    {
     "description": "PARK24 CO LTD",
     "symbol": "PKCOF"
    },
    {
     "description": "PARK24 CO LTD-SPN ADR",
     "symbol": "PKCOY"
    },
    {
     "description": "AKR CORPORINDO TBK PT",
     "symbol": "PKCPF"
    },
    {
     "description": "AKR CORPORINDO TBK PT-ADR",
     "symbol": "PKCPY"
    },
    {
     "description": "PARKER DRILLING CO-POST BANK",
     "symbol": "PKDC"
    },
    {
     "description": "PARKER DRILLING CO-CW24",
     "symbol": "PKDCW"
    },
    {
     "description": "PARK AEROSPACE CORP",
     "symbol": "PKE"
    },
    {
     "description": "PACKAGING CORP OF AMERICA",
     "symbol": "PKG"
    },
    {
     "description": "PERKINELMER INC",
     "symbol": "PKI"
    },
    {
     "description": "PEKIN LIFE INSURANCE CO",
     "symbol": "PKIN"
    },
    {
     "description": "PARKLAND CORP",
     "symbol": "PKIUF"
    },
    {
     "description": "TENET FINTECH GROUP INC",
     "symbol": "PKKFF"
    },
    {
     "description": "PARKWAY ACQUISITION CORP",
     "symbol": "PKKW"
    },
    {
     "description": "PERK LABS INC",
     "symbol": "PKLBF"
    },
    {
     "description": "PROTEAK UNO SAB DE CV",
     "symbol": "PKNOF"
    },
    {
     "description": "BANK OCBC NISP TBK PT",
     "symbol": "PKNPF"
    },
    {
     "description": "PARK-OHIO HOLDINGS CORP",
     "symbol": "PKOH"
    },
    {
     "description": "PEAK PHARMACEUTICALS INC",
     "symbol": "PKPH"
    },
    {
     "description": "PICK'N PAY STORES LTD-UN ADR",
     "symbol": "PKPYY"
    },
    {
     "description": "PEAK RARE EARTHS LTD",
     "symbol": "PKREF"
    },
    {
     "description": "KRAKATAU STEEL TBK PT-UP ADR",
     "symbol": "PKRKY"
    },
    {
     "description": "KRESNA GRAHA INVESTAMA TBK P",
     "symbol": "PKRSF"
    },
    {
     "description": "PARKSON RETAIL-UNSPON ADR",
     "symbol": "PKSGY"
    },
    {
     "description": "BANK TABUNGAN NEGARA PERSERO",
     "symbol": "PKTBF"
    },
    {
     "description": "PARKIT ENTERPRISE INC",
     "symbol": "PKTEF"
    },
    {
     "description": "PROTOKINETIX INC",
     "symbol": "PKTX"
    },
    {
     "description": "INVESCO BUYBACK ACHIEVERS ET",
     "symbol": "PKW"
    },
    {
     "description": "PARKWAY BANK\/LENOIR NC",
     "symbol": "PKWY"
    },
    {
     "description": "POSCO HOLDINGS INC -SPON ADR",
     "symbol": "PKX"
    },
    {
     "description": "PLANET LABS PBC",
     "symbol": "PL"
    },
    {
     "description": "PLANET LABS PBC        -CW27",
     "symbol": "PL.WS"
    },
    {
     "description": "PHOTRONICS INC",
     "symbol": "PLAB"
    },
    {
     "description": "PLANET GREEN HOLDINGS CORP",
     "symbol": "PLAG"
    },
    {
     "description": "ANAPLAN INC",
     "symbol": "PLAN"
    },
    {
     "description": "PATRIA LATIN AMERICAN OPPORT",
     "symbol": "PLAOU"
    },
    {
     "description": "WISDOMTREE GROWTH LEADERS FU",
     "symbol": "PLAT"
    },
    {
     "description": "PARMALAT SPA",
     "symbol": "PLATF"
    },
    {
     "description": "DAVE & BUSTER'S ENTERTAINMEN",
     "symbol": "PLAY"
    },
    {
     "description": "PLATZER FASTIGHETER HOLD-B",
     "symbol": "PLAZF"
    },
    {
     "description": "PLUMAS BANCORP",
     "symbol": "PLBC"
    },
    {
     "description": "PLBY GROUP INC",
     "symbol": "PLBY"
    },
    {
     "description": "CHILDREN'S PLACE INC\/THE",
     "symbol": "PLCE"
    },
    {
     "description": "PLURILOCK SECURITY INC",
     "symbol": "PLCKF"
    },
    {
     "description": "POLAR CAPITAL TECHNOLOGY TR",
     "symbol": "PLCQF"
    },
    {
     "description": "PROLOGIS INC",
     "symbol": "PLD"
    },
    {
     "description": "ProLogis Inc",
     "symbol": "PLDGP"
    },
    {
     "description": "PLAID INC",
     "symbol": "PLDIF"
    },
    {
     "description": "PUTNAM SUSTAINABLE LEADERS",
     "symbol": "PLDR"
    },
    {
     "description": "ORPHEUM PROPERTY INC",
     "symbol": "PLFF"
    },
    {
     "description": "PLANTFUEL LIFE INC",
     "symbol": "PLFLF"
    },
    {
     "description": "PALFINGER AG",
     "symbol": "PLFRF"
    },
    {
     "description": "PALFINGER AG",
     "symbol": "PLFRY"
    },
    {
     "description": "PULSE EVOLUTION CORP",
     "symbol": "PLFX"
    },
    {
     "description": "PLATINUM GROUP METALS LTD",
     "symbol": "PLG"
    },
    {
     "description": "PLAYLOGIC ENTERTAINMENT INC",
     "symbol": "PLGC"
    },
    {
     "description": "PLAYGON GAMES INC",
     "symbol": "PLGNF"
    },
    {
     "description": "PLANT HEALTH CARE PLC",
     "symbol": "PLHCF"
    },
    {
     "description": "PAUL HARTMANN AG",
     "symbol": "PLHNF"
    },
    {
     "description": "PLANET 13 HOLDINGS INC -CW22",
     "symbol": "PLHWF"
    },
    {
     "description": "PLEJD AB",
     "symbol": "PLJJF"
    },
    {
     "description": "SOLAR GOLD LTD",
     "symbol": "PLKT"
    },
    {
     "description": "PIEDMONT LITHIUM INC",
     "symbol": "PLL"
    },
    {
     "description": "PHILODRILL CORP",
     "symbol": "PLLDF"
    },
    {
     "description": "GEMFIELDS GROUP LTD",
     "symbol": "PLLHF"
    },
    {
     "description": "PIRELLI & C SPA",
     "symbol": "PLLIF"
    },
    {
     "description": "PLATA LATINA MINERALS CORP",
     "symbol": "PLLMF"
    },
    {
     "description": "PIEDMONT LITHIUM INC",
     "symbol": "PLLTL"
    },
    {
     "description": "PALLADON VENTURES LTD",
     "symbol": "PLLVF"
    },
    {
     "description": "POLAREAN IMAGING PLC",
     "symbol": "PLLWF"
    },
    {
     "description": "POLYMET MINING CORP",
     "symbol": "PLM"
    },
    {
     "description": "PLUM ACQUISITION CORP I-A",
     "symbol": "PLMI"
    },
    {
     "description": "PLUM ACQUISITION CORP I",
     "symbol": "PLMIU"
    },
    {
     "description": "PLUM ACQUISITION I A -CW28",
     "symbol": "PLMIW"
    },
    {
     "description": "PALAMINA CORP",
     "symbol": "PLMNF"
    },
    {
     "description": "PALOMAR HOLDINGS INC",
     "symbol": "PLMR"
    },
    {
     "description": "PLANET 13 HOLDINGS INC",
     "symbol": "PLNHF"
    },
    {
     "description": "PLANET FITNESS INC - CL A",
     "symbol": "PLNT"
    },
    {
     "description": "PROLIANCE INTERNATIONAL INC",
     "symbol": "PLNTQ"
    },
    {
     "description": "DOUGLAS DYNAMICS INC",
     "symbol": "PLOW"
    },
    {
     "description": "PREFORMED LINE PRODUCTS CO",
     "symbol": "PLPC"
    },
    {
     "description": "POLE TO WIN HOLDINGS INC",
     "symbol": "PLPHF"
    },
    {
     "description": "PPK GROUP LTD",
     "symbol": "PLPKF"
    },
    {
     "description": "PLANDAI BIOTECHNOLOGY INC",
     "symbol": "PLPL"
    },
    {
     "description": "PLUS PRODUCTS INC",
     "symbol": "PLPRF"
    },
    {
     "description": "PRINCIPAL US LC ADAPT MULTI",
     "symbol": "PLRG"
    },
    {
     "description": "POLAR CAPITAL HOLDINGS PLC",
     "symbol": "PLRRF"
    },
    {
     "description": "PLYMOUTH ROCK TECHNOLOGIES I",
     "symbol": "PLRTF"
    },
    {
     "description": "PLIANT THERAPEUTICS INC",
     "symbol": "PLRX"
    },
    {
     "description": "PULSE SEISMIC INC",
     "symbol": "PLSDF"
    },
    {
     "description": "PULSE BIOSCIENCES INC",
     "symbol": "PLSE"
    },
    {
     "description": "PANACEA LIFE SCIENCES HLDGS",
     "symbol": "PLSH"
    },
    {
     "description": "PHOENIX LIFE SCIENCES INTERN",
     "symbol": "PLSI"
    },
    {
     "description": "PLASSON INDUSTRIES LTD",
     "symbol": "PLSNF"
    },
    {
     "description": "PLUS500 LTD",
     "symbol": "PLSQF"
    },
    {
     "description": "PLATCOM INC",
     "symbol": "PLTI"
    },
    {
     "description": "PLAYTIKA HOLDING CORP",
     "symbol": "PLTK"
    },
    {
     "description": "PRINCIPAL US SC ADAPT MULTI",
     "symbol": "PLTL"
    },
    {
     "description": "GRANITESHARES PLATINUM TRUST",
     "symbol": "PLTM"
    },
    {
     "description": "PALANTIR TECHNOLOGIES INC-A",
     "symbol": "PLTR"
    },
    {
     "description": "PILOT THERAPEUTICS HOLDINGS",
     "symbol": "PLTT"
    },
    {
     "description": "PLANET 13 HOLDINGS -CW23",
     "symbol": "PLTWF"
    },
    {
     "description": "PLANTX LIFE INC",
     "symbol": "PLTXF"
    },
    {
     "description": "PLASTEC TECHNOLOGIES LTD",
     "symbol": "PLTYF"
    },
    {
     "description": "PLUG POWER INC",
     "symbol": "PLUG"
    },
    {
     "description": "EPLUS INC",
     "symbol": "PLUS"
    },
    {
     "description": "POLLUX PROPERTIES INDONESIA",
     "symbol": "PLUXF"
    },
    {
     "description": "PLANT VEDA FOODS LTD",
     "symbol": "PLVFF"
    },
    {
     "description": "INVESCO 1-30 LADDERED TREASU",
     "symbol": "PLW"
    },
    {
     "description": "PINELAWN CEMETERY",
     "symbol": "PLWN"
    },
    {
     "description": "PEOPLES WAY.COM INC",
     "symbol": "PLWY"
    },
    {
     "description": "PROTALIX BIOTHERAPEUTICS INC",
     "symbol": "PLX"
    },
    {
     "description": "PLX PHARMA INC",
     "symbol": "PLXP"
    },
    {
     "description": "MEDIA TECHNOLOGY GROUP LTD",
     "symbol": "PLXRF"
    },
    {
     "description": "PLEXUS CORP",
     "symbol": "PLXS"
    },
    {
     "description": "PLAYA HOTELS & RESORTS NV",
     "symbol": "PLYA"
    },
    {
     "description": "PLAYFAIR MINING LTD",
     "symbol": "PLYFF"
    },
    {
     "description": "PLYMOUTH INDUSTRIAL REIT INC",
     "symbol": "PLYM"
    },
    {
     "description": "PLYMOUTH INDUSTRIAL REIT",
     "symbol": "PLYM.PRA"
    },
    {
     "description": "PALAYAN RESOURCES INC",
     "symbol": "PLYN"
    },
    {
     "description": "POLYMERIC RESOURCES CORP",
     "symbol": "PLYR"
    },
    {
     "description": "PLYZER TECHNOLOGIES INC",
     "symbol": "PLYZ"
    },
    {
     "description": "PHILIP MORRIS INTERNATIONAL",
     "symbol": "PM"
    },
    {
     "description": "PLASMATECH INC",
     "symbol": "PMAH"
    },
    {
     "description": "INNOVATOR U.S. EQUITY POWER",
     "symbol": "PMAR"
    },
    {
     "description": "PREMIER INVESTMENTS LIMITED",
     "symbol": "PMAUF"
    },
    {
     "description": "INNOVATOR U.S. EQUITY POWER",
     "symbol": "PMAY"
    },
    {
     "description": "Pembina Pipeline Corporation",
     "symbol": "PMBPF"
    },
    {
     "description": "POSTD MERCHANT BANQUE",
     "symbol": "PMBY"
    },
    {
     "description": "PHARMACYTE BIOTECH INC",
     "symbol": "PMCB"
    },
    {
     "description": "PELOTON MINERALS CORP",
     "symbol": "PMCCF"
    },
    {
     "description": "PRO MEDICUS LTD",
     "symbol": "PMCUF"
    },
    {
     "description": "PSYCHEMEDICS CORP",
     "symbol": "PMD"
    },
    {
     "description": "MITRA ADIPERKASA TBK PT",
     "symbol": "PMDKF"
    },
    {
     "description": "MITRA ADIPERKASA-SPON ADR",
     "symbol": "PMDKY"
    },
    {
     "description": "PACE MEDICAL INC",
     "symbol": "PMDL"
    },
    {
     "description": "PLATEAU MINERAL DEVELOPMENT",
     "symbol": "PMDP"
    },
    {
     "description": "PRIME MERIDIAN RESOURCES COR",
     "symbol": "PMDRF"
    },
    {
     "description": "PINGTAN MARINE ENTERPRISE LT",
     "symbol": "PME"
    },
    {
     "description": "PM&E INC",
     "symbol": "PMEA"
    },
    {
     "description": "PREDICTMEDIX INC",
     "symbol": "PMEDF"
    },
    {
     "description": "PRIMELINE ENERGY HOLDINGS",
     "symbol": "PMEHF"
    },
    {
     "description": "PIMCO EMERGING MARKETS ADVAN",
     "symbol": "PMEMF"
    },
    {
     "description": "PATRIOT BATTERY METALS INC",
     "symbol": "PMETF"
    },
    {
     "description": "PIMCO MUNICIPAL INCOME FUND",
     "symbol": "PMF"
    },
    {
     "description": "PIMCO SHRT HIYI CORP-USD ACC",
     "symbol": "PMFIF"
    },
    {
     "description": "PIMCO US LOW DUR CORP BONDS",
     "symbol": "PMFXF"
    },
    {
     "description": "PRIVETERRA ACQUISITION COR-A",
     "symbol": "PMGM"
    },
    {
     "description": "PLAY MAGNUS AS",
     "symbol": "PMGMF"
    },
    {
     "description": "PRIVETERRA ACQUISITION CORP",
     "symbol": "PMGMU"
    },
    {
     "description": "PRIVETERRA ACQ CL A -CW27",
     "symbol": "PMGMW"
    },
    {
     "description": "PERPETUAL ENERGY INC",
     "symbol": "PMGYF"
    },
    {
     "description": "PRIME MERIDIAN HOLDING CO",
     "symbol": "PMHG"
    },
    {
     "description": "PMI GROUP INC",
     "symbol": "PMIR"
    },
    {
     "description": "PLAYMAKER CAPITAL INC",
     "symbol": "PMKRF"
    },
    {
     "description": "PINKMONKEY.COM INC",
     "symbol": "PMKY"
    },
    {
     "description": "PIMCO MUNICIPAL INCOME FD II",
     "symbol": "PML"
    },
    {
     "description": "PUTNAM MANAGED MUNI INCM TRS",
     "symbol": "PMM"
    },
    {
     "description": "PUMA SE",
     "symbol": "PMMAF"
    },
    {
     "description": "Pembina Pipeline Corporation",
     "symbol": "PMMBF"
    },
    {
     "description": "PAMPA METALS CORP",
     "symbol": "PMMCF"
    },
    {
     "description": "PIMCO US DOLLAR SHORT MATURI",
     "symbol": "PMMDF"
    },
    {
     "description": "PREMIUM EXPLORATION INC",
     "symbol": "PMMEF"
    },
    {
     "description": "PREMIUM GROUP CO LTD",
     "symbol": "PMMFF"
    },
    {
     "description": "PIMCO SHRT HIYI CORP-USD INC",
     "symbol": "PMMOF"
    },
    {
     "description": "PRECIOUS METALS & MINING TRU",
     "symbol": "PMMTF"
    },
    {
     "description": "PERSEUS MINING LTD",
     "symbol": "PMNXF"
    },
    {
     "description": "PUTNAM MUNI OPPORTUNITIES TR",
     "symbol": "PMO"
    },
    {
     "description": "HARBOUR ENERGY PLC",
     "symbol": "PMOIF"
    },
    {
     "description": "PRISMONE GROUP INC",
     "symbol": "PMOZ"
    },
    {
     "description": "PREMIER PRODUCTS GROUP INC",
     "symbol": "PMPG"
    },
    {
     "description": "PRIMARIS REIT",
     "symbol": "PMREF"
    },
    {
     "description": "PROTEOME SCIENCES PLC",
     "symbol": "PMSNF"
    },
    {
     "description": "PRIMAL SOLUTIONS INC",
     "symbol": "PMSO"
    },
    {
     "description": "PENNYMAC MORTGAGE INVESTMENT",
     "symbol": "PMT"
    },
    {
     "description": "PENNYMAC MTGE INVESTMENT",
     "symbol": "PMT.PRA"
    },
    {
     "description": "PENNYMAC MTGE INVESTMENT",
     "symbol": "PMT.PRB"
    },
    {
     "description": "PENNYMAC MTGE INVESTMENT",
     "symbol": "PMT.PRC"
    },
    {
     "description": "PRECIOUS METALS BULLION TRST",
     "symbol": "PMTRF"
    },
    {
     "description": "CPI CARD GROUP INC",
     "symbol": "PMTS"
    },
    {
     "description": "PLAYMATES TOYS LTD",
     "symbol": "PMTYF"
    },
    {
     "description": "MULTISTRADA ARAH SARANA TBK",
     "symbol": "PMUHF"
    },
    {
     "description": "PMV CONSUMER ACQUISITION-A",
     "symbol": "PMVC"
    },
    {
     "description": "PMV CONSUMER ACQUISITION COR",
     "symbol": "PMVC.U"
    },
    {
     "description": "PMV CONSUMER ACQUISIT -CW27",
     "symbol": "PMVC.WS"
    },
    {
     "description": "PMV PHARMACEUTICALS INC",
     "symbol": "PMVP"
    },
    {
     "description": "PIMCO MUNI INCOME FUND III",
     "symbol": "PMX"
    },
    {
     "description": "PHARMAXIS LTD",
     "symbol": "PMXSF"
    },
    {
     "description": "PRIMIX CORP",
     "symbol": "PMXX"
    },
    {
     "description": "BOAB METALS LTD",
     "symbol": "PMYLF"
    },
    {
     "description": "PETRONAS DAGANGAN BHD",
     "symbol": "PNADF"
    },
    {
     "description": "PETRONAS GAS BHD",
     "symbol": "PNAGF"
    },
    {
     "description": "PRINCETON NATIONAL BANCORP",
     "symbol": "PNBC"
    },
    {
     "description": "PIONEER BANKSHARES INC",
     "symbol": "PNBI"
    },
    {
     "description": "PATRIOT NATIONAL BANCORP INC",
     "symbol": "PNBK"
    },
    {
     "description": "PNC FINANCIAL SERVICES GROUP",
     "symbol": "PNC"
    },
    {
     "description": "PNC FINANCIAL SERVICES",
     "symbol": "PNC.PRP"
    },
    {
     "description": "GALLEON GOLD CORP",
     "symbol": "PNCKF"
    },
    {
     "description": "PENDER GROWTH FUND INC",
     "symbol": "PNDDF"
    },
    {
     "description": "INDOFOOD CBP SUKSES MAKMUR T",
     "symbol": "PNDFF"
    },
    {
     "description": "POND TECHNOLOGIES HOLDINGS I",
     "symbol": "PNDHF"
    },
    {
     "description": "PENDAL GROUP LTD",
     "symbol": "PNDLF"
    },
    {
     "description": "PANDOX AB",
     "symbol": "PNDXF"
    },
    {
     "description": "PANDORA A\/S",
     "symbol": "PNDZF"
    },
    {
     "description": "PHARNEXT SA",
     "symbol": "PNEXF"
    },
    {
     "description": "PIMCO NEW YORK MUNI INC FD",
     "symbol": "PNF"
    },
    {
     "description": "PINNACLE FINANCIAL PARTNERS",
     "symbol": "PNFP"
    },
    {
     "description": "PINNACLE FINANCIAL PARTN",
     "symbol": "PNFPP"
    },
    {
     "description": "PETRONEFT RESOURCES PLC",
     "symbol": "PNFTF"
    },
    {
     "description": "PING AN INSURANCE-ADR",
     "symbol": "PNGAY"
    },
    {
     "description": "PANGLOBAL BRANDS INC",
     "symbol": "PNGB"
    },
    {
     "description": "PENGRAM CORP",
     "symbol": "PNGM"
    },
    {
     "description": "PARINGA RESOURCES LTD",
     "symbol": "PNGZF"
    },
    {
     "description": "PIMCO NEW YORK MUNICIPAL II",
     "symbol": "PNI"
    },
    {
     "description": "PININFARINA SPA",
     "symbol": "PNINF"
    },
    {
     "description": "PANELTECH INTERNATIONAL HOLD",
     "symbol": "PNLT"
    },
    {
     "description": "PNM RESOURCES INC",
     "symbol": "PNM"
    },
    {
     "description": "JAYDEN RESOURCES INC",
     "symbol": "PNMLF"
    },
    {
     "description": "PENTAMASTER INTERNATIONAL LT",
     "symbol": "PNMRF"
    },
    {
     "description": "Public Service Company of New Mexico",
     "symbol": "PNMXO"
    },
    {
     "description": "PINNACLE BANK OF OREGON",
     "symbol": "PNNB"
    },
    {
     "description": "PINNACLE ETHANOL LLC - A",
     "symbol": "PNNCU"
    },
    {
     "description": "PENNINE PETROLEUM CORP",
     "symbol": "PNNEF"
    },
    {
     "description": "PERENNIAL INTERNATIONAL LTD",
     "symbol": "PNNLF"
    },
    {
     "description": "PENNANTPARK INVESTMENT CORP",
     "symbol": "PNNT"
    },
    {
     "description": "PENNEXX FOODS INC",
     "symbol": "PNNX"
    },
    {
     "description": "PENTA-OCEAN CONSTRUCTION CO",
     "symbol": "PNOCF"
    },
    {
     "description": "INNOVATOR U.S. EQUITY POWER",
     "symbol": "PNOV"
    },
    {
     "description": "PINETREE CAPITAL LTD",
     "symbol": "PNPFF"
    },
    {
     "description": "PINEAPPLE EXPRESS INC",
     "symbol": "PNPL"
    },
    {
     "description": "INVESCO NASDAQ INTERNET ETF",
     "symbol": "PNQI"
    },
    {
     "description": "PENTAIR PLC",
     "symbol": "PNR"
    },
    {
     "description": "PREMIER ENERGY CORP",
     "symbol": "PNRC"
    },
    {
     "description": "PRIMEENERGY RESOURCES CORP",
     "symbol": "PNRG"
    },
    {
     "description": "PORTO ENERGY CORP",
     "symbol": "PNRXF"
    },
    {
     "description": "PENSANA PLC",
     "symbol": "PNSPF"
    },
    {
     "description": "POINT BIOPHARMA GLOBAL INC",
     "symbol": "PNT"
    },
    {
     "description": "PENNANT GROUP INC\/THE",
     "symbol": "PNTG"
    },
    {
     "description": "PENTANET LTD",
     "symbol": "PNTLF"
    },
    {
     "description": "PONTEM CORP-CLASS A",
     "symbol": "PNTM"
    },
    {
     "description": "PONTEM CORP",
     "symbol": "PNTM.U"
    },
    {
     "description": "PONTEM CORP-CLASS A -CW27",
     "symbol": "PNTM.WS"
    },
    {
     "description": "PANTORO LTD",
     "symbol": "PNTOF"
    },
    {
     "description": "TRIGON METALS INC",
     "symbol": "PNTZF"
    },
    {
     "description": "PINNACLE WEST CAPITAL",
     "symbol": "PNW"
    },
    {
     "description": "VALEURA ENERGY INC",
     "symbol": "PNWRF"
    },
    {
     "description": "PHOENIX GROUP HOLDINGS PLC",
     "symbol": "PNXGF"
    },
    {
     "description": "ARGENTINA LITHIUM & ENERGY C",
     "symbol": "PNXLF"
    },
    {
     "description": "PNX METALS LTD",
     "symbol": "PNXMF"
    },
    {
     "description": "PLANET VENTURES INC",
     "symbol": "PNXPF"
    },
    {
     "description": "POYNT CORP",
     "symbol": "PNYTF"
    },
    {
     "description": "PORSCHE AUTOMOBIL HLDG-PRF",
     "symbol": "POAHF"
    },
    {
     "description": "PORSCHE AUTOMOBIL-UNSP ADR",
     "symbol": "POAHY"
    },
    {
     "description": "PREDICTIVE ONCOLOGY INC",
     "symbol": "POAI"
    },
    {
     "description": "INNOVATOR U.S. EQUITY POWER",
     "symbol": "POCT"
    },
    {
     "description": "PODA HOLDINGS INC",
     "symbol": "PODAF"
    },
    {
     "description": "INSULET CORP",
     "symbol": "PODD"
    },
    {
     "description": "PAN ORIENT ENERGY CORP",
     "symbol": "POEFF"
    },
    {
     "description": "NAVIGATOR CO SA\/THE",
     "symbol": "POELF"
    },
    {
     "description": "POET TECHNOLOGIES INC",
     "symbol": "POET"
    },
    {
     "description": "PETROFAC LTD",
     "symbol": "POFCF"
    },
    {
     "description": "PETROFAC LTD- UNSPON ADR",
     "symbol": "POFCY"
    },
    {
     "description": "PILOT CORP",
     "symbol": "POGHF"
    },
    {
     "description": "PIONEER OIL & GAS",
     "symbol": "POGS"
    },
    {
     "description": "POLSKIE GORNICTWO NAFTOW-ADR",
     "symbol": "POGWY"
    },
    {
     "description": "POLAR POWER INC",
     "symbol": "POLA"
    },
    {
     "description": "POOLBEG PHARMA PLC",
     "symbol": "POLBF"
    },
    {
     "description": "POLAR PETROLEUM CORP",
     "symbol": "POLR"
    },
    {
     "description": "POLYDEX PHARMACEUTICALS LTD",
     "symbol": "POLXF"
    },
    {
     "description": "PLANTRONICS INC",
     "symbol": "POLY"
    },
    {
     "description": "ANGEL POND HOLDINGS CORP-A",
     "symbol": "POND"
    },
    {
     "description": "ANGEL POND HOLDINGS CORP",
     "symbol": "POND.U"
    },
    {
     "description": "ANGEL POND HOLDINGS -CW27",
     "symbol": "POND.WS"
    },
    {
     "description": "ATARI SA",
     "symbol": "PONGF"
    },
    {
     "description": "PONO CAPITAL CORP-A",
     "symbol": "PONO"
    },
    {
     "description": "PONO CAPITAL CORP",
     "symbol": "PONOU"
    },
    {
     "description": "PONO CAPITAL CORP -CW22",
     "symbol": "PONOW"
    },
    {
     "description": "PONTIAC BANCORP INC",
     "symbol": "PONT"
    },
    {
     "description": "POOL CORP",
     "symbol": "POOL"
    },
    {
     "description": "POSEIDON CONCEPTS CORP",
     "symbol": "POOSF"
    },
    {
     "description": "POPMAIL.COM INC",
     "symbol": "POPM"
    },
    {
     "description": "POPREACH CORP",
     "symbol": "POPRF"
    },
    {
     "description": "PORTLAND GENERAL ELECTRIC CO",
     "symbol": "POR"
    },
    {
     "description": "POLA ORBIS HOLDINGS INC",
     "symbol": "PORBF"
    },
    {
     "description": "NOVX21 INC",
     "symbol": "PORMF"
    },
    {
     "description": "PANORO MINERALS LTD",
     "symbol": "POROF"
    },
    {
     "description": "SOUTHPORT ACQUISITION CORP",
     "symbol": "PORT"
    },
    {
     "description": "SOUTHPORT ACQUISITION CORP",
     "symbol": "PORT.U"
    },
    {
     "description": "SOUTHPORT ACQUISITION -CW23",
     "symbol": "PORT.WS"
    },
    {
     "description": "POSABIT SYSTEMS CORP",
     "symbol": "POSAF"
    },
    {
     "description": "POSITRON CORP",
     "symbol": "POSC"
    },
    {
     "description": "POSHMARK INC-CLASS A",
     "symbol": "POSH"
    },
    {
     "description": "POST HOLDINGS INC",
     "symbol": "POST"
    },
    {
     "description": "PORTMEIRION GROUP PLC",
     "symbol": "POTMF"
    },
    {
     "description": "POTNETWORK HOLDINGS INC",
     "symbol": "POTN"
    },
    {
     "description": "SOPERIOR FERTILIZER CORP",
     "symbol": "POTRF"
    },
    {
     "description": "BUDDY TECHNOLOGIES LTD",
     "symbol": "POTTF"
    },
    {
     "description": "POTENT VENTURES INC",
     "symbol": "POTVF"
    },
    {
     "description": "GLOBAL X CANNABIS ETF",
     "symbol": "POTX"
    },
    {
     "description": "POWERED BRANDS - CLASS A",
     "symbol": "POW"
    },
    {
     "description": "POWER INTEGRATIONS INC",
     "symbol": "POWI"
    },
    {
     "description": "POWELL INDUSTRIES INC",
     "symbol": "POWL"
    },
    {
     "description": "POWERED BRANDS",
     "symbol": "POWRU"
    },
    {
     "description": "POWERED BRANDS CL A  -CW27",
     "symbol": "POWRW"
    },
    {
     "description": "AMMO INC",
     "symbol": "POWW"
    },
    {
     "description": "AMMO INC",
     "symbol": "POWWP"
    },
    {
     "description": "PO YUEN CULTURAL HOLDINGS (H",
     "symbol": "POYN"
    },
    {
     "description": "POLYMETAL INTERNATIONAL PLC",
     "symbol": "POYYF"
    },
    {
     "description": "INVESCO AEROSPACE & DEFENSE",
     "symbol": "PPA"
    },
    {
     "description": "PERUSAHAAN GAS NEGARA TBK PT",
     "symbol": "PPAAF"
    },
    {
     "description": "PERUSAHAAN GAS NE-UNSPON ADR",
     "symbol": "PPAAY"
    },
    {
     "description": "PEOPLES TR CO ST ALBANS VT",
     "symbol": "PPAL"
    },
    {
     "description": "PICK'N PAY STORES LTD",
     "symbol": "PPASF"
    },
    {
     "description": "PEOPLES BANCORP WASH",
     "symbol": "PPBB"
    },
    {
     "description": "PACIFIC PREMIER BANCORP INC",
     "symbol": "PPBI"
    },
    {
     "description": "PINNACLE BANKSHARES CORP",
     "symbol": "PPBN"
    },
    {
     "description": "PURPLE BIOTECH LTD-ADR",
     "symbol": "PPBT"
    },
    {
     "description": "PURPLE BEVERAGE CO INC",
     "symbol": "PPBV"
    },
    {
     "description": "PILGRIM'S PRIDE CORP",
     "symbol": "PPC"
    },
    {
     "description": "PROPANC BIOPHARMA INC",
     "symbol": "PPCB"
    },
    {
     "description": "PICC PROPERTY & CASUALTY-H",
     "symbol": "PPCCF"
    },
    {
     "description": "PICC PROPERTY & CAS-UNSP ADR",
     "symbol": "PPCCY"
    },
    {
     "description": "PRESIDENT ENERGY PLC",
     "symbol": "PPCGF"
    },
    {
     "description": "PPC LTD-SPONSORED ADR",
     "symbol": "PPCLY"
    },
    {
     "description": "PREMIER PACIFIC CONSTRUCTION",
     "symbol": "PPCQ"
    },
    {
     "description": "BANK MANDIRI PERSERO TBK PT",
     "symbol": "PPERF"
    },
    {
     "description": "BANK MANDIRI TBK-UNSPON ADR",
     "symbol": "PPERY"
    },
    {
     "description": "PACIFIC PARADYM ENERGY INC",
     "symbol": "PPEVF"
    },
    {
     "description": "PPG INDUSTRIES INC",
     "symbol": "PPG"
    },
    {
     "description": "VANECK PHARMACEUTICAL ETF",
     "symbol": "PPH"
    },
    {
     "description": "POSITIVE PHYSICIANS HOLDINGS",
     "symbol": "PPHI"
    },
    {
     "description": "SPEXIS AG",
     "symbol": "PPHOF"
    },
    {
     "description": "PHP VENTURES ACQUISITION -A",
     "symbol": "PPHP"
    },
    {
     "description": "PHP VENTURES ACQUISITION-RTS",
     "symbol": "PPHPR"
    },
    {
     "description": "PHP VENTURES ACQUISITION COR",
     "symbol": "PPHPU"
    },
    {
     "description": "PHP VENTURES ACQUISITI -CW22",
     "symbol": "PPHPW"
    },
    {
     "description": "AXS ASTORIA INFLATION SENS",
     "symbol": "PPI"
    },
    {
     "description": "PERMA-PIPE INTERNATIONAL HOL",
     "symbol": "PPIH"
    },
    {
     "description": "COENZYME A INC",
     "symbol": "PPII"
    },
    {
     "description": "PPJ HEALTHCARE ENTERPRISES I",
     "symbol": "PPJE"
    },
    {
     "description": "PEPKOR HOLDINGS LTD",
     "symbol": "PPKRF"
    },
    {
     "description": "PABRIK KERTAS TJIWI KIMIA TB",
     "symbol": "PPKTF"
    },
    {
     "description": "PPL CORP",
     "symbol": "PPL"
    },
    {
     "description": "PP LONDON SUMATRA INDONES PT",
     "symbol": "PPLFF"
    },
    {
     "description": "PP LONDON SUMATRA-UNSPON ADR",
     "symbol": "PPLFY"
    },
    {
     "description": "PEOPLES LTD",
     "symbol": "PPLL"
    },
    {
     "description": "Pembina Pipeline Corporation",
     "symbol": "PPLPF"
    },
    {
     "description": "ABRDN PLATINUM ETF TRUST",
     "symbol": "PPLT"
    },
    {
     "description": "PROTIDE PHARMACEUTICALS INC",
     "symbol": "PPMD"
    },
    {
     "description": "POINT TO POINT METHODICS INC",
     "symbol": "PPMH"
    },
    {
     "description": "PROFIT PLANNERS MANAGEMENT",
     "symbol": "PPMT"
    },
    {
     "description": "CHAROEN POKPHAND INDONESI PT",
     "symbol": "PPOKF"
    },
    {
     "description": "PACIFIC SILK ROAD RESOURCES",
     "symbol": "PPOTF"
    },
    {
     "description": "PATIENT PORTAL TECHNOLOGIES",
     "symbol": "PPRG"
    },
    {
     "description": "CHOICE PROPERTIES REIT",
     "symbol": "PPRQF"
    },
    {
     "description": "PRONTOFORMS CORP",
     "symbol": "PPRRF"
    },
    {
     "description": "PEIPORT HOLDINGS LTD",
     "symbol": "PPRTF"
    },
    {
     "description": "KERING",
     "symbol": "PPRUF"
    },
    {
     "description": "KERING-UNSPONSORED ADR",
     "symbol": "PPRUY"
    },
    {
     "description": "PREMIER POWER RENEWABLE ENER",
     "symbol": "PPRW"
    },
    {
     "description": "PEOPLES-SIDNEY FINL CORP",
     "symbol": "PPSF"
    },
    {
     "description": "PIONEER POWER SOLUTIONS INC",
     "symbol": "PPSI"
    },
    {
     "description": "PEPSI-COLA PRODUCTS PHILIPPI",
     "symbol": "PPSTF"
    },
    {
     "description": "PUTNAM PREMIER INCOME TRUST",
     "symbol": "PPT"
    },
    {
     "description": "PERPETUA RESOURCES CORP",
     "symbol": "PPTA"
    },
    {
     "description": "PEPTIDREAM INC",
     "symbol": "PPTDF"
    },
    {
     "description": "PREMIUM ENERGY CORP",
     "symbol": "PPTL"
    },
    {
     "description": "US DIVERSIFIED REAL ESTATE E",
     "symbol": "PPTY"
    },
    {
     "description": "PacifiCorp",
     "symbol": "PPWLM"
    },
    {
     "description": "PacifiCorp",
     "symbol": "PPWLO"
    },
    {
     "description": "PAPAYA GROWTH OPPORTUNI-CL A",
     "symbol": "PPYA"
    },
    {
     "description": "PAPAYA GROWTH OPPORTUNITY CO",
     "symbol": "PPYAU"
    },
    {
     "description": "PAPAYA GROWTH OPPORTUNI-CW23",
     "symbol": "PPYAW"
    },
    {
     "description": "WESTERN ATLAS RESOURCES INC",
     "symbol": "PPZRF"
    },
    {
     "description": "PRINCIPAL SPECTRUM TAX-ADVAN",
     "symbol": "PQDI"
    },
    {
     "description": "PETROTEQ ENERGY INC",
     "symbol": "PQEFF"
    },
    {
     "description": "PGIM QUANT SOLUTIONS STRATEG",
     "symbol": "PQIN"
    },
    {
     "description": "PROASSURANCE CORP",
     "symbol": "PRA"
    },
    {
     "description": "PRA GROUP INC",
     "symbol": "PRAA"
    },
    {
     "description": "PRODUCTIVITY TECHNOLOGIES CP",
     "symbol": "PRAC"
    },
    {
     "description": "PERAK CORP BHD",
     "symbol": "PRAKF"
    },
    {
     "description": "PRAXIS PRECISION MEDICINES I",
     "symbol": "PRAX"
    },
    {
     "description": "FIS BIBLICALLY RESPONSIBLE",
     "symbol": "PRAY"
    },
    {
     "description": "PRECISE BIOMETRICS AB",
     "symbol": "PRBCF"
    },
    {
     "description": "PARABELLUM ACQUISITION COR-A",
     "symbol": "PRBM"
    },
    {
     "description": "PARABELLUM ACQUISITION CORP",
     "symbol": "PRBM.U"
    },
    {
     "description": "PARABELLUM ACQUISITION -CW23",
     "symbol": "PRBM.WS"
    },
    {
     "description": "PREMIUM BRANDS HOLDINGS CORP",
     "symbol": "PRBZF"
    },
    {
     "description": "PROTEIN REACTOR COMBINED FUE",
     "symbol": "PRCF"
    },
    {
     "description": "PORCH GROUP INC",
     "symbol": "PRCH"
    },
    {
     "description": "PLACER CREEK MINING CO",
     "symbol": "PRCK"
    },
    {
     "description": "PURE GLOBAL CANNABIS INC",
     "symbol": "PRCNF"
    },
    {
     "description": "PROCURRI CORP LTD",
     "symbol": "PRCRF"
    },
    {
     "description": "PROCEPT BIOROBOTICS CORP",
     "symbol": "PRCT"
    },
    {
     "description": "PHOENIX RISING COMPANIES",
     "symbol": "PRCX"
    },
    {
     "description": "PREMIER DIVERSIFIED HOLDINGS",
     "symbol": "PRDGF"
    },
    {
     "description": "PROFITABLE DEVELOPMENTS INC",
     "symbol": "PRDL"
    },
    {
     "description": "PERDOCEO EDUCATION CORP",
     "symbol": "PRDO"
    },
    {
     "description": "PARDES BIOSCIENCES INC",
     "symbol": "PRDS"
    },
    {
     "description": "PRADA S.P.A.",
     "symbol": "PRDSF"
    },
    {
     "description": "PRADA S.P.A.-UNSP ADR",
     "symbol": "PRDSY"
    },
    {
     "description": "PARTNERRE LTD",
     "symbol": "PRE.PRJ"
    },
    {
     "description": "PRESTIGE CARS INTERNATIONAL",
     "symbol": "PREC"
    },
    {
     "description": "PREDICTIVE TECHNOLOGY GROUP",
     "symbol": "PRED"
    },
    {
     "description": "PRNCPAL SPCTRM PREF SEC ACTV",
     "symbol": "PREF"
    },
    {
     "description": "Praire Ethanol-CAP UNIT CL A",
     "symbol": "PREHU"
    },
    {
     "description": "PRECIPITATE GOLD CORP",
     "symbol": "PREIF"
    },
    {
     "description": "PRAIRIESKY ROYALTY LTD",
     "symbol": "PREKF"
    },
    {
     "description": "PRAIRE ETHANOL LLC",
     "symbol": "PRENU"
    },
    {
     "description": "PERPETUAL RESOURCES LTD",
     "symbol": "PRESF"
    },
    {
     "description": "PROSPERITY REIT",
     "symbol": "PREUF"
    },
    {
     "description": "POWER RESOURCE EXPLORATION I",
     "symbol": "PREXF"
    },
    {
     "description": "INVESCO FTSE RAFI US 1000 ET",
     "symbol": "PRF"
    },
    {
     "description": "PERFICIENT INC",
     "symbol": "PRFT"
    },
    {
     "description": "PROSPEROUS FUTURE HOLDINGS L",
     "symbol": "PRFUF"
    },
    {
     "description": "PAINREFORM LTD",
     "symbol": "PRFX"
    },
    {
     "description": "INVESCO FTSE RAFI US 1500 SM",
     "symbol": "PRFZ"
    },
    {
     "description": "PROG HOLDINGS INC",
     "symbol": "PRG"
    },
    {
     "description": "PUREGOLD PRICE CLUB INC -ADR",
     "symbol": "PRGLY"
    },
    {
     "description": "PARAGON SHIPPING INC-CLASS A",
     "symbol": "PRGNF"
    },
    {
     "description": "PERRIGO CO PLC",
     "symbol": "PRGO"
    },
    {
     "description": "PROGRESS SOFTWARE CORP",
     "symbol": "PRGS"
    },
    {
     "description": "PURE H20 BIO-TECHNOLOGIES",
     "symbol": "PRHB"
    },
    {
     "description": "PREMIER HOLDING CORP",
     "symbol": "PRHL"
    },
    {
     "description": "PRIMERICA INC",
     "symbol": "PRI"
    },
    {
     "description": "PRIORITY INCOME FUND",
     "symbol": "PRIF.PRD"
    },
    {
     "description": "PRIORITY INCOME FUND",
     "symbol": "PRIF.PRF"
    },
    {
     "description": "PRIORITY INCOME FUND",
     "symbol": "PRIF.PRG"
    },
    {
     "description": "PRIORITY INCOME FUND",
     "symbol": "PRIF.PRH"
    },
    {
     "description": "PRIORITY INCOME",
     "symbol": "PRIF.PRI"
    },
    {
     "description": "PRIORITY INCOME FUND",
     "symbol": "PRIF.PRJ"
    },
    {
     "description": "PRIORITY INCOME FUND",
     "symbol": "PRIF.PRK"
    },
    {
     "description": "PRIORITY INCOME FUND",
     "symbol": "PRIF.PRL"
    },
    {
     "description": "PRIMORIS SERVICES CORP",
     "symbol": "PRIM"
    },
    {
     "description": "PROMOTORA DE INFORMA-ADR",
     "symbol": "PRISY"
    },
    {
     "description": "PARK NATIONAL CORP",
     "symbol": "PRK"
    },
    {
     "description": "PARKS! AMERICA INC",
     "symbol": "PRKA"
    },
    {
     "description": "PERK INTERNATIONAL INC",
     "symbol": "PRKI"
    },
    {
     "description": "PARKERVISION INC",
     "symbol": "PRKR"
    },
    {
     "description": "PARKVIDA GROUP INC",
     "symbol": "PRKV"
    },
    {
     "description": "PARKWAYLIFE REAL ESTATE",
     "symbol": "PRKWF"
    },
    {
     "description": "PROTO LABS INC",
     "symbol": "PRLB"
    },
    {
     "description": "PRELUDE THERAPEUTICS INC",
     "symbol": "PRLD"
    },
    {
     "description": "PILLARSTONE CAPITAL REIT",
     "symbol": "PRLE"
    },
    {
     "description": "Pillarstone Capital REIT",
     "symbol": "PRLEP"
    },
    {
     "description": "PEARL HOLDINGS ACQUISITION-A",
     "symbol": "PRLH"
    },
    {
     "description": "PEARL HOLDINGS ACQUISITION C",
     "symbol": "PRLHU"
    },
    {
     "description": "PEARL HOLDINGS ACQ -CW23",
     "symbol": "PRLHW"
    },
    {
     "description": "PIRELLI & C SPA - UNSP ADR",
     "symbol": "PRLLY"
    },
    {
     "description": "PROLOGIC MANAGEMENT SYSTEMS",
     "symbol": "PRLO"
    },
    {
     "description": "PARALLAX HEALTH SCIENCES INC",
     "symbol": "PRLX"
    },
    {
     "description": "PERIMETER SOLUTIONS SA",
     "symbol": "PRM"
    },
    {
     "description": "PURPOSE MULTI-ASSET INCOME F",
     "symbol": "PRMAF"
    },
    {
     "description": "PRIMEMD INC",
     "symbol": "PRMD"
    },
    {
     "description": "PROCONCEPT MARKETING GROUP",
     "symbol": "PRMK"
    },
    {
     "description": "PREMIER AFRICAN MINERALS LTD",
     "symbol": "PRMMF"
    },
    {
     "description": "PRIME MINING CORP",
     "symbol": "PRMNF"
    },
    {
     "description": "PROM RESOURCES INC",
     "symbol": "PRMO"
    },
    {
     "description": "PARAMOUNT RESOURCES LTD -A",
     "symbol": "PRMRF"
    },
    {
     "description": "PRIMO WATER CORP",
     "symbol": "PRMW"
    },
    {
     "description": "PRIMARY BK",
     "symbol": "PRMY"
    },
    {
     "description": "INVESCO DWA INDUSTRIALS MOME",
     "symbol": "PRN"
    },
    {
     "description": "ALTERITY THERAPEUTICS LTD",
     "symbol": "PRNAF"
    },
    {
     "description": "PERNOD RICARD SA - SPON ADR",
     "symbol": "PRNDY"
    },
    {
     "description": "PRINTRON INC",
     "symbol": "PRNI"
    },
    {
     "description": "THE 3D PRINTING ETF",
     "symbol": "PRNT"
    },
    {
     "description": "PROS HOLDINGS INC",
     "symbol": "PRO"
    },
    {
     "description": "PROACTIS HOLDINGS PLC",
     "symbol": "PROAF"
    },
    {
     "description": "PROBE METALS INC",
     "symbol": "PROBF"
    },
    {
     "description": "PROCAPS GROUP SA",
     "symbol": "PROC"
    },
    {
     "description": "PROCAPS GROUP SA -CW26",
     "symbol": "PROCW"
    },
    {
     "description": "PROFOUND MEDICAL CORP",
     "symbol": "PROF"
    },
    {
     "description": "PROGENITY INC",
     "symbol": "PROG"
    },
    {
     "description": "PROPEL MEDIA INC",
     "symbol": "PROM"
    },
    {
     "description": "PROSUS NV",
     "symbol": "PROSF"
    },
    {
     "description": "PROSUS NV -SPON ADR",
     "symbol": "PROSY"
    },
    {
     "description": "PROTEONOMIX INC",
     "symbol": "PROT"
    },
    {
     "description": "PROVIDENT FINANCIAL HLDGS",
     "symbol": "PROV"
    },
    {
     "description": "CC NEUBERGER PRINCIPAL II-A",
     "symbol": "PRPB"
    },
    {
     "description": "CC NEUBERGER PRINCIPAL HOLDI",
     "symbol": "PRPB.U"
    },
    {
     "description": "CC NEUBERGER PRINCIPAL -CW25",
     "symbol": "PRPB.WS"
    },
    {
     "description": "CC NEUBERGER PRINCIPAL III-A",
     "symbol": "PRPC"
    },
    {
     "description": "CC NEUBERGER PRINCIPAL HOLDI",
     "symbol": "PRPC.U"
    },
    {
     "description": "CC NEUBERGER PRINCIPAL -CW27",
     "symbol": "PRPC.WS"
    },
    {
     "description": "PROPHASE LABS INC",
     "symbol": "PRPH"
    },
    {
     "description": "PERPETUAL INDUSTRIES INC",
     "symbol": "PRPI"
    },
    {
     "description": "PURPLE INNOVATION INC",
     "symbol": "PRPL"
    },
    {
     "description": "PROTEK CAPITAL INC",
     "symbol": "PRPM"
    },
    {
     "description": "PRECIPIO INC",
     "symbol": "PRPO"
    },
    {
     "description": "PURPLEBRICKS GROUP PLC",
     "symbol": "PRPPF"
    },
    {
     "description": "PRAIRIE PROVIDENT RES INC",
     "symbol": "PRPRF"
    },
    {
     "description": "PROPELLUS INC",
     "symbol": "PRPS"
    },
    {
     "description": "PROQR THERAPEUTICS NV",
     "symbol": "PRQR"
    },
    {
     "description": "PROCREDIT HOLDING AG & CO KG",
     "symbol": "PRRCF"
    },
    {
     "description": "PRAETORIAN PROPERTY INC",
     "symbol": "PRRE"
    },
    {
     "description": "PREMIER FOODS PLC-UNSPON ADR",
     "symbol": "PRRFY"
    },
    {
     "description": "PREMIUM INCOME CORPORATION-A",
     "symbol": "PRRMF"
    },
    {
     "description": "PROSPECT RIDGE RESOURCES COR",
     "symbol": "PRRSF"
    },
    {
     "description": "IMMUTEP LTD",
     "symbol": "PRRUF"
    },
    {
     "description": "PROVIDENCE GOLD MINES INC",
     "symbol": "PRRVF"
    },
    {
     "description": "PARK LAWN CORP",
     "symbol": "PRRWF"
    },
    {
     "description": "PLANET RESOURCE RECOVERY INC",
     "symbol": "PRRY"
    },
    {
     "description": "PRUDENTIAL FINANCIAL INC",
     "symbol": "PRS"
    },
    {
     "description": "PROSAFE SE",
     "symbol": "PRSEF"
    },
    {
     "description": "PROSAFE SE-UNSP ADR",
     "symbol": "PRSEY"
    },
    {
     "description": "PORTSMOUTH SQUARE INC",
     "symbol": "PRSI"
    },
    {
     "description": "PERSONAS SOCIAL INC",
     "symbol": "PRSNF"
    },
    {
     "description": "PERASO INC",
     "symbol": "PRSO"
    },
    {
     "description": "PROSPECTOR CAPITAL CORP-CL A",
     "symbol": "PRSR"
    },
    {
     "description": "PROSPECTOR CAPITAL CORP",
     "symbol": "PRSRU"
    },
    {
     "description": "PROSPECTOR CAPITAL CORP-CW25",
     "symbol": "PRSRW"
    },
    {
     "description": "PROSPECT RESOURCES LTD",
     "symbol": "PRSTF"
    },
    {
     "description": "PERMROCK ROYALTY TRUST",
     "symbol": "PRT"
    },
    {
     "description": "PROTHENA CORP PLC",
     "symbol": "PRTA"
    },
    {
     "description": "PURETECH HEALTH PLC - ADR",
     "symbol": "PRTC"
    },
    {
     "description": "PETRO MATAD LTD",
     "symbol": "PRTDF"
    },
    {
     "description": "PORTAGE BIOTECH INC",
     "symbol": "PRTG"
    },
    {
     "description": "PRIORITY TECHNOLOGY HOLDINGS",
     "symbol": "PRTH"
    },
    {
     "description": "PRIORITY TECHNOLOGY HOLDINGS",
     "symbol": "PRTHU"
    },
    {
     "description": "PRIORITY TECHNOLOGY HO-CW20",
     "symbol": "PRTHW"
    },
    {
     "description": "PORT INC",
     "symbol": "PRTIF"
    },
    {
     "description": "PARATEK PHARMACEUTICALS INC",
     "symbol": "PRTK"
    },
    {
     "description": "PRIME TIME HOLDINGS INC",
     "symbol": "PRTM"
    },
    {
     "description": "PRTS CAM PTE LTD-TOKEN",
     "symbol": "PRTOF"
    },
    {
     "description": "PRECICION TRIM INC",
     "symbol": "PRTR"
    },
    {
     "description": "CARPARTS.COM INC",
     "symbol": "PRTS"
    },
    {
     "description": "PROTECT PHARMACEUTICAL CORP",
     "symbol": "PRTT"
    },
    {
     "description": "PARTY CITY HOLDCO INC",
     "symbol": "PRTY"
    },
    {
     "description": "PRUDENTIAL FINANCIAL INC",
     "symbol": "PRU"
    },
    {
     "description": "PRIVIA HEALTH GROUP INC",
     "symbol": "PRVA"
    },
    {
     "description": "PROVENTION BIO INC",
     "symbol": "PRVB"
    },
    {
     "description": "PREVECEUTICAL MEDICAL INC",
     "symbol": "PRVCF"
    },
    {
     "description": "PROVINCE RESOURCES LIMITED",
     "symbol": "PRVRF"
    },
    {
     "description": "PREVU INC",
     "symbol": "PRVU"
    },
    {
     "description": "PRODWAYS GROUP SA",
     "symbol": "PRWYF"
    },
    {
     "description": "PERNIX GROUP INC",
     "symbol": "PRXG"
    },
    {
     "description": "PREMIER EXHIBITIONS INC",
     "symbol": "PRXIQ"
    },
    {
     "description": "PROXIM WIRELESS CORP",
     "symbol": "PRXM"
    },
    {
     "description": "PURE EXTRACTS TECHNOLOGIES C",
     "symbol": "PRXTF"
    },
    {
     "description": "PARADOX INTERACTIVE AB",
     "symbol": "PRXXF"
    },
    {
     "description": "RAMAYANA LESTARI SENTOSA TBK",
     "symbol": "PRYBF"
    },
    {
     "description": "WARREGO ENERGY LTD",
     "symbol": "PRYGF"
    },
    {
     "description": "PRYSMIAN SPA",
     "symbol": "PRYMF"
    },
    {
     "description": "PRYSMIAN SPA-UNSPONSOREE ADR",
     "symbol": "PRYMY"
    },
    {
     "description": "BACKSTAGEPLAY INC",
     "symbol": "PRYNF"
    },
    {
     "description": "BOUNDARY GOLD & COPPER MININ",
     "symbol": "PRZFF"
    },
    {
     "description": "PRISM TECHNOLOGIES GROUP INC",
     "symbol": "PRZM"
    },
    {
     "description": "PUBLIC STORAGE",
     "symbol": "PSA"
    },
    {
     "description": "PUBLIC STORAGE",
     "symbol": "PSA.PRF"
    },
    {
     "description": "PUBLIC STORAGE",
     "symbol": "PSA.PRG"
    },
    {
     "description": "PUBLIC STORAGE",
     "symbol": "PSA.PRH"
    },
    {
     "description": "PUBLIC STORAGE",
     "symbol": "PSA.PRI"
    },
    {
     "description": "PUBLIC STORAGE",
     "symbol": "PSA.PRJ"
    },
    {
     "description": "PUBLIC STORAGE",
     "symbol": "PSA.PRK"
    },
    {
     "description": "PUBLIC STORAGE",
     "symbol": "PSA.PRL"
    },
    {
     "description": "PUBLIC STORAGE",
     "symbol": "PSA.PRM"
    },
    {
     "description": "PUBLIC STORAGE",
     "symbol": "PSA.PRN"
    },
    {
     "description": "PUBLIC STORAGE",
     "symbol": "PSA.PRO"
    },
    {
     "description": "PUBLIC STORAGE",
     "symbol": "PSA.PRP"
    },
    {
     "description": "PUBLIC STORAGE",
     "symbol": "PSA.PRQ"
    },
    {
     "description": "PUBLIC STORAGE",
     "symbol": "PSA.PRR"
    },
    {
     "description": "PUBLIC STORAGE",
     "symbol": "PSA.PRS"
    },
    {
     "description": "PROPERTY SOLUTIONS ACQUISI-A",
     "symbol": "PSAG"
    },
    {
     "description": "PROPERTY SOLUTIONS ACQUISITI",
     "symbol": "PSAGU"
    },
    {
     "description": "PROPERTY SOLUTIONS A -CW26",
     "symbol": "PSAGW"
    },
    {
     "description": "SUMMARECON AGUNG TBK PT",
     "symbol": "PSAHF"
    },
    {
     "description": "PS BUSINESS PARKS INC\/MD",
     "symbol": "PSB"
    },
    {
     "description": "PS BUSINESS PARKS INC",
     "symbol": "PSB.PRX"
    },
    {
     "description": "PS BUSINESS PARKS INC",
     "symbol": "PSB.PRY"
    },
    {
     "description": "PS BUSINESS PARKS INC",
     "symbol": "PSB.PRZ"
    },
    {
     "description": "PACIFIC STATE BANCORP",
     "symbol": "PSBC"
    },
    {
     "description": "POSTAL SAVINGS BANK OF CHI-H",
     "symbol": "PSBKF"
    },
    {
     "description": "PSB HOLDING CORP",
     "symbol": "PSBP"
    },
    {
     "description": "PSB HOLDINGS INC (WI)",
     "symbol": "PSBQ"
    },
    {
     "description": "PRINCIPAL US SMALL-CAP MULTI",
     "symbol": "PSC"
    },
    {
     "description": "PASCAL BIOSCIENCES INC",
     "symbol": "PSCBF"
    },
    {
     "description": "INVESCO S&P SMALLCAP CONSUME",
     "symbol": "PSCC"
    },
    {
     "description": "INVESCO S&P SMALLCAP CONSUME",
     "symbol": "PSCD"
    },
    {
     "description": "INVESCO S&P SMALLCAP ENERGY",
     "symbol": "PSCE"
    },
    {
     "description": "INVESCO S&P SMALLCAP FINANCI",
     "symbol": "PSCF"
    },
    {
     "description": "INVESCO S&P SMALLCAP HEALTH",
     "symbol": "PSCH"
    },
    {
     "description": "INVESCO S&P SMALLCAP INDUSTR",
     "symbol": "PSCI"
    },
    {
     "description": "PACER SWAN SOS CONSERVATIVE",
     "symbol": "PSCJ"
    },
    {
     "description": "INVESCO S&P SMALLCAP MATERIA",
     "symbol": "PSCM"
    },
    {
     "description": "PROTOSOURCE CORP",
     "symbol": "PSCO"
    },
    {
     "description": "PACER SWAN SOS CONS OCT ETF",
     "symbol": "PSCQ"
    },
    {
     "description": "PROTO SCRIPT PHARMACEUTICAL",
     "symbol": "PSCR"
    },
    {
     "description": "INVESCO S&P SMALLCAP INFORMA",
     "symbol": "PSCT"
    },
    {
     "description": "INVESCO S&P S C U&C SER ETF",
     "symbol": "PSCU"
    },
    {
     "description": "PACER SWAN SOS CONSERV APR",
     "symbol": "PSCW"
    },
    {
     "description": "PACER SWAN SOS CONSERVATIVE",
     "symbol": "PSCX"
    },
    {
     "description": "GAMING REALMS PLC",
     "symbol": "PSDMF"
    },
    {
     "description": "ADVISORSHARES POS DYN CANNAB",
     "symbol": "PSDN"
    },
    {
     "description": "POSEIDON NICKEL LTD",
     "symbol": "PSDNF"
    },
    {
     "description": "PROSPECT CAPITAL CORP",
     "symbol": "PSEC"
    },
    {
     "description": "PROSPECT CAPITAL CORP",
     "symbol": "PSEC.PRA"
    },
    {
     "description": "INNOVATOR U.S. EQUITY POWER",
     "symbol": "PSEP"
    },
    {
     "description": "PRINCIPAL QUALITY ETF",
     "symbol": "PSET"
    },
    {
     "description": "COHEN & STEERS SELECT PREFER",
     "symbol": "PSF"
    },
    {
     "description": "PACER SWAN SOS FLEX JANUARY",
     "symbol": "PSFD"
    },
    {
     "description": "PAYSAFE LTD",
     "symbol": "PSFE"
    },
    {
     "description": "PAYSAFE LTD -CW26",
     "symbol": "PSFE.WS"
    },
    {
     "description": "PACER SWAN SOS FUND OF FUNDS",
     "symbol": "PSFF"
    },
    {
     "description": "PACER SWAN SOS FLEX JULY ETF",
     "symbol": "PSFJ"
    },
    {
     "description": "PACER SWAN SOS FLEX APRIL",
     "symbol": "PSFM"
    },
    {
     "description": "PACER SWAN SOS FLEX OCT ETF",
     "symbol": "PSFO"
    },
    {
     "description": "POWERSAFE TECHNOLOGY CORP",
     "symbol": "PSFT"
    },
    {
     "description": "PRECIOUS SHIPPING PCL-FORGN",
     "symbol": "PSGFF"
    },
    {
     "description": "PERFECT SOLUTIONS GROUP INC",
     "symbol": "PSGI"
    },
    {
     "description": "PERSHING RESOURCES CO INC",
     "symbol": "PSGR"
    },
    {
     "description": "SEMEN INDONESIA PERSERO TBK",
     "symbol": "PSGTF"
    },
    {
     "description": "SEMEN INDONE-UNSPON ADR",
     "symbol": "PSGTY"
    },
    {
     "description": "PERFORMANCE SHIPPING INC",
     "symbol": "PSHG"
    },
    {
     "description": "PETROSHALE INC",
     "symbol": "PSHIF"
    },
    {
     "description": "PRO-SHIP INC",
     "symbol": "PSHPF"
    },
    {
     "description": "PERSHING SQUARE HOLDINGS LTD",
     "symbol": "PSHZF"
    },
    {
     "description": "INVESCO DYNAMIC SEMICONDUCTO",
     "symbol": "PSI"
    },
    {
     "description": "ADVISORSHARES PSYCHEDELICS",
     "symbol": "PSIL"
    },
    {
     "description": "PROFILE SOLUTIONS INC",
     "symbol": "PSIQ"
    },
    {
     "description": "POWER SOLUTIONS INTERNATIONA",
     "symbol": "PSIX"
    },
    {
     "description": "INVESCO DYNAMIC SOFTWARE ETF",
     "symbol": "PSJ"
    },
    {
     "description": "SPDR ICE PREFERRED SECURITIE",
     "symbol": "PSK"
    },
    {
     "description": "POLSKI KONCERN NAFTOWY ORLEN",
     "symbol": "PSKOF"
    },
    {
     "description": "PROTECTOR FORSIKRING ASA",
     "symbol": "PSKRF"
    },
    {
     "description": "PHILIPPINE STOCK EXCHANGE IN",
     "symbol": "PSKXF"
    },
    {
     "description": "INVESCO DWA CONSUMER STAPLES",
     "symbol": "PSL"
    },
    {
     "description": "SPROTT PHYSICAL SILVER TRUST",
     "symbol": "PSLV"
    },
    {
     "description": "INVESCO BALANCED MULTI-ASSET",
     "symbol": "PSMB"
    },
    {
     "description": "INVESCO CONSERVATIVE MULTI-A",
     "symbol": "PSMC"
    },
    {
     "description": "PACER SWAN SOS MODERATE JANU",
     "symbol": "PSMD"
    },
    {
     "description": "INVESCO GROWTH MULTI-ASSET A",
     "symbol": "PSMG"
    },
    {
     "description": "PACER SWAN SOS MODERATE JULY",
     "symbol": "PSMJ"
    },
    {
     "description": "INVESCO MODERATELY CONSERVAT",
     "symbol": "PSMM"
    },
    {
     "description": "PERSIMMON PLC",
     "symbol": "PSMMF"
    },
    {
     "description": "PERSIMMON PLC-UNSPON ADR",
     "symbol": "PSMMY"
    },
    {
     "description": "PACER SWAN SOS MOD OCT ETF",
     "symbol": "PSMO"
    },
    {
     "description": "PACER SWAN SOS MODERATE APR",
     "symbol": "PSMR"
    },
    {
     "description": "PRICESMART INC",
     "symbol": "PSMT"
    },
    {
     "description": "SINAR MAS MULTIARTHA PT",
     "symbol": "PSMUF"
    },
    {
     "description": "PARSONS CORP",
     "symbol": "PSN"
    },
    {
     "description": "PERSONALIS INC",
     "symbol": "PSNL"
    },
    {
     "description": "PEARSON PLC-SPONSORED ADR",
     "symbol": "PSO"
    },
    {
     "description": "PEARSON PLC",
     "symbol": "PSORF"
    },
    {
     "description": "INVESCO GLOBAL LISTED PRIVAT",
     "symbol": "PSP"
    },
    {
     "description": "POST HOLDINGS PARTNERING -A",
     "symbol": "PSPC"
    },
    {
     "description": "POST HOLDINGS PARTNERING COR",
     "symbol": "PSPC.U"
    },
    {
     "description": "POST HOLDINGS PARTNERI -CW23",
     "symbol": "PSPC.WS"
    },
    {
     "description": "PSP SWISS PROPERTY AG-REG",
     "symbol": "PSPSF"
    },
    {
     "description": "3POWER ENERGY GROUP",
     "symbol": "PSPW"
    },
    {
     "description": "PROSHARES SHORT QQQ",
     "symbol": "PSQ"
    },
    {
     "description": "INVESCO ACTIVE US REAL ESTAT",
     "symbol": "PSR"
    },
    {
     "description": "VALIANT EAGLE INC",
     "symbol": "PSRU"
    },
    {
     "description": "KEON CAPITAL INC",
     "symbol": "PSRVF"
    },
    {
     "description": "SURYA SEMESTA INTERNUSA PT",
     "symbol": "PSRYF"
    },
    {
     "description": "PSG GROUP LTD",
     "symbol": "PSSGF"
    },
    {
     "description": "PRESSANCE CORP",
     "symbol": "PSSKF"
    },
    {
     "description": "PRESS METAL ALUMINIUM HOLDIN",
     "symbol": "PSSMF"
    },
    {
     "description": "PASSUR AEROSPACE INC",
     "symbol": "PSSR"
    },
    {
     "description": "PUISSANT INDUSTRIES INC",
     "symbol": "PSSS"
    },
    {
     "description": "PSI SOFTWARE AG",
     "symbol": "PSSWF"
    },
    {
     "description": "PROSHARES ULTRASHORT 7-10 YR",
     "symbol": "PST"
    },
    {
     "description": "PURE STORAGE INC - CLASS A",
     "symbol": "PSTG"
    },
    {
     "description": "PERSHING SQUARE TONTINE -A",
     "symbol": "PSTH"
    },
    {
     "description": "PERSHING SQUARE TONTINE -WS",
     "symbol": "PSTH.WS"
    },
    {
     "description": "PLURISTEM THERAPEUTICS INC",
     "symbol": "PSTI"
    },
    {
     "description": "POSTAL REALTY TRUST INC- A",
     "symbol": "PSTL"
    },
    {
     "description": "POSTNL NV-ADR",
     "symbol": "PSTNY"
    },
    {
     "description": "POWERSTORM HOLDINGS INC",
     "symbol": "PSTO"
    },
    {
     "description": "INNOVATOR PWR BUFF SU ST ETF",
     "symbol": "PSTP"
    },
    {
     "description": "POSTROCK ENERGY CORP",
     "symbol": "PSTRQ"
    },
    {
     "description": "PRESCIENT THERAPEUTICS LTD",
     "symbol": "PSTTF"
    },
    {
     "description": "PLUS THERAPEUTICS INC",
     "symbol": "PSTV"
    },
    {
     "description": "POSTAL SAVINGS BANK-UNSP ADR",
     "symbol": "PSTVY"
    },
    {
     "description": "POSEIDA THERAPEUTICS INC",
     "symbol": "PSTX"
    },
    {
     "description": "PETROSUN INC",
     "symbol": "PSUD"
    },
    {
     "description": "ALAM SUTERA REALTY TBK PT",
     "symbol": "PSUTF"
    },
    {
     "description": "PRISM SOFTWARE CORP",
     "symbol": "PSWR"
    },
    {
     "description": "PRINCIPAL SOLAR INC",
     "symbol": "PSWW"
    },
    {
     "description": "PHILLIPS 66",
     "symbol": "PSX"
    },
    {
     "description": "PASINEX RESOURCES LTD",
     "symbol": "PSXRF"
    },
    {
     "description": "DEFIANCE NEXT GEN ALTERED EX",
     "symbol": "PSY"
    },
    {
     "description": "PSYBIO THERAPEUTICS CORP",
     "symbol": "PSYBF"
    },
    {
     "description": "PSYC CORP",
     "symbol": "PSYC"
    },
    {
     "description": "PSYCHED WELLNESS LTD",
     "symbol": "PSYCF"
    },
    {
     "description": "PSYENCE GROUP INC",
     "symbol": "PSYGF"
    },
    {
     "description": "PSYK ETF",
     "symbol": "PSYK"
    },
    {
     "description": "PARADIGM SYSTEM SOLUTIONS IN",
     "symbol": "PSYS"
    },
    {
     "description": "PASON SYSTEMS INC",
     "symbol": "PSYTF"
    },
    {
     "description": "PKO BANK POLSKI SA",
     "symbol": "PSZKF"
    },
    {
     "description": "PKO BANK POLSKI-UNSPON ADR",
     "symbol": "PSZKY"
    },
    {
     "description": "PRISZM INCOME FUND",
     "symbol": "PSZMF"
    },
    {
     "description": "PINTEC TECHNOLOGY HOLDINGS L",
     "symbol": "PT"
    },
    {
     "description": "COHEN & STEERS TAX-ADVANTAGE",
     "symbol": "PTA"
    },
    {
     "description": "ASTRA AGRO LESTARI TBK PT",
     "symbol": "PTABF"
    },
    {
     "description": "PTA HOLDINGS INC",
     "symbol": "PTAH"
    },
    {
     "description": "ASTRA INTERNATIONAL TBK PT",
     "symbol": "PTAIF"
    },
    {
     "description": "ASTRA INTERNATIONAL-UNSP ADR",
     "symbol": "PTAIY"
    },
    {
     "description": "PETROTAL CORP",
     "symbol": "PTALF"
    },
    {
     "description": "POTASH AMERICA INC",
     "symbol": "PTAM"
    },
    {
     "description": "PORT OF TAURANGA LTD",
     "symbol": "PTAUF"
    },
    {
     "description": "PORT OF TAURANGA-UNSPON ADR",
     "symbol": "PTAUY"
    },
    {
     "description": "ASURANSI RAMAYANA TBK PT",
     "symbol": "PTAYF"
    },
    {
     "description": "POET BIOREFINING CL A-UNIT",
     "symbol": "PTBBU"
    },
    {
     "description": "PACER TRENDPILOT US BOND ETF",
     "symbol": "PTBD"
    },
    {
     "description": "BEKASI FAJAR INDUSTRIAL ESTA",
     "symbol": "PTBFF"
    },
    {
     "description": "SURYA CITRA MEDIA PT TBK",
     "symbol": "PTBKF"
    },
    {
     "description": "BUANA LINTAS LAUTAN TBK PT",
     "symbol": "PTBLF"
    },
    {
     "description": "BANK MAYAPADA INTL TBK PT",
     "symbol": "PTBMF"
    },
    {
     "description": "BPD JAWA BARAT DAN BANTEN TB",
     "symbol": "PTBPF"
    },
    {
     "description": "BERLINA TBK PT",
     "symbol": "PTBRF"
    },
    {
     "description": "PT BANK NEGARA INDONE-UN ADR",
     "symbol": "PTBRY"
    },
    {
     "description": "POTOMAC BANCSHARES INC",
     "symbol": "PTBS"
    },
    {
     "description": "POPE & TALBOT INC",
     "symbol": "PTBTQ"
    },
    {
     "description": "PTC INC",
     "symbol": "PTC"
    },
    {
     "description": "CHANDRA ASRI PETROC-UNSP ADR",
     "symbol": "PTCAY"
    },
    {
     "description": "PURETECH HEALTH PLC",
     "symbol": "PTCHF"
    },
    {
     "description": "PETROGAS COMPANY",
     "symbol": "PTCO"
    },
    {
     "description": "PETROCORP INC",
     "symbol": "PTCP"
    },
    {
     "description": "PTC THERAPEUTICS INC",
     "symbol": "PTCT"
    },
    {
     "description": "WILMAR CAHAYA INDONESIA TBK",
     "symbol": "PTCXF"
    },
    {
     "description": "ADIRA DINAMIKA MULTI FINANCE",
     "symbol": "PTDFF"
    },
    {
     "description": "POLARITYTE INC",
     "symbol": "PTE"
    },
    {
     "description": "PLAINTREE SYSTEMS INC",
     "symbol": "PTEEF"
    },
    {
     "description": "PIONEERING TECHNOLOGY CORP",
     "symbol": "PTEFF"
    },
    {
     "description": "PEGASUS TEL INC",
     "symbol": "PTEL"
    },
    {
     "description": "PATTERSON-UTI ENERGY INC",
     "symbol": "PTEN"
    },
    {
     "description": "PROTEO INC",
     "symbol": "PTEO"
    },
    {
     "description": "PT ENSEVAL PUTERA MEGATRADIN",
     "symbol": "PTEPF"
    },
    {
     "description": "Test",
     "symbol": "PTEST"
    },
    {
     "description": "PACER TRENDPILOT EUROPEAN ET",
     "symbol": "PTEU"
    },
    {
     "description": "PACIFIC TEXTILES HOLDINGS",
     "symbol": "PTEXF"
    },
    {
     "description": "INVESCO DWA TECHNOLOGY MOMEN",
     "symbol": "PTF"
    },
    {
     "description": "TOWER BERSAMA INFRA-UNSP ADR",
     "symbol": "PTFRY"
    },
    {
     "description": "PTT GLOBAL CHEMICAL PCL-FOR",
     "symbol": "PTGCF"
    },
    {
     "description": "MEDCO ENERGI INTERNASIONAL T",
     "symbol": "PTGIF"
    },
    {
     "description": "PROTAGONIST THERAPEUTICS INC",
     "symbol": "PTGX"
    },
    {
     "description": "INVESCO DWA HEALTHCARE MOMEN",
     "symbol": "PTH"
    },
    {
     "description": "SOLUSI BANGUN INDONESIA TBK",
     "symbol": "PTHIF"
    },
    {
     "description": "HOLCIM INDONESIA TBK-UNS ADR",
     "symbol": "PTHIY"
    },
    {
     "description": "PANTHEON RESOURCES PLC",
     "symbol": "PTHRF"
    },
    {
     "description": "PT HERO SUPERMARKET",
     "symbol": "PTHSF"
    },
    {
     "description": "HEXINDO ADIPERKASA TBK PT",
     "symbol": "PTHXF"
    },
    {
     "description": "PROPTECH INVESTMENT CORP-A",
     "symbol": "PTIC"
    },
    {
     "description": "PROPTECH INVESTMENT CORP II",
     "symbol": "PTICU"
    },
    {
     "description": "PROPTECH INV CORP 2 -CW27",
     "symbol": "PTICW"
    },
    {
     "description": "PACER TRENDPILOT INTL ETF",
     "symbol": "PTIN"
    },
    {
     "description": "INDOSAT TBK PT",
     "symbol": "PTITF"
    },
    {
     "description": "PIMCO TACTICAL INCOME FUND",
     "symbol": "PTIUF"
    },
    {
     "description": "PROTAGENIC THERAPEUTICS INC",
     "symbol": "PTIX"
    },
    {
     "description": "PROTAGENIC THERAPEUTIC -CW25",
     "symbol": "PTIXW"
    },
    {
     "description": "INDO TAMBANGRAYA MEGAH TBK P",
     "symbol": "PTIZF"
    },
    {
     "description": "JASA MARGA (PERSERO) TBK PT",
     "symbol": "PTJSF"
    },
    {
     "description": "JASA MARGA (PERSERO) TB-ADR",
     "symbol": "PTJSY"
    },
    {
     "description": "JAYA REAL PROPERTY PT",
     "symbol": "PTJYF"
    },
    {
     "description": "KALBE FARMA TBK PT",
     "symbol": "PTKFF"
    },
    {
     "description": "KALBE FARMA PT-UNSPONS ADR",
     "symbol": "PTKFY"
    },
    {
     "description": "PACER TRENDPILOT US LARGE CA",
     "symbol": "PTLC"
    },
    {
     "description": "PETLIFE PHARMACEUTICALS INC",
     "symbol": "PTLF"
    },
    {
     "description": "LIPPO KARAWACI TBK PT",
     "symbol": "PTLKF"
    },
    {
     "description": "PORTILLO'S INC-CL A",
     "symbol": "PTLO"
    },
    {
     "description": "LIPPO CIKARANG PT",
     "symbol": "PTLPF"
    },
    {
     "description": "PACER TRENDPILOT US MID CAP",
     "symbol": "PTMC"
    },
    {
     "description": "MEDIA NUSANTARA CITRA-ADR",
     "symbol": "PTMEY"
    },
    {
     "description": "PLATINUM ASSET MANAGEMENT",
     "symbol": "PTMGF"
    },
    {
     "description": "MANDOM INDONESIA TBK PT",
     "symbol": "PTMIF"
    },
    {
     "description": "PORTMAN RIDGE FINANCE CORP",
     "symbol": "PTMN"
    },
    {
     "description": "JACCS MITRA PINASTHIKA MUSTI",
     "symbol": "PTMRF"
    },
    {
     "description": "MATAHARI DEPARTMENT ST-ADR",
     "symbol": "PTMSY"
    },
    {
     "description": "MAYORA INDAH PT",
     "symbol": "PTMYF"
    },
    {
     "description": "PALATIN TECHNOLOGIES INC",
     "symbol": "PTN"
    },
    {
     "description": "BANK CIMB NIAGA TBK PT",
     "symbol": "PTNAF"
    },
    {
     "description": "VALE INDONESIA TBK",
     "symbol": "PTNDF"
    },
    {
     "description": "VALE INDONESIA TB-UNSPON ADR",
     "symbol": "PTNDY"
    },
    {
     "description": "INDO KORDSA TBK PT",
     "symbol": "PTNKF"
    },
    {
     "description": "PACER TRENDPILOT 100 ETF",
     "symbol": "PTNQ"
    },
    {
     "description": "PARTNER COMMUNICATIONS-ADR",
     "symbol": "PTNR"
    },
    {
     "description": "PARTNER COMMUNICATIONS CO",
     "symbol": "PTNRF"
    },
    {
     "description": "PLATINA RESOURCES LTD",
     "symbol": "PTNUF"
    },
    {
     "description": "PARCELPAL LOGISTICS INC",
     "symbol": "PTNYF"
    },
    {
     "description": "PIERIDAE ENERGY LTD",
     "symbol": "PTOAF"
    },
    {
     "description": "PINE TECHNOLOGY ACQUISI-CL A",
     "symbol": "PTOC"
    },
    {
     "description": "PINE TECHNOLOGY ACQUISITION",
     "symbol": "PTOCU"
    },
    {
     "description": "PINE TECHNOLOGY ACQ A -CW28",
     "symbol": "PTOCW"
    },
    {
     "description": "PETROTECH OIL & GAS INC",
     "symbol": "PTOG"
    },
    {
     "description": "PLASTIC2OIL INC",
     "symbol": "PTOI"
    },
    {
     "description": "PELOTON INTERACTIVE INC-A",
     "symbol": "PTON"
    },
    {
     "description": "PEER TO PEER NETWORK",
     "symbol": "PTOP"
    },
    {
     "description": "P2 SOLAR INC",
     "symbol": "PTOS"
    },
    {
     "description": "PATRIOT ONE TECHNOLOGIES INC",
     "symbol": "PTOTF"
    },
    {
     "description": "PREMIER TECHNOLOGY PCL",
     "symbol": "PTPBF"
    },
    {
     "description": "PETROS PHARMACEUTICALS INC",
     "symbol": "PTPI"
    },
    {
     "description": "CHANDRA ASRI PETROCHEMICAL",
     "symbol": "PTPIF"
    },
    {
     "description": "PAKUWON JATI TBK PT",
     "symbol": "PTPKF"
    },
    {
     "description": "PURADELTA LESTARI TBK PT",
     "symbol": "PTPLF"
    },
    {
     "description": "PETROCHINA CO LTD -ADR",
     "symbol": "PTR"
    },
    {
     "description": "PROTERRA INC",
     "symbol": "PTRA"
    },
    {
     "description": "PGIM TOTAL RETURN BOND ETF",
     "symbol": "PTRB"
    },
    {
     "description": "PETRO RIVER OIL CORP",
     "symbol": "PTRC"
    },
    {
     "description": "ROK RESOURCES INC",
     "symbol": "PTRDF"
    },
    {
     "description": "PETROMINERALS CORP",
     "symbol": "PTRO"
    },
    {
     "description": "POINTERRA LTD",
     "symbol": "PTRRF"
    },
    {
     "description": "PETRO RIO SA UNSP - ADR",
     "symbol": "PTRRY"
    },
    {
     "description": "PARTNERS BANCORP",
     "symbol": "PTRS"
    },
    {
     "description": "PETRUS RESOURCES LTD",
     "symbol": "PTRUF"
    },
    {
     "description": "PETRO VIKING ENERGY INC",
     "symbol": "PTRVF"
    },
    {
     "description": "PTS INC",
     "symbol": "PTSH"
    },
    {
     "description": "P.A.M. TRANSPORTATION SVCS",
     "symbol": "PTSI"
    },
    {
     "description": "PARTNERS REAL ESTATE INVESTM",
     "symbol": "PTSRF"
    },
    {
     "description": "SAWIT SUMBERMAS SARANA TBK P",
     "symbol": "PTSWF"
    },
    {
     "description": "TUNAS BARU LAMPUNG TBK PT",
     "symbol": "PTTBF"
    },
    {
     "description": "PACT GROUP HOLDINGS LTD",
     "symbol": "PTTCF"
    },
    {
     "description": "PURE TRANSIT TECHNOLOGIES IN",
     "symbol": "PTTL"
    },
    {
     "description": "TIMAH TBK PT",
     "symbol": "PTTMF"
    },
    {
     "description": "PATTEN ENERGY SOLUTIONS GROU",
     "symbol": "PTTN"
    },
    {
     "description": "TOTAL BANGUN PERSADA",
     "symbol": "PTTOF"
    },
    {
     "description": "PTT PCL",
     "symbol": "PTTPF"
    },
    {
     "description": "PALMETTO REAL ESTATE TRUST",
     "symbol": "PTTTS"
    },
    {
     "description": "ORANGE POLSKA SA",
     "symbol": "PTTWF"
    },
    {
     "description": "PUREPOINT URANIUM GROUP INC",
     "symbol": "PTUUF"
    },
    {
     "description": "PACTIV EVERGREEN INC",
     "symbol": "PTVE"
    },
    {
     "description": "PETRO-VICTORY ENERGY CORP",
     "symbol": "PTVRF"
    },
    {
     "description": "ARWANA CITRAMULIA TBK PT",
     "symbol": "PTWCF"
    },
    {
     "description": "WIJAYA KARYA BETON TBK PT",
     "symbol": "PTWJF"
    },
    {
     "description": "XL AXIATA TBK PT-ADR",
     "symbol": "PTXKY"
    },
    {
     "description": "PTT EXPLORATION & PROD-FOR",
     "symbol": "PTXLF"
    },
    {
     "description": "PIMCO CORPORATE & INCOME OPP",
     "symbol": "PTY"
    },
    {
     "description": "PHOTOZOU HOLDINGS INC",
     "symbol": "PTZH"
    },
    {
     "description": "PATRIZIA AG",
     "symbol": "PTZIF"
    },
    {
     "description": "DOSNI ROHA INDONESIA TBK PT",
     "symbol": "PTZZF"
    },
    {
     "description": "PUREBASE CORP",
     "symbol": "PUBC"
    },
    {
     "description": "PUBLICIS GROUPE-ADR",
     "symbol": "PUBGY"
    },
    {
     "description": "PUBMATIC INC-CLASS A",
     "symbol": "PUBM"
    },
    {
     "description": "PANCONTINENTAL RESOURCES COR",
     "symbol": "PUCCF"
    },
    {
     "description": "GOAL ACQUISITIONS CORP",
     "symbol": "PUCK"
    },
    {
     "description": "GOAL ACQUISITIONS CORP",
     "symbol": "PUCKU"
    },
    {
     "description": "GOAL ACQUISITIONS CORP-CW",
     "symbol": "PUCKW"
    },
    {
     "description": "PUDA COAL INC",
     "symbol": "PUDA"
    },
    {
     "description": "PURIFLOH LTD",
     "symbol": "PUFLF"
    },
    {
     "description": "PUGET TECHNOLOGIES INC",
     "symbol": "PUGE"
    },
    {
     "description": "INVESCO DWA UTILITIES MOMENT",
     "symbol": "PUI"
    },
    {
     "description": "PRUDENTIAL PLC-ADR",
     "symbol": "PUK"
    },
    {
     "description": "PRUDENTIAL PLC",
     "symbol": "PUKPF"
    },
    {
     "description": "PULMATRIX INC",
     "symbol": "PULM"
    },
    {
     "description": "PGIM ULTRA SHORT BOND ETF",
     "symbol": "PULS"
    },
    {
     "description": "PROUROCARE MEDICAL INC",
     "symbol": "PUMD"
    },
    {
     "description": "PROPETRO HOLDING CORP",
     "symbol": "PUMP"
    },
    {
     "description": "PUMA SE - UNSPONSORED ADR",
     "symbol": "PUMSY"
    },
    {
     "description": "SUBVERSIVE METAVERSE ETF",
     "symbol": "PUNK"
    },
    {
     "description": "PROMOTORA Y OPERADORA-ADR",
     "symbol": "PUODY"
    },
    {
     "description": "PUBLIC POWER CORP",
     "symbol": "PUPOF"
    },
    {
     "description": "PHARMACOLOG I UPPSALA AB",
     "symbol": "PUPPF"
    },
    {
     "description": "PICK-UPS PLUS INC",
     "symbol": "PUPS"
    },
    {
     "description": "PURATION INC",
     "symbol": "PURA"
    },
    {
     "description": "PURE BIOSCIENCE INC",
     "symbol": "PURE"
    },
    {
     "description": "PURTHANOL RESOURCES LTD",
     "symbol": "PURT"
    },
    {
     "description": "PURERAY CORP",
     "symbol": "PURY"
    },
    {
     "description": "PUSHFOR INVESTMENTS INC",
     "symbol": "PUSOF"
    },
    {
     "description": "UNITED TRACTORS TBK PT",
     "symbol": "PUTKF"
    },
    {
     "description": "UNITED TRACTORS-UNSPON ADR",
     "symbol": "PUTKY"
    },
    {
     "description": "PTT PCL-NVDR",
     "symbol": "PUTRF"
    },
    {
     "description": "PTT PCL-UNSP ADR",
     "symbol": "PUTRY"
    },
    {
     "description": "WISDOMTREE CBOE S&P 500 PTWT",
     "symbol": "PUTW"
    },
    {
     "description": "PUMA EXPLORATION INC",
     "symbol": "PUXPF"
    },
    {
     "description": "PUYI INC - ADR",
     "symbol": "PUYI"
    },
    {
     "description": "PRIMAVERA CAPITAL ACQUISIT-A",
     "symbol": "PV"
    },
    {
     "description": "PRIMAVERA CAPITAL ACQUISITIO",
     "symbol": "PV.U"
    },
    {
     "description": "PRIMAVERA CAP ACQ CL A -CW26",
     "symbol": "PV.WS"
    },
    {
     "description": "PUTNAM FOCUSED LRG CAP VALUE",
     "symbol": "PVAL"
    },
    {
     "description": "PORVAIR PLC",
     "symbol": "PVARF"
    },
    {
     "description": "PROVIDENT BANCORP INC",
     "symbol": "PVBC"
    },
    {
     "description": "PACIFIC VALLEY BANCORP",
     "symbol": "PVBK"
    },
    {
     "description": "PROVECTUS BIOPHARMACEUTICA-A",
     "symbol": "PVCT"
    },
    {
     "description": "PROVIDENCE RESOURCES PLC",
     "symbol": "PVDRF"
    },
    {
     "description": "PACIFIC VEGAS GLOBAL STRATEG",
     "symbol": "PVEG"
    },
    {
     "description": "PRESS VENTURES INC",
     "symbol": "PVEN"
    },
    {
     "description": "Pretium Resources Inc",
     "symbol": "PVG"
    },
    {
     "description": "PROVENANCE GOLD CORP\/CA",
     "symbol": "PVGDF"
    },
    {
     "description": "PVH CORP",
     "symbol": "PVH"
    },
    {
     "description": "INVESCO VRDO TAX-FREE ETF",
     "symbol": "PVI"
    },
    {
     "description": "PERMIANVILLE ROYALTY TRUST",
     "symbol": "PVL"
    },
    {
     "description": "BEIJING ENERGY INTERNATIONAL",
     "symbol": "PVLTF"
    },
    {
     "description": "PIVOTAL SYSTEMS CORP INC-CDI",
     "symbol": "PVLYL"
    },
    {
     "description": "PINE VALLEY MINING CORP",
     "symbol": "PVMCF"
    },
    {
     "description": "PREVENTION INSURANCE.COM",
     "symbol": "PVNC"
    },
    {
     "description": "PV NANO CELL LTD",
     "symbol": "PVNNF"
    },
    {
     "description": "PROVISION OPERATION SYSTEMS",
     "symbol": "PVNO"
    },
    {
     "description": "PROVIDENCE RESOURCES INC",
     "symbol": "PVRS"
    },
    {
     "description": "PERVASIP CORP",
     "symbol": "PVSP"
    },
    {
     "description": "PIVOTAL THERAPEUTICS INC",
     "symbol": "PVTTF"
    },
    {
     "description": "PARTNERS VALUE INVESTMENTS I",
     "symbol": "PVVLF"
    },
    {
     "description": "Partners Value Investments Inc",
     "symbol": "PVVWF"
    },
    {
     "description": "PVW RESOURCES LTD",
     "symbol": "PVWRF"
    },
    {
     "description": "POWER REIT",
     "symbol": "PW"
    },
    {
     "description": "POWER REIT",
     "symbol": "PW.PRA"
    },
    {
     "description": "INVESCO DYNAMIC LARGE CAP GR",
     "symbol": "PWB"
    },
    {
     "description": "PACIFIC WEST BANK",
     "symbol": "PWBO"
    },
    {
     "description": "INVESCO DYNAMIC MARKET ETF",
     "symbol": "PWC"
    },
    {
     "description": "POWER CORP OF CANADA",
     "symbol": "PWCDF"
    },
    {
     "description": "PWRCOR INC",
     "symbol": "PWCO"
    },
    {
     "description": "PACIFIC WILDCAT RESOURCES",
     "symbol": "PWCRF"
    },
    {
     "description": "PACWEST EQUITIES INC",
     "symbol": "PWEI"
    },
    {
     "description": "POWERFLEET INC",
     "symbol": "PWFL"
    },
    {
     "description": "Power Financial Corporation",
     "symbol": "PWFNF"
    },
    {
     "description": "POWERLOCK INTERNATIONAL CORP",
     "symbol": "PWLK"
    },
    {
     "description": "POWERLONG REAL ESTATE HOLDIN",
     "symbol": "PWLNF"
    },
    {
     "description": "POWERLINX INC",
     "symbol": "PWNX"
    },
    {
     "description": "PENNS WOODS BANCORP INC",
     "symbol": "PWOD"
    },
    {
     "description": "PERELLA WEINBERG PARTNERS",
     "symbol": "PWP"
    },
    {
     "description": "FINTECH ACQUISI CORP -CW25",
     "symbol": "PWPPW"
    },
    {
     "description": "INVESCO NASDAQ-100 DIST",
     "symbol": "PWQQF"
    },
    {
     "description": "QUANTA SERVICES INC",
     "symbol": "PWR"
    },
    {
     "description": "PWR HOLDINGS LTD",
     "symbol": "PWRHF"
    },
    {
     "description": "POWER METALS CORP",
     "symbol": "PWRMF"
    },
    {
     "description": "PACER WEALTHSHIELD ETF",
     "symbol": "PWS"
    },
    {
     "description": "POWERSCHOOL HOLDINGS INC-A",
     "symbol": "PWSC"
    },
    {
     "description": "POWERUP ACQUISITION COR-CL A",
     "symbol": "PWUP"
    },
    {
     "description": "POWERUP ACQUISITION CORP",
     "symbol": "PWUPU"
    },
    {
     "description": "POWERUP ACQUISITION -CW27",
     "symbol": "PWUPW"
    },
    {
     "description": "INVESCO DYNAMIC LARGE CAP VA",
     "symbol": "PWV"
    },
    {
     "description": "POWERBAND SOLUTIONS INC",
     "symbol": "PWWBF"
    },
    {
     "description": "INVESCO CALIFORNIA AMT-FREE",
     "symbol": "PWZ"
    },
    {
     "description": "POWSZECHNY ZAKLAD UBEZPIECZE",
     "symbol": "PWZYF"
    },
    {
     "description": "P10 INC-A",
     "symbol": "PX"
    },
    {
     "description": "LOCATION SCIENCES GROUP PLC",
     "symbol": "PXAMF"
    },
    {
     "description": "PAX CLEAN ENERGY INC",
     "symbol": "PXCE"
    },
    {
     "description": "PHOENIX COPPER LTD",
     "symbol": "PXCLF"
    },
    {
     "description": "PHOENIX COPPER - SPON ADR",
     "symbol": "PXCLY"
    },
    {
     "description": "PIONEER NATURAL RESOURCES CO",
     "symbol": "PXD"
    },
    {
     "description": "INVESCO DYNAMIC ENERGY EXPLO",
     "symbol": "PXE"
    },
    {
     "description": "INVESCO FTSE RAFI DEVELOPED",
     "symbol": "PXF"
    },
    {
     "description": "PHOENIX FOOTWEAR GROUP INC",
     "symbol": "PXFG"
    },
    {
     "description": "PAX GLOBAL TECHNOLOGY LTD",
     "symbol": "PXGYF"
    },
    {
     "description": "INVESCO FTSE RAFI EMERGING M",
     "symbol": "PXH"
    },
    {
     "description": "PHONEX HOLDINGS INC",
     "symbol": "PXHI"
    },
    {
     "description": "INVESCO DWA ENERGY MOMENTUM",
     "symbol": "PXI"
    },
    {
     "description": "INVESCO DYNAMIC OIL & GAS SE",
     "symbol": "PXJ"
    },
    {
     "description": "PIXELWORKS INC",
     "symbol": "PXLW"
    },
    {
     "description": "PAXMAN AB",
     "symbol": "PXMBF"
    },
    {
     "description": "PHILEX MINING CORP",
     "symbol": "PXMFF"
    },
    {
     "description": "PIXIUM VISION SA",
     "symbol": "PXMVF"
    },
    {
     "description": "PXP ENERGY CORP",
     "symbol": "PXPEF"
    },
    {
     "description": "PEXIP HOLDING ASA",
     "symbol": "PXPHF"
    },
    {
     "description": "PHOENIX APPS INC",
     "symbol": "PXPP"
    },
    {
     "description": "INVESCO DYNAMIC NETWORKING E",
     "symbol": "PXQ"
    },
    {
     "description": "PIXARBIO CORP",
     "symbol": "PXRB"
    },
    {
     "description": "PYXIS TANKERS INC",
     "symbol": "PXS"
    },
    {
     "description": "PYXIS TANKERS",
     "symbol": "PXSAP"
    },
    {
     "description": "PYXIS TANKERS INC -CW25",
     "symbol": "PXSAW"
    },
    {
     "description": "PHOENIX SOLAR AG",
     "symbol": "PXSNF"
    },
    {
     "description": "PHOENIX MEDIA INVESTMENT HOL",
     "symbol": "PXSTF"
    },
    {
     "description": "PRINCIPAL INT ADAP MULTI",
     "symbol": "PXUS"
    },
    {
     "description": "POXEL SA",
     "symbol": "PXXLF"
    },
    {
     "description": "POLARX LTD",
     "symbol": "PXXXF"
    },
    {
     "description": "PRAXSYN CORP",
     "symbol": "PXYN"
    },
    {
     "description": "PRINCIPAL VALUE ETF",
     "symbol": "PY"
    },
    {
     "description": "HYDRO POWER TECHNOLOGIES INC",
     "symbol": "PYBX"
    },
    {
     "description": "PRYCE CORPORATION",
     "symbol": "PYCEF"
    },
    {
     "description": "MOUNT LOGAN CAPITAL INC",
     "symbol": "PYCFF"
    },
    {
     "description": "PAYCOR HCM INC",
     "symbol": "PYCR"
    },
    {
     "description": "PAYCHEST INC",
     "symbol": "PYCT"
    },
    {
     "description": "PYRAMID PETROLEUM INC",
     "symbol": "PYDPF"
    },
    {
     "description": "PAYFARE INC",
     "symbol": "PYFRF"
    },
    {
     "description": "PLAYMATES HOLDINGS LTD",
     "symbol": "PYHOF"
    },
    {
     "description": "PROPERTY FOR INDUSTRY LTD",
     "symbol": "PYIYF"
    },
    {
     "description": "HYDROCARBON DYNAMICS LTD",
     "symbol": "PYMOF"
    },
    {
     "description": "PIMCO NEW YORK MUNICIPAL III",
     "symbol": "PYN"
    },
    {
     "description": "PERIMETER MEDICAL IMAGING AI",
     "symbol": "PYNKF"
    },
    {
     "description": "PROMOTORA Y OPERADORA DE INF",
     "symbol": "PYOIF"
    },
    {
     "description": "POLYPID LTD",
     "symbol": "PYPD"
    },
    {
     "description": "ETRACS NYSE PICKENS CORE ETN",
     "symbol": "PYPE"
    },
    {
     "description": "PAYPAL HOLDINGS INC",
     "symbol": "PYPL"
    },
    {
     "description": "PAYPOINT PLC",
     "symbol": "PYPTF"
    },
    {
     "description": "PYROGENESIS CANADA INC",
     "symbol": "PYR"
    },
    {
     "description": "Pyrolyx AG",
     "symbol": "PYROF"
    },
    {
     "description": "PREFERREDPLUS TRST RRD",
     "symbol": "PYS"
    },
    {
     "description": "PREFERREDPLUS TRST GS",
     "symbol": "PYT"
    },
    {
     "description": "PLAYTECH PLC",
     "symbol": "PYTCF"
    },
    {
     "description": "PLAYTECH PLC-UNSP ADR",
     "symbol": "PYTCY"
    },
    {
     "description": "PYXIS ONCOLOGY INC",
     "symbol": "PYXS"
    },
    {
     "description": "PROMOTORA Y OPERAD DE INF-L",
     "symbol": "PYYIF"
    },
    {
     "description": "POYRY OYJ",
     "symbol": "PYYRF"
    },
    {
     "description": "PYXUS INTERNATIONAL INC",
     "symbol": "PYYX"
    },
    {
     "description": "INVESCO DWA BASIC MATERIALS",
     "symbol": "PYZ"
    },
    {
     "description": "INVESCO NATIONAL AMT-FREE MU",
     "symbol": "PZA"
    },
    {
     "description": "POWSZECHNY ZAKLAD-UNSP ADR",
     "symbol": "PZAKY"
    },
    {
     "description": "PIMCO CALIFORNIA MUNICIP III",
     "symbol": "PZC"
    },
    {
     "description": "PZ CUSSONS PLC-UNSP ADR",
     "symbol": "PZCUY"
    },
    {
     "description": "PARAMOUNT GOLD NEVADA CORP",
     "symbol": "PZG"
    },
    {
     "description": "PZENA INVESTMENT MANAGM-CL A",
     "symbol": "PZN"
    },
    {
     "description": "PAZOO INC",
     "symbol": "PZOO"
    },
    {
     "description": "PIZZA PIZZA ROYALTY CORP",
     "symbol": "PZRIF"
    },
    {
     "description": "PHASERX INC",
     "symbol": "PZRXQ"
    },
    {
     "description": "INVESCO NEW YORK AMT-FREE MU",
     "symbol": "PZT"
    },
    {
     "description": "PAPA JOHN'S INTL INC",
     "symbol": "PZZA"
    },
    {
     "description": "SARIMELATI KENCANA PT",
     "symbol": "PZZZF"
    },
    {
     "description": "FIRST TRUST NASDAQ ABA CBIF",
     "symbol": "QABA"
    },
    {
     "description": "QANTAS AIRWAYS LTD-SPN ADR",
     "symbol": "QABSY"
    },
    {
     "description": "IQ HEDGE MULTI-STRAT TRACKER",
     "symbol": "QAI"
    },
    {
     "description": "DBX ETF TRUST - XTRACKERS RU",
     "symbol": "QARP"
    },
    {
     "description": "ISHARES MSCI QATAR ETF",
     "symbol": "QAT"
    },
    {
     "description": "GULF INVESTMENT FUND PLC",
     "symbol": "QATAF"
    },
    {
     "description": "QUALSTAR CORP",
     "symbol": "QBAK"
    },
    {
     "description": "TELCO CUBA INC",
     "symbol": "QBAN"
    },
    {
     "description": "QUBE HOLDINGS LTD-UNSPR ADR",
     "symbol": "QBBHY"
    },
    {
     "description": "QUEBECOR INC-CL A",
     "symbol": "QBCAF"
    },
    {
     "description": "QUEBECOR INC  -CL B",
     "symbol": "QBCRF"
    },
    {
     "description": "QBE INSURANCE GROUP LTD",
     "symbol": "QBEIF"
    },
    {
     "description": "QBE INSURANCE GROUP-SPN ADR",
     "symbol": "QBIEY"
    },
    {
     "description": "Q BIOMED INC",
     "symbol": "QBIO"
    },
    {
     "description": "QUICKBIT EU AB",
     "symbol": "QBITF"
    },
    {
     "description": "QUINSAM CAPITAL CORP",
     "symbol": "QCAAF"
    },
    {
     "description": "QC HOLDINGS INC",
     "symbol": "QCCO"
    },
    {
     "description": "QUAD COUNTY CORN PROCES-UNIT",
     "symbol": "QCCP"
    },
    {
     "description": "QC COPPER AND GOLD INC",
     "symbol": "QCCUF"
    },
    {
     "description": "QUICKSTEP HOLDINGS LTD",
     "symbol": "QCKSF"
    },
    {
     "description": "FIRST TRUST NASDAQ CLEAN EDG",
     "symbol": "QCLN"
    },
    {
     "description": "GLOBAL X NASDAQ 100 COLLAR 9",
     "symbol": "QCLR"
    },
    {
     "description": "GLOBAL PVQ SE",
     "symbol": "QCLSF"
    },
    {
     "description": "QUALCOMM INC",
     "symbol": "QCOM"
    },
    {
     "description": "AMERICAN CENT QUAL CONVT SEC",
     "symbol": "QCON"
    },
    {
     "description": "QUANTEX CAPITAL CORP",
     "symbol": "QCPC"
    },
    {
     "description": "QCR HOLDINGS INC",
     "symbol": "QCRH"
    },
    {
     "description": "QCX GOLD CORP",
     "symbol": "QCXGF"
    },
    {
     "description": "QUDIAN INC-SPON ADR",
     "symbol": "QD"
    },
    {
     "description": "FT CBOE VEST NASDAQ-100 BUFF",
     "symbol": "QDEC"
    },
    {
     "description": "FLEXSHARES QUALITY DIVIDEND",
     "symbol": "QDEF"
    },
    {
     "description": "QUIDEL CORP",
     "symbol": "QDEL"
    },
    {
     "description": "FLEXSHARES QUALITY DIVIDEND",
     "symbol": "QDF"
    },
    {
     "description": "GLOBAL X S&P 500 QLTY DIV",
     "symbol": "QDIV"
    },
    {
     "description": "QUADLOGIC CONTROLS CORP",
     "symbol": "QDLC"
    },
    {
     "description": "QDM INTERNATIONAL INC",
     "symbol": "QDMI"
    },
    {
     "description": "PACER MET US LRG CAP DVD 400",
     "symbol": "QDPL"
    },
    {
     "description": "QUADRO RESOURCES LTD",
     "symbol": "QDROF"
    },
    {
     "description": "QUADRISE FUELS INTERNATIONAL",
     "symbol": "QDRSF"
    },
    {
     "description": "FLEXSHARES QUALITY DIVIDEND",
     "symbol": "QDYN"
    },
    {
     "description": "VIRTUAL MEDICAL INTERNATIONA",
     "symbol": "QEBR"
    },
    {
     "description": "IQ HEDGE EVENT-DRIVEN TRACKE",
     "symbol": "QED"
    },
    {
     "description": "QED CONNECT INC",
     "symbol": "QEDN"
    },
    {
     "description": "SPDR MSCI EAFE STRATEGICFACT",
     "symbol": "QEFA"
    },
    {
     "description": "QUANTUM ENERGY INC",
     "symbol": "QEGY"
    },
    {
     "description": "QEM LTD",
     "symbol": "QEMFF"
    },
    {
     "description": "SPDR MSCI EMERGING MARKETS S",
     "symbol": "QEMM"
    },
    {
     "description": "QUEENCH INC",
     "symbol": "QENC"
    },
    {
     "description": "Q.E.P. COMPANY INC",
     "symbol": "QEPC"
    },
    {
     "description": "QUESTEX GOLD AND COPPER LTD",
     "symbol": "QEXGF"
    },
    {
     "description": "QUATTRO EXPLORATION AND PROD",
     "symbol": "QEXXF"
    },
    {
     "description": "QUICKFEE LTD",
     "symbol": "QFEEF"
    },
    {
     "description": "360 DIGITECH INC",
     "symbol": "QFIN"
    },
    {
     "description": "Q-FREE ASA",
     "symbol": "QFREF"
    },
    {
     "description": "QUANTUM FINTECH ACQUISITION",
     "symbol": "QFTA"
    },
    {
     "description": "QUANTUM FINTECH ACQUISITION",
     "symbol": "QFTA.U"
    },
    {
     "description": "QUANTUM FINTECH ACQ -CW27",
     "symbol": "QFTA.WS"
    },
    {
     "description": "QIAGEN N.V.",
     "symbol": "QGEN"
    },
    {
     "description": "Q-GOLD RESOURCES LTD",
     "symbol": "QGLDF"
    },
    {
     "description": "QINGLING MOTORS CO LTD-H",
     "symbol": "QGLHF"
    },
    {
     "description": "QUESTFOR GR-PRICAF",
     "symbol": "QGPLF"
    },
    {
     "description": "AMERICAN CENTURY STOXX US QL",
     "symbol": "QGRO"
    },
    {
     "description": "Q2 GOLD RESOURCES INC",
     "symbol": "QGRSF"
    },
    {
     "description": "QUANTGATE SYSTEMS INC",
     "symbol": "QGSI"
    },
    {
     "description": "QUHUO LTD-ADR",
     "symbol": "QH"
    },
    {
     "description": "QUALITY HSES HTL&RES F&L-FOR",
     "symbol": "QHHRF"
    },
    {
     "description": "QHY GROUP",
     "symbol": "QHYG"
    },
    {
     "description": "QIANSUI INTERNATIONAL GROUP",
     "symbol": "QIAN"
    },
    {
     "description": "PROSHARES ULTRASHORT QQQ",
     "symbol": "QID"
    },
    {
     "description": "QUORUM INFORMATION TECH INC",
     "symbol": "QIFTF"
    },
    {
     "description": "HAIER SMART HOME CO LTD-D",
     "symbol": "QIHCF"
    },
    {
     "description": "QINGDAO FOOTWEAR INC",
     "symbol": "QING"
    },
    {
     "description": "AMERICAN CENTURY QLTY DIVER",
     "symbol": "QINT"
    },
    {
     "description": "QUIPT HOME MEDICAL CORP",
     "symbol": "QIPT"
    },
    {
     "description": "QIWI PLC-SPONSORED ADR",
     "symbol": "QIWI"
    },
    {
     "description": "FT CBOE VEST NASDAQ-100 BUFF",
     "symbol": "QJUN"
    },
    {
     "description": "SMI CULTURE & TRAVEL GROUP H",
     "symbol": "QJYMF"
    },
    {
     "description": "Q&K INTERNATIONAL GROUP-ADR",
     "symbol": "QK"
    },
    {
     "description": "QKL STORES INC",
     "symbol": "QKLS"
    },
    {
     "description": "FLEXSHARES US QUALITY LG CAP",
     "symbol": "QLC"
    },
    {
     "description": "PROSHARES ULTRA QQQ",
     "symbol": "QLD"
    },
    {
     "description": "QUALIGEN THERAPEUTICS INC",
     "symbol": "QLGN"
    },
    {
     "description": "QILIAN INTERNATIONAL HOLDING",
     "symbol": "QLI"
    },
    {
     "description": "QUALIS INNOVATIONS INC",
     "symbol": "QLIS"
    },
    {
     "description": "IQ HEDGE LONG\/SHORT TRACKER",
     "symbol": "QLS"
    },
    {
     "description": "ISHARES AAA - A RATED CORPOR",
     "symbol": "QLTA"
    },
    {
     "description": "FLEXSHARES US QUALITY LOW VO",
     "symbol": "QLV"
    },
    {
     "description": "FLEXSHARES DEVELOPED MARKETS",
     "symbol": "QLVD"
    },
    {
     "description": "FLEXSHARES EMERGING MARKETS",
     "symbol": "QLVE"
    },
    {
     "description": "QUALYS INC",
     "symbol": "QLYS"
    },
    {
     "description": "FT CBOE VEST NASDAQ-100 BUFF",
     "symbol": "QMAR"
    },
    {
     "description": "QUOTEMEDIA INC",
     "symbol": "QMCI"
    },
    {
     "description": "QUANTUM CORP",
     "symbol": "QMCO"
    },
    {
     "description": "QMC QUANTUM MINERALS CORP",
     "symbol": "QMCQF"
    },
    {
     "description": "QUICK-MED TECHNOLOGIES INC",
     "symbol": "QMDT"
    },
    {
     "description": "QMED INC",
     "symbol": "QMED"
    },
    {
     "description": "QUANTUM METAL EXCHANGE INC",
     "symbol": "QMEI"
    },
    {
     "description": "QMIS FINANCE SECURITIES CORP",
     "symbol": "QMIS"
    },
    {
     "description": "IQ HEDGE MARKET NEUT TRACK",
     "symbol": "QMN"
    },
    {
     "description": "ALPHA US QUANT MOM ETF",
     "symbol": "QMOM"
    },
    {
     "description": "QNB CORP",
     "symbol": "QNBC"
    },
    {
     "description": "QNB METALS INC",
     "symbol": "QNBMF"
    },
    {
     "description": "QUANTUM EMOTION CORP",
     "symbol": "QNCCF"
    },
    {
     "description": "QINGDAO PORT INTERNATIONAL-H",
     "symbol": "QNDPF"
    },
    {
     "description": "QUANERGY SYSTEMS INC",
     "symbol": "QNGY"
    },
    {
     "description": "CITIC CAPITAL ACQUISIT-CW27",
     "symbol": "QNGY.WS"
    },
    {
     "description": "QUEBEC NICKEL CORP",
     "symbol": "QNICF"
    },
    {
     "description": "QUANTUM GENOMICS SAS-REGR",
     "symbol": "QNNTF"
    },
    {
     "description": "QUOIN PHARMACEUTICALS LT-ADR",
     "symbol": "QNRX"
    },
    {
     "description": "QUINSTREET INC",
     "symbol": "QNST"
    },
    {
     "description": "QUANTA INC",
     "symbol": "QNTA"
    },
    {
     "description": "QUANTAFUEL AS",
     "symbol": "QNTFF"
    },
    {
     "description": "QUAINT OAK BANCORP INC",
     "symbol": "QNTO"
    },
    {
     "description": "QINETIQ GROUP PLC",
     "symbol": "QNTQF"
    },
    {
     "description": "QINETIQ GROUP PLC-UNSP ADR",
     "symbol": "QNTQY"
    },
    {
     "description": "QENEX COMMUNICATIONS INC",
     "symbol": "QNXC"
    },
    {
     "description": "QUALITY ONLINE EDUCATION GRO",
     "symbol": "QOEG"
    },
    {
     "description": "QUEST OIL CORP",
     "symbol": "QOIL"
    },
    {
     "description": "QUALITY ONE WIRELESS INC",
     "symbol": "QOWI"
    },
    {
     "description": "AMERICAN CENTURY QUAL PREF",
     "symbol": "QPFF"
    },
    {
     "description": "QUEENSLAND PACIFIC METALS LT",
     "symbol": "QPMLF"
    },
    {
     "description": "QUEST PATENT RESEARCH CORP",
     "symbol": "QPRC"
    },
    {
     "description": "QPS DIE CUTTERS & FINISHERS",
     "symbol": "QPSF"
    },
    {
     "description": "ADVISORSHARES Q PORT BL ALLO",
     "symbol": "QPT"
    },
    {
     "description": "QUEST PHARMATECH INC",
     "symbol": "QPTFF"
    },
    {
     "description": "ADVISORSHARES Q DYN GROWTH",
     "symbol": "QPX"
    },
    {
     "description": "SIMPLIFY EXCHANGE TRADED FUN",
     "symbol": "QQC"
    },
    {
     "description": "SIMPLIFY EXCHANGE TRADED FUN",
     "symbol": "QQD"
    },
    {
     "description": "FIRST TRUST NASDQ 100 EQ WEI",
     "symbol": "QQEW"
    },
    {
     "description": "QINQIN FOODSTUFFS GROUP CAYM",
     "symbol": "QQFSF"
    },
    {
     "description": "HCM DEFENDER 100 INDEX ETF",
     "symbol": "QQH"
    },
    {
     "description": "INVESCO ESG NASDAQ NEXT GEN",
     "symbol": "QQJG"
    },
    {
     "description": "INVESCO ESG NASDAQ 100",
     "symbol": "QQMG"
    },
    {
     "description": "INVESCO QQQ TRUST SERIES 1",
     "symbol": "QQQ"
    },
    {
     "description": "PROSHARES NSDQ 100 D\/W MOM",
     "symbol": "QQQA"
    },
    {
     "description": "DIREXION NASDAQ-100 EQ WEIGH",
     "symbol": "QQQE"
    },
    {
     "description": "QUIZAM MEDIA CORP",
     "symbol": "QQQFF"
    },
    {
     "description": "INVESCO NASDAQ NEXT GEN 100",
     "symbol": "QQQJ"
    },
    {
     "description": "INVESCO NASDAQ 100 ETF",
     "symbol": "QQQM"
    },
    {
     "description": "VICTORYSHARES NASDAQ NEXT 50",
     "symbol": "QQQN"
    },
    {
     "description": "NUVEEN NAS100 DYN OVERWRT FD",
     "symbol": "QQQX"
    },
    {
     "description": "FIRST TRUST NASDAQ-100 EX-TE",
     "symbol": "QQXT"
    },
    {
     "description": "QRAFT AI-ENH US LRG CAP ETF",
     "symbol": "QRFT"
    },
    {
     "description": "QUEST RESOURCE HOLDING CORP",
     "symbol": "QRHC"
    },
    {
     "description": "GLOBAL X NASDAQ 100 RISK MAN",
     "symbol": "QRMI"
    },
    {
     "description": "AURIZON HOLDINGS LTD",
     "symbol": "QRNNF"
    },
    {
     "description": "QRONS INC",
     "symbol": "QRON"
    },
    {
     "description": "QUARRY CITY SAVINGS & LOAN A",
     "symbol": "QRRY"
    },
    {
     "description": "QRS MUSIC TECHNOLOGIES INC",
     "symbol": "QRSM"
    },
    {
     "description": "QURATE RETAIL INC-SERIES A",
     "symbol": "QRTEA"
    },
    {
     "description": "QURATE RETAIL GROUP INC-B",
     "symbol": "QRTEB"
    },
    {
     "description": "QURATE RETAIL INC",
     "symbol": "QRTEP"
    },
    {
     "description": "QORVO INC",
     "symbol": "QRVO"
    },
    {
     "description": "QRXPHARMA LTD",
     "symbol": "QRXPF"
    },
    {
     "description": "QUANTUMSCAPE CORP",
     "symbol": "QS"
    },
    {
     "description": "QSAM BIOSCIENCES INC",
     "symbol": "QSAM"
    },
    {
     "description": "Q.BEYOND AG",
     "symbol": "QSCGF"
    },
    {
     "description": "QS ENERGY INC",
     "symbol": "QSEP"
    },
    {
     "description": "QUANTUM-SI INC",
     "symbol": "QSI"
    },
    {
     "description": "HIGHCAPE CAPITAL ACQUI -CW27",
     "symbol": "QSIAW"
    },
    {
     "description": "QUEST MANAGEMENT INC\/US",
     "symbol": "QSMG"
    },
    {
     "description": "FT CBOE VEST GROWTH-100 BUFF",
     "symbol": "QSPT"
    },
    {
     "description": "QUANTUM SOLAR POWER CORP",
     "symbol": "QSPW"
    },
    {
     "description": "RESTAURANT BRANDS INTERN",
     "symbol": "QSR"
    },
    {
     "description": "AMP BLACKSWAN TECH & TREASUR",
     "symbol": "QSWN"
    },
    {
     "description": "INNOVATOR GRW 100 ACCL PLUS",
     "symbol": "QTAP"
    },
    {
     "description": "Q TECHNOLOGY GROUP CO LTD",
     "symbol": "QTCHF"
    },
    {
     "description": "QUANTUM CAPITAL INC",
     "symbol": "QTCI"
    },
    {
     "description": "FIRST TRUST NASDQ 100 TECH I",
     "symbol": "QTEC"
    },
    {
     "description": "QUALTEK SERVICES INC-A",
     "symbol": "QTEK"
    },
    {
     "description": "ROTH CH ACQ -CW27",
     "symbol": "QTEKW"
    },
    {
     "description": "QUESTERRE ENERGY CORP - A",
     "symbol": "QTEYF"
    },
    {
     "description": "QUARK TECHNOLOGY GLOBAL INC",
     "symbol": "QTGI"
    },
    {
     "description": "QT GROUP OYJ",
     "symbol": "QTGPF"
    },
    {
     "description": "INNOVATOR GROWTH ACC PLUS-J",
     "symbol": "QTJA"
    },
    {
     "description": "INN GROWTH ACCEL PLUS JULY",
     "symbol": "QTJL"
    },
    {
     "description": "QUOTIENT LTD",
     "symbol": "QTNT"
    },
    {
     "description": "INNOVATOR GROWTH ACCEL PL-OC",
     "symbol": "QTOC"
    },
    {
     "description": "GLOBAL X NASDAQ 100 TAIL RIS",
     "symbol": "QTR"
    },
    {
     "description": "QUARTERHILL INC",
     "symbol": "QTRHF"
    },
    {
     "description": "QUANTERIX CORP",
     "symbol": "QTRX"
    },
    {
     "description": "QUTOUTIAO INC-ADR",
     "symbol": "QTT"
    },
    {
     "description": "DEFIANCE QUANTUM ETF",
     "symbol": "QTUM"
    },
    {
     "description": "QT VASCULAR LTD",
     "symbol": "QTVLF"
    },
    {
     "description": "Q2 HOLDINGS INC",
     "symbol": "QTWO"
    },
    {
     "description": "QUANTRX BIOMEDICAL CORP",
     "symbol": "QTXB"
    },
    {
     "description": "QUAD GRAPHICS INC",
     "symbol": "QUAD"
    },
    {
     "description": "ISHARES MSCI USA QUALITY FAC",
     "symbol": "QUAL"
    },
    {
     "description": "QUANTUM INTERNATIONAL CORP",
     "symbol": "QUAN"
    },
    {
     "description": "QANTAS AIRWAYS LTD",
     "symbol": "QUBSF"
    },
    {
     "description": "QUANTUM COMPUTING INC",
     "symbol": "QUBT"
    },
    {
     "description": "QUANTA COMPUTER INC-GDR REGS",
     "symbol": "QUCCF"
    },
    {
     "description": "QUALITAS CONTROLADORA SAB CV",
     "symbol": "QUCOF"
    },
    {
     "description": "QUEEN CITY INVESTMENTS INC",
     "symbol": "QUCT"
    },
    {
     "description": "QUINTON GROUP INC",
     "symbol": "QUGB"
    },
    {
     "description": "QUICKLOGIC CORP",
     "symbol": "QUIK"
    },
    {
     "description": "QUILTER PLC",
     "symbol": "QUILF"
    },
    {
     "description": "QUISITIVE TECHNOLOGY SOLUTIO",
     "symbol": "QUISF"
    },
    {
     "description": "QUALITY HOUSES LEASEHOLD PRO",
     "symbol": "QULHF"
    },
    {
     "description": "ETRACS 2X QUALITY FACTR TR",
     "symbol": "QULL"
    },
    {
     "description": "SENTRAL REIT",
     "symbol": "QULLF"
    },
    {
     "description": "QUMU CORP",
     "symbol": "QUMU"
    },
    {
     "description": "QUOTIENT TECHNOLOGY INC",
     "symbol": "QUOT"
    },
    {
     "description": "QUIXANT PLC",
     "symbol": "QUPLF"
    },
    {
     "description": "UNIQURE NV",
     "symbol": "QURE"
    },
    {
     "description": "QUARTA-RAD INC",
     "symbol": "QURT"
    },
    {
     "description": "SPDR MSCI USA STRATEGICFACTO",
     "symbol": "QUS"
    },
    {
     "description": "LUMIBIRD",
     "symbol": "QUTEF"
    },
    {
     "description": "QUESTOR TECHNOLOGY INC",
     "symbol": "QUTIF"
    },
    {
     "description": "ALPHA ARCH US QNT VALUE ETF",
     "symbol": "QVAL"
    },
    {
     "description": "QVC INC",
     "symbol": "QVCC"
    },
    {
     "description": "QVC INC",
     "symbol": "QVCD"
    },
    {
     "description": "INVESCO S&P 500 QVM MULTI-FA",
     "symbol": "QVML"
    },
    {
     "description": "INVESCO S&P MIDCAP 400 QVM M",
     "symbol": "QVMM"
    },
    {
     "description": "INVESCO S&P SMALLCAP 600 QVM",
     "symbol": "QVMS"
    },
    {
     "description": "QWICK MEDIA INC",
     "symbol": "QWIKF"
    },
    {
     "description": "SPDR MSCI WORLD STRATEGICFAC",
     "symbol": "QWLD"
    },
    {
     "description": "QUEST WATER GLOBAL INC",
     "symbol": "QWTR"
    },
    {
     "description": "QIAN YUAN BAIXING INC",
     "symbol": "QYBX"
    },
    {
     "description": "GLOBAL X NASD 100 COV CALL",
     "symbol": "QYLD"
    },
    {
     "description": "GLOBAL X NASDAQ 100 COVC GRW",
     "symbol": "QYLG"
    },
    {
     "description": "QYOU MEDIA INC",
     "symbol": "QYOUF"
    },
    {
     "description": "QUARTZ MOUNTAIN RESOURCES LT",
     "symbol": "QZMRF"
    },
    {
     "description": "RYDER SYSTEM INC",
     "symbol": "R"
    },
    {
     "description": "BROOKFIELD REAL ASSETS INCOM",
     "symbol": "RA"
    },
    {
     "description": "CLOOPEN GROUP HOLDING LTD",
     "symbol": "RAAS"
    },
    {
     "description": "VANECK INFLATION ALLOCATION",
     "symbol": "RAAX"
    },
    {
     "description": "RESEARCH ALLIANCE CORP II-A",
     "symbol": "RACB"
    },
    {
     "description": "FERRARI NV",
     "symbol": "RACE"
    },
    {
     "description": "RELATIVITY ACQUISITION COR-A",
     "symbol": "RACY"
    },
    {
     "description": "RELATIVITY ACQUISITION CORP",
     "symbol": "RACYU"
    },
    {
     "description": "RELATIVITY ACQUISITION-CW27",
     "symbol": "RACYW"
    },
    {
     "description": "RITE AID CORP",
     "symbol": "RAD"
    },
    {
     "description": "RADA ELECTRONIC INDS LTD",
     "symbol": "RADA"
    },
    {
     "description": "RADIUS GLOBAL INFRASTRUCTU-A",
     "symbol": "RADI"
    },
    {
     "description": "RADIAL RESEARCH CORP",
     "symbol": "RADLF"
    },
    {
     "description": "RAIA DROGASIL SA-SPON ADR",
     "symbol": "RADLY"
    },
    {
     "description": "RADIUM RESOURCES CORP",
     "symbol": "RADR"
    },
    {
     "description": "PIMA ZINC CORP",
     "symbol": "RAEWF"
    },
    {
     "description": "RAFARMA PHARMACEUTICALS INC",
     "symbol": "RAFA"
    },
    {
     "description": "PIMCO RAFI ESG US ETF",
     "symbol": "RAFE"
    },
    {
     "description": "RAFFLES FINANCIAL GROUP LTD",
     "symbol": "RAFFF"
    },
    {
     "description": "REGENCY AFFILIATES INC",
     "symbol": "RAFI"
    },
    {
     "description": "RAFFLES MEDICAL GROUP LTD",
     "symbol": "RAFLF"
    },
    {
     "description": "RA GLOBAL SERVICES INC",
     "symbol": "RAGL"
    },
    {
     "description": "ROAN HOLDINGS GROUP CO LTD",
     "symbol": "RAHGF"
    },
    {
     "description": "RAIFFEISEN BANK INTERNATIONA",
     "symbol": "RAIFF"
    },
    {
     "description": "RAIFFEISEN BANK INT-UNSP ADR",
     "symbol": "RAIFY"
    },
    {
     "description": "FREIGHTCAR AMERICA INC",
     "symbol": "RAIL"
    },
    {
     "description": "RAIN THERAPEUTICS INC",
     "symbol": "RAIN"
    },
    {
     "description": "RADIOIO INC",
     "symbol": "RAIO"
    },
    {
     "description": "RAINMAKER WORLDWIDE INC",
     "symbol": "RAKR"
    },
    {
     "description": "PROSHARES RAFI LONG\/SHORT",
     "symbol": "RALS"
    },
    {
     "description": "ARIES I ACQUISITION CORP -A",
     "symbol": "RAM"
    },
    {
     "description": "RAMM PHARMA CORP",
     "symbol": "RAMMF"
    },
    {
     "description": "ARIES I ACQUISITION CORP",
     "symbol": "RAMMU"
    },
    {
     "description": "ARIES I ACQUISITION COR-CW23",
     "symbol": "RAMMW"
    },
    {
     "description": "LIVERAMP HOLDINGS INC",
     "symbol": "RAMP"
    },
    {
     "description": "POLARIS INFRASTRUCTURE INC",
     "symbol": "RAMPF"
    },
    {
     "description": "RAND CAPITAL CORP",
     "symbol": "RAND"
    },
    {
     "description": "RANI THERAPEUTICS HOLDINGS-A",
     "symbol": "RANI"
    },
    {
     "description": "RANDSTAD NV",
     "symbol": "RANJF"
    },
    {
     "description": "RANDSTAD NV-UNSP ADR",
     "symbol": "RANJY"
    },
    {
     "description": "RANK GROUP PLC",
     "symbol": "RANKF"
    },
    {
     "description": "RACE ONCOLOGY LTD",
     "symbol": "RAONF"
    },
    {
     "description": "RESAPP HEALTH LTD",
     "symbol": "RAPHF"
    },
    {
     "description": "RAPT THERAPEUTICS INC",
     "symbol": "RAPT"
    },
    {
     "description": "ULTRAGENYX PHARMACEUTICAL IN",
     "symbol": "RARE"
    },
    {
     "description": "CANADA RARE EARTH CORP",
     "symbol": "RAREF"
    },
    {
     "description": "CADENCE MINERALS PLC",
     "symbol": "RARMF"
    },
    {
     "description": "RASNA THERAPEUTICS INC",
     "symbol": "RASP"
    },
    {
     "description": "RATHDOWNEY RESOURCES LTD",
     "symbol": "RATHF"
    },
    {
     "description": "RATIONAL AG -UNSP ADR",
     "symbol": "RATIY"
    },
    {
     "description": "RHEON AUTOMATIC MACHINERY",
     "symbol": "RAUMF"
    },
    {
     "description": "RAVE RESTAURANT GROUP INC",
     "symbol": "RAVE"
    },
    {
     "description": "FLEXSHARES READY ACCESS VARI",
     "symbol": "RAVI"
    },
    {
     "description": "RAYLIANT QUANTAMENTAL CHINA",
     "symbol": "RAYC"
    },
    {
     "description": "RAYLIANT QUANT DEV MKT EQTY",
     "symbol": "RAYD"
    },
    {
     "description": "RAYLIANT QUANT EMERGING MKT",
     "symbol": "RAYE"
    },
    {
     "description": "GLOBAL X SOLAR ETF",
     "symbol": "RAYS"
    },
    {
     "description": "RAYONT INC",
     "symbol": "RAYT"
    },
    {
     "description": "RAZER INC",
     "symbol": "RAZFF"
    },
    {
     "description": "RITCHIE BROS AUCTIONEERS",
     "symbol": "RBA"
    },
    {
     "description": "REDBALL ACQUISITION CORP - A",
     "symbol": "RBAC"
    },
    {
     "description": "REDBALL ACQUISITION CORP",
     "symbol": "RBAC.U"
    },
    {
     "description": "REDBALL ACQUISITION -CW22",
     "symbol": "RBAC.WS"
    },
    {
     "description": "RBAZ BANCORP INC",
     "symbol": "RBAZ"
    },
    {
     "description": "RBB BANCORP",
     "symbol": "RBB"
    },
    {
     "description": "RIBBON COMMUNICATIONS INC",
     "symbol": "RBBN"
    },
    {
     "description": "REPUBLIC BANCORP INC-CLASS A",
     "symbol": "RBCAA"
    },
    {
     "description": "RBC LIFE SCIENCES INC",
     "symbol": "RBCL"
    },
    {
     "description": "RUBICON TECHNOLOGY INC",
     "symbol": "RBCN"
    },
    {
     "description": "Royal Bank",
     "symbol": "RBCPF"
    },
    {
     "description": "RBID.COM INC",
     "symbol": "RBDC"
    },
    {
     "description": "ROBECO GLOBAL STARS EQUITIES",
     "symbol": "RBFBF"
    },
    {
     "description": "L&G ROBO GLOBAL ROBOTICS&AUT",
     "symbol": "RBGBF"
    },
    {
     "description": "RIMBACO GROUP GLOBAL LTD",
     "symbol": "RBGGF"
    },
    {
     "description": "RECKITT BENCKISER-SPON ADR",
     "symbol": "RBGLY"
    },
    {
     "description": "RECKITT BENCKISER GROUP PLC",
     "symbol": "RBGPF"
    },
    {
     "description": "RISING BIOSCIENCES INC",
     "symbol": "RBII"
    },
    {
     "description": "NATIONWIDE RISK-BASED INTL E",
     "symbol": "RBIN"
    },
    {
     "description": "RHINEBECK BANCORP INC",
     "symbol": "RBKB"
    },
    {
     "description": "ROBINSONS LAND CO",
     "symbol": "RBLAF"
    },
    {
     "description": "ROBINSONS LAND CO-ADR",
     "symbol": "RBLAY"
    },
    {
     "description": "ROBLOX CORP -CLASS A",
     "symbol": "RBLX"
    },
    {
     "description": "RUGBY MINING LTD",
     "symbol": "RBMNF"
    },
    {
     "description": "RAMBLER METALS AND MINING PL",
     "symbol": "RBMTF"
    },
    {
     "description": "SPDR BLOOMBERG CORP ESG SELT",
     "symbol": "RBND"
    },
    {
     "description": "ROBINSONS RETAIL HOLDINGS IN",
     "symbol": "RBNTF"
    },
    {
     "description": "RENEWABLE ENERGY & POWER INC",
     "symbol": "RBNW"
    },
    {
     "description": "REEBONZ HOLDING LTD-CW24",
     "symbol": "RBNZF"
    },
    {
     "description": "VICARIOUS SURGICAL INC",
     "symbol": "RBOT"
    },
    {
     "description": "VICARIOUS SURGICAL INC-CW27",
     "symbol": "RBOT.WS"
    },
    {
     "description": "RBR GLOBAL INC",
     "symbol": "RBRI"
    },
    {
     "description": "RHINO BIOTECH LTD",
     "symbol": "RBRXF"
    },
    {
     "description": "RUBIS-UNSPONSORED ADR",
     "symbol": "RBSFY"
    },
    {
     "description": "REBUS HOLDINGS INC",
     "symbol": "RBSH"
    },
    {
     "description": "NATWEST GROUP PLC",
     "symbol": "RBSPF"
    },
    {
     "description": "ROBOSERVER SYSTEMS CORP",
     "symbol": "RBSY"
    },
    {
     "description": "ROBERTET SA",
     "symbol": "RBTEF"
    },
    {
     "description": "RED BRANCH TECHNOLOGIES INC",
     "symbol": "RBTI"
    },
    {
     "description": "ZHEN DING RESOURCES INC",
     "symbol": "RBTK"
    },
    {
     "description": "NATIONWIDE RISK-BASED US EQ",
     "symbol": "RBUS"
    },
    {
     "description": "BOSKALIS WESTMINSTER-ADR",
     "symbol": "RBWNY"
    },
    {
     "description": "RAINBOW RARE EARTHS LTD",
     "symbol": "RBWRF"
    },
    {
     "description": "RUBY CREEK RESOURCES INC",
     "symbol": "RBYC"
    },
    {
     "description": "REEBONZ HOLDING LTD",
     "symbol": "RBZHF"
    },
    {
     "description": "REEBONZ HOLDING LTD",
     "symbol": "RBZWF"
    },
    {
     "description": "READY CAPITAL CORP",
     "symbol": "RC"
    },
    {
     "description": "READY CAPITAL CORP",
     "symbol": "RC.PRC"
    },
    {
     "description": "READY CAPITAL CORP",
     "symbol": "RC.PRE"
    },
    {
     "description": "READY CAPITAL CORP",
     "symbol": "RCA"
    },
    {
     "description": "REVELSTONE CAPITAL ACQUISI-A",
     "symbol": "RCAC"
    },
    {
     "description": "REVELSTONE CAPITAL ACQUISITI",
     "symbol": "RCACU"
    },
    {
     "description": "REVELSTONE CAPITAL ACQU -28",
     "symbol": "RCACW"
    },
    {
     "description": "RENOVACARE INC",
     "symbol": "RCAR"
    },
    {
     "description": "RED CAT HOLDINGS INC",
     "symbol": "RCAT"
    },
    {
     "description": "READY CAPITAL CORP",
     "symbol": "RCB"
    },
    {
     "description": "RIVER CITY BANK\/CA",
     "symbol": "RCBC"
    },
    {
     "description": "READY CAPITAL CORP",
     "symbol": "RCC"
    },
    {
     "description": "ROCHESTER NY CMNTY BASEBALL",
     "symbol": "RCCB"
    },
    {
     "description": "G.E.T.T. GOLD INC",
     "symbol": "RCCMF"
    },
    {
     "description": "INVESCO S&P 500 EQUAL WEIGHT",
     "symbol": "RCD"
    },
    {
     "description": "RICARDO PLC",
     "symbol": "RCDOF"
    },
    {
     "description": "RECORDATI INDUSTRIA CHIMICA",
     "symbol": "RCDTF"
    },
    {
     "description": "AVITA MEDICAL INC",
     "symbol": "RCEL"
    },
    {
     "description": "RCF ACQUISITION CORP-A",
     "symbol": "RCFA"
    },
    {
     "description": "RCF ACQUISITION CORP",
     "symbol": "RCFA.U"
    },
    {
     "description": "RCF ACQUISITION CORP -CW23",
     "symbol": "RCFA.WS"
    },
    {
     "description": "RENN FUND INC",
     "symbol": "RCG"
    },
    {
     "description": "ROSCAN GOLD CORP",
     "symbol": "RCGCF"
    },
    {
     "description": "RECHARGE ACQUISITION CORP-A",
     "symbol": "RCHG"
    },
    {
     "description": "RECHARGE ACQUISITION CORP",
     "symbol": "RCHGU"
    },
    {
     "description": "RECHARGE ACQUISITION -CW27",
     "symbol": "RCHGW"
    },
    {
     "description": "ROUCHON INDUSTRIES INC",
     "symbol": "RCHN"
    },
    {
     "description": "RATCHABURI ELECTRICITY-NVDR",
     "symbol": "RCHUF"
    },
    {
     "description": "ROGERS COMMUNICATIONS INC-B",
     "symbol": "RCI"
    },
    {
     "description": "ROGERS COMMUNICATI-CL A CONV",
     "symbol": "RCIAF"
    },
    {
     "description": "RENT-A-CENTER INC",
     "symbol": "RCII"
    },
    {
     "description": "REELCAUSE INC",
     "symbol": "RCIT"
    },
    {
     "description": "ROCKHOPPER EXPLORATION PLC",
     "symbol": "RCKHF"
    },
    {
     "description": "ROCKET PHARMACEUTICALS INC",
     "symbol": "RCKT"
    },
    {
     "description": "ROCK TECH LITHIUM INC",
     "symbol": "RCKTF"
    },
    {
     "description": "ROCKY BRANDS INC",
     "symbol": "RCKY"
    },
    {
     "description": "ROCKET INTERNET SE",
     "symbol": "RCKZF"
    },
    {
     "description": "ROYAL CARIBBEAN CRUISES LTD",
     "symbol": "RCL"
    },
    {
     "description": "ROSECLIFF ACQUISITION CORP-A",
     "symbol": "RCLF"
    },
    {
     "description": "RCL FOODS LTD\/SOUTH AFRICA",
     "symbol": "RCLFF"
    },
    {
     "description": "ROSECLIFF ACQUISITION CORP I",
     "symbol": "RCLFU"
    },
    {
     "description": "ROSECLIFF ACQ A -CW27",
     "symbol": "RCLFW"
    },
    {
     "description": "R1 RCM INC",
     "symbol": "RCM"
    },
    {
     "description": "RUICHENG CHINA MEDIA GROUP",
     "symbol": "RCMGF"
    },
    {
     "description": "REACH MESSAGING HOLDINGS INC",
     "symbol": "RCMH"
    },
    {
     "description": "RCM TECHNOLOGIES INC",
     "symbol": "RCMT"
    },
    {
     "description": "RCMW GROUP INC",
     "symbol": "RCMW"
    },
    {
     "description": "RECON TECHNOLOGY LTD-CLASS A",
     "symbol": "RCON"
    },
    {
     "description": "RENOVACOR INC",
     "symbol": "RCOR"
    },
    {
     "description": "RENOVACOR INC          -CW25",
     "symbol": "RCOR.WS"
    },
    {
     "description": "RECIPHARM AB-B SHS",
     "symbol": "RCPHF"
    },
    {
     "description": "ROCK CREEK PHARMACEUTICALS I",
     "symbol": "RCPIQ"
    },
    {
     "description": "RECIPE UNLIMITED CORP",
     "symbol": "RCPUF"
    },
    {
     "description": "RECRUIT HOLDINGS CO LTD",
     "symbol": "RCRRF"
    },
    {
     "description": "RECRUITER.COM GROUP INC",
     "symbol": "RCRT"
    },
    {
     "description": "RECRUITER.COM GROUP -CW26",
     "symbol": "RCRTW"
    },
    {
     "description": "RECRUIT HOLDINGS CO LTD-ADR",
     "symbol": "RCRUY"
    },
    {
     "description": "PIMCO STRATEGIC INCOME FUND",
     "symbol": "RCS"
    },
    {
     "description": "READY CREDIT CORP",
     "symbol": "RCTC"
    },
    {
     "description": "ROCHESTER RESOURCES LTD",
     "symbol": "RCTFF"
    },
    {
     "description": "TRANS CANADA GOLD CORP",
     "symbol": "RCTRF"
    },
    {
     "description": "REEF CASINO TRUST",
     "symbol": "RCTUF"
    },
    {
     "description": "ROCKET CITY ENTERPRISES INC",
     "symbol": "RCTY"
    },
    {
     "description": "ARCUS BIOSCIENCES INC",
     "symbol": "RCUS"
    },
    {
     "description": "RIGHTCROWD LTD",
     "symbol": "RCWDF"
    },
    {
     "description": "ARMOR MINERALS INC",
     "symbol": "RCZRF"
    },
    {
     "description": "RAADR INC",
     "symbol": "RDAR"
    },
    {
     "description": "REDBUBBLE LTD",
     "symbol": "RDBBF"
    },
    {
     "description": "REDBUBBLE LTD-SPON ADR",
     "symbol": "RDBBY"
    },
    {
     "description": "REDBOX ENTERTAINMENT INC",
     "symbol": "RDBX"
    },
    {
     "description": "REDBOX ENTERTAINMENT -CW27",
     "symbol": "RDBXW"
    },
    {
     "description": "RADCOM LTD",
     "symbol": "RDCM"
    },
    {
     "description": "REDEFY CORP",
     "symbol": "RDCO"
    },
    {
     "description": "REDISHRED CAPITAL CORP",
     "symbol": "RDCPF"
    },
    {
     "description": "RADIENT TECHNOLOGIES INC",
     "symbol": "RDDTF"
    },
    {
     "description": "RADIANT ENERGY CORP",
     "symbol": "RDEGF"
    },
    {
     "description": "RED ELECTRICA CORPORACION SA",
     "symbol": "RDEIF"
    },
    {
     "description": "RED ELECTRICA COR-UNSPON ADR",
     "symbol": "RDEIY"
    },
    {
     "description": "RED EAGLE MINING CORP",
     "symbol": "RDEMF"
    },
    {
     "description": "RED PINE EXPLORATION INC",
     "symbol": "RDEXF"
    },
    {
     "description": "REDFIELD ENERGY LLC",
     "symbol": "RDFD"
    },
    {
     "description": "BROOKSIDE ENERGY LTD",
     "symbol": "RDFEF"
    },
    {
     "description": "RAREVIEW DYNAMIC FIXED INCOM",
     "symbol": "RDFI"
    },
    {
     "description": "REDFIN CORP",
     "symbol": "RDFN"
    },
    {
     "description": "REDCORP VENTURES LTD",
     "symbol": "RDFVF"
    },
    {
     "description": "RIDGEFIELD ACQUISITION CORP",
     "symbol": "RDGA"
    },
    {
     "description": "VIVOS INC",
     "symbol": "RDGL"
    },
    {
     "description": "RIDGELINE MINERALS CORP",
     "symbol": "RDGMF"
    },
    {
     "description": "REDHILL BIOPHARMA LTD-SP ADR",
     "symbol": "RDHL"
    },
    {
     "description": "READING INTERNATIONAL INC-A",
     "symbol": "RDI"
    },
    {
     "description": "READING INTERNATIONAL INC-B",
     "symbol": "RDIB"
    },
    {
     "description": "INVESCO S&P ULTRA DIVIDEND",
     "symbol": "RDIV"
    },
    {
     "description": "REDLINE COMMUNICATIONS GROUP",
     "symbol": "RDLCF"
    },
    {
     "description": "REEDY LAGOON CORP LTD",
     "symbol": "RDLGF"
    },
    {
     "description": "RELX NV",
     "symbol": "RDLSF"
    },
    {
     "description": "READLY INTERNATIONAL AB",
     "symbol": "RDLYF"
    },
    {
     "description": "RED MILE ENTERTAINMENT INC",
     "symbol": "RDML"
    },
    {
     "description": "RED METAL LTD",
     "symbol": "RDMMF"
    },
    {
     "description": "SPDR BBG SASB DEV X-US ESG",
     "symbol": "RDMX"
    },
    {
     "description": "RADIAN GROUP INC",
     "symbol": "RDN"
    },
    {
     "description": "RADNET INC",
     "symbol": "RDNT"
    },
    {
     "description": "ALPS REIT DIVIDEND DOGS ETF",
     "symbol": "RDOG"
    },
    {
     "description": "RODINIA OIL CORP",
     "symbol": "RDOIF"
    },
    {
     "description": "REDEFINE PROPERTIES LTD",
     "symbol": "RDPEF"
    },
    {
     "description": "RADIOPHARM THERANOSTICS LTD",
     "symbol": "RDPTF"
    },
    {
     "description": "NEOMETALS LTD-SPON ADR",
     "symbol": "RDRUY"
    },
    {
     "description": "RED SKY ENERGY LTD",
     "symbol": "RDSKF"
    },
    {
     "description": "KONINKLIJKE DSM NV-SPONS ADR",
     "symbol": "RDSMY"
    },
    {
     "description": "RAPID DOSE THERAPEUTICS CORP",
     "symbol": "RDTCF"
    },
    {
     "description": "RED TIGER MINING INC",
     "symbol": "RDTMF"
    },
    {
     "description": "RADIUS GOLD INC",
     "symbol": "RDUFF"
    },
    {
     "description": "RADIUS HEALTH INC",
     "symbol": "RDUS"
    },
    {
     "description": "RDVA INC",
     "symbol": "RDVA"
    },
    {
     "description": "RED VIOLET INC",
     "symbol": "RDVT"
    },
    {
     "description": "RADVIEW SOFTWARE LTD",
     "symbol": "RDVWF"
    },
    {
     "description": "FIRST TRUST RISING DIVIDEND",
     "symbol": "RDVY"
    },
    {
     "description": "REDWIRE CORP",
     "symbol": "RDW"
    },
    {
     "description": "REDWIRE CORP          -CW27",
     "symbol": "RDW.WS"
    },
    {
     "description": "REDWOOD GROUP INTERNATIONAL",
     "symbol": "RDWD"
    },
    {
     "description": "RADWARE LTD",
     "symbol": "RDWR"
    },
    {
     "description": "REDROW PLC",
     "symbol": "RDWWF"
    },
    {
     "description": "DR. REDDY'S LABORATORIES-ADR",
     "symbol": "RDY"
    },
    {
     "description": "READY SET GOLD CORP",
     "symbol": "RDYFF"
    },
    {
     "description": "EVEREST RE GROUP LTD",
     "symbol": "RE"
    },
    {
     "description": "REAC GROUP INC",
     "symbol": "REAC"
    },
    {
     "description": "REALREAL INC\/THE",
     "symbol": "REAL"
    },
    {
     "description": "REAL BROKERAGE INC\/THE",
     "symbol": "REAX"
    },
    {
     "description": "REBEL GROUP INC",
     "symbol": "REBL"
    },
    {
     "description": "REBOSIS PROPERTY FUND LTD",
     "symbol": "REBOF"
    },
    {
     "description": "EMLES REAL ESTATE CREDIT ETF",
     "symbol": "REC"
    },
    {
     "description": "RECONNAISSANCE ENERGY AFRICA",
     "symbol": "RECAF"
    },
    {
     "description": "RECCE PHARMACEUTICALS LTD",
     "symbol": "RECEF"
    },
    {
     "description": "REAL ESTATE CREDIT INV LTD",
     "symbol": "RECIF"
    },
    {
     "description": "RECONSTRUCTION CAPITAL II LD",
     "symbol": "RECOF"
    },
    {
     "description": "COLUMBIA RESRH ENHANCED CORE",
     "symbol": "RECS"
    },
    {
     "description": "RECONNAISSANCE ENERGY -CW24",
     "symbol": "RECWF"
    },
    {
     "description": "REDIFF.COM INDIA LIMITED-ADR",
     "symbol": "REDFY"
    },
    {
     "description": "RED 5 LTD",
     "symbol": "REDLF"
    },
    {
     "description": "RISE EDUCATION CAYMAN - ADR",
     "symbol": "REDU"
    },
    {
     "description": "REDWOOD FINANCIAL INC",
     "symbol": "REDW"
    },
    {
     "description": "REE AUTOMOTIVE LTD - CLASS A",
     "symbol": "REE"
    },
    {
     "description": "REE AUTOMOTIVE LTD -A -CW26",
     "symbol": "REEAW"
    },
    {
     "description": "REECE LTD",
     "symbol": "REECF"
    },
    {
     "description": "REED'S INC",
     "symbol": "REED"
    },
    {
     "description": "RAREX LTD",
     "symbol": "REEEF"
    },
    {
     "description": "RESOURCES & ENERGY GROUP LTD",
     "symbol": "REEGF"
    },
    {
     "description": "RARE ELEMENT RESOURCES LTD",
     "symbol": "REEMF"
    },
    {
     "description": "ISHARES GLOBAL REIT ETF",
     "symbol": "REET"
    },
    {
     "description": "MEDICAL CANNABIS PAYMENT SOL",
     "symbol": "REFG"
    },
    {
     "description": "REF HOLDINGS",
     "symbol": "REFHF"
    },
    {
     "description": "CHICAGO ATLANTIC REAL ESTATE",
     "symbol": "REFI"
    },
    {
     "description": "RESEARCH FRONTIERS INC",
     "symbol": "REFR"
    },
    {
     "description": "REDFLOW LTD",
     "symbol": "REFXF"
    },
    {
     "description": "REGENCY CENTERS CORP",
     "symbol": "REG"
    },
    {
     "description": "RENEWABLE ENERGY GROUP INC",
     "symbol": "REGI"
    },
    {
     "description": "PRSHRS S&P MID 400 DVD ARIST",
     "symbol": "REGL"
    },
    {
     "description": "REMEGEN CO LTD-H",
     "symbol": "REGMF"
    },
    {
     "description": "REMEGEN CO LTD-UNSPONS ADR",
     "symbol": "REGMY"
    },
    {
     "description": "REGENERON PHARMACEUTICALS",
     "symbol": "REGN"
    },
    {
     "description": "GRAPH BLOCKCHAIN INC",
     "symbol": "REGRF"
    },
    {
     "description": "RED TRAIL ENERGY LLC-MEMB UN",
     "symbol": "REGX"
    },
    {
     "description": "RING ENERGY INC",
     "symbol": "REI"
    },
    {
     "description": "ALPS ACTIVE REIT ETF",
     "symbol": "REIT"
    },
    {
     "description": "PROSHARES SHORT REAL ESTATE",
     "symbol": "REK"
    },
    {
     "description": "REKOR SYSTEMS INC",
     "symbol": "REKR"
    },
    {
     "description": "NOVUME SOLUTIONS INC-CW23",
     "symbol": "REKRW"
    },
    {
     "description": "RELIANCE INFRASTRUCTURE-GDR",
     "symbol": "RELFF"
    },
    {
     "description": "RELIANCE GLOBAL GROUP INC",
     "symbol": "RELI"
    },
    {
     "description": "RELIANCE GLOBAL -CW26",
     "symbol": "RELIW"
    },
    {
     "description": "RICHARDSON ELEC LTD",
     "symbol": "RELL"
    },
    {
     "description": "RELM HOLDINGS INC",
     "symbol": "RELM"
    },
    {
     "description": "RELO GROUP INC",
     "symbol": "RELOF"
    },
    {
     "description": "RELIANT HOLDINGS INC",
     "symbol": "RELT"
    },
    {
     "description": "RELIV INTERNATIONAL INC",
     "symbol": "RELV"
    },
    {
     "description": "RELX PLC - SPON ADR",
     "symbol": "RELX"
    },
    {
     "description": "REMITLY GLOBAL INC",
     "symbol": "RELY"
    },
    {
     "description": "ISHARES MORTGAGE REAL ESTATE",
     "symbol": "REM"
    },
    {
     "description": "SPDR BBG SASB E\/M ESG SELECT",
     "symbol": "REMG"
    },
    {
     "description": "REMEDENT INC",
     "symbol": "REMI"
    },
    {
     "description": "ATLAS SALT INC",
     "symbol": "REMRF"
    },
    {
     "description": "VANECK RARE EARTH\/STRAT MET",
     "symbol": "REMX"
    },
    {
     "description": "REMY COINTREAU",
     "symbol": "REMYF"
    },
    {
     "description": "REMY COINTREAU-UNSP ADR",
     "symbol": "REMYY"
    },
    {
     "description": "RENREN INC-ADR",
     "symbol": "RENN"
    },
    {
     "description": "RENOVARE ENVIRONMENTAL INC",
     "symbol": "RENO"
    },
    {
     "description": "RENT THE RUNWAY INC-A",
     "symbol": "RENT"
    },
    {
     "description": "RENUEN CORP",
     "symbol": "RENU"
    },
    {
     "description": "REO PLASTICS INC",
     "symbol": "REOP"
    },
    {
     "description": "REOSTAR ENERGY CORP",
     "symbol": "REOS"
    },
    {
     "description": "RENOVA INC",
     "symbol": "REOVF"
    },
    {
     "description": "REPLICEL LIFE SCIENCES INC",
     "symbol": "REPCF"
    },
    {
     "description": "REPLIMUNE GROUP INC",
     "symbol": "REPL"
    },
    {
     "description": "NATIONAL ASSET RECOVERY CORP",
     "symbol": "REPO"
    },
    {
     "description": "RILEY EXPLORATION PERMIAN IN",
     "symbol": "REPX"
    },
    {
     "description": "REPSOL SA",
     "symbol": "REPYF"
    },
    {
     "description": "REPSOL SA-SPONSORED ADR",
     "symbol": "REPYY"
    },
    {
     "description": "ATRENEW INC",
     "symbol": "RERE"
    },
    {
     "description": "RPC INC",
     "symbol": "RES"
    },
    {
     "description": "RESCAP LIQUIDATING TRUST",
     "symbol": "RESCU"
    },
    {
     "description": "WISDOMTREE INTERNATIONAL ESG",
     "symbol": "RESD"
    },
    {
     "description": "WISDOMTREE EM MKT ESG FUND",
     "symbol": "RESE"
    },
    {
     "description": "KELLY RESIDENTIAL & APARTMEN",
     "symbol": "RESI"
    },
    {
     "description": "WISDOMTREE US ESG FUND",
     "symbol": "RESP"
    },
    {
     "description": "REATA PHARMACEUTICALS INC-A",
     "symbol": "RETA"
    },
    {
     "description": "12 RETECH CORP",
     "symbol": "RETC"
    },
    {
     "description": "REIT 1 LTD",
     "symbol": "RETDF"
    },
    {
     "description": "DIREXION DLY RETAIL BULL 3X",
     "symbol": "RETL"
    },
    {
     "description": "RETO ECO-SOLUTIONS INC",
     "symbol": "RETO"
    },
    {
     "description": "REVLON INC-CLASS A",
     "symbol": "REV"
    },
    {
     "description": "REVELATION BIOSCIENCES INC",
     "symbol": "REVB"
    },
    {
     "description": "PETRA ACQUISITION INC",
     "symbol": "REVBU"
    },
    {
     "description": "PETRA ACQUISITION INC -CW27",
     "symbol": "REVBW"
    },
    {
     "description": "ALPINE ACQUISITION CORP",
     "symbol": "REVE"
    },
    {
     "description": "ALPINE ACQUISITION CORP",
     "symbol": "REVEU"
    },
    {
     "description": "ALPINE ACQUISITION COR -CW23",
     "symbol": "REVEW"
    },
    {
     "description": "REV GROUP INC",
     "symbol": "REVG"
    },
    {
     "description": "REVOLUTION HEALTHCARE ACQU-A",
     "symbol": "REVH"
    },
    {
     "description": "REVOLUTION HEALTHCARE ACQUIS",
     "symbol": "REVHU"
    },
    {
     "description": "REVOLUTION HEALTHCARE -CW28",
     "symbol": "REVHW"
    },
    {
     "description": "REINET INVESTMENTS SCA",
     "symbol": "REVNF"
    },
    {
     "description": "COLUMBIA RESEARCH ENHANCED V",
     "symbol": "REVS"
    },
    {
     "description": "RIVERSTONE HOLDINGS LTD",
     "symbol": "REVSF"
    },
    {
     "description": "REVENIO GROUP OYJ",
     "symbol": "REVXF"
    },
    {
     "description": "PROSHARES ULTRASHORT TECH",
     "symbol": "REW"
    },
    {
     "description": "REX AMERICAN RESOURCES CORP",
     "symbol": "REX"
    },
    {
     "description": "REX INTERNATIONAL HOLDING",
     "symbol": "REXHF"
    },
    {
     "description": "RIDE ON EXPRESS HOLDINGS CO",
     "symbol": "REXOF"
    },
    {
     "description": "REXFORD INDUSTRIAL REALTY IN",
     "symbol": "REXR"
    },
    {
     "description": "REXFORD INDUSTRIAL REALT",
     "symbol": "REXR.PRB"
    },
    {
     "description": "REXFORD INDUSTRIAL REALT",
     "symbol": "REXR.PRC"
    },
    {
     "description": "REYNA GOLD CORP",
     "symbol": "REYGF"
    },
    {
     "description": "REYNOLDS CONSUMER PRODUCTS I",
     "symbol": "REYN"
    },
    {
     "description": "ISHARS RES AND MULTI REALES",
     "symbol": "REZ"
    },
    {
     "description": "RESIDEO TECHNOLOGIES INC",
     "symbol": "REZI"
    },
    {
     "description": "HASH CORP\/THE",
     "symbol": "REZNF"
    },
    {
     "description": "GLOBAL BATTERY METALS LTD",
     "symbol": "REZZF"
    },
    {
     "description": "REGIONS FINANCIAL CORP",
     "symbol": "RF"
    },
    {
     "description": "REGIONS FINANCIAL CORP",
     "symbol": "RF.PRB"
    },
    {
     "description": "REGIONS FINANCIAL CORP",
     "symbol": "RF.PRC"
    },
    {
     "description": "REGIONS FINANCIAL CORP",
     "symbol": "RF.PRE"
    },
    {
     "description": "RF ACQUISITION CORP - CL A",
     "symbol": "RFAC"
    },
    {
     "description": "RF ACQUISITION CORP- RIGHTS",
     "symbol": "RFACR"
    },
    {
     "description": "RF ACQUISITION CORP",
     "symbol": "RFACU"
    },
    {
     "description": "RF ACQUISITION CORP-CW27",
     "symbol": "RFACW"
    },
    {
     "description": "ROMANA FOOD BRANDS CORP",
     "symbol": "RFBC"
    },
    {
     "description": "RIVERFRONT DYNAMIC CORE INC",
     "symbol": "RFCI"
    },
    {
     "description": "REFOCUS GROUP INC",
     "symbol": "RFCS"
    },
    {
     "description": "RIVERFRONT DYNAMIC US DV ETF",
     "symbol": "RFDA"
    },
    {
     "description": "FIRST TRST DYN DEVEL INT ETF",
     "symbol": "RFDI"
    },
    {
     "description": "FIRST TRUST RIVERFRONT DYNAM",
     "symbol": "RFEM"
    },
    {
     "description": "FIRST TR DYNAMIC EUROPE ETF",
     "symbol": "RFEU"
    },
    {
     "description": "RIVERFRONT DYNAMIC US FC ETF",
     "symbol": "RFFC"
    },
    {
     "description": "REDFIELD ENERGY LL-UNIT CL A",
     "symbol": "RFFDU"
    },
    {
     "description": "INVESCO S&P MIDCAP 400 PURE",
     "symbol": "RFG"
    },
    {
     "description": "RETAIL FOOD GROUP LTD",
     "symbol": "RFGPF"
    },
    {
     "description": "RENFORTH RESOURCES INC",
     "symbol": "RFHRF"
    },
    {
     "description": "COHEN & STEERS TOT RET RLTY",
     "symbol": "RFI"
    },
    {
     "description": "RAIN FOREST INTERNATIONAL IN",
     "symbol": "RFII"
    },
    {
     "description": "RF INDUSTRIES LTD",
     "symbol": "RFIL"
    },
    {
     "description": "RAFAEL HOLDINGS INC-CLASS B",
     "symbol": "RFL"
    },
    {
     "description": "RAFFLES EDUCATION CORP LTD",
     "symbol": "RFLFF"
    },
    {
     "description": "RAFFLES EDUCATION-UNSP ADR",
     "symbol": "RFLFY"
    },
    {
     "description": "RIVERNORTH FLEXIBLE MUNI",
     "symbol": "RFM"
    },
    {
     "description": "RIVERNORTH FLEX MUNI II",
     "symbol": "RFMZ"
    },
    {
     "description": "RURAL FUNDS GROUP",
     "symbol": "RFNDF"
    },
    {
     "description": "RELIANT FINANCIAL SERVICE",
     "symbol": "RFNS"
    },
    {
     "description": "RESOLUTE FOREST PRODUCTS",
     "symbol": "RFP"
    },
    {
     "description": "INVESCO S&P MIDCAP 400 PURE",
     "symbol": "RFV"
    },
    {
     "description": "RUNNING FOX RESOURCE CORP",
     "symbol": "RFXRF"
    },
    {
     "description": "REINSURANCE GROUP OF AMERICA",
     "symbol": "RGA"
    },
    {
     "description": "REGIONAL BRANDS INC",
     "symbol": "RGBD"
    },
    {
     "description": "REGEN BIOLOGICS INC",
     "symbol": "RGBOQ"
    },
    {
     "description": "REGEN BIOPHARMA INC",
     "symbol": "RGBP"
    },
    {
     "description": "Regen Biopharma Inc",
     "symbol": "RGBPP"
    },
    {
     "description": "REGENCELL BIOSCIENCE HOLDING",
     "symbol": "RGC"
    },
    {
     "description": "RGC RESOURCES INC",
     "symbol": "RGCO"
    },
    {
     "description": "RDX TECHNOLOGIES CORP",
     "symbol": "RGDEF"
    },
    {
     "description": "REUNION GOLD CORP",
     "symbol": "RGDFF"
    },
    {
     "description": "RESPONSE GENETICS INC",
     "symbol": "RGDXQ"
    },
    {
     "description": "RICHTER GEDEON NYRT",
     "symbol": "RGEDF"
    },
    {
     "description": "REPLIGEN CORP",
     "symbol": "RGEN"
    },
    {
     "description": "RESOURCE GENERATION LTD",
     "symbol": "RGEXF"
    },
    {
     "description": "REAL GOOD FOOD CO INC\/THE",
     "symbol": "RGF"
    },
    {
     "description": "RESGREEN GROUP INTERNATIONAL",
     "symbol": "RGGI"
    },
    {
     "description": "REGIONAL REIT LTD",
     "symbol": "RGGLF"
    },
    {
     "description": "INVESCO S&P 500 EQUAL WEIGHT",
     "symbol": "RGI"
    },
    {
     "description": "REGENICIN INC",
     "symbol": "RGIN"
    },
    {
     "description": "SPAREBANK 1 RINGERIKE HADELA",
     "symbol": "RGKSF"
    },
    {
     "description": "ROYAL GOLD INC",
     "symbol": "RGLD"
    },
    {
     "description": "UHF LOGISTICS GROUP INC",
     "symbol": "RGLG"
    },
    {
     "description": "REGULUS THERAPEUTICS INC",
     "symbol": "RGLS"
    },
    {
     "description": "REGULUS RESOURCES INC",
     "symbol": "RGLSF"
    },
    {
     "description": "RTL GROUP",
     "symbol": "RGLXF"
    },
    {
     "description": "RTL GROUP SA-UNSPONSORED ADR",
     "symbol": "RGLXY"
    },
    {
     "description": "REGNUM CORP",
     "symbol": "RGMP"
    },
    {
     "description": "RENERGEN LTD",
     "symbol": "RGNNF"
    },
    {
     "description": "RENERGEN LTD-CDI",
     "symbol": "RGNTF"
    },
    {
     "description": "REGENXBIO INC",
     "symbol": "RGNX"
    },
    {
     "description": "RESOURCES CONNECTION INC",
     "symbol": "RGP"
    },
    {
     "description": "RATCH GROUP PCL-FOREIGN",
     "symbol": "RGPCF"
    },
    {
     "description": "ENWELL ENERGY PLC",
     "symbol": "RGPMF"
    },
    {
     "description": "STURM RUGER & CO INC",
     "symbol": "RGR"
    },
    {
     "description": "STAR PHOENIX GROUP LTD",
     "symbol": "RGRLF"
    },
    {
     "description": "REGIS RESOURCES LTD",
     "symbol": "RGRNF"
    },
    {
     "description": "REGENERX BIOPHARMACEUTICALS",
     "symbol": "RGRX"
    },
    {
     "description": "REGIS CORP",
     "symbol": "RGS"
    },
    {
     "description": "REAL GOODS SOLAR INC-CLASS A",
     "symbol": "RGSEQ"
    },
    {
     "description": "RESOURCES GLOBAL SERVICES GR",
     "symbol": "RGSG"
    },
    {
     "description": "ROGUE STATION COMPANIES INC",
     "symbol": "RGST"
    },
    {
     "description": "ROYCE GLOBAL VALUE TRUST",
     "symbol": "RGT"
    },
    {
     "description": "RIGETTI COMPUTING INC",
     "symbol": "RGTI"
    },
    {
     "description": "RIGETTI COMPUTING -CW27",
     "symbol": "RGTIW"
    },
    {
     "description": "REGI US INC",
     "symbol": "RGUS"
    },
    {
     "description": "REGENT VENTURES LTD",
     "symbol": "RGVNF"
    },
    {
     "description": "REMEGENIX INC",
     "symbol": "RGXX"
    },
    {
     "description": "RH",
     "symbol": "RH"
    },
    {
     "description": "Regional Health Properties Inc",
     "symbol": "RHB.PRB"
    },
    {
     "description": "RHB BANK BHD",
     "symbol": "RHBAF"
    },
    {
     "description": "BNY RESPONSIBLE HORIZONS CB",
     "symbol": "RHCB"
    },
    {
     "description": "RHC HELIUM LTD",
     "symbol": "RHCCF"
    },
    {
     "description": "RYMAN HEALTHCARE LTD",
     "symbol": "RHCGF"
    },
    {
     "description": "READEN HOLDING CORP",
     "symbol": "RHCO"
    },
    {
     "description": "RETAIL HOLDINGS NV",
     "symbol": "RHDGF"
    },
    {
     "description": "REGIONAL HEALTH PROPERTIES",
     "symbol": "RHE"
    },
    {
     "description": "REGIONAL HEALTH PROP INC",
     "symbol": "RHE.PRA"
    },
    {
     "description": "ROCHE HOLDING AG-BR",
     "symbol": "RHHBF"
    },
    {
     "description": "ROCHE HOLDINGS LTD-SPONS ADR",
     "symbol": "RHHBY"
    },
    {
     "description": "RHI MAGNESITA NV-ADR",
     "symbol": "RHHMY"
    },
    {
     "description": "ROCHE HOLDING AG-GENUSSCHEIN",
     "symbol": "RHHVF"
    },
    {
     "description": "ROBERT HALF INTL INC",
     "symbol": "RHI"
    },
    {
     "description": "ROUND HILL MUSIC ROYALTY FUN",
     "symbol": "RHILF"
    },
    {
     "description": "RHOEN-KLINIKUM AG",
     "symbol": "RHKJF"
    },
    {
     "description": "RHINOMED LTD",
     "symbol": "RHNMF"
    },
    {
     "description": "RYMAN HOSPITALITY PROPERTIES",
     "symbol": "RHP"
    },
    {
     "description": "RH TACTICAL ROTATION ETF",
     "symbol": "RHRX"
    },
    {
     "description": "RHYOLITE RESOURCES LTD",
     "symbol": "RHRYF"
    },
    {
     "description": "INVESCO S&P 500 EQUAL WEIGHT",
     "symbol": "RHS"
    },
    {
     "description": "RH TACTICAL OUTLOOK",
     "symbol": "RHTX"
    },
    {
     "description": "RICHELIEU HARDWARE LTD",
     "symbol": "RHUHF"
    },
    {
     "description": "RIVER HAWK AVIATION INC",
     "symbol": "RHWI"
    },
    {
     "description": "SOUTHERN CONCEPTS RESTAURANT",
     "symbol": "RIBS"
    },
    {
     "description": "RICEBRAN TECHNOLOGIES",
     "symbol": "RIBT"
    },
    {
     "description": "RECORDATI INDUSTRIA-UNSP ADR",
     "symbol": "RICFY"
    },
    {
     "description": "RCI HOSPITALITY HOLDINGS INC",
     "symbol": "RICK"
    },
    {
     "description": "AGRICO ACQUISITION CORP-A",
     "symbol": "RICO"
    },
    {
     "description": "RICOH CO LTD",
     "symbol": "RICOF"
    },
    {
     "description": "AGRICO ACQUISITION CORP",
     "symbol": "RICOU"
    },
    {
     "description": "AGRICO ACQUISITION A -CW28",
     "symbol": "RICOW"
    },
    {
     "description": "RICOH CO LTD-SPONSORED ADR",
     "symbol": "RICOY"
    },
    {
     "description": "LORDSTOWN MOTORS CORP-CL A",
     "symbol": "RIDE"
    },
    {
     "description": "RIDLEY CORP LTD",
     "symbol": "RIDYF"
    },
    {
     "description": "HOYA CAPITAL HI DVD YLD ETF",
     "symbol": "RIET"
    },
    {
     "description": "TRANSOCEAN LTD",
     "symbol": "RIG"
    },
    {
     "description": "RICHLAND RESOURCES INTERNATI",
     "symbol": "RIGG"
    },
    {
     "description": "RIGHTSMILE INC",
     "symbol": "RIGH"
    },
    {
     "description": "RIGEL PHARMACEUTICALS INC",
     "symbol": "RIGL"
    },
    {
     "description": "RIDGESTONE MINING INC",
     "symbol": "RIGMF"
    },
    {
     "description": "RIVERFRONT STRATEGIC INCOME",
     "symbol": "RIGS"
    },
    {
     "description": "VIRIDI CLEAN EN CRYPT MIN IN",
     "symbol": "RIGZ"
    },
    {
     "description": "RIGHTSCORP INC",
     "symbol": "RIHT"
    },
    {
     "description": "RENAVOTIO INC",
     "symbol": "RIII"
    },
    {
     "description": "BRAVEHEART RESOURCES INC",
     "symbol": "RIINF"
    },
    {
     "description": "B. RILEY FINANCIAL INC",
     "symbol": "RILY"
    },
    {
     "description": "B RILEY FINANCIAL INC",
     "symbol": "RILYG"
    },
    {
     "description": "B RILEY FINANCIAL INC",
     "symbol": "RILYK"
    },
    {
     "description": "B RILEY FINANCIAL INC",
     "symbol": "RILYL"
    },
    {
     "description": "B RILEY FINANCIAL INC",
     "symbol": "RILYM"
    },
    {
     "description": "B RILEY FINANCIAL INC",
     "symbol": "RILYN"
    },
    {
     "description": "B RILEY FINANCIAL INC",
     "symbol": "RILYO"
    },
    {
     "description": "B RILEY FINANCIAL INC",
     "symbol": "RILYP"
    },
    {
     "description": "B RILEY FINANCIAL INC",
     "symbol": "RILYT"
    },
    {
     "description": "B RILEY FINANCIAL INC",
     "symbol": "RILYZ"
    },
    {
     "description": "PROSHARES INFLATION EXPECTAT",
     "symbol": "RINF"
    },
    {
     "description": "ISHARES MSCI GLOBAL GOLD MIN",
     "symbol": "RING"
    },
    {
     "description": "RINNAI CORP",
     "symbol": "RINIF"
    },
    {
     "description": "RINNAI CORP - UNSP ADR",
     "symbol": "RINIY"
    },
    {
     "description": "RINO INTERNATIONAL CORP",
     "symbol": "RINO"
    },
    {
     "description": "RIO TINTO PLC-SPON ADR",
     "symbol": "RIO"
    },
    {
     "description": "RIOCAN REAL ESTATE INVST TR",
     "symbol": "RIOCF"
    },
    {
     "description": "RIO2 LTD\/NEW",
     "symbol": "RIOFF"
    },
    {
     "description": "RIOT BLOCKCHAIN INC",
     "symbol": "RIOT"
    },
    {
     "description": "RION CO LTD",
     "symbol": "RIOXF"
    },
    {
     "description": "INSPIRE TACTICAL BALANCED ES",
     "symbol": "RISN"
    },
    {
     "description": "FOLIOBEYOND RISING RATES ETF",
     "symbol": "RISR"
    },
    {
     "description": "ETFB GREEN SRI REITS ETF",
     "symbol": "RITA"
    },
    {
     "description": "MINERALRITE CORP",
     "symbol": "RITE"
    },
    {
     "description": "RIT CAPITAL PARTNERS PLC",
     "symbol": "RITPF"
    },
    {
     "description": "RIT TECHNOLOGIES LTD",
     "symbol": "RITT"
    },
    {
     "description": "RIVERNORTH OPPORTUNITIES FND",
     "symbol": "RIV"
    },
    {
     "description": "RIVER & MERCANTILE GROUP",
     "symbol": "RIVMF"
    },
    {
     "description": "RIVIAN AUTOMOTIVE INC-A",
     "symbol": "RIVN"
    },
    {
     "description": "RiverNorth Opportunities Fund Inc",
     "symbol": "RIVOP"
    },
    {
     "description": "RIVIERA TOOL CO",
     "symbol": "RIVT"
    },
    {
     "description": "RIVULET MEDIA INC",
     "symbol": "RIVU"
    },
    {
     "description": "RIVEX TECHNOLOGY CORP",
     "symbol": "RIVX"
    },
    {
     "description": "ELEMENTS ROGERS AGRI TOT RET",
     "symbol": "RJA"
    },
    {
     "description": "JACKSON ACQUISITION CO-CL A",
     "symbol": "RJAC"
    },
    {
     "description": "JACKSON ACQUISITION CO",
     "symbol": "RJAC.U"
    },
    {
     "description": "JACKSON ACQUISITION A -CW28",
     "symbol": "RJAC.WS"
    },
    {
     "description": "RJD GREEN INC",
     "symbol": "RJDG"
    },
    {
     "description": "RAYMOND JAMES FINANCIAL INC",
     "symbol": "RJF"
    },
    {
     "description": "ELEMENTS ROGERS TOTAL RETURN",
     "symbol": "RJI"
    },
    {
     "description": "ROJANA INDUS PARK PCL-FORGN",
     "symbol": "RJIFF"
    },
    {
     "description": "RJK EXPLORATIONS LTD-CL A",
     "symbol": "RJKAF"
    },
    {
     "description": "ELEMENTS ROGERS ENERGY TR",
     "symbol": "RJN"
    },
    {
     "description": "ELEMENTS ROGERS METALS TR",
     "symbol": "RJZ"
    },
    {
     "description": "RHOEN KLINIKUM AG-UNSPON ADR",
     "symbol": "RKAGY"
    },
    {
     "description": "ROCKCLIFF METALS CORP",
     "symbol": "RKCLF"
    },
    {
     "description": "ARCADIA BIOSCIENCES INC",
     "symbol": "RKDA"
    },
    {
     "description": "ROCKETFUEL BLOCKCHAIN INC",
     "symbol": "RKFL"
    },
    {
     "description": "ROAD KING INFRASTRUCTURE LTD",
     "symbol": "RKGXF"
    },
    {
     "description": "ROCKHAVEN RESOURCES LTD",
     "symbol": "RKHNF"
    },
    {
     "description": "MIROKU JYOHO SERVICE CO LTD",
     "symbol": "RKICF"
    },
    {
     "description": "REKO INTERNATIONAL GROUP INC",
     "symbol": "RKIGF"
    },
    {
     "description": "ROCKET LAB USA INC",
     "symbol": "RKLB"
    },
    {
     "description": "ROCKELLE CORP",
     "symbol": "RKLC"
    },
    {
     "description": "RENTOKIL INITIAL PLC",
     "symbol": "RKLIF"
    },
    {
     "description": "ROCKLEY PHOTONICS HOLDINGS L",
     "symbol": "RKLY"
    },
    {
     "description": "ROCKLEY PHOTONICS HOL -CW26",
     "symbol": "RKLY.WS"
    },
    {
     "description": "ROKMASTER RESOURCES CORP",
     "symbol": "RKMSF"
    },
    {
     "description": "RIKEN CORP",
     "symbol": "RKNCF"
    },
    {
     "description": "OPTIVA INC",
     "symbol": "RKNEF"
    },
    {
     "description": "ARKOSE ENERGY CORP",
     "symbol": "RKOS"
    },
    {
     "description": "RAKSUL INC",
     "symbol": "RKSLF"
    },
    {
     "description": "ROCKET COS INC-CLASS A",
     "symbol": "RKT"
    },
    {
     "description": "ROCKET INTERNET GROWTH OPP-A",
     "symbol": "RKTA"
    },
    {
     "description": "ROCKET INTERNET GROWTH OPPOR",
     "symbol": "RKTA.U"
    },
    {
     "description": "ROCKET INTERNET GROWTH -CW27",
     "symbol": "RKTA.WS"
    },
    {
     "description": "REFLECTKOTE INC",
     "symbol": "RKTE"
    },
    {
     "description": "RAKUTEN GROUP INC",
     "symbol": "RKUNF"
    },
    {
     "description": "RAKUTEN GROUP INC-ADR",
     "symbol": "RKUNY"
    },
    {
     "description": "ROCKWOOL A\/S-A SHS",
     "symbol": "RKWAF"
    },
    {
     "description": "ROCKWOOL A\/S-B SHS",
     "symbol": "RKWBF"
    },
    {
     "description": "RALPH LAUREN CORP",
     "symbol": "RL"
    },
    {
     "description": "REAL AMERICAN CAPITAL CORP",
     "symbol": "RLAB"
    },
    {
     "description": "RELAY THERAPEUTICS INC",
     "symbol": "RLAY"
    },
    {
     "description": "REAL BRANDS INC",
     "symbol": "RLBD"
    },
    {
     "description": "RELIABILITY INC",
     "symbol": "RLBY"
    },
    {
     "description": "ROLAND CORP",
     "symbol": "RLDCF"
    },
    {
     "description": "ROLAND DG CORP",
     "symbol": "RLDGF"
    },
    {
     "description": "RAMI LEVY CHAIN STORES HASHI",
     "symbol": "RLEVF"
    },
    {
     "description": "RELIEF THERAPEUTICS HOLDING",
     "symbol": "RLFTF"
    },
    {
     "description": "RELIEF THERAPEUTI -SPON ADR",
     "symbol": "RLFTY"
    },
    {
     "description": "REAL GOOD FOOD PLC",
     "symbol": "RLGDF"
    },
    {
     "description": "WEST RED LAKE GOLD MINES INC",
     "symbol": "RLGMF"
    },
    {
     "description": "RADIANT LOGISTICS INC",
     "symbol": "RLGT"
    },
    {
     "description": "REALOGY HOLDINGS CORP",
     "symbol": "RLGY"
    },
    {
     "description": "RLH PROPERTIES SAB DE CV",
     "symbol": "RLHPF"
    },
    {
     "description": "RLI CORP",
     "symbol": "RLI"
    },
    {
     "description": "RLJ LODGING TRUST",
     "symbol": "RLJ"
    },
    {
     "description": "RLJ LODGING TRUST",
     "symbol": "RLJ.PRA"
    },
    {
     "description": "ROLLS-ROYCE HOLDINGS -C SHR",
     "symbol": "RLLCF"
    },
    {
     "description": "REAL MATTERS INC",
     "symbol": "RLLMF"
    },
    {
     "description": "RELEVIUM TECHNOLOGIES INC",
     "symbol": "RLLVF"
    },
    {
     "description": "RELIANCE WORLDWIDE CORP LTD",
     "symbol": "RLLWF"
    },
    {
     "description": "RELMADA THERAPEUTICS INC",
     "symbol": "RLMD"
    },
    {
     "description": "RESOLUTION MINERALS LTD",
     "symbol": "RLMLF"
    },
    {
     "description": "ROLINCO NV",
     "symbol": "RLNCF"
    },
    {
     "description": "RESILIENT REIT LTD",
     "symbol": "RLNTF"
    },
    {
     "description": "RAILPOWER TECHNOLOGIES CORP",
     "symbol": "RLPHQ"
    },
    {
     "description": "CALIMA ENERGY LTD",
     "symbol": "RLTOF"
    },
    {
     "description": "REELTIME RENTALS INC",
     "symbol": "RLTR"
    },
    {
     "description": "COHEN & STEERS RL EST OPPRT",
     "symbol": "RLTY"
    },
    {
     "description": "RLX TECHNOLOGY INC-ADR",
     "symbol": "RLX"
    },
    {
     "description": "RELX PLC",
     "symbol": "RLXXF"
    },
    {
     "description": "SPDR SSGA MULTI-ASSET REAL R",
     "symbol": "RLY"
    },
    {
     "description": "RALLYBIO CORP",
     "symbol": "RLYB"
    },
    {
     "description": "RILEY GOLD CORP",
     "symbol": "RLYGF"
    },
    {
     "description": "RALLYE SA",
     "symbol": "RLYNF"
    },
    {
     "description": "REGIONAL MANAGEMENT CORP",
     "symbol": "RM"
    },
    {
     "description": "ROADMAN INVESTMENTS CORP",
     "symbol": "RMANF"
    },
    {
     "description": "RE\/MAX HOLDINGS INC-CL A",
     "symbol": "RMAX"
    },
    {
     "description": "RMB HOLDINGS LTD",
     "symbol": "RMBHF"
    },
    {
     "description": "RICHMOND MUTUAL BANCORPORATI",
     "symbol": "RMBI"
    },
    {
     "description": "RUMBLEON INC-B",
     "symbol": "RMBL"
    },
    {
     "description": "RAMBUS INC",
     "symbol": "RMBS"
    },
    {
     "description": "ROCKY MOUNTAIN CHOC FACT INC",
     "symbol": "RMCF"
    },
    {
     "description": "RESMED INC",
     "symbol": "RMD"
    },
    {
     "description": "REMEDY ENTERTAINMENT OYJ",
     "symbol": "RMDEF"
    },
    {
     "description": "RICHMOND MINERALS INC",
     "symbol": "RMDFF"
    },
    {
     "description": "RA MEDICAL SYSTEMS INC",
     "symbol": "RMED"
    },
    {
     "description": "RED METAL RESOURCES LTD",
     "symbol": "RMESF"
    },
    {
     "description": "RACKLA METALS INC",
     "symbol": "RMETF"
    },
    {
     "description": "RMG ACQUISITION CORP III -A",
     "symbol": "RMGC"
    },
    {
     "description": "RMG ACQUISITION CORP III",
     "symbol": "RMGCU"
    },
    {
     "description": "RMG ACQUISITION CL A -CW27",
     "symbol": "RMGCW"
    },
    {
     "description": "RESOLUTE MINING LTD",
     "symbol": "RMGGF"
    },
    {
     "description": "RESOLUTE LTD-UNSP ADR",
     "symbol": "RMGGY"
    },
    {
     "description": "RHI MAGNESITA NV",
     "symbol": "RMGNF"
    },
    {
     "description": "REMGRO LTD",
     "symbol": "RMGOF"
    },
    {
     "description": "ROCKY MOUNTAIN HIGH BRANDS I",
     "symbol": "RMHB"
    },
    {
     "description": "RIVERNORTH OPPORT MUNI INC",
     "symbol": "RMI"
    },
    {
     "description": "AUTOMOTIVE FINCO CORP",
     "symbol": "RMIAF"
    },
    {
     "description": "REGINA MIRACLE INTERNATIONAL",
     "symbol": "RMIHF"
    },
    {
     "description": "ROCKY MOUNTAIN INTL LTD",
     "symbol": "RMIL"
    },
    {
     "description": "ROMIOS GOLD RESOURCES INC",
     "symbol": "RMIOF"
    },
    {
     "description": "RM2 INTERNATIONAL SA",
     "symbol": "RMISF"
    },
    {
     "description": "RUSORO MINING LTD",
     "symbol": "RMLFF"
    },
    {
     "description": "RAMELIUS RESOURCES LTD",
     "symbol": "RMLRF"
    },
    {
     "description": "RIVERNORTH MANAGED DURATION",
     "symbol": "RMM"
    },
    {
     "description": "RMR SCIENCE TECHNOLOGIES INC",
     "symbol": "RMMRF"
    },
    {
     "description": "RIVERNORTH MANAGED DURATION",
     "symbol": "RMMZ"
    },
    {
     "description": "RIMINI STREET INC",
     "symbol": "RMNI"
    },
    {
     "description": "RIMINI STREET INC",
     "symbol": "RMNIW"
    },
    {
     "description": "RAINY MOUNTAIN ROYALTY CORP",
     "symbol": "RMNXF"
    },
    {
     "description": "ROMEO POWER INC",
     "symbol": "RMO"
    },
    {
     "description": "RIVERNORTH SPECIALTY FIN",
     "symbol": "RMPL.PR"
    },
    {
     "description": "RMR GROUP INC\/THE - A",
     "symbol": "RMR"
    },
    {
     "description": "RADISSON MINING RESOURCES",
     "symbol": "RMRDF"
    },
    {
     "description": "RAND MERCHANT INVESTMENT HOL",
     "symbol": "RMRHF"
    },
    {
     "description": "RIMROCK GOLD CORP",
     "symbol": "RMRK"
    },
    {
     "description": "REMSLEEP HOLDINGS INC",
     "symbol": "RMSL"
    },
    {
     "description": "RAMSAY HEALTH CARE LTD",
     "symbol": "RMSYF"
    },
    {
     "description": "ROYCE MICRO-CAP TRUST INC",
     "symbol": "RMT"
    },
    {
     "description": "REMOTE DYNAMICS INC",
     "symbol": "RMTD"
    },
    {
     "description": "ROCKWELL MEDICAL INC",
     "symbol": "RMTI"
    },
    {
     "description": "ROCKY MOUNTAIN AYRE INC",
     "symbol": "RMTN"
    },
    {
     "description": "RAMSAY HEALTH CARE-UNSP ADR",
     "symbol": "RMYHY"
    },
    {
     "description": "AVIDITY BIOSCIENCES INC",
     "symbol": "RNA"
    },
    {
     "description": "TRANSCODE THERAPEUTICS INC",
     "symbol": "RNAZ"
    },
    {
     "description": "RAINBOW INTERNATIONAL CORP",
     "symbol": "RNBI"
    },
    {
     "description": "RANDOLPH BANCORP INC",
     "symbol": "RNDB"
    },
    {
     "description": "DEVELOPED INT SELECT EQUITY",
     "symbol": "RNDM"
    },
    {
     "description": "ROUND ONE CORP",
     "symbol": "RNDOF"
    },
    {
     "description": "US EQUITY DIVIDEND SELECT",
     "symbol": "RNDV"
    },
    {
     "description": "RANDGOLD & EXPLORATION CO",
     "symbol": "RNDXF"
    },
    {
     "description": "RENESAS ELECTRONICS CORP",
     "symbol": "RNECF"
    },
    {
     "description": "RENESAS ELECTRO-UNSPON ADR",
     "symbol": "RNECY"
    },
    {
     "description": "EMERGING MARKETS EQTY SELECT",
     "symbol": "RNEM"
    },
    {
     "description": "MOUNT RAINIER ACQUISITION CO",
     "symbol": "RNER"
    },
    {
     "description": "MOUNT RAINIER ACQUISITION CO",
     "symbol": "RNERU"
    },
    {
     "description": "MOUNT RAINIER ACQUISIT -CW22",
     "symbol": "RNERW"
    },
    {
     "description": "ROSNEFT OIL CO PJSC",
     "symbol": "RNFTF"
    },
    {
     "description": "RINGCENTRAL INC-CLASS A",
     "symbol": "RNG"
    },
    {
     "description": "RENO GOLD CORP",
     "symbol": "RNGG"
    },
    {
     "description": "RANGER ENERGY SERVICES INC",
     "symbol": "RNGR"
    },
    {
     "description": "OSISKO DEVELOPMENT CORP",
     "symbol": "RNGTF"
    },
    {
     "description": "REGENEUS LTD",
     "symbol": "RNGUF"
    },
    {
     "description": "CHINA DILI GROUP",
     "symbol": "RNHEF"
    },
    {
     "description": "LARGE CAP US EQUITY SELECT",
     "symbol": "RNLC"
    },
    {
     "description": "RENAULT SA-UNSP ADR",
     "symbol": "RNLSY"
    },
    {
     "description": "RENALYTIX AI PLC-ADR",
     "symbol": "RNLX"
    },
    {
     "description": "RHEINMETALL AG",
     "symbol": "RNMBF"
    },
    {
     "description": "RHEINMETALL AG-UNSP ADR",
     "symbol": "RNMBY"
    },
    {
     "description": "MID CAP US EQUITY SELECT ETF",
     "symbol": "RNMC"
    },
    {
     "description": "RENAISSANCE INC",
     "symbol": "RNNCF"
    },
    {
     "description": "RENOLD PLC",
     "symbol": "RNOPF"
    },
    {
     "description": "COHEN & STEERS REIT AND PREF",
     "symbol": "RNP"
    },
    {
     "description": "RENAISSANCERE HOLDINGS LTD",
     "symbol": "RNR"
    },
    {
     "description": "RENAISSANCERE HOLDINGS L",
     "symbol": "RNR.PRF"
    },
    {
     "description": "RENAISSANCERE HOLDINGS L",
     "symbol": "RNR.PRG"
    },
    {
     "description": "GLOBAL X RENEWABLE ENER PROD",
     "symbol": "RNRG"
    },
    {
     "description": "REUNERT LTD",
     "symbol": "RNRTF"
    },
    {
     "description": "REUNERT LTD-UNSPONSORED ADR",
     "symbol": "RNRTY"
    },
    {
     "description": "RIMBUNAN SAWIT BHD",
     "symbol": "RNSBF"
    },
    {
     "description": "SMALL CAP US EQUITY SELECT",
     "symbol": "RNSC"
    },
    {
     "description": "RENAULT SA",
     "symbol": "RNSDF"
    },
    {
     "description": "RENISHAW PLC",
     "symbol": "RNSHF"
    },
    {
     "description": "RENISHAW PLC-UNSP ADR",
     "symbol": "RNSHY"
    },
    {
     "description": "RENASANT CORP",
     "symbol": "RNST"
    },
    {
     "description": "RENEURON GROUP PLC",
     "symbol": "RNUGF"
    },
    {
     "description": "RENNOVA HEALTH INC",
     "symbol": "RNVA"
    },
    {
     "description": "RENOVATE NEIGHBORHOODS INC",
     "symbol": "RNVT"
    },
    {
     "description": "RENEW ENERGY GLOBAL PLC-A",
     "symbol": "RNW"
    },
    {
     "description": "RENEWABLE CORP\/THE",
     "symbol": "RNWB"
    },
    {
     "description": "REC SILICON ASA",
     "symbol": "RNWEF"
    },
    {
     "description": "REC SILICON ASA -UNSP ADR",
     "symbol": "RNWEY"
    },
    {
     "description": "RENEWAL FUELS INC",
     "symbol": "RNWF"
    },
    {
     "description": "RENEW HOLDINGS PLC",
     "symbol": "RNWHF"
    },
    {
     "description": "REALNETWORKS INC",
     "symbol": "RNWK"
    },
    {
     "description": "808 RENEWABLE ENERGY CORP",
     "symbol": "RNWR"
    },
    {
     "description": "RENEW ENERGY GLOBAL -CW26",
     "symbol": "RNWWW"
    },
    {
     "description": "RENOVORX INC",
     "symbol": "RNXT"
    },
    {
     "description": "CONSTRUCTION PARTNERS INC-A",
     "symbol": "ROAD"
    },
    {
     "description": "ROGUE ONE INC",
     "symbol": "ROAG"
    },
    {
     "description": "HARTFORD MULTIFACTOR EMERGIN",
     "symbol": "ROAM"
    },
    {
     "description": "LGX OIL + GAS INC",
     "symbol": "ROAOF"
    },
    {
     "description": "ROTATE BLACK INC",
     "symbol": "ROBK"
    },
    {
     "description": "ROBO GLOBAL ROBOTICS AND AUT",
     "symbol": "ROBO"
    },
    {
     "description": "ROBOGROUP T.E.K LTD",
     "symbol": "ROBOF"
    },
    {
     "description": "FIRST TRUST NASDAQ ARTIFICIA",
     "symbol": "ROBT"
    },
    {
     "description": "ROBIX ENVIRONMENTAL TECHNOLO",
     "symbol": "ROBXF"
    },
    {
     "description": "ROC ENERGY ACQUISITION CORP",
     "symbol": "ROC"
    },
    {
     "description": "ROCA MINES INC",
     "symbol": "ROCAF"
    },
    {
     "description": "ROC Energy Acquisition-RTS",
     "symbol": "ROCAR"
    },
    {
     "description": "ROC ENERGY ACQUISITION CORP",
     "symbol": "ROCAU"
    },
    {
     "description": "RANGER OIL CORP-A",
     "symbol": "ROCC"
    },
    {
     "description": "ROTH CH ACQUISITION IV CO",
     "symbol": "ROCG"
    },
    {
     "description": "ROTH CH ACQUISITION IV CO",
     "symbol": "ROCGU"
    },
    {
     "description": "ROTH CH ACQUISITION IV -CW23",
     "symbol": "ROCGW"
    },
    {
     "description": "ROC ETF",
     "symbol": "ROCI"
    },
    {
     "description": "GIBRALTAR INDUSTRIES INC",
     "symbol": "ROCK"
    },
    {
     "description": "ROTH CH ACQUISITION V CO",
     "symbol": "ROCL"
    },
    {
     "description": "ROYAL OLYMPIC CRUISE LINES",
     "symbol": "ROCLF"
    },
    {
     "description": "ROTH CH ACQUISITION V CO.",
     "symbol": "ROCLU"
    },
    {
     "description": "ROTH CH ACQUISITION V -CW23",
     "symbol": "ROCLW"
    },
    {
     "description": "HARTFORD MULTIFACTOR DIVERSI",
     "symbol": "RODE"
    },
    {
     "description": "IPATH RETURN ON DISABILITY E",
     "symbol": "RODI"
    },
    {
     "description": "HARTFORD MULTIFACTOR DEVELOP",
     "symbol": "RODM"
    },
    {
     "description": "ROGERS CORP",
     "symbol": "ROG"
    },
    {
     "description": "ROHM CO LTD",
     "symbol": "ROHCF"
    },
    {
     "description": "ROHM CO LTD-UNSPON ADR",
     "symbol": "ROHCY"
    },
    {
     "description": "RETAIL OPPORTUNITY INVESTMEN",
     "symbol": "ROIC"
    },
    {
     "description": "ROUTE1 INC",
     "symbol": "ROIUF"
    },
    {
     "description": "ROIVANT SCIENCES LTD",
     "symbol": "ROIV"
    },
    {
     "description": "ROIVANT SCIENCES LTD -CW26",
     "symbol": "ROIVW"
    },
    {
     "description": "RESPONSE ONCOLOGY INC",
     "symbol": "ROIX"
    },
    {
     "description": "ROCKWELL AUTOMATION INC",
     "symbol": "ROK"
    },
    {
     "description": "ROKK3R INC",
     "symbol": "ROKK"
    },
    {
     "description": "TRUE BLUE HOLDINGS INC",
     "symbol": "ROKR"
    },
    {
     "description": "SPDR S&P KENSHO FINAL FRONTI",
     "symbol": "ROKT"
    },
    {
     "description": "ROKU INC",
     "symbol": "ROKU"
    },
    {
     "description": "ROLLINS INC",
     "symbol": "ROL"
    },
    {
     "description": "RBC BEARINGS INC",
     "symbol": "ROLL"
    },
    {
     "description": "RBC BEARINGS INC",
     "symbol": "ROLLP"
    },
    {
     "description": "PROSHARES ULTRA TECHNOLOGY",
     "symbol": "ROM"
    },
    {
     "description": "RUBICON ORGANICS INC",
     "symbol": "ROMJF"
    },
    {
     "description": "STRATEGY SHARES NEWFOUND\/RES",
     "symbol": "ROMO"
    },
    {
     "description": "REDWOOD MORTGAGE INVESTORS V",
     "symbol": "ROMVL"
    },
    {
     "description": "RUBICON ORGANICS INC -CW24",
     "symbol": "ROMWF"
    },
    {
     "description": "RICE ACQUISITION CORP II -A",
     "symbol": "RONI"
    },
    {
     "description": "RICE ACQUISITION CORP II",
     "symbol": "RONI.U"
    },
    {
     "description": "RICE ACQUISITION CORP II-CW",
     "symbol": "RONI.WS"
    },
    {
     "description": "IQ US REAL ESTATE SMALL CAP",
     "symbol": "ROOF"
    },
    {
     "description": "NORTHSTAR CLEAN TECHNOLOGIES",
     "symbol": "ROOOF"
    },
    {
     "description": "ROOT INC\/OH -CLASS A",
     "symbol": "ROOT"
    },
    {
     "description": "ROPER TECHNOLOGIES INC",
     "symbol": "ROP"
    },
    {
     "description": "ATAC US ROTATION ETF",
     "symbol": "RORO"
    },
    {
     "description": "HARTFORD MULTIFACTOR SMALL C",
     "symbol": "ROSC"
    },
    {
     "description": "ROSE HILL ACQUISITION CORP-A",
     "symbol": "ROSE"
    },
    {
     "description": "ROSE HILL ACQUISITION CORP",
     "symbol": "ROSEU"
    },
    {
     "description": "ROSE HILL ACQUISITION -CW24",
     "symbol": "ROSEW"
    },
    {
     "description": "ROSETTA GENOMICS LTD",
     "symbol": "ROSGQ"
    },
    {
     "description": "ROSTELECOM PJSC",
     "symbol": "ROSMF"
    },
    {
     "description": "ROSINBOMB",
     "symbol": "ROSN"
    },
    {
     "description": "ROSS ACQUISITION CORP II -A",
     "symbol": "ROSS"
    },
    {
     "description": "ROSS ACQUISITION CORP II",
     "symbol": "ROSS.U"
    },
    {
     "description": "ROSS ACQUISITION CORP -CW26",
     "symbol": "ROSS.WS"
    },
    {
     "description": "ROSS GROUP PLC",
     "symbol": "ROSSF"
    },
    {
     "description": "ROSS STORES INC",
     "symbol": "ROST"
    },
    {
     "description": "ROSTELECOM-SPONSORED ADR",
     "symbol": "ROSYY"
    },
    {
     "description": "PHARMAROTH LABS INC",
     "symbol": "ROTH"
    },
    {
     "description": "HARTFORD MULTIFACTOR US EQUI",
     "symbol": "ROUS"
    },
    {
     "description": "ROVER METALS CORP",
     "symbol": "ROVMF"
    },
    {
     "description": "ROVER GROUP INC",
     "symbol": "ROVR"
    },
    {
     "description": "ROVIO ENTERTAINMENT OY",
     "symbol": "ROVVF"
    },
    {
     "description": "ROWE COS\/THE",
     "symbol": "ROWC"
    },
    {
     "description": "RENOWORKS SOFTWARE INC",
     "symbol": "ROWKF"
    },
    {
     "description": "Series A Shares",
     "symbol": "ROXA"
    },
    {
     "description": "CASPIAN SUNRISE PLC",
     "symbol": "ROXIF"
    },
    {
     "description": "ROYAL ENERGY RESOURCES INC",
     "symbol": "ROYE"
    },
    {
     "description": "ROYAL HOLDINGS CO LTD",
     "symbol": "ROYHF"
    },
    {
     "description": "ROYALE ENERGY INC",
     "symbol": "ROYL"
    },
    {
     "description": "ROYAL MAIL PLC",
     "symbol": "ROYMF"
    },
    {
     "description": "ROYAL MAIL PLC-UNSP ADR",
     "symbol": "ROYMY"
    },
    {
     "description": "PACIFIC COAST OIL TRUST",
     "symbol": "ROYTL"
    },
    {
     "description": "ROYAL UNIBREW",
     "symbol": "ROYUF"
    },
    {
     "description": "RPAR RISK PARITY ETF",
     "symbol": "RPAR"
    },
    {
     "description": "REPAY HOLDINGS CORP",
     "symbol": "RPAY"
    },
    {
     "description": "RPCG PCL",
     "symbol": "RPCCF"
    },
    {
     "description": "RAPID7 INC",
     "symbol": "RPD"
    },
    {
     "description": "RAPIDTRON INC",
     "symbol": "RPDT"
    },
    {
     "description": "RAINIER PACIFIC FINANCIAL GR",
     "symbol": "RPFG"
    },
    {
     "description": "INVESCO S&P 500 PURE GROWTH",
     "symbol": "RPG"
    },
    {
     "description": "RPMGLOBAL HOLDINGS LTD",
     "symbol": "RPGHF"
    },
    {
     "description": "ENDURANCE RP LTD",
     "symbol": "RPGLF"
    },
    {
     "description": "REA GROUP LTD",
     "symbol": "RPGRF"
    },
    {
     "description": "REA GROUP LTD - UNSP ADR",
     "symbol": "RPGRY"
    },
    {
     "description": "ROHTO PHARMACEUTICAL CO LTD",
     "symbol": "RPHCF"
    },
    {
     "description": "RENEO PHARMACEUTICALS INC",
     "symbol": "RPHM"
    },
    {
     "description": "REGENTS PARK HEDGED MARKET",
     "symbol": "RPHS"
    },
    {
     "description": "RAPID MICRO BIOSYSTEMS INC-A",
     "symbol": "RPID"
    },
    {
     "description": "RICHARDS PACKAGING INCOME FD",
     "symbol": "RPKIF"
    },
    {
     "description": "RPM INTERNATIONAL INC",
     "symbol": "RPM"
    },
    {
     "description": "REGO PAYMENT ARCHITECTURES I",
     "symbol": "RPMT"
    },
    {
     "description": "RAPALA VMC OYJ",
     "symbol": "RPNMF"
    },
    {
     "description": "RAPID NUTRITION PLC",
     "symbol": "RPNRF"
    },
    {
     "description": "ROYALTY PHARMA PLC- CL A",
     "symbol": "RPRX"
    },
    {
     "description": "RPS GROUP PLC",
     "symbol": "RPSGF"
    },
    {
     "description": "RPT REALTY",
     "symbol": "RPT"
    },
    {
     "description": "RPT REALTY",
     "symbol": "RPT.PRD"
    },
    {
     "description": "REPARE THERAPEUTICS INC",
     "symbol": "RPTX"
    },
    {
     "description": "INVESCO S&P 500 PURE VALUE E",
     "symbol": "RPV"
    },
    {
     "description": "REPLY SPA",
     "symbol": "RPYTF"
    },
    {
     "description": "RELIQ HEALTH TECHNOLOGIES IN",
     "symbol": "RQHTF"
    },
    {
     "description": "COHEN & STEERS QUAL INC RLTY",
     "symbol": "RQI"
    },
    {
     "description": "RANDALL & QUILTER INVESTMENT",
     "symbol": "RQIHF"
    },
    {
     "description": "RIGEL RESOURCE ACQUISIT-CL A",
     "symbol": "RRAC"
    },
    {
     "description": "RIGEL RESOURCE ACQUISITION C",
     "symbol": "RRAC.U"
    },
    {
     "description": "RIGEL RESOURCE ACQUISI -CW23",
     "symbol": "RRAC.WS"
    },
    {
     "description": "RED RIVER BANCSHARES INC",
     "symbol": "RRBI"
    },
    {
     "description": "RANGE RESOURCES CORP",
     "symbol": "RRC"
    },
    {
     "description": "ROYAL ROAD MINERALS LTD",
     "symbol": "RRDMF"
    },
    {
     "description": "REGAL REAL ESTATE INVESTMENT",
     "symbol": "RREIF"
    },
    {
     "description": "RESOURCE REAL ESTATE OPPORTU",
     "symbol": "RREO"
    },
    {
     "description": "ROBINSONS RETAIL-UNSP ADR",
     "symbol": "RRETY"
    },
    {
     "description": "RED ROBIN GOURMET BURGERS",
     "symbol": "RRGB"
    },
    {
     "description": "REALITY RACING INC",
     "symbol": "RRGI"
    },
    {
     "description": "ADVOCATE RISING RATE HDG ETF",
     "symbol": "RRH"
    },
    {
     "description": "RENRUI HUMAN RESOURCES TECHN",
     "symbol": "RRHMF"
    },
    {
     "description": "RESOURCE RECOVERY INTL CORP",
     "symbol": "RRIC"
    },
    {
     "description": "RAINFOREST RESOURCES INC",
     "symbol": "RRIF"
    },
    {
     "description": "ROSS RIVER MINERALS INC",
     "symbol": "RRMLF"
    },
    {
     "description": "ROOTS CORP",
     "symbol": "RROTF"
    },
    {
     "description": "RE ROYALTIES LTD",
     "symbol": "RROYF"
    },
    {
     "description": "RED ROCK RESORTS INC-CLASS A",
     "symbol": "RRR"
    },
    {
     "description": "RED RIVER RESOURCES LTD",
     "symbol": "RRRDF"
    },
    {
     "description": "ROCK RIDGE RESOURCES INC",
     "symbol": "RRRI"
    },
    {
     "description": "ROCKRIDGE RESOURCES LTD",
     "symbol": "RRRLF"
    },
    {
     "description": "R-THREE TECHNOLOGIES INC",
     "symbol": "RRRT"
    },
    {
     "description": "RRITUAL SUPERFOODS INC",
     "symbol": "RRSFF"
    },
    {
     "description": "NEOMETALS LTD",
     "symbol": "RRSSF"
    },
    {
     "description": "ROADRUNNER TRANSPORTATION SY",
     "symbol": "RRTS"
    },
    {
     "description": "REGAL REXNORD CORP",
     "symbol": "RRX"
    },
    {
     "description": "RELIANCE STEEL & ALUMINUM",
     "symbol": "RS"
    },
    {
     "description": "RISING SUN BANCORP INC",
     "symbol": "RSAM"
    },
    {
     "description": "RESAAS SERVICES INC",
     "symbol": "RSASF"
    },
    {
     "description": "ROOSHINE INC",
     "symbol": "RSAU"
    },
    {
     "description": "REFLECT SCIENTIFIC INC",
     "symbol": "RSCF"
    },
    {
     "description": "REDWOOD SCIENTIFIC TECHNOLOG",
     "symbol": "RSCI"
    },
    {
     "description": "GLOBAL CARE CAPITAL INC",
     "symbol": "RSCZF"
    },
    {
     "description": "RAMSDENS HOLDINGS PLC",
     "symbol": "RSDEF"
    },
    {
     "description": "RAREVIEW SYSTEMATIC EQUITY",
     "symbol": "RSEE"
    },
    {
     "description": "RESERVOIR CAPITAL CORP",
     "symbol": "RSERF"
    },
    {
     "description": "RIVERNORTH SPECIALTY FINANCE",
     "symbol": "RSF"
    },
    {
     "description": "REPUBLIC SERVICES INC",
     "symbol": "RSG"
    },
    {
     "description": "ROGERS SUGAR INC",
     "symbol": "RSGUF"
    },
    {
     "description": "RESOURCING SOLUTIONS GROUP",
     "symbol": "RSGX"
    },
    {
     "description": "RUSHNET INC",
     "symbol": "RSHN"
    },
    {
     "description": "IRISH RESIDENTIAL PROPERTIES",
     "symbol": "RSHPF"
    },
    {
     "description": "RUSHYDRO-SP GDR 144A",
     "symbol": "RSHRL"
    },
    {
     "description": "RUSHYDRO PJSC-ADR",
     "symbol": "RSHYY"
    },
    {
     "description": "RUSH STREET INTERACTIVE INC",
     "symbol": "RSI"
    },
    {
     "description": "RISKIFIED LTD-A",
     "symbol": "RSKD"
    },
    {
     "description": "GEORGE RISK INDUSTRIES INC",
     "symbol": "RSKIA"
    },
    {
     "description": "RAYSEARCH LABORATORIES AB",
     "symbol": "RSLBF"
    },
    {
     "description": "RESHAPE LIFESCIENCES INC",
     "symbol": "RSLS"
    },
    {
     "description": "RESMED INC-CDI",
     "symbol": "RSMDF"
    },
    {
     "description": "RESONA HOLDINGS INC",
     "symbol": "RSNHF"
    },
    {
     "description": "RENAISSANCE URANIUM LTD",
     "symbol": "RSNUF"
    },
    {
     "description": "REYNA SILVER CORP",
     "symbol": "RSNVF"
    },
    {
     "description": "INVESCO S&P 500 EQUAL WEIGHT",
     "symbol": "RSP"
    },
    {
     "description": "INVESCO ESG SP 500 EQ WEIGHT",
     "symbol": "RSPE"
    },
    {
     "description": "RESPIRERX PHARMACEUTICALS IN",
     "symbol": "RSPI"
    },
    {
     "description": "REVERE SECTOR OPPORTUNITY ET",
     "symbol": "RSPY"
    },
    {
     "description": "ROBEX RESOURCES INC",
     "symbol": "RSRBF"
    },
    {
     "description": "RESOURCE REAL ESTATE OPPORTU",
     "symbol": "RSRL"
    },
    {
     "description": "RESERVE PETROLEUM COMPANY",
     "symbol": "RSRV"
    },
    {
     "description": "AFFINOR GROWERS INC",
     "symbol": "RSSFF"
    },
    {
     "description": "RESEARCH SOLUTIONS INC",
     "symbol": "RSSS"
    },
    {
     "description": "RS TECHNOLOGIES CO LTD",
     "symbol": "RSTCF"
    },
    {
     "description": "RESTAURANT GROUP PLC",
     "symbol": "RSTGF"
    },
    {
     "description": "RDE INC",
     "symbol": "RSTN"
    },
    {
     "description": "RESTAURANT BRANDS-EXCH UNITS",
     "symbol": "RSTRF"
    },
    {
     "description": "RESERVOIR MEDIA INC",
     "symbol": "RSVR"
    },
    {
     "description": "ROTH CH ACQ II -CW26",
     "symbol": "RSVRW"
    },
    {
     "description": "VANECK RUSSIA ETF",
     "symbol": "RSX"
    },
    {
     "description": "VANECK RUSSIA SMALL-CAP ETF",
     "symbol": "RSXJ"
    },
    {
     "description": "REAL SECURITY CO INC\/THE",
     "symbol": "RSYC"
    },
    {
     "description": "RAREVIEW TAX ADVANTAGED INCO",
     "symbol": "RTAI"
    },
    {
     "description": "RETAILORS LTD",
     "symbol": "RTALF"
    },
    {
     "description": "REDTONE ASIA INC",
     "symbol": "RTAS"
    },
    {
     "description": "RATHBONES GROUP PLC",
     "symbol": "RTBBF"
    },
    {
     "description": "RESTAURANT BRANDS NZ LTD",
     "symbol": "RTBRF"
    },
    {
     "description": "ROTTNEROS AB",
     "symbol": "RTERF"
    },
    {
     "description": "RATIO ENERGIES FINANCE LP",
     "symbol": "RTEXF"
    },
    {
     "description": "RTG MINING INC-CDI",
     "symbol": "RTGGF"
    },
    {
     "description": "ROTO-GRO INTERNATIONAL LTD",
     "symbol": "RTGIF"
    },
    {
     "description": "RETINALGENIX TECHNOLOGIES IN",
     "symbol": "RTGN"
    },
    {
     "description": "ARTGO HOLDINGS LTD",
     "symbol": "RTGOF"
    },
    {
     "description": "VANECK RETAIL ETF",
     "symbol": "RTH"
    },
    {
     "description": "RAISIO OYJ-V SHS",
     "symbol": "RTHVF"
    },
    {
     "description": "RATIO PETROLEUM ENERGY LP",
     "symbol": "RTIOF"
    },
    {
     "description": "NECESSITY RETAIL REIT INC\/TH",
     "symbol": "RTL"
    },
    {
     "description": "ST AUGUSTINE GOLD AND COPPER",
     "symbol": "RTLGF"
    },
    {
     "description": "RATIONAL AG",
     "symbol": "RTLLF"
    },
    {
     "description": "NECESSITY RETAIL REIT IN",
     "symbol": "RTLPO"
    },
    {
     "description": "NECESSITY RETAIL REIT IN",
     "symbol": "RTLPP"
    },
    {
     "description": "RATTLER MIDSTREAM LP",
     "symbol": "RTLR"
    },
    {
     "description": "INVESCO S&P 500 EQUAL WEIGHT",
     "symbol": "RTM"
    },
    {
     "description": "REITMANS (CANADA) LTD-A",
     "symbol": "RTMAF"
    },
    {
     "description": "RTCORE INC",
     "symbol": "RTME"
    },
    {
     "description": "RT MINERALS CORP",
     "symbol": "RTMFF"
    },
    {
     "description": "REITMANS (CANADA) LTD",
     "symbol": "RTMNF"
    },
    {
     "description": "RIGHTMOVE PLC",
     "symbol": "RTMVF"
    },
    {
     "description": "RIGHTMOVE PLC-UNSP ADR",
     "symbol": "RTMVY"
    },
    {
     "description": "ROOT9B HOLDINGS INC",
     "symbol": "RTNB"
    },
    {
     "description": "RIO TINTO LTD",
     "symbol": "RTNTF"
    },
    {
     "description": "RENALYTIX PLC",
     "symbol": "RTNXF"
    },
    {
     "description": "RATOS AB-B SHS",
     "symbol": "RTOBF"
    },
    {
     "description": "RENTOKIL INITIAL PLC-SP ADR",
     "symbol": "RTOKY"
    },
    {
     "description": "RIGHT ON BRANDS INC",
     "symbol": "RTON"
    },
    {
     "description": "ROTORK PLC",
     "symbol": "RTOXF"
    },
    {
     "description": "RIO TINTO PLC",
     "symbol": "RTPPF"
    },
    {
     "description": "RUMBLE RESOURCES LTD",
     "symbol": "RTRFF"
    },
    {
     "description": "RED TRUCK ENTERTAINMENT INC",
     "symbol": "RTRK"
    },
    {
     "description": "RIETER HOLDING AG-UNSP ADR",
     "symbol": "RTRZY"
    },
    {
     "description": "RAPID THERAPEUTIC SCIENCE LA",
     "symbol": "RTSLD"
    },
    {
     "description": "RTS OIL HOLDINGS INC",
     "symbol": "RTSO"
    },
    {
     "description": "RTG MINING INC",
     "symbol": "RTTGF"
    },
    {
     "description": "ROTTNEROS AB-UNSPONSORED ADR",
     "symbol": "RTTNY"
    },
    {
     "description": "RITO GROUP CORP",
     "symbol": "RTTO"
    },
    {
     "description": "RTW VENTURE FUND LTD",
     "symbol": "RTWFF"
    },
    {
     "description": "RAYTHEON TECHNOLOGIES CORP",
     "symbol": "RTX"
    },
    {
     "description": "SIMPLIFY US SCAP PL DN CONV",
     "symbol": "RTYD"
    },
    {
     "description": "RUBELLITE ENERGY INC",
     "symbol": "RUBLF"
    },
    {
     "description": "ARBORGEN HOLDINGS LTD",
     "symbol": "RUBNF"
    },
    {
     "description": "RUBIS",
     "symbol": "RUBSF"
    },
    {
     "description": "RUBIUS THERAPEUTICS INC",
     "symbol": "RUBY"
    },
    {
     "description": "RBC QUANT US DIVIDEND LEADER",
     "symbol": "RUDQF"
    },
    {
     "description": "RUENTEX DEVELOPMENT CO LTD",
     "symbol": "RUEXF"
    },
    {
     "description": "ALPHA DOG ETF",
     "symbol": "RUFF"
    },
    {
     "description": "RUFFER INVESTMENT COMPANY LD",
     "symbol": "RUFIF"
    },
    {
     "description": "ADAPTIVE CORE ETF",
     "symbol": "RULE"
    },
    {
     "description": "RUMO SA",
     "symbol": "RUMOF"
    },
    {
     "description": "SUNRUN INC",
     "symbol": "RUN"
    },
    {
     "description": "REUNION INDUSTRIES INC",
     "symbol": "RUNI"
    },
    {
     "description": "RUPERT RESOURCES LTD",
     "symbol": "RUPRF"
    },
    {
     "description": "RUSH ENTERPRISES INC-CL A",
     "symbol": "RUSHA"
    },
    {
     "description": "RUSH ENTERPRISES INC - CL B",
     "symbol": "RUSHB"
    },
    {
     "description": "RUSSEL METALS INC",
     "symbol": "RUSMF"
    },
    {
     "description": "Direxion Daily Russia Bear 3x Shares New",
     "symbol": "RUSS"
    },
    {
     "description": "RUTH'S HOSPITALITY GROUP INC",
     "symbol": "RUTH"
    },
    {
     "description": "RIVERVIEW ACQUISITION CORP-A",
     "symbol": "RVAC"
    },
    {
     "description": "RIVERVIEW ACQUISITION CORP",
     "symbol": "RVACU"
    },
    {
     "description": "RIVERVIEW ACQUISITION -CW28",
     "symbol": "RVACW"
    },
    {
     "description": "MARKRAY CORP",
     "symbol": "RVBR"
    },
    {
     "description": "RIVER VALLEY COMMUNITY BANCO",
     "symbol": "RVCB"
    },
    {
     "description": "RETAIL VALUE INC",
     "symbol": "RVIC"
    },
    {
     "description": "REVIV3 PROCARE CO",
     "symbol": "RVIV"
    },
    {
     "description": "RIVALRY CORP-SUB VOTING",
     "symbol": "RVLCF"
    },
    {
     "description": "REVIVAL GOLD INC",
     "symbol": "RVLGF"
    },
    {
     "description": "RVL PHARMACEUTICALS PLC",
     "symbol": "RVLP"
    },
    {
     "description": "REVOLUTION TECHNOLOGIES INC",
     "symbol": "RVLTF"
    },
    {
     "description": "REVOLVE GROUP INC",
     "symbol": "RVLV"
    },
    {
     "description": "REVITALIST LIFESTYLE AND WEL",
     "symbol": "RVLWF"
    },
    {
     "description": "REVOLUTION MEDICINES INC",
     "symbol": "RVMD"
    },
    {
     "description": "REVANCE THERAPEUTICS INC",
     "symbol": "RVNC"
    },
    {
     "description": "RAVEN GOLD CORP",
     "symbol": "RVNG"
    },
    {
     "description": "XTRACKERS MUNICIPAL INFRASTR",
     "symbol": "RVNU"
    },
    {
     "description": "RETRACTABLE TECHNOLOGIES INC",
     "symbol": "RVP"
    },
    {
     "description": "REVIVA PHARMACEUTICALS HOLDI",
     "symbol": "RVPH"
    },
    {
     "description": "TENZING ACQUISITION COR-CW23",
     "symbol": "RVPHW"
    },
    {
     "description": "REVIUM RECOVERY INC",
     "symbol": "RVRC"
    },
    {
     "description": "RIVER FINANCIAL CORP",
     "symbol": "RVRF"
    },
    {
     "description": "PATHFINDER VENTURES INC",
     "symbol": "RVRVF"
    },
    {
     "description": "RIVERVIEW BANCORP INC",
     "symbol": "RVSB"
    },
    {
     "description": "RIVERSIDE RESOURCES INC",
     "symbol": "RVSDF"
    },
    {
     "description": "RIVERSGOLD LTD",
     "symbol": "RVSGF"
    },
    {
     "description": "RAIL VISION LTD",
     "symbol": "RVSN"
    },
    {
     "description": "RAIL VISION LTD-CW27",
     "symbol": "RVSNW"
    },
    {
     "description": "RIVERSTONE ENERGY LTD",
     "symbol": "RVSTF"
    },
    {
     "description": "ROYCE VALUE TRUST",
     "symbol": "RVT"
    },
    {
     "description": "RIVAL TECHNOLOGIES INC",
     "symbol": "RVTI"
    },
    {
     "description": "ROVIO ENTERTAINMENT-UNSP ADR",
     "symbol": "RVTTY"
    },
    {
     "description": "RAVENQUEST BIOMED INC",
     "symbol": "RVVQF"
    },
    {
     "description": "REVIVE THERAPEUTICS LTD",
     "symbol": "RVVTF"
    },
    {
     "description": "RESVERLOGIX CORP",
     "symbol": "RVXCF"
    },
    {
     "description": "RUNWAY GROWTH FINANCE CORP",
     "symbol": "RWAY"
    },
    {
     "description": "RED WHITE & BLOOM BRANDS INC",
     "symbol": "RWBYF"
    },
    {
     "description": "REDWOOD CAPITAL BANCORP",
     "symbol": "RWCB"
    },
    {
     "description": "RWC INC",
     "symbol": "RWCI"
    },
    {
     "description": "RIWI CORP",
     "symbol": "RWCRF"
    },
    {
     "description": "RWE AKTIENGESELLSCHAF-SP ADR",
     "symbol": "RWEOY"
    },
    {
     "description": "RENEWABLE FUEL CORP",
     "symbol": "RWFC"
    },
    {
     "description": "RENEWABLES INFRASTRUCTURE GR",
     "symbol": "RWFRF"
    },
    {
     "description": "RODEDAWG INTERNATIONAL INDUS",
     "symbol": "RWGI"
    },
    {
     "description": "DIREXION RUSSELL G\/V",
     "symbol": "RWGV"
    },
    {
     "description": "INVESCO S&P SMALLCAP 600",
     "symbol": "RWJ"
    },
    {
     "description": "INVESCO S&P MIDCAP 400 REV",
     "symbol": "RWK"
    },
    {
     "description": "INVESCO S&P 500 REVENUE ETF",
     "symbol": "RWL"
    },
    {
     "description": "REWALK ROBOTICS LTD",
     "symbol": "RWLK"
    },
    {
     "description": "PROSHARES SHORT RUSSELL2000",
     "symbol": "RWM"
    },
    {
     "description": "REGALWORKS MEDIA INC",
     "symbol": "RWMI"
    },
    {
     "description": "RWE AG",
     "symbol": "RWNFF"
    },
    {
     "description": "SPDR DJ GLOBAL REAL ESTATE E",
     "symbol": "RWO"
    },
    {
     "description": "REDWOODS ACQUISITION CORP",
     "symbol": "RWODU"
    },
    {
     "description": "SPDR DOW JONES REIT ETF",
     "symbol": "RWR"
    },
    {
     "description": "IConsumer Corporation",
     "symbol": "RWRDP"
    },
    {
     "description": "REDWOOD TRUST INC",
     "symbol": "RWT"
    },
    {
     "description": "DIREXION RUSSELL V\/G",
     "symbol": "RWVG"
    },
    {
     "description": "RAND WORLDWIDE INC",
     "symbol": "RWWI"
    },
    {
     "description": "SPDR DR INTERNATIONAL RL EST",
     "symbol": "RWX"
    },
    {
     "description": "PROSHARES ULTRASHORT HEALTH",
     "symbol": "RXD"
    },
    {
     "description": "PROMETHEUS BIOSCIENCES INC",
     "symbol": "RXDX"
    },
    {
     "description": "REXEL SA - UNSPONSORED ADR",
     "symbol": "RXEEY"
    },
    {
     "description": "RXELITE INC",
     "symbol": "RXEI"
    },
    {
     "description": "RICHCO INVESTORS INC -CL B",
     "symbol": "RXHSF"
    },
    {
     "description": "ISHARES GLOBAL CONSUMER DISC",
     "symbol": "RXI"
    },
    {
     "description": "PROSHARES ULTRA HEALTH CARE",
     "symbol": "RXL"
    },
    {
     "description": "REXEL SA",
     "symbol": "RXLSF"
    },
    {
     "description": "PROGRESSIVE CARE INC",
     "symbol": "RXMD"
    },
    {
     "description": "RXR ACQUISITION CORP- CL A",
     "symbol": "RXRA"
    },
    {
     "description": "RXR ACQUISITION CORP",
     "symbol": "RXRAU"
    },
    {
     "description": "RXR ACQUISITION CL A -CW26",
     "symbol": "RXRAW"
    },
    {
     "description": "REX MINERALS LTD",
     "symbol": "RXRLF"
    },
    {
     "description": "RAZOR ENERGY CORP-RTS W\/I",
     "symbol": "RXRRF"
    },
    {
     "description": "RECURSION PHARMACEUTICALS-A",
     "symbol": "RXRX"
    },
    {
     "description": "RXSIGHT INC",
     "symbol": "RXST"
    },
    {
     "description": "RACKSPACE TECHNOLOGY INC",
     "symbol": "RXT"
    },
    {
     "description": "ROX RESOURCES LTD",
     "symbol": "RXXRF"
    },
    {
     "description": "ROYAL BANK OF CANADA",
     "symbol": "RY"
    },
    {
     "description": "ROYAL BANK OF CANADA",
     "symbol": "RY.PRT"
    },
    {
     "description": "RYANAIR HOLDINGS PLC-SP ADR",
     "symbol": "RYAAY"
    },
    {
     "description": "RYAH GROUP INC-SUB V",
     "symbol": "RYAHF"
    },
    {
     "description": "RAYONIER ADVANCED MATERIALS",
     "symbol": "RYAM"
    },
    {
     "description": "RYAN SPECIALTY GROUP HLDGS-A",
     "symbol": "RYAN"
    },
    {
     "description": "RYANAIR HOLDINGS PLC",
     "symbol": "RYAOF"
    },
    {
     "description": "RYB EDUCATION INC-ADR",
     "symbol": "RYB"
    },
    {
     "description": "RYOBI LTD",
     "symbol": "RYBIF"
    },
    {
     "description": "ROLLS-ROYCE HOLDINGS PLC",
     "symbol": "RYCEF"
    },
    {
     "description": "ROLLS-ROYCE HOLDINGS-SP ADR",
     "symbol": "RYCEY"
    },
    {
     "description": "SHELL PLC",
     "symbol": "RYDAF"
    },
    {
     "description": "INVESCO S&P 500 EQUAL WEIGHT",
     "symbol": "RYE"
    },
    {
     "description": "RISE GOLD CORP",
     "symbol": "RYES"
    },
    {
     "description": "INVESCO S&P 500 EQUAL WEIGHT",
     "symbol": "RYF"
    },
    {
     "description": "INVESCO S&P 500 EQUAL WEIGHT",
     "symbol": "RYH"
    },
    {
     "description": "RYMAN HEALTHCARE LTD-UNS ADR",
     "symbol": "RYHTY"
    },
    {
     "description": "RYERSON HOLDING CORP",
     "symbol": "RYI"
    },
    {
     "description": "INVESCO RAYMOND JAMES SB-1 E",
     "symbol": "RYJ"
    },
    {
     "description": "RYOHIN KEIKAKU CO LTD",
     "symbol": "RYKKF"
    },
    {
     "description": "RYOHIN KEIKAKU CO -UNSP ADR",
     "symbol": "RYKKY"
    },
    {
     "description": "GLOBAL X RUSSELL 2000 COV CL",
     "symbol": "RYLD"
    },
    {
     "description": "KONINKLIJKE PHILIPS NV",
     "symbol": "RYLPF"
    },
    {
     "description": "ROYAL MINES & MINERALS CORP",
     "symbol": "RYMM"
    },
    {
     "description": "RAYONIER INC",
     "symbol": "RYN"
    },
    {
     "description": "REYNALDOS MEXICAN FOOD CO",
     "symbol": "RYNL"
    },
    {
     "description": "RIO SILVER INC",
     "symbol": "RYOOF"
    },
    {
     "description": "RYODEN CORP",
     "symbol": "RYOTF"
    },
    {
     "description": "ROYALITE PETROLEUM CO INC",
     "symbol": "RYPE"
    },
    {
     "description": "RYU APPAREL INC",
     "symbol": "RYPPF"
    },
    {
     "description": "RNY PROPERTY TRUST",
     "symbol": "RYPTF"
    },
    {
     "description": "REYSAS LOGISTICS",
     "symbol": "RYSKF"
    },
    {
     "description": "ROYAL STANDARD MINERALS INC",
     "symbol": "RYSMF"
    },
    {
     "description": "RYOSAN CO LTD",
     "symbol": "RYSVF"
    },
    {
     "description": "INVESCO S&P 500 EQUAL WEIGHT",
     "symbol": "RYT"
    },
    {
     "description": "RHYTHM PHARMACEUTICALS INC",
     "symbol": "RYTM"
    },
    {
     "description": "ROYALTY NORTH PARTNERS LTD",
     "symbol": "RYTTF"
    },
    {
     "description": "INVESCO S&P 500 EQUAL WEIGHT",
     "symbol": "RYU"
    },
    {
     "description": "ROYAL WINS CORP",
     "symbol": "RYWCF"
    },
    {
     "description": "RAYMOND LTD-SPONSORED GDR",
     "symbol": "RYWKF"
    },
    {
     "description": "REINSURANCE GRP OF AMER",
     "symbol": "RZA"
    },
    {
     "description": "REINSURANCE GRP OF AMER",
     "symbol": "RZB"
    },
    {
     "description": "INVESCO S&P SMALLCAP 600 PUR",
     "symbol": "RZG"
    },
    {
     "description": "REZOLUTE INC",
     "symbol": "RZLT"
    },
    {
     "description": "RAZOR ENERGY CORP",
     "symbol": "RZREF"
    },
    {
     "description": "RAZOR LABS LTD",
     "symbol": "RZRLF"
    },
    {
     "description": "RCS MEDIAGROUP SPA",
     "symbol": "RZSMF"
    },
    {
     "description": "INVESCO S&P SMALLCAP 600 PUR",
     "symbol": "RZV"
    },
    {
     "description": "JIALIJIA GROUP CORP LTD",
     "symbol": "RZZN"
    },
    {
     "description": "RAZER INC - UNSP - ADR",
     "symbol": "RZZRY"
    },
    {
     "description": "SENTINELONE INC -CLASS A",
     "symbol": "S"
    },
    {
     "description": "SEABRIDGE GOLD INC",
     "symbol": "SA"
    },
    {
     "description": "PROSHARES ULTRA SMALLCAP600",
     "symbol": "SAA"
    },
    {
     "description": "SAAB AB-B",
     "symbol": "SAABF"
    },
    {
     "description": "SAAB AB-UNSPR ADR",
     "symbol": "SAABY"
    },
    {
     "description": "SARAS SPA-UNSP ADR",
     "symbol": "SAAFY"
    },
    {
     "description": "SHANTA GOLD LTD",
     "symbol": "SAAGF"
    },
    {
     "description": "NOUVEAU VENTURES INC",
     "symbol": "SAAX"
    },
    {
     "description": "SAIBU GAS CO LTD",
     "symbol": "SABGF"
    },
    {
     "description": "SOUTH ATLANTIC BANCSHARES",
     "symbol": "SABK"
    },
    {
     "description": "SABINE OIL & GAS HOLDINGS",
     "symbol": "SABNW"
    },
    {
     "description": "SABIO HOLDINGS INC",
     "symbol": "SABOF"
    },
    {
     "description": "SABRE CORP",
     "symbol": "SABR"
    },
    {
     "description": "SABRE CORP",
     "symbol": "SABRP"
    },
    {
     "description": "SAB BIOTHERAPEUTICS INC",
     "symbol": "SABS"
    },
    {
     "description": "SAB BIOTHERAPEUTICS INC-W",
     "symbol": "SABSW"
    },
    {
     "description": "SACHEM CAPITAL CORP",
     "symbol": "SACC"
    },
    {
     "description": "SACHEM CAPITAL CORP",
     "symbol": "SACH"
    },
    {
     "description": "SACHEM CAPITAL C",
     "symbol": "SACH.PRA"
    },
    {
     "description": "SADLIER (WILLIAM H) INC",
     "symbol": "SADL"
    },
    {
     "description": "SANATANA RESOURCES INC",
     "symbol": "SADMF"
    },
    {
     "description": "STARLIGHT ENERGY CORP",
     "symbol": "SAEC"
    },
    {
     "description": "SCHWAB ARIEL ESG ETF",
     "symbol": "SAEF"
    },
    {
     "description": "SUPATCHA RESOURCES INC",
     "symbol": "SAEI"
    },
    {
     "description": "SOLAR ALLIANCE ENERGY INC",
     "symbol": "SAENF"
    },
    {
     "description": "SANDEN CORP",
     "symbol": "SAEOF"
    },
    {
     "description": "SATURN OIL & GAS INC",
     "symbol": "SAEUF"
    },
    {
     "description": "SHOP APOTHEKE EU - UNSP ADR",
     "symbol": "SAEYY"
    },
    {
     "description": "SAFEHOLD INC",
     "symbol": "SAFE"
    },
    {
     "description": "SAFILO GROUP SPA",
     "symbol": "SAFLF"
    },
    {
     "description": "SAFILO GROUP SPA-ADR",
     "symbol": "SAFLY"
    },
    {
     "description": "SANDERSON FARMS INC",
     "symbol": "SAFM"
    },
    {
     "description": "SAFE ORTHOPAEDICS SA",
     "symbol": "SAFOF"
    },
    {
     "description": "SAFRAN SA",
     "symbol": "SAFRF"
    },
    {
     "description": "SAFRAN SA-UNSPON ADR",
     "symbol": "SAFRY"
    },
    {
     "description": "SAFER SHOT INC",
     "symbol": "SAFS"
    },
    {
     "description": "SAFETY INSURANCE GROUP INC",
     "symbol": "SAFT"
    },
    {
     "description": "SAGALIAM ACQUISITION CORP-A",
     "symbol": "SAGA"
    },
    {
     "description": "SAGALIAM ACQUISITION CORP",
     "symbol": "SAGAR"
    },
    {
     "description": "SAGALIAM ACQUISITION CORP",
     "symbol": "SAGAU"
    },
    {
     "description": "SOUTH AMERICAN GOLD CORP",
     "symbol": "SAGD"
    },
    {
     "description": "SAGE THERAPEUTICS INC",
     "symbol": "SAGE"
    },
    {
     "description": "STERLING METALS CORP",
     "symbol": "SAGGF"
    },
    {
     "description": "STAGECOACH GROUP PLC",
     "symbol": "SAGKF"
    },
    {
     "description": "STRATEGAS GLOBAL POLICY OPP",
     "symbol": "SAGP"
    },
    {
     "description": "ENAPTER AG",
     "symbol": "SAGRF"
    },
    {
     "description": "SAGAX AB-B",
     "symbol": "SAGXF"
    },
    {
     "description": "SONIC AUTOMOTIVE INC-CLASS A",
     "symbol": "SAH"
    },
    {
     "description": "SAHA PATHANAPIBUL PUB C-NVDR",
     "symbol": "SAHAF"
    },
    {
     "description": "SAUDI AMERICAN HOLDINGS CORP",
     "symbol": "SAHN"
    },
    {
     "description": "CAPITAN INVESTMENT LTD",
     "symbol": "SAHRF"
    },
    {
     "description": "SAIA INC",
     "symbol": "SAIA"
    },
    {
     "description": "SCIENCE APPLICATIONS INTE",
     "symbol": "SAIC"
    },
    {
     "description": "FIDELITY MINERALS CORP",
     "symbol": "SAIDF"
    },
    {
     "description": "SAILPOINT TECHNOLOGIES HOLDI",
     "symbol": "SAIL"
    },
    {
     "description": "SARATOGA INVESTMENT CORP",
     "symbol": "SAK"
    },
    {
     "description": "SAKHA ENTERPRISES CORP",
     "symbol": "SAKH"
    },
    {
     "description": "SACK LUNCH PRODUCTIONS INC",
     "symbol": "SAKL"
    },
    {
     "description": "SALISBURY BANCORP INC",
     "symbol": "SAL"
    },
    {
     "description": "SALEM MEDIA GROUP INC",
     "symbol": "SALM"
    },
    {
     "description": "SALON CITY INC",
     "symbol": "SALN"
    },
    {
     "description": "SALMAR ASA",
     "symbol": "SALRF"
    },
    {
     "description": "SALMAR ASA- UNSP ADR",
     "symbol": "SALRY"
    },
    {
     "description": "BOSTON BEER COMPANY INC-A",
     "symbol": "SAM"
    },
    {
     "description": "SCHULTZE SPECIAL PURPOSE-A",
     "symbol": "SAMA"
    },
    {
     "description": "SCHULTZE SPECIAL PURPOSE ACQ",
     "symbol": "SAMAU"
    },
    {
     "description": "SCHULTZE SPECIAL PURPO -CW28",
     "symbol": "SAMAW"
    },
    {
     "description": "SILVERCREST ASSET MANAGEME-A",
     "symbol": "SAMG"
    },
    {
     "description": "SAMSARA LUGGAGE INC",
     "symbol": "SAML"
    },
    {
     "description": "SAMA RESOURCES INC\/RESSOURCE",
     "symbol": "SAMMF"
    },
    {
     "description": "STRATEGAS MACRO THEM OPPS",
     "symbol": "SAMT"
    },
    {
     "description": "SAMUI AIRPORT PROPERTY FUND",
     "symbol": "SAMZF"
    },
    {
     "description": "BANCO SANTANDER SA-SPON ADR",
     "symbol": "SAN"
    },
    {
     "description": "SANA BIOTECHNOLOGY INC",
     "symbol": "SANA"
    },
    {
     "description": "SANABY HEALTH ACQ CORP - A",
     "symbol": "SANB"
    },
    {
     "description": "SANABY HEALTH ACQUISITION CO",
     "symbol": "SANBU"
    },
    {
     "description": "SANABY HEALTH ACQ -CW28",
     "symbol": "SANBW"
    },
    {
     "description": "SANDSTORM GOLD LTD",
     "symbol": "SAND"
    },
    {
     "description": "SANGOMA TECHNOLOGIES CORP",
     "symbol": "SANG"
    },
    {
     "description": "SANKEN ELECTRIC CO LTD",
     "symbol": "SANJF"
    },
    {
     "description": "SANMINA CORP",
     "symbol": "SANM"
    },
    {
     "description": "SANTO MINING CORP",
     "symbol": "SANP"
    },
    {
     "description": "SANTEON GROUP INC",
     "symbol": "SANT"
    },
    {
     "description": "S&W SEED CO",
     "symbol": "SANW"
    },
    {
     "description": "SERIA CO LTD",
     "symbol": "SAOGF"
    },
    {
     "description": "SAP SE-SPONSORED ADR",
     "symbol": "SAP"
    },
    {
     "description": "SAP SE",
     "symbol": "SAPGF"
    },
    {
     "description": "SAPUTO INC",
     "symbol": "SAPIF"
    },
    {
     "description": "SYLVANIA PLATINUM LTD",
     "symbol": "SAPLF"
    },
    {
     "description": "SAIPEM SPA",
     "symbol": "SAPMF"
    },
    {
     "description": "SAIPEM SPA-UNSPON ADR",
     "symbol": "SAPMY"
    },
    {
     "description": "SEVEN ARTS ENTERTAINMENT INC",
     "symbol": "SAPX"
    },
    {
     "description": "SARATOGA INVESTMENT CORP",
     "symbol": "SAR"
    },
    {
     "description": "Saraselect Namen Anteile",
     "symbol": "SARCF"
    },
    {
     "description": "SANFORD LIMITED",
     "symbol": "SARDF"
    },
    {
     "description": "SANFORD LTD-UNSPON ADR",
     "symbol": "SARDY"
    },
    {
     "description": "SABRE RESOURCES LTD",
     "symbol": "SAREF"
    },
    {
     "description": "TUTTLE CAP SHORT INNOVATION",
     "symbol": "SARK"
    },
    {
     "description": "SOUTHERN ARC MINERALS INC\/A",
     "symbol": "SARMF"
    },
    {
     "description": "CANADA HOUSE WELLNESS GROUP",
     "symbol": "SARSF"
    },
    {
     "description": "SARTORIUS AG",
     "symbol": "SARTF"
    },
    {
     "description": "ISH USD CORP ESG 0-3YR USD D",
     "symbol": "SARXF"
    },
    {
     "description": "SAS AB",
     "symbol": "SASDF"
    },
    {
     "description": "SAS AB-UNSPON ADR",
     "symbol": "SASDY"
    },
    {
     "description": "SAS DRAGON HLDGS LIMITED",
     "symbol": "SASEF"
    },
    {
     "description": "SASOL LTD",
     "symbol": "SASOF"
    },
    {
     "description": "SANDY SPRING BANCORP INC",
     "symbol": "SASR"
    },
    {
     "description": "SATELLOGIC INC-A",
     "symbol": "SATL"
    },
    {
     "description": "ZOZO INC",
     "symbol": "SATLF"
    },
    {
     "description": "SATELLOGIC INC-A -23",
     "symbol": "SATLW"
    },
    {
     "description": "INVESCO ALERIAN GALAXY CRYPT",
     "symbol": "SATO"
    },
    {
     "description": "SATO CORP",
     "symbol": "SATOF"
    },
    {
     "description": "ECHOSTAR CORP-A",
     "symbol": "SATS"
    },
    {
     "description": "SATIVUS TECH CORP",
     "symbol": "SATT"
    },
    {
     "description": "STRAUMANN HOLDING AG-REG",
     "symbol": "SAUHD"
    },
    {
     "description": "STRAUMANN HOLDING AG-UNS ADR",
     "symbol": "SAUHY"
    },
    {
     "description": "CASSAVA SCIENCES INC",
     "symbol": "SAVA"
    },
    {
     "description": "SPIRIT AIRLINES INC",
     "symbol": "SAVE"
    },
    {
     "description": "LIFEGOAL CONSERVATIVE WEALTH",
     "symbol": "SAVN"
    },
    {
     "description": "SAVANNAH RESOURCES PLC",
     "symbol": "SAVNF"
    },
    {
     "description": "SAVWATT USA INC",
     "symbol": "SAVW"
    },
    {
     "description": "SHAWCOR LTD",
     "symbol": "SAWLF"
    },
    {
     "description": "SA SA INTL HLDGS-UNSP ADR",
     "symbol": "SAXJY"
    },
    {
     "description": "SAMPO OYJ-A SHS",
     "symbol": "SAXPF"
    },
    {
     "description": "SAMPO OYJ-A SHS-UNSP ADR",
     "symbol": "SAXPY"
    },
    {
     "description": "3 SIXTY RISK SOLUTIONS LTD",
     "symbol": "SAYFF"
    },
    {
     "description": "SAFE BULKERS INC",
     "symbol": "SB"
    },
    {
     "description": "SAFE BULKERS INC",
     "symbol": "SB.PRC"
    },
    {
     "description": "SAFE BULKERS INC",
     "symbol": "SB.PRD"
    },
    {
     "description": "SBA COMMUNICATIONS CORP",
     "symbol": "SBAC"
    },
    {
     "description": "STRABAG SE-BR-UNSPON ADR",
     "symbol": "SBAGY"
    },
    {
     "description": "SUBAYE INC",
     "symbol": "SBAY"
    },
    {
     "description": "PROSHARES SHORT SMALLCAP600",
     "symbol": "SBB"
    },
    {
     "description": "SCORPIO TANKERS INC",
     "symbol": "SBBA"
    },
    {
     "description": "SEIBELS BRUCE GROUP INC",
     "symbol": "SBBG"
    },
    {
     "description": "SBCP BANCORP INC",
     "symbol": "SBBI"
    },
    {
     "description": "SABANA INDUSTRIAL REAL ESTAT",
     "symbol": "SBBSF"
    },
    {
     "description": "SCHIBSTED ASA-B SHS",
     "symbol": "SBBTF"
    },
    {
     "description": "SEACOAST BANKING CORP\/FL",
     "symbol": "SBCF"
    },
    {
     "description": "SBD CAPITAL CORP",
     "symbol": "SBDCF"
    },
    {
     "description": "SMALL BUSINESS DEVELOPMENT G",
     "symbol": "SBDG"
    },
    {
     "description": "SOUTH BEACH SPIRITS INC",
     "symbol": "SBES"
    },
    {
     "description": "SHARPLINK GAMING LTD",
     "symbol": "SBET"
    },
    {
     "description": "SPLASH BEVERAGE GROUP INC",
     "symbol": "SBEV"
    },
    {
     "description": "SPLASH BEVERAGE GROUP -CW",
     "symbol": "SBEV.WS"
    },
    {
     "description": "SBM OFFSHORE NV",
     "symbol": "SBFFF"
    },
    {
     "description": "SBM OFFSHORE NV-UNSPON ADR",
     "symbol": "SBFFY"
    },
    {
     "description": "SB FINANCIAL GROUP INC",
     "symbol": "SBFG"
    },
    {
     "description": "SUNSHINE BIOPHARMA INC",
     "symbol": "SBFM"
    },
    {
     "description": "SUNSHINE BIOPHARMA INC -27",
     "symbol": "SBFMW"
    },
    {
     "description": "SINCLAIR BROADCAST GROUP -A",
     "symbol": "SBGI"
    },
    {
     "description": "STANDARD BANK GROUP LTD",
     "symbol": "SBGOF"
    },
    {
     "description": "SCHNEIDER ELECTRIC SE",
     "symbol": "SBGSF"
    },
    {
     "description": "SCHNEIDER ELECT SE-UNSP ADR",
     "symbol": "SBGSY"
    },
    {
     "description": "SALLY BEAUTY HOLDINGS INC",
     "symbol": "SBH"
    },
    {
     "description": "SHO-BOND HOLDINGS CO LTD",
     "symbol": "SBHCF"
    },
    {
     "description": "SBI HOLDINGS INC",
     "symbol": "SBHGF"
    },
    {
     "description": "SINO BIOPHARMACEUTICAL-UNADR",
     "symbol": "SBHMY"
    },
    {
     "description": "WESTERN ASSET INTERMEDIATE",
     "symbol": "SBI"
    },
    {
     "description": "SABRE INS GROUP - UNSP ADR",
     "symbol": "SBIGY"
    },
    {
     "description": "SANDBRIDGE X2 CORP-A",
     "symbol": "SBII"
    },
    {
     "description": "SANDBRIDGE X2 CORP",
     "symbol": "SBII.U"
    },
    {
     "description": "SANDBRIDGE X2 CL A -CW27",
     "symbol": "SBII.WS"
    },
    {
     "description": "INVESCO NASDAQ BIOTECH",
     "symbol": "SBIMF"
    },
    {
     "description": "ALPS MEDICAL BREAKTHROUGHS",
     "symbol": "SBIO"
    },
    {
     "description": "STATE BANK OF INDI-GDR REG S",
     "symbol": "SBKFF"
    },
    {
     "description": "SUMITOMO BAKELITE CO LTD",
     "symbol": "SBKLF"
    },
    {
     "description": "SUMMIT BANK GROUP INC",
     "symbol": "SBKO"
    },
    {
     "description": "STAR BULK CARRIERS CORP",
     "symbol": "SBLK"
    },
    {
     "description": "Shin Nippon Biomedical Laboratories Ltd",
     "symbol": "SBLOF"
    },
    {
     "description": "SABLE RESOURCES LTD",
     "symbol": "SBLRF"
    },
    {
     "description": "STABILUS SE-UNSP ADR",
     "symbol": "SBLUY"
    },
    {
     "description": "PROSHARES SHORT BASIC MAT",
     "symbol": "SBM"
    },
    {
     "description": "SILVER BULLET MINES CORP",
     "symbol": "SBMCF"
    },
    {
     "description": "SINO BIOPHARMACEUTICAL",
     "symbol": "SBMFF"
    },
    {
     "description": "STRATABOUND MINERALS CORP",
     "symbol": "SBMIF"
    },
    {
     "description": "DANAKALI LTD",
     "symbol": "SBMSF"
    },
    {
     "description": "SOUTHERN BANCSHARES INC\/N C",
     "symbol": "SBNC"
    },
    {
     "description": "SOUTHERN BANCSHARES-PREF B",
     "symbol": "SBNCM"
    },
    {
     "description": "SOUTHERN BANCSHARE-PREF C",
     "symbol": "SBNCN"
    },
    {
     "description": "COLUMBIA SHORT DURATION BOND",
     "symbol": "SBND"
    },
    {
     "description": "SIGNATURE BANK",
     "symbol": "SBNY"
    },
    {
     "description": "SIGNATURE BANK NEW YORK",
     "symbol": "SBNYP"
    },
    {
     "description": "SCHOELLER-BLECKMANN OILFIELD",
     "symbol": "SBOEF"
    },
    {
     "description": "SCHOELLER-BLECKMANN-UNSP ADR",
     "symbol": "SBOEY"
    },
    {
     "description": "SILVERBOW RESOURCES INC",
     "symbol": "SBOW"
    },
    {
     "description": "SUPERBOX INC",
     "symbol": "SBOX"
    },
    {
     "description": "SABINE ROYALTY TRUST",
     "symbol": "SBR"
    },
    {
     "description": "SABRA HEALTH CARE REIT INC",
     "symbol": "SBRA"
    },
    {
     "description": "SBERBANK PJSC -SPONSORED ADR",
     "symbol": "SBRCY"
    },
    {
     "description": "SPAREBANK 1 SR BANK ASA",
     "symbol": "SBRKF"
    },
    {
     "description": "CIA SANEAMENTO BASICO DE-ADR",
     "symbol": "SBS"
    },
    {
     "description": "SPANISH BROADCASTING SYS-A",
     "symbol": "SBSAA"
    },
    {
     "description": "SOUTHSIDE BANCSHARES INC",
     "symbol": "SBSI"
    },
    {
     "description": "SCHIBSTED ASA-CL A",
     "symbol": "SBSNF"
    },
    {
     "description": "SCHIBSTED ASA-UNSPONS ADR",
     "symbol": "SBSNY"
    },
    {
     "description": "SBS HOLDINGS INC",
     "symbol": "SBSOF"
    },
    {
     "description": "SBS TRANSIT LTD",
     "symbol": "SBSTF"
    },
    {
     "description": "SIBANYE-STILLWATER LTD-ADR",
     "symbol": "SBSW"
    },
    {
     "description": "STERLING BANCORP INC\/MI",
     "symbol": "SBT"
    },
    {
     "description": "SILVERBACK THERAPEUTICS INC",
     "symbol": "SBTX"
    },
    {
     "description": "SUGARBUD CRAFT GROWERS CORP",
     "symbol": "SBUDF"
    },
    {
     "description": "IPATH SILVER ETN",
     "symbol": "SBUG"
    },
    {
     "description": "SILVER BUCKLE MINES INC",
     "symbol": "SBUM"
    },
    {
     "description": "STARBUCKS CORP",
     "symbol": "SBUX"
    },
    {
     "description": "SABVEST CAPITAL LTD",
     "symbol": "SBVTF"
    },
    {
     "description": "CORNISH METALS INC",
     "symbol": "SBWFF"
    },
    {
     "description": "SIBANYE STILLWATER LTD",
     "symbol": "SBYSF"
    },
    {
     "description": "SVENSKA CELLULO - UNSP ADR",
     "symbol": "SCABY"
    },
    {
     "description": "STEM CELL AUTHORITY LTD",
     "symbol": "SCAL"
    },
    {
     "description": "STRATIM CLOUD ACQUISITION CO",
     "symbol": "SCAQ"
    },
    {
     "description": "STRATIM CLOUD ACQUISITION CO",
     "symbol": "SCAQU"
    },
    {
     "description": "STRATIM CLOUD ACQ -CW28",
     "symbol": "SCAQW"
    },
    {
     "description": "SPARTA CAPITAL LTD",
     "symbol": "SCAXF"
    },
    {
     "description": "STANDARD CHARTERED PLC",
     "symbol": "SCBFF"
    },
    {
     "description": "STANDARD CHARTERED- UNSP ADR",
     "symbol": "SCBFY"
    },
    {
     "description": "SIG GROUP AG",
     "symbol": "SCBGF"
    },
    {
     "description": "SCIENCE BLOCKCHAIN PTE LTD",
     "symbol": "SCBKF"
    },
    {
     "description": "SOUTHERN COMMUNITY BANCSHARE",
     "symbol": "SCBS"
    },
    {
     "description": "SCOOBEEZ GLOBAL INC",
     "symbol": "SCBZ"
    },
    {
     "description": "PROSHARES ULTRASHORT CONS SV",
     "symbol": "SCC"
    },
    {
     "description": "SLEEP COUNTRY CANADA HOLDING",
     "symbol": "SCCAF"
    },
    {
     "description": "SACHEM CAPITAL CORP",
     "symbol": "SCCB"
    },
    {
     "description": "SACHEM CAPITAL CORP",
     "symbol": "SCCC"
    },
    {
     "description": "SUNAC CHINA HOLDINGS LTD",
     "symbol": "SCCCF"
    },
    {
     "description": "SACHEM CAPITAL CORP",
     "symbol": "SCCD"
    },
    {
     "description": "SACHEM CAPITAL CORP",
     "symbol": "SCCE"
    },
    {
     "description": "STRATEGIC RESOURCES INC",
     "symbol": "SCCFF"
    },
    {
     "description": "SOUTHERN COPPER CORP",
     "symbol": "SCCO"
    },
    {
     "description": "SCICLONE PHARMACEUTICALS HOL",
     "symbol": "SCCPF"
    },
    {
     "description": "ALSET CAPITAL INC",
     "symbol": "SCCRF"
    },
    {
     "description": "SCOUT24 AG-UNSPON ADR",
     "symbol": "SCCTY"
    },
    {
     "description": "LMP CAPITAL AND INCOME FUND",
     "symbol": "SCD"
    },
    {
     "description": "B-SCADA INC",
     "symbol": "SCDA"
    },
    {
     "description": "ETRACS 2X DIVID FACTR TR",
     "symbol": "SCDL"
    },
    {
     "description": "SCE TRUST II",
     "symbol": "SCE.PRG"
    },
    {
     "description": "SCE TRUST III",
     "symbol": "SCE.PRH"
    },
    {
     "description": "SCE TRUST IV",
     "symbol": "SCE.PRJ"
    },
    {
     "description": "SCE TRUST V",
     "symbol": "SCE.PRK"
    },
    {
     "description": "SCE TRUST VI",
     "symbol": "SCE.PRL"
    },
    {
     "description": "SCHOLAR EDUCATION GROUP",
     "symbol": "SCEDF"
    },
    {
     "description": "SOURCE ENERGY SERVICES LTD",
     "symbol": "SCEYF"
    },
    {
     "description": "SPOT COFFEE CANADA LTD",
     "symbol": "SCFFF"
    },
    {
     "description": "SCHAEFFLER AG - PREF",
     "symbol": "SCFLF"
    },
    {
     "description": "SECURITY FIRST INTERNATIONAL",
     "symbol": "SCFR"
    },
    {
     "description": "SHOUCHENG HOLDINGS LTD -ADR",
     "symbol": "SCGEY"
    },
    {
     "description": "SUNCITY GROUP HOLDINGS LTD",
     "symbol": "SCGHF"
    },
    {
     "description": "SOCIETE GENERALE SA",
     "symbol": "SCGLF"
    },
    {
     "description": "SOCIETE GENERALE-SPONS ADR",
     "symbol": "SCGLY"
    },
    {
     "description": "SERCO GROUP PLC-SPON ADR",
     "symbol": "SCGPY"
    },
    {
     "description": "SECOS GROUP LTD",
     "symbol": "SCGRF"
    },
    {
     "description": "SAXON CAPITAL GROUP INC",
     "symbol": "SCGX"
    },
    {
     "description": "SCIENTIFIC ENERGY INC",
     "symbol": "SCGY"
    },
    {
     "description": "SCHWAB US SMALL-CAP ETF",
     "symbol": "SCHA"
    },
    {
     "description": "SCHWAB US BROAD MARKET ETF",
     "symbol": "SCHB"
    },
    {
     "description": "SCHWAB INTL SMALL-CAP EQUITY",
     "symbol": "SCHC"
    },
    {
     "description": "SCHWAB US DVD EQUITY ETF",
     "symbol": "SCHD"
    },
    {
     "description": "SCHWAB EMERGING MARKETS EQUI",
     "symbol": "SCHE"
    },
    {
     "description": "SCHWAB INTL EQUITY ETF",
     "symbol": "SCHF"
    },
    {
     "description": "SCHWAB U.S. LARGE-CAP GROWTH",
     "symbol": "SCHG"
    },
    {
     "description": "SCHWAB US REIT ETF",
     "symbol": "SCHH"
    },
    {
     "description": "SCHWAB 5-10 YEAR CORPORATE B",
     "symbol": "SCHI"
    },
    {
     "description": "SCHWAB 1-5 YEAR CORPORATE BO",
     "symbol": "SCHJ"
    },
    {
     "description": "SCHWAB 1000 INDEX ETF",
     "symbol": "SCHK"
    },
    {
     "description": "SCHOLASTIC CORP",
     "symbol": "SCHL"
    },
    {
     "description": "SCHWAB US MID CAP ETF",
     "symbol": "SCHM"
    },
    {
     "description": "SCHNITZER STEEL INDS INC-A",
     "symbol": "SCHN"
    },
    {
     "description": "SCHWAB SHORT-TERM US TREAS",
     "symbol": "SCHO"
    },
    {
     "description": "SCHWAB U.S. TIPS ETF",
     "symbol": "SCHP"
    },
    {
     "description": "SCHWAB LONG-TERM US TREASURY",
     "symbol": "SCHQ"
    },
    {
     "description": "SCHWAB INTERMEDIATE-TERM US",
     "symbol": "SCHR"
    },
    {
     "description": "SCHWAB US LARGE-CAP VALUE",
     "symbol": "SCHV"
    },
    {
     "description": "SCHWAB (CHARLES) CORP",
     "symbol": "SCHW"
    },
    {
     "description": "CHARLES SCHWAB CORP",
     "symbol": "SCHW.PRD"
    },
    {
     "description": "CHARLES SCHWAB CORP",
     "symbol": "SCHW.PRJ"
    },
    {
     "description": "SCHWAB US LARGE-CAP ETF",
     "symbol": "SCHX"
    },
    {
     "description": "SCHWAB INTERNATIONAL DVD ETF",
     "symbol": "SCHY"
    },
    {
     "description": "SANDS CHINA LTD",
     "symbol": "SCHYF"
    },
    {
     "description": "SANDS CHINA LTD-UNSPONS ADR",
     "symbol": "SCHYY"
    },
    {
     "description": "SCHWAB US AGGREGATE BOND ETF",
     "symbol": "SCHZ"
    },
    {
     "description": "SERVICE CORP INTERNATIONAL",
     "symbol": "SCI"
    },
    {
     "description": "SCI ENGINEERED MATERIALS INC",
     "symbol": "SCIA"
    },
    {
     "description": "SPECTRASCIENCE INC",
     "symbol": "SCIE"
    },
    {
     "description": "SUNY CELLULAR COMMUNICATION",
     "symbol": "SCIXF"
    },
    {
     "description": "ISHARES MSCI JAPAN SMALL-CAP",
     "symbol": "SCJ"
    },
    {
     "description": "SOCKET MOBILE INC",
     "symbol": "SCKT"
    },
    {
     "description": "STEPAN CO",
     "symbol": "SCL"
    },
    {
     "description": "BROADSCALE ACQUISITION -CL A",
     "symbol": "SCLE"
    },
    {
     "description": "BROADSCALE ACQUISITION CORP",
     "symbol": "SCLEU"
    },
    {
     "description": "BROADSCALE ACQ CL A -CW26",
     "symbol": "SCLEW"
    },
    {
     "description": "SCALES CORP LTD",
     "symbol": "SCLZF"
    },
    {
     "description": "STELLUS CAPITAL INVESTMENT C",
     "symbol": "SCM"
    },
    {
     "description": "SEAPORT CALIBRE MATERIALS AC",
     "symbol": "SCMA"
    },
    {
     "description": "SEAPORT CALIBRE MATERIALS AC",
     "symbol": "SCMAU"
    },
    {
     "description": "SEAPORT CALIBRE MATERI -CW23",
     "symbol": "SCMAW"
    },
    {
     "description": "SWISSCOM AG-SPONSORED ADR",
     "symbol": "SCMWY"
    },
    {
     "description": "SMART CANNABIS CORP",
     "symbol": "SCNA"
    },
    {
     "description": "SCIENTIFIC INDUSTRIES INC",
     "symbol": "SCND"
    },
    {
     "description": "SCANFIL OYJ",
     "symbol": "SCNFF"
    },
    {
     "description": "SC HOLDINGS CORP",
     "symbol": "SCNG"
    },
    {
     "description": "SCANCELL HOLDINGS PLC",
     "symbol": "SCNLF"
    },
    {
     "description": "SCIENT INC",
     "symbol": "SCNTQ"
    },
    {
     "description": "PROSHARES ULTRASHORT BLOOMBE",
     "symbol": "SCO"
    },
    {
     "description": "SCION TECH GROWTH I-CLASS A",
     "symbol": "SCOA"
    },
    {
     "description": "SCION TECH GROWTH I",
     "symbol": "SCOAU"
    },
    {
     "description": "SCION TECH GROWTH I-CW25",
     "symbol": "SCOAW"
    },
    {
     "description": "SCION TECH GROWTH II-CLASS A",
     "symbol": "SCOB"
    },
    {
     "description": "SCION TECH GROWTH II",
     "symbol": "SCOBU"
    },
    {
     "description": "SCION TECH GROWTH II -CW27",
     "symbol": "SCOBW"
    },
    {
     "description": "SCHOOL SPECIALTY INC",
     "symbol": "SCOO"
    },
    {
     "description": "COMSCORE INC",
     "symbol": "SCOR"
    },
    {
     "description": "SCOUT24 SE",
     "symbol": "SCOTF"
    },
    {
     "description": "SHOPPING CENTRES AUSTRALASIA",
     "symbol": "SCPAF"
    },
    {
     "description": "SCPHARMACEUTICALS INC",
     "symbol": "SCPH"
    },
    {
     "description": "SCOPE INDUSTRIES",
     "symbol": "SCPJ"
    },
    {
     "description": "7C SOLARPARKEN AG",
     "symbol": "SCPKF"
    },
    {
     "description": "SCIPLAY CORP-CLASS A",
     "symbol": "SCPL"
    },
    {
     "description": "S4 CAPITAL PLC",
     "symbol": "SCPPF"
    },
    {
     "description": "SCOPUS BIOPHARMA INC",
     "symbol": "SCPS"
    },
    {
     "description": "SPORTS CONCEPTS INC",
     "symbol": "SCPT"
    },
    {
     "description": "SCRIPSAMERICA INC",
     "symbol": "SCRCQ"
    },
    {
     "description": "JANUS HENDERSON SUST CORP BD",
     "symbol": "SCRD"
    },
    {
     "description": "SCORES HOLDING CO INC",
     "symbol": "SCRH"
    },
    {
     "description": "SCREAMING EAGLE ACQ -CLASS A",
     "symbol": "SCRM"
    },
    {
     "description": "SCREAMING EAGLE ACQUISITION",
     "symbol": "SCRMU"
    },
    {
     "description": "SCREAMING EAGLE ACQ CL A -27",
     "symbol": "SCRMW"
    },
    {
     "description": "SEMBCORP INDUSTRIES LTD",
     "symbol": "SCRPF"
    },
    {
     "description": "SCHRODER REAL RETURN FUND",
     "symbol": "SCRRF"
    },
    {
     "description": "SCREENPRO SECURITY INC",
     "symbol": "SCRSF"
    },
    {
     "description": "SCOR-SPONSORED ADR",
     "symbol": "SCRYY"
    },
    {
     "description": "STEELCASE INC-CL A",
     "symbol": "SCS"
    },
    {
     "description": "SCANSOURCE INC",
     "symbol": "SCSC"
    },
    {
     "description": "SCOTTISH ORIENTAL SMALL COS",
     "symbol": "SCSHF"
    },
    {
     "description": "SCSK CORP",
     "symbol": "SCSKF"
    },
    {
     "description": "SECURITAS AB-B SHS",
     "symbol": "SCTBF"
    },
    {
     "description": "SECURITAS AB-UNSPONSORED ADR",
     "symbol": "SCTBY"
    },
    {
     "description": "SCOUTCAM INC",
     "symbol": "SCTC"
    },
    {
     "description": "SCOUT GAMING GROUP AB",
     "symbol": "SCTGF"
    },
    {
     "description": "SOCIETAL CDMO INC",
     "symbol": "SCTL"
    },
    {
     "description": "SCHIMATIC CASH TRANSACTIONS",
     "symbol": "SCTN"
    },
    {
     "description": "SPECTRA SYSTEMS CORP",
     "symbol": "SCTQ"
    },
    {
     "description": "SCOTTIE RESOURCES CORP",
     "symbol": "SCTSF"
    },
    {
     "description": "SCOTT TECHNOLOGY LTD",
     "symbol": "SCTTF"
    },
    {
     "description": "MONITRONICS INTERNATIONAL IN",
     "symbol": "SCTY"
    },
    {
     "description": "SCULPTOR CAPITAL MANAGEMENT",
     "symbol": "SCU"
    },
    {
     "description": "SCULPTOR ACQUISITION CORP -A",
     "symbol": "SCUA"
    },
    {
     "description": "SCULPTOR ACQUISITION CORP I",
     "symbol": "SCUA.U"
    },
    {
     "description": "SCULPTOR ACQUISITION A -23",
     "symbol": "SCUA.WS"
    },
    {
     "description": "AEGIS BRANDS INC",
     "symbol": "SCUPF"
    },
    {
     "description": "SCOTCH CREEK VENTURES INC",
     "symbol": "SCVFF"
    },
    {
     "description": "SHOE CARNIVAL INC",
     "symbol": "SCVL"
    },
    {
     "description": "SIAM CEMENT PUB CO-FOR REG",
     "symbol": "SCVPF"
    },
    {
     "description": "SIAM CEMENT PUBLIC-UNSP ADR",
     "symbol": "SCVPY"
    },
    {
     "description": "SIAM CEMENT PCL-NVDR",
     "symbol": "SCVUF"
    },
    {
     "description": "SCVX CORP - CLASS A",
     "symbol": "SCVX"
    },
    {
     "description": "SCVX CORP",
     "symbol": "SCVXU"
    },
    {
     "description": "CVX CORP - CLASS A -CW25",
     "symbol": "SCVXW"
    },
    {
     "description": "374WATER INC",
     "symbol": "SCWO"
    },
    {
     "description": "SCHWEITER TECHNOLOGIES AG-BR",
     "symbol": "SCWTF"
    },
    {
     "description": "SECUREWORKS CORP - A",
     "symbol": "SCWX"
    },
    {
     "description": "STARRETT (L.S.) CO  -CL A",
     "symbol": "SCX"
    },
    {
     "description": "STARRET (L.S.) CO-CL B",
     "symbol": "SCXLB"
    },
    {
     "description": "SCRYB INC",
     "symbol": "SCYRF"
    },
    {
     "description": "SECURITY BANCORP INC \/ TENN",
     "symbol": "SCYT"
    },
    {
     "description": "SCYNEXIS INC",
     "symbol": "SCYX"
    },
    {
     "description": "SCANDIUM INTERNATIONAL MININ",
     "symbol": "SCYYF"
    },
    {
     "description": "ISHARES MSCI EAFE SMALL-CAP",
     "symbol": "SCZ"
    },
    {
     "description": "SANTA CRUZ COUNTY BANK",
     "symbol": "SCZC"
    },
    {
     "description": "SANDRIDGE ENERGY INC",
     "symbol": "SD"
    },
    {
     "description": "SUSTAINABLE DEVELOPMENT AC-A",
     "symbol": "SDAC"
    },
    {
     "description": "SUSTAINABLE DEVELOPMENT ACQU",
     "symbol": "SDACU"
    },
    {
     "description": "SUSTAINABLE DEVELOP A -CW28",
     "symbol": "SDACW"
    },
    {
     "description": "S H RESEARCH & DEVELOPMENT C",
     "symbol": "SDAD"
    },
    {
     "description": "STUDIO ALICE CO LTD",
     "symbol": "SDAZF"
    },
    {
     "description": "SMILEDIRECTCLUB INC",
     "symbol": "SDC"
    },
    {
     "description": "USCF SUMMERHAVEN DYNAMIC ETF",
     "symbol": "SDCI"
    },
    {
     "description": "SA DES CIMENTS VICAT-VICAT",
     "symbol": "SDCVF"
    },
    {
     "description": "PROSHARES ULTRASHORT SC600",
     "symbol": "SDD"
    },
    {
     "description": "TERNIUM ARGENTINA SA",
     "symbol": "SDDFF"
    },
    {
     "description": "SMART DECISION INC",
     "symbol": "SDEC"
    },
    {
     "description": "SOUND ENHANCED FIXED INCOME",
     "symbol": "SDEF"
    },
    {
     "description": "SOUND EQUITY INCOME ETF",
     "symbol": "SDEI"
    },
    {
     "description": "GLOBAL X MSCI SUPERDIVIDEND",
     "symbol": "SDEM"
    },
    {
     "description": "ISH MSCI GLOB SUST DEVE GOAL",
     "symbol": "SDG"
    },
    {
     "description": "IMPACT SHARES SUSTAINABLE DE",
     "symbol": "SDGA"
    },
    {
     "description": "SUNDRUG CO LTD",
     "symbol": "SDGCF"
    },
    {
     "description": "SHANDONG GOLD MINING CO LT-H",
     "symbol": "SDGMF"
    },
    {
     "description": "SCHRODINGER INC",
     "symbol": "SDGR"
    },
    {
     "description": "GLOBAL INTERNET OF PEOPLE IN",
     "symbol": "SDH"
    },
    {
     "description": "PGIM SHRT DURAT HI YLD",
     "symbol": "SDHY"
    },
    {
     "description": "STRONGHOLD DIGITAL MINING-A",
     "symbol": "SDIG"
    },
    {
     "description": "SDI GROUP PLC",
     "symbol": "SDIIF"
    },
    {
     "description": "FRASERS GROUP PLC",
     "symbol": "SDIPF"
    },
    {
     "description": "GLOBAL X SUPERDIVIDEND ETF",
     "symbol": "SDIV"
    },
    {
     "description": "SDI LTD",
     "symbol": "SDLDF"
    },
    {
     "description": "SARTORIUS STEDIM BIOTECH",
     "symbol": "SDMHF"
    },
    {
     "description": "SCANDIA INC",
     "symbol": "SDNI"
    },
    {
     "description": "SUMITOMO DENSETSU CO LTD",
     "symbol": "SDNSF"
    },
    {
     "description": "SIDERURGICA VENEZ SIV-SP ADR",
     "symbol": "SDNVY"
    },
    {
     "description": "ALPS SECTOR DIVIDEND DOGS",
     "symbol": "SDOG"
    },
    {
     "description": "SANDSTON CORP",
     "symbol": "SDON"
    },
    {
     "description": "PROSHARES ULTPRO SHRT DOW30",
     "symbol": "SDOW"
    },
    {
     "description": "PROSHARES ULTSHRT UTILITIES",
     "symbol": "SDP"
    },
    {
     "description": "SUPERIOR DRILLING PRODUCTS I",
     "symbol": "SDPI"
    },
    {
     "description": "SIME DARBY PLANTATION BHD",
     "symbol": "SDPNF"
    },
    {
     "description": "SIDNEY RESOURCES CORP",
     "symbol": "SDRC"
    },
    {
     "description": "SANDRIDGE ENERGY INC-B-CW22",
     "symbol": "SDRDW"
    },
    {
     "description": "SITEMINDER LTD",
     "symbol": "SDRMF"
    },
    {
     "description": "SANDRIDGE ENERGY INC-A-CW22",
     "symbol": "SDRWW"
    },
    {
     "description": "PROSHARES ULTRASHORT S&P500",
     "symbol": "SDS"
    },
    {
     "description": "SUSPECT DETECTION SYSTEMS IN",
     "symbol": "SDSS"
    },
    {
     "description": "SOUTH DAKOTA SOYBEAN PROCE-A",
     "symbol": "SDSYA"
    },
    {
     "description": "SDIPTECH AB - B",
     "symbol": "SDTHF"
    },
    {
     "description": "SANDRIDGE MISSISSIPPIAN TRUS",
     "symbol": "SDTTU"
    },
    {
     "description": "STROUD RESOURCES LTD",
     "symbol": "SDURF"
    },
    {
     "description": "ISHARES MSCI USD ESG SCREEND",
     "symbol": "SDUSF"
    },
    {
     "description": "SIGNATURE DEVICES INC",
     "symbol": "SDVI"
    },
    {
     "description": "SANDVIK AB",
     "symbol": "SDVKF"
    },
    {
     "description": "SANDVIK AB-SPONSORED ADR",
     "symbol": "SDVKY"
    },
    {
     "description": "FIRST TRUST SMID CAP RISING",
     "symbol": "SDVY"
    },
    {
     "description": "SOUNDWILL HOLDINGS LTD",
     "symbol": "SDWHF"
    },
    {
     "description": "SHENGDA NETWORK TECHNOLOGY I",
     "symbol": "SDWL"
    },
    {
     "description": "SODEXO-SPONSORED ADR",
     "symbol": "SDXAY"
    },
    {
     "description": "SDX ENERGY PLC",
     "symbol": "SDXEF"
    },
    {
     "description": "SODEXO SA",
     "symbol": "SDXOF"
    },
    {
     "description": "SPDR S&P DIVIDEND ETF",
     "symbol": "SDY"
    },
    {
     "description": "SEA LTD-ADR",
     "symbol": "SE"
    },
    {
     "description": "US GLOBAL SEA TO SKY CARGO",
     "symbol": "SEA"
    },
    {
     "description": "SEACHANGE INTERNATIONAL INC",
     "symbol": "SEAC"
    },
    {
     "description": "SEAPEAK LLC",
     "symbol": "SEAL.PRA"
    },
    {
     "description": "SEAPEAK LLC",
     "symbol": "SEAL.PRB"
    },
    {
     "description": "XSPRING CAPITAL PCL",
     "symbol": "SEAMF"
    },
    {
     "description": "SEACO LTD",
     "symbol": "SEAOF"
    },
    {
     "description": "SEAWORLD ENTERTAINMENT INC",
     "symbol": "SEAS"
    },
    {
     "description": "VIVID SEATS INC - CLASS A",
     "symbol": "SEAT"
    },
    {
     "description": "VIVID SEATS INC -CW26",
     "symbol": "SEATW"
    },
    {
     "description": "SEATECH VENTURES CORP",
     "symbol": "SEAV"
    },
    {
     "description": "SEABOARD CORP",
     "symbol": "SEB"
    },
    {
     "description": "SOUTHEASTERN BANKING CORP",
     "symbol": "SEBC"
    },
    {
     "description": "SMART EMPLOYEE BENEFITS INC",
     "symbol": "SEBFF"
    },
    {
     "description": "SEVEN BANK LTD",
     "symbol": "SEBNF"
    },
    {
     "description": "SEB SA",
     "symbol": "SEBYF"
    },
    {
     "description": "SEB SA - UNSP ADR",
     "symbol": "SEBYY"
    },
    {
     "description": "SERCO GROUP PLC",
     "symbol": "SECCF"
    },
    {
     "description": "STARTENGINE COLLECT-MBP UNIT",
     "symbol": "SECFS"
    },
    {
     "description": "SECTOR 10 INC",
     "symbol": "SECI"
    },
    {
     "description": "SEC CARBON LTD",
     "symbol": "SECNF"
    },
    {
     "description": "SECOO HOLDING LTD - ADR",
     "symbol": "SECO"
    },
    {
     "description": "MAIN SECTOR ROTATION ETF",
     "symbol": "SECT"
    },
    {
     "description": "SPDR S&P US CON STAP SELECT",
     "symbol": "SECTF"
    },
    {
     "description": "SSC SECURITY SERVICES CORP",
     "symbol": "SECUF"
    },
    {
     "description": "SECHE ENVIRONNEM-UNSPON ADR",
     "symbol": "SECVY"
    },
    {
     "description": "SECURE ENERGY SERVICES INC",
     "symbol": "SECYF"
    },
    {
     "description": "SDCL EDGE ACQUISITION CORP-A",
     "symbol": "SEDA"
    },
    {
     "description": "SDCL EDGE ACQUISITION CORP",
     "symbol": "SEDA.U"
    },
    {
     "description": "SDCL EDGE ACQ CL A -CW28",
     "symbol": "SEDA.WS"
    },
    {
     "description": "SOLAREDGE TECHNOLOGIES INC",
     "symbol": "SEDG"
    },
    {
     "description": "SUMBER ENERGI ANDALAN TBK P",
     "symbol": "SEDKF"
    },
    {
     "description": "SED INTERNATIONAL HLDGS INC",
     "symbol": "SEDN"
    },
    {
     "description": "SEALED AIR CORP",
     "symbol": "SEE"
    },
    {
     "description": "ORIGIN AGRITECH LTD",
     "symbol": "SEED"
    },
    {
     "description": "THEDIRECTORY.COM INC",
     "symbol": "SEEK"
    },
    {
     "description": "SEELOS THERAPEUTICS INC",
     "symbol": "SEEL"
    },
    {
     "description": "SEEING MACHINES LTD",
     "symbol": "SEEMF"
    },
    {
     "description": "SEER INC",
     "symbol": "SEER"
    },
    {
     "description": "PROSHARES SHORT FINANCIALS",
     "symbol": "SEF"
    },
    {
     "description": "SYCAMORE ENTERTAINMENT GROUP",
     "symbol": "SEGI"
    },
    {
     "description": "Southeastern Grocers Inc",
     "symbol": "SEGR"
    },
    {
     "description": "SIA ENGINEERING CO LTD",
     "symbol": "SEGSF"
    },
    {
     "description": "SIA ENGINEERING CO-UNSP ADR",
     "symbol": "SEGSY"
    },
    {
     "description": "SEGRO PLC",
     "symbol": "SEGXF"
    },
    {
     "description": "SPT ENERGY GROUP INC-UNS ADR",
     "symbol": "SEGYY"
    },
    {
     "description": "SWEET EARTH HOLDINGS CORP",
     "symbol": "SEHCF"
    },
    {
     "description": "SEAHAWK GOLD CORP",
     "symbol": "SEHKF"
    },
    {
     "description": "SOLARGIGA ENERGY HOLDINGS LT",
     "symbol": "SEHLF"
    },
    {
     "description": "SEIBU HOLDINGS INC",
     "symbol": "SEIBF"
    },
    {
     "description": "SEI INVESTMENTS COMPANY",
     "symbol": "SEIC"
    },
    {
     "description": "SEMPERIT AG HOLDING",
     "symbol": "SEIGF"
    },
    {
     "description": "SEMPERIT AG HOLDING-UNSP ADR",
     "symbol": "SEIGY"
    },
    {
     "description": "SHARING ECONOMY INTERNATIONA",
     "symbol": "SEII"
    },
    {
     "description": "SEILON INC MIDWEST",
     "symbol": "SEIL"
    },
    {
     "description": "VIRTUS SEIX SENIOR LOAN ETF",
     "symbol": "SEIX"
    },
    {
     "description": "SEIKO EPSON CORP",
     "symbol": "SEKEF"
    },
    {
     "description": "SEIKO EPSON CORP-UNSPON ADR",
     "symbol": "SEKEY"
    },
    {
     "description": "SEIKITOKYU KOGYO CO LTD",
     "symbol": "SEKYF"
    },
    {
     "description": "SECOVA METALS CORP",
     "symbol": "SEKZF"
    },
    {
     "description": "SELECTA BIOSCIENCES INC",
     "symbol": "SELB"
    },
    {
     "description": "GLOBAL SELF STORAGE INC",
     "symbol": "SELF"
    },
    {
     "description": "STEELE OCEANIC CORP",
     "symbol": "SELR"
    },
    {
     "description": "ST. ELIAS MINES LTD",
     "symbol": "SELSF"
    },
    {
     "description": "SELECT MEDICAL HOLDINGS CORP",
     "symbol": "SEM"
    },
    {
     "description": "SIEMENS HEALTHINEERS AG",
     "symbol": "SEMHF"
    },
    {
     "description": "COLUMBIA SELIG SEMICON AN TE",
     "symbol": "SEMI"
    },
    {
     "description": "SEMRUSH HOLDINGS INC-A",
     "symbol": "SEMR"
    },
    {
     "description": "SIEM INDUSTRIES INC",
     "symbol": "SEMUF"
    },
    {
     "description": "SENECA FOODS CORP - CL A",
     "symbol": "SENEA"
    },
    {
     "description": "SENECA FOODS CORP - CL B",
     "symbol": "SENEB"
    },
    {
     "description": "Seneca Foods Corp",
     "symbol": "SENEM"
    },
    {
     "description": "SENSERA LTD",
     "symbol": "SENFF"
    },
    {
     "description": "SENSORION SA",
     "symbol": "SENOF"
    },
    {
     "description": "STRATEGIC ENVIRONMENTAL & EN",
     "symbol": "SENR"
    },
    {
     "description": "SENSEONICS HOLDINGS INC",
     "symbol": "SENS"
    },
    {
     "description": "ADVISORSHARES ALPHA DNA EQUI",
     "symbol": "SENT"
    },
    {
     "description": "STORA ENSO OYJ-SPONS ADR",
     "symbol": "SEOAY"
    },
    {
     "description": "STORA ENSO OYJ-R SHS",
     "symbol": "SEOJF"
    },
    {
     "description": "SEINO HOLDINGS CO LTD",
     "symbol": "SEOTF"
    },
    {
     "description": "SERNOVA CORP",
     "symbol": "SEOVF"
    },
    {
     "description": "SUPERDRY PLC",
     "symbol": "SEPGF"
    },
    {
     "description": "SUPERDRY PLC - UNSP ADR",
     "symbol": "SEPGY"
    },
    {
     "description": "SEAESCAPE ENTERTAINMENT INC",
     "symbol": "SEPI"
    },
    {
     "description": "SPECTRIS PLC",
     "symbol": "SEPJF"
    },
    {
     "description": "SPECTRIS PLC-UNSP ADR",
     "symbol": "SEPJY"
    },
    {
     "description": "BLUEMETRIC ENVIRONMENTAL INC",
     "symbol": "SEPOF"
    },
    {
     "description": "ASEP MEDICAL HOLDINGS INC",
     "symbol": "SEPSF"
    },
    {
     "description": "TRUESHARES STRUC OUT SEP ETF",
     "symbol": "SEPZ"
    },
    {
     "description": "SEQUOIA ECONOMIC INFRASTRUCT",
     "symbol": "SEQIF"
    },
    {
     "description": "SERA PROGNOSTICS INC-A",
     "symbol": "SERA"
    },
    {
     "description": "SERKO LTD",
     "symbol": "SERKF"
    },
    {
     "description": "SEIREN CO LTD",
     "symbol": "SERNF"
    },
    {
     "description": "SES AI CORP",
     "symbol": "SES"
    },
    {
     "description": "IVANHOE CAPITAL CL A -CW27",
     "symbol": "SES.WS"
    },
    {
     "description": "SES SOLAR INC",
     "symbol": "SESI"
    },
    {
     "description": "SUESS MICROTEC SE",
     "symbol": "SESMF"
    },
    {
     "description": "SESEN BIO INC",
     "symbol": "SESN"
    },
    {
     "description": "SETO HOLDINGS INC",
     "symbol": "SETO"
    },
    {
     "description": "SHIN-ETSU POLYMER CO LTD",
     "symbol": "SETUF"
    },
    {
     "description": "STAR ENTERTAINMENT GROUP INC",
     "symbol": "SETY"
    },
    {
     "description": "SONO GROUP NV",
     "symbol": "SEV"
    },
    {
     "description": "STS EVERMEDIA CORP",
     "symbol": "SEVM"
    },
    {
     "description": "SEVEN HILLS REALTY TRUST",
     "symbol": "SEVN"
    },
    {
     "description": "SUMMIT ENVIRONMENTAL CRP INC",
     "symbol": "SEVT"
    },
    {
     "description": "SICHUAN EXPRESSWAY CO-H",
     "symbol": "SEXHF"
    },
    {
     "description": "SIGNATURE EYEWEAR INC",
     "symbol": "SEYE"
    },
    {
     "description": "SOLARIA ENERGIA Y MEDIO AMBI",
     "symbol": "SEYMF"
    },
    {
     "description": "SEZZLE INC-CDI",
     "symbol": "SEZNL"
    },
    {
     "description": "STIFEL FINANCIAL CORP",
     "symbol": "SF"
    },
    {
     "description": "STIFEL FINANCIAL CORP",
     "symbol": "SF.PRB"
    },
    {
     "description": "STIFEL FINANCIAL CORP",
     "symbol": "SF.PRC"
    },
    {
     "description": "STIFEL FINANCIAL CORP",
     "symbol": "SF.PRD"
    },
    {
     "description": "STIFEL FINANCIAL CORP",
     "symbol": "SFB"
    },
    {
     "description": "SOUND FINANCIAL BANCORP INC",
     "symbol": "SFBC"
    },
    {
     "description": "SINO BIOENERGY CORP",
     "symbol": "SFBE"
    },
    {
     "description": "SFSB INC",
     "symbol": "SFBI"
    },
    {
     "description": "SOFTBANK CORP",
     "symbol": "SFBQF"
    },
    {
     "description": "SERVISFIRST BANCSHARES INC",
     "symbol": "SFBS"
    },
    {
     "description": "SB TECHNOLOGY CORP",
     "symbol": "SFBTF"
    },
    {
     "description": "SEAFCO PCL-NVDR",
     "symbol": "SFCCF"
    },
    {
     "description": "SECURITY FEDERAL CORP",
     "symbol": "SFDL"
    },
    {
     "description": "SHANGHAI FUDAN MICROELECT-H",
     "symbol": "SFDMF"
    },
    {
     "description": "SHANGHAI FUDAN MICROELEC-ADR",
     "symbol": "SFDMY"
    },
    {
     "description": "SAFEGUARD SCIENTIFICS INC",
     "symbol": "SFE"
    },
    {
     "description": "SAFELLO GROUP AB",
     "symbol": "SFELF"
    },
    {
     "description": "SAFE-T GROUP LTD-ADR",
     "symbol": "SFET"
    },
    {
     "description": "PEUGEOT INVEST",
     "symbol": "SFFFF"
    },
    {
     "description": "SCHAEFFLER AG-UNSP ADR",
     "symbol": "SFFLY"
    },
    {
     "description": "SHEFFIELD RESOURCES LTD",
     "symbol": "SFFRF"
    },
    {
     "description": "SIGNIFY NV",
     "symbol": "SFFYF"
    },
    {
     "description": "STEADFAST GROUP LTD",
     "symbol": "SFGLF"
    },
    {
     "description": "SAF-HOLLAND SE",
     "symbol": "SFHLF"
    },
    {
     "description": "WISDOMTREE US SHORT TERM COR",
     "symbol": "SFIG"
    },
    {
     "description": "STAR FINANCIAL GROUP INC-A",
     "symbol": "SFIGA"
    },
    {
     "description": "SKYFII LTD",
     "symbol": "SFIIF"
    },
    {
     "description": "SAFETEK INTERNATIONAL INC",
     "symbol": "SFIN"
    },
    {
     "description": "STARFLEET INNOTECH INC",
     "symbol": "SFIO"
    },
    {
     "description": "SECTOR 5 INC",
     "symbol": "SFIV"
    },
    {
     "description": "STITCH FIX INC-CLASS A",
     "symbol": "SFIX"
    },
    {
     "description": "SFL CORP LTD",
     "symbol": "SFL"
    },
    {
     "description": "SFLMAVEN CORP",
     "symbol": "SFLM"
    },
    {
     "description": "SPROUTS FARMERS MARKET INC",
     "symbol": "SFM"
    },
    {
     "description": "SIMMONS FIRST NATL CORP-CL A",
     "symbol": "SFNC"
    },
    {
     "description": "SOFINA",
     "symbol": "SFNXF"
    },
    {
     "description": "STRIKEFORCE TECHNOLOGIES INC",
     "symbol": "SFOR"
    },
    {
     "description": "SHANGHAI FOSUN PHARMACEUTI-H",
     "symbol": "SFOSF"
    },
    {
     "description": "SANTA FE PETROLEUM INC",
     "symbol": "SFPI"
    },
    {
     "description": "SILVER FIELDS RESOURCES INC",
     "symbol": "SFRFF"
    },
    {
     "description": "SALVATORE FERRAGAMO SPA",
     "symbol": "SFRGF"
    },
    {
     "description": "SALVATORE FERRAGAMO-UNSP ADR",
     "symbol": "SFRGY"
    },
    {
     "description": "SANDFIRE RESOURCES LTD",
     "symbol": "SFRRF"
    },
    {
     "description": "SEAFARER EXPLORATION CORP",
     "symbol": "SFRX"
    },
    {
     "description": "SIDNEY FEDERAL SAVINGS & LOA",
     "symbol": "SFSA"
    },
    {
     "description": "SAFESTORE HOLDINGS PLC",
     "symbol": "SFSHF"
    },
    {
     "description": "SFS GROUP AG",
     "symbol": "SFSLF"
    },
    {
     "description": "SOUTHERN FIRST BANCSHARES",
     "symbol": "SFST"
    },
    {
     "description": "SOFTWARE SERVICE INC",
     "symbol": "SFSVF"
    },
    {
     "description": "SHIFT TECHNOLOGIES INC",
     "symbol": "SFT"
    },
    {
     "description": "SOFTBANK GROUP CORP",
     "symbol": "SFTBF"
    },
    {
     "description": "SOFTBANK GROUP CORP-UNSP ADR",
     "symbol": "SFTBY"
    },
    {
     "description": "SOFTCHOICE CORP",
     "symbol": "SFTCF"
    },
    {
     "description": "SOFTLINE HOLDING PLC-GDR REG",
     "symbol": "SFTLF"
    },
    {
     "description": "SHIFT INC",
     "symbol": "SFTTF"
    },
    {
     "description": "SOFTMAX CO LTD\/JP",
     "symbol": "SFTXF"
    },
    {
     "description": "FANG HOLDINGS LTD - ADR",
     "symbol": "SFUN"
    },
    {
     "description": "SOFTWARE EFFECTIVE SOLUTIONS",
     "symbol": "SFWJ"
    },
    {
     "description": "SOFI SELECT 500 ETF",
     "symbol": "SFY"
    },
    {
     "description": "SOFI SOCIAL 50 ETF",
     "symbol": "SFYF"
    },
    {
     "description": "SAFESTYLE UK PLC",
     "symbol": "SFYLF"
    },
    {
     "description": "SOFI NEXT 500 ETF",
     "symbol": "SFYX"
    },
    {
     "description": "SWEETGREEN INC - CLASS A",
     "symbol": "SG"
    },
    {
     "description": "SAGA COMMUNICATIONS INC-CL A",
     "symbol": "SGA"
    },
    {
     "description": "SPDR ACWI IMI",
     "symbol": "SGACF"
    },
    {
     "description": "SEGA SAMMY HOLDINGS INC",
     "symbol": "SGAMF"
    },
    {
     "description": "SEGA SAMMY HOLDING-SPONS ADR",
     "symbol": "SGAMY"
    },
    {
     "description": "SINGAPORE TELECOMMUNICAT-ADR",
     "symbol": "SGAPY"
    },
    {
     "description": "SPDR USA VALUE",
     "symbol": "SGASF"
    },
    {
     "description": "SES",
     "symbol": "SGBAF"
    },
    {
     "description": "SHANGHAI HENLIUS BIOTECH I-H",
     "symbol": "SGBCF"
    },
    {
     "description": "SIGNATURE BANK GEORGIA SANDY",
     "symbol": "SGBG"
    },
    {
     "description": "GRAND CHINA ENERGY GROUP LTD",
     "symbol": "SGBH"
    },
    {
     "description": "SANGUI BIOTECH INTL INC",
     "symbol": "SGBI"
    },
    {
     "description": "STANDARD BANK GROUP-SPON ADR",
     "symbol": "SGBLY"
    },
    {
     "description": "SG BLOCKS INC",
     "symbol": "SGBX"
    },
    {
     "description": "SUPERIOR GROUP OF COS INC",
     "symbol": "SGC"
    },
    {
     "description": "SAGICOR FINANCIAL CO LTD",
     "symbol": "SGCFF"
    },
    {
     "description": "SOLSTICE GOLD CORP",
     "symbol": "SGCPF"
    },
    {
     "description": "SACGASCO LTD",
     "symbol": "SGCSF"
    },
    {
     "description": "SGD HOLDINGS LTD",
     "symbol": "SGDH"
    },
    {
     "description": "SPROTT JR. GOLD MINERS ETF",
     "symbol": "SGDJ"
    },
    {
     "description": "SPROTT GOLD MINERS ETF",
     "symbol": "SGDM"
    },
    {
     "description": "SEAGEN INC",
     "symbol": "SGEN"
    },
    {
     "description": "STERLING ENERGY RESOURCES",
     "symbol": "SGER"
    },
    {
     "description": "SPDR BBG US TREASURY",
     "symbol": "SGETF"
    },
    {
     "description": "SIEGFRIED HOLDING AG-REG",
     "symbol": "SGFEF"
    },
    {
     "description": "SINO GOLF HOLDINGS LTD",
     "symbol": "SGFHF"
    },
    {
     "description": "SG FLEET GROUP LTD",
     "symbol": "SGFLF"
    },
    {
     "description": "SOLON SE",
     "symbol": "SGFRF"
    },
    {
     "description": "SIGNIFY HEALTH INC -CLASS A",
     "symbol": "SGFY"
    },
    {
     "description": "IPATH SERIES B BBG SUGAR SUB",
     "symbol": "SGG"
    },
    {
     "description": "SIGMA GLOBAL CORP",
     "symbol": "SGGC"
    },
    {
     "description": "SAGE GOLD INC",
     "symbol": "SGGDF"
    },
    {
     "description": "SAGE GROUP PLC\/THE",
     "symbol": "SGGEF"
    },
    {
     "description": "IPATH BLOOMBERG SUGAR SUBIND",
     "symbol": "SGGFF"
    },
    {
     "description": "SINGAPORE TECH ENGINEERING",
     "symbol": "SGGKF"
    },
    {
     "description": "SINGAPORE TECHNOLOG-UNS ADR",
     "symbol": "SGGKY"
    },
    {
     "description": "SPDR S&P 500 LOW VOLATILITY",
     "symbol": "SGGSF"
    },
    {
     "description": "SIGNATURE RESOURCES LTD",
     "symbol": "SGGTF"
    },
    {
     "description": "SMART GLOBAL HOLDINGS INC",
     "symbol": "SGH"
    },
    {
     "description": "SUPER GROUP SGHC LTD",
     "symbol": "SGHC"
    },
    {
     "description": "SUPER GROUP SGHC LTD -25",
     "symbol": "SGHC.WS"
    },
    {
     "description": "SG HOLDINGS CO LTD",
     "symbol": "SGHHF"
    },
    {
     "description": "SHANGHAI INDUSTRIAL HLDG LTD",
     "symbol": "SGHIF"
    },
    {
     "description": "SHANGHAI INDUSTRIAL HLDG-ADR",
     "symbol": "SGHIY"
    },
    {
     "description": "SIGNAL HILL ACQUISITION CO-A",
     "symbol": "SGHL"
    },
    {
     "description": "SIGNAL HILL ACQUISITION CORP",
     "symbol": "SGHLU"
    },
    {
     "description": "SIGNAL HILL ACQ -CW27",
     "symbol": "SGHLW"
    },
    {
     "description": "SIGHT SCIENCES INC",
     "symbol": "SGHT"
    },
    {
     "description": "STRATEGIC REALTY TRUST INC",
     "symbol": "SGIC"
    },
    {
     "description": "SEAPORT GLOBAL ACQUISITION-A",
     "symbol": "SGII"
    },
    {
     "description": "SEAPORT GLOBAL ACQUISITION I",
     "symbol": "SGIIU"
    },
    {
     "description": "SEAPORT GLOBAL ACQ II -CW23",
     "symbol": "SGIIW"
    },
    {
     "description": "SHIONOGI & CO LTD",
     "symbol": "SGIOF"
    },
    {
     "description": "SHIONOGI & CO LTD-UNSPON ADR",
     "symbol": "SGIOY"
    },
    {
     "description": "SUGI HOLDINGS CO LTD",
     "symbol": "SGIPF"
    },
    {
     "description": "SINO GREEN LAND CORP",
     "symbol": "SGLA"
    },
    {
     "description": "SIGMA LABS INC",
     "symbol": "SGLB"
    },
    {
     "description": "SABRE GOLD MINES CORP",
     "symbol": "SGLDF"
    },
    {
     "description": "SGL CARBON SE",
     "symbol": "SGLFF"
    },
    {
     "description": "STRAUSS GROUP LTD",
     "symbol": "SGLJF"
    },
    {
     "description": "RICEGROWERS LIMITED",
     "symbol": "SGLLF"
    },
    {
     "description": "STARHILL GLOBAL REIT",
     "symbol": "SGLMF"
    },
    {
     "description": "SURGLINE INTERNATIONAL INC",
     "symbol": "SGLN"
    },
    {
     "description": "FOOD & LIFE COMPANIES LTD",
     "symbol": "SGLOF"
    },
    {
     "description": "SPYGLASS RESOURCES CORP",
     "symbol": "SGLRF"
    },
    {
     "description": "SIGNATURE LEISURE INC",
     "symbol": "SGLS"
    },
    {
     "description": "SINGULARITY FUTURE TECHNOLOG",
     "symbol": "SGLY"
    },
    {
     "description": "SIGMATRON INTERNATIONAL INC",
     "symbol": "SGMA"
    },
    {
     "description": "SUGARMADE INC",
     "symbol": "SGMD"
    },
    {
     "description": "SIGMA LITHIUM CORP",
     "symbol": "SGML"
    },
    {
     "description": "SUTTER GOLD MINING INC",
     "symbol": "SGMNF"
    },
    {
     "description": "SANGAMO THERAPEUTICS INC",
     "symbol": "SGMO"
    },
    {
     "description": "SCIENTIFIC GAMES CORP",
     "symbol": "SGMS"
    },
    {
     "description": "STEMGEN INC",
     "symbol": "SGNI"
    },
    {
     "description": "ABRDN GOLD ETF TRUST",
     "symbol": "SGOL"
    },
    {
     "description": "SNOOGOO CORP",
     "symbol": "SGOO"
    },
    {
     "description": "ISHARES 0-3 MONTH TREASURY B",
     "symbol": "SGOV"
    },
    {
     "description": "SPDR EM SMALL CAP",
     "symbol": "SGPDF"
    },
    {
     "description": "SAGA PLC",
     "symbol": "SGPLF"
    },
    {
     "description": "SPAR GROUP LIMITED\/THE",
     "symbol": "SGPPF"
    },
    {
     "description": "SPAR GROUP LTD-UNSP ADR",
     "symbol": "SGPPY"
    },
    {
     "description": "SINGAPORE PRESS HOLDINGS LTD",
     "symbol": "SGPRF"
    },
    {
     "description": "SINGAPORE PRESS HOLD-UNS ADR",
     "symbol": "SGPRY"
    },
    {
     "description": "SAGE GROUP PLC-UNSPON ADR",
     "symbol": "SGPYY"
    },
    {
     "description": "SOUTHGOBI RESOURCES LTD",
     "symbol": "SGQRF"
    },
    {
     "description": "SIGMABROADBAND CO",
     "symbol": "SGRB"
    },
    {
     "description": "SAN GOLD CORP",
     "symbol": "SGRCF"
    },
    {
     "description": "SPAR GROUP INC",
     "symbol": "SGRP"
    },
    {
     "description": "SPRING REAL ESTATE INVESTMEN",
     "symbol": "SGRRF"
    },
    {
     "description": "SURGERY PARTNERS INC",
     "symbol": "SGRY"
    },
    {
     "description": "STONEPATH GROUP INC",
     "symbol": "SGRZ"
    },
    {
     "description": "SGS SA-REG",
     "symbol": "SGSOF"
    },
    {
     "description": "SGS SA-UNSPONSORED ADR",
     "symbol": "SGSOY"
    },
    {
     "description": "SPDR BBG 1-3 US TREASURY",
     "symbol": "SGSPF"
    },
    {
     "description": "SPDR BBG SASB US HY CORP ESG",
     "symbol": "SGSSF"
    },
    {
     "description": "SABINA GOLD & SILVER CORP",
     "symbol": "SGSVF"
    },
    {
     "description": "SUGGESTION BOX INC",
     "symbol": "SGTB"
    },
    {
     "description": "SHENGTAI PHARMACEUTICAL INC",
     "symbol": "SGTI"
    },
    {
     "description": "SUSTAINABLE GREEN TEAM LTD",
     "symbol": "SGTM"
    },
    {
     "description": "SOLIGEN TECHNOLOGIES INC",
     "symbol": "SGTN"
    },
    {
     "description": "SURGUTNEFTEGAZ-SP ADR PREF",
     "symbol": "SGTPY"
    },
    {
     "description": "SINGULUS TECHNOLO-UNSPON ADR",
     "symbol": "SGTSY"
    },
    {
     "description": "SIGILON THERAPEUTICS INC",
     "symbol": "SGTX"
    },
    {
     "description": "SURGUTNEFTEGAS-SP ADR",
     "symbol": "SGTZY"
    },
    {
     "description": "STAR GROUP LP",
     "symbol": "SGU"
    },
    {
     "description": "SAGUARO HOLDINGS CORP",
     "symbol": "SGUJ"
    },
    {
     "description": "SOUND GLOBAL LTD",
     "symbol": "SGXXF"
    },
    {
     "description": "STRATEGY INTERNATIONAL INSUR",
     "symbol": "SGYI"
    },
    {
     "description": "PROSHARES SHORT S&P500",
     "symbol": "SH"
    },
    {
     "description": "SHAFTESBURY PLC",
     "symbol": "SHABF"
    },
    {
     "description": "SCP & CO HEALTHCARE ACQUIS-A",
     "symbol": "SHAC"
    },
    {
     "description": "SCP & CO HEALTHCARE ACQUISIT",
     "symbol": "SHACU"
    },
    {
     "description": "SCP & CO HEALTHCARE A -CW28",
     "symbol": "SHACW"
    },
    {
     "description": "WSDMTREE YLD EN US ST AGG",
     "symbol": "SHAG"
    },
    {
     "description": "SHAKE SHACK INC - CLASS A",
     "symbol": "SHAK"
    },
    {
     "description": "SHANGRI-LA ASIA LTD",
     "symbol": "SHALF"
    },
    {
     "description": "SHANGRI-LA ASIA LTD SPON ADR",
     "symbol": "SHALY"
    },
    {
     "description": "SHANDONG MOLONG PETROLEUM-H",
     "symbol": "SHANF"
    },
    {
     "description": "SHIMAMURA CO LTD",
     "symbol": "SHAOF"
    },
    {
     "description": "SPREE ACQUISITION CORP 1 LTD",
     "symbol": "SHAP"
    },
    {
     "description": "SPREE ACQUISITION CORP 1 LTD",
     "symbol": "SHAP.U"
    },
    {
     "description": "SPREE ACQUISITION 1 LTD -23",
     "symbol": "SHAP.WS"
    },
    {
     "description": "SHAMARAN PETROLEUM CORP",
     "symbol": "SHASF"
    },
    {
     "description": "SCOTTISH AMERICAN INV COMP",
     "symbol": "SHAVF"
    },
    {
     "description": "SHORE BANCSHARES INC",
     "symbol": "SHBI"
    },
    {
     "description": "SHANGHAI HAOHAI BIOLOGICAL-H",
     "symbol": "SHBTF"
    },
    {
     "description": "SOTERA HEALTH CO",
     "symbol": "SHC"
    },
    {
     "description": "SPINDLETOP HEALTH ACQUISIT-A",
     "symbol": "SHCA"
    },
    {
     "description": "SHARP CORP",
     "symbol": "SHCAF"
    },
    {
     "description": "SPINDLETOP HEALTH ACQUISITIO",
     "symbol": "SHCAU"
    },
    {
     "description": "SPINDLETOP HEALTH ACQ -CW28",
     "symbol": "SHCAW"
    },
    {
     "description": "SHARP CORP-UNSPONSORED ADR",
     "symbol": "SHCAY"
    },
    {
     "description": "SHI CORP",
     "symbol": "SHCC"
    },
    {
     "description": "SHOCHIKU CO LTD",
     "symbol": "SHCHF"
    },
    {
     "description": "SEARCH MINERALS INC",
     "symbol": "SHCMF"
    },
    {
     "description": "SHARECARE INC",
     "symbol": "SHCR"
    },
    {
     "description": "FALCON CAPITAL ACQUIS -CW27",
     "symbol": "SHCRW"
    },
    {
     "description": "SURETY HOLDINGS CORP",
     "symbol": "SHDC"
    },
    {
     "description": "SPDR GENDER DIVERSITY ETF",
     "symbol": "SHE"
    },
    {
     "description": "SHIN-ETSU CHEMICAL CO LTD",
     "symbol": "SHECF"
    },
    {
     "description": "SHIN-ETSU CHEM-UNSPON ADR",
     "symbol": "SHECY"
    },
    {
     "description": "SHINKO ELECTRIC INDUSTRIES",
     "symbol": "SHEGF"
    },
    {
     "description": "SHELL PLC-ADR",
     "symbol": "SHEL"
    },
    {
     "description": "SHENANDOAH TELECOMMUNICATION",
     "symbol": "SHEN"
    },
    {
     "description": "SHERRITT INTERNATIONAL CORP",
     "symbol": "SHERF"
    },
    {
     "description": "SHENZHEN HEPALINK PHARMACE-H",
     "symbol": "SHEZF"
    },
    {
     "description": "SHEFA GEMS LTD",
     "symbol": "SHFGF"
    },
    {
     "description": "ICLIMA DISTRIBUTED SMART ENE",
     "symbol": "SHFT"
    },
    {
     "description": "SHINHAN FINANCIAL GROUP-ADR",
     "symbol": "SHG"
    },
    {
     "description": "STAR DIAMOND CORP",
     "symbol": "SHGDF"
    },
    {
     "description": "SUN HUNG KAI CO-UNSPON ADR",
     "symbol": "SHGKY"
    },
    {
     "description": "SHARPE RESOURCES CORP",
     "symbol": "SHGP"
    },
    {
     "description": "SUCCESS HOLDING GROUP CORP U",
     "symbol": "SHGR"
    },
    {
     "description": "SHENGUAN HOLDINGS GROUP LTD",
     "symbol": "SHGXF"
    },
    {
     "description": "SHENGUAN HOLDINGS-UNSP ADR",
     "symbol": "SHGXY"
    },
    {
     "description": "SEARCHGUY.COM INC",
     "symbol": "SHGY"
    },
    {
     "description": "SCHIEHALLION FUND LTD\/THE",
     "symbol": "SHHFF"
    },
    {
     "description": "SANG HING HOLDINGS INTERNATI",
     "symbol": "SHHLF"
    },
    {
     "description": "SHIP HEALTHCARE HOLDINGS INC",
     "symbol": "SHHPF"
    },
    {
     "description": "SINOPEC SHANGHAI-SPONS ADR",
     "symbol": "SHI"
    },
    {
     "description": "SHIELD THERAPEUTICS PLC",
     "symbol": "SHIEF"
    },
    {
     "description": "SHENZHEN INVESTMENT HOLDINGS",
     "symbol": "SHIHF"
    },
    {
     "description": "SHINOKEN GROUP CO LTD",
     "symbol": "SHIOF"
    },
    {
     "description": "SEANERGY MARITIME HOLDINGS",
     "symbol": "SHIP"
    },
    {
     "description": "SEANERGY MARITIME HOLD-CW22",
     "symbol": "SHIPZ"
    },
    {
     "description": "SHANGHAI JUNSHI BIOSCIENCE-H",
     "symbol": "SHJBF"
    },
    {
     "description": "SHIBUYA CORPORATION",
     "symbol": "SHKBF"
    },
    {
     "description": "SAHAKOL EQUIPMENT PCL-NVDR",
     "symbol": "SHKEF"
    },
    {
     "description": "SINOTRUK HONG KONG LTD",
     "symbol": "SHKLF"
    },
    {
     "description": "SINOTRUK HONG KONG-UNSPN ADR",
     "symbol": "SHKLY"
    },
    {
     "description": "SCHINDLER HOLDING-PART CERT",
     "symbol": "SHLAF"
    },
    {
     "description": "SEARS HOLDINGS CORP",
     "symbol": "SHLDQ"
    },
    {
     "description": "SHELF DRILLING LTD",
     "symbol": "SHLLF"
    },
    {
     "description": "SCHINDLER HOLDING AG-REG",
     "symbol": "SHLRF"
    },
    {
     "description": "SHOALS TECHNOLOGIES GROUP -A",
     "symbol": "SHLS"
    },
    {
     "description": "SHELL MIDSTREAM PARTNERS LP",
     "symbol": "SHLX"
    },
    {
     "description": "SHL-JAPAN LTD",
     "symbol": "SHLZF"
    },
    {
     "description": "SPDR NUVEEN BLOOMBERG SHORT",
     "symbol": "SHM"
    },
    {
     "description": "SHIMAO GROUP HOLDIN-UNSP ADR",
     "symbol": "SHMAY"
    },
    {
     "description": "RENEWI PLC",
     "symbol": "SHMCF"
    },
    {
     "description": "SHIMANO INC",
     "symbol": "SHMDF"
    },
    {
     "description": "SAHAMIT MACHINERY PCL-NVDR",
     "symbol": "SHMMF"
    },
    {
     "description": "SOHM INC",
     "symbol": "SHMN"
    },
    {
     "description": "NATURALSHRIMP INC",
     "symbol": "SHMP"
    },
    {
     "description": "SHIMAO SERVICES HOLDINGS LTD",
     "symbol": "SHMSF"
    },
    {
     "description": "SHIMAO SERVICES HOLD-UNS ADR",
     "symbol": "SHMSY"
    },
    {
     "description": "SAHAMITR PRESSURE CONTA-NVDR",
     "symbol": "SHMTF"
    },
    {
     "description": "SHIMIZU CORP",
     "symbol": "SHMUF"
    },
    {
     "description": "SHIMIZU CORP - ADR",
     "symbol": "SHMUY"
    },
    {
     "description": "SHINMAYWA INDUSTRIES LTD",
     "symbol": "SHMWF"
    },
    {
     "description": "SYNERGY EMPIRE LTD",
     "symbol": "SHMY"
    },
    {
     "description": "SHIMADZU CORP",
     "symbol": "SHMZF"
    },
    {
     "description": "ROGUE BARON PLC",
     "symbol": "SHNJF"
    },
    {
     "description": "SHENTANG INTERNATIONAL INC",
     "symbol": "SHNL"
    },
    {
     "description": "SHIN MAINT HOLDINGS CO LTD",
     "symbol": "SHNMF"
    },
    {
     "description": "INTOUCH HOLDINGS PCL-F",
     "symbol": "SHNUF"
    },
    {
     "description": "SCHRODERS PLC",
     "symbol": "SHNWF"
    },
    {
     "description": "SUNSTONE HOTEL INVESTORS INC",
     "symbol": "SHO"
    },
    {
     "description": "SUNSTONE HOTEL INVESTORS",
     "symbol": "SHO.PRH"
    },
    {
     "description": "SUNSTONE HOTEL INVESTORS",
     "symbol": "SHO.PRI"
    },
    {
     "description": "SHOEI CO LTD\/TAITO-KU",
     "symbol": "SHOFF"
    },
    {
     "description": "STADIO HOLDINGS LTD",
     "symbol": "SHOLF"
    },
    {
     "description": "SOUTHERN HOME MEDICAL INC",
     "symbol": "SHOM"
    },
    {
     "description": "STEVEN MADDEN LTD",
     "symbol": "SHOO"
    },
    {
     "description": "SHOPIFY INC - CLASS A",
     "symbol": "SHOP"
    },
    {
     "description": "SIHUAN PHARMACEUTICAL HLDGS",
     "symbol": "SHPHF"
    },
    {
     "description": "SHANGHAI PHARMACEUTICALS-H",
     "symbol": "SHPMF"
    },
    {
     "description": "SHANGHAI PHARMACEUTICALS-ADR",
     "symbol": "SHPMY"
    },
    {
     "description": "SHOAL POINT ENERGY LTD",
     "symbol": "SHPNF"
    },
    {
     "description": "SHOP APOTHEKE EUROPE NV",
     "symbol": "SHPPF"
    },
    {
     "description": "SOPHOS GROUP PLC-ADR",
     "symbol": "SHPPY"
    },
    {
     "description": "SHAPEWAYS HOLDINGS INC",
     "symbol": "SHPW"
    },
    {
     "description": "SHAPEWAYS HOLDINGS INC-CW26",
     "symbol": "SHPW.WS"
    },
    {
     "description": "SHELTER ACQUISITION CORP I-A",
     "symbol": "SHQA"
    },
    {
     "description": "SHELTER ACQUISITION CORP I",
     "symbol": "SHQAU"
    },
    {
     "description": "SHELTER ACQ I CL A -CW27",
     "symbol": "SHQAW"
    },
    {
     "description": "SHARING SERVICES GLOBAL CO",
     "symbol": "SHRG"
    },
    {
     "description": "ISHARES EURO GOVT 7-10YR",
     "symbol": "SHRSF"
    },
    {
     "description": "SHIMA SEIKI MFG LTD",
     "symbol": "SHSMF"
    },
    {
     "description": "SINOPHARM GROUP CO-H",
     "symbol": "SHTDF"
    },
    {
     "description": "SINOPHARM GROUP CO-UNSP ADR",
     "symbol": "SHTDY"
    },
    {
     "description": "SHUN TAK HOLDINGS LTD",
     "symbol": "SHTGF"
    },
    {
     "description": "SOUTH32 LTD",
     "symbol": "SHTLF"
    },
    {
     "description": "S HOTELS & RESORTS P-FOREIGN",
     "symbol": "SHTPF"
    },
    {
     "description": "SUNLIGHT REAL ESTATE INVEST",
     "symbol": "SHTRF"
    },
    {
     "description": "SHUAA PARTNERS ACQUISIT-CL A",
     "symbol": "SHUA"
    },
    {
     "description": "SHUAA PARTNERS ACQUISITION C",
     "symbol": "SHUAU"
    },
    {
     "description": "SHUAA PARTNERS ACQ -CW27",
     "symbol": "SHUAW"
    },
    {
     "description": "SHUFERSAL LTD",
     "symbol": "SHUFF"
    },
    {
     "description": "SHUNFENG INTERNATIONAL CLEAN",
     "symbol": "SHUNF"
    },
    {
     "description": "SYNTAX STRAT US TOT MKT HDG",
     "symbol": "SHUS"
    },
    {
     "description": "ISHARES SHORT TREASURY BOND",
     "symbol": "SHV"
    },
    {
     "description": "STARCORE INTERNATIONAL MINES",
     "symbol": "SHVLF"
    },
    {
     "description": "SELECT HARVESTS LTD",
     "symbol": "SHVTF"
    },
    {
     "description": "SHERWIN-WILLIAMS CO\/THE",
     "symbol": "SHW"
    },
    {
     "description": "SHOWA DENKO K K",
     "symbol": "SHWDF"
    },
    {
     "description": "SHOWA DENKO KK-UNSPON ADR",
     "symbol": "SHWDY"
    },
    {
     "description": "SHANDONG WEIGAO GP MEDICAL-H",
     "symbol": "SHWGF"
    },
    {
     "description": "SHANDONG WEIGAO GP-UNSP ADR",
     "symbol": "SHWGY"
    },
    {
     "description": "SEAHAWK DEEP OCEAN TECH INC",
     "symbol": "SHWK"
    },
    {
     "description": "MEDICINE MAN TECHNOLOGIES IN",
     "symbol": "SHWZ"
    },
    {
     "description": "XINHUA WINSHARE PUBLISHING-H",
     "symbol": "SHXWF"
    },
    {
     "description": "ISHARES 1-3 YEAR TREASURY BO",
     "symbol": "SHY"
    },
    {
     "description": "VANECK SH HI YLD MUNI",
     "symbol": "SHYD"
    },
    {
     "description": "SHYFT GROUP INC\/THE",
     "symbol": "SHYF"
    },
    {
     "description": "ISHARES 0-5 YR HY CORP BOND",
     "symbol": "SHYG"
    },
    {
     "description": "XTRACKERS SHRT DUR HIGH YIEL",
     "symbol": "SHYL"
    },
    {
     "description": "NALA DIGITAL COMMERCE LTD",
     "symbol": "SHYMF"
    },
    {
     "description": "SHAKEY'S PIZZA ASIA VENTURES",
     "symbol": "SHYYF"
    },
    {
     "description": "SHENZHOU INTERNATI-UNSP ADR",
     "symbol": "SHZHY"
    },
    {
     "description": "SHENZHEN EXPRESSWAY CORP-H",
     "symbol": "SHZNF"
    },
    {
     "description": "SHENZHEN EXPRESSWAY-UNSP ADR",
     "symbol": "SHZNY"
    },
    {
     "description": "SHIZUOKA BANK-UNSPONS ADR",
     "symbol": "SHZUY"
    },
    {
     "description": "SILVERGATE CAPITAL CORP-CL A",
     "symbol": "SI"
    },
    {
     "description": "SILVERGATE CAP CORP",
     "symbol": "SI.PRA"
    },
    {
     "description": "STAR ASIA INVESTMENT CORPORA",
     "symbol": "SIACF"
    },
    {
     "description": "SINO AGRO FOOD INC",
     "symbol": "SIAF"
    },
    {
     "description": "DRAZCANNA INC",
     "symbol": "SIBED"
    },
    {
     "description": "SI-BONE INC",
     "symbol": "SIBN"
    },
    {
     "description": "SOKOMAN MINERALS CORP",
     "symbol": "SICNF"
    },
    {
     "description": "SIMCORP A\/S",
     "symbol": "SICRF"
    },
    {
     "description": "CIA SIDERURGICA NACL-SP ADR",
     "symbol": "SID"
    },
    {
     "description": "STAMFORD INDUSTRIAL GROUP IN",
     "symbol": "SIDGQ"
    },
    {
     "description": "SIDUS SPACE INC-CL A",
     "symbol": "SIDU"
    },
    {
     "description": "SIEBERT FINANCIAL CORP",
     "symbol": "SIEB"
    },
    {
     "description": "SIEMENS AG-SPONS ADR",
     "symbol": "SIEGY"
    },
    {
     "description": "SHANGHAI ELECTRIC GRP CO L-H",
     "symbol": "SIELF"
    },
    {
     "description": "SHANGHAI ELECTRIC-UNSP ADR",
     "symbol": "SIELY"
    },
    {
     "description": "SIENTRA INC",
     "symbol": "SIEN"
    },
    {
     "description": "SIERRA LAKE ACQUISITION CO-A",
     "symbol": "SIER"
    },
    {
     "description": "SIERRA GRANDE MINERALS INC",
     "symbol": "SIERF"
    },
    {
     "description": "SIERRA LAKE ACQUISITION CORP",
     "symbol": "SIERU"
    },
    {
     "description": "SIERRA LAKE ACQ CL A -CW28",
     "symbol": "SIERW"
    },
    {
     "description": "D'IETEREN GROUP-UNSO ADR",
     "symbol": "SIETY"
    },
    {
     "description": "D'IETEREN GROUP",
     "symbol": "SIEVF"
    },
    {
     "description": "SIFCO INDUSTRIES",
     "symbol": "SIF"
    },
    {
     "description": "SIF HOLDING NV",
     "symbol": "SIFGF"
    },
    {
     "description": "HARBOR SCIENTIFIC ALPHA INCO",
     "symbol": "SIFI"
    },
    {
     "description": "SIFY TECHNOLOGIES-SPON ADR",
     "symbol": "SIFY"
    },
    {
     "description": "SIGNET JEWELERS LTD",
     "symbol": "SIG"
    },
    {
     "description": "SIGA TECHNOLOGIES INC",
     "symbol": "SIGA"
    },
    {
     "description": "SELECTIVE INSURANCE GROUP",
     "symbol": "SIGI"
    },
    {
     "description": "SELECTIVE INSURANCE GROU",
     "symbol": "SIGIP"
    },
    {
     "description": "SIGNAL ADVANCE INC",
     "symbol": "SIGL"
    },
    {
     "description": "SIGNET INTERNATIONAL HOLDING",
     "symbol": "SIGN"
    },
    {
     "description": "SUNSET ISLAND GROUP INC",
     "symbol": "SIGO"
    },
    {
     "description": "SLIGRO FOOD GROUP NV",
     "symbol": "SIGRF"
    },
    {
     "description": "SIGYN THERAPEUTICS INC",
     "symbol": "SIGY"
    },
    {
     "description": "SHENZHEN INVESTMENT HOLD-ADR",
     "symbol": "SIHBY"
    },
    {
     "description": "HARBOR SCIENTIFIC ALPHA HIGH",
     "symbol": "SIHY"
    },
    {
     "description": "SPROTT INC",
     "symbol": "SII"
    },
    {
     "description": "STRATEGIC INTERNET INVESTMEN",
     "symbol": "SIII"
    },
    {
     "description": "SIIX CORP",
     "symbol": "SIIXF"
    },
    {
     "description": "PROSHARES ULTSHRT INDUSTRIAL",
     "symbol": "SIJ"
    },
    {
     "description": "LATECOERE",
     "symbol": "SIJDF"
    },
    {
     "description": "GLOBAL X SILVER MINERS ETF",
     "symbol": "SIL"
    },
    {
     "description": "SILICOM LTD",
     "symbol": "SILC"
    },
    {
     "description": "SINTOKOGIO LTD",
     "symbol": "SILDF"
    },
    {
     "description": "SILVER ELEPHANT MINING CORP",
     "symbol": "SILEF"
    },
    {
     "description": "SILO WELLNESS INC",
     "symbol": "SILFF"
    },
    {
     "description": "ETFMG PRIME JUNIOR SILVER MI",
     "symbol": "SILJ"
    },
    {
     "description": "SILK ROAD MEDICAL INC",
     "symbol": "SILK"
    },
    {
     "description": "SARINE TECHNOLOGIES LTD",
     "symbol": "SILLF"
    },
    {
     "description": "SILO PHARMA INC",
     "symbol": "SILO"
    },
    {
     "description": "SILVER SCOTT MINES INC",
     "symbol": "SILS"
    },
    {
     "description": "SILVERCREST METALS INC",
     "symbol": "SILV"
    },
    {
     "description": "ETFMG PRIME 2X DAILY JUNIOR",
     "symbol": "SILX"
    },
    {
     "description": "SILEX SYSTEMS LTD",
     "symbol": "SILXF"
    },
    {
     "description": "SILEX SYSTEMS LIMITED-SP ADR",
     "symbol": "SILXY"
    },
    {
     "description": "GRUPO SIMEC SAB-SPON ADR",
     "symbol": "SIM"
    },
    {
     "description": "SONICS & MATERIAL INC",
     "symbol": "SIMA"
    },
    {
     "description": "SIMCLAR INC",
     "symbol": "SIMC"
    },
    {
     "description": "SIME DARBY PROPERTY BHD",
     "symbol": "SIMEF"
    },
    {
     "description": "SILICON MOTION TECHNOL-ADR",
     "symbol": "SIMO"
    },
    {
     "description": "SIMPLY INC",
     "symbol": "SIMP"
    },
    {
     "description": "SPDR S&P KENSHO INTELLIGENT",
     "symbol": "SIMS"
    },
    {
     "description": "SIM TECHNOLOGY GROUP LTD",
     "symbol": "SIMTF"
    },
    {
     "description": "SMI VANTAGE LTD",
     "symbol": "SIMYF"
    },
    {
     "description": "SINCERITY APPLIED MATERIALS",
     "symbol": "SINC"
    },
    {
     "description": "SINGLEPOINT INC",
     "symbol": "SING"
    },
    {
     "description": "SINGAPORE AIRLINES LTD",
     "symbol": "SINGF"
    },
    {
     "description": "SINGAPORE AIRLINES-UNSPN ADR",
     "symbol": "SINGY"
    },
    {
     "description": "SINTX TECHNOLOGIES INC",
     "symbol": "SINT"
    },
    {
     "description": "ETFMG PRIME 2X DAILY INVERSE",
     "symbol": "SINV"
    },
    {
     "description": "SIONIX CORPORATION",
     "symbol": "SINX"
    },
    {
     "description": "SINO-OCEAN GROUP HOLDING LTD",
     "symbol": "SIOLF"
    },
    {
     "description": "SINO-OCEAN GROUP-UNSP ADR",
     "symbol": "SIOLY"
    },
    {
     "description": "SHIMAO GROUP HOLDINGS LTD",
     "symbol": "SIOPF"
    },
    {
     "description": "SIO GENE THERAPIES INC",
     "symbol": "SIOX"
    },
    {
     "description": "SIPP INDUSTRIES INC",
     "symbol": "SIPC"
    },
    {
     "description": "SIPP INTERNATIONAL INDUSTRIE",
     "symbol": "SIPN"
    },
    {
     "description": "SOLAR INTEGRATED ROOFING COR",
     "symbol": "SIRC"
    },
    {
     "description": "SISECAM RESOURCES LP",
     "symbol": "SIRE"
    },
    {
     "description": "SIRIOS RESOURCES INC",
     "symbol": "SIREF"
    },
    {
     "description": "SIRIUS XM HOLDINGS INC",
     "symbol": "SIRI"
    },
    {
     "description": "ISHARES FTSE 250",
     "symbol": "SIRLF"
    },
    {
     "description": "SIERRA INCOME CORP",
     "symbol": "SIRR"
    },
    {
     "description": "SECURE INCOME REIT PLC",
     "symbol": "SIRTF"
    },
    {
     "description": "SIR ROYALTY INCOME FUND",
     "symbol": "SIRZF"
    },
    {
     "description": "SIPEF NV",
     "symbol": "SISAF"
    },
    {
     "description": "SHINECO INC",
     "symbol": "SISI"
    },
    {
     "description": "SCIENCE IN SPORT PLC",
     "symbol": "SISPF"
    },
    {
     "description": "SAVARIA CORP",
     "symbol": "SISXF"
    },
    {
     "description": "SITE CENTERS CORP",
     "symbol": "SITC"
    },
    {
     "description": "SITE CENTERS CORP",
     "symbol": "SITC.PRA"
    },
    {
     "description": "SITEONE LANDSCAPE SUPPLY INC",
     "symbol": "SITE"
    },
    {
     "description": "SITC INTERNATIONAL HOLDINGS",
     "symbol": "SITIF"
    },
    {
     "description": "SITC INTERNATIONAL-UNSP ADR",
     "symbol": "SITIY"
    },
    {
     "description": "SITKA GOLD CORP",
     "symbol": "SITKF"
    },
    {
     "description": "SITIME CORP",
     "symbol": "SITM"
    },
    {
     "description": "SITO MOBILE LTD",
     "symbol": "SITOQ"
    },
    {
     "description": "SOUTHERN ITS INTERNATIONAL I",
     "symbol": "SITS"
    },
    {
     "description": "STABILUS SE",
     "symbol": "SIUAF"
    },
    {
     "description": "SHANGHAI INDUSTRIAL URBAN DE",
     "symbol": "SIUDF"
    },
    {
     "description": "SVB FINANCIAL GROUP",
     "symbol": "SIVB"
    },
    {
     "description": "SVB FINANCIAL GROUP",
     "symbol": "SIVBP"
    },
    {
     "description": "SILVER VERDE MAY MINING CO",
     "symbol": "SIVE"
    },
    {
     "description": "ABRDN SILVER ETF TRUST",
     "symbol": "SIVR"
    },
    {
     "description": "SIX FLAGS ENTERTAINMENT CORP",
     "symbol": "SIX"
    },
    {
     "description": "ETC 6 MERIDIAN MEGA CAP EQUI",
     "symbol": "SIXA"
    },
    {
     "description": "6D GLOBAL TECHNOLOGIES INC",
     "symbol": "SIXD"
    },
    {
     "description": "SIXT SE",
     "symbol": "SIXGF"
    },
    {
     "description": "ETC 6 MERIDIAN HEDGED EQUITY",
     "symbol": "SIXH"
    },
    {
     "description": "ALINZ US LRG 6 MT BUF JANJUL",
     "symbol": "SIXJ"
    },
    {
     "description": "ETC 6 MERIDIAN LOW BETA EQUI",
     "symbol": "SIXL"
    },
    {
     "description": "SIOUXLAND ENERGY & LIVES-WET",
     "symbol": "SIXN"
    },
    {
     "description": "ALLIANZIM US LARGE CAP 6 MON",
     "symbol": "SIXO"
    },
    {
     "description": "ETC 6 MERIDIAN SMALL CAP EQU",
     "symbol": "SIXS"
    },
    {
     "description": "SIXTH WAVE INNOVATIONS INC",
     "symbol": "SIXWF"
    },
    {
     "description": "ISHARES MSCI USA SIZE FACTOR",
     "symbol": "SIZE"
    },
    {
     "description": "MAJOR PRECIOUS METALS CORP",
     "symbol": "SIZYF"
    },
    {
     "description": "SCIENJOY HOLDING CORP-A",
     "symbol": "SJ"
    },
    {
     "description": "PROSHARES SHORT HIGH YIELD",
     "symbol": "SJB"
    },
    {
     "description": "SOUTH JERSEY INDUSTRIES",
     "symbol": "SJI"
    },
    {
     "description": "SOUTH JERSEY INDUSTRIES",
     "symbol": "SJIJ"
    },
    {
     "description": "SOUTH JERSEY INDUSTRIES",
     "symbol": "SJIV"
    },
    {
     "description": "JM SMUCKER CO\/THE",
     "symbol": "SJM"
    },
    {
     "description": "SJM HOLDINGS LTD",
     "symbol": "SJMHF"
    },
    {
     "description": "SJM HOLDINGS LTD - ADR",
     "symbol": "SJMHY"
    },
    {
     "description": "SPDR BLOOMBERG SHORT TERM HI",
     "symbol": "SJNK"
    },
    {
     "description": "WEALTHBRIDGE ACQUISITIO-CW24",
     "symbol": "SJOYW"
    },
    {
     "description": "SHAW COMMUNICATIONS INC-B",
     "symbol": "SJR"
    },
    {
     "description": "ARCWEST EXPLORATION INC",
     "symbol": "SJRNF"
    },
    {
     "description": "SHAW COMMUNICATIONS INC-A",
     "symbol": "SJRWF"
    },
    {
     "description": "SAN JUAN BASIN ROYALTY TR",
     "symbol": "SJT"
    },
    {
     "description": "SAN JU SAN FINANCIAL GROUP I",
     "symbol": "SJUSF"
    },
    {
     "description": "SJW GROUP",
     "symbol": "SJW"
    },
    {
     "description": "SAKAI TRADING CO LTD",
     "symbol": "SKAIF"
    },
    {
     "description": "SKAJAQUODA GROUP INC",
     "symbol": "SKAJ"
    },
    {
     "description": "SAKER AVIATION SERVICES INC",
     "symbol": "SKAS"
    },
    {
     "description": "SHIKUN & BINUI LTD",
     "symbol": "SKBNF"
    },
    {
     "description": "SKANSKA AB-SPN ADR",
     "symbol": "SKBSY"
    },
    {
     "description": "SKEENA RESOURCES LTD",
     "symbol": "SKE"
    },
    {
     "description": "PROSHARES ULTSHRT FINANCIALS",
     "symbol": "SKF"
    },
    {
     "description": "STARK FOCUS GROUP INC",
     "symbol": "SKFG"
    },
    {
     "description": "SIKA AG-REG",
     "symbol": "SKFOF"
    },
    {
     "description": "SKF AB-SPONSORED ADR",
     "symbol": "SKFRY"
    },
    {
     "description": "SKYBRIDGE TECHNOLOGY GROUP I",
     "symbol": "SKGO"
    },
    {
     "description": "SONIC HEALTHCARE LTD",
     "symbol": "SKHCF"
    },
    {
     "description": "SONIC HEALTHCARE LTD-SP ADR",
     "symbol": "SKHHY"
    },
    {
     "description": "STAKEHOLDER GOLD CORP",
     "symbol": "SKHRF"
    },
    {
     "description": "SEKISUI HOUSE LTD",
     "symbol": "SKHSF"
    },
    {
     "description": "SEKISUI HOUSE-SPONS ADR",
     "symbol": "SKHSY"
    },
    {
     "description": "SKILLSOFT CORP",
     "symbol": "SKIL"
    },
    {
     "description": "SKILLSOFT CORP - CW",
     "symbol": "SKIL.WS"
    },
    {
     "description": "BEAUTY HEALTH CO\/THE",
     "symbol": "SKIN"
    },
    {
     "description": "SPDR S&P\/ASX 200 FUND",
     "symbol": "SKJJF"
    },
    {
     "description": "SK KAKEN CO LTD",
     "symbol": "SKKAF"
    },
    {
     "description": "STRIKEWELL ENERGY CORP",
     "symbol": "SKKFF"
    },
    {
     "description": "SHIKOKU CHEMICALS CORP",
     "symbol": "SKKLF"
    },
    {
     "description": "SKRR EXPLORATION INC",
     "symbol": "SKKRF"
    },
    {
     "description": "SKKYNET CLOUD SYSTEMS INC",
     "symbol": "SKKY"
    },
    {
     "description": "SHINSEI BANK LTD",
     "symbol": "SKLKF"
    },
    {
     "description": "SHINSEI BANK LTD-SPON ADR",
     "symbol": "SKLKY"
    },
    {
     "description": "SEEK LTD",
     "symbol": "SKLTF"
    },
    {
     "description": "SEEK LTD-UNSPONSORED ADR",
     "symbol": "SKLTY"
    },
    {
     "description": "SKELLERUP HOLDING-UNSPON ADR",
     "symbol": "SKLUY"
    },
    {
     "description": "SKYE LIFE VENTURES LTD",
     "symbol": "SKLV"
    },
    {
     "description": "SKYLARK HOLDINGS CO LTD",
     "symbol": "SKLYF"
    },
    {
     "description": "SKILLZ INC",
     "symbol": "SKLZ"
    },
    {
     "description": "SK TELECOM CO LTD-SPON ADR",
     "symbol": "SKM"
    },
    {
     "description": "CHENGDA TECHNOLOGY CO LTD",
     "symbol": "SKMT"
    },
    {
     "description": "FLEXSHARES CREDIT-SCORED US",
     "symbol": "SKOR"
    },
    {
     "description": "SPARK POWER GROUP INC",
     "symbol": "SKPGF"
    },
    {
     "description": "SKY PETROLEUM INC",
     "symbol": "SKPI"
    },
    {
     "description": "SKY PERFECT-UNSPON ADR",
     "symbol": "SKPJY"
    },
    {
     "description": "SKYSHOP LOGISTICS INC",
     "symbol": "SKPN"
    },
    {
     "description": "SKYE PETROLEUM INC",
     "symbol": "SKPO"
    },
    {
     "description": "SILK ROAD ENTERTAINMENT INC",
     "symbol": "SKRJ"
    },
    {
     "description": "Scottish RE Group Ltd",
     "symbol": "SKRUF"
    },
    {
     "description": "SK REALTY VENTURES INC",
     "symbol": "SKRV"
    },
    {
     "description": "SKANSKA AB-B SHS",
     "symbol": "SKSBF"
    },
    {
     "description": "SHINKO SHOJI CO LTD",
     "symbol": "SKSJF"
    },
    {
     "description": "SKOOKUM SAFETY SOLUTIONS COR",
     "symbol": "SKSK"
    },
    {
     "description": "SK SQUARE CO LTD",
     "symbol": "SKSQF"
    },
    {
     "description": "SEKISUI CHEMICAL CO LTD",
     "symbol": "SKSUF"
    },
    {
     "description": "SEKISUI CHEMICAL-UNSPON ADR",
     "symbol": "SKSUY"
    },
    {
     "description": "TANGER FACTORY OUTLET CENTER",
     "symbol": "SKT"
    },
    {
     "description": "SKYCHAIN TECHNOLOGIES INC",
     "symbol": "SKTCF"
    },
    {
     "description": "SK3 GROUP INC",
     "symbol": "SKTO"
    },
    {
     "description": "SKYTOP LODGE CORPORATION",
     "symbol": "SKTP"
    },
    {
     "description": "Skytop Lodge Corp",
     "symbol": "SKTPP"
    },
    {
     "description": "SKF AB-B SHARES",
     "symbol": "SKUFF"
    },
    {
     "description": "SAKURA INTERNET INC",
     "symbol": "SKURF"
    },
    {
     "description": "SANSEI TECHNOLOGIES INC",
     "symbol": "SKUYF"
    },
    {
     "description": "SKINVISIBLE INC",
     "symbol": "SKVI"
    },
    {
     "description": "SENTRY TECHNOLOGY CORP",
     "symbol": "SKVY"
    },
    {
     "description": "SKYWEALTH GROUP INC",
     "symbol": "SKWG"
    },
    {
     "description": "SKECHERS USA INC-CL A",
     "symbol": "SKX"
    },
    {
     "description": "SANKYO CO LTD",
     "symbol": "SKXJF"
    },
    {
     "description": "SKYLINE CHAMPION CORP",
     "symbol": "SKY"
    },
    {
     "description": "SKYDECK ACQUISITION CORP-A",
     "symbol": "SKYA"
    },
    {
     "description": "SKYDECK ACQUISITION CORP",
     "symbol": "SKYAU"
    },
    {
     "description": "SKYDECK ACQ CORP CL A -CW27",
     "symbol": "SKYAW"
    },
    {
     "description": "SKYE BIOSCIENCE INC",
     "symbol": "SKYE"
    },
    {
     "description": "SKY440 INC",
     "symbol": "SKYF"
    },
    {
     "description": "SKY HARBOUR GROUP CORP",
     "symbol": "SKYH"
    },
    {
     "description": "YELLOWSTONE ACQUISIT A -CW25",
     "symbol": "SKYH.WS"
    },
    {
     "description": "SKY CENTURY INVESTMENT INC",
     "symbol": "SKYI"
    },
    {
     "description": "SKYWATER TECHNOLOGY INC",
     "symbol": "SKYT"
    },
    {
     "description": "PROSHARES ULTRA CLOUD COMP",
     "symbol": "SKYU"
    },
    {
     "description": "SKYWEST INC",
     "symbol": "SKYW"
    },
    {
     "description": "SQL TECHNOLOGIES CORP",
     "symbol": "SKYX"
    },
    {
     "description": "FIRST TRUST CLOUD COMPUTING",
     "symbol": "SKYY"
    },
    {
     "description": "SKYCITY ENTERTAINMENT GROUP",
     "symbol": "SKYZF"
    },
    {
     "description": "SILICON LABORATORIES INC",
     "symbol": "SLAB"
    },
    {
     "description": "SOCIAL LEVERAGE ACQUISITIO-A",
     "symbol": "SLAC"
    },
    {
     "description": "SOCIAL LEVERAGE ACQUISITION",
     "symbol": "SLAC.U"
    },
    {
     "description": "SOCIAL LEVERAGE ACQ A -CW27",
     "symbol": "SLAC.WS"
    },
    {
     "description": "STELLA CHEMIFA CORP",
     "symbol": "SLAHF"
    },
    {
     "description": "SLAM CORP-A",
     "symbol": "SLAM"
    },
    {
     "description": "SLAM CORP",
     "symbol": "SLAMU"
    },
    {
     "description": "SLAM CORP-A -CW27",
     "symbol": "SLAMW"
    },
    {
     "description": "SILK LASER AUSTRALIA LTD",
     "symbol": "SLASF"
    },
    {
     "description": "SCHLUMBERGER LTD",
     "symbol": "SLB"
    },
    {
     "description": "SLINGER BAG INC",
     "symbol": "SLBG"
    },
    {
     "description": "US SILICA HOLDINGS INC",
     "symbol": "SLCA"
    },
    {
     "description": "SPOTLIGHT CAPITAL HOLDINGS I",
     "symbol": "SLCH"
    },
    {
     "description": "SLC AGRICOLA SA",
     "symbol": "SLCJF"
    },
    {
     "description": "SLC AGRICOLA SA-SPON ADR",
     "symbol": "SLCJY"
    },
    {
     "description": "SOVEREIGN LITHIUM INC",
     "symbol": "SLCO"
    },
    {
     "description": "SILVER CREST ACQUISITION C-A",
     "symbol": "SLCR"
    },
    {
     "description": "SILVER CREST ACQUISITION COR",
     "symbol": "SLCRU"
    },
    {
     "description": "SILVER CREST ACQ CL A -CW28",
     "symbol": "SLCRW"
    },
    {
     "description": "SOLID BIOSCIENCES INC",
     "symbol": "SLDB"
    },
    {
     "description": "SOLIDUSGOLD INC",
     "symbol": "SLDGF"
    },
    {
     "description": "SOLID POWER INC",
     "symbol": "SLDP"
    },
    {
     "description": "DECARBONIZATION PLUS -CW23",
     "symbol": "SLDPW"
    },
    {
     "description": "STELLA DIAGNOSTICS INC",
     "symbol": "SLDX"
    },
    {
     "description": "SILERGY CORP",
     "symbol": "SLEGF"
    },
    {
     "description": "SUN LIFE FINANCIAL INC",
     "symbol": "SLF"
    },
    {
     "description": "FUTURE MOBILITY SOLUTIONS LT",
     "symbol": "SLFFF"
    },
    {
     "description": "Sun Life Financial Inc",
     "symbol": "SLFIF"
    },
    {
     "description": "ABRDN PLC",
     "symbol": "SLFPF"
    },
    {
     "description": "ABRDN PLC-UNSPON ADR",
     "symbol": "SLFPY"
    },
    {
     "description": "SL GREEN REALTY CORP",
     "symbol": "SLG"
    },
    {
     "description": "SL GREEN REALTY CORP",
     "symbol": "SLG.PRI"
    },
    {
     "description": "SOMALOGIC INC",
     "symbol": "SLGC"
    },
    {
     "description": "CM LIFE SCIENCES II -CW27",
     "symbol": "SLGCW"
    },
    {
     "description": "SCOTT'S LIQUID GOLD INC",
     "symbol": "SLGD"
    },
    {
     "description": "SUPER LEAGUE GAMING INC",
     "symbol": "SLGG"
    },
    {
     "description": "SOLGOLD PLC",
     "symbol": "SLGGF"
    },
    {
     "description": "SOL-GEL TECHNOLOGIES LTD",
     "symbol": "SLGL"
    },
    {
     "description": "SILGAN HOLDINGS INC",
     "symbol": "SLGN"
    },
    {
     "description": "SLM SOLUTIONS GROUP AG",
     "symbol": "SLGRF"
    },
    {
     "description": "SLANG WORLDWIDE INC",
     "symbol": "SLGWF"
    },
    {
     "description": "SAN LEON ENERGY PLC",
     "symbol": "SLGYF"
    },
    {
     "description": "SKYLIGHT HEALTH GROUP INC",
     "symbol": "SLHG"
    },
    {
     "description": "SKYLIGHT HEALTH GRP INC",
     "symbol": "SLHGP"
    },
    {
     "description": "STANDARD LITHIUM LTD",
     "symbol": "SLI"
    },
    {
     "description": "SULJA BROS BUILDING SUPPLIES",
     "symbol": "SLJB"
    },
    {
     "description": "SANLAM LTD-SPONSORED ADR",
     "symbol": "SLLDY"
    },
    {
     "description": "GUSBOURNE PLC",
     "symbol": "SLLFF"
    },
    {
     "description": "SEARCHLIGHT SOLUTIONS LTD",
     "symbol": "SLLN"
    },
    {
     "description": "11 88 0 SOLUTIONS AG",
     "symbol": "SLLNF"
    },
    {
     "description": "RECHARGE RESOURCES LTD",
     "symbol": "SLLTF"
    },
    {
     "description": "SLM CORP",
     "symbol": "SLM"
    },
    {
     "description": "SANLAM LTD",
     "symbol": "SLMAF"
    },
    {
     "description": "SLM CORP",
     "symbol": "SLMBP"
    },
    {
     "description": "SALMONES CAMANCHACA SA",
     "symbol": "SLMCF"
    },
    {
     "description": "SOLIS MINERALS LTD",
     "symbol": "SLMFF"
    },
    {
     "description": "APEX RESOURCES INC",
     "symbol": "SLMLF"
    },
    {
     "description": "LyondellBasell Advanced Polymers Inc",
     "symbol": "SLMNP"
    },
    {
     "description": "SUL AMERICA SA - UNITS",
     "symbol": "SLMRF"
    },
    {
     "description": "SLAM EXPLORATION LTD",
     "symbol": "SLMXF"
    },
    {
     "description": "DAMARA GOLD CORP",
     "symbol": "SLMZF"
    },
    {
     "description": "SILENCE THERAPEUTICS PLC",
     "symbol": "SLN"
    },
    {
     "description": "SILENCE THERAPEUTICS PLC",
     "symbol": "SLNCF"
    },
    {
     "description": "SOLUTION FINANCIAL INC",
     "symbol": "SLNFF"
    },
    {
     "description": "STABILIS SOLUTIONS INC",
     "symbol": "SLNG"
    },
    {
     "description": "SOLUNA HOLDINGS INC",
     "symbol": "SLNH"
    },
    {
     "description": "SOLUNA HOLDINGS INC",
     "symbol": "SLNHP"
    },
    {
     "description": "STELLA INTERNATIONAL",
     "symbol": "SLNLF"
    },
    {
     "description": "STELLA INTL-UNSPON ADR",
     "symbol": "SLNLY"
    },
    {
     "description": "SALON MEDIA GROUP INC",
     "symbol": "SLNM"
    },
    {
     "description": "SOLENO THERAPEUTICS INC",
     "symbol": "SLNO"
    },
    {
     "description": "SOLUTIONS 30 S.E.-UNSP ADR",
     "symbol": "SLNTY"
    },
    {
     "description": "SOLANBRIDGE GROUP INC",
     "symbol": "SLNX"
    },
    {
     "description": "SOLSTAD OFFSHORE ASA",
     "symbol": "SLOFF"
    },
    {
     "description": "S.O.I.T.E.C.",
     "symbol": "SLOIF"
    },
    {
     "description": "S.O.I.T.E.C.-UNSPON ADR",
     "symbol": "SLOIY"
    },
    {
     "description": "SAN LOTUS HOLDING INC",
     "symbol": "SLOT"
    },
    {
     "description": "SIMULATIONS PLUS INC",
     "symbol": "SLP"
    },
    {
     "description": "ISHARES 0-5 YR INV GRD CORP",
     "symbol": "SLQD"
    },
    {
     "description": "SELECTQUOTE INC",
     "symbol": "SLQT"
    },
    {
     "description": "SINOPEC ENGINEERING GROUP-H",
     "symbol": "SLQTF"
    },
    {
     "description": "SLR INVESTMENT CORP",
     "symbol": "SLRC"
    },
    {
     "description": "SOLERA NATIONAL BANCORP INC",
     "symbol": "SLRK"
    },
    {
     "description": "STELLAR RESOURCES LTD",
     "symbol": "SLROF"
    },
    {
     "description": "SILVER RANGE RESOURCES LTD",
     "symbol": "SLRRF"
    },
    {
     "description": "SALARIUS PHARMACEUTICALS INC",
     "symbol": "SLRX"
    },
    {
     "description": "SELLAS LIFE SCIENCES GROUP I",
     "symbol": "SLS"
    },
    {
     "description": "SOLASTO CORP",
     "symbol": "SLSCF"
    },
    {
     "description": "SELECT SANDS CORP",
     "symbol": "SLSDF"
    },
    {
     "description": "SEOUL SEMICONDUCTOR CO LTD",
     "symbol": "SLSOF"
    },
    {
     "description": "SILVER SURPRIZE INC",
     "symbol": "SLSR"
    },
    {
     "description": "SOLARIS RESOURCES INC",
     "symbol": "SLSSF"
    },
    {
     "description": "PEGASUS RESOURCES INC",
     "symbol": "SLTFF"
    },
    {
     "description": "SILVERTON ENERGY INC",
     "symbol": "SLTN"
    },
    {
     "description": "SLATE OFFICE REIT",
     "symbol": "SLTTF"
    },
    {
     "description": "SOLAR THIN FILMS INC",
     "symbol": "SLTZ"
    },
    {
     "description": "SOLUTIONS 30 SE",
     "symbol": "SLUNF"
    },
    {
     "description": "SOLUCORP INDUSTRIES",
     "symbol": "SLUP"
    },
    {
     "description": "ISHARES SILVER TRUST",
     "symbol": "SLV"
    },
    {
     "description": "SILVER DOLLAR RESOURCES INC",
     "symbol": "SLVDF"
    },
    {
     "description": "SILVERLAKE AXIS LTD",
     "symbol": "SLVFF"
    },
    {
     "description": "SYLVAMO CORP",
     "symbol": "SLVM"
    },
    {
     "description": "SILVER MINES LTD",
     "symbol": "SLVMF"
    },
    {
     "description": "X-LINKS SLVR SHRS COVRD CALL",
     "symbol": "SLVO"
    },
    {
     "description": "ISHARES MSCI GLOBAL SILVER A",
     "symbol": "SLVP"
    },
    {
     "description": "SILVERSPAC INC-CL A",
     "symbol": "SLVR"
    },
    {
     "description": "SILVER ONE RESOURCES INC",
     "symbol": "SLVRF"
    },
    {
     "description": "SILVERSPAC INC",
     "symbol": "SLVRU"
    },
    {
     "description": "SILVERSPAC INC -CW23",
     "symbol": "SLVRW"
    },
    {
     "description": "SILVER TIGER METALS INC",
     "symbol": "SLVTF"
    },
    {
     "description": "SOLVAY SA - UNSP ADR",
     "symbol": "SLVYY"
    },
    {
     "description": "VANECK STEEL ETF",
     "symbol": "SLX"
    },
    {
     "description": "FINTECH SELECT LTD",
     "symbol": "SLXXF"
    },
    {
     "description": "SPDR S&P 600 SMALL CAP ETF",
     "symbol": "SLY"
    },
    {
     "description": "SPDR S&P 600 SMALL CAP GROWT",
     "symbol": "SLYG"
    },
    {
     "description": "SPDR S&P 600 SMALL CAP VALUE",
     "symbol": "SLYV"
    },
    {
     "description": "SLAVE LAKE ZINC CORP",
     "symbol": "SLZNF"
    },
    {
     "description": "SM ENERGY CO",
     "symbol": "SM"
    },
    {
     "description": "SMA ALLIANCE INC",
     "symbol": "SMAA"
    },
    {
     "description": "SOMA GOLD CORP",
     "symbol": "SMAGF"
    },
    {
     "description": "SUMMIT BANCSHARES INC",
     "symbol": "SMAL"
    },
    {
     "description": "Standard Management Corp",
     "symbol": "SMANP"
    },
    {
     "description": "SPORTSMAP TECH ACQUISITION C",
     "symbol": "SMAP"
    },
    {
     "description": "SPORTSMAP TECH ACQUISITION C",
     "symbol": "SMAPU"
    },
    {
     "description": "SPORTSMAP TECH ACQ -CW27",
     "symbol": "SMAPW"
    },
    {
     "description": "SMARTSHEET INC-CLASS A",
     "symbol": "SMAR"
    },
    {
     "description": "SOMATIC SYSTEMS INC",
     "symbol": "SMAS"
    },
    {
     "description": "CANADIAN GOLDCAMPS CORP",
     "symbol": "SMATF"
    },
    {
     "description": "SIEMENS AG-REG",
     "symbol": "SMAWF"
    },
    {
     "description": "SIMEC ATLANTIS ENERGY LTD",
     "symbol": "SMAYF"
    },
    {
     "description": "VANECK SHORT MUNI ETF",
     "symbol": "SMB"
    },
    {
     "description": "SOUTHERN MISSOURI BANCORP",
     "symbol": "SMBC"
    },
    {
     "description": "SMARTFINANCIAL INC",
     "symbol": "SMBK"
    },
    {
     "description": "SEMBCORP MARINE LTD",
     "symbol": "SMBMF"
    },
    {
     "description": "SEMBCORP MARINE LTD-UNSP ADR",
     "symbol": "SMBMY"
    },
    {
     "description": "SOMBOON ADV TECH - NVDR",
     "symbol": "SMBVF"
    },
    {
     "description": "SIMBA ESSEL ENERGY INC",
     "symbol": "SMBZF"
    },
    {
     "description": "SMC CORP-SPONSORED ADR",
     "symbol": "SMCAY"
    },
    {
     "description": "SIAM COMMERCIAL BANK-FOREIGN",
     "symbol": "SMCBF"
    },
    {
     "description": "STRATEGIC MINERALS PLC",
     "symbol": "SMCDF"
    },
    {
     "description": "SMC ENTERTAINMENT INC",
     "symbol": "SMCE"
    },
    {
     "description": "SUPER MICRO COMPUTER INC",
     "symbol": "SMCI"
    },
    {
     "description": "ALPHAMARK ACT MANAGED SMALL",
     "symbol": "SMCP"
    },
    {
     "description": "SIMCORP A\/S - UNSP ADR",
     "symbol": "SMCYY"
    },
    {
     "description": "SHL TELEMEDICINE LTD-REG",
     "symbol": "SMDCF"
    },
    {
     "description": "PROSHARES ULTPRO SHRT MC400",
     "symbol": "SMDD"
    },
    {
     "description": "SINGING MACHINE CO INC\/THE",
     "symbol": "SMDM"
    },
    {
     "description": "SIERRA MADRE GOLD AND SILVER",
     "symbol": "SMDRF"
    },
    {
     "description": "PROSHRS RSL 2000 DVD GRW ETF",
     "symbol": "SMDV"
    },
    {
     "description": "SYNTAX STRATIFIED MIDCAP ETF",
     "symbol": "SMDY"
    },
    {
     "description": "STRATEGIC METALS LTD",
     "symbol": "SMDZF"
    },
    {
     "description": "SIME DARBY BERHAD",
     "symbol": "SMEBF"
    },
    {
     "description": "SMC CORP",
     "symbol": "SMECF"
    },
    {
     "description": "SHARPS COMPLIANCE CORP",
     "symbol": "SMED"
    },
    {
     "description": "SIEMENS ENERGY AG",
     "symbol": "SMEGF"
    },
    {
     "description": "SIMULATED ENVIRONMENT CONCEP",
     "symbol": "SMEV"
    },
    {
     "description": "SUMITOMO MITSUI-SPONS ADR",
     "symbol": "SMFG"
    },
    {
     "description": "SMURFIT KAPPA GROUP PLC-ADR",
     "symbol": "SMFKY"
    },
    {
     "description": "SMART FOR LIFE INC",
     "symbol": "SMFL"
    },
    {
     "description": "SUMITOMO MITSUI FINANCIAL GR",
     "symbol": "SMFNF"
    },
    {
     "description": "SEMA4 HOLDINGS CORP",
     "symbol": "SMFR"
    },
    {
     "description": "SUMITOMO FORESTRY CO LTD",
     "symbol": "SMFRF"
    },
    {
     "description": "CM LIFE SCIENCES INC-A -CW27",
     "symbol": "SMFRW"
    },
    {
     "description": "SMURFIT KAPPA GROUP PLC",
     "symbol": "SMFTF"
    },
    {
     "description": "S A M TRADE ASIA PTE LTD",
     "symbol": "SMFX"
    },
    {
     "description": "SCOTTS MIRACLE-GRO CO",
     "symbol": "SMG"
    },
    {
     "description": "SAN MIGUEL CORP",
     "symbol": "SMGBF"
    },
    {
     "description": "SAN MIGUEL CORP-SPON ADR",
     "symbol": "SMGBY"
    },
    {
     "description": "SMG INDUSTRIES INC",
     "symbol": "SMGI"
    },
    {
     "description": "SMITHS GROUP PLC",
     "symbol": "SMGKF"
    },
    {
     "description": "SAN MIGUEL BREWERY HK LTD",
     "symbol": "SMGLF"
    },
    {
     "description": "SUMMERSET GROUP HOLDINGS LTD",
     "symbol": "SMGRF"
    },
    {
     "description": "SMITHS GROUP PLC- SPON ADR",
     "symbol": "SMGZY"
    },
    {
     "description": "VANECK SEMICONDUCTOR ETF",
     "symbol": "SMH"
    },
    {
     "description": "ETRACS MON PAY 2X LEV US -B",
     "symbol": "SMHB"
    },
    {
     "description": "SIMCERE PHARMACEUTICAL GROUP",
     "symbol": "SMHGF"
    },
    {
     "description": "SEACOR MARINE HOLDINGS INC",
     "symbol": "SMHI"
    },
    {
     "description": "VANECK HIP SUSTAINABLE MUNI",
     "symbol": "SMI"
    },
    {
     "description": "SMITH-MIDLAND CORP",
     "symbol": "SMID"
    },
    {
     "description": "AAM B&G SM\/MID CAP INC GRWTH",
     "symbol": "SMIG"
    },
    {
     "description": "SUMMIT HEALTHCARE ACQ-A",
     "symbol": "SMIH"
    },
    {
     "description": "SUMMIT HEALTHCARE ACQUISITIO",
     "symbol": "SMIHU"
    },
    {
     "description": "SUMMIT HEALTHCARE A -CW23",
     "symbol": "SMIHW"
    },
    {
     "description": "ISHARES MSCI INDIA SMALL-CAP",
     "symbol": "SMIN"
    },
    {
     "description": "SEMIRARA MINING AND POWER CO",
     "symbol": "SMIRF"
    },
    {
     "description": "SCHMITT INDUSTRIES INC",
     "symbol": "SMIT"
    },
    {
     "description": "MELIA HOTELS INTERNATIONAL",
     "symbol": "SMIZF"
    },
    {
     "description": "SMART CARD MARKETING SYSTEMS",
     "symbol": "SMKG"
    },
    {
     "description": "SIAM MAKRO PUBLIC C-UNSP ADR",
     "symbol": "SMKUY"
    },
    {
     "description": "XTRACKERS S&P SMALLCAP 600",
     "symbol": "SMLE"
    },
    {
     "description": "ISHARES MSCI USA SMALL-CAP M",
     "symbol": "SMLF"
    },
    {
     "description": "SYNLAIT MILK LTD",
     "symbol": "SMLKF"
    },
    {
     "description": "SUMMIT MIDSTREAM PARTNERS LP",
     "symbol": "SMLP"
    },
    {
     "description": "SEMLER SCIENTIFIC INC",
     "symbol": "SMLR"
    },
    {
     "description": "SPDR SSGA US SMALL CAP LOW",
     "symbol": "SMLV"
    },
    {
     "description": "SALIENT MIDSTREAM & MLP FUND",
     "symbol": "SMM"
    },
    {
     "description": "SUMMIT INDUSTRIAL INCOME REI",
     "symbol": "SMMCF"
    },
    {
     "description": "ISHARES RUSSELL 2500 ETF",
     "symbol": "SMMD"
    },
    {
     "description": "SMARTMETRIC INC",
     "symbol": "SMME"
    },
    {
     "description": "SUMMIT FINANCIAL GROUP INC",
     "symbol": "SMMF"
    },
    {
     "description": "SIEMENS HEALTHINEE-UNSP ADR",
     "symbol": "SMMNY"
    },
    {
     "description": "SYMMETRY TECHNOLOGIES INC",
     "symbol": "SMMR"
    },
    {
     "description": "SUMMIT THERAPEUTICS INC",
     "symbol": "SMMT"
    },
    {
     "description": "PIMCO SHORT TERM MUNICIPAL B",
     "symbol": "SMMU"
    },
    {
     "description": "ISHARES MSCI USA SMALL-CAP M",
     "symbol": "SMMV"
    },
    {
     "description": "SUMITOMO METAL MININ-UNS ADR",
     "symbol": "SMMYY"
    },
    {
     "description": "PROSHARES ULTSHRT BASIC MAT",
     "symbol": "SMN"
    },
    {
     "description": "SIEMENS ENERGY AG-UNSP ADR",
     "symbol": "SMNEY"
    },
    {
     "description": "SHIMANO INC-UNSPON ADR",
     "symbol": "SMNNY"
    },
    {
     "description": "SMN CORP",
     "symbol": "SMNOF"
    },
    {
     "description": "S2 MINERALS INC",
     "symbol": "SMNRF"
    },
    {
     "description": "SARANA MENARA NUSANTARA PT",
     "symbol": "SMNUF"
    },
    {
     "description": "SONORO GOLD CORP",
     "symbol": "SMOFF"
    },
    {
     "description": "VANECK LOW CARBON ENERGY ETF",
     "symbol": "SMOG"
    },
    {
     "description": "SMOORE INTERNATIONAL HOLDING",
     "symbol": "SMORF"
    },
    {
     "description": "STANDARD MOTOR PRODS",
     "symbol": "SMP"
    },
    {
     "description": "PLAYGROUND VENTURES INC",
     "symbol": "SMPBF"
    },
    {
     "description": "SOUTHERN EMPIRE RESOURCES CO",
     "symbol": "SMPEF"
    },
    {
     "description": "SAN MIGUEL FOOD AND BEVERAGE",
     "symbol": "SMPFF"
    },
    {
     "description": "SIMPLY GOOD FOODS CO\/THE",
     "symbol": "SMPL"
    },
    {
     "description": "SOMPO JAPAN NIPPONKOA-UN ADR",
     "symbol": "SMPNY"
    },
    {
     "description": "STRATEGIC MANAGEMENT & OPPOR",
     "symbol": "SMPP"
    },
    {
     "description": "STANDARD METALS PROCESSING I",
     "symbol": "SMPR"
    },
    {
     "description": "SUN SUMMIT MINERALS CORP",
     "symbol": "SMREF"
    },
    {
     "description": "SMAREGI INC",
     "symbol": "SMRGF"
    },
    {
     "description": "SUPERIOR MARKETING RESEARCH",
     "symbol": "SMRH"
    },
    {
     "description": "SIMTROL INC",
     "symbol": "SMRL"
    },
    {
     "description": "SMARTAG INTERNATIONAL INC",
     "symbol": "SMRN"
    },
    {
     "description": "SMARTRENT INC",
     "symbol": "SMRT"
    },
    {
     "description": "SMOOTH ROCK VENTURES CORP",
     "symbol": "SMRVF"
    },
    {
     "description": "SMARTSHARES NZ MID CAP ETF",
     "symbol": "SMRZF"
    },
    {
     "description": "SAMSONITE INTERNAT-UNSP ADR",
     "symbol": "SMSEY"
    },
    {
     "description": "SMITH MICRO SOFTWARE INC",
     "symbol": "SMSI"
    },
    {
     "description": "SIMS LTD-SPON ADR",
     "symbol": "SMSMY"
    },
    {
     "description": "SAMSONITE INTERNATIONAL SA",
     "symbol": "SMSOF"
    },
    {
     "description": "SMS CO LTD",
     "symbol": "SMSZF"
    },
    {
     "description": "SEMTECH CORP",
     "symbol": "SMTC"
    },
    {
     "description": "SMART EYE AB",
     "symbol": "SMTEF"
    },
    {
     "description": "SMA SOLAR TECHNOLOGY AG",
     "symbol": "SMTGF"
    },
    {
     "description": "SMA SOLAR TECHNOLOGY-UN ADR",
     "symbol": "SMTGY"
    },
    {
     "description": "SANARA MEDTECH INC",
     "symbol": "SMTI"
    },
    {
     "description": "SMARTKEM INC",
     "symbol": "SMTK"
    },
    {
     "description": "GCL NEW ENERGY HOLDINGS LTD",
     "symbol": "SMTLF"
    },
    {
     "description": "SUMITOMO ELECTRIC INDUSTRIES",
     "symbol": "SMTOF"
    },
    {
     "description": "SUMITOMO ELEC INDS-UNSP ADR",
     "symbol": "SMTOY"
    },
    {
     "description": "SIERRA METALS INC",
     "symbol": "SMTS"
    },
    {
     "description": "SUMITOMO RUBBER INDUSTRIES",
     "symbol": "SMTUF"
    },
    {
     "description": "SAMTY RESIDENTIAL INVESTMENT",
     "symbol": "SMTYF"
    },
    {
     "description": "SIMS LTD",
     "symbol": "SMUPF"
    },
    {
     "description": "TOKENS.COM CORP",
     "symbol": "SMURF"
    },
    {
     "description": "SIAM COMMERCIAL BANK P-NVDR",
     "symbol": "SMUUF"
    },
    {
     "description": "SIAM COMMERCIAL BAN-UNSP ADR",
     "symbol": "SMUUY"
    },
    {
     "description": "SOCIAL MEDIA VENTURES INC",
     "symbol": "SMVI"
    },
    {
     "description": "SMART VENTURES INC",
     "symbol": "SMVR"
    },
    {
     "description": "SMAVE SOLUTIONS INC",
     "symbol": "SMVS"
    },
    {
     "description": "SIMILARWEB LTD",
     "symbol": "SMWB"
    },
    {
     "description": "SPDR WORLD CON STAPLES",
     "symbol": "SMWCF"
    },
    {
     "description": "SPDR WORLD ENERGY",
     "symbol": "SMWFF"
    },
    {
     "description": "SMITHS NEWS PLC-UNSPO ADR",
     "symbol": "SMWPY"
    },
    {
     "description": "SM WIRTSCHAFTSBERATUNG AG",
     "symbol": "SMWZF"
    },
    {
     "description": "SNAP-ON INC",
     "symbol": "SNA"
    },
    {
     "description": "SAN-A CO LTD",
     "symbol": "SNAAF"
    },
    {
     "description": "SONA NANOTECH INC",
     "symbol": "SNANF"
    },
    {
     "description": "SNAP INC - A",
     "symbol": "SNAP"
    },
    {
     "description": "SINO ASSURANCE INC",
     "symbol": "SNAS"
    },
    {
     "description": "STAR NAVIGATION SYSTEMS GROU",
     "symbol": "SNAVF"
    },
    {
     "description": "STRYVE FOODS INC-CLASS A",
     "symbol": "SNAX"
    },
    {
     "description": "STRYVE FOOD INC-CW24",
     "symbol": "SNAXW"
    },
    {
     "description": "SENTIENT BRANDS HOLDINGS INC",
     "symbol": "SNBH"
    },
    {
     "description": "SANBIO CO LTD",
     "symbol": "SNBIF"
    },
    {
     "description": "SLEEP NUMBER CORP",
     "symbol": "SNBR"
    },
    {
     "description": "SNC-LAVALIN GROUP INC",
     "symbol": "SNCAF"
    },
    {
     "description": "SCIENCE 37 HOLDINGS INC",
     "symbol": "SNCE"
    },
    {
     "description": "SANARCO FUNDS INC",
     "symbol": "SNCF"
    },
    {
     "description": "SNT CORP",
     "symbol": "SNCJF"
    },
    {
     "description": "SOUTHERN CONCRETE PILE-NVDR",
     "symbol": "SNCLF"
    },
    {
     "description": "SUN CORP",
     "symbol": "SNCPF"
    },
    {
     "description": "SYNCHRONOSS TECHNOLOGIES INC",
     "symbol": "SNCR"
    },
    {
     "description": "SYNCHRONOSS TECH",
     "symbol": "SNCRL"
    },
    {
     "description": "RASSINI SAB DE CV",
     "symbol": "SNCVF"
    },
    {
     "description": "SUN COUNTRY AIRLINES HOLDING",
     "symbol": "SNCY"
    },
    {
     "description": "SMART SAND INC",
     "symbol": "SND"
    },
    {
     "description": "SONIDA SENIOR LIVING INC",
     "symbol": "SNDA"
    },
    {
     "description": "REDHAWK HOLDINGS CORP",
     "symbol": "SNDD"
    },
    {
     "description": "STANDARD HOLDINGS GROUP LTD",
     "symbol": "SNDH"
    },
    {
     "description": "SUNDIAL GROWERS INC",
     "symbol": "SNDL"
    },
    {
     "description": "SCHNEIDER NATIONAL INC-CL B",
     "symbol": "SNDR"
    },
    {
     "description": "SCANDINAVIAN TOBACCO GROUP A",
     "symbol": "SNDVF"
    },
    {
     "description": "SYNDAX PHARMACEUTICALS INC",
     "symbol": "SNDX"
    },
    {
     "description": "SUNRIDGE INTERNATIONAL INC",
     "symbol": "SNDZ"
    },
    {
     "description": "SOUND ENERGY PLC",
     "symbol": "SNEGF"
    },
    {
     "description": "SNACK EMPIRE HOLDINGS LTD",
     "symbol": "SNEHF"
    },
    {
     "description": "SONY GROUP CORP",
     "symbol": "SNEJF"
    },
    {
     "description": "SYNEL MLL PAYWAY LTD",
     "symbol": "SNELF"
    },
    {
     "description": "SENESTECH INC",
     "symbol": "SNES"
    },
    {
     "description": "STONEX GROUP INC",
     "symbol": "SNEX"
    },
    {
     "description": "SECURITY NATL FINL CORP-CL A",
     "symbol": "SNFCA"
    },
    {
     "description": "SINOFERT HOLDINGS LTD",
     "symbol": "SNFRF"
    },
    {
     "description": "SINOFERT HOLDINGS-UNSP ADR",
     "symbol": "SNFRY"
    },
    {
     "description": "SINGAPORE O&G LTD",
     "symbol": "SNGGF"
    },
    {
     "description": "SINGASIA HOLDINGS LTD",
     "symbol": "SNGHF"
    },
    {
     "description": "SINGAPORE TELECOMMUNICATIONS",
     "symbol": "SNGNF"
    },
    {
     "description": "SINGAMAS CONTAINER HLDGS",
     "symbol": "SNGSF"
    },
    {
     "description": "SGISSUE-CW23 SINGAPORE AIR",
     "symbol": "SNGWF"
    },
    {
     "description": "SOLIGENIX INC",
     "symbol": "SNGX"
    },
    {
     "description": "SYNRGY CORP",
     "symbol": "SNGY"
    },
    {
     "description": "SHONGHOYA INTERNATIONAL GROU",
     "symbol": "SNHO"
    },
    {
     "description": "SANEI ARCHITECTURE PLANNING",
     "symbol": "SNHPF"
    },
    {
     "description": "SENSIO TECHNOLOGIES INC",
     "symbol": "SNIOF"
    },
    {
     "description": "SNIPP INTERACTIVE INC",
     "symbol": "SNIPF"
    },
    {
     "description": "SENIOR PLC",
     "symbol": "SNIRF"
    },
    {
     "description": "SANKEI REAL ESTATE INC",
     "symbol": "SNKEF"
    },
    {
     "description": "SANKO CO LTD",
     "symbol": "SNKOF"
    },
    {
     "description": "SINO LAND CO",
     "symbol": "SNLAF"
    },
    {
     "description": "SINO LAND COMPANY LTD-SP ADR",
     "symbol": "SNLAY"
    },
    {
     "description": "SECURITY NATL CORP SIOUX CTY",
     "symbol": "SNLC"
    },
    {
     "description": "SAN LORENZO GOLD CORP\/CANADA",
     "symbol": "SNLGF"
    },
    {
     "description": "SINOLINK WORLDWIDE HOLDINGS",
     "symbol": "SNLKF"
    },
    {
     "description": "HOMESTEAD GOLD AND SILVER LT",
     "symbol": "SNLM"
    },
    {
     "description": "HIGHLAND\/IBOXX SENIOR LOAN E",
     "symbol": "SNLN"
    },
    {
     "description": "SYNTROL CORP",
     "symbol": "SNLP"
    },
    {
     "description": "SAN LUIS TRUST BANK FSB",
     "symbol": "SNLS"
    },
    {
     "description": "SONA MOBILE HOLDINGS CORP",
     "symbol": "SNMBQ"
    },
    {
     "description": "SUNCORP GROUP LTD-SPON ADR",
     "symbol": "SNMCY"
    },
    {
     "description": "SNM GLOBAL HOLDINGS",
     "symbol": "SNMN"
    },
    {
     "description": "EVOLVE TRANSITION INFRASTRUC",
     "symbol": "SNMP"
    },
    {
     "description": "SNAM SPA",
     "symbol": "SNMRF"
    },
    {
     "description": "SNAM RETE GAS-UNSPONSOR ADR",
     "symbol": "SNMRY"
    },
    {
     "description": "SPIN MASTER CORP-SUB VTG SHR",
     "symbol": "SNMSF"
    },
    {
     "description": "SUNCORP GROUP LTD",
     "symbol": "SNMYF"
    },
    {
     "description": "SMITH & NEPHEW PLC -SPON ADR",
     "symbol": "SNN"
    },
    {
     "description": "SIENNA RESOURCES INC",
     "symbol": "SNNAF"
    },
    {
     "description": "SIENNA BIOPHARMACEUTICALS IN",
     "symbol": "SNNAQ"
    },
    {
     "description": "SIBANNAC INC",
     "symbol": "SNNC"
    },
    {
     "description": "SENECA FINANCIAL CORP",
     "symbol": "SNNF"
    },
    {
     "description": "PPX MINING CORP",
     "symbol": "SNNGF"
    },
    {
     "description": "KINGWELL GROUP LTD",
     "symbol": "SNNHF"
    },
    {
     "description": "SENSEN NETWORKS LTD",
     "symbol": "SNNSF"
    },
    {
     "description": "SMITH & NEPHEW PLC",
     "symbol": "SNNUF"
    },
    {
     "description": "SUNNIVA INC",
     "symbol": "SNNVF"
    },
    {
     "description": "SUNNYSIDE BANCORP INC",
     "symbol": "SNNY"
    },
    {
     "description": "SONOMA PHARMACEUTICALS INC",
     "symbol": "SNOA"
    },
    {
     "description": "SINO-I TECHNOLOGY LTD",
     "symbol": "SNOIF"
    },
    {
     "description": "SINOTRANS LIMITED-H",
     "symbol": "SNOTF"
    },
    {
     "description": "SNOWFLAKE INC-CLASS A",
     "symbol": "SNOW"
    },
    {
     "description": "CHINA PETROLEUM & CHEM-ADR",
     "symbol": "SNP"
    },
    {
     "description": "XTRACKERS S&P 500 ESG ETF",
     "symbol": "SNPE"
    },
    {
     "description": "SANTEN PHARMACEUTICAL CO LTD",
     "symbol": "SNPHF"
    },
    {
     "description": "SANTEN PHARMACEUTICAL-UN ADR",
     "symbol": "SNPHY"
    },
    {
     "description": "SINOPEC KANTONS HOLDINGS",
     "symbol": "SNPKF"
    },
    {
     "description": "CHINA PETROLEUM & CHEMICAL-H",
     "symbol": "SNPMF"
    },
    {
     "description": "SNAP ONE HOLDINGS CORP",
     "symbol": "SNPO"
    },
    {
     "description": "SINOPEC ENGINRING GRP-H ADR",
     "symbol": "SNPRY"
    },
    {
     "description": "SYNOPSYS INC",
     "symbol": "SNPS"
    },
    {
     "description": "SUNNY OPTICAL TECH",
     "symbol": "SNPTF"
    },
    {
     "description": "SUN PACIFIC HOLDING CORP",
     "symbol": "SNPW"
    },
    {
     "description": "SYNAPTOGENIX INC",
     "symbol": "SNPX"
    },
    {
     "description": "SNP SCHNEIDER-NEUREITHER & P",
     "symbol": "SNPXF"
    },
    {
     "description": "TISDALE RESOURCES CORP",
     "symbol": "SNRAF"
    },
    {
     "description": "SUSGLOBAL ENERGY CORP",
     "symbol": "SNRG"
    },
    {
     "description": "SENIOR CONNECT ACQUISITION-A",
     "symbol": "SNRH"
    },
    {
     "description": "SENIOR CONNECT ACQUISITION C",
     "symbol": "SNRHU"
    },
    {
     "description": "SENIOR CONNECT ACQ A -CW27",
     "symbol": "SNRHW"
    },
    {
     "description": "SANRIO CO LTD",
     "symbol": "SNROF"
    },
    {
     "description": "SUPER NOVA RESOURCES INC",
     "symbol": "SNRR"
    },
    {
     "description": "SUNRISE CONSULTING GROUP INC",
     "symbol": "SNRS"
    },
    {
     "description": "SOLAR ENERGY INITIATIVE INC",
     "symbol": "SNRY"
    },
    {
     "description": "SENSEI BIOTHERAPEUTICS INC",
     "symbol": "SNSE"
    },
    {
     "description": "SENSE TECHNOLOGIES INC",
     "symbol": "SNSGF"
    },
    {
     "description": "SANKO SANGYO CO LTD",
     "symbol": "SNSKF"
    },
    {
     "description": "GLOBAL X INTERNET OF THINGS",
     "symbol": "SNSR"
    },
    {
     "description": "SUNSET CAPITAL ASSETS INC",
     "symbol": "SNST"
    },
    {
     "description": "SANSIRI PCL-NVDR",
     "symbol": "SNSUF"
    },
    {
     "description": "SENSTAR TECHNOLOGIES LTD",
     "symbol": "SNT"
    },
    {
     "description": "STRATEGIC MINERALS EUROPE CO",
     "symbol": "SNTAF"
    },
    {
     "description": "SANTE TECHNOLOGY HOLDINGS IN",
     "symbol": "SNTE"
    },
    {
     "description": "SENTAGE HOLDINGS INC",
     "symbol": "SNTG"
    },
    {
     "description": "SANTANA MINERALS LTD",
     "symbol": "SNTNF"
    },
    {
     "description": "SUMMIT NETWORKS INC",
     "symbol": "SNTW"
    },
    {
     "description": "SUNTEX ENTERPRISES INC",
     "symbol": "SNTX"
    },
    {
     "description": "MERLYN AI TACTICAL GRW & INC",
     "symbol": "SNUG"
    },
    {
     "description": "SERINUS ENERGY PLC",
     "symbol": "SNUYF"
    },
    {
     "description": "SYNOVUS FINANCIAL CORP",
     "symbol": "SNV"
    },
    {
     "description": "SYNOVUS FINANCIAL CORP",
     "symbol": "SNV.PRD"
    },
    {
     "description": "SYNOVUS FINANCIAL CORP",
     "symbol": "SNV.PRE"
    },
    {
     "description": "SONORO ENERGY LTD",
     "symbol": "SNVFF"
    },
    {
     "description": "SONOVIA LTD",
     "symbol": "SNVIF"
    },
    {
     "description": "SAVOY ENERGY CORP",
     "symbol": "SNVP"
    },
    {
     "description": "STEP ENERGY SERVICES LTD",
     "symbol": "SNVVF"
    },
    {
     "description": "SANWA HOLDINGS CORP",
     "symbol": "SNWAF"
    },
    {
     "description": "SNOWLINE GOLD CORP",
     "symbol": "SNWGF"
    },
    {
     "description": "SANWIRE CORP",
     "symbol": "SNWR"
    },
    {
     "description": "SANUWAVE HEALTH INC",
     "symbol": "SNWV"
    },
    {
     "description": "TD SYNNEX CORP",
     "symbol": "SNX"
    },
    {
     "description": "SANOFI-ADR",
     "symbol": "SNY"
    },
    {
     "description": "SUNNYLIFE GLOBAL INC",
     "symbol": "SNYL"
    },
    {
     "description": "SANOFI",
     "symbol": "SNYNF"
    },
    {
     "description": "SYNERGY CHC CORP",
     "symbol": "SNYR"
    },
    {
     "description": "SANY HEAVY EQUIPMENT INTL",
     "symbol": "SNYYF"
    },
    {
     "description": "SENZIME AB",
     "symbol": "SNZZF"
    },
    {
     "description": "SOUTHERN CO\/THE",
     "symbol": "SO"
    },
    {
     "description": "SARTORIUS AG-UNSP ADR",
     "symbol": "SOAGY"
    },
    {
     "description": "SOFTBANK CORP-UNSP ADR",
     "symbol": "SOBKY"
    },
    {
     "description": "SOBR SAFE INC",
     "symbol": "SOBR"
    },
    {
     "description": "SOLVAY BANK SOLVAY N Y",
     "symbol": "SOBS"
    },
    {
     "description": "Southern California Gas Co",
     "symbol": "SOCGM"
    },
    {
     "description": "Southern California Gas Company",
     "symbol": "SOCGP"
    },
    {
     "description": "GLOBAL X SOCIAL MEDIA ETF",
     "symbol": "SOCL"
    },
    {
     "description": "PHAROS ENERGY PLC",
     "symbol": "SOCLF"
    },
    {
     "description": "SOCIAL DETENTION INC",
     "symbol": "SODE"
    },
    {
     "description": "SOLITRON DEVICES INC",
     "symbol": "SODI"
    },
    {
     "description": "SOLAR ENERTECH CORP",
     "symbol": "SOEN"
    },
    {
     "description": "CAREPAY INC",
     "symbol": "SOFE"
    },
    {
     "description": "SOFI TECHNOLOGIES INC",
     "symbol": "SOFI"
    },
    {
     "description": "SONIC FOUNDRY INC",
     "symbol": "SOFO"
    },
    {
     "description": "CLEANGO INNOVATIONS INC",
     "symbol": "SOFSF"
    },
    {
     "description": "SOFTECH INC",
     "symbol": "SOFT"
    },
    {
     "description": "SOFWAVE MEDICAL LTD",
     "symbol": "SOFWF"
    },
    {
     "description": "STRATEGIC OIL & GAS LTD",
     "symbol": "SOGFF"
    },
    {
     "description": "THE SHORT DE-SPAC ETF",
     "symbol": "SOGU"
    },
    {
     "description": "SOHGO SECURITY SERVICES CO",
     "symbol": "SOHGF"
    },
    {
     "description": "SOHGO SECURITY SERVICES-ADR",
     "symbol": "SOHGY"
    },
    {
     "description": "SORTIS HOLDINGS INC",
     "symbol": "SOHI"
    },
    {
     "description": "SOUTHERN TRUST SECURITIES HO",
     "symbol": "SOHL"
    },
    {
     "description": "SOTHERLY HOTELS INC",
     "symbol": "SOHO"
    },
    {
     "description": "SOTHERLY HOTELS INC",
     "symbol": "SOHOB"
    },
    {
     "description": "SOHO CHINA LTD",
     "symbol": "SOHOF"
    },
    {
     "description": "SOTHERLY HOTELS INC",
     "symbol": "SOHON"
    },
    {
     "description": "SOTHERLY HOTELS INC",
     "symbol": "SOHOO"
    },
    {
     "description": "SOHU.COM LTD-ADR",
     "symbol": "SOHU"
    },
    {
     "description": "SUMITOMO HEAVY INDUSTRIES",
     "symbol": "SOHVF"
    },
    {
     "description": "SUMITOMO HEAVY INDUS-UNS ADR",
     "symbol": "SOHVY"
    },
    {
     "description": "SOLARIS OILFIELD INFRAST-A",
     "symbol": "SOI"
    },
    {
     "description": "STOLT-NIELSEN LTD",
     "symbol": "SOIEF"
    },
    {
     "description": "STRIKER OIL & GAS INC",
     "symbol": "SOIS"
    },
    {
     "description": "SOUTHERN CO",
     "symbol": "SOJC"
    },
    {
     "description": "SOUTHERN CO",
     "symbol": "SOJD"
    },
    {
     "description": "SOUTHERN CO",
     "symbol": "SOJE"
    },
    {
     "description": "RENESOLA LTD-ADR",
     "symbol": "SOL"
    },
    {
     "description": "SOLVBL SOLUTIONS INC",
     "symbol": "SOLBF"
    },
    {
     "description": "SOL GLOBAL INVESTMENTS CORP",
     "symbol": "SOLCF"
    },
    {
     "description": "SHUI ON LAND LTD",
     "symbol": "SOLLF"
    },
    {
     "description": "SHUI ON LAND LTD-UNSPON ADR",
     "symbol": "SOLLY"
    },
    {
     "description": "SOUTHERN CO",
     "symbol": "SOLN"
    },
    {
     "description": "ELECTRAMECCANICA VEHICLES CO",
     "symbol": "SOLO"
    },
    {
     "description": "ELECTRAMECCANICA VEHICL-CW23",
     "symbol": "SOLOW"
    },
    {
     "description": "SMARTETFS SUSTAINABLE ENERGY",
     "symbol": "SOLR"
    },
    {
     "description": "SOLLENSYS CORP",
     "symbol": "SOLS"
    },
    {
     "description": "SOSEI GROUP CORP",
     "symbol": "SOLTF"
    },
    {
     "description": "SOLUTIONS GROUP INC",
     "symbol": "SOLU"
    },
    {
     "description": "SOUTHERN MICHIGAN BANCORP",
     "symbol": "SOMC"
    },
    {
     "description": "SOMERSET TRUST HOLDING CO",
     "symbol": "SOME"
    },
    {
     "description": "SECOM CO LTD",
     "symbol": "SOMLF"
    },
    {
     "description": "SECOM CO LTD - UNSP - ADR",
     "symbol": "SOMLY"
    },
    {
     "description": "SUMITOMO CHEMICAL CO LTD",
     "symbol": "SOMMF"
    },
    {
     "description": "SUMITOMO CHEMICAL CO-UNS ADR",
     "symbol": "SOMMY"
    },
    {
     "description": "SOMNOMED LTD",
     "symbol": "SOMNF"
    },
    {
     "description": "SINOMAX GROUP LTD",
     "symbol": "SOMXF"
    },
    {
     "description": "SONOCO PRODUCTS CO",
     "symbol": "SON"
    },
    {
     "description": "SONDER HOLDINGS INC",
     "symbol": "SOND"
    },
    {
     "description": "GORES METROPOULOS II -CW28",
     "symbol": "SONDW"
    },
    {
     "description": "SONIM TECHNOLOGIES INC",
     "symbol": "SONM"
    },
    {
     "description": "SONNET BIOTHERAPEUTICS HOLDI",
     "symbol": "SONN"
    },
    {
     "description": "SONOS INC",
     "symbol": "SONO"
    },
    {
     "description": "SONAR RADIO CORP",
     "symbol": "SONR"
    },
    {
     "description": "SONOVA HOLDING AG-REG",
     "symbol": "SONVF"
    },
    {
     "description": "SONOVA HOLDING-UNSPON ADR",
     "symbol": "SONVY"
    },
    {
     "description": "SONENDO INC",
     "symbol": "SONX"
    },
    {
     "description": "SONY GROUP CORP - SP ADR",
     "symbol": "SONY"
    },
    {
     "description": "SAPPORO HOLDINGS LTD",
     "symbol": "SOOBF"
    },
    {
     "description": "SOCIETY PASS INC",
     "symbol": "SOPA"
    },
    {
     "description": "SOPHIA GENETICS SA",
     "symbol": "SOPH"
    },
    {
     "description": "SOUTHPEAK INTERACTIVE CORP",
     "symbol": "SOPK"
    },
    {
     "description": "SOLAR PARK INITIATIVES INC",
     "symbol": "SOPV"
    },
    {
     "description": "SONDE RESOURCES CORP",
     "symbol": "SOQDQ"
    },
    {
     "description": "SOURCE CAPITAL INC",
     "symbol": "SOR"
    },
    {
     "description": "STRATEGIC ELEMENTS LTD",
     "symbol": "SORHF"
    },
    {
     "description": "GUNTHER INTERNATIONAL LTD",
     "symbol": "SORT"
    },
    {
     "description": "SOS LTD",
     "symbol": "SOS"
    },
    {
     "description": "DEOLEO SA",
     "symbol": "SOSCF"
    },
    {
     "description": "STORAGE COMPUTER CORP",
     "symbol": "SOSO"
    },
    {
     "description": "SOUTHERN STATES SIGN CO",
     "symbol": "SOST"
    },
    {
     "description": "STROEER SE & CO KGAA",
     "symbol": "SOTDF"
    },
    {
     "description": "STROEER SE & CO- UNSP ADR",
     "symbol": "SOTDY"
    },
    {
     "description": "SUNNY OPTICAL TECH-UNSP ADR",
     "symbol": "SOTGY"
    },
    {
     "description": "SOTETSU HOLDINGS INC",
     "symbol": "SOTHF"
    },
    {
     "description": "SONO-TEK CORP",
     "symbol": "SOTK"
    },
    {
     "description": "SOUTHPOINT BANCSHARES INC",
     "symbol": "SOUB"
    },
    {
     "description": "SOU 300 GROUP HOLDING CO",
     "symbol": "SOUG"
    },
    {
     "description": "SOUTH32 - ADR",
     "symbol": "SOUHY"
    },
    {
     "description": "SOVOS BRANDS INC",
     "symbol": "SOVO"
    },
    {
     "description": "SONAECOM SGPS SA",
     "symbol": "SOVTF"
    },
    {
     "description": "SOW GOOD INC",
     "symbol": "SOWG"
    },
    {
     "description": "DIREXION DAILY SEMI BULL 3X",
     "symbol": "SOXL"
    },
    {
     "description": "INVESCO PHLX SEMICONDUCTOR",
     "symbol": "SOXQ"
    },
    {
     "description": "DIREXION DAILY SEMI BEAR 3X",
     "symbol": "SOXS"
    },
    {
     "description": "ISHARES SEMICONDUCTOR ETF",
     "symbol": "SOXX"
    },
    {
     "description": "TEUCRIUM SOYBEAN FUND",
     "symbol": "SOYB"
    },
    {
     "description": "SOYO GROUP INC",
     "symbol": "SOYO"
    },
    {
     "description": "SP PLUS CORP",
     "symbol": "SP"
    },
    {
     "description": "SPDR PORTFOLIO AGGREGATE BON",
     "symbol": "SPAB"
    },
    {
     "description": "ISHARES AGRIBUSINESS",
     "symbol": "SPAGF"
    },
    {
     "description": "DEFIANCE NEXTGEN SPAC DERIVE",
     "symbol": "SPAK"
    },
    {
     "description": "SATS LTD",
     "symbol": "SPASF"
    },
    {
     "description": "SATS LTD-UNSPONSORED ADR",
     "symbol": "SPASY"
    },
    {
     "description": "ROBINSON ALT YLD PREMERG SP",
     "symbol": "SPAX"
    },
    {
     "description": "SPANISH MOUNTAIN GOLD LTD",
     "symbol": "SPAZF"
    },
    {
     "description": "SPECTRUM BRANDS HOLDINGS INC",
     "symbol": "SPB"
    },
    {
     "description": "SPEAKEASY CANNABIS CLUB LTD",
     "symbol": "SPBBF"
    },
    {
     "description": "SIMPLIFY US EQ PLUS GBTC ETF",
     "symbol": "SPBC"
    },
    {
     "description": "SPDR BBG US AGGREGATE",
     "symbol": "SPBGF"
    },
    {
     "description": "SPDR PORTFOLIO CORPORATE BON",
     "symbol": "SPBO"
    },
    {
     "description": "SPORTS POUCH BEVERAGE CO INC",
     "symbol": "SPBV"
    },
    {
     "description": "CROSSINGBRIDGE PRE-MERGER SP",
     "symbol": "SPC"
    },
    {
     "description": "SUPERCOM LTD",
     "symbol": "SPCB"
    },
    {
     "description": "VIRGIN GALACTIC HOLDINGS INC",
     "symbol": "SPCE"
    },
    {
     "description": "SPCG PCL - NVDR",
     "symbol": "SPCGF"
    },
    {
     "description": "SOUND POINT ACQUISITION CO-A",
     "symbol": "SPCM"
    },
    {
     "description": "SOUND POINT ACQUISITION CORP",
     "symbol": "SPCMU"
    },
    {
     "description": "SOUND POINT ACQUISITION-CW27",
     "symbol": "SPCMW"
    },
    {
     "description": "SPC NICKEL CORP",
     "symbol": "SPCNF"
    },
    {
     "description": "STEPHAN CO\/THE",
     "symbol": "SPCO"
    },
    {
     "description": "SPAC & NEW ISSUE ETF",
     "symbol": "SPCX"
    },
    {
     "description": "SIMPLIFY US EQUITY PLUS DOWN",
     "symbol": "SPD"
    },
    {
     "description": "SPEED COMMERCE INC",
     "symbol": "SPDC"
    },
    {
     "description": "SPEEDUS CORP",
     "symbol": "SPDE"
    },
    {
     "description": "DIREXION DLY S&P 500 BEAR 1X",
     "symbol": "SPDN"
    },
    {
     "description": "SPDR WORLD CON DISCRETIONRY",
     "symbol": "SPDRF"
    },
    {
     "description": "AAM S&P 500 HIGH DIV VAL ETF",
     "symbol": "SPDV"
    },
    {
     "description": "SPDR PORTFOLIO DEVELOPED WOR",
     "symbol": "SPDW"
    },
    {
     "description": "SPECIAL OPPORTUNITIES FUND",
     "symbol": "SPE"
    },
    {
     "description": "SPECIAL OPPORTUNITY FUND",
     "symbol": "SPE.PRC"
    },
    {
     "description": "SPECTRALCAST INC",
     "symbol": "SPEC"
    },
    {
     "description": "SPDR PORTFOLIO EMERGING MARK",
     "symbol": "SPEM"
    },
    {
     "description": "SPDR PORTFOLIO EUROPE ETF",
     "symbol": "SPEU"
    },
    {
     "description": "SPEY RESOURCES CORP",
     "symbol": "SPEYF"
    },
    {
     "description": "GLOBAL X SUPERINCOME PREFER",
     "symbol": "SPFF"
    },
    {
     "description": "SOUTH PLAINS FINANCIAL INC",
     "symbol": "SPFI"
    },
    {
     "description": "Presidio Property Trust Inc",
     "symbol": "SPFTP"
    },
    {
     "description": "STANDARD PREMIUM FINANCE HOL",
     "symbol": "SPFX"
    },
    {
     "description": "SPACEFY INC",
     "symbol": "SPFYF"
    },
    {
     "description": "SIMON PROPERTY GROUP INC",
     "symbol": "SPG"
    },
    {
     "description": "SIMON PROPERTY GROUP INC",
     "symbol": "SPG.PRJ"
    },
    {
     "description": "SINO PROSPER STATE GOLD RESO",
     "symbol": "SPGHF"
    },
    {
     "description": "S&P GLOBAL INC",
     "symbol": "SPGI"
    },
    {
     "description": "SPDR PORTFOLIO MSCI GLOBAL S",
     "symbol": "SPGM"
    },
    {
     "description": "INVESCO S&P 500 GARP ETF",
     "symbol": "SPGP"
    },
    {
     "description": "SIMON PROPERTY GROUP ACQUI-A",
     "symbol": "SPGS"
    },
    {
     "description": "SIMON PROPERTY GROUP ACQUISI",
     "symbol": "SPGS.U"
    },
    {
     "description": "SIMON PROPERTY GROUP -CW26",
     "symbol": "SPGS.WS"
    },
    {
     "description": "SUSTAINABLE PROJECTS GROUP I",
     "symbol": "SPGX"
    },
    {
     "description": "WHITECAP RESOURCES INC",
     "symbol": "SPGYF"
    },
    {
     "description": "SPECTRUM GROUP INTERNATIONAL",
     "symbol": "SPGZ"
    },
    {
     "description": "SUBURBAN PROPANE PARTNERS LP",
     "symbol": "SPH"
    },
    {
     "description": "INVESCO S&P 500 HIGH BETA ET",
     "symbol": "SPHB"
    },
    {
     "description": "INVESCO S&P 500 HIGH DIVIDEN",
     "symbol": "SPHD"
    },
    {
     "description": "SANTHERA PHARMACEUTICALS-REG",
     "symbol": "SPHDF"
    },
    {
     "description": "SPH REIT",
     "symbol": "SPHEF"
    },
    {
     "description": "SPOTLIGHT HOMES INC",
     "symbol": "SPHM"
    },
    {
     "description": "INVESCO S&P 500 QUALITY ETF",
     "symbol": "SPHQ"
    },
    {
     "description": "STARPHARMA HOLDINGS LTD",
     "symbol": "SPHRF"
    },
    {
     "description": "STARPHARMA HOLDINGS-SPON ADR",
     "symbol": "SPHRY"
    },
    {
     "description": "SPHERE RESOURCES INC",
     "symbol": "SPHUF"
    },
    {
     "description": "SM PRIME HOLDINGS INC",
     "symbol": "SPHXF"
    },
    {
     "description": "SPDR PORTFOLIO HIGH YIELD BO",
     "symbol": "SPHY"
    },
    {
     "description": "SPI ENERGY CO LTD",
     "symbol": "SPI"
    },
    {
     "description": "SPDR PORT INT CORP BOND ETF",
     "symbol": "SPIB"
    },
    {
     "description": "SPICE VENTURE CAPITAL PTE LT",
     "symbol": "SPICF"
    },
    {
     "description": "SEPTENI HOLDINGS-UNSP ADR",
     "symbol": "SPIDY"
    },
    {
     "description": "SPINE INJURY SOLUTIONS INC",
     "symbol": "SPIN"
    },
    {
     "description": "SPDR PORTFOLIO TIPS ETF",
     "symbol": "SPIP"
    },
    {
     "description": "SPIRE GLOBAL INC",
     "symbol": "SPIR"
    },
    {
     "description": "SPIRE GLOBAL INC      -CW30",
     "symbol": "SPIR.WS"
    },
    {
     "description": "SPIE SA",
     "symbol": "SPIWF"
    },
    {
     "description": "SPAREBANKEN VEST",
     "symbol": "SPIZF"
    },
    {
     "description": "SPK ACQUISITION CORP",
     "symbol": "SPK"
    },
    {
     "description": "SPK ACQUISITION CORP-RTS",
     "symbol": "SPKAR"
    },
    {
     "description": "SPK ACQUISITION CORP",
     "symbol": "SPKAU"
    },
    {
     "description": "SILVER SPIKE ACQUISITION-A",
     "symbol": "SPKB"
    },
    {
     "description": "SILVER SPIKE ACQUISITION COR",
     "symbol": "SPKBU"
    },
    {
     "description": "SILVER SPIKE ACQ -A CW26",
     "symbol": "SPKBW"
    },
    {
     "description": "SPARK NEW ZEALAND-SPON ADR",
     "symbol": "SPKKY"
    },
    {
     "description": "SINOPEC KANTONS-UNSPON ADR",
     "symbol": "SPKOY"
    },
    {
     "description": "SPECTRA PRODS INC",
     "symbol": "SPKTF"
    },
    {
     "description": "SPDR PORT LNG TRM CORP BND",
     "symbol": "SPLB"
    },
    {
     "description": "SPDR PORTFOLIO S&P 500 ETF",
     "symbol": "SPLG"
    },
    {
     "description": "HIGH FUSION INC",
     "symbol": "SPLIF"
    },
    {
     "description": "SPLUNK INC",
     "symbol": "SPLK"
    },
    {
     "description": "SENTRY PETROLEUM LTD",
     "symbol": "SPLM"
    },
    {
     "description": "STEEL PARTNERS HOLDINGS LP",
     "symbol": "SPLP"
    },
    {
     "description": "STEEL PARTNERS HLDS LP",
     "symbol": "SPLP.PRA"
    },
    {
     "description": "SPOTLITE360 IOT SOLUTIONS IN",
     "symbol": "SPLTF"
    },
    {
     "description": "INVESCO S&P 500 LOW VOLATILI",
     "symbol": "SPLV"
    },
    {
     "description": "SOCIALPLAY USA INC",
     "symbol": "SPLY"
    },
    {
     "description": "SPDR PORTFOLIO MORTGAGE BACK",
     "symbol": "SPMB"
    },
    {
     "description": "SPDR PORTFOLIO S&P 400 MID C",
     "symbol": "SPMD"
    },
    {
     "description": "SPEEDEMISSIONS INC",
     "symbol": "SPMI"
    },
    {
     "description": "SENTRY SEL PRIMARY METALS-A",
     "symbol": "SPMLF"
    },
    {
     "description": "SPACE COMMUNICATION LTD",
     "symbol": "SPMMF"
    },
    {
     "description": "INVESCO S&P 500 MOMENTUM ETF",
     "symbol": "SPMO"
    },
    {
     "description": "SPEARMINT RESOURCES INC",
     "symbol": "SPMTF"
    },
    {
     "description": "INVESCO S&P 500 MINIMUM VARI",
     "symbol": "SPMV"
    },
    {
     "description": "SUPERMAX CORP BHD",
     "symbol": "SPMXF"
    },
    {
     "description": "SPIRENT COMMUNICATIONS-ADR",
     "symbol": "SPMYY"
    },
    {
     "description": "SPINDLETOP OIL & GAS CO",
     "symbol": "SPND"
    },
    {
     "description": "SEASPINE HOLDINGS CORP",
     "symbol": "SPNE"
    },
    {
     "description": "SUPERIOR ENERGY SERVICES INC",
     "symbol": "SPNR"
    },
    {
     "description": "SPARTON RESOURCES INC",
     "symbol": "SPNRF"
    },
    {
     "description": "SAPIENS INTERNATIONAL CORP",
     "symbol": "SPNS"
    },
    {
     "description": "SIRIUSPOINT LTD",
     "symbol": "SPNT"
    },
    {
     "description": "SIRIUSPOINT LTD",
     "symbol": "SPNT.PRB"
    },
    {
     "description": "SPIRENT COMMUNICATIONS PLC",
     "symbol": "SPNUF"
    },
    {
     "description": "SOUTH PORT NEW ZEALAND LTD",
     "symbol": "SPNZF"
    },
    {
     "description": "SPECTRUM OIL CORP",
     "symbol": "SPOC"
    },
    {
     "description": "GOLDSPOT DISCOVERIES CORP",
     "symbol": "SPOFF"
    },
    {
     "description": "SPO NETWORKS INC",
     "symbol": "SPOID"
    },
    {
     "description": "SPOK HOLDINGS INC",
     "symbol": "SPOK"
    },
    {
     "description": "SPO GLOBAL INC",
     "symbol": "SPOM"
    },
    {
     "description": "SPONSORSONE INC",
     "symbol": "SPONF"
    },
    {
     "description": "SPOTIFY TECHNOLOGY SA",
     "symbol": "SPOT"
    },
    {
     "description": "STRATA POWER CORP",
     "symbol": "SPOWF"
    },
    {
     "description": "SPORTECH PLC",
     "symbol": "SPOZF"
    },
    {
     "description": "STEPPE CEMENT LTD",
     "symbol": "SPPCF"
    },
    {
     "description": "SPICE PRIVATE EQUITY AG",
     "symbol": "SPPEF"
    },
    {
     "description": "SPENCER PHARMACEUTICAL INC",
     "symbol": "SPPH"
    },
    {
     "description": "SPECTRUM PHARMACEUTICALS INC",
     "symbol": "SPPI"
    },
    {
     "description": "SAPPI LTD -SPONSORED ADR",
     "symbol": "SPPJY"
    },
    {
     "description": "SPROTT PHYSICAL PLATINUM AND",
     "symbol": "SPPP"
    },
    {
     "description": "SPECIALTY LIQUID TRANSPORTAT",
     "symbol": "SPQDF"
    },
    {
     "description": "SPORTSQUEST INC",
     "symbol": "SPQS"
    },
    {
     "description": "SPIRIT AEROSYSTEMS HOLD-CL A",
     "symbol": "SPR"
    },
    {
     "description": "SPRUCE BIOSCIENCES INC",
     "symbol": "SPRB"
    },
    {
     "description": "SPAREBANK 1 OESTLANDET",
     "symbol": "SPRBF"
    },
    {
     "description": "SCISPARC LTD",
     "symbol": "SPRC"
    },
    {
     "description": "SP\/F S&P GLOBAL REIT SHARIA",
     "symbol": "SPRE"
    },
    {
     "description": "SPRINGS REJUVENATION INC",
     "symbol": "SPRJ"
    },
    {
     "description": "STRAT PETROLEUM LTD",
     "symbol": "SPRL"
    },
    {
     "description": "SUPERNOVA ENERGY INC",
     "symbol": "SPRN"
    },
    {
     "description": "SPERO THERAPEUTICS INC",
     "symbol": "SPRO"
    },
    {
     "description": "SURGE COMPONENTS INC",
     "symbol": "SPRS"
    },
    {
     "description": "SUPURVA HEALTHCARE GROUP INC",
     "symbol": "SPRV"
    },
    {
     "description": "SPEAR ALPHA ETF",
     "symbol": "SPRX"
    },
    {
     "description": "SPRIZA INC",
     "symbol": "SPRZ"
    },
    {
     "description": "SOPRA STERIA GROUP",
     "symbol": "SPSAF"
    },
    {
     "description": "SPDR PORT SHRT TRM CORP BND",
     "symbol": "SPSB"
    },
    {
     "description": "SPS COMMERCE INC",
     "symbol": "SPSC"
    },
    {
     "description": "SP FUNDS DOW JONES GLOBAL SU",
     "symbol": "SPSK"
    },
    {
     "description": "SPDR PORTFOLIO S&P 600 SMALL",
     "symbol": "SPSM"
    },
    {
     "description": "SPECTACULAR SOLAR INC",
     "symbol": "SPSO"
    },
    {
     "description": "SINGAPORE POST LTD",
     "symbol": "SPSTF"
    },
    {
     "description": "SINGAPORE POST LTD-UNSP ADR",
     "symbol": "SPSTY"
    },
    {
     "description": "SPROUT SOCIAL INC - CLASS A",
     "symbol": "SPT"
    },
    {
     "description": "SPDR PORT INT TREASURY TERM",
     "symbol": "SPTI"
    },
    {
     "description": "SINOPEC SHANGHAI PETROCHEM-H",
     "symbol": "SPTJF"
    },
    {
     "description": "SPORTSTEK ACQUISITION CORP-A",
     "symbol": "SPTK"
    },
    {
     "description": "SPORTSTEK ACQUISITION CORP",
     "symbol": "SPTKU"
    },
    {
     "description": "SPORTSTEK ACQ CL A -CW27",
     "symbol": "SPTKW"
    },
    {
     "description": "SPDR PORT LNG TRM TRSRY",
     "symbol": "SPTL"
    },
    {
     "description": "SPDR PORTFOLIO S&P 1500 COMP",
     "symbol": "SPTM"
    },
    {
     "description": "SPARTANNASH CO",
     "symbol": "SPTN"
    },
    {
     "description": "SPDR PORT SHRT TRM TRSRY",
     "symbol": "SPTS"
    },
    {
     "description": "SPLITIT PAYMENTS - SPON ADR",
     "symbol": "SPTTY"
    },
    {
     "description": "SPRINTEX LTD",
     "symbol": "SPTXF"
    },
    {
     "description": "SPECIFICITY INC",
     "symbol": "SPTY"
    },
    {
     "description": "SIMPLIFY US EQUITY PLUS UPSI",
     "symbol": "SPUC"
    },
    {
     "description": "SIPUP CORP",
     "symbol": "SPUP"
    },
    {
     "description": "SP FUNDS S&P SHARIA INDUSTRY",
     "symbol": "SPUS"
    },
    {
     "description": "DIREXION DLY S&P 500 BULL 2X",
     "symbol": "SPUU"
    },
    {
     "description": "INVESCO S&P 500 VALUE WITH M",
     "symbol": "SPVM"
    },
    {
     "description": "SPECTRA7 MICROSYSTEMS INC",
     "symbol": "SPVNF"
    },
    {
     "description": "INVESCO S&P 500 ENHANCED VAL",
     "symbol": "SPVU"
    },
    {
     "description": "SPORTSMAN'S WAREHOUSE HOLDIN",
     "symbol": "SPWH"
    },
    {
     "description": "SUNPOWER CORP",
     "symbol": "SPWR"
    },
    {
     "description": "SPDR WORLD UTILITIES",
     "symbol": "SPWUF"
    },
    {
     "description": "SPECTRUMDNA INC",
     "symbol": "SPXA"
    },
    {
     "description": "PROSHARES S&P 500 BOND ETF",
     "symbol": "SPXB"
    },
    {
     "description": "SPX CORP",
     "symbol": "SPXC"
    },
    {
     "description": "SINGAPORE EXCHANGE LTD",
     "symbol": "SPXCF"
    },
    {
     "description": "SINGAPORE EXCHANGE-UNSP ADR",
     "symbol": "SPXCY"
    },
    {
     "description": "PROSHARES S&P 500 EX-ENERGY",
     "symbol": "SPXE"
    },
    {
     "description": "DIREXION DLY S&P 500 BULL 3X",
     "symbol": "SPXL"
    },
    {
     "description": "PROSHARES S&P 500 EX-FINANCI",
     "symbol": "SPXN"
    },
    {
     "description": "DIREXION DLY S&P 500 BEAR 3X",
     "symbol": "SPXS"
    },
    {
     "description": "SPIRAX-SARCO ENGINEERING PLC",
     "symbol": "SPXSF"
    },
    {
     "description": "SPIRAX-SARCO ENGIN-UNSP ADR",
     "symbol": "SPXSY"
    },
    {
     "description": "PROSHARES S&P 500 EX-TECHNOL",
     "symbol": "SPXT"
    },
    {
     "description": "PROSH ULTRAPRO SHORT S&P 500",
     "symbol": "SPXU"
    },
    {
     "description": "PROSHARES TRUST-S&P 500 EX-H",
     "symbol": "SPXV"
    },
    {
     "description": "NUVEEN S&P500 DYNAM OVERWR",
     "symbol": "SPXX"
    },
    {
     "description": "SPAREBANK 1 NORD-NORGE",
     "symbol": "SPXXF"
    },
    {
     "description": "MORGAN CREEK-EXOS SPAC ORGIN",
     "symbol": "SPXZ"
    },
    {
     "description": "SPDR S&P 500 ETF TRUST",
     "symbol": "SPY"
    },
    {
     "description": "SIMPLIFY US EQUITY PLUS CONV",
     "symbol": "SPYC"
    },
    {
     "description": "SPDR PORTFOLIO S&P 500 HIGH",
     "symbol": "SPYD"
    },
    {
     "description": "SPDR PORTFOLIO S&P 500 GROWT",
     "symbol": "SPYG"
    },
    {
     "description": "SPYR INC",
     "symbol": "SPYR"
    },
    {
     "description": "SPDR PORT S&P 500 VALUE",
     "symbol": "SPYV"
    },
    {
     "description": "SPDR S&P 500 FOSSIL FUEL RES",
     "symbol": "SPYX"
    },
    {
     "description": "SPOOZ INC",
     "symbol": "SPZI"
    },
    {
     "description": "SPRITZER BHD",
     "symbol": "SPZRF"
    },
    {
     "description": "BLOCK INC",
     "symbol": "SQ"
    },
    {
     "description": "SQUARE CHAIN CORP",
     "symbol": "SQCC"
    },
    {
     "description": "SUSQUEHANNA COMMUNITY FINANC",
     "symbol": "SQCF"
    },
    {
     "description": "LEADERSHARES EQUITY SKEW ETF",
     "symbol": "SQEW"
    },
    {
     "description": "PRESIDIO PROPERTY TRUST - A",
     "symbol": "SQFT"
    },
    {
     "description": "PRESIDIO PROPERTY TRUST",
     "symbol": "SQFTP"
    },
    {
     "description": "PRESIDIO PROPERTY TRST -CW27",
     "symbol": "SQFTW"
    },
    {
     "description": "SQI DIAGNOSTICS INC",
     "symbol": "SQIDF"
    },
    {
     "description": "SEQLL INC",
     "symbol": "SQL"
    },
    {
     "description": "SEQLL INC -CW26",
     "symbol": "SQLLW"
    },
    {
     "description": "LEGG MASON SMALL-CAP QUALITY",
     "symbol": "SQLV"
    },
    {
     "description": "QUIMICA Y MINERA CHIL-SP ADR",
     "symbol": "SQM"
    },
    {
     "description": "SQUARE ENIX HOLDINGS CO-ADR",
     "symbol": "SQNNY"
    },
    {
     "description": "SEQUANS COMMUNICATIONS-ADR",
     "symbol": "SQNS"
    },
    {
     "description": "SQUARE ENIX HOLDINGS CO LTD",
     "symbol": "SQNXF"
    },
    {
     "description": "PROSHARES ULTRAPRO SHORT QQQ",
     "symbol": "SQQQ"
    },
    {
     "description": "SQUARESPACE INC - CLASS A",
     "symbol": "SQSP"
    },
    {
     "description": "SQZ BIOTECHNOLOGIES CO",
     "symbol": "SQZ"
    },
    {
     "description": "SERICA ENERGY PLC",
     "symbol": "SQZZF"
    },
    {
     "description": "SPIRE INC",
     "symbol": "SR"
    },
    {
     "description": "SPIRE INC",
     "symbol": "SR.PRA"
    },
    {
     "description": "SPORTRADAR GROUP AG-A",
     "symbol": "SRAD"
    },
    {
     "description": "SANDFIRE RESOURCES AMERICA I",
     "symbol": "SRAFF"
    },
    {
     "description": "STADLER RAIL AG",
     "symbol": "SRAIF"
    },
    {
     "description": "SISRAM MEDICAL LTD",
     "symbol": "SRAMF"
    },
    {
     "description": "SRISAWAD CORP PCL-ADR",
     "symbol": "SRAWY"
    },
    {
     "description": "SRAX INC",
     "symbol": "SRAX"
    },
    {
     "description": "VPN TECHNOLOGIES INC",
     "symbol": "SRBBF"
    },
    {
     "description": "SIRONA BIOCHEM CORP",
     "symbol": "SRBCF"
    },
    {
     "description": "SES IMAGOTAG",
     "symbol": "SRBEF"
    },
    {
     "description": "SERABI GOLD PLC",
     "symbol": "SRBIF"
    },
    {
     "description": "SHANRONG BIOTECHNOLOGY CORP",
     "symbol": "SRBT"
    },
    {
     "description": "STRATEC SE",
     "symbol": "SRBZF"
    },
    {
     "description": "SPIRIT REALTY CAPITAL INC",
     "symbol": "SRC"
    },
    {
     "description": "SPIRIT REALTY CAPITAL IN",
     "symbol": "SRC.PRA"
    },
    {
     "description": "STRIA LITHIUM INC",
     "symbol": "SRCAF"
    },
    {
     "description": "1ST SOURCE CORP",
     "symbol": "SRCE"
    },
    {
     "description": "SPRUCE RIDGE RES LTD",
     "symbol": "SRCGF"
    },
    {
     "description": "SEARCHLIGHT MINERALS CORP",
     "symbol": "SRCH"
    },
    {
     "description": "STERICYCLE INC",
     "symbol": "SRCL"
    },
    {
     "description": "SPARTA COMMERCIAL SERVICES I",
     "symbol": "SRCO"
    },
    {
     "description": "SHERWOOD CORP PCL-FOREIGN",
     "symbol": "SRCPF"
    },
    {
     "description": "SCORPIO GOLD CORP",
     "symbol": "SRCRF"
    },
    {
     "description": "Spire Inc",
     "symbol": "SRCU"
    },
    {
     "description": "STONEBRIDGE RESOURCES EXPLOR",
     "symbol": "SRCX"
    },
    {
     "description": "SURMODICS INC",
     "symbol": "SRDX"
    },
    {
     "description": "SEMPRA ENERGY",
     "symbol": "SRE"
    },
    {
     "description": "SEMPRA ENERGY",
     "symbol": "SREA"
    },
    {
     "description": "STOREBRAND ASA",
     "symbol": "SREDF"
    },
    {
     "description": "STOREBRAND ASA-UNSPON ADR",
     "symbol": "SREDY"
    },
    {
     "description": "SUNRISE ENERGY METALS LTD",
     "symbol": "SREMF"
    },
    {
     "description": "GLOBAL X SUPERDIVIDEND REIT",
     "symbol": "SRET"
    },
    {
     "description": "SERVICESOURCE INTERNATIONAL",
     "symbol": "SREV"
    },
    {
     "description": "SERITAGE GROWTH PROP- A REIT",
     "symbol": "SRG"
    },
    {
     "description": "SERITAGE GROWTH PROPERT",
     "symbol": "SRG.PRA"
    },
    {
     "description": "SURGALIGN HOLDINGS INC",
     "symbol": "SRGA"
    },
    {
     "description": "SURUGA BANK LTD",
     "symbol": "SRGBF"
    },
    {
     "description": "SOUTHRIDGE ENTERPRISES INC",
     "symbol": "SRGE"
    },
    {
     "description": "SRG GLOBAL LTD",
     "symbol": "SRGGF"
    },
    {
     "description": "SHOPRITE HOLDINGS-SPN ADR",
     "symbol": "SRGHY"
    },
    {
     "description": "SRG MINING INC",
     "symbol": "SRGMF"
    },
    {
     "description": "SRI TRANG AGRO-INDS PCL-NVDR",
     "symbol": "SRGPF"
    },
    {
     "description": "SUNPOWER GROUP LTD",
     "symbol": "SRGRF"
    },
    {
     "description": "SURGE COPPER CORP",
     "symbol": "SRGXF"
    },
    {
     "description": "STAR GOLD CORP",
     "symbol": "SRGZ"
    },
    {
     "description": "STARHUB LTD",
     "symbol": "SRHBF"
    },
    {
     "description": "STARHUB LTD-UNSPONSORED ADR",
     "symbol": "SRHBY"
    },
    {
     "description": "SHOPRITE HOLDINGS LTD",
     "symbol": "SRHGF"
    },
    {
     "description": "SYRAH RESOURCES LTD-SPON ADR",
     "symbol": "SRHYY"
    },
    {
     "description": "STONERIDGE INC",
     "symbol": "SRI"
    },
    {
     "description": "SPEAKING ROSES INTERNATIONAL",
     "symbol": "SRII"
    },
    {
     "description": "SORIANO (A) CORP",
     "symbol": "SRIOF"
    },
    {
     "description": "SKY GOLD CORP",
     "symbol": "SRKZF"
    },
    {
     "description": "SCULLY ROYALTY LTD",
     "symbol": "SRL"
    },
    {
     "description": "SPDR BLACKSTONE SENIOR LOAN",
     "symbol": "SRLN"
    },
    {
     "description": "SPRAGUE RESOURCES LP",
     "symbol": "SRLP"
    },
    {
     "description": "SEAFIELD RESOURCES LTD",
     "symbol": "SRLTF"
    },
    {
     "description": "SOUTHERN REALTY CO",
     "symbol": "SRLY"
    },
    {
     "description": "SALAZAR RESOURCES LTD",
     "symbol": "SRLZF"
    },
    {
     "description": "SPAREBANK 1 SMN",
     "symbol": "SRMGF"
    },
    {
     "description": "INVESCO MORNINGSTAR MLP DIST",
     "symbol": "SRMKF"
    },
    {
     "description": "SARAMA RESOURCES LTD",
     "symbol": "SRMMF"
    },
    {
     "description": "SADDLE RANCH MEDIA INC",
     "symbol": "SRMX"
    },
    {
     "description": "SORRENTO THERAPEUTICS INC",
     "symbol": "SRNE"
    },
    {
     "description": "SOUTHERN BANC COMPANY INC",
     "symbol": "SRNN"
    },
    {
     "description": "STRATOS RENEWABLES CORP",
     "symbol": "SRNW"
    },
    {
     "description": "SOURCENEXT CORP",
     "symbol": "SRNXF"
    },
    {
     "description": "SAILFISH ROYALTY CORP",
     "symbol": "SROYF"
    },
    {
     "description": "STARTS PROCEED INVESTMENT CO",
     "symbol": "SRPIF"
    },
    {
     "description": "SAREPTA THERAPEUTICS INC",
     "symbol": "SRPT"
    },
    {
     "description": "SCORPEX INC",
     "symbol": "SRPX"
    },
    {
     "description": "SIERRA ONCOLOGY INC",
     "symbol": "SRRA"
    },
    {
     "description": "SUNRISE REAL ESTATE GROUP",
     "symbol": "SRRE"
    },
    {
     "description": "SCHOLAR ROCK HOLDING CORP",
     "symbol": "SRRK"
    },
    {
     "description": "SIRIUS REAL ESTATE LTD",
     "symbol": "SRRLF"
    },
    {
     "description": "SHAGRIR GROUP VEHICLE SERVIC",
     "symbol": "SRRPF"
    },
    {
     "description": "SLATE GROCERY REIT-CL U",
     "symbol": "SRRTF"
    },
    {
     "description": "PROSHARES ULTRASHORT RE",
     "symbol": "SRS"
    },
    {
     "description": "SARISSA CAPITAL ACQUISITI-A",
     "symbol": "SRSA"
    },
    {
     "description": "SARISSA CAPITAL ACQUISITION",
     "symbol": "SRSAU"
    },
    {
     "description": "SARISSA CAPITAL ACQUI -CW27",
     "symbol": "SRSAW"
    },
    {
     "description": "SEARS CANADA INC",
     "symbol": "SRSCQ"
    },
    {
     "description": "SPIRITS TIME INTERNATIONAL I",
     "symbol": "SRSG"
    },
    {
     "description": "STRATECO RESOURCES INC",
     "symbol": "SRSIF"
    },
    {
     "description": "STAR STRUCK LTD",
     "symbol": "SRSK"
    },
    {
     "description": "STRATEGIC RESOURCES INTERNAT",
     "symbol": "SRSN"
    },
    {
     "description": "SARISSA RESOURCES INC",
     "symbol": "SRSR"
    },
    {
     "description": "S2 RESOURCES LTD",
     "symbol": "SRSSF"
    },
    {
     "description": "STARTEK INC",
     "symbol": "SRT"
    },
    {
     "description": "SARTORIUS STEDIM-UNSP ADR",
     "symbol": "SRTOY"
    },
    {
     "description": "SENSUS HEALTHCARE INC",
     "symbol": "SRTS"
    },
    {
     "description": "SARANTIS SA",
     "symbol": "SRTSF"
    },
    {
     "description": "ZOZO INC -UNSP ADR",
     "symbol": "SRTTY"
    },
    {
     "description": "PROSHARES ULTRAPRO SHRT R2K",
     "symbol": "SRTY"
    },
    {
     "description": "STRATUS CAPITAL CORP",
     "symbol": "SRUS"
    },
    {
     "description": "SPROUTLY CANADA INC",
     "symbol": "SRUTF"
    },
    {
     "description": "SPROTT PHYSICAL URANIUM TRUS",
     "symbol": "SRUUF"
    },
    {
     "description": "CUSHING MLP & INFRASTRUCTURE",
     "symbol": "SRV"
    },
    {
     "description": "PACER BENCHMARK DATA INFRA",
     "symbol": "SRVR"
    },
    {
     "description": "STAR VAULT AB-B SHS",
     "symbol": "SRVTF"
    },
    {
     "description": "SOLARWORLD AG",
     "symbol": "SRWRF"
    },
    {
     "description": "ISHARES MSCI WORLD SRI-USD-D",
     "symbol": "SRXIF"
    },
    {
     "description": "SPARX GROUP CO LTD",
     "symbol": "SRXXF"
    },
    {
     "description": "SURREY BANCORP",
     "symbol": "SRYB"
    },
    {
     "description": "SURROZEN INC",
     "symbol": "SRZN"
    },
    {
     "description": "SURROZEN INC-CW25",
     "symbol": "SRZNW"
    },
    {
     "description": "SCIENCE STRATEGIC ACQUISIT-A",
     "symbol": "SSAA"
    },
    {
     "description": "SSAB AB-A SHARES",
     "symbol": "SSAAF"
    },
    {
     "description": "SCIENCE STRATEGIC ACQUISITIO",
     "symbol": "SSAAU"
    },
    {
     "description": "SCIENCE STRATEGIC A -CW27",
     "symbol": "SSAAW"
    },
    {
     "description": "SSAB AB-A SHARES-UNSPON ADR",
     "symbol": "SSAAY"
    },
    {
     "description": "SOUTHSTATE CORP",
     "symbol": "SSB"
    },
    {
     "description": "SPDR BBG US TIPS",
     "symbol": "SSBBF"
    },
    {
     "description": "SUMMIT STATE BANK",
     "symbol": "SSBI"
    },
    {
     "description": "SOUTHERN STATES BANCSHARES",
     "symbol": "SSBK"
    },
    {
     "description": "SSB BANCORP INC",
     "symbol": "SSBP"
    },
    {
     "description": "SPIRITS CAP CORP",
     "symbol": "SSCC"
    },
    {
     "description": "SPDR S&P US CON DIS SELECT",
     "symbol": "SSCDF"
    },
    {
     "description": "SMARTCOOL SYSTEMS INC",
     "symbol": "SSCFF"
    },
    {
     "description": "SMSA CRANE ACQUISITION CORP",
     "symbol": "SSCR"
    },
    {
     "description": "SIMPSON MANUFACTURING CO INC",
     "symbol": "SSD"
    },
    {
     "description": "SPDR ASIA DVD ARISTOCRATS",
     "symbol": "SSDEF"
    },
    {
     "description": "SHISEIDO CO LTD",
     "symbol": "SSDOF"
    },
    {
     "description": "SHISEIDO LTD-SPONSORED ADR",
     "symbol": "SSDOY"
    },
    {
     "description": "SPDR S&P 400 US MID CAP",
     "symbol": "SSDRF"
    },
    {
     "description": "SHENGSHI ELEVATOR INTERNATIO",
     "symbol": "SSDT"
    },
    {
     "description": "SILVER SPRUCE RESOURCES INC",
     "symbol": "SSEBF"
    },
    {
     "description": "SPDR US DIV ARISTOCRATS",
     "symbol": "SSEEF"
    },
    {
     "description": "SPDR S&P US HEALTH SELECT",
     "symbol": "SSEHF"
    },
    {
     "description": "SENESTECH INC-CW23",
     "symbol": "SSEHW"
    },
    {
     "description": "STARSTREAM ENTERTAINMENT INC",
     "symbol": "SSET"
    },
    {
     "description": "SPDR RUSSELL 2000 US S\/C",
     "symbol": "SSEUF"
    },
    {
     "description": "SPDR S&P US COMMS SELECT",
     "symbol": "SSEXF"
    },
    {
     "description": "SSE PLC",
     "symbol": "SSEZF"
    },
    {
     "description": "SSE PLC-SPN ADR",
     "symbol": "SSEZY"
    },
    {
     "description": "DAY HAG NED DVS RES S SEC FI",
     "symbol": "SSFI"
    },
    {
     "description": "SONASOFT CORP",
     "symbol": "SSFT"
    },
    {
     "description": "PROSHARES ULTSHRT SEMICONDUC",
     "symbol": "SSG"
    },
    {
     "description": "SPDR EM ASIA",
     "symbol": "SSGAF"
    },
    {
     "description": "SPDR BBG 1-3MO US TRES USDA",
     "symbol": "SSGBF"
    },
    {
     "description": "SPDR WORLD SMALL CAP",
     "symbol": "SSGEF"
    },
    {
     "description": "SPDR WORLD FINANCIALS",
     "symbol": "SSGFF"
    },
    {
     "description": "SPDR GLOBAL REAL ESTATE",
     "symbol": "SSGGF"
    },
    {
     "description": "SPDR MSCI WORLD COMMUNICATIO",
     "symbol": "SSGMF"
    },
    {
     "description": "STOP SLEEP GO INC",
     "symbol": "SSGOF"
    },
    {
     "description": "SPDR S&P US ENERGY SELECT",
     "symbol": "SSGUF"
    },
    {
     "description": "SPDR WORLD MATERIALS",
     "symbol": "SSGWF"
    },
    {
     "description": "SPDR S&P US INDUST SELECT",
     "symbol": "SSGXF"
    },
    {
     "description": "SOUTHSHORE COMMUNITY BANK",
     "symbol": "SSHC"
    },
    {
     "description": "SENSHUKAI CO LTD",
     "symbol": "SSHKF"
    },
    {
     "description": "SUNAC SERVICES HOLDINGS LTD",
     "symbol": "SSHLF"
    },
    {
     "description": "VOW ASA",
     "symbol": "SSHPF"
    },
    {
     "description": "SSHT S&T GROUP LTD",
     "symbol": "SSHT"
    },
    {
     "description": "SPDR EUROPE HEALTH CARE",
     "symbol": "SSHXF"
    },
    {
     "description": "SILVER SPIKE INVESTMENT CORP",
     "symbol": "SSIC"
    },
    {
     "description": "SA SA INTERNATIONAL HLDGS",
     "symbol": "SSILF"
    },
    {
     "description": "STRATA SKIN SCIENCES INC",
     "symbol": "SSKN"
    },
    {
     "description": "SASOL LTD-SPONSORED ADR",
     "symbol": "SSL"
    },
    {
     "description": "SILTRONIC AG",
     "symbol": "SSLLF"
    },
    {
     "description": "SYNTAX STRATIFIED SMALLCAP",
     "symbol": "SSLY"
    },
    {
     "description": "SINOTRANS SHIPPING LTD",
     "symbol": "SSLYF"
    },
    {
     "description": "SOCIETA SPORTIVA LAZIO SPA",
     "symbol": "SSLZF"
    },
    {
     "description": "SANTOS LTD-SPONSORED ADR",
     "symbol": "SSLZY"
    },
    {
     "description": "SFC ENERGY AG-BR",
     "symbol": "SSMFF"
    },
    {
     "description": "SAMSUNG LIFE INSURANCE CO LT",
     "symbol": "SSMMF"
    },
    {
     "description": "SYSMEX CORP",
     "symbol": "SSMXF"
    },
    {
     "description": "SYSMEX CORP-UNSPON ADR",
     "symbol": "SSMXY"
    },
    {
     "description": "SS&C TECHNOLOGIES HOLDINGS",
     "symbol": "SSNC"
    },
    {
     "description": "SANSHIN ELECTRONICS CO LTD",
     "symbol": "SSNEF"
    },
    {
     "description": "SAISON INFORMATION SYSTEMS",
     "symbol": "SSNIF"
    },
    {
     "description": "SAMSUNG ELECTRONICS CO LTD",
     "symbol": "SSNLF"
    },
    {
     "description": "SAMSUNG ELECTRONICS-PREF",
     "symbol": "SSNNF"
    },
    {
     "description": "SILVERSUN TECHNOLOGIES INC",
     "symbol": "SSNT"
    },
    {
     "description": "PROSHARES ULTRA S&P500",
     "symbol": "SSO"
    },
    {
     "description": "SIXTY SIX OILFIELD SERV INC",
     "symbol": "SSOF"
    },
    {
     "description": "SUNSTOCK INC",
     "symbol": "SSOK"
    },
    {
     "description": "EW SCRIPPS CO\/THE-A",
     "symbol": "SSP"
    },
    {
     "description": "SIRIUSPOINT LTD-RIGHT",
     "symbol": "SSPCF"
    },
    {
     "description": "SSP GROUP PLC",
     "symbol": "SSPPF"
    },
    {
     "description": "JANUS HENDERSON US SUST EQTY",
     "symbol": "SSPX"
    },
    {
     "description": "SYNTAX STRATIFIED LARGE CAP",
     "symbol": "SSPY"
    },
    {
     "description": "Saturns Sears Roebuck Accep Corp",
     "symbol": "SSRAP"
    },
    {
     "description": "SENTISEARCH INC",
     "symbol": "SSRC"
    },
    {
     "description": "SWISS RE AG",
     "symbol": "SSREF"
    },
    {
     "description": "SWISS RE LTD-SPN ADR",
     "symbol": "SSREY"
    },
    {
     "description": "SSR MINING INC",
     "symbol": "SSRM"
    },
    {
     "description": "SILVER SANDS RESOURCES CORP",
     "symbol": "SSRSF"
    },
    {
     "description": "SHURGARD SELF STORAGE SA",
     "symbol": "SSSAF"
    },
    {
     "description": "SYSTEMATIC SAVINGS BANK",
     "symbol": "SSSB"
    },
    {
     "description": "SPDR S&P US FINANCIAL SELECT",
     "symbol": "SSSEF"
    },
    {
     "description": "SARTORIUS AG - ADR",
     "symbol": "SSSGY"
    },
    {
     "description": "SPDR S&P 500 UCITS ETF DIST",
     "symbol": "SSSPF"
    },
    {
     "description": "SURO CAPITAL CORP",
     "symbol": "SSSS"
    },
    {
     "description": "SURO CAPITAL CORP",
     "symbol": "SSSSL"
    },
    {
     "description": "SPDR EUROPE ENERGY",
     "symbol": "SSSXF"
    },
    {
     "description": "SYSTEM1 INC",
     "symbol": "SST"
    },
    {
     "description": "SYSTEM1 INC-CW",
     "symbol": "SST.WS"
    },
    {
     "description": "SIAM STEEL SERVICE CENTER",
     "symbol": "SSTEF"
    },
    {
     "description": "SHOTSPOTTER INC",
     "symbol": "SSTI"
    },
    {
     "description": "SHUTTERSTOCK INC",
     "symbol": "SSTK"
    },
    {
     "description": "SILVERSTAR HOLDINGS LTD",
     "symbol": "SSTRF"
    },
    {
     "description": "SSTARTRADE TECH INC",
     "symbol": "SSTT"
    },
    {
     "description": "SANDY STEELE UNLIMITED INC",
     "symbol": "SSTU"
    },
    {
     "description": "STRAITS TRADING CO LTD",
     "symbol": "SSTVF"
    },
    {
     "description": "SURE TRACE SECURITY CORP",
     "symbol": "SSTY"
    },
    {
     "description": "SIGNA SPORTS UNITED NV",
     "symbol": "SSU"
    },
    {
     "description": "SIGNA SPORTS UNITED BV-WRNT",
     "symbol": "SSU.WS"
    },
    {
     "description": "SUMITOMO CORP",
     "symbol": "SSUMF"
    },
    {
     "description": "SUMITOMO CORP-SPON ADR",
     "symbol": "SSUMY"
    },
    {
     "description": "STATSURE DIAGNOSTIC SYSTEMS",
     "symbol": "SSUR"
    },
    {
     "description": "DAY HAGAN\/NED DAVIS RESEARCH",
     "symbol": "SSUS"
    },
    {
     "description": "SECURED SERVICES INC",
     "symbol": "SSVC"
    },
    {
     "description": "SOUTHERN SILVER EXPLORATION",
     "symbol": "SSVFF"
    },
    {
     "description": "SUMMA SILVER CORP",
     "symbol": "SSVRF"
    },
    {
     "description": "SPDR MSCI WORLD ACC",
     "symbol": "SSWRF"
    },
    {
     "description": "SUNLINK HEALTH SYSTEMS INC",
     "symbol": "SSY"
    },
    {
     "description": "SENSYNE HEALTH PLC",
     "symbol": "SSYNF"
    },
    {
     "description": "SASSY RESOURCES CORP",
     "symbol": "SSYRF"
    },
    {
     "description": "STRATASYS LTD",
     "symbol": "SSYS"
    },
    {
     "description": "SENSATA TECHNOLOGIES HOLDING",
     "symbol": "ST"
    },
    {
     "description": "STAAR SURGICAL CO",
     "symbol": "STAA"
    },
    {
     "description": "STATERA BIOPHARMA INC",
     "symbol": "STAB"
    },
    {
     "description": "PORTEX MINERALS INC",
     "symbol": "STACF"
    },
    {
     "description": "STANLEY ELECTRIC CO LTD",
     "symbol": "STAEF"
    },
    {
     "description": "STAFFING 360 SOLUTIONS INC",
     "symbol": "STAF"
    },
    {
     "description": "STAG INDUSTRIAL INC",
     "symbol": "STAG"
    },
    {
     "description": "STRABAG AG",
     "symbol": "STAGF"
    },
    {
     "description": "STAR ALLIANCE INTERNATIONAL",
     "symbol": "STAL"
    },
    {
     "description": "SING TAO NEWS CORP LTD",
     "symbol": "STAOF"
    },
    {
     "description": "ISTAR INC",
     "symbol": "STAR"
    },
    {
     "description": "ISTAR INC",
     "symbol": "STAR.PRD"
    },
    {
     "description": "ISTAR INC",
     "symbol": "STAR.PRG"
    },
    {
     "description": "ISTAR INC",
     "symbol": "STAR.PRI"
    },
    {
     "description": "STAR NUTRITION INC",
     "symbol": "STAU"
    },
    {
     "description": "S & T BANCORP INC",
     "symbol": "STBA"
    },
    {
     "description": "STRABAG SE-BR",
     "symbol": "STBBF"
    },
    {
     "description": "STARBREEZE AB",
     "symbol": "STBEF"
    },
    {
     "description": "SUNTORY BEVERAGE & FOOD LTD",
     "symbol": "STBFF"
    },
    {
     "description": "SUNTORY BEVERAGE & FOOD-UADR",
     "symbol": "STBFY"
    },
    {
     "description": "STURGIS BANCORP INC",
     "symbol": "STBI"
    },
    {
     "description": "STUDIO BANK",
     "symbol": "STBK"
    },
    {
     "description": "DRIVEWEALTH STEADY SAVER ETF",
     "symbol": "STBL"
    },
    {
     "description": "ST BARBARA LTD",
     "symbol": "STBMF"
    },
    {
     "description": "ST BARBARA LTD-SP ADR",
     "symbol": "STBMY"
    },
    {
     "description": "STRATEGIC GLOBAL INVESTMENTS",
     "symbol": "STBV"
    },
    {
     "description": "STEWART INFORMATION SERVICES",
     "symbol": "STC"
    },
    {
     "description": "STARCO BRANDS INC",
     "symbol": "STCB"
    },
    {
     "description": "STERLING CONSOLIDATED CORP",
     "symbol": "STCC"
    },
    {
     "description": "SURGE TECHNOLOGIES INC",
     "symbol": "STCI"
    },
    {
     "description": "STEEL CONNECT INC",
     "symbol": "STCN"
    },
    {
     "description": "STRATOCOMM CORP",
     "symbol": "STCO"
    },
    {
     "description": "SELLA CAPITAL REAL ESTATE LT",
     "symbol": "STCPF"
    },
    {
     "description": "SEERTECH CORP",
     "symbol": "STCRQ"
    },
    {
     "description": "STADA ARZNEIMITTEL AG",
     "symbol": "STDAF"
    },
    {
     "description": "STANDARD ENERGY CORP",
     "symbol": "STDE"
    },
    {
     "description": "STERIS PLC",
     "symbol": "STE"
    },
    {
     "description": "STREAM MEDIA CORP",
     "symbol": "STEAF"
    },
    {
     "description": "SCATEC ASA",
     "symbol": "STECF"
    },
    {
     "description": "STEMTECH CORP",
     "symbol": "STEK"
    },
    {
     "description": "STEM INC",
     "symbol": "STEM"
    },
    {
     "description": "STEPSTONE GROUP INC-CLASS A",
     "symbol": "STEP"
    },
    {
     "description": "STERLING CHECK CORP",
     "symbol": "STER"
    },
    {
     "description": "ST ENERGY TRANSITION I LTD",
     "symbol": "STET"
    },
    {
     "description": "ST ENERGY TRANSITION I LTD",
     "symbol": "STET.U"
    },
    {
     "description": "ST ENERGY TRANSITION I-CW23",
     "symbol": "STET.WS"
    },
    {
     "description": "STEVIA CORP",
     "symbol": "STEV"
    },
    {
     "description": "SRH TOTAL RETURN FUND INC",
     "symbol": "STEW"
    },
    {
     "description": "STEADFAST APARTMENT REIT INC",
     "symbol": "STFR"
    },
    {
     "description": "SUNLANDS TECHNOLOGY- SP ADR",
     "symbol": "STG"
    },
    {
     "description": "AFENTRA PLC",
     "symbol": "STGAF"
    },
    {
     "description": "STARTENGINE CROWDFUNDING INC",
     "symbol": "STGC"
    },
    {
     "description": "STONE GOLD INC",
     "symbol": "STGDF"
    },
    {
     "description": "STARTENGINE COLLECT-MBP UNIT",
     "symbol": "STGES"
    },
    {
     "description": "STG GROUP INC",
     "symbol": "STGGQ"
    },
    {
     "description": "SCENTRE GROUP",
     "symbol": "STGPF"
    },
    {
     "description": "STRAKER TRANSLATIONS LTD",
     "symbol": "STGRF"
    },
    {
     "description": "STAGWELL INC",
     "symbol": "STGW"
    },
    {
     "description": "SMARTGROUP CORP LTD",
     "symbol": "STGXF"
    },
    {
     "description": "STINGRAY GROUP INC",
     "symbol": "STGYF"
    },
    {
     "description": "STARGAZE ENTERTAINMENT GROUP",
     "symbol": "STGZ"
    },
    {
     "description": "SOUTHCORP CAPITAL INC",
     "symbol": "STHC"
    },
    {
     "description": "STELMINE CANADA LTD",
     "symbol": "STHFF"
    },
    {
     "description": "STEINHOFF INTERNATIONAL H NV",
     "symbol": "STHHF"
    },
    {
     "description": "SPROUT TINY HOMES INC",
     "symbol": "STHI"
    },
    {
     "description": "STEARNS HOLDINGS LLC -CW27",
     "symbol": "STHLW"
    },
    {
     "description": "SANTARO INTERACTIVE ENTERTAI",
     "symbol": "STIE"
    },
    {
     "description": "NEURONETICS INC",
     "symbol": "STIM"
    },
    {
     "description": "SMITHSON INVESTMENT TRUST",
     "symbol": "STINF"
    },
    {
     "description": "ISHARES 0-5 YEAR TIPS BOND E",
     "symbol": "STIP"
    },
    {
     "description": "ST JOSEPH INC",
     "symbol": "STJO"
    },
    {
     "description": "ST JAMES'S PLACE PLC",
     "symbol": "STJPF"
    },
    {
     "description": "COLUMBIA SELIG PREM TECH GW",
     "symbol": "STK"
    },
    {
     "description": "STOCKLAND",
     "symbol": "STKAF"
    },
    {
     "description": "STRIKE ENERGY LTD",
     "symbol": "STKKF"
    },
    {
     "description": "SUNOPTA INC",
     "symbol": "STKL"
    },
    {
     "description": "SOTKAMO SILVER AB",
     "symbol": "STKMF"
    },
    {
     "description": "ONE GROUP HOSPITALITY INC\/TH",
     "symbol": "STKS"
    },
    {
     "description": "STRIKEPOINT GOLD INC",
     "symbol": "STKXF"
    },
    {
     "description": "STELLANTIS NV",
     "symbol": "STLA"
    },
    {
     "description": "STERLING BUSINESS SOLUTIONS",
     "symbol": "STLB"
    },
    {
     "description": "STEEL DYNAMICS INC",
     "symbol": "STLD"
    },
    {
     "description": "STILLFRONT GROUP AB",
     "symbol": "STLFF"
    },
    {
     "description": "ISHARES FACTORS US GWTH STYL",
     "symbol": "STLG"
    },
    {
     "description": "STELLA-JONES INC",
     "symbol": "STLJF"
    },
    {
     "description": "ST ELMO SILVER MINES CORP",
     "symbol": "STLM"
    },
    {
     "description": "ISHARES FACTORS US VAL STYLE",
     "symbol": "STLV"
    },
    {
     "description": "STELLAR AFRICAGOLD INC",
     "symbol": "STLXF"
    },
    {
     "description": "HG HOLDINGS INC",
     "symbol": "STLY"
    },
    {
     "description": "STMICROELECTRONICS NV-NY SHS",
     "symbol": "STM"
    },
    {
     "description": "STAR MICA HOLDINGS CO LTD",
     "symbol": "STMAF"
    },
    {
     "description": "STARTMONDAY TECHNOLOGY CORP",
     "symbol": "STMDF"
    },
    {
     "description": "STMICROELECTRONICS NV",
     "symbol": "STMEF"
    },
    {
     "description": "STAMPER OIL & GAS CORP",
     "symbol": "STMGF"
    },
    {
     "description": "STEM HOLDINGS INC",
     "symbol": "STMH"
    },
    {
     "description": "STEMCELL HOLDINGS INC",
     "symbol": "STMM"
    },
    {
     "description": "SUMITOMO METAL MINING CO LTD",
     "symbol": "STMNF"
    },
    {
     "description": "STANMORE RESOURCES LTD",
     "symbol": "STMRF"
    },
    {
     "description": "SCOTTISH MORTGAGE INV TR PLC",
     "symbol": "STMZF"
    },
    {
     "description": "STANTEC INC",
     "symbol": "STN"
    },
    {
     "description": "STANCE EQUITY ESG LRG CAP CO",
     "symbol": "STNC"
    },
    {
     "description": "Santander UK PLC",
     "symbol": "STNDF"
    },
    {
     "description": "STONECO LTD-A",
     "symbol": "STNE"
    },
    {
     "description": "SCORPIO TANKERS INC",
     "symbol": "STNG"
    },
    {
     "description": "STINGER RESOURCES INC",
     "symbol": "STNRF"
    },
    {
     "description": "STEVIA NUTRA CORP",
     "symbol": "STNT"
    },
    {
     "description": "STARTRONIX INTL INC",
     "symbol": "STNX"
    },
    {
     "description": "EQUINOR ASA",
     "symbol": "STOHF"
    },
    {
     "description": "STOKE THERAPEUTICS INC",
     "symbol": "STOK"
    },
    {
     "description": "STONEMOR INC",
     "symbol": "STON"
    },
    {
     "description": "STORE CAPITAL CORP",
     "symbol": "STOR"
    },
    {
     "description": "SANTOS LTD",
     "symbol": "STOSF"
    },
    {
     "description": "SPDR DL SHRT DURATION TR ETF",
     "symbol": "STOT"
    },
    {
     "description": "STEPPE GOLD LTD",
     "symbol": "STPGF"
    },
    {
     "description": "STELLA PHARMA CORP",
     "symbol": "STPHF"
    },
    {
     "description": "SOUTHERN PACIFIC RESOURCE CO",
     "symbol": "STPJF"
    },
    {
     "description": "INDUSTRIALS REIT LTD",
     "symbol": "STPRF"
    },
    {
     "description": "PIMCO 1-5 YEAR US TIPS INDEX",
     "symbol": "STPZ"
    },
    {
     "description": "STRATEGIC ACQUISITIONS (NEV)",
     "symbol": "STQN"
    },
    {
     "description": "STRANDLINE RESOURCES LTD",
     "symbol": "STQNF"
    },
    {
     "description": "STRATEGIC EDUCATION INC",
     "symbol": "STRA"
    },
    {
     "description": "STRASBAUGH INC",
     "symbol": "STRB"
    },
    {
     "description": "SARCOS TECHNOLOGY AND ROBOTI",
     "symbol": "STRC"
    },
    {
     "description": "ROTOR ACQUSIITION CL A-CW27",
     "symbol": "STRCW"
    },
    {
     "description": "SUPERNOVA PARTNERS ACQUISI-A",
     "symbol": "STRE"
    },
    {
     "description": "SUPERNOVA PARTNERS ACQUISITI",
     "symbol": "STRE.U"
    },
    {
     "description": "SUPERNOVA PARTNERSS -A -CW27",
     "symbol": "STRE.WS"
    },
    {
     "description": "STAR ROYALTIES LTD",
     "symbol": "STRFF"
    },
    {
     "description": "STARGUIDE GROUP INC",
     "symbol": "STRG"
    },
    {
     "description": "STAR8 CORP",
     "symbol": "STRH"
    },
    {
     "description": "STR HOLDINGS INC",
     "symbol": "STRI"
    },
    {
     "description": "STERLING CONSTRUCTION CO",
     "symbol": "STRL"
    },
    {
     "description": "STREAMLINE HEALTH SOLUTIONS",
     "symbol": "STRM"
    },
    {
     "description": "STRAN & CO INC",
     "symbol": "STRN"
    },
    {
     "description": "STRAN & CO -CW26",
     "symbol": "STRNW"
    },
    {
     "description": "SEVERN TRENT PL-SPON ADR",
     "symbol": "STRNY"
    },
    {
     "description": "SUTRO BIOPHARMA INC",
     "symbol": "STRO"
    },
    {
     "description": "STARR PEAK MINING LTD",
     "symbol": "STRPF"
    },
    {
     "description": "STAR EQUITY HOLDINGS INC",
     "symbol": "STRR"
    },
    {
     "description": "SATORI RESOURCES INC",
     "symbol": "STRRF"
    },
    {
     "description": "STAR EQUITY HOLDINGS INC",
     "symbol": "STRRP"
    },
    {
     "description": "STRATUS PROPERTIES INC",
     "symbol": "STRS"
    },
    {
     "description": "STRATTEC SECURITY CORP",
     "symbol": "STRT"
    },
    {
     "description": "STRATA-X ENERGY LTD",
     "symbol": "STRXF"
    },
    {
     "description": "STARRY GROUP HOLDINGS INC-A",
     "symbol": "STRY"
    },
    {
     "description": "STARRY GROUP HOLDINGS -CW25",
     "symbol": "STRY.WS"
    },
    {
     "description": "STORYTEL AB",
     "symbol": "STRYF"
    },
    {
     "description": "STAR BUFFET INC",
     "symbol": "STRZ"
    },
    {
     "description": "SATSUMA PHARMACEUTICALS INC",
     "symbol": "STSA"
    },
    {
     "description": "SOUTH STAR BATTERY METALS CO",
     "symbol": "STSBF"
    },
    {
     "description": "START SCIENTIFIC INC",
     "symbol": "STSC"
    },
    {
     "description": "STRATEC SE - UNSP ADR",
     "symbol": "STSEY"
    },
    {
     "description": "SMARTSTOP SELF STORAGE REI-A",
     "symbol": "STSFF"
    },
    {
     "description": "STS GROUP AG",
     "symbol": "STSGF"
    },
    {
     "description": "STEMSATION INTERNATIONAL INC",
     "symbol": "STSN"
    },
    {
     "description": "SHARPS TECHNOLOGY INC",
     "symbol": "STSS"
    },
    {
     "description": "SHARPS TECHNOLOGY INC -27",
     "symbol": "STSSW"
    },
    {
     "description": "STATE STREET CORP",
     "symbol": "STT"
    },
    {
     "description": "STATE STREET CORP",
     "symbol": "STT.PRD"
    },
    {
     "description": "STATE STREET CORP",
     "symbol": "STT.PRG"
    },
    {
     "description": "STANDARD URANIUM LTD",
     "symbol": "STTDF"
    },
    {
     "description": "SMARTONE TELECOMMUNICATIONS",
     "symbol": "STTFF"
    },
    {
     "description": "SHATTUCK LABS INC",
     "symbol": "STTK"
    },
    {
     "description": "STRUCTURAL MONITORING-CDI",
     "symbol": "STTLF"
    },
    {
     "description": "STRAITS TRADING CO-UNSP ADR",
     "symbol": "STTSY"
    },
    {
     "description": "SPLITIT PAYMENTS LTD",
     "symbol": "STTTF"
    },
    {
     "description": "STRATEX OIL & GAS HOLDINGS I",
     "symbol": "STTX"
    },
    {
     "description": "STI GROUP INC",
     "symbol": "STUO"
    },
    {
     "description": "STRAIGHTUP RESOURCES INC",
     "symbol": "STUPF"
    },
    {
     "description": "SPDR S&P\/ASX 200 LISTED PROP",
     "symbol": "STUUF"
    },
    {
     "description": "STEVVA CORP",
     "symbol": "STVA"
    },
    {
     "description": "NINE MILE METALS LTD",
     "symbol": "STVGF"
    },
    {
     "description": "STAVELY MINERALS LTD",
     "symbol": "STVMF"
    },
    {
     "description": "STEVANATO GROUP SPA",
     "symbol": "STVN"
    },
    {
     "description": "STWC HOLDINGS INC",
     "symbol": "STWC"
    },
    {
     "description": "STARWOOD PROPERTY TRUST INC",
     "symbol": "STWD"
    },
    {
     "description": "SOFTWARE AG-SPONSORED ADR",
     "symbol": "STWRY"
    },
    {
     "description": "SEAGATE TECHNOLOGY HOLDINGS",
     "symbol": "STX"
    },
    {
     "description": "SPDR S&P\/ASX 50 FUND",
     "symbol": "STXFF"
    },
    {
     "description": "STARREX INTERNATIONAL LTD",
     "symbol": "STXMF"
    },
    {
     "description": "STUHINI EXPLORATION LTD",
     "symbol": "STXPF"
    },
    {
     "description": "STEREOTAXIS INC",
     "symbol": "STXS"
    },
    {
     "description": "STRIX GROUP PLC",
     "symbol": "STXXF"
    },
    {
     "description": "SITOY GROUP HOLDINGS LTD",
     "symbol": "STYDF"
    },
    {
     "description": "STYLECLICK INC - CL A",
     "symbol": "STYLA"
    },
    {
     "description": "STINGER SYSTEMS INC",
     "symbol": "STYS"
    },
    {
     "description": "CONSTELLATION BRANDS INC-A",
     "symbol": "STZ"
    },
    {
     "description": "CONSTELLATION BRANDS INC-B",
     "symbol": "STZ.B"
    },
    {
     "description": "STELCO HOLDINGS INC",
     "symbol": "STZHF"
    },
    {
     "description": "SUN TZU CORP",
     "symbol": "STZU"
    },
    {
     "description": "SUNCOR ENERGY INC",
     "symbol": "SU"
    },
    {
     "description": "SHOULDERUP TECHNOLOGY ACQU-A",
     "symbol": "SUAC"
    },
    {
     "description": "SHOULDERUP TECHNOLOGY ACQUIS",
     "symbol": "SUAC.U"
    },
    {
     "description": "SHOULDERUP TECHNOLOGY -CW23",
     "symbol": "SUAC.WS"
    },
    {
     "description": "ISHARES SHORT-TERM NATIONAL",
     "symbol": "SUB"
    },
    {
     "description": "SUBURBAN MINERALS CORP",
     "symbol": "SUBB"
    },
    {
     "description": "SUBSEA 7 SA-SPON ADR",
     "symbol": "SUBCY"
    },
    {
     "description": "FOUNT SUBSCRIPTION ECONOMY",
     "symbol": "SUBS"
    },
    {
     "description": "Roundhill Streaming Services & Technology ETF",
     "symbol": "SUBZ"
    },
    {
     "description": "SUMITOMO OSAKA CEMENT CO LTD",
     "symbol": "SUCEF"
    },
    {
     "description": "SUEDZUCKER AG",
     "symbol": "SUEZF"
    },
    {
     "description": "SUEDZUCKER AG-UNSP ADR",
     "symbol": "SUEZY"
    },
    {
     "description": "OPHIR RESOURCES CO",
     "symbol": "SUFF"
    },
    {
     "description": "SURUGA BANK LTD-UNSPON ADR",
     "symbol": "SUGBY"
    },
    {
     "description": "SUGAR CREEK FINANCIAL CORP",
     "symbol": "SUGR"
    },
    {
     "description": "SURGICAL INNOVATIONS GROUP",
     "symbol": "SUGVF"
    },
    {
     "description": "SUN HUNG KAI PROPERTIES",
     "symbol": "SUHJF"
    },
    {
     "description": "SUN HUNG KAI PROP LTD-SP ADR",
     "symbol": "SUHJY"
    },
    {
     "description": "SUN COMMUNITIES INC",
     "symbol": "SUI"
    },
    {
     "description": "SINO UNITED WORLDWIDE CONSOL",
     "symbol": "SUIC"
    },
    {
     "description": "SUPERIOR MINING INTERNATIONA",
     "symbol": "SUIFF"
    },
    {
     "description": "ISHARES MSCI JAPAN SRI USD-A",
     "symbol": "SUJAF"
    },
    {
     "description": "SULLIDEN MINING CAPITAL INC",
     "symbol": "SULMF"
    },
    {
     "description": "SULZER AG-REG",
     "symbol": "SULZF"
    },
    {
     "description": "SUMMIT MATERIALS INC -CL A",
     "symbol": "SUM"
    },
    {
     "description": "SUMCO CORP",
     "symbol": "SUMCF"
    },
    {
     "description": "SUMMER ENERGY HOLDINGS INC",
     "symbol": "SUME"
    },
    {
     "description": "SUMO LOGIC INC",
     "symbol": "SUMO"
    },
    {
     "description": "SUMMER INFANT INC",
     "symbol": "SUMR"
    },
    {
     "description": "SUPREMEX INC",
     "symbol": "SUMXF"
    },
    {
     "description": "SUNOCO LP",
     "symbol": "SUN"
    },
    {
     "description": "SUNCAST SOLAR ENERGY INC",
     "symbol": "SUNC"
    },
    {
     "description": "SUNDANCE STRATEGIES INC",
     "symbol": "SUND"
    },
    {
     "description": "Sun Life Financial Inc",
     "symbol": "SUNFF"
    },
    {
     "description": "SUNLIGHT FINANCIAL HOLDINGS",
     "symbol": "SUNL"
    },
    {
     "description": "SPARTAN ACQUISIT II A -CW25",
     "symbol": "SUNL.WS"
    },
    {
     "description": "SUN PEAK METALS CORP",
     "symbol": "SUNPF"
    },
    {
     "description": "SUN SPORTS AND ENTERTAINMENT",
     "symbol": "SUNR"
    },
    {
     "description": "SUNCORP TECHNOLOGIES LTD",
     "symbol": "SUNTF"
    },
    {
     "description": "SUNWORKS INC",
     "symbol": "SUNW"
    },
    {
     "description": "SUNSHINE OILSANDS LTD",
     "symbol": "SUNYF"
    },
    {
     "description": "SUMCO CORP-UNSPON ADR",
     "symbol": "SUOPY"
    },
    {
     "description": "SUOXINDA HOLDINGS LTD",
     "symbol": "SUOXF"
    },
    {
     "description": "SUPERIOR INDUSTRIES INTL",
     "symbol": "SUP"
    },
    {
     "description": "SUPERBAG CO LTD",
     "symbol": "SUPBF"
    },
    {
     "description": "SUPALAI PCL-NVDR",
     "symbol": "SUPCF"
    },
    {
     "description": "SUPERIOR GOLD INC",
     "symbol": "SUPGF"
    },
    {
     "description": "SUPERMARKET INCOME REIT PLC",
     "symbol": "SUPIF"
    },
    {
     "description": "PROSHARES SUPPLY CHAIN LOGIS",
     "symbol": "SUPL"
    },
    {
     "description": "SUPERNUS PHARMACEUTICALS INC",
     "symbol": "SUPN"
    },
    {
     "description": "GRUPO SUPERVIELLE SA-SP ADR",
     "symbol": "SUPV"
    },
    {
     "description": "SUMITOMO REALTY & DEVELOPMEN",
     "symbol": "SURDF"
    },
    {
     "description": "SURFACE ONCOLOGY INC",
     "symbol": "SURF"
    },
    {
     "description": "SURGEPAYS INC",
     "symbol": "SURG"
    },
    {
     "description": "SURGEPAYS INC -CW24",
     "symbol": "SURGW"
    },
    {
     "description": "SUN ART RETAIL GROUP LTD",
     "symbol": "SURRF"
    },
    {
     "description": "SUN ART RETAIL GROUP-UNS ADR",
     "symbol": "SURRY"
    },
    {
     "description": "SUNTEC REIT",
     "symbol": "SURVF"
    },
    {
     "description": "ISHARES MSCI USA ESG SELECT",
     "symbol": "SUSA"
    },
    {
     "description": "ISHARES ESG AWARE 1-5 YEAR U",
     "symbol": "SUSB"
    },
    {
     "description": "ISHARES ESG AWARE USD CORPOR",
     "symbol": "SUSC"
    },
    {
     "description": "ISHARES ESG MSCI USA LEADERS",
     "symbol": "SUSL"
    },
    {
     "description": "ISHARES MSCI EM SRI UCITS",
     "symbol": "SUSMF"
    },
    {
     "description": "SURGICAL SCIENCE SWEDEN AB",
     "symbol": "SUSRF"
    },
    {
     "description": "SPDR S&P US TECH SELECT",
     "symbol": "SUSTF"
    },
    {
     "description": "INVESTIGATOR RESOURCES LTD",
     "symbol": "SUTAF"
    },
    {
     "description": "SUTIMCO INTERNATIONAL INC",
     "symbol": "SUTI"
    },
    {
     "description": "SUMITOMO MITSUI TR-SPON ADR",
     "symbol": "SUTNY"
    },
    {
     "description": "SUB-URBAN BRANDS INC",
     "symbol": "SUUB"
    },
    {
     "description": "STRATHMORE PLUS ENERGY CORP",
     "symbol": "SUUFF"
    },
    {
     "description": "SUPERIOR PLUS CORP",
     "symbol": "SUUIF"
    },
    {
     "description": "SARTORIUS AG-VORZUG",
     "symbol": "SUVPF"
    },
    {
     "description": "SUVANZA",
     "symbol": "SUVZ"
    },
    {
     "description": "SUNWIN STEVIA INTERNATIONAL",
     "symbol": "SUWN"
    },
    {
     "description": "SUN-WA TECHNOS CORP",
     "symbol": "SUWTF"
    },
    {
     "description": "SUZANO SA - SPON ADR",
     "symbol": "SUZ"
    },
    {
     "description": "SULZER AG-UNSPN ADR",
     "symbol": "SUZRY"
    },
    {
     "description": "SPRING VALLEY ACQUIS-CLASS A",
     "symbol": "SV"
    },
    {
     "description": "SINOVAC BIOTECH LTD",
     "symbol": "SVA"
    },
    {
     "description": "SILVERTON ADVENTURES INC",
     "symbol": "SVAD"
    },
    {
     "description": "ISHARES US SMALL CAP VAL FAC",
     "symbol": "SVAL"
    },
    {
     "description": "STANDARD VAPE CORP",
     "symbol": "SVAP"
    },
    {
     "description": "STORAGEVAULT CANADA INC",
     "symbol": "SVAUF"
    },
    {
     "description": "SVEDBERGS I DALSTORP AB-B SH",
     "symbol": "SVBDF"
    },
    {
     "description": "SILVER BULL RES INC",
     "symbol": "SVBL"
    },
    {
     "description": "SILVER BELT MINES INC",
     "symbol": "SVBM"
    },
    {
     "description": "SILVER BEAR RESOURCES PLC",
     "symbol": "SVBRF"
    },
    {
     "description": "SVB & T CORP",
     "symbol": "SVBT"
    },
    {
     "description": "SERVICE PROPERTIES TRUST",
     "symbol": "SVC"
    },
    {
     "description": "SVENSKA CELLULOSA AB SCA-B",
     "symbol": "SVCBF"
    },
    {
     "description": "SENVEST CAPITAL INC",
     "symbol": "SVCTF"
    },
    {
     "description": "SVF INVESTMENT CORP-CL A",
     "symbol": "SVFA"
    },
    {
     "description": "SVF INVESTMENT CORP",
     "symbol": "SVFAU"
    },
    {
     "description": "SVF INVESTMENT CL A -CW27",
     "symbol": "SVFAW"
    },
    {
     "description": "SVF INVESTMENT CORP 2-CLS A",
     "symbol": "SVFB"
    },
    {
     "description": "SVF INVESTMENT CORP 3-CLS A",
     "symbol": "SVFC"
    },
    {
     "description": "SAVE FOODS INC",
     "symbol": "SVFD"
    },
    {
     "description": "SILVER GRAIL RESOURCES LTD",
     "symbol": "SVGAF"
    },
    {
     "description": "SCHEID VINEYARDS INC-CLASS A",
     "symbol": "SVIN"
    },
    {
     "description": "SVI PCL-FOREIGN SHARE",
     "symbol": "SVIPF"
    },
    {
     "description": "-1 SHORT VIX FUTURES ETF",
     "symbol": "SVIX"
    },
    {
     "description": "SEVERSTAL-SPON 144A GDR",
     "symbol": "SVJTL"
    },
    {
     "description": "SEVERSTAL - GDR REG S",
     "symbol": "SVJTY"
    },
    {
     "description": "SKANDINAVISKA ENSKILDA BAN-A",
     "symbol": "SVKEF"
    },
    {
     "description": "SILVER LAKE RESOURCES LTD",
     "symbol": "SVLKF"
    },
    {
     "description": "SAVILLS PLC",
     "symbol": "SVLPF"
    },
    {
     "description": "SUNVAULT ENERGY INC",
     "symbol": "SVLT"
    },
    {
     "description": "SILVERCORP METALS INC",
     "symbol": "SVM"
    },
    {
     "description": "SAVMOBI TECHNOLOGY INC",
     "symbol": "SVMB"
    },
    {
     "description": "SILVER VALLEY METALS CORP",
     "symbol": "SVMFF"
    },
    {
     "description": "SOVEREIGN METALS LTD",
     "symbol": "SVMLF"
    },
    {
     "description": "SILVERORE MINES INC",
     "symbol": "SVMN"
    },
    {
     "description": "MAGNORA ASA",
     "symbol": "SVMRF"
    },
    {
     "description": "7 ACQUISITION CORP-A",
     "symbol": "SVNA"
    },
    {
     "description": "7 ACQUISITION CORP",
     "symbol": "SVNAU"
    },
    {
     "description": "7 ACQUISITION CORP-A -CW23",
     "symbol": "SVNAW"
    },
    {
     "description": "SEVEN BANK LTD-UNSPON ADR",
     "symbol": "SVNBY"
    },
    {
     "description": "SEVEN & I HOLDINGS CO LTD",
     "symbol": "SVNDF"
    },
    {
     "description": "SEVEN & I HOLDINGS-UNSPN ADR",
     "symbol": "SVNDY"
    },
    {
     "description": "727 COMMUNICATIONS INC",
     "symbol": "SVNJ"
    },
    {
     "description": "SVENSKA HANDELSBANKEN-A SHS",
     "symbol": "SVNLF"
    },
    {
     "description": "SVENSKA HANDELSB-A-UNSP ADR",
     "symbol": "SVNLY"
    },
    {
     "description": "SAVANNAH ENERGY PLC",
     "symbol": "SVNNF"
    },
    {
     "description": "79NORTH INC",
     "symbol": "SVNTF"
    },
    {
     "description": "SIMPLIFY VOLATILITY PREMIUM",
     "symbol": "SVOL"
    },
    {
     "description": "SUVO STRATEGIC MINERALS LTD",
     "symbol": "SVOSF"
    },
    {
     "description": "KIN AND CARTA PLC",
     "symbol": "SVPLF"
    },
    {
     "description": "SAVARA INC",
     "symbol": "SVRA"
    },
    {
     "description": "SAVERONE 2014 LTD -ADR",
     "symbol": "SVRE"
    },
    {
     "description": "SEVIER COUNTY BANCSHARES INC",
     "symbol": "SVRH"
    },
    {
     "description": "SILVER PREDATOR CORP",
     "symbol": "SVROF"
    },
    {
     "description": "SAVOREAT LTD",
     "symbol": "SVRTF"
    },
    {
     "description": "PURPOSE SILVER BULLION FUND",
     "symbol": "SVRZF"
    },
    {
     "description": "SILVER STAR ENERGY INC",
     "symbol": "SVSE"
    },
    {
     "description": "STEREO VISION ENTERTAIMENT",
     "symbol": "SVSN"
    },
    {
     "description": "SHEERVISION INC",
     "symbol": "SVSO"
    },
    {
     "description": "SPRING VALLEY ACQUISITION",
     "symbol": "SVSVU"
    },
    {
     "description": "SPRING VALLEY ACQ CL A -CW27",
     "symbol": "SVSVW"
    },
    {
     "description": "SERVOTRONICS INC",
     "symbol": "SVT"
    },
    {
     "description": "SERVICE TEAM INC",
     "symbol": "SVTE"
    },
    {
     "description": "SM INVESTMENTS CORP",
     "symbol": "SVTMF"
    },
    {
     "description": "SILVERTON METALS CORP",
     "symbol": "SVTNF"
    },
    {
     "description": "S-VENTURES PLC",
     "symbol": "SVTPF"
    },
    {
     "description": "SEVERN TRENT PLC",
     "symbol": "SVTRF"
    },
    {
     "description": "SAVI FINANCIAL CORP",
     "symbol": "SVVB"
    },
    {
     "description": "FIRSTHAND TECHNOLOGY VALUE",
     "symbol": "SVVC"
    },
    {
     "description": "SOVEREIGN EXPLORATION ASSOCI",
     "symbol": "SVXA"
    },
    {
     "description": "PROSHARES SHORT VIX ST FUTUR",
     "symbol": "SVXY"
    },
    {
     "description": "SOLVAY SA",
     "symbol": "SVYSF"
    },
    {
     "description": "SOFTWARE ACQUISITION GROUP-A",
     "symbol": "SWAG"
    },
    {
     "description": "SOFTWARE ACQUISITION GROUP I",
     "symbol": "SWAGU"
    },
    {
     "description": "SOFTWARE ACQ GROUP III -CW27",
     "symbol": "SWAGW"
    },
    {
     "description": "AMPLIFY BLACKSWAN GROWTH TSY",
     "symbol": "SWAN"
    },
    {
     "description": "DIREXION DAILY SOFT BULL 2X",
     "symbol": "SWAR"
    },
    {
     "description": "SHOCKWAVE MEDICAL INC",
     "symbol": "SWAV"
    },
    {
     "description": "SMITH & WESSON BRANDS INC",
     "symbol": "SWBI"
    },
    {
     "description": "SOUTHWEST CASINO CORP",
     "symbol": "SWCC"
    },
    {
     "description": "SWITCH INC - A",
     "symbol": "SWCH"
    },
    {
     "description": "SOFTWARE AG",
     "symbol": "SWDAF"
    },
    {
     "description": "SWEDBANK AB - A SHARES",
     "symbol": "SWDBF"
    },
    {
     "description": "SWEDBANK AB-ADR",
     "symbol": "SWDBY"
    },
    {
     "description": "SWEDENCARE AB",
     "symbol": "SWDCF"
    },
    {
     "description": "SKYWORTH GROUP LTD",
     "symbol": "SWDHF"
    },
    {
     "description": "SKYWORTH GROUP-UNSPON ADR",
     "symbol": "SWDHY"
    },
    {
     "description": "SWEEGEN INC",
     "symbol": "SWEE"
    },
    {
     "description": "ATHLON ACQUISITION CORP-A",
     "symbol": "SWET"
    },
    {
     "description": "ATHLON ACQUISITION CORP",
     "symbol": "SWETU"
    },
    {
     "description": "ATHLON ACQUISITION WTS-CW26",
     "symbol": "SWETW"
    },
    {
     "description": "SWATCH GROUP AG\/THE-BR",
     "symbol": "SWGAF"
    },
    {
     "description": "SWATCH GROUP AG\/THE-UNSP ADR",
     "symbol": "SWGAY"
    },
    {
     "description": "SAWAI GROUP HOLDINGS CO LTD",
     "symbol": "SWGHF"
    },
    {
     "description": "STAR WEALTH GROUP INC",
     "symbol": "SWGI"
    },
    {
     "description": "SWATCH GROUP AG\/THE-REG",
     "symbol": "SWGNF"
    },
    {
     "description": "SOLARWINDS CORP",
     "symbol": "SWI"
    },
    {
     "description": "LATHAM GROUP INC",
     "symbol": "SWIM"
    },
    {
     "description": "SOUTHWEST IOWA REN-UNIT CL A",
     "symbol": "SWIOU"
    },
    {
     "description": "SIERRA WIRELESS INC",
     "symbol": "SWIR"
    },
    {
     "description": "SEKUR PRIVATE DATA LTD",
     "symbol": "SWISF"
    },
    {
     "description": "STANLEY BLACK & DECKER INC",
     "symbol": "SWK"
    },
    {
     "description": "SWK HOLDINGS CORP",
     "symbol": "SWKH"
    },
    {
     "description": "SKYWORKS SOLUTIONS INC",
     "symbol": "SWKS"
    },
    {
     "description": "SILVER WOLF EXPLORATION LTD",
     "symbol": "SWLFF"
    },
    {
     "description": "SCHWEITZER-MAUDUIT INTL INC",
     "symbol": "SWM"
    },
    {
     "description": "SWEDISH MATCH AB",
     "symbol": "SWMAF"
    },
    {
     "description": "SWEDISH MATCH AB-UNSPON ADR",
     "symbol": "SWMAY"
    },
    {
     "description": "STARWIN MEDIA HOLDINGS INC",
     "symbol": "SWMD"
    },
    {
     "description": "SWARMIO MEDIA HOLDINGS INC",
     "symbol": "SWMIF"
    },
    {
     "description": "SOUTHWESTERN ENERGY CO",
     "symbol": "SWN"
    },
    {
     "description": "EDM RESOURCES INC",
     "symbol": "SWNLF"
    },
    {
     "description": "SOUTHWESTERN MEDICAL SOLUTIO",
     "symbol": "SWNM"
    },
    {
     "description": "SOFTWAREONE HOLDING AG",
     "symbol": "SWONF"
    },
    {
     "description": "SPDR WORLD HEALTH CARE",
     "symbol": "SWOOF"
    },
    {
     "description": "SWIRE PROPERTIES LTD",
     "symbol": "SWPFF"
    },
    {
     "description": "SWIRE PROPERTIES LTD-ADR",
     "symbol": "SWPLY"
    },
    {
     "description": "SWOOP HOLDINGS LTD",
     "symbol": "SWPPF"
    },
    {
     "description": "SWISS PRIME SITE-REG",
     "symbol": "SWPRF"
    },
    {
     "description": "SWISSQUOTE GROUP HOLDING-REG",
     "symbol": "SWQGF"
    },
    {
     "description": "SWIRE PACIFIC LTD - CL A",
     "symbol": "SWRAF"
    },
    {
     "description": "SWIRE PACIFIC LTD-SP ADR A",
     "symbol": "SWRAY"
    },
    {
     "description": "SWIRE PACIFIC LTD-CL B",
     "symbol": "SWRBF"
    },
    {
     "description": "SWIRE PACIFIC LTD-ADR B",
     "symbol": "SWRBY"
    },
    {
     "description": "SHIBUSAWA WAREHOUSE CO LTD",
     "symbol": "SWRHF"
    },
    {
     "description": "SEAWRIGHT HOLDINGS INC",
     "symbol": "SWRI"
    },
    {
     "description": "U-SWIRL INC",
     "symbol": "SWRL"
    },
    {
     "description": "APPSWARM INC",
     "symbol": "SWRM"
    },
    {
     "description": "SWISS LIFE HOLDING AG-REG",
     "symbol": "SWSDF"
    },
    {
     "description": "SPRINGWATER SPECIAL SITUATIO",
     "symbol": "SWSS"
    },
    {
     "description": "SWISS WATER DECAFFEINATED CO",
     "symbol": "SWSSF"
    },
    {
     "description": "SPRINGWATER SPECIAL SITUATIO",
     "symbol": "SWSSU"
    },
    {
     "description": "SPRINGWATER SPECIAL SIT-CW26",
     "symbol": "SWSSW"
    },
    {
     "description": "STANLEY BLACK & DECKER I",
     "symbol": "SWT"
    },
    {
     "description": "SPRINGWORKS THERAPEUTICS INC",
     "symbol": "SWTX"
    },
    {
     "description": "SWVL HOLDINGS CORP",
     "symbol": "SWVL"
    },
    {
     "description": "PIVOTAL HOLDINGS CORP -CW27",
     "symbol": "SWVLW"
    },
    {
     "description": "SIMON WORLDWIDE INC",
     "symbol": "SWWI"
    },
    {
     "description": "SOUTHWEST GAS HOLDINGS INC",
     "symbol": "SWX"
    },
    {
     "description": "SANOMA OYJ-UNSP ADR",
     "symbol": "SWYBY"
    },
    {
     "description": "STORNOWAY DIAMOND CORP",
     "symbol": "SWYDF"
    },
    {
     "description": "SWISS HELVETIA FUND",
     "symbol": "SWZ"
    },
    {
     "description": "SWISSCOM AG-REG",
     "symbol": "SWZCF"
    },
    {
     "description": "SCHWEIZERISCH NATIONALBA-REG",
     "symbol": "SWZNF"
    },
    {
     "description": "SUNCOKE ENERGY INC",
     "symbol": "SXC"
    },
    {
     "description": "ISHARES EURO STOXX BANKS 30-",
     "symbol": "SXERF"
    },
    {
     "description": "SONOMAX TECHNOLOGIES INC",
     "symbol": "SXHHF"
    },
    {
     "description": "STANDEX INTERNATIONAL CORP",
     "symbol": "SXI"
    },
    {
     "description": "SPDR S&P US MATERIALS SELECT",
     "symbol": "SXLBF"
    },
    {
     "description": "SIXTY NORTH GOLD MINING LTD",
     "symbol": "SXNTF"
    },
    {
     "description": "ST-GEORGES ECO-MINING CORP",
     "symbol": "SXOOF"
    },
    {
     "description": "SHANDONG XINHUA PHARMACEUT-H",
     "symbol": "SXPHF"
    },
    {
     "description": "ETC 6 MERIDIAN QUALITY GROWT",
     "symbol": "SXQG"
    },
    {
     "description": "SIOUX RIVER ET-CAP UNIT CL A",
     "symbol": "SXRIU"
    },
    {
     "description": "SENSIENT TECHNOLOGIES CORP",
     "symbol": "SXT"
    },
    {
     "description": "CHINA SXT PHARMACEUTICALS IN",
     "symbol": "SXTC"
    },
    {
     "description": "SITRONIX TECHNOLOGY CORP",
     "symbol": "SXTKF"
    },
    {
     "description": "JANUS HENDERSON INT SUSTAIN",
     "symbol": "SXUS"
    },
    {
     "description": "SIKA AG-BR-ADR",
     "symbol": "SXYAY"
    },
    {
     "description": "SO-YOUNG INTERNATIONAL-ADR",
     "symbol": "SY"
    },
    {
     "description": "SYRAH RESOURCES LTD",
     "symbol": "SYAAF"
    },
    {
     "description": "SYDBANK A\/S-UNSPONSORED ADR",
     "symbol": "SYANY"
    },
    {
     "description": "SAYONA MINING LTD",
     "symbol": "SYAXF"
    },
    {
     "description": "SYNTEC BIOFUEL INC",
     "symbol": "SYBF"
    },
    {
     "description": "SECURITY BANK CORP",
     "symbol": "SYBJF"
    },
    {
     "description": "SYNERGY BRANDS INC",
     "symbol": "SYBRQ"
    },
    {
     "description": "STOCK YARDS BANCORP INC",
     "symbol": "SYBT"
    },
    {
     "description": "SYNLOGIC INC",
     "symbol": "SYBX"
    },
    {
     "description": "SANYO CHEMICAL INDUSTRIES",
     "symbol": "SYCHF"
    },
    {
     "description": "SYNCORA HOLDINGS LTD",
     "symbol": "SYCRF"
    },
    {
     "description": "DELOTA CORP",
     "symbol": "SYDRF"
    },
    {
     "description": "SEYCHELLE ENVIRO TECH INC",
     "symbol": "SYEV"
    },
    {
     "description": "SYNCHRONY FINANCIAL",
     "symbol": "SYF"
    },
    {
     "description": "SYNCHRONY FINANCIAL",
     "symbol": "SYF.PRA"
    },
    {
     "description": "SYNAIRGEN PLC",
     "symbol": "SYGGF"
    },
    {
     "description": "SKYHARBOUR RESOURCES LTD",
     "symbol": "SYHBF"
    },
    {
     "description": "SYMPHONY HOLDINGS LTD",
     "symbol": "SYHLF"
    },
    {
     "description": "SYNTHOMER PLC-UN ADR",
     "symbol": "SYHMY"
    },
    {
     "description": "SYNERGIE WELLNESS PRODUCTS I",
     "symbol": "SYHO"
    },
    {
     "description": "SYMRISE AG",
     "symbol": "SYIEF"
    },
    {
     "description": "SYMRISE AG-UNSPON ADR",
     "symbol": "SYIEY"
    },
    {
     "description": "STRYKER CORP",
     "symbol": "SYK"
    },
    {
     "description": "SOLITON SYSTEMS KK",
     "symbol": "SYKKF"
    },
    {
     "description": "SKY NETWORK TELEVISION LTD",
     "symbol": "SYKWF"
    },
    {
     "description": "CAMBRIA SHAREHOLDER YIELD ET",
     "symbol": "SYLD"
    },
    {
     "description": "SYMBIO PHARMACEUTIC-SPON ADR",
     "symbol": "SYMQY"
    },
    {
     "description": "SYNTHETIC BIOLOGICS INC",
     "symbol": "SYN"
    },
    {
     "description": "SYNAPTICS INC",
     "symbol": "SYNA"
    },
    {
     "description": "SYNTHESIS ENERGY SYSTEMS INC",
     "symbol": "SYNE"
    },
    {
     "description": "SYNEOS HEALTH INC",
     "symbol": "SYNH"
    },
    {
     "description": "SYNVISTA THERAPEUTICS INC",
     "symbol": "SYNI"
    },
    {
     "description": "DAY TRADEXCHANGE INC",
     "symbol": "SYNJ"
    },
    {
     "description": "SYNALLOY CORP",
     "symbol": "SYNL"
    },
    {
     "description": "SYMPHONY INTERNATIONAL HOLDI",
     "symbol": "SYNNF"
    },
    {
     "description": "SANYO SPECIAL STEEL CO LTD",
     "symbol": "SYPLF"
    },
    {
     "description": "SYPRIS SOLUTIONS INC",
     "symbol": "SYPR"
    },
    {
     "description": "SCRYPT INC",
     "symbol": "SYPT"
    },
    {
     "description": "LIAONING SHUIYUN QINGHE RICE",
     "symbol": "SYQH"
    },
    {
     "description": "SYROS PHARMACEUTICALS INC",
     "symbol": "SYRS"
    },
    {
     "description": "SYROS PHARMACEUTICALS -CW22",
     "symbol": "SYRSW"
    },
    {
     "description": "SACYR SA",
     "symbol": "SYRVF"
    },
    {
     "description": "SYSOREX INC",
     "symbol": "SYSX"
    },
    {
     "description": "SIYATA MOBILE INC",
     "symbol": "SYTA"
    },
    {
     "description": "SIYATA MOBILE INC -CW25",
     "symbol": "SYTAW"
    },
    {
     "description": "ENTERPRISE DIVERSIFIED INC",
     "symbol": "SYTE"
    },
    {
     "description": "ANBC INC",
     "symbol": "SYUP"
    },
    {
     "description": "SYNTAX STRATIFIED US TOTAL M",
     "symbol": "SYUS"
    },
    {
     "description": "SYNOVICS PHARMACEUTICALS INC",
     "symbol": "SYVC"
    },
    {
     "description": "SYCAMORE VENTURES INC",
     "symbol": "SYVN"
    },
    {
     "description": "SYNNEX TECHNOLOGY INTL CORP",
     "symbol": "SYXTF"
    },
    {
     "description": "SYNODON INC - A",
     "symbol": "SYXXF"
    },
    {
     "description": "SYSCO CORP",
     "symbol": "SYY"
    },
    {
     "description": "SYN PROP E TECH SA-SP ADR",
     "symbol": "SYYNY"
    },
    {
     "description": "SYNTHOMER PLC",
     "symbol": "SYYYF"
    },
    {
     "description": "SYLOGIST LTD",
     "symbol": "SYZLF"
    },
    {
     "description": "CUSHING NEXTGEN INFRA INC",
     "symbol": "SZC"
    },
    {
     "description": "SCOR SE",
     "symbol": "SZCRF"
    },
    {
     "description": "DONGJIANG ENVIRONMENTAL-H",
     "symbol": "SZDEF"
    },
    {
     "description": "SEAZEN GROUP LTD",
     "symbol": "SZENF"
    },
    {
     "description": "SUEZ",
     "symbol": "SZEVF"
    },
    {
     "description": "SENZAGEN AB",
     "symbol": "SZGEF"
    },
    {
     "description": "SALZGITTER AG",
     "symbol": "SZGPF"
    },
    {
     "description": "SALZGITTER AG-UNSP ADR",
     "symbol": "SZGPY"
    },
    {
     "description": "SOJITZ CORP",
     "symbol": "SZHFF"
    },
    {
     "description": "SHENZHOU INTERNATIONAL GROUP",
     "symbol": "SZHIF"
    },
    {
     "description": "SHENZHEN INTL HOLDINGS",
     "symbol": "SZIHF"
    },
    {
     "description": "PROSHARES ULTSHRT CONS GOODS",
     "symbol": "SZK"
    },
    {
     "description": "SHIZUOKA BANK LTD\/THE",
     "symbol": "SZKBF"
    },
    {
     "description": "SUZUKI MOTOR CORP",
     "symbol": "SZKMF"
    },
    {
     "description": "SUZUKI MOTOR CORP-UNS ADR",
     "symbol": "SZKMY"
    },
    {
     "description": "SWISS LIFE HOLDING-UNSP ADR",
     "symbol": "SZLMY"
    },
    {
     "description": "STAGEZERO LIFE SCIENCES LTD",
     "symbol": "SZLSF"
    },
    {
     "description": "PACER CFRA STOVALL EQUAL",
     "symbol": "SZNE"
    },
    {
     "description": "SHENZHEN INVESTMENT LTD",
     "symbol": "SZNTF"
    },
    {
     "description": "DB CRUDE OIL SHORT EXCHANGE",
     "symbol": "SZOXF"
    },
    {
     "description": "SAIZEN REIT",
     "symbol": "SZRRF"
    },
    {
     "description": "SANTACRUZ SILVER MINING LTD",
     "symbol": "SZSMF"
    },
    {
     "description": "SHANDONG ZHOUYUAN SEED AND N",
     "symbol": "SZSN"
    },
    {
     "description": "SUZUKEN CO LTD",
     "symbol": "SZUKF"
    },
    {
     "description": "SIZZLE ACQUISITION CORP",
     "symbol": "SZZL"
    },
    {
     "description": "SIZZLE ACQUISITION CORP",
     "symbol": "SZZLU"
    },
    {
     "description": "SIZZLE ACQUISITION CORP-CW26",
     "symbol": "SZZLW"
    },
    {
     "description": "AT&T INC",
     "symbol": "T"
    },
    {
     "description": "AT&T INC",
     "symbol": "T.PRA"
    },
    {
     "description": "AT&T INC",
     "symbol": "T.PRC"
    },
    {
     "description": "AT&T Inc",
     "symbol": "T.WI"
    },
    {
     "description": "TRAVELCENTERS OF AMERICA INC",
     "symbol": "TA"
    },
    {
     "description": "TOMBAO ANTIQUES AND ART GROU",
     "symbol": "TAAI"
    },
    {
     "description": "TAAL DISTRIBUTED INFORMATION",
     "symbol": "TAALF"
    },
    {
     "description": "TABCORP HOLDINGS LTD",
     "symbol": "TABCF"
    },
    {
     "description": "TRANSALTA CORP",
     "symbol": "TAC"
    },
    {
     "description": "TREPONT ACQUISITION CORP I-A",
     "symbol": "TACA"
    },
    {
     "description": "TREPONT ACQUISITION CORP I",
     "symbol": "TACA.U"
    },
    {
     "description": "TREPONT ACQUISITION COR-CW26",
     "symbol": "TACA.WS"
    },
    {
     "description": "TABCORP HOLDINGS LTD-UNS ADR",
     "symbol": "TACBY"
    },
    {
     "description": "TRANSATLANTIC CAPITAL INC",
     "symbol": "TACI"
    },
    {
     "description": "TOTAL ACCESS COMM-FOREIGN",
     "symbol": "TACJF"
    },
    {
     "description": "FAIRLEAD TACTICAL SECTOR ETF",
     "symbol": "TACK"
    },
    {
     "description": "TRANSACT TECHNOLOGIES INC",
     "symbol": "TACT"
    },
    {
     "description": "TOTAL ACCESS COMM-UNSPON ADR",
     "symbol": "TACYY"
    },
    {
     "description": "TARSIER LTD",
     "symbol": "TAER"
    },
    {
     "description": "T ROWE PRICE QM US BOND ETF",
     "symbol": "TAGG"
    },
    {
     "description": "TAG IMMOBILIEN AG",
     "symbol": "TAGOF"
    },
    {
     "description": "TRISTAR ACQUISITION GROUP",
     "symbol": "TAGP"
    },
    {
     "description": "TEUCRIUM AGRICULTURAL FUND",
     "symbol": "TAGS"
    },
    {
     "description": "TANSEISHA CO LTD",
     "symbol": "TAHCF"
    },
    {
     "description": "TAHERA DIAMOND CORP",
     "symbol": "TAHEF"
    },
    {
     "description": "TAI HING GROUP HOLDINGS LTD",
     "symbol": "TAHIF"
    },
    {
     "description": "TRACKER FUND OF HONG KON-HKD",
     "symbol": "TAHKF"
    },
    {
     "description": "TAI CHEUNG HOLDINGS",
     "symbol": "TAICF"
    },
    {
     "description": "THAI OPTICAL GROUP PCL-NVDR",
     "symbol": "TAIGF"
    },
    {
     "description": "TAIHO KOGYO CO LTD",
     "symbol": "TAIHF"
    },
    {
     "description": "CAMBRIA TAIL RISK ETF",
     "symbol": "TAIL"
    },
    {
     "description": "TAIGA MOTORS CORP",
     "symbol": "TAIMF"
    },
    {
     "description": "TAISHO PHARMA HOLD UNSP- ADR",
     "symbol": "TAIPY"
    },
    {
     "description": "TAISHO PHARMACEUTICAL HOLDIN",
     "symbol": "TAISF"
    },
    {
     "description": "TAITRON COMPONENTS INC-CL A",
     "symbol": "TAIT"
    },
    {
     "description": "TAJIRI RESOURCES CORP",
     "symbol": "TAJIF"
    },
    {
     "description": "TAKEDA PHARMACEUTIC-SP ADR",
     "symbol": "TAK"
    },
    {
     "description": "TRANSAKT LTD",
     "symbol": "TAKD"
    },
    {
     "description": "TAKAMATSU CONSTRUCTION GROUP",
     "symbol": "TAKMF"
    },
    {
     "description": "DRONE DELIVERY CANADA CORP",
     "symbol": "TAKOF"
    },
    {
     "description": "TAL EDUCATION GROUP- ADR",
     "symbol": "TAL"
    },
    {
     "description": "TAL-CAP INC",
     "symbol": "TALC"
    },
    {
     "description": "TALKSPACE INC",
     "symbol": "TALK"
    },
    {
     "description": "HUDSON EXECUTIVE INV -CW25",
     "symbol": "TALKW"
    },
    {
     "description": "TALON INTERNATIONAL INC",
     "symbol": "TALN"
    },
    {
     "description": "TALOS ENERGY INC",
     "symbol": "TALO"
    },
    {
     "description": "TALARIS THERAPEUTICS INC",
     "symbol": "TALS"
    },
    {
     "description": "TRANSNATIONAL GROUP INC",
     "symbol": "TAMG"
    },
    {
     "description": "INVESCO SOLAR ETF",
     "symbol": "TAN"
    },
    {
     "description": "TANTECH HOLDINGS LTD",
     "symbol": "TANH"
    },
    {
     "description": "TRAVELCENTERS OF AMERICA",
     "symbol": "TANNI"
    },
    {
     "description": "TRAVELCENTERS OF AMERICA",
     "symbol": "TANNL"
    },
    {
     "description": "TRAVELCENTERS OF AMERICA",
     "symbol": "TANNZ"
    },
    {
     "description": "TANVEX BIOPHARMA INC",
     "symbol": "TANVF"
    },
    {
     "description": "IPERIONX LTD",
     "symbol": "TAOFF"
    },
    {
     "description": "TAG OIL LTD",
     "symbol": "TAOIF"
    },
    {
     "description": "TAOPING INC",
     "symbol": "TAOP"
    },
    {
     "description": "MOLSON COORS BEVERAGE CO - B",
     "symbol": "TAP"
    },
    {
     "description": "MOLSON COORS BEVERAGE CO - A",
     "symbol": "TAP.A"
    },
    {
     "description": "TAI PING CARPETS INTERNATION",
     "symbol": "TAPCF"
    },
    {
     "description": "TRIPUTRA AGRO PERSADA PT",
     "symbol": "TAPGF"
    },
    {
     "description": "TAPINATOR INC",
     "symbol": "TAPM"
    },
    {
     "description": "TAP RESOURCES INC",
     "symbol": "TAPP"
    },
    {
     "description": "TRAQER CORP",
     "symbol": "TAQR"
    },
    {
     "description": "PROTARA THERAPEUTIC INC",
     "symbol": "TARA"
    },
    {
     "description": "TARO PHARMACEUTICAL INDUS",
     "symbol": "TARO"
    },
    {
     "description": "TARSUS PHARMACEUTICALS INC",
     "symbol": "TARS"
    },
    {
     "description": "ALIANZA MINERALS LTD",
     "symbol": "TARSF"
    },
    {
     "description": "TASMAN RESOURCES LTD",
     "symbol": "TASEF"
    },
    {
     "description": "TASKUS INC-A",
     "symbol": "TASK"
    },
    {
     "description": "CARROLS RESTAURANT GROUP INC",
     "symbol": "TAST"
    },
    {
     "description": "TAS TECNOLOGIA AVANZATA",
     "symbol": "TASZF"
    },
    {
     "description": "TATYANA DESIGNS INC",
     "symbol": "TATD"
    },
    {
     "description": "TATA STEEL LIMITED -GDR REGS",
     "symbol": "TATLY"
    },
    {
     "description": "TAT TECHNOLOGIES LTD",
     "symbol": "TATT"
    },
    {
     "description": "TATE & LYLE PLC",
     "symbol": "TATYF"
    },
    {
     "description": "TATE & LYLE PLC-SPONS ADR",
     "symbol": "TATYY"
    },
    {
     "description": "TAURIGA SCIENCES INC",
     "symbol": "TAUG"
    },
    {
     "description": "TERRE AUX BOEUFS LTD",
     "symbol": "TAUX"
    },
    {
     "description": "TAV HAVALIMANLARI HOLDING AS",
     "symbol": "TAVHF"
    },
    {
     "description": "TAV HAVALIMANLARI HLD-UN ADR",
     "symbol": "TAVHY"
    },
    {
     "description": "TAVISTOCK INVESTMENTS PLC",
     "symbol": "TAVKF"
    },
    {
     "description": "THAI AIRWAYS INTL PCL-FOR",
     "symbol": "TAWNF"
    },
    {
     "description": "AMERICAN CENTURY DIVER MUNI",
     "symbol": "TAXF"
    },
    {
     "description": "TAYLOR DEVICES INC",
     "symbol": "TAYD"
    },
    {
     "description": "TAYLOR CONSULTING INC",
     "symbol": "TAYO"
    },
    {
     "description": "TRELLEBORG AB-B SHS",
     "symbol": "TBABF"
    },
    {
     "description": "TED BAKER PLC",
     "symbol": "TBAKF"
    },
    {
     "description": "AT&T INC",
     "symbol": "TBB"
    },
    {
     "description": "TEB BANCORP INC",
     "symbol": "TBBA"
    },
    {
     "description": "TRIAD BUSINESS BANK",
     "symbol": "TBBC"
    },
    {
     "description": "BANCORP INC\/THE",
     "symbol": "TBBK"
    },
    {
     "description": "AT&T INC",
     "symbol": "TBC"
    },
    {
     "description": "TBC BANK GROUP PLC",
     "symbol": "TBCCF"
    },
    {
     "description": "THUNDER BRIDGE CAPITAL PAR-A",
     "symbol": "TBCP"
    },
    {
     "description": "THUNDER BRIDGE CAPITAL PARTN",
     "symbol": "TBCPU"
    },
    {
     "description": "THUNDER BRIDGE CAP A -CW28",
     "symbol": "TBCPW"
    },
    {
     "description": "TIMBERCREEK FINANCIAL CORP",
     "symbol": "TBCRF"
    },
    {
     "description": "GORDON CREEK ENERGY INC",
     "symbol": "TBDYF"
    },
    {
     "description": "TIBET PHARMACEUTICALS INC",
     "symbol": "TBET"
    },
    {
     "description": "HIGH PERFORMANCE BEVERAGES C",
     "symbol": "TBEV"
    },
    {
     "description": "PROSHARES SHORT 20+ TREASURY",
     "symbol": "TBF"
    },
    {
     "description": "OXURION NV",
     "symbol": "TBGNF"
    },
    {
     "description": "TEMBO GOLD CORP",
     "symbol": "TBGPF"
    },
    {
     "description": "TRUEBLUE INC",
     "symbol": "TBI"
    },
    {
     "description": "TOBII AB",
     "symbol": "TBIIF"
    },
    {
     "description": "TRUSTBIX INC",
     "symbol": "TBIXF"
    },
    {
     "description": "INNOVATOR 20 YR T BOND 9 BUF",
     "symbol": "TBJL"
    },
    {
     "description": "TRIUMPH BANCORP INC",
     "symbol": "TBK"
    },
    {
     "description": "TRIUMPH BANCORP INC",
     "symbol": "TBKCP"
    },
    {
     "description": "TABOOLA.COM LTD",
     "symbol": "TBLA"
    },
    {
     "description": "TABOOLA.COM LTD -CW27",
     "symbol": "TBLAW"
    },
    {
     "description": "THORNBURG INCOME BUILDER OPP",
     "symbol": "TBLD"
    },
    {
     "description": "TOMBILL MINES LTD",
     "symbol": "TBLLF"
    },
    {
     "description": "TIGER BRANDS LTD",
     "symbol": "TBLMF"
    },
    {
     "description": "TIGER BRANDS LTD -SPONS ADR",
     "symbol": "TBLMY"
    },
    {
     "description": "TOUGHBUILT INDUSTRIES INC",
     "symbol": "TBLT"
    },
    {
     "description": "TOUGHBUILT INDUSTRIES-CW23",
     "symbol": "TBLTW"
    },
    {
     "description": "BIG TREE CARBON INC",
     "symbol": "TBMIF"
    },
    {
     "description": "BUKIT ASAM TBK PT - UNSP ADR",
     "symbol": "TBNGY"
    },
    {
     "description": "TERRITORIAL BANCORP INC",
     "symbol": "TBNK"
    },
    {
     "description": "TAMBORAN RESOURCES LTD",
     "symbol": "TBNRF"
    },
    {
     "description": "THERAVANCE BIOPHARMA INC",
     "symbol": "TBPH"
    },
    {
     "description": "TETRA BIO-PHARMA INC",
     "symbol": "TBPMF"
    },
    {
     "description": "THERMA BRIGHT INC",
     "symbol": "TBRIF"
    },
    {
     "description": "TB SA ACQUISITION CORP -A",
     "symbol": "TBSA"
    },
    {
     "description": "TB SA ACQUISITION CORP",
     "symbol": "TBSAU"
    },
    {
     "description": "TB SA ACQUISITION A -CW28",
     "symbol": "TBSAW"
    },
    {
     "description": "PROSHARES ULTRASHORT 20+Y TR",
     "symbol": "TBT"
    },
    {
     "description": "TABLE TRAC INC",
     "symbol": "TBTC"
    },
    {
     "description": "TWIN BUTTE ENERGY LTD",
     "symbol": "TBTEF"
    },
    {
     "description": "TUBI PTY LTD",
     "symbol": "TBUIF"
    },
    {
     "description": "TOBU RAILWAY CO LTD",
     "symbol": "TBURF"
    },
    {
     "description": "T ROWE PRICE ULTRA SHORT-TER",
     "symbol": "TBUX"
    },
    {
     "description": "THAI BEVERAGE PCL",
     "symbol": "TBVPF"
    },
    {
     "description": "THAI BEVERAGE PCL-UNSP ADR",
     "symbol": "TBVPY"
    },
    {
     "description": "PROSHARES SHORT 7-10 YR TSY",
     "symbol": "TBX"
    },
    {
     "description": "TURMALINA METALS CORP",
     "symbol": "TBXXF"
    },
    {
     "description": "TUANCHE LTD-ADR",
     "symbol": "TC"
    },
    {
     "description": "TUATARA CAPITAL ACQUISITIO-A",
     "symbol": "TCAC"
    },
    {
     "description": "TUATARA CAPITAL ACQUISITION",
     "symbol": "TCACU"
    },
    {
     "description": "TUATARA CAP ACQ CL A -CW27",
     "symbol": "TCACW"
    },
    {
     "description": "TC Energy Corporation",
     "symbol": "TCANF"
    },
    {
     "description": "TP ICAP GROUP PLC",
     "symbol": "TCAPF"
    },
    {
     "description": "TC BANCSHARES INC",
     "symbol": "TCBC"
    },
    {
     "description": "TEXAS CAPITAL BANCSHARES INC",
     "symbol": "TCBI"
    },
    {
     "description": "TEXAS CAPITAL BANCSHARES",
     "symbol": "TCBIO"
    },
    {
     "description": "TRICO BANCSHARES",
     "symbol": "TCBK"
    },
    {
     "description": "TC BIOPHARM HOLDINGS PLC-ADR",
     "symbol": "TCBP"
    },
    {
     "description": "TC BIOPHARM HOLDINGS LTD",
     "symbol": "TCBPW"
    },
    {
     "description": "TEXAS COMMUNITY BANCSHARES",
     "symbol": "TCBS"
    },
    {
     "description": "THIRD COAST BANCSHARES INC",
     "symbol": "TCBX"
    },
    {
     "description": "TECHNOGYM SPA",
     "symbol": "TCCHF"
    },
    {
     "description": "TECHNICAL COMMUNICATIONS",
     "symbol": "TCCO"
    },
    {
     "description": "TECHNOPRO HOLDINGS-SPON ADR",
     "symbol": "TCCPY"
    },
    {
     "description": "TRICIDA INC",
     "symbol": "TCDA"
    },
    {
     "description": "TRANSCOASTAL CORP",
     "symbol": "TCEC"
    },
    {
     "description": "TENCENT HOLDINGS LTD-UNS ADR",
     "symbol": "TCEHY"
    },
    {
     "description": "COMMUNITY FINANCIAL CORP\/THE",
     "symbol": "TCFC"
    },
    {
     "description": "TECAN GROUP AG-UNSP ADR",
     "symbol": "TCGGY"
    },
    {
     "description": "TECHNOLOGY GENERAL CORP",
     "symbol": "TCGN"
    },
    {
     "description": "TECAN GROUP AG-REG",
     "symbol": "TCHBF"
    },
    {
     "description": "TECH CENTRAL INC",
     "symbol": "TCHC"
    },
    {
     "description": "TIAN CHANG GROUP HOLDINGS",
     "symbol": "TCHGF"
    },
    {
     "description": "TRUSTCASH HOLDINGS INC",
     "symbol": "TCHH"
    },
    {
     "description": "ISHARES MSCI CHINA TECH",
     "symbol": "TCHI"
    },
    {
     "description": "T ROWE PRICE BLUE CHIP GROWT",
     "symbol": "TCHP"
    },
    {
     "description": "TRANSCONTINENTAL REALTY INV",
     "symbol": "TCI"
    },
    {
     "description": "TRACSIS PLC",
     "symbol": "TCIIF"
    },
    {
     "description": "TACHI-S CO LTD",
     "symbol": "TCISF"
    },
    {
     "description": "TECK RESOURCES LTD-CLS A",
     "symbol": "TCKRF"
    },
    {
     "description": "TRANSCONTINENTAL INC-CL A",
     "symbol": "TCLAF"
    },
    {
     "description": "TRANSCONTINENTAL INC-CL B",
     "symbol": "TCLCF"
    },
    {
     "description": "TCL ELECTRONICS HOLDINGS LTD",
     "symbol": "TCLHF"
    },
    {
     "description": "THERACLION",
     "symbol": "TCLIF"
    },
    {
     "description": "TECHNICOLOR-SPON ADR",
     "symbol": "TCLRY"
    },
    {
     "description": "TACTILE SYSTEMS TECHNOLOGY I",
     "symbol": "TCMD"
    },
    {
     "description": "TELECOM ARGENTINA S.A.-B",
     "symbol": "TCMFF"
    },
    {
     "description": "TRICON RESIDENTIAL INC",
     "symbol": "TCN"
    },
    {
     "description": "TRANSCANNA HOLDINGS INC",
     "symbol": "TCNAF"
    },
    {
     "description": "TOWN CENTER BANK\/IL",
     "symbol": "TCNB"
    },
    {
     "description": "TRULIEVE CANNABIS CORP",
     "symbol": "TCNNF"
    },
    {
     "description": "TOKYO CENTURY CORP",
     "symbol": "TCNRF"
    },
    {
     "description": "TOUCAN INTERACTIVE CORP",
     "symbol": "TCNT"
    },
    {
     "description": "TRULIEVE CANNABIS CORP -CW22",
     "symbol": "TCNWF"
    },
    {
     "description": "TRAJECTORY ALPHA ACQUISITI-A",
     "symbol": "TCOA"
    },
    {
     "description": "TRAJECTORY ALPHA ACQUISITION",
     "symbol": "TCOA.U"
    },
    {
     "description": "TRAJECTORY ALPHA ACQ A -CW27",
     "symbol": "TCOA.WS"
    },
    {
     "description": "TRIP.COM GROUP LTD-ADR",
     "symbol": "TCOM"
    },
    {
     "description": "TRACON PHARMACEUTICALS INC",
     "symbol": "TCON"
    },
    {
     "description": "TREECON RESOURCES INC",
     "symbol": "TCOR"
    },
    {
     "description": "BLACKROCK TCP CAPITAL CORP",
     "symbol": "TCPC"
    },
    {
     "description": "TRUE CORP PCL-FOREIGN",
     "symbol": "TCPFF"
    },
    {
     "description": "TICON PROPERTY FUND",
     "symbol": "TCPYF"
    },
    {
     "description": "TECHCOM INC",
     "symbol": "TCRI"
    },
    {
     "description": "TCR2 THERAPEUTICS INC",
     "symbol": "TCRR"
    },
    {
     "description": "TERRACE ENERGY CORP",
     "symbol": "TCRRF"
    },
    {
     "description": "ALAUNOS THERAPEUTICS INC",
     "symbol": "TCRT"
    },
    {
     "description": "TSCAN THERAPEUTICS INC",
     "symbol": "TCRX"
    },
    {
     "description": "CONTAINER STORE GROUP INC\/TH",
     "symbol": "TCS"
    },
    {
     "description": "PREMISE CAPITAL DIVERSIFIED",
     "symbol": "TCTL"
    },
    {
     "description": "TENCENT HOLDINGS LTD",
     "symbol": "TCTZF"
    },
    {
     "description": "TCV ACQUISITION CORP-A",
     "symbol": "TCVA"
    },
    {
     "description": "TOCVAN VENTURES CORP",
     "symbol": "TCVNF"
    },
    {
     "description": "TUCOWS INC-CLASS A",
     "symbol": "TCX"
    },
    {
     "description": "TINGYI (CAYMAN ISLN) HLDG CO",
     "symbol": "TCYMF"
    },
    {
     "description": "TECSYS INC",
     "symbol": "TCYSF"
    },
    {
     "description": "TORONTO-DOMINION BANK",
     "symbol": "TD"
    },
    {
     "description": "TX GROUP AG",
     "symbol": "TDAAF"
    },
    {
     "description": "Toronto Dominion Bank",
     "symbol": "TDBKF"
    },
    {
     "description": "TOYOTA BOSHOKU CORP",
     "symbol": "TDBOF"
    },
    {
     "description": "TOYOTA BOSHOKU-UNSP ADR",
     "symbol": "TDBOY"
    },
    {
     "description": "TDB SPLIT CORP-CLASS A",
     "symbol": "TDBSF"
    },
    {
     "description": "TERADATA CORP",
     "symbol": "TDC"
    },
    {
     "description": "TDC A\/S",
     "symbol": "TDCAF"
    },
    {
     "description": "THIRD CENTURY BANCORP",
     "symbol": "TDCB"
    },
    {
     "description": "30DC INC",
     "symbol": "TDCH"
    },
    {
     "description": "TDC SOFT INC",
     "symbol": "TDCSF"
    },
    {
     "description": "TDCX INC",
     "symbol": "TDCX"
    },
    {
     "description": "TIDEWATER INC-CW42",
     "symbol": "TDDWW"
    },
    {
     "description": "TEMPLETON DRAGON FUND INC",
     "symbol": "TDF"
    },
    {
     "description": "TRANSDIGM GROUP INC",
     "symbol": "TDG"
    },
    {
     "description": "TONGDA GROUP HOLDINGS LTD",
     "symbol": "TDGFF"
    },
    {
     "description": "TIDEWATER INC-CW42",
     "symbol": "TDGMW"
    },
    {
     "description": "T&D HOLDINGS INC",
     "symbol": "TDHOF"
    },
    {
     "description": "T&D HOLDINGS INC-UNSPON ADR",
     "symbol": "TDHOY"
    },
    {
     "description": "FT NASDAQ TECH DVD INDEX FD",
     "symbol": "TDIV"
    },
    {
     "description": "MACH7 TECHNOLOGIES LTD",
     "symbol": "TDMMF"
    },
    {
     "description": "TRIDENT BRANDS INC",
     "symbol": "TDNT"
    },
    {
     "description": "TELADOC HEALTH INC",
     "symbol": "TDOC"
    },
    {
     "description": "TOD'S SPA - UNSP ADR",
     "symbol": "TDPAY"
    },
    {
     "description": "TODD RIVER RESOURCES LTD",
     "symbol": "TDRCF"
    },
    {
     "description": "TIDEROCK COMPANIES INC",
     "symbol": "TDRK"
    },
    {
     "description": "TUDOR GOLD CORP",
     "symbol": "TDRRF"
    },
    {
     "description": "TELEPHONE AND DATA SYSTEMS",
     "symbol": "TDS"
    },
    {
     "description": "TELEPHONE & DATA SYS",
     "symbol": "TDS.PRV"
    },
    {
     "description": "CABANA TARGET DRAWDOWN 5 ETF",
     "symbol": "TDSA"
    },
    {
     "description": "CABANA TARGET DRAWDOWN 7 ETF",
     "symbol": "TDSB"
    },
    {
     "description": "CABANA TARGET DRAWDWN 10 ETF",
     "symbol": "TDSC"
    },
    {
     "description": "CABANA TARGET DRAWDWN 13 ETF",
     "symbol": "TDSD"
    },
    {
     "description": "CABANA TARGET DRAWDWN 16 ETF",
     "symbol": "TDSE"
    },
    {
     "description": "TELO GENOMICS CORP",
     "symbol": "TDSGF"
    },
    {
     "description": "TELEPHONE & DATA SYS",
     "symbol": "TDSpU"
    },
    {
     "description": "AMITY LPX FD I LP LTD",
     "symbol": "TDSPZ"
    },
    {
     "description": "FLEXSHARES IBOXX 5-YEAR TARG",
     "symbol": "TDTF"
    },
    {
     "description": "FLEXSHARES IBOXX 3-YEAR TARG",
     "symbol": "TDTT"
    },
    {
     "description": "THREDUP INC - CLASS A",
     "symbol": "TDUP"
    },
    {
     "description": "PROSHARES S&P TECH DVD ARIST",
     "symbol": "TDV"
    },
    {
     "description": "T ROWE PRICE DIVIDEND GROWTH",
     "symbol": "TDVG"
    },
    {
     "description": "TOBII DYNAVOX AB",
     "symbol": "TDVXF"
    },
    {
     "description": "TIDEWATER INC",
     "symbol": "TDW"
    },
    {
     "description": "TIDEWATER INC-CW24",
     "symbol": "TDW.WS"
    },
    {
     "description": "TIDEWATER INC -A CW23",
     "symbol": "TDW.WSA"
    },
    {
     "description": "TIDEWATER INC -B   CW23",
     "symbol": "TDW.WSB"
    },
    {
     "description": "GLOBAL SMART CAPITAL CORP",
     "symbol": "TDXP"
    },
    {
     "description": "TELEDYNE TECHNOLOGIES INC",
     "symbol": "TDY"
    },
    {
     "description": "THERMODYNETICS INC",
     "symbol": "TDYT"
    },
    {
     "description": "ECOFIN SUSTAIN & SOC IMPCT",
     "symbol": "TEAF"
    },
    {
     "description": "WORRY FREE TEA HOUSE HOLDING",
     "symbol": "TEAH"
    },
    {
     "description": "ATLASSIAN CORP PLC-CLASS A",
     "symbol": "TEAM"
    },
    {
     "description": "ISHARES US TECH BREAKTHROUGH",
     "symbol": "TECB"
    },
    {
     "description": "TECO 2030 ASA",
     "symbol": "TECFF"
    },
    {
     "description": "BIO-TECHNE CORP",
     "symbol": "TECH"
    },
    {
     "description": "TECK RESOURCES LTD-CLS B",
     "symbol": "TECK"
    },
    {
     "description": "DIREXION DAILY TECH BULL 3X",
     "symbol": "TECL"
    },
    {
     "description": "DIREXION DAILY TECH BEAR 3X",
     "symbol": "TECS"
    },
    {
     "description": "TECTONIC FINANCIAL INC",
     "symbol": "TECTP"
    },
    {
     "description": "TARENA INTERNATIONAL INC-ADR",
     "symbol": "TEDU"
    },
    {
     "description": "TELEFONICA SA-SPON ADR",
     "symbol": "TEF"
    },
    {
     "description": "TELEFONICA SA",
     "symbol": "TEFOF"
    },
    {
     "description": "TRIANGLE ENERGY GLOBAL LTD",
     "symbol": "TEGEF"
    },
    {
     "description": "TERRA ENERGY & RESOURCE TECH",
     "symbol": "TEGR"
    },
    {
     "description": "TRANSACT ENERGY CORP",
     "symbol": "TEGY"
    },
    {
     "description": "TECHNOVATIVE GROUP INC",
     "symbol": "TEHG"
    },
    {
     "description": "TEMPLETON EMERG MKTS INC FD",
     "symbol": "TEI"
    },
    {
     "description": "TIANLI EDUCATION INTERNATION",
     "symbol": "TEIHF"
    },
    {
     "description": "TEKCAPITAL PLC",
     "symbol": "TEKCF"
    },
    {
     "description": "TEK DIGITEL CORPORATION",
     "symbol": "TEKI"
    },
    {
     "description": "TEKKORP DIGITAL ACQUISITIO-A",
     "symbol": "TEKK"
    },
    {
     "description": "TEKKORP DIGITAL ACQUISITION",
     "symbol": "TEKKU"
    },
    {
     "description": "TEKKORP DIGITAL ACQUI -CW27",
     "symbol": "TEKKW"
    },
    {
     "description": "TE CONNECTIVITY LTD",
     "symbol": "TEL"
    },
    {
     "description": "TELA BIO INC",
     "symbol": "TELA"
    },
    {
     "description": "TELECURE TECHNOLOGIES INC",
     "symbol": "TELCF"
    },
    {
     "description": "TELEFONICA DEUTSCHLAND HOLDI",
     "symbol": "TELDF"
    },
    {
     "description": "TELEFONICA DEUTSCHLAND - ADR",
     "symbol": "TELDY"
    },
    {
     "description": "TELESCOPE INNOVATIONS CORP",
     "symbol": "TELIF"
    },
    {
     "description": "TELLURIAN INC",
     "symbol": "TELL"
    },
    {
     "description": "TELENOR ASA",
     "symbol": "TELNF"
    },
    {
     "description": "TELENOR ASA-ADR",
     "symbol": "TELNY"
    },
    {
     "description": "TELLURIAN INC",
     "symbol": "TELZ"
    },
    {
     "description": "JPMORGAN CLIMATE CHANGE SOLS",
     "symbol": "TEMP"
    },
    {
     "description": "PERSOL HOLDINGS CO LTD",
     "symbol": "TEMPF"
    },
    {
     "description": "TENNECO INC-CLASS A",
     "symbol": "TEN"
    },
    {
     "description": "TENABLE HOLDINGS INC",
     "symbol": "TENB"
    },
    {
     "description": "DIREXION DLY 5G COMM BULL 2X",
     "symbol": "TENG"
    },
    {
     "description": "TENAX THERAPEUTICS INC",
     "symbol": "TENX"
    },
    {
     "description": "TELECOM ARGENTINA SA-SP ADR",
     "symbol": "TEO"
    },
    {
     "description": "TEMPLE BAR INVESTMENT TRUST",
     "symbol": "TEPBF"
    },
    {
     "description": "TOHOKU ELECTRIC POWER CO INC",
     "symbol": "TEPCF"
    },
    {
     "description": "TOHOKU ELECTRIC POW-UNSP ADR",
     "symbol": "TEPCY"
    },
    {
     "description": "T ROWE PRICE EQUITY INCOME E",
     "symbol": "TEQI"
    },
    {
     "description": "TERADYNE INC",
     "symbol": "TER"
    },
    {
     "description": "TERAFORCE TECHNOLOGY CORP",
     "symbol": "TERA"
    },
    {
     "description": "TERRACOM LTD",
     "symbol": "TERCF"
    },
    {
     "description": "TERNS PHARMACEUTICALS INC",
     "symbol": "TERN"
    },
    {
     "description": "TERN PLC",
     "symbol": "TERNF"
    },
    {
     "description": "TERNA-RETE ELETTRICA NAZIONA",
     "symbol": "TERRF"
    },
    {
     "description": "286 LENOX PARTNERS LLC",
     "symbol": "TESLU"
    },
    {
     "description": "TESSCO TECHNOLOGIES INC",
     "symbol": "TESS"
    },
    {
     "description": "TETON ADVISORS INC-CLASS A",
     "symbol": "TETAA"
    },
    {
     "description": "TETON ADVISORS INC-CLASS B",
     "symbol": "TETAB"
    },
    {
     "description": "TECH AND ENERGY TRANSITION-A",
     "symbol": "TETC"
    },
    {
     "description": "TECH AND ENERGY TRANSITION",
     "symbol": "TETCU"
    },
    {
     "description": "TECH AND ENERGY TRANSI -CW27",
     "symbol": "TETCW"
    },
    {
     "description": "TECHNOLOGY & TELECOMMUNICATI",
     "symbol": "TETE"
    },
    {
     "description": "TECHNOLOGY & TELECOMMUNICATI",
     "symbol": "TETEU"
    },
    {
     "description": "TECHNOLOGY & TELECOMMUNI -27",
     "symbol": "TETEW"
    },
    {
     "description": "TETHYS PETROLEUM LTD",
     "symbol": "TETHF"
    },
    {
     "description": "TECTONIC METALS INC",
     "symbol": "TETOF"
    },
    {
     "description": "Box Ships Inc",
     "symbol": "TEUCF"
    },
    {
     "description": "BOX SHIPS INC",
     "symbol": "TEUFF"
    },
    {
     "description": "PARETEUM CORP",
     "symbol": "TEUM"
    },
    {
     "description": "TEUTON RESOURCES",
     "symbol": "TEUTF"
    },
    {
     "description": "THE EUROPEAN SMALLER COMPANI",
     "symbol": "TEUUF"
    },
    {
     "description": "TEUZA-A FAIRCHILD TECH VENT",
     "symbol": "TEUZF"
    },
    {
     "description": "TEVA PHARMACEUTICAL-SP ADR",
     "symbol": "TEVA"
    },
    {
     "description": "TEVA PHARMACEUTICAL IND LTD",
     "symbol": "TEVJF"
    },
    {
     "description": "TEVANO SYSTEMS HOLDINGS INC",
     "symbol": "TEVNF"
    },
    {
     "description": "TEREX CORP",
     "symbol": "TEX"
    },
    {
     "description": "TEIXEIRA DUARTE SA",
     "symbol": "TEXAF"
    },
    {
     "description": "TEXCOM INC",
     "symbol": "TEXC"
    },
    {
     "description": "TERAX ENERGY INC",
     "symbol": "TEXG"
    },
    {
     "description": "TERNA SPA-UNSPONSORED ADR",
     "symbol": "TEZNY"
    },
    {
     "description": "TREASURE FACTORY CO LTD",
     "symbol": "TFACF"
    },
    {
     "description": "O2 CZECH REPUBLIC AS",
     "symbol": "TFAOF"
    },
    {
     "description": "TOPPAN FORMS CO LTD",
     "symbol": "TFARF"
    },
    {
     "description": "TFN FOOTBALL NETWORK INC",
     "symbol": "TFBN"
    },
    {
     "description": "TRUIST FINANCIAL CORP",
     "symbol": "TFC"
    },
    {
     "description": "TRUIST FINANCIAL CORP",
     "symbol": "TFC.PRI"
    },
    {
     "description": "TRUIST FINANCIAL CORP",
     "symbol": "TFC.PRO"
    },
    {
     "description": "TRUIST FINANCIAL CORP",
     "symbol": "TFC.PRR"
    },
    {
     "description": "TERRA FIRMA CAPITAL CORP",
     "symbol": "TFCCF"
    },
    {
     "description": "TFF PHARMACEUTICALS INC",
     "symbol": "TFFP"
    },
    {
     "description": "TRACKER FINANCIAL GROUP LTD",
     "symbol": "TFGL"
    },
    {
     "description": "SPDR NUVEEN BLOOMBERG MUNICI",
     "symbol": "TFI"
    },
    {
     "description": "TFI INTERNATIONAL INC",
     "symbol": "TFII"
    },
    {
     "description": "INNOVATOR 20 YR TREAS BOND 5",
     "symbol": "TFJL"
    },
    {
     "description": "ISHARES TREASURY FLOATING RA",
     "symbol": "TFLO"
    },
    {
     "description": "TEFRON LTD",
     "symbol": "TFRFF"
    },
    {
     "description": "WT US FLTING RATE BND-USD AC",
     "symbol": "TFRNF"
    },
    {
     "description": "TASTY FRIES INC",
     "symbol": "TFRY"
    },
    {
     "description": "TERRA INC FUND6",
     "symbol": "TFSA"
    },
    {
     "description": "TFS FINANCIAL CORP",
     "symbol": "TFSL"
    },
    {
     "description": "24SEVENOFFICE GROUP AB",
     "symbol": "TFSVF"
    },
    {
     "description": "TELEFLEX INC",
     "symbol": "TFX"
    },
    {
     "description": "FIGHT ZONE INC\/THE",
     "symbol": "TFZI"
    },
    {
     "description": "TREDEGAR CORP",
     "symbol": "TG"
    },
    {
     "description": "TRANSGLOBE ENERGY CORP",
     "symbol": "TGA"
    },
    {
     "description": "TARGET GLOBAL ACQUISITION -A",
     "symbol": "TGAA"
    },
    {
     "description": "TARGET GLOBAL ACQUISITION I",
     "symbol": "TGAAU"
    },
    {
     "description": "TARGET GLOBAL ACQ I -CW27",
     "symbol": "TGAAW"
    },
    {
     "description": "TAIGA BUILDING PRODUCTS LTD",
     "symbol": "TGAFF"
    },
    {
     "description": "TRANSPHORM INC",
     "symbol": "TGAN"
    },
    {
     "description": "TOWNGAS SMART ENERGY CO LTD",
     "symbol": "TGASF"
    },
    {
     "description": "TASEKO MINES LTD",
     "symbol": "TGB"
    },
    {
     "description": "TAIWAN CEMENT",
     "symbol": "TGBMF"
    },
    {
     "description": "TEGO CYBER INC",
     "symbol": "TGCB"
    },
    {
     "description": "TONGDAO LIEPIN GROUP",
     "symbol": "TGDLF"
    },
    {
     "description": "TECOGEN INC\/WALTHAM MA",
     "symbol": "TGEN"
    },
    {
     "description": "TRANS GLOBAL GROUP INC",
     "symbol": "TGGI"
    },
    {
     "description": "TARUGA MINERALS LTD",
     "symbol": "TGGRF"
    },
    {
     "description": "TEXTAINER GROUP HOLDINGS LTD",
     "symbol": "TGH"
    },
    {
     "description": "TEXTAINER GROUP HOLDINGS",
     "symbol": "TGH.PRA"
    },
    {
     "description": "TEXTAINER GROUP HOLDINGS",
     "symbol": "TGH.PRB"
    },
    {
     "description": "TOUCHPOINT GROUP HOLDINGS",
     "symbol": "TGHI"
    },
    {
     "description": "TORNADO GLOBAL HYDROVACS LTD",
     "symbol": "TGHLF"
    },
    {
     "description": "TRIUMPH GROUP INC",
     "symbol": "TGI"
    },
    {
     "description": "TRIAD GUARANTY INC",
     "symbol": "TGIC"
    },
    {
     "description": "SOFI WEEKLY INCOME ETF",
     "symbol": "TGIF"
    },
    {
     "description": "1933 INDUSTRIES INC",
     "symbol": "TGIFF"
    },
    {
     "description": "TIGER INTL RESOURCES INC",
     "symbol": "TGILF"
    },
    {
     "description": "TRILLIUM GOLD MINES INC",
     "symbol": "TGLDF"
    },
    {
     "description": "THEGLOBE.COM INC",
     "symbol": "TGLO"
    },
    {
     "description": "TECNOGLASS INC",
     "symbol": "TGLS"
    },
    {
     "description": "TGLT SA-SPON ADR",
     "symbol": "TGLTY"
    },
    {
     "description": "TOP GLOVE CORP BHD-SPONS ADR",
     "symbol": "TGLVY"
    },
    {
     "description": "TOGAMI ELECTRIC MFG CO LTD",
     "symbol": "TGMEF"
    },
    {
     "description": "THETA GOLD MINES LTD",
     "symbol": "TGMGF"
    },
    {
     "description": "TROY GOLD & MINERAL CORP",
     "symbol": "TGMR"
    },
    {
     "description": "TEGNA INC",
     "symbol": "TGNA"
    },
    {
     "description": "TUNGSTEN MINING NL",
     "symbol": "TGNMF"
    },
    {
     "description": "TRIGANO SA",
     "symbol": "TGNOF"
    },
    {
     "description": "GREEN ORGANIC DUTCHMAN HOLDI",
     "symbol": "TGODF"
    },
    {
     "description": "TETRAGON FINANCIAL GROUP LTD",
     "symbol": "TGONF"
    },
    {
     "description": "3I GROUP PLC",
     "symbol": "TGOPF"
    },
    {
     "description": "3I GROUP PLC-UNSPON ADR",
     "symbol": "TGOPY"
    },
    {
     "description": "TOYODA GOSEI CO LTD",
     "symbol": "TGOSF"
    },
    {
     "description": "TOYODA GOSEI CO-UNSPON ADR",
     "symbol": "TGOSY"
    },
    {
     "description": "TOGETHER PHARMA LTD",
     "symbol": "TGPHF"
    },
    {
     "description": "KIMBELL TIGER ACQUISITION-A",
     "symbol": "TGR"
    },
    {
     "description": "KIMBELL TIGER ACQUISITION CO",
     "symbol": "TGR.U"
    },
    {
     "description": "KIMBELL TIGER ACQ A -CW23",
     "symbol": "TGR.WS"
    },
    {
     "description": "TONG REN TANG TECHNOLOGIES-H",
     "symbol": "TGRNF"
    },
    {
     "description": "TIGER OIL AND ENERGY INC",
     "symbol": "TGRO"
    },
    {
     "description": "TRON GROUP INC",
     "symbol": "TGRP"
    },
    {
     "description": "TIGER REEF INC",
     "symbol": "TGRR"
    },
    {
     "description": "TIAN GE INTERACTIVE HOLDINGS",
     "symbol": "TGRVF"
    },
    {
     "description": "T ROWE PRICE GROWTH STOCK ET",
     "symbol": "TGRW"
    },
    {
     "description": "TRANSPORTADOR GAS-ADR SP B",
     "symbol": "TGS"
    },
    {
     "description": "TGS ESPORTS INC",
     "symbol": "TGSEF"
    },
    {
     "description": "TGS NOPEC GEOPHYSICAL-SP ADR",
     "symbol": "TGSGY"
    },
    {
     "description": "TGS INTERNATIONAL LTD",
     "symbol": "TGSI"
    },
    {
     "description": "TGS ASA",
     "symbol": "TGSNF"
    },
    {
     "description": "TARGET CORP",
     "symbol": "TGT"
    },
    {
     "description": "TARGETED MICROWAVE SOLUTIONS",
     "symbol": "TGTMF"
    },
    {
     "description": "TUNGSTEN CORP PLC",
     "symbol": "TGTNF"
    },
    {
     "description": "TG THERAPEUTICS INC",
     "symbol": "TGTX"
    },
    {
     "description": "TG VENTURE ACQUISITION CORP",
     "symbol": "TGVC"
    },
    {
     "description": "TG VENTURE ACQUISITION CORP",
     "symbol": "TGVCU"
    },
    {
     "description": "TG VENTURE ACQUISITION -CW23",
     "symbol": "TGVCW"
    },
    {
     "description": "TGC VENTURES INTERNATIONAL I",
     "symbol": "TGVN"
    },
    {
     "description": "TRYG A\/S",
     "symbol": "TGVSF"
    },
    {
     "description": "TRYG A\/S-UNSPON ADR",
     "symbol": "TGVSY"
    },
    {
     "description": "TARGET HOSPITALITY CORP",
     "symbol": "TH"
    },
    {
     "description": "THRIVE ACQUISITION CORP - A",
     "symbol": "THAC"
    },
    {
     "description": "THRIVE ACQUISITION CORP",
     "symbol": "THACU"
    },
    {
     "description": "THRIVE ACQUISITION -CW23",
     "symbol": "THACW"
    },
    {
     "description": "THORESEN THAI AGENCIES-FOR",
     "symbol": "THAFF"
    },
    {
     "description": "TALENTHOUSE AG",
     "symbol": "THAGF"
    },
    {
     "description": "THORESEN THAI AGENCIES-NVDR",
     "symbol": "THAHF"
    },
    {
     "description": "THUNDERBIRD ENTERTAINMENT GR",
     "symbol": "THBRF"
    },
    {
     "description": "TENET HEALTHCARE CORP",
     "symbol": "THC"
    },
    {
     "description": "TUSCAN HOLDINGS CORP II",
     "symbol": "THCA"
    },
    {
     "description": "TUSCAN HOLDINGS CORP II",
     "symbol": "THCAU"
    },
    {
     "description": "TUSCAN HOLDINGS CORP II-CW25",
     "symbol": "THCAW"
    },
    {
     "description": "THC BIOMED INTL LTD",
     "symbol": "THCBF"
    },
    {
     "description": "HEALING CO INC\/THE",
     "symbol": "THCC"
    },
    {
     "description": "THUNDER BRIDGE CAPITAL PAR-A",
     "symbol": "THCP"
    },
    {
     "description": "THUNDER BRIDGE CAPITAL PARTN",
     "symbol": "THCPU"
    },
    {
     "description": "THUNDER BRIDGE CAPITAL-CW",
     "symbol": "THCPW"
    },
    {
     "description": "THC THERAPEUTICS INC",
     "symbol": "THCT"
    },
    {
     "description": "THE CANNABIS ETF",
     "symbol": "THCX"
    },
    {
     "description": "ISHARES MSCI THAILAND ETF",
     "symbol": "THD"
    },
    {
     "description": "TV ASAHI HOLDINGS-UNSP ADR",
     "symbol": "THDDY"
    },
    {
     "description": "3DSHOPPING.COM",
     "symbol": "THDS"
    },
    {
     "description": "THERMADOR GROUPE",
     "symbol": "THEPF"
    },
    {
     "description": "THERALINK TECHNOLOGIES INC",
     "symbol": "THER"
    },
    {
     "description": "FIRST FINANCIAL CORP\/INDIANA",
     "symbol": "THFF"
    },
    {
     "description": "HANOVER INSURANCE GROUP INC\/",
     "symbol": "THG"
    },
    {
     "description": "THG HOLDINGS PLC - UNSP ADR",
     "symbol": "THGHY"
    },
    {
     "description": "THG PLC",
     "symbol": "THGPF"
    },
    {
     "description": "TECHNO HORIZON CO LTD",
     "symbol": "THHCF"
    },
    {
     "description": "THINK RESEARCH CORP",
     "symbol": "THKKF"
    },
    {
     "description": "THK CO LTD",
     "symbol": "THKLF"
    },
    {
     "description": "THK CO LTD-UNSPON ADR",
     "symbol": "THKLY"
    },
    {
     "description": "THALES SA",
     "symbol": "THLEF"
    },
    {
     "description": "THALES SA - UNSP ADR",
     "symbol": "THLLY"
    },
    {
     "description": "T.H. LEHMAN AND CO INC",
     "symbol": "THLM"
    },
    {
     "description": "THULE GROUP AB\/THE",
     "symbol": "THLPF"
    },
    {
     "description": "INTL TOWER HILL MINES LTD",
     "symbol": "THM"
    },
    {
     "description": "THUNDER MOUNTAIN GOLD INC",
     "symbol": "THMG"
    },
    {
     "description": "THAICOM PCL-FOREIGN",
     "symbol": "THMHF"
    },
    {
     "description": "THERMOGENESIS HOLDINGS INC",
     "symbol": "THMO"
    },
    {
     "description": "THINKIFIC LABS INC-SUB VTG",
     "symbol": "THNCF"
    },
    {
     "description": "TECHNOLOGY ONE LIMITED",
     "symbol": "THNOF"
    },
    {
     "description": "TECHNIP ENERGIES NV",
     "symbol": "THNPF"
    },
    {
     "description": "TECHNIP ENERGIES ADR - SPON",
     "symbol": "THNPY"
    },
    {
     "description": "ROBO GLOBAL ARTIFICIAL INTEL",
     "symbol": "THNQ"
    },
    {
     "description": "THANACHART CAPITAL-UNSP ADR",
     "symbol": "THNUY"
    },
    {
     "description": "THANACHART CAPITAL-FOREIGN",
     "symbol": "THNVF"
    },
    {
     "description": "MINOR INTL PCL-CW23",
     "symbol": "THNWF"
    },
    {
     "description": "THOR INDUSTRIES INC",
     "symbol": "THO"
    },
    {
     "description": "TOHO GAS CO LTD",
     "symbol": "THOGF"
    },
    {
     "description": "TOHO CO LTD",
     "symbol": "THOOF"
    },
    {
     "description": "THAI OIL PCL-NVDR",
     "symbol": "THOPF"
    },
    {
     "description": "THOR MINING PLC",
     "symbol": "THORF"
    },
    {
     "description": "BIOPORTO A\/S",
     "symbol": "THOXF"
    },
    {
     "description": "THINKPATH INC",
     "symbol": "THPHF"
    },
    {
     "description": "TOHO HOLDINGS CO LTD",
     "symbol": "THPMF"
    },
    {
     "description": "TECHPOINT INC-JDR",
     "symbol": "THPTF"
    },
    {
     "description": "TEKLA HEALTHCARE OPPORTUNITI",
     "symbol": "THQ"
    },
    {
     "description": "EMBRACER GROUP AB",
     "symbol": "THQQF"
    },
    {
     "description": "THERMON GROUP HOLDINGS INC",
     "symbol": "THR"
    },
    {
     "description": "THERMA-MED INC",
     "symbol": "THRA"
    },
    {
     "description": "SPDR GLOBAL CONVERTIBLE DIST",
     "symbol": "THRGF"
    },
    {
     "description": "GENTHERM INC",
     "symbol": "THRM"
    },
    {
     "description": "THORNE HEALTHTECH INC",
     "symbol": "THRN"
    },
    {
     "description": "THERON RESOURCE GROUP",
     "symbol": "THRO"
    },
    {
     "description": "THRESHER INDUSTRIES INC",
     "symbol": "THRR"
    },
    {
     "description": "THUNDERBIRD RESORTS INC",
     "symbol": "THRSF"
    },
    {
     "description": "INTELLIGENT MONITORING GROUP",
     "symbol": "THRTF"
    },
    {
     "description": "THESEUS PHARMACEUTICALS INC",
     "symbol": "THRX"
    },
    {
     "description": "THRYV HOLDINGS INC",
     "symbol": "THRY"
    },
    {
     "description": "THRYV HOLDINGS INC-CW23",
     "symbol": "THRYW"
    },
    {
     "description": "TREEHOUSE FOODS INC",
     "symbol": "THS"
    },
    {
     "description": "THESIS GOLD INC",
     "symbol": "THSGF"
    },
    {
     "description": "TRUETT-HURST INC",
     "symbol": "THST"
    },
    {
     "description": "THERATECHNOLOGIES INC",
     "symbol": "THTX"
    },
    {
     "description": "THULE GROUP AB-UNSP ADR",
     "symbol": "THUPY"
    },
    {
     "description": "THUNDERSTRUCK RESOURCES LTD",
     "symbol": "THURF"
    },
    {
     "description": "THOMASVILLE BANCSHARES INC",
     "symbol": "THVB"
    },
    {
     "description": "MINOR INTL PCL NVDR -CW24",
     "symbol": "THVWF"
    },
    {
     "description": "TEKLA WORLD HEALTHCARE FUND",
     "symbol": "THW"
    },
    {
     "description": "TARGET HOSPITALITY CORP-CW25",
     "symbol": "THWWW"
    },
    {
     "description": "THOR EXPLORATION LTD",
     "symbol": "THXPF"
    },
    {
     "description": "TOEWS AGILITY SHARES DYNAMIC",
     "symbol": "THY"
    },
    {
     "description": "TAIHEIYO CEMENT CORP",
     "symbol": "THYCF"
    },
    {
     "description": "TAIHEIYO CEMENT-UNSPON ADR",
     "symbol": "THYCY"
    },
    {
     "description": "TIAN AN CHINA INVESTMENT",
     "symbol": "TIACF"
    },
    {
     "description": "TELECOM ITALIA SPA-SPON ADR",
     "symbol": "TIAIY"
    },
    {
     "description": "TELECOM ITALIA-RSP",
     "symbol": "TIAJF"
    },
    {
     "description": "TIANNENG POWER INTL LTD",
     "symbol": "TIANF"
    },
    {
     "description": "TELECOM ITALIA SPA",
     "symbol": "TIAOF"
    },
    {
     "description": "TRITENT INTERNATIONAL CORP",
     "symbol": "TICJ"
    },
    {
     "description": "TIDELANDS OIL & GAS CORP",
     "symbol": "TIDE"
    },
    {
     "description": "TIE KINETIX",
     "symbol": "TIEKF"
    },
    {
     "description": "TIEMCO LTD",
     "symbol": "TIEMF"
    },
    {
     "description": "TIETTO MINERALS LTD",
     "symbol": "TIETF"
    },
    {
     "description": "TREAN INSURANCE GROUP INC",
     "symbol": "TIG"
    },
    {
     "description": "TRIUMPH GOLD CORP",
     "symbol": "TIGCF"
    },
    {
     "description": "TIGRENT INC",
     "symbol": "TIGE"
    },
    {
     "description": "MILLICOM INTL CELLULAR S.A.",
     "symbol": "TIGO"
    },
    {
     "description": "UP FINTECH HOLDING LTD - ADR",
     "symbol": "TIGR"
    },
    {
     "description": "THARISA PLC",
     "symbol": "TIHRF"
    },
    {
     "description": "TELECOM ITALIA SPA-SPON ADR",
     "symbol": "TIIAY"
    },
    {
     "description": "TIIDAL GAMING GROUP CORP",
     "symbol": "TIIDF"
    },
    {
     "description": "TEL-INSTRUMENT ELECTRONICS",
     "symbol": "TIKK"
    },
    {
     "description": "TIKCRO TECHNOLOGIES LTD",
     "symbol": "TIKRF"
    },
    {
     "description": "INSTIL BIO INC",
     "symbol": "TIL"
    },
    {
     "description": "TILL CAPITAL CORP",
     "symbol": "TILCF"
    },
    {
     "description": "INTERFACE INC",
     "symbol": "TILE"
    },
    {
     "description": "FLEXSHARES MORNINGSTAR US MA",
     "symbol": "TILT"
    },
    {
     "description": "TIM SA-ADR",
     "symbol": "TIMB"
    },
    {
     "description": "TIMIA CAPITAL CORP",
     "symbol": "TIMCF"
    },
    {
     "description": "CLOCKWISE CAPITAL INNOVATION",
     "symbol": "TIME"
    },
    {
     "description": "TIMMINCO LTD",
     "symbol": "TIMNF"
    },
    {
     "description": "TEIJIN LTD",
     "symbol": "TINLF"
    },
    {
     "description": "TEIJIN LTD-UNSPONSORED ADR",
     "symbol": "TINLY"
    },
    {
     "description": "TECHNOVATOR INTERNATIONAL LT",
     "symbol": "TINNF"
    },
    {
     "description": "TAMINO MINERALS INC",
     "symbol": "TINO"
    },
    {
     "description": "PROSHARES SMART MATERIALS",
     "symbol": "TINT"
    },
    {
     "description": "TIGA ACQUISITION CORP- CL A",
     "symbol": "TINV"
    },
    {
     "description": "TIGA ACQUISITION CORP",
     "symbol": "TINV.U"
    },
    {
     "description": "TIGA ACQUISITION CORP-CW26",
     "symbol": "TINV.WS"
    },
    {
     "description": "PROSHARES NANOTECHNOLOGY ETF",
     "symbol": "TINY"
    },
    {
     "description": "TIO TECH A- CLASS A",
     "symbol": "TIOA"
    },
    {
     "description": "TIO TECH A",
     "symbol": "TIOAU"
    },
    {
     "description": "TIO TECH A -CW28",
     "symbol": "TIOAW"
    },
    {
     "description": "T42 IOT TRACKING SOLUTIONS P",
     "symbol": "TIOTF"
    },
    {
     "description": "ISHARES TIPS BOND ETF",
     "symbol": "TIP"
    },
    {
     "description": "DIREXION DAILY TIPS BEAR 2X",
     "symbol": "TIPD"
    },
    {
     "description": "TITAN PETROCHEMICALS GROUP L",
     "symbol": "TIPGF"
    },
    {
     "description": "DIREXION DAILY TIPS BULL 2X",
     "symbol": "TIPL"
    },
    {
     "description": "TYNER RESOURCES LTD",
     "symbol": "TIPNF"
    },
    {
     "description": "TIANRONG INTERNET PRODUCTS",
     "symbol": "TIPS"
    },
    {
     "description": "TIPTREE INC",
     "symbol": "TIPT"
    },
    {
     "description": "LYXOR CORE US TIPS DR",
     "symbol": "TIPUF"
    },
    {
     "description": "SPDR BLOOMBERG 1-10 YEAR TIP",
     "symbol": "TIPX"
    },
    {
     "description": "PIMCO BROAD US TIPS INDEX",
     "symbol": "TIPZ"
    },
    {
     "description": "TIAN RUIXIANG HOLDINGS LTD-A",
     "symbol": "TIRX"
    },
    {
     "description": "TAISEI CORP",
     "symbol": "TISCF"
    },
    {
     "description": "TAISEI CORP-UNSPONSORED ADR",
     "symbol": "TISCY"
    },
    {
     "description": "TREASURE ISLAND ROYALTY TRUS",
     "symbol": "TISDZ"
    },
    {
     "description": "TEAM INC",
     "symbol": "TISI"
    },
    {
     "description": "TIS INC",
     "symbol": "TISNF"
    },
    {
     "description": "TITAN CEMENT CO. S.A.",
     "symbol": "TITCF"
    },
    {
     "description": "TITOMIC LTD",
     "symbol": "TITMF"
    },
    {
     "description": "TITAN MACHINERY INC",
     "symbol": "TITN"
    },
    {
     "description": "CVW CLEANTECH INC",
     "symbol": "TITUF"
    },
    {
     "description": "TIVIC HEALTH SYSTEMS INC",
     "symbol": "TIVC"
    },
    {
     "description": "TIX CORP",
     "symbol": "TIXC"
    },
    {
     "description": "TELUS INTERNATIONAL CDA INC",
     "symbol": "TIXT"
    },
    {
     "description": "TENGJUN BIOTECHNOLOGY CORP",
     "symbol": "TJBH"
    },
    {
     "description": "TIANJIN PORT DVLP HLDS LTD",
     "symbol": "TJIPF"
    },
    {
     "description": "TIANJIN DEVELOPMENT HLDGS LT",
     "symbol": "TJSCF"
    },
    {
     "description": "TAJ SYSTEMS INC",
     "symbol": "TJSS"
    },
    {
     "description": "TJX COMPANIES INC",
     "symbol": "TJX"
    },
    {
     "description": "TEEKAY CORP",
     "symbol": "TK"
    },
    {
     "description": "TAOKAENOI FOOD & MARKETING P",
     "symbol": "TKAEF"
    },
    {
     "description": "TELEKOM AUSTRIA AG-ADR",
     "symbol": "TKAGY"
    },
    {
     "description": "THYSSENKRUPP AG-SPON ADR",
     "symbol": "TKAMY"
    },
    {
     "description": "TAKUNG ART CO LTD",
     "symbol": "TKAT"
    },
    {
     "description": "JUST EAT TAKEAWAY",
     "symbol": "TKAYF"
    },
    {
     "description": "TAKBO GROUP HOLDINGS LTD",
     "symbol": "TKBGF"
    },
    {
     "description": "TAKARA BIO INC",
     "symbol": "TKBIF"
    },
    {
     "description": "TURKCELL ILETISIM HIZMET-ADR",
     "symbol": "TKC"
    },
    {
     "description": "TOKAI CARBON CO LTD",
     "symbol": "TKCBF"
    },
    {
     "description": "TOKAI CARBON CO LTD-UNSP ADR",
     "symbol": "TKCBY"
    },
    {
     "description": "TOUKEI COMPUTER CO LTD",
     "symbol": "TKCCF"
    },
    {
     "description": "TAOKA CHEMICAL CO LTD",
     "symbol": "TKCHF"
    },
    {
     "description": "TURNKEY CAPITAL INC",
     "symbol": "TKCI"
    },
    {
     "description": "TOHO CO LTD",
     "symbol": "TKCOF"
    },
    {
     "description": "VANECK DEV MKT DVD LEADERS",
     "symbol": "TKCPF"
    },
    {
     "description": "TKC CORP",
     "symbol": "TKCXF"
    },
    {
     "description": "TOKYO ELECTRIC POWER COMPANY",
     "symbol": "TKECF"
    },
    {
     "description": "TOKYO ELECTRIC POW-UNSP ADR",
     "symbol": "TKECY"
    },
    {
     "description": "TEKFEN HOLDING AS-UNSP ADR",
     "symbol": "TKFHY"
    },
    {
     "description": "TEKFEN HOLDING AS",
     "symbol": "TKFNF"
    },
    {
     "description": "TOKYU FUDOSAN HO-UNSPON ADR",
     "symbol": "TKFOY"
    },
    {
     "description": "TARKETT",
     "symbol": "TKFTF"
    },
    {
     "description": "TURKIYE GARANTI BANKASI",
     "symbol": "TKGBF"
    },
    {
     "description": "TURKIYE GARANTI BANKASI-ADR",
     "symbol": "TKGBY"
    },
    {
     "description": "TEKEGLDMPIRE INC",
     "symbol": "TKGL"
    },
    {
     "description": "TOKYO GAS CO LTD",
     "symbol": "TKGSF"
    },
    {
     "description": "TOKYO GAS CO LTD-UNSPON ADR",
     "symbol": "TKGSY"
    },
    {
     "description": "TURKIYE GARANTI BA-144A ADR",
     "symbol": "TKGZY"
    },
    {
     "description": "KOEI TECMO HOLDINGS CO LTD",
     "symbol": "TKHCF"
    },
    {
     "description": "TAKARA HOLDINGS INC",
     "symbol": "TKHIF"
    },
    {
     "description": "TURK HAVA YOLLARI-UNSPON ADR",
     "symbol": "TKHVY"
    },
    {
     "description": "TAIKISHA LTD",
     "symbol": "TKIAF"
    },
    {
     "description": "TRU KIDS PARENT LLC-UNITS",
     "symbol": "TKIDU"
    },
    {
     "description": "TOKYO KEIKI INC",
     "symbol": "TKIEF"
    },
    {
     "description": "TIKEHAU CAPITAL",
     "symbol": "TKKHF"
    },
    {
     "description": "YOSHITSU CO LTD-ADR",
     "symbol": "TKLF"
    },
    {
     "description": "TRUTANKLESS INC",
     "symbol": "TKLS"
    },
    {
     "description": "TAKAMATSU MACHINERY CO LTD",
     "symbol": "TKMTF"
    },
    {
     "description": "ALPHA TEKNOVA INC",
     "symbol": "TKNO"
    },
    {
     "description": "TBS HOLDINGS INC",
     "symbol": "TKOBF"
    },
    {
     "description": "TELKONET INC",
     "symbol": "TKOI"
    },
    {
     "description": "TEIKOKU ELECTRIC MFG CO LTD",
     "symbol": "TKOLF"
    },
    {
     "description": "TOKIO MARINE HOLDINGS INC",
     "symbol": "TKOMF"
    },
    {
     "description": "TOKIO MARINE HOLDINGS-ADR",
     "symbol": "TKOMY"
    },
    {
     "description": "TAKEDA PHARMACEUTICAL CO LTD",
     "symbol": "TKPHF"
    },
    {
     "description": "TAKARA PRINTING CO LTD",
     "symbol": "TKPTF"
    },
    {
     "description": "TIMKEN CO",
     "symbol": "TKR"
    },
    {
     "description": "TINKA RESOURCES LTD",
     "symbol": "TKRFF"
    },
    {
     "description": "TOKAI RIKA CO LTD",
     "symbol": "TKRKF"
    },
    {
     "description": "TAKARA LEBEN REAL ESTATE INV",
     "symbol": "TKRLF"
    },
    {
     "description": "TAKASHIMAYA CO LTD",
     "symbol": "TKSHF"
    },
    {
     "description": "TAKASAGO THERMAL ENGINEERING",
     "symbol": "TKSNF"
    },
    {
     "description": "TINKERINE STUDIOS LTD",
     "symbol": "TKSTF"
    },
    {
     "description": "TAKUMA CO LTD",
     "symbol": "TKUMF"
    },
    {
     "description": "TOKYU REIT INC",
     "symbol": "TKURF"
    },
    {
     "description": "TRACKX HOLDINGS INC",
     "symbol": "TKXHF"
    },
    {
     "description": "TOKUYAMA CORP",
     "symbol": "TKYMF"
    },
    {
     "description": "TOKUYAMA CORP-UNSP ADR",
     "symbol": "TKYMY"
    },
    {
     "description": "TURKIYE VAKIFLAR-UNSPON ADR",
     "symbol": "TKYVY"
    },
    {
     "description": "TWINLAB CONSOLIDATED HOLDING",
     "symbol": "TLCC"
    },
    {
     "description": "TELECONNECT INC",
     "symbol": "TLCO"
    },
    {
     "description": "TLD3 ENTERTAINMENT GROUP INC",
     "symbol": "TLDE"
    },
    {
     "description": "TELIDYNE INC",
     "symbol": "TLDN"
    },
    {
     "description": "TANDY LEATHER FACTORY INC",
     "symbol": "TLFA"
    },
    {
     "description": "TELEFIX COMMUNICATIONS HOLDI",
     "symbol": "TLFX"
    },
    {
     "description": "TLG ACQUISITION ONE COR-CL A",
     "symbol": "TLGA"
    },
    {
     "description": "TLG ACQUISITION ONE CORP",
     "symbol": "TLGA.U"
    },
    {
     "description": "TLG ACQUISITION ONE A -CW28",
     "symbol": "TLGA.WS"
    },
    {
     "description": "TELENET GROUP HOLDING NV",
     "symbol": "TLGHF"
    },
    {
     "description": "TELENET GROUP HOLD-UNSP ADR",
     "symbol": "TLGHY"
    },
    {
     "description": "EVER HARVEST INTERNATIONAL G",
     "symbol": "TLGN"
    },
    {
     "description": "TALGA GROUP LTD",
     "symbol": "TLGRF"
    },
    {
     "description": "TELIGENT INC",
     "symbol": "TLGTQ"
    },
    {
     "description": "TLGY ACQUISITION CORP - A",
     "symbol": "TLGY"
    },
    {
     "description": "TLGY ACQUISITION CORP",
     "symbol": "TLGYU"
    },
    {
     "description": "TLGY ACQUISITION CORP -23",
     "symbol": "TLGYW"
    },
    {
     "description": "ISHARES 10-20 YEAR TREASURY",
     "symbol": "TLH"
    },
    {
     "description": "TOCCA LIFE HOLDINGS INC",
     "symbol": "TLIF"
    },
    {
     "description": "TALIS BIOMEDICAL CORP",
     "symbol": "TLIS"
    },
    {
     "description": "TELKOM INDONESIA PERSERO-ADR",
     "symbol": "TLK"
    },
    {
     "description": "TULIKIVI OYJ CLASS A",
     "symbol": "TLKAF"
    },
    {
     "description": "TELKOM SA SOC LTD-SPON ADR",
     "symbol": "TLKGY"
    },
    {
     "description": "TELKOM INDONESIA PERSERO TBK",
     "symbol": "TLKMF"
    },
    {
     "description": "TELETOUCH COMMUNICATIONS INC",
     "symbol": "TLLEQ"
    },
    {
     "description": "TILT HOLDINGS INC",
     "symbol": "TLLTF"
    },
    {
     "description": "TALANX AG - ADR",
     "symbol": "TLLXY"
    },
    {
     "description": "TRILOGY INTERNATIONAL PARTNE",
     "symbol": "TLLYF"
    },
    {
     "description": "GOLD LINE RESOURCES LTD",
     "symbol": "TLLZF"
    },
    {
     "description": "TALON METALS CORP",
     "symbol": "TLOFF"
    },
    {
     "description": "TETRALOGIC PHARMACEUTICALS C",
     "symbol": "TLOG"
    },
    {
     "description": "INFINITY STONE VENTURES CORP",
     "symbol": "TLOOF"
    },
    {
     "description": "TELPAC INDUSTRIES INC",
     "symbol": "TLPC"
    },
    {
     "description": "TELEPERFORMANCE",
     "symbol": "TLPFF"
    },
    {
     "description": "TELEPERFORMANCE-UNSPON ADR",
     "symbol": "TLPFY"
    },
    {
     "description": "TELIX PHARMACEUTICALS LTD",
     "symbol": "TLPPF"
    },
    {
     "description": "TIMBERLINE RESOURCES CORP",
     "symbol": "TLRS"
    },
    {
     "description": "TILRAY BRANDS INC",
     "symbol": "TLRY"
    },
    {
     "description": "TELOS CORPORATION",
     "symbol": "TLS"
    },
    {
     "description": "TIZIANA LIFE SCIENCES LTD",
     "symbol": "TLSA"
    },
    {
     "description": "TALISMAN MINING LTD",
     "symbol": "TLSMF"
    },
    {
     "description": "TELIA CO AB",
     "symbol": "TLSNF"
    },
    {
     "description": "TELIA CO - UNSPON ADR",
     "symbol": "TLSNY"
    },
    {
     "description": "TRANSPORTATION & LOGISTICS S",
     "symbol": "TLSS"
    },
    {
     "description": "TELSTRA CORP-ADR",
     "symbol": "TLSYY"
    },
    {
     "description": "ISHARES 20+ YEAR TREASURY BO",
     "symbol": "TLT"
    },
    {
     "description": "FLEXSHARES MORNINGSTAR DEVEL",
     "symbol": "TLTD"
    },
    {
     "description": "FLEXSHARES MORNINGSTAR EMERG",
     "symbol": "TLTE"
    },
    {
     "description": "THERALASE TECHNOLOGIES INC",
     "symbol": "TLTFF"
    },
    {
     "description": "TELE2 AB-B SHS",
     "symbol": "TLTZF"
    },
    {
     "description": "TELE2 AB-B-UNSPON ADR",
     "symbol": "TLTZY"
    },
    {
     "description": "MINDS PLUS MACHINES GROUP LT",
     "symbol": "TLVLF"
    },
    {
     "description": "TILLY'S INC-CLASS A SHRS",
     "symbol": "TLYS"
    },
    {
     "description": "TOYOTA MOTOR CORP -SPON ADR",
     "symbol": "TM"
    },
    {
     "description": "MUSIC ACQUISITION CORP\/THE-A",
     "symbol": "TMAC"
    },
    {
     "description": "MUSIC ACQUISITION CORP\/THE",
     "symbol": "TMAC.U"
    },
    {
     "description": "MUSIC ACQUISITION CL A -CW28",
     "symbol": "TMAC.WS"
    },
    {
     "description": "TOUCHMARK BANCSHARES INC",
     "symbol": "TMAK"
    },
    {
     "description": "TEMAS RESOURCES CORP",
     "symbol": "TMASF"
    },
    {
     "description": "MAIN THEMATIC INNOVATION ETF",
     "symbol": "TMAT"
    },
    {
     "description": "TECHNOLOGY METALS AUSTRALIA",
     "symbol": "TMAUF"
    },
    {
     "description": "TMBTHANACHAER BANK-UNS ADR",
     "symbol": "TMBBY"
    },
    {
     "description": "TOMBADOR IRON LTD",
     "symbol": "TMBIF"
    },
    {
     "description": "TIMBER PHARMACEUTICALS INC",
     "symbol": "TMBR"
    },
    {
     "description": "TOMBSTONE EXPLORATION CORP",
     "symbol": "TMBXF"
    },
    {
     "description": "TMC THE METALS CO INC",
     "symbol": "TMC"
    },
    {
     "description": "TOMCO ENERGY PLC",
     "symbol": "TMCGF"
    },
    {
     "description": "TREACE MEDICAL CONCEPTS INC",
     "symbol": "TMCI"
    },
    {
     "description": "TEMECULA VALLEY BANCORP INC",
     "symbol": "TMCV"
    },
    {
     "description": "TMC THE METALS CO INC -CW25I",
     "symbol": "TMCWW"
    },
    {
     "description": "TITAN MEDICAL INC",
     "symbol": "TMDI"
    },
    {
     "description": "PROSHARES RUSSELL US DVD GRW",
     "symbol": "TMDV"
    },
    {
     "description": "TRANSMEDICS GROUP INC",
     "symbol": "TMDX"
    },
    {
     "description": "TENCENT MUSIC ENTERTAINM-ADR",
     "symbol": "TME"
    },
    {
     "description": "TERME BANCORP INC",
     "symbol": "TMEB"
    },
    {
     "description": "THERMOENERGY CORP",
     "symbol": "TMEN"
    },
    {
     "description": "DRX DLY 20+ YR TREAS BULL 3X",
     "symbol": "TMF"
    },
    {
     "description": "MOTLEY FOOL 100 INDEX ETF",
     "symbol": "TMFC"
    },
    {
     "description": "MOTLEY FOOL CAPITAL EFFICIE",
     "symbol": "TMFE"
    },
    {
     "description": "MOTLEY FOOL GLOBAL OPP",
     "symbol": "TMFG"
    },
    {
     "description": "MOTLEY FOOL MID-CAP GROWTH",
     "symbol": "TMFM"
    },
    {
     "description": "MOTLEY FOOL SMALL-CAP GROWTH",
     "symbol": "TMFS"
    },
    {
     "description": "MOTLEY FOOL NEXT INDEX ETF",
     "symbol": "TMFX"
    },
    {
     "description": "HOLIDAYCHECK GROUP AG",
     "symbol": "TMFXF"
    },
    {
     "description": "THERMAL ENERGY INTL INC",
     "symbol": "TMGEF"
    },
    {
     "description": "MARQUIE GROUP INC \/THE",
     "symbol": "TMGI"
    },
    {
     "description": "TERMINUS ENERGY INC",
     "symbol": "TMGY"
    },
    {
     "description": "TAYLOR MORRISON HOME CORP",
     "symbol": "TMHC"
    },
    {
     "description": "TSIM SHA TSUI-UNSPON ADR",
     "symbol": "TMHTY"
    },
    {
     "description": "TREND MICRO INC",
     "symbol": "TMICF"
    },
    {
     "description": "TREND MICRO INC-SPON ADR",
     "symbol": "TMICY"
    },
    {
     "description": "TAYLOR MARITIME INVESTMENTS",
     "symbol": "TMILF"
    },
    {
     "description": "TRENDMAKER INC LTD",
     "symbol": "TMIN"
    },
    {
     "description": "TARSIN MOBILE INC",
     "symbol": "TMIX"
    },
    {
     "description": "TASTEMAKER ACQUISITION COR-A",
     "symbol": "TMKR"
    },
    {
     "description": "TASTEMAKER ACQUISITION CORP",
     "symbol": "TMKRU"
    },
    {
     "description": "TASTEMAKER ACQ CL A -CW25",
     "symbol": "TMKRW"
    },
    {
     "description": "TOMOKU CO LTD",
     "symbol": "TMKUF"
    },
    {
     "description": "TELE GROUP CORP",
     "symbol": "TMLL"
    },
    {
     "description": "TAMERLANE VENTURES INC",
     "symbol": "TMLVF"
    },
    {
     "description": "TMM INC",
     "symbol": "TMMI"
    },
    {
     "description": "TINGO INC",
     "symbol": "TMNA"
    },
    {
     "description": "TEMENOS AG - REG",
     "symbol": "TMNSF"
    },
    {
     "description": "THERMO FISHER SCIENTIFIC INC",
     "symbol": "TMO"
    },
    {
     "description": "TOMTOM NV",
     "symbol": "TMOAF"
    },
    {
     "description": "TOMTOM-UNSP ADR",
     "symbol": "TMOAY"
    },
    {
     "description": "TRIMOL GROUP INC",
     "symbol": "TMOL"
    },
    {
     "description": "TOMPKINS FINANCIAL CORP",
     "symbol": "TMP"
    },
    {
     "description": "TEMPUS HOLDINGS LTD",
     "symbol": "TMPHF"
    },
    {
     "description": "TURMERIC ACQUISITION CORP-A",
     "symbol": "TMPM"
    },
    {
     "description": "TURMERIC ACQUISITION CORP",
     "symbol": "TMPMU"
    },
    {
     "description": "TURMERIC ACQUISITION A -CW25",
     "symbol": "TMPMW"
    },
    {
     "description": "TIMES CHINA HOLDINGS LTD",
     "symbol": "TMPPF"
    },
    {
     "description": "TRILOGY METALS INC",
     "symbol": "TMQ"
    },
    {
     "description": "TOMRA SYSTEMS ASA",
     "symbol": "TMRAF"
    },
    {
     "description": "TOMRA SYSTEMS A\/S\/A -SP ADR",
     "symbol": "TMRAY"
    },
    {
     "description": "TEXAS MINERAL RESOURCES CORP",
     "symbol": "TMRC"
    },
    {
     "description": "TEMPUS RESOURCES LTD",
     "symbol": "TMRFF"
    },
    {
     "description": "TAMRON CO LTD",
     "symbol": "TMRNF"
    },
    {
     "description": "TEMIR CORP",
     "symbol": "TMRR"
    },
    {
     "description": "TRANSGLOBAL ASSETS INC",
     "symbol": "TMSH"
    },
    {
     "description": "TENNANT MINERALS LTD",
     "symbol": "TMSMF"
    },
    {
     "description": "TEMENOS AG-SP ADR",
     "symbol": "TMSNY"
    },
    {
     "description": "Thomson Reuters Corporation",
     "symbol": "TMSOF"
    },
    {
     "description": "TEAMSPIRIT INC",
     "symbol": "TMSPF"
    },
    {
     "description": "TIMKENSTEEL CORP",
     "symbol": "TMST"
    },
    {
     "description": "TECHMATRIX CORPORATION",
     "symbol": "TMTMF"
    },
    {
     "description": "TOROMONT INDUSTRIES LTD",
     "symbol": "TMTNF"
    },
    {
     "description": "T-MOBILE US INC",
     "symbol": "TMUS"
    },
    {
     "description": "DRX DLY 20+ YR TREAS BEAR 3X",
     "symbol": "TMV"
    },
    {
     "description": "TEAMVIEWER AG",
     "symbol": "TMVWF"
    },
    {
     "description": "TEAMVIEWER AG - UNSP ADR",
     "symbol": "TMVWY"
    },
    {
     "description": "TERMINIX GLOBAL HOLDINGS INC",
     "symbol": "TMX"
    },
    {
     "description": "TELEFONOS DE MEXICO SAB-L",
     "symbol": "TMXLF"
    },
    {
     "description": "TRIMAX CORP",
     "symbol": "TMXN"
    },
    {
     "description": "TMX GROUP LTD",
     "symbol": "TMXXF"
    },
    {
     "description": "DIREXION DLY SM CAP BULL 3X",
     "symbol": "TNA"
    },
    {
     "description": "TENAGA NASIONAL BHD",
     "symbol": "TNABF"
    },
    {
     "description": "TENAGA NASIONAL-SPONS ADR",
     "symbol": "TNABY"
    },
    {
     "description": "TANKE BIOSCIENCES CORP",
     "symbol": "TNBI"
    },
    {
     "description": "TENNANT CO",
     "symbol": "TNC"
    },
    {
     "description": "TC Energy Corporation",
     "symbol": "TNCAF"
    },
    {
     "description": "TAN CHONG MOTOR HOLDINGS BHD",
     "symbol": "TNCMF"
    },
    {
     "description": "TANDEM DIABETES CARE INC",
     "symbol": "TNDM"
    },
    {
     "description": "TRUE NORTH ENERGY CORP",
     "symbol": "TNEN"
    },
    {
     "description": "TRINET GROUP INC",
     "symbol": "TNET"
    },
    {
     "description": "TINEXTA SPA - UNSP ADR",
     "symbol": "TNEXY"
    },
    {
     "description": "TAMARACK VALLEY ENERGY LTD",
     "symbol": "TNEYF"
    },
    {
     "description": "TONGCHENG TRAVEL HOLDINGS LT",
     "symbol": "TNGCF"
    },
    {
     "description": "TONOGOLD RESOURCES INC",
     "symbol": "TNGL"
    },
    {
     "description": "TRUE NORTH GEMS INC",
     "symbol": "TNGMF"
    },
    {
     "description": "TENGION INC",
     "symbol": "TNGNQ"
    },
    {
     "description": "TANG PALACE CHINA HOLDINGS",
     "symbol": "TNGPF"
    },
    {
     "description": "THUNGELA RESOURCES LTD",
     "symbol": "TNGRF"
    },
    {
     "description": "TUNGSTEN WEST PLC",
     "symbol": "TNGWF"
    },
    {
     "description": "TANGO THERAPEUTICS INC",
     "symbol": "TNGX"
    },
    {
     "description": "TNG LTD",
     "symbol": "TNGZF"
    },
    {
     "description": "TIMES NEIGHBORHOOD HOLDINGS",
     "symbol": "TNHDF"
    },
    {
     "description": "TECHNIP SA",
     "symbol": "TNHPF"
    },
    {
     "description": "TONIES SE - A",
     "symbol": "TNIEF"
    },
    {
     "description": "TECNICAS REUNIDAS SA",
     "symbol": "TNISF"
    },
    {
     "description": "TECNICAS REUNIDAS SA-UNS ADR",
     "symbol": "TNISY"
    },
    {
     "description": "TIANJIN CAPITAL ENVIRON-H",
     "symbol": "TNJIF"
    },
    {
     "description": "TEEKAY TANKERS LTD-CLASS A",
     "symbol": "TNK"
    },
    {
     "description": "TANKE INC",
     "symbol": "TNKE"
    },
    {
     "description": "TRAVEL + LEISURE CO",
     "symbol": "TNL"
    },
    {
     "description": "TRAINLINE PLC",
     "symbol": "TNLIF"
    },
    {
     "description": "TRAINLINE PLC - UNSP ADR",
     "symbol": "TNLIY"
    },
    {
     "description": "TRANS-LUX CORP",
     "symbol": "TNLX"
    },
    {
     "description": "TENMA CORP",
     "symbol": "TNMAF"
    },
    {
     "description": "TITAN MINING CORP",
     "symbol": "TNMCF"
    },
    {
     "description": "TIANRONG MED GROUP INC",
     "symbol": "TNMD"
    },
    {
     "description": "WHITE METAL RESOURCES CORP",
     "symbol": "TNMLF"
    },
    {
     "description": "TEN LIFESTYLE GROUP PLC",
     "symbol": "TNNLF"
    },
    {
     "description": "TENOX CORP",
     "symbol": "TNOXF"
    },
    {
     "description": "TSAKOS ENERGY NAVIGATION LTD",
     "symbol": "TNP"
    },
    {
     "description": "TSAKOS ENERGY NAVIGATION",
     "symbol": "TNP.PRD"
    },
    {
     "description": "TSAKOS ENERGY NAVIGATION",
     "symbol": "TNP.PRE"
    },
    {
     "description": "TSAKOS ENERGY NAVIGATION",
     "symbol": "TNP.PRF"
    },
    {
     "description": "TIAN'AN PHARMACEUTICAL CO LT",
     "symbol": "TNPH"
    },
    {
     "description": "TEN PAO GROUP HOLDINGS LTD",
     "symbol": "TNPOF"
    },
    {
     "description": "TARANIS RESOURCES INC",
     "symbol": "TNREF"
    },
    {
     "description": "THUNDER ENERGIES CORP",
     "symbol": "TNRG"
    },
    {
     "description": "TITAN RESOURCES INTERNATIONA",
     "symbol": "TNRI"
    },
    {
     "description": "TENARIS SA",
     "symbol": "TNRSF"
    },
    {
     "description": "FINDEV INC",
     "symbol": "TNSGF"
    },
    {
     "description": "TITANIUM SANDS LTD",
     "symbol": "TNSMF"
    },
    {
     "description": "Transalta Corporation",
     "symbol": "TNSSF"
    },
    {
     "description": "JADE POWER TRUST",
     "symbol": "TNSTF"
    },
    {
     "description": "TINTRA PLC",
     "symbol": "TNTAF"
    },
    {
     "description": "TINTIC STANDARD GOLD MINES I",
     "symbol": "TNTC"
    },
    {
     "description": "POSTNL NV",
     "symbol": "TNTFF"
    },
    {
     "description": "TANTALUS SYSTEMS HOLDING INC",
     "symbol": "TNTLF"
    },
    {
     "description": "TRANSITION METALS CORP",
     "symbol": "TNTMF"
    },
    {
     "description": "TINTRI INC",
     "symbol": "TNTRQ"
    },
    {
     "description": "Toronto Dominion Bank",
     "symbol": "TNTTF"
    },
    {
     "description": "NR INSTANT PRODUCE PCL-CW23",
     "symbol": "TNVDF"
    },
    {
     "description": "ERAWAN GROUP PCL\/THE-CW24",
     "symbol": "TNVWF"
    },
    {
     "description": "TONIX PHARMACEUTICALS HOLDIN",
     "symbol": "TNXP"
    },
    {
     "description": "TALANX AG",
     "symbol": "TNXXF"
    },
    {
     "description": "TENAYA THERAPEUTICS INC",
     "symbol": "TNYA"
    },
    {
     "description": "TINLEY BEVERAGE CO INC\/THE",
     "symbol": "TNYBF"
    },
    {
     "description": "TINYBEANS GROUP PTY LTD",
     "symbol": "TNYYF"
    },
    {
     "description": "TALON 1 ACQUISITION CORP-A",
     "symbol": "TOAC"
    },
    {
     "description": "TALON 1 ACQUISITION CORP",
     "symbol": "TOACU"
    },
    {
     "description": "TALON 1 ACQUISITION COR-CW23",
     "symbol": "TOACW"
    },
    {
     "description": "TOAGOSEI CO LTD",
     "symbol": "TOAGF"
    },
    {
     "description": "TOA OIL CO LTD",
     "symbol": "TOAOF"
    },
    {
     "description": "TAAT GLOBAL ALTERNATIVES INC",
     "symbol": "TOBAF"
    },
    {
     "description": "TOM GROUP LTD",
     "symbol": "TOCOF"
    },
    {
     "description": "TOD'S SPA",
     "symbol": "TODGF"
    },
    {
     "description": "TONOPAH DIVIDE MINING",
     "symbol": "TODM"
    },
    {
     "description": "TOEI ANIMATION CO LTD",
     "symbol": "TOEAF"
    },
    {
     "description": "TOEI CO LTD",
     "symbol": "TOEIF"
    },
    {
     "description": "TOKYO ELECTRON LTD",
     "symbol": "TOELF"
    },
    {
     "description": "TOKYO ELECTRON LTD-UNSP ADR",
     "symbol": "TOELY"
    },
    {
     "description": "TORO ENERGY LTD",
     "symbol": "TOEYF"
    },
    {
     "description": "TOFUTTI BRANDS INC",
     "symbol": "TOFB"
    },
    {
     "description": "TOGA LTD",
     "symbol": "TOGL"
    },
    {
     "description": "TOMAGOLD CORP",
     "symbol": "TOGOF"
    },
    {
     "description": "TOHO ZINC CO LTD",
     "symbol": "TOHZF"
    },
    {
     "description": "ONCOLOGY INSTITUTE INC\/THE",
     "symbol": "TOI"
    },
    {
     "description": "ONCOLOGY INSTITUTE INC CW-22",
     "symbol": "TOIIW"
    },
    {
     "description": "3D OIL LTD",
     "symbol": "TOILF"
    },
    {
     "description": "THAI OIL PCL-FOREIGN",
     "symbol": "TOIPF"
    },
    {
     "description": "THAI OIL PCL - UNSP ADR",
     "symbol": "TOIPY"
    },
    {
     "description": "TOPICUS.COM INC-SUB VOTING",
     "symbol": "TOITF"
    },
    {
     "description": "ISHARES MSCI KOKUSAI ETF",
     "symbol": "TOK"
    },
    {
     "description": "TOKYO OHKA KOGYO CO LTD",
     "symbol": "TOKCF"
    },
    {
     "description": "CAMBRIA CANNABIS ETF",
     "symbol": "TOKE"
    },
    {
     "description": "OPTIMA MEDICAL INNOVATIONS C",
     "symbol": "TOKIF"
    },
    {
     "description": "TOKAI TOKYO FINANCI-SPON ADR",
     "symbol": "TOKTY"
    },
    {
     "description": "TOKYU CORP",
     "symbol": "TOKUF"
    },
    {
     "description": "TOKYU CORP-UNSPONSORED ADR",
     "symbol": "TOKUY"
    },
    {
     "description": "TOLL BROTHERS INC",
     "symbol": "TOL"
    },
    {
     "description": "TRICAN WELL SERVICE LTD",
     "symbol": "TOLWF"
    },
    {
     "description": "PROSHARES GLB INFRASTRUCTURE",
     "symbol": "TOLZ"
    },
    {
     "description": "TODOS MEDICAL LTD",
     "symbol": "TOMDF"
    },
    {
     "description": "TOMO HOLDINGS LTD",
     "symbol": "TOMOF"
    },
    {
     "description": "TOMMY CO LTD - UNSP ADR",
     "symbol": "TOMYY"
    },
    {
     "description": "TOMI ENVIRONMENTAL SOLUTIONS",
     "symbol": "TOMZ"
    },
    {
     "description": "TOENEC CORP",
     "symbol": "TONOF"
    },
    {
     "description": "TOPPAN INC",
     "symbol": "TONPF"
    },
    {
     "description": "TONNER-ONE WORLD HOLDINGS IN",
     "symbol": "TONR"
    },
    {
     "description": "THERMWOOD CORP",
     "symbol": "TOOD"
    },
    {
     "description": "TOPCON CORP",
     "symbol": "TOPCF"
    },
    {
     "description": "TOPPAN INC-APON ADR",
     "symbol": "TOPPY"
    },
    {
     "description": "TOP SHIPS INC",
     "symbol": "TOPS"
    },
    {
     "description": "TOPAZ RESOURCES INC",
     "symbol": "TOPZ"
    },
    {
     "description": "TORIKIZOKU HOLDINGS CO LTD",
     "symbol": "TORIF"
    },
    {
     "description": "TOR MINERALS INTERNATIONAL",
     "symbol": "TORM"
    },
    {
     "description": "VOLT CARBON TECHNOLOGIES INC",
     "symbol": "TORVF"
    },
    {
     "description": "TORRINGTON WATER CO",
     "symbol": "TORW"
    },
    {
     "description": "TOREX GOLD RESOURCES INC",
     "symbol": "TORXF"
    },
    {
     "description": "TOSHIBA CORP",
     "symbol": "TOSBF"
    },
    {
     "description": "TOSOH CORP",
     "symbol": "TOSCF"
    },
    {
     "description": "TOYO SEIKAN GROUP HOLDINGS L",
     "symbol": "TOSKF"
    },
    {
     "description": "TOAST INC-CLASS A",
     "symbol": "TOST"
    },
    {
     "description": "TOSHIBA CORP-UNSPONSORED ADR",
     "symbol": "TOSYY"
    },
    {
     "description": "TOTO LTD",
     "symbol": "TOTDF"
    },
    {
     "description": "TOTO LTD-UNSPONSORED ADR",
     "symbol": "TOTDY"
    },
    {
     "description": "SPDR DOUBLELINE TR TACT ETF",
     "symbol": "TOTL"
    },
    {
     "description": "T ROWE PRICE TOTAL RETURN ET",
     "symbol": "TOTR"
    },
    {
     "description": "TOYO TIRE CORP",
     "symbol": "TOTTF"
    },
    {
     "description": "TOTAL ENERGY SERVICES INC",
     "symbol": "TOTZF"
    },
    {
     "description": "TUNIU CORP-SPON ADR",
     "symbol": "TOUR"
    },
    {
     "description": "TOWNE BANK",
     "symbol": "TOWN"
    },
    {
     "description": "TOWER ONE WIRELESS CORP",
     "symbol": "TOWTF"
    },
    {
     "description": "TOYO CORP",
     "symbol": "TOYNF"
    },
    {
     "description": "TOYOTA MOTOR CORP",
     "symbol": "TOYOF"
    },
    {
     "description": "TOYS \"R\" US ANZ LTD",
     "symbol": "TOYRF"
    },
    {
     "description": "THAI PLASPAC PCL-NVDR",
     "symbol": "TPACF"
    },
    {
     "description": "ECOFIN DIGITAL PAYMENTS INFR",
     "symbol": "TPAY"
    },
    {
     "description": "TURNING POINT BRANDS INC",
     "symbol": "TPB"
    },
    {
     "description": "TPB ACQUISITION CORP I-CL A",
     "symbol": "TPBA"
    },
    {
     "description": "TPB ACQUISITION CORP I",
     "symbol": "TPBAU"
    },
    {
     "description": "TPB ACQUISITION CORP I-CL-CW",
     "symbol": "TPBAW"
    },
    {
     "description": "BETMAKERS TECHNOLOGY GROUP L",
     "symbol": "TPBTF"
    },
    {
     "description": "TUTOR PERINI CORP",
     "symbol": "TPC"
    },
    {
     "description": "TITAN LOGIX CORP",
     "symbol": "TPCFF"
    },
    {
     "description": "TECHPRECISION CORP",
     "symbol": "TPCS"
    },
    {
     "description": "TALON ENERGY LTD",
     "symbol": "TPDDF"
    },
    {
     "description": "TOPDANMARK A\/S-UNSPON ADR",
     "symbol": "TPDKY"
    },
    {
     "description": "TOPDANMARK A\/S",
     "symbol": "TPDNF"
    },
    {
     "description": "THAI PRESIDENT FOODS PCL",
     "symbol": "TPFPF"
    },
    {
     "description": "TPG INC",
     "symbol": "TPG"
    },
    {
     "description": "TPG TELECOM LTD",
     "symbol": "TPGTF"
    },
    {
     "description": "TOP GLOVE CORP BHD",
     "symbol": "TPGVF"
    },
    {
     "description": "TPG PACE BENEFICIAL FIN-CL A",
     "symbol": "TPGY"
    },
    {
     "description": "TPG PACE BENEFICIAL FINANCE",
     "symbol": "TPGY.U"
    },
    {
     "description": "TPG PACE BENEFICIAL A -CW27",
     "symbol": "TPGY.WS"
    },
    {
     "description": "TRI POINTE HOMES INC",
     "symbol": "TPH"
    },
    {
     "description": "TIMOTHY PLAN HIGH DVD STOCK",
     "symbol": "TPHD"
    },
    {
     "description": "TIMOTHY PLAN HIGH DIVIDEND S",
     "symbol": "TPHE"
    },
    {
     "description": "TOP FRONTIER INVESTMENT HOLD",
     "symbol": "TPHIF"
    },
    {
     "description": "TRINITY PLACE HOLDINGS INC",
     "symbol": "TPHS"
    },
    {
     "description": "MYCOTOPIA THERAPIES INC",
     "symbol": "TPIA"
    },
    {
     "description": "TPI COMPOSITES INC",
     "symbol": "TPIC"
    },
    {
     "description": "TIMOTHY PLAN INTERNATIONAL E",
     "symbol": "TPIF"
    },
    {
     "description": "TRIAD PRO INNOVATORS INC",
     "symbol": "TPII"
    },
    {
     "description": "TEXAS PACIFIC LAND CORP",
     "symbol": "TPL"
    },
    {
     "description": "TIMOTHY PLAN US LARGE\/MID CA",
     "symbol": "TPLC"
    },
    {
     "description": "TIMOTHY PLAN US LARGE\/MID CA",
     "symbol": "TPLE"
    },
    {
     "description": "PVA TEPLA AG",
     "symbol": "TPLKF"
    },
    {
     "description": "TEMPLE & WEBSTER GROUP LTD",
     "symbol": "TPLWF"
    },
    {
     "description": "CUB ENERGY INC",
     "symbol": "TPNEF"
    },
    {
     "description": "PULSE NETWORK INC\/THE",
     "symbol": "TPNI"
    },
    {
     "description": "THIRD POINT INVESTORS LTD",
     "symbol": "TPNTF"
    },
    {
     "description": "DRX DLY TRANSPORTS BULL 3X",
     "symbol": "TPOR"
    },
    {
     "description": "TMPOS INC",
     "symbol": "TPPM"
    },
    {
     "description": "TRIPLE P N.V.",
     "symbol": "TPPPF"
    },
    {
     "description": "TOP STRIKE RESOURCES CORP",
     "symbol": "TPPRF"
    },
    {
     "description": "TPG TELECOM LTD -UNSP ADR",
     "symbol": "TPPTY"
    },
    {
     "description": "TAPESTRY INC",
     "symbol": "TPR"
    },
    {
     "description": "GCM MINING CORP",
     "symbol": "TPRFF"
    },
    {
     "description": "TRAVIS PERKINS PLC-ADR",
     "symbol": "TPRKY"
    },
    {
     "description": "TOWER PROPERTIES CO",
     "symbol": "TPRP"
    },
    {
     "description": "GRAN COLOMBIA GOLD CORP-CW24",
     "symbol": "TPRXF"
    },
    {
     "description": "TIMOTHY PLAN US SMALL CAP CO",
     "symbol": "TPSC"
    },
    {
     "description": "TOPSPORTS INTERNATIONAL HOLD",
     "symbol": "TPSRF"
    },
    {
     "description": "TEMPEST THERAPEUTICS INC",
     "symbol": "TPST"
    },
    {
     "description": "TERRA PROPERTY TRUST",
     "symbol": "TPTA"
    },
    {
     "description": "TOPPS TILES PLC",
     "symbol": "TPTJF"
    },
    {
     "description": "TPT GLOBAL TECH INC",
     "symbol": "TPTW"
    },
    {
     "description": "TURNING POINT THERAPEUTICS I",
     "symbol": "TPTX"
    },
    {
     "description": "TRIPLEPOINT VENTURE GROWTH B",
     "symbol": "TPVG"
    },
    {
     "description": "TRUSTPOWER LTD",
     "symbol": "TPWRF"
    },
    {
     "description": "TEMPUR SEALY INTERNATIONAL I",
     "symbol": "TPX"
    },
    {
     "description": "TORTOISE NORTH AMERICAN PIPE",
     "symbol": "TPYP"
    },
    {
     "description": "TORTOISE POWER & ENRGY INFRA",
     "symbol": "TPZ"
    },
    {
     "description": "TOPAZ ENERGY CORP",
     "symbol": "TPZEF"
    },
    {
     "description": "TORQUE LIFESTYLE BRANDS INC",
     "symbol": "TQLB"
    },
    {
     "description": "PROSHARES ULTRAPRO QQQ",
     "symbol": "TQQQ"
    },
    {
     "description": "TOOTSIE ROLL INDS",
     "symbol": "TR"
    },
    {
     "description": "TRAACK TECHNOLOGIES INC",
     "symbol": "TRAA"
    },
    {
     "description": "TRACK DATA CORP",
     "symbol": "TRAC"
    },
    {
     "description": "TRITON AMERICAN ENERGY CORP",
     "symbol": "TRAE"
    },
    {
     "description": "TERAGO INC",
     "symbol": "TRAGF"
    },
    {
     "description": "TRINE II ACQUISITION CORP -A",
     "symbol": "TRAQ"
    },
    {
     "description": "TRINE II ACQUISITION CORP",
     "symbol": "TRAQ.U"
    },
    {
     "description": "TRINE II ACQ CL A -CW27",
     "symbol": "TRAQ.WS"
    },
    {
     "description": "TERAS RESOURCES INC",
     "symbol": "TRARF"
    },
    {
     "description": "TRATON SE",
     "symbol": "TRATF"
    },
    {
     "description": "TRANSURBAN GROUP",
     "symbol": "TRAUF"
    },
    {
     "description": "TURBODYNE TECHNOLOGIES INC",
     "symbol": "TRBD"
    },
    {
     "description": "TRADITIONS BANCORP INC",
     "symbol": "TRBK"
    },
    {
     "description": "TORQ RESOURCES INC",
     "symbol": "TRBMF"
    },
    {
     "description": "TURBO GLOBAL PARTNERS INC",
     "symbol": "TRBO"
    },
    {
     "description": "TRB SYSTEMS INTL INC",
     "symbol": "TRBX"
    },
    {
     "description": "TEJON RANCH CO",
     "symbol": "TRC"
    },
    {
     "description": "TWIN RIDGE CAPITAL ACQUISI-A",
     "symbol": "TRCA"
    },
    {
     "description": "TWIN RIDGE CAPITAL ACQUISITI",
     "symbol": "TRCA.U"
    },
    {
     "description": "TWIN RIDGE CAPITAL ACQ -CW28",
     "symbol": "TRCA.WS"
    },
    {
     "description": "TRACCOM INC",
     "symbol": "TRCC"
    },
    {
     "description": "TRACK GROUP INC",
     "symbol": "TRCK"
    },
    {
     "description": "TRANSCOSMOS INC",
     "symbol": "TRCLF"
    },
    {
     "description": "TRANSNATIONAL CANNABIS LTD",
     "symbol": "TRCNF"
    },
    {
     "description": "TRACTION URANIUM CORP",
     "symbol": "TRCTF"
    },
    {
     "description": "TRI CITY BANKSHARES CORP",
     "symbol": "TRCY"
    },
    {
     "description": "ENTRADA THERAPEUTICS INC",
     "symbol": "TRDA"
    },
    {
     "description": "NEXTGEN TREND AND DEFEND ETF",
     "symbol": "TRDF"
    },
    {
     "description": "TREND EXPLORATION INC",
     "symbol": "TRDX"
    },
    {
     "description": "TERNA ENERGY SA",
     "symbol": "TREAF"
    },
    {
     "description": "TERNA ENERGY SA-UNSP ADR",
     "symbol": "TREAY"
    },
    {
     "description": "TRECORA RESOURCES",
     "symbol": "TREC"
    },
    {
     "description": "LENDINGTREE INC",
     "symbol": "TREE"
    },
    {
     "description": "TREATMENT.COM INTERNATIONAL",
     "symbol": "TREIF"
    },
    {
     "description": "TREND INNOVATIONS HOLDING IN",
     "symbol": "TREN"
    },
    {
     "description": "TRUCEPT INC",
     "symbol": "TREP"
    },
    {
     "description": "TREVALI MINING CORP",
     "symbol": "TREVF"
    },
    {
     "description": "TREX COMPANY INC",
     "symbol": "TREX"
    },
    {
     "description": "TRUFIN PLC",
     "symbol": "TRFNF"
    },
    {
     "description": "TRIPLE FLAG PRECIOUS MET",
     "symbol": "TRFPF"
    },
    {
     "description": "TARGET CAPITAL INC",
     "symbol": "TRGCF"
    },
    {
     "description": "TARACHI GOLD CORP",
     "symbol": "TRGGF"
    },
    {
     "description": "TARGETED MEDICAL PHARMA INC",
     "symbol": "TRGM"
    },
    {
     "description": "TRANSGENE SA",
     "symbol": "TRGNF"
    },
    {
     "description": "TARGA RESOURCES CORP",
     "symbol": "TRGP"
    },
    {
     "description": "TABULA RASA HEALTHCARE INC",
     "symbol": "TRHC"
    },
    {
     "description": "THOMSON REUTERS CORP",
     "symbol": "TRI"
    },
    {
     "description": "TRINITY BIOTECH PLC-SPON ADR",
     "symbol": "TRIB"
    },
    {
     "description": "TRIO INDUSTRIES GROUP INC",
     "symbol": "TRIG"
    },
    {
     "description": "TRIO RESOURCES INC",
     "symbol": "TRII"
    },
    {
     "description": "TRINITY CAPITAL INC",
     "symbol": "TRIN"
    },
    {
     "description": "TRIPADVISOR INC",
     "symbol": "TRIP"
    },
    {
     "description": "TRAQIQ INC",
     "symbol": "TRIQ"
    },
    {
     "description": "TRITERRAS INC-CLASS A",
     "symbol": "TRIRF"
    },
    {
     "description": "TRITERRAS INC-CLASS A -CW21",
     "symbol": "TRIRW"
    },
    {
     "description": "TRISTAR ACQUISITION I CORP-A",
     "symbol": "TRIS"
    },
    {
     "description": "TRISTAR ACQUISITION I CORP",
     "symbol": "TRIS.U"
    },
    {
     "description": "TRISTAR ACQ I CL A -CW28",
     "symbol": "TRIS.WS"
    },
    {
     "description": "TRI-TECH HOLDING INC",
     "symbol": "TRITF"
    },
    {
     "description": "TRAJAN GROUP HOLDINGS LTD",
     "symbol": "TRJNF"
    },
    {
     "description": "TROIKA MEDIA GROUP INC",
     "symbol": "TRKA"
    },
    {
     "description": "TROIKA MEDIA GROUP INC -CW28",
     "symbol": "TRKAW"
    },
    {
     "description": "TRICKLESTAR PTE LTD",
     "symbol": "TRKLF"
    },
    {
     "description": "TURK TELEKOMUNIKASYON AS",
     "symbol": "TRKNF"
    },
    {
     "description": "TURK TELEKOMUNIKA-UNSPON ADR",
     "symbol": "TRKNY"
    },
    {
     "description": "TRACKER CORP OF AMERICA",
     "symbol": "TRKR"
    },
    {
     "description": "TARKU RESOURCES LTD",
     "symbol": "TRKUF"
    },
    {
     "description": "TREK RESOURCES INC\/DE",
     "symbol": "TRKX"
    },
    {
     "description": "TURKIYE SINAI KALKINMA-ADR",
     "symbol": "TRKYY"
    },
    {
     "description": "TRILINC GLOBAL IMPACT FUND",
     "symbol": "TRLC"
    },
    {
     "description": "THREEGOLD RESOURCES INC",
     "symbol": "TRLDF"
    },
    {
     "description": "TRILLION ENERGY INTERNATIONA",
     "symbol": "TRLEF"
    },
    {
     "description": "MAVEN BRANDS INC",
     "symbol": "TRLFF"
    },
    {
     "description": "TRILOGIQ",
     "symbol": "TRLQF"
    },
    {
     "description": "TRIMBLE INC",
     "symbol": "TRMB"
    },
    {
     "description": "TORM PLC-A",
     "symbol": "TRMD"
    },
    {
     "description": "TRUSTMARK CORP",
     "symbol": "TRMK"
    },
    {
     "description": "TOURMALINE OIL CORP",
     "symbol": "TRMLF"
    },
    {
     "description": "NEW WAVE HOLDINGS CORP",
     "symbol": "TRMNF"
    },
    {
     "description": "TREMOR INTERNATIONAL LTD-ADR",
     "symbol": "TRMR"
    },
    {
     "description": "TRINITY INDUSTRIES INC",
     "symbol": "TRN"
    },
    {
     "description": "PACER TRENDPILOT FUNDS OF FD",
     "symbol": "TRND"
    },
    {
     "description": "TARONIS FUELS INC",
     "symbol": "TRNF"
    },
    {
     "description": "TRENDLINES GROUP LTD\/THE",
     "symbol": "TRNGF"
    },
    {
     "description": "TRENDLINES GROUP LT-SPON ADR",
     "symbol": "TRNLY"
    },
    {
     "description": "TERRENO REALTY CORP",
     "symbol": "TRNO"
    },
    {
     "description": "Transalta Corporation",
     "symbol": "TRNPF"
    },
    {
     "description": "TRANSCAT INC",
     "symbol": "TRNS"
    },
    {
     "description": "TARONIS TECHNOLOGIES INC",
     "symbol": "TRNX"
    },
    {
     "description": "TRIUMPH OIL & GAS",
     "symbol": "TROG"
    },
    {
     "description": "NEWORIGIN GOLD CORP",
     "symbol": "TROIF"
    },
    {
     "description": "TOOTSIE ROLL INDUSTRIES-CL B",
     "symbol": "TROLB"
    },
    {
     "description": "CORNER GROWTH ACQUISITION -A",
     "symbol": "TRON"
    },
    {
     "description": "CORNER GROWTH ACQUISITION CO",
     "symbol": "TRONU"
    },
    {
     "description": "CORNER GROWTH ACQUISITI-CW23",
     "symbol": "TRONW"
    },
    {
     "description": "TROOPS INC",
     "symbol": "TROO"
    },
    {
     "description": "TROUBADOUR RESOURCES INC",
     "symbol": "TROUF"
    },
    {
     "description": "T ROWE PRICE GROUP INC",
     "symbol": "TROW"
    },
    {
     "description": "TRONOX HOLDINGS PLC- A",
     "symbol": "TROX"
    },
    {
     "description": "TC ENERGY CORP",
     "symbol": "TRP"
    },
    {
     "description": "TRIP.COM GROUP LTD",
     "symbol": "TRPCF"
    },
    {
     "description": "TC Energy Corporation",
     "symbol": "TRPFF"
    },
    {
     "description": "PACER MET US LRG CAP DVD 300",
     "symbol": "TRPL"
    },
    {
     "description": "3R PETE OLEO E - UNSP ADR",
     "symbol": "TRPOY"
    },
    {
     "description": "TRIP TECHNOLOGIES INC",
     "symbol": "TRPS"
    },
    {
     "description": "TRIBE PROPERTY TECHNOLOGIES",
     "symbol": "TRPTF"
    },
    {
     "description": "TURQUOISE HILL RESOURCES LTD",
     "symbol": "TRQ"
    },
    {
     "description": "TRIPBORN INC",
     "symbol": "TRRB"
    },
    {
     "description": "TERRA ENERGY RESOURCES LTD",
     "symbol": "TRRE"
    },
    {
     "description": "TRIFECTA GOLD LTD",
     "symbol": "TRRFF"
    },
    {
     "description": "TRANSATLANTIC MINING CORP",
     "symbol": "TRRGF"
    },
    {
     "description": "TRINITY RESOURCES INC",
     "symbol": "TRRI"
    },
    {
     "description": "TORRENT CAPITAL LTD",
     "symbol": "TRRPF"
    },
    {
     "description": "TRISURA GROUP LTD",
     "symbol": "TRRSF"
    },
    {
     "description": "TERRAVEST INDUSTRIES INC",
     "symbol": "TRRVF"
    },
    {
     "description": "TNR GOLD CORP",
     "symbol": "TRRXF"
    },
    {
     "description": "TRIMAS CORP",
     "symbol": "TRS"
    },
    {
     "description": "3SBIO INC",
     "symbol": "TRSBF"
    },
    {
     "description": "TRES-OR RESOURCES LTD",
     "symbol": "TRSFF"
    },
    {
     "description": "TROPHY RESOURCES INC",
     "symbol": "TRSI"
    },
    {
     "description": "TERRASCEND CORP",
     "symbol": "TRSSF"
    },
    {
     "description": "TRUSTCO BANK CORP NY",
     "symbol": "TRST"
    },
    {
     "description": "TREASURE ASA",
     "symbol": "TRSUF"
    },
    {
     "description": "TRANSALTA RENEWABLES INC",
     "symbol": "TRSWF"
    },
    {
     "description": "TRIO-TECH INTERNATIONAL",
     "symbol": "TRT"
    },
    {
     "description": "TRANSTECH INDUSTRIES INC",
     "symbol": "TRTI"
    },
    {
     "description": "TORTEC GROUP CORP",
     "symbol": "TRTK"
    },
    {
     "description": "TORTOISEECOFIN ACQUISITION-A",
     "symbol": "TRTL"
    },
    {
     "description": "TORTOISEECOFIN ACQUISITION C",
     "symbol": "TRTL.U"
    },
    {
     "description": "TORTOISEECOFIN ACQUISIT-CW",
     "symbol": "TRTL.WS"
    },
    {
     "description": "TRITON INTERNATIONAL LTD",
     "symbol": "TRTN"
    },
    {
     "description": "TRITON INTERNATIONAL LTD",
     "symbol": "TRTN.PRA"
    },
    {
     "description": "TRITON INTERNATIONAL LTD",
     "symbol": "TRTN.PRB"
    },
    {
     "description": "TRITON INTERNATIONAL LTD",
     "symbol": "TRTN.PRC"
    },
    {
     "description": "TRITON INTERNATIONAL LTD",
     "symbol": "TRTN.PRD"
    },
    {
     "description": "TRITON INTERNATIONAL LTD",
     "symbol": "TRTN.PRE"
    },
    {
     "description": "TRUSTPILOT AS",
     "symbol": "TRTPF"
    },
    {
     "description": "TPG RE FINANCE TRUST INC",
     "symbol": "TRTX"
    },
    {
     "description": "TPG RE FINANCE TRUST INC",
     "symbol": "TRTX.PRC"
    },
    {
     "description": "CAMBRIA TRINITY ETF",
     "symbol": "TRTY"
    },
    {
     "description": "TRANSUNION",
     "symbol": "TRU"
    },
    {
     "description": "TRIUMPH APPAREL CORP",
     "symbol": "TRUA"
    },
    {
     "description": "TRUECAR INC",
     "symbol": "TRUE"
    },
    {
     "description": "RED LIGHT HOLLAND CORP",
     "symbol": "TRUFF"
    },
    {
     "description": "TRULY INTERNATIONAL HOLDINGS",
     "symbol": "TRUHF"
    },
    {
     "description": "TRULY INTL HLDGS-SPONS A",
     "symbol": "TRUHY"
    },
    {
     "description": "TRU PRECIOUS METALS CORP",
     "symbol": "TRUIF"
    },
    {
     "description": "TRULITE INC",
     "symbol": "TRUL"
    },
    {
     "description": "TERUMO CORP",
     "symbol": "TRUMF"
    },
    {
     "description": "TERUMO CORP-UNSPON ADR",
     "symbol": "TRUMY"
    },
    {
     "description": "TRUPANION INC",
     "symbol": "TRUP"
    },
    {
     "description": "TRUXTON CORP",
     "symbol": "TRUX"
    },
    {
     "description": "TRAVELERS COS INC\/THE",
     "symbol": "TRV"
    },
    {
     "description": "TRIVAGO NV - ADR",
     "symbol": "TRVG"
    },
    {
     "description": "TREVI THERAPEUTICS INC",
     "symbol": "TRVI"
    },
    {
     "description": "TREVENA INC",
     "symbol": "TRVN"
    },
    {
     "description": "TWO RIVERS FINANCIAL GROUP",
     "symbol": "TRVR"
    },
    {
     "description": "TRUWORTHS INTERNATIONAL LTD",
     "symbol": "TRWKF"
    },
    {
     "description": "TRAWELL CO SPA-SPON ADR",
     "symbol": "TRWLY"
    },
    {
     "description": "TANZANIAN GOLD CORP",
     "symbol": "TRX"
    },
    {
     "description": "TREX ACQUISITION CORP",
     "symbol": "TRXA"
    },
    {
     "description": "TRANSENTERIX INC-CW25",
     "symbol": "TRXDW"
    },
    {
     "description": "TRINITY EXPLORATION & PRODUC",
     "symbol": "TRXEF"
    },
    {
     "description": "COLUMBINE VALLEY RESOURCES I",
     "symbol": "TRXO"
    },
    {
     "description": "TORII PHARMACEUTICAL CO LTD",
     "symbol": "TRXPF"
    },
    {
     "description": "TORAY INDUSTRIES INC",
     "symbol": "TRYIF"
    },
    {
     "description": "TORAY INDUSTRIES-UNSPON ADR",
     "symbol": "TRYIY"
    },
    {
     "description": "TREASURY METALS -CW23",
     "symbol": "TRYMF"
    },
    {
     "description": "SONICSHARES AIR HOTEL CRUISE",
     "symbol": "TRYP"
    },
    {
     "description": "TRYP THERAPEUTICS INC",
     "symbol": "TRYPF"
    },
    {
     "description": "TROY RESOURCES LTD",
     "symbol": "TRYRF"
    },
    {
     "description": "BESSOR MINERALS INC",
     "symbol": "TRYXF"
    },
    {
     "description": "TRANSAT A.T. INC",
     "symbol": "TRZBF"
    },
    {
     "description": "TOURISM HOLDINGS LIMITED",
     "symbol": "TRZHF"
    },
    {
     "description": "TENARIS SA-ADR",
     "symbol": "TS"
    },
    {
     "description": "TSAKER CHEMICAL GROUP LTD",
     "symbol": "TSAKF"
    },
    {
     "description": "TELESAT CORP",
     "symbol": "TSAT"
    },
    {
     "description": "TOUCHSTONE BANKSHARES INC",
     "symbol": "TSBA"
    },
    {
     "description": "TIMBERLAND BANCORP INC",
     "symbol": "TSBK"
    },
    {
     "description": "TRISTATE CAPITAL HLDGS INC",
     "symbol": "TSC"
    },
    {
     "description": "TUSCANY ENERGY LTD",
     "symbol": "TSCAF"
    },
    {
     "description": "TRISTATE CAPITAL HLDGS",
     "symbol": "TSCAP"
    },
    {
     "description": "TRISTATE CAPITAL HLDGS",
     "symbol": "TSCBP"
    },
    {
     "description": "TECHNOLOGY SOLUTIONS CO",
     "symbol": "TSCC"
    },
    {
     "description": "TESCO PLC",
     "symbol": "TSCDF"
    },
    {
     "description": "TESCO PLC-SPONSORED ADR",
     "symbol": "TSCDY"
    },
    {
     "description": "TISCO FINANCIAL GRO-UNSP ADR",
     "symbol": "TSCFY"
    },
    {
     "description": "TRUSTCO GROUP HOLDING-SP ADR",
     "symbol": "TSCHY"
    },
    {
     "description": "TISCO FINANCIAL-FOREIGN",
     "symbol": "TSCIF"
    },
    {
     "description": "TOYO SECURITIES CO LTD",
     "symbol": "TSCLF"
    },
    {
     "description": "TRACTOR SUPPLY COMPANY",
     "symbol": "TSCO"
    },
    {
     "description": "TESSENDERLO GROUP",
     "symbol": "TSDOF"
    },
    {
     "description": "TSODILO RESOURCES LTD",
     "symbol": "TSDRF"
    },
    {
     "description": "TRINSEO PLC",
     "symbol": "TSE"
    },
    {
     "description": "TOWER SEMICONDUCTOR LTD",
     "symbol": "TSEM"
    },
    {
     "description": "TOSEI REIT INVESTMENT CORP",
     "symbol": "TSEQF"
    },
    {
     "description": "TSUGAMI CORP",
     "symbol": "TSGMF"
    },
    {
     "description": "TSUGAMI CORP-UNSPON ADR",
     "symbol": "TSGMY"
    },
    {
     "description": "TSINGTAO BREWERY CO LTD-H",
     "symbol": "TSGTF"
    },
    {
     "description": "TSINGTAO BREWERY-SPONS ADR",
     "symbol": "TSGTY"
    },
    {
     "description": "TRISTAR GOLD INC",
     "symbol": "TSGZF"
    },
    {
     "description": "TAYSHA GENE THERAPIES INC",
     "symbol": "TSHA"
    },
    {
     "description": "TOSHO CO LTD",
     "symbol": "TSHCF"
    },
    {
     "description": "SHIBAURA MACHINE CO-UNSP ADR",
     "symbol": "TSHMY"
    },
    {
     "description": "TRADESHOW MARKETING CO LTD",
     "symbol": "TSHO"
    },
    {
     "description": "TOSHIBA TEC CORP-UNSP ADR",
     "symbol": "TSHTY"
    },
    {
     "description": "TCW STRATEGIC INCOME FUND",
     "symbol": "TSI"
    },
    {
     "description": "TISHMAN SPEYER INNOVATI-CL A",
     "symbol": "TSIB"
    },
    {
     "description": "TISHMAN SPEYER INNOVATION CO",
     "symbol": "TSIBU"
    },
    {
     "description": "TISHMAN SPEYER IN CL A -CW27",
     "symbol": "TSIBW"
    },
    {
     "description": "TSI HOLDINGS CO LTD",
     "symbol": "TSIHF"
    },
    {
     "description": "TOP SHELF INTERNATIONAL HOLD",
     "symbol": "TSIIF"
    },
    {
     "description": "361 DEGREES INTERNATIONAL",
     "symbol": "TSIOF"
    },
    {
     "description": "INNOVATOR TRIPLE STACKER-JAN",
     "symbol": "TSJA"
    },
    {
     "description": "TALISKER RESOURCES LTD",
     "symbol": "TSKFF"
    },
    {
     "description": "TESLA INC",
     "symbol": "TSLA"
    },
    {
     "description": "TASSAL GROUP LTD",
     "symbol": "TSLLF"
    },
    {
     "description": "THINKSMART LTD",
     "symbol": "TSLMF"
    },
    {
     "description": "LOTUS'S RETAIL GROWTH FREEHO",
     "symbol": "TSLRF"
    },
    {
     "description": "TransAlta Corporation",
     "symbol": "TSLTF"
    },
    {
     "description": "TIER ONE SILVER INC",
     "symbol": "TSLVF"
    },
    {
     "description": "SIXTH STREET SPECIALTY LENDI",
     "symbol": "TSLX"
    },
    {
     "description": "TAIWAN SEMICONDUCTOR-SP ADR",
     "symbol": "TSM"
    },
    {
     "description": "TSUMURA & CO",
     "symbol": "TSMRF"
    },
    {
     "description": "TALLINNA SADAM AS",
     "symbol": "TSMTF"
    },
    {
     "description": "TAIWAN SEMICONDUCTOR MANUFAC",
     "symbol": "TSMWF"
    },
    {
     "description": "TYSON FOODS INC-CL A",
     "symbol": "TSN"
    },
    {
     "description": "TECHNISCAN INC",
     "symbol": "TSNI"
    },
    {
     "description": "TRISTEL PLC",
     "symbol": "TSNLF"
    },
    {
     "description": "INNOVATOR TRIPLE STACKER OCT",
     "symbol": "TSOC"
    },
    {
     "description": "TAISEI ONCHO CO LTD",
     "symbol": "TSOCF"
    },
    {
     "description": "THERAPEUTIC SOLUTIONS INTERN",
     "symbol": "TSOI"
    },
    {
     "description": "TESORO RESOURCES LTD",
     "symbol": "TSORF"
    },
    {
     "description": "TUSIMPLE HOLDINGS INC - A",
     "symbol": "TSP"
    },
    {
     "description": "T ROWE PRICE US EQY RESEARCH",
     "symbol": "TSPA"
    },
    {
     "description": "CLEANAWAY WASTE MANAGEMENT L",
     "symbol": "TSPCF"
    },
    {
     "description": "TGI SOLAR POWER GROUP INC",
     "symbol": "TSPG"
    },
    {
     "description": "TORISHIMA PUMP MFG CO LTD",
     "symbol": "TSPPF"
    },
    {
     "description": "TCW SPECIAL PURPOSE ACQ-CL A",
     "symbol": "TSPQ"
    },
    {
     "description": "TCW SPECIAL PURPOSE ACQUISIT",
     "symbol": "TSPQ.U"
    },
    {
     "description": "TCW SPECIAL PURPOSE AC- CW28",
     "symbol": "TSPQ.WS"
    },
    {
     "description": "TOWNSQUARE MEDIA INC - CL A",
     "symbol": "TSQ"
    },
    {
     "description": "TSR INC",
     "symbol": "TSRI"
    },
    {
     "description": "TREASURY METALS INC",
     "symbol": "TSRMF"
    },
    {
     "description": "TRADESTAR RESOURCES CORP",
     "symbol": "TSRR"
    },
    {
     "description": "PACIFIC CURRENT GROUP LTD",
     "symbol": "TSRUF"
    },
    {
     "description": "TREASURY WINE ESTATES LTD",
     "symbol": "TSRYF"
    },
    {
     "description": "TREASURY WINE ESTATES-ADR",
     "symbol": "TSRYY"
    },
    {
     "description": "TSS INC",
     "symbol": "TSSI"
    },
    {
     "description": "TSUTSUMI JEWELRY CO LTD",
     "symbol": "TSSJF"
    },
    {
     "description": "TISSUE REGENIX GROUP PLC",
     "symbol": "TSSNF"
    },
    {
     "description": "TRENDSETTER SOLAR PRODUCTS",
     "symbol": "TSSP"
    },
    {
     "description": "TESSI SA",
     "symbol": "TSSZF"
    },
    {
     "description": "THAT MARKETING SOLUTION INC",
     "symbol": "TSTS"
    },
    {
     "description": "TSE SUI LUEN JEWELLERY INTL",
     "symbol": "TSUIF"
    },
    {
     "description": "TOYO SUISAN KAISHA LTD",
     "symbol": "TSUKF"
    },
    {
     "description": "TOYO SUISAN KAISHA-UNSP ADR",
     "symbol": "TSUKY"
    },
    {
     "description": "TSUKURUBA INC",
     "symbol": "TSURF"
    },
    {
     "description": "TSURUHA HOLDINGS INC",
     "symbol": "TSUSF"
    },
    {
     "description": "TEAM17 GROUP PLC",
     "symbol": "TSVNF"
    },
    {
     "description": "2SEVENTY BIO INC",
     "symbol": "TSVT"
    },
    {
     "description": "TRAVELSKY TECHNOLOGY LTD-H",
     "symbol": "TSYHF"
    },
    {
     "description": "TRAVELSKY TECHNOLOGY-ADR H",
     "symbol": "TSYHY"
    },
    {
     "description": "TERRA SYSTEMS INC",
     "symbol": "TSYI"
    },
    {
     "description": "TSRC CORP",
     "symbol": "TSYRF"
    },
    {
     "description": "TRANE TECHNOLOGIES PLC",
     "symbol": "TT"
    },
    {
     "description": "FCF US QUALITY ETF",
     "symbol": "TTAC"
    },
    {
     "description": "FCF INTERNATIONAL QUALITY ET",
     "symbol": "TTAI"
    },
    {
     "description": "TERVEYSTALO OYJ",
     "symbol": "TTALF"
    },
    {
     "description": "TTW PCL",
     "symbol": "TTAPF"
    },
    {
     "description": "TTW PCL            -UNSP ADR",
     "symbol": "TTAPY"
    },
    {
     "description": "TRITAX EUROBOX PLC",
     "symbol": "TTAXF"
    },
    {
     "description": "TATA CONSUMER PROD-ADR SPONS",
     "symbol": "TTAZF"
    },
    {
     "description": "2020 BULKERS LTD",
     "symbol": "TTBKF"
    },
    {
     "description": "TOTAL BRAIN LTD",
     "symbol": "TTBLF"
    },
    {
     "description": "TRITAX BIG BOX REIT PLC",
     "symbol": "TTBXF"
    },
    {
     "description": "TORO CO",
     "symbol": "TTC"
    },
    {
     "description": "TS TECH CO LTD",
     "symbol": "TTCAF"
    },
    {
     "description": "TATTOOED CHEF INC",
     "symbol": "TTCF"
    },
    {
     "description": "DIGITAL TELECOMMUNICATIONS",
     "symbol": "TTCFF"
    },
    {
     "description": "TITAN CEMENT INTERNATIONAL T",
     "symbol": "TTCIF"
    },
    {
     "description": "TAUTACHROME INC",
     "symbol": "TTCM"
    },
    {
     "description": "TELIT COMMUNICATIONS PLC",
     "symbol": "TTCNF"
    },
    {
     "description": "TRADE DESK INC\/THE -CLASS A",
     "symbol": "TTD"
    },
    {
     "description": "TDK CORP",
     "symbol": "TTDKF"
    },
    {
     "description": "TDK CORP-SPONSORED ADR",
     "symbol": "TTDKY"
    },
    {
     "description": "TOTALENERGIES SE -SPON ADR",
     "symbol": "TTE"
    },
    {
     "description": "TTEC HOLDINGS INC",
     "symbol": "TTEC"
    },
    {
     "description": "TETRA TECH INC",
     "symbol": "TTEK"
    },
    {
     "description": "BULLION GOLD RESOURCES CORP",
     "symbol": "TTEXF"
    },
    {
     "description": "3AM TECHNOLOGIES INC",
     "symbol": "TTEZ"
    },
    {
     "description": "TOTALENERGIES SE",
     "symbol": "TTFNF"
    },
    {
     "description": "TT ELECTRONICS PLC",
     "symbol": "TTGPF"
    },
    {
     "description": "TECHTARGET",
     "symbol": "TTGT"
    },
    {
     "description": "TITANIUM HOLDINGS GROUP INC",
     "symbol": "TTHG"
    },
    {
     "description": "TETHYS OIL AB",
     "symbol": "TTHYF"
    },
    {
     "description": "TETRA TECHNOLOGIES INC",
     "symbol": "TTI"
    },
    {
     "description": "TERTIARY MINERALS PLC",
     "symbol": "TTIRF"
    },
    {
     "description": "TOTAL HELIUM LTD",
     "symbol": "TTLHF"
    },
    {
     "description": "TOTAL TELCOM INC",
     "symbol": "TTLTF"
    },
    {
     "description": "TANTALEX RESOURCES CORP",
     "symbol": "TTLXF"
    },
    {
     "description": "TATA MOTORS LTD-SPON ADR",
     "symbol": "TTM"
    },
    {
     "description": "TTM TECHNOLOGIES",
     "symbol": "TTMI"
    },
    {
     "description": "DIGITAL TELECOMMUNICATIONS-F",
     "symbol": "TTMMF"
    },
    {
     "description": "TRITON MINERALS LTD",
     "symbol": "TTMNF"
    },
    {
     "description": "THAI METAL DRUM PCL-NVDR",
     "symbol": "TTMTF"
    },
    {
     "description": "DATABLE TECHNOLOGY CORP",
     "symbol": "TTMZF"
    },
    {
     "description": "TECHTRONIC INDUSTRIES CO LTD",
     "symbol": "TTNDF"
    },
    {
     "description": "TECHTRONIC INDUSTRIES-SP ADR",
     "symbol": "TTNDY"
    },
    {
     "description": "TITAN NRG",
     "symbol": "TTNN"
    },
    {
     "description": "TOHO TITANIUM CO LTD",
     "symbol": "TTNNF"
    },
    {
     "description": "TITAN PHARMACEUTICALS INC",
     "symbol": "TTNP"
    },
    {
     "description": "TITAN PHARMACEUTICALS I-CW24",
     "symbol": "TTNPW"
    },
    {
     "description": "TITANIUM GROUP LTD",
     "symbol": "TTNUF"
    },
    {
     "description": "TOFAS TURK OTOMOBIL FABRIKA",
     "symbol": "TTOFF"
    },
    {
     "description": "T2 BIOSYSTEMS INC",
     "symbol": "TTOO"
    },
    {
     "description": "TORONTO PICTURES INC",
     "symbol": "TTOPF"
    },
    {
     "description": "TORTOISE PIPELINE & ENERGY",
     "symbol": "TTP"
    },
    {
     "description": "TELSTRA CORP LTD",
     "symbol": "TTRAF"
    },
    {
     "description": "TERRA ENERGY CORP",
     "symbol": "TTRHF"
    },
    {
     "description": "TURK TRAKTOR VE ZIRAAT MAKIN",
     "symbol": "TTRKF"
    },
    {
     "description": "TILE SHOP HLDGS INC",
     "symbol": "TTSH"
    },
    {
     "description": "TARTISAN NICKEL CORP",
     "symbol": "TTSRF"
    },
    {
     "description": "PROSHARES ULT -3X 20+ YR TSY",
     "symbol": "TTT"
    },
    {
     "description": "TITANIUM TRANSPORTATION GROU",
     "symbol": "TTTGF"
    },
    {
     "description": "TITAN MINERALS LTD",
     "symbol": "TTTNF"
    },
    {
     "description": "TREMOR INTERNATIONAL LTD",
     "symbol": "TTTPF"
    },
    {
     "description": "TREATT PLC",
     "symbol": "TTTRF"
    },
    {
     "description": "TRUTRACE TECHNOLOGIES INC",
     "symbol": "TTTSF"
    },
    {
     "description": "TOKYU FUDOSAN HOLDINGS CORP",
     "symbol": "TTUUF"
    },
    {
     "description": "TAKE-TWO INTERACTIVE SOFTWRE",
     "symbol": "TTWO"
    },
    {
     "description": "TTW PCL - FOREIGN SHARES",
     "symbol": "TTWPF"
    },
    {
     "description": "TTW PCL - NVDR",
     "symbol": "TTWSF"
    },
    {
     "description": "TRILLIANT EXPLORATION CORP",
     "symbol": "TTXP"
    },
    {
     "description": "TEXHONG TEXTILE GROUP LTD",
     "symbol": "TTXTF"
    },
    {
     "description": "TRINITY PETE TR CTF BEN INT",
     "symbol": "TTYP"
    },
    {
     "description": "TELUS CORP",
     "symbol": "TU"
    },
    {
     "description": "TUAS LTD",
     "symbol": "TUALF"
    },
    {
     "description": "THUNDERFUL GROUP AB",
     "symbol": "TUDRF"
    },
    {
     "description": "TUESDAY MORNING CORP",
     "symbol": "TUEM"
    },
    {
     "description": "TRUE NORTH COMMERCIAL REAL E",
     "symbol": "TUERF"
    },
    {
     "description": "THAI UNION FROZEN-UNSP ADR",
     "symbol": "TUFBY"
    },
    {
     "description": "TUFIN SOFTWARE TECHNOLOGIES",
     "symbol": "TUFN"
    },
    {
     "description": "THAI UNION GROUP PCL-NVDR",
     "symbol": "TUFUF"
    },
    {
     "description": "TUGA INNOVATIONS INC",
     "symbol": "TUGAF"
    },
    {
     "description": "TRADEUP GLOBAL CORP-A",
     "symbol": "TUGC"
    },
    {
     "description": "TRADEUP GLOBAL CORP",
     "symbol": "TUGCU"
    },
    {
     "description": "TRADEUP GLOBAL CORP-A -CW27",
     "symbol": "TUGCW"
    },
    {
     "description": "TUNGTEX HOLDINGS CO LTD",
     "symbol": "TUGHF"
    },
    {
     "description": "TUI AG",
     "symbol": "TUIFF"
    },
    {
     "description": "TUI AG-UNSPON ADR",
     "symbol": "TUIFY"
    },
    {
     "description": "TUPPERWARE BRANDS CORP",
     "symbol": "TUP"
    },
    {
     "description": "TUPRAS-TURKIYE PETROL RAFINE",
     "symbol": "TUPRF"
    },
    {
     "description": "ISHARES MSCI TURKEY ETF",
     "symbol": "TUR"
    },
    {
     "description": "TURBINE AVIATION INC",
     "symbol": "TURA"
    },
    {
     "description": "180 DEGREE CAPITAL CORP",
     "symbol": "TURN"
    },
    {
     "description": "TWO RIVERS WATER & FARMING C",
     "symbol": "TURV"
    },
    {
     "description": "FT TOTAL US MARKET ALPHADEX",
     "symbol": "TUSA"
    },
    {
     "description": "MAMMOTH ENERGY SERVICES INC",
     "symbol": "TUSK"
    },
    {
     "description": "TULLOW OIL PLC",
     "symbol": "TUWLF"
    },
    {
     "description": "TULLOW OIL PLC-UNSPON ADR",
     "symbol": "TUWOY"
    },
    {
     "description": "TUXIS CORPORATION",
     "symbol": "TUXS"
    },
    {
     "description": "TUYA INC",
     "symbol": "TUYA"
    },
    {
     "description": "GRUPO TELEVISA SA-SPON ADR",
     "symbol": "TV"
    },
    {
     "description": "TVA GROUP INC- B SHRS",
     "symbol": "TVAGF"
    },
    {
     "description": "TV ASAHI HOLDINGS CORP",
     "symbol": "TVAHF"
    },
    {
     "description": "TEL AVIV STOCK EXCHANGE LTD",
     "symbol": "TVAVF"
    },
    {
     "description": "TELEVISION BROADCASTS LTD",
     "symbol": "TVBCF"
    },
    {
     "description": "TELEVISION BROADCASTS-SP ADR",
     "symbol": "TVBCY"
    },
    {
     "description": "TENN VALLEY AUTHORITY",
     "symbol": "TVC"
    },
    {
     "description": "THREE VALLEY COPPER CORP",
     "symbol": "TVCCF"
    },
    {
     "description": "TVC TELECOM INC",
     "symbol": "TVCE"
    },
    {
     "description": "TV DIRECT PCL-NDVR",
     "symbol": "TVDPF"
    },
    {
     "description": "TENN VALLEY AUTHORITY",
     "symbol": "TVE"
    },
    {
     "description": "TERRACE VENTURES INC",
     "symbol": "TVER"
    },
    {
     "description": "Traverse Energy Ltd",
     "symbol": "TVETF"
    },
    {
     "description": "TELEVISION FRANCAISE (T.F.1)",
     "symbol": "TVFCF"
    },
    {
     "description": "TVI PACIFIC INC",
     "symbol": "TVIPF"
    },
    {
     "description": "VELOCITYSHARES 2X VIX SH-TRM",
     "symbol": "TVIXF"
    },
    {
     "description": "TENNESSEE VALLEY FINANCIAL",
     "symbol": "TVLF"
    },
    {
     "description": "TREVALI MINING CORP-CW22",
     "symbol": "TVLMF"
    },
    {
     "description": "TURBOTVILLE NATL BANK PA",
     "symbol": "TVNB"
    },
    {
     "description": "TURNER VALLEY OIL & GAS INC",
     "symbol": "TVOG"
    },
    {
     "description": "TWIN VEE POWERCATS INC",
     "symbol": "TVPC"
    },
    {
     "description": "TRAVIS PERKINS PLC",
     "symbol": "TVPKF"
    },
    {
     "description": "WHEREVERTV BROADCASTING CORP",
     "symbol": "TVTV"
    },
    {
     "description": "TRAVERE THERAPEUTICS INC",
     "symbol": "TVTX"
    },
    {
     "description": "TIVITY HEALTH INC",
     "symbol": "TVTY"
    },
    {
     "description": "TRADEWEB MARKETS INC-CLASS A",
     "symbol": "TW"
    },
    {
     "description": "TOWA BANK LTD\/THE",
     "symbol": "TWABF"
    },
    {
     "description": "TWA CORP",
     "symbol": "TWAC"
    },
    {
     "description": "TOWA PHARMACEUTICAL CO LTD",
     "symbol": "TWAPF"
    },
    {
     "description": "BILANDER ACQUISITION CORP-A",
     "symbol": "TWCB"
    },
    {
     "description": "BILANDER ACQUISITION CORP",
     "symbol": "TWCBU"
    },
    {
     "description": "BILANDER ACQ CL A -CW27",
     "symbol": "TWCBW"
    },
    {
     "description": "TOWN & COUNTRY FINANCIAL COR",
     "symbol": "TWCF"
    },
    {
     "description": "T.W. CHRISTIAN INC",
     "symbol": "TWCI"
    },
    {
     "description": "TRACKWISE DESIGNS PLC",
     "symbol": "TWDLF"
    },
    {
     "description": "TOWERSTREAM CORP",
     "symbol": "TWER"
    },
    {
     "description": "TITAN INTERNATIONAL INC",
     "symbol": "TWI"
    },
    {
     "description": "TWIN DISC INC",
     "symbol": "TWIN"
    },
    {
     "description": "TRAJAN WEALTH INCOME OPPORTU",
     "symbol": "TWIO"
    },
    {
     "description": "TREE ISLAND STEEL LTD",
     "symbol": "TWIRF"
    },
    {
     "description": "THOUGHTWORKS HOLDING INC",
     "symbol": "TWKS"
    },
    {
     "description": "TWILIO INC - A",
     "symbol": "TWLO"
    },
    {
     "description": "TWELVE SEAS INVTMNT CO II -A",
     "symbol": "TWLV"
    },
    {
     "description": "TWELVE SEAS INVESTMENT CO II",
     "symbol": "TWLVU"
    },
    {
     "description": "TWELVE SEAS INV II A -CW28",
     "symbol": "TWLVW"
    },
    {
     "description": "PROSHARES ULTRASHORT R2000",
     "symbol": "TWM"
    },
    {
     "description": "TIDEWATER MIDSTREAM AND INFR",
     "symbol": "TWMIF"
    },
    {
     "description": "TAIWAN FUND INC",
     "symbol": "TWN"
    },
    {
     "description": "TAILWIND ACQUISITION CORP-A",
     "symbol": "TWND"
    },
    {
     "description": "TAILWIND ACQUISITION CORP",
     "symbol": "TWND.U"
    },
    {
     "description": "TAILWIND ACQUISITION -CW27",
     "symbol": "TWND.WS"
    },
    {
     "description": "TOWNE BANCORP INC\/AZ",
     "symbol": "TWNE"
    },
    {
     "description": "TAILWIND INTERNATIONAL ACQ-A",
     "symbol": "TWNI"
    },
    {
     "description": "TAILWIND INTERNATIONAL ACQUI",
     "symbol": "TWNI.U"
    },
    {
     "description": "TAILWIND INTERNATIONAL -CW28",
     "symbol": "TWNI.WS"
    },
    {
     "description": "HOSTESS BRANDS INC",
     "symbol": "TWNK"
    },
    {
     "description": "TWO HARBORS INVESTMENT CORP",
     "symbol": "TWO"
    },
    {
     "description": "TWO HARBORS INV CORP",
     "symbol": "TWO.PRA"
    },
    {
     "description": "TWO HARBORS INV CORP",
     "symbol": "TWO.PRB"
    },
    {
     "description": "TWO HARBORS INV CORP",
     "symbol": "TWO.PRC"
    },
    {
     "description": "TWO - CLASS A",
     "symbol": "TWOA"
    },
    {
     "description": "TWO",
     "symbol": "TWOA.U"
    },
    {
     "description": "TAYLOR WIMPEY PLC",
     "symbol": "TWODF"
    },
    {
     "description": "TAYLOR WIMPEY PLC-UNSPON ADR",
     "symbol": "TWODY"
    },
    {
     "description": "TWO HANDS CORP",
     "symbol": "TWOH"
    },
    {
     "description": "TELEDATA WORLD SERVICES INC",
     "symbol": "TWOS"
    },
    {
     "description": "2U INC",
     "symbol": "TWOU"
    },
    {
     "description": "TOWER RESOURCES LTD",
     "symbol": "TWRFF"
    },
    {
     "description": "THEWORKS.CO.UK PLC",
     "symbol": "TWRKF"
    },
    {
     "description": "TRISTAR WELLNESS SOLUTIONS I",
     "symbol": "TWSI"
    },
    {
     "description": "TWIST BIOSCIENCE CORP",
     "symbol": "TWST"
    },
    {
     "description": "20\/20 GENESYSTEMS INC",
     "symbol": "TWTG"
    },
    {
     "description": "TWITTER INC",
     "symbol": "TWTR"
    },
    {
     "description": "BATCH 22X LTD",
     "symbol": "TWTXF"
    },
    {
     "description": "TERNIUM SA-SPONSORED ADR",
     "symbol": "TX"
    },
    {
     "description": "CANG BAO TIAN XIA INTERNATIO",
     "symbol": "TXCB"
    },
    {
     "description": "TRANSWITCH CORP",
     "symbol": "TXCCQ"
    },
    {
     "description": "TEMPLETON EMERGING MARKETS-O",
     "symbol": "TXEMF"
    },
    {
     "description": "10X GENOMICS INC-CLASS A",
     "symbol": "TXG"
    },
    {
     "description": "TEXAS GULF ENERGY INC",
     "symbol": "TXGE"
    },
    {
     "description": "TEXGEN POWER LLC",
     "symbol": "TXGWU"
    },
    {
     "description": "TEXHOMA ENERGY INC",
     "symbol": "TXHE"
    },
    {
     "description": "TX HOLDINGS INC",
     "symbol": "TXHG"
    },
    {
     "description": "TECHNOPRO HOLDINGS INC",
     "symbol": "TXHPF"
    },
    {
     "description": "TONGXIN INTERNATIONAL LTD",
     "symbol": "TXIC"
    },
    {
     "description": "TESLA EXPLORATION LTD",
     "symbol": "TXLZF"
    },
    {
     "description": "TIREX CORP",
     "symbol": "TXMC"
    },
    {
     "description": "THERAPEUTICSMD INC",
     "symbol": "TXMD"
    },
    {
     "description": "X MSCI WORLD CONSUMER STAPL",
     "symbol": "TXMIF"
    },
    {
     "description": "TEXAS INSTRUMENTS INC",
     "symbol": "TXN"
    },
    {
     "description": "TEXAS ROADHOUSE INC",
     "symbol": "TXRH"
    },
    {
     "description": "TAXUS PHARMACEUTICALS HOLDIN",
     "symbol": "TXSP"
    },
    {
     "description": "TEXTRON INC",
     "symbol": "TXT"
    },
    {
     "description": "PROTEXT MOBILITY INC",
     "symbol": "TXTM"
    },
    {
     "description": "TEXWINCA HOLDINGS LTD",
     "symbol": "TXWHF"
    },
    {
     "description": "TRI-CONTINENTAL CORP",
     "symbol": "TY"
    },
    {
     "description": "TRI-CONTINENTAL",
     "symbol": "TY.PR"
    },
    {
     "description": "SIMPLIFY RISK PARITY TREASUR",
     "symbol": "TYA"
    },
    {
     "description": "TRINITY BANK NA\/TEXAS",
     "symbol": "TYBT"
    },
    {
     "description": "CALVIN B. TAYLOR BANKSHARES",
     "symbol": "TYCB"
    },
    {
     "description": "TOKYU CONSTRUCTION CO LTD",
     "symbol": "TYCLF"
    },
    {
     "description": "TINGYI CAYMAN - UNSP ADR",
     "symbol": "TYCMY"
    },
    {
     "description": "TOYO CONSTRUCTION CO LTD",
     "symbol": "TYCOF"
    },
    {
     "description": "DRX DLY 7-10 Y TREAS BULL 3X",
     "symbol": "TYD"
    },
    {
     "description": "THYSSENKRUPP AG",
     "symbol": "TYEKF"
    },
    {
     "description": "TRI-COUNTY FINANCIAL GROUP",
     "symbol": "TYFG"
    },
    {
     "description": "TORTOISE ENERGY INFRASTRUCT",
     "symbol": "TYG"
    },
    {
     "description": "TOYO GOSEI CO LTD",
     "symbol": "TYGIF"
    },
    {
     "description": "TYHEE GOLD CORP",
     "symbol": "TYHJF"
    },
    {
     "description": "TOYOTA TSUSHO CORP",
     "symbol": "TYHOF"
    },
    {
     "description": "TY HOLDINGS CO LTD\/KOREA-PF",
     "symbol": "TYHPF"
    },
    {
     "description": "TOYOTA INDUSTRIES CORP",
     "symbol": "TYIDF"
    },
    {
     "description": "TOYOTA INDUSTRIES-UNSPON ADR",
     "symbol": "TYIDY"
    },
    {
     "description": "TOYO INK SC HOLDINGS CO LTD",
     "symbol": "TYKIF"
    },
    {
     "description": "TYLER TECHNOLOGIES INC",
     "symbol": "TYL"
    },
    {
     "description": "TYME TECHNOLOGIES INC",
     "symbol": "TYME"
    },
    {
     "description": "DIREXION NANOTECHNOLOGY",
     "symbol": "TYNE"
    },
    {
     "description": "NIPPON SANSO HOLDINGS CORP",
     "symbol": "TYNPF"
    },
    {
     "description": "DRX DLY 7-10 Y TREAS BEAR 3X",
     "symbol": "TYO"
    },
    {
     "description": "TOYOBO CO LTD-UNSPONS ADR",
     "symbol": "TYOBY"
    },
    {
     "description": "TAEYOUNG ENGINEERING&CONS-PF",
     "symbol": "TYOOF"
    },
    {
     "description": "TAIYO YUDEN CO LTD",
     "symbol": "TYOYF"
    },
    {
     "description": "TAIYO YUDEN CO LTD-UNSP ADR",
     "symbol": "TYOYY"
    },
    {
     "description": "GOLDFLARE EXPLORATION INC",
     "symbol": "TYPFF"
    },
    {
     "description": "TYRO PAYMENTS LTD",
     "symbol": "TYPMF"
    },
    {
     "description": "TYRA BIOSCIENCES INC",
     "symbol": "TYRA"
    },
    {
     "description": "TOKYO TATEMONO CO LTD",
     "symbol": "TYTMF"
    },
    {
     "description": "TYTAN HOLDINGS INC",
     "symbol": "TYTN"
    },
    {
     "description": "TYRANNA RESOURCES LTD",
     "symbol": "TYXXF"
    },
    {
     "description": "DIREXION DLY SM CAP BEAR 3X",
     "symbol": "TZA"
    },
    {
     "description": "TSUZUKI DENKI CO LTD",
     "symbol": "TZKIF"
    },
    {
     "description": "TZ LTD",
     "symbol": "TZLTF"
    },
    {
     "description": "TRAVELZOO",
     "symbol": "TZOO"
    },
    {
     "description": "THERMAFREEZE PRODUCTS CORP",
     "symbol": "TZPC"
    },
    {
     "description": "TZP STRATEGIES ACQUISI-CL A",
     "symbol": "TZPS"
    },
    {
     "description": "TZP STRATEGIES ACQUISITION",
     "symbol": "TZPSU"
    },
    {
     "description": "TZP STRATEGIES -CL A -CW27",
     "symbol": "TZPSW"
    },
    {
     "description": "Tzero Group Inc",
     "symbol": "TZROP"
    },
    {
     "description": "THUMZUP MEDIA CORP",
     "symbol": "TZUP"
    },
    {
     "description": "UNITY SOFTWARE INC",
     "symbol": "U"
    },
    {
     "description": "UNDER ARMOUR INC-CLASS C",
     "symbol": "UA"
    },
    {
     "description": "UNDER ARMOUR INC-CLASS A",
     "symbol": "UAA"
    },
    {
     "description": "ISHARES MSCI UAE ETF",
     "symbol": "UAE"
    },
    {
     "description": "UNITED AMERICAN HEALTHCARE",
     "symbol": "UAHC"
    },
    {
     "description": "UNITED AIRLINES HOLDINGS INC",
     "symbol": "UAL"
    },
    {
     "description": "UNITED AMERICAN CORP",
     "symbol": "UAMA"
    },
    {
     "description": "UA MULTIMEDIA INC",
     "symbol": "UAMM"
    },
    {
     "description": "UNITED STATES ANTIMONY CORP",
     "symbol": "UAMY"
    },
    {
     "description": "CVR PARTNERS LP",
     "symbol": "UAN"
    },
    {
     "description": "UNITED AMERICAN PETROLEUM CO",
     "symbol": "UAPC"
    },
    {
     "description": "UNION AUCTION PCL-NVDR",
     "symbol": "UAPNF"
    },
    {
     "description": "INNOVATOR U.S. EQUITY ULTRA",
     "symbol": "UAPR"
    },
    {
     "description": "UMBRA APPLIED TECHNOLOGIES G",
     "symbol": "UATG"
    },
    {
     "description": "INNOVATOR U.S. EQUITY ULTRA",
     "symbol": "UAUG"
    },
    {
     "description": "AGEAGLE AERIAL SYSTEMS INC",
     "symbol": "UAVS"
    },
    {
     "description": "URSTADT BIDDLE - CLASS A",
     "symbol": "UBA"
    },
    {
     "description": "URBANA CORP-NON VOTING A",
     "symbol": "UBAAF"
    },
    {
     "description": "UNITED BANCORPORATION ALAB-A",
     "symbol": "UBAB"
    },
    {
     "description": "UZABASE INC",
     "symbol": "UBAZF"
    },
    {
     "description": "UBC ALGORITHMIC FUNDAMENTALS",
     "symbol": "UBCB"
    },
    {
     "description": "UBS ETF SMI",
     "symbol": "UBCHF"
    },
    {
     "description": "UNITED BANCORP INC\/OHIO",
     "symbol": "UBCP"
    },
    {
     "description": "UBE CORP",
     "symbol": "UBEOF"
    },
    {
     "description": "UBE INDUSTRIES LTD-ADR",
     "symbol": "UBEOY"
    },
    {
     "description": "UBER TECHNOLOGIES INC",
     "symbol": "UBER"
    },
    {
     "description": "UNITED BULLION EXCHANGE INC",
     "symbol": "UBEX"
    },
    {
     "description": "UNITED SECURITY BANCSHARE\/CA",
     "symbol": "UBFO"
    },
    {
     "description": "NET-A-GO TECHNOLOGY CO LTD",
     "symbol": "UBGHF"
    },
    {
     "description": "UBS AG London Branch",
     "symbol": "UBGZF"
    },
    {
     "description": "UBI BLOCKCHAIN INTERNET LTD",
     "symbol": "UBIA"
    },
    {
     "description": "UBS ETF GOLD",
     "symbol": "UBISF"
    },
    {
     "description": "UNITED BANK FOR AFRICA-REG S",
     "symbol": "UBKZF"
    },
    {
     "description": "U-BLOX HOLDING AG",
     "symbol": "UBLXF"
    },
    {
     "description": "URBANIMMERSIVE INC",
     "symbol": "UBMRF"
    },
    {
     "description": "UB BANCORP",
     "symbol": "UBNC"
    },
    {
     "description": "VICTORYSHARES ESG CORE PLUS",
     "symbol": "UBND"
    },
    {
     "description": "URBANISE.COM LTD",
     "symbol": "UBNSF"
    },
    {
     "description": "UNITED BANCSHARES INC\/OHIO",
     "symbol": "UBOH"
    },
    {
     "description": "DIREXION DAILY ROBOTICS ART",
     "symbol": "UBOT"
    },
    {
     "description": "URSTADT BIDDLE PROPERTIES",
     "symbol": "UBP"
    },
    {
     "description": "URSTADT BIDDLE PROPERTIE",
     "symbol": "UBP.PRH"
    },
    {
     "description": "URSTADT BIDDLE PROPERTIE",
     "symbol": "UBP.PRK"
    },
    {
     "description": "UBIQUITECH SOFTWARE CORP",
     "symbol": "UBQU"
    },
    {
     "description": "PROSHARES ULTRA MSCI BRAZIL",
     "symbol": "UBR"
    },
    {
     "description": "UBS GROUP AG-REG",
     "symbol": "UBS"
    },
    {
     "description": "KURE TECHNOLOGIES INC",
     "symbol": "UBSBF"
    },
    {
     "description": "UBISOFT ENTERTAINMENT",
     "symbol": "UBSFF"
    },
    {
     "description": "UBISOFT ENTERTAIN-UNSPON ADR",
     "symbol": "UBSFY"
    },
    {
     "description": "UNITED BANKSHARES INC",
     "symbol": "UBSI"
    },
    {
     "description": "UBS ETF MSCI PACIFIC EX JPN",
     "symbol": "UBSMF"
    },
    {
     "description": "UBS PRPRTY FD SW MIXD SIMA",
     "symbol": "UBSSF"
    },
    {
     "description": "UBS ETF B. US LIQ. CORP. 1-5",
     "symbol": "UBSVF"
    },
    {
     "description": "UBS ETF MSCI PACIFIC SRI DIS",
     "symbol": "UBSXF"
    },
    {
     "description": "UBS AG London Branch",
     "symbol": "UBSZF"
    },
    {
     "description": "PROSHARES ULTRA 20+ YEAR TSY",
     "symbol": "UBT"
    },
    {
     "description": "UNITY BIOTECHNOLOGY INC",
     "symbol": "UBX"
    },
    {
     "description": "UBUYHOLDINGS INC",
     "symbol": "UBYH"
    },
    {
     "description": "OSSIAM SHILLER BRLY CAPE USD",
     "symbol": "UCAPF"
    },
    {
     "description": "UC ASSET LIMITED PARTNERSHIP",
     "symbol": "UCASU"
    },
    {
     "description": "UNITED COMMUNITY BANKS\/GA",
     "symbol": "UCBI"
    },
    {
     "description": "UNITED COMMUNITY BANK",
     "symbol": "UCBIO"
    },
    {
     "description": "UCB SA",
     "symbol": "UCBJF"
    },
    {
     "description": "UCB SA - UNSPONSORED ADR",
     "symbol": "UCBJY"
    },
    {
     "description": "PROSHARES ULTRA CONS SERVICE",
     "symbol": "UCC"
    },
    {
     "description": "UPCO INTERNATIONAL INC",
     "symbol": "UCCPF"
    },
    {
     "description": "ETRACS UBS BBG CONS MA SER B",
     "symbol": "UCIB"
    },
    {
     "description": "UMBRA COMPANIES INC",
     "symbol": "UCIX"
    },
    {
     "description": "UCLOUDLINK GROUP INC",
     "symbol": "UCL"
    },
    {
     "description": "US NUCLEAR CORP",
     "symbol": "UCLE"
    },
    {
     "description": "ULTRATECH CEMENT-GDR",
     "symbol": "UCLQF"
    },
    {
     "description": "PROSHARES ULTRA BLOOMBERG CR",
     "symbol": "UCO"
    },
    {
     "description": "FIRST TRUST TCW UNCONSTRAINE",
     "symbol": "UCON"
    },
    {
     "description": "UNITED COMMUNICATIONS PARTNE",
     "symbol": "UCPA"
    },
    {
     "description": "UNICAPITAL CORP",
     "symbol": "UCPC"
    },
    {
     "description": "UNITED CORPORATIONS LTD",
     "symbol": "UCPLF"
    },
    {
     "description": "VICTORYSHARES ESG CORP BOND",
     "symbol": "UCRD"
    },
    {
     "description": "UNITED CONSORTIUM LTD",
     "symbol": "UCSO"
    },
    {
     "description": "CTN MEDIA GROUP INC",
     "symbol": "UCTN"
    },
    {
     "description": "ULTRA CLEAN HOLDINGS INC",
     "symbol": "UCTT"
    },
    {
     "description": "PROSHARES ULTRA NASDAQ CYBR",
     "symbol": "UCYB"
    },
    {
     "description": "INNOVATOR U.S. EQUITY ULTRA",
     "symbol": "UDEC"
    },
    {
     "description": "UNITED INTERNET AG-REG SHARE",
     "symbol": "UDIRF"
    },
    {
     "description": "UDEMY INC",
     "symbol": "UDMY"
    },
    {
     "description": "INVESCO DB US DOLLAR INDEX B",
     "symbol": "UDN"
    },
    {
     "description": "UNIDOC HEALTH CORP",
     "symbol": "UDOCF"
    },
    {
     "description": "PROSHARES ULTRAPRO DOW30",
     "symbol": "UDOW"
    },
    {
     "description": "UDR INC",
     "symbol": "UDR"
    },
    {
     "description": "UDS GROUP INC",
     "symbol": "UDSG"
    },
    {
     "description": "URBAN EDGE PROPERTIES",
     "symbol": "UE"
    },
    {
     "description": "URANIUM ENERGY CORP",
     "symbol": "UEC"
    },
    {
     "description": "UNITED HEALTH PRODUCTS INC",
     "symbol": "UEEC"
    },
    {
     "description": "ULTRA ELECTRONICS HLDGS PLC",
     "symbol": "UEHPF"
    },
    {
     "description": "ULTRA ELECTRONICS HLD-UN ADR",
     "symbol": "UEHPY"
    },
    {
     "description": "UNIVERSAL ELECTRONICS INC",
     "symbol": "UEIC"
    },
    {
     "description": "ULKER BISKUVI SANAYI AS-ADR",
     "symbol": "UELKY"
    },
    {
     "description": "Union Electric Company",
     "symbol": "UELMO"
    },
    {
     "description": "UTILICO EMERGING MARKETS TRU",
     "symbol": "UEMTF"
    },
    {
     "description": "Union Electric Company",
     "symbol": "UEPCN"
    },
    {
     "description": "Union Electric Company",
     "symbol": "UEPCO"
    },
    {
     "description": "Union Electric Company",
     "symbol": "UEPCP"
    },
    {
     "description": "Union Electric Company",
     "symbol": "UEPEM"
    },
    {
     "description": "Union Electric Company",
     "symbol": "UEPEN"
    },
    {
     "description": "Union Electric Company",
     "symbol": "UEPEO"
    },
    {
     "description": "Union Electric Company",
     "symbol": "UEPEP"
    },
    {
     "description": "NET 1 UEPS TECHNOLOGIES INC",
     "symbol": "UEPS"
    },
    {
     "description": "UNITED ETHANOL LLC-MEMB UN-A",
     "symbol": "UETH"
    },
    {
     "description": "UNIVERSAL ENTERTAINMENT CORP",
     "symbol": "UETMF"
    },
    {
     "description": "VICTORYSHARES USAA MSCI EMER",
     "symbol": "UEVM"
    },
    {
     "description": "UEX CORP",
     "symbol": "UEXCF"
    },
    {
     "description": "UNIQUE FABRICATING INC",
     "symbol": "UFAB"
    },
    {
     "description": "UNION FINANCIAL CORP",
     "symbol": "UFCP"
    },
    {
     "description": "UNITED FIRE GROUP INC",
     "symbol": "UFCS"
    },
    {
     "description": "INNOVATOR U.S. EQUITY ULTRA",
     "symbol": "UFEB"
    },
    {
     "description": "UNIFIN FINANCIERA SAB DE CV",
     "symbol": "UFFRF"
    },
    {
     "description": "UNIPOL GRUPPO-UNSPON ADR",
     "symbol": "UFGSY"
    },
    {
     "description": "UNIFI INC",
     "symbol": "UFI"
    },
    {
     "description": "UNIVERSAL MFG CO",
     "symbol": "UFMG"
    },
    {
     "description": "PROCURE SPACE ETF",
     "symbol": "UFO"
    },
    {
     "description": "UFP INDUSTRIES INC",
     "symbol": "UFPI"
    },
    {
     "description": "UFP TECHNOLOGIES INC",
     "symbol": "UFPT"
    },
    {
     "description": "UNITED GUARDIAN INC",
     "symbol": "UG"
    },
    {
     "description": "UNITED STATES GAS FUND LP",
     "symbol": "UGA"
    },
    {
     "description": "VELOCITYSHARES 3X LG NAT GAS",
     "symbol": "UGAZF"
    },
    {
     "description": "UNCOMMON PORT DES CORE EQTY",
     "symbol": "UGCE"
    },
    {
     "description": "UNIGOLD INC",
     "symbol": "UGDIF"
    },
    {
     "description": "PROSHARES ULTRA CONSUM GOODS",
     "symbol": "UGE"
    },
    {
     "description": "UGE INTERNATIONAL LTD",
     "symbol": "UGEIF"
    },
    {
     "description": "UNDERGROUND ENERGY CORP",
     "symbol": "UGGYF"
    },
    {
     "description": "UNIVERSAL GLOBAL HUB INC",
     "symbol": "UGHB"
    },
    {
     "description": "UNION BRIDGE HOLDINGS LTD",
     "symbol": "UGHL"
    },
    {
     "description": "UGI CORP",
     "symbol": "UGI"
    },
    {
     "description": "UGI CORP",
     "symbol": "UGIC"
    },
    {
     "description": "PROSHARES ULTRA GOLD",
     "symbol": "UGL"
    },
    {
     "description": "VELOCITYSHARES 3X LONG GOLD",
     "symbol": "UGLDF"
    },
    {
     "description": "ULTRAPAR PARTICPAC-SPON ADR",
     "symbol": "UGP"
    },
    {
     "description": "URBAN-GRO INC",
     "symbol": "UGRO"
    },
    {
     "description": "AMERCO",
     "symbol": "UHAL"
    },
    {
     "description": "UNIVERSAL HEALTH SVCS-CL D",
     "symbol": "UHID"
    },
    {
     "description": "USHIO INC",
     "symbol": "UHOIF"
    },
    {
     "description": "UNIVERSAL HEALTH SERVICES-B",
     "symbol": "UHS"
    },
    {
     "description": "UNIVERSAL HEALTH RLTY INCOME",
     "symbol": "UHT"
    },
    {
     "description": "UBIQUITI INC",
     "symbol": "UI"
    },
    {
     "description": "UIB GROUP LTD",
     "symbol": "UIBGF"
    },
    {
     "description": "UNITED INSURANCE HOLDINGS CO",
     "symbol": "UIHC"
    },
    {
     "description": "SINGAPORE LAND GROUP LTD",
     "symbol": "UILCF"
    },
    {
     "description": "SINGAPORE LD GR LTD-UNS ADR",
     "symbol": "UILCY"
    },
    {
     "description": "UBS ETF MSCI USA VALUE",
     "symbol": "UIRAF"
    },
    {
     "description": "UNISYS CORP",
     "symbol": "UIS"
    },
    {
     "description": "UTILICRAFT AEROSPACE INDUSTR",
     "symbol": "UITA"
    },
    {
     "description": "VICTORYSHARES USAA CORE INTE",
     "symbol": "UITB"
    },
    {
     "description": "VICTORYSHARES USAA MSCI INTE",
     "symbol": "UIVM"
    },
    {
     "description": "INNOVATOR U.S. EQUITY ULTRA",
     "symbol": "UJAN"
    },
    {
     "description": "PROSHARES ULTRA HIGH YIELD",
     "symbol": "UJB"
    },
    {
     "description": "INNOVATOR U.S. EQUITY ULTRA",
     "symbol": "UJUL"
    },
    {
     "description": "INNOVATOR U.S. EQUITY ULTRA",
     "symbol": "UJUN"
    },
    {
     "description": "UCOMMUNE INTERNATIONAL LTD-A",
     "symbol": "UK"
    },
    {
     "description": "UK OIL & GAS PLC",
     "symbol": "UKLLF"
    },
    {
     "description": "UCOMMUNE INTERNATIONAL -CW25",
     "symbol": "UKOMW"
    },
    {
     "description": "UNILEVER PLC-SPONSORED ADR",
     "symbol": "UL"
    },
    {
     "description": "ULTRALIFE CORP",
     "symbol": "ULBI"
    },
    {
     "description": "UBS AG London Branch",
     "symbol": "ULBWF"
    },
    {
     "description": "FRONTIER GROUP HOLDINGS INC",
     "symbol": "ULCC"
    },
    {
     "description": "PROSHARES ULTRA EURO",
     "symbol": "ULE"
    },
    {
     "description": "ULTIMATE FRANCHISE SYSTEMS",
     "symbol": "ULFS"
    },
    {
     "description": "UROLOGIX INC",
     "symbol": "ULGX"
    },
    {
     "description": "UNIVERSAL LOGISTICS HOLDINGS",
     "symbol": "ULH"
    },
    {
     "description": "THE UNITED LABORATORIES INTE",
     "symbol": "ULIHF"
    },
    {
     "description": "PORTER HOLDING INTERNATIONAL",
     "symbol": "ULNV"
    },
    {
     "description": "ULS GROUP INC",
     "symbol": "ULPRF"
    },
    {
     "description": "ULTIMATE SPORTS ENTMNT INC",
     "symbol": "ULSP"
    },
    {
     "description": "SPDR ULTRA SHORT-TERM BOND",
     "symbol": "ULST"
    },
    {
     "description": "ULTA BEAUTY INC",
     "symbol": "ULTA"
    },
    {
     "description": "UNITED LITHIUM CORP",
     "symbol": "ULTHF"
    },
    {
     "description": "ULTIMOVACS ASA",
     "symbol": "ULTMF"
    },
    {
     "description": "IQ ULTRA SHORT DURATION ETF",
     "symbol": "ULTR"
    },
    {
     "description": "ULTRAPETROL (BAHAMAS) LTD",
     "symbol": "ULTRF"
    },
    {
     "description": "ULTRA LITHIUM INC",
     "symbol": "ULTXF"
    },
    {
     "description": "ULURU INC",
     "symbol": "ULUR"
    },
    {
     "description": "ULVAC INC",
     "symbol": "ULVAF"
    },
    {
     "description": "VICTORYSHARES USAA MSCI USA",
     "symbol": "ULVM"
    },
    {
     "description": "UMAMI SUSTAINABLE SEAFOOD IN",
     "symbol": "UMAM"
    },
    {
     "description": "INNOVATOR U.S. EQUITY ULTRA",
     "symbol": "UMAR"
    },
    {
     "description": "UAV CORP",
     "symbol": "UMAV"
    },
    {
     "description": "UMAX GROUP CORP",
     "symbol": "UMAX"
    },
    {
     "description": "INNOVATOR U.S. EQUITY ULTRA",
     "symbol": "UMAY"
    },
    {
     "description": "UMB FINANCIAL CORP",
     "symbol": "UMBF"
    },
    {
     "description": "UNITED MICROELECTRON-SP ADR",
     "symbol": "UMC"
    },
    {
     "description": "UMC INC",
     "symbol": "UMCN"
    },
    {
     "description": "PROSHARES ULTRAPRO MIDCAP400",
     "symbol": "UMDD"
    },
    {
     "description": "UMEWORLD LTD",
     "symbol": "UMEWF"
    },
    {
     "description": "UMF GROUP INC",
     "symbol": "UMFG"
    },
    {
     "description": "UNIVERSAL MUSIC GROUP NV",
     "symbol": "UMGNF"
    },
    {
     "description": "UNIVERSAL MEDIA GROUP INC",
     "symbol": "UMGP"
    },
    {
     "description": "UMH PROPERTIES INC",
     "symbol": "UMH"
    },
    {
     "description": "UMH PROPERTIES INC",
     "symbol": "UMH.PRC"
    },
    {
     "description": "UMH PROPERTIES INC",
     "symbol": "UMH.PRD"
    },
    {
     "description": "UMATRIN HOLDING LTD",
     "symbol": "UMHL"
    },
    {
     "description": "USCF MIDSTREAM ENERGY INCOME",
     "symbol": "UMI"
    },
    {
     "description": "UMICORE",
     "symbol": "UMICF"
    },
    {
     "description": "UMICORE - UNSPON ADR",
     "symbol": "UMICY"
    },
    {
     "description": "UNITED MALT GRP LTD",
     "symbol": "UMLGF"
    },
    {
     "description": "ULTIMATE LIFESTYLE CORP",
     "symbol": "UMLS"
    },
    {
     "description": "WAHED DOW JONES ISLAMIC WRLD",
     "symbol": "UMMA"
    },
    {
     "description": "UMPQUA HOLDINGS CORP",
     "symbol": "UMPQ"
    },
    {
     "description": "US MASTERS RESIDENTIAL PROPE",
     "symbol": "UMRRF"
    },
    {
     "description": "UMS HOLDINGS LTD",
     "symbol": "UMSSF"
    },
    {
     "description": "GENERTEC UNIVERSAL MEDICAL G",
     "symbol": "UMTAF"
    },
    {
     "description": "UNICO AMERICAN CORP",
     "symbol": "UNAM"
    },
    {
     "description": "UNION BANKSHARES INC \/VT",
     "symbol": "UNB"
    },
    {
     "description": "UNITED NATIONAL BANK\/CAIRO G",
     "symbol": "UNBK"
    },
    {
     "description": "UNIBAIL-RODAMCO-WESTFIELD",
     "symbol": "UNBLF"
    },
    {
     "description": "UNICREDIT SPA",
     "symbol": "UNCFF"
    },
    {
     "description": "UNICHARM CORP",
     "symbol": "UNCHF"
    },
    {
     "description": "UNICREDIT SPA-ADR",
     "symbol": "UNCRY"
    },
    {
     "description": "UNICYCIVE THERAPEUTICS INC",
     "symbol": "UNCY"
    },
    {
     "description": "UNDERSEA RECOVERY GROUP CORP",
     "symbol": "UNDR"
    },
    {
     "description": "UNITED ENERGY GROUP LTD",
     "symbol": "UNEGF"
    },
    {
     "description": "UNEEQO INC",
     "symbol": "UNEQ"
    },
    {
     "description": "UNEX HOLDINGS INC",
     "symbol": "UNEX"
    },
    {
     "description": "UNIFIRST CORP\/MA",
     "symbol": "UNF"
    },
    {
     "description": "UNITED NATURAL FOODS INC",
     "symbol": "UNFI"
    },
    {
     "description": "US NATURAL GAS FUND LP",
     "symbol": "UNG"
    },
    {
     "description": "UNITEDHEALTH GROUP INC",
     "symbol": "UNH"
    },
    {
     "description": "EC HEALTHCARE",
     "symbol": "UNHLF"
    },
    {
     "description": "UNITED HAMPSHIRE US REIT",
     "symbol": "UNHRF"
    },
    {
     "description": "UNIVERSITY BANCORP INC",
     "symbol": "UNIB"
    },
    {
     "description": "UNICHARM CORP - SPN ADR",
     "symbol": "UNICY"
    },
    {
     "description": "UNI-SELECT INC",
     "symbol": "UNIEF"
    },
    {
     "description": "U&I FINANCIAL CORP",
     "symbol": "UNIF"
    },
    {
     "description": "UNITIKA LTD",
     "symbol": "UNIKF"
    },
    {
     "description": "UNIROYAL GLOBAL ENGINEERED P",
     "symbol": "UNIR"
    },
    {
     "description": "UNIBAIL-RODAMCO-WESTFIEL\/CDI",
     "symbol": "UNIRF"
    },
    {
     "description": "UNITI GROUP INC",
     "symbol": "UNIT"
    },
    {
     "description": "UNIVERSAL INFOTAINMENT SYSTE",
     "symbol": "UNIV"
    },
    {
     "description": "UNICAJA BANCO SA",
     "symbol": "UNJCF"
    },
    {
     "description": "UNITED STATES 12 MONTH NATUR",
     "symbol": "UNL"
    },
    {
     "description": "UNILEVER INDONESIA TBK PT",
     "symbol": "UNLRF"
    },
    {
     "description": "UNILEVER INDONESIA-UNSPN ADR",
     "symbol": "UNLRY"
    },
    {
     "description": "UNILEVER PLC",
     "symbol": "UNLYF"
    },
    {
     "description": "UNUM GROUP",
     "symbol": "UNM"
    },
    {
     "description": "UNUM GROUP",
     "symbol": "UNMA"
    },
    {
     "description": "TRITENT INT'L AGRICULTURE IN",
     "symbol": "UNMK"
    },
    {
     "description": "UNIDEN CORP",
     "symbol": "UNNCF"
    },
    {
     "description": "UNION TOOL CO",
     "symbol": "UNNTF"
    },
    {
     "description": "INNOVATOR U.S. EQUITY ULTRA",
     "symbol": "UNOV"
    },
    {
     "description": "UNION PACIFIC CORP",
     "symbol": "UNP"
    },
    {
     "description": "UNB CORP\/PA",
     "symbol": "UNPA"
    },
    {
     "description": "UNIPOLSAI ASSICURAZIONI SPA",
     "symbol": "UNPLF"
    },
    {
     "description": "UNIPER SE",
     "symbol": "UNPRF"
    },
    {
     "description": "UNI-PRESIDENT CHINA HOLDINGS",
     "symbol": "UNPSF"
    },
    {
     "description": "UNIQUE LOGISTICS INTERNATION",
     "symbol": "UNQL"
    },
    {
     "description": "UNITED ENERGY CORP\/NEVADA",
     "symbol": "UNRG"
    },
    {
     "description": "UNITED CO RUSAL INTERNATIONA",
     "symbol": "UNRIF"
    },
    {
     "description": "UNRIVALED BRANDS INC",
     "symbol": "UNRV"
    },
    {
     "description": "UNIVERSAL SOLAR TECHNOLOGY",
     "symbol": "UNSS"
    },
    {
     "description": "UNIT CORP",
     "symbol": "UNTC"
    },
    {
     "description": "UNIT CORP-CW27",
     "symbol": "UNTCW"
    },
    {
     "description": "UNITED TENNESSEE BANKSHARES",
     "symbol": "UNTN"
    },
    {
     "description": "UNITY BANCORP INC",
     "symbol": "UNTY"
    },
    {
     "description": "UNIVEC INC",
     "symbol": "UNVC"
    },
    {
     "description": "UNIVERSAL MUSIC GRO-UNSP ADR",
     "symbol": "UNVGY"
    },
    {
     "description": "UNIVO PHARMACEUTICALS",
     "symbol": "UNVOF"
    },
    {
     "description": "UNIVAR SOLUTIONS INC",
     "symbol": "UNVR"
    },
    {
     "description": "UNI-PIXEL INC",
     "symbol": "UNXLQ"
    },
    {
     "description": "UNITED EXPRESS INC",
     "symbol": "UNXP"
    },
    {
     "description": "UOA DEVELOPMENT BHD",
     "symbol": "UOADF"
    },
    {
     "description": "INNOVATOR U.S. EQUITY ULTRA",
     "symbol": "UOCT"
    },
    {
     "description": "UOL GROUP LTD",
     "symbol": "UOLGF"
    },
    {
     "description": "UOL GROUP LIMITED-SP ADR",
     "symbol": "UOLGY"
    },
    {
     "description": "UONLIVE CORP",
     "symbol": "UOLI"
    },
    {
     "description": "UOMO MEDIA INC",
     "symbol": "UOMO"
    },
    {
     "description": "URBAN ONE INC",
     "symbol": "UONE"
    },
    {
     "description": "URBAN ONE INC",
     "symbol": "UONEK"
    },
    {
     "description": "UNITED OVERSEAS BANK LTD",
     "symbol": "UOVEF"
    },
    {
     "description": "UNITED OVERSEAS BANK-SP ADR",
     "symbol": "UOVEY"
    },
    {
     "description": "WHEELS UP EXPERIENCE INC",
     "symbol": "UP"
    },
    {
     "description": "ASPIRATIONAL CONSUMER -CW25",
     "symbol": "UP.WS"
    },
    {
     "description": "ULTRA RISK PARITY ETF",
     "symbol": "UPAR"
    },
    {
     "description": "UNITED PLANTATIONS BHD",
     "symbol": "UPBMF"
    },
    {
     "description": "UNIVERSE PHARMACEUTICALS INC",
     "symbol": "UPC"
    },
    {
     "description": "UNI-PRESIDENT CHINA-UNSP ADR",
     "symbol": "UPCHY"
    },
    {
     "description": "UNIVERSAL POTASH CORP",
     "symbol": "UPCO"
    },
    {
     "description": "UPD HOLDING CORP",
     "symbol": "UPDC"
    },
    {
     "description": "UPHEALTH INC",
     "symbol": "UPH"
    },
    {
     "description": "UPHEALTH IN - CW24",
     "symbol": "UPH.WS"
    },
    {
     "description": "UNIVERSAL POWER INDUSTRY COR",
     "symbol": "UPIN"
    },
    {
     "description": "UNIVERSAL PROPTECH INC",
     "symbol": "UPIPF"
    },
    {
     "description": "UPLAND SOFTWARE INC",
     "symbol": "UPLD"
    },
    {
     "description": "UPM-KYMMENE OYJ",
     "symbol": "UPMKF"
    },
    {
     "description": "UPM-KYMMENE OYJ-UNSPON ADR",
     "symbol": "UPMMY"
    },
    {
     "description": "UPONOR OYJ",
     "symbol": "UPNRF"
    },
    {
     "description": "UPONOR OYJ-UNSPON ADR",
     "symbol": "UPNRY"
    },
    {
     "description": "UNITED PALM OIL INDUSTRY-FOR",
     "symbol": "UPOIF"
    },
    {
     "description": "UPPER STREET MARKETING INC",
     "symbol": "UPPR"
    },
    {
     "description": "USA PERFORMANCE PRODUCTS INC",
     "symbol": "UPRM"
    },
    {
     "description": "PROSHARES ULTRAPRO S&P 500",
     "symbol": "UPRO"
    },
    {
     "description": "UNITED PARCEL SERVICE-CL B",
     "symbol": "UPS"
    },
    {
     "description": "UPSNAP INC\/UNITED STATES",
     "symbol": "UPSN"
    },
    {
     "description": "UPSTART HOLDINGS INC",
     "symbol": "UPST"
    },
    {
     "description": "TRADEUP ACQUISITION CORP",
     "symbol": "UPTD"
    },
    {
     "description": "TRADEUP ACQUISITION CORP",
     "symbol": "UPTDU"
    },
    {
     "description": "TRADEUP ACQUISITION CORP-CW",
     "symbol": "UPTDW"
    },
    {
     "description": "PROSHARES ULTRA FTSE EUROPE",
     "symbol": "UPV"
    },
    {
     "description": "PROSHARES ULTRA UTILITIES",
     "symbol": "UPW"
    },
    {
     "description": "UPWORK INC",
     "symbol": "UPWK"
    },
    {
     "description": "UPAY INC",
     "symbol": "UPYY"
    },
    {
     "description": "UBIQUITOUS AI CORP",
     "symbol": "UQAIF"
    },
    {
     "description": "GLOBAL X URANIUM ETF",
     "symbol": "URA"
    },
    {
     "description": "UNITED RAIL INC",
     "symbol": "URAL"
    },
    {
     "description": "INTERNATIONAL PROSPECT VENTU",
     "symbol": "URANF"
    },
    {
     "description": "URBI DESARROLLOS URBANOS SAB",
     "symbol": "URBDF"
    },
    {
     "description": "URBAN BARNS FOODS INC",
     "symbol": "URBF"
    },
    {
     "description": "URBAN OUTFITTERS INC",
     "symbol": "URBN"
    },
    {
     "description": "URBAN TELEVISION NETWORK",
     "symbol": "URBT"
    },
    {
     "description": "VANADIAN ENERGY CORP",
     "symbol": "URCFF"
    },
    {
     "description": "URANIUM ROYALTY CORP-CW24",
     "symbol": "URCWF"
    },
    {
     "description": "PROSHARES ULTRA REAL ESTATE",
     "symbol": "URE"
    },
    {
     "description": "DEVEX RESOURCES LTD",
     "symbol": "UREQF"
    },
    {
     "description": "Us Masters Residential Property Fund",
     "symbol": "URFFF"
    },
    {
     "description": "UR-ENERGY INC",
     "symbol": "URG"
    },
    {
     "description": "UROGEN PHARMA LTD",
     "symbol": "URGN"
    },
    {
     "description": "ACADEMY METALS INC",
     "symbol": "URGYF"
    },
    {
     "description": "UNITED RESOURCE HOLDINGS GRO",
     "symbol": "URHG"
    },
    {
     "description": "UNITED RENTALS INC",
     "symbol": "URI"
    },
    {
     "description": "NAMESILO TECHNOLOGIES CORP",
     "symbol": "URLOF"
    },
    {
     "description": "URBANA CORP",
     "symbol": "URNAF"
    },
    {
     "description": "NORTHSHORE GLOBAL URANIUM MI",
     "symbol": "URNM"
    },
    {
     "description": "URANIUM ROYALTY CORP",
     "symbol": "UROY"
    },
    {
     "description": "NEW KLONDIKE EXPLORATION LTD",
     "symbol": "URPLF"
    },
    {
     "description": "TWENTY SEVEN CO LTD",
     "symbol": "URRNF"
    },
    {
     "description": "ISHARES MSCI WORLD ETF",
     "symbol": "URTH"
    },
    {
     "description": "PROSHARES ULTRAPRO RUSS2000",
     "symbol": "URTY"
    },
    {
     "description": "URAVAN MINERALS INC",
     "symbol": "URVNF"
    },
    {
     "description": "TENTH AVENUE PETROLEUM CORP",
     "symbol": "URXZF"
    },
    {
     "description": "UNITED ROYALE HOLDINGS CORP",
     "symbol": "URYL"
    },
    {
     "description": "LIBERTY ALL STAR EQUITY FUND",
     "symbol": "USA"
    },
    {
     "description": "USA COMPRESSION PARTNERS LP",
     "symbol": "USAC"
    },
    {
     "description": "U.S. AEROSPACE INC",
     "symbol": "USAE"
    },
    {
     "description": "PACER AMERICAN ENERGY INDEPE",
     "symbol": "USAI"
    },
    {
     "description": "USA TRUCK INC",
     "symbol": "USAK"
    },
    {
     "description": "U.S. AUTOMOTIVE MFG INC",
     "symbol": "USAM"
    },
    {
     "description": "UNIVERSAL STAINLESS & ALLOY",
     "symbol": "USAP"
    },
    {
     "description": "QHSLAB INC",
     "symbol": "USAQ"
    },
    {
     "description": "AMERICAS GOLD AND SILVER COR",
     "symbol": "USAS"
    },
    {
     "description": "US GOLD CORP",
     "symbol": "USAU"
    },
    {
     "description": "US BANCORP",
     "symbol": "USB"
    },
    {
     "description": "US BANCORP",
     "symbol": "USB.PRA"
    },
    {
     "description": "US BANCORP",
     "symbol": "USB.PRH"
    },
    {
     "description": "US BANCORP",
     "symbol": "USB.PRP"
    },
    {
     "description": "US BANCORP",
     "symbol": "USB.PRQ"
    },
    {
     "description": "US BANCORP",
     "symbol": "USB.PRR"
    },
    {
     "description": "US BANCORP",
     "symbol": "USB.PRS"
    },
    {
     "description": "US PREMIUM BEEF LLC- CLASS B",
     "symbol": "USBBU"
    },
    {
     "description": "US BIOTEC INC",
     "symbol": "USBC"
    },
    {
     "description": "ISHARES USD BOND FACTOR ETF",
     "symbol": "USBF"
    },
    {
     "description": "US PREMIUM BEEF LLC- CLASS A",
     "symbol": "USBFU"
    },
    {
     "description": "USA BANK",
     "symbol": "USBK"
    },
    {
     "description": "U.S. BASKETBALL LEAGUE INC",
     "symbol": "USBL"
    },
    {
     "description": "USCB FINANCIAL HOLDINGS INC",
     "symbol": "USCB"
    },
    {
     "description": "UNITED STATES COMMODITY INDE",
     "symbol": "USCI"
    },
    {
     "description": "USCORP",
     "symbol": "USCS"
    },
    {
     "description": "TKB CRITICAL TECHNOLOGIES -A",
     "symbol": "USCT"
    },
    {
     "description": "TKB CRITICAL TECHNOLOGIES 1",
     "symbol": "USCTU"
    },
    {
     "description": "TKB CRITICAL TECHNOLOG -CW23",
     "symbol": "USCTW"
    },
    {
     "description": "US COPPER CORP",
     "symbol": "USCUF"
    },
    {
     "description": "UNITED SILVER CORP",
     "symbol": "USCZF"
    },
    {
     "description": "PROSHARES ULTRA SEMICONDUCT",
     "symbol": "USD"
    },
    {
     "description": "USDATA CORPORATION",
     "symbol": "USDC"
    },
    {
     "description": "US-DADI FERTILIZER IND INTL",
     "symbol": "USDF"
    },
    {
     "description": "USD PARTNERS LP",
     "symbol": "USDP"
    },
    {
     "description": "UAS DRONE CORP",
     "symbol": "USDR"
    },
    {
     "description": "WISDOMTREE BBG USD BULLISH",
     "symbol": "USDU"
    },
    {
     "description": "U S ENERGY CORP - WYOMING",
     "symbol": "USEG"
    },
    {
     "description": "US ENERGY INITIATIVES CORP I",
     "symbol": "USEI"
    },
    {
     "description": "INNOVATOR U.S. EQUITY ULTRA",
     "symbol": "USEP"
    },
    {
     "description": "INVESCO RUSSELL 1000 ENHANCE",
     "symbol": "USEQ"
    },
    {
     "description": "USERTESTING INC",
     "symbol": "USER"
    },
    {
     "description": "US FOODS HOLDING CORP",
     "symbol": "USFD"
    },
    {
     "description": "WISDOMTREE FLOATING RATE TRE",
     "symbol": "USFR"
    },
    {
     "description": "US GLOBAL NANOSPACE INC",
     "symbol": "USGA"
    },
    {
     "description": "AMERICAN PACIFIC MINING CORP",
     "symbol": "USGDF"
    },
    {
     "description": "USHA RESOURCES LTD",
     "symbol": "USHAF"
    },
    {
     "description": "ISHARES BROAD USD HIGH YIELD",
     "symbol": "USHY"
    },
    {
     "description": "PRINCIPAL ULTRA-SHORT ACTIVE",
     "symbol": "USI"
    },
    {
     "description": "ISHARES BROAD USD INVESTMENT",
     "symbol": "USIG"
    },
    {
     "description": "USIO INC",
     "symbol": "USIO"
    },
    {
     "description": "UNITED STATES 12 MONTH OIL",
     "symbol": "USL"
    },
    {
     "description": "INVESCO RUSSELL 1000 LOW BET",
     "symbol": "USLB"
    },
    {
     "description": "US LIGHTING GROUP INC",
     "symbol": "USLG"
    },
    {
     "description": "UNITED STATES LIME & MINERAL",
     "symbol": "USLM"
    },
    {
     "description": "U S LIQUIDS INC",
     "symbol": "USLQ"
    },
    {
     "description": "VELOCITYSHARES 3X LNG SILVER",
     "symbol": "USLVF"
    },
    {
     "description": "US CELLULAR CORP",
     "symbol": "USM"
    },
    {
     "description": "PRINCIPAL US MEGA-CAP ETF",
     "symbol": "USMC"
    },
    {
     "description": "WISDOMTREE US MULTIFACTOR FU",
     "symbol": "USMF"
    },
    {
     "description": "UNITED SUPER MARKETS HOLDING",
     "symbol": "USMHF"
    },
    {
     "description": "NORTH AMERICAN CANNABIS HOLD",
     "symbol": "USMJ"
    },
    {
     "description": "ETRACS 2X MINVOL FACTR TR",
     "symbol": "USML"
    },
    {
     "description": "US METRO BANCORP",
     "symbol": "USMT"
    },
    {
     "description": "ISHARES MSCI USA MIN VOL FAC",
     "symbol": "USMV"
    },
    {
     "description": "USANA HEALTH SCIENCES INC",
     "symbol": "USNA"
    },
    {
     "description": "US NATIONAL TELECOM INC",
     "symbol": "USNL"
    },
    {
     "description": "USEN-NEXT HOLDINGS CO LTD",
     "symbol": "USNNF"
    },
    {
     "description": "US NEUROSURGICAL HOLDINGS IN",
     "symbol": "USNU"
    },
    {
     "description": "USINAS SIDERURG MINAS-SP ADR",
     "symbol": "USNZY"
    },
    {
     "description": "UNITED STATES OIL FUND LP",
     "symbol": "USO"
    },
    {
     "description": "X-LINKS CRUDE OIL COV CALL",
     "symbol": "USOI"
    },
    {
     "description": "US OIL & GAS PLC-SPON ADR",
     "symbol": "USOPY"
    },
    {
     "description": "U.S. PHYSICAL THERAPY INC",
     "symbol": "USPH"
    },
    {
     "description": "ULTIMATE SPORTS INC",
     "symbol": "USPS"
    },
    {
     "description": "UNISOURCE CORP",
     "symbol": "USRC"
    },
    {
     "description": "USA RECYCLING INDUSTRIES INC",
     "symbol": "USRI"
    },
    {
     "description": "US STEM CELL INC",
     "symbol": "USRM"
    },
    {
     "description": "ISHARES CORE US REIT ETF",
     "symbol": "USRT"
    },
    {
     "description": "XTRACKERS MSCI USA ESG LDRS",
     "symbol": "USSG"
    },
    {
     "description": "UNISERVE COMMUNICATIONS CORP",
     "symbol": "USSHF"
    },
    {
     "description": "USS CO LTD",
     "symbol": "USSJF"
    },
    {
     "description": "USS CO LTD-UNSPON ADR",
     "symbol": "USSJY"
    },
    {
     "description": "PROSHARES ULTRA 7-10 YEAR TR",
     "symbol": "UST"
    },
    {
     "description": "VICTORYSHARES USAA CORE SHOR",
     "symbol": "USTB"
    },
    {
     "description": "USA REAL ESTATE HOLDING CO",
     "symbol": "USTC"
    },
    {
     "description": "VICTORYSHARES USAA MSCI USA",
     "symbol": "USVM"
    },
    {
     "description": "US VALUE ETF",
     "symbol": "USVT"
    },
    {
     "description": "US WIND FARMING INC",
     "symbol": "USWF"
    },
    {
     "description": "US WELL SERVICES INC",
     "symbol": "USWS"
    },
    {
     "description": "US WELL SERVICES INC-CW23",
     "symbol": "USWSW"
    },
    {
     "description": "US XPRESS ENTERPRISES INC -A",
     "symbol": "USX"
    },
    {
     "description": "ISHARES ESG ADVANCE MSCI USA",
     "symbol": "USXF"
    },
    {
     "description": "UNISYNC CORP",
     "symbol": "USYNF"
    },
    {
     "description": "UTA ACQUISITION CORPORATIO-A",
     "symbol": "UTAA"
    },
    {
     "description": "UTA ACQUISITION CORPORATION",
     "symbol": "UTAAU"
    },
    {
     "description": "UTA ACQUISITION CORPORAT -23",
     "symbol": "UTAAW"
    },
    {
     "description": "UNITED ARROWS LTD-ADR",
     "symbol": "UTDAY"
    },
    {
     "description": "UNITED E&P INC",
     "symbol": "UTDE"
    },
    {
     "description": "VIRTUS REAVES UTILITIES ETF",
     "symbol": "UTES"
    },
    {
     "description": "COHEN & STEERS INFRASTRUCTUR",
     "symbol": "UTF"
    },
    {
     "description": "REAVES UTILITY INCOME FUND",
     "symbol": "UTG"
    },
    {
     "description": "UTG INC",
     "symbol": "UTGN"
    },
    {
     "description": "UNITE GROUP PLC\/THE",
     "symbol": "UTGPF"
    },
    {
     "description": "UNITED THERAPEUTICS CORP",
     "symbol": "UTHR"
    },
    {
     "description": "UNIVERSAL TECHNICAL INSTITUT",
     "symbol": "UTI"
    },
    {
     "description": "UNITIL CORP",
     "symbol": "UTL"
    },
    {
     "description": "UTAH MEDICAL PRODUCTS INC",
     "symbol": "UTMD"
    },
    {
     "description": "UTIME LTD",
     "symbol": "UTME"
    },
    {
     "description": "UNITED INC",
     "symbol": "UTNDF"
    },
    {
     "description": "UDATA NET CORP",
     "symbol": "UTNT"
    },
    {
     "description": "TRACESAFE INC",
     "symbol": "UTOLF"
    },
    {
     "description": "UNIVERSAL TRACKING SOLUTIONS",
     "symbol": "UTRK"
    },
    {
     "description": "VESPER US LARGE CAP SHORT TE",
     "symbol": "UTRN"
    },
    {
     "description": "MINERVA SURGICAL INC",
     "symbol": "UTRS"
    },
    {
     "description": "UNITRONIX CORP",
     "symbol": "UTRX"
    },
    {
     "description": "UTSTARCOM HOLDINGS CORP",
     "symbol": "UTSI"
    },
    {
     "description": "DRX DLY UTILITIES BULL 3X",
     "symbol": "UTSL"
    },
    {
     "description": "UTZ BRANDS INC",
     "symbol": "UTZ"
    },
    {
     "description": "UNITED UTILITIES GROUP-ADR",
     "symbol": "UUGRY"
    },
    {
     "description": "UNITED UTILITIES GROUP PLC",
     "symbol": "UUGWF"
    },
    {
     "description": "UNITED URBAN INVESTMENT CORP",
     "symbol": "UUICF"
    },
    {
     "description": "UMT UNITED MOBILITY TECHNOLO",
     "symbol": "UUMTF"
    },
    {
     "description": "INVESCO DB US DOLLAR INDEX B",
     "symbol": "UUP"
    },
    {
     "description": "UCORE RARE METALS INC",
     "symbol": "UURAF"
    },
    {
     "description": "UNIVERSAL SECURITY INSTRUMNT",
     "symbol": "UUU"
    },
    {
     "description": "ENERGY FUELS INC",
     "symbol": "UUUU"
    },
    {
     "description": "UNIVERCELL HOLDINGS INC",
     "symbol": "UVCL"
    },
    {
     "description": "UVA DIVIDEND VALUE ETF",
     "symbol": "UVDV"
    },
    {
     "description": "UNIVERSAL INSURANCE HOLDINGS",
     "symbol": "UVE"
    },
    {
     "description": "UV FLU TECHNOLOGIES INC",
     "symbol": "UVFT"
    },
    {
     "description": "2X LONG VIX FUTURES ETF",
     "symbol": "UVIX"
    },
    {
     "description": "UNIVANICH PALM OIL PCL-NVDR",
     "symbol": "UVPOF"
    },
    {
     "description": "UNIVERSAL ROBINA CORP",
     "symbol": "UVRBF"
    },
    {
     "description": "UNIVERSAL ROBINA CORP-ADR",
     "symbol": "UVRBY"
    },
    {
     "description": "UNIVERSAL ENERGY CORP",
     "symbol": "UVSE"
    },
    {
     "description": "UNIVEST FINANCIAL CORP",
     "symbol": "UVSP"
    },
    {
     "description": "UNIVERSAL SYSTEMS INC\/WASH",
     "symbol": "UVSS"
    },
    {
     "description": "UNIVERSAL STAR HOLDINGS LTD",
     "symbol": "UVSTF"
    },
    {
     "description": "UNIVERSAL CORP\/VA",
     "symbol": "UVV"
    },
    {
     "description": "PROSHARES ULTRA VIX ST FUTUR",
     "symbol": "UVXY"
    },
    {
     "description": "UWC BHD",
     "symbol": "UWCBF"
    },
    {
     "description": "U3O8 CORP",
     "symbol": "UWEFF"
    },
    {
     "description": "UNITED WORLD HOLDING GROUP L",
     "symbol": "UWHGF"
    },
    {
     "description": "UWHARRIE CAPITAL CORP",
     "symbol": "UWHR"
    },
    {
     "description": "UWINK INC",
     "symbol": "UWKI"
    },
    {
     "description": "PROSHARES ULTRA RUSSELL2000",
     "symbol": "UWM"
    },
    {
     "description": "UWM HOLDINGS CORP",
     "symbol": "UWMC"
    },
    {
     "description": "GORES HOLDINGS IV INC -CW25",
     "symbol": "UWMC.WS"
    },
    {
     "description": "PROSHARES ULTRA INDUSTRIALS",
     "symbol": "UXI"
    },
    {
     "description": "UXIN LTD - ADR",
     "symbol": "UXIN"
    },
    {
     "description": "PROSHARES ULTRA FINANCIALS",
     "symbol": "UYG"
    },
    {
     "description": "PROSHARES ULTRA BASIC MATERI",
     "symbol": "UYM"
    },
    {
     "description": "FLUGHAFEN ZURICH AG-REG",
     "symbol": "UZAPF"
    },
    {
     "description": "UNITED STATES CELLULAR C",
     "symbol": "UZD"
    },
    {
     "description": "US CELLULAR CORP",
     "symbol": "UZE"
    },
    {
     "description": "US CELLULAR CORP",
     "symbol": "UZF"
    },
    {
     "description": "VISA INC-CLASS A SHARES",
     "symbol": "V"
    },
    {
     "description": "VIRGINIA NATIONAL BANKSHARES",
     "symbol": "VABK"
    },
    {
     "description": "VIRTUS NEWFLEET ABS\/MBS ETF",
     "symbol": "VABS"
    },
    {
     "description": "MARRIOTT VACATIONS WORLD",
     "symbol": "VAC"
    },
    {
     "description": "VACCITECH PLC",
     "symbol": "VACC"
    },
    {
     "description": "VAT GROUP AG-ADR",
     "symbol": "VACNY"
    },
    {
     "description": "VADO CORP",
     "symbol": "VADP"
    },
    {
     "description": "VAISALA OYJ- A SHS",
     "symbol": "VAIAF"
    },
    {
     "description": "VALARIS LTD",
     "symbol": "VAL"
    },
    {
     "description": "VALARIS LTD -CW28",
     "symbol": "VAL.WS"
    },
    {
     "description": "VALE SA-SP ADR",
     "symbol": "VALE"
    },
    {
     "description": "VALNEVA SE - ADR",
     "symbol": "VALN"
    },
    {
     "description": "AMERICAN CENTURY STOXX US",
     "symbol": "VALQ"
    },
    {
     "description": "ETFMG SIT ULTRA SHORT ETF",
     "symbol": "VALT"
    },
    {
     "description": "VALUE LINE INC",
     "symbol": "VALU"
    },
    {
     "description": "SHENGKAI INNOVATIONS INC",
     "symbol": "VALV"
    },
    {
     "description": "CAMBRIA VALUE & MOMENTUM ETF",
     "symbol": "VAMO"
    },
    {
     "description": "VANTEX RESOURCES LTD",
     "symbol": "VANTF"
    },
    {
     "description": "VANECK JPM EM LOC CUR BD ETF",
     "symbol": "VANVF"
    },
    {
     "description": "VAPOTHERM INC",
     "symbol": "VAPO"
    },
    {
     "description": "VAPORBRANDS INTERNATIONAL IN",
     "symbol": "VAPR"
    },
    {
     "description": "VECTOR ACQUISITION CORP II-A",
     "symbol": "VAQC"
    },
    {
     "description": "VA-Q-TEC AG",
     "symbol": "VAQTF"
    },
    {
     "description": "VARTA AG",
     "symbol": "VARGF"
    },
    {
     "description": "Varta Aktiengesel UNSP - ADR",
     "symbol": "VARTY"
    },
    {
     "description": "BOE VARITRONIX LTD",
     "symbol": "VARXF"
    },
    {
     "description": "VASO CORP",
     "symbol": "VASO"
    },
    {
     "description": "INNOVATE CORP",
     "symbol": "VATE"
    },
    {
     "description": "VIVA GOLD CORP",
     "symbol": "VAUCF"
    },
    {
     "description": "VANGUARD MATERIALS ETF",
     "symbol": "VAW"
    },
    {
     "description": "VAXXINITY INC-A",
     "symbol": "VAXX"
    },
    {
     "description": "VAYCAYCHELLA INC",
     "symbol": "VAYK"
    },
    {
     "description": "VANGUARD SMALL-CAP ETF",
     "symbol": "VB"
    },
    {
     "description": "VALKYRIE BALANCE SHEET OPPS",
     "symbol": "VBB"
    },
    {
     "description": "INVESCO BOND FUND",
     "symbol": "VBF"
    },
    {
     "description": "VILLAGE BANK AND TRUST FINAN",
     "symbol": "VBFC"
    },
    {
     "description": "VERDE BIO HOLDINGS INC",
     "symbol": "VBHI"
    },
    {
     "description": "VBI VACCINES INC",
     "symbol": "VBIV"
    },
    {
     "description": "VIEWBIX INC",
     "symbol": "VBIX"
    },
    {
     "description": "VIVA BIOTECH HOLDINGS",
     "symbol": "VBIZF"
    },
    {
     "description": "VANGUARD SMALL-CAP GRWTH ETF",
     "symbol": "VBK"
    },
    {
     "description": "VASCULAR BIOGENICS LTD",
     "symbol": "VBLT"
    },
    {
     "description": "VIDENT CORE US BOND STRATEGY",
     "symbol": "VBND"
    },
    {
     "description": "VERSABANK",
     "symbol": "VBNK"
    },
    {
     "description": "VISCOGLIOSI BROTHERS ACQUISI",
     "symbol": "VBOC"
    },
    {
     "description": "VISCOGLIOSI BROTHERS ACQUISI",
     "symbol": "VBOCU"
    },
    {
     "description": "VISCOGLIOSI BROTHERS AC -27",
     "symbol": "VBOCW"
    },
    {
     "description": "VANGUARD SMALL-CAP VALUE ETF",
     "symbol": "VBR"
    },
    {
     "description": "VUBOTICS INC",
     "symbol": "VBTC"
    },
    {
     "description": "VERITEX HOLDINGS INC",
     "symbol": "VBTX"
    },
    {
     "description": "VERBIO VEREINIGTE BIOENERGI",
     "symbol": "VBVBF"
    },
    {
     "description": "VIABUILT VENTURES INC",
     "symbol": "VBVT"
    },
    {
     "description": "VISTEON CORP",
     "symbol": "VC"
    },
    {
     "description": "SIMPLIFY VOLT ROBOCAR DISRUP",
     "symbol": "VCAR"
    },
    {
     "description": "VITALIBIS INC",
     "symbol": "VCBDQ"
    },
    {
     "description": "V-CUBE INC",
     "symbol": "VCCBF"
    },
    {
     "description": "VALUECOMMERCE CO LTD",
     "symbol": "VCCLF"
    },
    {
     "description": "VICTORIA PLC",
     "symbol": "VCCTF"
    },
    {
     "description": "VANGUARD ESG US CORP BOND",
     "symbol": "VCEB"
    },
    {
     "description": "VERICEL CORP",
     "symbol": "VCEL"
    },
    {
     "description": "VALUE CONVERGENCE HOLDINGS",
     "symbol": "VCHLF"
    },
    {
     "description": "V TECHNOLOGY CO LTD",
     "symbol": "VCHYF"
    },
    {
     "description": "VERTICAL CAPITAL INCOME",
     "symbol": "VCIF"
    },
    {
     "description": "VITREOUS GLASS INC",
     "symbol": "VCIGF"
    },
    {
     "description": "VIVICELLS INTERNATIONAL INC",
     "symbol": "VCII"
    },
    {
     "description": "VINCI SA",
     "symbol": "VCISF"
    },
    {
     "description": "VINCI S.A.-UNSPONS ADR",
     "symbol": "VCISY"
    },
    {
     "description": "VANGUARD INT-TERM CORPORATE",
     "symbol": "VCIT"
    },
    {
     "description": "VICKERS VANTAGE CORP I",
     "symbol": "VCKA"
    },
    {
     "description": "VICKERS VANTAGE CORP I",
     "symbol": "VCKAU"
    },
    {
     "description": "VICKERS VANTAGE CORP I -CW27",
     "symbol": "VCKAW"
    },
    {
     "description": "VANECK MORNINGST US MOAT ETF",
     "symbol": "VCKVF"
    },
    {
     "description": "VERECLOUD INC",
     "symbol": "VCLD"
    },
    {
     "description": "VIRTUS DUFF & PHELPS CLEAN E",
     "symbol": "VCLN"
    },
    {
     "description": "S\/V CLOUD & CYBERSECURITY DI",
     "symbol": "VCLO"
    },
    {
     "description": "VANGUARD LONG-TERM CORP BOND",
     "symbol": "VCLT"
    },
    {
     "description": "VCAMPUS CORP",
     "symbol": "VCMP"
    },
    {
     "description": "VACCINEX INC",
     "symbol": "VCNX"
    },
    {
     "description": "VICTORIA OIL & GAS PLC",
     "symbol": "VCOGF"
    },
    {
     "description": "VICON INDUSTRIES INC",
     "symbol": "VCON"
    },
    {
     "description": "VISIBER57 CORP",
     "symbol": "VCOR"
    },
    {
     "description": "VICPLAS INTERNATIONAL LTD",
     "symbol": "VCPLF"
    },
    {
     "description": "VANGUARD CONSUMER DISCRE ETF",
     "symbol": "VCR"
    },
    {
     "description": "VANG USDCPBD USDA",
     "symbol": "VCRPF"
    },
    {
     "description": "VACASA INC -CL A",
     "symbol": "VCSA"
    },
    {
     "description": "VANGUARD S\/T CORP BOND ETF",
     "symbol": "VCSH"
    },
    {
     "description": "VIEWCAST.COM INC",
     "symbol": "VCST"
    },
    {
     "description": "RAINMAKER SYSTEMS INC",
     "symbol": "VCTL"
    },
    {
     "description": "VICTORY CAPITAL HOLDING - A",
     "symbol": "VCTR"
    },
    {
     "description": "VECTION TECHNOLOGIES LTD",
     "symbol": "VCTTF"
    },
    {
     "description": "VIDEOLOCITY INTERNATIONAL",
     "symbol": "VCTY"
    },
    {
     "description": "VIZSLA COPPER CORP",
     "symbol": "VCUFF"
    },
    {
     "description": "INVESCO CA V M I",
     "symbol": "VCV"
    },
    {
     "description": "VINACAPITAL VIETNAM OPPORTUN",
     "symbol": "VCVOF"
    },
    {
     "description": "VATIC VENTURES CORP",
     "symbol": "VCVVF"
    },
    {
     "description": "10X CAPITAL VENTURE ACQUIS-A",
     "symbol": "VCXA"
    },
    {
     "description": "10X CAPITAL VENTURE ACQUISIT",
     "symbol": "VCXAU"
    },
    {
     "description": "10X CAPITAL VENTURE AC -CW27",
     "symbol": "VCXAW"
    },
    {
     "description": "10X CAPITAL VENTURE ACQUIS-A",
     "symbol": "VCXB"
    },
    {
     "description": "10X CAPITAL VENTURE ACQUISIT",
     "symbol": "VCXB.U"
    },
    {
     "description": "10X CAPITAL VENTURE AC -CW27",
     "symbol": "VCXB.WS"
    },
    {
     "description": "VELOCITY ENERGY INC",
     "symbol": "VCYE"
    },
    {
     "description": "VERACYTE INC",
     "symbol": "VCYT"
    },
    {
     "description": "VINDA INTERNATIONAL HOLDINGS",
     "symbol": "VDAHF"
    },
    {
     "description": "VINDA INTERNATIONAL-UNSP ADR",
     "symbol": "VDAHY"
    },
    {
     "description": "VANGUARD CONSUMER STAPLE ETF",
     "symbol": "VDC"
    },
    {
     "description": "VANGUARD ENERGY ETF",
     "symbol": "VDE"
    },
    {
     "description": "VEIDEKKE ASA",
     "symbol": "VDEKF"
    },
    {
     "description": "VAN DE VELDE NV",
     "symbol": "VDEVF"
    },
    {
     "description": "VODKA BRANDS CORP",
     "symbol": "VDKB"
    },
    {
     "description": "VODACOM GROUP LTD-SP ADR",
     "symbol": "VDMCY"
    },
    {
     "description": "VOYAGER METALS INC",
     "symbol": "VDMRF"
    },
    {
     "description": "V-SHARES US LEADER DIVERSITY",
     "symbol": "VDNI"
    },
    {
     "description": "VAL-D'OR MINING CORP",
     "symbol": "VDOMF"
    },
    {
     "description": "GNOMESTAR CRAFT INC",
     "symbol": "VDQSF"
    },
    {
     "description": "VIDRALA SA",
     "symbol": "VDRFF"
    },
    {
     "description": "VIADERMA INC",
     "symbol": "VDRM"
    },
    {
     "description": "VENDETTA MINING CORP",
     "symbol": "VDTAF"
    },
    {
     "description": "VANGUARD FTSE DEVELOPED ETF",
     "symbol": "VEA"
    },
    {
     "description": "VECTRUS INC",
     "symbol": "VEC"
    },
    {
     "description": "VEECO INSTRUMENTS INC",
     "symbol": "VECO"
    },
    {
     "description": "VECTIVBIO HOLDING AG",
     "symbol": "VECT"
    },
    {
     "description": "Vedanta Limited",
     "symbol": "VEDL"
    },
    {
     "description": "TWIN VEE POWERCATS CO",
     "symbol": "VEEE"
    },
    {
     "description": "VEEVA SYSTEMS INC-CLASS A",
     "symbol": "VEEV"
    },
    {
     "description": "VEF AB",
     "symbol": "VEFFF"
    },
    {
     "description": "ADVSHRS STAR GBL BUY-WRITE",
     "symbol": "VEGA"
    },
    {
     "description": "BETTER PLANT SCIENCES INC",
     "symbol": "VEGGD"
    },
    {
     "description": "ISHARES MSCI GLOBAL AGRICULT",
     "symbol": "VEGI"
    },
    {
     "description": "US VEGAN CLIMATE ETF",
     "symbol": "VEGN"
    },
    {
     "description": "VIRGINIA ENERGY RESOURCES IN",
     "symbol": "VEGYF"
    },
    {
     "description": "VALUE EXCHANGE INTERNATIONAL",
     "symbol": "VEII"
    },
    {
     "description": "VEJII HOLDINGS LTD",
     "symbol": "VEJID"
    },
    {
     "description": "VELOCITY FINANCIAL INC",
     "symbol": "VEL"
    },
    {
     "description": "VELOCITY ACQUISITION CORP-A",
     "symbol": "VELO"
    },
    {
     "description": "VELOCITY ACQUISITION CORP",
     "symbol": "VELOU"
    },
    {
     "description": "VELOCITY ACQUISITION-CW27",
     "symbol": "VELOW"
    },
    {
     "description": "CANADIAN OVERSEAS PETROLEUM",
     "symbol": "VELXF"
    },
    {
     "description": "VANG USDEMGVB USDA",
     "symbol": "VEMGF"
    },
    {
     "description": "VENTURE CORP LTD",
     "symbol": "VEMLF"
    },
    {
     "description": "VENTURE CORP LTD-UNSP ADR",
     "symbol": "VEMLY"
    },
    {
     "description": "VENUS ACQUISITION CORP",
     "symbol": "VENA"
    },
    {
     "description": "VENUS ACQUISITION CORP -RTS",
     "symbol": "VENAR"
    },
    {
     "description": "VENUS ACQUISITION CORP",
     "symbol": "VENAU"
    },
    {
     "description": "VENUS ACQUISITION CORP -CW27",
     "symbol": "VENAW"
    },
    {
     "description": "VENZEE TECHNOLOGIES INC",
     "symbol": "VENZF"
    },
    {
     "description": "VEOLIA ENVIRONNEMENT",
     "symbol": "VEOEF"
    },
    {
     "description": "VEOLIA ENVIRONNEMENT-ADR",
     "symbol": "VEOEY"
    },
    {
     "description": "VEON LTD",
     "symbol": "VEON"
    },
    {
     "description": "VERA THERAPEUTICS INC",
     "symbol": "VERA"
    },
    {
     "description": "VERB TECHNOLOGY CO INC",
     "symbol": "VERB"
    },
    {
     "description": "VERB TECHNOLOGY CO INC-CW24",
     "symbol": "VERBW"
    },
    {
     "description": "VERSAILLES FINANCIAL CORP",
     "symbol": "VERF"
    },
    {
     "description": "VERITONE INC",
     "symbol": "VERI"
    },
    {
     "description": "VERKKOKAUPPA.COM OYJ",
     "symbol": "VERKF"
    },
    {
     "description": "VENUS CONCEPT INC",
     "symbol": "VERO"
    },
    {
     "description": "PROSHARES METAVERSE ETF",
     "symbol": "VERS"
    },
    {
     "description": "VERU INC",
     "symbol": "VERU"
    },
    {
     "description": "VERVE THERAPEUTICS INC",
     "symbol": "VERV"
    },
    {
     "description": "VERTEX INC - CLASS A",
     "symbol": "VERX"
    },
    {
     "description": "VERICITY INC",
     "symbol": "VERY"
    },
    {
     "description": "VESTIAGE INC",
     "symbol": "VEST"
    },
    {
     "description": "CORP INMOBILIARIA VESTA SAB",
     "symbol": "VESTF"
    },
    {
     "description": "VERMILION ENERGY INC",
     "symbol": "VET"
    },
    {
     "description": "VETOQUINOL SA",
     "symbol": "VETOF"
    },
    {
     "description": "VECTOR LTD",
     "symbol": "VETTF"
    },
    {
     "description": "VANGUARD FTSE ALL-WORLD EX-U",
     "symbol": "VEU"
    },
    {
     "description": "VICINITY MOTOR CORP",
     "symbol": "VEV"
    },
    {
     "description": "VEXT SCIENCE INC",
     "symbol": "VEXTF"
    },
    {
     "description": "VANG FTSE AW USDA",
     "symbol": "VFAWF"
    },
    {
     "description": "VF CORP",
     "symbol": "VFC"
    },
    {
     "description": "VANG FTSE EUR EURD",
     "symbol": "VFDEF"
    },
    {
     "description": "VANG FTSE EM USDA",
     "symbol": "VFEAF"
    },
    {
     "description": "VILLAGE FARMS INTERNATIONAL",
     "symbol": "VFF"
    },
    {
     "description": "VANGUARD FINANCIALS ETF",
     "symbol": "VFH"
    },
    {
     "description": "SIMPLIFY VOLT FINTECH DISRUP",
     "symbol": "VFIN"
    },
    {
     "description": "DELAWARE INV NATL MUNI INC F",
     "symbol": "VFL"
    },
    {
     "description": "VANGUARD US LIQUIDITY FACTOR",
     "symbol": "VFLQ"
    },
    {
     "description": "VANGUARD US MULTIFACTOR ETF",
     "symbol": "VFMF"
    },
    {
     "description": "VANGUARD US MOMENTUM FACTOR",
     "symbol": "VFMO"
    },
    {
     "description": "VANGUARD US MINIMUM VOLATILI",
     "symbol": "VFMV"
    },
    {
     "description": "VANG FTSEAPXJ USDA",
     "symbol": "VFPAF"
    },
    {
     "description": "VANG FTSE AW USDD",
     "symbol": "VFPEF"
    },
    {
     "description": "VANGUARD U.S. QUALITY FACTOR",
     "symbol": "VFQY"
    },
    {
     "description": "VERITAS FARMS INC",
     "symbol": "VFRM"
    },
    {
     "description": "VANG FTSE NA USDA",
     "symbol": "VFUUF"
    },
    {
     "description": "VANGUARD U.S. VALUE FACTOR",
     "symbol": "VFVA"
    },
    {
     "description": "VONAGE HOLDINGS CORP",
     "symbol": "VG"
    },
    {
     "description": "PLANT & CO BRANDS LTD",
     "symbol": "VGANF"
    },
    {
     "description": "VANGUARD AU PROP SEC IDX ETF",
     "symbol": "VGAPF"
    },
    {
     "description": "VANG FTSE DW USDA",
     "symbol": "VGDDF"
    },
    {
     "description": "VANG USD 0-1YR TRBD USDA",
     "symbol": "VGDFF"
    },
    {
     "description": "VANG FTSE JPN USDA",
     "symbol": "VGDTF"
    },
    {
     "description": "VANG FTSE DW USDD",
     "symbol": "VGDVF"
    },
    {
     "description": "VERY GOOD FOOD CO INC\/THE",
     "symbol": "VGFC"
    },
    {
     "description": "VANG FTSE NA USDD",
     "symbol": "VGFNF"
    },
    {
     "description": "VANG S&P500 USDA",
     "symbol": "VGFPF"
    },
    {
     "description": "VANG USDEMGVB USDD",
     "symbol": "VGFUF"
    },
    {
     "description": "VANGUARD AUST SHARES IDX ETF",
     "symbol": "VGGDF"
    },
    {
     "description": "BOOSH PLANT-BASED BRANDS INC",
     "symbol": "VGGIF"
    },
    {
     "description": "GREENHAWK RESOURCES INC",
     "symbol": "VGGOF"
    },
    {
     "description": "VIRTUS GLOBAL MULTI-SECTOR",
     "symbol": "VGI"
    },
    {
     "description": "V GROUP INC",
     "symbol": "VGID"
    },
    {
     "description": "VIRGIN GROUP ACQUISITION C-A",
     "symbol": "VGII"
    },
    {
     "description": "VIRGIN GROUP ACQUISITION COR",
     "symbol": "VGII.U"
    },
    {
     "description": "VIRGIN GROUP ACQ C A -CW26",
     "symbol": "VGII.WS"
    },
    {
     "description": "VGI PARTNERS LTD",
     "symbol": "VGIPF"
    },
    {
     "description": "VANGUARD INTERMEDIATE-TERM T",
     "symbol": "VGIT"
    },
    {
     "description": "VANGUARD FTSE EUROPE ETF",
     "symbol": "VGK"
    },
    {
     "description": "VISTA GROUP INTERNATIONAL LT",
     "symbol": "VGLIF"
    },
    {
     "description": "VG LIFE SCIENCES INC",
     "symbol": "VGLS"
    },
    {
     "description": "VANGUARD LONG-TERM TREASURY",
     "symbol": "VGLT"
    },
    {
     "description": "INVESCO TRUST FOR INVESTMEN",
     "symbol": "VGM"
    },
    {
     "description": "VISIBLE GOLD MINES INC",
     "symbol": "VGMIF"
    },
    {
     "description": "VGP",
     "symbol": "VGPBF"
    },
    {
     "description": "VECTOR GROUP LTD",
     "symbol": "VGR"
    },
    {
     "description": "VANG FTSE DEX EURA",
     "symbol": "VGRDF"
    },
    {
     "description": "VIASPACE GREEN ENERGY INC",
     "symbol": "VGREF"
    },
    {
     "description": "VANG FTSE100 GBPA",
     "symbol": "VGRRF"
    },
    {
     "description": "VANG GLBAGG ETF USD H ACC",
     "symbol": "VGRSF"
    },
    {
     "description": "VANGUARD SHORT-TERM TREASURY",
     "symbol": "VGSH"
    },
    {
     "description": "VANGUARD INFO TECH ETF",
     "symbol": "VGT"
    },
    {
     "description": "VGTEL INC",
     "symbol": "VGTL"
    },
    {
     "description": "VANG FTSEAPXJ USDD",
     "symbol": "VGUDF"
    },
    {
     "description": "VANG FTSE HDY USDA",
     "symbol": "VGWEF"
    },
    {
     "description": "VISTA GOLD CORP",
     "symbol": "VGZ"
    },
    {
     "description": "VIVEON HEALTH ACQUISITION CO",
     "symbol": "VHAQ"
    },
    {
     "description": "Viveon Health Acquisition Corp",
     "symbol": "VHAQ.RT"
    },
    {
     "description": "VIVEON HEALTH ACQUISITION CO",
     "symbol": "VHAQ.U"
    },
    {
     "description": "VIVEON HEALTH ACQ -CW27",
     "symbol": "VHAQ.WS"
    },
    {
     "description": "VIRNETX HOLDING CORP",
     "symbol": "VHC"
    },
    {
     "description": "VALHI INC",
     "symbol": "VHI"
    },
    {
     "description": "VITALHUB CORP",
     "symbol": "VHIBF"
    },
    {
     "description": "VECTOR 21 HOLDINGS INC",
     "symbol": "VHLD"
    },
    {
     "description": "VALUETRONICS HOLDINGS LTD",
     "symbol": "VHLGF"
    },
    {
     "description": "VAHANNA TECH EDGE ACQUISI-A",
     "symbol": "VHNA"
    },
    {
     "description": "VAHANNA TECH EDGE ACQUISITIO",
     "symbol": "VHNAU"
    },
    {
     "description": "VAHANNA TECH EDGE -CW24",
     "symbol": "VHNAW"
    },
    {
     "description": "VANGUARD HEALTH CARE ETF",
     "symbol": "VHT"
    },
    {
     "description": "VAPOR HUB INTERNATIONAL INC",
     "symbol": "VHUB"
    },
    {
     "description": "VIA RENEWABLES INC",
     "symbol": "VIA"
    },
    {
     "description": "FLUGHAFEN WIEN AG-SP ADR",
     "symbol": "VIAAY"
    },
    {
     "description": "VIA OPTRONICS AG",
     "symbol": "VIAO"
    },
    {
     "description": "VIA PHARMACEUTICALS INC",
     "symbol": "VIAP"
    },
    {
     "description": "VIA RENEWABLES INC",
     "symbol": "VIASP"
    },
    {
     "description": "VIAVI SOLUTIONS INC",
     "symbol": "VIAV"
    },
    {
     "description": "VIB VERMOEGEN AG",
     "symbol": "VIBBF"
    },
    {
     "description": "VIBE GROWTH CORP",
     "symbol": "VIBEF"
    },
    {
     "description": "VIB VERMOEGEN AG-UNSP ADR",
     "symbol": "VIBVY"
    },
    {
     "description": "RAFINA INNOVATIONS INC",
     "symbol": "VICA"
    },
    {
     "description": "ADVISORSHARES VICE ETF",
     "symbol": "VICE"
    },
    {
     "description": "VICI PROPERTIES INC",
     "symbol": "VICI"
    },
    {
     "description": "VICAPSYS LIFE SCIENCES INC",
     "symbol": "VICP"
    },
    {
     "description": "VICOR CORP",
     "symbol": "VICR"
    },
    {
     "description": "VICTURA CONSTRUCTION GROUP I",
     "symbol": "VICT"
    },
    {
     "description": "VIDAROO CORP",
     "symbol": "VIDA"
    },
    {
     "description": "VIDEO DISPLAY CORP",
     "symbol": "VIDE"
    },
    {
     "description": "VIDENT INTERNATIONAL EQUITY",
     "symbol": "VIDI"
    },
    {
     "description": "WAYPOINT REIT",
     "symbol": "VIEGF"
    },
    {
     "description": "VIEW INC",
     "symbol": "VIEW"
    },
    {
     "description": "VIEWTRAN GROUP INC",
     "symbol": "VIEWF"
    },
    {
     "description": "CF FINANCE ACQUISITION -CW27",
     "symbol": "VIEWW"
    },
    {
     "description": "VIE FINANCIAL GROUP INC",
     "symbol": "VIFI"
    },
    {
     "description": "VANGUARD DIVIDEND APPREC ETF",
     "symbol": "VIG"
    },
    {
     "description": "VANGUARD INT DIV APP INDX FD",
     "symbol": "VIGI"
    },
    {
     "description": "VIGIL NEUROSCIENCE INC",
     "symbol": "VIGL"
    },
    {
     "description": "VISION HYDROGEN CORP",
     "symbol": "VIHD"
    },
    {
     "description": "7GC & CO HOLDINGS INC -CL A",
     "symbol": "VII"
    },
    {
     "description": "7GC & CO HOLDINGS INC",
     "symbol": "VIIAU"
    },
    {
     "description": "7GC & CO HOLDINGS CL A -CW26",
     "symbol": "VIIAW"
    },
    {
     "description": "VELOCITYSHARES VIX SHORT-TRM",
     "symbol": "VIIXF"
    },
    {
     "description": "YOURGENE HEALTH PLC",
     "symbol": "VILGF"
    },
    {
     "description": "VIMIAN GROUP AB",
     "symbol": "VIMGF"
    },
    {
     "description": "VINCERX PHARMA INC",
     "symbol": "VINC"
    },
    {
     "description": "FRESH VINE WINE INC",
     "symbol": "VINE"
    },
    {
     "description": "GAUCHO GROUP HOLDINGS INC",
     "symbol": "VINO"
    },
    {
     "description": "VINCI PARTNERS INVESTMENTS-A",
     "symbol": "VINP"
    },
    {
     "description": "VINDICATOR SILVER LEAD MNG",
     "symbol": "VINS"
    },
    {
     "description": "VANGUARD S&P SMALL-CAP 600 G",
     "symbol": "VIOG"
    },
    {
     "description": "VANGUARD S&P SMALL-CAP 600 E",
     "symbol": "VIOO"
    },
    {
     "description": "VIOR INC",
     "symbol": "VIORF"
    },
    {
     "description": "VIOMI TECHNOLOGY CO LTD-ADR",
     "symbol": "VIOT"
    },
    {
     "description": "VANGUARD S&P SMALL-CAP 600 V",
     "symbol": "VIOV"
    },
    {
     "description": "V.I.P. COMLINK",
     "symbol": "VIPK"
    },
    {
     "description": "SILVER VIPER MINERALS CORP",
     "symbol": "VIPRF"
    },
    {
     "description": "VIPSHOP HOLDINGS LTD - ADR",
     "symbol": "VIPS"
    },
    {
     "description": "VIPR CORP",
     "symbol": "VIPV"
    },
    {
     "description": "VIR BIOTECHNOLOGY INC",
     "symbol": "VIR"
    },
    {
     "description": "VIRATECH CORP",
     "symbol": "VIRA"
    },
    {
     "description": "VIRCO MFG CORPORATION",
     "symbol": "VIRC"
    },
    {
     "description": "VIRIOS THERAPEUTICS INC",
     "symbol": "VIRI"
    },
    {
     "description": "PACER BIOTHREAT ETF",
     "symbol": "VIRS"
    },
    {
     "description": "VIRTU FINANCIAL INC-CLASS A",
     "symbol": "VIRT"
    },
    {
     "description": "VIRACTA THERAPEUTICS INC",
     "symbol": "VIRX"
    },
    {
     "description": "VANGUARD INDUSTRIALS ETF",
     "symbol": "VIS"
    },
    {
     "description": "VISLINK TECHNOLOGIES INC",
     "symbol": "VISL"
    },
    {
     "description": "VISIUM TECHNOLOGIES INC",
     "symbol": "VISM"
    },
    {
     "description": "VISTA OIL & GAS SAB DE CV",
     "symbol": "VIST"
    },
    {
     "description": "VICTORIA GOLD CORP",
     "symbol": "VITFF"
    },
    {
     "description": "VITAL FARMS INC",
     "symbol": "VITL"
    },
    {
     "description": "VITRO S.A.B.-SERIES A",
     "symbol": "VITOF"
    },
    {
     "description": "VITANA-X INC",
     "symbol": "VITX"
    },
    {
     "description": "VITRO SAB-UNSPONSORED ADR",
     "symbol": "VITYY"
    },
    {
     "description": "TELEFONICA BRASIL-ADR",
     "symbol": "VIV"
    },
    {
     "description": "VIVIC CORP",
     "symbol": "VIVC"
    },
    {
     "description": "VIVEVE MEDICAL INC",
     "symbol": "VIVE"
    },
    {
     "description": "VIVENDI SE",
     "symbol": "VIVEF"
    },
    {
     "description": "VIVENDI SE-UNSPON ADR",
     "symbol": "VIVHY"
    },
    {
     "description": "VIVAKOR INC",
     "symbol": "VIVK"
    },
    {
     "description": "MERIDIAN BIOSCIENCE INC",
     "symbol": "VIVO"
    },
    {
     "description": "VIVORYON THERAPEUTICS NV",
     "symbol": "VIVRF"
    },
    {
     "description": "AVIVAGEN INC",
     "symbol": "VIVXF"
    },
    {
     "description": "PROSHARES VIX MID-TERM FUT",
     "symbol": "VIXM"
    },
    {
     "description": "PROSHARES VIX SHORT-TERM FUT",
     "symbol": "VIXY"
    },
    {
     "description": "VIZCONNECT INC",
     "symbol": "VIZC"
    },
    {
     "description": "VISIONGLOBAL CORP",
     "symbol": "VIZG"
    },
    {
     "description": "VISIONARY GOLD CORP",
     "symbol": "VIZNF"
    },
    {
     "description": "VOXELJET AG-ADR",
     "symbol": "VJET"
    },
    {
     "description": "VIKING LINE OYJ",
     "symbol": "VKGLF"
    },
    {
     "description": "INVESCO AD MIT II",
     "symbol": "VKI"
    },
    {
     "description": "VIKING ENERGY GROUP INC",
     "symbol": "VKIN"
    },
    {
     "description": "INVESCO MUNICIPAL TRUST",
     "symbol": "VKQ"
    },
    {
     "description": "VISKASE COS INC",
     "symbol": "VKSC"
    },
    {
     "description": "VITAL KSK HOLDINGS INC",
     "symbol": "VKSKF"
    },
    {
     "description": "VIKING THERAPEUTICS INC",
     "symbol": "VKTX"
    },
    {
     "description": "VANECK PREF US EQUITY ETF",
     "symbol": "VKVEF"
    },
    {
     "description": "VALOR LATITUDE ACQUISITION-A",
     "symbol": "VLAT"
    },
    {
     "description": "VALOR LATITUDE ACQUISITION C",
     "symbol": "VLATU"
    },
    {
     "description": "VALOR LATITUDE ACQ A -CW28",
     "symbol": "VLATW"
    },
    {
     "description": "VALENTINE BEAUTY INC",
     "symbol": "VLBI"
    },
    {
     "description": "VILLEROY & BOCH AG-PFD",
     "symbol": "VLBOF"
    },
    {
     "description": "VELOCITY MINERALS LTD",
     "symbol": "VLCJF"
    },
    {
     "description": "VOLCON INC",
     "symbol": "VLCN"
    },
    {
     "description": "VOLCAN CIA MINERA SAA-CMN B",
     "symbol": "VLCNF"
    },
    {
     "description": "VELO3D INC",
     "symbol": "VLD"
    },
    {
     "description": "VELO3D INC             -CW25",
     "symbol": "VLD.WS"
    },
    {
     "description": "VALIDIAN CORP",
     "symbol": "VLDI"
    },
    {
     "description": "VELODYNE LIDAR INC",
     "symbol": "VLDR"
    },
    {
     "description": "GRAF INDUSTRIAL CORP-CW25",
     "symbol": "VLDRW"
    },
    {
     "description": "VALEO",
     "symbol": "VLEEF"
    },
    {
     "description": "VALEO SA-SPON ADR",
     "symbol": "VLEEY"
    },
    {
     "description": "VALUEGOLD ETF-HKD",
     "symbol": "VLGDF"
    },
    {
     "description": "VILLAGE SUPER MARKET-CLASS A",
     "symbol": "VLGEA"
    },
    {
     "description": "VOLKSWAGEN AG",
     "symbol": "VLKAF"
    },
    {
     "description": "VOLKSWAGEN AG-PREF",
     "symbol": "VLKPF"
    },
    {
     "description": "VISCOUNT MINING CORP",
     "symbol": "VLMGF"
    },
    {
     "description": "VALMET OYJ-UNSP  ADR",
     "symbol": "VLMTY"
    },
    {
     "description": "VOLCANIC GOLD MINES INC",
     "symbol": "VLMZF"
    },
    {
     "description": "VALENS SEMICONDUCTOR LTD",
     "symbol": "VLN"
    },
    {
     "description": "VALENS SEMICONDUCTOR -CW26",
     "symbol": "VLN.WS"
    },
    {
     "description": "VALENS CO INC\/THE",
     "symbol": "VLNS"
    },
    {
     "description": "VELAN INC",
     "symbol": "VLNSF"
    },
    {
     "description": "VAN LANSCHOT KEMPEN NV",
     "symbol": "VLNVF"
    },
    {
     "description": "VALERO ENERGY CORP",
     "symbol": "VLO"
    },
    {
     "description": "VALLON PHARMACEUTICALS INC",
     "symbol": "VLON"
    },
    {
     "description": "VALLOUREC SA",
     "symbol": "VLOUF"
    },
    {
     "description": "VALLOUREC SA-SPN ADR",
     "symbol": "VLOWY"
    },
    {
     "description": "VOESTALPINE AG",
     "symbol": "VLPNF"
    },
    {
     "description": "VOESTALPINE AG-UNSPON ADR",
     "symbol": "VLPNY"
    },
    {
     "description": "CONTROLADORA VUELA CIA-ADR",
     "symbol": "VLRS"
    },
    {
     "description": "INVESCO HIGH INCOME TRUST II",
     "symbol": "VLT"
    },
    {
     "description": "VOLTA INC",
     "symbol": "VLTA"
    },
    {
     "description": "VOLTA INC-CW26",
     "symbol": "VLTA.WS"
    },
    {
     "description": "VOLTALIA SA- REGR",
     "symbol": "VLTAF"
    },
    {
     "description": "VOLTA FINANCE LTD",
     "symbol": "VLTFF"
    },
    {
     "description": "VOLT RESOURCES LTD",
     "symbol": "VLTRF"
    },
    {
     "description": "VOLATUS AEROSPACE CORP",
     "symbol": "VLTTF"
    },
    {
     "description": "SPDR S&P 1500 VALUE TILT ETF",
     "symbol": "VLU"
    },
    {
     "description": "ISHARES MSCI USA VALUE FACTO",
     "symbol": "VLUE"
    },
    {
     "description": "Volution Group PLC",
     "symbol": "VLUTF"
    },
    {
     "description": "VOLVO CAR AB - ADR",
     "symbol": "VLVCY"
    },
    {
     "description": "VOLVO AB-B SHS-UNSPON ADR",
     "symbol": "VLVLY"
    },
    {
     "description": "VOLVO CAR AB-B",
     "symbol": "VLVOF"
    },
    {
     "description": "VELTEX CORP",
     "symbol": "VLXC"
    },
    {
     "description": "VOLEX PLC",
     "symbol": "VLXGF"
    },
    {
     "description": "VALLEY NATIONAL BANCORP",
     "symbol": "VLY"
    },
    {
     "description": "VALLEY NATIONAL BANCORP",
     "symbol": "VLYPO"
    },
    {
     "description": "VALLEY NATIONAL BANCORP",
     "symbol": "VLYPP"
    },
    {
     "description": "VISION MARINE TECHNOLOGIES",
     "symbol": "VMAR"
    },
    {
     "description": "VANGUARD MORTGAGE-BACKED SEC",
     "symbol": "VMBS"
    },
    {
     "description": "VULCAN MATERIALS CO",
     "symbol": "VMC"
    },
    {
     "description": "VALUENCE MERGER CORP I-CL A",
     "symbol": "VMCA"
    },
    {
     "description": "VALUENCE MERGER CORP I",
     "symbol": "VMCAU"
    },
    {
     "description": "VALUENCE MERGER CORP -CW27",
     "symbol": "VMCAW"
    },
    {
     "description": "VISUALMED CLINICAL SOLUTIONS",
     "symbol": "VMCS"
    },
    {
     "description": "VIEMED HEALTHCARE INC",
     "symbol": "VMD"
    },
    {
     "description": "VIMEO INC",
     "symbol": "VMEO"
    },
    {
     "description": "VMG CONSUMER ACQUISITION C-A",
     "symbol": "VMGA"
    },
    {
     "description": "VMG CONSUMER ACQUISITION COR",
     "symbol": "VMGAU"
    },
    {
     "description": "VMG CONSUMER ACQUISITION COR",
     "symbol": "VMGAW"
    },
    {
     "description": "VICTORY MARINE HOLDINGS CORP",
     "symbol": "VMHG"
    },
    {
     "description": "VALMONT INDUSTRIES",
     "symbol": "VMI"
    },
    {
     "description": "VANSTAR MINING RESOURCES INC",
     "symbol": "VMNGF"
    },
    {
     "description": "VEMANTI GROUP INC",
     "symbol": "VMNT"
    },
    {
     "description": "INVESCO MUNICIPAL OPPORTUNI",
     "symbol": "VMO"
    },
    {
     "description": "ALPHA VALUE MOM TREND ETF",
     "symbol": "VMOT"
    },
    {
     "description": "VALMIE RESOURCES INC",
     "symbol": "VMRI"
    },
    {
     "description": "VIMY RESOURCES LTD",
     "symbol": "VMRSF"
    },
    {
     "description": "VITA MOBILE SYSTEMS INC",
     "symbol": "VMSI"
    },
    {
     "description": "VMT SCIENTIFIC INC",
     "symbol": "VMTF"
    },
    {
     "description": "VICTOR MINING INDUSTRY GROUP",
     "symbol": "VMTG"
    },
    {
     "description": "VENUS MEDTECH HANGZHOU INC-H",
     "symbol": "VMTHF"
    },
    {
     "description": "VMWARE INC-CLASS A",
     "symbol": "VMW"
    },
    {
     "description": "GLOBAL X MSCI VIETNAM ETF",
     "symbol": "VNAM"
    },
    {
     "description": "VINCE HOLDING CORP",
     "symbol": "VNCE"
    },
    {
     "description": "VICTORY NICKEL INC",
     "symbol": "VNCKF"
    },
    {
     "description": "VANDA PHARMACEUTICALS INC",
     "symbol": "VNDA"
    },
    {
     "description": "VANADIUM RESOURCES LTD",
     "symbol": "VNDMF"
    },
    {
     "description": "VNET GROUP INC-ADR",
     "symbol": "VNET"
    },
    {
     "description": "VANG FTSE JPN USDD",
     "symbol": "VNFGF"
    },
    {
     "description": "VANGUARD FTSE CANADIAN CAPPE",
     "symbol": "VNFTF"
    },
    {
     "description": "VAND USDCP1-3 USDA",
     "symbol": "VNGBF"
    },
    {
     "description": "VANG USDCPBD USDD",
     "symbol": "VNGCF"
    },
    {
     "description": "VANG S&P500 USDD",
     "symbol": "VNGDF"
    },
    {
     "description": "VANG FTSE HDY USDD",
     "symbol": "VNGGF"
    },
    {
     "description": "VANG FTSE EUR EURA",
     "symbol": "VNGLF"
    },
    {
     "description": "VANG FTSE EM USDD",
     "symbol": "VNGUF"
    },
    {
     "description": "VANJIA CORP",
     "symbol": "VNJA"
    },
    {
     "description": "JANUS HENDERSON SHORT DURATI",
     "symbol": "VNLA"
    },
    {
     "description": "VANOIL ENERGY LTD",
     "symbol": "VNLEF"
    },
    {
     "description": "VEON LTD",
     "symbol": "VNLTF"
    },
    {
     "description": "VANECK VIETNAM ETF",
     "symbol": "VNM"
    },
    {
     "description": "NATIXIS VAUGHAN NELSON MIDC",
     "symbol": "VNMC"
    },
    {
     "description": "VIETNAM HOLDING LTD",
     "symbol": "VNMHF"
    },
    {
     "description": "VANGUARD CANADIAN ST BD ETF",
     "symbol": "VNNGF"
    },
    {
     "description": "VONOVIA SE",
     "symbol": "VNNVF"
    },
    {
     "description": "VINERGY CAPITAL INC",
     "symbol": "VNNYF"
    },
    {
     "description": "VORNADO REALTY TRUST",
     "symbol": "VNO"
    },
    {
     "description": "VORNADO REALTY TRUST",
     "symbol": "VNO.PRL"
    },
    {
     "description": "VORNADO REALTY TRUST",
     "symbol": "VNO.PRM"
    },
    {
     "description": "VORNADO REALTY TRUST",
     "symbol": "VNO.PRN"
    },
    {
     "description": "VORNADO REALTY TRUST",
     "symbol": "VNO.PRO"
    },
    {
     "description": "VIPER ENERGY PARTNERS LP",
     "symbol": "VNOM"
    },
    {
     "description": "Vornado Realty Trust",
     "symbol": "VNORP"
    },
    {
     "description": "VANGUARD REAL ESTATE ETF",
     "symbol": "VNQ"
    },
    {
     "description": "VANGUARD GLBL EX-US REAL EST",
     "symbol": "VNQI"
    },
    {
     "description": "VANGUARD FTSE CANADA INDEX",
     "symbol": "VNRDF"
    },
    {
     "description": "VIENNA INSURANCE GRP-SP ADR",
     "symbol": "VNRFY"
    },
    {
     "description": "VIENNA INSURANCE GROUP AG",
     "symbol": "VNRGF"
    },
    {
     "description": "VOLITIONRX LTD",
     "symbol": "VNRX"
    },
    {
     "description": "NATIXIS VAUGHN NELSON SELECT",
     "symbol": "VNSE"
    },
    {
     "description": "VONTIER CORP",
     "symbol": "VNT"
    },
    {
     "description": "VENTANA BIOTECH INC",
     "symbol": "VNTA"
    },
    {
     "description": "NANO MOBILE HEALTHCARE INC",
     "symbol": "VNTH"
    },
    {
     "description": "VENTURENET CAPITAL GROUP INC",
     "symbol": "VNTN"
    },
    {
     "description": "VENATOR MATERIALS PLC",
     "symbol": "VNTR"
    },
    {
     "description": "VNUE INC",
     "symbol": "VNUE"
    },
    {
     "description": "VECIMA NETWORKS INC",
     "symbol": "VNWTF"
    },
    {
     "description": "VANGUARD MID-CAP ETF",
     "symbol": "VO"
    },
    {
     "description": "VOLTABOX AG",
     "symbol": "VOAXF"
    },
    {
     "description": "VOBILE GROUP LTD",
     "symbol": "VOBIF"
    },
    {
     "description": "VOC ENERGY TRUST",
     "symbol": "VOC"
    },
    {
     "description": "VODAFONE GROUP PLC-SP ADR",
     "symbol": "VOD"
    },
    {
     "description": "VODACOM GROUP LTD",
     "symbol": "VODAF"
    },
    {
     "description": "VODAFONE GROUP PLC",
     "symbol": "VODPF"
    },
    {
     "description": "VANGUARD MID-CAP VALUE ETF",
     "symbol": "VOE"
    },
    {
     "description": "VISTA OIL & GAS -CW22",
     "symbol": "VOGGF"
    },
    {
     "description": "VOLCAN HOLDINGS INC",
     "symbol": "VOHO"
    },
    {
     "description": "MIND SOLUTIONS INC",
     "symbol": "VOIS"
    },
    {
     "description": "VOLVO AB-A SHS",
     "symbol": "VOLAF"
    },
    {
     "description": "VOLT INFO SCIENCES INC",
     "symbol": "VOLT"
    },
    {
     "description": "VOLVO AB-B SHS",
     "symbol": "VOLVF"
    },
    {
     "description": "VANGUARD RUSSELL 1000",
     "symbol": "VONE"
    },
    {
     "description": "VANGUARD RUSSELL 1000 GROWTH",
     "symbol": "VONG"
    },
    {
     "description": "VONTOBEL HOLDING AG-REG",
     "symbol": "VONHF"
    },
    {
     "description": "VERONI BRANDS CORP",
     "symbol": "VONI"
    },
    {
     "description": "VONOVIA SE-UNSP ADR",
     "symbol": "VONOY"
    },
    {
     "description": "VANGUARD RUSSELL 1000 VALUE",
     "symbol": "VONV"
    },
    {
     "description": "VANGUARD S&P 500 ETF",
     "symbol": "VOO"
    },
    {
     "description": "VANGUARD S&P 500 GROWTH ETF",
     "symbol": "VOOG"
    },
    {
     "description": "VANGUARD S&P 500 VALUE ETF",
     "symbol": "VOOV"
    },
    {
     "description": "VOPAK",
     "symbol": "VOPKF"
    },
    {
     "description": "VOPAK-UNSPONSORED ADR",
     "symbol": "VOPKY"
    },
    {
     "description": "VIOQUEST PHARMACEUTICALS INC",
     "symbol": "VOQP"
    },
    {
     "description": "VOR BIOPHARMA INC",
     "symbol": "VOR"
    },
    {
     "description": "VIRGIN ORBIT HOLDINGS INC",
     "symbol": "VORB"
    },
    {
     "description": "NEXTGEN ACQ CORP II -A -CW27",
     "symbol": "VORBW"
    },
    {
     "description": "VOSSLOH AG",
     "symbol": "VOSSF"
    },
    {
     "description": "VOSSLOH AG-UNSPONSORED ADR",
     "symbol": "VOSSY"
    },
    {
     "description": "VANGUARD MID-CAP GROWTH ETF",
     "symbol": "VOT"
    },
    {
     "description": "VOTI DETECTION INC",
     "symbol": "VOTDF"
    },
    {
     "description": "ENGINE NO1 TRANSFORM 500 ETF",
     "symbol": "VOTE"
    },
    {
     "description": "VANGUARD COMMUNICATION SERVI",
     "symbol": "VOX"
    },
    {
     "description": "VOX ROYALTY CORP",
     "symbol": "VOXCF"
    },
    {
     "description": "VOXX INTERNATIONAL CORP",
     "symbol": "VOXX"
    },
    {
     "description": "VOYA FINANCIAL INC",
     "symbol": "VOYA"
    },
    {
     "description": "VOYA FINANCIAL INC",
     "symbol": "VOYA.PRB"
    },
    {
     "description": "VALMET OYJ",
     "symbol": "VOYJF"
    },
    {
     "description": "VALOR RESOURCES LTD",
     "symbol": "VOYRF"
    },
    {
     "description": "VOYANT INTERNATIONAL CORP",
     "symbol": "VOYT"
    },
    {
     "description": "VOLPARA HEALTH TECHNOLOGIES",
     "symbol": "VPAHF"
    },
    {
     "description": "VIRTUS PRIVATE CREDIT STRATE",
     "symbol": "VPC"
    },
    {
     "description": "VPC IMPACT ACQUISITION HOL-A",
     "symbol": "VPCB"
    },
    {
     "description": "VPC IMPACT ACQUISITION HOLD",
     "symbol": "VPCBU"
    },
    {
     "description": "VPC IMPACT ACQ CL A -CW27",
     "symbol": "VPCBW"
    },
    {
     "description": "VIPER NETWORKS INC",
     "symbol": "VPER"
    },
    {
     "description": "VISHAY PRECISION GROUP",
     "symbol": "VPG"
    },
    {
     "description": "VALUE PARTNERS GROUP LTD",
     "symbol": "VPGLF"
    },
    {
     "description": "VALEO PHARMA INC",
     "symbol": "VPHIF"
    },
    {
     "description": "VANGUARD FTSE PACIFIC ETF",
     "symbol": "VPL"
    },
    {
     "description": "VANGU USDTRBD USDD",
     "symbol": "VPLCF"
    },
    {
     "description": "VOIP-PAL.COM INC",
     "symbol": "VPLM"
    },
    {
     "description": "GLOBAL X DATA CENTER REITS",
     "symbol": "VPN"
    },
    {
     "description": "SIMPLIFY VOLT POP CULT DISRU",
     "symbol": "VPOP"
    },
    {
     "description": "VAPOR GROUP INC",
     "symbol": "VPOR"
    },
    {
     "description": "VPC SPECIALTY LENDING INVEST",
     "symbol": "VPPCF"
    },
    {
     "description": "VPR BRANDS LP",
     "symbol": "VPRB"
    },
    {
     "description": "VITALITY PRODUCTS INC",
     "symbol": "VPRIF"
    },
    {
     "description": "VIROPRO INC",
     "symbol": "VPRO"
    },
    {
     "description": "VISION AIRSHIPS INC",
     "symbol": "VPSN"
    },
    {
     "description": "VENTRIPOINT DIAGNOSTICS LTD",
     "symbol": "VPTDF"
    },
    {
     "description": "SENEX ENERGY LTD",
     "symbol": "VPTOF"
    },
    {
     "description": "VIDEOPROPULSION INTERACTIVE",
     "symbol": "VPTV"
    },
    {
     "description": "VANGUARD UTILITIES ETF",
     "symbol": "VPU"
    },
    {
     "description": "INVESCO PENNSYLVANIA VALUE M",
     "symbol": "VPV"
    },
    {
     "description": "VIQ SOLUTIONS INC",
     "symbol": "VQS"
    },
    {
     "description": "VERA BRADLEY INC",
     "symbol": "VRA"
    },
    {
     "description": "VIRTUS REAL ASSET INCOME ETF",
     "symbol": "VRAI"
    },
    {
     "description": "GLIMPSE GROUP INC\/THE",
     "symbol": "VRAR"
    },
    {
     "description": "VIEWRAY INC",
     "symbol": "VRAY"
    },
    {
     "description": "VIRBAC SA",
     "symbol": "VRBCF"
    },
    {
     "description": "VANADIUMCORP RESOURCE INC",
     "symbol": "VRBFD"
    },
    {
     "description": "VERRICA PHARMACEUTICALS INC",
     "symbol": "VRCA"
    },
    {
     "description": "VERICI DX PLC",
     "symbol": "VRCDF"
    },
    {
     "description": "VICTORY RESOURCES CORP",
     "symbol": "VRCFF"
    },
    {
     "description": "VERDE SCIENCE INC",
     "symbol": "VRCI"
    },
    {
     "description": "VERSACOM INTERNATIONAL INC",
     "symbol": "VRCM"
    },
    {
     "description": "VARCA VENTURES INC",
     "symbol": "VRCV"
    },
    {
     "description": "VERIDIS ENVIRONMENT LTD",
     "symbol": "VRDDF"
    },
    {
     "description": "VIRIDIAN THERAPEUTICS INC",
     "symbol": "VRDN"
    },
    {
     "description": "VERDE RESOURCES INC",
     "symbol": "VRDR"
    },
    {
     "description": "VIRIDIS HOLDINGS INC",
     "symbol": "VRDSF"
    },
    {
     "description": "VERIS RESIDENTIAL INC",
     "symbol": "VRE"
    },
    {
     "description": "VIRTUAL ED LINK INC",
     "symbol": "VRED"
    },
    {
     "description": "VAREX IMAGING CORP",
     "symbol": "VREX"
    },
    {
     "description": "VANGU USDTRBD USDA",
     "symbol": "VRGFF"
    },
    {
     "description": "INVESCO VARIABLE RATE INVEST",
     "symbol": "VRIG"
    },
    {
     "description": "VROOM INC",
     "symbol": "VRM"
    },
    {
     "description": "VERIFYME INC",
     "symbol": "VRME"
    },
    {
     "description": "VERIFYME INC -CW25",
     "symbol": "VRMEW"
    },
    {
     "description": "VERONA PHARMA PLC - ADR",
     "symbol": "VRNA"
    },
    {
     "description": "ALAN ALLMAN ASSOCIATES",
     "symbol": "VRNLF"
    },
    {
     "description": "VERANO HOLDINGS CORP",
     "symbol": "VRNOF"
    },
    {
     "description": "VARONIS SYSTEMS INC",
     "symbol": "VRNS"
    },
    {
     "description": "VERINT SYSTEMS INC",
     "symbol": "VRNT"
    },
    {
     "description": "INVESCO VARIABLE RATE PREFER",
     "symbol": "VRP"
    },
    {
     "description": "VIRPAX PHARMACEUTICALS INC",
     "symbol": "VRPX"
    },
    {
     "description": "VR RESOURCES LTD",
     "symbol": "VRRCF"
    },
    {
     "description": "VERRA MOBILITY CORP",
     "symbol": "VRRM"
    },
    {
     "description": "VERRA MOBILITY CORP - CW23",
     "symbol": "VRRMW"
    },
    {
     "description": "VALTERRA RESOURCE CORP",
     "symbol": "VRSCF"
    },
    {
     "description": "VERISANTE TECHNOLOGY INC",
     "symbol": "VRSEF"
    },
    {
     "description": "VERISK ANALYTICS INC",
     "symbol": "VRSK"
    },
    {
     "description": "VERISIGN INC",
     "symbol": "VRSN"
    },
    {
     "description": "VERSARIEN PLC",
     "symbol": "VRSRF"
    },
    {
     "description": "VMS REHAB SYSTEMS INC",
     "symbol": "VRSYF"
    },
    {
     "description": "VERTIV HOLDINGS CO",
     "symbol": "VRT"
    },
    {
     "description": "VESTIN REALTY MORTGAGE I INC",
     "symbol": "VRTA"
    },
    {
     "description": "VESTIN REALTY MORTGAGE II",
     "symbol": "VRTB"
    },
    {
     "description": "VERITEC INC",
     "symbol": "VRTC"
    },
    {
     "description": "INDIGENOUS BLOOM HEMP CORP",
     "symbol": "VRTHF"
    },
    {
     "description": "VARTECH SYSTEMS INC",
     "symbol": "VRTK"
    },
    {
     "description": "VIRTUS INVESTMENT PARTNERS",
     "symbol": "VRTS"
    },
    {
     "description": "VIATAR CTC SOLUTIONS INC",
     "symbol": "VRTT"
    },
    {
     "description": "VERITIV CORP",
     "symbol": "VRTV"
    },
    {
     "description": "VERTEX PHARMACEUTICALS INC",
     "symbol": "VRTX"
    },
    {
     "description": "VERUS INTERNATIONAL INC",
     "symbol": "VRUS"
    },
    {
     "description": "VIRTUAL INTERACTIVE TECHNOLO",
     "symbol": "VRVR"
    },
    {
     "description": "VORTIV LTD",
     "symbol": "VRVVF"
    },
    {
     "description": "MEDIAVALET INC",
     "symbol": "VRXWF"
    },
    {
     "description": "VERSUS SYSTEMS INC",
     "symbol": "VS"
    },
    {
     "description": "VISION SENSING ACQUISITION-A",
     "symbol": "VSAC"
    },
    {
     "description": "VISION SENSING ACQUISITION C",
     "symbol": "VSACU"
    },
    {
     "description": "VISION SENSING ACQ -CW23",
     "symbol": "VSACW"
    },
    {
     "description": "VIASAT INC",
     "symbol": "VSAT"
    },
    {
     "description": "VITASPRING BIOMEDICAL CO LTD",
     "symbol": "VSBC"
    },
    {
     "description": "VSBLTY GROUPE TECHNOLOGIES C",
     "symbol": "VSBGF"
    },
    {
     "description": "VICTORIA'S SECRET & CO",
     "symbol": "VSCO"
    },
    {
     "description": "VICTORYSHARES DIVIDEND ACCEL",
     "symbol": "VSDA"
    },
    {
     "description": "VSE CORP",
     "symbol": "VSEC"
    },
    {
     "description": "GREEN ECONOMY DEVELOPMENT LT",
     "symbol": "VSFFF"
    },
    {
     "description": "VANGUARD ESG INTL STOCK ETF",
     "symbol": "VSGX"
    },
    {
     "description": "VISHAY INTERTECHNOLOGY INC",
     "symbol": "VSH"
    },
    {
     "description": "VISION INC\/TOKYO JAPAN",
     "symbol": "VSIOF"
    },
    {
     "description": "VOLSHARES LARGE CAP ETF",
     "symbol": "VSL"
    },
    {
     "description": "APPLIED FINANCE VALUATION",
     "symbol": "VSLU"
    },
    {
     "description": "VASAMED INC",
     "symbol": "VSMD"
    },
    {
     "description": "VERIFY SMART CORP",
     "symbol": "VSMR"
    },
    {
     "description": "VICTORYSHARES US MIN VOL ETF",
     "symbol": "VSMV"
    },
    {
     "description": "VISTA OIL & GAS SAB DE CV",
     "symbol": "VSOGF"
    },
    {
     "description": "VIASPACE INC",
     "symbol": "VSPC"
    },
    {
     "description": "VECTORSHARES MIN VOL ETF",
     "symbol": "VSPY"
    },
    {
     "description": "VICTORY SQUARE TECHNOLOGIES",
     "symbol": "VSQTF"
    },
    {
     "description": "VOICESERVE INC",
     "symbol": "VSRV"
    },
    {
     "description": "VANGUARD FTSE ALL WO X-US SC",
     "symbol": "VSS"
    },
    {
     "description": "VALID SOLUCOES SA-SP ADR",
     "symbol": "VSSPY"
    },
    {
     "description": "VISIONSTATE CORP",
     "symbol": "VSSSF"
    },
    {
     "description": "VOICE ASSIST INC",
     "symbol": "VSST"
    },
    {
     "description": "VERSUS SYSTEMS -CW26",
     "symbol": "VSSYW"
    },
    {
     "description": "VISTRA CORP",
     "symbol": "VST"
    },
    {
     "description": "VISTRA CORP - CW24",
     "symbol": "VST.WSA"
    },
    {
     "description": "VASTA PLATFORM LTD",
     "symbol": "VSTA"
    },
    {
     "description": "VISION TECHNOLOGY CORP",
     "symbol": "VSTCQ"
    },
    {
     "description": "VNV GLOBAL AB",
     "symbol": "VSTKF"
    },
    {
     "description": "VERASTEM INC",
     "symbol": "VSTM"
    },
    {
     "description": "VISTA OUTDOOR INC",
     "symbol": "VSTO"
    },
    {
     "description": "VIEW SYSTEMS INC",
     "symbol": "VSYM"
    },
    {
     "description": "VESYNC CO LTD",
     "symbol": "VSYNF"
    },
    {
     "description": "VISCOUNT SYSTEMS INC",
     "symbol": "VSYS"
    },
    {
     "description": "VANGUARD TOT WORLD STK ETF",
     "symbol": "VT"
    },
    {
     "description": "Invesco Dynamic Credit Opportunities Fund",
     "symbol": "VTA"
    },
    {
     "description": "VANTAGE TOWERS - UNSP ADR",
     "symbol": "VTAGY"
    },
    {
     "description": "VENTOUX CCM ACQUISITION CORP",
     "symbol": "VTAQ"
    },
    {
     "description": "VENTOUX CCM ACQUISITION-RGT",
     "symbol": "VTAQR"
    },
    {
     "description": "VENTOUX CCM ACQUISITION CORP",
     "symbol": "VTAQU"
    },
    {
     "description": "VENTOUX CCM ACQ -CW25",
     "symbol": "VTAQW"
    },
    {
     "description": "VANGUARD TOTAL CORPORATE BND",
     "symbol": "VTC"
    },
    {
     "description": "VANTAGE DRILLING INTERNATION",
     "symbol": "VTDRF"
    },
    {
     "description": "VANGUARD TAX-EXEMPT BOND ETF",
     "symbol": "VTEB"
    },
    {
     "description": "VITEC GROUP PLC\/THE",
     "symbol": "VTEPF"
    },
    {
     "description": "VERITEQ CORP",
     "symbol": "VTEQ"
    },
    {
     "description": "VTEX -CLASS A",
     "symbol": "VTEX"
    },
    {
     "description": "DEVELOP GLOBAL LTD",
     "symbol": "VTEXF"
    },
    {
     "description": "VANTAGE DRILLING CO",
     "symbol": "VTGDF"
    },
    {
     "description": "VITA GROUP LTD",
     "symbol": "VTGFF"
    },
    {
     "description": "VISTAGEN THERAPEUTICS INC",
     "symbol": "VTGN"
    },
    {
     "description": "VITAL HEALTHCARE PROPERTY TR",
     "symbol": "VTHPF"
    },
    {
     "description": "VANGUARD RUSSELL 3000",
     "symbol": "VTHR"
    },
    {
     "description": "VANGUARD TOTAL STOCK MKT ETF",
     "symbol": "VTI"
    },
    {
     "description": "VITA 34 AG",
     "symbol": "VTIAF"
    },
    {
     "description": "VANGUARD SHORT-TERM TIPS",
     "symbol": "VTIP"
    },
    {
     "description": "VECTOIQ ACQUISITION CO-CL A",
     "symbol": "VTIQ"
    },
    {
     "description": "VECTOIQ ACQUISITION CORP II",
     "symbol": "VTIQU"
    },
    {
     "description": "VECTOIQ ACQUISITION CO-CW23",
     "symbol": "VTIQW"
    },
    {
     "description": "VTECH HOLDINGS LTD",
     "symbol": "VTKLF"
    },
    {
     "description": "VTECH HOLDINGS LTD-UNSP ADR",
     "symbol": "VTKLY"
    },
    {
     "description": "VITAMIN BLUE INC",
     "symbol": "VTMB"
    },
    {
     "description": "VALENTINE MARK CORP",
     "symbol": "VTMC"
    },
    {
     "description": "VIETNAM ENTERPRISE INV LTD-C",
     "symbol": "VTMEF"
    },
    {
     "description": "VENTURE MINERALS LTD",
     "symbol": "VTMLF"
    },
    {
     "description": "VERTU MOTORS PLC",
     "symbol": "VTMTF"
    },
    {
     "description": "VITAL METALS LTD",
     "symbol": "VTMXF"
    },
    {
     "description": "INVESCO TRUST FOR INVESTMENT",
     "symbol": "VTN"
    },
    {
     "description": "VETANOVA INC",
     "symbol": "VTNA"
    },
    {
     "description": "VERTEX ENERGY INC",
     "symbol": "VTNR"
    },
    {
     "description": "BRISTOW GROUP INC",
     "symbol": "VTOL"
    },
    {
     "description": "VAST SOLUTIONS INC-CL B1",
     "symbol": "VTON"
    },
    {
     "description": "VENTAS INC",
     "symbol": "VTR"
    },
    {
     "description": "VITROLIFE AB - UNSP ADR",
     "symbol": "VTRLY"
    },
    {
     "description": "VIATRIS INC",
     "symbol": "VTRS"
    },
    {
     "description": "VITRU LTD",
     "symbol": "VTRU"
    },
    {
     "description": "VITESCO TECHNOLOGIES GROUP A",
     "symbol": "VTSCF"
    },
    {
     "description": "VITESCO TECHNOLOGIE-ADR SPON",
     "symbol": "VTSCY"
    },
    {
     "description": "VIRTRA INC",
     "symbol": "VTSI"
    },
    {
     "description": "VITASOY INTL HOLDINGS LTD",
     "symbol": "VTSYF"
    },
    {
     "description": "VAT GROUP AG",
     "symbol": "VTTGF"
    },
    {
     "description": "VAST SOLUTIONS INC-CL B3",
     "symbol": "VTTH"
    },
    {
     "description": "VANGUARD VALUE ETF",
     "symbol": "VTV"
    },
    {
     "description": "VTV THERAPEUTICS INC- CL A",
     "symbol": "VTVT"
    },
    {
     "description": "VANGUARD RUSSELL 2000 GROWTH",
     "symbol": "VTWG"
    },
    {
     "description": "VANGUARD RUSSELL 2000 ETF",
     "symbol": "VTWO"
    },
    {
     "description": "VANTAGE TOWERS AG",
     "symbol": "VTWRF"
    },
    {
     "description": "VANGUARD RUSSELL 2000 VALUE",
     "symbol": "VTWV"
    },
    {
     "description": "VORTEX BRANDS CO",
     "symbol": "VTXB"
    },
    {
     "description": "VICTREX PLC",
     "symbol": "VTXPF"
    },
    {
     "description": "VERTEX MINERALS LTD",
     "symbol": "VTXXF"
    },
    {
     "description": "VICTORY BANCORP INC\/THE",
     "symbol": "VTYB"
    },
    {
     "description": "VENTYX BIOSCIENCES INC",
     "symbol": "VTYX"
    },
    {
     "description": "VANGUARD GROWTH ETF",
     "symbol": "VUG"
    },
    {
     "description": "VANG FTSE100 GBPD",
     "symbol": "VUKEF"
    },
    {
     "description": "VULCAN INTERNATIONAL CORP",
     "symbol": "VULC"
    },
    {
     "description": "VULCAN MINERALS INC",
     "symbol": "VULMF"
    },
    {
     "description": "VULCAN ENERGY RESOURCES LTD",
     "symbol": "VULNF"
    },
    {
     "description": "VU1 CORP",
     "symbol": "VUOC"
    },
    {
     "description": "VP BANK AG-A",
     "symbol": "VUPPF"
    },
    {
     "description": "VANGUARD ULTRA SHORT BOND ET",
     "symbol": "VUSB"
    },
    {
     "description": "VIDENT CORE US EQUITY ETF",
     "symbol": "VUSE"
    },
    {
     "description": "TEXTON PROPERTY FUND LTD",
     "symbol": "VUVAF"
    },
    {
     "description": "VUZIX CORP",
     "symbol": "VUZI"
    },
    {
     "description": "VANGUARD LARGE-CAP ETF",
     "symbol": "VV"
    },
    {
     "description": "VIVA CHINA HOLDINGS LTD",
     "symbol": "VVCHF"
    },
    {
     "description": "VIVO CANNABIS INC",
     "symbol": "VVCIF"
    },
    {
     "description": "VVC EXPLORATION CORP",
     "symbol": "VVCVF"
    },
    {
     "description": "VIAVID BROADCASTING INC",
     "symbol": "VVDB"
    },
    {
     "description": "VIAD CORP",
     "symbol": "VVI"
    },
    {
     "description": "EARTHRENEW INC",
     "symbol": "VVIVF"
    },
    {
     "description": "VIVINT SMART HOME INC",
     "symbol": "VVNT"
    },
    {
     "description": "VIVOS THERAPEUTICS INC",
     "symbol": "VVOS"
    },
    {
     "description": "VIVOPOWER INTERNATIONAL PLC",
     "symbol": "VVPR"
    },
    {
     "description": "INVESCO SENIOR INCOME TRUST",
     "symbol": "VVR"
    },
    {
     "description": "VANECK SEMICONDUCTOR ETF",
     "symbol": "VVSMF"
    },
    {
     "description": "VALVOLINE INC",
     "symbol": "VVV"
    },
    {
     "description": "VIVA WORLD TRADE INC",
     "symbol": "VVWT"
    },
    {
     "description": "VOLKSWAGEN A G-UNSPON ADR",
     "symbol": "VWAGY"
    },
    {
     "description": "VOLKSWAGEN AG-UNSP ADR PREF",
     "symbol": "VWAPY"
    },
    {
     "description": "VESTAS WIND SYSTEMS-UNSP ADR",
     "symbol": "VWDRY"
    },
    {
     "description": "VINTAGE WINE ESTATES INC",
     "symbol": "VWE"
    },
    {
     "description": "VINTAGE WINE ESTATES -CW27",
     "symbol": "VWEWW"
    },
    {
     "description": "VIRTUS WMC INTERNATIONAL DIV",
     "symbol": "VWID"
    },
    {
     "description": "VANGUARD FTSE EMERGING MARKE",
     "symbol": "VWO"
    },
    {
     "description": "VANGUARD EMERG MKTS GOV BND",
     "symbol": "VWOB"
    },
    {
     "description": "VESTAS WIND SYSTEMS A\/S",
     "symbol": "VWSYF"
    },
    {
     "description": "VIDLER WATER RESOUCES INC",
     "symbol": "VWTR"
    },
    {
     "description": "VITAXEL GROUP LTD",
     "symbol": "VXELD"
    },
    {
     "description": "VANGUARD EXTENDED MARKET ETF",
     "symbol": "VXF"
    },
    {
     "description": "VIREXIT TECHNOLOGIES INC",
     "symbol": "VXIT"
    },
    {
     "description": "VAXIL BIO LTD",
     "symbol": "VXLLF"
    },
    {
     "description": "VAXART INC",
     "symbol": "VXRT"
    },
    {
     "description": "VOXTUR ANALYTICS CORP",
     "symbol": "VXTRF"
    },
    {
     "description": "VANGUARD TOTAL INTL STOCK",
     "symbol": "VXUS"
    },
    {
     "description": "IPATH SERIES B S&P 500 VIX",
     "symbol": "VXX"
    },
    {
     "description": "IPATH SER B S&P 500 VIX M\/T",
     "symbol": "VXZ"
    },
    {
     "description": "VYCOR MEDICAL INC",
     "symbol": "VYCO"
    },
    {
     "description": "VYDROTECH INC",
     "symbol": "VYDR"
    },
    {
     "description": "VICTORY OILFIELD TECH INC",
     "symbol": "VYEY"
    },
    {
     "description": "VY GLOBAL GROWTH-CL A",
     "symbol": "VYGG"
    },
    {
     "description": "VY GLOBAL GROWTH",
     "symbol": "VYGG.U"
    },
    {
     "description": "VY GLOBAL GROWTH-CL A -CW30",
     "symbol": "VYGG.WS"
    },
    {
     "description": "CARTA HOLDINGS INC",
     "symbol": "VYGPF"
    },
    {
     "description": "VOYAGER THERAPEUTICS INC",
     "symbol": "VYGR"
    },
    {
     "description": "VOYAGER DIGITAL LTD",
     "symbol": "VYGVF"
    },
    {
     "description": "VANGUARD HIGH DVD YIELD ETF",
     "symbol": "VYM"
    },
    {
     "description": "VANGUARD INT HIGH DVD YLD IN",
     "symbol": "VYMI"
    },
    {
     "description": "VYNLEADS INC",
     "symbol": "VYND"
    },
    {
     "description": "VYNE THERAPEUTICS INC",
     "symbol": "VYNE"
    },
    {
     "description": "VYANT BIO INC",
     "symbol": "VYNT"
    },
    {
     "description": "VIYYA TECHNOLOGIES INC",
     "symbol": "VYON"
    },
    {
     "description": "VYSTAR CORP",
     "symbol": "VYST"
    },
    {
     "description": "VINYTHAI PUBLIC CO LTD-FOREI",
     "symbol": "VYTPF"
    },
    {
     "description": "VOYAGEUR PHARMACEUTICALS LTD",
     "symbol": "VYYRF"
    },
    {
     "description": "VERIZON COMMUNICATIONS INC",
     "symbol": "VZ"
    },
    {
     "description": "VIZIO HOLDING  CORP-A",
     "symbol": "VZIO"
    },
    {
     "description": "VIZSLA SILVER CORP",
     "symbol": "VZLA"
    },
    {
     "description": "WAYFAIR INC- CLASS A",
     "symbol": "W"
    },
    {
     "description": "WABTEC CORP",
     "symbol": "WAB"
    },
    {
     "description": "WESTAMERICA BANCORPORATION",
     "symbol": "WABC"
    },
    {
     "description": "WESTAMERICA CORP",
     "symbol": "WACC"
    },
    {
     "description": "WACOAL HOLDINGS CORP",
     "symbol": "WACLF"
    },
    {
     "description": "WACOAL HOLDINGS CORP-SP ADR",
     "symbol": "WACLY"
    },
    {
     "description": "WACOM CO LTD",
     "symbol": "WACMF"
    },
    {
     "description": "WACOM CO LTD-UNSP ADR",
     "symbol": "WACMY"
    },
    {
     "description": "WASHINGTON FEDERAL INC",
     "symbol": "WAFD"
    },
    {
     "description": "WASHINGTON FEDERAL INC",
     "symbol": "WAFDP"
    },
    {
     "description": "WAH FU EDUCATION GROUP LTD",
     "symbol": "WAFU"
    },
    {
     "description": "WAKE FOREST BANCSHARES INC",
     "symbol": "WAKE"
    },
    {
     "description": "WAI KEE HOLDINGS LTD",
     "symbol": "WAKHF"
    },
    {
     "description": "WESTERN ALLIANCE BANCORP",
     "symbol": "WAL"
    },
    {
     "description": "WESTERN ALLIANCE BANCORP",
     "symbol": "WAL.PRA"
    },
    {
     "description": "WALDENCAST ACQUISITION COR-A",
     "symbol": "WALD"
    },
    {
     "description": "WALDENCAST ACQUISITION CORP",
     "symbol": "WALDU"
    },
    {
     "description": "WALDENCAST ACQ CL A -CW27",
     "symbol": "WALDW"
    },
    {
     "description": "MEGAWATT LITHIUM AND BATTERY",
     "symbol": "WALRF"
    },
    {
     "description": "WESTERN ALASKA MINERALS CORP",
     "symbol": "WAMFF"
    },
    {
     "description": "WANDISCO PLC",
     "symbol": "WANSF"
    },
    {
     "description": "DRX DLY CONS DISC BULL 3X",
     "symbol": "WANT"
    },
    {
     "description": "WHARF HOLDINGS LTD",
     "symbol": "WARFF"
    },
    {
     "description": "WHARF HOLDINGS-UNSPON ADR",
     "symbol": "WARFY"
    },
    {
     "description": "WARRIOR GOLD INC",
     "symbol": "WARGF"
    },
    {
     "description": "COOL TECHNOLOGIES INC",
     "symbol": "WARM"
    },
    {
     "description": "WARRIOR TECHNOLOGIES ACQ-A",
     "symbol": "WARR"
    },
    {
     "description": "WARRIOR TECHNOLOGIES ACQUISI",
     "symbol": "WARR.U"
    },
    {
     "description": "WARRIOR TECHNOLOGIES A -CW28",
     "symbol": "WARR.WS"
    },
    {
     "description": "WASHINGTON TRUST BANCORP",
     "symbol": "WASH"
    },
    {
     "description": "WATERS CORP",
     "symbol": "WAT"
    },
    {
     "description": "ENERGOUS CORP",
     "symbol": "WATT"
    },
    {
     "description": "WAVERLEY CAPITAL ACQUISITI-A",
     "symbol": "WAVC"
    },
    {
     "description": "WAVERLEY CAPITAL ACQUISITION",
     "symbol": "WAVC.U"
    },
    {
     "description": "WAVERLEY CAPITAL -A -CW27",
     "symbol": "WAVC.WS"
    },
    {
     "description": "WAVEDANCER INC",
     "symbol": "WAVD"
    },
    {
     "description": "ECO WAVE POWER GLOBAL AB-ADR",
     "symbol": "WAVE"
    },
    {
     "description": "WESTERN ACQUISITION VENTURES",
     "symbol": "WAVS"
    },
    {
     "description": "WESTERN ACQUISITION VENTURES",
     "symbol": "WAVSU"
    },
    {
     "description": "WESTERN ACQUISITION VEN-CW27",
     "symbol": "WAVSW"
    },
    {
     "description": "WORLD ACCESS INC",
     "symbol": "WAXS"
    },
    {
     "description": "WAYNE SAVINGS BANCSHARES INC",
     "symbol": "WAYN"
    },
    {
     "description": "WAVE SYNC CORP",
     "symbol": "WAYS"
    },
    {
     "description": "WEIBO CORP-SPON ADR",
     "symbol": "WB"
    },
    {
     "description": "WALGREENS BOOTS ALLIANCE INC",
     "symbol": "WBA"
    },
    {
     "description": "WISDOMTREE BATTERY VALUE CHA",
     "symbol": "WBAT"
    },
    {
     "description": "WB BURGERS ASIA INC",
     "symbol": "WBBA"
    },
    {
     "description": "WESTBURY BANCORP INC",
     "symbol": "WBBW"
    },
    {
     "description": "WARNER BROS DISCOVERY INC",
     "symbol": "WBD"
    },
    {
     "description": "WINC INC",
     "symbol": "WBEV"
    },
    {
     "description": "WILSON BANK HOLDING CO",
     "symbol": "WBHC"
    },
    {
     "description": "WBI BULLBEAR VALUE 3000 ETF",
     "symbol": "WBIF"
    },
    {
     "description": "WBI BULLBEAR YIELD 3000 ETF",
     "symbol": "WBIG"
    },
    {
     "description": "WBI BULLBEAR GLOBAL INCOME E",
     "symbol": "WBII"
    },
    {
     "description": "WBI BULLBEAR QUALITY 3000 ET",
     "symbol": "WBIL"
    },
    {
     "description": "WBI BULLBEAR TREND S US 3000",
     "symbol": "WBIT"
    },
    {
     "description": "WBI POWER FACTOR HIGH DIV",
     "symbol": "WBIY"
    },
    {
     "description": "WESTERN ASSET TOTAL RETURN E",
     "symbol": "WBND"
    },
    {
     "description": "WESTBOND ENTERPRISES CORP",
     "symbol": "WBNEF"
    },
    {
     "description": "WOODBRIDGE LIQUIDATION TST-A",
     "symbol": "WBQNL"
    },
    {
     "description": "WIENERBERGER AG",
     "symbol": "WBRBF"
    },
    {
     "description": "WIENERBERGER AG-SPON ADR",
     "symbol": "WBRBY"
    },
    {
     "description": "WILD BRUSH ENERGY INC",
     "symbol": "WBRE"
    },
    {
     "description": "WEBSTER FINANCIAL CORP",
     "symbol": "WBS"
    },
    {
     "description": "WEBSTER FINANCIAL CORP",
     "symbol": "WBS.PRF"
    },
    {
     "description": "WEBSTER FINANCIAL CORP",
     "symbol": "WBS.PRG"
    },
    {
     "description": "WEBSAFETY INC",
     "symbol": "WBSI"
    },
    {
     "description": "WEBSTAR TECHNOLOGY GROUP INC",
     "symbol": "WBSR"
    },
    {
     "description": "WELBILT INC",
     "symbol": "WBT"
    },
    {
     "description": "WESTBROOK THOMPSON-UNITS",
     "symbol": "WBTMU"
    },
    {
     "description": "WEEBIT NANO LTD",
     "symbol": "WBTNF"
    },
    {
     "description": "WU BA SUPERIOR PRODUCTS HOLD",
     "symbol": "WBWB"
    },
    {
     "description": "WALLBOX NV",
     "symbol": "WBX"
    },
    {
     "description": "WALLBOX BV - CLASS A -CW26",
     "symbol": "WBX.WS"
    },
    {
     "description": "WASHINGTON BUSINESS BANK",
     "symbol": "WBZB"
    },
    {
     "description": "WCB HOLDINGS INC",
     "symbol": "WCBH"
    },
    {
     "description": "WISDOMTREE CYBERSECURITY FND",
     "symbol": "WCBR"
    },
    {
     "description": "WESCO INTERNATIONAL INC",
     "symbol": "WCC"
    },
    {
     "description": "WESCO INTERNATIONAL INC",
     "symbol": "WCC.PRA"
    },
    {
     "description": "WEALTHCRAFT CAPITAL INC",
     "symbol": "WCCP"
    },
    {
     "description": "WORLD CLASS EXTRACTIONS INC",
     "symbol": "WCEXF"
    },
    {
     "description": "WCF BANCORP INC",
     "symbol": "WCFB"
    },
    {
     "description": "WINCHESTER ENERGY LTD",
     "symbol": "WCHEF"
    },
    {
     "description": "WEST CHINA CEMENT LTD",
     "symbol": "WCHNF"
    },
    {
     "description": "WINCHESTER HOLDING GROUP",
     "symbol": "WCHS"
    },
    {
     "description": "WEE-CIG INTERNATIONAL CORP",
     "symbol": "WCIG"
    },
    {
     "description": "WISDOMTREE CLOUD COMPUTING",
     "symbol": "WCLD"
    },
    {
     "description": "WASTE CONNECTIONS INC",
     "symbol": "WCN"
    },
    {
     "description": "WESTERN CAPITAL RESOURCES",
     "symbol": "WCRS"
    },
    {
     "description": "WORLD COPPER LTD",
     "symbol": "WCUFF"
    },
    {
     "description": "WELLNESS CENTER USA INC",
     "symbol": "WCUI"
    },
    {
     "description": "WEST CANYON ENERGY CORP",
     "symbol": "WCYN"
    },
    {
     "description": "WALKER & DUNLOP INC",
     "symbol": "WD"
    },
    {
     "description": "WORKDAY INC-CLASS A",
     "symbol": "WDAY"
    },
    {
     "description": "WOODBROOK GROUP HOLDINGS INC",
     "symbol": "WDBG"
    },
    {
     "description": "WESTERN DIGITAL CORP",
     "symbol": "WDC"
    },
    {
     "description": "WT CLOUD COMPUTING USD ACC",
     "symbol": "WDCCF"
    },
    {
     "description": "WILDCAT RESOURCES LTD",
     "symbol": "WDCTF"
    },
    {
     "description": "WORLDS INC",
     "symbol": "WDDD"
    },
    {
     "description": "WD-40 CO",
     "symbol": "WDFC"
    },
    {
     "description": "K9 GOLD CORP",
     "symbol": "WDFCF"
    },
    {
     "description": "WOODLANDS FINANCIAL SERVICES",
     "symbol": "WDFN"
    },
    {
     "description": "WIDAD GROUP BHD-CW23",
     "symbol": "WDGBF"
    },
    {
     "description": "JOHN WOOD GROUP PLC",
     "symbol": "WDGJF"
    },
    {
     "description": "WOOD GROUP (JOHN)-UNSPON ADR",
     "symbol": "WDGJY"
    },
    {
     "description": "WIDGIE NICKEL LTD",
     "symbol": "WDGNF"
    },
    {
     "description": "WATERDROP INC",
     "symbol": "WDH"
    },
    {
     "description": "WEEDHIRE INTERNATIONAL INC",
     "symbol": "WDHR"
    },
    {
     "description": "WESTERN ASSET DIVERS INC",
     "symbol": "WDI"
    },
    {
     "description": "SPDR S&P GLOBAL DIVIDEND ETF",
     "symbol": "WDIV"
    },
    {
     "description": "PANACHE BEVERAGE INC",
     "symbol": "WDKA"
    },
    {
     "description": "SOCIAL LIFE NETWORK INC",
     "symbol": "WDLF"
    },
    {
     "description": "WISDOM EDUCATION INTERNATION",
     "symbol": "WDMSF"
    },
    {
     "description": "WT US FLTING RATE BND-USD",
     "symbol": "WDMTF"
    },
    {
     "description": "WISDOMTREE BIOREVOLUTION FND",
     "symbol": "WDNA"
    },
    {
     "description": "WESDOME GOLD MINES LTD",
     "symbol": "WDOFF"
    },
    {
     "description": "WAREHOUSES DE PAUW SCA",
     "symbol": "WDPSF"
    },
    {
     "description": "GAMELANCER GAMING CORP",
     "symbol": "WDRGF"
    },
    {
     "description": "WANDERPORT CORP",
     "symbol": "WDRP"
    },
    {
     "description": "WISDOMTREE US QLY DIV GRWTH",
     "symbol": "WDSSF"
    },
    {
     "description": "WISDOMTREE JAPAN USD HGD ACC",
     "symbol": "WDTRF"
    },
    {
     "description": "WEWORK INC-CL A",
     "symbol": "WE"
    },
    {
     "description": "WEWORK INC -CW26",
     "symbol": "WE.WS"
    },
    {
     "description": "WESTERN ASSET PREMIER BOND",
     "symbol": "WEA"
    },
    {
     "description": "TEUCRIUM WHEAT FUND",
     "symbol": "WEAT"
    },
    {
     "description": "WEAVE COMMUNICATIONS INC",
     "symbol": "WEAV"
    },
    {
     "description": "WEB BLOCKCHAIN MEDIA INC",
     "symbol": "WEBB"
    },
    {
     "description": "WEBCO INDUSTRIES INC",
     "symbol": "WEBC"
    },
    {
     "description": "WEBJET LTD",
     "symbol": "WEBJF"
    },
    {
     "description": "DIREXION DAILY DOW JONES INT",
     "symbol": "WEBL"
    },
    {
     "description": "WESTPAC BANKING CORP",
     "symbol": "WEBNF"
    },
    {
     "description": "WEBER INC - CLASS A",
     "symbol": "WEBR"
    },
    {
     "description": "DIREXION DAILY DOW JONES INT",
     "symbol": "WEBS"
    },
    {
     "description": "WEC ENERGY GROUP INC",
     "symbol": "WEC"
    },
    {
     "description": "WHITE ENERGY CO LTD",
     "symbol": "WECFF"
    },
    {
     "description": "WECOMMERCE HOLDINGS LTD",
     "symbol": "WECMF"
    },
    {
     "description": "WECONNECT TECH INTERNATIONAL",
     "symbol": "WECT"
    },
    {
     "description": "WEED GROWTH FUND INC",
     "symbol": "WEDG"
    },
    {
     "description": "WESTAIM CORP\/THE",
     "symbol": "WEDXF"
    },
    {
     "description": "ROUNDHILL CANNABIS ETF",
     "symbol": "WEED"
    },
    {
     "description": "WESTERN ENERGY SERVICES CORP",
     "symbol": "WEEEF"
    },
    {
     "description": "WISDOMTREE EU EQ ACC USD HDG",
     "symbol": "WEEUF"
    },
    {
     "description": "WESCAN GOLDFIELDS INC",
     "symbol": "WEGOF"
    },
    {
     "description": "WEIR GROUP PLC - SPON ADR",
     "symbol": "WEGRY"
    },
    {
     "description": "WESTBRIDGE ENERGY CORP",
     "symbol": "WEGYF"
    },
    {
     "description": "WEG SA- SPN ADR",
     "symbol": "WEGZY"
    },
    {
     "description": "WEIDAI LTD-ADR",
     "symbol": "WEI"
    },
    {
     "description": "WEICHAI POWER CO LTD-H",
     "symbol": "WEICF"
    },
    {
     "description": "WEICHAI POWER CO-UNSP ADR",
     "symbol": "WEICY"
    },
    {
     "description": "WEIR GROUP PLC\/THE",
     "symbol": "WEIGF"
    },
    {
     "description": "WOLVERINE ENERGY & INFRASTRU",
     "symbol": "WEIIF"
    },
    {
     "description": "DYNAMIC SHORT SHORT",
     "symbol": "WEIX"
    },
    {
     "description": "WEJO GROUP LTD",
     "symbol": "WEJO"
    },
    {
     "description": "WEJO GROUP LTD -CW28",
     "symbol": "WEJOW"
    },
    {
     "description": "WEBJET LTD - UNSP ADR",
     "symbol": "WEJTY"
    },
    {
     "description": "INTEGRATED WELLNESS ACQ - A",
     "symbol": "WEL"
    },
    {
     "description": "INTEGRATED WELLNESS ACQUISIT",
     "symbol": "WEL.U"
    },
    {
     "description": "INTEGRATED WELLNESS -CW28",
     "symbol": "WEL.WS"
    },
    {
     "description": "WELLTOWER INC",
     "symbol": "WELL"
    },
    {
     "description": "Wisconsin Electric Power Company",
     "symbol": "WELPM"
    },
    {
     "description": "Wisconsin Electric Power Company",
     "symbol": "WELPP"
    },
    {
     "description": "WINLAND HOLDINGS CORP",
     "symbol": "WELX"
    },
    {
     "description": "WEIMOB INC",
     "symbol": "WEMXF"
    },
    {
     "description": "WENDY'S CO\/THE",
     "symbol": "WEN"
    },
    {
     "description": "SUMMUS SOLUTIONS NV",
     "symbol": "WENEF"
    },
    {
     "description": "WELLQUEST MEDICAL & WELLNESS",
     "symbol": "WEQL"
    },
    {
     "description": "WERNER ENTERPRISES INC",
     "symbol": "WERN"
    },
    {
     "description": "WE-R-YOU CORP",
     "symbol": "WERU"
    },
    {
     "description": "WESTERN MIDSTREAM PARTNERS L",
     "symbol": "WES"
    },
    {
     "description": "W&E SOURCE CORP",
     "symbol": "WESC"
    },
    {
     "description": "WEST MINING CORP",
     "symbol": "WESMF"
    },
    {
     "description": "WISDOMTREE INVESTMENTS INC",
     "symbol": "WETF"
    },
    {
     "description": "WETRADE GROUP INC",
     "symbol": "WETG"
    },
    {
     "description": "WETOUCH TECHNOLOGY INC",
     "symbol": "WETH"
    },
    {
     "description": "WEWARDS INC",
     "symbol": "WEWA"
    },
    {
     "description": "WEX INC",
     "symbol": "WEX"
    },
    {
     "description": "WESTERN EXPLORATION INC",
     "symbol": "WEXPF"
    },
    {
     "description": "WEYCO GROUP INC",
     "symbol": "WEYS"
    },
    {
     "description": "WOORI FINANCIAL-SPON ADR",
     "symbol": "WF"
    },
    {
     "description": "WESFARMERS LTD",
     "symbol": "WFAFF"
    },
    {
     "description": "WESFARMERS LIMITED-UNSP ADR",
     "symbol": "WFAFY"
    },
    {
     "description": "WELLS FARGO & CO",
     "symbol": "WFC"
    },
    {
     "description": "WELLS FARGO & COMPANY",
     "symbol": "WFC.PRA"
    },
    {
     "description": "WELLS FARGO & COMPANY",
     "symbol": "WFC.PRC"
    },
    {
     "description": "WELLS FARGO & COMPANY",
     "symbol": "WFC.PRD"
    },
    {
     "description": "WELLS FARGO & COMPANY",
     "symbol": "WFC.PRL"
    },
    {
     "description": "WELLS FARGO & COMPANY",
     "symbol": "WFC.PRQ"
    },
    {
     "description": "WELLS FARGO & COMPANY",
     "symbol": "WFC.PRR"
    },
    {
     "description": "WELLS FARGO & COMPANY",
     "symbol": "WFC.PRY"
    },
    {
     "description": "WELLS FARGO & COMPANY",
     "symbol": "WFC.PRZ"
    },
    {
     "description": "WHERE FOOD COMES FROM INC",
     "symbol": "WFCF"
    },
    {
     "description": "1867 WESTERN FINANCIAL CORP",
     "symbol": "WFCL"
    },
    {
     "description": "Wells Fargo and Company",
     "symbol": "WFCNP"
    },
    {
     "description": "WEST FRASER TIMBER CO LTD",
     "symbol": "WFG"
    },
    {
     "description": "BC BUD CORP\/THE",
     "symbol": "WFGCF"
    },
    {
     "description": "DIREXION WORK FROM HOME ETF",
     "symbol": "WFH"
    },
    {
     "description": "WORLD FINANCIAL HOLDING GROU",
     "symbol": "WFHG"
    },
    {
     "description": "WISDOMTREE US HIGH YIELD COR",
     "symbol": "WFHY"
    },
    {
     "description": "WALL FINANCIAL CORP",
     "symbol": "WFICF"
    },
    {
     "description": "WISDOMTREE US CORPORATE BOND",
     "symbol": "WFIG"
    },
    {
     "description": "SCHRODER UK PUBLIC PRIVATE",
     "symbol": "WFPCF"
    },
    {
     "description": "WEATHERFORD INTERNATIONAL PL",
     "symbol": "WFRD"
    },
    {
     "description": "WEST AFRICAN RESOURCES LTD",
     "symbol": "WFRSF"
    },
    {
     "description": "WESTERN FOREST PRODUCTS INC",
     "symbol": "WFSTF"
    },
    {
     "description": "WAVEFRONT TECHNOLOGY SOLUTIO",
     "symbol": "WFTSF"
    },
    {
     "description": "WEATHERFORDINTERNATIONA-CW23",
     "symbol": "WFTUF"
    },
    {
     "description": "WI-FI WIRELESS LTD",
     "symbol": "WFWRF"
    },
    {
     "description": "WGE HOLDINGS CORP",
     "symbol": "WGEE"
    },
    {
     "description": "WINDGEN ENERGY INC",
     "symbol": "WGEI"
    },
    {
     "description": "WGI HOLDINGS INC",
     "symbol": "WGIH"
    },
    {
     "description": "WSHARES ENHANCED GOLD ETF",
     "symbol": "WGLD"
    },
    {
     "description": "WESTWARD GOLD INC",
     "symbol": "WGLIF"
    },
    {
     "description": "WINSTON GOLD CORP",
     "symbol": "WGMCF"
    },
    {
     "description": "VALKYRIE BITCOIN MINERS ETF",
     "symbol": "WGMI"
    },
    {
     "description": "WGNB Corp",
     "symbol": "WGNAP"
    },
    {
     "description": "WEGENER CORP",
     "symbol": "WGNR"
    },
    {
     "description": "WINNEBAGO INDUSTRIES",
     "symbol": "WGO"
    },
    {
     "description": "WISDOMTREE US GROWTH AND MOM",
     "symbol": "WGRO"
    },
    {
     "description": "WINGS & THINGS INC",
     "symbol": "WGTG"
    },
    {
     "description": "WYNDHAM HOTELS & RESORTS INC",
     "symbol": "WH"
    },
    {
     "description": "WILLISTON HOLDING COMPANY IN",
     "symbol": "WHCA"
    },
    {
     "description": "CACTUS INC - A",
     "symbol": "WHD"
    },
    {
     "description": "SALT LAKE POTASH LTD",
     "symbol": "WHELF"
    },
    {
     "description": "WORLD HEALTH ENERGY HOLDINGS",
     "symbol": "WHEN"
    },
    {
     "description": "WHITEHORSE FINANCE INC",
     "symbol": "WHF"
    },
    {
     "description": "WESTWOOD HOLDINGS GROUP INC",
     "symbol": "WHG"
    },
    {
     "description": "WHITEHORSE GOLD CORP",
     "symbol": "WHGDF"
    },
    {
     "description": "WH GROUP LTD - SPON ADR",
     "symbol": "WHGLY"
    },
    {
     "description": "WHITE GOLD CORP",
     "symbol": "WHGOF"
    },
    {
     "description": "WAREHOUSE GROUP LIMITED\/THE",
     "symbol": "WHGPF"
    },
    {
     "description": "WH GROUP LTD",
     "symbol": "WHGRF"
    },
    {
     "description": "WHITEHAVEN COAL LTD",
     "symbol": "WHITF"
    },
    {
     "description": "WHITEHAVEN COAL LTD-UNSP ADR",
     "symbol": "WHITY"
    },
    {
     "description": "WORLD HOCKEY ASSOCIATION COR",
     "symbol": "WHKA"
    },
    {
     "description": "WHEELOCK & CO LTD",
     "symbol": "WHLKF"
    },
    {
     "description": "WILHELMINA INTERNATIONAL INC",
     "symbol": "WHLM"
    },
    {
     "description": "WHEELER REAL ESTATE INVESTME",
     "symbol": "WHLR"
    },
    {
     "description": "WHEELER REIT INC",
     "symbol": "WHLRD"
    },
    {
     "description": "WHEELER REIT INC",
     "symbol": "WHLRL"
    },
    {
     "description": "WHEELER REIT INC",
     "symbol": "WHLRP"
    },
    {
     "description": "CHASE PACKAGING CORP",
     "symbol": "WHLT"
    },
    {
     "description": "WLMG HOLDING INC",
     "symbol": "WHLX"
    },
    {
     "description": "WESTHAVEN GOLD CORP -CW24",
     "symbol": "WHNWF"
    },
    {
     "description": "WHIRLPOOL CORP",
     "symbol": "WHR"
    },
    {
     "description": "WEARABLE HEALTH SOLUTIONS IN",
     "symbol": "WHSI"
    },
    {
     "description": "WHISPIR LTD",
     "symbol": "WHSPF"
    },
    {
     "description": "WASHTEC AG",
     "symbol": "WHTAF"
    },
    {
     "description": "WELL HEALTH TECHNOLOGIES COR",
     "symbol": "WHTCF"
    },
    {
     "description": "MANGAZEYA MINING LTD",
     "symbol": "WHTGF"
    },
    {
     "description": "WHITEHAWK LTD",
     "symbol": "WHTHF"
    },
    {
     "description": "WH SMITH PLC",
     "symbol": "WHTPF"
    },
    {
     "description": "WORLD HOUSEWARE HOLDINGS LTD",
     "symbol": "WHWRF"
    },
    {
     "description": "WEST HIGH YIELD WHY RESOURCE",
     "symbol": "WHYRF"
    },
    {
     "description": "WESTERN ASSET INFL-LINK SEC",
     "symbol": "WIA"
    },
    {
     "description": "WEST ISLAND BRANDS INC",
     "symbol": "WIBFF"
    },
    {
     "description": "WISTRON CORP",
     "symbol": "WICOF"
    },
    {
     "description": "WI-FI TV INC",
     "symbol": "WIFT"
    },
    {
     "description": "WISETECH GLOBAL LTD -UNSP",
     "symbol": "WIGBY"
    },
    {
     "description": "WIHLBORGS FASTI AB-UNSP ADR",
     "symbol": "WIHLY"
    },
    {
     "description": "IPATH WOMEN IN LEADERSHIP ET",
     "symbol": "WIL"
    },
    {
     "description": "G. WILLI-FOOD INTERNATIONAL",
     "symbol": "WILC"
    },
    {
     "description": "DEMANT A\/S",
     "symbol": "WILLF"
    },
    {
     "description": "DEMANT A\/S-UN ADR",
     "symbol": "WILYY"
    },
    {
     "description": "WIMI HOLOGRAM CLOUD INC-ADR",
     "symbol": "WIMI"
    },
    {
     "description": "WINMARK CORP",
     "symbol": "WINA"
    },
    {
     "description": "WESTERN ASSET ST DUR INC ETF",
     "symbol": "WINC"
    },
    {
     "description": "WINGSTOP INC",
     "symbol": "WING"
    },
    {
     "description": "WINHA INTERNATIONAL GROUP LT",
     "symbol": "WINH"
    },
    {
     "description": "WINDFALL GEOTEK INC",
     "symbol": "WINKF"
    },
    {
     "description": "HARBOR LONG-TERM GROWERS ETF",
     "symbol": "WINN"
    },
    {
     "description": "SIMPLICITY ESPORTS AND GAMIN",
     "symbol": "WINR"
    },
    {
     "description": "SIMPLICITY ESPORTS AND -CW22",
     "symbol": "WINRW"
    },
    {
     "description": "WINS FINANCE HOLDINGS INC",
     "symbol": "WINSF"
    },
    {
     "description": "WINDTREE THERAPEUTICS INC",
     "symbol": "WINT"
    },
    {
     "description": "WINDTREE THERAPEUTICS -CW26",
     "symbol": "WINTW"
    },
    {
     "description": "WINVEST ACQUISITION CORP",
     "symbol": "WINV"
    },
    {
     "description": "WINVEST ACQUISITION CORP-RTS",
     "symbol": "WINVR"
    },
    {
     "description": "WINVEST ACQUISITION CORP",
     "symbol": "WINVU"
    },
    {
     "description": "WINVEST ACQUISITION -CW23",
     "symbol": "WINVW"
    },
    {
     "description": "SPDR FTSE INTERNATIONAL GOVE",
     "symbol": "WIP"
    },
    {
     "description": "WINPAK LTD",
     "symbol": "WIPKF"
    },
    {
     "description": "ENCORE WIRE CORP",
     "symbol": "WIRE"
    },
    {
     "description": "WIRELESS XCESSORIES GROUP",
     "symbol": "WIRX"
    },
    {
     "description": "WISA TECHNOLOGIES INC",
     "symbol": "WISA"
    },
    {
     "description": "CONTEXTLOGIC INC - A",
     "symbol": "WISH"
    },
    {
     "description": "WEISS KOREA OPPORTUNITY FUND",
     "symbol": "WISKF"
    },
    {
     "description": "WISEMAN GLOBAL LTD",
     "symbol": "WISM"
    },
    {
     "description": "WT AT1 COCO UCITS ETF USD",
     "symbol": "WISSF"
    },
    {
     "description": "WIPRO LTD-ADR",
     "symbol": "WIT"
    },
    {
     "description": "WESTERN ASSET INFL-LINK OPPS",
     "symbol": "WIW"
    },
    {
     "description": "WIX.COM LTD",
     "symbol": "WIX"
    },
    {
     "description": "MERLYN AI BULL-RIDER BEAR-FI",
     "symbol": "WIZ"
    },
    {
     "description": "WISE PLC - SPON ADR",
     "symbol": "WIZEY"
    },
    {
     "description": "WEST JAPAN RAILWAY CO",
     "symbol": "WJRYF"
    },
    {
     "description": "WEST JAPAN RAILWAY-UNSP ADR",
     "symbol": "WJRYY"
    },
    {
     "description": "WAJAX CORP",
     "symbol": "WJXFF"
    },
    {
     "description": "WORKIVA INC",
     "symbol": "WK"
    },
    {
     "description": "WIJAYA KARYA PERSERO TBK PT",
     "symbol": "WKAPF"
    },
    {
     "description": "WACKER CHEMIE AG",
     "symbol": "WKCMF"
    },
    {
     "description": "WISEKEY INTL HOLDINGS-ADR",
     "symbol": "WKEY"
    },
    {
     "description": "SANDERSON DESIGN GROUP PLC",
     "symbol": "WKGBF"
    },
    {
     "description": "WESTKAM GOLD CORP",
     "symbol": "WKGFF"
    },
    {
     "description": "WORKHORSE GROUP INC",
     "symbol": "WKHS"
    },
    {
     "description": "WORKMAN CO LTD",
     "symbol": "WKISF"
    },
    {
     "description": "WALKER LANE EXPLORATION INC",
     "symbol": "WKLN"
    },
    {
     "description": "SOFI WEEKLY DIVIDEND ETF",
     "symbol": "WKLY"
    },
    {
     "description": "WALKME LTD",
     "symbol": "WKME"
    },
    {
     "description": "WORKSPACE GROUP PLC",
     "symbol": "WKPPF"
    },
    {
     "description": "WASKITA KARYA PERSERO TBK PT",
     "symbol": "WKPYF"
    },
    {
     "description": "WACKER NEUSON SE",
     "symbol": "WKRCF"
    },
    {
     "description": "WORKSPORT LTD",
     "symbol": "WKSP"
    },
    {
     "description": "WORKSPORT LTD -CW26",
     "symbol": "WKSPW"
    },
    {
     "description": "WEBSKY INC",
     "symbol": "WKYN"
    },
    {
     "description": "WHITE LABEL LIQUID INC",
     "symbol": "WLAB"
    },
    {
     "description": "WIALAN TECHNOLOGIES INC",
     "symbol": "WLAN"
    },
    {
     "description": "WELBE INC",
     "symbol": "WLBEF"
    },
    {
     "description": "WALLBRIDGE MINING CO LTD",
     "symbol": "WLBMF"
    },
    {
     "description": "WELCIA HOLDINGS CO LTD",
     "symbol": "WLCGF"
    },
    {
     "description": "WELL TOLD CO INC\/THE",
     "symbol": "WLCOF"
    },
    {
     "description": "WILDBRAIN LTD",
     "symbol": "WLDBF"
    },
    {
     "description": "WILDFLOWER BRANDS INC",
     "symbol": "WLDFF"
    },
    {
     "description": "WILLDAN GROUP INC",
     "symbol": "WLDN"
    },
    {
     "description": "WILDPACK BEVERAGE INC",
     "symbol": "WLDPF"
    },
    {
     "description": "AFFINITY WORLD LEADERS EQUIT",
     "symbol": "WLDR"
    },
    {
     "description": "WILLIS LEASE FINANCE CORP",
     "symbol": "WLFC"
    },
    {
     "description": "WOLFORD AG-SPONSORED ADR",
     "symbol": "WLFDY"
    },
    {
     "description": "WOLFDEN RESOURCES CORP",
     "symbol": "WLFFF"
    },
    {
     "description": "WILH WILHELMSEN HOLDING-A",
     "symbol": "WLHSF"
    },
    {
     "description": "WESTLAKE CORP",
     "symbol": "WLK"
    },
    {
     "description": "WALKABOUT RESOURCES LTD",
     "symbol": "WLKBF"
    },
    {
     "description": "WESTLAKE CHEMICAL PARTNERS L",
     "symbol": "WLKP"
    },
    {
     "description": "WILK TECHNOLOGIES LTD",
     "symbol": "WLKTF"
    },
    {
     "description": "WHITING PETROLEUM CORP",
     "symbol": "WLL"
    },
    {
     "description": "WHITING PETROLEUM CORP - A",
     "symbol": "WLLAW"
    },
    {
     "description": "WHITING PETROLEUM CORP - B",
     "symbol": "WLLBW"
    },
    {
     "description": "WILH WILHELMSEN HOLDING-B",
     "symbol": "WLLSF"
    },
    {
     "description": "WILMAR INTERNATIONAL LTD",
     "symbol": "WLMIF"
    },
    {
     "description": "WILMAR INTERNATIONAL-UNS ADR",
     "symbol": "WLMIY"
    },
    {
     "description": "WILLIAMS INDUSTRIAL SERVICES",
     "symbol": "WLMS"
    },
    {
     "description": "WULING MOTORS HOLDINGS LTD",
     "symbol": "WLMTF"
    },
    {
     "description": "DISCOVER WELLNESS SOLUTIONS",
     "symbol": "WLNSF"
    },
    {
     "description": "WINLAND OCEAN SHIPPING CORP",
     "symbol": "WLOLQ"
    },
    {
     "description": "WILLPLUS HOLDINGS CORP",
     "symbol": "WLPSF"
    },
    {
     "description": "ALORO MINING CORP",
     "symbol": "WLRMF"
    },
    {
     "description": "WELLSTAR INTERNATIONAL INC",
     "symbol": "WLSI"
    },
    {
     "description": "WEALTHTRUST DBS LONG TERM GR",
     "symbol": "WLTG"
    },
    {
     "description": "LIFEGOAL WEALTH BUILDER ETF",
     "symbol": "WLTH"
    },
    {
     "description": "WILTON RESOURCES INC",
     "symbol": "WLTNF"
    },
    {
     "description": "WOOLWORTHS HOLDINGS LTD",
     "symbol": "WLWHF"
    },
    {
     "description": "WOOLWORTHS HOLDINGS LTD-GDR",
     "symbol": "WLWHY"
    },
    {
     "description": "WILEY (JOHN) & SONS-CLASS A",
     "symbol": "WLY"
    },
    {
     "description": "WILEY (JOHN) & SONS-CL B",
     "symbol": "WLYB"
    },
    {
     "description": "WALLY WORLD MEDIA INC",
     "symbol": "WLYW"
    },
    {
     "description": "WASTE MANAGEMENT INC",
     "symbol": "WM"
    },
    {
     "description": "WILLIAMS COS INC",
     "symbol": "WMB"
    },
    {
     "description": "WESTERN ASSET MORTGAGE CAPIT",
     "symbol": "WMC"
    },
    {
     "description": "WAM CAPITAL LTD",
     "symbol": "WMCLF"
    },
    {
     "description": "WMD HOLDINGS GROUP INC",
     "symbol": "WMDH"
    },
    {
     "description": "WESTMOUNT ENERGY LTD",
     "symbol": "WMELF"
    },
    {
     "description": "WARNER MUSIC GROUP CORP-CL A",
     "symbol": "WMG"
    },
    {
     "description": "WILLIAMS GRAND PRIX HOLDINGS",
     "symbol": "WMGPF"
    },
    {
     "description": "WELLNESS MATRIX GROUP INC",
     "symbol": "WMGR"
    },
    {
     "description": "WEIS MARKETS INC",
     "symbol": "WMK"
    },
    {
     "description": "WEALTH MINERALS LTD",
     "symbol": "WMLLF"
    },
    {
     "description": "WT NICKEL",
     "symbol": "WMMTF"
    },
    {
     "description": "WALMART DE MEXICO SAB DE CV",
     "symbol": "WMMVF"
    },
    {
     "description": "WALMART DE MEXICO-SPON ADR V",
     "symbol": "WMMVY"
    },
    {
     "description": "ASTON MINERALS LTD",
     "symbol": "WMNNF"
    },
    {
     "description": "WILLIAM PENN BANCORP",
     "symbol": "WMPN"
    },
    {
     "description": "ADVANCED DRAINAGE SYSTEMS IN",
     "symbol": "WMS"
    },
    {
     "description": "WALMART INC",
     "symbol": "WMT"
    },
    {
     "description": "WT BATTERY SOLUTIONS-USD ACC",
     "symbol": "WMTEF"
    },
    {
     "description": "WESTMOUNTAIN GOLD INC",
     "symbol": "WMTN"
    },
    {
     "description": "WEST WITS MINING LTD",
     "symbol": "WMWWF"
    },
    {
     "description": "ELEMENTS LKD TO MORNINGSTAR",
     "symbol": "WMWXF"
    },
    {
     "description": "WILUNA MINING CORP LTD",
     "symbol": "WMXCF"
    },
    {
     "description": "WESTERN AREAS LTD",
     "symbol": "WNARF"
    },
    {
     "description": "WEALTHNAVI INC",
     "symbol": "WNAVF"
    },
    {
     "description": "WINNING BRANDS CORP",
     "symbol": "WNBD"
    },
    {
     "description": "WABASH NATIONAL CORP",
     "symbol": "WNC"
    },
    {
     "description": "WYNCREST GROUP INC",
     "symbol": "WNCG"
    },
    {
     "description": "WAN CHENG METAL PACKAGING CO",
     "symbol": "WNCHF"
    },
    {
     "description": "WINECO PRODUCTIONS INC",
     "symbol": "WNCP"
    },
    {
     "description": "WENDEL",
     "symbol": "WNDLF"
    },
    {
     "description": "SOLARWINDOW TECHNOLOGIES INC",
     "symbol": "WNDW"
    },
    {
     "description": "GLOBAL X WIND ENERGY ETF",
     "symbol": "WNDY"
    },
    {
     "description": "WESTERN NEW ENGLAND BANCORP",
     "symbol": "WNEB"
    },
    {
     "description": "Weston George Ltd",
     "symbol": "WNGPF"
    },
    {
     "description": "WESTON (GEORGE) LTD",
     "symbol": "WNGRF"
    },
    {
     "description": "WINVEST GROUP LTD",
     "symbol": "WNLV"
    },
    {
     "description": "WINMILL & CO INC -CL A",
     "symbol": "WNMLA"
    },
    {
     "description": "ANDRETTI ACQUISITION CORP-A",
     "symbol": "WNNR"
    },
    {
     "description": "ANDRETTI ACQUISITION CORP",
     "symbol": "WNNR.U"
    },
    {
     "description": "ANDRETTI ACQ CORP -A -CW23",
     "symbol": "WNNR.WS"
    },
    {
     "description": "WENR CORPORATION",
     "symbol": "WNRC"
    },
    {
     "description": "WINNERS INC",
     "symbol": "WNRS"
    },
    {
     "description": "WNS HOLDINGS LTD-ADR",
     "symbol": "WNS"
    },
    {
     "description": "MEIWU TECHNOLOGY CO LTD",
     "symbol": "WNW"
    },
    {
     "description": "WENTWORTH ENERGY INC",
     "symbol": "WNWG"
    },
    {
     "description": "WEATHERNEWS INC",
     "symbol": "WNWSF"
    },
    {
     "description": "DIEBOLD NIXDORF AG",
     "symbol": "WNXDF"
    },
    {
     "description": "WORLD AM INC",
     "symbol": "WOAM"
    },
    {
     "description": "WOODSBORO BANK",
     "symbol": "WOBK"
    },
    {
     "description": "WOD RETAIL SOLUTIONS INC",
     "symbol": "WODI"
    },
    {
     "description": "WISDOM HOMES OF AMERICA INC",
     "symbol": "WOFA"
    },
    {
     "description": "WOLFSPEED INC",
     "symbol": "WOLF"
    },
    {
     "description": "WOLTERS KLUWER",
     "symbol": "WOLTF"
    },
    {
     "description": "WOLVERINE TECHNOLOGIES CORP",
     "symbol": "WOLV"
    },
    {
     "description": "WOOLWORTHS GROUP LTD",
     "symbol": "WOLWF"
    },
    {
     "description": "IMPACT SHARES YWCA WOMEN'S E",
     "symbol": "WOMN"
    },
    {
     "description": "WONDERFI TECHNOLOGIES INC",
     "symbol": "WONDF"
    },
    {
     "description": "WEQ HOLDINGS INC",
     "symbol": "WONEF"
    },
    {
     "description": "ISHARES GLOBAL TIMBER & FORE",
     "symbol": "WOOD"
    },
    {
     "description": "PETCO HEALTH AND WELLNESS CO",
     "symbol": "WOOF"
    },
    {
     "description": "WOODSIDE PETROLEUM LTD",
     "symbol": "WOPEF"
    },
    {
     "description": "WOODSIDE PETROLEUM-SP ADR",
     "symbol": "WOPEY"
    },
    {
     "description": "WORTHINGTON INDUSTRIES",
     "symbol": "WOR"
    },
    {
     "description": "WAKE UP NOW INC",
     "symbol": "WORC"
    },
    {
     "description": "SCWORX CORP",
     "symbol": "WORX"
    },
    {
     "description": "WATCHES OF SWITZERLAND GROUP",
     "symbol": "WOSGF"
    },
    {
     "description": "WATER OASIS GROUP LTD",
     "symbol": "WOSSF"
    },
    {
     "description": "WIDEOPENWEST INC",
     "symbol": "WOW"
    },
    {
     "description": "WOW WORLD INC",
     "symbol": "WOWDF"
    },
    {
     "description": "METRO ONE TELECOMMUNICATIONS",
     "symbol": "WOWI"
    },
    {
     "description": "WOWI INC",
     "symbol": "WOWU"
    },
    {
     "description": "WP CAREY INC",
     "symbol": "WPC"
    },
    {
     "description": "WARBURG PINCUS CAPITAL COR-A",
     "symbol": "WPCA"
    },
    {
     "description": "WARBURG PINCUS CAPITAL CORP",
     "symbol": "WPCA.U"
    },
    {
     "description": "WARBURG PINCUS CAP A -CW27",
     "symbol": "WPCA.WS"
    },
    {
     "description": "WARBURG PINCUS CAPITAL I-B",
     "symbol": "WPCB"
    },
    {
     "description": "WARBURG PINCUS CAPITAL COR B",
     "symbol": "WPCB.U"
    },
    {
     "description": "WARBURG PINCUS CAPITAL-CW",
     "symbol": "WPCB.WS"
    },
    {
     "description": "WPD PHARMACEUTICALS INC",
     "symbol": "WPDPF"
    },
    {
     "description": "WORLD POKER FUND HOLDINGS IN",
     "symbol": "WPFH"
    },
    {
     "description": "WINSTON PHARMACEUTICALS INC",
     "symbol": "WPHM"
    },
    {
     "description": "WORLD POKER STORE INC\/THE",
     "symbol": "WPKS"
    },
    {
     "description": "WISE PLC - A",
     "symbol": "WPLCF"
    },
    {
     "description": "WHEATON PRECIOUS METALS CORP",
     "symbol": "WPM"
    },
    {
     "description": "WESTERN PACIFIC MINERALS LTD",
     "symbol": "WPMLF"
    },
    {
     "description": "WISHPOND TECHNOLOGIES LTD",
     "symbol": "WPNDF"
    },
    {
     "description": "FIRST RESPONDER TECHNOLOGIES",
     "symbol": "WPNNF"
    },
    {
     "description": "WARPAINT LONDON PLC",
     "symbol": "WPNTF"
    },
    {
     "description": "WPP PLC-SPONSORED ADR",
     "symbol": "WPP"
    },
    {
     "description": "WPP PLC",
     "symbol": "WPPGF"
    },
    {
     "description": "WESTPORT FUEL SYSTEMS INC",
     "symbol": "WPRT"
    },
    {
     "description": "ISHARES INTERNATIONAL DEVELO",
     "symbol": "WPS"
    },
    {
     "description": "WATERPURE INTERNATIONAL INC",
     "symbol": "WPUR"
    },
    {
     "description": "WORLD QUANTUM GROWTH ACQUI-A",
     "symbol": "WQGA"
    },
    {
     "description": "WORLD QUANTUM GROWTH ACQUISI",
     "symbol": "WQGA.U"
    },
    {
     "description": "WORLD QUANTUM GROWTH -CW28",
     "symbol": "WQGA.WS"
    },
    {
     "description": "WQN INC",
     "symbol": "WQNI"
    },
    {
     "description": "WEIQIAO TEXTILE CO LTD-H",
     "symbol": "WQTEF"
    },
    {
     "description": "WILLIAMS ROWLAND ACQUISITION",
     "symbol": "WRAC"
    },
    {
     "description": "WILLIAMS ROWLAND ACQUISITION",
     "symbol": "WRAC.U"
    },
    {
     "description": "WILLIAMS ROWLAND ACQ -CW22",
     "symbol": "WRAC.WS"
    },
    {
     "description": "WRAP TECHNOLOGIES INC",
     "symbol": "WRAP"
    },
    {
     "description": "WR BERKLEY CORP",
     "symbol": "WRB"
    },
    {
     "description": "BERKLEY (WR) CORPORATION",
     "symbol": "WRB.PRE"
    },
    {
     "description": "BERKLEY (WR) CORPORATION",
     "symbol": "WRB.PRF"
    },
    {
     "description": "BERKLEY (WR) CORPORATION",
     "symbol": "WRB.PRG"
    },
    {
     "description": "BERKLEY (WR) CORPORATION",
     "symbol": "WRB.PRH"
    },
    {
     "description": "WARBY PARKER INC-CLASS A",
     "symbol": "WRBY"
    },
    {
     "description": "WIRECARD AG",
     "symbol": "WRCDF"
    },
    {
     "description": "WERELDHAVE NV",
     "symbol": "WRDEF"
    },
    {
     "description": "WORLDLINE SA - UNSP ADR",
     "symbol": "WRDLY"
    },
    {
     "description": "WASHINGTON REIT",
     "symbol": "WRE"
    },
    {
     "description": "WHARF REAL ESTATE INVESTMENT",
     "symbol": "WRFRF"
    },
    {
     "description": "WARRIOR GIRL CORP",
     "symbol": "WRGL"
    },
    {
     "description": "LOVE HEMP GROUP PLC",
     "symbol": "WRHLF"
    },
    {
     "description": "WRIT MEDIA GROUP INC",
     "symbol": "WRIT"
    },
    {
     "description": "WHITE RIVER BANCSHARES CO",
     "symbol": "WRIV"
    },
    {
     "description": "WESTROCK CO",
     "symbol": "WRK"
    },
    {
     "description": "WINDROCK LTD CO",
     "symbol": "WRLC"
    },
    {
     "description": "WORLD ACCEPTANCE CORP",
     "symbol": "WRLD"
    },
    {
     "description": "WHIRLPOOL SA-PREF",
     "symbol": "WRLPF"
    },
    {
     "description": "WIREMEDIA INC",
     "symbol": "WRMA"
    },
    {
     "description": "WHITE ROCK MINERALS LTD",
     "symbol": "WRMCF"
    },
    {
     "description": "WATERMARK LODGING TRUST IN-A",
     "symbol": "WRMK"
    },
    {
     "description": "WESTERN COPPER AND GOLD CORP",
     "symbol": "WRN"
    },
    {
     "description": "IQ GLOBAL EQUITY R&D LEA ETF",
     "symbol": "WRND"
    },
    {
     "description": "WARPSPEED TAXI INC",
     "symbol": "WRPT"
    },
    {
     "description": "WALKER RIVER RESOURCES CORP",
     "symbol": "WRRZF"
    },
    {
     "description": "WARTSILA OYJ ABP",
     "symbol": "WRTBF"
    },
    {
     "description": "WARTSILA OYJ-UNSPON ADR",
     "symbol": "WRTBY"
    },
    {
     "description": "WESBANCO INC",
     "symbol": "WSBC"
    },
    {
     "description": "WESBANCO INC",
     "symbol": "WSBCP"
    },
    {
     "description": "WATERSTONE FINANCIAL INC",
     "symbol": "WSBF"
    },
    {
     "description": "WASKITA BETON PRECAST TBK PT",
     "symbol": "WSBPF"
    },
    {
     "description": "WILLSCOT MOBILE MINI HOLDING",
     "symbol": "WSC"
    },
    {
     "description": "WATERSIDE CAPITAL CORP",
     "symbol": "WSCC"
    },
    {
     "description": "WALL STREET MEDIA CO INC",
     "symbol": "WSCO"
    },
    {
     "description": "NORTH AMERICAN NICKEL INC",
     "symbol": "WSCRF"
    },
    {
     "description": "WILLSCOT MOBILE MINI HO-CW22",
     "symbol": "WSCTW"
    },
    {
     "description": "WISDOMTREE US QTY DIV GWTH",
     "symbol": "WSDDF"
    },
    {
     "description": "WISDOMTREE EUR EQUITY-USD HG",
     "symbol": "WSDMF"
    },
    {
     "description": "WT CYBERSECURITY-USD ACC",
     "symbol": "WSDTF"
    },
    {
     "description": "WISDOMTREE EM EQ INC ACC",
     "symbol": "WSEMF"
    },
    {
     "description": "WARSAW STOCK EXCHANGE",
     "symbol": "WSEWF"
    },
    {
     "description": "WSB FINANCIAL GROUP INC",
     "symbol": "WSFGQ"
    },
    {
     "description": "WOODSTOCK HOLDINGS INC",
     "symbol": "WSFL"
    },
    {
     "description": "WSFS FINANCIAL CORP",
     "symbol": "WSFS"
    },
    {
     "description": "WIKISOFT CORP",
     "symbol": "WSFT"
    },
    {
     "description": "GREENLINK INTERNATIONAL INC",
     "symbol": "WSHE"
    },
    {
     "description": "WASATCH PHARMACEUTICAL INC",
     "symbol": "WSHP"
    },
    {
     "description": "WASION GROUP HOLDINGS LTD",
     "symbol": "WSIOF"
    },
    {
     "description": "WISEKEY INTERNATIONAL HOLDIN",
     "symbol": "WSKEF"
    },
    {
     "description": "WILLIAMS-SONOMA INC",
     "symbol": "WSM"
    },
    {
     "description": "WILLIAMSVILLE SEARS MANAGEME",
     "symbol": "WSML"
    },
    {
     "description": "WESANA HEALTH HOLDINGS INC",
     "symbol": "WSNAF"
    },
    {
     "description": "WATSCO INC",
     "symbol": "WSO"
    },
    {
     "description": "WATSCO INC  -CL B",
     "symbol": "WSO.B"
    },
    {
     "description": "WASHINGTON H. SOUL PATTINSON",
     "symbol": "WSOUF"
    },
    {
     "description": "W-SCOPE CORP",
     "symbol": "WSPCF"
    },
    {
     "description": "WSP GLOBAL INC",
     "symbol": "WSPOF"
    },
    {
     "description": "WESTERN PLAINS ENERGY-CL C",
     "symbol": "WSPPU"
    },
    {
     "description": "WHITESTONE REIT",
     "symbol": "WSR"
    },
    {
     "description": "WESTERN SIERRA RESOURCE CORP",
     "symbol": "WSRC"
    },
    {
     "description": "WISR LTD",
     "symbol": "WSRLF"
    },
    {
     "description": "WISTRON NEWEB CORP",
     "symbol": "WSRNF"
    },
    {
     "description": "HARRYS MANUFACTURING INC",
     "symbol": "WSRRF"
    },
    {
     "description": "WASECO RESOURCES INC",
     "symbol": "WSRUF"
    },
    {
     "description": "WALLSTREET SECURITIES INC",
     "symbol": "WSSE"
    },
    {
     "description": "WEST SHORE BANK CORP",
     "symbol": "WSSH"
    },
    {
     "description": "WESTERN BULK CHARTERING AS",
     "symbol": "WSSTF"
    },
    {
     "description": "WEST PHARMACEUTICAL SERVICES",
     "symbol": "WST"
    },
    {
     "description": "WAYSIDE TECHNOLOGY GROUP INC",
     "symbol": "WSTG"
    },
    {
     "description": "WEST HOLDINGS CORP",
     "symbol": "WSTHF"
    },
    {
     "description": "WESTELL TECHNOLOGIES INC-A",
     "symbol": "WSTL"
    },
    {
     "description": "HRSOFT INC",
     "symbol": "WSTM"
    },
    {
     "description": "WESTLIN CORP",
     "symbol": "WSTN"
    },
    {
     "description": "WESTERN URANIUM & VANADIUM C",
     "symbol": "WSTRF"
    },
    {
     "description": "WESTPORTS HOLDINGS BHD",
     "symbol": "WSTTF"
    },
    {
     "description": "WESIZWE PLATINUM LTD",
     "symbol": "WSZWF"
    },
    {
     "description": "WISDOMTREE AI AND INNOVATION",
     "symbol": "WTAI"
    },
    {
     "description": "WT ART INTELLIGENCE -USD ACC",
     "symbol": "WTAIF"
    },
    {
     "description": "WEST BANCORPORATION",
     "symbol": "WTBA"
    },
    {
     "description": "WHITBREAD PLC",
     "symbol": "WTBCF"
    },
    {
     "description": "WHITBREAD PLC-SPON ADR",
     "symbol": "WTBDY"
    },
    {
     "description": "WTB FINANCIAL CORP-CL A",
     "symbol": "WTBFA"
    },
    {
     "description": "WTB FINANCIAL CORP-CL B",
     "symbol": "WTBFB"
    },
    {
     "description": "WISETECH GLOBAL LTD",
     "symbol": "WTCHF"
    },
    {
     "description": "WESTERN TROY CAPITAL RES",
     "symbol": "WTCRF"
    },
    {
     "description": "COPPER LAKE RESOURCES LTD",
     "symbol": "WTCZF"
    },
    {
     "description": "WESTECH CAPITAL CORP",
     "symbol": "WTECQ"
    },
    {
     "description": "WELLTEQ DIGITAL HEALTH INC",
     "symbol": "WTEQF"
    },
    {
     "description": "ALKALINE WATER CO INC\/THE",
     "symbol": "WTER"
    },
    {
     "description": "WINTRUST FINANCIAL CORP",
     "symbol": "WTFC"
    },
    {
     "description": "WINTRUST FINANCIAL CORP",
     "symbol": "WTFCM"
    },
    {
     "description": "WINTRUST FINANCIAL CORP",
     "symbol": "WTFCP"
    },
    {
     "description": "WESTGOLD RESOURCES LTD",
     "symbol": "WTGRF"
    },
    {
     "description": "WESTHAVEN GOLD CORP",
     "symbol": "WTHVF"
    },
    {
     "description": "W&T OFFSHORE INC",
     "symbol": "WTI"
    },
    {
     "description": "WATER TECHNOLOGIES INTERNATI",
     "symbol": "WTII"
    },
    {
     "description": "WISDOMTREE US EQ INC ACC",
     "symbol": "WTIPF"
    },
    {
     "description": "WELLTEK INC",
     "symbol": "WTKN"
    },
    {
     "description": "WOLTERS KLUWER NV-SPONS ADR",
     "symbol": "WTKWY"
    },
    {
     "description": "WESTERN METALS CORP",
     "symbol": "WTLC"
    },
    {
     "description": "WATER INTELLIGENCE PLC",
     "symbol": "WTLLF"
    },
    {
     "description": "WHITE MOUNTAINS INSURANCE GP",
     "symbol": "WTM"
    },
    {
     "description": "WELSBACH TECHNOLOGY METALS",
     "symbol": "WTMA"
    },
    {
     "description": "WELSBACH TECH METALS ACQ -RT",
     "symbol": "WTMAR"
    },
    {
     "description": "WELBACH TECHNOLOGY METALS AC",
     "symbol": "WTMAU"
    },
    {
     "description": "WISDOMTREE MGD FUTURES STRAT",
     "symbol": "WTMF"
    },
    {
     "description": "WITAN INVESTMENT TRUST PLC",
     "symbol": "WTNTF"
    },
    {
     "description": "WATER NOW INC",
     "symbol": "WTNW"
    },
    {
     "description": "WISDOMTREE NEW ECONOMY REAL",
     "symbol": "WTRE"
    },
    {
     "description": "ESSENTIAL UTILITIES INC",
     "symbol": "WTRG"
    },
    {
     "description": "WAITR HOLDINGS INC",
     "symbol": "WTRH"
    },
    {
     "description": "WESTERN RESOURCES CORP",
     "symbol": "WTRNF"
    },
    {
     "description": "WI-TRON INC",
     "symbol": "WTRO"
    },
    {
     "description": "ESSENTIAL UTILITIES INC",
     "symbol": "WTRU"
    },
    {
     "description": "WESTERN PLAINS ENERGY-CL A",
     "symbol": "WTRYU"
    },
    {
     "description": "WATTS WATER TECHNOLOGIES-A",
     "symbol": "WTS"
    },
    {
     "description": "WESTSHORE TERMINALS INVESTME",
     "symbol": "WTSHF"
    },
    {
     "description": "WIRELESS TELECOM GROUP INC",
     "symbol": "WTT"
    },
    {
     "description": "SPDR WORLD TECHNOLOGY",
     "symbol": "WTTHF"
    },
    {
     "description": "SELECT ENERGY SERVICES INC-A",
     "symbol": "WTTR"
    },
    {
     "description": "WISDOMTREE U.S. VALUE FUND",
     "symbol": "WTV"
    },
    {
     "description": "WILLIS TOWERS WATSON PLC",
     "symbol": "WTW"
    },
    {
     "description": "WESTWING GROUP SE",
     "symbol": "WTWGF"
    },
    {
     "description": "WEST TEXAS RESOURCES INC",
     "symbol": "WTXR"
    },
    {
     "description": "WESTERN UNION CO",
     "symbol": "WU"
    },
    {
     "description": "ESOTERICA NEXTG ECONOMY ETF",
     "symbol": "WUGI"
    },
    {
     "description": "WUHAN GENERAL GROUP CHINA IN",
     "symbol": "WUHN"
    },
    {
     "description": "TERAWULF INC",
     "symbol": "WULF"
    },
    {
     "description": "WUXI APPTEC CO LTD-UNSP ADR",
     "symbol": "WUXAY"
    },
    {
     "description": "WUXI APPTEC CO LTD-H",
     "symbol": "WUXIF"
    },
    {
     "description": "CHINA WUYI MOUNTAIN LTD",
     "symbol": "WUYI"
    },
    {
     "description": "WAVE LIFE SCIENCES LTD",
     "symbol": "WVE"
    },
    {
     "description": "WVS FINANCIAL CORP",
     "symbol": "WVFC"
    },
    {
     "description": "WEST VAULT MINING INC",
     "symbol": "WVMDF"
    },
    {
     "description": "WORLDVEST EQUITY INC",
     "symbol": "WVVEF"
    },
    {
     "description": "WILLAMETTE VALLEY VINEYARDS",
     "symbol": "WVVI"
    },
    {
     "description": "WILLAMETTE VALL VINEYARD",
     "symbol": "WVVIP"
    },
    {
     "description": "WW INTERNATIONAL INC",
     "symbol": "WW"
    },
    {
     "description": "WORLDWIDE WEBB ACQUISITION-A",
     "symbol": "WWAC"
    },
    {
     "description": "WORLDWIDE WEBB ACQUISITION C",
     "symbol": "WWACU"
    },
    {
     "description": "WORLDWIDE WEBB ACQ -CW23",
     "symbol": "WWACW"
    },
    {
     "description": "WOODWARD INC",
     "symbol": "WWD"
    },
    {
     "description": "WORLDWIDE HOLDINGS CORP",
     "symbol": "WWDH"
    },
    {
     "description": "WORLD WRESTLING ENTERTAIN-A",
     "symbol": "WWE"
    },
    {
     "description": "W WORLD CORP",
     "symbol": "WWHC"
    },
    {
     "description": "WORLDWIDE HEALTHCARE TRUST P",
     "symbol": "WWHZF"
    },
    {
     "description": "WORLD OF WIRELESS INTERNATIO",
     "symbol": "WWII"
    },
    {
     "description": "WOWIO INC",
     "symbol": "WWIO"
    },
    {
     "description": "INSPIRE INTERNATIONAL ESG ET",
     "symbol": "WWJD"
    },
    {
     "description": "WORLDLINE SA",
     "symbol": "WWLNF"
    },
    {
     "description": "WW ENERGY INC",
     "symbol": "WWNG"
    },
    {
     "description": "WANT WANT CHINA HOLDINGS LTD",
     "symbol": "WWNTF"
    },
    {
     "description": "WANT WANT CHINA-UNSPON ADR",
     "symbol": "WWNTY"
    },
    {
     "description": "DIREXION WORLD WITHOUT WASTE",
     "symbol": "WWOW"
    },
    {
     "description": "WIND WORKS POWER CORP",
     "symbol": "WWPW"
    },
    {
     "description": "WESTWATER RESOURCES INC",
     "symbol": "WWR"
    },
    {
     "description": "WORLD WIRELESS COMMUNICATION",
     "symbol": "WWRL"
    },
    {
     "description": "WORLDWIDE STRATEGIES INC",
     "symbol": "WWSG"
    },
    {
     "description": "WORLD WIDE STONE CORP",
     "symbol": "WWST"
    },
    {
     "description": "WATER WAYS TECHNOLOGIES INC",
     "symbol": "WWTIF"
    },
    {
     "description": "WUESTENROT & WUERTTEMBER-ADR",
     "symbol": "WWUEY"
    },
    {
     "description": "WOLVERINE WORLD WIDE INC",
     "symbol": "WWW"
    },
    {
     "description": "WUXI BIOLOGICS CAYMAN INC",
     "symbol": "WXIBF"
    },
    {
     "description": "WAXMAN INDUSTRIES INC",
     "symbol": "WXMN"
    },
    {
     "description": "WUXI BIOLOGICS CAYMAN - ADR",
     "symbol": "WXXWY"
    },
    {
     "description": "WEYERHAEUSER CO",
     "symbol": "WY"
    },
    {
     "description": "WORRY FREE HOLDINGS CO",
     "symbol": "WYCC"
    },
    {
     "description": "WORLEY LTD",
     "symbol": "WYGPF"
    },
    {
     "description": "WORLEY LTD-UNSPON ADR",
     "symbol": "WYGPY"
    },
    {
     "description": "WYNN MACAU LTD",
     "symbol": "WYNMF"
    },
    {
     "description": "WYNN MACAU LTD-UNSPON ADR",
     "symbol": "WYNMY"
    },
    {
     "description": "WYNN RESORTS LTD",
     "symbol": "WYNN"
    },
    {
     "description": "WAYPOINT BIOMEDICAL HOLDINGS",
     "symbol": "WYPH"
    },
    {
     "description": "WIDEPOINT CORP",
     "symbol": "WYY"
    },
    {
     "description": "WENZHOU KANGNING HOSPITAL -H",
     "symbol": "WZHUF"
    },
    {
     "description": "WIZZ AIR HOLDINGS PLC",
     "symbol": "WZZAF"
    },
    {
     "description": "WIZZ AIR HOLDINGS - UNSP ADR",
     "symbol": "WZZZY"
    },
    {
     "description": "UNITED STATES STEEL CORP",
     "symbol": "X"
    },
    {
     "description": "XAAR PLC",
     "symbol": "XAARF"
    },
    {
     "description": "BEYOND AIR INC",
     "symbol": "XAIR"
    },
    {
     "description": "XALLES HOLDINGS INC",
     "symbol": "XALL"
    },
    {
     "description": "XANADU MINES LTD",
     "symbol": "XANAF"
    },
    {
     "description": "SPDR S&P AEROSPACE & DEF ETF",
     "symbol": "XAR"
    },
    {
     "description": "GOLDMONEY INC",
     "symbol": "XAUMF"
    },
    {
     "description": "INNOVATOR US EQY ACCEL 9 BUF",
     "symbol": "XBAP"
    },
    {
     "description": "SPDR S&P BIOTECH ETF",
     "symbol": "XBI"
    },
    {
     "description": "XENETIC BIOSCIENCES INC",
     "symbol": "XBIO"
    },
    {
     "description": "XENETIC BIOSCIENCES -CW24",
     "symbol": "XBIOW"
    },
    {
     "description": "XBIOTECH INC",
     "symbol": "XBIT"
    },
    {
     "description": "INNOVATOR US EQ AC 9 BUFF-J",
     "symbol": "XBJA"
    },
    {
     "description": "INN US EQ ACC 9 BUFF JULY",
     "symbol": "XBJL"
    },
    {
     "description": "INNOVATOR US EQY ACC 9 BUFF",
     "symbol": "XBOC"
    },
    {
     "description": "CROSS BORDER RESOURCES INC",
     "symbol": "XBOR"
    },
    {
     "description": "XEBRA BRANDS LTD",
     "symbol": "XBRAF"
    },
    {
     "description": "VANECK BITCOIN STRATEGY ETF",
     "symbol": "XBTF"
    },
    {
     "description": "YUTUDAO MARINE BIOTECHNOLOGY",
     "symbol": "XCAN"
    },
    {
     "description": "COLUMBIA EM CORE EX-CHINA ET",
     "symbol": "XCEM"
    },
    {
     "description": "XCELMOBILITY INC",
     "symbol": "XCLL"
    },
    {
     "description": "GLOBAL X S&P 500 COLLAR 95-1",
     "symbol": "XCLR"
    },
    {
     "description": "XTERA COMMUNICATIONS INC",
     "symbol": "XCOMQ"
    },
    {
     "description": "XCPCNL BUSINESS SERVICES COR",
     "symbol": "XCPL"
    },
    {
     "description": "XCANA PETROLEUM CORP",
     "symbol": "XCPT"
    },
    {
     "description": "XCORPOREAL INC",
     "symbol": "XCRP"
    },
    {
     "description": "XCELERATE INC",
     "symbol": "XCRT"
    },
    {
     "description": "EXICURE INC",
     "symbol": "XCUR"
    },
    {
     "description": "INNOVATOR US EQY ACCEL-APR",
     "symbol": "XDAP"
    },
    {
     "description": "FRANKLIN EXPONENTIAL DATA",
     "symbol": "XDAT"
    },
    {
     "description": "FT CBOE VEST US EQY ENHANCE",
     "symbol": "XDEC"
    },
    {
     "description": "INNOVATOR US EQ ACCELERATE-J",
     "symbol": "XDJA"
    },
    {
     "description": "INN US EQ ACCELERATED JULY",
     "symbol": "XDJL"
    },
    {
     "description": "KELLY CRISPR & GENE EDITING",
     "symbol": "XDNA"
    },
    {
     "description": "XD INC",
     "symbol": "XDNCF"
    },
    {
     "description": "INNOVATOR US EQUITY ACCEL OC",
     "symbol": "XDOC"
    },
    {
     "description": "INNOVATOR GRW 100 ACCEL QTR",
     "symbol": "XDQQ"
    },
    {
     "description": "MPHASE TECHNOLOGIES INC",
     "symbol": "XDSL"
    },
    {
     "description": "INNOVATOR US EQY ACCL-QUART",
     "symbol": "XDSQ"
    },
    {
     "description": "X MSCI WORLD FINANCIALS",
     "symbol": "XDWFF"
    },
    {
     "description": "X MSCI WORLD HEALTH CARE",
     "symbol": "XDWHF"
    },
    {
     "description": "XEBEC ADSORPTION INC",
     "symbol": "XEBEF"
    },
    {
     "description": "XCEL ENERGY INC",
     "symbol": "XEL"
    },
    {
     "description": "EXELA TECHNOLOGIES INC",
     "symbol": "XELA"
    },
    {
     "description": "EXELA TECHNOLOGIES INC",
     "symbol": "XELAP"
    },
    {
     "description": "EXELA TECHNOLOGIES INC",
     "symbol": "XELAU"
    },
    {
     "description": "EXELA TECHNOLOGIES INC-CW23",
     "symbol": "XELAW"
    },
    {
     "description": "XCEL BRANDS INC",
     "symbol": "XELB"
    },
    {
     "description": "XENON PHARMACEUTICALS INC",
     "symbol": "XENE"
    },
    {
     "description": "XENO TRANSPLANTS CORP",
     "symbol": "XENO"
    },
    {
     "description": "INTERSECT ENT INC",
     "symbol": "XENT"
    },
    {
     "description": "XEMPLAR ENERGY CORP",
     "symbol": "XEPRF"
    },
    {
     "description": "XERIANT INC",
     "symbol": "XERI"
    },
    {
     "description": "XERIS BIOPHARMA HOLDINGS INC",
     "symbol": "XERS"
    },
    {
     "description": "SPDR OIL & GAS EQUIP & SERV",
     "symbol": "XES"
    },
    {
     "description": "ELECTRONIC SERVITOR PUBN NET",
     "symbol": "XESP"
    },
    {
     "description": "X-FAB SILICON FOUNDRIES SE",
     "symbol": "XFABF"
    },
    {
     "description": "X-FACTOR COMMUNICATIONS HOLD",
     "symbol": "XFCH"
    },
    {
     "description": "XTREME FIGHTING CHAMPIONSHIP",
     "symbol": "XFCI"
    },
    {
     "description": "Federated Hermes Short Duration Corporate ETF",
     "symbol": "XFCSX"
    },
    {
     "description": "Federated Hermes Short Duration High Yield ETF",
     "symbol": "XFHYX"
    },
    {
     "description": "EXCELFIN ACQUISITION CORP-A",
     "symbol": "XFIN"
    },
    {
     "description": "EXCELFIN ACQUISITION CORP",
     "symbol": "XFINU"
    },
    {
     "description": "EXCELFIN ACQUISITION -CW23",
     "symbol": "XFINW"
    },
    {
     "description": "XFUELS INC",
     "symbol": "XFLS"
    },
    {
     "description": "XAI OCTAGON FLOATING RATE AL",
     "symbol": "XFLT"
    },
    {
     "description": "XAI OCTAGON FLT RT ALT",
     "symbol": "XFLT.PRA"
    },
    {
     "description": "X4 PHARMACEUTICALS INC",
     "symbol": "XFOR"
    },
    {
     "description": "X4 PHARMACEUTICALS INC -CW24",
     "symbol": "XFORW"
    },
    {
     "description": "X4 PHARMACEUTICALS CW-24",
     "symbol": "XFOWW"
    },
    {
     "description": "XFIT BRANDS INC",
     "symbol": "XFTB"
    },
    {
     "description": "EXAGEN INC",
     "symbol": "XGN"
    },
    {
     "description": "SPDR S&P HOMEBUILDERS ETF",
     "symbol": "XHB"
    },
    {
     "description": "SPDR S&P HEALTH CARE EQUIPME",
     "symbol": "XHE"
    },
    {
     "description": "BEAT HOLDINGS LTD",
     "symbol": "XHFNF"
    },
    {
     "description": "XENIA HOTELS & RESORTS INC",
     "symbol": "XHR"
    },
    {
     "description": "SPDR S&P HEALTH CARE SER ETF",
     "symbol": "XHS"
    },
    {
     "description": "BONDBLOXX USD HY BOND CCS",
     "symbol": "XHYC"
    },
    {
     "description": "BONDBLOXX USD HY BOND CNONCS",
     "symbol": "XHYD"
    },
    {
     "description": "BONDBLOXX USD HY BOND ENERGY",
     "symbol": "XHYE"
    },
    {
     "description": "BONDBLOXX USD HY BOND F REIT",
     "symbol": "XHYF"
    },
    {
     "description": "BONDBLOXX USD HY BOND HEALTH",
     "symbol": "XHYH"
    },
    {
     "description": "BONDBLOXX USD HY BOND INDUS",
     "symbol": "XHYI"
    },
    {
     "description": "BONDBLOXX USD HY BOND TMT",
     "symbol": "XHYT"
    },
    {
     "description": "XIAOMI CORP-CLASS B",
     "symbol": "XIACF"
    },
    {
     "description": "XIAOMI CORP - UNSP ADR",
     "symbol": "XIACY"
    },
    {
     "description": "XIABUXIABU CATERING MANAGEME",
     "symbol": "XIAXF"
    },
    {
     "description": "XIGEM TECHNOLOGIES CORP",
     "symbol": "XIGMF"
    },
    {
     "description": "XINYUAN REAL ESTATE CO L-ADR",
     "symbol": "XIN"
    },
    {
     "description": "NEW WORK SE",
     "symbol": "XINXF"
    },
    {
     "description": "XIOR STUDENT HOUSING NV",
     "symbol": "XIORF"
    },
    {
     "description": "XINYI SOLAR HOLDINGS LTD-ADR",
     "symbol": "XISHY"
    },
    {
     "description": "SPDR FACTSET INNOVATIVE TECH",
     "symbol": "XITK"
    },
    {
     "description": "XENOUS HOLDINGS INC",
     "symbol": "XITO"
    },
    {
     "description": "ISHARES ESG SCREEN S&P MID",
     "symbol": "XJH"
    },
    {
     "description": "XINJIANG GOLDWIND SCI&TEC-H",
     "symbol": "XJNGF"
    },
    {
     "description": "ISHARES ESG SCREEN SP SMALL",
     "symbol": "XJR"
    },
    {
     "description": "FT CBOE VEST US EQUITY ENHAN",
     "symbol": "XJUN"
    },
    {
     "description": "XL FLEET CORP",
     "symbol": "XL"
    },
    {
     "description": "MATERIALS SELECT SECTOR SPDR",
     "symbol": "XLB"
    },
    {
     "description": "COMM SERV SELECT SECTOR SPDR",
     "symbol": "XLC"
    },
    {
     "description": "ENERGY SELECT SECTOR SPDR",
     "symbol": "XLE"
    },
    {
     "description": "XXL ENERGY CORP",
     "symbol": "XLEFF"
    },
    {
     "description": "FINANCIAL SELECT SECTOR SPDR",
     "symbol": "XLF"
    },
    {
     "description": "INVESCO S&P 500 TOP 50 ETF",
     "symbol": "XLG"
    },
    {
     "description": "INDUSTRIAL SELECT SECT SPDR",
     "symbol": "XLI"
    },
    {
     "description": "INVESCO US INDUSTRIALS S&P",
     "symbol": "XLISF"
    },
    {
     "description": "TECHNOLOGY SELECT SECT SPDR",
     "symbol": "XLK"
    },
    {
     "description": "XLMEDIA PLC",
     "symbol": "XLMDF"
    },
    {
     "description": "XILIO THERAPEUTICS INC",
     "symbol": "XLO"
    },
    {
     "description": "CONSUMER STAPLES SPDR",
     "symbol": "XLP"
    },
    {
     "description": "XCELPLUS INTERNATIONAL INC",
     "symbol": "XLPI"
    },
    {
     "description": "REAL ESTATE SELECT SECT SPDR",
     "symbol": "XLRE"
    },
    {
     "description": "SPDR SSGA US SECTOR ROTATE",
     "symbol": "XLSR"
    },
    {
     "description": "UTILITIES SELECT SECTOR SPDR",
     "symbol": "XLU"
    },
    {
     "description": "HEALTH CARE SELECT SECTOR",
     "symbol": "XLV"
    },
    {
     "description": "XINLIWANG INTERNATIONAL",
     "symbol": "XLWH"
    },
    {
     "description": "CONSUMER DISCRETIONARY SELT",
     "symbol": "XLY"
    },
    {
     "description": "QUALTRICS INTERNATIONAL-CL A",
     "symbol": "XM"
    },
    {
     "description": "CS ETF (CH) ON SBI DOM G7-15",
     "symbol": "XMBBF"
    },
    {
     "description": "SPDR S&P METALS & MINING ETF",
     "symbol": "XME"
    },
    {
     "description": "XEMEX GROUP INC",
     "symbol": "XMEX"
    },
    {
     "description": "INVESCO S&P MIDCAP QUAL ETF",
     "symbol": "XMHQ"
    },
    {
     "description": "INVESCO S&P MIDCAP LOW VOLAT",
     "symbol": "XMLV"
    },
    {
     "description": "Xtrackers IE PLC MSCI Emerging Markets",
     "symbol": "XMMEF"
    },
    {
     "description": "INVESCO S&P MIDCAP MOMENTUM",
     "symbol": "XMMO"
    },
    {
     "description": "XMREALITY AB",
     "symbol": "XMMRF"
    },
    {
     "description": "VANECK CEF MUNI INCOME ETF",
     "symbol": "XMPT"
    },
    {
     "description": "X WORLD SWAP 1C",
     "symbol": "XMSCF"
    },
    {
     "description": "ISHARES CORE FTSE 100 ACC",
     "symbol": "XMTCF"
    },
    {
     "description": "ISHARES CORE MSCI EMU EUR A",
     "symbol": "XMTIF"
    },
    {
     "description": "XOMETRY INC-A",
     "symbol": "XMTR"
    },
    {
     "description": "XMET INC",
     "symbol": "XMTTF"
    },
    {
     "description": "INVESCO S&P MIDCAP VALUE WIT",
     "symbol": "XMVM"
    },
    {
     "description": "X MSCI WORLD 1D",
     "symbol": "XMWUF"
    },
    {
     "description": "XENCOR INC",
     "symbol": "XNCR"
    },
    {
     "description": "XINDA INTERNATIONAL CORP",
     "symbol": "XNDA"
    },
    {
     "description": "XANDER RESOURCES INC",
     "symbol": "XNDRF"
    },
    {
     "description": "XUNLEI LTD-ADR",
     "symbol": "XNET"
    },
    {
     "description": "XINGDA INT'L HOLDINGS",
     "symbol": "XNGIF"
    },
    {
     "description": "ENN ENERGY HOLDINGS LTD",
     "symbol": "XNGSF"
    },
    {
     "description": "ENN ENERGY HOLDINGS-UNSP ADR",
     "symbol": "XNGSY"
    },
    {
     "description": "XINJIANG GOLDWIND-UNSP ADR",
     "symbol": "XNJJY"
    },
    {
     "description": "XENONICS HOLDINGS INC",
     "symbol": "XNNHQ"
    },
    {
     "description": "SPDR NYSE TECHNOLOGY ETF",
     "symbol": "XNTK"
    },
    {
     "description": "XINYI SOLAR HOLDINGS LTD",
     "symbol": "XNYIF"
    },
    {
     "description": "EXXON MOBIL CORP",
     "symbol": "XOM"
    },
    {
     "description": "XOMA CORP",
     "symbol": "XOMA"
    },
    {
     "description": "XOMA CORP",
     "symbol": "XOMAO"
    },
    {
     "description": "XOMA CORP",
     "symbol": "XOMAP"
    },
    {
     "description": "SPDR S&P OIL & GAS EXP & PR",
     "symbol": "XOP"
    },
    {
     "description": "XOS INC",
     "symbol": "XOS"
    },
    {
     "description": "NEXTGEN ACQUISITION -CW26",
     "symbol": "XOSWW"
    },
    {
     "description": "GRANITESHARES XOUT US L\/C",
     "symbol": "XOUT"
    },
    {
     "description": "XP INC - CLASS A",
     "symbol": "XP"
    },
    {
     "description": "XPAC ACQUISITION CORP-A",
     "symbol": "XPAX"
    },
    {
     "description": "XPAC ACQUISITION CORP",
     "symbol": "XPAXU"
    },
    {
     "description": "XPAC ACQUISITION CORP-CW27",
     "symbol": "XPAXW"
    },
    {
     "description": "POWER & DIGITAL ACQUISITIO-A",
     "symbol": "XPDB"
    },
    {
     "description": "POWER & DIGITAL INFRASTRUCTU",
     "symbol": "XPDBU"
    },
    {
     "description": "POWER & DIGITAL ACQ -CW24",
     "symbol": "XPDBW"
    },
    {
     "description": "XPEL INC",
     "symbol": "XPEL"
    },
    {
     "description": "XPERI HOLDING CORP",
     "symbol": "XPER"
    },
    {
     "description": "XPENG INC - ADR",
     "symbol": "XPEV"
    },
    {
     "description": "SPDR S&P PHARMACEUTICALS ETF",
     "symbol": "XPH"
    },
    {
     "description": "XPHYTO THERAPEUTICS CORP",
     "symbol": "XPHYF"
    },
    {
     "description": "SOLITARIO ZINC CORP",
     "symbol": "XPL"
    },
    {
     "description": "FIRST TRUST EXPANDED TECH",
     "symbol": "XPND"
    },
    {
     "description": "XPENG INC - CLASS A SHARES",
     "symbol": "XPNGF"
    },
    {
     "description": "XPO LOGISTICS INC",
     "symbol": "XPO"
    },
    {
     "description": "DPCM CAPITAL INC - CLASS A",
     "symbol": "XPOA"
    },
    {
     "description": "DPCM CAPITAL INC",
     "symbol": "XPOA.U"
    },
    {
     "description": "DPCM CAPITAL INC -A -CW27",
     "symbol": "XPOA.WS"
    },
    {
     "description": "XPONENTIAL FITNESS INC-A",
     "symbol": "XPOF"
    },
    {
     "description": "EXPION360 INC",
     "symbol": "XPON"
    },
    {
     "description": "PROSHARES ULTRA FTSE CHINA50",
     "symbol": "XPP"
    },
    {
     "description": "XP POWER LTD",
     "symbol": "XPPLF"
    },
    {
     "description": "EXPRO GROUP HOLDINGS NV",
     "symbol": "XPRO"
    },
    {
     "description": "XP Inc",
     "symbol": "XPVVV"
    },
    {
     "description": "XRAPPLIED TECHNOLOGIES INC",
     "symbol": "XRAPF"
    },
    {
     "description": "DENTSPLY SIRONA INC",
     "symbol": "XRAY"
    },
    {
     "description": "XREF LTD",
     "symbol": "XREFF"
    },
    {
     "description": "XR ENERGY INC",
     "symbol": "XREG"
    },
    {
     "description": "XTIERRA INC",
     "symbol": "XRESF"
    },
    {
     "description": "XRF SCIENTIFIC LTD",
     "symbol": "XRFSF"
    },
    {
     "description": "INVESCO S&P 500 EX-RATE SENS",
     "symbol": "XRLV"
    },
    {
     "description": "GLOBAL X S&P 500 RISK MANAGE",
     "symbol": "XRMI"
    },
    {
     "description": "XERO LTD",
     "symbol": "XROLF"
    },
    {
     "description": "SPDR S&P RETAIL ETF",
     "symbol": "XRT"
    },
    {
     "description": "XEROS TECHNOLOGY GROUP PLC",
     "symbol": "XRTEF"
    },
    {
     "description": "XORTX THERAPEUTICS INC",
     "symbol": "XRTX"
    },
    {
     "description": "XEROX HOLDINGS CORP",
     "symbol": "XRX"
    },
    {
     "description": "XRX INTERNATIONAL ENTERTAIN",
     "symbol": "XRXH"
    },
    {
     "description": "SPDR S&P SEMICONDUCTOR ETF",
     "symbol": "XSD"
    },
    {
     "description": "X S&P SELECT FRONTIER SWAP",
     "symbol": "XSFDF"
    },
    {
     "description": "X S&P GLOBAL INFRA SWAP",
     "symbol": "XSGIF"
    },
    {
     "description": "INVESCO S&P SMALLCAP HIGH DI",
     "symbol": "XSHD"
    },
    {
     "description": "XS FINANCIAL INC",
     "symbol": "XSHLF"
    },
    {
     "description": "INVESCO S&P SMALLCAP QUALITY",
     "symbol": "XSHQ"
    },
    {
     "description": "INVESCO S&P SMALLCAP LOW VOL",
     "symbol": "XSLV"
    },
    {
     "description": "INVESCO S&P SMALLCAP MOMENTU",
     "symbol": "XSMO"
    },
    {
     "description": "NOVACCESS GLOBAL INC",
     "symbol": "XSNX"
    },
    {
     "description": "WISDMTREE EMERG MKT EX-ST OW",
     "symbol": "XSOE"
    },
    {
     "description": "XPRESSPA GROUP INC",
     "symbol": "XSPA"
    },
    {
     "description": "XSPORT GLOBAL INC",
     "symbol": "XSPT"
    },
    {
     "description": "X S&P500 SWAP",
     "symbol": "XSPUF"
    },
    {
     "description": "XSTATE RESOURCES LTD",
     "symbol": "XSTLF"
    },
    {
     "description": "INVESCO S&P SMALLCAP VALUE W",
     "symbol": "XSVM"
    },
    {
     "description": "XSOVT BRANDS INC",
     "symbol": "XSVT"
    },
    {
     "description": "SPDR S&P SOFTWARE & SER ETF",
     "symbol": "XSW"
    },
    {
     "description": "ISHARES EXPONENTIAL TECH ETF",
     "symbol": "XT"
    },
    {
     "description": "INNOVATOR US EQTY ACCEL PL",
     "symbol": "XTAP"
    },
    {
     "description": "XANTIPPE RESOURCES LTD",
     "symbol": "XTCPF"
    },
    {
     "description": "X CSI300 SWAP 1C",
     "symbol": "XTCSF"
    },
    {
     "description": "XTEP INTERNATIONAL-UNSP ADR",
     "symbol": "XTEPY"
    },
    {
     "description": "OLIVE RESOURCE CAPITAL INC",
     "symbol": "XTERF"
    },
    {
     "description": "XTRA-GOLD RESOURCES CORP",
     "symbol": "XTGRF"
    },
    {
     "description": "INNOVATOR US EQ ACC PLUS - J",
     "symbol": "XTJA"
    },
    {
     "description": "INN US EQ ACCEL PLUS JULY",
     "symbol": "XTJL"
    },
    {
     "description": "SPDR S&P TELECOM ETF",
     "symbol": "XTL"
    },
    {
     "description": "XTL BIOPHARMACEUTICALS-ADR",
     "symbol": "XTLB"
    },
    {
     "description": "XTM INC",
     "symbol": "XTMIF"
    },
    {
     "description": "XTREME MOTORSPORTS INTERNATI",
     "symbol": "XTMM"
    },
    {
     "description": "SPDR S&P TRANSPORTATION ETF",
     "symbol": "XTN"
    },
    {
     "description": "XTANT MEDICAL HOLDINGS INC",
     "symbol": "XTNT"
    },
    {
     "description": "INNOVATOR US EQY ACCEL PL-OC",
     "symbol": "XTOC"
    },
    {
     "description": "XTEP INTERNATIONAL HOLDINGS",
     "symbol": "XTPEF"
    },
    {
     "description": "XTRA ENERGY CORP",
     "symbol": "XTPT"
    },
    {
     "description": "GLOBAL X S&P 500 TAIL RISK E",
     "symbol": "XTR"
    },
    {
     "description": "X MSCI USA UCITS ETF",
     "symbol": "XTRIF"
    },
    {
     "description": "X RUSSELL 2000",
     "symbol": "XTRKF"
    },
    {
     "description": "EXTREME BIODIESEL INC",
     "symbol": "XTRM"
    },
    {
     "description": "X-TERRA RESOURCES INC",
     "symbol": "XTRRF"
    },
    {
     "description": "X USD TREASURIES 1-3",
     "symbol": "XTRSF"
    },
    {
     "description": "X MSCI USA INFORMATION TECH",
     "symbol": "XTRTF"
    },
    {
     "description": "X GLOBAL GOV BOND USD",
     "symbol": "XTRXF"
    },
    {
     "description": "X MSCI CHINA 1C",
     "symbol": "XTTRF"
    },
    {
     "description": "X USD HIGH YIELD BOND",
     "symbol": "XTTXF"
    },
    {
     "description": "ADASTRA HOLDINGS LTD",
     "symbol": "XTXXF"
    },
    {
     "description": "X MSCI USA FINANCIALS",
     "symbol": "XUFNF"
    },
    {
     "description": "XVIVO PERFUSION AB",
     "symbol": "XVIPF"
    },
    {
     "description": "ACRUENCE ACTIVE HEDGE US ETF",
     "symbol": "XVOL"
    },
    {
     "description": "ISHARES ESG SCREENED S&P500",
     "symbol": "XVV"
    },
    {
     "description": "SPDR S&P INTERNET ETF",
     "symbol": "XWEB"
    },
    {
     "description": "FFP PARTNERS  -LP-CL A",
     "symbol": "XXFPL"
    },
    {
     "description": "22ND CENTURY GROUP INC",
     "symbol": "XXII"
    },
    {
     "description": "XXL ASA - UNSP ADR",
     "symbol": "XXLLY"
    },
    {
     "description": "XIMEN MINING CORP",
     "symbol": "XXMMF"
    },
    {
     "description": "X MSCI WORLD MATERIALS",
     "symbol": "XXTKF"
    },
    {
     "description": "X MSCI WORLD QUALITY",
     "symbol": "XXTXF"
    },
    {
     "description": "X FINANCIAL-ADR",
     "symbol": "XYF"
    },
    {
     "description": "XINYI GLASS HOLDINGS LTD",
     "symbol": "XYIGF"
    },
    {
     "description": "XINYI GLASS HOLDI-UNSP ADR",
     "symbol": "XYIGY"
    },
    {
     "description": "XYLEM INC",
     "symbol": "XYL"
    },
    {
     "description": "GLOBAL X S&P 500 COVE CALL E",
     "symbol": "XYLD"
    },
    {
     "description": "GLOBAL X S&P 500 COVC & GRW",
     "symbol": "XYLG"
    },
    {
     "description": "SWEET NATURAL TRADING CO LTD",
     "symbol": "XYLTF"
    },
    {
     "description": "XYNERGY HOLDINGS INC",
     "symbol": "XYNH"
    },
    {
     "description": "ANACORTES MINING CORP",
     "symbol": "XYZFF"
    },
    {
     "description": "MITSUI MINING & SMELTING CO",
     "symbol": "XZJCF"
    },
    {
     "description": "ALLEGHANY CORP",
     "symbol": "Y"
    },
    {
     "description": "YANCOAL AUSTRALIA LTD",
     "symbol": "YACAF"
    },
    {
     "description": "YADEA GROUP HOLDINGS LTD",
     "symbol": "YADGF"
    },
    {
     "description": "YAGEO CORPORATION-SPONS GDR",
     "symbol": "YAGOY"
    },
    {
     "description": "Z HOLDINGS CORP",
     "symbol": "YAHOF"
    },
    {
     "description": "Z HOLDINGS CORP-UNSPON ADR",
     "symbol": "YAHOY"
    },
    {
     "description": "YALLA GROUP LTD",
     "symbol": "YALA"
    },
    {
     "description": "YAMAHA CORP",
     "symbol": "YAMCF"
    },
    {
     "description": "YAMAHA CORP-SPONSORED ADR",
     "symbol": "YAMCY"
    },
    {
     "description": "YAMAHA MOTOR CO LTD",
     "symbol": "YAMHF"
    },
    {
     "description": "YAMAHA MOTOR CO-UNSPON ADR",
     "symbol": "YAMHY"
    },
    {
     "description": "YA-MAN LTD",
     "symbol": "YAMNF"
    },
    {
     "description": "DRX DLY FTSE CHINA BEAR 3X",
     "symbol": "YANG"
    },
    {
     "description": "YARA INTERNATIONAL-ADR",
     "symbol": "YARIY"
    },
    {
     "description": "YASKAWA ELECTRIC CORP",
     "symbol": "YASKF"
    },
    {
     "description": "YASKAWA ELECTRIC CORP-ADR",
     "symbol": "YASKY"
    },
    {
     "description": "YAMATO HOLDINGS CO LTD",
     "symbol": "YATRF"
    },
    {
     "description": "YAMATO HOLDINGS CO-UNSP ADR",
     "symbol": "YATRY"
    },
    {
     "description": "EVMO INC",
     "symbol": "YAYO"
    },
    {
     "description": "YONG BAI CHAO NEW RETAIL COR",
     "symbol": "YBCN"
    },
    {
     "description": "YUBO INTERNATIONAL BIOTECH L",
     "symbol": "YBGJ"
    },
    {
     "description": "YELLOW BRICK ROAD HOLDINGS L",
     "symbol": "YBRHF"
    },
    {
     "description": "CBDMD INC",
     "symbol": "YCBD"
    },
    {
     "description": "CBDMD INC",
     "symbol": "YCBD.PRA"
    },
    {
     "description": "YANCHANG PETROLEUM INTERNATI",
     "symbol": "YCGPF"
    },
    {
     "description": "Yachiyo Industry Company Ltd",
     "symbol": "YCHYF"
    },
    {
     "description": "PROSHARES ULTRA YEN",
     "symbol": "YCL"
    },
    {
     "description": "PROSHARES ULTRASHORT YEN",
     "symbol": "YCS"
    },
    {
     "description": "FT CBOE V INTERN EQ BUFF DEC",
     "symbol": "YDEC"
    },
    {
     "description": "YADONG GROUP HOLDINGS LTD",
     "symbol": "YDGHF"
    },
    {
     "description": "YDUQS PART-SPONSORED ADR",
     "symbol": "YDUQY"
    },
    {
     "description": "YADKIN VALLEY CO",
     "symbol": "YDVL"
    },
    {
     "description": "YODOGAWA STEEL WORKS LTD",
     "symbol": "YDWAF"
    },
    {
     "description": "YULONG ECO-MATERIALS LTD",
     "symbol": "YECO"
    },
    {
     "description": "YELLOW CORP",
     "symbol": "YELL"
    },
    {
     "description": "YELP INC",
     "symbol": "YELP"
    },
    {
     "description": "YETI HOLDINGS INC",
     "symbol": "YETI"
    },
    {
     "description": "YEW BIO-PHARM GROUP INC",
     "symbol": "YEWB"
    },
    {
     "description": "ENVIRONMENTAL WASTE INTL INC",
     "symbol": "YEWTF"
    },
    {
     "description": "YEXT INC",
     "symbol": "YEXT"
    },
    {
     "description": "YAMAGUCHI FINANCIAL GROUP IN",
     "symbol": "YFGSF"
    },
    {
     "description": "YAGEO CORPORATION",
     "symbol": "YGEQF"
    },
    {
     "description": "MINGZHU LOGISTICS HOLDINGS L",
     "symbol": "YGMZ"
    },
    {
     "description": "YANGARRA RESOURCES LTD",
     "symbol": "YGRAF"
    },
    {
     "description": "GOLD TERRA RESOURCE CORP",
     "symbol": "YGTFF"
    },
    {
     "description": "SSLJ.COM LTD - A",
     "symbol": "YGTYF"
    },
    {
     "description": "YOKOGAWA BRIDGE HOLDINGS COR",
     "symbol": "YGWAF"
    },
    {
     "description": "YOUNGEVITY INTERNATIONAL INC",
     "symbol": "YGYI"
    },
    {
     "description": "Youngevity International Inc",
     "symbol": "YGYIP"
    },
    {
     "description": "YEAHKA LTD",
     "symbol": "YHEKF"
    },
    {
     "description": "111 INC",
     "symbol": "YI"
    },
    {
     "description": "YIDU TECH INC",
     "symbol": "YIDUF"
    },
    {
     "description": "YIXIN GROUP LTD",
     "symbol": "YIGRF"
    },
    {
     "description": "YICHANG HEC CHANGJIANG PHA-H",
     "symbol": "YIHCF"
    },
    {
     "description": "YIK WO INTERNATIONAL HOLDING",
     "symbol": "YIKWF"
    },
    {
     "description": "DRX DLY FTSE CHINA BULL 3X",
     "symbol": "YINN"
    },
    {
     "description": "YIP'S CHEMICAL HOLDINGS LTD",
     "symbol": "YIPCF"
    },
    {
     "description": "YIPPY INC",
     "symbol": "YIPI"
    },
    {
     "description": "YINHANG INTERNET TECHNOLOGIE",
     "symbol": "YITD"
    },
    {
     "description": "YIT OYJ-UNSPON ADR",
     "symbol": "YITYY"
    },
    {
     "description": "YUNJI INC-ADR",
     "symbol": "YJ"
    },
    {
     "description": "YIJIA GROUP CORP",
     "symbol": "YJGJ"
    },
    {
     "description": "FT CBOE VEST INTERNATIONAL E",
     "symbol": "YJUN"
    },
    {
     "description": "YAKULT HONSHA CO LTD",
     "symbol": "YKLTF"
    },
    {
     "description": "YAKULT HONSHA CO LTD - ADR",
     "symbol": "YKLTY"
    },
    {
     "description": "PRINCIPAL ACTIVE HIGH YIELD",
     "symbol": "YLD"
    },
    {
     "description": "CLEARBRIDG DIV STRGY ESG ETF",
     "symbol": "YLDE"
    },
    {
     "description": "YANLORD LAND GROUP LTD",
     "symbol": "YLDGF"
    },
    {
     "description": "YANLORD LAND GROUP-UNSP ADR",
     "symbol": "YLDGY"
    },
    {
     "description": "YELLOW HAT LTD",
     "symbol": "YLLWF"
    },
    {
     "description": "YELLOW CAKE PLC",
     "symbol": "YLLXF"
    },
    {
     "description": "YELLOW PAGES LTD\/CANADA",
     "symbol": "YLWDF"
    },
    {
     "description": "YELLOW MEDIA LTD-CW22",
     "symbol": "YLWWF"
    },
    {
     "description": "Y-MABS THERAPEUTICS INC",
     "symbol": "YMAB"
    },
    {
     "description": "YOMA STRATEGIC HLDGS LTD",
     "symbol": "YMAIF"
    },
    {
     "description": "FT CBOE VEST INT EQTY BUF-MA",
     "symbol": "YMAR"
    },
    {
     "description": "AZBIL CORP",
     "symbol": "YMATF"
    },
    {
     "description": "YAMADA HOLDINGS CO LTD",
     "symbol": "YMDAF"
    },
    {
     "description": "YAMASHIN-FILTER CORP",
     "symbol": "YMFCF"
    },
    {
     "description": "FULL TRUCK ALLIANCE -SPN ADR",
     "symbol": "YMM"
    },
    {
     "description": "YAMATO KOGYO CO LTD",
     "symbol": "YMTKF"
    },
    {
     "description": "YUMANITY THERAPEUTICS INC",
     "symbol": "YMTX"
    },
    {
     "description": "YAMAZAKI BAKING-UNSPONS ADR",
     "symbol": "YMZBY"
    },
    {
     "description": "YAMAZEN CORP",
     "symbol": "YMZNF"
    },
    {
     "description": "YANTAI NORTH ANDRE JUICE-H",
     "symbol": "YNAJF"
    },
    {
     "description": "YANDEX NV-A",
     "symbol": "YNDX"
    },
    {
     "description": "YUNFENG FINANCIAL GROUP LTD",
     "symbol": "YNFGF"
    },
    {
     "description": "YINGDE GASES GROUP CO LTD",
     "symbol": "YNGDF"
    },
    {
     "description": "YIHAI INTERNATIONAL HOLDING",
     "symbol": "YNNHF"
    },
    {
     "description": "KING STONE ENERGY GROUP LTD",
     "symbol": "YNSKF"
    },
    {
     "description": "YNVISIBLE INTERACTIVE INC",
     "symbol": "YNVYF"
    },
    {
     "description": "YOJEE LTD",
     "symbol": "YOJEF"
    },
    {
     "description": "YOKOGAWA ELECTRIC CORP",
     "symbol": "YOKEF"
    },
    {
     "description": "YOKOGAWA ELECTRIC-UNSP ADR",
     "symbol": "YOKEY"
    },
    {
     "description": "ADVISORSHARES PURE CANNABIS",
     "symbol": "YOLO"
    },
    {
     "description": "YONEX CO LTD",
     "symbol": "YONXF"
    },
    {
     "description": "YANGAROO INC",
     "symbol": "YOOIF"
    },
    {
     "description": "YORA INTERNATIONAL INC",
     "symbol": "YORI"
    },
    {
     "description": "YORK HARBOUR METALS INC",
     "symbol": "YORKF"
    },
    {
     "description": "YOKOHAMA RUBBER CO LTD",
     "symbol": "YORUF"
    },
    {
     "description": "YOKOHAMA RUBBER CO LT-ADR",
     "symbol": "YORUY"
    },
    {
     "description": "YORK WATER CO",
     "symbol": "YORW"
    },
    {
     "description": "YOTTA ACQUISITION CORP",
     "symbol": "YOTAU"
    },
    {
     "description": "CLEAR SECURE INC -CLASS A",
     "symbol": "YOU"
    },
    {
     "description": "YOURWAY CANNABIS BRANDS INC",
     "symbol": "YOURF"
    },
    {
     "description": "YPF S.A.-SPONSORED ADR",
     "symbol": "YPF"
    },
    {
     "description": "YAPPN CORP",
     "symbol": "YPPN"
    },
    {
     "description": "ARROW REVERSE CAP 500 ETF",
     "symbol": "YPS"
    },
    {
     "description": "17 EDUCATION & TECHNOLOGY GR",
     "symbol": "YQ"
    },
    {
     "description": "YARA INTERNATIONAL ASA",
     "symbol": "YRAIF"
    },
    {
     "description": "YORBEAU RESOURCES INC-CL A",
     "symbol": "YRBAF"
    },
    {
     "description": "YURTEC CORP",
     "symbol": "YRCCF"
    },
    {
     "description": "YIREN DIGITAL LTD - SPS ADR",
     "symbol": "YRD"
    },
    {
     "description": "YANGTZE RIVER PORT AND LOGIS",
     "symbol": "YRIV"
    },
    {
     "description": "GLOBAL UAV TECHNOLOGIES LTD",
     "symbol": "YRLLF"
    },
    {
     "description": "YOROZU CORP",
     "symbol": "YRZUF"
    },
    {
     "description": "FT CBOE VEST INTERNATIONAL E",
     "symbol": "YSEP"
    },
    {
     "description": "YATSEN HOLDING LTD-ADR",
     "symbol": "YSG"
    },
    {
     "description": "1399 INTERNET TECHNOLOGY APP",
     "symbol": "YSGG"
    },
    {
     "description": "YESTAR HEALTHCARE HOLDINGS",
     "symbol": "YSHCF"
    },
    {
     "description": "YANGZIJIANG SHIPBUILDING",
     "symbol": "YSHLF"
    },
    {
     "description": "YOSHITAKE INC",
     "symbol": "YSHOF"
    },
    {
     "description": "YIELD10 BIOSCIENCE INC",
     "symbol": "YTEN"
    },
    {
     "description": "YACHT FINDERS INC",
     "symbol": "YTFD"
    },
    {
     "description": "YTL Corporation Berhad",
     "symbol": "YTLCF"
    },
    {
     "description": "YTL POWER INTERNATIONAL BHD",
     "symbol": "YTLPF"
    },
    {
     "description": "YTO EXPRESS HOLDINGS LTD",
     "symbol": "YTOEF"
    },
    {
     "description": "TPG PACE BENEFICIAL II COR-A",
     "symbol": "YTPG"
    },
    {
     "description": "YATRA ONLINE INC",
     "symbol": "YTRA"
    },
    {
     "description": "YT REALTY GROUP LTD",
     "symbol": "YTRGF"
    },
    {
     "description": "FINCERA INC",
     "symbol": "YUANF"
    },
    {
     "description": "YUE YUEN INDUSTRIAL HLDG",
     "symbol": "YUEIF"
    },
    {
     "description": "YUE YUEN INDUSTRIAL-UNSP ADR",
     "symbol": "YUEIY"
    },
    {
     "description": "YOUGOV PLC",
     "symbol": "YUGVF"
    },
    {
     "description": "YUHAN CORPORATION-PREF",
     "symbol": "YUHCF"
    },
    {
     "description": "YUHAN CORP",
     "symbol": "YUHNF"
    },
    {
     "description": "YUHE INTERNATIONAL INC",
     "symbol": "YUII"
    },
    {
     "description": "YUKA GROUP INC",
     "symbol": "YUKA"
    },
    {
     "description": "YUM! BRANDS INC",
     "symbol": "YUM"
    },
    {
     "description": "YUMA ENERGY INC",
     "symbol": "YUMAQ"
    },
    {
     "description": "YUM CHINA HOLDINGS INC",
     "symbol": "YUMC"
    },
    {
     "description": "YUMMIES INC",
     "symbol": "YUMM"
    },
    {
     "description": "DEMAE-CAN CO LTD",
     "symbol": "YUMSF"
    },
    {
     "description": "VANECK FUTURE OF FOOD ETF",
     "symbol": "YUMY"
    },
    {
     "description": "YUEXIU REAL ESTATE INVESTMEN",
     "symbol": "YUXXF"
    },
    {
     "description": "YUZHOU GROUP HOLDINGS CO LTD",
     "symbol": "YUZHF"
    },
    {
     "description": "LIQUID MEDIA GROUP LTD",
     "symbol": "YVR"
    },
    {
     "description": "YOWIE GROUP LTD",
     "symbol": "YWGRF"
    },
    {
     "description": "DIXIE GOLD INC",
     "symbol": "YWRLF"
    },
    {
     "description": "PROSHARES SHORT FTSE CHINA50",
     "symbol": "YXI"
    },
    {
     "description": "YOOX NET-A-PORTER GROUP",
     "symbol": "YXOXF"
    },
    {
     "description": "YX Asset Recovery Limited",
     "symbol": "YXR"
    },
    {
     "description": "JOYY INC-ADR",
     "symbol": "YY"
    },
    {
     "description": "Joyy Inc",
     "symbol": "YYINZ"
    },
    {
     "description": "AMPLIFY HIGH INCOME ETF",
     "symbol": "YYY"
    },
    {
     "description": "CHINA YANYUAN YUHUI NATL ED",
     "symbol": "YYYH"
    },
    {
     "description": "YANKUANG ENERGY GROUP-SP ADR",
     "symbol": "YZCAY"
    },
    {
     "description": "SINOPEC OILFIELD SERVICE -H",
     "symbol": "YZCFF"
    },
    {
     "description": "YANKUANG ENERGY GROUP CO-H",
     "symbol": "YZCHF"
    },
    {
     "description": "YANGTZE OPTICAL FIBRE AND-H",
     "symbol": "YZOFF"
    },
    {
     "description": "YAMAZAKI BAKING CO LTD",
     "symbol": "YZZKF"
    },
    {
     "description": "ZILLOW GROUP INC - C",
     "symbol": "Z"
    },
    {
     "description": "ZA GROUP INC",
     "symbol": "ZAAG"
    },
    {
     "description": "ZACAPA RESOURCES LTD",
     "symbol": "ZACAF"
    },
    {
     "description": "ZAHAV INC",
     "symbol": "ZAHA"
    },
    {
     "description": "ZINC8 ENERGY SOLUTIONS INC",
     "symbol": "ZAIRF"
    },
    {
     "description": "ZAPF CREATION AG",
     "symbol": "ZAPNF"
    },
    {
     "description": "ZAZA ENERGY CORP",
     "symbol": "ZAZA"
    },
    {
     "description": "ZIMMER BIOMET HOLDINGS INC",
     "symbol": "ZBH"
    },
    {
     "description": "ZEB NICKEL CORP",
     "symbol": "ZBNIF"
    },
    {
     "description": "ZEBRA TECHNOLOGIES CORP-CL A",
     "symbol": "ZBRA"
    },
    {
     "description": "BATS Test",
     "symbol": "ZBZX"
    },
    {
     "description": "BODY BASICS INC",
     "symbol": "ZCBD"
    },
    {
     "description": "ZHONGCHAO INC-CLASS A",
     "symbol": "ZCMD"
    },
    {
     "description": "IMPRESO INC",
     "symbol": "ZCOM"
    },
    {
     "description": "ZINCCORP RESOURCES INC",
     "symbol": "ZCPRF"
    },
    {
     "description": "ZINCORE METALS INC",
     "symbol": "ZCRMF"
    },
    {
     "description": "GRAYSCALE ZCASH TRUST",
     "symbol": "ZCSH"
    },
    {
     "description": "ZACATECAS SILVER CORP",
     "symbol": "ZCTSF"
    },
    {
     "description": "ZIFF DAVIS INC",
     "symbol": "ZD"
    },
    {
     "description": "ZHIDAO INTERNATIONAL HOLDING",
     "symbol": "ZDAOF"
    },
    {
     "description": "ZENOVIA DIGITAL EXCHANGE COR",
     "symbol": "ZDEC"
    },
    {
     "description": "SINTANA ENERGY INC",
     "symbol": "ZDEXF"
    },
    {
     "description": "ZEDGE INC-CL B",
     "symbol": "ZDGE"
    },
    {
     "description": "ZOO DIGITAL GROUP PLC",
     "symbol": "ZDGGF"
    },
    {
     "description": "ZONED PROPERTIES INC",
     "symbol": "ZDPY"
    },
    {
     "description": "ZEALAND PHARMA A\/S-ADR",
     "symbol": "ZEAL"
    },
    {
     "description": "ZACKS EARNINGS CONSISTENT PO",
     "symbol": "ZECP"
    },
    {
     "description": "ZENDESK INC",
     "symbol": "ZEN"
    },
    {
     "description": "ZENERGY INTERNATIONAL INC",
     "symbol": "ZENG"
    },
    {
     "description": "ZENOSENSE INC",
     "symbol": "ZENO"
    },
    {
     "description": "ZENVIA INC - A",
     "symbol": "ZENV"
    },
    {
     "description": "ZEONS CORP",
     "symbol": "ZEON"
    },
    {
     "description": "ZEON CORP",
     "symbol": "ZEOOF"
    },
    {
     "description": "ZEON CORP -UNSPONSORED ADR",
     "symbol": "ZEOOY"
    },
    {
     "description": "ZEPP HEALTH CORP-ADR",
     "symbol": "ZEPP"
    },
    {
     "description": "ECOARK HOLDINGS INC",
     "symbol": "ZEST"
    },
    {
     "description": "ZETA GLOBAL HOLDINGS CORP-A",
     "symbol": "ZETA"
    },
    {
     "description": "ZEU TECHNOLOGIES INC",
     "symbol": "ZEUCF"
    },
    {
     "description": "OLYMPIC STEEL INC",
     "symbol": "ZEUS"
    },
    {
     "description": "ZEUS RESOURCES LTD",
     "symbol": "ZEUUF"
    },
    {
     "description": "LIGHTNING EMOTORS INC",
     "symbol": "ZEV"
    },
    {
     "description": "LIGHTNING EMOTORS INC-CW25",
     "symbol": "ZEV.WS"
    },
    {
     "description": "Test",
     "symbol": "ZEXIT"
    },
    {
     "description": "ZAMBEEF PRODUCTS PLC",
     "symbol": "ZFPPF"
    },
    {
     "description": "ZURICH INSURANCE GROUP AG",
     "symbol": "ZFSVF"
    },
    {
     "description": "ZILLOW GROUP INC - A",
     "symbol": "ZG"
    },
    {
     "description": "2G ENERGY AG",
     "symbol": "ZGBEF"
    },
    {
     "description": "ZIEGLER COS INC\/THE",
     "symbol": "ZGCO"
    },
    {
     "description": "GENERATION Z ETF",
     "symbol": "ZGEN"
    },
    {
     "description": "ERMENEGILDO ZEGNA HOLDITALIA",
     "symbol": "ZGN"
    },
    {
     "description": "ERMENEGILDO ZEGNA HOLD -CW27",
     "symbol": "ZGN.WS"
    },
    {
     "description": "ZERO GRAVITY SOLUTIONS INC",
     "symbol": "ZGSI"
    },
    {
     "description": "ZIGEXN CO LTD",
     "symbol": "ZGXNF"
    },
    {
     "description": "ZHIHU INC - ADR",
     "symbol": "ZH"
    },
    {
     "description": "ZHAOJIN MINING INDUSTRY - H",
     "symbol": "ZHAOF"
    },
    {
     "description": "ZENITH CAPITAL CORP\/ALBERTA",
     "symbol": "ZHCLF"
    },
    {
     "description": "ZEGA BUY AND HEDGE ETF",
     "symbol": "ZHDG"
    },
    {
     "description": "ZHONG HUI DAO MING COPPER HO",
     "symbol": "ZHDM"
    },
    {
     "description": "ZHOU HEI YA INTERNATIONAL HO",
     "symbol": "ZHEIF"
    },
    {
     "description": "ZHEJIANG EXPRESSWAY CO-H",
     "symbol": "ZHEXF"
    },
    {
     "description": "ZHUHAI HOLDINGS INVESTMENT G",
     "symbol": "ZHHHF"
    },
    {
     "description": "ZHEJIANG SHIBAO CO-UNSP ADR",
     "symbol": "ZHHJY"
    },
    {
     "description": "ZHONGSHENG GROUP HOLDINGS",
     "symbol": "ZHSHF"
    },
    {
     "description": "ZHUDING INTERNATIONAL LTD",
     "symbol": "ZHUD"
    },
    {
     "description": "ZHUZHOU CRRC TIMES ELECTRIC",
     "symbol": "ZHUZF"
    },
    {
     "description": "ZHUZHOU CSR TIMES ELECTR-ADR",
     "symbol": "ZHUZY"
    },
    {
     "description": "ZHONG YUAN BIO-TECHNOLOGY HO",
     "symbol": "ZHYBF"
    },
    {
     "description": "ZHAOHENG HYDROPOWER LTD",
     "symbol": "ZHYLF"
    },
    {
     "description": "ZOOMINFO TECHNOLOGIES INC",
     "symbol": "ZI"
    },
    {
     "description": "ZICIX CORP",
     "symbol": "ZICX"
    },
    {
     "description": "Test",
     "symbol": "ZIEXT"
    },
    {
     "description": "THE ACQUIRERS FUND ETF",
     "symbol": "ZIG"
    },
    {
     "description": "ZIJIN MINING GROUP CO LTD-H",
     "symbol": "ZIJMF"
    },
    {
     "description": "ZIJIN MINING GROUP-UNSP ADR",
     "symbol": "ZIJMY"
    },
    {
     "description": "ZIM INTEGRATED SHIPPING SERV",
     "symbol": "ZIM"
    },
    {
     "description": "ZIM CORP",
     "symbol": "ZIMCF"
    },
    {
     "description": "ZIMVIE INC",
     "symbol": "ZIMV"
    },
    {
     "description": "FTAC ZEUS ACQUISITION C-CL A",
     "symbol": "ZING"
    },
    {
     "description": "FTAC ZEUS ACQUISITION CORP",
     "symbol": "ZINGU"
    },
    {
     "description": "FTAC ZEUS ACQ C CL A -CW27",
     "symbol": "ZINGW"
    },
    {
     "description": "ZIONS BANCORP NA",
     "symbol": "ZION"
    },
    {
     "description": "ZIONS BANCORP NA",
     "symbol": "ZIONL"
    },
    {
     "description": "ZIONS BANCORP NA",
     "symbol": "ZIONO"
    },
    {
     "description": "ZIONS BANCORP NA",
     "symbol": "ZIONP"
    },
    {
     "description": "ZIPRECRUITER INC-A",
     "symbol": "ZIP"
    },
    {
     "description": "ZIPLINK INC",
     "symbol": "ZIPL"
    },
    {
     "description": "ZIVO BIOSCIENCE INC",
     "symbol": "ZIVO"
    },
    {
     "description": "ZIVO BIOSCIENCE INC -CW23",
     "symbol": "ZIVOW"
    },
    {
     "description": "VELOCITYSHARES INV VIX MEDIU",
     "symbol": "ZIVZF"
    },
    {
     "description": "ZIP CO LTD",
     "symbol": "ZIZTF"
    },
    {
     "description": "Test",
     "symbol": "ZJZZT"
    },
    {
     "description": "ZKB GOLD ETF AA USD",
     "symbol": "ZKBGF"
    },
    {
     "description": "ZKB GOLD ETF AA CHF",
     "symbol": "ZKBHF"
    },
    {
     "description": "ZKB SILVER ETF AA CHF",
     "symbol": "ZKBSF"
    },
    {
     "description": "ZK INTERNATIONAL GROUP CO LT",
     "symbol": "ZKIN"
    },
    {
     "description": "ZKB PLATINUM ETF AA CHF",
     "symbol": "ZKPLF"
    },
    {
     "description": "ZAI LAB LTD-ADR",
     "symbol": "ZLAB"
    },
    {
     "description": "ZELIRA THERAPEUTICS LTD",
     "symbol": "ZLDAD"
    },
    {
     "description": "ZEALAND PHARMA A\/S",
     "symbol": "ZLDPF"
    },
    {
     "description": "ZALANDO SE",
     "symbol": "ZLDSF"
    },
    {
     "description": "ZOOMLION HEAVY INDUSTRY - H",
     "symbol": "ZLIOF"
    },
    {
     "description": "ZOOMLION HEAVY INDUS-UNS ADR",
     "symbol": "ZLIOY"
    },
    {
     "description": "ZALANDO SE - UNSPONSORED ADR",
     "symbol": "ZLNDY"
    },
    {
     "description": "ZEAL NETWORK SE",
     "symbol": "ZLNWF"
    },
    {
     "description": "ZOOPLUS SE",
     "symbol": "ZLPSF"
    },
    {
     "description": "ZOOM VIDEO COMMUNICATIONS-A",
     "symbol": "ZM"
    },
    {
     "description": "ZOOMD TECHNOLOGIES LTD",
     "symbol": "ZMDTF"
    },
    {
     "description": "ZHANGMEN EDUCATION INC- ADR",
     "symbol": "ZME"
    },
    {
     "description": "ZAMAGE DIGITAL ART IMAGING I",
     "symbol": "ZMGD"
    },
    {
     "description": "ZIMPLATS HOLDINGS LTD",
     "symbol": "ZMPLF"
    },
    {
     "description": "ZALEMARK HOLDING CO INC",
     "symbol": "ZMRK"
    },
    {
     "description": "ZECOTEK PHOTONICS INC",
     "symbol": "ZMSPF"
    },
    {
     "description": "ZUMTOBEL AG-UNSP ADR",
     "symbol": "ZMTBY"
    },
    {
     "description": "ZOOMAWAY TECHNOLOGIES INC",
     "symbol": "ZMWYF"
    },
    {
     "description": "ZANE INTERACTIVE PUBLISHING",
     "symbol": "ZNAE"
    },
    {
     "description": "ZINCX RESOURCES CORP",
     "symbol": "ZNCXF"
    },
    {
     "description": "ZYNGA INC - CL A",
     "symbol": "ZNGA"
    },
    {
     "description": "ZANAGA IRON ORE CO LTD-DI",
     "symbol": "ZNGGF"
    },
    {
     "description": "CHINA SOUTHERN AIR-SPONS ADR",
     "symbol": "ZNH"
    },
    {
     "description": "ZENKOKU HOSHO CO - UNSP ADR",
     "symbol": "ZNKKY"
    },
    {
     "description": "ZENKOKU HOSHO CO LTD",
     "symbol": "ZNKUF"
    },
    {
     "description": "ZANN CORP",
     "symbol": "ZNNC"
    },
    {
     "description": "ZHONGYUAN BANK CO LTD - ADR",
     "symbol": "ZNNGY"
    },
    {
     "description": "ZION OIL & GAS INC",
     "symbol": "ZNOG"
    },
    {
     "description": "ZION OIL & GAS INC -CW20",
     "symbol": "ZNOGW"
    },
    {
     "description": "ZNERGY INC",
     "symbol": "ZNRG"
    },
    {
     "description": "Z ENERGY LTD",
     "symbol": "ZNRGF"
    },
    {
     "description": "ZANITE ACQUISITION CORP-CL A",
     "symbol": "ZNTE"
    },
    {
     "description": "ZANITE ACQUISITION CORP",
     "symbol": "ZNTEU"
    },
    {
     "description": "ZANITE ACQ CL A -CW25",
     "symbol": "ZNTEW"
    },
    {
     "description": "ZENTALIS PHARMACEUTICALS INC",
     "symbol": "ZNTL"
    },
    {
     "description": "ZNEXT MINING CORP",
     "symbol": "ZNXT"
    },
    {
     "description": "ZINZINO AB-B SHS",
     "symbol": "ZNZNF"
    },
    {
     "description": "ZOJIRUSHI CORP",
     "symbol": "ZOJIF"
    },
    {
     "description": "ZOMEDICA CORP",
     "symbol": "ZOM"
    },
    {
     "description": "NOS SGPS",
     "symbol": "ZONNF"
    },
    {
     "description": "ZONZIA MEDIA INC",
     "symbol": "ZONX"
    },
    {
     "description": "ZOONO GROUP LTD",
     "symbol": "ZOONF"
    },
    {
     "description": "ZOOPLUS AG -UNSP ADR",
     "symbol": "ZOPLY"
    },
    {
     "description": "ZOOMPASS HOLDINGS INC",
     "symbol": "ZPAS"
    },
    {
     "description": "ZEPHYR ENERGY PLC",
     "symbol": "ZPHRF"
    },
    {
     "description": "ZEPHYR MINERALS LTD",
     "symbol": "ZPHYF"
    },
    {
     "description": "SPDR USA S\/C VALUE",
     "symbol": "ZPRVF"
    },
    {
     "description": "SURGE ENERGY INC",
     "symbol": "ZPTAF"
    },
    {
     "description": "ZARDOYA OTIS SA",
     "symbol": "ZRDZF"
    },
    {
     "description": "PIMCO 25+ YR ZERO CPN US TIF",
     "symbol": "ZROZ"
    },
    {
     "description": "ZUR ROSE GROUP AG",
     "symbol": "ZRSEF"
    },
    {
     "description": "ZURVITA HOLDINGS INC",
     "symbol": "ZRVT"
    },
    {
     "description": "ZSCALER INC",
     "symbol": "ZS"
    },
    {
     "description": "ZOSANO PHARMA CORP",
     "symbol": "ZSAN"
    },
    {
     "description": "ZHONGSHENG GROUP-UNSP ADR",
     "symbol": "ZSHGY"
    },
    {
     "description": "ZENSHO Company Ltd",
     "symbol": "ZSHOF"
    },
    {
     "description": "ZKB SILVER ETF AA USD",
     "symbol": "ZSILF"
    },
    {
     "description": "PROSHARES ULTRASHORT SILVER",
     "symbol": "ZSL"
    },
    {
     "description": "ZST DIGITAL NETWORKS INC",
     "symbol": "ZSTN"
    },
    {
     "description": "BMO ULTRA SHORT-TERM BOND ET",
     "symbol": "ZSTTF"
    },
    {
     "description": "SMART CLOSET INC",
     "symbol": "ZSYC"
    },
    {
     "description": "ZIMMER ENERGY TRANSITION -A",
     "symbol": "ZT"
    },
    {
     "description": "ZIMMER ENERGY TRANSITION ACQ",
     "symbol": "ZTAQU"
    },
    {
     "description": "ZIMMER ENERGY TRANS -A -CW23",
     "symbol": "ZTAQW"
    },
    {
     "description": "ZTE CORP-H",
     "symbol": "ZTCOF"
    },
    {
     "description": "ZTE CORP-UNSPON ADR",
     "symbol": "ZTCOY"
    },
    {
     "description": "ZENTEK LTD",
     "symbol": "ZTEK"
    },
    {
     "description": "TEST",
     "symbol": "ZTEST"
    },
    {
     "description": "ZONETAIL INC",
     "symbol": "ZTLLF"
    },
    {
     "description": "ZIMTU CAPITAL CORP",
     "symbol": "ZTMUF"
    },
    {
     "description": "ZOOM TECHNOLOGIES INC",
     "symbol": "ZTNO"
    },
    {
     "description": "ZTO EXPRESS CAYMAN INC-ADR",
     "symbol": "ZTO"
    },
    {
     "description": "VIRTUS TOTAL RETURN FUND INC",
     "symbol": "ZTR"
    },
    {
     "description": "ZOETIS INC",
     "symbol": "ZTS"
    },
    {
     "description": "Test",
     "symbol": "ZTST"
    },
    {
     "description": "ZTEST ELECTRONICS INC",
     "symbol": "ZTSTF"
    },
    {
     "description": "ZULU TEK INC",
     "symbol": "ZULU"
    },
    {
     "description": "ZOOMERMEDIA LTD",
     "symbol": "ZUMRF"
    },
    {
     "description": "ZUMIEZ INC",
     "symbol": "ZUMZ"
    },
    {
     "description": "ZUORA INC - CLASS A",
     "symbol": "ZUO"
    },
    {
     "description": "ZURICH INSURANCE GROUP-ADR",
     "symbol": "ZURVY"
    },
    {
     "description": "ZEUUS INC",
     "symbol": "ZUUS"
    },
    {
     "description": "ZEVIA PBC-A",
     "symbol": "ZVIA"
    },
    {
     "description": "ZVELO INC",
     "symbol": "ZVLO"
    },
    {
     "description": "ZOVIO INC",
     "symbol": "ZVO"
    },
    {
     "description": "ZEVOTEK INC",
     "symbol": "ZVTK"
    },
    {
     "description": "Test",
     "symbol": "ZVV"
    },
    {
     "description": "TEST",
     "symbol": "ZVZZT"
    },
    {
     "description": "GOLDKEY CORP",
     "symbol": "ZWBC"
    },
    {
     "description": "ZWIPE AS",
     "symbol": "ZWPEF"
    },
    {
     "description": "Z-WORK ACQUISITION CORP-A",
     "symbol": "ZWRK"
    },
    {
     "description": "Z-WORK ACQUISITION CORP",
     "symbol": "ZWRKU"
    },
    {
     "description": "Z-WORK ACQ CL A -CW26",
     "symbol": "ZWRKW"
    },
    {
     "description": "ZURN WATER SOLUTIONS CORP",
     "symbol": "ZWS"
    },
    {
     "description": "ZHONGDE WASTE TECHNOLOGY AG",
     "symbol": "ZWTYF"
    },
    {
     "description": "Test",
     "symbol": "ZXIET"
    },
    {
     "description": "TEST",
     "symbol": "ZXYZ.A"
    },
    {
     "description": "TEST",
     "symbol": "ZXZZT"
    },
    {
     "description": "ZYMERGEN INC",
     "symbol": "ZY"
    },
    {
     "description": "ZHONG YA INTERNATIONAL LTD",
     "symbol": "ZYJT"
    },
    {
     "description": "ZYMEWORKS INC",
     "symbol": "ZYME"
    },
    {
     "description": "ZYNERBA PHARMACEUTICALS INC",
     "symbol": "ZYNE"
    },
    {
     "description": "ZYQC GROUP HOLDING LTD",
     "symbol": "ZYQG"
    },
    {
     "description": "ZYNEX INC",
     "symbol": "ZYXI"
    },
    {
     "description": "ZHENGZHOU COAL MINING MACH-H",
     "symbol": "ZZCMF"
    },
    {
     "description": "ZHONGAN ONLINE P&C INSURAN-H",
     "symbol": "ZZHGF"
    },
    {
     "description": "ZHONGAN ONLINE P&C INS-ADR",
     "symbol": "ZZHGY"
    },
    {
     "description": "Test",
     "symbol": "ZZK"
    },
    {
     "description": "ZZLL INFORMATION TECHNOLOGY",
     "symbol": "ZZLL"
    },
    {
     "description": "Test",
     "symbol": "ZZZ"
    },
    {
     "description": "ZINC ONE RESOURCES INC",
     "symbol": "ZZZOF"
    }
   ];